
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire66d5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire66d5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("31N0p", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eX8nW = parcelRequire("eX8nW");

var $dDvZT = parcelRequire("dDvZT");

var $gH8Ve = parcelRequire("gH8Ve");

var $lmDUN = parcelRequire("lmDUN");

var $26nWE = parcelRequire("26nWE");

var $gWYwh = parcelRequire("gWYwh");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $c3F4R = parcelRequire("c3F4R");

var $4LxkX = parcelRequire("4LxkX");

var $2IafG = parcelRequire("2IafG");

var $6aMbm = parcelRequire("6aMbm");

var $eE1Sn = parcelRequire("eE1Sn");

var $4wQxQ = parcelRequire("4wQxQ");

var $f3RkF = parcelRequire("f3RkF");

var $ajhqL = parcelRequire("ajhqL");

var $13TrR = parcelRequire("13TrR");

var $3xknF = parcelRequire("3xknF");

var $5JqSP = parcelRequire("5JqSP");

var $lhzyP = parcelRequire("lhzyP");

var $3tUnp = parcelRequire("3tUnp");

var $9tM8w = parcelRequire("9tM8w");

var $du5vT = parcelRequire("du5vT");

var $8OOjj = parcelRequire("8OOjj");

var $fTFTk = parcelRequire("fTFTk");

var $aDJ1B = parcelRequire("aDJ1B");

var $1scQ2 = parcelRequire("1scQ2");

var $ifJZI = parcelRequire("ifJZI");

var $ijm9Y = parcelRequire("ijm9Y");

var $9kCJF = parcelRequire("9kCJF");

var $lCaM2 = parcelRequire("lCaM2");

var $3XlS2 = parcelRequire("3XlS2");

var $iOdTc = parcelRequire("iOdTc");

var $fbkeM = parcelRequire("fbkeM");

var $eEukW = parcelRequire("eEukW");

var $l8Kgs = parcelRequire("l8Kgs");

var $dAAl0 = parcelRequire("dAAl0");

var $bMiFH = parcelRequire("bMiFH");

var $lneXJ = parcelRequire("lneXJ");

var $aX5wF = parcelRequire("aX5wF");

var $l5lP1 = parcelRequire("l5lP1");

var $3TOA3 = parcelRequire("3TOA3");

var $ckhr5 = parcelRequire("ckhr5");

var $dvzf1 = parcelRequire("dvzf1");

var $fnNKN = parcelRequire("fnNKN");

var $fzE9o = parcelRequire("fzE9o");

var $9eSGE = parcelRequire("9eSGE");

var $1E9Rm = parcelRequire("1E9Rm");

var $9A3c5 = parcelRequire("9A3c5");

var $6vUrj = parcelRequire("6vUrj");

var $6Uu3e = parcelRequire("6Uu3e");

var $5CFT4 = parcelRequire("5CFT4");

var $2bFOy = parcelRequire("2bFOy");

var $8gm0h = parcelRequire("8gm0h");

var $fvTyO = parcelRequire("fvTyO");

var $laTYc = parcelRequire("laTYc");

var $gMVt3 = parcelRequire("gMVt3");

var $h6J9f = parcelRequire("h6J9f");

var $2adP5 = parcelRequire("2adP5");

var $ffWyI = parcelRequire("ffWyI");

var $8qWlp = parcelRequire("8qWlp");

var $9QW6c = parcelRequire("9QW6c");

var $bctHB = parcelRequire("bctHB");

var $8mgFa = parcelRequire("8mgFa");

var $3Rkxj = parcelRequire("3Rkxj");

var $g7zRo = parcelRequire("g7zRo");

var $gkhWS = parcelRequire("gkhWS");

var $iVKe8 = parcelRequire("iVKe8");

var $8K7Jl = parcelRequire("8K7Jl");

var $2Nx5l = parcelRequire("2Nx5l");

var $jFWDT = parcelRequire("jFWDT");

var $dwAOK = parcelRequire("dwAOK");

var $dp3IX = parcelRequire("dp3IX");

var $QE2yw = parcelRequire("QE2yw");

var $f6w5N = parcelRequire("f6w5N");

var $f87mP = parcelRequire("f87mP");

var $dp8LO = parcelRequire("dp8LO");

var $dCSiT = parcelRequire("dCSiT");

var $i5zdK = parcelRequire("i5zdK");

var $1V5lh = parcelRequire("1V5lh");

var $1hGnJ = parcelRequire("1hGnJ");

var $jzLgh = parcelRequire("jzLgh");

var $iqqtV = parcelRequire("iqqtV");

var $krgwg = parcelRequire("krgwg");

var $1XBvb = parcelRequire("1XBvb");

var $dDJiI = parcelRequire("dDJiI");

var $7piEH = parcelRequire("7piEH");

var $frFYv = parcelRequire("frFYv");

var $5eiZy = parcelRequire("5eiZy");

var $cRRDT = parcelRequire("cRRDT");

var $6atBT = parcelRequire("6atBT");

var $eN9vd = parcelRequire("eN9vd");

var $lQFj9 = parcelRequire("lQFj9");

var $fbvdA = parcelRequire("fbvdA");

var $gMyai = parcelRequire("gMyai");

var $626Kw = parcelRequire("626Kw");

var $5kKGI = parcelRequire("5kKGI");

var $88Wwg = parcelRequire("88Wwg");

var $5ddno = parcelRequire("5ddno");

var $ax3NO = parcelRequire("ax3NO");

var $j6AED = parcelRequire("j6AED");

var $9nAI4 = parcelRequire("9nAI4");

var $leGC4 = parcelRequire("leGC4");

var $dSnj4 = parcelRequire("dSnj4");

var $lVCHq = parcelRequire("lVCHq");

var $fbA8J = parcelRequire("fbA8J");

var $aGDGs = parcelRequire("aGDGs");

var $iYG6e = parcelRequire("iYG6e");

var $lWjTr = parcelRequire("lWjTr");

var $6OoWC = parcelRequire("6OoWC");

var $hYL8G = parcelRequire("hYL8G");

var $lHZZ7 = parcelRequire("lHZZ7");

var $4mNpz = parcelRequire("4mNpz");

var $6Xrci = parcelRequire("6Xrci");

var $3OVuZ = parcelRequire("3OVuZ");

var $eFFx8 = parcelRequire("eFFx8");

var $aJD8C = parcelRequire("aJD8C");

var $fJLhk = parcelRequire("fJLhk");

var $3zkbY = parcelRequire("3zkbY");

var $9TAZi = parcelRequire("9TAZi");

var $cqs9v = parcelRequire("cqs9v");

var $8PsOG = parcelRequire("8PsOG");

var $as54b = parcelRequire("as54b");

var $1cCOf = parcelRequire("1cCOf");

var $9OEq4 = parcelRequire("9OEq4");

var $eCBhU = parcelRequire("eCBhU");

var $cUgOr = parcelRequire("cUgOr");

var $hGnwj = parcelRequire("hGnwj");

var $g31Ce = parcelRequire("g31Ce");

var $rzjlZ = parcelRequire("rzjlZ");

var $9EvIV = parcelRequire("9EvIV");

var $fQMpe = parcelRequire("fQMpe");

var $42zXR = parcelRequire("42zXR");

var $5ZJSQ = parcelRequire("5ZJSQ");

var $cx0Ur = parcelRequire("cx0Ur");

var $dbBv0 = parcelRequire("dbBv0");

var $dRLB0 = parcelRequire("dRLB0");

var $1nK9H = parcelRequire("1nK9H");

var $foFxi = parcelRequire("foFxi");

var $2AGy2 = parcelRequire("2AGy2");

var $lDdLA = parcelRequire("lDdLA");

var $5L5uH = parcelRequire("5L5uH");

var $7O2T2 = parcelRequire("7O2T2");

var $N4tZW = parcelRequire("N4tZW");

var $j6N8F = parcelRequire("j6N8F");

var $9WX7F = parcelRequire("9WX7F");

var $grFVK = parcelRequire("grFVK");

var $aZ3HH = parcelRequire("aZ3HH");

var $dBuCl = parcelRequire("dBuCl");

var $9eX4e = parcelRequire("9eX4e");

var $jFOY1 = parcelRequire("jFOY1");

var $8tW2T = parcelRequire("8tW2T");

var $bOz44 = parcelRequire("bOz44");

var $aIP8h = parcelRequire("aIP8h");

var $lFg4k = parcelRequire("lFg4k");

var $48AmV = parcelRequire("48AmV");

var $hkF3C = parcelRequire("hkF3C");

var $01r7k = parcelRequire("01r7k");
module.exports.registerSpanErrorInstrumentation = $eX8nW.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $dDvZT.getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $dDvZT.markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $dDvZT.markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $dDvZT.markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $dDvZT.setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $dDvZT.spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $dDvZT.spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $dDvZT.spanSourceWasExplicitlySet;
module.exports.TRACING_DEFAULTS = $gH8Ve.TRACING_DEFAULTS;
module.exports.startIdleSpan = $gH8Ve.startIdleSpan;
module.exports.SentrySpan = $lmDUN.SentrySpan;
module.exports._INTERNAL_setDeferSegmentSpanCapture = $26nWE._INTERNAL_setDeferSegmentSpanCapture;
module.exports.SentryNonRecordingSpan = $gWYwh.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $h5H4c.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $h5H4c.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $h5H4c.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $h5H4c.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $h5H4c.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $5CFne.SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $5CFne._INTERNAL_startInactiveSpan;
module.exports.continueTrace = $5CFne.continueTrace;
module.exports.isTracingSuppressed = $5CFne.isTracingSuppressed;
module.exports.spanIsIgnored = $5CFne.spanIsIgnored;
module.exports.startInactiveSpan = $5CFne.startInactiveSpan;
module.exports.startNewTrace = $5CFne.startNewTrace;
module.exports.startSpan = $5CFne.startSpan;
module.exports.startSpanManual = $5CFne.startSpanManual;
module.exports.suppressTracing = $5CFne.suppressTracing;
module.exports.withActiveSpan = $5CFne.withActiveSpan;
module.exports.bindScopeToEmitter = $c3F4R.bindScopeToEmitter;
module.exports.getDynamicSamplingContextFromClient = $4LxkX.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $4LxkX.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $4LxkX.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $4LxkX.spanToBaggageHeader;
module.exports.setMeasurement = $2IafG.setMeasurement;
module.exports.timedEventsToMeasurements = $2IafG.timedEventsToMeasurements;
module.exports.sampleSpan = $6aMbm.sampleSpan;
module.exports.logSpanEnd = $eE1Sn.logSpanEnd;
module.exports.logSpanStart = $eE1Sn.logSpanStart;
module.exports.captureSpan = $4wQxQ.captureSpan;
module.exports.safeSetSpanJSONAttributes = $4wQxQ.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $f3RkF.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $f3RkF.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $f3RkF.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $f3RkF.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $f3RkF.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $f3RkF.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $f3RkF.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $f3RkF.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $f3RkF.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $f3RkF.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $f3RkF.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $ajhqL.createEventEnvelope;
module.exports.createSessionEnvelope = $ajhqL.createSessionEnvelope;
module.exports.createSpanEnvelope = $ajhqL.createSpanEnvelope;
module.exports.addEventProcessor = $13TrR.addEventProcessor;
module.exports.captureEvent = $13TrR.captureEvent;
module.exports.captureException = $13TrR.captureException;
module.exports.captureMessage = $13TrR.captureMessage;
module.exports.captureSession = $13TrR.captureSession;
module.exports.close = $13TrR.close;
module.exports.endSession = $13TrR.endSession;
module.exports.flush = $13TrR.flush;
module.exports.isEnabled = $13TrR.isEnabled;
module.exports.isInitialized = $13TrR.isInitialized;
module.exports.lastEventId = $13TrR.lastEventId;
module.exports.setAttribute = $13TrR.setAttribute;
module.exports.setAttributes = $13TrR.setAttributes;
module.exports.setContext = $13TrR.setContext;
module.exports.setConversationId = $13TrR.setConversationId;
module.exports.setExtra = $13TrR.setExtra;
module.exports.setExtras = $13TrR.setExtras;
module.exports.setTag = $13TrR.setTag;
module.exports.setTags = $13TrR.setTags;
module.exports.setUser = $13TrR.setUser;
module.exports.startSession = $13TrR.startSession;
module.exports.captureCheckIn = $3xknF.captureCheckIn;
module.exports.withMonitor = $3xknF.withMonitor;
module.exports.getClient = $5JqSP.getClient;
module.exports.getCurrentScope = $5JqSP.getCurrentScope;
module.exports.getExternalPropagationContext = $5JqSP.getExternalPropagationContext;
module.exports.getGlobalScope = $5JqSP.getGlobalScope;
module.exports.getIsolationScope = $5JqSP.getIsolationScope;
module.exports.getTraceContextFromScope = $5JqSP.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $5JqSP.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $5JqSP.registerExternalPropagationContext;
module.exports.withIsolationScope = $5JqSP.withIsolationScope;
module.exports.withScope = $5JqSP.withScope;
module.exports.getDefaultCurrentScope = $lhzyP.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $lhzyP.getDefaultIsolationScope;
module.exports.getAsyncContextStrategy = $3tUnp.getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $3tUnp.setAsyncContextStrategy;
module.exports._INTERNAL_createTracingChannelBinding = $9tM8w._INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $9tM8w.waitForTracingChannelBinding;
module.exports.getGlobalSingleton = $du5vT.getGlobalSingleton;
module.exports.getMainCarrier = $du5vT.getMainCarrier;
module.exports.closeSession = $8OOjj.closeSession;
module.exports.makeSession = $8OOjj.makeSession;
module.exports.updateSession = $8OOjj.updateSession;
module.exports.Scope = $fTFTk.Scope;
module.exports.notifyEventProcessors = $aDJ1B.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $1scQ2.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $1scQ2.getReportDialogEndpoint;
module.exports.Client = $ifJZI.Client;
module.exports.initAndBind = $ijm9Y.initAndBind;
module.exports.setCurrentClient = $ijm9Y.setCurrentClient;
module.exports.createTransport = $9kCJF.createTransport;
module.exports.makeOfflineTransport = $lCaM2.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $3XlS2.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $3XlS2.makeMultiplexedTransport;
module.exports.addIntegration = $iOdTc.addIntegration;
module.exports.defineIntegration = $iOdTc.defineIntegration;
module.exports.extendIntegration = $iOdTc.extendIntegration;
module.exports.getIntegrationsToSetup = $iOdTc.getIntegrationsToSetup;
module.exports.installedIntegrations = $iOdTc.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $fbkeM._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $fbkeM._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $fbkeM._INTERNAL_skipAiProviderWrapping;
module.exports._INTERNAL_filterKeyValueData = $eEukW.filterKeyValueData;
module.exports._INTERNAL_filterCookies = $l8Kgs.filterCookies;
module.exports._INTERNAL_filterQueryParams = $dAAl0.filterQueryParams;
module.exports.filterCollectedUrl = $bMiFH.filterCollectedUrl;
module.exports.filterCollectedUrlQuery = $bMiFH.filterCollectedUrlQuery;
module.exports.envToBool = $lneXJ.envToBool;
module.exports.applyScopeDataToEvent = $aX5wF.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $aX5wF.getCombinedScopeData;
module.exports.mergeScopeData = $aX5wF.mergeScopeData;
module.exports.prepareEvent = $l5lP1.prepareEvent;
module.exports.createCheckInEnvelope = $3TOA3.createCheckInEnvelope;
module.exports.hasSpansEnabled = $ckhr5.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $dvzf1.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $dvzf1.withStreamedSpan;
module.exports.isSentryRequestUrl = $fnNKN.isSentryRequestUrl;
module.exports.handleCallbackErrors = $fzE9o.handleCallbackErrors;
module.exports.fmt = $9eSGE.fmt;
module.exports.parameterize = $9eSGE.parameterize;
module.exports.handleTunnelRequest = $1E9Rm.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $9A3c5.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $9A3c5.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $6vUrj.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $6vUrj.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $6vUrj.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $6vUrj.getActiveSpan;
module.exports.getRootSpan = $6vUrj.getRootSpan;
module.exports.getSpanDescendants = $6vUrj.getSpanDescendants;
module.exports.getStatusMessage = $6vUrj.getStatusMessage;
module.exports.spanIsSampled = $6vUrj.spanIsSampled;
module.exports.spanIsSentrySpan = $6vUrj.spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $6vUrj.spanTimeInputToSeconds;
module.exports.spanToJSON = $6vUrj.spanToJSON;
module.exports.spanToStreamedSpanJSON = $6vUrj.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $6vUrj.spanToTraceContext;
module.exports.spanToTraceHeader = $6vUrj.spanToTraceHeader;
module.exports.updateSpanName = $6vUrj.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $6Uu3e._setSpanForScope;
module.exports.parseSampleRate = $5CFT4.parseSampleRate;
module.exports.applySdkMetadata = $2bFOy.applySdkMetadata;
module.exports.getTraceData = $8gm0h.getTraceData;
module.exports.shouldPropagateTraceForUrl = $fvTyO.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $laTYc.getTraceMetaTags;
module.exports.debounce = $gMVt3.debounce;
module.exports.uniq = $h6J9f.uniq;
module.exports.derefWeakRef = $2adP5.derefWeakRef;
module.exports.makeWeakRef = $2adP5.makeWeakRef;
module.exports.shouldIgnoreSpan = $ffWyI.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $8qWlp.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $8qWlp.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $8qWlp.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $8qWlp.getMaxBodyByteLength;
module.exports.headersToDict = $8qWlp.headersToDict;
module.exports.httpHeadersToSpanAttributes = $8qWlp.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $8qWlp.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $8qWlp.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $8qWlp.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $9QW6c.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $9QW6c.DEV_ENVIRONMENT;
module.exports.SPAN_KIND = $bctHB.SPAN_KIND;
module.exports.spanKindToName = $bctHB.spanKindToName;
module.exports.addBreadcrumb = $8mgFa.addBreadcrumb;
module.exports.functionToStringIntegration = $3Rkxj.functionToStringIntegration;
module.exports.eventFiltersIntegration = $g7zRo.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $g7zRo.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $gkhWS.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $iVKe8.moduleMetadataIntegration;
module.exports.requestDataIntegration = $8K7Jl.requestDataIntegration;
module.exports.captureConsoleIntegration = $2Nx5l.captureConsoleIntegration;
module.exports.dedupeIntegration = $jFWDT.dedupeIntegration;
module.exports.extraErrorDataIntegration = $dwAOK.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $dp3IX.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $QE2yw.instrumentSupabaseClient;
module.exports.supabaseIntegration = $QE2yw.supabaseIntegration;
module.exports.zodErrorsIntegration = $f6w5N.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $f87mP.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $dp8LO.consoleIntegration;
module.exports.featureFlagsIntegration = $dCSiT.featureFlagsIntegration;
module.exports.growthbookIntegration = $i5zdK.growthbookIntegration;
module.exports.conversationIdIntegration = $1V5lh.conversationIdIntegration;
module.exports.profiler = $1hGnJ.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $jzLgh._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $jzLgh.instrumentFetchRequest;
module.exports.captureFeedback = $iqqtV.captureFeedback;
module.exports._INTERNAL_captureLog = $krgwg._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $krgwg._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $krgwg._INTERNAL_flushLogsBuffer;
module.exports.logger = $1XBvb;
module.exports.consoleLoggingIntegration = $dDJiI.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $7piEH._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $7piEH._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $7piEH._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $frFYv;
module.exports.createConsolaReporter = $5eiZy.createConsolaReporter;
module.exports.LAST_STEP_ONLY_USAGE_KEYS = $cRRDT.LAST_STEP_ONLY_USAGE_KEYS;
module.exports.addVercelAiProcessors = $cRRDT.addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $cRRDT.getProviderMetadataAttributes;
module.exports.getTruncatedJsonString = $6atBT.getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $6atBT.resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $6atBT.shouldEnableTruncation;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports._INTERNAL_cleanupToolCallSpanContext = $lQFj9._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $lQFj9._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $fbvdA.toolCallSpanContextMap;
module.exports.addOpenAiRequestAttributes = $gMyai.addRequestAttributes;
module.exports.extractOpenAiRequestAttributes = $gMyai.extractRequestAttributes;
module.exports.instrumentOpenAiClient = $gMyai.instrumentOpenAiClient;
module.exports.addOpenAiResponseAttributes = $626Kw.addResponseAttributes;
module.exports.extractOpenAiRequestParameters = $626Kw.extractRequestParameters;
module.exports.instrumentOpenAiStream = $5kKGI.instrumentStream;
module.exports.OPENAI_INTEGRATION_NAME = $88Wwg.OPENAI_INTEGRATION_NAME;
module.exports.addAnthropicRequestAttributes = $5ddno.addPrivateRequestAttributes;
module.exports.addAnthropicResponseAttributes = $5ddno.addResponseAttributes;
module.exports.extractAnthropicRequestAttributes = $5ddno.extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $5ddno.instrumentAnthropicAiClient;
module.exports.instrumentAsyncIterableStream = $ax3NO.instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $ax3NO.instrumentMessageStream;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $j6AED.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.addGoogleGenAIRequestAttributes = $9nAI4.addPrivateRequestAttributes;
module.exports.addGoogleGenAIResponseAttributes = $9nAI4.addResponseAttributes;
module.exports.extractGoogleGenAIRequestAttributes = $9nAI4.extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $9nAI4.instrumentGoogleGenAIClient;
module.exports.instrumentGoogleGenAIStream = $leGC4.instrumentStream;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $dSnj4.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $lVCHq.createLangChainCallbackHandler;
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $fbA8J._INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentLangChainEmbeddings = $fbA8J.instrumentLangChainEmbeddings;
module.exports._INTERNAL_mergeLangChainCallbackHandler = $aGDGs._INTERNAL_mergeLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $iYG6e.LANGCHAIN_INTEGRATION_NAME;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $lWjTr._INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $lWjTr.instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $lWjTr.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $lWjTr.instrumentLangGraph;
module.exports.instrumentStateGraph = $lWjTr.instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $lWjTr.instrumentStateGraphCompile;
module.exports.extractAgentNameFromParams = $6OoWC.extractAgentNameFromParams;
module.exports.extractLLMFromParams = $6OoWC.extractLLMFromParams;
module.exports.wrapToolsWithSpans = $6OoWC.wrapToolsWithSpans;
module.exports.LANGGRAPH_INTEGRATION_NAME = $hYL8G.LANGGRAPH_INTEGRATION_NAME;
module.exports.instrumentWorkersAiClient = $lHZZ7.instrumentWorkersAiClient;
module.exports.SpanBuffer = $4mNpz.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $6Xrci.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $3OVuZ.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $eFFx8._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $eFFx8._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $eFFx8._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $eFFx8._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $eFFx8._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $aJD8C.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $fJLhk.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $3zkbY.dsnFromString;
module.exports.dsnToString = $3zkbY.dsnToString;
module.exports.makeDsn = $3zkbY.makeDsn;
module.exports.SentryError = $9TAZi.SentryError;
module.exports.GLOBAL_OBJ = $cqs9v.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $8PsOG.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $8PsOG.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $as54b.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $as54b.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $1cCOf.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $9OEq4.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $eCBhU.addHandler;
module.exports.maybeInstrument = $eCBhU.maybeInstrument;
module.exports.resetInstrumentationHandlers = $eCBhU.resetInstrumentationHandlers;
module.exports.triggerHandlers = $eCBhU.triggerHandlers;
module.exports.isDOMError = $cUgOr.isDOMError;
module.exports.isDOMException = $cUgOr.isDOMException;
module.exports.isElement = $cUgOr.isElement;
module.exports.isError = $cUgOr.isError;
module.exports.isErrorEvent = $cUgOr.isErrorEvent;
module.exports.isEvent = $cUgOr.isEvent;
module.exports.isInstanceOf = $cUgOr.isInstanceOf;
module.exports.isObjectLike = $cUgOr.isObjectLike;
module.exports.isParameterizedString = $cUgOr.isParameterizedString;
module.exports.isPlainObject = $cUgOr.isPlainObject;
module.exports.isPrimitive = $cUgOr.isPrimitive;
module.exports.isRegExp = $cUgOr.isRegExp;
module.exports.isString = $cUgOr.isString;
module.exports.isSyntheticEvent = $cUgOr.isSyntheticEvent;
module.exports.isThenable = $cUgOr.isThenable;
module.exports.isVueViewModel = $cUgOr.isVueViewModel;
module.exports.isBrowser = $hGnwj.isBrowser;
module.exports.CONSOLE_LEVELS = $g31Ce.CONSOLE_LEVELS;
module.exports.consoleSandbox = $g31Ce.consoleSandbox;
module.exports.debug = $g31Ce.debug;
module.exports.originalConsoleMethods = $g31Ce.originalConsoleMethods;
module.exports.addContextToFrame = $rzjlZ.addContextToFrame;
module.exports.addExceptionMechanism = $rzjlZ.addExceptionMechanism;
module.exports.addExceptionTypeValue = $rzjlZ.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $rzjlZ.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $rzjlZ.getEventDescription;
module.exports.isAlreadyCaptured = $rzjlZ.isAlreadyCaptured;
module.exports.parseSemver = $rzjlZ.parseSemver;
module.exports.uuid4 = $rzjlZ.uuid4;
module.exports.normalize = $9EvIV.normalize;
module.exports.normalizeToSize = $9EvIV.normalizeToSize;
module.exports.normalizeUrlToBase = $9EvIV.normalizeUrlToBase;
module.exports.setNormalizeStringifier = $9EvIV.setNormalizeStringifier;
module.exports.setNormalizationDepthOverrideHint = $fQMpe.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $fQMpe.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $42zXR.addNonEnumerableProperty;
module.exports.convertToPlainObject = $42zXR.convertToPlainObject;
module.exports.dropUndefinedKeys = $42zXR.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $42zXR.extractExceptionKeysForMessage;
module.exports.fill = $42zXR.fill;
module.exports.getOriginalFunction = $42zXR.getOriginalFunction;
module.exports.markFunctionWrapped = $42zXR.markFunctionWrapped;
module.exports.objectify = $42zXR.objectify;
module.exports.basename = $5ZJSQ.basename;
module.exports.dirname = $5ZJSQ.dirname;
module.exports.isAbsolute = $5ZJSQ.isAbsolute;
module.exports.join = $5ZJSQ.join;
module.exports.normalizePath = $5ZJSQ.normalizePath;
module.exports.relative = $5ZJSQ.relative;
module.exports.resolve = $5ZJSQ.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $cx0Ur.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $cx0Ur.makePromiseBuffer;
module.exports.severityLevelFromString = $dbBv0.severityLevelFromString;
module.exports.replaceExports = $dRLB0.replaceExports;
module.exports.UNKNOWN_FUNCTION = $1nK9H.UNKNOWN_FUNCTION;
module.exports.createStackParser = $1nK9H.createStackParser;
module.exports.getFramesFromEvent = $1nK9H.getFramesFromEvent;
module.exports.getFunctionName = $1nK9H.getFunctionName;
module.exports.stackParserFromStackParserOptions = $1nK9H.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $1nK9H.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $foFxi.isMatchingPattern;
module.exports.safeJoin = $foFxi.safeJoin;
module.exports.snipLine = $foFxi.snipLine;
module.exports.stringMatchesSomePattern = $foFxi.stringMatchesSomePattern;
module.exports.stringify = $foFxi.stringify;
module.exports.truncate = $foFxi.truncate;
module.exports.isNativeFunction = $2AGy2.isNativeFunction;
module.exports.supportsDOMError = $2AGy2.supportsDOMError;
module.exports.supportsDOMException = $2AGy2.supportsDOMException;
module.exports.supportsErrorEvent = $2AGy2.supportsErrorEvent;
module.exports.supportsFetch = $2AGy2.supportsFetch;
module.exports.supportsHistory = $2AGy2.supportsHistory;
module.exports.supportsNativeFetch = $2AGy2.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $2AGy2.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $2AGy2.supportsReportingObserver;
module.exports.SyncPromise = $lDdLA.SyncPromise;
module.exports.rejectedSyncPromise = $lDdLA.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $lDdLA.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $5L5uH.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $5L5uH.dateTimestampInSeconds;
module.exports.timestampInSeconds = $5L5uH.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $7O2T2.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $7O2T2.extractTraceparentData;
module.exports.generateSentryTraceHeader = $7O2T2.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $7O2T2.generateTraceparentHeader;
module.exports.isContinuingTrace = $7O2T2.isContinuingTrace;
module.exports.propagationContextFromHeaders = $7O2T2.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $7O2T2.shouldContinueTrace;
module.exports.getSDKSource = $N4tZW.getSDKSource;
module.exports.isBrowserBundle = $N4tZW.isBrowserBundle;
module.exports.addItemToEnvelope = $j6N8F.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $j6N8F.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $j6N8F.createEnvelope;
module.exports.createEventEnvelopeHeaders = $j6N8F.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $j6N8F.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $j6N8F.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $j6N8F.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $j6N8F.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $j6N8F.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $j6N8F.parseEnvelope;
module.exports.serializeEnvelope = $j6N8F.serializeEnvelope;
module.exports.createClientReportEnvelope = $9WX7F.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $grFVK.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $grFVK.disabledUntil;
module.exports.isRateLimited = $grFVK.isRateLimited;
module.exports.parseRetryAfterHeader = $grFVK.parseRetryAfterHeader;
module.exports.updateRateLimits = $grFVK.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $aZ3HH.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $aZ3HH.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $aZ3HH.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $aZ3HH.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $aZ3HH.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $aZ3HH.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $aZ3HH.objectToBaggageHeader;
module.exports.parseBaggageHeader = $aZ3HH.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $dBuCl.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $dBuCl.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $dBuCl.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $dBuCl.isURLObjectRelative;
module.exports.parseStringToURLObject = $dBuCl.parseStringToURLObject;
module.exports.parseUrl = $dBuCl.parseUrl;
module.exports.stripDataUrlContent = $dBuCl.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $dBuCl.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $9eX4e._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $9eX4e.eventFromMessage;
module.exports.eventFromUnknownInput = $9eX4e.eventFromUnknownInput;
module.exports.exceptionFromError = $9eX4e.exceptionFromError;
module.exports.parseStackFrames = $9eX4e.parseStackFrames;
module.exports.LRUMap = $jFOY1.LRUMap;
module.exports.generateSpanId = $8tW2T.generateSpanId;
module.exports.generateTraceId = $8tW2T.generateTraceId;
module.exports.SDK_VERSION = $bOz44.SDK_VERSION;
module.exports.getDebugImagesForResources = $aIP8h.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $aIP8h.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $lFg4k.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $48AmV.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $hkF3C.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $hkF3C.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $hkF3C.withRandomSafeContext;
module.exports.getComponentName = $01r7k.getComponentName;
module.exports.getLocationHref = $01r7k.getLocationHref;
module.exports.htmlTreeAsString = $01r7k.htmlTreeAsString;

});
parcelRegister("eX8nW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $1cCOf = parcelRequire("1cCOf");

var $9OEq4 = parcelRequire("9OEq4");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");

var $h5H4c = parcelRequire("h5H4c");
let $ae2d1478f6435221$var$errorsInstrumented = false;
function $ae2d1478f6435221$var$registerSpanErrorInstrumentation() {
    if ($ae2d1478f6435221$var$errorsInstrumented) return;
    function errorCallback() {
        const activeSpan = $6vUrj.getActiveSpan();
        const rootSpan = activeSpan && $6vUrj.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = "internal_error";
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    $ae2d1478f6435221$var$errorsInstrumented = true;
    $1cCOf.addGlobalErrorInstrumentationHandler(errorCallback);
    $9OEq4.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $ae2d1478f6435221$var$registerSpanErrorInstrumentation;

});
parcelRegister("3T29C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2d482de677cff0bd$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $2d482de677cff0bd$var$DEBUG_BUILD;

});

parcelRegister("1cCOf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
let $0e0504324afd11ac$var$_oldOnErrorHandler = null;
function $0e0504324afd11ac$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, $0e0504324afd11ac$var$instrumentError);
}
function $0e0504324afd11ac$var$instrumentError() {
    $0e0504324afd11ac$var$_oldOnErrorHandler = $cqs9v.GLOBAL_OBJ.onerror;
    $cqs9v.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $eCBhU.triggerHandlers("error", handlerData);
        if ($0e0504324afd11ac$var$_oldOnErrorHandler) return $0e0504324afd11ac$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $cqs9v.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $0e0504324afd11ac$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("cqs9v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $90bdc02f7f46955f$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $90bdc02f7f46955f$var$GLOBAL_OBJ;

});

parcelRegister("eCBhU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $1nK9H = parcelRequire("1nK9H");
const $aa5189e8c33be6d7$var$handlers = {};
const $aa5189e8c33be6d7$var$instrumented = {};
function $aa5189e8c33be6d7$var$addHandler(type, handler) {
    $aa5189e8c33be6d7$var$handlers[type] = $aa5189e8c33be6d7$var$handlers[type] || [];
    $aa5189e8c33be6d7$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $aa5189e8c33be6d7$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $aa5189e8c33be6d7$var$resetInstrumentationHandlers() {
    Object.keys($aa5189e8c33be6d7$var$handlers).forEach((key)=>{
        $aa5189e8c33be6d7$var$handlers[key] = void 0;
    });
}
function $aa5189e8c33be6d7$var$maybeInstrument(type, instrumentFn) {
    if (!$aa5189e8c33be6d7$var$instrumented[type]) {
        $aa5189e8c33be6d7$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $aa5189e8c33be6d7$var$triggerHandlers(type, data) {
    const typeHandlers = type && $aa5189e8c33be6d7$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${$1nK9H.getFunctionName(handler)}
Error:`, e);
    }
}
module.exports.addHandler = $aa5189e8c33be6d7$var$addHandler;
module.exports.maybeInstrument = $aa5189e8c33be6d7$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $aa5189e8c33be6d7$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $aa5189e8c33be6d7$var$triggerHandlers;

});
parcelRegister("g31Ce", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $3T29C = parcelRequire("3T29C");

var $cqs9v = parcelRequire("cqs9v");
const $baee2e0277344483$var$CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $baee2e0277344483$var$PREFIX = "Sentry Logger ";
const $baee2e0277344483$var$originalConsoleMethods = {};
function $baee2e0277344483$var$consoleSandbox(callback) {
    if (!("console" in $cqs9v.GLOBAL_OBJ)) return callback();
    const console = $cqs9v.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($baee2e0277344483$var$originalConsoleMethods);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $baee2e0277344483$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $baee2e0277344483$var$enable() {
    $baee2e0277344483$var$_getLoggerSettings().enabled = true;
}
function $baee2e0277344483$var$disable() {
    $baee2e0277344483$var$_getLoggerSettings().enabled = false;
}
function $baee2e0277344483$var$isEnabled() {
    return $baee2e0277344483$var$_getLoggerSettings().enabled;
}
function $baee2e0277344483$var$log(...args) {
    $baee2e0277344483$var$_maybeLog("log", ...args);
}
function $baee2e0277344483$var$warn(...args) {
    $baee2e0277344483$var$_maybeLog("warn", ...args);
}
function $baee2e0277344483$var$error(...args) {
    $baee2e0277344483$var$_maybeLog("error", ...args);
}
function $baee2e0277344483$var$_maybeLog(level, ...args) {
    if (!$3T29C.DEBUG_BUILD) return;
    if ($baee2e0277344483$var$isEnabled()) $baee2e0277344483$var$consoleSandbox(()=>{
        $cqs9v.GLOBAL_OBJ.console[level](`${$baee2e0277344483$var$PREFIX}[${level}]:`, ...args);
    });
}
function $baee2e0277344483$var$_getLoggerSettings() {
    if (!$3T29C.DEBUG_BUILD) return {
        enabled: false
    };
    return $du5vT.getGlobalSingleton("loggerSettings", ()=>({
            enabled: false
        }));
}
const $baee2e0277344483$var$debug = {
    enable: /** Enable logging. */ $baee2e0277344483$var$enable,
    disable: /** Disable logging. */ $baee2e0277344483$var$disable,
    isEnabled: /** Check if logging is enabled. */ $baee2e0277344483$var$isEnabled,
    log: /** Log a message. */ $baee2e0277344483$var$log,
    warn: /** Log a warning. */ $baee2e0277344483$var$warn,
    error: /** Log an error. */ $baee2e0277344483$var$error
};
module.exports.CONSOLE_LEVELS = $baee2e0277344483$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $baee2e0277344483$var$consoleSandbox;
module.exports.debug = $baee2e0277344483$var$debug;
module.exports.originalConsoleMethods = $baee2e0277344483$var$originalConsoleMethods;

});
parcelRegister("du5vT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bOz44 = parcelRequire("bOz44");

var $cqs9v = parcelRequire("cqs9v");
function $9d125a9112331993$var$getMainCarrier() {
    $9d125a9112331993$var$getSentryCarrier($cqs9v.GLOBAL_OBJ);
    return $cqs9v.GLOBAL_OBJ;
}
function $9d125a9112331993$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || $bOz44.SDK_VERSION;
    return __SENTRY__[$bOz44.SDK_VERSION] = __SENTRY__[$bOz44.SDK_VERSION] || {};
}
function $9d125a9112331993$var$getGlobalSingleton(name, creator, obj = $cqs9v.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$bOz44.SDK_VERSION] = __SENTRY__[$bOz44.SDK_VERSION] || {};
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $9d125a9112331993$var$getGlobalSingleton;
module.exports.getMainCarrier = $9d125a9112331993$var$getMainCarrier;
module.exports.getSentryCarrier = $9d125a9112331993$var$getSentryCarrier;

});
parcelRegister("bOz44", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $899f905847bf7e36$var$SDK_VERSION = "10.76.2";
module.exports.SDK_VERSION = $899f905847bf7e36$var$SDK_VERSION;

});



parcelRegister("1nK9H", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $101bbded4daee7e7$var$STACKTRACE_FRAME_LIMIT = 50;
const $101bbded4daee7e7$var$UNKNOWN_FUNCTION = "?";
const $101bbded4daee7e7$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $101bbded4daee7e7$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $101bbded4daee7e7$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $101bbded4daee7e7$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($101bbded4daee7e7$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $101bbded4daee7e7$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $101bbded4daee7e7$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
function $101bbded4daee7e7$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $101bbded4daee7e7$var$createStackParser(...stackParser);
    return stackParser;
}
function $101bbded4daee7e7$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($101bbded4daee7e7$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($101bbded4daee7e7$var$STRIP_FRAME_REGEXP.test($101bbded4daee7e7$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($101bbded4daee7e7$var$STRIP_FRAME_REGEXP.test($101bbded4daee7e7$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $101bbded4daee7e7$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $101bbded4daee7e7$var$getLastStackFrame(localStack).filename,
            function: frame.function || $101bbded4daee7e7$var$UNKNOWN_FUNCTION
        }));
}
function $101bbded4daee7e7$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $101bbded4daee7e7$var$defaultFunctionName = "<anonymous>";
function $101bbded4daee7e7$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return $101bbded4daee7e7$var$defaultFunctionName;
        return fn.name || $101bbded4daee7e7$var$defaultFunctionName;
    } catch  {
        return $101bbded4daee7e7$var$defaultFunctionName;
    }
}
function $101bbded4daee7e7$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $101bbded4daee7e7$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $101bbded4daee7e7$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $101bbded4daee7e7$var$createStackParser;
module.exports.getFramesFromEvent = $101bbded4daee7e7$var$getFramesFromEvent;
module.exports.getFunctionName = $101bbded4daee7e7$var$getFunctionName;
module.exports.normalizeStackTracePath = $101bbded4daee7e7$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $101bbded4daee7e7$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $101bbded4daee7e7$var$stripSentryFramesAndReverse;

});



parcelRegister("9OEq4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
let $7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler = null;
function $7258230b1b3a55b1$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, $7258230b1b3a55b1$var$instrumentUnhandledRejection);
}
function $7258230b1b3a55b1$var$instrumentUnhandledRejection() {
    $7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler = $cqs9v.GLOBAL_OBJ.onunhandledrejection;
    $cqs9v.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $eCBhU.triggerHandlers("unhandledrejection", handlerData);
        if ($7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler) return $7258230b1b3a55b1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $cqs9v.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $7258230b1b3a55b1$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("6vUrj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $7DFGy = parcelRequire("7DFGy");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $dDvZT = parcelRequire("dDvZT");

var $42zXR = parcelRequire("42zXR");

var $8tW2T = parcelRequire("8tW2T");

var $5L5uH = parcelRequire("5L5uH");

var $7O2T2 = parcelRequire("7O2T2");

var $g31Ce = parcelRequire("g31Ce");

var $6Uu3e = parcelRequire("6Uu3e");
const $0139502da7d050dc$var$TRACE_FLAG_NONE = 0;
const $0139502da7d050dc$var$TRACE_FLAG_SAMPLED = 1;
let $0139502da7d050dc$var$hasShownSpanDropWarning = false;
function $0139502da7d050dc$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $0139502da7d050dc$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $0139502da7d050dc$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $0139502da7d050dc$var$spanToJSON(span).parent_span_id;
    const scope = $dDvZT.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $8tW2T.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $0139502da7d050dc$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $0139502da7d050dc$var$spanIsSampled(span);
    return $7O2T2.generateSentryTraceHeader(traceId, spanId, sampled);
}
function $0139502da7d050dc$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $0139502da7d050dc$var$spanIsSampled(span);
    return $7O2T2.generateTraceparentHeader(traceId, spanId, sampled);
}
function $0139502da7d050dc$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $0139502da7d050dc$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $0139502da7d050dc$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $0139502da7d050dc$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return void 0;
}
function $0139502da7d050dc$var$spanTimeInputToSeconds(input) {
    if (typeof input === "number") return $0139502da7d050dc$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $0139502da7d050dc$var$ensureTimestampInSeconds(input.getTime());
    return $5L5uH.timestampInSeconds();
}
function $0139502da7d050dc$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $0139502da7d050dc$var$spanToJSON(span) {
    if ($0139502da7d050dc$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($0139502da7d050dc$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $0139502da7d050dc$var$getOtelParentSpanId(span),
            start_timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(endTime) || void 0,
            status: $0139502da7d050dc$var$getStatusMessage(status),
            op: attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $0139502da7d050dc$var$convertSpanLinksForEnvelope(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $0139502da7d050dc$var$spanToStreamedSpanJSON(span) {
    if ($0139502da7d050dc$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($0139502da7d050dc$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $0139502da7d050dc$var$getOtelParentSpanId(span),
            start_timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $0139502da7d050dc$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $0139502da7d050dc$var$INTERNAL_getSegmentSpan(span),
            status: $0139502da7d050dc$var$getSimpleStatus(status),
            attributes: $0139502da7d050dc$var$addStatusMessageAttribute(attributes, status),
            links: $0139502da7d050dc$var$getStreamedSpanLinks(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $0139502da7d050dc$var$INTERNAL_getSegmentSpan(span)
    };
}
function $0139502da7d050dc$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $0139502da7d050dc$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $7DFGy.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $7DFGy.serializeAttributes(link.attributes)
            }))
    };
}
function $0139502da7d050dc$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $0139502da7d050dc$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
function $0139502da7d050dc$var$spanIsSampled(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $0139502da7d050dc$var$TRACE_FLAG_SAMPLED;
}
function $0139502da7d050dc$var$getStatusMessage(status) {
    if (!status || status.code === $h5H4c.SPAN_STATUS_UNSET) return void 0;
    if (status.code === $h5H4c.SPAN_STATUS_OK) return "ok";
    return status.message || "internal_error";
}
function $0139502da7d050dc$var$getSimpleStatus(status) {
    return !status || status.code === $h5H4c.SPAN_STATUS_OK || status.code === $h5H4c.SPAN_STATUS_UNSET || status.message === "cancelled" ? "ok" : "error";
}
function $0139502da7d050dc$var$addStatusMessageAttribute(attributes, status) {
    const statusMessage = $0139502da7d050dc$var$getSimpleStatus(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE]: statusMessage
        },
        ...attributes
    };
}
const $0139502da7d050dc$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $0139502da7d050dc$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $0139502da7d050dc$var$addChildSpanToSpan(span, childSpan) {
    const rootSpan = span[$0139502da7d050dc$var$ROOT_SPAN_FIELD] || span;
    $42zXR.addNonEnumerableProperty(childSpan, $0139502da7d050dc$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$0139502da7d050dc$var$spanIsSampled(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$0139502da7d050dc$var$CHILD_SPANS_FIELD]) span[$0139502da7d050dc$var$CHILD_SPANS_FIELD].add(childSpan);
    else $42zXR.addNonEnumerableProperty(span, $0139502da7d050dc$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $0139502da7d050dc$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$0139502da7d050dc$var$CHILD_SPANS_FIELD]) span[$0139502da7d050dc$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $0139502da7d050dc$var$getSpanDescendants(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($0139502da7d050dc$var$spanIsSampled(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$0139502da7d050dc$var$CHILD_SPANS_FIELD] ? Array.from(span2[$0139502da7d050dc$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $0139502da7d050dc$var$getRootSpan = $0139502da7d050dc$var$INTERNAL_getSegmentSpan;
function $0139502da7d050dc$var$INTERNAL_getSegmentSpan(span) {
    return span[$0139502da7d050dc$var$ROOT_SPAN_FIELD] || span;
}
function $0139502da7d050dc$var$getActiveSpan() {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $6Uu3e._getSpanForScope($5JqSP.getCurrentScope());
}
function $0139502da7d050dc$var$showSpanDropWarning() {
    if (!$0139502da7d050dc$var$hasShownSpanDropWarning) {
        $g31Ce.consoleSandbox(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $0139502da7d050dc$var$hasShownSpanDropWarning = true;
    }
}
function $0139502da7d050dc$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $0139502da7d050dc$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $0139502da7d050dc$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $0139502da7d050dc$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $0139502da7d050dc$var$addChildSpanToSpan;
module.exports.addStatusMessageAttribute = $0139502da7d050dc$var$addStatusMessageAttribute;
module.exports.convertSpanLinksForEnvelope = $0139502da7d050dc$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $0139502da7d050dc$var$getActiveSpan;
module.exports.getRootSpan = $0139502da7d050dc$var$getRootSpan;
module.exports.getSimpleStatus = $0139502da7d050dc$var$getSimpleStatus;
module.exports.getSpanDescendants = $0139502da7d050dc$var$getSpanDescendants;
module.exports.getStatusMessage = $0139502da7d050dc$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $0139502da7d050dc$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $0139502da7d050dc$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $0139502da7d050dc$var$showSpanDropWarning;
module.exports.spanIsSampled = $0139502da7d050dc$var$spanIsSampled;
module.exports.spanIsSentrySpan = $0139502da7d050dc$var$spanIsSentrySpan;
module.exports.spanTimeInputToSeconds = $0139502da7d050dc$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $0139502da7d050dc$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $0139502da7d050dc$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $0139502da7d050dc$var$spanToTraceContext;
module.exports.spanToTraceHeader = $0139502da7d050dc$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $0139502da7d050dc$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $0139502da7d050dc$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $0139502da7d050dc$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $0139502da7d050dc$var$updateSpanName;

});
parcelRegister("3tUnp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $5ARfg = parcelRequire("5ARfg");
function $288fcfb7ac7b2551$var$setAsyncContextStrategy(strategy) {
    const registry = $du5vT.getMainCarrier();
    const sentry = $du5vT.getSentryCarrier(registry);
    sentry.acs = strategy;
}
function $288fcfb7ac7b2551$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $du5vT.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    return $5ARfg.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $288fcfb7ac7b2551$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $288fcfb7ac7b2551$var$setAsyncContextStrategy;

});
parcelRegister("5ARfg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lhzyP = parcelRequire("lhzyP");

var $fTFTk = parcelRequire("fTFTk");

var $6sseM = parcelRequire("6sseM");

var $cUgOr = parcelRequire("cUgOr");

var $du5vT = parcelRequire("du5vT");
class $41299de80defac8e$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $fTFTk.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $fTFTk.Scope();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($cUgOr.isThenable(maybePromiseResult)) return $6sseM.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $41299de80defac8e$var$getAsyncContextStack() {
    const registry = $du5vT.getMainCarrier();
    const sentry = $du5vT.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $41299de80defac8e$var$AsyncContextStack($lhzyP.getDefaultCurrentScope(), $lhzyP.getDefaultIsolationScope());
}
function $41299de80defac8e$var$withScope(callback) {
    return $41299de80defac8e$var$getAsyncContextStack().withScope(callback);
}
function $41299de80defac8e$var$withSetScope(scope, callback) {
    const stack = $41299de80defac8e$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $41299de80defac8e$var$withIsolationScope(callback) {
    return $41299de80defac8e$var$getAsyncContextStack().withScope(()=>{
        return callback($41299de80defac8e$var$getAsyncContextStack().getIsolationScope());
    });
}
function $41299de80defac8e$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $41299de80defac8e$var$withIsolationScope,
        withScope: $41299de80defac8e$var$withScope,
        withSetScope: $41299de80defac8e$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $41299de80defac8e$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$41299de80defac8e$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$41299de80defac8e$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $41299de80defac8e$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $41299de80defac8e$var$getStackAsyncContextStrategy;

});
parcelRegister("lhzyP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $fTFTk = parcelRequire("fTFTk");
function $f7e6c51c8f7f23ac$var$getDefaultCurrentScope() {
    return $du5vT.getGlobalSingleton("defaultCurrentScope", ()=>new $fTFTk.Scope());
}
function $f7e6c51c8f7f23ac$var$getDefaultIsolationScope() {
    return $du5vT.getGlobalSingleton("defaultIsolationScope", ()=>new $fTFTk.Scope());
}
module.exports.getDefaultCurrentScope = $f7e6c51c8f7f23ac$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $f7e6c51c8f7f23ac$var$getDefaultIsolationScope;

});
parcelRegister("fTFTk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $8OOjj = parcelRequire("8OOjj");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $4ty0t = parcelRequire("4ty0t");

var $rzjlZ = parcelRequire("rzjlZ");

var $8tW2T = parcelRequire("8tW2T");

var $hkF3C = parcelRequire("hkF3C");

var $6Uu3e = parcelRequire("6Uu3e");

var $foFxi = parcelRequire("foFxi");

var $5L5uH = parcelRequire("5L5uH");
const $b92c7cceddef7346$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $b92c7cceddef7346$var$Scope {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $8tW2T.generateTraceId(),
            sampleRand: $hkF3C.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $b92c7cceddef7346$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $6Uu3e._setSpanForScope(newScope, $6Uu3e._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) $8OOjj.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $b92c7cceddef7346$var$Scope ? scopeToMerge.getScopeData() : $cUgOr.isPlainObject(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        $6Uu3e._setSpanForScope(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $8tW2T.generateTraceId(),
            sampleRand: $hkF3C.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $b92c7cceddef7346$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $5L5uH.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $foFxi.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $6Uu3e._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $4ty0t.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $rzjlZ.uuid4();
        if (!this._client) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $rzjlZ.uuid4();
        if (!this._client) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $rzjlZ.uuid4();
        if (!this._client) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $b92c7cceddef7346$var$Scope;

});
parcelRegister("8OOjj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $rzjlZ = parcelRequire("rzjlZ");

var $5L5uH = parcelRequire("5L5uH");
function $66ba04d85bff3445$var$makeSession(context) {
    const startingTime = $5L5uH.timestampInSeconds();
    const session = {
        sid: $rzjlZ.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$66ba04d85bff3445$var$sessionToJSON(session)
    };
    if (context) $66ba04d85bff3445$var$updateSession(session, context);
    return session;
}
function $66ba04d85bff3445$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $5L5uH.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : $rzjlZ.uuid4();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $66ba04d85bff3445$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $66ba04d85bff3445$var$updateSession(session, context);
}
function $66ba04d85bff3445$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $66ba04d85bff3445$var$closeSession;
module.exports.makeSession = $66ba04d85bff3445$var$makeSession;
module.exports.updateSession = $66ba04d85bff3445$var$updateSession;

});
parcelRegister("rzjlZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $hkF3C = parcelRequire("hkF3C");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");
function $052de9ca810d3b4b$var$getCrypto() {
    const gbl = $cqs9v.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $052de9ca810d3b4b$var$emptyUuid;
function $052de9ca810d3b4b$var$getRandomByte() {
    return $hkF3C.safeMathRandom() * 16;
}
function $052de9ca810d3b4b$var$uuid4(crypto = $052de9ca810d3b4b$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return $hkF3C.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$052de9ca810d3b4b$var$emptyUuid) $052de9ca810d3b4b$var$emptyUuid = "10000000100040008000100000000000";
    return $052de9ca810d3b4b$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($052de9ca810d3b4b$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $052de9ca810d3b4b$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $052de9ca810d3b4b$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $052de9ca810d3b4b$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $052de9ca810d3b4b$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $052de9ca810d3b4b$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $052de9ca810d3b4b$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $052de9ca810d3b4b$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $052de9ca810d3b4b$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $052de9ca810d3b4b$var$parseSemver(input) {
    const match = input.match($052de9ca810d3b4b$var$SEMVER_REGEXP) || [];
    const major = $052de9ca810d3b4b$var$_parseInt(match[1]);
    const minor = $052de9ca810d3b4b$var$_parseInt(match[2]);
    const patch = $052de9ca810d3b4b$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $052de9ca810d3b4b$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$foFxi.snipLine(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = $foFxi.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$foFxi.snipLine(line, 0));
}
function $052de9ca810d3b4b$var$checkOrSetAlreadyCaught(exception) {
    if ($052de9ca810d3b4b$var$isAlreadyCaptured(exception)) return true;
    try {
        $42zXR.addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $052de9ca810d3b4b$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}
module.exports.addContextToFrame = $052de9ca810d3b4b$var$addContextToFrame;
module.exports.addExceptionMechanism = $052de9ca810d3b4b$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $052de9ca810d3b4b$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $052de9ca810d3b4b$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $052de9ca810d3b4b$var$getEventDescription;
module.exports.isAlreadyCaptured = $052de9ca810d3b4b$var$isAlreadyCaptured;
module.exports.parseSemver = $052de9ca810d3b4b$var$parseSemver;
module.exports.uuid4 = $052de9ca810d3b4b$var$uuid4;

});
parcelRegister("42zXR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");
function $2f133f1db6540c46$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $2f133f1db6540c46$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
function $2f133f1db6540c46$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $2f133f1db6540c46$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $2f133f1db6540c46$var$addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $2f133f1db6540c46$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($2f133f1db6540c46$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $2f133f1db6540c46$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $2f133f1db6540c46$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
function $2f133f1db6540c46$var$convertToPlainObject(value) {
    if ($cUgOr.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2f133f1db6540c46$var$getOwnProperties(value)
    };
    if ($cUgOr.isEvent(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$2f133f1db6540c46$var$getOwnProperties(value)
        };
    }
    return value;
}
function $2f133f1db6540c46$var$getOwnProperties(obj) {
    if ($cUgOr.isObjectLike(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $2f133f1db6540c46$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($2f133f1db6540c46$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $2f133f1db6540c46$var$dropUndefinedKeys(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $2f133f1db6540c46$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2f133f1db6540c46$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($2f133f1db6540c46$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($2f133f1db6540c46$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $2f133f1db6540c46$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $2f133f1db6540c46$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $2f133f1db6540c46$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $cUgOr.isPrimitive(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $2f133f1db6540c46$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $2f133f1db6540c46$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $2f133f1db6540c46$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $2f133f1db6540c46$var$extractExceptionKeysForMessage;
module.exports.fill = $2f133f1db6540c46$var$fill;
module.exports.getOriginalFunction = $2f133f1db6540c46$var$getOriginalFunction;
module.exports.markFunctionWrapped = $2f133f1db6540c46$var$markFunctionWrapped;
module.exports.objectify = $2f133f1db6540c46$var$objectify;
module.exports.wrapMethod = $2f133f1db6540c46$var$wrapMethod;

});
parcelRegister("cUgOr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $9657c1a387c3e228$var$objectToString = Object.prototype.toString;
function $9657c1a387c3e228$var$isError(wat) {
    switch($9657c1a387c3e228$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $9657c1a387c3e228$var$isInstanceOf(wat, Error);
    }
}
function $9657c1a387c3e228$var$isBuiltin(wat, className) {
    return $9657c1a387c3e228$var$objectToString.call(wat) === `[object ${className}]`;
}
function $9657c1a387c3e228$var$isErrorEvent(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "ErrorEvent");
}
function $9657c1a387c3e228$var$isDOMError(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "DOMError");
}
function $9657c1a387c3e228$var$isDOMException(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "DOMException");
}
function $9657c1a387c3e228$var$isString(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "String");
}
function $9657c1a387c3e228$var$isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $9657c1a387c3e228$var$isPrimitive(wat) {
    return wat === null || $9657c1a387c3e228$var$isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $9657c1a387c3e228$var$isPlainObject(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "Object");
}
function $9657c1a387c3e228$var$isObjectLike(wat) {
    return typeof wat === "object" && wat !== null;
}
function $9657c1a387c3e228$var$isEvent(wat) {
    return typeof Event !== "undefined" && $9657c1a387c3e228$var$isInstanceOf(wat, Event);
}
function $9657c1a387c3e228$var$isElement(wat) {
    return typeof Element !== "undefined" && $9657c1a387c3e228$var$isInstanceOf(wat, Element);
}
function $9657c1a387c3e228$var$isRegExp(wat) {
    return $9657c1a387c3e228$var$isBuiltin(wat, "RegExp");
}
function $9657c1a387c3e228$var$isThenable(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $9657c1a387c3e228$var$isSyntheticEvent(wat) {
    return $9657c1a387c3e228$var$isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $9657c1a387c3e228$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $9657c1a387c3e228$var$isVueViewModel(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $9657c1a387c3e228$var$isRequest(request) {
    return typeof Request !== "undefined" && $9657c1a387c3e228$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $9657c1a387c3e228$var$isDOMError;
module.exports.isDOMException = $9657c1a387c3e228$var$isDOMException;
module.exports.isElement = $9657c1a387c3e228$var$isElement;
module.exports.isError = $9657c1a387c3e228$var$isError;
module.exports.isErrorEvent = $9657c1a387c3e228$var$isErrorEvent;
module.exports.isEvent = $9657c1a387c3e228$var$isEvent;
module.exports.isInstanceOf = $9657c1a387c3e228$var$isInstanceOf;
module.exports.isObjectLike = $9657c1a387c3e228$var$isObjectLike;
module.exports.isParameterizedString = $9657c1a387c3e228$var$isParameterizedString;
module.exports.isPlainObject = $9657c1a387c3e228$var$isPlainObject;
module.exports.isPrimitive = $9657c1a387c3e228$var$isPrimitive;
module.exports.isRegExp = $9657c1a387c3e228$var$isRegExp;
module.exports.isRequest = $9657c1a387c3e228$var$isRequest;
module.exports.isString = $9657c1a387c3e228$var$isString;
module.exports.isSyntheticEvent = $9657c1a387c3e228$var$isSyntheticEvent;
module.exports.isThenable = $9657c1a387c3e228$var$isThenable;
module.exports.isVueViewModel = $9657c1a387c3e228$var$isVueViewModel;

});


parcelRegister("hkF3C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");
let $c9e427130d9269a0$var$RESOLVED_RUNNER;
function $c9e427130d9269a0$var$withRandomSafeContext(cb) {
    if ($c9e427130d9269a0$var$RESOLVED_RUNNER !== void 0) return $c9e427130d9269a0$var$RESOLVED_RUNNER ? $c9e427130d9269a0$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = $cqs9v.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $c9e427130d9269a0$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $c9e427130d9269a0$var$RESOLVED_RUNNER(cb);
    }
    $c9e427130d9269a0$var$RESOLVED_RUNNER = null;
    return cb();
}
function $c9e427130d9269a0$var$safeMathRandom() {
    return $c9e427130d9269a0$var$withRandomSafeContext(()=>Math.random());
}
function $c9e427130d9269a0$var$safeDateNow() {
    return $c9e427130d9269a0$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $c9e427130d9269a0$var$safeDateNow;
module.exports.safeMathRandom = $c9e427130d9269a0$var$safeMathRandom;
module.exports.withRandomSafeContext = $c9e427130d9269a0$var$withRandomSafeContext;

});

parcelRegister("foFxi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");
function $b3595115c73b2dc9$var$stringify(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $b3595115c73b2dc9$var$truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $b3595115c73b2dc9$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $b3595115c73b2dc9$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ($cUgOr.isPrimitive(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push($9EvIV.stringifyValue(void 0, value));
    }
    return output.join(delimiter);
}
function $b3595115c73b2dc9$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$cUgOr.isString(value)) return false;
    if ($cUgOr.isRegExp(pattern)) return pattern.test(value);
    if ($cUgOr.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $b3595115c73b2dc9$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($b3595115c73b2dc9$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $b3595115c73b2dc9$var$isMatchingPattern;
module.exports.safeJoin = $b3595115c73b2dc9$var$safeJoin;
module.exports.snipLine = $b3595115c73b2dc9$var$snipLine;
module.exports.stringMatchesSomePattern = $b3595115c73b2dc9$var$stringMatchesSomePattern;
module.exports.stringify = $b3595115c73b2dc9$var$stringify;
module.exports.truncate = $b3595115c73b2dc9$var$truncate;

});
parcelRegister("9EvIV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fQMpe = parcelRequire("fQMpe");

var $42zXR = parcelRequire("42zXR");

var $1nK9H = parcelRequire("1nK9H");
let $7070751abfdd78c2$var$stringifier;
function $7070751abfdd78c2$var$setNormalizeStringifier(newStringifier) {
    $7070751abfdd78c2$var$stringifier = newStringifier;
}
function $7070751abfdd78c2$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        return $7070751abfdd78c2$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $7070751abfdd78c2$var$normalizeToSize(object, depth = 3, maxSize = 102400) {
    const normalized = $7070751abfdd78c2$var$normalize(object, depth);
    if ($7070751abfdd78c2$var$jsonSize(normalized) > maxSize) return $7070751abfdd78c2$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
function $7070751abfdd78c2$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $7070751abfdd78c2$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $7070751abfdd78c2$var$stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ($fQMpe.hasSkipNormalizationHint(value)) return value;
    const overrideDepth = $fQMpe.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $7070751abfdd78c2$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = $42zXR.convertToPlainObject(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $7070751abfdd78c2$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $7070751abfdd78c2$var$stringifyValue(key, value) {
    try {
        if ($7070751abfdd78c2$var$stringifier) {
            const stringified = $7070751abfdd78c2$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${$1nK9H.getFunctionName(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $7070751abfdd78c2$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $7070751abfdd78c2$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $7070751abfdd78c2$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $7070751abfdd78c2$var$jsonSize(value) {
    return $7070751abfdd78c2$var$utf8Length(JSON.stringify(value));
}
function $7070751abfdd78c2$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $7070751abfdd78c2$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $7070751abfdd78c2$var$normalize;
module.exports.normalizeToSize = $7070751abfdd78c2$var$normalizeToSize;
module.exports.normalizeUrlToBase = $7070751abfdd78c2$var$normalizeUrlToBase;
module.exports.setNormalizeStringifier = $7070751abfdd78c2$var$setNormalizeStringifier;
module.exports.stringifyValue = $7070751abfdd78c2$var$stringifyValue;

});
parcelRegister("fQMpe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");
const $b8a142bff366f410$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $b8a142bff366f410$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $b8a142bff366f410$var$setSkipNormalizationHint(obj) {
    $42zXR.addNonEnumerableProperty(obj, $b8a142bff366f410$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $b8a142bff366f410$var$setNormalizationDepthOverrideHint(obj, depth) {
    $42zXR.addNonEnumerableProperty(obj, $b8a142bff366f410$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $b8a142bff366f410$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$b8a142bff366f410$var$SENTRY_SKIP_NORMALIZATION]);
}
function $b8a142bff366f410$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$b8a142bff366f410$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}
module.exports.getNormalizationDepthOverrideHint = $b8a142bff366f410$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $b8a142bff366f410$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $b8a142bff366f410$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $b8a142bff366f410$var$setSkipNormalizationHint;

});




parcelRegister("5L5uH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hkF3C = parcelRequire("hkF3C");

var $cqs9v = parcelRequire("cqs9v");
const $43159a8cc4d802e2$var$ONE_SECOND_IN_MS = 1e3;
function $43159a8cc4d802e2$var$dateTimestampInSeconds() {
    return $hkF3C.safeDateNow() / $43159a8cc4d802e2$var$ONE_SECOND_IN_MS;
}
function $43159a8cc4d802e2$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $cqs9v.GLOBAL_OBJ;
    if (!performance?.now || !performance.timeOrigin) return $43159a8cc4d802e2$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + $hkF3C.withRandomSafeContext(()=>performance.now())) / $43159a8cc4d802e2$var$ONE_SECOND_IN_MS;
    };
}
let $43159a8cc4d802e2$var$_cachedTimestampInSeconds;
function $43159a8cc4d802e2$var$timestampInSeconds() {
    const func = $43159a8cc4d802e2$var$_cachedTimestampInSeconds ?? ($43159a8cc4d802e2$var$_cachedTimestampInSeconds = $43159a8cc4d802e2$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $43159a8cc4d802e2$var$cachedTimeOrigin = null;
function $43159a8cc4d802e2$var$getBrowserTimeOrigin() {
    const { performance: performance } = $cqs9v.GLOBAL_OBJ;
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = $hkF3C.withRandomSafeContext(()=>performance.now());
    const dateNow = $hkF3C.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $43159a8cc4d802e2$var$browserPerformanceTimeOrigin() {
    if ($43159a8cc4d802e2$var$cachedTimeOrigin === null) $43159a8cc4d802e2$var$cachedTimeOrigin = $43159a8cc4d802e2$var$getBrowserTimeOrigin();
    return $43159a8cc4d802e2$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $43159a8cc4d802e2$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $43159a8cc4d802e2$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $43159a8cc4d802e2$var$timestampInSeconds;

});


parcelRegister("4ty0t", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $34243fdcb1b8eefc$var$merge(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $34243fdcb1b8eefc$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $34243fdcb1b8eefc$var$merge;

});

parcelRegister("8tW2T", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $rzjlZ = parcelRequire("rzjlZ");
function $62ce0ecfa1927b33$var$generateTraceId() {
    return $rzjlZ.uuid4();
}
function $62ce0ecfa1927b33$var$generateSpanId() {
    return $rzjlZ.uuid4().substring(16);
}
module.exports.generateSpanId = $62ce0ecfa1927b33$var$generateSpanId;
module.exports.generateTraceId = $62ce0ecfa1927b33$var$generateTraceId;

});

parcelRegister("6Uu3e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $2adP5 = parcelRequire("2adP5");
const $507f489210a81073$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $507f489210a81073$var$_setSpanForScope(scope, span) {
    if (span) $42zXR.addNonEnumerableProperty(scope, $507f489210a81073$var$SCOPE_SPAN_FIELD, $2adP5.makeWeakRef(span));
    else delete scope[$507f489210a81073$var$SCOPE_SPAN_FIELD];
}
function $507f489210a81073$var$_getSpanForScope(scope) {
    return $2adP5.derefWeakRef(scope[$507f489210a81073$var$SCOPE_SPAN_FIELD]);
}
module.exports._getSpanForScope = $507f489210a81073$var$_getSpanForScope;
module.exports._setSpanForScope = $507f489210a81073$var$_setSpanForScope;

});
parcelRegister("2adP5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");
function $19373ceb3edf88b5$var$makeWeakRef(value) {
    try {
        const WeakRefImpl = $cqs9v.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $19373ceb3edf88b5$var$derefWeakRef(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}
module.exports.derefWeakRef = $19373ceb3edf88b5$var$derefWeakRef;
module.exports.makeWeakRef = $19373ceb3edf88b5$var$makeWeakRef;

});




parcelRegister("6sseM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4b3b42f24caf0bc4$var$isActualPromise = (p)=>p instanceof Promise && !p[$4b3b42f24caf0bc4$var$kChainedCopy];
const $4b3b42f24caf0bc4$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $4b3b42f24caf0bc4$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $4b3b42f24caf0bc4$var$isActualPromise(chained) && $4b3b42f24caf0bc4$var$isActualPromise(original) ? chained : $4b3b42f24caf0bc4$var$copyProps(original, chained);
};
const $4b3b42f24caf0bc4$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$4b3b42f24caf0bc4$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $4b3b42f24caf0bc4$var$chainAndCopyPromiseLike;

});



parcelRegister("7DFGy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");
function $58fc82c09605267a$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $58fc82c09605267a$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $58fc82c09605267a$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $58fc82c09605267a$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $58fc82c09605267a$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $58fc82c09605267a$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $58fc82c09605267a$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $58fc82c09605267a$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($cUgOr.isPrimitive(val)) weight += $58fc82c09605267a$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $58fc82c09605267a$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $58fc82c09605267a$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $58fc82c09605267a$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $58fc82c09605267a$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $58fc82c09605267a$var$isAttributeObject;
module.exports.serializeAttributes = $58fc82c09605267a$var$serializeAttributes;

});

parcelRegister("5JqSP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $du5vT = parcelRequire("du5vT");

var $fTFTk = parcelRequire("fTFTk");

var $8tW2T = parcelRequire("8tW2T");
let $42c6023278febdcd$var$_externalPropagationContextProvider;
function $42c6023278febdcd$var$registerExternalPropagationContext(fn) {
    $42c6023278febdcd$var$_externalPropagationContextProvider = fn;
}
function $42c6023278febdcd$var$getExternalPropagationContext() {
    return $42c6023278febdcd$var$_externalPropagationContextProvider?.();
}
function $42c6023278febdcd$var$hasExternalPropagationContext() {
    return $42c6023278febdcd$var$_externalPropagationContextProvider !== void 0;
}
function $42c6023278febdcd$var$getCurrentScope() {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
function $42c6023278febdcd$var$getIsolationScope() {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
function $42c6023278febdcd$var$getGlobalScope() {
    return $du5vT.getGlobalSingleton("globalScope", ()=>new $fTFTk.Scope());
}
function $42c6023278febdcd$var$withScope(...rest) {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $42c6023278febdcd$var$withIsolationScope(...rest) {
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $42c6023278febdcd$var$getClient() {
    return $42c6023278febdcd$var$getCurrentScope().getClient();
}
function $42c6023278febdcd$var$getTraceContextFromScope(scope) {
    const externalContext = $42c6023278febdcd$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $8tW2T.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $42c6023278febdcd$var$getClient;
module.exports.getCurrentScope = $42c6023278febdcd$var$getCurrentScope;
module.exports.getExternalPropagationContext = $42c6023278febdcd$var$getExternalPropagationContext;
module.exports.getGlobalScope = $42c6023278febdcd$var$getGlobalScope;
module.exports.getIsolationScope = $42c6023278febdcd$var$getIsolationScope;
module.exports.getTraceContextFromScope = $42c6023278febdcd$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $42c6023278febdcd$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $42c6023278febdcd$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $42c6023278febdcd$var$withIsolationScope;
module.exports.withScope = $42c6023278febdcd$var$withScope;

});

parcelRegister("f3RkF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const $af708185da4792c9$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const $af708185da4792c9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $af708185da4792c9$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $af708185da4792c9$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $af708185da4792c9$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("h5H4c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c7144f765c0d780b$var$SPAN_STATUS_UNSET = 0;
const $c7144f765c0d780b$var$SPAN_STATUS_OK = 1;
const $c7144f765c0d780b$var$SPAN_STATUS_ERROR = 2;
function $c7144f765c0d780b$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $c7144f765c0d780b$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "not_found"
            };
        case 409:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "already_exists"
            };
        case 413:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "cancelled"
            };
        default:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "unavailable"
            };
        case 504:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
                message: "internal_error"
            };
    }
    return {
        code: $c7144f765c0d780b$var$SPAN_STATUS_ERROR,
        message: "internal_error"
    };
}
function $c7144f765c0d780b$var$setHttpStatus(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $c7144f765c0d780b$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $c7144f765c0d780b$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $c7144f765c0d780b$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $c7144f765c0d780b$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $c7144f765c0d780b$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $c7144f765c0d780b$var$setHttpStatus;

});

parcelRegister("dDvZT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $2adP5 = parcelRequire("2adP5");
const $9ed7bcdda0d6e774$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $9ed7bcdda0d6e774$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $9ed7bcdda0d6e774$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $9ed7bcdda0d6e774$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $9ed7bcdda0d6e774$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $9ed7bcdda0d6e774$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $2adP5.makeWeakRef(isolationScope));
        $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $9ed7bcdda0d6e774$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$9ed7bcdda0d6e774$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $2adP5.derefWeakRef(spanWithScopes[$9ed7bcdda0d6e774$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $9ed7bcdda0d6e774$var$markSpanForOtelSourceInference(span) {
    $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $9ed7bcdda0d6e774$var$spanShouldInferOtelSource(span) {
    return span[$9ed7bcdda0d6e774$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $9ed7bcdda0d6e774$var$markSpanSourceAsExplicit(span) {
    $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $9ed7bcdda0d6e774$var$spanSourceWasExplicitlySet(span) {
    return span[$9ed7bcdda0d6e774$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $9ed7bcdda0d6e774$var$markSpanAsTracerProviderSpan(span) {
    $42zXR.addNonEnumerableProperty(span, $9ed7bcdda0d6e774$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $9ed7bcdda0d6e774$var$spanIsTracerProviderSpan(span) {
    return span[$9ed7bcdda0d6e774$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}
module.exports.getCapturedScopesOnSpan = $9ed7bcdda0d6e774$var$getCapturedScopesOnSpan;
module.exports.markSpanAsTracerProviderSpan = $9ed7bcdda0d6e774$var$markSpanAsTracerProviderSpan;
module.exports.markSpanForOtelSourceInference = $9ed7bcdda0d6e774$var$markSpanForOtelSourceInference;
module.exports.markSpanSourceAsExplicit = $9ed7bcdda0d6e774$var$markSpanSourceAsExplicit;
module.exports.setCapturedScopesOnSpan = $9ed7bcdda0d6e774$var$setCapturedScopesOnSpan;
module.exports.spanIsTracerProviderSpan = $9ed7bcdda0d6e774$var$spanIsTracerProviderSpan;
module.exports.spanShouldInferOtelSource = $9ed7bcdda0d6e774$var$spanShouldInferOtelSource;
module.exports.spanSourceWasExplicitlySet = $9ed7bcdda0d6e774$var$spanSourceWasExplicitlySet;

});

parcelRegister("7O2T2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g31Ce = parcelRequire("g31Ce");

var $aZ3HH = parcelRequire("aZ3HH");

var $3zkbY = parcelRequire("3zkbY");

var $5CFT4 = parcelRequire("5CFT4");

var $8tW2T = parcelRequire("8tW2T");

var $hkF3C = parcelRequire("hkF3C");
const $5aef712847bf836f$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $5aef712847bf836f$var$extractTraceparentData(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($5aef712847bf836f$var$TRACEPARENT_REGEXP);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $5aef712847bf836f$var$isContinuingTrace(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $5aef712847bf836f$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $5aef712847bf836f$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $aZ3HH.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $8tW2T.generateTraceId(),
        sampleRand: $hkF3C.safeMathRandom()
    };
    const sampleRand = $5aef712847bf836f$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $5aef712847bf836f$var$generateSentryTraceHeader(traceId = $8tW2T.generateTraceId(), spanId = $8tW2T.generateSpanId(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $5aef712847bf836f$var$generateTraceparentHeader(traceId = $8tW2T.generateTraceId(), spanId = $8tW2T.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $5aef712847bf836f$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = $5CFT4.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = $5CFT4.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    $hkF3C.safeMathRandom() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + $hkF3C.safeMathRandom() * (1 - parsedSampleRate);
    else return $hkF3C.safeMathRandom();
}
function $5aef712847bf836f$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $3zkbY.extractOrgIdFromClient(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $g31Ce.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $g31Ce.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $5aef712847bf836f$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $5aef712847bf836f$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $5aef712847bf836f$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $5aef712847bf836f$var$generateTraceparentHeader;
module.exports.isContinuingTrace = $5aef712847bf836f$var$isContinuingTrace;
module.exports.propagationContextFromHeaders = $5aef712847bf836f$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $5aef712847bf836f$var$shouldContinueTrace;

});
parcelRegister("aZ3HH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");
const $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const $7ff2796312ccd2d8$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
function $7ff2796312ccd2d8$var$baggageHeaderToDynamicSamplingContext(baggageHeader) {
    const baggageObject = $7ff2796312ccd2d8$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $7ff2796312ccd2d8$var$dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $7ff2796312ccd2d8$var$objectToBaggageHeader(sentryPrefixedDSC);
}
function $7ff2796312ccd2d8$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$cUgOr.isString(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $7ff2796312ccd2d8$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $7ff2796312ccd2d8$var$baggageHeaderToObject(baggageHeader);
}
function $7ff2796312ccd2d8$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $7ff2796312ccd2d8$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $7ff2796312ccd2d8$var$MAX_BAGGAGE_STRING_LENGTH) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $7ff2796312ccd2d8$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $7ff2796312ccd2d8$var$parseBaggageHeader(existing);
    const incomingEntries = $7ff2796312ccd2d8$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $7ff2796312ccd2d8$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $7ff2796312ccd2d8$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $7ff2796312ccd2d8$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $7ff2796312ccd2d8$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $7ff2796312ccd2d8$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $7ff2796312ccd2d8$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $7ff2796312ccd2d8$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $7ff2796312ccd2d8$var$parseBaggageHeader;

});

parcelRegister("3zkbY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
const $29944db88c851502$var$ORG_ID_REGEX = /^o(\d+)\./;
const $29944db88c851502$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $29944db88c851502$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $29944db88c851502$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $29944db88c851502$var$dsnFromString(str) {
    const match = $29944db88c851502$var$DSN_REGEX.exec(str);
    if (!match) {
        $g31Ce.consoleSandbox(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $29944db88c851502$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $29944db88c851502$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $29944db88c851502$var$validateDsn(dsn) {
    if (!$3T29C.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $g31Ce.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $g31Ce.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$29944db88c851502$var$isValidProtocol(protocol)) {
        $g31Ce.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $g31Ce.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $29944db88c851502$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($29944db88c851502$var$ORG_ID_REGEX);
    return match?.[1];
}
function $29944db88c851502$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $29944db88c851502$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
function $29944db88c851502$var$makeDsn(from) {
    const components = typeof from === "string" ? $29944db88c851502$var$dsnFromString(from) : $29944db88c851502$var$dsnFromComponents(from);
    if (!components || !$29944db88c851502$var$validateDsn(components)) return void 0;
    return components;
}
module.exports.dsnFromString = $29944db88c851502$var$dsnFromString;
module.exports.dsnToString = $29944db88c851502$var$dsnToString;
module.exports.extractOrgIdFromClient = $29944db88c851502$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $29944db88c851502$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $29944db88c851502$var$makeDsn;

});

parcelRegister("5CFT4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $4180fe4ee82350a0$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}
module.exports.parseSampleRate = $4180fe4ee82350a0$var$parseSampleRate;

});




parcelRegister("gH8Ve", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $ckhr5 = parcelRequire("ckhr5");

var $ffWyI = parcelRequire("ffWyI");

var $6Uu3e = parcelRequire("6Uu3e");

var $6vUrj = parcelRequire("6vUrj");

var $5L5uH = parcelRequire("5L5uH");

var $gWYwh = parcelRequire("gWYwh");

var $lmDUN = parcelRequire("lmDUN");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $dDvZT = parcelRequire("dDvZT");
const $c2779539310b9438$var$TRACING_DEFAULTS = {
    idleTimeout: 1e3,
    finalTimeout: 3e4,
    childSpanTimeout: 15e3
};
const $c2779539310b9438$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $c2779539310b9438$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $c2779539310b9438$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $c2779539310b9438$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function $c2779539310b9438$var$startIdleSpan(startSpanOptions, options = {}) {
    const activities = /* @__PURE__ */ new Map();
    let _finished = false;
    let _idleTimeoutID;
    let _childSpanTimeoutID;
    let _finishReason = $c2779539310b9438$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $c2779539310b9438$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $c2779539310b9438$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $c2779539310b9438$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $5JqSP.getClient();
    const scope = $5JqSP.getCurrentScope();
    if (!client || !$ckhr5.hasSpansEnabled()) {
        const span2 = new $gWYwh.SentryNonRecordingSpan({
            traceId: scope.getPropagationContext().traceId
        });
        $dDvZT.setCapturedScopesOnSpan(span2, scope, $5JqSP.getIsolationScope());
        return span2;
    }
    const previousActiveSpan = $6vUrj.getActiveSpan();
    const span = $c2779539310b9438$var$_startIdleSpan(startSpanOptions);
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            if ($gWYwh.spanIsNonRecordingSpan(thisArg)) return;
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $5L5uH.timestampInSeconds();
            const spanEndTimestamp = $6vUrj.spanTimeInputToSeconds(timestamp);
            const spans = $6vUrj.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $6vUrj.spanToJSON(span);
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $6vUrj.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                if (ignoreSpans && $ffWyI.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, void 0);
            const spanStartTimestamp = spanJson.start_timestamp;
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = void 0;
        }
    }
    function _cancelChildSpanTimeout() {
        if (_childSpanTimeoutID) {
            clearTimeout(_childSpanTimeoutID);
            _childSpanTimeoutID = void 0;
        }
    }
    function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $c2779539310b9438$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    function _restartChildSpanTimeout(endTimestamp) {
        _cancelChildSpanTimeout();
        _childSpanTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $c2779539310b9438$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $5L5uH.timestampInSeconds();
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
    }
    function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $5L5uH.timestampInSeconds();
            _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
            _cancelChildSpanTimeout();
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $6Uu3e._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $6vUrj.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === "unknown") span.setStatus({
            code: $h5H4c.SPAN_STATUS_OK
        });
        $g31Ce.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $6vUrj.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
            }
            const childSpanJSON = $6vUrj.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($3T29C.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
                if (!spanStartedBeforeIdleSpanEnd) $g31Ce.debug.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $g31Ce.debug.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $6vUrj.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        if (_finished || startedSpan === span || !!$6vUrj.spanToJSON(startedSpan).timestamp || startedSpan instanceof $lmDUN.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $6vUrj.getSpanDescendants(span);
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: "deadline_exceeded"
            });
            _finishReason = $c2779539310b9438$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $c2779539310b9438$var$_startIdleSpan(options) {
    const span = $5CFne.startInactiveSpan(options);
    $6Uu3e._setSpanForScope($5JqSP.getCurrentScope(), span);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Started span is an idle span");
    return span;
}
module.exports.TRACING_DEFAULTS = $c2779539310b9438$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $c2779539310b9438$var$startIdleSpan;

});
parcelRegister("ckhr5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");
function $8f94e0b485116c5e$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $5JqSP.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $8f94e0b485116c5e$var$hasSpansEnabled;

});

parcelRegister("ffWyI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $foFxi = parcelRequire("foFxi");
function $b1b5ae56630cb71e$var$logIgnoredSpan(droppedSpan) {
    $g31Ce.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $b1b5ae56630cb71e$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($b1b5ae56630cb71e$var$isStringOrRegExp(pattern)) {
            if (span.description && $foFxi.isMatchingPattern(span.description, pattern)) {
                $3T29C.DEBUG_BUILD && $b1b5ae56630cb71e$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $foFxi.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $foFxi.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$b1b5ae56630cb71e$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            $3T29C.DEBUG_BUILD && $b1b5ae56630cb71e$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $b1b5ae56630cb71e$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return $foFxi.isMatchingPattern(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $b1b5ae56630cb71e$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $b1b5ae56630cb71e$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}
module.exports.reparentChildSpans = $b1b5ae56630cb71e$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $b1b5ae56630cb71e$var$shouldIgnoreSpan;

});

parcelRegister("gWYwh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");

var $8tW2T = parcelRequire("8tW2T");

var $6vUrj = parcelRequire("6vUrj");
const $c571020d7209a652$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $c571020d7209a652$var$SentryNonRecordingSpan {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $8tW2T.generateTraceId();
        this._spanId = spanContext.spanId || $8tW2T.generateSpanId();
        this.dropReason = spanContext.dropReason;
        $42zXR.addNonEnumerableProperty(this, $c571020d7209a652$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $6vUrj.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $c571020d7209a652$var$spanIsNonRecordingSpan(span) {
    return !!span && span[$c571020d7209a652$var$NON_RECORDING_SPAN_FIELD] === true;
}
module.exports.SentryNonRecordingSpan = $c571020d7209a652$var$SentryNonRecordingSpan;
module.exports.spanIsNonRecordingSpan = $c571020d7209a652$var$spanIsNonRecordingSpan;

});

parcelRegister("lmDUN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $ajhqL = parcelRequire("ajhqL");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $8tW2T = parcelRequire("8tW2T");

var $6vUrj = parcelRequire("6vUrj");

var $5L5uH = parcelRequire("5L5uH");

var $4LxkX = parcelRequire("4LxkX");

var $eE1Sn = parcelRequire("eE1Sn");

var $2IafG = parcelRequire("2IafG");

var $hcX9d = parcelRequire("hcX9d");

var $6Xrci = parcelRequire("6Xrci");

var $dDvZT = parcelRequire("dDvZT");
const $f8da9d5c51e274f7$var$MAX_SPAN_COUNT = 1e3;
class $f8da9d5c51e274f7$var$SentrySpan {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $8tW2T.generateTraceId();
        this._spanId = spanContext.spanId || $8tW2T.generateSpanId();
        this._startTime = spanContext.startTimestamp || $5L5uH.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "manual",
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $6vUrj.TRACE_FLAG_SAMPLED : $6vUrj.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === $f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE && value !== void 0 && $dDvZT.spanShouldInferOtelSource(this)) $dDvZT.markSpanSourceAsExplicit(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = $6vUrj.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!$dDvZT.spanShouldInferOtelSource(this)) this.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = $dDvZT.spanIsTracerProviderSpan(this);
            return;
        }
        this._endTime = $6vUrj.spanTimeInputToSeconds(endTimestamp);
        $eE1Sn.logSpanEnd(this);
        this._onSpanEnded();
        this._frozen = $dDvZT.spanIsTracerProviderSpan(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $6vUrj.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $2IafG.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $6vUrj.getRootSpan(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? $6vUrj.getRootSpan(this).spanContext().spanId : void 0,
            links: $6vUrj.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $6vUrj.getRootSpan(this),
            status: $6vUrj.getSimpleStatus(this._status),
            attributes: $6vUrj.addStatusMessageAttribute(this._attributes, this._status),
            links: $6vUrj.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Adding an event to span:", name);
        const time$1 = $f8da9d5c51e274f7$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $5L5uH.timestampInSeconds();
        const attributes = $f8da9d5c51e274f7$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $6vUrj.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $5JqSP.getClient();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = $6vUrj.getRootSpan(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $f8da9d5c51e274f7$var$sendSpanEnvelope($ajhqL.createSpanEnvelope([
                this
            ], client));
            else {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = $hcX9d.getSegmentSpanCaptureStrategy();
            if (strategy2) {
                const scope2 = $dDvZT.getCapturedScopesOnSpan(this).scope || $5JqSP.getCurrentScope();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && $6Xrci.hasSpanStreamingEnabled(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = $dDvZT.getCapturedScopesOnSpan(this).scope || $5JqSP.getCurrentScope();
        const strategy = $hcX9d.getSegmentSpanCaptureStrategy();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$f8da9d5c51e274f7$var$isFullFinishedSpan($6vUrj.spanToJSON(this))) return void 0;
        if (!this._name) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $dDvZT.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of $6vUrj.getSpanDescendants(this)){
            if (descendant === this || $f8da9d5c51e274f7$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = $6vUrj.spanToJSON(descendant);
            if (!$f8da9d5c51e274f7$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        delete this._attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: $6vUrj.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $f8da9d5c51e274f7$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $f8da9d5c51e274f7$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $4LxkX.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $2IafG.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $f8da9d5c51e274f7$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $f8da9d5c51e274f7$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $f8da9d5c51e274f7$var$isStandaloneSpan(span) {
    return span instanceof $f8da9d5c51e274f7$var$SentrySpan && span.isStandaloneSpan();
}
function $f8da9d5c51e274f7$var$sendSpanEnvelope(envelope) {
    const client = $5JqSP.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $f8da9d5c51e274f7$var$SentrySpan;

});
parcelRegister("ajhqL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4LxkX = parcelRequire("4LxkX");

var $dvzf1 = parcelRequire("dvzf1");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hkF3C = parcelRequire("hkF3C");

var $ffWyI = parcelRequire("ffWyI");

var $6vUrj = parcelRequire("6vUrj");
function $78193315b3283e9a$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $78193315b3283e9a$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $j6N8F.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return $j6N8F.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
function $78193315b3283e9a$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $j6N8F.getSdkMetadataForEnvelopeHeader(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $78193315b3283e9a$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $j6N8F.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $j6N8F.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
function $78193315b3283e9a$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = $4LxkX.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $6vUrj.spanToJSON(span);
        return !$ffWyI.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $6vUrj.spanToJSON(span);
        const processedSpan = !$dvzf1.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $6vUrj.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $6vUrj.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($j6N8F.createSpanEnvelopeItem(spanJson));
    }
    return $j6N8F.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $78193315b3283e9a$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $78193315b3283e9a$var$createEventEnvelope;
module.exports.createSessionEnvelope = $78193315b3283e9a$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $78193315b3283e9a$var$createSpanEnvelope;

});
parcelRegister("4LxkX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QW6c = parcelRequire("9QW6c");

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $aZ3HH = parcelRequire("aZ3HH");

var $3zkbY = parcelRequire("3zkbY");

var $ckhr5 = parcelRequire("ckhr5");

var $42zXR = parcelRequire("42zXR");

var $6vUrj = parcelRequire("6vUrj");

var $gWYwh = parcelRequire("gWYwh");

var $dDvZT = parcelRequire("dDvZT");
const $3785694342169588$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $3785694342169588$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $42zXR.addNonEnumerableProperty(spanWithMaybeDsc, $3785694342169588$var$FROZEN_DSC_FIELD, dsc);
}
function $3785694342169588$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || $9QW6c.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $3zkbY.extractOrgIdFromClient(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $3785694342169588$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $3785694342169588$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function $3785694342169588$var$getDynamicSamplingContextFromSpan(span) {
    const client = $5JqSP.getClient();
    if (!client) return {};
    const rootSpan = $6vUrj.getRootSpan(span);
    const rootSpanJson = $6vUrj.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$3785694342169588$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = $gWYwh.spanIsNonRecordingSpan(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!$ckhr5.hasSpansEnabled(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = $dDvZT.getCapturedScopesOnSpan(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$3785694342169588$var$getDynamicSamplingContextFromScope(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && $aZ3HH.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $3785694342169588$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    const source = rootSpanAttributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ($ckhr5.hasSpansEnabled()) {
        dsc.sampled = String($6vUrj.spanIsSampled(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $dDvZT.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $3785694342169588$var$spanToBaggageHeader(span) {
    const dsc = $3785694342169588$var$getDynamicSamplingContextFromSpan(span);
    return $aZ3HH.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $3785694342169588$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $3785694342169588$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $3785694342169588$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $3785694342169588$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $3785694342169588$var$spanToBaggageHeader;

});
parcelRegister("9QW6c", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $72c609a756dd8729$var$DEFAULT_ENVIRONMENT = "production";
const $72c609a756dd8729$var$DEV_ENVIRONMENT = "development";
module.exports.DEFAULT_ENVIRONMENT = $72c609a756dd8729$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $72c609a756dd8729$var$DEV_ENVIRONMENT;

});


parcelRegister("dvzf1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $42zXR = parcelRequire("42zXR");
function $9d5981cb10f487c4$var$withStreamedSpan(callback) {
    $42zXR.addNonEnumerableProperty(callback, "_streamed", true);
    return callback;
}
function $9d5981cb10f487c4$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $9d5981cb10f487c4$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $9d5981cb10f487c4$var$withStreamedSpan;

});

parcelRegister("j6N8F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $3zkbY = parcelRequire("3zkbY");

var $9EvIV = parcelRequire("9EvIV");

var $hkF3C = parcelRequire("hkF3C");

var $cqs9v = parcelRequire("cqs9v");
function $de94b1cea1c7957d$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $de94b1cea1c7957d$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $de94b1cea1c7957d$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $de94b1cea1c7957d$var$envelopeContainsItemType(envelope, types) {
    return $de94b1cea1c7957d$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
function $de94b1cea1c7957d$var$encodeUTF8(input) {
    const carrier$1 = $du5vT.getSentryCarrier($cqs9v.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $de94b1cea1c7957d$var$decodeUTF8(input) {
    const carrier$1 = $du5vT.getSentryCarrier($cqs9v.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $de94b1cea1c7957d$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $de94b1cea1c7957d$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $de94b1cea1c7957d$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify($9EvIV.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $de94b1cea1c7957d$var$concatBuffers(parts);
}
function $de94b1cea1c7957d$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $de94b1cea1c7957d$var$parseEnvelope(env) {
    let buffer = typeof env === "string" ? $de94b1cea1c7957d$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($de94b1cea1c7957d$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $de94b1cea1c7957d$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $de94b1cea1c7957d$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === "string" ? $de94b1cea1c7957d$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $de94b1cea1c7957d$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $de94b1cea1c7957d$var$_isOverriddenType(type) {
    return type in $de94b1cea1c7957d$var$DATA_CATEGORY_OVERRIDES;
}
function $de94b1cea1c7957d$var$envelopeItemTypeToDataCategory(type) {
    return $de94b1cea1c7957d$var$_isOverriddenType(type) ? $de94b1cea1c7957d$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $de94b1cea1c7957d$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $de94b1cea1c7957d$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $de94b1cea1c7957d$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $de94b1cea1c7957d$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $de94b1cea1c7957d$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $de94b1cea1c7957d$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $de94b1cea1c7957d$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $de94b1cea1c7957d$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $de94b1cea1c7957d$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $de94b1cea1c7957d$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $de94b1cea1c7957d$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $de94b1cea1c7957d$var$parseEnvelope;
module.exports.serializeEnvelope = $de94b1cea1c7957d$var$serializeEnvelope;

});


parcelRegister("eE1Sn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
function $aa9641ae301e3b6d$var$logSpanStart(span) {
    if (!$3T29C.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = $6vUrj.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $6vUrj.spanIsSampled(span);
    const rootSpan = $6vUrj.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = $6vUrj.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    $g31Ce.debug.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $aa9641ae301e3b6d$var$logSpanEnd(span) {
    if (!$3T29C.DEBUG_BUILD) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = $6vUrj.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $6vUrj.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    $g31Ce.debug.log(msg);
}
module.exports.logSpanEnd = $aa9641ae301e3b6d$var$logSpanEnd;
module.exports.logSpanStart = $aa9641ae301e3b6d$var$logSpanStart;

});

parcelRegister("2IafG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
function $1f97a4a6faa0ff0d$var$setMeasurement(name, value, unit, activeSpan = $6vUrj.getActiveSpan()) {
    const rootSpan = activeSpan && $6vUrj.getRootSpan(activeSpan);
    if (rootSpan) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
function $1f97a4a6faa0ff0d$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $1f97a4a6faa0ff0d$var$setMeasurement;
module.exports.timedEventsToMeasurements = $1f97a4a6faa0ff0d$var$timedEventsToMeasurements;

});

parcelRegister("hcX9d", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");
function $c8717028b4493875$var$setSegmentSpanCaptureStrategy(strategy) {
    $du5vT.getSentryCarrier($du5vT.getMainCarrier()).segmentSpanCaptureStrategy = strategy;
}
function $c8717028b4493875$var$getSegmentSpanCaptureStrategy() {
    return $du5vT.getSentryCarrier($du5vT.getMainCarrier()).segmentSpanCaptureStrategy;
}
module.exports.getSegmentSpanCaptureStrategy = $c8717028b4493875$var$getSegmentSpanCaptureStrategy;
module.exports.setSegmentSpanCaptureStrategy = $c8717028b4493875$var$setSegmentSpanCaptureStrategy;

});

parcelRegister("6Xrci", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $510d59981c7a3e38$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === "stream";
}
module.exports.hasSpanStreamingEnabled = $510d59981c7a3e38$var$hasSpanStreamingEnabled;

});


parcelRegister("5CFne", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $aZ3HH = parcelRequire("aZ3HH");

var $g31Ce = parcelRequire("g31Ce");

var $fzE9o = parcelRequire("fzE9o");

var $ckhr5 = parcelRequire("ckhr5");

var $ffWyI = parcelRequire("ffWyI");

var $6Xrci = parcelRequire("6Xrci");

var $5CFT4 = parcelRequire("5CFT4");

var $8tW2T = parcelRequire("8tW2T");

var $hkF3C = parcelRequire("hkF3C");

var $6Uu3e = parcelRequire("6Uu3e");

var $6vUrj = parcelRequire("6vUrj");

var $7O2T2 = parcelRequire("7O2T2");

var $4LxkX = parcelRequire("4LxkX");

var $eE1Sn = parcelRequire("eE1Sn");

var $6aMbm = parcelRequire("6aMbm");

var $gWYwh = parcelRequire("gWYwh");

var $lmDUN = parcelRequire("lmDUN");

var $h5H4c = parcelRequire("h5H4c");

var $dDvZT = parcelRequire("dDvZT");
const $4180984b3f9577eb$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function $4180984b3f9577eb$var$startSpan(options, callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $4180984b3f9577eb$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $5JqSP.withScope(customForkedScope, ()=>{
        const wrapper = $4180984b3f9577eb$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $5JqSP.getCurrentScope();
            const parentSpan = $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan);
            const client = $5JqSP.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, client) : $4180984b3f9577eb$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$4180984b3f9577eb$var$spanIsIgnored(activeSpan) || !parentSpan) $6Uu3e._setSpanForScope(scope, activeSpan);
            return $fzE9o.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                const { status: status } = $6vUrj.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $4180984b3f9577eb$var$startSpanManual(options, callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $4180984b3f9577eb$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $5JqSP.withScope(customForkedScope, ()=>{
        const wrapper = $4180984b3f9577eb$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $5JqSP.getCurrentScope();
            const parentSpan = $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, $5JqSP.getClient()) : $4180984b3f9577eb$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$4180984b3f9577eb$var$spanIsIgnored(activeSpan) || !parentSpan) $6Uu3e._setSpanForScope(scope, activeSpan);
            return $fzE9o.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = $6vUrj.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
            });
        });
    });
}
function $4180984b3f9577eb$var$startInactiveSpan(options) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $4180984b3f9577eb$var$_startInactiveSpanImpl(options);
}
function $4180984b3f9577eb$var$_INTERNAL_startInactiveSpan(options) {
    return $4180984b3f9577eb$var$_startInactiveSpanImpl(options);
}
function $4180984b3f9577eb$var$_startInactiveSpanImpl(options) {
    const spanArguments = $4180984b3f9577eb$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>$5JqSP.withScope(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$4180984b3f9577eb$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $5JqSP.getCurrentScope();
        const parentSpan = $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan);
        const client = $5JqSP.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, client);
        return $4180984b3f9577eb$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $4180984b3f9577eb$var$continueTrace = (options, callback)=>{
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $5JqSP.getClient();
    const incomingDsc = $aZ3HH.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$7O2T2.shouldContinueTrace(client, incomingDsc?.org_id)) return $4180984b3f9577eb$var$startNewTrace(callback);
    return $5JqSP.withScope((scope)=>{
        const propagationContext = $7O2T2.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $6Uu3e._setSpanForScope(scope, void 0);
        return callback();
    });
};
function $4180984b3f9577eb$var$withActiveSpan(span, callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $5JqSP.withScope((scope)=>{
        $6Uu3e._setSpanForScope(scope, span || void 0);
        return callback(scope);
    });
}
function $4180984b3f9577eb$var$suppressTracing(callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $5JqSP.withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [$4180984b3f9577eb$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$4180984b3f9577eb$var$SUPPRESS_TRACING_KEY]: void 0
        });
        return res;
    });
}
function $4180984b3f9577eb$var$isTracingSuppressed(scope = $5JqSP.getCurrentScope()) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$4180984b3f9577eb$var$SUPPRESS_TRACING_KEY] === true;
}
function $4180984b3f9577eb$var$startNewTrace(callback) {
    const acs = $4180984b3f9577eb$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $5JqSP.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $8tW2T.generateTraceId(),
            sampleRand: $hkF3C.safeMathRandom()
        });
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $4180984b3f9577eb$var$withActiveSpan(null, callback);
    });
}
function $4180984b3f9577eb$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new $gWYwh.SentryNonRecordingSpan({
        traceId: scope.getPropagationContext().traceId
    });
    $dDvZT.setCapturedScopesOnSpan(span, scope, $5JqSP.getIsolationScope());
    return span;
}
function $4180984b3f9577eb$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = $5JqSP.getIsolationScope();
    if (!$ckhr5.hasSpansEnabled()) {
        const scopePropagationContext = scope.getPropagationContext();
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new $gWYwh.SentryNonRecordingSpan({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) $6vUrj.addChildSpanToSpan(parentSpan, span2);
        $dDvZT.setCapturedScopesOnSpan(span2, scope, isolationScope);
        return span2;
    }
    const client = $5JqSP.getClient();
    if ($4180984b3f9577eb$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$4180984b3f9577eb$var$isTracingSuppressed(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new $gWYwh.SentryNonRecordingSpan({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) $6vUrj.addChildSpanToSpan(parentSpan, ignoredSpan);
        $dDvZT.setCapturedScopesOnSpan(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $4180984b3f9577eb$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        $6vUrj.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        const dsc = $4LxkX.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $6vUrj.spanIsSampled(parentSpan);
        span = $4180984b3f9577eb$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        $4LxkX.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = scope.getPropagationContext();
        span = $4180984b3f9577eb$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) $4LxkX.freezeDscOnSpan(span, dsc);
    }
    $eE1Sn.logSpanStart(span);
    return span;
}
function $4180984b3f9577eb$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $6vUrj.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $4180984b3f9577eb$var$getAcs() {
    const carrier$1 = $du5vT.getMainCarrier();
    return $3tUnp.getAsyncContextStrategy(carrier$1);
}
function $4180984b3f9577eb$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = $5JqSP.getClient();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $4180984b3f9577eb$var$isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : $6aMbm.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: $5CFT4.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $lmDUN.SentrySpan({
        ...spanArguments,
        attributes: {
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "custom",
            [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", $6Xrci.hasSpanStreamingEnabled(client) ? "span" : "transaction");
    }
    $dDvZT.setCapturedScopesOnSpan(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $4180984b3f9577eb$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $4180984b3f9577eb$var$isTracingSuppressed(scope);
    const sampled = _isTracingSuppressed ? false : $6vUrj.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $lmDUN.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $gWYwh.SentryNonRecordingSpan({
        traceId: traceId
    });
    $6vUrj.addChildSpanToSpan(parentSpan, childSpan);
    $dDvZT.setCapturedScopesOnSpan(childSpan, scope, isolationScope);
    const client = $5JqSP.getClient();
    if (!client) return childSpan;
    if ($6Xrci.hasSpanStreamingEnabled(client) && $gWYwh.spanIsNonRecordingSpan(childSpan)) {
        if ($gWYwh.spanIsNonRecordingSpan(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $4180984b3f9577eb$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = $6Uu3e._getSpanForScope(scope);
    if (!span) return void 0;
    const client = $5JqSP.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $6vUrj.getRootSpan(span);
    return span;
}
function $4180984b3f9577eb$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $4180984b3f9577eb$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
function $4180984b3f9577eb$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$6Xrci.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $ffWyI.shouldIgnoreSpan({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $4180984b3f9577eb$var$spanIsIgnored(span) {
    return $gWYwh.spanIsNonRecordingSpan(span) && span.dropReason === "ignored";
}
module.exports.SUPPRESS_TRACING_KEY = $4180984b3f9577eb$var$SUPPRESS_TRACING_KEY;
module.exports._INTERNAL_startInactiveSpan = $4180984b3f9577eb$var$_INTERNAL_startInactiveSpan;
module.exports.continueTrace = $4180984b3f9577eb$var$continueTrace;
module.exports.isTracingSuppressed = $4180984b3f9577eb$var$isTracingSuppressed;
module.exports.spanIsIgnored = $4180984b3f9577eb$var$spanIsIgnored;
module.exports.startInactiveSpan = $4180984b3f9577eb$var$startInactiveSpan;
module.exports.startNewTrace = $4180984b3f9577eb$var$startNewTrace;
module.exports.startSpan = $4180984b3f9577eb$var$startSpan;
module.exports.startSpanManual = $4180984b3f9577eb$var$startSpanManual;
module.exports.suppressTracing = $4180984b3f9577eb$var$suppressTracing;
module.exports.withActiveSpan = $4180984b3f9577eb$var$withActiveSpan;

});
parcelRegister("fzE9o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6sseM = parcelRequire("6sseM");

var $cUgOr = parcelRequire("cUgOr");
function $b56944f7a499cdfd$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $b56944f7a499cdfd$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $b56944f7a499cdfd$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($cUgOr.isThenable(value)) return $6sseM.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $b56944f7a499cdfd$var$handleCallbackErrors;

});

parcelRegister("6aMbm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $ckhr5 = parcelRequire("ckhr5");

var $5CFT4 = parcelRequire("5CFT4");
function $47e90d3c2c0ac8d2$var$sampleSpan(options, samplingContext, sampleRand) {
    if (!$ckhr5.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = $5CFT4.parseSampleRate(sampleRate);
    if (parsedSampleRate === void 0) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $47e90d3c2c0ac8d2$var$sampleSpan;

});



parcelRegister("26nWE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gMVt3 = parcelRequire("gMVt3");

var $hcX9d = parcelRequire("hcX9d");
const $187eb74ae7bc7e72$var$CAPTURED_SPANS = /* @__PURE__ */ new WeakSet();
const $187eb74ae7bc7e72$var$isSpanAlreadyCaptured = (span)=>$187eb74ae7bc7e72$var$CAPTURED_SPANS.has(span);
const $187eb74ae7bc7e72$var$markSpanCaptured = (span)=>{
    $187eb74ae7bc7e72$var$CAPTURED_SPANS.add(span);
};
const $187eb74ae7bc7e72$var$CLIENT_QUEUES = /* @__PURE__ */ new WeakMap();
function $187eb74ae7bc7e72$var$_INTERNAL_setDeferSegmentSpanCapture(client) {
    if (!$hcX9d.getSegmentSpanCaptureStrategy()) $hcX9d.setSegmentSpanCaptureStrategy($187eb74ae7bc7e72$var$deferredSegmentSpanCaptureStrategy);
    if ($187eb74ae7bc7e72$var$CLIENT_QUEUES.has(client)) return;
    const pendingCaptures = /* @__PURE__ */ new Set();
    const debouncedDrain = $gMVt3.debounce(()=>{
        const captures = [
            ...pendingCaptures
        ];
        pendingCaptures.clear();
        for (const capture of captures)capture();
    }, 1, {
        maxWait: 100
    });
    client.on("flush", ()=>{
        debouncedDrain.flush();
    });
    $187eb74ae7bc7e72$var$CLIENT_QUEUES.set(client, (capture)=>{
        pendingCaptures.add(capture);
        debouncedDrain();
    });
}
const $187eb74ae7bc7e72$var$deferredSegmentSpanCaptureStrategy = {
    onSegmentSpanEnded (convert, scope) {
        const client = scope.getClient();
        const enqueue = client && $187eb74ae7bc7e72$var$CLIENT_QUEUES.get(client);
        if (!enqueue) {
            const transactionEvent = convert();
            if (transactionEvent) client?.captureEvent(transactionEvent);
            return;
        }
        enqueue(()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $187eb74ae7bc7e72$var$isSpanAlreadyCaptured,
                onSpanCaptured: $187eb74ae7bc7e72$var$markSpanCaptured
            });
            if (transactionEvent) client.captureEvent(transactionEvent);
        });
    },
    onChildSpanEnded (span, rootSpan, convert, scope) {
        if ($187eb74ae7bc7e72$var$CAPTURED_SPANS.has(span) || !$187eb74ae7bc7e72$var$CAPTURED_SPANS.has(rootSpan)) return;
        const client = scope.getClient();
        const enqueue = client && $187eb74ae7bc7e72$var$CLIENT_QUEUES.get(client);
        const captureOrphan = ()=>{
            const transactionEvent = convert({
                isSpanAlreadyCaptured: $187eb74ae7bc7e72$var$isSpanAlreadyCaptured,
                onSpanCaptured: $187eb74ae7bc7e72$var$markSpanCaptured
            });
            if (transactionEvent?.contexts?.trace?.data) transactionEvent.contexts.trace.data["sentry.parent_span_already_sent"] = true;
            if (transactionEvent) client?.captureEvent(transactionEvent);
        };
        if (enqueue) enqueue(captureOrphan);
        else captureOrphan();
    }
};
module.exports._INTERNAL_setDeferSegmentSpanCapture = $187eb74ae7bc7e72$var$_INTERNAL_setDeferSegmentSpanCapture;

});
parcelRegister("gMVt3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c38db4eed84dc7b7$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== void 0 && clearTimeout(timerId);
        maxTimerId !== void 0 && clearTimeout(maxTimerId);
        timerId = maxTimerId = void 0;
    }
    function flush() {
        if (timerId !== void 0 || maxTimerId !== void 0) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === void 0) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $c38db4eed84dc7b7$var$debounce;

});


parcelRegister("c3F4R", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");
const $8c75a0f29048ba84$var$ADD_LISTENER_METHODS = [
    "addListener",
    "on",
    "once",
    "prependListener",
    "prependOnceListener",
    "addEventListener"
];
const $8c75a0f29048ba84$var$REMOVE_LISTENER_METHODS = [
    "removeListener",
    "off",
    "removeEventListener"
];
const $8c75a0f29048ba84$var$SCOPE_BOUND_LISTENERS = /* @__PURE__ */ Symbol("SentryScopeBoundListeners");
let $8c75a0f29048ba84$var$registeringWrapper;
function $8c75a0f29048ba84$var$isReentrantWrapperRegistration(listener) {
    return $8c75a0f29048ba84$var$registeringWrapper !== void 0 && (listener === $8c75a0f29048ba84$var$registeringWrapper || listener.listener === $8c75a0f29048ba84$var$registeringWrapper);
}
function $8c75a0f29048ba84$var$bindScopeToEmitter(emitter, scope = $5JqSP.getCurrentScope()) {
    const ee = emitter;
    if ($8c75a0f29048ba84$var$getPatchMap(ee)) return emitter;
    $8c75a0f29048ba84$var$createPatchMap(ee);
    for (const methodName of $8c75a0f29048ba84$var$ADD_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $8c75a0f29048ba84$var$patchAddListener(ee, ee[methodName], scope);
    }
    for (const methodName of $8c75a0f29048ba84$var$REMOVE_LISTENER_METHODS){
        if (typeof ee[methodName] !== "function") continue;
        ee[methodName] = $8c75a0f29048ba84$var$patchRemoveListener(ee, ee[methodName]);
    }
    if (typeof ee.removeAllListeners === "function") ee.removeAllListeners = $8c75a0f29048ba84$var$patchRemoveAllListeners(ee, ee.removeAllListeners);
    return emitter;
}
function $8c75a0f29048ba84$var$bindListenerToScope(listener, scope) {
    return function(...args) {
        return $5JqSP.withScope(scope, ()=>listener.apply(this, args));
    };
}
function $8c75a0f29048ba84$var$isBoundListener(listener) {
    return typeof listener === "function";
}
function $8c75a0f29048ba84$var$patchAddListener(ee, original, scope) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        if (!$8c75a0f29048ba84$var$isBoundListener(listener) || $8c75a0f29048ba84$var$isReentrantWrapperRegistration(listener)) return original.apply(this, args);
        const map = $8c75a0f29048ba84$var$getPatchMap(ee) || $8c75a0f29048ba84$var$createPatchMap(ee);
        let listeners = map.get(event);
        if (!listeners) {
            listeners = /* @__PURE__ */ new WeakMap();
            map.set(event, listeners);
        }
        let boundListener = listeners.get(listener);
        if (!boundListener) {
            boundListener = $8c75a0f29048ba84$var$bindListenerToScope(listener, scope);
            listeners.set(listener, boundListener);
        }
        const previous = $8c75a0f29048ba84$var$registeringWrapper;
        $8c75a0f29048ba84$var$registeringWrapper = boundListener;
        try {
            return original.call(this, event, boundListener, ...rest);
        } finally{
            $8c75a0f29048ba84$var$registeringWrapper = previous;
        }
    };
}
function $8c75a0f29048ba84$var$patchRemoveListener(ee, original) {
    return function(...args) {
        const event = args[0];
        const listener = args[1];
        const rest = args.slice(2);
        const boundListener = $8c75a0f29048ba84$var$isBoundListener(listener) ? $8c75a0f29048ba84$var$getPatchMap(ee)?.get(event)?.get(listener) : void 0;
        if (!boundListener) return original.apply(this, args);
        return original.call(this, event, boundListener, ...rest);
    };
}
function $8c75a0f29048ba84$var$patchRemoveAllListeners(ee, original) {
    return function(...args) {
        const map = $8c75a0f29048ba84$var$getPatchMap(ee);
        if (map) {
            if (args.length === 0) $8c75a0f29048ba84$var$createPatchMap(ee);
            else {
                const event = args[0];
                map.delete(event);
            }
        }
        return original.apply(this, args);
    };
}
function $8c75a0f29048ba84$var$createPatchMap(ee) {
    const map = /* @__PURE__ */ new Map();
    ee[$8c75a0f29048ba84$var$SCOPE_BOUND_LISTENERS] = map;
    return map;
}
function $8c75a0f29048ba84$var$getPatchMap(ee) {
    return ee[$8c75a0f29048ba84$var$SCOPE_BOUND_LISTENERS];
}
module.exports.bindScopeToEmitter = $8c75a0f29048ba84$var$bindScopeToEmitter;

});

parcelRegister("4wQxQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $aX5wF = parcelRequire("aX5wF");

var $6vUrj = parcelRequire("6vUrj");

var $dDvZT = parcelRequire("dDvZT");

var $dvzf1 = parcelRequire("dvzf1");

var $fYBGH = parcelRequire("fYBGH");

var $9QW6c = parcelRequire("9QW6c");

var $eAISS = parcelRequire("eAISS");
function $34c2e8e657651818$var$captureSpan(span, client) {
    const spanJSON = $6vUrj.spanToStreamedSpanJSON(span);
    const segmentSpan = $6vUrj.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $6vUrj.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $dDvZT.getCapturedScopesOnSpan(span);
    const finalScopeData = $aX5wF.getCombinedScopeData(spanIsolationScope, spanScope);
    $34c2e8e657651818$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    const spanKind = span.kind;
    client.emit("preprocessSpan", spanJSON, {
        spanKind: spanKind
    });
    if (spanJSON.is_segment) {
        $34c2e8e657651818$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $34c2e8e657651818$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $dvzf1.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $34c2e8e657651818$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    const spanNameSource = processedSpan.attributes?.[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanJSON.is_segment && spanNameSource) $34c2e8e657651818$var$safeSetSpanJSONAttributes(processedSpan, {
        ["sentry.segment.name.source"]: spanNameSource
    });
    return {
        ...$6vUrj.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $34c2e8e657651818$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = $fYBGH.scopeContextsToSpanAttributes(scopeData.contexts);
    $34c2e8e657651818$var$safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function $34c2e8e657651818$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $34c2e8e657651818$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $34c2e8e657651818$var$safeSetSpanJSONAttributes(segmentSpanJSON, {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS]: integrationNames
    });
}
function $34c2e8e657651818$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    $34c2e8e657651818$var$safeSetSpanJSONAttributes(spanJSON, {
        [$eAISS.SENTRY_TRACE_LIFECYCLE]: "stream",
        [$eAISS.SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$eAISS.SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$eAISS.SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$eAISS.SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment || $9QW6c.DEFAULT_ENVIRONMENT,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$f3RkF.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
function $34c2e8e657651818$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $6vUrj.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
module.exports.applyBeforeSendSpanCallback = $34c2e8e657651818$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $34c2e8e657651818$var$captureSpan;
module.exports.safeSetSpanJSONAttributes = $34c2e8e657651818$var$safeSetSpanJSONAttributes;

});
parcelRegister("aX5wF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $4LxkX = parcelRequire("4LxkX");

var $4ty0t = parcelRequire("4ty0t");

var $6vUrj = parcelRequire("6vUrj");
function $7f93b3696c1e22bd$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $7f93b3696c1e22bd$var$applyDataToEvent(event, data);
    if (span) $7f93b3696c1e22bd$var$applySpanToEvent(event, span);
    $7f93b3696c1e22bd$var$applyFingerprintToEvent(event, fingerprint);
    $7f93b3696c1e22bd$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $7f93b3696c1e22bd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $7f93b3696c1e22bd$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "extra", extra);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "tags", tags);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "attributes", attributes);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "user", user);
    $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, "contexts", contexts);
    data.sdkProcessingMetadata = $4ty0t.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $4ty0t.merge(data[prop], mergeVal, 1);
}
function $7f93b3696c1e22bd$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $5JqSP.getGlobalScope().getScopeData();
    isolationScope && $7f93b3696c1e22bd$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $7f93b3696c1e22bd$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $7f93b3696c1e22bd$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $7f93b3696c1e22bd$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $7f93b3696c1e22bd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $7f93b3696c1e22bd$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $6vUrj.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $4LxkX.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $6vUrj.getRootSpan(span);
    const transactionName = $6vUrj.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $7f93b3696c1e22bd$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $7f93b3696c1e22bd$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $7f93b3696c1e22bd$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $7f93b3696c1e22bd$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $7f93b3696c1e22bd$var$mergeScopeData;

});

parcelRegister("fYBGH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ba19b19bbb2994c3$var$scopeContextsToSpanAttributes(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}
module.exports.scopeContextsToSpanAttributes = $ba19b19bbb2994c3$var$scopeContextsToSpanAttributes;

});

parcelRegister("eAISS", function(module, exports) {
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

module.exports = (parcelRequire("eZ61f"));

});
parcelRegister("eZ61f", function(module, exports) {

$parcel$export(module.exports, "AI_CITATIONS", function () { return $8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd; }, function (v) { return $8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd = v; });
$parcel$export(module.exports, "AI_COMPLETION_TOKENS_USED", function () { return $8b11dd70aaca6dbd$export$cc06afd6de7f2c10; }, function (v) { return $8b11dd70aaca6dbd$export$cc06afd6de7f2c10 = v; });
$parcel$export(module.exports, "AI_DOCUMENTS", function () { return $8b11dd70aaca6dbd$export$ced6746028fe2cc; }, function (v) { return $8b11dd70aaca6dbd$export$ced6746028fe2cc = v; });
$parcel$export(module.exports, "AI_FINISH_REASON", function () { return $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8; }, function (v) { return $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8 = v; });
$parcel$export(module.exports, "AI_FREQUENCY_PENALTY", function () { return $8b11dd70aaca6dbd$export$f02d892201cd8d36; }, function (v) { return $8b11dd70aaca6dbd$export$f02d892201cd8d36 = v; });
$parcel$export(module.exports, "AI_FUNCTION_CALL", function () { return $8b11dd70aaca6dbd$export$f277a7ef9e273960; }, function (v) { return $8b11dd70aaca6dbd$export$f277a7ef9e273960 = v; });
$parcel$export(module.exports, "AI_GENERATION_ID", function () { return $8b11dd70aaca6dbd$export$1a8c212c3becaa80; }, function (v) { return $8b11dd70aaca6dbd$export$1a8c212c3becaa80 = v; });
$parcel$export(module.exports, "AI_INPUT_MESSAGES", function () { return $8b11dd70aaca6dbd$export$721b137086c68a47; }, function (v) { return $8b11dd70aaca6dbd$export$721b137086c68a47 = v; });
$parcel$export(module.exports, "AI_IS_SEARCH_REQUIRED", function () { return $8b11dd70aaca6dbd$export$6afde2bb69d9aa86; }, function (v) { return $8b11dd70aaca6dbd$export$6afde2bb69d9aa86 = v; });
$parcel$export(module.exports, "AI_METADATA", function () { return $8b11dd70aaca6dbd$export$eadb4b562c974031; }, function (v) { return $8b11dd70aaca6dbd$export$eadb4b562c974031 = v; });
$parcel$export(module.exports, "AI_MODEL_ID", function () { return $8b11dd70aaca6dbd$export$22a90f0ac1eee843; }, function (v) { return $8b11dd70aaca6dbd$export$22a90f0ac1eee843 = v; });
$parcel$export(module.exports, "AI_MODEL_PROVIDER", function () { return $8b11dd70aaca6dbd$export$a727f215a0be1dad; }, function (v) { return $8b11dd70aaca6dbd$export$a727f215a0be1dad = v; });
$parcel$export(module.exports, "AI_PIPELINE_NAME", function () { return $8b11dd70aaca6dbd$export$536bc61b34d995e5; }, function (v) { return $8b11dd70aaca6dbd$export$536bc61b34d995e5 = v; });
$parcel$export(module.exports, "AI_PREAMBLE", function () { return $8b11dd70aaca6dbd$export$c43ea6115b380e62; }, function (v) { return $8b11dd70aaca6dbd$export$c43ea6115b380e62 = v; });
$parcel$export(module.exports, "AI_PRESENCE_PENALTY", function () { return $8b11dd70aaca6dbd$export$d2a16e26bada7cf1; }, function (v) { return $8b11dd70aaca6dbd$export$d2a16e26bada7cf1 = v; });
$parcel$export(module.exports, "AI_PROMPT_TOKENS_USED", function () { return $8b11dd70aaca6dbd$export$604eb1bd2278163b; }, function (v) { return $8b11dd70aaca6dbd$export$604eb1bd2278163b = v; });
$parcel$export(module.exports, "AI_RAW_PROMPTING", function () { return $8b11dd70aaca6dbd$export$2f8568696c5aa352; }, function (v) { return $8b11dd70aaca6dbd$export$2f8568696c5aa352 = v; });
$parcel$export(module.exports, "AI_RESPONSES", function () { return $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9; }, function (v) { return $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9 = v; });
$parcel$export(module.exports, "AI_RESPONSE_FORMAT", function () { return $8b11dd70aaca6dbd$export$e176bf5dc45e40df; }, function (v) { return $8b11dd70aaca6dbd$export$e176bf5dc45e40df = v; });
$parcel$export(module.exports, "AI_SEARCH_QUERIES", function () { return $8b11dd70aaca6dbd$export$c4ea01fd53f64e16; }, function (v) { return $8b11dd70aaca6dbd$export$c4ea01fd53f64e16 = v; });
$parcel$export(module.exports, "AI_SEARCH_RESULTS", function () { return $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9; }, function (v) { return $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9 = v; });
$parcel$export(module.exports, "AI_SEED", function () { return $8b11dd70aaca6dbd$export$1762c11b666b026a; }, function (v) { return $8b11dd70aaca6dbd$export$1762c11b666b026a = v; });
$parcel$export(module.exports, "AI_STREAMING", function () { return $8b11dd70aaca6dbd$export$14ddd4b729910100; }, function (v) { return $8b11dd70aaca6dbd$export$14ddd4b729910100 = v; });
$parcel$export(module.exports, "AI_TAGS", function () { return $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb; }, function (v) { return $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb = v; });
$parcel$export(module.exports, "AI_TEMPERATURE", function () { return $8b11dd70aaca6dbd$export$2b748b9eca00828b; }, function (v) { return $8b11dd70aaca6dbd$export$2b748b9eca00828b = v; });
$parcel$export(module.exports, "AI_TEXTS", function () { return $8b11dd70aaca6dbd$export$5af25308c11addea; }, function (v) { return $8b11dd70aaca6dbd$export$5af25308c11addea = v; });
$parcel$export(module.exports, "AI_TOOLS", function () { return $8b11dd70aaca6dbd$export$28f78b3b1663cb92; }, function (v) { return $8b11dd70aaca6dbd$export$28f78b3b1663cb92 = v; });
$parcel$export(module.exports, "AI_TOOL_CALLS", function () { return $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f; }, function (v) { return $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f = v; });
$parcel$export(module.exports, "AI_TOP_K", function () { return $8b11dd70aaca6dbd$export$322bd4ea9f163663; }, function (v) { return $8b11dd70aaca6dbd$export$322bd4ea9f163663 = v; });
$parcel$export(module.exports, "AI_TOP_P", function () { return $8b11dd70aaca6dbd$export$95711b9e669edad8; }, function (v) { return $8b11dd70aaca6dbd$export$95711b9e669edad8 = v; });
$parcel$export(module.exports, "AI_TOTAL_COST", function () { return $8b11dd70aaca6dbd$export$5924d7d72384626a; }, function (v) { return $8b11dd70aaca6dbd$export$5924d7d72384626a = v; });
$parcel$export(module.exports, "AI_TOTAL_TOKENS_USED", function () { return $8b11dd70aaca6dbd$export$db3b1b877a4ce4db; }, function (v) { return $8b11dd70aaca6dbd$export$db3b1b877a4ce4db = v; });
$parcel$export(module.exports, "AI_WARNINGS", function () { return $8b11dd70aaca6dbd$export$a434a3e8afec2879; }, function (v) { return $8b11dd70aaca6dbd$export$a434a3e8afec2879 = v; });
$parcel$export(module.exports, "ANGULAR_VERSION", function () { return $8b11dd70aaca6dbd$export$fe00bb20636d42af; }, function (v) { return $8b11dd70aaca6dbd$export$fe00bb20636d42af = v; });
$parcel$export(module.exports, "APP_APP_BUILD", function () { return $8b11dd70aaca6dbd$export$712aa698b7ee271e; }, function (v) { return $8b11dd70aaca6dbd$export$712aa698b7ee271e = v; });
$parcel$export(module.exports, "APP_APP_IDENTIFIER", function () { return $8b11dd70aaca6dbd$export$1fac638b11ec16d9; }, function (v) { return $8b11dd70aaca6dbd$export$1fac638b11ec16d9 = v; });
$parcel$export(module.exports, "APP_APP_NAME", function () { return $8b11dd70aaca6dbd$export$d132016ea64058e3; }, function (v) { return $8b11dd70aaca6dbd$export$d132016ea64058e3 = v; });
$parcel$export(module.exports, "APP_APP_START_TIME", function () { return $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed; }, function (v) { return $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed = v; });
$parcel$export(module.exports, "APP_APP_VERSION", function () { return $8b11dd70aaca6dbd$export$9f80c4b11053cef1; }, function (v) { return $8b11dd70aaca6dbd$export$9f80c4b11053cef1 = v; });
$parcel$export(module.exports, "APP_BUILD", function () { return $8b11dd70aaca6dbd$export$5f7a08466d84e877; }, function (v) { return $8b11dd70aaca6dbd$export$5f7a08466d84e877 = v; });
$parcel$export(module.exports, "APP_IDENTIFIER", function () { return $8b11dd70aaca6dbd$export$2cea7f14750b8c19; }, function (v) { return $8b11dd70aaca6dbd$export$2cea7f14750b8c19 = v; });
$parcel$export(module.exports, "APP_IN_FOREGROUND", function () { return $8b11dd70aaca6dbd$export$34c59270f032a6c6; }, function (v) { return $8b11dd70aaca6dbd$export$34c59270f032a6c6 = v; });
$parcel$export(module.exports, "APP_NAME", function () { return $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7; }, function (v) { return $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7 = v; });
$parcel$export(module.exports, "APP_START_COLD", function () { return $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50; }, function (v) { return $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50 = v; });
$parcel$export(module.exports, "APP_START_TIME", function () { return $8b11dd70aaca6dbd$export$ba267414e3c0d822; }, function (v) { return $8b11dd70aaca6dbd$export$ba267414e3c0d822 = v; });
$parcel$export(module.exports, "APP_START_TYPE", function () { return $8b11dd70aaca6dbd$export$71b176005902b99e; }, function (v) { return $8b11dd70aaca6dbd$export$71b176005902b99e = v; });
$parcel$export(module.exports, "APP_START_WARM", function () { return $8b11dd70aaca6dbd$export$5c5b5a3c245a0079; }, function (v) { return $8b11dd70aaca6dbd$export$5c5b5a3c245a0079 = v; });
$parcel$export(module.exports, "APP_VERSION", function () { return $8b11dd70aaca6dbd$export$8ee1df3c6367a60; }, function (v) { return $8b11dd70aaca6dbd$export$8ee1df3c6367a60 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_DELAY_VALUE", function () { return $8b11dd70aaca6dbd$export$e8c7802ae95beccf; }, function (v) { return $8b11dd70aaca6dbd$export$e8c7802ae95beccf = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_COUNT", function () { return $8b11dd70aaca6dbd$export$bb237734da4d464; }, function (v) { return $8b11dd70aaca6dbd$export$bb237734da4d464 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_COUNT", function () { return $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6; }, function (v) { return $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_TOTAL_COUNT", function () { return $8b11dd70aaca6dbd$export$36223ebd4a30e9f5; }, function (v) { return $8b11dd70aaca6dbd$export$36223ebd4a30e9f5 = v; });
$parcel$export(module.exports, "APP_VITALS_START_COLD_VALUE", function () { return $8b11dd70aaca6dbd$export$8feaa177bb7941e2; }, function (v) { return $8b11dd70aaca6dbd$export$8feaa177bb7941e2 = v; });
$parcel$export(module.exports, "APP_VITALS_START_PREWARMED", function () { return $8b11dd70aaca6dbd$export$e1ca25240db91d68; }, function (v) { return $8b11dd70aaca6dbd$export$e1ca25240db91d68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_REASON", function () { return $8b11dd70aaca6dbd$export$404a223fd1ada08b; }, function (v) { return $8b11dd70aaca6dbd$export$404a223fd1ada08b = v; });
$parcel$export(module.exports, "APP_VITALS_START_SCREEN", function () { return $8b11dd70aaca6dbd$export$53362079310c68; }, function (v) { return $8b11dd70aaca6dbd$export$53362079310c68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_TYPE", function () { return $8b11dd70aaca6dbd$export$3efb5af0ac379f77; }, function (v) { return $8b11dd70aaca6dbd$export$3efb5af0ac379f77 = v; });
$parcel$export(module.exports, "APP_VITALS_START_WARM_VALUE", function () { return $8b11dd70aaca6dbd$export$2c10c1ca0612c46d; }, function (v) { return $8b11dd70aaca6dbd$export$2c10c1ca0612c46d = v; });
$parcel$export(module.exports, "APP_VITALS_TTFD_VALUE", function () { return $8b11dd70aaca6dbd$export$bbb86ad4d6654da6; }, function (v) { return $8b11dd70aaca6dbd$export$bbb86ad4d6654da6 = v; });
$parcel$export(module.exports, "APP_VITALS_TTID_VALUE", function () { return $8b11dd70aaca6dbd$export$ad6896f00a2b1076; }, function (v) { return $8b11dd70aaca6dbd$export$ad6896f00a2b1076 = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_COUNT", function () { return $8b11dd70aaca6dbd$export$300f39d8506a273d; }, function (v) { return $8b11dd70aaca6dbd$export$300f39d8506a273d = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_TIME", function () { return $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7; }, function (v) { return $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7 = v; });
$parcel$export(module.exports, "ART_GC_PRE_OOME_COUNT", function () { return $8b11dd70aaca6dbd$export$74b78acb4c54c06b; }, function (v) { return $8b11dd70aaca6dbd$export$74b78acb4c54c06b = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_COUNT", function () { return $8b11dd70aaca6dbd$export$b15b2c133bc50e33; }, function (v) { return $8b11dd70aaca6dbd$export$b15b2c133bc50e33 = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_TIME", function () { return $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95; }, function (v) { return $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95 = v; });
$parcel$export(module.exports, "ART_GC_WAITING_TIME", function () { return $8b11dd70aaca6dbd$export$c170b7ff277132ea; }, function (v) { return $8b11dd70aaca6dbd$export$c170b7ff277132ea = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE", function () { return $8b11dd70aaca6dbd$export$9459a5df93695e45; }, function (v) { return $8b11dd70aaca6dbd$export$9459a5df93695e45 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_GC", function () { return $8b11dd70aaca6dbd$export$a7902bd57492ebe8; }, function (v) { return $8b11dd70aaca6dbd$export$a7902bd57492ebe8 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_OOME", function () { return $8b11dd70aaca6dbd$export$d2ace0da59da09b7; }, function (v) { return $8b11dd70aaca6dbd$export$d2ace0da59da09b7 = v; });
$parcel$export(module.exports, "ART_MEMORY_MAX", function () { return $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb; }, function (v) { return $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb = v; });
$parcel$export(module.exports, "ART_MEMORY_TOTAL", function () { return $8b11dd70aaca6dbd$export$5405b0a98e00e538; }, function (v) { return $8b11dd70aaca6dbd$export$5405b0a98e00e538 = v; });
$parcel$export(module.exports, "ATTRIBUTE_METADATA", function () { return $8b11dd70aaca6dbd$export$bd393bbb84b309d3; }, function (v) { return $8b11dd70aaca6dbd$export$bd393bbb84b309d3 = v; });
$parcel$export(module.exports, "ATTRIBUTE_TYPE", function () { return $8b11dd70aaca6dbd$export$96f586f8837b86ae; }, function (v) { return $8b11dd70aaca6dbd$export$96f586f8837b86ae = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_GROUP", function () { return $8b11dd70aaca6dbd$export$5d9f28f388f552d2; }, function (v) { return $8b11dd70aaca6dbd$export$5d9f28f388f552d2 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_STREAM", function () { return $8b11dd70aaca6dbd$export$b3d2f68e0e769504; }, function (v) { return $8b11dd70aaca6dbd$export$b3d2f68e0e769504 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_URL", function () { return $8b11dd70aaca6dbd$export$2c98412ed43013e8; }, function (v) { return $8b11dd70aaca6dbd$export$2c98412ed43013e8 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", function () { return $8b11dd70aaca6dbd$export$a7bd794d11c19f1b; }, function (v) { return $8b11dd70aaca6dbd$export$a7bd794d11c19f1b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSISTENT_READ", function () { return $8b11dd70aaca6dbd$export$df4227832b83fdd0; }, function (v) { return $8b11dd70aaca6dbd$export$df4227832b83fdd0 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSUMED_CAPACITY", function () { return $8b11dd70aaca6dbd$export$f131a6d8fbc0534f; }, function (v) { return $8b11dd70aaca6dbd$export$f131a6d8fbc0534f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_COUNT", function () { return $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a; }, function (v) { return $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_EXCLUSIVE_START_TABLE", function () { return $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98; }, function (v) { return $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", function () { return $8b11dd70aaca6dbd$export$3565fa72459aa4d6; }, function (v) { return $8b11dd70aaca6dbd$export$3565fa72459aa4d6 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", function () { return $8b11dd70aaca6dbd$export$bb67a834ae4bffdc; }, function (v) { return $8b11dd70aaca6dbd$export$bb67a834ae4bffdc = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_INDEX_NAME", function () { return $8b11dd70aaca6dbd$export$4a06c859a283f06; }, function (v) { return $8b11dd70aaca6dbd$export$4a06c859a283f06 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ITEM_COLLECTION_METRICS", function () { return $8b11dd70aaca6dbd$export$68324fac2038d0f2; }, function (v) { return $8b11dd70aaca6dbd$export$68324fac2038d0f2 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LIMIT", function () { return $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb; }, function (v) { return $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", function () { return $8b11dd70aaca6dbd$export$bfdf2261058f56b; }, function (v) { return $8b11dd70aaca6dbd$export$bfdf2261058f56b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROJECTION", function () { return $8b11dd70aaca6dbd$export$23bf57842d9d53df; }, function (v) { return $8b11dd70aaca6dbd$export$23bf57842d9d53df = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", function () { return $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35; }, function (v) { return $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", function () { return $8b11dd70aaca6dbd$export$82eb6cccda27c3ff; }, function (v) { return $8b11dd70aaca6dbd$export$82eb6cccda27c3ff = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCANNED_COUNT", function () { return $8b11dd70aaca6dbd$export$8ea68734d455808f; }, function (v) { return $8b11dd70aaca6dbd$export$8ea68734d455808f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCAN_FORWARD", function () { return $8b11dd70aaca6dbd$export$40050e29324d44ee; }, function (v) { return $8b11dd70aaca6dbd$export$40050e29324d44ee = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SEGMENT", function () { return $8b11dd70aaca6dbd$export$5cd7541006d9f467; }, function (v) { return $8b11dd70aaca6dbd$export$5cd7541006d9f467 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SELECT", function () { return $8b11dd70aaca6dbd$export$81c017edd95d692e; }, function (v) { return $8b11dd70aaca6dbd$export$81c017edd95d692e = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_COUNT", function () { return $8b11dd70aaca6dbd$export$120b3897a58cf903; }, function (v) { return $8b11dd70aaca6dbd$export$120b3897a58cf903 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_NAMES", function () { return $8b11dd70aaca6dbd$export$d4a9de43b4b1076c; }, function (v) { return $8b11dd70aaca6dbd$export$d4a9de43b4b1076c = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TOTAL_SEGMENTS", function () { return $8b11dd70aaca6dbd$export$f37f4f9022f1ab17; }, function (v) { return $8b11dd70aaca6dbd$export$f37f4f9022f1ab17 = v; });
$parcel$export(module.exports, "AWS_EXTENDED_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$66ac18da14747cfb; }, function (v) { return $8b11dd70aaca6dbd$export$66ac18da14747cfb = v; });
$parcel$export(module.exports, "AWS_KINESIS_STREAM_NAME", function () { return $8b11dd70aaca6dbd$export$9e49b833525ca49d; }, function (v) { return $8b11dd70aaca6dbd$export$9e49b833525ca49d = v; });
$parcel$export(module.exports, "AWS_LAMBDA_AWS_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$b084fea5b3097227; }, function (v) { return $8b11dd70aaca6dbd$export$b084fea5b3097227 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS", function () { return $8b11dd70aaca6dbd$export$e09cd8615652e8d0; }, function (v) { return $8b11dd70aaca6dbd$export$e09cd8615652e8d0 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_NAME", function () { return $8b11dd70aaca6dbd$export$a43a60ec723a90ee; }, function (v) { return $8b11dd70aaca6dbd$export$a43a60ec723a90ee = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_VERSION", function () { return $8b11dd70aaca6dbd$export$34cc955357266287; }, function (v) { return $8b11dd70aaca6dbd$export$34cc955357266287 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_ARN", function () { return $8b11dd70aaca6dbd$export$d9dd218693ea9bba; }, function (v) { return $8b11dd70aaca6dbd$export$d9dd218693ea9bba = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_FUNCTION_ARN", function () { return $8b11dd70aaca6dbd$export$c9649b7156282a2f; }, function (v) { return $8b11dd70aaca6dbd$export$c9649b7156282a2f = v; });
$parcel$export(module.exports, "AWS_LAMBDA_REMAINING_TIME_IN_MILLIS", function () { return $8b11dd70aaca6dbd$export$daa8ce1f8adc553e; }, function (v) { return $8b11dd70aaca6dbd$export$daa8ce1f8adc553e = v; });
$parcel$export(module.exports, "AWS_LOG_GROUP_NAMES", function () { return $8b11dd70aaca6dbd$export$cb93c7b05db202cf; }, function (v) { return $8b11dd70aaca6dbd$export$cb93c7b05db202cf = v; });
$parcel$export(module.exports, "AWS_LOG_STREAM_NAMES", function () { return $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d; }, function (v) { return $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d = v; });
$parcel$export(module.exports, "AWS_REQUEST_EXTENDED_ID", function () { return $8b11dd70aaca6dbd$export$48c6d4c44afdc0b; }, function (v) { return $8b11dd70aaca6dbd$export$48c6d4c44afdc0b = v; });
$parcel$export(module.exports, "AWS_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$c78d41789fe4b1e4; }, function (v) { return $8b11dd70aaca6dbd$export$c78d41789fe4b1e4 = v; });
$parcel$export(module.exports, "AWS_S3_BUCKET", function () { return $8b11dd70aaca6dbd$export$f462d9921f1f7332; }, function (v) { return $8b11dd70aaca6dbd$export$f462d9921f1f7332 = v; });
$parcel$export(module.exports, "AWS_SECRETSMANAGER_SECRET_ARN", function () { return $8b11dd70aaca6dbd$export$bc71f8df9a45e243; }, function (v) { return $8b11dd70aaca6dbd$export$bc71f8df9a45e243 = v; });
$parcel$export(module.exports, "AWS_SNS_TOPIC_ARN", function () { return $8b11dd70aaca6dbd$export$ed840ec4a5f5d053; }, function (v) { return $8b11dd70aaca6dbd$export$ed840ec4a5f5d053 = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_ACTIVITY_ARN", function () { return $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e; }, function (v) { return $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN", function () { return $8b11dd70aaca6dbd$export$d1c007424092e3f5; }, function (v) { return $8b11dd70aaca6dbd$export$d1c007424092e3f5 = v; });
$parcel$export(module.exports, "BLOCKED_MAIN_THREAD", function () { return $8b11dd70aaca6dbd$export$9ebb466ce954c49c; }, function (v) { return $8b11dd70aaca6dbd$export$9ebb466ce954c49c = v; });
$parcel$export(module.exports, "BROWSER_NAME", function () { return $8b11dd70aaca6dbd$export$e9aafc7348984403; }, function (v) { return $8b11dd70aaca6dbd$export$e9aafc7348984403 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START", function () { return $8b11dd70aaca6dbd$export$faaa46964f075237; }, function (v) { return $8b11dd70aaca6dbd$export$faaa46964f075237 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_TIME_ORIGIN", function () { return $8b11dd70aaca6dbd$export$d28c4b3cc4431a87; }, function (v) { return $8b11dd70aaca6dbd$export$d28c4b3cc4431a87 = v; });
$parcel$export(module.exports, "BROWSER_REPORT_TYPE", function () { return $8b11dd70aaca6dbd$export$734b017b330c8fe6; }, function (v) { return $8b11dd70aaca6dbd$export$734b017b330c8fe6 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER", function () { return $8b11dd70aaca6dbd$export$683ebdc48ba3758d; }, function (v) { return $8b11dd70aaca6dbd$export$683ebdc48ba3758d = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER_TYPE", function () { return $8b11dd70aaca6dbd$export$be0263971250ef44; }, function (v) { return $8b11dd70aaca6dbd$export$be0263971250ef44 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_SOURCE_CHAR_POSITION", function () { return $8b11dd70aaca6dbd$export$36a0cbc35c405232; }, function (v) { return $8b11dd70aaca6dbd$export$36a0cbc35c405232 = v; });
$parcel$export(module.exports, "BROWSER_VERSION", function () { return $8b11dd70aaca6dbd$export$469f7765ba335497; }, function (v) { return $8b11dd70aaca6dbd$export$469f7765ba335497 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_REPORT_EVENT", function () { return $8b11dd70aaca6dbd$export$fe6fe2b7af051610; }, function (v) { return $8b11dd70aaca6dbd$export$fe6fe2b7af051610 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY", function () { return $8b11dd70aaca6dbd$export$8345821877c4dfad; }, function (v) { return $8b11dd70aaca6dbd$export$8345821877c4dfad = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$f6c188a7e02335cf; }, function (v) { return $8b11dd70aaca6dbd$export$f6c188a7e02335cf = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_VALUE", function () { return $8b11dd70aaca6dbd$export$aaf709a8971e825f; }, function (v) { return $8b11dd70aaca6dbd$export$aaf709a8971e825f = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FCP_VALUE", function () { return $8b11dd70aaca6dbd$export$def01b82f8c092f7; }, function (v) { return $8b11dd70aaca6dbd$export$def01b82f8c092f7 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FP_VALUE", function () { return $8b11dd70aaca6dbd$export$23d4264c606a73a6; }, function (v) { return $8b11dd70aaca6dbd$export$23d4264c606a73a6 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_VALUE", function () { return $8b11dd70aaca6dbd$export$af9ece53bb92f66b; }, function (v) { return $8b11dd70aaca6dbd$export$af9ece53bb92f66b = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ELEMENT", function () { return $8b11dd70aaca6dbd$export$25421625a565b69; }, function (v) { return $8b11dd70aaca6dbd$export$25421625a565b69 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ID", function () { return $8b11dd70aaca6dbd$export$ab0c90d873e69ccb; }, function (v) { return $8b11dd70aaca6dbd$export$ab0c90d873e69ccb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_LOAD_TIME", function () { return $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb; }, function (v) { return $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_RENDER_TIME", function () { return $8b11dd70aaca6dbd$export$f86df4de196e1a7c; }, function (v) { return $8b11dd70aaca6dbd$export$f86df4de196e1a7c = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_REPORT_EVENT", function () { return $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8; }, function (v) { return $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_SIZE", function () { return $8b11dd70aaca6dbd$export$99023486ecc470bd; }, function (v) { return $8b11dd70aaca6dbd$export$99023486ecc470bd = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_URL", function () { return $8b11dd70aaca6dbd$export$2f6c85eaf382e81; }, function (v) { return $8b11dd70aaca6dbd$export$2f6c85eaf382e81 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_VALUE", function () { return $8b11dd70aaca6dbd$export$1158d57c0aed42be; }, function (v) { return $8b11dd70aaca6dbd$export$1158d57c0aed42be = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_REQUEST_TIME", function () { return $8b11dd70aaca6dbd$export$d85c4f947ab776e3; }, function (v) { return $8b11dd70aaca6dbd$export$d85c4f947ab776e3 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_VALUE", function () { return $8b11dd70aaca6dbd$export$813ef8386d874918; }, function (v) { return $8b11dd70aaca6dbd$export$813ef8386d874918 = v; });
$parcel$export(module.exports, "CACHE_HIT", function () { return $8b11dd70aaca6dbd$export$7c2f74ff9251f64; }, function (v) { return $8b11dd70aaca6dbd$export$7c2f74ff9251f64 = v; });
$parcel$export(module.exports, "CACHE_ITEM_SIZE", function () { return $8b11dd70aaca6dbd$export$993f84dab107b880; }, function (v) { return $8b11dd70aaca6dbd$export$993f84dab107b880 = v; });
$parcel$export(module.exports, "CACHE_KEY", function () { return $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f; }, function (v) { return $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f = v; });
$parcel$export(module.exports, "CACHE_OPERATION", function () { return $8b11dd70aaca6dbd$export$f01e5cd42b9ec146; }, function (v) { return $8b11dd70aaca6dbd$export$f01e5cd42b9ec146 = v; });
$parcel$export(module.exports, "CACHE_TTL", function () { return $8b11dd70aaca6dbd$export$987f6b4367434b55; }, function (v) { return $8b11dd70aaca6dbd$export$987f6b4367434b55 = v; });
$parcel$export(module.exports, "CACHE_WRITE", function () { return $8b11dd70aaca6dbd$export$d9d145585d5022bb; }, function (v) { return $8b11dd70aaca6dbd$export$d9d145585d5022bb = v; });
$parcel$export(module.exports, "CHANNEL", function () { return $8b11dd70aaca6dbd$export$44ffba16bd48dac6; }, function (v) { return $8b11dd70aaca6dbd$export$44ffba16bd48dac6 = v; });
$parcel$export(module.exports, "CLIENT_ADDRESS", function () { return $8b11dd70aaca6dbd$export$3134892c5d2e251a; }, function (v) { return $8b11dd70aaca6dbd$export$3134892c5d2e251a = v; });
$parcel$export(module.exports, "CLIENT_PORT", function () { return $8b11dd70aaca6dbd$export$8495028d10296058; }, function (v) { return $8b11dd70aaca6dbd$export$8495028d10296058 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_DURATION", function () { return $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c; }, function (v) { return $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_QUERY_TYPE", function () { return $8b11dd70aaca6dbd$export$658dced473c19301; }, function (v) { return $8b11dd70aaca6dbd$export$658dced473c19301 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_READ", function () { return $8b11dd70aaca6dbd$export$97b0f9c3fbe64076; }, function (v) { return $8b11dd70aaca6dbd$export$97b0f9c3fbe64076 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_WRITTEN", function () { return $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb; }, function (v) { return $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS", function () { return $8b11dd70aaca6dbd$export$880007904f61a388; }, function (v) { return $8b11dd70aaca6dbd$export$880007904f61a388 = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ", function () { return $8b11dd70aaca6dbd$export$3e903b72d4d9e07d; }, function (v) { return $8b11dd70aaca6dbd$export$3e903b72d4d9e07d = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN", function () { return $8b11dd70aaca6dbd$export$34da07180e0e56af; }, function (v) { return $8b11dd70aaca6dbd$export$34da07180e0e56af = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_BUCKET", function () { return $8b11dd70aaca6dbd$export$c49aafdaeb061953; }, function (v) { return $8b11dd70aaca6dbd$export$c49aafdaeb061953 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_OPERATION", function () { return $8b11dd70aaca6dbd$export$ceb762c61de2f17f; }, function (v) { return $8b11dd70aaca6dbd$export$ceb762c61de2f17f = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_DELIMITER", function () { return $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf; }, function (v) { return $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_KEY", function () { return $8b11dd70aaca6dbd$export$1c86a56857b024db; }, function (v) { return $8b11dd70aaca6dbd$export$1c86a56857b024db = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PART_NUMBER", function () { return $8b11dd70aaca6dbd$export$7598f3464be47440; }, function (v) { return $8b11dd70aaca6dbd$export$7598f3464be47440 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PREFIX", function () { return $8b11dd70aaca6dbd$export$b673289c971fc0ae; }, function (v) { return $8b11dd70aaca6dbd$export$b673289c971fc0ae = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_ATTEMPT", function () { return $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f; }, function (v) { return $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF", function () { return $8b11dd70aaca6dbd$export$6ddeaf0498614ebb; }, function (v) { return $8b11dd70aaca6dbd$export$6ddeaf0498614ebb = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_DELAY", function () { return $8b11dd70aaca6dbd$export$97b78f78d64a7232; }, function (v) { return $8b11dd70aaca6dbd$export$97b78f78d64a7232 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_LIMIT", function () { return $8b11dd70aaca6dbd$export$5147715be870fff7; }, function (v) { return $8b11dd70aaca6dbd$export$5147715be870fff7 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_TIMEOUT", function () { return $8b11dd70aaca6dbd$export$5276bb46e6096fba; }, function (v) { return $8b11dd70aaca6dbd$export$5276bb46e6096fba = v; });
$parcel$export(module.exports, "CLOUD_ACCOUNT_ID", function () { return $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3; }, function (v) { return $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3 = v; });
$parcel$export(module.exports, "CLOUD_AVAILABILITY_ZONE", function () { return $8b11dd70aaca6dbd$export$226a2381b8f0cf78; }, function (v) { return $8b11dd70aaca6dbd$export$226a2381b8f0cf78 = v; });
$parcel$export(module.exports, "CLOUD_PLATFORM", function () { return $8b11dd70aaca6dbd$export$fd35512cae286064; }, function (v) { return $8b11dd70aaca6dbd$export$fd35512cae286064 = v; });
$parcel$export(module.exports, "CLOUD_PROVIDER", function () { return $8b11dd70aaca6dbd$export$de9bbf95ab1d81e; }, function (v) { return $8b11dd70aaca6dbd$export$de9bbf95ab1d81e = v; });
$parcel$export(module.exports, "CLOUD_REGION", function () { return $8b11dd70aaca6dbd$export$47fb20e8d18d7d15; }, function (v) { return $8b11dd70aaca6dbd$export$47fb20e8d18d7d15 = v; });
$parcel$export(module.exports, "CLOUD_RESOURCE_ID", function () { return $8b11dd70aaca6dbd$export$9db7964e4b8cb849; }, function (v) { return $8b11dd70aaca6dbd$export$9db7964e4b8cb849 = v; });
$parcel$export(module.exports, "CLS", function () { return $8b11dd70aaca6dbd$export$7139adf9d3bace41; }, function (v) { return $8b11dd70aaca6dbd$export$7139adf9d3bace41 = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY", function () { return $8b11dd70aaca6dbd$export$8ac3d09060e7f25d; }, function (v) { return $8b11dd70aaca6dbd$export$8ac3d09060e7f25d = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$dad0e4778ea23971; }, function (v) { return $8b11dd70aaca6dbd$export$dad0e4778ea23971 = v; });
$parcel$export(module.exports, "CODE_FILEPATH", function () { return $8b11dd70aaca6dbd$export$c14d903ccf9385a8; }, function (v) { return $8b11dd70aaca6dbd$export$c14d903ccf9385a8 = v; });
$parcel$export(module.exports, "CODE_FILE_PATH", function () { return $8b11dd70aaca6dbd$export$934cded0041affd7; }, function (v) { return $8b11dd70aaca6dbd$export$934cded0041affd7 = v; });
$parcel$export(module.exports, "CODE_FUNCTION", function () { return $8b11dd70aaca6dbd$export$6386da1dcba88c9d; }, function (v) { return $8b11dd70aaca6dbd$export$6386da1dcba88c9d = v; });
$parcel$export(module.exports, "CODE_FUNCTION_NAME", function () { return $8b11dd70aaca6dbd$export$a3371797e606e2; }, function (v) { return $8b11dd70aaca6dbd$export$a3371797e606e2 = v; });
$parcel$export(module.exports, "CODE_LINENO", function () { return $8b11dd70aaca6dbd$export$a5bbef0af83b23e5; }, function (v) { return $8b11dd70aaca6dbd$export$a5bbef0af83b23e5 = v; });
$parcel$export(module.exports, "CODE_LINE_NUMBER", function () { return $8b11dd70aaca6dbd$export$91ed1f55874222a6; }, function (v) { return $8b11dd70aaca6dbd$export$91ed1f55874222a6 = v; });
$parcel$export(module.exports, "CODE_NAMESPACE", function () { return $8b11dd70aaca6dbd$export$23de81068d2aed1b; }, function (v) { return $8b11dd70aaca6dbd$export$23de81068d2aed1b = v; });
$parcel$export(module.exports, "CONNECTIONTYPE", function () { return $8b11dd70aaca6dbd$export$d738320e1fba9e9d; }, function (v) { return $8b11dd70aaca6dbd$export$d738320e1fba9e9d = v; });
$parcel$export(module.exports, "CONNECTION_RTT", function () { return $8b11dd70aaca6dbd$export$2eacdea75497e8a5; }, function (v) { return $8b11dd70aaca6dbd$export$2eacdea75497e8a5 = v; });
$parcel$export(module.exports, "CULTURE_CALENDAR", function () { return $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2; }, function (v) { return $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2 = v; });
$parcel$export(module.exports, "CULTURE_DISPLAY_NAME", function () { return $8b11dd70aaca6dbd$export$c54e27e8d90ee081; }, function (v) { return $8b11dd70aaca6dbd$export$c54e27e8d90ee081 = v; });
$parcel$export(module.exports, "CULTURE_IS_24_HOUR_FORMAT", function () { return $8b11dd70aaca6dbd$export$4943adcec371c2a6; }, function (v) { return $8b11dd70aaca6dbd$export$4943adcec371c2a6 = v; });
$parcel$export(module.exports, "CULTURE_LOCALE", function () { return $8b11dd70aaca6dbd$export$f000a5900d0480c2; }, function (v) { return $8b11dd70aaca6dbd$export$f000a5900d0480c2 = v; });
$parcel$export(module.exports, "CULTURE_TIMEZONE", function () { return $8b11dd70aaca6dbd$export$8f5234893868273b; }, function (v) { return $8b11dd70aaca6dbd$export$8f5234893868273b = v; });
$parcel$export(module.exports, "DB_COLLECTION_NAME", function () { return $8b11dd70aaca6dbd$export$1a35518f6e81e8c7; }, function (v) { return $8b11dd70aaca6dbd$export$1a35518f6e81e8c7 = v; });
$parcel$export(module.exports, "DB_DRIVER_NAME", function () { return $8b11dd70aaca6dbd$export$a2d90911eaae60fc; }, function (v) { return $8b11dd70aaca6dbd$export$a2d90911eaae60fc = v; });
$parcel$export(module.exports, "DB_NAME", function () { return $8b11dd70aaca6dbd$export$3c22ff8b64b8f565; }, function (v) { return $8b11dd70aaca6dbd$export$3c22ff8b64b8f565 = v; });
$parcel$export(module.exports, "DB_NAMESPACE", function () { return $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f; }, function (v) { return $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f = v; });
$parcel$export(module.exports, "DB_OPERATION", function () { return $8b11dd70aaca6dbd$export$8c11477e471467c8; }, function (v) { return $8b11dd70aaca6dbd$export$8c11477e471467c8 = v; });
$parcel$export(module.exports, "DB_OPERATION_BATCH_SIZE", function () { return $8b11dd70aaca6dbd$export$92a96f6363488aee; }, function (v) { return $8b11dd70aaca6dbd$export$92a96f6363488aee = v; });
$parcel$export(module.exports, "DB_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$f91beb6088f9ded9; }, function (v) { return $8b11dd70aaca6dbd$export$f91beb6088f9ded9 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY", function () { return $8b11dd70aaca6dbd$export$78bc7224576bf289; }, function (v) { return $8b11dd70aaca6dbd$export$78bc7224576bf289 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$a8027e0ea0d93ca; }, function (v) { return $8b11dd70aaca6dbd$export$a8027e0ea0d93ca = v; });
$parcel$export(module.exports, "DB_QUERY_SUMMARY", function () { return $8b11dd70aaca6dbd$export$5e59d3aea52e5037; }, function (v) { return $8b11dd70aaca6dbd$export$5e59d3aea52e5037 = v; });
$parcel$export(module.exports, "DB_QUERY_TEXT", function () { return $8b11dd70aaca6dbd$export$47e408be0da7933f; }, function (v) { return $8b11dd70aaca6dbd$export$47e408be0da7933f = v; });
$parcel$export(module.exports, "DB_REDIS_CONNECTION", function () { return $8b11dd70aaca6dbd$export$d5772b934ca13e57; }, function (v) { return $8b11dd70aaca6dbd$export$d5772b934ca13e57 = v; });
$parcel$export(module.exports, "DB_REDIS_KEY", function () { return $8b11dd70aaca6dbd$export$36e47f6a5777561d; }, function (v) { return $8b11dd70aaca6dbd$export$36e47f6a5777561d = v; });
$parcel$export(module.exports, "DB_REDIS_PARAMETERS", function () { return $8b11dd70aaca6dbd$export$e768cbc99cd68acf; }, function (v) { return $8b11dd70aaca6dbd$export$e768cbc99cd68acf = v; });
$parcel$export(module.exports, "DB_RESPONSE_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$dfcc6c69df1343f2; }, function (v) { return $8b11dd70aaca6dbd$export$dfcc6c69df1343f2 = v; });
$parcel$export(module.exports, "DB_SQL_BINDINGS", function () { return $8b11dd70aaca6dbd$export$69b0a5d9226b5211; }, function (v) { return $8b11dd70aaca6dbd$export$69b0a5d9226b5211 = v; });
$parcel$export(module.exports, "DB_STATEMENT", function () { return $8b11dd70aaca6dbd$export$da010a4f4fc971ae; }, function (v) { return $8b11dd70aaca6dbd$export$da010a4f4fc971ae = v; });
$parcel$export(module.exports, "DB_STORED_PROCEDURE_NAME", function () { return $8b11dd70aaca6dbd$export$5d515b35be0601a0; }, function (v) { return $8b11dd70aaca6dbd$export$5d515b35be0601a0 = v; });
$parcel$export(module.exports, "DB_SYSTEM", function () { return $8b11dd70aaca6dbd$export$3e1b1037a315c5ca; }, function (v) { return $8b11dd70aaca6dbd$export$3e1b1037a315c5ca = v; });
$parcel$export(module.exports, "DB_SYSTEM_NAME", function () { return $8b11dd70aaca6dbd$export$847fdd494825f0fb; }, function (v) { return $8b11dd70aaca6dbd$export$847fdd494825f0fb = v; });
$parcel$export(module.exports, "DB_USER", function () { return $8b11dd70aaca6dbd$export$a9d76f26c6c730a9; }, function (v) { return $8b11dd70aaca6dbd$export$a9d76f26c6c730a9 = v; });
$parcel$export(module.exports, "DEVICEMEMORY", function () { return $8b11dd70aaca6dbd$export$de03f86d1c9866ca; }, function (v) { return $8b11dd70aaca6dbd$export$de03f86d1c9866ca = v; });
$parcel$export(module.exports, "DEVICE_ARCHS", function () { return $8b11dd70aaca6dbd$export$65798ecab7eef8c; }, function (v) { return $8b11dd70aaca6dbd$export$65798ecab7eef8c = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_LEVEL", function () { return $8b11dd70aaca6dbd$export$22aa61f48b9c79a0; }, function (v) { return $8b11dd70aaca6dbd$export$22aa61f48b9c79a0 = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_TEMPERATURE", function () { return $8b11dd70aaca6dbd$export$69f5fb98f5aed812; }, function (v) { return $8b11dd70aaca6dbd$export$69f5fb98f5aed812 = v; });
$parcel$export(module.exports, "DEVICE_BOOT_TIME", function () { return $8b11dd70aaca6dbd$export$bdea5d1006fd280a; }, function (v) { return $8b11dd70aaca6dbd$export$bdea5d1006fd280a = v; });
$parcel$export(module.exports, "DEVICE_BRAND", function () { return $8b11dd70aaca6dbd$export$f63a7230c5b1d609; }, function (v) { return $8b11dd70aaca6dbd$export$f63a7230c5b1d609 = v; });
$parcel$export(module.exports, "DEVICE_CHARGING", function () { return $8b11dd70aaca6dbd$export$6f25e59b05bb8e17; }, function (v) { return $8b11dd70aaca6dbd$export$6f25e59b05bb8e17 = v; });
$parcel$export(module.exports, "DEVICE_CHIPSET", function () { return $8b11dd70aaca6dbd$export$a56ad13c4afc7421; }, function (v) { return $8b11dd70aaca6dbd$export$a56ad13c4afc7421 = v; });
$parcel$export(module.exports, "DEVICE_CLASS", function () { return $8b11dd70aaca6dbd$export$d9ce89ce8912bf12; }, function (v) { return $8b11dd70aaca6dbd$export$d9ce89ce8912bf12 = v; });
$parcel$export(module.exports, "DEVICE_CONNECTION_TYPE", function () { return $8b11dd70aaca6dbd$export$17094e5f380e4162; }, function (v) { return $8b11dd70aaca6dbd$export$17094e5f380e4162 = v; });
$parcel$export(module.exports, "DEVICE_CPU_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$28a0ffdf747973a0; }, function (v) { return $8b11dd70aaca6dbd$export$28a0ffdf747973a0 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_FREE_STORAGE", function () { return $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9; }, function (v) { return $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_STORAGE_SIZE", function () { return $8b11dd70aaca6dbd$export$edc72ee4a17f5152; }, function (v) { return $8b11dd70aaca6dbd$export$edc72ee4a17f5152 = v; });
$parcel$export(module.exports, "DEVICE_FAMILY", function () { return $8b11dd70aaca6dbd$export$19e4df138d354f8b; }, function (v) { return $8b11dd70aaca6dbd$export$19e4df138d354f8b = v; });
$parcel$export(module.exports, "DEVICE_FREE_MEMORY", function () { return $8b11dd70aaca6dbd$export$92b0d20fa482b4b2; }, function (v) { return $8b11dd70aaca6dbd$export$92b0d20fa482b4b2 = v; });
$parcel$export(module.exports, "DEVICE_FREE_STORAGE", function () { return $8b11dd70aaca6dbd$export$3f638a793d61933f; }, function (v) { return $8b11dd70aaca6dbd$export$3f638a793d61933f = v; });
$parcel$export(module.exports, "DEVICE_ID", function () { return $8b11dd70aaca6dbd$export$3f511731cc3687d4; }, function (v) { return $8b11dd70aaca6dbd$export$3f511731cc3687d4 = v; });
$parcel$export(module.exports, "DEVICE_LOCALE", function () { return $8b11dd70aaca6dbd$export$692b08741d6b6265; }, function (v) { return $8b11dd70aaca6dbd$export$692b08741d6b6265 = v; });
$parcel$export(module.exports, "DEVICE_LOW_MEMORY", function () { return $8b11dd70aaca6dbd$export$cf67f8cb2324428e; }, function (v) { return $8b11dd70aaca6dbd$export$cf67f8cb2324428e = v; });
$parcel$export(module.exports, "DEVICE_LOW_POWER_MODE", function () { return $8b11dd70aaca6dbd$export$9d4197c1ffc5f359; }, function (v) { return $8b11dd70aaca6dbd$export$9d4197c1ffc5f359 = v; });
$parcel$export(module.exports, "DEVICE_MANUFACTURER", function () { return $8b11dd70aaca6dbd$export$509634fbff540e75; }, function (v) { return $8b11dd70aaca6dbd$export$509634fbff540e75 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_ESTIMATED_CAPACITY", function () { return $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5; }, function (v) { return $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_SIZE", function () { return $8b11dd70aaca6dbd$export$e0cb371ca548b1d6; }, function (v) { return $8b11dd70aaca6dbd$export$e0cb371ca548b1d6 = v; });
$parcel$export(module.exports, "DEVICE_MODEL", function () { return $8b11dd70aaca6dbd$export$3c39026d09026bc2; }, function (v) { return $8b11dd70aaca6dbd$export$3c39026d09026bc2 = v; });
$parcel$export(module.exports, "DEVICE_MODEL_ID", function () { return $8b11dd70aaca6dbd$export$bf9e8248cb72cf00; }, function (v) { return $8b11dd70aaca6dbd$export$bf9e8248cb72cf00 = v; });
$parcel$export(module.exports, "DEVICE_NAME", function () { return $8b11dd70aaca6dbd$export$1054f22a72121d0f; }, function (v) { return $8b11dd70aaca6dbd$export$1054f22a72121d0f = v; });
$parcel$export(module.exports, "DEVICE_ONLINE", function () { return $8b11dd70aaca6dbd$export$723b8a59dad2e467; }, function (v) { return $8b11dd70aaca6dbd$export$723b8a59dad2e467 = v; });
$parcel$export(module.exports, "DEVICE_ORIENTATION", function () { return $8b11dd70aaca6dbd$export$160081ff141bac8e; }, function (v) { return $8b11dd70aaca6dbd$export$160081ff141bac8e = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_COUNT", function () { return $8b11dd70aaca6dbd$export$194f62c84d27310; }, function (v) { return $8b11dd70aaca6dbd$export$194f62c84d27310 = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_FREQUENCY", function () { return $8b11dd70aaca6dbd$export$7ed866d57b018d09; }, function (v) { return $8b11dd70aaca6dbd$export$7ed866d57b018d09 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DENSITY", function () { return $8b11dd70aaca6dbd$export$d50bae4562e03e5; }, function (v) { return $8b11dd70aaca6dbd$export$d50bae4562e03e5 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DPI", function () { return $8b11dd70aaca6dbd$export$649ea67a18fe8e8b; }, function (v) { return $8b11dd70aaca6dbd$export$649ea67a18fe8e8b = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_HEIGHT_PIXELS", function () { return $8b11dd70aaca6dbd$export$136a5c1b43caaccd; }, function (v) { return $8b11dd70aaca6dbd$export$136a5c1b43caaccd = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_WIDTH_PIXELS", function () { return $8b11dd70aaca6dbd$export$e33a28ea554b6ddc; }, function (v) { return $8b11dd70aaca6dbd$export$e33a28ea554b6ddc = v; });
$parcel$export(module.exports, "DEVICE_SIMULATOR", function () { return $8b11dd70aaca6dbd$export$acbe2d25ac76ea64; }, function (v) { return $8b11dd70aaca6dbd$export$acbe2d25ac76ea64 = v; });
$parcel$export(module.exports, "DEVICE_STORAGE_SIZE", function () { return $8b11dd70aaca6dbd$export$793c13e17d7e5e2b; }, function (v) { return $8b11dd70aaca6dbd$export$793c13e17d7e5e2b = v; });
$parcel$export(module.exports, "DEVICE_THERMAL_STATE", function () { return $8b11dd70aaca6dbd$export$a5617e33b89fd956; }, function (v) { return $8b11dd70aaca6dbd$export$a5617e33b89fd956 = v; });
$parcel$export(module.exports, "DEVICE_TIMEZONE", function () { return $8b11dd70aaca6dbd$export$b51f82164fa31e07; }, function (v) { return $8b11dd70aaca6dbd$export$b51f82164fa31e07 = v; });
$parcel$export(module.exports, "DEVICE_USABLE_MEMORY", function () { return $8b11dd70aaca6dbd$export$f2ef55183c04d202; }, function (v) { return $8b11dd70aaca6dbd$export$f2ef55183c04d202 = v; });
$parcel$export(module.exports, "DIST", function () { return $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c; }, function (v) { return $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c = v; });
$parcel$export(module.exports, "EFFECTIVECONNECTIONTYPE", function () { return $8b11dd70aaca6dbd$export$f0511e328234ae83; }, function (v) { return $8b11dd70aaca6dbd$export$f0511e328234ae83 = v; });
$parcel$export(module.exports, "ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$be46596bc6608f3b; }, function (v) { return $8b11dd70aaca6dbd$export$be46596bc6608f3b = v; });
$parcel$export(module.exports, "ERROR_TYPE", function () { return $8b11dd70aaca6dbd$export$f215947b3d76a6b7; }, function (v) { return $8b11dd70aaca6dbd$export$f215947b3d76a6b7 = v; });
$parcel$export(module.exports, "EVENT_ID", function () { return $8b11dd70aaca6dbd$export$89bbc91416db6670; }, function (v) { return $8b11dd70aaca6dbd$export$89bbc91416db6670 = v; });
$parcel$export(module.exports, "EVENT_NAME", function () { return $8b11dd70aaca6dbd$export$b4b5eff8a8712c89; }, function (v) { return $8b11dd70aaca6dbd$export$b4b5eff8a8712c89 = v; });
$parcel$export(module.exports, "EXCEPTION_ESCAPED", function () { return $8b11dd70aaca6dbd$export$f455969a57ab8a03; }, function (v) { return $8b11dd70aaca6dbd$export$f455969a57ab8a03 = v; });
$parcel$export(module.exports, "EXCEPTION_MESSAGE", function () { return $8b11dd70aaca6dbd$export$13f2f8f42af49cec; }, function (v) { return $8b11dd70aaca6dbd$export$13f2f8f42af49cec = v; });
$parcel$export(module.exports, "EXCEPTION_STACKTRACE", function () { return $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3; }, function (v) { return $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3 = v; });
$parcel$export(module.exports, "EXCEPTION_TYPE", function () { return $8b11dd70aaca6dbd$export$d9ca2a279a11be5e; }, function (v) { return $8b11dd70aaca6dbd$export$d9ca2a279a11be5e = v; });
$parcel$export(module.exports, "FAAS_COLDSTART", function () { return $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9; }, function (v) { return $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9 = v; });
$parcel$export(module.exports, "FAAS_CRON", function () { return $8b11dd70aaca6dbd$export$8413282a17f1cda5; }, function (v) { return $8b11dd70aaca6dbd$export$8413282a17f1cda5 = v; });
$parcel$export(module.exports, "FAAS_DURATION_IN_MS", function () { return $8b11dd70aaca6dbd$export$30d19ddc7705e7e8; }, function (v) { return $8b11dd70aaca6dbd$export$30d19ddc7705e7e8 = v; });
$parcel$export(module.exports, "FAAS_ENTRY_POINT", function () { return $8b11dd70aaca6dbd$export$64a4f09e2444b3d; }, function (v) { return $8b11dd70aaca6dbd$export$64a4f09e2444b3d = v; });
$parcel$export(module.exports, "FAAS_EXECUTION", function () { return $8b11dd70aaca6dbd$export$645b039fe163809e; }, function (v) { return $8b11dd70aaca6dbd$export$645b039fe163809e = v; });
$parcel$export(module.exports, "FAAS_ID", function () { return $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1; }, function (v) { return $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1 = v; });
$parcel$export(module.exports, "FAAS_IDENTITY", function () { return $8b11dd70aaca6dbd$export$8bf64516740c1369; }, function (v) { return $8b11dd70aaca6dbd$export$8bf64516740c1369 = v; });
$parcel$export(module.exports, "FAAS_INVOCATION_ID", function () { return $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b; }, function (v) { return $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b = v; });
$parcel$export(module.exports, "FAAS_INVOKED_NAME", function () { return $8b11dd70aaca6dbd$export$abe90fedb3dddda2; }, function (v) { return $8b11dd70aaca6dbd$export$abe90fedb3dddda2 = v; });
$parcel$export(module.exports, "FAAS_INVOKED_PROVIDER", function () { return $8b11dd70aaca6dbd$export$4a19da9c85ed2ade; }, function (v) { return $8b11dd70aaca6dbd$export$4a19da9c85ed2ade = v; });
$parcel$export(module.exports, "FAAS_INVOKED_REGION", function () { return $8b11dd70aaca6dbd$export$5e091479f094bdbc; }, function (v) { return $8b11dd70aaca6dbd$export$5e091479f094bdbc = v; });
$parcel$export(module.exports, "FAAS_NAME", function () { return $8b11dd70aaca6dbd$export$d70909b5aa96a79a; }, function (v) { return $8b11dd70aaca6dbd$export$d70909b5aa96a79a = v; });
$parcel$export(module.exports, "FAAS_TIME", function () { return $8b11dd70aaca6dbd$export$651d142a8017d83d; }, function (v) { return $8b11dd70aaca6dbd$export$651d142a8017d83d = v; });
$parcel$export(module.exports, "FAAS_TRIGGER", function () { return $8b11dd70aaca6dbd$export$44382a010a9f7fcf; }, function (v) { return $8b11dd70aaca6dbd$export$44382a010a9f7fcf = v; });
$parcel$export(module.exports, "FAAS_VERSION", function () { return $8b11dd70aaca6dbd$export$807abfdc6b7b9338; }, function (v) { return $8b11dd70aaca6dbd$export$807abfdc6b7b9338 = v; });
$parcel$export(module.exports, "FCP", function () { return $8b11dd70aaca6dbd$export$31881d07f2569218; }, function (v) { return $8b11dd70aaca6dbd$export$31881d07f2569218 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY", function () { return $8b11dd70aaca6dbd$export$e5bbf306deb709a6; }, function (v) { return $8b11dd70aaca6dbd$export$e5bbf306deb709a6 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$aa8721167c5c8d2d; }, function (v) { return $8b11dd70aaca6dbd$export$aa8721167c5c8d2d = v; });
$parcel$export(module.exports, "FP", function () { return $8b11dd70aaca6dbd$export$757b93e5b3adc7cb; }, function (v) { return $8b11dd70aaca6dbd$export$757b93e5b3adc7cb = v; });
$parcel$export(module.exports, "FRAMES_DELAY", function () { return $8b11dd70aaca6dbd$export$f869eaa92db1dc9b; }, function (v) { return $8b11dd70aaca6dbd$export$f869eaa92db1dc9b = v; });
$parcel$export(module.exports, "FRAMES_FROZEN", function () { return $8b11dd70aaca6dbd$export$5d1d761e41c32d9e; }, function (v) { return $8b11dd70aaca6dbd$export$5d1d761e41c32d9e = v; });
$parcel$export(module.exports, "FRAMES_FROZEN_RATE", function () { return $8b11dd70aaca6dbd$export$8aec72d9491f9399; }, function (v) { return $8b11dd70aaca6dbd$export$8aec72d9491f9399 = v; });
$parcel$export(module.exports, "FRAMES_SLOW", function () { return $8b11dd70aaca6dbd$export$5562635d2be2ab25; }, function (v) { return $8b11dd70aaca6dbd$export$5562635d2be2ab25 = v; });
$parcel$export(module.exports, "FRAMES_SLOW_RATE", function () { return $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d; }, function (v) { return $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d = v; });
$parcel$export(module.exports, "FRAMES_TOTAL", function () { return $8b11dd70aaca6dbd$export$b561df15f64d32e3; }, function (v) { return $8b11dd70aaca6dbd$export$b561df15f64d32e3 = v; });
$parcel$export(module.exports, "FS_ERROR", function () { return $8b11dd70aaca6dbd$export$181f78b28f2ffa57; }, function (v) { return $8b11dd70aaca6dbd$export$181f78b28f2ffa57 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_ID", function () { return $8b11dd70aaca6dbd$export$6c97c77b89571c75; }, function (v) { return $8b11dd70aaca6dbd$export$6c97c77b89571c75 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_TYPE", function () { return $8b11dd70aaca6dbd$export$51e431eaf1f9bf58; }, function (v) { return $8b11dd70aaca6dbd$export$51e431eaf1f9bf58 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_ID", function () { return $8b11dd70aaca6dbd$export$71429c7ef7cb7063; }, function (v) { return $8b11dd70aaca6dbd$export$71429c7ef7cb7063 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_RESOURCE", function () { return $8b11dd70aaca6dbd$export$99905d7583a6e8ac; }, function (v) { return $8b11dd70aaca6dbd$export$99905d7583a6e8ac = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SOURCE", function () { return $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd; }, function (v) { return $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SPECVERSION", function () { return $8b11dd70aaca6dbd$export$fd23e5b8d261a89; }, function (v) { return $8b11dd70aaca6dbd$export$fd23e5b8d261a89 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIME", function () { return $8b11dd70aaca6dbd$export$25fabc9b3d1dd567; }, function (v) { return $8b11dd70aaca6dbd$export$25fabc9b3d1dd567 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIMESTAMP", function () { return $8b11dd70aaca6dbd$export$41507f7b07dad151; }, function (v) { return $8b11dd70aaca6dbd$export$41507f7b07dad151 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TYPE", function () { return $8b11dd70aaca6dbd$export$1352f3699c35dd73; }, function (v) { return $8b11dd70aaca6dbd$export$1352f3699c35dd73 = v; });
$parcel$export(module.exports, "GCP_PROJECT_ID", function () { return $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac; }, function (v) { return $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac = v; });
$parcel$export(module.exports, "GEN_AI_AGENT_NAME", function () { return $8b11dd70aaca6dbd$export$c29634e3cf41e479; }, function (v) { return $8b11dd70aaca6dbd$export$c29634e3cf41e479 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_UTILIZATION", function () { return $8b11dd70aaca6dbd$export$e6a60882cce7a085; }, function (v) { return $8b11dd70aaca6dbd$export$e6a60882cce7a085 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_WINDOW_SIZE", function () { return $8b11dd70aaca6dbd$export$6773c9098ba5e194; }, function (v) { return $8b11dd70aaca6dbd$export$6773c9098ba5e194 = v; });
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID", function () { return $8b11dd70aaca6dbd$export$6ee6b62f50047686; }, function (v) { return $8b11dd70aaca6dbd$export$6ee6b62f50047686 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$efac052bb3661242; }, function (v) { return $8b11dd70aaca6dbd$export$efac052bb3661242 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_READ_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$7ccd63b9ca955862; }, function (v) { return $8b11dd70aaca6dbd$export$7ccd63b9ca955862 = v; });
$parcel$export(module.exports, "GEN_AI_COST_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$50921df5a58cb3ef; }, function (v) { return $8b11dd70aaca6dbd$export$50921df5a58cb3ef = v; });
$parcel$export(module.exports, "GEN_AI_COST_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$8e48efc7acb57a97; }, function (v) { return $8b11dd70aaca6dbd$export$8e48efc7acb57a97 = v; });
$parcel$export(module.exports, "GEN_AI_COST_REASONING_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$cea9121727113f77; }, function (v) { return $8b11dd70aaca6dbd$export$cea9121727113f77 = v; });
$parcel$export(module.exports, "GEN_AI_COST_TOTAL_TOKENS", function () { return $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa; }, function (v) { return $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa = v; });
$parcel$export(module.exports, "GEN_AI_EMBEDDINGS_INPUT", function () { return $8b11dd70aaca6dbd$export$6b729e898b9067ce; }, function (v) { return $8b11dd70aaca6dbd$export$6b729e898b9067ce = v; });
$parcel$export(module.exports, "GEN_AI_FUNCTION_ID", function () { return $8b11dd70aaca6dbd$export$984fbab9b52f7e24; }, function (v) { return $8b11dd70aaca6dbd$export$984fbab9b52f7e24 = v; });
$parcel$export(module.exports, "GEN_AI_INPUT_MESSAGES", function () { return $8b11dd70aaca6dbd$export$9ea17906a87ada6f; }, function (v) { return $8b11dd70aaca6dbd$export$9ea17906a87ada6f = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$394b443aaff3ef92; }, function (v) { return $8b11dd70aaca6dbd$export$394b443aaff3ef92 = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_TYPE", function () { return $8b11dd70aaca6dbd$export$6ddc374adbc06720; }, function (v) { return $8b11dd70aaca6dbd$export$6ddc374adbc06720 = v; });
$parcel$export(module.exports, "GEN_AI_OUTPUT_MESSAGES", function () { return $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2; }, function (v) { return $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2 = v; });
$parcel$export(module.exports, "GEN_AI_PIPELINE_NAME", function () { return $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee; }, function (v) { return $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT", function () { return $8b11dd70aaca6dbd$export$86a8df7fff52fc69; }, function (v) { return $8b11dd70aaca6dbd$export$86a8df7fff52fc69 = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT_NAME", function () { return $8b11dd70aaca6dbd$export$cf2115d46768f4c5; }, function (v) { return $8b11dd70aaca6dbd$export$cf2115d46768f4c5 = v; });
$parcel$export(module.exports, "GEN_AI_PROVIDER_NAME", function () { return $8b11dd70aaca6dbd$export$3d7e036e195764db; }, function (v) { return $8b11dd70aaca6dbd$export$3d7e036e195764db = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS", function () { return $8b11dd70aaca6dbd$export$60c1d11221608cee; }, function (v) { return $8b11dd70aaca6dbd$export$60c1d11221608cee = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY", function () { return $8b11dd70aaca6dbd$export$bc3cef164abbc42c; }, function (v) { return $8b11dd70aaca6dbd$export$bc3cef164abbc42c = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MAX_TOKENS", function () { return $8b11dd70aaca6dbd$export$43f9afb62cd79dec; }, function (v) { return $8b11dd70aaca6dbd$export$43f9afb62cd79dec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MESSAGES", function () { return $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f; }, function (v) { return $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MODEL", function () { return $8b11dd70aaca6dbd$export$ccf46db9ab1743ec; }, function (v) { return $8b11dd70aaca6dbd$export$ccf46db9ab1743ec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_PRESENCE_PENALTY", function () { return $8b11dd70aaca6dbd$export$76c1c247342d776; }, function (v) { return $8b11dd70aaca6dbd$export$76c1c247342d776 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_REASONING_EFFORT", function () { return $8b11dd70aaca6dbd$export$92f5944f0b02c9fb; }, function (v) { return $8b11dd70aaca6dbd$export$92f5944f0b02c9fb = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_SEED", function () { return $8b11dd70aaca6dbd$export$867eeefcb1c95b27; }, function (v) { return $8b11dd70aaca6dbd$export$867eeefcb1c95b27 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_STOP_SEQUENCES", function () { return $8b11dd70aaca6dbd$export$5ada4697ae6aa17e; }, function (v) { return $8b11dd70aaca6dbd$export$5ada4697ae6aa17e = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TEMPERATURE", function () { return $8b11dd70aaca6dbd$export$427122300e8d54d0; }, function (v) { return $8b11dd70aaca6dbd$export$427122300e8d54d0 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_K", function () { return $8b11dd70aaca6dbd$export$bcea8881375c352f; }, function (v) { return $8b11dd70aaca6dbd$export$bcea8881375c352f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_P", function () { return $8b11dd70aaca6dbd$export$b867715f9a0c04e9; }, function (v) { return $8b11dd70aaca6dbd$export$b867715f9a0c04e9 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASONS", function () { return $8b11dd70aaca6dbd$export$69878a39cbdbe097; }, function (v) { return $8b11dd70aaca6dbd$export$69878a39cbdbe097 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_ID", function () { return $8b11dd70aaca6dbd$export$584c61a1b769552d; }, function (v) { return $8b11dd70aaca6dbd$export$584c61a1b769552d = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_MODEL", function () { return $8b11dd70aaca6dbd$export$8169ebcb0b0331dd; }, function (v) { return $8b11dd70aaca6dbd$export$8169ebcb0b0331dd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_STREAMING", function () { return $8b11dd70aaca6dbd$export$2c9713b624877853; }, function (v) { return $8b11dd70aaca6dbd$export$2c9713b624877853 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TEXT", function () { return $8b11dd70aaca6dbd$export$45942692aeb454e0; }, function (v) { return $8b11dd70aaca6dbd$export$45942692aeb454e0 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK", function () { return $8b11dd70aaca6dbd$export$8e5efeaa031210cd; }, function (v) { return $8b11dd70aaca6dbd$export$8e5efeaa031210cd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN", function () { return $8b11dd70aaca6dbd$export$35a62769ee05a05a; }, function (v) { return $8b11dd70aaca6dbd$export$35a62769ee05a05a = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOKENS_PER_SECOND", function () { return $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06; }, function (v) { return $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOOL_CALLS", function () { return $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4; }, function (v) { return $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM", function () { return $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67; }, function (v) { return $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_INSTRUCTIONS", function () { return $8b11dd70aaca6dbd$export$352a8075b163d53; }, function (v) { return $8b11dd70aaca6dbd$export$352a8075b163d53 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_MESSAGE", function () { return $8b11dd70aaca6dbd$export$426d7b90ba5d79db; }, function (v) { return $8b11dd70aaca6dbd$export$426d7b90ba5d79db = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_ARGUMENTS", function () { return $8b11dd70aaca6dbd$export$f5a1ee40934d19ce; }, function (v) { return $8b11dd70aaca6dbd$export$f5a1ee40934d19ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_RESULT", function () { return $8b11dd70aaca6dbd$export$1ba812a9756622ce; }, function (v) { return $8b11dd70aaca6dbd$export$1ba812a9756622ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DEFINITIONS", function () { return $8b11dd70aaca6dbd$export$351120039c36e03; }, function (v) { return $8b11dd70aaca6dbd$export$351120039c36e03 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$d42aa25ca09e17c4; }, function (v) { return $8b11dd70aaca6dbd$export$d42aa25ca09e17c4 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_INPUT", function () { return $8b11dd70aaca6dbd$export$d268db29b88a4286; }, function (v) { return $8b11dd70aaca6dbd$export$d268db29b88a4286 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_MESSAGE", function () { return $8b11dd70aaca6dbd$export$c5deb6018f2d6251; }, function (v) { return $8b11dd70aaca6dbd$export$c5deb6018f2d6251 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_NAME", function () { return $8b11dd70aaca6dbd$export$e06baa3034409453; }, function (v) { return $8b11dd70aaca6dbd$export$e06baa3034409453 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_OUTPUT", function () { return $8b11dd70aaca6dbd$export$646fdb5910ce3931; }, function (v) { return $8b11dd70aaca6dbd$export$646fdb5910ce3931 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_TYPE", function () { return $8b11dd70aaca6dbd$export$662e3d2d4361e29b; }, function (v) { return $8b11dd70aaca6dbd$export$662e3d2d4361e29b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$1de3962f221ba441; }, function (v) { return $8b11dd70aaca6dbd$export$1de3962f221ba441 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$a4b3f0f5499c8738; }, function (v) { return $8b11dd70aaca6dbd$export$a4b3f0f5499c8738 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_COMPLETION_TOKENS", function () { return $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b; }, function (v) { return $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$2eb2ab35b317a103; }, function (v) { return $8b11dd70aaca6dbd$export$2eb2ab35b317a103 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED", function () { return $8b11dd70aaca6dbd$export$c7e14ea195ede241; }, function (v) { return $8b11dd70aaca6dbd$export$c7e14ea195ede241 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE", function () { return $8b11dd70aaca6dbd$export$41ac034e7b9725a2; }, function (v) { return $8b11dd70aaca6dbd$export$41ac034e7b9725a2 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$9e521119d7751e37; }, function (v) { return $8b11dd70aaca6dbd$export$9e521119d7751e37 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS_REASONING", function () { return $8b11dd70aaca6dbd$export$cbac8f541a64a150; }, function (v) { return $8b11dd70aaca6dbd$export$cbac8f541a64a150 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_PROMPT_TOKENS", function () { return $8b11dd70aaca6dbd$export$93dd08efa94c9dd4; }, function (v) { return $8b11dd70aaca6dbd$export$93dd08efa94c9dd4 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_REASONING_OUTPUT_TOKENS", function () { return $8b11dd70aaca6dbd$export$183e3523dac20bca; }, function (v) { return $8b11dd70aaca6dbd$export$183e3523dac20bca = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_TOTAL_TOKENS", function () { return $8b11dd70aaca6dbd$export$3867ca1d8381d4e3; }, function (v) { return $8b11dd70aaca6dbd$export$3867ca1d8381d4e3 = v; });
$parcel$export(module.exports, "GRAPHQL_DOCUMENT", function () { return $8b11dd70aaca6dbd$export$11febcf9917c0057; }, function (v) { return $8b11dd70aaca6dbd$export$11febcf9917c0057 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$88ae1ee0c0a63398; }, function (v) { return $8b11dd70aaca6dbd$export$88ae1ee0c0a63398 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_TYPE", function () { return $8b11dd70aaca6dbd$export$d5bd986d1f283f29; }, function (v) { return $8b11dd70aaca6dbd$export$d5bd986d1f283f29 = v; });
$parcel$export(module.exports, "HARDWARECONCURRENCY", function () { return $8b11dd70aaca6dbd$export$fc4a2d238535d998; }, function (v) { return $8b11dd70aaca6dbd$export$fc4a2d238535d998 = v; });
$parcel$export(module.exports, "HTTP_CLIENT_IP", function () { return $8b11dd70aaca6dbd$export$57e53a60bf563f41; }, function (v) { return $8b11dd70aaca6dbd$export$57e53a60bf563f41 = v; });
$parcel$export(module.exports, "HTTP_DECODED_RESPONSE_CONTENT_LENGTH", function () { return $8b11dd70aaca6dbd$export$ffdb1464deb0eedb; }, function (v) { return $8b11dd70aaca6dbd$export$ffdb1464deb0eedb = v; });
$parcel$export(module.exports, "HTTP_FLAVOR", function () { return $8b11dd70aaca6dbd$export$b52670c950fd640; }, function (v) { return $8b11dd70aaca6dbd$export$b52670c950fd640 = v; });
$parcel$export(module.exports, "HTTP_FRAGMENT", function () { return $8b11dd70aaca6dbd$export$c499fd8f1db3d18e; }, function (v) { return $8b11dd70aaca6dbd$export$c499fd8f1db3d18e = v; });
$parcel$export(module.exports, "HTTP_HOST", function () { return $8b11dd70aaca6dbd$export$b2ee2242301eff05; }, function (v) { return $8b11dd70aaca6dbd$export$b2ee2242301eff05 = v; });
$parcel$export(module.exports, "HTTP_METHOD", function () { return $8b11dd70aaca6dbd$export$2ebf9f7586f16841; }, function (v) { return $8b11dd70aaca6dbd$export$2ebf9f7586f16841 = v; });
$parcel$export(module.exports, "HTTP_QUERY", function () { return $8b11dd70aaca6dbd$export$6e9ffd608b3e828b; }, function (v) { return $8b11dd70aaca6dbd$export$6e9ffd608b3e828b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DATA", function () { return $8b11dd70aaca6dbd$export$b960c5a73a722e6c; }, function (v) { return $8b11dd70aaca6dbd$export$b960c5a73a722e6c = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECTION_END", function () { return $8b11dd70aaca6dbd$export$a7a850351369c77e; }, function (v) { return $8b11dd70aaca6dbd$export$a7a850351369c77e = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECT_START", function () { return $8b11dd70aaca6dbd$export$b18bca78f4736a94; }, function (v) { return $8b11dd70aaca6dbd$export$b18bca78f4736a94 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_END", function () { return $8b11dd70aaca6dbd$export$61a0059f562fb6c2; }, function (v) { return $8b11dd70aaca6dbd$export$61a0059f562fb6c2 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_START", function () { return $8b11dd70aaca6dbd$export$7dc0d5aefb816d91; }, function (v) { return $8b11dd70aaca6dbd$export$7dc0d5aefb816d91 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_FETCH_START", function () { return $8b11dd70aaca6dbd$export$58f6db56c841bef6; }, function (v) { return $8b11dd70aaca6dbd$export$58f6db56c841bef6 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY", function () { return $8b11dd70aaca6dbd$export$97a3da679f509d5; }, function (v) { return $8b11dd70aaca6dbd$export$97a3da679f509d5 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$c387ec65fd1c2638; }, function (v) { return $8b11dd70aaca6dbd$export$c387ec65fd1c2638 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_METHOD", function () { return $8b11dd70aaca6dbd$export$4d9db82211f308a4; }, function (v) { return $8b11dd70aaca6dbd$export$4d9db82211f308a4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_END", function () { return $8b11dd70aaca6dbd$export$ee4948a3be025123; }, function (v) { return $8b11dd70aaca6dbd$export$ee4948a3be025123 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_START", function () { return $8b11dd70aaca6dbd$export$e0021eb2979cddaa; }, function (v) { return $8b11dd70aaca6dbd$export$e0021eb2979cddaa = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REQUEST_START", function () { return $8b11dd70aaca6dbd$export$7c0ac0c19a45beac; }, function (v) { return $8b11dd70aaca6dbd$export$7c0ac0c19a45beac = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESEND_COUNT", function () { return $8b11dd70aaca6dbd$export$6c32e9d84f534ee; }, function (v) { return $8b11dd70aaca6dbd$export$6c32e9d84f534ee = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_END", function () { return $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b; }, function (v) { return $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_START", function () { return $8b11dd70aaca6dbd$export$45e7eea99a17d6e4; }, function (v) { return $8b11dd70aaca6dbd$export$45e7eea99a17d6e4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SAME_ORIGIN", function () { return $8b11dd70aaca6dbd$export$20ea34e16c0aa64f; }, function (v) { return $8b11dd70aaca6dbd$export$20ea34e16c0aa64f = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SECURE_CONNECTION_START", function () { return $8b11dd70aaca6dbd$export$8365b0f03557fae9; }, function (v) { return $8b11dd70aaca6dbd$export$8365b0f03557fae9 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_TIME_TO_FIRST_BYTE", function () { return $8b11dd70aaca6dbd$export$49ebbb9621675650; }, function (v) { return $8b11dd70aaca6dbd$export$49ebbb9621675650 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_WORKER_START", function () { return $8b11dd70aaca6dbd$export$842be66a901f093; }, function (v) { return $8b11dd70aaca6dbd$export$842be66a901f093 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_SIZE", function () { return $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1; }, function (v) { return $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH", function () { return $8b11dd70aaca6dbd$export$57b055d4bc586d67; }, function (v) { return $8b11dd70aaca6dbd$export$57b055d4bc586d67 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_CONTENT_LENGTH", function () { return $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a; }, function (v) { return $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY", function () { return $8b11dd70aaca6dbd$export$fa7e1f5305153b3d; }, function (v) { return $8b11dd70aaca6dbd$export$fa7e1f5305153b3d = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$5674ce9d013eb7bd; }, function (v) { return $8b11dd70aaca6dbd$export$5674ce9d013eb7bd = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_SIZE", function () { return $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72; }, function (v) { return $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$afd59480458e1b57; }, function (v) { return $8b11dd70aaca6dbd$export$afd59480458e1b57 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_TRANSFER_SIZE", function () { return $8b11dd70aaca6dbd$export$48e61fb9bccccba9; }, function (v) { return $8b11dd70aaca6dbd$export$48e61fb9bccccba9 = v; });
$parcel$export(module.exports, "HTTP_ROUTE", function () { return $8b11dd70aaca6dbd$export$d3e674514dd3a3e1; }, function (v) { return $8b11dd70aaca6dbd$export$d3e674514dd3a3e1 = v; });
$parcel$export(module.exports, "HTTP_SCHEME", function () { return $8b11dd70aaca6dbd$export$97ad02b50c60ef68; }, function (v) { return $8b11dd70aaca6dbd$export$97ad02b50c60ef68 = v; });
$parcel$export(module.exports, "HTTP_SERVER_NAME", function () { return $8b11dd70aaca6dbd$export$61d053b1b63e82c4; }, function (v) { return $8b11dd70aaca6dbd$export$61d053b1b63e82c4 = v; });
$parcel$export(module.exports, "HTTP_SERVER_REQUEST_TIME_IN_QUEUE", function () { return $8b11dd70aaca6dbd$export$54256cce0d674dea; }, function (v) { return $8b11dd70aaca6dbd$export$54256cce0d674dea = v; });
$parcel$export(module.exports, "HTTP_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca; }, function (v) { return $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca = v; });
$parcel$export(module.exports, "HTTP_TARGET", function () { return $8b11dd70aaca6dbd$export$be3f46982f6c7160; }, function (v) { return $8b11dd70aaca6dbd$export$be3f46982f6c7160 = v; });
$parcel$export(module.exports, "HTTP_URL", function () { return $8b11dd70aaca6dbd$export$778e4213e2788579; }, function (v) { return $8b11dd70aaca6dbd$export$778e4213e2788579 = v; });
$parcel$export(module.exports, "HTTP_USER_AGENT", function () { return $8b11dd70aaca6dbd$export$8b48ca3594d2b172; }, function (v) { return $8b11dd70aaca6dbd$export$8b48ca3594d2b172 = v; });
$parcel$export(module.exports, "ID", function () { return $8b11dd70aaca6dbd$export$8be180ec26319f9f; }, function (v) { return $8b11dd70aaca6dbd$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "INP", function () { return $8b11dd70aaca6dbd$export$60eccaddefa8fc1c; }, function (v) { return $8b11dd70aaca6dbd$export$60eccaddefa8fc1c = v; });
$parcel$export(module.exports, "JSONRPC_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$c99ce4fe37484d84; }, function (v) { return $8b11dd70aaca6dbd$export$c99ce4fe37484d84 = v; });
$parcel$export(module.exports, "JSONRPC_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$fdf432fcac7d8f37; }, function (v) { return $8b11dd70aaca6dbd$export$fdf432fcac7d8f37 = v; });
$parcel$export(module.exports, "JVM_GC_ACTION", function () { return $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd; }, function (v) { return $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd = v; });
$parcel$export(module.exports, "JVM_GC_NAME", function () { return $8b11dd70aaca6dbd$export$dcc1eab7f3f31816; }, function (v) { return $8b11dd70aaca6dbd$export$dcc1eab7f3f31816 = v; });
$parcel$export(module.exports, "JVM_MEMORY_POOL_NAME", function () { return $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86; }, function (v) { return $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86 = v; });
$parcel$export(module.exports, "JVM_MEMORY_TYPE", function () { return $8b11dd70aaca6dbd$export$53416edeea4c2d74; }, function (v) { return $8b11dd70aaca6dbd$export$53416edeea4c2d74 = v; });
$parcel$export(module.exports, "JVM_THREAD_DAEMON", function () { return $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e; }, function (v) { return $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e = v; });
$parcel$export(module.exports, "JVM_THREAD_STATE", function () { return $8b11dd70aaca6dbd$export$8e104aed582a26bc; }, function (v) { return $8b11dd70aaca6dbd$export$8e104aed582a26bc = v; });
$parcel$export(module.exports, "KOA_NAME", function () { return $8b11dd70aaca6dbd$export$577047501949be9; }, function (v) { return $8b11dd70aaca6dbd$export$577047501949be9 = v; });
$parcel$export(module.exports, "KOA_TYPE", function () { return $8b11dd70aaca6dbd$export$c4c45b599a2c15e; }, function (v) { return $8b11dd70aaca6dbd$export$c4c45b599a2c15e = v; });
$parcel$export(module.exports, "LCP", function () { return $8b11dd70aaca6dbd$export$361cb541700d648e; }, function (v) { return $8b11dd70aaca6dbd$export$361cb541700d648e = v; });
$parcel$export(module.exports, "LCP_ELEMENT", function () { return $8b11dd70aaca6dbd$export$974f160e11f25731; }, function (v) { return $8b11dd70aaca6dbd$export$974f160e11f25731 = v; });
$parcel$export(module.exports, "LCP_ID", function () { return $8b11dd70aaca6dbd$export$7162f5c702b95903; }, function (v) { return $8b11dd70aaca6dbd$export$7162f5c702b95903 = v; });
$parcel$export(module.exports, "LCP_LOADTIME", function () { return $8b11dd70aaca6dbd$export$a034d066a9090500; }, function (v) { return $8b11dd70aaca6dbd$export$a034d066a9090500 = v; });
$parcel$export(module.exports, "LCP_RENDERTIME", function () { return $8b11dd70aaca6dbd$export$70938021e43e047c; }, function (v) { return $8b11dd70aaca6dbd$export$70938021e43e047c = v; });
$parcel$export(module.exports, "LCP_SIZE", function () { return $8b11dd70aaca6dbd$export$5f6ac460012a73bb; }, function (v) { return $8b11dd70aaca6dbd$export$5f6ac460012a73bb = v; });
$parcel$export(module.exports, "LCP_URL", function () { return $8b11dd70aaca6dbd$export$d8e498c1c670bcbf; }, function (v) { return $8b11dd70aaca6dbd$export$d8e498c1c670bcbf = v; });
$parcel$export(module.exports, "LOGGER_NAME", function () { return $8b11dd70aaca6dbd$export$cc1a78a24d947903; }, function (v) { return $8b11dd70aaca6dbd$export$cc1a78a24d947903 = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REASON", function () { return $8b11dd70aaca6dbd$export$d29b927e0bb0ffea; }, function (v) { return $8b11dd70aaca6dbd$export$d29b927e0bb0ffea = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$b3999cacef245779; }, function (v) { return $8b11dd70aaca6dbd$export$b3999cacef245779 = v; });
$parcel$export(module.exports, "MCP_CLIENT_NAME", function () { return $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6; }, function (v) { return $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6 = v; });
$parcel$export(module.exports, "MCP_CLIENT_TITLE", function () { return $8b11dd70aaca6dbd$export$2ab876a45bd6e64; }, function (v) { return $8b11dd70aaca6dbd$export$2ab876a45bd6e64 = v; });
$parcel$export(module.exports, "MCP_CLIENT_VERSION", function () { return $8b11dd70aaca6dbd$export$cb8027e4395c6c0e; }, function (v) { return $8b11dd70aaca6dbd$export$cb8027e4395c6c0e = v; });
$parcel$export(module.exports, "MCP_LIFECYCLE_PHASE", function () { return $8b11dd70aaca6dbd$export$f5303d1bac3c2660; }, function (v) { return $8b11dd70aaca6dbd$export$f5303d1bac3c2660 = v; });
$parcel$export(module.exports, "MCP_LOGGING_DATA_TYPE", function () { return $8b11dd70aaca6dbd$export$6c463c5f3b00f64; }, function (v) { return $8b11dd70aaca6dbd$export$6c463c5f3b00f64 = v; });
$parcel$export(module.exports, "MCP_LOGGING_LEVEL", function () { return $8b11dd70aaca6dbd$export$e25d553065457cab; }, function (v) { return $8b11dd70aaca6dbd$export$e25d553065457cab = v; });
$parcel$export(module.exports, "MCP_LOGGING_LOGGER", function () { return $8b11dd70aaca6dbd$export$15d24c154ea8a56f; }, function (v) { return $8b11dd70aaca6dbd$export$15d24c154ea8a56f = v; });
$parcel$export(module.exports, "MCP_LOGGING_MESSAGE", function () { return $8b11dd70aaca6dbd$export$e5065789a6c415d0; }, function (v) { return $8b11dd70aaca6dbd$export$e5065789a6c415d0 = v; });
$parcel$export(module.exports, "MCP_METHOD_NAME", function () { return $8b11dd70aaca6dbd$export$62662c561d7c7835; }, function (v) { return $8b11dd70aaca6dbd$export$62662c561d7c7835 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_CURRENT", function () { return $8b11dd70aaca6dbd$export$218f394557fb0a5a; }, function (v) { return $8b11dd70aaca6dbd$export$218f394557fb0a5a = v; });
$parcel$export(module.exports, "MCP_PROGRESS_MESSAGE", function () { return $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf; }, function (v) { return $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf = v; });
$parcel$export(module.exports, "MCP_PROGRESS_PERCENTAGE", function () { return $8b11dd70aaca6dbd$export$9d23f3030ed2597e; }, function (v) { return $8b11dd70aaca6dbd$export$9d23f3030ed2597e = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOKEN", function () { return $8b11dd70aaca6dbd$export$a26ff217a6124160; }, function (v) { return $8b11dd70aaca6dbd$export$a26ff217a6124160 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOTAL", function () { return $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77; }, function (v) { return $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77 = v; });
$parcel$export(module.exports, "MCP_PROMPT_NAME", function () { return $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96; }, function (v) { return $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$328519d02a26ac41; }, function (v) { return $8b11dd70aaca6dbd$export$328519d02a26ac41 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT", function () { return $8b11dd70aaca6dbd$export$d2061b291c43d045; }, function (v) { return $8b11dd70aaca6dbd$export$d2061b291c43d045 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT", function () { return $8b11dd70aaca6dbd$export$d1f04dfd3d695286; }, function (v) { return $8b11dd70aaca6dbd$export$d1f04dfd3d695286 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_ROLE", function () { return $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8; }, function (v) { return $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_READY", function () { return $8b11dd70aaca6dbd$export$e795000978a75b12; }, function (v) { return $8b11dd70aaca6dbd$export$e795000978a75b12 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$9f4683b4d1018ace; }, function (v) { return $8b11dd70aaca6dbd$export$9f4683b4d1018ace = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY", function () { return $8b11dd70aaca6dbd$export$e431b042fcdb1d63; }, function (v) { return $8b11dd70aaca6dbd$export$e431b042fcdb1d63 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$a453239171ac9a23; }, function (v) { return $8b11dd70aaca6dbd$export$a453239171ac9a23 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_NAME", function () { return $8b11dd70aaca6dbd$export$3a7726a976c18d5f; }, function (v) { return $8b11dd70aaca6dbd$export$3a7726a976c18d5f = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_URI", function () { return $8b11dd70aaca6dbd$export$7eca7a6c06843b93; }, function (v) { return $8b11dd70aaca6dbd$export$7eca7a6c06843b93 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$f25c55f83e5b0672; }, function (v) { return $8b11dd70aaca6dbd$export$f25c55f83e5b0672 = v; });
$parcel$export(module.exports, "MCP_RESOURCE_PROTOCOL", function () { return $8b11dd70aaca6dbd$export$9562bfac4eb079cb; }, function (v) { return $8b11dd70aaca6dbd$export$9562bfac4eb079cb = v; });
$parcel$export(module.exports, "MCP_RESOURCE_URI", function () { return $8b11dd70aaca6dbd$export$c276d164ff91d2f7; }, function (v) { return $8b11dd70aaca6dbd$export$c276d164ff91d2f7 = v; });
$parcel$export(module.exports, "MCP_SERVER_NAME", function () { return $8b11dd70aaca6dbd$export$2f3e0574f1a99754; }, function (v) { return $8b11dd70aaca6dbd$export$2f3e0574f1a99754 = v; });
$parcel$export(module.exports, "MCP_SERVER_TITLE", function () { return $8b11dd70aaca6dbd$export$15eecaab68167880; }, function (v) { return $8b11dd70aaca6dbd$export$15eecaab68167880 = v; });
$parcel$export(module.exports, "MCP_SERVER_VERSION", function () { return $8b11dd70aaca6dbd$export$513c47f6e194086a; }, function (v) { return $8b11dd70aaca6dbd$export$513c47f6e194086a = v; });
$parcel$export(module.exports, "MCP_SESSION_ID", function () { return $8b11dd70aaca6dbd$export$a3f464c4d5cd9096; }, function (v) { return $8b11dd70aaca6dbd$export$a3f464c4d5cd9096 = v; });
$parcel$export(module.exports, "MCP_TOOL_NAME", function () { return $8b11dd70aaca6dbd$export$ed366a03a2330b03; }, function (v) { return $8b11dd70aaca6dbd$export$ed366a03a2330b03 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT", function () { return $8b11dd70aaca6dbd$export$9b802c784f235e1d; }, function (v) { return $8b11dd70aaca6dbd$export$9b802c784f235e1d = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT_COUNT", function () { return $8b11dd70aaca6dbd$export$add0fc8b8c5726a4; }, function (v) { return $8b11dd70aaca6dbd$export$add0fc8b8c5726a4 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_IS_ERROR", function () { return $8b11dd70aaca6dbd$export$e7f32463f5bfd554; }, function (v) { return $8b11dd70aaca6dbd$export$e7f32463f5bfd554 = v; });
$parcel$export(module.exports, "MCP_TRANSPORT", function () { return $8b11dd70aaca6dbd$export$f9346f394edf26a; }, function (v) { return $8b11dd70aaca6dbd$export$f9346f394edf26a = v; });
$parcel$export(module.exports, "MDC_KEY", function () { return $8b11dd70aaca6dbd$export$16b917774e73ef92; }, function (v) { return $8b11dd70aaca6dbd$export$16b917774e73ef92 = v; });
$parcel$export(module.exports, "MDC_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$15d2b60bf3b65454; }, function (v) { return $8b11dd70aaca6dbd$export$15d2b60bf3b65454 = v; });
$parcel$export(module.exports, "MESSAGING_BATCH_MESSAGE_COUNT", function () { return $8b11dd70aaca6dbd$export$db55eca5af256142; }, function (v) { return $8b11dd70aaca6dbd$export$db55eca5af256142 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION", function () { return $8b11dd70aaca6dbd$export$967c74f8b1f3d35; }, function (v) { return $8b11dd70aaca6dbd$export$967c74f8b1f3d35 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_CONNECTION", function () { return $8b11dd70aaca6dbd$export$7c33ae67962515d1; }, function (v) { return $8b11dd70aaca6dbd$export$7c33ae67962515d1 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_NAME", function () { return $8b11dd70aaca6dbd$export$9c69839b2d93489b; }, function (v) { return $8b11dd70aaca6dbd$export$9c69839b2d93489b = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_BODY_SIZE", function () { return $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8; }, function (v) { return $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_CONVERSATION_ID", function () { return $8b11dd70aaca6dbd$export$c529961b911626ac; }, function (v) { return $8b11dd70aaca6dbd$export$c529961b911626ac = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ENVELOPE_SIZE", function () { return $8b11dd70aaca6dbd$export$e39c4b15d2881f5; }, function (v) { return $8b11dd70aaca6dbd$export$e39c4b15d2881f5 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ID", function () { return $8b11dd70aaca6dbd$export$a8ca145161313e7; }, function (v) { return $8b11dd70aaca6dbd$export$a8ca145161313e7 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RECEIVE_LATENCY", function () { return $8b11dd70aaca6dbd$export$3c1204d03918d076; }, function (v) { return $8b11dd70aaca6dbd$export$3c1204d03918d076 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RETRY_COUNT", function () { return $8b11dd70aaca6dbd$export$eaac3f141165e288; }, function (v) { return $8b11dd70aaca6dbd$export$eaac3f141165e288 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_NAME", function () { return $8b11dd70aaca6dbd$export$4c7e6934714150e6; }, function (v) { return $8b11dd70aaca6dbd$export$4c7e6934714150e6 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_TYPE", function () { return $8b11dd70aaca6dbd$export$6f71f9711d666eb4; }, function (v) { return $8b11dd70aaca6dbd$export$6f71f9711d666eb4 = v; });
$parcel$export(module.exports, "MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY", function () { return $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4; }, function (v) { return $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4 = v; });
$parcel$export(module.exports, "MESSAGING_SYSTEM", function () { return $8b11dd70aaca6dbd$export$55478a0b7d2ae98f; }, function (v) { return $8b11dd70aaca6dbd$export$55478a0b7d2ae98f = v; });
$parcel$export(module.exports, "METHOD", function () { return $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a; }, function (v) { return $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a = v; });
$parcel$export(module.exports, "MIDDLEWARE_NAME", function () { return $8b11dd70aaca6dbd$export$a82607b6424c06c8; }, function (v) { return $8b11dd70aaca6dbd$export$a82607b6424c06c8 = v; });
$parcel$export(module.exports, "NAVIGATION_ORIGIN", function () { return $8b11dd70aaca6dbd$export$6b081f3484c7f4e5; }, function (v) { return $8b11dd70aaca6dbd$export$6b081f3484c7f4e5 = v; });
$parcel$export(module.exports, "NAVIGATION_ROUTE_ID", function () { return $8b11dd70aaca6dbd$export$b7754d85fd39406c; }, function (v) { return $8b11dd70aaca6dbd$export$b7754d85fd39406c = v; });
$parcel$export(module.exports, "NAVIGATION_TYPE", function () { return $8b11dd70aaca6dbd$export$492856c046eb4728; }, function (v) { return $8b11dd70aaca6dbd$export$492856c046eb4728 = v; });
$parcel$export(module.exports, "NEL_ELAPSED_TIME", function () { return $8b11dd70aaca6dbd$export$c1678a2059fbe906; }, function (v) { return $8b11dd70aaca6dbd$export$c1678a2059fbe906 = v; });
$parcel$export(module.exports, "NEL_PHASE", function () { return $8b11dd70aaca6dbd$export$6d384a0bc1011c34; }, function (v) { return $8b11dd70aaca6dbd$export$6d384a0bc1011c34 = v; });
$parcel$export(module.exports, "NEL_REFERRER", function () { return $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4; }, function (v) { return $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4 = v; });
$parcel$export(module.exports, "NEL_SAMPLING_FUNCTION", function () { return $8b11dd70aaca6dbd$export$cfcbff40019f0ff1; }, function (v) { return $8b11dd70aaca6dbd$export$cfcbff40019f0ff1 = v; });
$parcel$export(module.exports, "NEL_TYPE", function () { return $8b11dd70aaca6dbd$export$27157b5f68e583af; }, function (v) { return $8b11dd70aaca6dbd$export$27157b5f68e583af = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_EFFECTIVE_TYPE", function () { return $8b11dd70aaca6dbd$export$54bf5ed61532925d; }, function (v) { return $8b11dd70aaca6dbd$export$54bf5ed61532925d = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_RTT", function () { return $8b11dd70aaca6dbd$export$60ed0786292ace08; }, function (v) { return $8b11dd70aaca6dbd$export$60ed0786292ace08 = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_TYPE", function () { return $8b11dd70aaca6dbd$export$d770bfb8345e146; }, function (v) { return $8b11dd70aaca6dbd$export$d770bfb8345e146 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_ADDRESS", function () { return $8b11dd70aaca6dbd$export$bb73817f1290ad28; }, function (v) { return $8b11dd70aaca6dbd$export$bb73817f1290ad28 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_PORT", function () { return $8b11dd70aaca6dbd$export$f201c980f2b75802; }, function (v) { return $8b11dd70aaca6dbd$export$f201c980f2b75802 = v; });
$parcel$export(module.exports, "NETWORK_PEER_ADDRESS", function () { return $8b11dd70aaca6dbd$export$b40e970572afd0ee; }, function (v) { return $8b11dd70aaca6dbd$export$b40e970572afd0ee = v; });
$parcel$export(module.exports, "NETWORK_PEER_PORT", function () { return $8b11dd70aaca6dbd$export$8850630a3d343488; }, function (v) { return $8b11dd70aaca6dbd$export$8850630a3d343488 = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_NAME", function () { return $8b11dd70aaca6dbd$export$fd0a39a918d6516f; }, function (v) { return $8b11dd70aaca6dbd$export$fd0a39a918d6516f = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$e68ef41f8e0335bf; }, function (v) { return $8b11dd70aaca6dbd$export$e68ef41f8e0335bf = v; });
$parcel$export(module.exports, "NETWORK_TRANSPORT", function () { return $8b11dd70aaca6dbd$export$5bff09650e762829; }, function (v) { return $8b11dd70aaca6dbd$export$5bff09650e762829 = v; });
$parcel$export(module.exports, "NETWORK_TYPE", function () { return $8b11dd70aaca6dbd$export$21c1adce0e067f37; }, function (v) { return $8b11dd70aaca6dbd$export$21c1adce0e067f37 = v; });
$parcel$export(module.exports, "NET_HOST_IP", function () { return $8b11dd70aaca6dbd$export$fed6ce86f48c84bc; }, function (v) { return $8b11dd70aaca6dbd$export$fed6ce86f48c84bc = v; });
$parcel$export(module.exports, "NET_HOST_NAME", function () { return $8b11dd70aaca6dbd$export$500c2675137ac16e; }, function (v) { return $8b11dd70aaca6dbd$export$500c2675137ac16e = v; });
$parcel$export(module.exports, "NET_HOST_PORT", function () { return $8b11dd70aaca6dbd$export$402c7728623fd8df; }, function (v) { return $8b11dd70aaca6dbd$export$402c7728623fd8df = v; });
$parcel$export(module.exports, "NET_PEER_IP", function () { return $8b11dd70aaca6dbd$export$15417259f4c0fe6b; }, function (v) { return $8b11dd70aaca6dbd$export$15417259f4c0fe6b = v; });
$parcel$export(module.exports, "NET_PEER_NAME", function () { return $8b11dd70aaca6dbd$export$2b3b7f579a727f45; }, function (v) { return $8b11dd70aaca6dbd$export$2b3b7f579a727f45 = v; });
$parcel$export(module.exports, "NET_PEER_PORT", function () { return $8b11dd70aaca6dbd$export$514832a0b029734b; }, function (v) { return $8b11dd70aaca6dbd$export$514832a0b029734b = v; });
$parcel$export(module.exports, "NET_PROTOCOL_NAME", function () { return $8b11dd70aaca6dbd$export$b0522e6a14dec1a4; }, function (v) { return $8b11dd70aaca6dbd$export$b0522e6a14dec1a4 = v; });
$parcel$export(module.exports, "NET_PROTOCOL_VERSION", function () { return $8b11dd70aaca6dbd$export$659ea19f71a7ee0b; }, function (v) { return $8b11dd70aaca6dbd$export$659ea19f71a7ee0b = v; });
$parcel$export(module.exports, "NET_SOCK_FAMILY", function () { return $8b11dd70aaca6dbd$export$1b61d972db315e73; }, function (v) { return $8b11dd70aaca6dbd$export$1b61d972db315e73 = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_ADDR", function () { return $8b11dd70aaca6dbd$export$fb2970ee11a479ee; }, function (v) { return $8b11dd70aaca6dbd$export$fb2970ee11a479ee = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_PORT", function () { return $8b11dd70aaca6dbd$export$920aceb2a8fad77e; }, function (v) { return $8b11dd70aaca6dbd$export$920aceb2a8fad77e = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_ADDR", function () { return $8b11dd70aaca6dbd$export$48f8f6fbc999d187; }, function (v) { return $8b11dd70aaca6dbd$export$48f8f6fbc999d187 = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_NAME", function () { return $8b11dd70aaca6dbd$export$eed590fa00a8223b; }, function (v) { return $8b11dd70aaca6dbd$export$eed590fa00a8223b = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_PORT", function () { return $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da; }, function (v) { return $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da = v; });
$parcel$export(module.exports, "NET_TRANSPORT", function () { return $8b11dd70aaca6dbd$export$779ef03d633a9086; }, function (v) { return $8b11dd70aaca6dbd$export$779ef03d633a9086 = v; });
$parcel$export(module.exports, "OS_BUILD", function () { return $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc; }, function (v) { return $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc = v; });
$parcel$export(module.exports, "OS_BUILD_ID", function () { return $8b11dd70aaca6dbd$export$ca719aa57653a0a7; }, function (v) { return $8b11dd70aaca6dbd$export$ca719aa57653a0a7 = v; });
$parcel$export(module.exports, "OS_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$74b19c5f48270c05; }, function (v) { return $8b11dd70aaca6dbd$export$74b19c5f48270c05 = v; });
$parcel$export(module.exports, "OS_KERNEL_VERSION", function () { return $8b11dd70aaca6dbd$export$c351affe7e8098cb; }, function (v) { return $8b11dd70aaca6dbd$export$c351affe7e8098cb = v; });
$parcel$export(module.exports, "OS_NAME", function () { return $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765; }, function (v) { return $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765 = v; });
$parcel$export(module.exports, "OS_RAW_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$ec182524c4c57275; }, function (v) { return $8b11dd70aaca6dbd$export$ec182524c4c57275 = v; });
$parcel$export(module.exports, "OS_ROOTED", function () { return $8b11dd70aaca6dbd$export$9e45758246a85b07; }, function (v) { return $8b11dd70aaca6dbd$export$9e45758246a85b07 = v; });
$parcel$export(module.exports, "OS_THEME", function () { return $8b11dd70aaca6dbd$export$9fa5d5f0144954cb; }, function (v) { return $8b11dd70aaca6dbd$export$9fa5d5f0144954cb = v; });
$parcel$export(module.exports, "OS_TYPE", function () { return $8b11dd70aaca6dbd$export$e66ba5bc4b978023; }, function (v) { return $8b11dd70aaca6dbd$export$e66ba5bc4b978023 = v; });
$parcel$export(module.exports, "OS_VERSION", function () { return $8b11dd70aaca6dbd$export$2306e23cc611a36d; }, function (v) { return $8b11dd70aaca6dbd$export$2306e23cc611a36d = v; });
$parcel$export(module.exports, "OTEL_KIND", function () { return $8b11dd70aaca6dbd$export$144f8c1fe01428db; }, function (v) { return $8b11dd70aaca6dbd$export$144f8c1fe01428db = v; });
$parcel$export(module.exports, "OTEL_SCOPE_NAME", function () { return $8b11dd70aaca6dbd$export$f303b2744d52121c; }, function (v) { return $8b11dd70aaca6dbd$export$f303b2744d52121c = v; });
$parcel$export(module.exports, "OTEL_SCOPE_VERSION", function () { return $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6; }, function (v) { return $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6 = v; });
$parcel$export(module.exports, "OTEL_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$b4c85774878b4841; }, function (v) { return $8b11dd70aaca6dbd$export$b4c85774878b4841 = v; });
$parcel$export(module.exports, "OTEL_STATUS_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$1c967a71bc9a3077; }, function (v) { return $8b11dd70aaca6dbd$export$1c967a71bc9a3077 = v; });
$parcel$export(module.exports, "PARAMS_KEY", function () { return $8b11dd70aaca6dbd$export$5e3884a35a19eb90; }, function (v) { return $8b11dd70aaca6dbd$export$5e3884a35a19eb90 = v; });
$parcel$export(module.exports, "PARAMS_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$6e7ff99bb3259573; }, function (v) { return $8b11dd70aaca6dbd$export$6e7ff99bb3259573 = v; });
$parcel$export(module.exports, "PERFORMANCE_ACTIVATIONSTART", function () { return $8b11dd70aaca6dbd$export$7c932cba2d9e7a7; }, function (v) { return $8b11dd70aaca6dbd$export$7c932cba2d9e7a7 = v; });
$parcel$export(module.exports, "PERFORMANCE_TIMEORIGIN", function () { return $8b11dd70aaca6dbd$export$94091942edce0667; }, function (v) { return $8b11dd70aaca6dbd$export$94091942edce0667 = v; });
$parcel$export(module.exports, "PREVIOUS_ROUTE", function () { return $8b11dd70aaca6dbd$export$3671a8a524706a9d; }, function (v) { return $8b11dd70aaca6dbd$export$3671a8a524706a9d = v; });
$parcel$export(module.exports, "PROCESS_COMMAND_ARGS", function () { return $8b11dd70aaca6dbd$export$c288888dc82d233f; }, function (v) { return $8b11dd70aaca6dbd$export$c288888dc82d233f = v; });
$parcel$export(module.exports, "PROCESS_EXECUTABLE_NAME", function () { return $8b11dd70aaca6dbd$export$8ff188536cebc35; }, function (v) { return $8b11dd70aaca6dbd$export$8ff188536cebc35 = v; });
$parcel$export(module.exports, "PROCESS_PID", function () { return $8b11dd70aaca6dbd$export$6407d78968c0eabe; }, function (v) { return $8b11dd70aaca6dbd$export$6407d78968c0eabe = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$43e9fb9ec28d9743; }, function (v) { return $8b11dd70aaca6dbd$export$43e9fb9ec28d9743 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_NAME", function () { return $8b11dd70aaca6dbd$export$26f31d5c5c201739; }, function (v) { return $8b11dd70aaca6dbd$export$26f31d5c5c201739 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_VERSION", function () { return $8b11dd70aaca6dbd$export$bff85124d2d35b93; }, function (v) { return $8b11dd70aaca6dbd$export$bff85124d2d35b93 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_NAME", function () { return $8b11dd70aaca6dbd$export$495c671ed5a6408c; }, function (v) { return $8b11dd70aaca6dbd$export$495c671ed5a6408c = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_VERSION", function () { return $8b11dd70aaca6dbd$export$54b3d4d5548c35c3; }, function (v) { return $8b11dd70aaca6dbd$export$54b3d4d5548c35c3 = v; });
$parcel$export(module.exports, "QUERY_KEY", function () { return $8b11dd70aaca6dbd$export$2954db6444fe1fa8; }, function (v) { return $8b11dd70aaca6dbd$export$2954db6444fe1fa8 = v; });
$parcel$export(module.exports, "QUERY_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$15c1c974d16dd678; }, function (v) { return $8b11dd70aaca6dbd$export$15c1c974d16dd678 = v; });
$parcel$export(module.exports, "REACT_VERSION", function () { return $8b11dd70aaca6dbd$export$9be2ae89a1eac217; }, function (v) { return $8b11dd70aaca6dbd$export$9be2ae89a1eac217 = v; });
$parcel$export(module.exports, "RELEASE", function () { return $8b11dd70aaca6dbd$export$5c698591c0e586a2; }, function (v) { return $8b11dd70aaca6dbd$export$5c698591c0e586a2 = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY", function () { return $8b11dd70aaca6dbd$export$b711f2bb9c9a848a; }, function (v) { return $8b11dd70aaca6dbd$export$b711f2bb9c9a848a = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$1d3a8501efd30213; }, function (v) { return $8b11dd70aaca6dbd$export$1d3a8501efd30213 = v; });
$parcel$export(module.exports, "REPLAY_ID", function () { return $8b11dd70aaca6dbd$export$cebaf684ced5a2c9; }, function (v) { return $8b11dd70aaca6dbd$export$cebaf684ced5a2c9 = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c; }, function (v) { return $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME", function () { return $8b11dd70aaca6dbd$export$b1b162b01baeb044; }, function (v) { return $8b11dd70aaca6dbd$export$b1b162b01baeb044 = v; });
$parcel$export(module.exports, "RESOURCE_RENDER_BLOCKING_STATUS", function () { return $8b11dd70aaca6dbd$export$8be2d593d7f88ed8; }, function (v) { return $8b11dd70aaca6dbd$export$8be2d593d7f88ed8 = v; });
$parcel$export(module.exports, "ROUTE", function () { return $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0; }, function (v) { return $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0 = v; });
$parcel$export(module.exports, "RPC_GRPC_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$66581dc6d3d083d1; }, function (v) { return $8b11dd70aaca6dbd$export$66581dc6d3d083d1 = v; });
$parcel$export(module.exports, "RPC_METHOD", function () { return $8b11dd70aaca6dbd$export$e545f99e7abcc499; }, function (v) { return $8b11dd70aaca6dbd$export$e545f99e7abcc499 = v; });
$parcel$export(module.exports, "RPC_RESPONSE_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa; }, function (v) { return $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa = v; });
$parcel$export(module.exports, "RPC_SERVICE", function () { return $8b11dd70aaca6dbd$export$186c94c351c54768; }, function (v) { return $8b11dd70aaca6dbd$export$186c94c351c54768 = v; });
$parcel$export(module.exports, "RPC_SYSTEM", function () { return $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c; }, function (v) { return $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c = v; });
$parcel$export(module.exports, "RPC_SYSTEM_NAME", function () { return $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5; }, function (v) { return $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5 = v; });
$parcel$export(module.exports, "RUNTIME_BUILD", function () { return $8b11dd70aaca6dbd$export$9d5bffdff936d554; }, function (v) { return $8b11dd70aaca6dbd$export$9d5bffdff936d554 = v; });
$parcel$export(module.exports, "RUNTIME_NAME", function () { return $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79; }, function (v) { return $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79 = v; });
$parcel$export(module.exports, "RUNTIME_RAW_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$27933a9557f87e98; }, function (v) { return $8b11dd70aaca6dbd$export$27933a9557f87e98 = v; });
$parcel$export(module.exports, "RUNTIME_VERSION", function () { return $8b11dd70aaca6dbd$export$eefa737b40a0d535; }, function (v) { return $8b11dd70aaca6dbd$export$eefa737b40a0d535 = v; });
$parcel$export(module.exports, "SCORE_KEY", function () { return $8b11dd70aaca6dbd$export$92740ffbcb02553b; }, function (v) { return $8b11dd70aaca6dbd$export$92740ffbcb02553b = v; });
$parcel$export(module.exports, "SCORE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$500e89753f9f1008; }, function (v) { return $8b11dd70aaca6dbd$export$500e89753f9f1008 = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY", function () { return $8b11dd70aaca6dbd$export$d91a18e47fdddefd; }, function (v) { return $8b11dd70aaca6dbd$export$d91a18e47fdddefd = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$eccbe6f20884ea7f; }, function (v) { return $8b11dd70aaca6dbd$export$eccbe6f20884ea7f = v; });
$parcel$export(module.exports, "SCORE_TOTAL", function () { return $8b11dd70aaca6dbd$export$9e24f11d79141afb; }, function (v) { return $8b11dd70aaca6dbd$export$9e24f11d79141afb = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY", function () { return $8b11dd70aaca6dbd$export$f0b96ad9586f8887; }, function (v) { return $8b11dd70aaca6dbd$export$f0b96ad9586f8887 = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$8a92ed5d436a85c6; }, function (v) { return $8b11dd70aaca6dbd$export$8a92ed5d436a85c6 = v; });
$parcel$export(module.exports, "SENTRY_ACTION", function () { return $8b11dd70aaca6dbd$export$edd59acdf7e86a71; }, function (v) { return $8b11dd70aaca6dbd$export$edd59acdf7e86a71 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_NAME", function () { return $8b11dd70aaca6dbd$export$ae81a1ae71952d50; }, function (v) { return $8b11dd70aaca6dbd$export$ae81a1ae71952d50 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_VERSION", function () { return $8b11dd70aaca6dbd$export$6101470cd57eac1b; }, function (v) { return $8b11dd70aaca6dbd$export$6101470cd57eac1b = v; });
$parcel$export(module.exports, "SENTRY_CANCELLATION_REASON", function () { return $8b11dd70aaca6dbd$export$452c0aee9673fe67; }, function (v) { return $8b11dd70aaca6dbd$export$452c0aee9673fe67 = v; });
$parcel$export(module.exports, "SENTRY_CATEGORY", function () { return $8b11dd70aaca6dbd$export$773dddd1e8667756; }, function (v) { return $8b11dd70aaca6dbd$export$773dddd1e8667756 = v; });
$parcel$export(module.exports, "SENTRY_CLIENT_SAMPLE_RATE", function () { return $8b11dd70aaca6dbd$export$98815f8579a64a90; }, function (v) { return $8b11dd70aaca6dbd$export$98815f8579a64a90 = v; });
$parcel$export(module.exports, "SENTRY_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$7bc4e27428665019; }, function (v) { return $8b11dd70aaca6dbd$export$7bc4e27428665019 = v; });
$parcel$export(module.exports, "SENTRY_DIST", function () { return $8b11dd70aaca6dbd$export$e7d7477fa9057ee2; }, function (v) { return $8b11dd70aaca6dbd$export$e7d7477fa9057ee2 = v; });
$parcel$export(module.exports, "SENTRY_DOMAIN", function () { return $8b11dd70aaca6dbd$export$1f4267a3fc018448; }, function (v) { return $8b11dd70aaca6dbd$export$1f4267a3fc018448 = v; });
$parcel$export(module.exports, "SENTRY_DSC_ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$c171cae150389952; }, function (v) { return $8b11dd70aaca6dbd$export$c171cae150389952 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PROJECT_ID", function () { return $8b11dd70aaca6dbd$export$d9bb35e957b22c72; }, function (v) { return $8b11dd70aaca6dbd$export$d9bb35e957b22c72 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PUBLIC_KEY", function () { return $8b11dd70aaca6dbd$export$b3508a2c95f74e3d; }, function (v) { return $8b11dd70aaca6dbd$export$b3508a2c95f74e3d = v; });
$parcel$export(module.exports, "SENTRY_DSC_RELEASE", function () { return $8b11dd70aaca6dbd$export$20bb272f4d21532d; }, function (v) { return $8b11dd70aaca6dbd$export$20bb272f4d21532d = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLED", function () { return $8b11dd70aaca6dbd$export$d7e64fbd0102ce90; }, function (v) { return $8b11dd70aaca6dbd$export$d7e64fbd0102ce90 = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLE_RATE", function () { return $8b11dd70aaca6dbd$export$c17eae7e86dbba3c; }, function (v) { return $8b11dd70aaca6dbd$export$c17eae7e86dbba3c = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRACE_ID", function () { return $8b11dd70aaca6dbd$export$349603c0a9165744; }, function (v) { return $8b11dd70aaca6dbd$export$349603c0a9165744 = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRANSACTION", function () { return $8b11dd70aaca6dbd$export$4dadf693741f0283; }, function (v) { return $8b11dd70aaca6dbd$export$4dadf693741f0283 = v; });
$parcel$export(module.exports, "SENTRY_ENVIRONMENT", function () { return $8b11dd70aaca6dbd$export$6377864d12f7eeb3; }, function (v) { return $8b11dd70aaca6dbd$export$6377864d12f7eeb3 = v; });
$parcel$export(module.exports, "SENTRY_EXCLUSIVE_TIME", function () { return $8b11dd70aaca6dbd$export$ba081af9585ed4; }, function (v) { return $8b11dd70aaca6dbd$export$ba081af9585ed4 = v; });
$parcel$export(module.exports, "SENTRY_GRAPHQL_OPERATION", function () { return $8b11dd70aaca6dbd$export$7841dacb241485d0; }, function (v) { return $8b11dd70aaca6dbd$export$7841dacb241485d0 = v; });
$parcel$export(module.exports, "SENTRY_GROUP", function () { return $8b11dd70aaca6dbd$export$52c7044cf6301362; }, function (v) { return $8b11dd70aaca6dbd$export$52c7044cf6301362 = v; });
$parcel$export(module.exports, "SENTRY_HTTP_PREFETCH", function () { return $8b11dd70aaca6dbd$export$56ea1c9e44590e20; }, function (v) { return $8b11dd70aaca6dbd$export$56ea1c9e44590e20 = v; });
$parcel$export(module.exports, "SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $8b11dd70aaca6dbd$export$7626e389d05f4c36; }, function (v) { return $8b11dd70aaca6dbd$export$7626e389d05f4c36 = v; });
$parcel$export(module.exports, "SENTRY_IS_REMOTE", function () { return $8b11dd70aaca6dbd$export$5e0a48187329b2e7; }, function (v) { return $8b11dd70aaca6dbd$export$5e0a48187329b2e7 = v; });
$parcel$export(module.exports, "SENTRY_KIND", function () { return $8b11dd70aaca6dbd$export$c322b150d7667841; }, function (v) { return $8b11dd70aaca6dbd$export$c322b150d7667841 = v; });
$parcel$export(module.exports, "SENTRY_MAIN_THREAD", function () { return $8b11dd70aaca6dbd$export$4a4797d3c962f753; }, function (v) { return $8b11dd70aaca6dbd$export$4a4797d3c962f753 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_PARAMETER_KEY", function () { return $8b11dd70aaca6dbd$export$767524d5e72e2645; }, function (v) { return $8b11dd70aaca6dbd$export$767524d5e72e2645 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_TEMPLATE", function () { return $8b11dd70aaca6dbd$export$497354ca7b0ee666; }, function (v) { return $8b11dd70aaca6dbd$export$497354ca7b0ee666 = v; });
$parcel$export(module.exports, "SENTRY_METRIC_SOURCE", function () { return $8b11dd70aaca6dbd$export$cbdc4ad11118116a; }, function (v) { return $8b11dd70aaca6dbd$export$cbdc4ad11118116a = v; });
$parcel$export(module.exports, "SENTRY_MOBILE", function () { return $8b11dd70aaca6dbd$export$5b890de778c4c2fe; }, function (v) { return $8b11dd70aaca6dbd$export$5b890de778c4c2fe = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY", function () { return $8b11dd70aaca6dbd$export$a78d9803b5e0a83e; }, function (v) { return $8b11dd70aaca6dbd$export$a78d9803b5e0a83e = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$df1b536467b3992a; }, function (v) { return $8b11dd70aaca6dbd$export$df1b536467b3992a = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_ROUTE", function () { return $8b11dd70aaca6dbd$export$73104a329e205998; }, function (v) { return $8b11dd70aaca6dbd$export$73104a329e205998 = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_TYPE", function () { return $8b11dd70aaca6dbd$export$5740e3da55330b0a; }, function (v) { return $8b11dd70aaca6dbd$export$5740e3da55330b0a = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY", function () { return $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da; }, function (v) { return $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY_HASH", function () { return $8b11dd70aaca6dbd$export$e5f1321e53e24810; }, function (v) { return $8b11dd70aaca6dbd$export$e5f1321e53e24810 = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DESCRIPTION", function () { return $8b11dd70aaca6dbd$export$56dd3098cbca7c8a; }, function (v) { return $8b11dd70aaca6dbd$export$56dd3098cbca7c8a = v; });
$parcel$export(module.exports, "SENTRY_OBSERVED_TIMESTAMP_NANOS", function () { return $8b11dd70aaca6dbd$export$aa7aff70e4380665; }, function (v) { return $8b11dd70aaca6dbd$export$aa7aff70e4380665 = v; });
$parcel$export(module.exports, "SENTRY_OP", function () { return $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf; }, function (v) { return $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf = v; });
$parcel$export(module.exports, "SENTRY_ORIGIN", function () { return $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6; }, function (v) { return $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6 = v; });
$parcel$export(module.exports, "SENTRY_PLATFORM", function () { return $8b11dd70aaca6dbd$export$91ad03bba7909fb5; }, function (v) { return $8b11dd70aaca6dbd$export$91ad03bba7909fb5 = v; });
$parcel$export(module.exports, "SENTRY_PROFILER_ID", function () { return $8b11dd70aaca6dbd$export$86128e6c0ab71d64; }, function (v) { return $8b11dd70aaca6dbd$export$86128e6c0ab71d64 = v; });
$parcel$export(module.exports, "SENTRY_PROFILE_ID", function () { return $8b11dd70aaca6dbd$export$745b60c4819aec1d; }, function (v) { return $8b11dd70aaca6dbd$export$745b60c4819aec1d = v; });
$parcel$export(module.exports, "SENTRY_RELEASE", function () { return $8b11dd70aaca6dbd$export$d2c893bfac1da9a1; }, function (v) { return $8b11dd70aaca6dbd$export$d2c893bfac1da9a1 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_ID", function () { return $8b11dd70aaca6dbd$export$1c14ad02f9534b19; }, function (v) { return $8b11dd70aaca6dbd$export$1c14ad02f9534b19 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_IS_BUFFERING", function () { return $8b11dd70aaca6dbd$export$db3cb63e0594d014; }, function (v) { return $8b11dd70aaca6dbd$export$db3cb63e0594d014 = v; });
$parcel$export(module.exports, "SENTRY_REPORT_EVENT", function () { return $8b11dd70aaca6dbd$export$a65c9a0eba2c222d; }, function (v) { return $8b11dd70aaca6dbd$export$a65c9a0eba2c222d = v; });
$parcel$export(module.exports, "SENTRY_SDK_INTEGRATIONS", function () { return $8b11dd70aaca6dbd$export$68dbcca9c0e339ec; }, function (v) { return $8b11dd70aaca6dbd$export$68dbcca9c0e339ec = v; });
$parcel$export(module.exports, "SENTRY_SDK_NAME", function () { return $8b11dd70aaca6dbd$export$d59b669d4bb3f006; }, function (v) { return $8b11dd70aaca6dbd$export$d59b669d4bb3f006 = v; });
$parcel$export(module.exports, "SENTRY_SDK_VERSION", function () { return $8b11dd70aaca6dbd$export$4d88d347aa9667fc; }, function (v) { return $8b11dd70aaca6dbd$export$4d88d347aa9667fc = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_ID", function () { return $8b11dd70aaca6dbd$export$9943ffdcaa4bc506; }, function (v) { return $8b11dd70aaca6dbd$export$9943ffdcaa4bc506 = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME", function () { return $8b11dd70aaca6dbd$export$d4f25b923533dbba; }, function (v) { return $8b11dd70aaca6dbd$export$d4f25b923533dbba = v; });
$parcel$export(module.exports, "SENTRY_SERVER_SAMPLE_RATE", function () { return $8b11dd70aaca6dbd$export$35f3396a1cdeea45; }, function (v) { return $8b11dd70aaca6dbd$export$35f3396a1cdeea45 = v; });
$parcel$export(module.exports, "SENTRY_SOURCE", function () { return $8b11dd70aaca6dbd$export$80e399da474bc98d; }, function (v) { return $8b11dd70aaca6dbd$export$80e399da474bc98d = v; });
$parcel$export(module.exports, "SENTRY_SPAN_SOURCE", function () { return $8b11dd70aaca6dbd$export$e01809e2dbceac35; }, function (v) { return $8b11dd70aaca6dbd$export$e01809e2dbceac35 = v; });
$parcel$export(module.exports, "SENTRY_STATUS", function () { return $8b11dd70aaca6dbd$export$41900d5c4e8a9c68; }, function (v) { return $8b11dd70aaca6dbd$export$41900d5c4e8a9c68 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03; }, function (v) { return $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_MESSAGE", function () { return $8b11dd70aaca6dbd$export$6803ac54f919d9cc; }, function (v) { return $8b11dd70aaca6dbd$export$6803ac54f919d9cc = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_FROM", function () { return $8b11dd70aaca6dbd$export$72f5b47540331169; }, function (v) { return $8b11dd70aaca6dbd$export$72f5b47540331169 = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TO", function () { return $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb; }, function (v) { return $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TYPE", function () { return $8b11dd70aaca6dbd$export$6b5244c457b68e65; }, function (v) { return $8b11dd70aaca6dbd$export$6b5244c457b68e65 = v; });
$parcel$export(module.exports, "SENTRY_THREAD_ID", function () { return $8b11dd70aaca6dbd$export$b7bd0c9a886f3414; }, function (v) { return $8b11dd70aaca6dbd$export$b7bd0c9a886f3414 = v; });
$parcel$export(module.exports, "SENTRY_TIMESTAMP_SEQUENCE", function () { return $8b11dd70aaca6dbd$export$6b77f2bacac7c93d; }, function (v) { return $8b11dd70aaca6dbd$export$6b77f2bacac7c93d = v; });
$parcel$export(module.exports, "SENTRY_TRACE_LIFECYCLE", function () { return $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea; }, function (v) { return $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea = v; });
$parcel$export(module.exports, "SENTRY_TRACE_PARENT_SPAN_ID", function () { return $8b11dd70aaca6dbd$export$feb4fe753df28a82; }, function (v) { return $8b11dd70aaca6dbd$export$feb4fe753df28a82 = v; });
$parcel$export(module.exports, "SENTRY_TRACE_STATUS", function () { return $8b11dd70aaca6dbd$export$d6267756132e2175; }, function (v) { return $8b11dd70aaca6dbd$export$d6267756132e2175 = v; });
$parcel$export(module.exports, "SENTRY_TRANSACTION", function () { return $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6; }, function (v) { return $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6 = v; });
$parcel$export(module.exports, "SENTRY_USER_EMAIL", function () { return $8b11dd70aaca6dbd$export$5b9a0015e1c530ed; }, function (v) { return $8b11dd70aaca6dbd$export$5b9a0015e1c530ed = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_CITY", function () { return $8b11dd70aaca6dbd$export$8bbff71c84508218; }, function (v) { return $8b11dd70aaca6dbd$export$8bbff71c84508218 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_COUNTRY_CODE", function () { return $8b11dd70aaca6dbd$export$b55aa07a514a2430; }, function (v) { return $8b11dd70aaca6dbd$export$b55aa07a514a2430 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_REGION", function () { return $8b11dd70aaca6dbd$export$9927ad09f7c084dc; }, function (v) { return $8b11dd70aaca6dbd$export$9927ad09f7c084dc = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_SUBDIVISION", function () { return $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6; }, function (v) { return $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6 = v; });
$parcel$export(module.exports, "SENTRY_USER_ID", function () { return $8b11dd70aaca6dbd$export$a10d277c42e6cae3; }, function (v) { return $8b11dd70aaca6dbd$export$a10d277c42e6cae3 = v; });
$parcel$export(module.exports, "SENTRY_USER_IP", function () { return $8b11dd70aaca6dbd$export$cdc0ce5c66182801; }, function (v) { return $8b11dd70aaca6dbd$export$cdc0ce5c66182801 = v; });
$parcel$export(module.exports, "SENTRY_USER_USERNAME", function () { return $8b11dd70aaca6dbd$export$2504d4bd698dd962; }, function (v) { return $8b11dd70aaca6dbd$export$2504d4bd698dd962 = v; });
$parcel$export(module.exports, "SERVER_ADDRESS", function () { return $8b11dd70aaca6dbd$export$9dc86f3b876e96ef; }, function (v) { return $8b11dd70aaca6dbd$export$9dc86f3b876e96ef = v; });
$parcel$export(module.exports, "SERVER_NAME", function () { return $8b11dd70aaca6dbd$export$70ff7865f52549ae; }, function (v) { return $8b11dd70aaca6dbd$export$70ff7865f52549ae = v; });
$parcel$export(module.exports, "SERVER_PORT", function () { return $8b11dd70aaca6dbd$export$f77b53a42be6e6fd; }, function (v) { return $8b11dd70aaca6dbd$export$f77b53a42be6e6fd = v; });
$parcel$export(module.exports, "SERVICE_NAME", function () { return $8b11dd70aaca6dbd$export$818eb7ab11414506; }, function (v) { return $8b11dd70aaca6dbd$export$818eb7ab11414506 = v; });
$parcel$export(module.exports, "SERVICE_VERSION", function () { return $8b11dd70aaca6dbd$export$829ef6b2e59d984d; }, function (v) { return $8b11dd70aaca6dbd$export$829ef6b2e59d984d = v; });
$parcel$export(module.exports, "SESSION_ID", function () { return $8b11dd70aaca6dbd$export$b30f4cb52c088a26; }, function (v) { return $8b11dd70aaca6dbd$export$b30f4cb52c088a26 = v; });
$parcel$export(module.exports, "STALL_PERCENTAGE", function () { return $8b11dd70aaca6dbd$export$335eace0ff1771cd; }, function (v) { return $8b11dd70aaca6dbd$export$335eace0ff1771cd = v; });
$parcel$export(module.exports, "STALL_TOTAL_TIME", function () { return $8b11dd70aaca6dbd$export$374d88a2025416ac; }, function (v) { return $8b11dd70aaca6dbd$export$374d88a2025416ac = v; });
$parcel$export(module.exports, "STATE_TYPE", function () { return $8b11dd70aaca6dbd$export$bb7a91303551eb37; }, function (v) { return $8b11dd70aaca6dbd$export$bb7a91303551eb37 = v; });
$parcel$export(module.exports, "THREAD_ID", function () { return $8b11dd70aaca6dbd$export$f132ea291a7db56b; }, function (v) { return $8b11dd70aaca6dbd$export$f132ea291a7db56b = v; });
$parcel$export(module.exports, "THREAD_NAME", function () { return $8b11dd70aaca6dbd$export$f0abd4170bbd2468; }, function (v) { return $8b11dd70aaca6dbd$export$f0abd4170bbd2468 = v; });
$parcel$export(module.exports, "TIMBER_TAG", function () { return $8b11dd70aaca6dbd$export$50d00a157dc08581; }, function (v) { return $8b11dd70aaca6dbd$export$50d00a157dc08581 = v; });
$parcel$export(module.exports, "TIME_TO_FULL_DISPLAY", function () { return $8b11dd70aaca6dbd$export$484576567a98833f; }, function (v) { return $8b11dd70aaca6dbd$export$484576567a98833f = v; });
$parcel$export(module.exports, "TIME_TO_INITIAL_DISPLAY", function () { return $8b11dd70aaca6dbd$export$ec9e491e475d0c97; }, function (v) { return $8b11dd70aaca6dbd$export$ec9e491e475d0c97 = v; });
$parcel$export(module.exports, "TRANSACTION", function () { return $8b11dd70aaca6dbd$export$a86c59c10992220f; }, function (v) { return $8b11dd70aaca6dbd$export$a86c59c10992220f = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_PATH", function () { return $8b11dd70aaca6dbd$export$e12f06597e992fde; }, function (v) { return $8b11dd70aaca6dbd$export$e12f06597e992fde = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_TYPE", function () { return $8b11dd70aaca6dbd$export$7ec54678ba28ea59; }, function (v) { return $8b11dd70aaca6dbd$export$7ec54678ba28ea59 = v; });
$parcel$export(module.exports, "TTFB", function () { return $8b11dd70aaca6dbd$export$433ba14c16717110; }, function (v) { return $8b11dd70aaca6dbd$export$433ba14c16717110 = v; });
$parcel$export(module.exports, "TTFB_REQUESTTIME", function () { return $8b11dd70aaca6dbd$export$309ee349b8a537f; }, function (v) { return $8b11dd70aaca6dbd$export$309ee349b8a537f = v; });
$parcel$export(module.exports, "TYPE", function () { return $8b11dd70aaca6dbd$export$b87f371cbc396fcf; }, function (v) { return $8b11dd70aaca6dbd$export$b87f371cbc396fcf = v; });
$parcel$export(module.exports, "UI_COMPONENT_NAME", function () { return $8b11dd70aaca6dbd$export$60050fc49fe0e7e2; }, function (v) { return $8b11dd70aaca6dbd$export$60050fc49fe0e7e2 = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTFD", function () { return $8b11dd70aaca6dbd$export$348c8e2b37f276cd; }, function (v) { return $8b11dd70aaca6dbd$export$348c8e2b37f276cd = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTID", function () { return $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2; }, function (v) { return $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2 = v; });
$parcel$export(module.exports, "UI_ELEMENT_HEIGHT", function () { return $8b11dd70aaca6dbd$export$50d5adc4b543ce95; }, function (v) { return $8b11dd70aaca6dbd$export$50d5adc4b543ce95 = v; });
$parcel$export(module.exports, "UI_ELEMENT_ID", function () { return $8b11dd70aaca6dbd$export$9221f1d2c934d9f; }, function (v) { return $8b11dd70aaca6dbd$export$9221f1d2c934d9f = v; });
$parcel$export(module.exports, "UI_ELEMENT_IDENTIFIER", function () { return $8b11dd70aaca6dbd$export$3a56578b3ae09a02; }, function (v) { return $8b11dd70aaca6dbd$export$3a56578b3ae09a02 = v; });
$parcel$export(module.exports, "UI_ELEMENT_LOAD_TIME", function () { return $8b11dd70aaca6dbd$export$e47b8dab9466c895; }, function (v) { return $8b11dd70aaca6dbd$export$e47b8dab9466c895 = v; });
$parcel$export(module.exports, "UI_ELEMENT_PAINT_TYPE", function () { return $8b11dd70aaca6dbd$export$4ca52f75cf4889c5; }, function (v) { return $8b11dd70aaca6dbd$export$4ca52f75cf4889c5 = v; });
$parcel$export(module.exports, "UI_ELEMENT_RENDER_TIME", function () { return $8b11dd70aaca6dbd$export$7343d7d72195067f; }, function (v) { return $8b11dd70aaca6dbd$export$7343d7d72195067f = v; });
$parcel$export(module.exports, "UI_ELEMENT_TYPE", function () { return $8b11dd70aaca6dbd$export$f334f32f8d4d8063; }, function (v) { return $8b11dd70aaca6dbd$export$f334f32f8d4d8063 = v; });
$parcel$export(module.exports, "UI_ELEMENT_URL", function () { return $8b11dd70aaca6dbd$export$c7bf2089e89a217c; }, function (v) { return $8b11dd70aaca6dbd$export$c7bf2089e89a217c = v; });
$parcel$export(module.exports, "UI_ELEMENT_WIDTH", function () { return $8b11dd70aaca6dbd$export$f514f97553a434b2; }, function (v) { return $8b11dd70aaca6dbd$export$f514f97553a434b2 = v; });
$parcel$export(module.exports, "URL", function () { return $8b11dd70aaca6dbd$export$61abde59b50deb8e; }, function (v) { return $8b11dd70aaca6dbd$export$61abde59b50deb8e = v; });
$parcel$export(module.exports, "URL_DOMAIN", function () { return $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93; }, function (v) { return $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93 = v; });
$parcel$export(module.exports, "URL_FRAGMENT", function () { return $8b11dd70aaca6dbd$export$7044ea8d89b6f59d; }, function (v) { return $8b11dd70aaca6dbd$export$7044ea8d89b6f59d = v; });
$parcel$export(module.exports, "URL_FULL", function () { return $8b11dd70aaca6dbd$export$40eacf1a072c9dbd; }, function (v) { return $8b11dd70aaca6dbd$export$40eacf1a072c9dbd = v; });
$parcel$export(module.exports, "URL_PATH", function () { return $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac; }, function (v) { return $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY", function () { return $8b11dd70aaca6dbd$export$5bee9450fe31dde1; }, function (v) { return $8b11dd70aaca6dbd$export$5bee9450fe31dde1 = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY_BASE", function () { return $8b11dd70aaca6dbd$export$d0b571fb4406d953; }, function (v) { return $8b11dd70aaca6dbd$export$d0b571fb4406d953 = v; });
$parcel$export(module.exports, "URL_PORT", function () { return $8b11dd70aaca6dbd$export$258b370e6c2b85d5; }, function (v) { return $8b11dd70aaca6dbd$export$258b370e6c2b85d5 = v; });
$parcel$export(module.exports, "URL_QUERY", function () { return $8b11dd70aaca6dbd$export$dc5e5523da291a4b; }, function (v) { return $8b11dd70aaca6dbd$export$dc5e5523da291a4b = v; });
$parcel$export(module.exports, "URL_SAME_ORIGIN", function () { return $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0; }, function (v) { return $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0 = v; });
$parcel$export(module.exports, "URL_SCHEME", function () { return $8b11dd70aaca6dbd$export$1350d8937b0f26fb; }, function (v) { return $8b11dd70aaca6dbd$export$1350d8937b0f26fb = v; });
$parcel$export(module.exports, "URL_TEMPLATE", function () { return $8b11dd70aaca6dbd$export$2a045f777fb349a8; }, function (v) { return $8b11dd70aaca6dbd$export$2a045f777fb349a8 = v; });
$parcel$export(module.exports, "USER_AGENT_ORIGINAL", function () { return $8b11dd70aaca6dbd$export$8bb874585539a88f; }, function (v) { return $8b11dd70aaca6dbd$export$8bb874585539a88f = v; });
$parcel$export(module.exports, "USER_EMAIL", function () { return $8b11dd70aaca6dbd$export$17d3a50785727199; }, function (v) { return $8b11dd70aaca6dbd$export$17d3a50785727199 = v; });
$parcel$export(module.exports, "USER_FULL_NAME", function () { return $8b11dd70aaca6dbd$export$2931c570009689e; }, function (v) { return $8b11dd70aaca6dbd$export$2931c570009689e = v; });
$parcel$export(module.exports, "USER_GEO_CITY", function () { return $8b11dd70aaca6dbd$export$199cbcedee735a43; }, function (v) { return $8b11dd70aaca6dbd$export$199cbcedee735a43 = v; });
$parcel$export(module.exports, "USER_GEO_COUNTRY_CODE", function () { return $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862; }, function (v) { return $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862 = v; });
$parcel$export(module.exports, "USER_GEO_REGION", function () { return $8b11dd70aaca6dbd$export$674c01ec2f0b89c3; }, function (v) { return $8b11dd70aaca6dbd$export$674c01ec2f0b89c3 = v; });
$parcel$export(module.exports, "USER_GEO_SUBDIVISION", function () { return $8b11dd70aaca6dbd$export$bda1686739fd61c7; }, function (v) { return $8b11dd70aaca6dbd$export$bda1686739fd61c7 = v; });
$parcel$export(module.exports, "USER_HASH", function () { return $8b11dd70aaca6dbd$export$8d804148f485d54c; }, function (v) { return $8b11dd70aaca6dbd$export$8d804148f485d54c = v; });
$parcel$export(module.exports, "USER_ID", function () { return $8b11dd70aaca6dbd$export$212a8f1ea37518bd; }, function (v) { return $8b11dd70aaca6dbd$export$212a8f1ea37518bd = v; });
$parcel$export(module.exports, "USER_IP_ADDRESS", function () { return $8b11dd70aaca6dbd$export$c9ac0fee28245883; }, function (v) { return $8b11dd70aaca6dbd$export$c9ac0fee28245883 = v; });
$parcel$export(module.exports, "USER_NAME", function () { return $8b11dd70aaca6dbd$export$77078610759fe5f6; }, function (v) { return $8b11dd70aaca6dbd$export$77078610759fe5f6 = v; });
$parcel$export(module.exports, "USER_ROLES", function () { return $8b11dd70aaca6dbd$export$7c6317deeec7a6c1; }, function (v) { return $8b11dd70aaca6dbd$export$7c6317deeec7a6c1 = v; });
$parcel$export(module.exports, "VERCEL_BRANCH", function () { return $8b11dd70aaca6dbd$export$877ebf2e4ad81f03; }, function (v) { return $8b11dd70aaca6dbd$export$877ebf2e4ad81f03 = v; });
$parcel$export(module.exports, "VERCEL_BUILD_ID", function () { return $8b11dd70aaca6dbd$export$70b2343945496e1f; }, function (v) { return $8b11dd70aaca6dbd$export$70b2343945496e1f = v; });
$parcel$export(module.exports, "VERCEL_DEPLOYMENT_ID", function () { return $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d; }, function (v) { return $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d = v; });
$parcel$export(module.exports, "VERCEL_DESTINATION", function () { return $8b11dd70aaca6dbd$export$cc81114a03caab18; }, function (v) { return $8b11dd70aaca6dbd$export$cc81114a03caab18 = v; });
$parcel$export(module.exports, "VERCEL_EDGE_TYPE", function () { return $8b11dd70aaca6dbd$export$bc14eb892daceb23; }, function (v) { return $8b11dd70aaca6dbd$export$bc14eb892daceb23 = v; });
$parcel$export(module.exports, "VERCEL_ENTRYPOINT", function () { return $8b11dd70aaca6dbd$export$3c973217450c3e9d; }, function (v) { return $8b11dd70aaca6dbd$export$3c973217450c3e9d = v; });
$parcel$export(module.exports, "VERCEL_EXECUTION_REGION", function () { return $8b11dd70aaca6dbd$export$582c0b730ff1ddb9; }, function (v) { return $8b11dd70aaca6dbd$export$582c0b730ff1ddb9 = v; });
$parcel$export(module.exports, "VERCEL_ID", function () { return $8b11dd70aaca6dbd$export$b3edfb545b65f1c5; }, function (v) { return $8b11dd70aaca6dbd$export$b3edfb545b65f1c5 = v; });
$parcel$export(module.exports, "VERCEL_JA3_DIGEST", function () { return $8b11dd70aaca6dbd$export$2593317d8731841c; }, function (v) { return $8b11dd70aaca6dbd$export$2593317d8731841c = v; });
$parcel$export(module.exports, "VERCEL_JA4_DIGEST", function () { return $8b11dd70aaca6dbd$export$8bb5bc1732aa41f; }, function (v) { return $8b11dd70aaca6dbd$export$8bb5bc1732aa41f = v; });
$parcel$export(module.exports, "VERCEL_LOG_TYPE", function () { return $8b11dd70aaca6dbd$export$74a79c98b110b5b9; }, function (v) { return $8b11dd70aaca6dbd$export$74a79c98b110b5b9 = v; });
$parcel$export(module.exports, "VERCEL_PATH", function () { return $8b11dd70aaca6dbd$export$26461b03281b4db4; }, function (v) { return $8b11dd70aaca6dbd$export$26461b03281b4db4 = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_ID", function () { return $8b11dd70aaca6dbd$export$eaea590d6d3dd93c; }, function (v) { return $8b11dd70aaca6dbd$export$eaea590d6d3dd93c = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_NAME", function () { return $8b11dd70aaca6dbd$export$af45365f70099379; }, function (v) { return $8b11dd70aaca6dbd$export$af45365f70099379 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CACHE_ID", function () { return $8b11dd70aaca6dbd$export$a49e732d34d5ba9b; }, function (v) { return $8b11dd70aaca6dbd$export$a49e732d34d5ba9b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CLIENT_IP", function () { return $8b11dd70aaca6dbd$export$7c147fe246bc8bd3; }, function (v) { return $8b11dd70aaca6dbd$export$7c147fe246bc8bd3 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_HOST", function () { return $8b11dd70aaca6dbd$export$e5111b6070e1ee9e; }, function (v) { return $8b11dd70aaca6dbd$export$e5111b6070e1ee9e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_LAMBDA_REGION", function () { return $8b11dd70aaca6dbd$export$591cbfd403f8c8d; }, function (v) { return $8b11dd70aaca6dbd$export$591cbfd403f8c8d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_METHOD", function () { return $8b11dd70aaca6dbd$export$b1388db955bbb885; }, function (v) { return $8b11dd70aaca6dbd$export$b1388db955bbb885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH", function () { return $8b11dd70aaca6dbd$export$e898d0e9e211abd9; }, function (v) { return $8b11dd70aaca6dbd$export$e898d0e9e211abd9 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE", function () { return $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069; }, function (v) { return $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE_VARIANT", function () { return $8b11dd70aaca6dbd$export$9786ad94c199ffbb; }, function (v) { return $8b11dd70aaca6dbd$export$9786ad94c199ffbb = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REFERER", function () { return $8b11dd70aaca6dbd$export$269890524eed693b; }, function (v) { return $8b11dd70aaca6dbd$export$269890524eed693b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REGION", function () { return $8b11dd70aaca6dbd$export$2ec623a8212d6b64; }, function (v) { return $8b11dd70aaca6dbd$export$2ec623a8212d6b64 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_RESPONSE_BYTE_SIZE", function () { return $8b11dd70aaca6dbd$export$30e7673b01ff994e; }, function (v) { return $8b11dd70aaca6dbd$export$30e7673b01ff994e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_SCHEME", function () { return $8b11dd70aaca6dbd$export$9ea93477840812bf; }, function (v) { return $8b11dd70aaca6dbd$export$9ea93477840812bf = v; });
$parcel$export(module.exports, "VERCEL_PROXY_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$a6da0c365670c430; }, function (v) { return $8b11dd70aaca6dbd$export$a6da0c365670c430 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_TIMESTAMP", function () { return $8b11dd70aaca6dbd$export$7986b22da43f2885; }, function (v) { return $8b11dd70aaca6dbd$export$7986b22da43f2885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_USER_AGENT", function () { return $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f; }, function (v) { return $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_CACHE", function () { return $8b11dd70aaca6dbd$export$dfe49501efcdffce; }, function (v) { return $8b11dd70aaca6dbd$export$dfe49501efcdffce = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_ID", function () { return $8b11dd70aaca6dbd$export$be465f50c92eb01d; }, function (v) { return $8b11dd70aaca6dbd$export$be465f50c92eb01d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_ACTION", function () { return $8b11dd70aaca6dbd$export$c138d1796bb34999; }, function (v) { return $8b11dd70aaca6dbd$export$c138d1796bb34999 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_RULE_ID", function () { return $8b11dd70aaca6dbd$export$85a0016690a0ccf2; }, function (v) { return $8b11dd70aaca6dbd$export$85a0016690a0ccf2 = v; });
$parcel$export(module.exports, "VERCEL_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$883acab36ede4bfa; }, function (v) { return $8b11dd70aaca6dbd$export$883acab36ede4bfa = v; });
$parcel$export(module.exports, "VERCEL_SOURCE", function () { return $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1; }, function (v) { return $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1 = v; });
$parcel$export(module.exports, "VERCEL_STATUS_CODE", function () { return $8b11dd70aaca6dbd$export$b3c6c599110d7bab; }, function (v) { return $8b11dd70aaca6dbd$export$b3c6c599110d7bab = v; });
$parcel$export(module.exports, "_AWS_KINESIS_STREAM_NAME", function () { return $8b11dd70aaca6dbd$export$247839c65766758; }, function (v) { return $8b11dd70aaca6dbd$export$247839c65766758 = v; });
$parcel$export(module.exports, "_AWS_REQUEST_ID", function () { return $8b11dd70aaca6dbd$export$f4d52b02df927d54; }, function (v) { return $8b11dd70aaca6dbd$export$f4d52b02df927d54 = v; });
$parcel$export(module.exports, "_HTTP_REQUEST_METHOD", function () { return $8b11dd70aaca6dbd$export$df30ee8c5b5f1989; }, function (v) { return $8b11dd70aaca6dbd$export$df30ee8c5b5f1989 = v; });
$parcel$export(module.exports, "_SENTRY_SEGMENT_ID", function () { return $8b11dd70aaca6dbd$export$268a117c860fca6d; }, function (v) { return $8b11dd70aaca6dbd$export$268a117c860fca6d = v; });
var $8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd;
var $8b11dd70aaca6dbd$export$cc06afd6de7f2c10;
var $8b11dd70aaca6dbd$export$ced6746028fe2cc;
var $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8;
var $8b11dd70aaca6dbd$export$f02d892201cd8d36;
var $8b11dd70aaca6dbd$export$f277a7ef9e273960;
var $8b11dd70aaca6dbd$export$1a8c212c3becaa80;
var $8b11dd70aaca6dbd$export$721b137086c68a47;
var $8b11dd70aaca6dbd$export$6afde2bb69d9aa86;
var $8b11dd70aaca6dbd$export$eadb4b562c974031;
var $8b11dd70aaca6dbd$export$22a90f0ac1eee843;
var $8b11dd70aaca6dbd$export$a727f215a0be1dad;
var $8b11dd70aaca6dbd$export$536bc61b34d995e5;
var $8b11dd70aaca6dbd$export$c43ea6115b380e62;
var $8b11dd70aaca6dbd$export$d2a16e26bada7cf1;
var $8b11dd70aaca6dbd$export$604eb1bd2278163b;
var $8b11dd70aaca6dbd$export$2f8568696c5aa352;
var $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9;
var $8b11dd70aaca6dbd$export$e176bf5dc45e40df;
var $8b11dd70aaca6dbd$export$c4ea01fd53f64e16;
var $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9;
var $8b11dd70aaca6dbd$export$1762c11b666b026a;
var $8b11dd70aaca6dbd$export$14ddd4b729910100;
var $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb;
var $8b11dd70aaca6dbd$export$2b748b9eca00828b;
var $8b11dd70aaca6dbd$export$5af25308c11addea;
var $8b11dd70aaca6dbd$export$28f78b3b1663cb92;
var $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f;
var $8b11dd70aaca6dbd$export$322bd4ea9f163663;
var $8b11dd70aaca6dbd$export$95711b9e669edad8;
var $8b11dd70aaca6dbd$export$5924d7d72384626a;
var $8b11dd70aaca6dbd$export$db3b1b877a4ce4db;
var $8b11dd70aaca6dbd$export$a434a3e8afec2879;
var $8b11dd70aaca6dbd$export$fe00bb20636d42af;
var $8b11dd70aaca6dbd$export$712aa698b7ee271e;
var $8b11dd70aaca6dbd$export$1fac638b11ec16d9;
var $8b11dd70aaca6dbd$export$d132016ea64058e3;
var $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed;
var $8b11dd70aaca6dbd$export$9f80c4b11053cef1;
var $8b11dd70aaca6dbd$export$5f7a08466d84e877;
var $8b11dd70aaca6dbd$export$2cea7f14750b8c19;
var $8b11dd70aaca6dbd$export$34c59270f032a6c6;
var $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7;
var $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50;
var $8b11dd70aaca6dbd$export$ba267414e3c0d822;
var $8b11dd70aaca6dbd$export$71b176005902b99e;
var $8b11dd70aaca6dbd$export$5c5b5a3c245a0079;
var $8b11dd70aaca6dbd$export$8ee1df3c6367a60;
var $8b11dd70aaca6dbd$export$e8c7802ae95beccf;
var $8b11dd70aaca6dbd$export$bb237734da4d464;
var $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6;
var $8b11dd70aaca6dbd$export$36223ebd4a30e9f5;
var $8b11dd70aaca6dbd$export$8feaa177bb7941e2;
var $8b11dd70aaca6dbd$export$e1ca25240db91d68;
var $8b11dd70aaca6dbd$export$404a223fd1ada08b;
var $8b11dd70aaca6dbd$export$53362079310c68;
var $8b11dd70aaca6dbd$export$3efb5af0ac379f77;
var $8b11dd70aaca6dbd$export$2c10c1ca0612c46d;
var $8b11dd70aaca6dbd$export$bbb86ad4d6654da6;
var $8b11dd70aaca6dbd$export$ad6896f00a2b1076;
var $8b11dd70aaca6dbd$export$300f39d8506a273d;
var $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7;
var $8b11dd70aaca6dbd$export$74b78acb4c54c06b;
var $8b11dd70aaca6dbd$export$b15b2c133bc50e33;
var $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95;
var $8b11dd70aaca6dbd$export$c170b7ff277132ea;
var $8b11dd70aaca6dbd$export$9459a5df93695e45;
var $8b11dd70aaca6dbd$export$a7902bd57492ebe8;
var $8b11dd70aaca6dbd$export$d2ace0da59da09b7;
var $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb;
var $8b11dd70aaca6dbd$export$5405b0a98e00e538;
var $8b11dd70aaca6dbd$export$bd393bbb84b309d3;
var $8b11dd70aaca6dbd$export$96f586f8837b86ae;
var $8b11dd70aaca6dbd$export$5d9f28f388f552d2;
var $8b11dd70aaca6dbd$export$b3d2f68e0e769504;
var $8b11dd70aaca6dbd$export$2c98412ed43013e8;
var $8b11dd70aaca6dbd$export$a7bd794d11c19f1b;
var $8b11dd70aaca6dbd$export$df4227832b83fdd0;
var $8b11dd70aaca6dbd$export$f131a6d8fbc0534f;
var $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a;
var $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98;
var $8b11dd70aaca6dbd$export$3565fa72459aa4d6;
var $8b11dd70aaca6dbd$export$bb67a834ae4bffdc;
var $8b11dd70aaca6dbd$export$4a06c859a283f06;
var $8b11dd70aaca6dbd$export$68324fac2038d0f2;
var $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb;
var $8b11dd70aaca6dbd$export$bfdf2261058f56b;
var $8b11dd70aaca6dbd$export$23bf57842d9d53df;
var $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35;
var $8b11dd70aaca6dbd$export$82eb6cccda27c3ff;
var $8b11dd70aaca6dbd$export$8ea68734d455808f;
var $8b11dd70aaca6dbd$export$40050e29324d44ee;
var $8b11dd70aaca6dbd$export$5cd7541006d9f467;
var $8b11dd70aaca6dbd$export$81c017edd95d692e;
var $8b11dd70aaca6dbd$export$120b3897a58cf903;
var $8b11dd70aaca6dbd$export$d4a9de43b4b1076c;
var $8b11dd70aaca6dbd$export$f37f4f9022f1ab17;
var $8b11dd70aaca6dbd$export$66ac18da14747cfb;
var $8b11dd70aaca6dbd$export$9e49b833525ca49d;
var $8b11dd70aaca6dbd$export$b084fea5b3097227;
var $8b11dd70aaca6dbd$export$e09cd8615652e8d0;
var $8b11dd70aaca6dbd$export$a43a60ec723a90ee;
var $8b11dd70aaca6dbd$export$34cc955357266287;
var $8b11dd70aaca6dbd$export$d9dd218693ea9bba;
var $8b11dd70aaca6dbd$export$c9649b7156282a2f;
var $8b11dd70aaca6dbd$export$daa8ce1f8adc553e;
var $8b11dd70aaca6dbd$export$cb93c7b05db202cf;
var $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d;
var $8b11dd70aaca6dbd$export$48c6d4c44afdc0b;
var $8b11dd70aaca6dbd$export$c78d41789fe4b1e4;
var $8b11dd70aaca6dbd$export$f462d9921f1f7332;
var $8b11dd70aaca6dbd$export$bc71f8df9a45e243;
var $8b11dd70aaca6dbd$export$ed840ec4a5f5d053;
var $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e;
var $8b11dd70aaca6dbd$export$d1c007424092e3f5;
var $8b11dd70aaca6dbd$export$9ebb466ce954c49c;
var $8b11dd70aaca6dbd$export$e9aafc7348984403;
var $8b11dd70aaca6dbd$export$faaa46964f075237;
var $8b11dd70aaca6dbd$export$d28c4b3cc4431a87;
var $8b11dd70aaca6dbd$export$734b017b330c8fe6;
var $8b11dd70aaca6dbd$export$683ebdc48ba3758d;
var $8b11dd70aaca6dbd$export$be0263971250ef44;
var $8b11dd70aaca6dbd$export$36a0cbc35c405232;
var $8b11dd70aaca6dbd$export$469f7765ba335497;
var $8b11dd70aaca6dbd$export$fe6fe2b7af051610;
var $8b11dd70aaca6dbd$export$8345821877c4dfad;
var $8b11dd70aaca6dbd$export$f6c188a7e02335cf;
var $8b11dd70aaca6dbd$export$aaf709a8971e825f;
var $8b11dd70aaca6dbd$export$def01b82f8c092f7;
var $8b11dd70aaca6dbd$export$23d4264c606a73a6;
var $8b11dd70aaca6dbd$export$af9ece53bb92f66b;
var $8b11dd70aaca6dbd$export$25421625a565b69;
var $8b11dd70aaca6dbd$export$ab0c90d873e69ccb;
var $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb;
var $8b11dd70aaca6dbd$export$f86df4de196e1a7c;
var $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8;
var $8b11dd70aaca6dbd$export$99023486ecc470bd;
var $8b11dd70aaca6dbd$export$2f6c85eaf382e81;
var $8b11dd70aaca6dbd$export$1158d57c0aed42be;
var $8b11dd70aaca6dbd$export$d85c4f947ab776e3;
var $8b11dd70aaca6dbd$export$813ef8386d874918;
var $8b11dd70aaca6dbd$export$7c2f74ff9251f64;
var $8b11dd70aaca6dbd$export$993f84dab107b880;
var $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f;
var $8b11dd70aaca6dbd$export$f01e5cd42b9ec146;
var $8b11dd70aaca6dbd$export$987f6b4367434b55;
var $8b11dd70aaca6dbd$export$d9d145585d5022bb;
var $8b11dd70aaca6dbd$export$44ffba16bd48dac6;
var $8b11dd70aaca6dbd$export$3134892c5d2e251a;
var $8b11dd70aaca6dbd$export$8495028d10296058;
var $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c;
var $8b11dd70aaca6dbd$export$658dced473c19301;
var $8b11dd70aaca6dbd$export$97b0f9c3fbe64076;
var $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb;
var $8b11dd70aaca6dbd$export$880007904f61a388;
var $8b11dd70aaca6dbd$export$3e903b72d4d9e07d;
var $8b11dd70aaca6dbd$export$34da07180e0e56af;
var $8b11dd70aaca6dbd$export$c49aafdaeb061953;
var $8b11dd70aaca6dbd$export$ceb762c61de2f17f;
var $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf;
var $8b11dd70aaca6dbd$export$1c86a56857b024db;
var $8b11dd70aaca6dbd$export$7598f3464be47440;
var $8b11dd70aaca6dbd$export$b673289c971fc0ae;
var $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f;
var $8b11dd70aaca6dbd$export$6ddeaf0498614ebb;
var $8b11dd70aaca6dbd$export$97b78f78d64a7232;
var $8b11dd70aaca6dbd$export$5147715be870fff7;
var $8b11dd70aaca6dbd$export$5276bb46e6096fba;
var $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3;
var $8b11dd70aaca6dbd$export$226a2381b8f0cf78;
var $8b11dd70aaca6dbd$export$fd35512cae286064;
var $8b11dd70aaca6dbd$export$de9bbf95ab1d81e;
var $8b11dd70aaca6dbd$export$47fb20e8d18d7d15;
var $8b11dd70aaca6dbd$export$9db7964e4b8cb849;
var $8b11dd70aaca6dbd$export$7139adf9d3bace41;
var $8b11dd70aaca6dbd$export$8ac3d09060e7f25d;
var $8b11dd70aaca6dbd$export$dad0e4778ea23971;
var $8b11dd70aaca6dbd$export$c14d903ccf9385a8;
var $8b11dd70aaca6dbd$export$934cded0041affd7;
var $8b11dd70aaca6dbd$export$6386da1dcba88c9d;
var $8b11dd70aaca6dbd$export$a3371797e606e2;
var $8b11dd70aaca6dbd$export$a5bbef0af83b23e5;
var $8b11dd70aaca6dbd$export$91ed1f55874222a6;
var $8b11dd70aaca6dbd$export$23de81068d2aed1b;
var $8b11dd70aaca6dbd$export$d738320e1fba9e9d;
var $8b11dd70aaca6dbd$export$2eacdea75497e8a5;
var $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2;
var $8b11dd70aaca6dbd$export$c54e27e8d90ee081;
var $8b11dd70aaca6dbd$export$4943adcec371c2a6;
var $8b11dd70aaca6dbd$export$f000a5900d0480c2;
var $8b11dd70aaca6dbd$export$8f5234893868273b;
var $8b11dd70aaca6dbd$export$1a35518f6e81e8c7;
var $8b11dd70aaca6dbd$export$a2d90911eaae60fc;
var $8b11dd70aaca6dbd$export$3c22ff8b64b8f565;
var $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f;
var $8b11dd70aaca6dbd$export$8c11477e471467c8;
var $8b11dd70aaca6dbd$export$92a96f6363488aee;
var $8b11dd70aaca6dbd$export$f91beb6088f9ded9;
var $8b11dd70aaca6dbd$export$78bc7224576bf289;
var $8b11dd70aaca6dbd$export$a8027e0ea0d93ca;
var $8b11dd70aaca6dbd$export$5e59d3aea52e5037;
var $8b11dd70aaca6dbd$export$47e408be0da7933f;
var $8b11dd70aaca6dbd$export$d5772b934ca13e57;
var $8b11dd70aaca6dbd$export$36e47f6a5777561d;
var $8b11dd70aaca6dbd$export$e768cbc99cd68acf;
var $8b11dd70aaca6dbd$export$dfcc6c69df1343f2;
var $8b11dd70aaca6dbd$export$69b0a5d9226b5211;
var $8b11dd70aaca6dbd$export$da010a4f4fc971ae;
var $8b11dd70aaca6dbd$export$5d515b35be0601a0;
var $8b11dd70aaca6dbd$export$3e1b1037a315c5ca;
var $8b11dd70aaca6dbd$export$847fdd494825f0fb;
var $8b11dd70aaca6dbd$export$a9d76f26c6c730a9;
var $8b11dd70aaca6dbd$export$de03f86d1c9866ca;
var $8b11dd70aaca6dbd$export$65798ecab7eef8c;
var $8b11dd70aaca6dbd$export$22aa61f48b9c79a0;
var $8b11dd70aaca6dbd$export$69f5fb98f5aed812;
var $8b11dd70aaca6dbd$export$bdea5d1006fd280a;
var $8b11dd70aaca6dbd$export$f63a7230c5b1d609;
var $8b11dd70aaca6dbd$export$6f25e59b05bb8e17;
var $8b11dd70aaca6dbd$export$a56ad13c4afc7421;
var $8b11dd70aaca6dbd$export$d9ce89ce8912bf12;
var $8b11dd70aaca6dbd$export$17094e5f380e4162;
var $8b11dd70aaca6dbd$export$28a0ffdf747973a0;
var $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9;
var $8b11dd70aaca6dbd$export$edc72ee4a17f5152;
var $8b11dd70aaca6dbd$export$19e4df138d354f8b;
var $8b11dd70aaca6dbd$export$92b0d20fa482b4b2;
var $8b11dd70aaca6dbd$export$3f638a793d61933f;
var $8b11dd70aaca6dbd$export$3f511731cc3687d4;
var $8b11dd70aaca6dbd$export$692b08741d6b6265;
var $8b11dd70aaca6dbd$export$cf67f8cb2324428e;
var $8b11dd70aaca6dbd$export$9d4197c1ffc5f359;
var $8b11dd70aaca6dbd$export$509634fbff540e75;
var $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5;
var $8b11dd70aaca6dbd$export$e0cb371ca548b1d6;
var $8b11dd70aaca6dbd$export$3c39026d09026bc2;
var $8b11dd70aaca6dbd$export$bf9e8248cb72cf00;
var $8b11dd70aaca6dbd$export$1054f22a72121d0f;
var $8b11dd70aaca6dbd$export$723b8a59dad2e467;
var $8b11dd70aaca6dbd$export$160081ff141bac8e;
var $8b11dd70aaca6dbd$export$194f62c84d27310;
var $8b11dd70aaca6dbd$export$7ed866d57b018d09;
var $8b11dd70aaca6dbd$export$d50bae4562e03e5;
var $8b11dd70aaca6dbd$export$649ea67a18fe8e8b;
var $8b11dd70aaca6dbd$export$136a5c1b43caaccd;
var $8b11dd70aaca6dbd$export$e33a28ea554b6ddc;
var $8b11dd70aaca6dbd$export$acbe2d25ac76ea64;
var $8b11dd70aaca6dbd$export$793c13e17d7e5e2b;
var $8b11dd70aaca6dbd$export$a5617e33b89fd956;
var $8b11dd70aaca6dbd$export$b51f82164fa31e07;
var $8b11dd70aaca6dbd$export$f2ef55183c04d202;
var $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c;
var $8b11dd70aaca6dbd$export$f0511e328234ae83;
var $8b11dd70aaca6dbd$export$be46596bc6608f3b;
var $8b11dd70aaca6dbd$export$f215947b3d76a6b7;
var $8b11dd70aaca6dbd$export$89bbc91416db6670;
var $8b11dd70aaca6dbd$export$b4b5eff8a8712c89;
var $8b11dd70aaca6dbd$export$f455969a57ab8a03;
var $8b11dd70aaca6dbd$export$13f2f8f42af49cec;
var $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3;
var $8b11dd70aaca6dbd$export$d9ca2a279a11be5e;
var $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9;
var $8b11dd70aaca6dbd$export$8413282a17f1cda5;
var $8b11dd70aaca6dbd$export$30d19ddc7705e7e8;
var $8b11dd70aaca6dbd$export$64a4f09e2444b3d;
var $8b11dd70aaca6dbd$export$645b039fe163809e;
var $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1;
var $8b11dd70aaca6dbd$export$8bf64516740c1369;
var $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b;
var $8b11dd70aaca6dbd$export$abe90fedb3dddda2;
var $8b11dd70aaca6dbd$export$4a19da9c85ed2ade;
var $8b11dd70aaca6dbd$export$5e091479f094bdbc;
var $8b11dd70aaca6dbd$export$d70909b5aa96a79a;
var $8b11dd70aaca6dbd$export$651d142a8017d83d;
var $8b11dd70aaca6dbd$export$44382a010a9f7fcf;
var $8b11dd70aaca6dbd$export$807abfdc6b7b9338;
var $8b11dd70aaca6dbd$export$31881d07f2569218;
var $8b11dd70aaca6dbd$export$e5bbf306deb709a6;
var $8b11dd70aaca6dbd$export$aa8721167c5c8d2d;
var $8b11dd70aaca6dbd$export$757b93e5b3adc7cb;
var $8b11dd70aaca6dbd$export$f869eaa92db1dc9b;
var $8b11dd70aaca6dbd$export$5d1d761e41c32d9e;
var $8b11dd70aaca6dbd$export$8aec72d9491f9399;
var $8b11dd70aaca6dbd$export$5562635d2be2ab25;
var $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d;
var $8b11dd70aaca6dbd$export$b561df15f64d32e3;
var $8b11dd70aaca6dbd$export$181f78b28f2ffa57;
var $8b11dd70aaca6dbd$export$6c97c77b89571c75;
var $8b11dd70aaca6dbd$export$51e431eaf1f9bf58;
var $8b11dd70aaca6dbd$export$71429c7ef7cb7063;
var $8b11dd70aaca6dbd$export$99905d7583a6e8ac;
var $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd;
var $8b11dd70aaca6dbd$export$fd23e5b8d261a89;
var $8b11dd70aaca6dbd$export$25fabc9b3d1dd567;
var $8b11dd70aaca6dbd$export$41507f7b07dad151;
var $8b11dd70aaca6dbd$export$1352f3699c35dd73;
var $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac;
var $8b11dd70aaca6dbd$export$c29634e3cf41e479;
var $8b11dd70aaca6dbd$export$e6a60882cce7a085;
var $8b11dd70aaca6dbd$export$6773c9098ba5e194;
var $8b11dd70aaca6dbd$export$6ee6b62f50047686;
var $8b11dd70aaca6dbd$export$efac052bb3661242;
var $8b11dd70aaca6dbd$export$7ccd63b9ca955862;
var $8b11dd70aaca6dbd$export$50921df5a58cb3ef;
var $8b11dd70aaca6dbd$export$8e48efc7acb57a97;
var $8b11dd70aaca6dbd$export$cea9121727113f77;
var $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa;
var $8b11dd70aaca6dbd$export$6b729e898b9067ce;
var $8b11dd70aaca6dbd$export$984fbab9b52f7e24;
var $8b11dd70aaca6dbd$export$9ea17906a87ada6f;
var $8b11dd70aaca6dbd$export$394b443aaff3ef92;
var $8b11dd70aaca6dbd$export$6ddc374adbc06720;
var $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2;
var $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee;
var $8b11dd70aaca6dbd$export$86a8df7fff52fc69;
var $8b11dd70aaca6dbd$export$cf2115d46768f4c5;
var $8b11dd70aaca6dbd$export$3d7e036e195764db;
var $8b11dd70aaca6dbd$export$60c1d11221608cee;
var $8b11dd70aaca6dbd$export$bc3cef164abbc42c;
var $8b11dd70aaca6dbd$export$43f9afb62cd79dec;
var $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f;
var $8b11dd70aaca6dbd$export$ccf46db9ab1743ec;
var $8b11dd70aaca6dbd$export$76c1c247342d776;
var $8b11dd70aaca6dbd$export$92f5944f0b02c9fb;
var $8b11dd70aaca6dbd$export$867eeefcb1c95b27;
var $8b11dd70aaca6dbd$export$5ada4697ae6aa17e;
var $8b11dd70aaca6dbd$export$427122300e8d54d0;
var $8b11dd70aaca6dbd$export$bcea8881375c352f;
var $8b11dd70aaca6dbd$export$b867715f9a0c04e9;
var $8b11dd70aaca6dbd$export$69878a39cbdbe097;
var $8b11dd70aaca6dbd$export$584c61a1b769552d;
var $8b11dd70aaca6dbd$export$8169ebcb0b0331dd;
var $8b11dd70aaca6dbd$export$2c9713b624877853;
var $8b11dd70aaca6dbd$export$45942692aeb454e0;
var $8b11dd70aaca6dbd$export$8e5efeaa031210cd;
var $8b11dd70aaca6dbd$export$35a62769ee05a05a;
var $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06;
var $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4;
var $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67;
var $8b11dd70aaca6dbd$export$352a8075b163d53;
var $8b11dd70aaca6dbd$export$426d7b90ba5d79db;
var $8b11dd70aaca6dbd$export$f5a1ee40934d19ce;
var $8b11dd70aaca6dbd$export$1ba812a9756622ce;
var $8b11dd70aaca6dbd$export$351120039c36e03;
var $8b11dd70aaca6dbd$export$d42aa25ca09e17c4;
var $8b11dd70aaca6dbd$export$d268db29b88a4286;
var $8b11dd70aaca6dbd$export$c5deb6018f2d6251;
var $8b11dd70aaca6dbd$export$e06baa3034409453;
var $8b11dd70aaca6dbd$export$646fdb5910ce3931;
var $8b11dd70aaca6dbd$export$662e3d2d4361e29b;
var $8b11dd70aaca6dbd$export$1de3962f221ba441;
var $8b11dd70aaca6dbd$export$a4b3f0f5499c8738;
var $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b;
var $8b11dd70aaca6dbd$export$2eb2ab35b317a103;
var $8b11dd70aaca6dbd$export$c7e14ea195ede241;
var $8b11dd70aaca6dbd$export$41ac034e7b9725a2;
var $8b11dd70aaca6dbd$export$9e521119d7751e37;
var $8b11dd70aaca6dbd$export$cbac8f541a64a150;
var $8b11dd70aaca6dbd$export$93dd08efa94c9dd4;
var $8b11dd70aaca6dbd$export$183e3523dac20bca;
var $8b11dd70aaca6dbd$export$3867ca1d8381d4e3;
var $8b11dd70aaca6dbd$export$11febcf9917c0057;
var $8b11dd70aaca6dbd$export$88ae1ee0c0a63398;
var $8b11dd70aaca6dbd$export$d5bd986d1f283f29;
var $8b11dd70aaca6dbd$export$fc4a2d238535d998;
var $8b11dd70aaca6dbd$export$57e53a60bf563f41;
var $8b11dd70aaca6dbd$export$ffdb1464deb0eedb;
var $8b11dd70aaca6dbd$export$b52670c950fd640;
var $8b11dd70aaca6dbd$export$c499fd8f1db3d18e;
var $8b11dd70aaca6dbd$export$b2ee2242301eff05;
var $8b11dd70aaca6dbd$export$2ebf9f7586f16841;
var $8b11dd70aaca6dbd$export$6e9ffd608b3e828b;
var $8b11dd70aaca6dbd$export$b960c5a73a722e6c;
var $8b11dd70aaca6dbd$export$a7a850351369c77e;
var $8b11dd70aaca6dbd$export$b18bca78f4736a94;
var $8b11dd70aaca6dbd$export$61a0059f562fb6c2;
var $8b11dd70aaca6dbd$export$7dc0d5aefb816d91;
var $8b11dd70aaca6dbd$export$58f6db56c841bef6;
var $8b11dd70aaca6dbd$export$97a3da679f509d5;
var $8b11dd70aaca6dbd$export$c387ec65fd1c2638;
var $8b11dd70aaca6dbd$export$4d9db82211f308a4;
var $8b11dd70aaca6dbd$export$ee4948a3be025123;
var $8b11dd70aaca6dbd$export$e0021eb2979cddaa;
var $8b11dd70aaca6dbd$export$7c0ac0c19a45beac;
var $8b11dd70aaca6dbd$export$6c32e9d84f534ee;
var $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b;
var $8b11dd70aaca6dbd$export$45e7eea99a17d6e4;
var $8b11dd70aaca6dbd$export$20ea34e16c0aa64f;
var $8b11dd70aaca6dbd$export$8365b0f03557fae9;
var $8b11dd70aaca6dbd$export$49ebbb9621675650;
var $8b11dd70aaca6dbd$export$842be66a901f093;
var $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1;
var $8b11dd70aaca6dbd$export$57b055d4bc586d67;
var $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a;
var $8b11dd70aaca6dbd$export$fa7e1f5305153b3d;
var $8b11dd70aaca6dbd$export$5674ce9d013eb7bd;
var $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72;
var $8b11dd70aaca6dbd$export$afd59480458e1b57;
var $8b11dd70aaca6dbd$export$48e61fb9bccccba9;
var $8b11dd70aaca6dbd$export$d3e674514dd3a3e1;
var $8b11dd70aaca6dbd$export$97ad02b50c60ef68;
var $8b11dd70aaca6dbd$export$61d053b1b63e82c4;
var $8b11dd70aaca6dbd$export$54256cce0d674dea;
var $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca;
var $8b11dd70aaca6dbd$export$be3f46982f6c7160;
var $8b11dd70aaca6dbd$export$778e4213e2788579;
var $8b11dd70aaca6dbd$export$8b48ca3594d2b172;
var $8b11dd70aaca6dbd$export$8be180ec26319f9f;
var $8b11dd70aaca6dbd$export$60eccaddefa8fc1c;
var $8b11dd70aaca6dbd$export$c99ce4fe37484d84;
var $8b11dd70aaca6dbd$export$fdf432fcac7d8f37;
var $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd;
var $8b11dd70aaca6dbd$export$dcc1eab7f3f31816;
var $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86;
var $8b11dd70aaca6dbd$export$53416edeea4c2d74;
var $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e;
var $8b11dd70aaca6dbd$export$8e104aed582a26bc;
var $8b11dd70aaca6dbd$export$577047501949be9;
var $8b11dd70aaca6dbd$export$c4c45b599a2c15e;
var $8b11dd70aaca6dbd$export$361cb541700d648e;
var $8b11dd70aaca6dbd$export$974f160e11f25731;
var $8b11dd70aaca6dbd$export$7162f5c702b95903;
var $8b11dd70aaca6dbd$export$a034d066a9090500;
var $8b11dd70aaca6dbd$export$70938021e43e047c;
var $8b11dd70aaca6dbd$export$5f6ac460012a73bb;
var $8b11dd70aaca6dbd$export$d8e498c1c670bcbf;
var $8b11dd70aaca6dbd$export$cc1a78a24d947903;
var $8b11dd70aaca6dbd$export$d29b927e0bb0ffea;
var $8b11dd70aaca6dbd$export$b3999cacef245779;
var $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6;
var $8b11dd70aaca6dbd$export$2ab876a45bd6e64;
var $8b11dd70aaca6dbd$export$cb8027e4395c6c0e;
var $8b11dd70aaca6dbd$export$f5303d1bac3c2660;
var $8b11dd70aaca6dbd$export$6c463c5f3b00f64;
var $8b11dd70aaca6dbd$export$e25d553065457cab;
var $8b11dd70aaca6dbd$export$15d24c154ea8a56f;
var $8b11dd70aaca6dbd$export$e5065789a6c415d0;
var $8b11dd70aaca6dbd$export$62662c561d7c7835;
var $8b11dd70aaca6dbd$export$218f394557fb0a5a;
var $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf;
var $8b11dd70aaca6dbd$export$9d23f3030ed2597e;
var $8b11dd70aaca6dbd$export$a26ff217a6124160;
var $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77;
var $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96;
var $8b11dd70aaca6dbd$export$328519d02a26ac41;
var $8b11dd70aaca6dbd$export$d2061b291c43d045;
var $8b11dd70aaca6dbd$export$d1f04dfd3d695286;
var $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8;
var $8b11dd70aaca6dbd$export$e795000978a75b12;
var $8b11dd70aaca6dbd$export$9f4683b4d1018ace;
var $8b11dd70aaca6dbd$export$e431b042fcdb1d63;
var $8b11dd70aaca6dbd$export$a453239171ac9a23;
var $8b11dd70aaca6dbd$export$3a7726a976c18d5f;
var $8b11dd70aaca6dbd$export$7eca7a6c06843b93;
var $8b11dd70aaca6dbd$export$f25c55f83e5b0672;
var $8b11dd70aaca6dbd$export$9562bfac4eb079cb;
var $8b11dd70aaca6dbd$export$c276d164ff91d2f7;
var $8b11dd70aaca6dbd$export$2f3e0574f1a99754;
var $8b11dd70aaca6dbd$export$15eecaab68167880;
var $8b11dd70aaca6dbd$export$513c47f6e194086a;
var $8b11dd70aaca6dbd$export$a3f464c4d5cd9096;
var $8b11dd70aaca6dbd$export$ed366a03a2330b03;
var $8b11dd70aaca6dbd$export$9b802c784f235e1d;
var $8b11dd70aaca6dbd$export$add0fc8b8c5726a4;
var $8b11dd70aaca6dbd$export$e7f32463f5bfd554;
var $8b11dd70aaca6dbd$export$f9346f394edf26a;
var $8b11dd70aaca6dbd$export$16b917774e73ef92;
var $8b11dd70aaca6dbd$export$15d2b60bf3b65454;
var $8b11dd70aaca6dbd$export$db55eca5af256142;
var $8b11dd70aaca6dbd$export$967c74f8b1f3d35;
var $8b11dd70aaca6dbd$export$7c33ae67962515d1;
var $8b11dd70aaca6dbd$export$9c69839b2d93489b;
var $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8;
var $8b11dd70aaca6dbd$export$c529961b911626ac;
var $8b11dd70aaca6dbd$export$e39c4b15d2881f5;
var $8b11dd70aaca6dbd$export$a8ca145161313e7;
var $8b11dd70aaca6dbd$export$3c1204d03918d076;
var $8b11dd70aaca6dbd$export$eaac3f141165e288;
var $8b11dd70aaca6dbd$export$4c7e6934714150e6;
var $8b11dd70aaca6dbd$export$6f71f9711d666eb4;
var $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4;
var $8b11dd70aaca6dbd$export$55478a0b7d2ae98f;
var $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a;
var $8b11dd70aaca6dbd$export$a82607b6424c06c8;
var $8b11dd70aaca6dbd$export$6b081f3484c7f4e5;
var $8b11dd70aaca6dbd$export$b7754d85fd39406c;
var $8b11dd70aaca6dbd$export$492856c046eb4728;
var $8b11dd70aaca6dbd$export$c1678a2059fbe906;
var $8b11dd70aaca6dbd$export$6d384a0bc1011c34;
var $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4;
var $8b11dd70aaca6dbd$export$cfcbff40019f0ff1;
var $8b11dd70aaca6dbd$export$27157b5f68e583af;
var $8b11dd70aaca6dbd$export$54bf5ed61532925d;
var $8b11dd70aaca6dbd$export$60ed0786292ace08;
var $8b11dd70aaca6dbd$export$d770bfb8345e146;
var $8b11dd70aaca6dbd$export$bb73817f1290ad28;
var $8b11dd70aaca6dbd$export$f201c980f2b75802;
var $8b11dd70aaca6dbd$export$b40e970572afd0ee;
var $8b11dd70aaca6dbd$export$8850630a3d343488;
var $8b11dd70aaca6dbd$export$fd0a39a918d6516f;
var $8b11dd70aaca6dbd$export$e68ef41f8e0335bf;
var $8b11dd70aaca6dbd$export$5bff09650e762829;
var $8b11dd70aaca6dbd$export$21c1adce0e067f37;
var $8b11dd70aaca6dbd$export$fed6ce86f48c84bc;
var $8b11dd70aaca6dbd$export$500c2675137ac16e;
var $8b11dd70aaca6dbd$export$402c7728623fd8df;
var $8b11dd70aaca6dbd$export$15417259f4c0fe6b;
var $8b11dd70aaca6dbd$export$2b3b7f579a727f45;
var $8b11dd70aaca6dbd$export$514832a0b029734b;
var $8b11dd70aaca6dbd$export$b0522e6a14dec1a4;
var $8b11dd70aaca6dbd$export$659ea19f71a7ee0b;
var $8b11dd70aaca6dbd$export$1b61d972db315e73;
var $8b11dd70aaca6dbd$export$fb2970ee11a479ee;
var $8b11dd70aaca6dbd$export$920aceb2a8fad77e;
var $8b11dd70aaca6dbd$export$48f8f6fbc999d187;
var $8b11dd70aaca6dbd$export$eed590fa00a8223b;
var $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da;
var $8b11dd70aaca6dbd$export$779ef03d633a9086;
var $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc;
var $8b11dd70aaca6dbd$export$ca719aa57653a0a7;
var $8b11dd70aaca6dbd$export$74b19c5f48270c05;
var $8b11dd70aaca6dbd$export$c351affe7e8098cb;
var $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765;
var $8b11dd70aaca6dbd$export$ec182524c4c57275;
var $8b11dd70aaca6dbd$export$9e45758246a85b07;
var $8b11dd70aaca6dbd$export$9fa5d5f0144954cb;
var $8b11dd70aaca6dbd$export$e66ba5bc4b978023;
var $8b11dd70aaca6dbd$export$2306e23cc611a36d;
var $8b11dd70aaca6dbd$export$144f8c1fe01428db;
var $8b11dd70aaca6dbd$export$f303b2744d52121c;
var $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6;
var $8b11dd70aaca6dbd$export$b4c85774878b4841;
var $8b11dd70aaca6dbd$export$1c967a71bc9a3077;
var $8b11dd70aaca6dbd$export$5e3884a35a19eb90;
var $8b11dd70aaca6dbd$export$6e7ff99bb3259573;
var $8b11dd70aaca6dbd$export$7c932cba2d9e7a7;
var $8b11dd70aaca6dbd$export$94091942edce0667;
var $8b11dd70aaca6dbd$export$3671a8a524706a9d;
var $8b11dd70aaca6dbd$export$c288888dc82d233f;
var $8b11dd70aaca6dbd$export$8ff188536cebc35;
var $8b11dd70aaca6dbd$export$6407d78968c0eabe;
var $8b11dd70aaca6dbd$export$43e9fb9ec28d9743;
var $8b11dd70aaca6dbd$export$26f31d5c5c201739;
var $8b11dd70aaca6dbd$export$bff85124d2d35b93;
var $8b11dd70aaca6dbd$export$495c671ed5a6408c;
var $8b11dd70aaca6dbd$export$54b3d4d5548c35c3;
var $8b11dd70aaca6dbd$export$2954db6444fe1fa8;
var $8b11dd70aaca6dbd$export$15c1c974d16dd678;
var $8b11dd70aaca6dbd$export$9be2ae89a1eac217;
var $8b11dd70aaca6dbd$export$5c698591c0e586a2;
var $8b11dd70aaca6dbd$export$b711f2bb9c9a848a;
var $8b11dd70aaca6dbd$export$1d3a8501efd30213;
var $8b11dd70aaca6dbd$export$cebaf684ced5a2c9;
var $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c;
var $8b11dd70aaca6dbd$export$b1b162b01baeb044;
var $8b11dd70aaca6dbd$export$8be2d593d7f88ed8;
var $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0;
var $8b11dd70aaca6dbd$export$66581dc6d3d083d1;
var $8b11dd70aaca6dbd$export$e545f99e7abcc499;
var $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa;
var $8b11dd70aaca6dbd$export$186c94c351c54768;
var $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c;
var $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5;
var $8b11dd70aaca6dbd$export$9d5bffdff936d554;
var $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79;
var $8b11dd70aaca6dbd$export$27933a9557f87e98;
var $8b11dd70aaca6dbd$export$eefa737b40a0d535;
var $8b11dd70aaca6dbd$export$92740ffbcb02553b;
var $8b11dd70aaca6dbd$export$500e89753f9f1008;
var $8b11dd70aaca6dbd$export$d91a18e47fdddefd;
var $8b11dd70aaca6dbd$export$eccbe6f20884ea7f;
var $8b11dd70aaca6dbd$export$9e24f11d79141afb;
var $8b11dd70aaca6dbd$export$f0b96ad9586f8887;
var $8b11dd70aaca6dbd$export$8a92ed5d436a85c6;
var $8b11dd70aaca6dbd$export$edd59acdf7e86a71;
var $8b11dd70aaca6dbd$export$ae81a1ae71952d50;
var $8b11dd70aaca6dbd$export$6101470cd57eac1b;
var $8b11dd70aaca6dbd$export$452c0aee9673fe67;
var $8b11dd70aaca6dbd$export$773dddd1e8667756;
var $8b11dd70aaca6dbd$export$98815f8579a64a90;
var $8b11dd70aaca6dbd$export$7bc4e27428665019;
var $8b11dd70aaca6dbd$export$e7d7477fa9057ee2;
var $8b11dd70aaca6dbd$export$1f4267a3fc018448;
var $8b11dd70aaca6dbd$export$c171cae150389952;
var $8b11dd70aaca6dbd$export$d9bb35e957b22c72;
var $8b11dd70aaca6dbd$export$b3508a2c95f74e3d;
var $8b11dd70aaca6dbd$export$20bb272f4d21532d;
var $8b11dd70aaca6dbd$export$d7e64fbd0102ce90;
var $8b11dd70aaca6dbd$export$c17eae7e86dbba3c;
var $8b11dd70aaca6dbd$export$349603c0a9165744;
var $8b11dd70aaca6dbd$export$4dadf693741f0283;
var $8b11dd70aaca6dbd$export$6377864d12f7eeb3;
var $8b11dd70aaca6dbd$export$ba081af9585ed4;
var $8b11dd70aaca6dbd$export$7841dacb241485d0;
var $8b11dd70aaca6dbd$export$52c7044cf6301362;
var $8b11dd70aaca6dbd$export$56ea1c9e44590e20;
var $8b11dd70aaca6dbd$export$7626e389d05f4c36;
var $8b11dd70aaca6dbd$export$5e0a48187329b2e7;
var $8b11dd70aaca6dbd$export$c322b150d7667841;
var $8b11dd70aaca6dbd$export$4a4797d3c962f753;
var $8b11dd70aaca6dbd$export$767524d5e72e2645;
var $8b11dd70aaca6dbd$export$497354ca7b0ee666;
var $8b11dd70aaca6dbd$export$cbdc4ad11118116a;
var $8b11dd70aaca6dbd$export$5b890de778c4c2fe;
var $8b11dd70aaca6dbd$export$a78d9803b5e0a83e;
var $8b11dd70aaca6dbd$export$df1b536467b3992a;
var $8b11dd70aaca6dbd$export$73104a329e205998;
var $8b11dd70aaca6dbd$export$5740e3da55330b0a;
var $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da;
var $8b11dd70aaca6dbd$export$e5f1321e53e24810;
var $8b11dd70aaca6dbd$export$56dd3098cbca7c8a;
var $8b11dd70aaca6dbd$export$aa7aff70e4380665;
var $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf;
var $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6;
var $8b11dd70aaca6dbd$export$91ad03bba7909fb5;
var $8b11dd70aaca6dbd$export$86128e6c0ab71d64;
var $8b11dd70aaca6dbd$export$745b60c4819aec1d;
var $8b11dd70aaca6dbd$export$d2c893bfac1da9a1;
var $8b11dd70aaca6dbd$export$1c14ad02f9534b19;
var $8b11dd70aaca6dbd$export$db3cb63e0594d014;
var $8b11dd70aaca6dbd$export$a65c9a0eba2c222d;
var $8b11dd70aaca6dbd$export$68dbcca9c0e339ec;
var $8b11dd70aaca6dbd$export$d59b669d4bb3f006;
var $8b11dd70aaca6dbd$export$4d88d347aa9667fc;
var $8b11dd70aaca6dbd$export$9943ffdcaa4bc506;
var $8b11dd70aaca6dbd$export$d4f25b923533dbba;
var $8b11dd70aaca6dbd$export$35f3396a1cdeea45;
var $8b11dd70aaca6dbd$export$80e399da474bc98d;
var $8b11dd70aaca6dbd$export$e01809e2dbceac35;
var $8b11dd70aaca6dbd$export$41900d5c4e8a9c68;
var $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03;
var $8b11dd70aaca6dbd$export$6803ac54f919d9cc;
var $8b11dd70aaca6dbd$export$72f5b47540331169;
var $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb;
var $8b11dd70aaca6dbd$export$6b5244c457b68e65;
var $8b11dd70aaca6dbd$export$b7bd0c9a886f3414;
var $8b11dd70aaca6dbd$export$6b77f2bacac7c93d;
var $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea;
var $8b11dd70aaca6dbd$export$feb4fe753df28a82;
var $8b11dd70aaca6dbd$export$d6267756132e2175;
var $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6;
var $8b11dd70aaca6dbd$export$5b9a0015e1c530ed;
var $8b11dd70aaca6dbd$export$8bbff71c84508218;
var $8b11dd70aaca6dbd$export$b55aa07a514a2430;
var $8b11dd70aaca6dbd$export$9927ad09f7c084dc;
var $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6;
var $8b11dd70aaca6dbd$export$a10d277c42e6cae3;
var $8b11dd70aaca6dbd$export$cdc0ce5c66182801;
var $8b11dd70aaca6dbd$export$2504d4bd698dd962;
var $8b11dd70aaca6dbd$export$9dc86f3b876e96ef;
var $8b11dd70aaca6dbd$export$70ff7865f52549ae;
var $8b11dd70aaca6dbd$export$f77b53a42be6e6fd;
var $8b11dd70aaca6dbd$export$818eb7ab11414506;
var $8b11dd70aaca6dbd$export$829ef6b2e59d984d;
var $8b11dd70aaca6dbd$export$b30f4cb52c088a26;
var $8b11dd70aaca6dbd$export$335eace0ff1771cd;
var $8b11dd70aaca6dbd$export$374d88a2025416ac;
var $8b11dd70aaca6dbd$export$bb7a91303551eb37;
var $8b11dd70aaca6dbd$export$f132ea291a7db56b;
var $8b11dd70aaca6dbd$export$f0abd4170bbd2468;
var $8b11dd70aaca6dbd$export$50d00a157dc08581;
var $8b11dd70aaca6dbd$export$484576567a98833f;
var $8b11dd70aaca6dbd$export$ec9e491e475d0c97;
var $8b11dd70aaca6dbd$export$a86c59c10992220f;
var $8b11dd70aaca6dbd$export$e12f06597e992fde;
var $8b11dd70aaca6dbd$export$7ec54678ba28ea59;
var $8b11dd70aaca6dbd$export$433ba14c16717110;
var $8b11dd70aaca6dbd$export$309ee349b8a537f;
var $8b11dd70aaca6dbd$export$b87f371cbc396fcf;
var $8b11dd70aaca6dbd$export$60050fc49fe0e7e2;
var $8b11dd70aaca6dbd$export$348c8e2b37f276cd;
var $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2;
var $8b11dd70aaca6dbd$export$50d5adc4b543ce95;
var $8b11dd70aaca6dbd$export$9221f1d2c934d9f;
var $8b11dd70aaca6dbd$export$3a56578b3ae09a02;
var $8b11dd70aaca6dbd$export$e47b8dab9466c895;
var $8b11dd70aaca6dbd$export$4ca52f75cf4889c5;
var $8b11dd70aaca6dbd$export$7343d7d72195067f;
var $8b11dd70aaca6dbd$export$f334f32f8d4d8063;
var $8b11dd70aaca6dbd$export$c7bf2089e89a217c;
var $8b11dd70aaca6dbd$export$f514f97553a434b2;
var $8b11dd70aaca6dbd$export$61abde59b50deb8e;
var $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93;
var $8b11dd70aaca6dbd$export$7044ea8d89b6f59d;
var $8b11dd70aaca6dbd$export$40eacf1a072c9dbd;
var $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac;
var $8b11dd70aaca6dbd$export$5bee9450fe31dde1;
var $8b11dd70aaca6dbd$export$d0b571fb4406d953;
var $8b11dd70aaca6dbd$export$258b370e6c2b85d5;
var $8b11dd70aaca6dbd$export$dc5e5523da291a4b;
var $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0;
var $8b11dd70aaca6dbd$export$1350d8937b0f26fb;
var $8b11dd70aaca6dbd$export$2a045f777fb349a8;
var $8b11dd70aaca6dbd$export$8bb874585539a88f;
var $8b11dd70aaca6dbd$export$17d3a50785727199;
var $8b11dd70aaca6dbd$export$2931c570009689e;
var $8b11dd70aaca6dbd$export$199cbcedee735a43;
var $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862;
var $8b11dd70aaca6dbd$export$674c01ec2f0b89c3;
var $8b11dd70aaca6dbd$export$bda1686739fd61c7;
var $8b11dd70aaca6dbd$export$8d804148f485d54c;
var $8b11dd70aaca6dbd$export$212a8f1ea37518bd;
var $8b11dd70aaca6dbd$export$c9ac0fee28245883;
var $8b11dd70aaca6dbd$export$77078610759fe5f6;
var $8b11dd70aaca6dbd$export$7c6317deeec7a6c1;
var $8b11dd70aaca6dbd$export$877ebf2e4ad81f03;
var $8b11dd70aaca6dbd$export$70b2343945496e1f;
var $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d;
var $8b11dd70aaca6dbd$export$cc81114a03caab18;
var $8b11dd70aaca6dbd$export$bc14eb892daceb23;
var $8b11dd70aaca6dbd$export$3c973217450c3e9d;
var $8b11dd70aaca6dbd$export$582c0b730ff1ddb9;
var $8b11dd70aaca6dbd$export$b3edfb545b65f1c5;
var $8b11dd70aaca6dbd$export$2593317d8731841c;
var $8b11dd70aaca6dbd$export$8bb5bc1732aa41f;
var $8b11dd70aaca6dbd$export$74a79c98b110b5b9;
var $8b11dd70aaca6dbd$export$26461b03281b4db4;
var $8b11dd70aaca6dbd$export$eaea590d6d3dd93c;
var $8b11dd70aaca6dbd$export$af45365f70099379;
var $8b11dd70aaca6dbd$export$a49e732d34d5ba9b;
var $8b11dd70aaca6dbd$export$7c147fe246bc8bd3;
var $8b11dd70aaca6dbd$export$e5111b6070e1ee9e;
var $8b11dd70aaca6dbd$export$591cbfd403f8c8d;
var $8b11dd70aaca6dbd$export$b1388db955bbb885;
var $8b11dd70aaca6dbd$export$e898d0e9e211abd9;
var $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069;
var $8b11dd70aaca6dbd$export$9786ad94c199ffbb;
var $8b11dd70aaca6dbd$export$269890524eed693b;
var $8b11dd70aaca6dbd$export$2ec623a8212d6b64;
var $8b11dd70aaca6dbd$export$30e7673b01ff994e;
var $8b11dd70aaca6dbd$export$9ea93477840812bf;
var $8b11dd70aaca6dbd$export$a6da0c365670c430;
var $8b11dd70aaca6dbd$export$7986b22da43f2885;
var $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f;
var $8b11dd70aaca6dbd$export$dfe49501efcdffce;
var $8b11dd70aaca6dbd$export$be465f50c92eb01d;
var $8b11dd70aaca6dbd$export$c138d1796bb34999;
var $8b11dd70aaca6dbd$export$85a0016690a0ccf2;
var $8b11dd70aaca6dbd$export$883acab36ede4bfa;
var $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1;
var $8b11dd70aaca6dbd$export$b3c6c599110d7bab;
var $8b11dd70aaca6dbd$export$247839c65766758;
var $8b11dd70aaca6dbd$export$f4d52b02df927d54;
var $8b11dd70aaca6dbd$export$df30ee8c5b5f1989;
var $8b11dd70aaca6dbd$export$268a117c860fca6d;
"use strict";
const $8b11dd70aaca6dbd$var$AI_CITATIONS = "ai.citations", $8b11dd70aaca6dbd$var$AI_COMPLETION_TOKENS_USED = "ai.completion_tokens.used", $8b11dd70aaca6dbd$var$AI_DOCUMENTS = "ai.documents", $8b11dd70aaca6dbd$var$AI_FINISH_REASON = "ai.finish_reason", $8b11dd70aaca6dbd$var$AI_FREQUENCY_PENALTY = "ai.frequency_penalty", $8b11dd70aaca6dbd$var$AI_FUNCTION_CALL = "ai.function_call", $8b11dd70aaca6dbd$var$AI_GENERATION_ID = "ai.generation_id", $8b11dd70aaca6dbd$var$AI_INPUT_MESSAGES = "ai.input_messages", $8b11dd70aaca6dbd$var$AI_IS_SEARCH_REQUIRED = "ai.is_search_required", $8b11dd70aaca6dbd$var$AI_METADATA = "ai.metadata", $8b11dd70aaca6dbd$var$AI_MODEL_ID = "ai.model_id", $8b11dd70aaca6dbd$var$AI_MODEL_PROVIDER = "ai.model.provider", $8b11dd70aaca6dbd$var$AI_PIPELINE_NAME = "ai.pipeline.name", $8b11dd70aaca6dbd$var$AI_PREAMBLE = "ai.preamble", $8b11dd70aaca6dbd$var$AI_PRESENCE_PENALTY = "ai.presence_penalty", $8b11dd70aaca6dbd$var$AI_PROMPT_TOKENS_USED = "ai.prompt_tokens.used", $8b11dd70aaca6dbd$var$AI_RAW_PROMPTING = "ai.raw_prompting", $8b11dd70aaca6dbd$var$AI_RESPONSES = "ai.responses", $8b11dd70aaca6dbd$var$AI_RESPONSE_FORMAT = "ai.response_format", $8b11dd70aaca6dbd$var$AI_SEARCH_QUERIES = "ai.search_queries", $8b11dd70aaca6dbd$var$AI_SEARCH_RESULTS = "ai.search_results", $8b11dd70aaca6dbd$var$AI_SEED = "ai.seed", $8b11dd70aaca6dbd$var$AI_STREAMING = "ai.streaming", $8b11dd70aaca6dbd$var$AI_TAGS = "ai.tags", $8b11dd70aaca6dbd$var$AI_TEMPERATURE = "ai.temperature", $8b11dd70aaca6dbd$var$AI_TEXTS = "ai.texts", $8b11dd70aaca6dbd$var$AI_TOOLS = "ai.tools", $8b11dd70aaca6dbd$var$AI_TOOL_CALLS = "ai.tool_calls", $8b11dd70aaca6dbd$var$AI_TOP_K = "ai.top_k", $8b11dd70aaca6dbd$var$AI_TOP_P = "ai.top_p", $8b11dd70aaca6dbd$var$AI_TOTAL_COST = "ai.total_cost", $8b11dd70aaca6dbd$var$AI_TOTAL_TOKENS_USED = "ai.total_tokens.used", $8b11dd70aaca6dbd$var$AI_WARNINGS = "ai.warnings", $8b11dd70aaca6dbd$var$ANGULAR_VERSION = "angular.version", $8b11dd70aaca6dbd$var$APP_APP_BUILD = "app.app_build", $8b11dd70aaca6dbd$var$APP_APP_IDENTIFIER = "app.app_identifier", $8b11dd70aaca6dbd$var$APP_APP_NAME = "app.app_name", $8b11dd70aaca6dbd$var$APP_APP_START_TIME = "app.app_start_time", $8b11dd70aaca6dbd$var$APP_APP_VERSION = "app.app_version", $8b11dd70aaca6dbd$var$APP_BUILD = "app.build", $8b11dd70aaca6dbd$var$APP_IDENTIFIER = "app.identifier", $8b11dd70aaca6dbd$var$APP_IN_FOREGROUND = "app.in_foreground", $8b11dd70aaca6dbd$var$APP_NAME = "app.name", $8b11dd70aaca6dbd$var$APP_START_COLD = "app_start_cold", $8b11dd70aaca6dbd$var$APP_START_TIME = "app.start_time", $8b11dd70aaca6dbd$var$APP_START_TYPE = "app_start_type", $8b11dd70aaca6dbd$var$APP_START_WARM = "app_start_warm", $8b11dd70aaca6dbd$var$APP_VERSION = "app.version", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_DELAY_VALUE = "app.vitals.frames.delay.value", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_FROZEN_COUNT = "app.vitals.frames.frozen.count", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_SLOW_COUNT = "app.vitals.frames.slow.count", $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_TOTAL_COUNT = "app.vitals.frames.total.count", $8b11dd70aaca6dbd$var$APP_VITALS_START_COLD_VALUE = "app.vitals.start.cold.value", $8b11dd70aaca6dbd$var$APP_VITALS_START_PREWARMED = "app.vitals.start.prewarmed", $8b11dd70aaca6dbd$var$APP_VITALS_START_REASON = "app.vitals.start.reason", $8b11dd70aaca6dbd$var$APP_VITALS_START_SCREEN = "app.vitals.start.screen", $8b11dd70aaca6dbd$var$APP_VITALS_START_TYPE = "app.vitals.start.type", $8b11dd70aaca6dbd$var$APP_VITALS_START_WARM_VALUE = "app.vitals.start.warm.value", $8b11dd70aaca6dbd$var$APP_VITALS_TTFD_VALUE = "app.vitals.ttfd.value", $8b11dd70aaca6dbd$var$APP_VITALS_TTID_VALUE = "app.vitals.ttid.value", $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_COUNT = "art.gc.blocking_count", $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_TIME = "art.gc.blocking_time", $8b11dd70aaca6dbd$var$ART_GC_PRE_OOME_COUNT = "art.gc.pre_oome_count", $8b11dd70aaca6dbd$var$ART_GC_TOTAL_COUNT = "art.gc.total_count", $8b11dd70aaca6dbd$var$ART_GC_TOTAL_TIME = "art.gc.total_time", $8b11dd70aaca6dbd$var$ART_GC_WAITING_TIME = "art.gc.waiting_time", $8b11dd70aaca6dbd$var$ART_MEMORY_FREE = "art.memory.free", $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_GC = "art.memory.free_until_gc", $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_OOME = "art.memory.free_until_oome", $8b11dd70aaca6dbd$var$ART_MEMORY_MAX = "art.memory.max", $8b11dd70aaca6dbd$var$ART_MEMORY_TOTAL = "art.memory.total", $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP = "aws.cloudwatch.logs.log_group", $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM = "aws.cloudwatch.logs.log_stream", $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_URL = "aws.cloudwatch.logs.url", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_COUNT = "aws.dynamodb.count", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SELECT = "aws.dynamodb.select", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names", $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments", $8b11dd70aaca6dbd$var$AWS_EXTENDED_REQUEST_ID = "aws.extended_request_id", $8b11dd70aaca6dbd$var$AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream_name", $8b11dd70aaca6dbd$var$_AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream.name", $8b11dd70aaca6dbd$var$AWS_LAMBDA_AWS_REQUEST_ID = "aws.lambda.aws_request_id", $8b11dd70aaca6dbd$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = "aws.lambda.execution_duration_in_millis", $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_NAME = "aws.lambda.function_name", $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_VERSION = "aws.lambda.function_version", $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn", $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN = "aws.lambda.invoked_function_arn", $8b11dd70aaca6dbd$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = "aws.lambda.remaining_time_in_millis", $8b11dd70aaca6dbd$var$AWS_LOG_GROUP_NAMES = "aws.log.group.names", $8b11dd70aaca6dbd$var$AWS_LOG_STREAM_NAMES = "aws.log.stream.names", $8b11dd70aaca6dbd$var$AWS_REQUEST_EXTENDED_ID = "aws.request.extended_id", $8b11dd70aaca6dbd$var$AWS_REQUEST_ID = "aws.request_id", $8b11dd70aaca6dbd$var$_AWS_REQUEST_ID = "aws.request.id", $8b11dd70aaca6dbd$var$AWS_S3_BUCKET = "aws.s3.bucket", $8b11dd70aaca6dbd$var$AWS_SECRETSMANAGER_SECRET_ARN = "aws.secretsmanager.secret.arn", $8b11dd70aaca6dbd$var$AWS_SNS_TOPIC_ARN = "aws.sns.topic.arn", $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN = "aws.step_functions.activity.arn", $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = "aws.step_functions.state_machine.arn", $8b11dd70aaca6dbd$var$BLOCKED_MAIN_THREAD = "blocked_main_thread", $8b11dd70aaca6dbd$var$BROWSER_NAME = "browser.name", $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = "browser.performance.navigation.activation_start", $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_TIME_ORIGIN = "browser.performance.time_origin", $8b11dd70aaca6dbd$var$BROWSER_REPORT_TYPE = "browser.report.type", $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER = "browser.script.invoker", $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER_TYPE = "browser.script.invoker_type", $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION = "browser.script.source_char_position", $8b11dd70aaca6dbd$var$BROWSER_VERSION = "browser.version", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT = "browser.web_vital.cls.report_event", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY = "browser.web_vital.cls.source.<key>", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = "browser.web_vital.cls.source", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_VALUE = "browser.web_vital.cls.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FCP_VALUE = "browser.web_vital.fcp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FP_VALUE = "browser.web_vital.fp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_INP_VALUE = "browser.web_vital.inp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ELEMENT = "browser.web_vital.lcp.element", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ID = "browser.web_vital.lcp.id", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME = "browser.web_vital.lcp.load_time", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME = "browser.web_vital.lcp.render_time", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT = "browser.web_vital.lcp.report_event", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_SIZE = "browser.web_vital.lcp.size", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_URL = "browser.web_vital.lcp.url", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_VALUE = "browser.web_vital.lcp.value", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = "browser.web_vital.ttfb.request_time", $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_VALUE = "browser.web_vital.ttfb.value", $8b11dd70aaca6dbd$var$CACHE_HIT = "cache.hit", $8b11dd70aaca6dbd$var$CACHE_ITEM_SIZE = "cache.item_size", $8b11dd70aaca6dbd$var$CACHE_KEY = "cache.key", $8b11dd70aaca6dbd$var$CACHE_OPERATION = "cache.operation", $8b11dd70aaca6dbd$var$CACHE_TTL = "cache.ttl", $8b11dd70aaca6dbd$var$CACHE_WRITE = "cache.write", $8b11dd70aaca6dbd$var$CHANNEL = "channel", $8b11dd70aaca6dbd$var$CLIENT_ADDRESS = "client.address", $8b11dd70aaca6dbd$var$CLIENT_PORT = "client.port", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_DURATION = "cloudflare.d1.duration", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_QUERY_TYPE = "cloudflare.d1.query_type", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_READ = "cloudflare.d1.rows_read", $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_WRITTEN = "cloudflare.d1.rows_written", $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = "cloudflare.durable_object.query.bindings", $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = "cloudflare.durable_object.response.rows_read", $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = "cloudflare.durable_object.response.rows_written", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_BUCKET = "cloudflare.r2.bucket", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_OPERATION = "cloudflare.r2.operation", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_DELIMITER = "cloudflare.r2.request.delimiter", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_KEY = "cloudflare.r2.request.key", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER = "cloudflare.r2.request.part_number", $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PREFIX = "cloudflare.r2.request.prefix", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_ATTEMPT = "cloudflare.workflow.attempt", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = "cloudflare.workflow.retries.backoff", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY = "cloudflare.workflow.retries.delay", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = "cloudflare.workflow.retries.limit", $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_TIMEOUT = "cloudflare.workflow.timeout", $8b11dd70aaca6dbd$var$CLOUD_ACCOUNT_ID = "cloud.account.id", $8b11dd70aaca6dbd$var$CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone", $8b11dd70aaca6dbd$var$CLOUD_PLATFORM = "cloud.platform", $8b11dd70aaca6dbd$var$CLOUD_PROVIDER = "cloud.provider", $8b11dd70aaca6dbd$var$CLOUD_REGION = "cloud.region", $8b11dd70aaca6dbd$var$CLOUD_RESOURCE_ID = "cloud.resource_id", $8b11dd70aaca6dbd$var$CLS = "cls", $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY = "cls.source.<key>", $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY_BASE = "cls.source", $8b11dd70aaca6dbd$var$CODE_FILEPATH = "code.filepath", $8b11dd70aaca6dbd$var$CODE_FILE_PATH = "code.file.path", $8b11dd70aaca6dbd$var$CODE_FUNCTION = "code.function", $8b11dd70aaca6dbd$var$CODE_FUNCTION_NAME = "code.function.name", $8b11dd70aaca6dbd$var$CODE_LINENO = "code.lineno", $8b11dd70aaca6dbd$var$CODE_LINE_NUMBER = "code.line.number", $8b11dd70aaca6dbd$var$CODE_NAMESPACE = "code.namespace", $8b11dd70aaca6dbd$var$CONNECTIONTYPE = "connectionType", $8b11dd70aaca6dbd$var$CONNECTION_RTT = "connection.rtt", $8b11dd70aaca6dbd$var$CULTURE_CALENDAR = "culture.calendar", $8b11dd70aaca6dbd$var$CULTURE_DISPLAY_NAME = "culture.display_name", $8b11dd70aaca6dbd$var$CULTURE_IS_24_HOUR_FORMAT = "culture.is_24_hour_format", $8b11dd70aaca6dbd$var$CULTURE_LOCALE = "culture.locale", $8b11dd70aaca6dbd$var$CULTURE_TIMEZONE = "culture.timezone", $8b11dd70aaca6dbd$var$DB_COLLECTION_NAME = "db.collection.name", $8b11dd70aaca6dbd$var$DB_DRIVER_NAME = "db.driver.name", $8b11dd70aaca6dbd$var$DB_NAME = "db.name", $8b11dd70aaca6dbd$var$DB_NAMESPACE = "db.namespace", $8b11dd70aaca6dbd$var$DB_OPERATION = "db.operation", $8b11dd70aaca6dbd$var$DB_OPERATION_BATCH_SIZE = "db.operation.batch.size", $8b11dd70aaca6dbd$var$DB_OPERATION_NAME = "db.operation.name", $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY = "db.query.parameter.<key>", $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY_BASE = "db.query.parameter", $8b11dd70aaca6dbd$var$DB_QUERY_SUMMARY = "db.query.summary", $8b11dd70aaca6dbd$var$DB_QUERY_TEXT = "db.query.text", $8b11dd70aaca6dbd$var$DB_REDIS_CONNECTION = "db.redis.connection", $8b11dd70aaca6dbd$var$DB_REDIS_KEY = "db.redis.key", $8b11dd70aaca6dbd$var$DB_REDIS_PARAMETERS = "db.redis.parameters", $8b11dd70aaca6dbd$var$DB_RESPONSE_STATUS_CODE = "db.response.status_code", $8b11dd70aaca6dbd$var$DB_SQL_BINDINGS = "db.sql.bindings", $8b11dd70aaca6dbd$var$DB_STATEMENT = "db.statement", $8b11dd70aaca6dbd$var$DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name", $8b11dd70aaca6dbd$var$DB_SYSTEM = "db.system", $8b11dd70aaca6dbd$var$DB_SYSTEM_NAME = "db.system.name", $8b11dd70aaca6dbd$var$DB_USER = "db.user", $8b11dd70aaca6dbd$var$DEVICEMEMORY = "deviceMemory", $8b11dd70aaca6dbd$var$DEVICE_ARCHS = "device.archs", $8b11dd70aaca6dbd$var$DEVICE_BATTERY_LEVEL = "device.battery_level", $8b11dd70aaca6dbd$var$DEVICE_BATTERY_TEMPERATURE = "device.battery_temperature", $8b11dd70aaca6dbd$var$DEVICE_BOOT_TIME = "device.boot_time", $8b11dd70aaca6dbd$var$DEVICE_BRAND = "device.brand", $8b11dd70aaca6dbd$var$DEVICE_CHARGING = "device.charging", $8b11dd70aaca6dbd$var$DEVICE_CHIPSET = "device.chipset", $8b11dd70aaca6dbd$var$DEVICE_CLASS = "device.class", $8b11dd70aaca6dbd$var$DEVICE_CONNECTION_TYPE = "device.connection_type", $8b11dd70aaca6dbd$var$DEVICE_CPU_DESCRIPTION = "device.cpu_description", $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_FREE_STORAGE = "device.external_free_storage", $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_STORAGE_SIZE = "device.external_storage_size", $8b11dd70aaca6dbd$var$DEVICE_FAMILY = "device.family", $8b11dd70aaca6dbd$var$DEVICE_FREE_MEMORY = "device.free_memory", $8b11dd70aaca6dbd$var$DEVICE_FREE_STORAGE = "device.free_storage", $8b11dd70aaca6dbd$var$DEVICE_ID = "device.id", $8b11dd70aaca6dbd$var$DEVICE_LOCALE = "device.locale", $8b11dd70aaca6dbd$var$DEVICE_LOW_MEMORY = "device.low_memory", $8b11dd70aaca6dbd$var$DEVICE_LOW_POWER_MODE = "device.low_power_mode", $8b11dd70aaca6dbd$var$DEVICE_MANUFACTURER = "device.manufacturer", $8b11dd70aaca6dbd$var$DEVICE_MEMORY_ESTIMATED_CAPACITY = "device.memory.estimated_capacity", $8b11dd70aaca6dbd$var$DEVICE_MEMORY_SIZE = "device.memory_size", $8b11dd70aaca6dbd$var$DEVICE_MODEL = "device.model", $8b11dd70aaca6dbd$var$DEVICE_MODEL_ID = "device.model_id", $8b11dd70aaca6dbd$var$DEVICE_NAME = "device.name", $8b11dd70aaca6dbd$var$DEVICE_ONLINE = "device.online", $8b11dd70aaca6dbd$var$DEVICE_ORIENTATION = "device.orientation", $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_COUNT = "device.processor_count", $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_FREQUENCY = "device.processor_frequency", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DENSITY = "device.screen_density", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DPI = "device.screen_dpi", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_HEIGHT_PIXELS = "device.screen_height_pixels", $8b11dd70aaca6dbd$var$DEVICE_SCREEN_WIDTH_PIXELS = "device.screen_width_pixels", $8b11dd70aaca6dbd$var$DEVICE_SIMULATOR = "device.simulator", $8b11dd70aaca6dbd$var$DEVICE_STORAGE_SIZE = "device.storage_size", $8b11dd70aaca6dbd$var$DEVICE_THERMAL_STATE = "device.thermal_state", $8b11dd70aaca6dbd$var$DEVICE_TIMEZONE = "device.timezone", $8b11dd70aaca6dbd$var$DEVICE_USABLE_MEMORY = "device.usable_memory", $8b11dd70aaca6dbd$var$DIST = "dist", $8b11dd70aaca6dbd$var$EFFECTIVECONNECTIONTYPE = "effectiveConnectionType", $8b11dd70aaca6dbd$var$ENVIRONMENT = "environment", $8b11dd70aaca6dbd$var$ERROR_TYPE = "error.type", $8b11dd70aaca6dbd$var$EVENT_ID = "event.id", $8b11dd70aaca6dbd$var$EVENT_NAME = "event.name", $8b11dd70aaca6dbd$var$EXCEPTION_ESCAPED = "exception.escaped", $8b11dd70aaca6dbd$var$EXCEPTION_MESSAGE = "exception.message", $8b11dd70aaca6dbd$var$EXCEPTION_STACKTRACE = "exception.stacktrace", $8b11dd70aaca6dbd$var$EXCEPTION_TYPE = "exception.type", $8b11dd70aaca6dbd$var$FAAS_COLDSTART = "faas.coldstart", $8b11dd70aaca6dbd$var$FAAS_CRON = "faas.cron", $8b11dd70aaca6dbd$var$FAAS_DURATION_IN_MS = "faas.duration_in_ms", $8b11dd70aaca6dbd$var$FAAS_ENTRY_POINT = "faas.entry_point", $8b11dd70aaca6dbd$var$FAAS_EXECUTION = "faas.execution", $8b11dd70aaca6dbd$var$FAAS_ID = "faas.id", $8b11dd70aaca6dbd$var$FAAS_IDENTITY = "faas.identity", $8b11dd70aaca6dbd$var$FAAS_INVOCATION_ID = "faas.invocation_id", $8b11dd70aaca6dbd$var$FAAS_INVOKED_NAME = "faas.invoked_name", $8b11dd70aaca6dbd$var$FAAS_INVOKED_PROVIDER = "faas.invoked_provider", $8b11dd70aaca6dbd$var$FAAS_INVOKED_REGION = "faas.invoked_region", $8b11dd70aaca6dbd$var$FAAS_NAME = "faas.name", $8b11dd70aaca6dbd$var$FAAS_TIME = "faas.time", $8b11dd70aaca6dbd$var$FAAS_TRIGGER = "faas.trigger", $8b11dd70aaca6dbd$var$FAAS_VERSION = "faas.version", $8b11dd70aaca6dbd$var$FCP = "fcp", $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY = "flag.evaluation.<key>", $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY_BASE = "flag.evaluation", $8b11dd70aaca6dbd$var$FP = "fp", $8b11dd70aaca6dbd$var$FRAMES_DELAY = "frames.delay", $8b11dd70aaca6dbd$var$FRAMES_FROZEN = "frames.frozen", $8b11dd70aaca6dbd$var$FRAMES_FROZEN_RATE = "frames_frozen_rate", $8b11dd70aaca6dbd$var$FRAMES_SLOW = "frames.slow", $8b11dd70aaca6dbd$var$FRAMES_SLOW_RATE = "frames_slow_rate", $8b11dd70aaca6dbd$var$FRAMES_TOTAL = "frames.total", $8b11dd70aaca6dbd$var$FS_ERROR = "fs_error", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_ID = "gcp.function.context.event_id", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE = "gcp.function.context.event_type", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_ID = "gcp.function.context.id", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_RESOURCE = "gcp.function.context.resource", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SOURCE = "gcp.function.context.source", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SPECVERSION = "gcp.function.context.specversion", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIME = "gcp.function.context.time", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIMESTAMP = "gcp.function.context.timestamp", $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TYPE = "gcp.function.context.type", $8b11dd70aaca6dbd$var$GCP_PROJECT_ID = "gcp.project.id", $8b11dd70aaca6dbd$var$GEN_AI_AGENT_NAME = "gen_ai.agent.name", $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_UTILIZATION = "gen_ai.context.utilization", $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_WINDOW_SIZE = "gen_ai.context.window_size", $8b11dd70aaca6dbd$var$GEN_AI_CONVERSATION_ID = "gen_ai.conversation.id", $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = "gen_ai.cost.cache_creation.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS = "gen_ai.cost.cache_read.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_INPUT_TOKENS = "gen_ai.cost.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_OUTPUT_TOKENS = "gen_ai.cost.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS = "gen_ai.cost.reasoning.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_COST_TOTAL_TOKENS = "gen_ai.cost.total_tokens", $8b11dd70aaca6dbd$var$GEN_AI_EMBEDDINGS_INPUT = "gen_ai.embeddings.input", $8b11dd70aaca6dbd$var$GEN_AI_FUNCTION_ID = "gen_ai.function_id", $8b11dd70aaca6dbd$var$GEN_AI_INPUT_MESSAGES = "gen_ai.input.messages", $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_NAME = "gen_ai.operation.name", $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_TYPE = "gen_ai.operation.type", $8b11dd70aaca6dbd$var$GEN_AI_OUTPUT_MESSAGES = "gen_ai.output.messages", $8b11dd70aaca6dbd$var$GEN_AI_PIPELINE_NAME = "gen_ai.pipeline.name", $8b11dd70aaca6dbd$var$GEN_AI_PROMPT = "gen_ai.prompt", $8b11dd70aaca6dbd$var$GEN_AI_PROMPT_NAME = "gen_ai.prompt.name", $8b11dd70aaca6dbd$var$GEN_AI_PROVIDER_NAME = "gen_ai.provider.name", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_AVAILABLE_TOOLS = "gen_ai.request.available_tools", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_FREQUENCY_PENALTY = "gen_ai.request.frequency_penalty", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MAX_TOKENS = "gen_ai.request.max_tokens", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MESSAGES = "gen_ai.request.messages", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MODEL = "gen_ai.request.model", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_PRESENCE_PENALTY = "gen_ai.request.presence_penalty", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_REASONING_EFFORT = "gen_ai.request.reasoning_effort", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_SEED = "gen_ai.request.seed", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_STOP_SEQUENCES = "gen_ai.request.stop_sequences", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TEMPERATURE = "gen_ai.request.temperature", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_K = "gen_ai.request.top_k", $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_P = "gen_ai.request.top_p", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_FINISH_REASONS = "gen_ai.response.finish_reasons", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_ID = "gen_ai.response.id", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_MODEL = "gen_ai.response.model", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_STREAMING = "gen_ai.response.streaming", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TEXT = "gen_ai.response.text", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = "gen_ai.response.time_to_first_chunk", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = "gen_ai.response.time_to_first_token", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND = "gen_ai.response.tokens_per_second", $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOOL_CALLS = "gen_ai.response.tool_calls", $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM = "gen_ai.system", $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_INSTRUCTIONS = "gen_ai.system_instructions", $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_MESSAGE = "gen_ai.system.message", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_ARGUMENTS = "gen_ai.tool.call.arguments", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_RESULT = "gen_ai.tool.call.result", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DEFINITIONS = "gen_ai.tool.definitions", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DESCRIPTION = "gen_ai.tool.description", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_INPUT = "gen_ai.tool.input", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_MESSAGE = "gen_ai.tool.message", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_NAME = "gen_ai.tool.name", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_OUTPUT = "gen_ai.tool.output", $8b11dd70aaca6dbd$var$GEN_AI_TOOL_TYPE = "gen_ai.tool.type", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_COMPLETION_TOKENS = "gen_ai.usage.completion_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS = "gen_ai.usage.input_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED = "gen_ai.usage.input_tokens.cached", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = "gen_ai.usage.input_tokens.cache_write", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS = "gen_ai.usage.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = "gen_ai.usage.output_tokens.reasoning", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_PROMPT_TOKENS = "gen_ai.usage.prompt_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = "gen_ai.usage.reasoning.output_tokens", $8b11dd70aaca6dbd$var$GEN_AI_USAGE_TOTAL_TOKENS = "gen_ai.usage.total_tokens", $8b11dd70aaca6dbd$var$GRAPHQL_DOCUMENT = "graphql.document", $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_NAME = "graphql.operation.name", $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_TYPE = "graphql.operation.type", $8b11dd70aaca6dbd$var$HARDWARECONCURRENCY = "hardwareConcurrency", $8b11dd70aaca6dbd$var$HTTP_CLIENT_IP = "http.client_ip", $8b11dd70aaca6dbd$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH = "http.decoded_response_content_length", $8b11dd70aaca6dbd$var$HTTP_FLAVOR = "http.flavor", $8b11dd70aaca6dbd$var$HTTP_FRAGMENT = "http.fragment", $8b11dd70aaca6dbd$var$HTTP_HOST = "http.host", $8b11dd70aaca6dbd$var$HTTP_METHOD = "http.method", $8b11dd70aaca6dbd$var$HTTP_QUERY = "http.query", $8b11dd70aaca6dbd$var$HTTP_REQUEST_BODY_DATA = "http.request.body.data", $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECTION_END = "http.request.connection_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECT_START = "http.request.connect_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_END = "http.request.domain_lookup_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_START = "http.request.domain_lookup_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_FETCH_START = "http.request.fetch_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY = "http.request.header.<key>", $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY_BASE = "http.request.header", $8b11dd70aaca6dbd$var$HTTP_REQUEST_METHOD = "http.request.method", $8b11dd70aaca6dbd$var$_HTTP_REQUEST_METHOD = "http.request_method", $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_END = "http.request.redirect_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_START = "http.request.redirect_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_REQUEST_START = "http.request.request_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count", $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_END = "http.request.response_end", $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_START = "http.request.response_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_SAME_ORIGIN = "http.request.same_origin", $8b11dd70aaca6dbd$var$HTTP_REQUEST_SECURE_CONNECTION_START = "http.request.secure_connection_start", $8b11dd70aaca6dbd$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE = "http.request.time_to_first_byte", $8b11dd70aaca6dbd$var$HTTP_REQUEST_WORKER_START = "http.request.worker_start", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_BODY_SIZE = "http.response.body.size", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH = "http.response.header.content-length", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY = "http.response.header.<key>", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY_BASE = "http.response.header", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_SIZE = "http.response.size", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_STATUS_CODE = "http.response.status_code", $8b11dd70aaca6dbd$var$HTTP_RESPONSE_TRANSFER_SIZE = "http.response_transfer_size", $8b11dd70aaca6dbd$var$HTTP_ROUTE = "http.route", $8b11dd70aaca6dbd$var$HTTP_SCHEME = "http.scheme", $8b11dd70aaca6dbd$var$HTTP_SERVER_NAME = "http.server_name", $8b11dd70aaca6dbd$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE = "http.server.request.time_in_queue", $8b11dd70aaca6dbd$var$HTTP_STATUS_CODE = "http.status_code", $8b11dd70aaca6dbd$var$HTTP_TARGET = "http.target", $8b11dd70aaca6dbd$var$HTTP_URL = "http.url", $8b11dd70aaca6dbd$var$HTTP_USER_AGENT = "http.user_agent", $8b11dd70aaca6dbd$var$ID = "id", $8b11dd70aaca6dbd$var$INP = "inp", $8b11dd70aaca6dbd$var$JSONRPC_PROTOCOL_VERSION = "jsonrpc.protocol.version", $8b11dd70aaca6dbd$var$JSONRPC_REQUEST_ID = "jsonrpc.request.id", $8b11dd70aaca6dbd$var$JVM_GC_ACTION = "jvm.gc.action", $8b11dd70aaca6dbd$var$JVM_GC_NAME = "jvm.gc.name", $8b11dd70aaca6dbd$var$JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name", $8b11dd70aaca6dbd$var$JVM_MEMORY_TYPE = "jvm.memory.type", $8b11dd70aaca6dbd$var$JVM_THREAD_DAEMON = "jvm.thread.daemon", $8b11dd70aaca6dbd$var$JVM_THREAD_STATE = "jvm.thread.state", $8b11dd70aaca6dbd$var$KOA_NAME = "koa.name", $8b11dd70aaca6dbd$var$KOA_TYPE = "koa.type", $8b11dd70aaca6dbd$var$LCP = "lcp", $8b11dd70aaca6dbd$var$LCP_ELEMENT = "lcp.element", $8b11dd70aaca6dbd$var$LCP_ID = "lcp.id", $8b11dd70aaca6dbd$var$LCP_LOADTIME = "lcp.loadTime", $8b11dd70aaca6dbd$var$LCP_RENDERTIME = "lcp.renderTime", $8b11dd70aaca6dbd$var$LCP_SIZE = "lcp.size", $8b11dd70aaca6dbd$var$LCP_URL = "lcp.url", $8b11dd70aaca6dbd$var$LOGGER_NAME = "logger.name", $8b11dd70aaca6dbd$var$MCP_CANCELLED_REASON = "mcp.cancelled.reason", $8b11dd70aaca6dbd$var$MCP_CANCELLED_REQUEST_ID = "mcp.cancelled.request_id", $8b11dd70aaca6dbd$var$MCP_CLIENT_NAME = "mcp.client.name", $8b11dd70aaca6dbd$var$MCP_CLIENT_TITLE = "mcp.client.title", $8b11dd70aaca6dbd$var$MCP_CLIENT_VERSION = "mcp.client.version", $8b11dd70aaca6dbd$var$MCP_LIFECYCLE_PHASE = "mcp.lifecycle.phase", $8b11dd70aaca6dbd$var$MCP_LOGGING_DATA_TYPE = "mcp.logging.data_type", $8b11dd70aaca6dbd$var$MCP_LOGGING_LEVEL = "mcp.logging.level", $8b11dd70aaca6dbd$var$MCP_LOGGING_LOGGER = "mcp.logging.logger", $8b11dd70aaca6dbd$var$MCP_LOGGING_MESSAGE = "mcp.logging.message", $8b11dd70aaca6dbd$var$MCP_METHOD_NAME = "mcp.method.name", $8b11dd70aaca6dbd$var$MCP_PROGRESS_CURRENT = "mcp.progress.current", $8b11dd70aaca6dbd$var$MCP_PROGRESS_MESSAGE = "mcp.progress.message", $8b11dd70aaca6dbd$var$MCP_PROGRESS_PERCENTAGE = "mcp.progress.percentage", $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOKEN = "mcp.progress.token", $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOTAL = "mcp.progress.total", $8b11dd70aaca6dbd$var$MCP_PROMPT_NAME = "mcp.prompt.name", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_DESCRIPTION = "mcp.prompt.result.description", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT = "mcp.prompt.result.message_content", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_COUNT = "mcp.prompt.result.message_count", $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_ROLE = "mcp.prompt.result.message_role", $8b11dd70aaca6dbd$var$MCP_PROTOCOL_READY = "mcp.protocol.ready", $8b11dd70aaca6dbd$var$MCP_PROTOCOL_VERSION = "mcp.protocol.version", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY = "mcp.request.argument.<key>", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY_BASE = "mcp.request.argument", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_NAME = "mcp.request.argument.name", $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_URI = "mcp.request.argument.uri", $8b11dd70aaca6dbd$var$MCP_REQUEST_ID = "mcp.request.id", $8b11dd70aaca6dbd$var$MCP_RESOURCE_PROTOCOL = "mcp.resource.protocol", $8b11dd70aaca6dbd$var$MCP_RESOURCE_URI = "mcp.resource.uri", $8b11dd70aaca6dbd$var$MCP_SERVER_NAME = "mcp.server.name", $8b11dd70aaca6dbd$var$MCP_SERVER_TITLE = "mcp.server.title", $8b11dd70aaca6dbd$var$MCP_SERVER_VERSION = "mcp.server.version", $8b11dd70aaca6dbd$var$MCP_SESSION_ID = "mcp.session.id", $8b11dd70aaca6dbd$var$MCP_TOOL_NAME = "mcp.tool.name", $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT = "mcp.tool.result.content", $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT_COUNT = "mcp.tool.result.content_count", $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_IS_ERROR = "mcp.tool.result.is_error", $8b11dd70aaca6dbd$var$MCP_TRANSPORT = "mcp.transport", $8b11dd70aaca6dbd$var$MDC_KEY = "mdc.<key>", $8b11dd70aaca6dbd$var$MDC_KEY_BASE = "mdc", $8b11dd70aaca6dbd$var$MESSAGING_BATCH_MESSAGE_COUNT = "messaging.batch.message_count", $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION = "messaging.destination", $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_CONNECTION = "messaging.destination.connection", $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_NAME = "messaging.destination.name", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_BODY_SIZE = "messaging.message.body.size", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_CONVERSATION_ID = "messaging.message.conversation_id", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ENVELOPE_SIZE = "messaging.message.envelope.size", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ID = "messaging.message.id", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RECEIVE_LATENCY = "messaging.message.receive.latency", $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RETRY_COUNT = "messaging.message.retry.count", $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_NAME = "messaging.operation.name", $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_TYPE = "messaging.operation.type", $8b11dd70aaca6dbd$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = "messaging.rabbitmq.destination.routing_key", $8b11dd70aaca6dbd$var$MESSAGING_SYSTEM = "messaging.system", $8b11dd70aaca6dbd$var$METHOD = "method", $8b11dd70aaca6dbd$var$MIDDLEWARE_NAME = "middleware.name", $8b11dd70aaca6dbd$var$NAVIGATION_ORIGIN = "navigation.origin", $8b11dd70aaca6dbd$var$NAVIGATION_ROUTE_ID = "navigation.route.id", $8b11dd70aaca6dbd$var$NAVIGATION_TYPE = "navigation.type", $8b11dd70aaca6dbd$var$NEL_ELAPSED_TIME = "nel.elapsed_time", $8b11dd70aaca6dbd$var$NEL_PHASE = "nel.phase", $8b11dd70aaca6dbd$var$NEL_REFERRER = "nel.referrer", $8b11dd70aaca6dbd$var$NEL_SAMPLING_FUNCTION = "nel.sampling_function", $8b11dd70aaca6dbd$var$NEL_TYPE = "nel.type", $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_EFFECTIVE_TYPE = "network.connection.effective_type", $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_RTT = "network.connection.rtt", $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_TYPE = "network.connection.type", $8b11dd70aaca6dbd$var$NETWORK_LOCAL_ADDRESS = "network.local.address", $8b11dd70aaca6dbd$var$NETWORK_LOCAL_PORT = "network.local.port", $8b11dd70aaca6dbd$var$NETWORK_PEER_ADDRESS = "network.peer.address", $8b11dd70aaca6dbd$var$NETWORK_PEER_PORT = "network.peer.port", $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_NAME = "network.protocol.name", $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_VERSION = "network.protocol.version", $8b11dd70aaca6dbd$var$NETWORK_TRANSPORT = "network.transport", $8b11dd70aaca6dbd$var$NETWORK_TYPE = "network.type", $8b11dd70aaca6dbd$var$NET_HOST_IP = "net.host.ip", $8b11dd70aaca6dbd$var$NET_HOST_NAME = "net.host.name", $8b11dd70aaca6dbd$var$NET_HOST_PORT = "net.host.port", $8b11dd70aaca6dbd$var$NET_PEER_IP = "net.peer.ip", $8b11dd70aaca6dbd$var$NET_PEER_NAME = "net.peer.name", $8b11dd70aaca6dbd$var$NET_PEER_PORT = "net.peer.port", $8b11dd70aaca6dbd$var$NET_PROTOCOL_NAME = "net.protocol.name", $8b11dd70aaca6dbd$var$NET_PROTOCOL_VERSION = "net.protocol.version", $8b11dd70aaca6dbd$var$NET_SOCK_FAMILY = "net.sock.family", $8b11dd70aaca6dbd$var$NET_SOCK_HOST_ADDR = "net.sock.host.addr", $8b11dd70aaca6dbd$var$NET_SOCK_HOST_PORT = "net.sock.host.port", $8b11dd70aaca6dbd$var$NET_SOCK_PEER_ADDR = "net.sock.peer.addr", $8b11dd70aaca6dbd$var$NET_SOCK_PEER_NAME = "net.sock.peer.name", $8b11dd70aaca6dbd$var$NET_SOCK_PEER_PORT = "net.sock.peer.port", $8b11dd70aaca6dbd$var$NET_TRANSPORT = "net.transport", $8b11dd70aaca6dbd$var$OS_BUILD = "os.build", $8b11dd70aaca6dbd$var$OS_BUILD_ID = "os.build_id", $8b11dd70aaca6dbd$var$OS_DESCRIPTION = "os.description", $8b11dd70aaca6dbd$var$OS_KERNEL_VERSION = "os.kernel_version", $8b11dd70aaca6dbd$var$OS_NAME = "os.name", $8b11dd70aaca6dbd$var$OS_RAW_DESCRIPTION = "os.raw_description", $8b11dd70aaca6dbd$var$OS_ROOTED = "os.rooted", $8b11dd70aaca6dbd$var$OS_THEME = "os.theme", $8b11dd70aaca6dbd$var$OS_TYPE = "os.type", $8b11dd70aaca6dbd$var$OS_VERSION = "os.version", $8b11dd70aaca6dbd$var$OTEL_KIND = "otel.kind", $8b11dd70aaca6dbd$var$OTEL_SCOPE_NAME = "otel.scope.name", $8b11dd70aaca6dbd$var$OTEL_SCOPE_VERSION = "otel.scope.version", $8b11dd70aaca6dbd$var$OTEL_STATUS_CODE = "otel.status_code", $8b11dd70aaca6dbd$var$OTEL_STATUS_DESCRIPTION = "otel.status_description", $8b11dd70aaca6dbd$var$PARAMS_KEY = "params.<key>", $8b11dd70aaca6dbd$var$PARAMS_KEY_BASE = "params", $8b11dd70aaca6dbd$var$PERFORMANCE_ACTIVATIONSTART = "performance.activationStart", $8b11dd70aaca6dbd$var$PERFORMANCE_TIMEORIGIN = "performance.timeOrigin", $8b11dd70aaca6dbd$var$PREVIOUS_ROUTE = "previous_route", $8b11dd70aaca6dbd$var$PROCESS_COMMAND_ARGS = "process.command_args", $8b11dd70aaca6dbd$var$PROCESS_EXECUTABLE_NAME = "process.executable.name", $8b11dd70aaca6dbd$var$PROCESS_PID = "process.pid", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_NAME = "process.runtime.engine.name", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_VERSION = "process.runtime.engine.version", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_NAME = "process.runtime.name", $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_VERSION = "process.runtime.version", $8b11dd70aaca6dbd$var$QUERY_KEY = "query.<key>", $8b11dd70aaca6dbd$var$QUERY_KEY_BASE = "query", $8b11dd70aaca6dbd$var$REACT_VERSION = "react.version", $8b11dd70aaca6dbd$var$RELEASE = "release", $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY = "remix.action_form_data.<key>", $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY_BASE = "remix.action_form_data", $8b11dd70aaca6dbd$var$REPLAY_ID = "replay_id", $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT = "resource.deployment.environment", $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = "resource.deployment.environment.name", $8b11dd70aaca6dbd$var$RESOURCE_RENDER_BLOCKING_STATUS = "resource.render_blocking_status", $8b11dd70aaca6dbd$var$ROUTE = "route", $8b11dd70aaca6dbd$var$RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code", $8b11dd70aaca6dbd$var$RPC_METHOD = "rpc.method", $8b11dd70aaca6dbd$var$RPC_RESPONSE_STATUS_CODE = "rpc.response.status_code", $8b11dd70aaca6dbd$var$RPC_SERVICE = "rpc.service", $8b11dd70aaca6dbd$var$RPC_SYSTEM = "rpc.system", $8b11dd70aaca6dbd$var$RPC_SYSTEM_NAME = "rpc.system.name", $8b11dd70aaca6dbd$var$RUNTIME_BUILD = "runtime.build", $8b11dd70aaca6dbd$var$RUNTIME_NAME = "runtime.name", $8b11dd70aaca6dbd$var$RUNTIME_RAW_DESCRIPTION = "runtime.raw_description", $8b11dd70aaca6dbd$var$RUNTIME_VERSION = "runtime.version", $8b11dd70aaca6dbd$var$SCORE_KEY = "score.<key>", $8b11dd70aaca6dbd$var$SCORE_KEY_BASE = "score", $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY = "score.ratio.<key>", $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY_BASE = "score.ratio", $8b11dd70aaca6dbd$var$SCORE_TOTAL = "score.total", $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY = "score.weight.<key>", $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY_BASE = "score.weight", $8b11dd70aaca6dbd$var$SENTRY_ACTION = "sentry.action", $8b11dd70aaca6dbd$var$SENTRY_BROWSER_NAME = "sentry.browser.name", $8b11dd70aaca6dbd$var$SENTRY_BROWSER_VERSION = "sentry.browser.version", $8b11dd70aaca6dbd$var$SENTRY_CANCELLATION_REASON = "sentry.cancellation_reason", $8b11dd70aaca6dbd$var$SENTRY_CATEGORY = "sentry.category", $8b11dd70aaca6dbd$var$SENTRY_CLIENT_SAMPLE_RATE = "sentry.client_sample_rate", $8b11dd70aaca6dbd$var$SENTRY_DESCRIPTION = "sentry.description", $8b11dd70aaca6dbd$var$SENTRY_DIST = "sentry.dist", $8b11dd70aaca6dbd$var$SENTRY_DOMAIN = "sentry.domain", $8b11dd70aaca6dbd$var$SENTRY_DSC_ENVIRONMENT = "sentry.dsc.environment", $8b11dd70aaca6dbd$var$SENTRY_DSC_PROJECT_ID = "sentry.dsc.project_id", $8b11dd70aaca6dbd$var$SENTRY_DSC_PUBLIC_KEY = "sentry.dsc.public_key", $8b11dd70aaca6dbd$var$SENTRY_DSC_RELEASE = "sentry.dsc.release", $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLED = "sentry.dsc.sampled", $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLE_RATE = "sentry.dsc.sample_rate", $8b11dd70aaca6dbd$var$SENTRY_DSC_TRACE_ID = "sentry.dsc.trace_id", $8b11dd70aaca6dbd$var$SENTRY_DSC_TRANSACTION = "sentry.dsc.transaction", $8b11dd70aaca6dbd$var$SENTRY_ENVIRONMENT = "sentry.environment", $8b11dd70aaca6dbd$var$SENTRY_EXCLUSIVE_TIME = "sentry.exclusive_time", $8b11dd70aaca6dbd$var$SENTRY_GRAPHQL_OPERATION = "sentry.graphql.operation", $8b11dd70aaca6dbd$var$SENTRY_GROUP = "sentry.group", $8b11dd70aaca6dbd$var$SENTRY_HTTP_PREFETCH = "sentry.http.prefetch", $8b11dd70aaca6dbd$var$SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason", $8b11dd70aaca6dbd$var$SENTRY_IS_REMOTE = "sentry.is_remote", $8b11dd70aaca6dbd$var$SENTRY_KIND = "sentry.kind", $8b11dd70aaca6dbd$var$SENTRY_MAIN_THREAD = "sentry.main_thread", $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_PARAMETER_KEY = "sentry.message.parameter.<key>", $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_TEMPLATE = "sentry.message.template", $8b11dd70aaca6dbd$var$SENTRY_METRIC_SOURCE = "sentry.metric.source", $8b11dd70aaca6dbd$var$SENTRY_MOBILE = "sentry.mobile", $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY = "sentry.module.<key>", $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY_BASE = "sentry.module", $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = "sentry.nextjs.ssr.function.route", $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE = "sentry.nextjs.ssr.function.type", $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY = "sentry.normalized_db_query", $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY_HASH = "sentry.normalized_db_query.hash", $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DESCRIPTION = "sentry.normalized_description", $8b11dd70aaca6dbd$var$SENTRY_OBSERVED_TIMESTAMP_NANOS = "sentry.observed_timestamp_nanos", $8b11dd70aaca6dbd$var$SENTRY_OP = "sentry.op", $8b11dd70aaca6dbd$var$SENTRY_ORIGIN = "sentry.origin", $8b11dd70aaca6dbd$var$SENTRY_PLATFORM = "sentry.platform", $8b11dd70aaca6dbd$var$SENTRY_PROFILER_ID = "sentry.profiler_id", $8b11dd70aaca6dbd$var$SENTRY_PROFILE_ID = "sentry.profile_id", $8b11dd70aaca6dbd$var$SENTRY_RELEASE = "sentry.release", $8b11dd70aaca6dbd$var$SENTRY_REPLAY_ID = "sentry.replay_id", $8b11dd70aaca6dbd$var$SENTRY_REPLAY_IS_BUFFERING = "sentry.replay_is_buffering", $8b11dd70aaca6dbd$var$SENTRY_REPORT_EVENT = "sentry.report_event", $8b11dd70aaca6dbd$var$SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations", $8b11dd70aaca6dbd$var$SENTRY_SDK_NAME = "sentry.sdk.name", $8b11dd70aaca6dbd$var$SENTRY_SDK_VERSION = "sentry.sdk.version", $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_ID = "sentry.segment.id", $8b11dd70aaca6dbd$var$_SENTRY_SEGMENT_ID = "sentry.segment_id", $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_NAME = "sentry.segment.name", $8b11dd70aaca6dbd$var$SENTRY_SERVER_SAMPLE_RATE = "sentry.server_sample_rate", $8b11dd70aaca6dbd$var$SENTRY_SOURCE = "sentry.source", $8b11dd70aaca6dbd$var$SENTRY_SPAN_SOURCE = "sentry.span.source", $8b11dd70aaca6dbd$var$SENTRY_STATUS = "sentry.status", $8b11dd70aaca6dbd$var$SENTRY_STATUS_CODE = "sentry.status_code", $8b11dd70aaca6dbd$var$SENTRY_STATUS_MESSAGE = "sentry.status.message", $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_FROM = "sentry.sveltekit.navigation.from", $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TO = "sentry.sveltekit.navigation.to", $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE = "sentry.sveltekit.navigation.type", $8b11dd70aaca6dbd$var$SENTRY_THREAD_ID = "sentry.thread.id", $8b11dd70aaca6dbd$var$SENTRY_TIMESTAMP_SEQUENCE = "sentry.timestamp.sequence", $8b11dd70aaca6dbd$var$SENTRY_TRACE_LIFECYCLE = "sentry.trace_lifecycle", $8b11dd70aaca6dbd$var$SENTRY_TRACE_PARENT_SPAN_ID = "sentry.trace.parent_span_id", $8b11dd70aaca6dbd$var$SENTRY_TRACE_STATUS = "sentry.trace.status", $8b11dd70aaca6dbd$var$SENTRY_TRANSACTION = "sentry.transaction", $8b11dd70aaca6dbd$var$SENTRY_USER_EMAIL = "sentry.user.email", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_CITY = "sentry.user.geo.city", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_COUNTRY_CODE = "sentry.user.geo.country_code", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_REGION = "sentry.user.geo.region", $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_SUBDIVISION = "sentry.user.geo.subdivision", $8b11dd70aaca6dbd$var$SENTRY_USER_ID = "sentry.user.id", $8b11dd70aaca6dbd$var$SENTRY_USER_IP = "sentry.user.ip", $8b11dd70aaca6dbd$var$SENTRY_USER_USERNAME = "sentry.user.username", $8b11dd70aaca6dbd$var$SERVER_ADDRESS = "server.address", $8b11dd70aaca6dbd$var$SERVER_NAME = "server_name", $8b11dd70aaca6dbd$var$SERVER_PORT = "server.port", $8b11dd70aaca6dbd$var$SERVICE_NAME = "service.name", $8b11dd70aaca6dbd$var$SERVICE_VERSION = "service.version", $8b11dd70aaca6dbd$var$SESSION_ID = "session.id", $8b11dd70aaca6dbd$var$STALL_PERCENTAGE = "stall_percentage", $8b11dd70aaca6dbd$var$STALL_TOTAL_TIME = "stall_total_time", $8b11dd70aaca6dbd$var$STATE_TYPE = "state.type", $8b11dd70aaca6dbd$var$THREAD_ID = "thread.id", $8b11dd70aaca6dbd$var$THREAD_NAME = "thread.name", $8b11dd70aaca6dbd$var$TIMBER_TAG = "timber.tag", $8b11dd70aaca6dbd$var$TIME_TO_FULL_DISPLAY = "time_to_full_display", $8b11dd70aaca6dbd$var$TIME_TO_INITIAL_DISPLAY = "time_to_initial_display", $8b11dd70aaca6dbd$var$TRANSACTION = "transaction", $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_PATH = "trpc.procedure_path", $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_TYPE = "trpc.procedure_type", $8b11dd70aaca6dbd$var$TTFB = "ttfb", $8b11dd70aaca6dbd$var$TTFB_REQUESTTIME = "ttfb.requestTime", $8b11dd70aaca6dbd$var$TYPE = "type", $8b11dd70aaca6dbd$var$UI_COMPONENT_NAME = "ui.component_name", $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTFD = "ui.contributes_to_ttfd", $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTID = "ui.contributes_to_ttid", $8b11dd70aaca6dbd$var$UI_ELEMENT_HEIGHT = "ui.element.height", $8b11dd70aaca6dbd$var$UI_ELEMENT_ID = "ui.element.id", $8b11dd70aaca6dbd$var$UI_ELEMENT_IDENTIFIER = "ui.element.identifier", $8b11dd70aaca6dbd$var$UI_ELEMENT_LOAD_TIME = "ui.element.load_time", $8b11dd70aaca6dbd$var$UI_ELEMENT_PAINT_TYPE = "ui.element.paint_type", $8b11dd70aaca6dbd$var$UI_ELEMENT_RENDER_TIME = "ui.element.render_time", $8b11dd70aaca6dbd$var$UI_ELEMENT_TYPE = "ui.element.type", $8b11dd70aaca6dbd$var$UI_ELEMENT_URL = "ui.element.url", $8b11dd70aaca6dbd$var$UI_ELEMENT_WIDTH = "ui.element.width", $8b11dd70aaca6dbd$var$URL = "url", $8b11dd70aaca6dbd$var$URL_DOMAIN = "url.domain", $8b11dd70aaca6dbd$var$URL_FRAGMENT = "url.fragment", $8b11dd70aaca6dbd$var$URL_FULL = "url.full", $8b11dd70aaca6dbd$var$URL_PATH = "url.path", $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY = "url.path.parameter.<key>", $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY_BASE = "url.path.parameter", $8b11dd70aaca6dbd$var$URL_PORT = "url.port", $8b11dd70aaca6dbd$var$URL_QUERY = "url.query", $8b11dd70aaca6dbd$var$URL_SAME_ORIGIN = "url.same_origin", $8b11dd70aaca6dbd$var$URL_SCHEME = "url.scheme", $8b11dd70aaca6dbd$var$URL_TEMPLATE = "url.template", $8b11dd70aaca6dbd$var$USER_AGENT_ORIGINAL = "user_agent.original", $8b11dd70aaca6dbd$var$USER_EMAIL = "user.email", $8b11dd70aaca6dbd$var$USER_FULL_NAME = "user.full_name", $8b11dd70aaca6dbd$var$USER_GEO_CITY = "user.geo.city", $8b11dd70aaca6dbd$var$USER_GEO_COUNTRY_CODE = "user.geo.country_code", $8b11dd70aaca6dbd$var$USER_GEO_REGION = "user.geo.region", $8b11dd70aaca6dbd$var$USER_GEO_SUBDIVISION = "user.geo.subdivision", $8b11dd70aaca6dbd$var$USER_HASH = "user.hash", $8b11dd70aaca6dbd$var$USER_ID = "user.id", $8b11dd70aaca6dbd$var$USER_IP_ADDRESS = "user.ip_address", $8b11dd70aaca6dbd$var$USER_NAME = "user.name", $8b11dd70aaca6dbd$var$USER_ROLES = "user.roles", $8b11dd70aaca6dbd$var$VERCEL_BRANCH = "vercel.branch", $8b11dd70aaca6dbd$var$VERCEL_BUILD_ID = "vercel.build_id", $8b11dd70aaca6dbd$var$VERCEL_DEPLOYMENT_ID = "vercel.deployment_id", $8b11dd70aaca6dbd$var$VERCEL_DESTINATION = "vercel.destination", $8b11dd70aaca6dbd$var$VERCEL_EDGE_TYPE = "vercel.edge_type", $8b11dd70aaca6dbd$var$VERCEL_ENTRYPOINT = "vercel.entrypoint", $8b11dd70aaca6dbd$var$VERCEL_EXECUTION_REGION = "vercel.execution_region", $8b11dd70aaca6dbd$var$VERCEL_ID = "vercel.id", $8b11dd70aaca6dbd$var$VERCEL_JA3_DIGEST = "vercel.ja3_digest", $8b11dd70aaca6dbd$var$VERCEL_JA4_DIGEST = "vercel.ja4_digest", $8b11dd70aaca6dbd$var$VERCEL_LOG_TYPE = "vercel.log_type", $8b11dd70aaca6dbd$var$VERCEL_PATH = "vercel.path", $8b11dd70aaca6dbd$var$VERCEL_PROJECT_ID = "vercel.project_id", $8b11dd70aaca6dbd$var$VERCEL_PROJECT_NAME = "vercel.project_name", $8b11dd70aaca6dbd$var$VERCEL_PROXY_CACHE_ID = "vercel.proxy.cache_id", $8b11dd70aaca6dbd$var$VERCEL_PROXY_CLIENT_IP = "vercel.proxy.client_ip", $8b11dd70aaca6dbd$var$VERCEL_PROXY_HOST = "vercel.proxy.host", $8b11dd70aaca6dbd$var$VERCEL_PROXY_LAMBDA_REGION = "vercel.proxy.lambda_region", $8b11dd70aaca6dbd$var$VERCEL_PROXY_METHOD = "vercel.proxy.method", $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH = "vercel.proxy.path", $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE = "vercel.proxy.path_type", $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE_VARIANT = "vercel.proxy.path_type_variant", $8b11dd70aaca6dbd$var$VERCEL_PROXY_REFERER = "vercel.proxy.referer", $8b11dd70aaca6dbd$var$VERCEL_PROXY_REGION = "vercel.proxy.region", $8b11dd70aaca6dbd$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE = "vercel.proxy.response_byte_size", $8b11dd70aaca6dbd$var$VERCEL_PROXY_SCHEME = "vercel.proxy.scheme", $8b11dd70aaca6dbd$var$VERCEL_PROXY_STATUS_CODE = "vercel.proxy.status_code", $8b11dd70aaca6dbd$var$VERCEL_PROXY_TIMESTAMP = "vercel.proxy.timestamp", $8b11dd70aaca6dbd$var$VERCEL_PROXY_USER_AGENT = "vercel.proxy.user_agent", $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_CACHE = "vercel.proxy.vercel_cache", $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_ID = "vercel.proxy.vercel_id", $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_ACTION = "vercel.proxy.waf_action", $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_RULE_ID = "vercel.proxy.waf_rule_id", $8b11dd70aaca6dbd$var$VERCEL_REQUEST_ID = "vercel.request_id", $8b11dd70aaca6dbd$var$VERCEL_SOURCE = "vercel.source", $8b11dd70aaca6dbd$var$VERCEL_STATUS_CODE = "vercel.status_code", $8b11dd70aaca6dbd$var$ATTRIBUTE_TYPE = {
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt_tokens.used": "integer",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.name": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.driver.name": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning_effort": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination.name": "string",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.system": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    "query.<key>": "string",
    "react.version": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.exclusive_time": "double",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "state.type": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $8b11dd70aaca6dbd$var$ATTRIBUTE_METADATA = {
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id"
        },
        aliases: [
            "gen_ai.response.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.response.model"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name"
        },
        aliases: [
            "gen_ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "gen_ai.input.messages"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ]
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens"
        },
        aliases: [
            "gen_ai.usage.total_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.ttl": {
        brief: "The ttl of the cache in seconds",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute."
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute."
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path"
        },
        aliases: [
            "code.file.path"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users",
        deprecation: {
            replacement: "db.query.text"
        },
        aliases: [
            "db.query.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The name of the device. On mobile, this is the user-assigned device name. On servers and desktops, this is typically the hostname.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist."
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement."
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0)."
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.frozen.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app_vitals.frames.frozen.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.slow.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app_vitals.frames.slow.count` divided by `app_vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.frames.total.count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning_effort": {
        brief: "Constrains the effort on reasoning for reasoning models. Supported values vary by provider.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    334
                ],
                description: "Added gen_ai.request.reasoning_effort attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments"
        },
        aliases: [
            "gen_ai.tool.call.arguments"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        changelog: [
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the normalized HTTP Header name (lowercase), the value being the header values.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "url.template"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.path",
            reason: "This attribute is being deprecated in favor of url.path and url.query"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute."
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute."
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute."
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute."
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute."
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute."
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute."
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port"
        },
        aliases: [
            "server.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport"
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute."
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute."
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement."
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ]
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ]
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event is now recorded as a browser.web_vital.lcp.report_event or browser.web_vital.cls.report_event attribute. No backfill required."
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ]
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ]
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            replacement: "sentry.span.source",
            reason: "This attribute is being deprecated in favor of sentry.span.source"
        },
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ]
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "navigation.origin",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "navigation.type",
            reason: "Use the more generic attribute instead"
        },
        aliases: [
            "navigation.type"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ]
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ]
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ]
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ]
    },
    "server.address": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address, which is the OTel-aligned replacement."
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full"
        },
        aliases: [
            "url.full",
            "http.url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin."
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute path reference.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};
$8b11dd70aaca6dbd$export$b60c5e9f9b7b58bd = $8b11dd70aaca6dbd$var$AI_CITATIONS, $8b11dd70aaca6dbd$export$cc06afd6de7f2c10 = $8b11dd70aaca6dbd$var$AI_COMPLETION_TOKENS_USED, $8b11dd70aaca6dbd$export$ced6746028fe2cc = $8b11dd70aaca6dbd$var$AI_DOCUMENTS, $8b11dd70aaca6dbd$export$e6f4aa4f4fcb6da8 = $8b11dd70aaca6dbd$var$AI_FINISH_REASON, $8b11dd70aaca6dbd$export$f02d892201cd8d36 = $8b11dd70aaca6dbd$var$AI_FREQUENCY_PENALTY, $8b11dd70aaca6dbd$export$f277a7ef9e273960 = $8b11dd70aaca6dbd$var$AI_FUNCTION_CALL, $8b11dd70aaca6dbd$export$1a8c212c3becaa80 = $8b11dd70aaca6dbd$var$AI_GENERATION_ID, $8b11dd70aaca6dbd$export$721b137086c68a47 = $8b11dd70aaca6dbd$var$AI_INPUT_MESSAGES, $8b11dd70aaca6dbd$export$6afde2bb69d9aa86 = $8b11dd70aaca6dbd$var$AI_IS_SEARCH_REQUIRED, $8b11dd70aaca6dbd$export$eadb4b562c974031 = $8b11dd70aaca6dbd$var$AI_METADATA, $8b11dd70aaca6dbd$export$22a90f0ac1eee843 = $8b11dd70aaca6dbd$var$AI_MODEL_ID, $8b11dd70aaca6dbd$export$a727f215a0be1dad = $8b11dd70aaca6dbd$var$AI_MODEL_PROVIDER, $8b11dd70aaca6dbd$export$536bc61b34d995e5 = $8b11dd70aaca6dbd$var$AI_PIPELINE_NAME, $8b11dd70aaca6dbd$export$c43ea6115b380e62 = $8b11dd70aaca6dbd$var$AI_PREAMBLE, $8b11dd70aaca6dbd$export$d2a16e26bada7cf1 = $8b11dd70aaca6dbd$var$AI_PRESENCE_PENALTY, $8b11dd70aaca6dbd$export$604eb1bd2278163b = $8b11dd70aaca6dbd$var$AI_PROMPT_TOKENS_USED, $8b11dd70aaca6dbd$export$2f8568696c5aa352 = $8b11dd70aaca6dbd$var$AI_RAW_PROMPTING, $8b11dd70aaca6dbd$export$ccc8efd7dd31d3a9 = $8b11dd70aaca6dbd$var$AI_RESPONSES, $8b11dd70aaca6dbd$export$e176bf5dc45e40df = $8b11dd70aaca6dbd$var$AI_RESPONSE_FORMAT, $8b11dd70aaca6dbd$export$c4ea01fd53f64e16 = $8b11dd70aaca6dbd$var$AI_SEARCH_QUERIES, $8b11dd70aaca6dbd$export$bb5e6f2f31a15da9 = $8b11dd70aaca6dbd$var$AI_SEARCH_RESULTS, $8b11dd70aaca6dbd$export$1762c11b666b026a = $8b11dd70aaca6dbd$var$AI_SEED, $8b11dd70aaca6dbd$export$14ddd4b729910100 = $8b11dd70aaca6dbd$var$AI_STREAMING, $8b11dd70aaca6dbd$export$5311d7c8e1f8eabb = $8b11dd70aaca6dbd$var$AI_TAGS, $8b11dd70aaca6dbd$export$2b748b9eca00828b = $8b11dd70aaca6dbd$var$AI_TEMPERATURE, $8b11dd70aaca6dbd$export$5af25308c11addea = $8b11dd70aaca6dbd$var$AI_TEXTS, $8b11dd70aaca6dbd$export$28f78b3b1663cb92 = $8b11dd70aaca6dbd$var$AI_TOOLS, $8b11dd70aaca6dbd$export$a1d3f09f0f1f066f = $8b11dd70aaca6dbd$var$AI_TOOL_CALLS, $8b11dd70aaca6dbd$export$322bd4ea9f163663 = $8b11dd70aaca6dbd$var$AI_TOP_K, $8b11dd70aaca6dbd$export$95711b9e669edad8 = $8b11dd70aaca6dbd$var$AI_TOP_P, $8b11dd70aaca6dbd$export$5924d7d72384626a = $8b11dd70aaca6dbd$var$AI_TOTAL_COST, $8b11dd70aaca6dbd$export$db3b1b877a4ce4db = $8b11dd70aaca6dbd$var$AI_TOTAL_TOKENS_USED, $8b11dd70aaca6dbd$export$a434a3e8afec2879 = $8b11dd70aaca6dbd$var$AI_WARNINGS, $8b11dd70aaca6dbd$export$fe00bb20636d42af = $8b11dd70aaca6dbd$var$ANGULAR_VERSION, $8b11dd70aaca6dbd$export$712aa698b7ee271e = $8b11dd70aaca6dbd$var$APP_APP_BUILD, $8b11dd70aaca6dbd$export$1fac638b11ec16d9 = $8b11dd70aaca6dbd$var$APP_APP_IDENTIFIER, $8b11dd70aaca6dbd$export$d132016ea64058e3 = $8b11dd70aaca6dbd$var$APP_APP_NAME, $8b11dd70aaca6dbd$export$53f2f47ec3b2f9ed = $8b11dd70aaca6dbd$var$APP_APP_START_TIME, $8b11dd70aaca6dbd$export$9f80c4b11053cef1 = $8b11dd70aaca6dbd$var$APP_APP_VERSION, $8b11dd70aaca6dbd$export$5f7a08466d84e877 = $8b11dd70aaca6dbd$var$APP_BUILD, $8b11dd70aaca6dbd$export$2cea7f14750b8c19 = $8b11dd70aaca6dbd$var$APP_IDENTIFIER, $8b11dd70aaca6dbd$export$34c59270f032a6c6 = $8b11dd70aaca6dbd$var$APP_IN_FOREGROUND, $8b11dd70aaca6dbd$export$5b6c28c7dca07ad7 = $8b11dd70aaca6dbd$var$APP_NAME, $8b11dd70aaca6dbd$export$1dc8ae58b58d6c50 = $8b11dd70aaca6dbd$var$APP_START_COLD, $8b11dd70aaca6dbd$export$ba267414e3c0d822 = $8b11dd70aaca6dbd$var$APP_START_TIME, $8b11dd70aaca6dbd$export$71b176005902b99e = $8b11dd70aaca6dbd$var$APP_START_TYPE, $8b11dd70aaca6dbd$export$5c5b5a3c245a0079 = $8b11dd70aaca6dbd$var$APP_START_WARM, $8b11dd70aaca6dbd$export$8ee1df3c6367a60 = $8b11dd70aaca6dbd$var$APP_VERSION, $8b11dd70aaca6dbd$export$e8c7802ae95beccf = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_DELAY_VALUE, $8b11dd70aaca6dbd$export$bb237734da4d464 = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_FROZEN_COUNT, $8b11dd70aaca6dbd$export$cdaaf6d1fdcba0b6 = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_SLOW_COUNT, $8b11dd70aaca6dbd$export$36223ebd4a30e9f5 = $8b11dd70aaca6dbd$var$APP_VITALS_FRAMES_TOTAL_COUNT, $8b11dd70aaca6dbd$export$8feaa177bb7941e2 = $8b11dd70aaca6dbd$var$APP_VITALS_START_COLD_VALUE, $8b11dd70aaca6dbd$export$e1ca25240db91d68 = $8b11dd70aaca6dbd$var$APP_VITALS_START_PREWARMED, $8b11dd70aaca6dbd$export$404a223fd1ada08b = $8b11dd70aaca6dbd$var$APP_VITALS_START_REASON, $8b11dd70aaca6dbd$export$53362079310c68 = $8b11dd70aaca6dbd$var$APP_VITALS_START_SCREEN, $8b11dd70aaca6dbd$export$3efb5af0ac379f77 = $8b11dd70aaca6dbd$var$APP_VITALS_START_TYPE, $8b11dd70aaca6dbd$export$2c10c1ca0612c46d = $8b11dd70aaca6dbd$var$APP_VITALS_START_WARM_VALUE, $8b11dd70aaca6dbd$export$bbb86ad4d6654da6 = $8b11dd70aaca6dbd$var$APP_VITALS_TTFD_VALUE, $8b11dd70aaca6dbd$export$ad6896f00a2b1076 = $8b11dd70aaca6dbd$var$APP_VITALS_TTID_VALUE, $8b11dd70aaca6dbd$export$300f39d8506a273d = $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_COUNT, $8b11dd70aaca6dbd$export$ecaa0e7f4773ddc7 = $8b11dd70aaca6dbd$var$ART_GC_BLOCKING_TIME, $8b11dd70aaca6dbd$export$74b78acb4c54c06b = $8b11dd70aaca6dbd$var$ART_GC_PRE_OOME_COUNT, $8b11dd70aaca6dbd$export$b15b2c133bc50e33 = $8b11dd70aaca6dbd$var$ART_GC_TOTAL_COUNT, $8b11dd70aaca6dbd$export$5f1381d9ae1b1c95 = $8b11dd70aaca6dbd$var$ART_GC_TOTAL_TIME, $8b11dd70aaca6dbd$export$c170b7ff277132ea = $8b11dd70aaca6dbd$var$ART_GC_WAITING_TIME, $8b11dd70aaca6dbd$export$9459a5df93695e45 = $8b11dd70aaca6dbd$var$ART_MEMORY_FREE, $8b11dd70aaca6dbd$export$a7902bd57492ebe8 = $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_GC, $8b11dd70aaca6dbd$export$d2ace0da59da09b7 = $8b11dd70aaca6dbd$var$ART_MEMORY_FREE_UNTIL_OOME, $8b11dd70aaca6dbd$export$c15dd8d2461e0aeb = $8b11dd70aaca6dbd$var$ART_MEMORY_MAX, $8b11dd70aaca6dbd$export$5405b0a98e00e538 = $8b11dd70aaca6dbd$var$ART_MEMORY_TOTAL, $8b11dd70aaca6dbd$export$bd393bbb84b309d3 = $8b11dd70aaca6dbd$var$ATTRIBUTE_METADATA, $8b11dd70aaca6dbd$export$96f586f8837b86ae = $8b11dd70aaca6dbd$var$ATTRIBUTE_TYPE, $8b11dd70aaca6dbd$export$5d9f28f388f552d2 = $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP, $8b11dd70aaca6dbd$export$b3d2f68e0e769504 = $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM, $8b11dd70aaca6dbd$export$2c98412ed43013e8 = $8b11dd70aaca6dbd$var$AWS_CLOUDWATCH_LOGS_URL, $8b11dd70aaca6dbd$export$a7bd794d11c19f1b = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $8b11dd70aaca6dbd$export$df4227832b83fdd0 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSISTENT_READ, $8b11dd70aaca6dbd$export$f131a6d8fbc0534f = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_CONSUMED_CAPACITY, $8b11dd70aaca6dbd$export$9bdc66d4a70e7e3a = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_COUNT, $8b11dd70aaca6dbd$export$bfbbc3cbcaa90e98 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $8b11dd70aaca6dbd$export$3565fa72459aa4d6 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $8b11dd70aaca6dbd$export$bb67a834ae4bffdc = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $8b11dd70aaca6dbd$export$4a06c859a283f06 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_INDEX_NAME, $8b11dd70aaca6dbd$export$68324fac2038d0f2 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $8b11dd70aaca6dbd$export$5e1bd62ffd2786fb = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LIMIT, $8b11dd70aaca6dbd$export$bfdf2261058f56b = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $8b11dd70aaca6dbd$export$23bf57842d9d53df = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROJECTION, $8b11dd70aaca6dbd$export$bfbd7e060eeb4d35 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $8b11dd70aaca6dbd$export$82eb6cccda27c3ff = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $8b11dd70aaca6dbd$export$8ea68734d455808f = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCANNED_COUNT, $8b11dd70aaca6dbd$export$40050e29324d44ee = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SCAN_FORWARD, $8b11dd70aaca6dbd$export$5cd7541006d9f467 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SEGMENT, $8b11dd70aaca6dbd$export$81c017edd95d692e = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_SELECT, $8b11dd70aaca6dbd$export$120b3897a58cf903 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_COUNT, $8b11dd70aaca6dbd$export$d4a9de43b4b1076c = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TABLE_NAMES, $8b11dd70aaca6dbd$export$f37f4f9022f1ab17 = $8b11dd70aaca6dbd$var$AWS_DYNAMODB_TOTAL_SEGMENTS, $8b11dd70aaca6dbd$export$66ac18da14747cfb = $8b11dd70aaca6dbd$var$AWS_EXTENDED_REQUEST_ID, $8b11dd70aaca6dbd$export$9e49b833525ca49d = $8b11dd70aaca6dbd$var$AWS_KINESIS_STREAM_NAME, $8b11dd70aaca6dbd$export$b084fea5b3097227 = $8b11dd70aaca6dbd$var$AWS_LAMBDA_AWS_REQUEST_ID, $8b11dd70aaca6dbd$export$e09cd8615652e8d0 = $8b11dd70aaca6dbd$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS, $8b11dd70aaca6dbd$export$a43a60ec723a90ee = $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_NAME, $8b11dd70aaca6dbd$export$34cc955357266287 = $8b11dd70aaca6dbd$var$AWS_LAMBDA_FUNCTION_VERSION, $8b11dd70aaca6dbd$export$d9dd218693ea9bba = $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_ARN, $8b11dd70aaca6dbd$export$c9649b7156282a2f = $8b11dd70aaca6dbd$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN, $8b11dd70aaca6dbd$export$daa8ce1f8adc553e = $8b11dd70aaca6dbd$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS, $8b11dd70aaca6dbd$export$cb93c7b05db202cf = $8b11dd70aaca6dbd$var$AWS_LOG_GROUP_NAMES, $8b11dd70aaca6dbd$export$930f9bd3cc2e5b3d = $8b11dd70aaca6dbd$var$AWS_LOG_STREAM_NAMES, $8b11dd70aaca6dbd$export$48c6d4c44afdc0b = $8b11dd70aaca6dbd$var$AWS_REQUEST_EXTENDED_ID, $8b11dd70aaca6dbd$export$c78d41789fe4b1e4 = $8b11dd70aaca6dbd$var$AWS_REQUEST_ID, $8b11dd70aaca6dbd$export$f462d9921f1f7332 = $8b11dd70aaca6dbd$var$AWS_S3_BUCKET, $8b11dd70aaca6dbd$export$bc71f8df9a45e243 = $8b11dd70aaca6dbd$var$AWS_SECRETSMANAGER_SECRET_ARN, $8b11dd70aaca6dbd$export$ed840ec4a5f5d053 = $8b11dd70aaca6dbd$var$AWS_SNS_TOPIC_ARN, $8b11dd70aaca6dbd$export$c1a559a4f74a5e8e = $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN, $8b11dd70aaca6dbd$export$d1c007424092e3f5 = $8b11dd70aaca6dbd$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN, $8b11dd70aaca6dbd$export$9ebb466ce954c49c = $8b11dd70aaca6dbd$var$BLOCKED_MAIN_THREAD, $8b11dd70aaca6dbd$export$e9aafc7348984403 = $8b11dd70aaca6dbd$var$BROWSER_NAME, $8b11dd70aaca6dbd$export$faaa46964f075237 = $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START, $8b11dd70aaca6dbd$export$d28c4b3cc4431a87 = $8b11dd70aaca6dbd$var$BROWSER_PERFORMANCE_TIME_ORIGIN, $8b11dd70aaca6dbd$export$734b017b330c8fe6 = $8b11dd70aaca6dbd$var$BROWSER_REPORT_TYPE, $8b11dd70aaca6dbd$export$683ebdc48ba3758d = $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER, $8b11dd70aaca6dbd$export$be0263971250ef44 = $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_INVOKER_TYPE, $8b11dd70aaca6dbd$export$36a0cbc35c405232 = $8b11dd70aaca6dbd$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION, $8b11dd70aaca6dbd$export$469f7765ba335497 = $8b11dd70aaca6dbd$var$BROWSER_VERSION, $8b11dd70aaca6dbd$export$fe6fe2b7af051610 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT, $8b11dd70aaca6dbd$export$8345821877c4dfad = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY, $8b11dd70aaca6dbd$export$f6c188a7e02335cf = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE, $8b11dd70aaca6dbd$export$aaf709a8971e825f = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_CLS_VALUE, $8b11dd70aaca6dbd$export$def01b82f8c092f7 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FCP_VALUE, $8b11dd70aaca6dbd$export$23d4264c606a73a6 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_FP_VALUE, $8b11dd70aaca6dbd$export$af9ece53bb92f66b = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_INP_VALUE, $8b11dd70aaca6dbd$export$25421625a565b69 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ELEMENT, $8b11dd70aaca6dbd$export$ab0c90d873e69ccb = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_ID, $8b11dd70aaca6dbd$export$538c05cc8cb2a2bb = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME, $8b11dd70aaca6dbd$export$f86df4de196e1a7c = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME, $8b11dd70aaca6dbd$export$51e8aa8c0d65e7b8 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT, $8b11dd70aaca6dbd$export$99023486ecc470bd = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_SIZE, $8b11dd70aaca6dbd$export$2f6c85eaf382e81 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_URL, $8b11dd70aaca6dbd$export$1158d57c0aed42be = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_LCP_VALUE, $8b11dd70aaca6dbd$export$d85c4f947ab776e3 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME, $8b11dd70aaca6dbd$export$813ef8386d874918 = $8b11dd70aaca6dbd$var$BROWSER_WEB_VITAL_TTFB_VALUE, $8b11dd70aaca6dbd$export$7c2f74ff9251f64 = $8b11dd70aaca6dbd$var$CACHE_HIT, $8b11dd70aaca6dbd$export$993f84dab107b880 = $8b11dd70aaca6dbd$var$CACHE_ITEM_SIZE, $8b11dd70aaca6dbd$export$7b9c2315e94d8d2f = $8b11dd70aaca6dbd$var$CACHE_KEY, $8b11dd70aaca6dbd$export$f01e5cd42b9ec146 = $8b11dd70aaca6dbd$var$CACHE_OPERATION, $8b11dd70aaca6dbd$export$987f6b4367434b55 = $8b11dd70aaca6dbd$var$CACHE_TTL, $8b11dd70aaca6dbd$export$d9d145585d5022bb = $8b11dd70aaca6dbd$var$CACHE_WRITE, $8b11dd70aaca6dbd$export$44ffba16bd48dac6 = $8b11dd70aaca6dbd$var$CHANNEL, $8b11dd70aaca6dbd$export$3134892c5d2e251a = $8b11dd70aaca6dbd$var$CLIENT_ADDRESS, $8b11dd70aaca6dbd$export$8495028d10296058 = $8b11dd70aaca6dbd$var$CLIENT_PORT, $8b11dd70aaca6dbd$export$d6d0e4fcf46d490c = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_DURATION, $8b11dd70aaca6dbd$export$658dced473c19301 = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_QUERY_TYPE, $8b11dd70aaca6dbd$export$97b0f9c3fbe64076 = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_READ, $8b11dd70aaca6dbd$export$cf2c95ed5efbe9eb = $8b11dd70aaca6dbd$var$CLOUDFLARE_D1_ROWS_WRITTEN, $8b11dd70aaca6dbd$export$880007904f61a388 = $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS, $8b11dd70aaca6dbd$export$3e903b72d4d9e07d = $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ, $8b11dd70aaca6dbd$export$34da07180e0e56af = $8b11dd70aaca6dbd$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN, $8b11dd70aaca6dbd$export$c49aafdaeb061953 = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_BUCKET, $8b11dd70aaca6dbd$export$ceb762c61de2f17f = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_OPERATION, $8b11dd70aaca6dbd$export$a5f54ccfb28c0caf = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_DELIMITER, $8b11dd70aaca6dbd$export$1c86a56857b024db = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_KEY, $8b11dd70aaca6dbd$export$7598f3464be47440 = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER, $8b11dd70aaca6dbd$export$b673289c971fc0ae = $8b11dd70aaca6dbd$var$CLOUDFLARE_R2_REQUEST_PREFIX, $8b11dd70aaca6dbd$export$98b23f3e6f0c2a6f = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_ATTEMPT, $8b11dd70aaca6dbd$export$6ddeaf0498614ebb = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF, $8b11dd70aaca6dbd$export$97b78f78d64a7232 = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY, $8b11dd70aaca6dbd$export$5147715be870fff7 = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT, $8b11dd70aaca6dbd$export$5276bb46e6096fba = $8b11dd70aaca6dbd$var$CLOUDFLARE_WORKFLOW_TIMEOUT, $8b11dd70aaca6dbd$export$cbcbc1f67a937cf3 = $8b11dd70aaca6dbd$var$CLOUD_ACCOUNT_ID, $8b11dd70aaca6dbd$export$226a2381b8f0cf78 = $8b11dd70aaca6dbd$var$CLOUD_AVAILABILITY_ZONE, $8b11dd70aaca6dbd$export$fd35512cae286064 = $8b11dd70aaca6dbd$var$CLOUD_PLATFORM, $8b11dd70aaca6dbd$export$de9bbf95ab1d81e = $8b11dd70aaca6dbd$var$CLOUD_PROVIDER, $8b11dd70aaca6dbd$export$47fb20e8d18d7d15 = $8b11dd70aaca6dbd$var$CLOUD_REGION, $8b11dd70aaca6dbd$export$9db7964e4b8cb849 = $8b11dd70aaca6dbd$var$CLOUD_RESOURCE_ID, $8b11dd70aaca6dbd$export$7139adf9d3bace41 = "cls", $8b11dd70aaca6dbd$export$8ac3d09060e7f25d = $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY, $8b11dd70aaca6dbd$export$dad0e4778ea23971 = $8b11dd70aaca6dbd$var$CLS_SOURCE_KEY_BASE, $8b11dd70aaca6dbd$export$c14d903ccf9385a8 = $8b11dd70aaca6dbd$var$CODE_FILEPATH, $8b11dd70aaca6dbd$export$934cded0041affd7 = $8b11dd70aaca6dbd$var$CODE_FILE_PATH, $8b11dd70aaca6dbd$export$6386da1dcba88c9d = $8b11dd70aaca6dbd$var$CODE_FUNCTION, $8b11dd70aaca6dbd$export$a3371797e606e2 = $8b11dd70aaca6dbd$var$CODE_FUNCTION_NAME, $8b11dd70aaca6dbd$export$a5bbef0af83b23e5 = $8b11dd70aaca6dbd$var$CODE_LINENO, $8b11dd70aaca6dbd$export$91ed1f55874222a6 = $8b11dd70aaca6dbd$var$CODE_LINE_NUMBER, $8b11dd70aaca6dbd$export$23de81068d2aed1b = $8b11dd70aaca6dbd$var$CODE_NAMESPACE, $8b11dd70aaca6dbd$export$d738320e1fba9e9d = $8b11dd70aaca6dbd$var$CONNECTIONTYPE, $8b11dd70aaca6dbd$export$2eacdea75497e8a5 = $8b11dd70aaca6dbd$var$CONNECTION_RTT, $8b11dd70aaca6dbd$export$2bc3ea101f86c1d2 = $8b11dd70aaca6dbd$var$CULTURE_CALENDAR, $8b11dd70aaca6dbd$export$c54e27e8d90ee081 = $8b11dd70aaca6dbd$var$CULTURE_DISPLAY_NAME, $8b11dd70aaca6dbd$export$4943adcec371c2a6 = $8b11dd70aaca6dbd$var$CULTURE_IS_24_HOUR_FORMAT, $8b11dd70aaca6dbd$export$f000a5900d0480c2 = $8b11dd70aaca6dbd$var$CULTURE_LOCALE, $8b11dd70aaca6dbd$export$8f5234893868273b = $8b11dd70aaca6dbd$var$CULTURE_TIMEZONE, $8b11dd70aaca6dbd$export$1a35518f6e81e8c7 = $8b11dd70aaca6dbd$var$DB_COLLECTION_NAME, $8b11dd70aaca6dbd$export$a2d90911eaae60fc = $8b11dd70aaca6dbd$var$DB_DRIVER_NAME, $8b11dd70aaca6dbd$export$3c22ff8b64b8f565 = $8b11dd70aaca6dbd$var$DB_NAME, $8b11dd70aaca6dbd$export$b8019c0e2a5b5f0f = $8b11dd70aaca6dbd$var$DB_NAMESPACE, $8b11dd70aaca6dbd$export$8c11477e471467c8 = $8b11dd70aaca6dbd$var$DB_OPERATION, $8b11dd70aaca6dbd$export$92a96f6363488aee = $8b11dd70aaca6dbd$var$DB_OPERATION_BATCH_SIZE, $8b11dd70aaca6dbd$export$f91beb6088f9ded9 = $8b11dd70aaca6dbd$var$DB_OPERATION_NAME, $8b11dd70aaca6dbd$export$78bc7224576bf289 = $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY, $8b11dd70aaca6dbd$export$a8027e0ea0d93ca = $8b11dd70aaca6dbd$var$DB_QUERY_PARAMETER_KEY_BASE, $8b11dd70aaca6dbd$export$5e59d3aea52e5037 = $8b11dd70aaca6dbd$var$DB_QUERY_SUMMARY, $8b11dd70aaca6dbd$export$47e408be0da7933f = $8b11dd70aaca6dbd$var$DB_QUERY_TEXT, $8b11dd70aaca6dbd$export$d5772b934ca13e57 = $8b11dd70aaca6dbd$var$DB_REDIS_CONNECTION, $8b11dd70aaca6dbd$export$36e47f6a5777561d = $8b11dd70aaca6dbd$var$DB_REDIS_KEY, $8b11dd70aaca6dbd$export$e768cbc99cd68acf = $8b11dd70aaca6dbd$var$DB_REDIS_PARAMETERS, $8b11dd70aaca6dbd$export$dfcc6c69df1343f2 = $8b11dd70aaca6dbd$var$DB_RESPONSE_STATUS_CODE, $8b11dd70aaca6dbd$export$69b0a5d9226b5211 = $8b11dd70aaca6dbd$var$DB_SQL_BINDINGS, $8b11dd70aaca6dbd$export$da010a4f4fc971ae = $8b11dd70aaca6dbd$var$DB_STATEMENT, $8b11dd70aaca6dbd$export$5d515b35be0601a0 = $8b11dd70aaca6dbd$var$DB_STORED_PROCEDURE_NAME, $8b11dd70aaca6dbd$export$3e1b1037a315c5ca = $8b11dd70aaca6dbd$var$DB_SYSTEM, $8b11dd70aaca6dbd$export$847fdd494825f0fb = $8b11dd70aaca6dbd$var$DB_SYSTEM_NAME, $8b11dd70aaca6dbd$export$a9d76f26c6c730a9 = $8b11dd70aaca6dbd$var$DB_USER, $8b11dd70aaca6dbd$export$de03f86d1c9866ca = $8b11dd70aaca6dbd$var$DEVICEMEMORY, $8b11dd70aaca6dbd$export$65798ecab7eef8c = $8b11dd70aaca6dbd$var$DEVICE_ARCHS, $8b11dd70aaca6dbd$export$22aa61f48b9c79a0 = $8b11dd70aaca6dbd$var$DEVICE_BATTERY_LEVEL, $8b11dd70aaca6dbd$export$69f5fb98f5aed812 = $8b11dd70aaca6dbd$var$DEVICE_BATTERY_TEMPERATURE, $8b11dd70aaca6dbd$export$bdea5d1006fd280a = $8b11dd70aaca6dbd$var$DEVICE_BOOT_TIME, $8b11dd70aaca6dbd$export$f63a7230c5b1d609 = $8b11dd70aaca6dbd$var$DEVICE_BRAND, $8b11dd70aaca6dbd$export$6f25e59b05bb8e17 = $8b11dd70aaca6dbd$var$DEVICE_CHARGING, $8b11dd70aaca6dbd$export$a56ad13c4afc7421 = $8b11dd70aaca6dbd$var$DEVICE_CHIPSET, $8b11dd70aaca6dbd$export$d9ce89ce8912bf12 = $8b11dd70aaca6dbd$var$DEVICE_CLASS, $8b11dd70aaca6dbd$export$17094e5f380e4162 = $8b11dd70aaca6dbd$var$DEVICE_CONNECTION_TYPE, $8b11dd70aaca6dbd$export$28a0ffdf747973a0 = $8b11dd70aaca6dbd$var$DEVICE_CPU_DESCRIPTION, $8b11dd70aaca6dbd$export$5480ae1ba5d50bb9 = $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_FREE_STORAGE, $8b11dd70aaca6dbd$export$edc72ee4a17f5152 = $8b11dd70aaca6dbd$var$DEVICE_EXTERNAL_STORAGE_SIZE, $8b11dd70aaca6dbd$export$19e4df138d354f8b = $8b11dd70aaca6dbd$var$DEVICE_FAMILY, $8b11dd70aaca6dbd$export$92b0d20fa482b4b2 = $8b11dd70aaca6dbd$var$DEVICE_FREE_MEMORY, $8b11dd70aaca6dbd$export$3f638a793d61933f = $8b11dd70aaca6dbd$var$DEVICE_FREE_STORAGE, $8b11dd70aaca6dbd$export$3f511731cc3687d4 = $8b11dd70aaca6dbd$var$DEVICE_ID, $8b11dd70aaca6dbd$export$692b08741d6b6265 = $8b11dd70aaca6dbd$var$DEVICE_LOCALE, $8b11dd70aaca6dbd$export$cf67f8cb2324428e = $8b11dd70aaca6dbd$var$DEVICE_LOW_MEMORY, $8b11dd70aaca6dbd$export$9d4197c1ffc5f359 = $8b11dd70aaca6dbd$var$DEVICE_LOW_POWER_MODE, $8b11dd70aaca6dbd$export$509634fbff540e75 = $8b11dd70aaca6dbd$var$DEVICE_MANUFACTURER, $8b11dd70aaca6dbd$export$ccbc4fdff4b5eff5 = $8b11dd70aaca6dbd$var$DEVICE_MEMORY_ESTIMATED_CAPACITY, $8b11dd70aaca6dbd$export$e0cb371ca548b1d6 = $8b11dd70aaca6dbd$var$DEVICE_MEMORY_SIZE, $8b11dd70aaca6dbd$export$3c39026d09026bc2 = $8b11dd70aaca6dbd$var$DEVICE_MODEL, $8b11dd70aaca6dbd$export$bf9e8248cb72cf00 = $8b11dd70aaca6dbd$var$DEVICE_MODEL_ID, $8b11dd70aaca6dbd$export$1054f22a72121d0f = $8b11dd70aaca6dbd$var$DEVICE_NAME, $8b11dd70aaca6dbd$export$723b8a59dad2e467 = $8b11dd70aaca6dbd$var$DEVICE_ONLINE, $8b11dd70aaca6dbd$export$160081ff141bac8e = $8b11dd70aaca6dbd$var$DEVICE_ORIENTATION, $8b11dd70aaca6dbd$export$194f62c84d27310 = $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_COUNT, $8b11dd70aaca6dbd$export$7ed866d57b018d09 = $8b11dd70aaca6dbd$var$DEVICE_PROCESSOR_FREQUENCY, $8b11dd70aaca6dbd$export$d50bae4562e03e5 = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DENSITY, $8b11dd70aaca6dbd$export$649ea67a18fe8e8b = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_DPI, $8b11dd70aaca6dbd$export$136a5c1b43caaccd = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_HEIGHT_PIXELS, $8b11dd70aaca6dbd$export$e33a28ea554b6ddc = $8b11dd70aaca6dbd$var$DEVICE_SCREEN_WIDTH_PIXELS, $8b11dd70aaca6dbd$export$acbe2d25ac76ea64 = $8b11dd70aaca6dbd$var$DEVICE_SIMULATOR, $8b11dd70aaca6dbd$export$793c13e17d7e5e2b = $8b11dd70aaca6dbd$var$DEVICE_STORAGE_SIZE, $8b11dd70aaca6dbd$export$a5617e33b89fd956 = $8b11dd70aaca6dbd$var$DEVICE_THERMAL_STATE, $8b11dd70aaca6dbd$export$b51f82164fa31e07 = $8b11dd70aaca6dbd$var$DEVICE_TIMEZONE, $8b11dd70aaca6dbd$export$f2ef55183c04d202 = $8b11dd70aaca6dbd$var$DEVICE_USABLE_MEMORY, $8b11dd70aaca6dbd$export$7c98fc0c48a16b1c = $8b11dd70aaca6dbd$var$DIST, $8b11dd70aaca6dbd$export$f0511e328234ae83 = $8b11dd70aaca6dbd$var$EFFECTIVECONNECTIONTYPE, $8b11dd70aaca6dbd$export$be46596bc6608f3b = $8b11dd70aaca6dbd$var$ENVIRONMENT, $8b11dd70aaca6dbd$export$f215947b3d76a6b7 = $8b11dd70aaca6dbd$var$ERROR_TYPE, $8b11dd70aaca6dbd$export$89bbc91416db6670 = $8b11dd70aaca6dbd$var$EVENT_ID, $8b11dd70aaca6dbd$export$b4b5eff8a8712c89 = $8b11dd70aaca6dbd$var$EVENT_NAME, $8b11dd70aaca6dbd$export$f455969a57ab8a03 = $8b11dd70aaca6dbd$var$EXCEPTION_ESCAPED, $8b11dd70aaca6dbd$export$13f2f8f42af49cec = $8b11dd70aaca6dbd$var$EXCEPTION_MESSAGE, $8b11dd70aaca6dbd$export$cd357afe2ffdd2c3 = $8b11dd70aaca6dbd$var$EXCEPTION_STACKTRACE, $8b11dd70aaca6dbd$export$d9ca2a279a11be5e = $8b11dd70aaca6dbd$var$EXCEPTION_TYPE, $8b11dd70aaca6dbd$export$bbd59a8c7efad4c9 = $8b11dd70aaca6dbd$var$FAAS_COLDSTART, $8b11dd70aaca6dbd$export$8413282a17f1cda5 = $8b11dd70aaca6dbd$var$FAAS_CRON, $8b11dd70aaca6dbd$export$30d19ddc7705e7e8 = $8b11dd70aaca6dbd$var$FAAS_DURATION_IN_MS, $8b11dd70aaca6dbd$export$64a4f09e2444b3d = $8b11dd70aaca6dbd$var$FAAS_ENTRY_POINT, $8b11dd70aaca6dbd$export$645b039fe163809e = $8b11dd70aaca6dbd$var$FAAS_EXECUTION, $8b11dd70aaca6dbd$export$b23ef8b8ffa607e1 = $8b11dd70aaca6dbd$var$FAAS_ID, $8b11dd70aaca6dbd$export$8bf64516740c1369 = $8b11dd70aaca6dbd$var$FAAS_IDENTITY, $8b11dd70aaca6dbd$export$9a0dc8e612f3e10b = $8b11dd70aaca6dbd$var$FAAS_INVOCATION_ID, $8b11dd70aaca6dbd$export$abe90fedb3dddda2 = $8b11dd70aaca6dbd$var$FAAS_INVOKED_NAME, $8b11dd70aaca6dbd$export$4a19da9c85ed2ade = $8b11dd70aaca6dbd$var$FAAS_INVOKED_PROVIDER, $8b11dd70aaca6dbd$export$5e091479f094bdbc = $8b11dd70aaca6dbd$var$FAAS_INVOKED_REGION, $8b11dd70aaca6dbd$export$d70909b5aa96a79a = $8b11dd70aaca6dbd$var$FAAS_NAME, $8b11dd70aaca6dbd$export$651d142a8017d83d = $8b11dd70aaca6dbd$var$FAAS_TIME, $8b11dd70aaca6dbd$export$44382a010a9f7fcf = $8b11dd70aaca6dbd$var$FAAS_TRIGGER, $8b11dd70aaca6dbd$export$807abfdc6b7b9338 = $8b11dd70aaca6dbd$var$FAAS_VERSION, $8b11dd70aaca6dbd$export$31881d07f2569218 = "fcp", $8b11dd70aaca6dbd$export$e5bbf306deb709a6 = $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY, $8b11dd70aaca6dbd$export$aa8721167c5c8d2d = $8b11dd70aaca6dbd$var$FLAG_EVALUATION_KEY_BASE, $8b11dd70aaca6dbd$export$757b93e5b3adc7cb = "fp", $8b11dd70aaca6dbd$export$f869eaa92db1dc9b = $8b11dd70aaca6dbd$var$FRAMES_DELAY, $8b11dd70aaca6dbd$export$5d1d761e41c32d9e = $8b11dd70aaca6dbd$var$FRAMES_FROZEN, $8b11dd70aaca6dbd$export$8aec72d9491f9399 = $8b11dd70aaca6dbd$var$FRAMES_FROZEN_RATE, $8b11dd70aaca6dbd$export$5562635d2be2ab25 = $8b11dd70aaca6dbd$var$FRAMES_SLOW, $8b11dd70aaca6dbd$export$2dc31837ce6f7a3d = $8b11dd70aaca6dbd$var$FRAMES_SLOW_RATE, $8b11dd70aaca6dbd$export$b561df15f64d32e3 = $8b11dd70aaca6dbd$var$FRAMES_TOTAL, $8b11dd70aaca6dbd$export$181f78b28f2ffa57 = $8b11dd70aaca6dbd$var$FS_ERROR, $8b11dd70aaca6dbd$export$6c97c77b89571c75 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_ID, $8b11dd70aaca6dbd$export$51e431eaf1f9bf58 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE, $8b11dd70aaca6dbd$export$71429c7ef7cb7063 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_ID, $8b11dd70aaca6dbd$export$99905d7583a6e8ac = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_RESOURCE, $8b11dd70aaca6dbd$export$b6c4be74fd0c06bd = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SOURCE, $8b11dd70aaca6dbd$export$fd23e5b8d261a89 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_SPECVERSION, $8b11dd70aaca6dbd$export$25fabc9b3d1dd567 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIME, $8b11dd70aaca6dbd$export$41507f7b07dad151 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TIMESTAMP, $8b11dd70aaca6dbd$export$1352f3699c35dd73 = $8b11dd70aaca6dbd$var$GCP_FUNCTION_CONTEXT_TYPE, $8b11dd70aaca6dbd$export$fd6c9d5c74d943ac = $8b11dd70aaca6dbd$var$GCP_PROJECT_ID, $8b11dd70aaca6dbd$export$c29634e3cf41e479 = $8b11dd70aaca6dbd$var$GEN_AI_AGENT_NAME, $8b11dd70aaca6dbd$export$e6a60882cce7a085 = $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_UTILIZATION, $8b11dd70aaca6dbd$export$6773c9098ba5e194 = $8b11dd70aaca6dbd$var$GEN_AI_CONTEXT_WINDOW_SIZE, $8b11dd70aaca6dbd$export$6ee6b62f50047686 = $8b11dd70aaca6dbd$var$GEN_AI_CONVERSATION_ID, $8b11dd70aaca6dbd$export$efac052bb3661242 = $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS, $8b11dd70aaca6dbd$export$7ccd63b9ca955862 = $8b11dd70aaca6dbd$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS, $8b11dd70aaca6dbd$export$50921df5a58cb3ef = $8b11dd70aaca6dbd$var$GEN_AI_COST_INPUT_TOKENS, $8b11dd70aaca6dbd$export$8e48efc7acb57a97 = $8b11dd70aaca6dbd$var$GEN_AI_COST_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$cea9121727113f77 = $8b11dd70aaca6dbd$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$bed35ff7f9af3aaa = $8b11dd70aaca6dbd$var$GEN_AI_COST_TOTAL_TOKENS, $8b11dd70aaca6dbd$export$6b729e898b9067ce = $8b11dd70aaca6dbd$var$GEN_AI_EMBEDDINGS_INPUT, $8b11dd70aaca6dbd$export$984fbab9b52f7e24 = $8b11dd70aaca6dbd$var$GEN_AI_FUNCTION_ID, $8b11dd70aaca6dbd$export$9ea17906a87ada6f = $8b11dd70aaca6dbd$var$GEN_AI_INPUT_MESSAGES, $8b11dd70aaca6dbd$export$394b443aaff3ef92 = $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_NAME, $8b11dd70aaca6dbd$export$6ddc374adbc06720 = $8b11dd70aaca6dbd$var$GEN_AI_OPERATION_TYPE, $8b11dd70aaca6dbd$export$ab8c7ebc9add56b2 = $8b11dd70aaca6dbd$var$GEN_AI_OUTPUT_MESSAGES, $8b11dd70aaca6dbd$export$40ecc5bcd633d1ee = $8b11dd70aaca6dbd$var$GEN_AI_PIPELINE_NAME, $8b11dd70aaca6dbd$export$86a8df7fff52fc69 = $8b11dd70aaca6dbd$var$GEN_AI_PROMPT, $8b11dd70aaca6dbd$export$cf2115d46768f4c5 = $8b11dd70aaca6dbd$var$GEN_AI_PROMPT_NAME, $8b11dd70aaca6dbd$export$3d7e036e195764db = $8b11dd70aaca6dbd$var$GEN_AI_PROVIDER_NAME, $8b11dd70aaca6dbd$export$60c1d11221608cee = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_AVAILABLE_TOOLS, $8b11dd70aaca6dbd$export$bc3cef164abbc42c = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_FREQUENCY_PENALTY, $8b11dd70aaca6dbd$export$43f9afb62cd79dec = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MAX_TOKENS, $8b11dd70aaca6dbd$export$a5ab4ffc4765f75f = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MESSAGES, $8b11dd70aaca6dbd$export$ccf46db9ab1743ec = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_MODEL, $8b11dd70aaca6dbd$export$76c1c247342d776 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_PRESENCE_PENALTY, $8b11dd70aaca6dbd$export$92f5944f0b02c9fb = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_REASONING_EFFORT, $8b11dd70aaca6dbd$export$867eeefcb1c95b27 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_SEED, $8b11dd70aaca6dbd$export$5ada4697ae6aa17e = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_STOP_SEQUENCES, $8b11dd70aaca6dbd$export$427122300e8d54d0 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TEMPERATURE, $8b11dd70aaca6dbd$export$bcea8881375c352f = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_K, $8b11dd70aaca6dbd$export$b867715f9a0c04e9 = $8b11dd70aaca6dbd$var$GEN_AI_REQUEST_TOP_P, $8b11dd70aaca6dbd$export$69878a39cbdbe097 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_FINISH_REASONS, $8b11dd70aaca6dbd$export$584c61a1b769552d = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_ID, $8b11dd70aaca6dbd$export$8169ebcb0b0331dd = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_MODEL, $8b11dd70aaca6dbd$export$2c9713b624877853 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_STREAMING, $8b11dd70aaca6dbd$export$45942692aeb454e0 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TEXT, $8b11dd70aaca6dbd$export$8e5efeaa031210cd = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK, $8b11dd70aaca6dbd$export$35a62769ee05a05a = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN, $8b11dd70aaca6dbd$export$8ea4f7e986ca4b06 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND, $8b11dd70aaca6dbd$export$d2fd9ecaff0285a4 = $8b11dd70aaca6dbd$var$GEN_AI_RESPONSE_TOOL_CALLS, $8b11dd70aaca6dbd$export$a6c8e656a4f9bb67 = $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM, $8b11dd70aaca6dbd$export$352a8075b163d53 = $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_INSTRUCTIONS, $8b11dd70aaca6dbd$export$426d7b90ba5d79db = $8b11dd70aaca6dbd$var$GEN_AI_SYSTEM_MESSAGE, $8b11dd70aaca6dbd$export$f5a1ee40934d19ce = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_ARGUMENTS, $8b11dd70aaca6dbd$export$1ba812a9756622ce = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_CALL_RESULT, $8b11dd70aaca6dbd$export$351120039c36e03 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DEFINITIONS, $8b11dd70aaca6dbd$export$d42aa25ca09e17c4 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_DESCRIPTION, $8b11dd70aaca6dbd$export$d268db29b88a4286 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_INPUT, $8b11dd70aaca6dbd$export$c5deb6018f2d6251 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_MESSAGE, $8b11dd70aaca6dbd$export$e06baa3034409453 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_NAME, $8b11dd70aaca6dbd$export$646fdb5910ce3931 = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_OUTPUT, $8b11dd70aaca6dbd$export$662e3d2d4361e29b = $8b11dd70aaca6dbd$var$GEN_AI_TOOL_TYPE, $8b11dd70aaca6dbd$export$1de3962f221ba441 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $8b11dd70aaca6dbd$export$a4b3f0f5499c8738 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $8b11dd70aaca6dbd$export$1aecdac6cecbdc5b = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_COMPLETION_TOKENS, $8b11dd70aaca6dbd$export$2eb2ab35b317a103 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS, $8b11dd70aaca6dbd$export$c7e14ea195ede241 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED, $8b11dd70aaca6dbd$export$41ac034e7b9725a2 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE, $8b11dd70aaca6dbd$export$9e521119d7751e37 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$cbac8f541a64a150 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING, $8b11dd70aaca6dbd$export$93dd08efa94c9dd4 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_PROMPT_TOKENS, $8b11dd70aaca6dbd$export$183e3523dac20bca = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, $8b11dd70aaca6dbd$export$3867ca1d8381d4e3 = $8b11dd70aaca6dbd$var$GEN_AI_USAGE_TOTAL_TOKENS, $8b11dd70aaca6dbd$export$11febcf9917c0057 = $8b11dd70aaca6dbd$var$GRAPHQL_DOCUMENT, $8b11dd70aaca6dbd$export$88ae1ee0c0a63398 = $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_NAME, $8b11dd70aaca6dbd$export$d5bd986d1f283f29 = $8b11dd70aaca6dbd$var$GRAPHQL_OPERATION_TYPE, $8b11dd70aaca6dbd$export$fc4a2d238535d998 = $8b11dd70aaca6dbd$var$HARDWARECONCURRENCY, $8b11dd70aaca6dbd$export$57e53a60bf563f41 = $8b11dd70aaca6dbd$var$HTTP_CLIENT_IP, $8b11dd70aaca6dbd$export$ffdb1464deb0eedb = $8b11dd70aaca6dbd$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH, $8b11dd70aaca6dbd$export$b52670c950fd640 = $8b11dd70aaca6dbd$var$HTTP_FLAVOR, $8b11dd70aaca6dbd$export$c499fd8f1db3d18e = $8b11dd70aaca6dbd$var$HTTP_FRAGMENT, $8b11dd70aaca6dbd$export$b2ee2242301eff05 = $8b11dd70aaca6dbd$var$HTTP_HOST, $8b11dd70aaca6dbd$export$2ebf9f7586f16841 = $8b11dd70aaca6dbd$var$HTTP_METHOD, $8b11dd70aaca6dbd$export$6e9ffd608b3e828b = $8b11dd70aaca6dbd$var$HTTP_QUERY, $8b11dd70aaca6dbd$export$b960c5a73a722e6c = $8b11dd70aaca6dbd$var$HTTP_REQUEST_BODY_DATA, $8b11dd70aaca6dbd$export$a7a850351369c77e = $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECTION_END, $8b11dd70aaca6dbd$export$b18bca78f4736a94 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_CONNECT_START, $8b11dd70aaca6dbd$export$61a0059f562fb6c2 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_END, $8b11dd70aaca6dbd$export$7dc0d5aefb816d91 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_DOMAIN_LOOKUP_START, $8b11dd70aaca6dbd$export$58f6db56c841bef6 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_FETCH_START, $8b11dd70aaca6dbd$export$97a3da679f509d5 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY, $8b11dd70aaca6dbd$export$c387ec65fd1c2638 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_HEADER_KEY_BASE, $8b11dd70aaca6dbd$export$4d9db82211f308a4 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_METHOD, $8b11dd70aaca6dbd$export$ee4948a3be025123 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_END, $8b11dd70aaca6dbd$export$e0021eb2979cddaa = $8b11dd70aaca6dbd$var$HTTP_REQUEST_REDIRECT_START, $8b11dd70aaca6dbd$export$7c0ac0c19a45beac = $8b11dd70aaca6dbd$var$HTTP_REQUEST_REQUEST_START, $8b11dd70aaca6dbd$export$6c32e9d84f534ee = $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESEND_COUNT, $8b11dd70aaca6dbd$export$d1f9fbdb211dd29b = $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_END, $8b11dd70aaca6dbd$export$45e7eea99a17d6e4 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_RESPONSE_START, $8b11dd70aaca6dbd$export$20ea34e16c0aa64f = $8b11dd70aaca6dbd$var$HTTP_REQUEST_SAME_ORIGIN, $8b11dd70aaca6dbd$export$8365b0f03557fae9 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_SECURE_CONNECTION_START, $8b11dd70aaca6dbd$export$49ebbb9621675650 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE, $8b11dd70aaca6dbd$export$842be66a901f093 = $8b11dd70aaca6dbd$var$HTTP_REQUEST_WORKER_START, $8b11dd70aaca6dbd$export$a9f5a6cb28adccb1 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_BODY_SIZE, $8b11dd70aaca6dbd$export$57b055d4bc586d67 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_CONTENT_LENGTH, $8b11dd70aaca6dbd$export$3ddfd660caa7bf7a = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH, $8b11dd70aaca6dbd$export$fa7e1f5305153b3d = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY, $8b11dd70aaca6dbd$export$5674ce9d013eb7bd = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_HEADER_KEY_BASE, $8b11dd70aaca6dbd$export$6e8dc14cff6ccf72 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_SIZE, $8b11dd70aaca6dbd$export$afd59480458e1b57 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_STATUS_CODE, $8b11dd70aaca6dbd$export$48e61fb9bccccba9 = $8b11dd70aaca6dbd$var$HTTP_RESPONSE_TRANSFER_SIZE, $8b11dd70aaca6dbd$export$d3e674514dd3a3e1 = $8b11dd70aaca6dbd$var$HTTP_ROUTE, $8b11dd70aaca6dbd$export$97ad02b50c60ef68 = $8b11dd70aaca6dbd$var$HTTP_SCHEME, $8b11dd70aaca6dbd$export$61d053b1b63e82c4 = $8b11dd70aaca6dbd$var$HTTP_SERVER_NAME, $8b11dd70aaca6dbd$export$54256cce0d674dea = $8b11dd70aaca6dbd$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE, $8b11dd70aaca6dbd$export$8c01f0f407bcc5ca = $8b11dd70aaca6dbd$var$HTTP_STATUS_CODE, $8b11dd70aaca6dbd$export$be3f46982f6c7160 = $8b11dd70aaca6dbd$var$HTTP_TARGET, $8b11dd70aaca6dbd$export$778e4213e2788579 = $8b11dd70aaca6dbd$var$HTTP_URL, $8b11dd70aaca6dbd$export$8b48ca3594d2b172 = $8b11dd70aaca6dbd$var$HTTP_USER_AGENT, $8b11dd70aaca6dbd$export$8be180ec26319f9f = "id", $8b11dd70aaca6dbd$export$60eccaddefa8fc1c = "inp", $8b11dd70aaca6dbd$export$c99ce4fe37484d84 = $8b11dd70aaca6dbd$var$JSONRPC_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$fdf432fcac7d8f37 = $8b11dd70aaca6dbd$var$JSONRPC_REQUEST_ID, $8b11dd70aaca6dbd$export$4c21cc9cdf2f5dbd = $8b11dd70aaca6dbd$var$JVM_GC_ACTION, $8b11dd70aaca6dbd$export$dcc1eab7f3f31816 = $8b11dd70aaca6dbd$var$JVM_GC_NAME, $8b11dd70aaca6dbd$export$dcb7f1379b2b8f86 = $8b11dd70aaca6dbd$var$JVM_MEMORY_POOL_NAME, $8b11dd70aaca6dbd$export$53416edeea4c2d74 = $8b11dd70aaca6dbd$var$JVM_MEMORY_TYPE, $8b11dd70aaca6dbd$export$69f7e5d2b74c5c9e = $8b11dd70aaca6dbd$var$JVM_THREAD_DAEMON, $8b11dd70aaca6dbd$export$8e104aed582a26bc = $8b11dd70aaca6dbd$var$JVM_THREAD_STATE, $8b11dd70aaca6dbd$export$577047501949be9 = $8b11dd70aaca6dbd$var$KOA_NAME, $8b11dd70aaca6dbd$export$c4c45b599a2c15e = $8b11dd70aaca6dbd$var$KOA_TYPE, $8b11dd70aaca6dbd$export$361cb541700d648e = "lcp", $8b11dd70aaca6dbd$export$974f160e11f25731 = $8b11dd70aaca6dbd$var$LCP_ELEMENT, $8b11dd70aaca6dbd$export$7162f5c702b95903 = $8b11dd70aaca6dbd$var$LCP_ID, $8b11dd70aaca6dbd$export$a034d066a9090500 = $8b11dd70aaca6dbd$var$LCP_LOADTIME, $8b11dd70aaca6dbd$export$70938021e43e047c = $8b11dd70aaca6dbd$var$LCP_RENDERTIME, $8b11dd70aaca6dbd$export$5f6ac460012a73bb = $8b11dd70aaca6dbd$var$LCP_SIZE, $8b11dd70aaca6dbd$export$d8e498c1c670bcbf = $8b11dd70aaca6dbd$var$LCP_URL, $8b11dd70aaca6dbd$export$cc1a78a24d947903 = $8b11dd70aaca6dbd$var$LOGGER_NAME, $8b11dd70aaca6dbd$export$d29b927e0bb0ffea = $8b11dd70aaca6dbd$var$MCP_CANCELLED_REASON, $8b11dd70aaca6dbd$export$b3999cacef245779 = $8b11dd70aaca6dbd$var$MCP_CANCELLED_REQUEST_ID, $8b11dd70aaca6dbd$export$ff168b5f9cf9dcf6 = $8b11dd70aaca6dbd$var$MCP_CLIENT_NAME, $8b11dd70aaca6dbd$export$2ab876a45bd6e64 = $8b11dd70aaca6dbd$var$MCP_CLIENT_TITLE, $8b11dd70aaca6dbd$export$cb8027e4395c6c0e = $8b11dd70aaca6dbd$var$MCP_CLIENT_VERSION, $8b11dd70aaca6dbd$export$f5303d1bac3c2660 = $8b11dd70aaca6dbd$var$MCP_LIFECYCLE_PHASE, $8b11dd70aaca6dbd$export$6c463c5f3b00f64 = $8b11dd70aaca6dbd$var$MCP_LOGGING_DATA_TYPE, $8b11dd70aaca6dbd$export$e25d553065457cab = $8b11dd70aaca6dbd$var$MCP_LOGGING_LEVEL, $8b11dd70aaca6dbd$export$15d24c154ea8a56f = $8b11dd70aaca6dbd$var$MCP_LOGGING_LOGGER, $8b11dd70aaca6dbd$export$e5065789a6c415d0 = $8b11dd70aaca6dbd$var$MCP_LOGGING_MESSAGE, $8b11dd70aaca6dbd$export$62662c561d7c7835 = $8b11dd70aaca6dbd$var$MCP_METHOD_NAME, $8b11dd70aaca6dbd$export$218f394557fb0a5a = $8b11dd70aaca6dbd$var$MCP_PROGRESS_CURRENT, $8b11dd70aaca6dbd$export$2a5ff6de5448ecdf = $8b11dd70aaca6dbd$var$MCP_PROGRESS_MESSAGE, $8b11dd70aaca6dbd$export$9d23f3030ed2597e = $8b11dd70aaca6dbd$var$MCP_PROGRESS_PERCENTAGE, $8b11dd70aaca6dbd$export$a26ff217a6124160 = $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOKEN, $8b11dd70aaca6dbd$export$c8072f5fcfdb5b77 = $8b11dd70aaca6dbd$var$MCP_PROGRESS_TOTAL, $8b11dd70aaca6dbd$export$c4e4b74f1ccf3d96 = $8b11dd70aaca6dbd$var$MCP_PROMPT_NAME, $8b11dd70aaca6dbd$export$328519d02a26ac41 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_DESCRIPTION, $8b11dd70aaca6dbd$export$d2061b291c43d045 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT, $8b11dd70aaca6dbd$export$d1f04dfd3d695286 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_COUNT, $8b11dd70aaca6dbd$export$234fbd86ea0f0bd8 = $8b11dd70aaca6dbd$var$MCP_PROMPT_RESULT_MESSAGE_ROLE, $8b11dd70aaca6dbd$export$e795000978a75b12 = $8b11dd70aaca6dbd$var$MCP_PROTOCOL_READY, $8b11dd70aaca6dbd$export$9f4683b4d1018ace = $8b11dd70aaca6dbd$var$MCP_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$e431b042fcdb1d63 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY, $8b11dd70aaca6dbd$export$a453239171ac9a23 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_KEY_BASE, $8b11dd70aaca6dbd$export$3a7726a976c18d5f = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_NAME, $8b11dd70aaca6dbd$export$7eca7a6c06843b93 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ARGUMENT_URI, $8b11dd70aaca6dbd$export$f25c55f83e5b0672 = $8b11dd70aaca6dbd$var$MCP_REQUEST_ID, $8b11dd70aaca6dbd$export$9562bfac4eb079cb = $8b11dd70aaca6dbd$var$MCP_RESOURCE_PROTOCOL, $8b11dd70aaca6dbd$export$c276d164ff91d2f7 = $8b11dd70aaca6dbd$var$MCP_RESOURCE_URI, $8b11dd70aaca6dbd$export$2f3e0574f1a99754 = $8b11dd70aaca6dbd$var$MCP_SERVER_NAME, $8b11dd70aaca6dbd$export$15eecaab68167880 = $8b11dd70aaca6dbd$var$MCP_SERVER_TITLE, $8b11dd70aaca6dbd$export$513c47f6e194086a = $8b11dd70aaca6dbd$var$MCP_SERVER_VERSION, $8b11dd70aaca6dbd$export$a3f464c4d5cd9096 = $8b11dd70aaca6dbd$var$MCP_SESSION_ID, $8b11dd70aaca6dbd$export$ed366a03a2330b03 = $8b11dd70aaca6dbd$var$MCP_TOOL_NAME, $8b11dd70aaca6dbd$export$9b802c784f235e1d = $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT, $8b11dd70aaca6dbd$export$add0fc8b8c5726a4 = $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_CONTENT_COUNT, $8b11dd70aaca6dbd$export$e7f32463f5bfd554 = $8b11dd70aaca6dbd$var$MCP_TOOL_RESULT_IS_ERROR, $8b11dd70aaca6dbd$export$f9346f394edf26a = $8b11dd70aaca6dbd$var$MCP_TRANSPORT, $8b11dd70aaca6dbd$export$16b917774e73ef92 = $8b11dd70aaca6dbd$var$MDC_KEY, $8b11dd70aaca6dbd$export$15d2b60bf3b65454 = "mdc", $8b11dd70aaca6dbd$export$db55eca5af256142 = $8b11dd70aaca6dbd$var$MESSAGING_BATCH_MESSAGE_COUNT, $8b11dd70aaca6dbd$export$967c74f8b1f3d35 = $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION, $8b11dd70aaca6dbd$export$7c33ae67962515d1 = $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_CONNECTION, $8b11dd70aaca6dbd$export$9c69839b2d93489b = $8b11dd70aaca6dbd$var$MESSAGING_DESTINATION_NAME, $8b11dd70aaca6dbd$export$be22d22d4b6cf5d8 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_BODY_SIZE, $8b11dd70aaca6dbd$export$c529961b911626ac = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_CONVERSATION_ID, $8b11dd70aaca6dbd$export$e39c4b15d2881f5 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ENVELOPE_SIZE, $8b11dd70aaca6dbd$export$a8ca145161313e7 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_ID, $8b11dd70aaca6dbd$export$3c1204d03918d076 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RECEIVE_LATENCY, $8b11dd70aaca6dbd$export$eaac3f141165e288 = $8b11dd70aaca6dbd$var$MESSAGING_MESSAGE_RETRY_COUNT, $8b11dd70aaca6dbd$export$4c7e6934714150e6 = $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_NAME, $8b11dd70aaca6dbd$export$6f71f9711d666eb4 = $8b11dd70aaca6dbd$var$MESSAGING_OPERATION_TYPE, $8b11dd70aaca6dbd$export$2a3cd2bb71fb63a4 = $8b11dd70aaca6dbd$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY, $8b11dd70aaca6dbd$export$55478a0b7d2ae98f = $8b11dd70aaca6dbd$var$MESSAGING_SYSTEM, $8b11dd70aaca6dbd$export$bed10c4da9b8eb0a = $8b11dd70aaca6dbd$var$METHOD, $8b11dd70aaca6dbd$export$a82607b6424c06c8 = $8b11dd70aaca6dbd$var$MIDDLEWARE_NAME, $8b11dd70aaca6dbd$export$6b081f3484c7f4e5 = $8b11dd70aaca6dbd$var$NAVIGATION_ORIGIN, $8b11dd70aaca6dbd$export$b7754d85fd39406c = $8b11dd70aaca6dbd$var$NAVIGATION_ROUTE_ID, $8b11dd70aaca6dbd$export$492856c046eb4728 = $8b11dd70aaca6dbd$var$NAVIGATION_TYPE, $8b11dd70aaca6dbd$export$c1678a2059fbe906 = $8b11dd70aaca6dbd$var$NEL_ELAPSED_TIME, $8b11dd70aaca6dbd$export$6d384a0bc1011c34 = $8b11dd70aaca6dbd$var$NEL_PHASE, $8b11dd70aaca6dbd$export$1499a7dbfc01e7d4 = $8b11dd70aaca6dbd$var$NEL_REFERRER, $8b11dd70aaca6dbd$export$cfcbff40019f0ff1 = $8b11dd70aaca6dbd$var$NEL_SAMPLING_FUNCTION, $8b11dd70aaca6dbd$export$27157b5f68e583af = $8b11dd70aaca6dbd$var$NEL_TYPE, $8b11dd70aaca6dbd$export$54bf5ed61532925d = $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_EFFECTIVE_TYPE, $8b11dd70aaca6dbd$export$60ed0786292ace08 = $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_RTT, $8b11dd70aaca6dbd$export$d770bfb8345e146 = $8b11dd70aaca6dbd$var$NETWORK_CONNECTION_TYPE, $8b11dd70aaca6dbd$export$bb73817f1290ad28 = $8b11dd70aaca6dbd$var$NETWORK_LOCAL_ADDRESS, $8b11dd70aaca6dbd$export$f201c980f2b75802 = $8b11dd70aaca6dbd$var$NETWORK_LOCAL_PORT, $8b11dd70aaca6dbd$export$b40e970572afd0ee = $8b11dd70aaca6dbd$var$NETWORK_PEER_ADDRESS, $8b11dd70aaca6dbd$export$8850630a3d343488 = $8b11dd70aaca6dbd$var$NETWORK_PEER_PORT, $8b11dd70aaca6dbd$export$fd0a39a918d6516f = $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_NAME, $8b11dd70aaca6dbd$export$e68ef41f8e0335bf = $8b11dd70aaca6dbd$var$NETWORK_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$5bff09650e762829 = $8b11dd70aaca6dbd$var$NETWORK_TRANSPORT, $8b11dd70aaca6dbd$export$21c1adce0e067f37 = $8b11dd70aaca6dbd$var$NETWORK_TYPE, $8b11dd70aaca6dbd$export$fed6ce86f48c84bc = $8b11dd70aaca6dbd$var$NET_HOST_IP, $8b11dd70aaca6dbd$export$500c2675137ac16e = $8b11dd70aaca6dbd$var$NET_HOST_NAME, $8b11dd70aaca6dbd$export$402c7728623fd8df = $8b11dd70aaca6dbd$var$NET_HOST_PORT, $8b11dd70aaca6dbd$export$15417259f4c0fe6b = $8b11dd70aaca6dbd$var$NET_PEER_IP, $8b11dd70aaca6dbd$export$2b3b7f579a727f45 = $8b11dd70aaca6dbd$var$NET_PEER_NAME, $8b11dd70aaca6dbd$export$514832a0b029734b = $8b11dd70aaca6dbd$var$NET_PEER_PORT, $8b11dd70aaca6dbd$export$b0522e6a14dec1a4 = $8b11dd70aaca6dbd$var$NET_PROTOCOL_NAME, $8b11dd70aaca6dbd$export$659ea19f71a7ee0b = $8b11dd70aaca6dbd$var$NET_PROTOCOL_VERSION, $8b11dd70aaca6dbd$export$1b61d972db315e73 = $8b11dd70aaca6dbd$var$NET_SOCK_FAMILY, $8b11dd70aaca6dbd$export$fb2970ee11a479ee = $8b11dd70aaca6dbd$var$NET_SOCK_HOST_ADDR, $8b11dd70aaca6dbd$export$920aceb2a8fad77e = $8b11dd70aaca6dbd$var$NET_SOCK_HOST_PORT, $8b11dd70aaca6dbd$export$48f8f6fbc999d187 = $8b11dd70aaca6dbd$var$NET_SOCK_PEER_ADDR, $8b11dd70aaca6dbd$export$eed590fa00a8223b = $8b11dd70aaca6dbd$var$NET_SOCK_PEER_NAME, $8b11dd70aaca6dbd$export$f2e5bb5cd4a130da = $8b11dd70aaca6dbd$var$NET_SOCK_PEER_PORT, $8b11dd70aaca6dbd$export$779ef03d633a9086 = $8b11dd70aaca6dbd$var$NET_TRANSPORT, $8b11dd70aaca6dbd$export$d98b87c8d53d0dbc = $8b11dd70aaca6dbd$var$OS_BUILD, $8b11dd70aaca6dbd$export$ca719aa57653a0a7 = $8b11dd70aaca6dbd$var$OS_BUILD_ID, $8b11dd70aaca6dbd$export$74b19c5f48270c05 = $8b11dd70aaca6dbd$var$OS_DESCRIPTION, $8b11dd70aaca6dbd$export$c351affe7e8098cb = $8b11dd70aaca6dbd$var$OS_KERNEL_VERSION, $8b11dd70aaca6dbd$export$be7cd6b3ae3ae765 = $8b11dd70aaca6dbd$var$OS_NAME, $8b11dd70aaca6dbd$export$ec182524c4c57275 = $8b11dd70aaca6dbd$var$OS_RAW_DESCRIPTION, $8b11dd70aaca6dbd$export$9e45758246a85b07 = $8b11dd70aaca6dbd$var$OS_ROOTED, $8b11dd70aaca6dbd$export$9fa5d5f0144954cb = $8b11dd70aaca6dbd$var$OS_THEME, $8b11dd70aaca6dbd$export$e66ba5bc4b978023 = $8b11dd70aaca6dbd$var$OS_TYPE, $8b11dd70aaca6dbd$export$2306e23cc611a36d = $8b11dd70aaca6dbd$var$OS_VERSION, $8b11dd70aaca6dbd$export$144f8c1fe01428db = $8b11dd70aaca6dbd$var$OTEL_KIND, $8b11dd70aaca6dbd$export$f303b2744d52121c = $8b11dd70aaca6dbd$var$OTEL_SCOPE_NAME, $8b11dd70aaca6dbd$export$866b2dbc7bf18ce6 = $8b11dd70aaca6dbd$var$OTEL_SCOPE_VERSION, $8b11dd70aaca6dbd$export$b4c85774878b4841 = $8b11dd70aaca6dbd$var$OTEL_STATUS_CODE, $8b11dd70aaca6dbd$export$1c967a71bc9a3077 = $8b11dd70aaca6dbd$var$OTEL_STATUS_DESCRIPTION, $8b11dd70aaca6dbd$export$5e3884a35a19eb90 = $8b11dd70aaca6dbd$var$PARAMS_KEY, $8b11dd70aaca6dbd$export$6e7ff99bb3259573 = $8b11dd70aaca6dbd$var$PARAMS_KEY_BASE, $8b11dd70aaca6dbd$export$7c932cba2d9e7a7 = $8b11dd70aaca6dbd$var$PERFORMANCE_ACTIVATIONSTART, $8b11dd70aaca6dbd$export$94091942edce0667 = $8b11dd70aaca6dbd$var$PERFORMANCE_TIMEORIGIN, $8b11dd70aaca6dbd$export$3671a8a524706a9d = $8b11dd70aaca6dbd$var$PREVIOUS_ROUTE, $8b11dd70aaca6dbd$export$c288888dc82d233f = $8b11dd70aaca6dbd$var$PROCESS_COMMAND_ARGS, $8b11dd70aaca6dbd$export$8ff188536cebc35 = $8b11dd70aaca6dbd$var$PROCESS_EXECUTABLE_NAME, $8b11dd70aaca6dbd$export$6407d78968c0eabe = $8b11dd70aaca6dbd$var$PROCESS_PID, $8b11dd70aaca6dbd$export$43e9fb9ec28d9743 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_DESCRIPTION, $8b11dd70aaca6dbd$export$26f31d5c5c201739 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_NAME, $8b11dd70aaca6dbd$export$bff85124d2d35b93 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_ENGINE_VERSION, $8b11dd70aaca6dbd$export$495c671ed5a6408c = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_NAME, $8b11dd70aaca6dbd$export$54b3d4d5548c35c3 = $8b11dd70aaca6dbd$var$PROCESS_RUNTIME_VERSION, $8b11dd70aaca6dbd$export$2954db6444fe1fa8 = $8b11dd70aaca6dbd$var$QUERY_KEY, $8b11dd70aaca6dbd$export$15c1c974d16dd678 = $8b11dd70aaca6dbd$var$QUERY_KEY_BASE, $8b11dd70aaca6dbd$export$9be2ae89a1eac217 = $8b11dd70aaca6dbd$var$REACT_VERSION, $8b11dd70aaca6dbd$export$5c698591c0e586a2 = $8b11dd70aaca6dbd$var$RELEASE, $8b11dd70aaca6dbd$export$b711f2bb9c9a848a = $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY, $8b11dd70aaca6dbd$export$1d3a8501efd30213 = $8b11dd70aaca6dbd$var$REMIX_ACTION_FORM_DATA_KEY_BASE, $8b11dd70aaca6dbd$export$cebaf684ced5a2c9 = $8b11dd70aaca6dbd$var$REPLAY_ID, $8b11dd70aaca6dbd$export$d4c658ecdcb7c78c = $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT, $8b11dd70aaca6dbd$export$b1b162b01baeb044 = $8b11dd70aaca6dbd$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME, $8b11dd70aaca6dbd$export$8be2d593d7f88ed8 = $8b11dd70aaca6dbd$var$RESOURCE_RENDER_BLOCKING_STATUS, $8b11dd70aaca6dbd$export$dbd0a3528a97ccc0 = $8b11dd70aaca6dbd$var$ROUTE, $8b11dd70aaca6dbd$export$66581dc6d3d083d1 = $8b11dd70aaca6dbd$var$RPC_GRPC_STATUS_CODE, $8b11dd70aaca6dbd$export$e545f99e7abcc499 = $8b11dd70aaca6dbd$var$RPC_METHOD, $8b11dd70aaca6dbd$export$7e1af5787f8c4aaa = $8b11dd70aaca6dbd$var$RPC_RESPONSE_STATUS_CODE, $8b11dd70aaca6dbd$export$186c94c351c54768 = $8b11dd70aaca6dbd$var$RPC_SERVICE, $8b11dd70aaca6dbd$export$2e3fd8dfcb16fe0c = $8b11dd70aaca6dbd$var$RPC_SYSTEM, $8b11dd70aaca6dbd$export$7eeeceaa1dbd7cd5 = $8b11dd70aaca6dbd$var$RPC_SYSTEM_NAME, $8b11dd70aaca6dbd$export$9d5bffdff936d554 = $8b11dd70aaca6dbd$var$RUNTIME_BUILD, $8b11dd70aaca6dbd$export$dc3a801c9a2c5b79 = $8b11dd70aaca6dbd$var$RUNTIME_NAME, $8b11dd70aaca6dbd$export$27933a9557f87e98 = $8b11dd70aaca6dbd$var$RUNTIME_RAW_DESCRIPTION, $8b11dd70aaca6dbd$export$eefa737b40a0d535 = $8b11dd70aaca6dbd$var$RUNTIME_VERSION, $8b11dd70aaca6dbd$export$92740ffbcb02553b = $8b11dd70aaca6dbd$var$SCORE_KEY, $8b11dd70aaca6dbd$export$500e89753f9f1008 = $8b11dd70aaca6dbd$var$SCORE_KEY_BASE, $8b11dd70aaca6dbd$export$d91a18e47fdddefd = $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY, $8b11dd70aaca6dbd$export$eccbe6f20884ea7f = $8b11dd70aaca6dbd$var$SCORE_RATIO_KEY_BASE, $8b11dd70aaca6dbd$export$9e24f11d79141afb = $8b11dd70aaca6dbd$var$SCORE_TOTAL, $8b11dd70aaca6dbd$export$f0b96ad9586f8887 = $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY, $8b11dd70aaca6dbd$export$8a92ed5d436a85c6 = $8b11dd70aaca6dbd$var$SCORE_WEIGHT_KEY_BASE, $8b11dd70aaca6dbd$export$edd59acdf7e86a71 = $8b11dd70aaca6dbd$var$SENTRY_ACTION, $8b11dd70aaca6dbd$export$ae81a1ae71952d50 = $8b11dd70aaca6dbd$var$SENTRY_BROWSER_NAME, $8b11dd70aaca6dbd$export$6101470cd57eac1b = $8b11dd70aaca6dbd$var$SENTRY_BROWSER_VERSION, $8b11dd70aaca6dbd$export$452c0aee9673fe67 = $8b11dd70aaca6dbd$var$SENTRY_CANCELLATION_REASON, $8b11dd70aaca6dbd$export$773dddd1e8667756 = $8b11dd70aaca6dbd$var$SENTRY_CATEGORY, $8b11dd70aaca6dbd$export$98815f8579a64a90 = $8b11dd70aaca6dbd$var$SENTRY_CLIENT_SAMPLE_RATE, $8b11dd70aaca6dbd$export$7bc4e27428665019 = $8b11dd70aaca6dbd$var$SENTRY_DESCRIPTION, $8b11dd70aaca6dbd$export$e7d7477fa9057ee2 = $8b11dd70aaca6dbd$var$SENTRY_DIST, $8b11dd70aaca6dbd$export$1f4267a3fc018448 = $8b11dd70aaca6dbd$var$SENTRY_DOMAIN, $8b11dd70aaca6dbd$export$c171cae150389952 = $8b11dd70aaca6dbd$var$SENTRY_DSC_ENVIRONMENT, $8b11dd70aaca6dbd$export$d9bb35e957b22c72 = $8b11dd70aaca6dbd$var$SENTRY_DSC_PROJECT_ID, $8b11dd70aaca6dbd$export$b3508a2c95f74e3d = $8b11dd70aaca6dbd$var$SENTRY_DSC_PUBLIC_KEY, $8b11dd70aaca6dbd$export$20bb272f4d21532d = $8b11dd70aaca6dbd$var$SENTRY_DSC_RELEASE, $8b11dd70aaca6dbd$export$d7e64fbd0102ce90 = $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLED, $8b11dd70aaca6dbd$export$c17eae7e86dbba3c = $8b11dd70aaca6dbd$var$SENTRY_DSC_SAMPLE_RATE, $8b11dd70aaca6dbd$export$349603c0a9165744 = $8b11dd70aaca6dbd$var$SENTRY_DSC_TRACE_ID, $8b11dd70aaca6dbd$export$4dadf693741f0283 = $8b11dd70aaca6dbd$var$SENTRY_DSC_TRANSACTION, $8b11dd70aaca6dbd$export$6377864d12f7eeb3 = $8b11dd70aaca6dbd$var$SENTRY_ENVIRONMENT, $8b11dd70aaca6dbd$export$ba081af9585ed4 = $8b11dd70aaca6dbd$var$SENTRY_EXCLUSIVE_TIME, $8b11dd70aaca6dbd$export$7841dacb241485d0 = $8b11dd70aaca6dbd$var$SENTRY_GRAPHQL_OPERATION, $8b11dd70aaca6dbd$export$52c7044cf6301362 = $8b11dd70aaca6dbd$var$SENTRY_GROUP, $8b11dd70aaca6dbd$export$56ea1c9e44590e20 = $8b11dd70aaca6dbd$var$SENTRY_HTTP_PREFETCH, $8b11dd70aaca6dbd$export$7626e389d05f4c36 = $8b11dd70aaca6dbd$var$SENTRY_IDLE_SPAN_FINISH_REASON, $8b11dd70aaca6dbd$export$5e0a48187329b2e7 = $8b11dd70aaca6dbd$var$SENTRY_IS_REMOTE, $8b11dd70aaca6dbd$export$c322b150d7667841 = $8b11dd70aaca6dbd$var$SENTRY_KIND, $8b11dd70aaca6dbd$export$4a4797d3c962f753 = $8b11dd70aaca6dbd$var$SENTRY_MAIN_THREAD, $8b11dd70aaca6dbd$export$767524d5e72e2645 = $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_PARAMETER_KEY, $8b11dd70aaca6dbd$export$497354ca7b0ee666 = $8b11dd70aaca6dbd$var$SENTRY_MESSAGE_TEMPLATE, $8b11dd70aaca6dbd$export$cbdc4ad11118116a = $8b11dd70aaca6dbd$var$SENTRY_METRIC_SOURCE, $8b11dd70aaca6dbd$export$5b890de778c4c2fe = $8b11dd70aaca6dbd$var$SENTRY_MOBILE, $8b11dd70aaca6dbd$export$a78d9803b5e0a83e = $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY, $8b11dd70aaca6dbd$export$df1b536467b3992a = $8b11dd70aaca6dbd$var$SENTRY_MODULE_KEY_BASE, $8b11dd70aaca6dbd$export$73104a329e205998 = $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE, $8b11dd70aaca6dbd$export$5740e3da55330b0a = $8b11dd70aaca6dbd$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE, $8b11dd70aaca6dbd$export$8dcc2d92ff6d65da = $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY, $8b11dd70aaca6dbd$export$e5f1321e53e24810 = $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DB_QUERY_HASH, $8b11dd70aaca6dbd$export$56dd3098cbca7c8a = $8b11dd70aaca6dbd$var$SENTRY_NORMALIZED_DESCRIPTION, $8b11dd70aaca6dbd$export$aa7aff70e4380665 = $8b11dd70aaca6dbd$var$SENTRY_OBSERVED_TIMESTAMP_NANOS, $8b11dd70aaca6dbd$export$dacb7d452aa6bcaf = $8b11dd70aaca6dbd$var$SENTRY_OP, $8b11dd70aaca6dbd$export$15dfc6c5e8f9baf6 = $8b11dd70aaca6dbd$var$SENTRY_ORIGIN, $8b11dd70aaca6dbd$export$91ad03bba7909fb5 = $8b11dd70aaca6dbd$var$SENTRY_PLATFORM, $8b11dd70aaca6dbd$export$86128e6c0ab71d64 = $8b11dd70aaca6dbd$var$SENTRY_PROFILER_ID, $8b11dd70aaca6dbd$export$745b60c4819aec1d = $8b11dd70aaca6dbd$var$SENTRY_PROFILE_ID, $8b11dd70aaca6dbd$export$d2c893bfac1da9a1 = $8b11dd70aaca6dbd$var$SENTRY_RELEASE, $8b11dd70aaca6dbd$export$1c14ad02f9534b19 = $8b11dd70aaca6dbd$var$SENTRY_REPLAY_ID, $8b11dd70aaca6dbd$export$db3cb63e0594d014 = $8b11dd70aaca6dbd$var$SENTRY_REPLAY_IS_BUFFERING, $8b11dd70aaca6dbd$export$a65c9a0eba2c222d = $8b11dd70aaca6dbd$var$SENTRY_REPORT_EVENT, $8b11dd70aaca6dbd$export$68dbcca9c0e339ec = $8b11dd70aaca6dbd$var$SENTRY_SDK_INTEGRATIONS, $8b11dd70aaca6dbd$export$d59b669d4bb3f006 = $8b11dd70aaca6dbd$var$SENTRY_SDK_NAME, $8b11dd70aaca6dbd$export$4d88d347aa9667fc = $8b11dd70aaca6dbd$var$SENTRY_SDK_VERSION, $8b11dd70aaca6dbd$export$9943ffdcaa4bc506 = $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_ID, $8b11dd70aaca6dbd$export$d4f25b923533dbba = $8b11dd70aaca6dbd$var$SENTRY_SEGMENT_NAME, $8b11dd70aaca6dbd$export$35f3396a1cdeea45 = $8b11dd70aaca6dbd$var$SENTRY_SERVER_SAMPLE_RATE, $8b11dd70aaca6dbd$export$80e399da474bc98d = $8b11dd70aaca6dbd$var$SENTRY_SOURCE, $8b11dd70aaca6dbd$export$e01809e2dbceac35 = $8b11dd70aaca6dbd$var$SENTRY_SPAN_SOURCE, $8b11dd70aaca6dbd$export$41900d5c4e8a9c68 = $8b11dd70aaca6dbd$var$SENTRY_STATUS, $8b11dd70aaca6dbd$export$362bb1cb0bb5ca03 = $8b11dd70aaca6dbd$var$SENTRY_STATUS_CODE, $8b11dd70aaca6dbd$export$6803ac54f919d9cc = $8b11dd70aaca6dbd$var$SENTRY_STATUS_MESSAGE, $8b11dd70aaca6dbd$export$72f5b47540331169 = $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_FROM, $8b11dd70aaca6dbd$export$6c61a8c9aa5305cb = $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TO, $8b11dd70aaca6dbd$export$6b5244c457b68e65 = $8b11dd70aaca6dbd$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE, $8b11dd70aaca6dbd$export$b7bd0c9a886f3414 = $8b11dd70aaca6dbd$var$SENTRY_THREAD_ID, $8b11dd70aaca6dbd$export$6b77f2bacac7c93d = $8b11dd70aaca6dbd$var$SENTRY_TIMESTAMP_SEQUENCE, $8b11dd70aaca6dbd$export$ddbc15c0e8e8a7ea = $8b11dd70aaca6dbd$var$SENTRY_TRACE_LIFECYCLE, $8b11dd70aaca6dbd$export$feb4fe753df28a82 = $8b11dd70aaca6dbd$var$SENTRY_TRACE_PARENT_SPAN_ID, $8b11dd70aaca6dbd$export$d6267756132e2175 = $8b11dd70aaca6dbd$var$SENTRY_TRACE_STATUS, $8b11dd70aaca6dbd$export$570ac5a3fd7e6cc6 = $8b11dd70aaca6dbd$var$SENTRY_TRANSACTION, $8b11dd70aaca6dbd$export$5b9a0015e1c530ed = $8b11dd70aaca6dbd$var$SENTRY_USER_EMAIL, $8b11dd70aaca6dbd$export$8bbff71c84508218 = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_CITY, $8b11dd70aaca6dbd$export$b55aa07a514a2430 = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_COUNTRY_CODE, $8b11dd70aaca6dbd$export$9927ad09f7c084dc = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_REGION, $8b11dd70aaca6dbd$export$52a07a35ff8ec6b6 = $8b11dd70aaca6dbd$var$SENTRY_USER_GEO_SUBDIVISION, $8b11dd70aaca6dbd$export$a10d277c42e6cae3 = $8b11dd70aaca6dbd$var$SENTRY_USER_ID, $8b11dd70aaca6dbd$export$cdc0ce5c66182801 = $8b11dd70aaca6dbd$var$SENTRY_USER_IP, $8b11dd70aaca6dbd$export$2504d4bd698dd962 = $8b11dd70aaca6dbd$var$SENTRY_USER_USERNAME, $8b11dd70aaca6dbd$export$9dc86f3b876e96ef = $8b11dd70aaca6dbd$var$SERVER_ADDRESS, $8b11dd70aaca6dbd$export$70ff7865f52549ae = $8b11dd70aaca6dbd$var$SERVER_NAME, $8b11dd70aaca6dbd$export$f77b53a42be6e6fd = $8b11dd70aaca6dbd$var$SERVER_PORT, $8b11dd70aaca6dbd$export$818eb7ab11414506 = $8b11dd70aaca6dbd$var$SERVICE_NAME, $8b11dd70aaca6dbd$export$829ef6b2e59d984d = $8b11dd70aaca6dbd$var$SERVICE_VERSION, $8b11dd70aaca6dbd$export$b30f4cb52c088a26 = $8b11dd70aaca6dbd$var$SESSION_ID, $8b11dd70aaca6dbd$export$335eace0ff1771cd = $8b11dd70aaca6dbd$var$STALL_PERCENTAGE, $8b11dd70aaca6dbd$export$374d88a2025416ac = $8b11dd70aaca6dbd$var$STALL_TOTAL_TIME, $8b11dd70aaca6dbd$export$bb7a91303551eb37 = $8b11dd70aaca6dbd$var$STATE_TYPE, $8b11dd70aaca6dbd$export$f132ea291a7db56b = $8b11dd70aaca6dbd$var$THREAD_ID, $8b11dd70aaca6dbd$export$f0abd4170bbd2468 = $8b11dd70aaca6dbd$var$THREAD_NAME, $8b11dd70aaca6dbd$export$50d00a157dc08581 = $8b11dd70aaca6dbd$var$TIMBER_TAG, $8b11dd70aaca6dbd$export$484576567a98833f = $8b11dd70aaca6dbd$var$TIME_TO_FULL_DISPLAY, $8b11dd70aaca6dbd$export$ec9e491e475d0c97 = $8b11dd70aaca6dbd$var$TIME_TO_INITIAL_DISPLAY, $8b11dd70aaca6dbd$export$a86c59c10992220f = $8b11dd70aaca6dbd$var$TRANSACTION, $8b11dd70aaca6dbd$export$e12f06597e992fde = $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_PATH, $8b11dd70aaca6dbd$export$7ec54678ba28ea59 = $8b11dd70aaca6dbd$var$TRPC_PROCEDURE_TYPE, $8b11dd70aaca6dbd$export$433ba14c16717110 = $8b11dd70aaca6dbd$var$TTFB, $8b11dd70aaca6dbd$export$309ee349b8a537f = $8b11dd70aaca6dbd$var$TTFB_REQUESTTIME, $8b11dd70aaca6dbd$export$b87f371cbc396fcf = $8b11dd70aaca6dbd$var$TYPE, $8b11dd70aaca6dbd$export$60050fc49fe0e7e2 = $8b11dd70aaca6dbd$var$UI_COMPONENT_NAME, $8b11dd70aaca6dbd$export$348c8e2b37f276cd = $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTFD, $8b11dd70aaca6dbd$export$7f47e8a8b2d97cb2 = $8b11dd70aaca6dbd$var$UI_CONTRIBUTES_TO_TTID, $8b11dd70aaca6dbd$export$50d5adc4b543ce95 = $8b11dd70aaca6dbd$var$UI_ELEMENT_HEIGHT, $8b11dd70aaca6dbd$export$9221f1d2c934d9f = $8b11dd70aaca6dbd$var$UI_ELEMENT_ID, $8b11dd70aaca6dbd$export$3a56578b3ae09a02 = $8b11dd70aaca6dbd$var$UI_ELEMENT_IDENTIFIER, $8b11dd70aaca6dbd$export$e47b8dab9466c895 = $8b11dd70aaca6dbd$var$UI_ELEMENT_LOAD_TIME, $8b11dd70aaca6dbd$export$4ca52f75cf4889c5 = $8b11dd70aaca6dbd$var$UI_ELEMENT_PAINT_TYPE, $8b11dd70aaca6dbd$export$7343d7d72195067f = $8b11dd70aaca6dbd$var$UI_ELEMENT_RENDER_TIME, $8b11dd70aaca6dbd$export$f334f32f8d4d8063 = $8b11dd70aaca6dbd$var$UI_ELEMENT_TYPE, $8b11dd70aaca6dbd$export$c7bf2089e89a217c = $8b11dd70aaca6dbd$var$UI_ELEMENT_URL, $8b11dd70aaca6dbd$export$f514f97553a434b2 = $8b11dd70aaca6dbd$var$UI_ELEMENT_WIDTH, $8b11dd70aaca6dbd$export$61abde59b50deb8e = "url", $8b11dd70aaca6dbd$export$5a5ce44f9fb51f93 = $8b11dd70aaca6dbd$var$URL_DOMAIN, $8b11dd70aaca6dbd$export$7044ea8d89b6f59d = $8b11dd70aaca6dbd$var$URL_FRAGMENT, $8b11dd70aaca6dbd$export$40eacf1a072c9dbd = $8b11dd70aaca6dbd$var$URL_FULL, $8b11dd70aaca6dbd$export$4c1fa0ac0eff2ac = $8b11dd70aaca6dbd$var$URL_PATH, $8b11dd70aaca6dbd$export$5bee9450fe31dde1 = $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY, $8b11dd70aaca6dbd$export$d0b571fb4406d953 = $8b11dd70aaca6dbd$var$URL_PATH_PARAMETER_KEY_BASE, $8b11dd70aaca6dbd$export$258b370e6c2b85d5 = $8b11dd70aaca6dbd$var$URL_PORT, $8b11dd70aaca6dbd$export$dc5e5523da291a4b = $8b11dd70aaca6dbd$var$URL_QUERY, $8b11dd70aaca6dbd$export$fd5a8904ab5abfe0 = $8b11dd70aaca6dbd$var$URL_SAME_ORIGIN, $8b11dd70aaca6dbd$export$1350d8937b0f26fb = $8b11dd70aaca6dbd$var$URL_SCHEME, $8b11dd70aaca6dbd$export$2a045f777fb349a8 = $8b11dd70aaca6dbd$var$URL_TEMPLATE, $8b11dd70aaca6dbd$export$8bb874585539a88f = $8b11dd70aaca6dbd$var$USER_AGENT_ORIGINAL, $8b11dd70aaca6dbd$export$17d3a50785727199 = $8b11dd70aaca6dbd$var$USER_EMAIL, $8b11dd70aaca6dbd$export$2931c570009689e = $8b11dd70aaca6dbd$var$USER_FULL_NAME, $8b11dd70aaca6dbd$export$199cbcedee735a43 = $8b11dd70aaca6dbd$var$USER_GEO_CITY, $8b11dd70aaca6dbd$export$4ba5bf9d4e3ed862 = $8b11dd70aaca6dbd$var$USER_GEO_COUNTRY_CODE, $8b11dd70aaca6dbd$export$674c01ec2f0b89c3 = $8b11dd70aaca6dbd$var$USER_GEO_REGION, $8b11dd70aaca6dbd$export$bda1686739fd61c7 = $8b11dd70aaca6dbd$var$USER_GEO_SUBDIVISION, $8b11dd70aaca6dbd$export$8d804148f485d54c = $8b11dd70aaca6dbd$var$USER_HASH, $8b11dd70aaca6dbd$export$212a8f1ea37518bd = $8b11dd70aaca6dbd$var$USER_ID, $8b11dd70aaca6dbd$export$c9ac0fee28245883 = $8b11dd70aaca6dbd$var$USER_IP_ADDRESS, $8b11dd70aaca6dbd$export$77078610759fe5f6 = $8b11dd70aaca6dbd$var$USER_NAME, $8b11dd70aaca6dbd$export$7c6317deeec7a6c1 = $8b11dd70aaca6dbd$var$USER_ROLES, $8b11dd70aaca6dbd$export$877ebf2e4ad81f03 = $8b11dd70aaca6dbd$var$VERCEL_BRANCH, $8b11dd70aaca6dbd$export$70b2343945496e1f = $8b11dd70aaca6dbd$var$VERCEL_BUILD_ID, $8b11dd70aaca6dbd$export$8415b56d2c6d2b1d = $8b11dd70aaca6dbd$var$VERCEL_DEPLOYMENT_ID, $8b11dd70aaca6dbd$export$cc81114a03caab18 = $8b11dd70aaca6dbd$var$VERCEL_DESTINATION, $8b11dd70aaca6dbd$export$bc14eb892daceb23 = $8b11dd70aaca6dbd$var$VERCEL_EDGE_TYPE, $8b11dd70aaca6dbd$export$3c973217450c3e9d = $8b11dd70aaca6dbd$var$VERCEL_ENTRYPOINT, $8b11dd70aaca6dbd$export$582c0b730ff1ddb9 = $8b11dd70aaca6dbd$var$VERCEL_EXECUTION_REGION, $8b11dd70aaca6dbd$export$b3edfb545b65f1c5 = $8b11dd70aaca6dbd$var$VERCEL_ID, $8b11dd70aaca6dbd$export$2593317d8731841c = $8b11dd70aaca6dbd$var$VERCEL_JA3_DIGEST, $8b11dd70aaca6dbd$export$8bb5bc1732aa41f = $8b11dd70aaca6dbd$var$VERCEL_JA4_DIGEST, $8b11dd70aaca6dbd$export$74a79c98b110b5b9 = $8b11dd70aaca6dbd$var$VERCEL_LOG_TYPE, $8b11dd70aaca6dbd$export$26461b03281b4db4 = $8b11dd70aaca6dbd$var$VERCEL_PATH, $8b11dd70aaca6dbd$export$eaea590d6d3dd93c = $8b11dd70aaca6dbd$var$VERCEL_PROJECT_ID, $8b11dd70aaca6dbd$export$af45365f70099379 = $8b11dd70aaca6dbd$var$VERCEL_PROJECT_NAME, $8b11dd70aaca6dbd$export$a49e732d34d5ba9b = $8b11dd70aaca6dbd$var$VERCEL_PROXY_CACHE_ID, $8b11dd70aaca6dbd$export$7c147fe246bc8bd3 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_CLIENT_IP, $8b11dd70aaca6dbd$export$e5111b6070e1ee9e = $8b11dd70aaca6dbd$var$VERCEL_PROXY_HOST, $8b11dd70aaca6dbd$export$591cbfd403f8c8d = $8b11dd70aaca6dbd$var$VERCEL_PROXY_LAMBDA_REGION, $8b11dd70aaca6dbd$export$b1388db955bbb885 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_METHOD, $8b11dd70aaca6dbd$export$e898d0e9e211abd9 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH, $8b11dd70aaca6dbd$export$ab6fee0e8a6ee069 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE, $8b11dd70aaca6dbd$export$9786ad94c199ffbb = $8b11dd70aaca6dbd$var$VERCEL_PROXY_PATH_TYPE_VARIANT, $8b11dd70aaca6dbd$export$269890524eed693b = $8b11dd70aaca6dbd$var$VERCEL_PROXY_REFERER, $8b11dd70aaca6dbd$export$2ec623a8212d6b64 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_REGION, $8b11dd70aaca6dbd$export$30e7673b01ff994e = $8b11dd70aaca6dbd$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE, $8b11dd70aaca6dbd$export$9ea93477840812bf = $8b11dd70aaca6dbd$var$VERCEL_PROXY_SCHEME, $8b11dd70aaca6dbd$export$a6da0c365670c430 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_STATUS_CODE, $8b11dd70aaca6dbd$export$7986b22da43f2885 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_TIMESTAMP, $8b11dd70aaca6dbd$export$a9f943c7ceb3b42f = $8b11dd70aaca6dbd$var$VERCEL_PROXY_USER_AGENT, $8b11dd70aaca6dbd$export$dfe49501efcdffce = $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_CACHE, $8b11dd70aaca6dbd$export$be465f50c92eb01d = $8b11dd70aaca6dbd$var$VERCEL_PROXY_VERCEL_ID, $8b11dd70aaca6dbd$export$c138d1796bb34999 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_ACTION, $8b11dd70aaca6dbd$export$85a0016690a0ccf2 = $8b11dd70aaca6dbd$var$VERCEL_PROXY_WAF_RULE_ID, $8b11dd70aaca6dbd$export$883acab36ede4bfa = $8b11dd70aaca6dbd$var$VERCEL_REQUEST_ID, $8b11dd70aaca6dbd$export$9cfc88d203f9cdf1 = $8b11dd70aaca6dbd$var$VERCEL_SOURCE, $8b11dd70aaca6dbd$export$b3c6c599110d7bab = $8b11dd70aaca6dbd$var$VERCEL_STATUS_CODE, $8b11dd70aaca6dbd$export$247839c65766758 = $8b11dd70aaca6dbd$var$_AWS_KINESIS_STREAM_NAME, $8b11dd70aaca6dbd$export$f4d52b02df927d54 = $8b11dd70aaca6dbd$var$_AWS_REQUEST_ID, $8b11dd70aaca6dbd$export$df30ee8c5b5f1989 = $8b11dd70aaca6dbd$var$_HTTP_REQUEST_METHOD, $8b11dd70aaca6dbd$export$268a117c860fca6d = $8b11dd70aaca6dbd$var$_SENTRY_SEGMENT_ID; //# sourceMappingURL=attributes.cjs.map

});



parcelRegister("13TrR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $8OOjj = parcelRequire("8OOjj");

var $g31Ce = parcelRequire("g31Ce");

var $l5lP1 = parcelRequire("l5lP1");

var $aX5wF = parcelRequire("aX5wF");

var $cqs9v = parcelRequire("cqs9v");
function $0c6115202d4214b3$var$captureException(exception, hint) {
    return $5JqSP.getCurrentScope().captureException(exception, $l5lP1.parseEventHintOrCaptureContext(hint));
}
function $0c6115202d4214b3$var$captureMessage(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return $5JqSP.getCurrentScope().captureMessage(message, level, hint);
}
function $0c6115202d4214b3$var$captureEvent(event, hint) {
    return $5JqSP.getCurrentScope().captureEvent(event, hint);
}
function $0c6115202d4214b3$var$setContext(name, context) {
    $5JqSP.getIsolationScope().setContext(name, context);
}
function $0c6115202d4214b3$var$setExtras(extras) {
    $5JqSP.getIsolationScope().setExtras(extras);
}
function $0c6115202d4214b3$var$setExtra(key, extra) {
    $5JqSP.getIsolationScope().setExtra(key, extra);
}
function $0c6115202d4214b3$var$setTags(tags) {
    $5JqSP.getIsolationScope().setTags(tags);
}
function $0c6115202d4214b3$var$setTag(key, value) {
    $5JqSP.getIsolationScope().setTag(key, value);
}
function $0c6115202d4214b3$var$setAttributes(attributes) {
    $5JqSP.getIsolationScope().setAttributes(attributes);
}
function $0c6115202d4214b3$var$setAttribute(key, value) {
    $5JqSP.getIsolationScope().setAttribute(key, value);
}
function $0c6115202d4214b3$var$setUser(user) {
    $5JqSP.getIsolationScope().setUser(user);
}
function $0c6115202d4214b3$var$setConversationId(conversationId) {
    $5JqSP.getIsolationScope().setConversationId(conversationId);
}
function $0c6115202d4214b3$var$lastEventId() {
    return $5JqSP.getIsolationScope().lastEventId();
}
async function $0c6115202d4214b3$var$flush(timeout) {
    const client = $5JqSP.getClient();
    if (client) return client.flush(timeout);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $0c6115202d4214b3$var$close(timeout) {
    const client = $5JqSP.getClient();
    if (client) return client.close(timeout);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $0c6115202d4214b3$var$isInitialized() {
    return !!$5JqSP.getClient();
}
function $0c6115202d4214b3$var$isEnabled() {
    const client = $5JqSP.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $0c6115202d4214b3$var$addEventProcessor(callback) {
    $5JqSP.getIsolationScope().addEventProcessor(callback);
}
function $0c6115202d4214b3$var$startSession(context) {
    const isolationScope = $5JqSP.getIsolationScope();
    const { user: user } = $aX5wF.getCombinedScopeData(isolationScope, $5JqSP.getCurrentScope());
    const { userAgent: userAgent } = $cqs9v.GLOBAL_OBJ.navigator || {};
    const session$1 = $8OOjj.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") $8OOjj.updateSession(currentSession, {
        status: "exited"
    });
    $0c6115202d4214b3$var$endSession();
    isolationScope.setSession(session$1);
    return session$1;
}
function $0c6115202d4214b3$var$endSession() {
    const isolationScope = $5JqSP.getIsolationScope();
    const currentScope = $5JqSP.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $8OOjj.closeSession(session$1);
    $0c6115202d4214b3$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $0c6115202d4214b3$var$_sendSessionUpdate() {
    const isolationScope = $5JqSP.getIsolationScope();
    const client = $5JqSP.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $0c6115202d4214b3$var$captureSession(end = false) {
    if (end) {
        $0c6115202d4214b3$var$endSession();
        return;
    }
    $0c6115202d4214b3$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $0c6115202d4214b3$var$addEventProcessor;
module.exports.captureEvent = $0c6115202d4214b3$var$captureEvent;
module.exports.captureException = $0c6115202d4214b3$var$captureException;
module.exports.captureMessage = $0c6115202d4214b3$var$captureMessage;
module.exports.captureSession = $0c6115202d4214b3$var$captureSession;
module.exports.close = $0c6115202d4214b3$var$close;
module.exports.endSession = $0c6115202d4214b3$var$endSession;
module.exports.flush = $0c6115202d4214b3$var$flush;
module.exports.isEnabled = $0c6115202d4214b3$var$isEnabled;
module.exports.isInitialized = $0c6115202d4214b3$var$isInitialized;
module.exports.lastEventId = $0c6115202d4214b3$var$lastEventId;
module.exports.setAttribute = $0c6115202d4214b3$var$setAttribute;
module.exports.setAttributes = $0c6115202d4214b3$var$setAttributes;
module.exports.setContext = $0c6115202d4214b3$var$setContext;
module.exports.setConversationId = $0c6115202d4214b3$var$setConversationId;
module.exports.setExtra = $0c6115202d4214b3$var$setExtra;
module.exports.setExtras = $0c6115202d4214b3$var$setExtras;
module.exports.setTag = $0c6115202d4214b3$var$setTag;
module.exports.setTags = $0c6115202d4214b3$var$setTags;
module.exports.setUser = $0c6115202d4214b3$var$setUser;
module.exports.startSession = $0c6115202d4214b3$var$startSession;

});
parcelRegister("l5lP1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9QW6c = parcelRequire("9QW6c");

var $aDJ1B = parcelRequire("aDJ1B");

var $fTFTk = parcelRequire("fTFTk");

var $aIP8h = parcelRequire("aIP8h");

var $lpiqE = parcelRequire("lpiqE");

var $rzjlZ = parcelRequire("rzjlZ");

var $9EvIV = parcelRequire("9EvIV");

var $aX5wF = parcelRequire("aX5wF");

var $foFxi = parcelRequire("foFxi");

var $lDdLA = parcelRequire("lDdLA");

var $5L5uH = parcelRequire("5L5uH");
function $f59afdf92dbb9314$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $rzjlZ.uuid4(),
        timestamp: event.timestamp || $5L5uH.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $f59afdf92dbb9314$var$applyClientOptions(prepared, options);
    $f59afdf92dbb9314$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $f59afdf92dbb9314$var$applyDebugIds(prepared, options.stackParser);
    const finalScope = $f59afdf92dbb9314$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $rzjlZ.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = $aX5wF.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $aX5wF.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = $lpiqE.isInternalException(hint) ? $lDdLA.resolvedSyncPromise(prepared) : $aDJ1B.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) $f59afdf92dbb9314$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $f59afdf92dbb9314$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $f59afdf92dbb9314$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || $9QW6c.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $foFxi.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = $foFxi.truncate(exception.value, maxValueLength);
    });
}
function $f59afdf92dbb9314$var$applyDebugIds(event, stackParser) {
    const filenameDebugIdMap = $aIP8h.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $f59afdf92dbb9314$var$applyDebugMeta(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $f59afdf92dbb9314$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $f59afdf92dbb9314$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $9EvIV.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $9EvIV.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $9EvIV.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $9EvIV.normalize(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = $9EvIV.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $9EvIV.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $9EvIV.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $f59afdf92dbb9314$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $fTFTk.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
function $f59afdf92dbb9314$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return void 0;
    if ($f59afdf92dbb9314$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($f59afdf92dbb9314$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $f59afdf92dbb9314$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $fTFTk.Scope || typeof hint === "function";
}
const $f59afdf92dbb9314$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $f59afdf92dbb9314$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$f59afdf92dbb9314$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $f59afdf92dbb9314$var$applyClientOptions;
module.exports.applyDebugIds = $f59afdf92dbb9314$var$applyDebugIds;
module.exports.applyDebugMeta = $f59afdf92dbb9314$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $f59afdf92dbb9314$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $f59afdf92dbb9314$var$prepareEvent;

});
parcelRegister("aDJ1B", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $lDdLA = parcelRequire("lDdLA");
function $7bf078e723615ca5$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $7bf078e723615ca5$var$_notifyEventProcessors(event, hint, processors, index);
        return $cUgOr.isThenable(result) ? result : $lDdLA.resolvedSyncPromise(result);
    } catch (error) {
        return $lDdLA.rejectedSyncPromise(error);
    }
}
function $7bf078e723615ca5$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $3T29C.DEBUG_BUILD && result === null && $g31Ce.debug.log(`Event processor "${processor.id || "?"}" dropped event`);
    if ($cUgOr.isThenable(result)) return result.then((final)=>$7bf078e723615ca5$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $7bf078e723615ca5$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $7bf078e723615ca5$var$notifyEventProcessors;

});
parcelRegister("lDdLA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");
const $fbf7eb3ffe3a5292$var$STATE_PENDING = 0;
const $fbf7eb3ffe3a5292$var$STATE_RESOLVED = 1;
const $fbf7eb3ffe3a5292$var$STATE_REJECTED = 2;
function $fbf7eb3ffe3a5292$var$resolvedSyncPromise(value) {
    return new $fbf7eb3ffe3a5292$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
function $fbf7eb3ffe3a5292$var$rejectedSyncPromise(reason) {
    return new $fbf7eb3ffe3a5292$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
class $fbf7eb3ffe3a5292$var$SyncPromise {
    constructor(executor){
        this._state = $fbf7eb3ffe3a5292$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $fbf7eb3ffe3a5292$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $fbf7eb3ffe3a5292$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $fbf7eb3ffe3a5292$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $fbf7eb3ffe3a5292$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $fbf7eb3ffe3a5292$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $fbf7eb3ffe3a5292$var$STATE_PENDING) return;
            if ($cUgOr.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($fbf7eb3ffe3a5292$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($fbf7eb3ffe3a5292$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $fbf7eb3ffe3a5292$var$SyncPromise;
module.exports.rejectedSyncPromise = $fbf7eb3ffe3a5292$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $fbf7eb3ffe3a5292$var$resolvedSyncPromise;

});


parcelRegister("aIP8h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1nK9H = parcelRequire("1nK9H");

var $cqs9v = parcelRequire("cqs9v");
let $7ce5ad5428bb4776$var$parsedStackResults;
let $7ce5ad5428bb4776$var$lastSentryKeysCount;
let $7ce5ad5428bb4776$var$lastNativeKeysCount;
let $7ce5ad5428bb4776$var$cachedFilenameDebugIds;
function $7ce5ad5428bb4776$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $cqs9v.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $cqs9v.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($7ce5ad5428bb4776$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $7ce5ad5428bb4776$var$lastSentryKeysCount && nativeDebugIdKeys.length === $7ce5ad5428bb4776$var$lastNativeKeysCount) return $7ce5ad5428bb4776$var$cachedFilenameDebugIds;
    $7ce5ad5428bb4776$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $7ce5ad5428bb4776$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $7ce5ad5428bb4776$var$cachedFilenameDebugIds = {};
    if (!$7ce5ad5428bb4776$var$parsedStackResults) $7ce5ad5428bb4776$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $7ce5ad5428bb4776$var$parsedStackResults?.[key];
            if (result && $7ce5ad5428bb4776$var$cachedFilenameDebugIds && debugId) {
                $7ce5ad5428bb4776$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($7ce5ad5428bb4776$var$parsedStackResults) $7ce5ad5428bb4776$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $7ce5ad5428bb4776$var$cachedFilenameDebugIds && $7ce5ad5428bb4776$var$parsedStackResults) {
                        $7ce5ad5428bb4776$var$cachedFilenameDebugIds[filename] = debugId;
                        $7ce5ad5428bb4776$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $7ce5ad5428bb4776$var$cachedFilenameDebugIds;
}
function $7ce5ad5428bb4776$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $7ce5ad5428bb4776$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $1nK9H.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $7ce5ad5428bb4776$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $7ce5ad5428bb4776$var$getFilenameToDebugIdMap;

});

parcelRegister("lpiqE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f95a3a5fa863ccc5$var$isInternalException(hint) {
    return hint.data?.__sentry__ === true;
}
function $f95a3a5fa863ccc5$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $f95a3a5fa863ccc5$var$getPossibleEventMessages;
module.exports.isInternalException = $f95a3a5fa863ccc5$var$isInternalException;

});



parcelRegister("3xknF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $5CFne = parcelRequire("5CFne");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $rzjlZ = parcelRequire("rzjlZ");

var $5L5uH = parcelRequire("5L5uH");

var $7O2T2 = parcelRequire("7O2T2");
function $293443555adadb2a$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $293443555adadb2a$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: "in_progress"
        }, upsertMonitorConfig);
        const now = $5L5uH.timestampInSeconds();
        function finishCheckIn(status) {
            $293443555adadb2a$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $5L5uH.timestampInSeconds() - now
            });
        }
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ($cUgOr.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn("ok");
            return r;
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        finishCheckIn("ok");
        return maybePromiseResult;
    }
    const oldPropagationContext = {
        ...$5JqSP.getCurrentScope().getPropagationContext()
    };
    return $5JqSP.withIsolationScope(()=>{
        if (upsertMonitorConfig?.isolateTrace) return $5CFne.startNewTrace(runCallback);
        const scope = $5JqSP.getCurrentScope();
        if (!$7O2T2.isContinuingTrace(scope.getPropagationContext())) scope.setPropagationContext(oldPropagationContext);
        return runCallback();
    });
}
function $293443555adadb2a$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $5JqSP.getCurrentScope();
    const client = $5JqSP.getClient();
    if (!client) $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $rzjlZ.uuid4();
}
module.exports.captureCheckIn = $293443555adadb2a$var$captureCheckIn;
module.exports.withMonitor = $293443555adadb2a$var$withMonitor;

});

parcelRegister("9tM8w", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $du5vT = parcelRequire("du5vT");

var $6Uu3e = parcelRequire("6Uu3e");

var $dFAcI = parcelRequire("dFAcI");

var $3tUnp = parcelRequire("3tUnp");
function $6e6c2965d6f840bb$var$waitForTracingChannelBinding(callback, retries = 1) {
    const binding = $3tUnp.getAsyncContextStrategy($du5vT.getMainCarrier()).getTracingChannelBinding?.();
    if (binding) {
        callback();
        return;
    }
    if (!retries) return;
    $dFAcI.safeUnref(setTimeout(()=>{
        $6e6c2965d6f840bb$var$waitForTracingChannelBinding(callback, retries - 1);
    }, 1));
}
function $6e6c2965d6f840bb$var$_INTERNAL_createTracingChannelBinding(asyncLocalStorage, getScopes) {
    return {
        asyncLocalStorage: asyncLocalStorage,
        getStoreWithActiveSpan: (span)=>{
            const { scope: scope, isolationScope: isolationScope } = getScopes();
            const activeScope = scope.clone();
            $6Uu3e._setSpanForScope(activeScope, span);
            return {
                scope: activeScope,
                isolationScope: isolationScope
            };
        }
    };
}
module.exports._INTERNAL_createTracingChannelBinding = $6e6c2965d6f840bb$var$_INTERNAL_createTracingChannelBinding;
module.exports.waitForTracingChannelBinding = $6e6c2965d6f840bb$var$waitForTracingChannelBinding;

});
parcelRegister("dFAcI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9f3b30185f3ebd8c$var$safeUnref(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}
module.exports.safeUnref = $9f3b30185f3ebd8c$var$safeUnref;

});


parcelRegister("1scQ2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");
const $10f25d640eca1a3f$var$SENTRY_API_VERSION = "7";
function $10f25d640eca1a3f$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $10f25d640eca1a3f$var$_getIngestEndpoint(dsn) {
    return `${$10f25d640eca1a3f$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $10f25d640eca1a3f$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $10f25d640eca1a3f$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $10f25d640eca1a3f$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$10f25d640eca1a3f$var$_getIngestEndpoint(dsn)}?${$10f25d640eca1a3f$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $10f25d640eca1a3f$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $3zkbY.makeDsn(dsnLike);
    if (!dsn$1) return "";
    const endpoint = `${$10f25d640eca1a3f$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$3zkbY.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $10f25d640eca1a3f$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $10f25d640eca1a3f$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $10f25d640eca1a3f$var$getReportDialogEndpoint;

});

parcelRegister("ifJZI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1scQ2 = parcelRequire("1scQ2");

var $9QW6c = parcelRequire("9QW6c");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $ajhqL = parcelRequire("ajhqL");

var $iOdTc = parcelRequire("iOdTc");

var $krgwg = parcelRequire("krgwg");

var $7piEH = parcelRequire("7piEH");

var $8OOjj = parcelRequire("8OOjj");

var $4LxkX = parcelRequire("4LxkX");

var $dvzf1 = parcelRequire("dvzf1");

var $jGI7F = parcelRequire("jGI7F");

var $9kCJF = parcelRequire("9kCJF");

var $9WX7F = parcelRequire("9WX7F");

var $g31Ce = parcelRequire("g31Ce");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $lpiqE = parcelRequire("lpiqE");

var $cUgOr = parcelRequire("cUgOr");

var $4ty0t = parcelRequire("4ty0t");

var $rzjlZ = parcelRequire("rzjlZ");

var $5CFT4 = parcelRequire("5CFT4");

var $l5lP1 = parcelRequire("l5lP1");

var $cx0Ur = parcelRequire("cx0Ur");

var $hkF3C = parcelRequire("hkF3C");

var $ffWyI = parcelRequire("ffWyI");

var $6vUrj = parcelRequire("6vUrj");

var $dFAcI = parcelRequire("dFAcI");

var $6iJce = parcelRequire("6iJce");

var $ehLHs = parcelRequire("ehLHs");
const $d49d4e3a9c5373f3$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $d49d4e3a9c5373f3$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $d49d4e3a9c5373f3$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $d49d4e3a9c5373f3$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $d49d4e3a9c5373f3$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $d49d4e3a9c5373f3$var$_makeInternalError(message) {
    return {
        message: message,
        [$d49d4e3a9c5373f3$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $d49d4e3a9c5373f3$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$d49d4e3a9c5373f3$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $d49d4e3a9c5373f3$var$_isInternalError(error) {
    return $cUgOr.isObjectLike(error) && $d49d4e3a9c5373f3$var$INTERNAL_ERROR_SYMBOL in error;
}
function $d49d4e3a9c5373f3$var$_isDoNotSendEventError(error) {
    return $cUgOr.isObjectLike(error) && $d49d4e3a9c5373f3$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $d49d4e3a9c5373f3$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $d49d4e3a9c5373f3$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = $dFAcI.safeUnref(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $d49d4e3a9c5373f3$var$Client {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $cx0Ur.makePromiseBuffer(options.transportOptions?.bufferSize ?? $9kCJF.DEFAULT_TRANSPORT_BUFFER_SIZE);
        this._dataCollection = $ehLHs.resolveDataCollectionOptions(options);
        if (options.dsn) this._dsn = $3zkbY.makeDsn(options.dsn);
        else $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs ?? true;
        if (this._options.enableLogs) $d49d4e3a9c5373f3$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $d49d4e3a9c5373f3$var$estimateLogSizeInBytes, $krgwg._INTERNAL_flushLogsBuffer);
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        if (enableMetrics) $d49d4e3a9c5373f3$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $d49d4e3a9c5373f3$var$estimateMetricSizeInBytes, $7piEH._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $rzjlZ.uuid4();
        if ($rzjlZ.checkOrSetAlreadyCaught(exception)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log($d49d4e3a9c5373f3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $rzjlZ.uuid4(),
            ...hint
        };
        const eventMessage = $cUgOr.isParameterizedString(message) ? message : String(message);
        const isMessage = $cUgOr.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $rzjlZ.uuid4();
        if (hint?.originalException && $rzjlZ.checkOrSetAlreadyCaught(hint.originalException)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log($d49d4e3a9c5373f3$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $d49d4e3a9c5373f3$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        $8OOjj.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        $iOdTc.setupIntegration(this, integration$1, this._integrations);
        if (!isAlreadyInstalled) $iOdTc.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = $jGI7F.extractGenAiSpansFromEvent(event, this);
        let env = $ajhqL.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        if (!$lpiqE.isInternalException(hint)) for (const attachment of hint.attachments || [])env = $j6N8F.addItemToEnvelope(env, $j6N8F.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $j6N8F.addItemToEnvelope(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $9QW6c.DEFAULT_ENVIRONMENT } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn($d49d4e3a9c5373f3$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn($d49d4e3a9c5373f3$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = $ajhqL.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Error while sending envelope:", reason);
            return {};
        }
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $iOdTc.setupIntegrations(this, integrations);
        $iOdTc.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        const sessionNonTerminal = session$1.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $8OOjj.updateSession(session$1, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $l5lP1.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$5JqSP.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $4LxkX.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $5JqSP.getCurrentScope(), isolationScope = $5JqSP.getIsolationScope()) {
        if ($3T29C.DEBUG_BUILD && $d49d4e3a9c5373f3$var$isErrorEvent(event)) $g31Ce.debug.log(`Captured error event \`${$lpiqE.getPossibleEventMessages(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($3T29C.DEBUG_BUILD) {
                if ($d49d4e3a9c5373f3$var$_isDoNotSendEventError(reason)) $g31Ce.debug.log(reason.message);
                else if ($d49d4e3a9c5373f3$var$_isInternalError(reason)) $g31Ce.debug.warn(reason.message);
                else $g31Ce.debug.warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $d49d4e3a9c5373f3$var$isTransactionEvent(event);
        const isError = $d49d4e3a9c5373f3$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : $5CFT4.parseSampleRate(sampleRate);
        const dataCategory = $d49d4e3a9c5373f3$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $d49d4e3a9c5373f3$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            if ($lpiqE.isInternalException(hint)) return prepared;
            const result = $d49d4e3a9c5373f3$var$processBeforeSend(this, options, prepared, hint);
            return $d49d4e3a9c5373f3$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $d49d4e3a9c5373f3$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && $hkF3C.safeMathRandom() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $d49d4e3a9c5373f3$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($d49d4e3a9c5373f3$var$_isDoNotSendEventError(reason) || $d49d4e3a9c5373f3$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $d49d4e3a9c5373f3$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $cx0Ur.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("No dsn provided, will not send outcomes");
            return;
        }
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Sending outcomes:", outcomes);
        const envelope = $9WX7F.createClientReportEnvelope(outcomes, this._options.tunnel && $3zkbY.dsnToString(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $d49d4e3a9c5373f3$var$getDataCategoryByType(type) {
    return type === "replay_event" ? "replay" : type || "error";
}
function $d49d4e3a9c5373f3$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($cUgOr.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$cUgOr.isPlainObject(event) && event !== null) throw $d49d4e3a9c5373f3$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $d49d4e3a9c5373f3$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$cUgOr.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $d49d4e3a9c5373f3$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $d49d4e3a9c5373f3$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$dvzf1.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($d49d4e3a9c5373f3$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($d49d4e3a9c5373f3$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan$1 || ignoreSpans) {
            const rootSpanJson = $6iJce.convertTransactionEventToSpanJson(processedEvent);
            if (ignoreSpans?.length && $ffWyI.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $6vUrj.showSpanDropWarning();
                else processedEvent = $4ty0t.merge(event, $6iJce.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && $ffWyI.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $ffWyI.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $6vUrj.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $d49d4e3a9c5373f3$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $d49d4e3a9c5373f3$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $d49d4e3a9c5373f3$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $d49d4e3a9c5373f3$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $d49d4e3a9c5373f3$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $d49d4e3a9c5373f3$var$estimateAttributesSizeInBytes(log.attributes);
}
function $d49d4e3a9c5373f3$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $d49d4e3a9c5373f3$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($cUgOr.isPrimitive(value)) weight += $d49d4e3a9c5373f3$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $d49d4e3a9c5373f3$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}
module.exports.Client = $d49d4e3a9c5373f3$var$Client;

});
parcelRegister("iOdTc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
const $db17ab9f6b83c126$var$installedIntegrations = [];
function $db17ab9f6b83c126$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $db17ab9f6b83c126$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $db17ab9f6b83c126$var$filterDuplicates(integrations);
}
function $db17ab9f6b83c126$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $db17ab9f6b83c126$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $db17ab9f6b83c126$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $db17ab9f6b83c126$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$db17ab9f6b83c126$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $db17ab9f6b83c126$var$installedIntegrations.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Integration installed: ${integration.name}`);
}
function $db17ab9f6b83c126$var$addIntegration(integration) {
    const client = $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $db17ab9f6b83c126$var$defineIntegration(fn) {
    return fn;
}
function $db17ab9f6b83c126$var$extendIntegration(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}
module.exports.addIntegration = $db17ab9f6b83c126$var$addIntegration;
module.exports.afterSetupIntegrations = $db17ab9f6b83c126$var$afterSetupIntegrations;
module.exports.defineIntegration = $db17ab9f6b83c126$var$defineIntegration;
module.exports.extendIntegration = $db17ab9f6b83c126$var$extendIntegration;
module.exports.getIntegrationsToSetup = $db17ab9f6b83c126$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $db17ab9f6b83c126$var$installedIntegrations;
module.exports.setupIntegration = $db17ab9f6b83c126$var$setupIntegration;
module.exports.setupIntegrations = $db17ab9f6b83c126$var$setupIntegrations;

});

parcelRegister("krgwg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DFGy = parcelRequire("7DFGy");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $aX5wF = parcelRequire("aX5wF");

var $6Uu3e = parcelRequire("6Uu3e");

var $5L5uH = parcelRequire("5L5uH");

var $6tiuR = parcelRequire("6tiuR");

var $cyH85 = parcelRequire("cyH85");

var $tJywI = parcelRequire("tJywI");

var $owf5B = parcelRequire("owf5B");
const $ee1324b0e2dbfe43$var$MAX_LOG_BUFFER_SIZE = 100;
function $ee1324b0e2dbfe43$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $ee1324b0e2dbfe43$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $ee1324b0e2dbfe43$var$_getBufferMap();
    const logBuffer = $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $ee1324b0e2dbfe43$var$MAX_LOG_BUFFER_SIZE) {
        $ee1324b0e2dbfe43$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $ee1324b0e2dbfe43$var$_INTERNAL_captureLog(beforeLog, currentScope = $5JqSP.getCurrentScope(), captureSerializedLog = $ee1324b0e2dbfe43$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = true, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = $cyH85._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $aX5wF.getCombinedScopeData($5JqSP.getIsolationScope(), currentScope);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ($cUgOr.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $6Uu3e._getSpanForScope(currentScope);
    $ee1324b0e2dbfe43$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? $g31Ce.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $5L5uH.timestampInSeconds();
    const sequenceAttr = $6tiuR.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $ee1324b0e2dbfe43$var$_removeLoneSurrogates(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $tJywI.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: $ee1324b0e2dbfe43$var$sanitizeLogAttributes({
            ...$7DFGy.serializeAttributes(scopeAttributes),
            ...$7DFGy.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $ee1324b0e2dbfe43$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $owf5B.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $ee1324b0e2dbfe43$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope$1);
}
function $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer(client) {
    return $ee1324b0e2dbfe43$var$_getBufferMap().get(client);
}
function $ee1324b0e2dbfe43$var$_getBufferMap() {
    return $du5vT.getGlobalSingleton("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $ee1324b0e2dbfe43$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $ee1324b0e2dbfe43$var$_removeLoneSurrogates(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $ee1324b0e2dbfe43$var$_removeLoneSurrogates(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $ee1324b0e2dbfe43$var$_removeLoneSurrogates(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
module.exports._INTERNAL_captureLog = $ee1324b0e2dbfe43$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $ee1324b0e2dbfe43$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $ee1324b0e2dbfe43$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $ee1324b0e2dbfe43$var$_INTERNAL_getLogBuffer;
module.exports._removeLoneSurrogates = $ee1324b0e2dbfe43$var$_removeLoneSurrogates;

});
parcelRegister("6tiuR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $4b63cc92966eeb16$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $4b63cc92966eeb16$var$_sequenceNumber = 0;
let $4b63cc92966eeb16$var$_previousTimestampMs;
function $4b63cc92966eeb16$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($4b63cc92966eeb16$var$_previousTimestampMs !== void 0 && nowMs !== $4b63cc92966eeb16$var$_previousTimestampMs) $4b63cc92966eeb16$var$_sequenceNumber = 0;
    const value = $4b63cc92966eeb16$var$_sequenceNumber;
    $4b63cc92966eeb16$var$_sequenceNumber++;
    $4b63cc92966eeb16$var$_previousTimestampMs = nowMs;
    return {
        key: $4b63cc92966eeb16$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}
module.exports.getSequenceAttribute = $4b63cc92966eeb16$var$getSequenceAttribute;

});

parcelRegister("cyH85", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $4LxkX = parcelRequire("4LxkX");

var $6vUrj = parcelRequire("6vUrj");
function $924a1d99835cbd1c$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return $5JqSP.withScope(scope, ()=>{
        const span = $6vUrj.getActiveSpan();
        const traceContext = span ? $6vUrj.spanToTraceContext(span) : $5JqSP.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $4LxkX.getDynamicSamplingContextFromSpan(span) : $4LxkX.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $924a1d99835cbd1c$var$_getTraceInfoFromScope;

});

parcelRegister("tJywI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $05960bff567f053c$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $05960bff567f053c$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("owf5B", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hGnwj = parcelRequire("hGnwj");
function $049b40ab805c2423$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $049b40ab805c2423$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $3zkbY.dsnToString(dsn$1);
    return $j6N8F.createEnvelope(headers, [
        $049b40ab805c2423$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $049b40ab805c2423$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $049b40ab805c2423$var$createLogEnvelope;

});
parcelRegister("hGnwj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jlXif = parcelRequire("jlXif");

var $cqs9v = parcelRequire("cqs9v");
function $cdf89a88f9f557e2$var$isBrowser() {
    return typeof window !== "undefined" && (!$jlXif.isNodeEnv() || $cdf89a88f9f557e2$var$isElectronNodeRenderer());
}
function $cdf89a88f9f557e2$var$isElectronNodeRenderer() {
    const process = $cqs9v.GLOBAL_OBJ.process;
    return process?.type === "renderer";
}
module.exports.isBrowser = $cdf89a88f9f557e2$var$isBrowser;

});
parcelRegister("jlXif", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $N4tZW = parcelRequire("N4tZW");
function isNodeEnv() {
    return !$N4tZW.isBrowserBundle() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("N4tZW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $09380dea9edf3ef0$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $09380dea9edf3ef0$var$getSDKSource() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}
module.exports.getSDKSource = $09380dea9edf3ef0$var$getSDKSource;
module.exports.isBrowserBundle = $09380dea9edf3ef0$var$isBrowserBundle;

});





parcelRegister("7piEH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DFGy = parcelRequire("7DFGy");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $aX5wF = parcelRequire("aX5wF");

var $6Uu3e = parcelRequire("6Uu3e");

var $5L5uH = parcelRequire("5L5uH");

var $6tiuR = parcelRequire("6tiuR");

var $cyH85 = parcelRequire("cyH85");

var $cVjko = parcelRequire("cVjko");
const $564956c3adbb93ed$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $564956c3adbb93ed$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $564956c3adbb93ed$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $564956c3adbb93ed$var$_getBufferMap();
    const metricBuffer = $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $564956c3adbb93ed$var$MAX_METRIC_BUFFER_SIZE) {
        $564956c3adbb93ed$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $564956c3adbb93ed$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $564956c3adbb93ed$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $564956c3adbb93ed$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = $cyH85._getTraceInfoFromScope(client, currentScope);
    const span = $6Uu3e._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = $5L5uH.timestampInSeconds();
    const sequenceAttr = $6tiuR.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$7DFGy.serializeAttributes(scopeAttributes),
            ...$7DFGy.serializeAttributes(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $564956c3adbb93ed$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $5JqSP.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $564956c3adbb93ed$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No client available to capture metric.");
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("metrics option not enabled, metric will not be captured.");
        return;
    }
    const { user: user, attributes: scopeAttributes } = $aX5wF.getCombinedScopeData($5JqSP.getIsolationScope(), currentScope);
    const enrichedMetric = $564956c3adbb93ed$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $564956c3adbb93ed$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $564956c3adbb93ed$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $cVjko.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $564956c3adbb93ed$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope$1);
}
function $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer(client) {
    return $564956c3adbb93ed$var$_getBufferMap().get(client);
}
function $564956c3adbb93ed$var$_getBufferMap() {
    return $du5vT.getGlobalSingleton("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
module.exports._INTERNAL_captureMetric = $564956c3adbb93ed$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $564956c3adbb93ed$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $564956c3adbb93ed$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $564956c3adbb93ed$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("cVjko", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hGnwj = parcelRequire("hGnwj");
function $9689cd02cfc8c867$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $9689cd02cfc8c867$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $3zkbY.dsnToString(dsn$1);
    return $j6N8F.createEnvelope(headers, [
        $9689cd02cfc8c867$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $9689cd02cfc8c867$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $9689cd02cfc8c867$var$createMetricEnvelope;

});


parcelRegister("jGI7F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hGnwj = parcelRequire("hGnwj");

var $6Xrci = parcelRequire("6Xrci");

var $lSsqe = parcelRequire("lSsqe");
function $e5542a69f194c9be$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || $6Xrci.hasSpanStreamingEnabled(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push($lSsqe.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: genAiSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $e5542a69f194c9be$var$extractGenAiSpansFromEvent;

});
parcelRegister("lSsqe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6vUrj = parcelRequire("6vUrj");
function $fed4b02d3998cc26$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $6vUrj.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $fed4b02d3998cc26$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("9kCJF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $j6N8F = parcelRequire("j6N8F");

var $cx0Ur = parcelRequire("cx0Ur");

var $grFVK = parcelRequire("grFVK");
const $6cb40761fed21f8b$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function $6cb40761fed21f8b$var$createTransport(options, makeRequest, buffer = $cx0Ur.makePromiseBuffer(options.bufferSize || $6cb40761fed21f8b$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        $j6N8F.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $j6N8F.envelopeItemTypeToDataCategory(type);
            if ($grFVK.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $j6N8F.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ($j6N8F.envelopeContainsItemType(filteredEnvelope, [
                "client_report"
            ])) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $j6N8F.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $j6N8F.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $j6N8F.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ($3T29C.DEBUG_BUILD && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) $g31Ce.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $grFVK.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $cx0Ur.SENTRY_BUFFER_FULL_ERROR) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $6cb40761fed21f8b$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $6cb40761fed21f8b$var$createTransport;

});
parcelRegister("cx0Ur", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lDdLA = parcelRequire("lDdLA");

var $dFAcI = parcelRequire("dFAcI");
const $91f945b2de2f1bc8$var$SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $91f945b2de2f1bc8$var$makePromiseBuffer(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return $lDdLA.rejectedSyncPromise($91f945b2de2f1bc8$var$SENTRY_BUFFER_FULL_ERROR);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return $lDdLA.resolvedSyncPromise(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$dFAcI.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $91f945b2de2f1bc8$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $91f945b2de2f1bc8$var$makePromiseBuffer;

});

parcelRegister("grFVK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hkF3C = parcelRequire("hkF3C");
const $bf8fb17aeb222d51$var$DEFAULT_RETRY_AFTER = 60000;
function $bf8fb17aeb222d51$var$parseRetryAfterHeader(header, now = $hkF3C.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $bf8fb17aeb222d51$var$DEFAULT_RETRY_AFTER;
}
function $bf8fb17aeb222d51$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $bf8fb17aeb222d51$var$isRateLimited(limits, dataCategory, now = $hkF3C.safeDateNow()) {
    return $bf8fb17aeb222d51$var$disabledUntil(limits, dataCategory) > now;
}
function $bf8fb17aeb222d51$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $hkF3C.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $bf8fb17aeb222d51$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $bf8fb17aeb222d51$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $bf8fb17aeb222d51$var$disabledUntil;
module.exports.isRateLimited = $bf8fb17aeb222d51$var$isRateLimited;
module.exports.parseRetryAfterHeader = $bf8fb17aeb222d51$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $bf8fb17aeb222d51$var$updateRateLimits;

});


parcelRegister("9WX7F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j6N8F = parcelRequire("j6N8F");

var $5L5uH = parcelRequire("5L5uH");
function $73e76458722c824e$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || $5L5uH.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $j6N8F.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $73e76458722c824e$var$createClientReportEnvelope;

});

parcelRegister("6iJce", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");
function $49677b90a8cc85d1$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[$f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $49677b90a8cc85d1$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$f3RkF.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$f3RkF.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $49677b90a8cc85d1$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $49677b90a8cc85d1$var$convertTransactionEventToSpanJson;

});

parcelRegister("ehLHs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bD531 = parcelRequire("bD531");
const $a667a7748364f040$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $a667a7748364f040$var$isCollectBehavior(value) {
    return typeof value === "boolean" || "allow" in value || "deny" in value;
}
function $a667a7748364f040$var$resolveHttpHeaders(httpHeaders, base) {
    if (httpHeaders === void 0) return {
        ...base.httpHeaders
    };
    if ($a667a7748364f040$var$isCollectBehavior(httpHeaders)) return {
        request: httpHeaders,
        response: httpHeaders
    };
    return {
        request: httpHeaders.request ?? base.httpHeaders.request,
        response: httpHeaders.response ?? base.httpHeaders.response
    };
}
function $a667a7748364f040$var$resolveDataCollectionOptions(options) {
    const base = options.dataCollection != null ? $a667a7748364f040$var$DEFAULTS : $bD531.defaultPiiToCollectionOptions(options.sendDefaultPii);
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? base.userInfo,
        cookies: dc.cookies ?? base.cookies,
        httpHeaders: $a667a7748364f040$var$resolveHttpHeaders(dc.httpHeaders, base),
        httpBodies: dc.httpBodies ?? base.httpBodies,
        // oxlint-disable-next-line typescript/no-deprecated
        urlQueryParams: dc.urlQueryParams ?? dc.queryParams ?? base.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? base.graphQL.document,
            variables: dc.graphQL?.variables ?? base.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? base.genAI.inputs,
            outputs: dc.genAI?.outputs ?? base.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? base.databaseQueryData,
        stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? base.frameContextLines
    };
}
module.exports.resolveDataCollectionOptions = $a667a7748364f040$var$resolveDataCollectionOptions;

});
parcelRegister("bD531", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qpfH = parcelRequire("5qpfH");
function $8777409456dbe390$var$defaultPiiToCollectionOptions(sendDefaultPii) {
    return sendDefaultPii === true ? {
        userInfo: true,
        cookies: true,
        httpHeaders: {
            request: true,
            response: true
        },
        httpBodies: [
            "incomingRequest",
            "outgoingRequest",
            "incomingResponse",
            "outgoingResponse"
        ],
        urlQueryParams: true,
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: true,
            outputs: true
        },
        databaseQueryData: true,
        stackFrameVariables: true,
        frameContextLines: 7
    } : {
        userInfo: false,
        cookies: {
            deny: $5qpfH.PII_HEADER_SNIPPETS
        },
        httpHeaders: {
            request: {
                deny: $5qpfH.PII_HEADER_SNIPPETS
            },
            response: {
                deny: $5qpfH.PII_HEADER_SNIPPETS
            }
        },
        httpBodies: [],
        urlQueryParams: {
            deny: $5qpfH.PII_HEADER_SNIPPETS
        },
        // The GraphQL document has literal values redacted at collection time, so it was historically
        // always attached regardless of `sendDefaultPii`; keep it on to preserve that behavior.
        graphQL: {
            document: true,
            variables: true
        },
        genAI: {
            inputs: false,
            outputs: false
        },
        // Database query values were only sent with `sendDefaultPii: true` (e.g. Supabase gated on it),
        // so map the legacy "off" state to `false`.
        databaseQueryData: false,
        stackFrameVariables: true,
        frameContextLines: 7
    };
}
module.exports.defaultPiiToCollectionOptions = $8777409456dbe390$var$defaultPiiToCollectionOptions;

});
parcelRegister("5qpfH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $3f32f80539dc08e2$var$FILTERED_VALUE = "[Filtered]";
const $3f32f80539dc08e2$var$PII_HEADER_SNIPPETS = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $3f32f80539dc08e2$var$SENSITIVE_KEY_SNIPPETS = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $3f32f80539dc08e2$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];
module.exports.FILTERED_VALUE = $3f32f80539dc08e2$var$FILTERED_VALUE;
module.exports.PII_HEADER_SNIPPETS = $3f32f80539dc08e2$var$PII_HEADER_SNIPPETS;
module.exports.SENSITIVE_COOKIE_NAME_SNIPPETS = $3f32f80539dc08e2$var$SENSITIVE_COOKIE_NAME_SNIPPETS;
module.exports.SENSITIVE_KEY_SNIPPETS = $3f32f80539dc08e2$var$SENSITIVE_KEY_SNIPPETS;

});




parcelRegister("ijm9Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
function $d54b30cefda1b099$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($3T29C.DEBUG_BUILD) $g31Ce.debug.enable();
        else $g31Ce.consoleSandbox(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = $5JqSP.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $d54b30cefda1b099$var$setCurrentClient(client);
    client.init();
    return client;
}
function $d54b30cefda1b099$var$setCurrentClient(client) {
    $5JqSP.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $d54b30cefda1b099$var$initAndBind;
module.exports.setCurrentClient = $d54b30cefda1b099$var$setCurrentClient;

});

parcelRegister("lCaM2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $j6N8F = parcelRequire("j6N8F");

var $hkF3C = parcelRequire("hkF3C");

var $grFVK = parcelRequire("grFVK");

var $dFAcI = parcelRequire("dFAcI");
const $fbc581032890f96b$var$MIN_DELAY = 100;
const $fbc581032890f96b$var$START_DELAY = 5e3;
const $fbc581032890f96b$var$MAX_DELAY = 36e5;
function $fbc581032890f96b$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("[Offline]:", ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error("No `createStore` function was provided");
        const store = options.createStore(options);
        let retryDelay = $fbc581032890f96b$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay2) {
            if ($j6N8F.envelopeContainsItemType(env, [
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay2);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = $dFAcI.safeUnref(setTimeout(async ()=>{
                flushTimer = void 0;
                const found = await store.shift();
                if (found) {
                    log("Attempting to send previously queued event");
                    found[0].sent_at = new Date($hkF3C.safeDateNow()).toISOString();
                    send(found, true).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $fbc581032890f96b$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            if (!isRetry && $j6N8F.envelopeContainsItemType(envelope$1, [
                "replay_event",
                "replay_recording"
            ])) {
                await store.push(envelope$1);
                flushIn($fbc581032890f96b$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error("Envelope not sent because `shouldSend` callback returned false");
                const result = await transport.send(envelope$1);
                let delay = $fbc581032890f96b$var$MIN_DELAY;
                if (result) {
                    if (result.headers?.["retry-after"]) delay = $grFVK.parseRetryAfterHeader(result.headers["retry-after"]);
                    else if (result.headers?.["x-sentry-rate-limits"]) delay = 6e4;
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $fbc581032890f96b$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log("Error sending. Event queued.", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                if (timeout === void 0) {
                    retryDelay = $fbc581032890f96b$var$START_DELAY;
                    flushIn($fbc581032890f96b$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $fbc581032890f96b$var$MIN_DELAY;
module.exports.START_DELAY = $fbc581032890f96b$var$START_DELAY;
module.exports.makeOfflineTransport = $fbc581032890f96b$var$makeOfflineTransport;

});

parcelRegister("3XlS2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1scQ2 = parcelRequire("1scQ2");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");
const $2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = "MULTIPLEXED_TRANSPORT_EXTRA_KEY";
function $2e17d8d07d4e6df7$var$eventFromEnvelope(env, types) {
    let event;
    $j6N8F.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : void 0;
        return !!event;
    });
    return event;
}
function $2e17d8d07d4e6df7$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $2e17d8d07d4e6df7$var$eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
function $2e17d8d07d4e6df7$var$overrideDsn(envelope$1, dsn) {
    return $j6N8F.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
function $2e17d8d07d4e6df7$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = /* @__PURE__ */ new Map();
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $3zkbY.dsnFromString(dsn$1);
                if (!validatedDsn) return void 0;
                const url = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $2e17d8d07d4e6df7$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    "event"
                ];
                return $2e17d8d07d4e6df7$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, void 0);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            const transportsWithFallback = transports.length ? transports : [
                [
                    "",
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($2e17d8d07d4e6df7$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $2e17d8d07d4e6df7$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $2e17d8d07d4e6df7$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $2e17d8d07d4e6df7$var$makeMultiplexedTransport;

});

parcelRegister("fbkeM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
const $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS = /* @__PURE__ */ new Set();
function $b0d794d28f9c9d2c$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS.add(module);
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
function $b0d794d28f9c9d2c$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS.has(module);
}
function $b0d794d28f9c9d2c$var$_INTERNAL_clearAiProviderSkips() {
    $b0d794d28f9c9d2c$var$SKIPPED_AI_PROVIDERS.clear();
    $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Cleared AI provider skip registrations");
}
module.exports._INTERNAL_clearAiProviderSkips = $b0d794d28f9c9d2c$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $b0d794d28f9c9d2c$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $b0d794d28f9c9d2c$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("eEukW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qpfH = parcelRequire("5qpfH");
function $aaac555d2270f807$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $aaac555d2270f807$var$shouldFilterDataKey(key, behavior, additionalDenyTerms) {
    if (behavior === false) return true;
    const lowerKey = key.toLowerCase();
    const denySnippets = additionalDenyTerms != null ? [
        ...$5qpfH.SENSITIVE_KEY_SNIPPETS,
        ...additionalDenyTerms
    ] : $5qpfH.SENSITIVE_KEY_SNIPPETS;
    if ($aaac555d2270f807$var$isSensitiveKey(lowerKey, denySnippets)) return true;
    if (behavior === true) return false;
    const terms = "deny" in behavior ? behavior.deny : behavior.allow;
    const matchesConfiguredTerm = terms.some((term)=>lowerKey.includes(term.toLowerCase()));
    return "deny" in behavior ? matchesConfiguredTerm : !matchesConfiguredTerm;
}
function $aaac555d2270f807$var$filterKeyValueData(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const result = {};
    for (const key of Object.keys(data))result[key] = $aaac555d2270f807$var$shouldFilterDataKey(key, behavior, additionalDenyTerms) ? $5qpfH.FILTERED_VALUE : data[key];
    return result;
}
module.exports.filterKeyValueData = $aaac555d2270f807$var$filterKeyValueData;
module.exports.shouldFilterDataKey = $aaac555d2270f807$var$shouldFilterDataKey;

});

parcelRegister("l8Kgs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dixtt = parcelRequire("dixtt");

var $5qpfH = parcelRequire("5qpfH");

var $eEukW = parcelRequire("eEukW");
function $f63e3b7f0c741638$var$filterCookies(cookieString, behavior) {
    if (behavior === false) return {};
    try {
        const parsed = $dixtt.parseCookie(cookieString);
        if (Object.keys(parsed).length === 0) return {};
        return $eEukW.filterKeyValueData(parsed, behavior, $5qpfH.SENSITIVE_COOKIE_NAME_SNIPPETS);
    } catch  {
        return $5qpfH.FILTERED_VALUE;
    }
}
module.exports.filterCookies = $f63e3b7f0c741638$var$filterCookies;

});
parcelRegister("dixtt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9ae6ec215cbbc078$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        if (void 0 === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            if (val.charCodeAt(0) === 34) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $9ae6ec215cbbc078$var$parseCookie;

});


parcelRegister("dAAl0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5qpfH = parcelRequire("5qpfH");

var $eEukW = parcelRequire("eEukW");
function $9e4ad3184b16c68b$var$filterQueryParams(queryString, behavior) {
    if (!queryString || behavior === false) return void 0;
    return queryString.split("&").map((pair)=>{
        const separatorIndex = pair.indexOf("=");
        const encodedKey = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
        const key = new URLSearchParams(`${encodedKey}=`).keys().next().value;
        return key !== void 0 && $eEukW.shouldFilterDataKey(key, behavior) ? `${encodedKey}=${$5qpfH.FILTERED_VALUE}` : pair;
    }).join("&");
}
module.exports.filterQueryParams = $9e4ad3184b16c68b$var$filterQueryParams;

});

parcelRegister("bMiFH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $dAAl0 = parcelRequire("dAAl0");

var $deA5a = parcelRequire("deA5a");
function $8932a929f51eaadd$var$urlQueryParamsBehavior(client) {
    return (client ?? $5JqSP.getClient())?.getDataCollectionOptions().urlQueryParams ?? true;
}
function $8932a929f51eaadd$var$filterCollectedUrl(url, client) {
    return url === void 0 ? void 0 : $deA5a.filterUrlQuery(url, $8932a929f51eaadd$var$urlQueryParamsBehavior(client));
}
function $8932a929f51eaadd$var$filterCollectedUrlQuery(query, client) {
    if (!query) return query;
    const hasPrefix = query.startsWith("?");
    const filtered = $dAAl0.filterQueryParams(hasPrefix ? query.slice(1) : query, $8932a929f51eaadd$var$urlQueryParamsBehavior(client));
    return filtered && hasPrefix ? `?${filtered}` : filtered;
}
module.exports.filterCollectedUrl = $8932a929f51eaadd$var$filterCollectedUrl;
module.exports.filterCollectedUrlQuery = $8932a929f51eaadd$var$filterCollectedUrlQuery;

});
parcelRegister("deA5a", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dAAl0 = parcelRequire("dAAl0");
function $9a28925bce5c6738$var$filterUrlQuery(url, behavior) {
    const fragmentStart = url.indexOf("#");
    const queryEnd = fragmentStart === -1 ? url.length : fragmentStart;
    const queryStart = url.indexOf("?");
    if (queryStart === -1 || queryStart > queryEnd) return url;
    const prefix = url.slice(0, queryStart);
    const query = url.slice(queryStart + 1, queryEnd);
    const suffix = url.slice(queryEnd);
    const filtered = $dAAl0.filterQueryParams(query, behavior);
    return filtered ? `${prefix}?${filtered}${suffix}` : `${prefix}${suffix}`;
}
module.exports.filterUrlQuery = $9a28925bce5c6738$var$filterUrlQuery;

});


parcelRegister("lneXJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f8f75a345f867308$var$FALSY_ENV_VALUES = /* @__PURE__ */ new Set([
    "false",
    "f",
    "n",
    "no",
    "off",
    "0"
]);
const $f8f75a345f867308$var$TRUTHY_ENV_VALUES = /* @__PURE__ */ new Set([
    "true",
    "t",
    "y",
    "yes",
    "on",
    "1"
]);
function $f8f75a345f867308$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($f8f75a345f867308$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($f8f75a345f867308$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $f8f75a345f867308$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $f8f75a345f867308$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $f8f75a345f867308$var$envToBool;

});

parcelRegister("3TOA3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hkF3C = parcelRequire("hkF3C");
function $2d6dbe66eee26d01$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $3zkbY.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $2d6dbe66eee26d01$var$createCheckInEnvelopeItem(checkIn);
    return $j6N8F.createEnvelope(headers, [
        item
    ]);
}
function $2d6dbe66eee26d01$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $2d6dbe66eee26d01$var$createCheckInEnvelope;

});

parcelRegister("fnNKN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dBuCl = parcelRequire("dBuCl");
function $b32f9911f4d0d105$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $b32f9911f4d0d105$var$checkDsn(url, dsn) || $b32f9911f4d0d105$var$checkTunnel(url, tunnel);
}
function $b32f9911f4d0d105$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $b32f9911f4d0d105$var$removeTrailingSlash(url) === $b32f9911f4d0d105$var$removeTrailingSlash(tunnel);
}
function $b32f9911f4d0d105$var$checkDsn(url$1, dsn) {
    const urlParts = $dBuCl.parseStringToURLObject(url$1);
    if (!urlParts || $dBuCl.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $b32f9911f4d0d105$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $b32f9911f4d0d105$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $b32f9911f4d0d105$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $b32f9911f4d0d105$var$isSentryRequestUrl;

});
parcelRegister("dBuCl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $bMiFH = parcelRequire("bMiFH");
const $9e767b0ca808b61c$var$DEFAULT_BASE_URL = "thismessage:/";
function $9e767b0ca808b61c$var$isURLObjectRelative(url) {
    return "isRelative" in url;
}
function $9e767b0ca808b61c$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $9e767b0ca808b61c$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $9e767b0ca808b61c$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($9e767b0ca808b61c$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $9e767b0ca808b61c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $9e767b0ca808b61c$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $9e767b0ca808b61c$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName, client) {
    const attributes$1 = {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
    };
    if (routeName) {
        attributes$1[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes$1[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
    }
    if (request?.method) attributes$1[$f3RkF.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes$1["url.query"] = $bMiFH.filterCollectedUrlQuery(urlObject.search, client);
        if (urlObject.hash) attributes$1["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes$1["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes$1[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
        }
        if (!$9e767b0ca808b61c$var$isURLObjectRelative(urlObject)) {
            attributes$1[$eAISS.URL_FULL] = $bMiFH.filterCollectedUrl(urlObject.href, client);
            if (urlObject.port) attributes$1["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes$1["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes$1[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $9e767b0ca808b61c$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes$1
    ];
}
function $9e767b0ca808b61c$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $9e767b0ca808b61c$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $9e767b0ca808b61c$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $9e767b0ca808b61c$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $9e767b0ca808b61c$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $9e767b0ca808b61c$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $9e767b0ca808b61c$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $9e767b0ca808b61c$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $9e767b0ca808b61c$var$parseStringToURLObject;
module.exports.parseUrl = $9e767b0ca808b61c$var$parseUrl;
module.exports.stripDataUrlContent = $9e767b0ca808b61c$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $9e767b0ca808b61c$var$stripUrlQueryAndFragment;

});


parcelRegister("9eSGE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6b9fd78cb281f867$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
const $6b9fd78cb281f867$var$fmt = $6b9fd78cb281f867$var$parameterize;
module.exports.fmt = $6b9fd78cb281f867$var$fmt;
module.exports.parameterize = $6b9fd78cb281f867$var$parameterize;

});

parcelRegister("1E9Rm", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1scQ2 = parcelRequire("1scQ2");

var $g31Ce = parcelRequire("g31Ce");

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");
async function $13312ccd86a07de6$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response("Tunnel not configured", {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $j6N8F.parseEnvelope(body);
    } catch  {
        return new Response("Invalid envelope", {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response("Invalid envelope: missing header", {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response("Invalid envelope: missing DSN", {
        status: 400
    });
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $g31Ce.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response("DSN not allowed", {
            status: 403
        });
    }
    const dsnComponents = $3zkbY.makeDsn(dsn$1);
    if (!dsnComponents) {
        $g31Ce.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response("Invalid DSN", {
            status: 403
        });
    }
    const sentryIngestUrl = $1scQ2.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-sentry-envelope"
            },
            body: body
        });
    } catch (error) {
        $g31Ce.debug.error("Sentry tunnel: failed to forward envelope", error);
        return new Response("Failed to forward envelope to Sentry", {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $13312ccd86a07de6$var$handleTunnelRequest;

});

parcelRegister("9A3c5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6f99f418a33e1378$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === void 0) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
function $6f99f418a33e1378$var$addAutoIpAddressToSession(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}
module.exports.addAutoIpAddressToSession = $6f99f418a33e1378$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $6f99f418a33e1378$var$addAutoIpAddressToUser;

});

parcelRegister("2bFOy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bOz44 = parcelRequire("bOz44");
function $197d0b56419d73f3$var$applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: $bOz44.SDK_VERSION
            }));
        sdk.version = $bOz44.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $197d0b56419d73f3$var$applySdkMetadata;

});

parcelRegister("8gm0h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3tUnp = parcelRequire("3tUnp");

var $du5vT = parcelRequire("du5vT");

var $5JqSP = parcelRequire("5JqSP");

var $13TrR = parcelRequire("13TrR");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");

var $ckhr5 = parcelRequire("ckhr5");

var $gWYwh = parcelRequire("gWYwh");

var $4LxkX = parcelRequire("4LxkX");

var $aZ3HH = parcelRequire("aZ3HH");

var $7O2T2 = parcelRequire("7O2T2");
function $6040e2ce93309652$var$getTraceData(options = {}) {
    const client = options.client || $5JqSP.getClient();
    if (!$13TrR.isEnabled() || !client) return {};
    const carrier$1 = $du5vT.getMainCarrier();
    const acs = $3tUnp.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $5JqSP.getCurrentScope();
    const span = options.span || $6vUrj.getActiveSpan();
    const isTwpPlaceholder = $gWYwh.spanIsNonRecordingSpan(span) && !$ckhr5.hasSpansEnabled(client.getOptions());
    if (!span && $5JqSP.hasExternalPropagationContext()) return {};
    const sentryTrace = span && !isTwpPlaceholder ? $6vUrj.spanToTraceHeader(span) : $6040e2ce93309652$var$scopeToTraceHeader(scope);
    const dsc = span ? $4LxkX.getDynamicSamplingContextFromSpan(span) : $4LxkX.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $aZ3HH.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $7O2T2.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $g31Ce.debug.warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    const traceData = {
        "sentry-trace": sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span && !isTwpPlaceholder ? $6vUrj.spanToTraceparentHeader(span) : $6040e2ce93309652$var$scopeToTraceparentHeader(scope);
    return traceData;
}
function $6040e2ce93309652$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $7O2T2.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $6040e2ce93309652$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $7O2T2.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $6040e2ce93309652$var$getTraceData;

});

parcelRegister("fvTyO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $foFxi = parcelRequire("foFxi");
const $b4b4d9726191fe5f$var$NOT_PROPAGATED_MESSAGE = "[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:";
function $b4b4d9726191fe5f$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== "string" || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== void 0) {
        $3T29C.DEBUG_BUILD && !cachedDecision && $g31Ce.debug.log($b4b4d9726191fe5f$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $foFxi.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $3T29C.DEBUG_BUILD && !decision && $g31Ce.debug.log($b4b4d9726191fe5f$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $b4b4d9726191fe5f$var$shouldPropagateTraceForUrl;

});

parcelRegister("laTYc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8gm0h = parcelRequire("8gm0h");
function $f6a5f2a16a237c39$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $8gm0h.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join("");
}
module.exports.getTraceMetaTags = $f6a5f2a16a237c39$var$getTraceMetaTags;

});

parcelRegister("h6J9f", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c74604b311330f5a$var$uniq(input) {
    return Array.from(new Set(input));
}
module.exports.uniq = $c74604b311330f5a$var$uniq;

});

parcelRegister("8qWlp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $bD531 = parcelRequire("bD531");

var $5qpfH = parcelRequire("5qpfH");

var $eEukW = parcelRequire("eEukW");

var $dFAcI = parcelRequire("dFAcI");
const $623e026128e97057$var$MAX_BODY_BYTE_LENGTH = 1048576;
const $623e026128e97057$var$TEXT_CONTENT_TYPES = [
    "text/",
    "application/json",
    "application/x-www-form-urlencoded",
    "application/xml",
    "application/graphql"
];
function $623e026128e97057$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === "small") return 1e3;
    if (maxRequestBodySize === "medium") return 1e4;
    return $623e026128e97057$var$MAX_BODY_BYTE_LENGTH;
}
function $623e026128e97057$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") headers[key] = value;
        });
    } catch  {}
    return headers;
}
function $623e026128e97057$var$headersToDict(reqHeaders) {
    const headers = /* @__PURE__ */ Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === "string") headers[key] = value;
            else if (typeof value === "number") headers[key] = String(value);
        });
    } catch  {}
    return headers;
}
function $623e026128e97057$var$winterCGRequestToRequestData(req) {
    const headers = $623e026128e97057$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $623e026128e97057$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
function $623e026128e97057$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $623e026128e97057$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
async function $623e026128e97057$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get("content-type");
        if (!$623e026128e97057$var$isTextualContentType(contentType)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Skipping body capture for non-textual content type:", contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get("content-length");
        const maxBodySize = $623e026128e97057$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $623e026128e97057$var$MAX_BODY_BYTE_LENGTH) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Skipping body capture: body too large", length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $dFAcI.safeUnref(setTimeout(()=>resolve(null), 2e3));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Timeout reading request body");
            return;
        }
        if (!body) return;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log("Captured request body:", bodyByteLength, "bytes");
    } catch (error) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Error capturing request body:", error);
    }
}
function $623e026128e97057$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    const forwardedHost = typeof headers["x-forwarded-host"] === "string" ? headers["x-forwarded-host"] : void 0;
    const host = forwardedHost || (typeof headers.host === "string" ? headers.host : void 0);
    const forwardedProto = typeof headers["x-forwarded-proto"] === "string" ? headers["x-forwarded-proto"] : void 0;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? "https" : "http");
    const url = request.url || "";
    const absoluteUrl = $623e026128e97057$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    const data = request.body || void 0;
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $623e026128e97057$var$extractQueryParamsFromUrl(url),
        headers: $623e026128e97057$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $623e026128e97057$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith("http")) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return void 0;
}
function $623e026128e97057$var$httpHeadersToSpanAttributes(headers, dataCollection = false, lifecycle = "request") {
    const resolvedDataCollection = typeof dataCollection === "boolean" ? $bD531.defaultPiiToCollectionOptions(dataCollection) : dataCollection;
    const headerBehavior = lifecycle === "request" ? resolvedDataCollection.httpHeaders.request : resolvedDataCollection.httpHeaders.response;
    const cookieBehavior = resolvedDataCollection.cookies;
    const prefix = `http.${lifecycle}.header.`;
    const spanAttributes = {};
    try {
        const regularHeaders = {};
        for (const [key, value] of Object.entries(headers)){
            if (value == null) continue;
            const lowerKey = key.toLowerCase();
            const isCookieHeader = lowerKey === "cookie" || lowerKey === "set-cookie";
            if (isCookieHeader) {
                if (cookieBehavior === false) continue;
                if (typeof value === "string" && value !== "") {
                    const parsed = $623e026128e97057$var$parseCookieHeader(value, lowerKey === "set-cookie");
                    const filtered = $eEukW.filterKeyValueData(parsed, cookieBehavior, $5qpfH.SENSITIVE_COOKIE_NAME_SNIPPETS);
                    for (const [cookieKey, cookieValue] of Object.entries(filtered))spanAttributes[`${prefix}${$623e026128e97057$var$normalizeAttributeKey(lowerKey)}.${$623e026128e97057$var$normalizeAttributeKey(cookieKey)}`] = cookieValue;
                } else spanAttributes[`${prefix}${$623e026128e97057$var$normalizeAttributeKey(lowerKey)}`] = $5qpfH.FILTERED_VALUE;
            } else {
                if (headerBehavior === false) continue;
                if (Array.isArray(value)) regularHeaders[lowerKey] = value.map((v)=>v != null ? String(v) : v).join(";");
                else if (typeof value === "string") regularHeaders[lowerKey] = value;
            }
        }
        if (headerBehavior !== false) {
            const filtered = $eEukW.filterKeyValueData(regularHeaders, headerBehavior);
            for (const [headerKey, headerValue] of Object.entries(filtered))spanAttributes[`${prefix}${$623e026128e97057$var$normalizeAttributeKey(headerKey)}`] = headerValue;
        }
    } catch  {}
    return spanAttributes;
}
function $623e026128e97057$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, "_");
}
function $623e026128e97057$var$parseCookieHeader(value, isSetCookie) {
    const semicolonIndex = value.indexOf(";");
    const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
    const cookies = isSetCookie ? [
        cookieString
    ] : cookieString.split("; ");
    const result = {};
    for (const cookie of cookies){
        const equalSignIndex = cookie.indexOf("=");
        const cookieKey = (equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie).toLowerCase();
        const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : "";
        result[cookieKey] = cookieValue;
    }
    return result;
}
function $623e026128e97057$var$extractQueryParamsFromUrl(url) {
    if (!url) return;
    try {
        const queryParams = new URL(url, "http://s.io").search.slice(1);
        return queryParams.length ? queryParams : void 0;
    } catch  {
        return void 0;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $623e026128e97057$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $623e026128e97057$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $623e026128e97057$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $623e026128e97057$var$getMaxBodyByteLength;
module.exports.headersToDict = $623e026128e97057$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $623e026128e97057$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $623e026128e97057$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $623e026128e97057$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $623e026128e97057$var$winterCGRequestToRequestData;

});

parcelRegister("bctHB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8277daf33362ca55$var$SPAN_KIND = {
    INTERNAL: 0,
    SERVER: 1,
    CLIENT: 2,
    PRODUCER: 3,
    CONSUMER: 4
};
const $8277daf33362ca55$var$SPAN_KIND_NAME = {
    [$8277daf33362ca55$var$SPAN_KIND.INTERNAL]: "INTERNAL",
    [$8277daf33362ca55$var$SPAN_KIND.SERVER]: "SERVER",
    [$8277daf33362ca55$var$SPAN_KIND.CLIENT]: "CLIENT",
    [$8277daf33362ca55$var$SPAN_KIND.PRODUCER]: "PRODUCER",
    [$8277daf33362ca55$var$SPAN_KIND.CONSUMER]: "CONSUMER"
};
function $8277daf33362ca55$var$spanKindToName(kind) {
    return $8277daf33362ca55$var$SPAN_KIND_NAME[kind];
}
module.exports.SPAN_KIND = $8277daf33362ca55$var$SPAN_KIND;
module.exports.spanKindToName = $8277daf33362ca55$var$spanKindToName;

});

parcelRegister("8mgFa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $g31Ce = parcelRequire("g31Ce");

var $5L5uH = parcelRequire("5L5uH");
const $615d4db46a01524f$var$DEFAULT_BREADCRUMBS = 100;
function $615d4db46a01524f$var$addBreadcrumb(breadcrumb, hint) {
    const client = $5JqSP.getClient();
    const isolationScope = $5JqSP.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $615d4db46a01524f$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $5L5uH.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $g31Ce.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $615d4db46a01524f$var$addBreadcrumb;

});

parcelRegister("3Rkxj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $iOdTc = parcelRequire("iOdTc");

var $42zXR = parcelRequire("42zXR");
const $2cf640672a2aea88$var$INTEGRATION_NAME = "FunctionToString";
const $2cf640672a2aea88$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $2cf640672a2aea88$var$_functionToStringIntegration = ()=>{
    return {
        name: $2cf640672a2aea88$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $42zXR.getOriginalFunction(this);
                    let unwrappedFunction;
                    try {
                        if ($2cf640672a2aea88$var$SETUP_CLIENTS.has($5JqSP.getClient()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $2cf640672a2aea88$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $2cf640672a2aea88$var$functionToStringIntegration = $iOdTc.defineIntegration($2cf640672a2aea88$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $2cf640672a2aea88$var$functionToStringIntegration;

});

parcelRegister("g7zRo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $lpiqE = parcelRequire("lpiqE");

var $rzjlZ = parcelRequire("rzjlZ");

var $foFxi = parcelRequire("foFxi");
const $bbc91de2425cb6af$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /Java exception was raised during method invocation$/,
    // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065, https://github.com/getsentry/sentry-javascript/issues/23733)
    /Java object is gone$/
];
const $bbc91de2425cb6af$var$INTEGRATION_NAME = "EventFilters";
const $bbc91de2425cb6af$var$eventFiltersIntegration = $iOdTc.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $bbc91de2425cb6af$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $bbc91de2425cb6af$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $bbc91de2425cb6af$var$_mergeOptions(options, clientOptions);
            }
            return $bbc91de2425cb6af$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
const $bbc91de2425cb6af$var$inboundFiltersIntegration = $iOdTc.defineIntegration((options = {})=>{
    return {
        ...$bbc91de2425cb6af$var$eventFiltersIntegration(options),
        name: "InboundFilters"
    };
});
function $bbc91de2425cb6af$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $bbc91de2425cb6af$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $bbc91de2425cb6af$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($bbc91de2425cb6af$var$_isIgnoredError(event, options.ignoreErrors)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${$rzjlZ.getEventDescription(event)}`);
            return true;
        }
        if ($bbc91de2425cb6af$var$_isUselessError(event)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${$rzjlZ.getEventDescription(event)}`);
            return true;
        }
        if ($bbc91de2425cb6af$var$_isDeniedUrl(event, options.denyUrls)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${$rzjlZ.getEventDescription(event)}.
Url: ${$bbc91de2425cb6af$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$bbc91de2425cb6af$var$_isAllowedUrl(event, options.allowUrls)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${$rzjlZ.getEventDescription(event)}.
Url: ${$bbc91de2425cb6af$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($bbc91de2425cb6af$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${$rzjlZ.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $bbc91de2425cb6af$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $lpiqE.getPossibleEventMessages(event).some((message)=>$foFxi.stringMatchesSomePattern(message, ignoreErrors));
}
function $bbc91de2425cb6af$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $foFxi.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $bbc91de2425cb6af$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $bbc91de2425cb6af$var$_getEventFilterUrl(event);
    return !url ? false : $foFxi.stringMatchesSomePattern(url, denyUrls);
}
function $bbc91de2425cb6af$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $bbc91de2425cb6af$var$_getEventFilterUrl(event);
    return !url ? true : $foFxi.stringMatchesSomePattern(url, allowUrls);
}
function $bbc91de2425cb6af$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $bbc91de2425cb6af$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $bbc91de2425cb6af$var$_getLastValidUrl(frames) : null;
    } catch  {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`Cannot extract url for event ${$rzjlZ.getEventDescription(event)}`);
        return null;
    }
}
function $bbc91de2425cb6af$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}
module.exports.eventFiltersIntegration = $bbc91de2425cb6af$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $bbc91de2425cb6af$var$inboundFiltersIntegration;

});

parcelRegister("gkhWS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $aJD8C = parcelRequire("aJD8C");

var $9eX4e = parcelRequire("9eX4e");
const $be2c6fce6a30c3a1$var$DEFAULT_KEY = "cause";
const $be2c6fce6a30c3a1$var$DEFAULT_LIMIT = 5;
const $be2c6fce6a30c3a1$var$INTEGRATION_NAME = "LinkedErrors";
const $be2c6fce6a30c3a1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $be2c6fce6a30c3a1$var$DEFAULT_LIMIT;
    const key = options.key || $be2c6fce6a30c3a1$var$DEFAULT_KEY;
    return {
        name: $be2c6fce6a30c3a1$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            $aJD8C.applyAggregateErrorsToEvent($9eX4e.exceptionFromError, options2.stackParser, key, limit, event, hint);
        }
    };
};
const $be2c6fce6a30c3a1$var$linkedErrorsIntegration = $iOdTc.defineIntegration($be2c6fce6a30c3a1$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $be2c6fce6a30c3a1$var$linkedErrorsIntegration;

});
parcelRegister("aJD8C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");
function $7d0c775358931250$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$cUgOr.isError(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ($cUgOr.isError(error[key])) {
        $7d0c775358931250$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $7d0c775358931250$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($7d0c775358931250$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($cUgOr.isError(childError)) {
            $7d0c775358931250$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $7d0c775358931250$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $7d0c775358931250$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $7d0c775358931250$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $7d0c775358931250$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$7d0c775358931250$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $7d0c775358931250$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $7d0c775358931250$var$applyAggregateErrorsToEvent;

});

parcelRegister("9eX4e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $rzjlZ = parcelRequire("rzjlZ");

var $9EvIV = parcelRequire("9EvIV");

var $42zXR = parcelRequire("42zXR");
function $6ba33d6325c7ea10$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $6ba33d6325c7ea10$var$hasSentryFetchUrlHost(error) {
    return $cUgOr.isError(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $6ba33d6325c7ea10$var$_enhanceErrorWithSentryInfo(error) {
    if ($6ba33d6325c7ea10$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $6ba33d6325c7ea10$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $6ba33d6325c7ea10$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $6ba33d6325c7ea10$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $6ba33d6325c7ea10$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ($cUgOr.isError(value)) return value;
    }
    return void 0;
}
function $6ba33d6325c7ea10$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = $42zXR.extractExceptionKeysForMessage(exception);
    if ($cUgOr.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $6ba33d6325c7ea10$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $6ba33d6325c7ea10$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $6ba33d6325c7ea10$var$getException(client, mechanism, exception, hint) {
    if ($cUgOr.isError(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ($cUgOr.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: $9EvIV.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $6ba33d6325c7ea10$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $6ba33d6325c7ea10$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $6ba33d6325c7ea10$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $6ba33d6325c7ea10$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $6ba33d6325c7ea10$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $rzjlZ.addExceptionTypeValue(event, void 0, void 0);
    $rzjlZ.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $6ba33d6325c7ea10$var$eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $6ba33d6325c7ea10$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $rzjlZ.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($cUgOr.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $6ba33d6325c7ea10$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $6ba33d6325c7ea10$var$eventFromMessage;
module.exports.eventFromUnknownInput = $6ba33d6325c7ea10$var$eventFromUnknownInput;
module.exports.exceptionFromError = $6ba33d6325c7ea10$var$exceptionFromError;
module.exports.parseStackFrames = $6ba33d6325c7ea10$var$parseStackFrames;

});


parcelRegister("iVKe8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $lFg4k = parcelRequire("lFg4k");

var $j6N8F = parcelRequire("j6N8F");
const $dc81689577bb540b$var$moduleMetadataIntegration = $iOdTc.defineIntegration(()=>{
    return {
        name: "ModuleMetadata",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $j6N8F.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $lFg4k.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $lFg4k.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $dc81689577bb540b$var$moduleMetadataIntegration;

});
parcelRegister("lFg4k", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cqs9v = parcelRequire("cqs9v");
const $fc59e44246a66f95$var$filenameMetadataMap = /* @__PURE__ */ new Map();
const $fc59e44246a66f95$var$parsedStacks = /* @__PURE__ */ new Set();
function $fc59e44246a66f95$var$getFilenameToMetadataMap(parser) {
    if (!$cqs9v.GLOBAL_OBJ._sentryModuleMetadata) return {};
    const filenameMap = {};
    for (const stack of Object.keys($cqs9v.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $cqs9v.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $fc59e44246a66f95$var$ensureMetadataStacksAreParsed(parser) {
    if (!$cqs9v.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($cqs9v.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $cqs9v.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($fc59e44246a66f95$var$parsedStacks.has(stack)) continue;
        $fc59e44246a66f95$var$parsedStacks.add(stack);
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            $fc59e44246a66f95$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
function $fc59e44246a66f95$var$getMetadataForUrl(parser, filename) {
    $fc59e44246a66f95$var$ensureMetadataStacksAreParsed(parser);
    return $fc59e44246a66f95$var$filenameMetadataMap.get(filename);
}
function $fc59e44246a66f95$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $fc59e44246a66f95$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
function $fc59e44246a66f95$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $fc59e44246a66f95$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $fc59e44246a66f95$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $fc59e44246a66f95$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $fc59e44246a66f95$var$stripMetadataFromStackFrames;

});


parcelRegister("8K7Jl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $dixtt = parcelRequire("dixtt");

var $dAAl0 = parcelRequire("dAAl0");

var $deA5a = parcelRequire("deA5a");

var $8qWlp = parcelRequire("8qWlp");

var $iI370 = parcelRequire("iI370");

var $4wQxQ = parcelRequire("4wQxQ");

var $eAISS = parcelRequire("eAISS");
const $65d89db27b188a6b$var$INTEGRATION_NAME = "RequestData";
const $65d89db27b188a6b$var$_requestDataIntegration = (options = {})=>{
    function resolveIncludeAndDataCollection(client) {
        const dc = client.getDataCollectionOptions();
        const dataCollection = {
            ...dc,
            ...options.include?.cookies === true && dc.cookies === false && {
                cookies: true
            },
            ...options.include?.headers === true && dc.httpHeaders.request === false && {
                httpHeaders: {
                    ...dc.httpHeaders,
                    request: true
                }
            },
            ...options.include?.query_string === true && dc.urlQueryParams === false && {
                urlQueryParams: true
            }
        };
        return {
            dataCollection: dataCollection,
            include: {
                cookies: dataCollection.cookies !== false,
                // Always attach body data that's already on the scope — dataCollection.httpBodies gates write-time, not read-time
                data: true,
                headers: dataCollection.httpHeaders.request !== false,
                ip: dataCollection.userInfo,
                query_string: dataCollection.urlQueryParams !== false,
                // No dataCollection equivalent — URL is always included
                url: true,
                ...options.include
            }
        };
    }
    return {
        name: $65d89db27b188a6b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            if (normalizedRequest) $65d89db27b188a6b$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, include, dataCollection);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $5JqSP.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { include: include, dataCollection: dataCollection } = resolveIncludeAndDataCollection(client);
            $65d89db27b188a6b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection);
        }
    };
};
const $65d89db27b188a6b$var$requestDataIntegration = $iOdTc.defineIntegration($65d89db27b188a6b$var$_requestDataIntegration);
function $65d89db27b188a6b$var$addNormalizedRequestDataToEvent(event, req, additionalData, include, dataCollection) {
    const requestData = $65d89db27b188a6b$var$extractNormalizedRequestData(req, include);
    if (requestData.query_string) requestData.query_string = $65d89db27b188a6b$var$normalizeAndFilterQueryString(requestData.query_string, dataCollection.urlQueryParams);
    if (requestData.url) requestData.url = $deA5a.filterUrlQuery(requestData.url, dataCollection.urlQueryParams);
    event.request = {
        ...event.request,
        ...requestData
    };
    if (include.ip) {
        const ip = req.headers && $iI370.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $65d89db27b188a6b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, dataCollection) {
    const requestData = $65d89db27b188a6b$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes$1 = {};
    if (requestData.url) attributes$1[$eAISS.URL_FULL] = $deA5a.filterUrlQuery(requestData.url, dataCollection.urlQueryParams);
    if (requestData.method) attributes$1["http.request.method"] = requestData.method;
    if (requestData.query_string) attributes$1[$eAISS.URL_QUERY] = $65d89db27b188a6b$var$normalizeAndFilterQueryString(requestData.query_string, dataCollection.urlQueryParams);
    $4wQxQ.safeSetSpanJSONAttributes(span, attributes$1);
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join("; ");
        const cookieAttributes = $8qWlp.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, dataCollection, "request");
        $4wQxQ.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $8qWlp.httpHeadersToSpanAttributes(requestData.headers, dataCollection, "request");
        $4wQxQ.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === "string" ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $4wQxQ.safeSetSpanJSONAttributes(span, {
            "http.request.body.data": serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $iI370.getClientIPAddress(normalizedRequest.headers) || ipAddress || void 0;
        if (ip) $4wQxQ.safeSetSpanJSONAttributes(span, {
            [$f3RkF.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $65d89db27b188a6b$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($iI370.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $dixtt.parseCookie(headers.cookie) : void 0);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $65d89db27b188a6b$var$normalizeAndFilterQueryString(queryString, behavior) {
    const normalized = $65d89db27b188a6b$var$normalizeQueryString(queryString);
    return normalized ? $dAAl0.filterQueryParams(normalized, behavior) : void 0;
}
function $65d89db27b188a6b$var$normalizeQueryString(queryString) {
    if (typeof queryString === "string") return queryString || void 0;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const normalized = new URLSearchParams(pairs).toString();
    return normalized || void 0;
}
module.exports.requestDataIntegration = $65d89db27b188a6b$var$requestDataIntegration;

});
parcelRegister("iI370", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d9eec003e23cfeba$var$ipHeaderNames = [
    "X-Client-IP",
    "X-Forwarded-For",
    "Fly-Client-IP",
    "CF-Connecting-IP",
    "Fastly-Client-Ip",
    "True-Client-Ip",
    "X-Real-IP",
    "X-Cluster-Client-IP",
    "X-Forwarded",
    "Forwarded-For",
    "Forwarded",
    "X-Vercel-Forwarded-For"
];
function $d9eec003e23cfeba$var$getClientIPAddress(headers) {
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    const headerValues = $d9eec003e23cfeba$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(";") : rawValue;
        if (headerName === "Forwarded") return $d9eec003e23cfeba$var$parseForwardedHeader(value);
        return value?.split(",").map((v)=>v.trim());
    });
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $d9eec003e23cfeba$var$isIP(ip));
    return ipAddress || null;
}
function $d9eec003e23cfeba$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(";")){
        if (part.startsWith("for=")) return part.slice(4);
    }
    return null;
}
function $d9eec003e23cfeba$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $d9eec003e23cfeba$var$getClientIPAddress;
module.exports.ipHeaderNames = $d9eec003e23cfeba$var$ipHeaderNames;

});


parcelRegister("2Nx5l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $13TrR = parcelRequire("13TrR");

var $8PsOG = parcelRequire("8PsOG");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $rzjlZ = parcelRequire("rzjlZ");

var $dbBv0 = parcelRequire("dbBv0");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");
const $2099d26b534f0549$var$INTEGRATION_NAME = "CaptureConsole";
const $2099d26b534f0549$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $g31Ce.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $2099d26b534f0549$var$INTEGRATION_NAME,
        setup (client) {
            if (!("console" in $cqs9v.GLOBAL_OBJ)) return;
            $8PsOG.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($5JqSP.getClient() !== client || !levels.includes(level)) return;
                $2099d26b534f0549$var$consoleHandler(args, level, handled);
            });
        }
    };
};
const $2099d26b534f0549$var$captureConsoleIntegration = $iOdTc.defineIntegration($2099d26b534f0549$var$_captureConsoleIntegration);
function $2099d26b534f0549$var$consoleHandler(args, level, handled) {
    const severityLevel = $dbBv0.severityLevelFromString(level);
    const syntheticException = new Error();
    const captureContext = {
        level: $dbBv0.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $5JqSP.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            $rzjlZ.addExceptionMechanism(event, {
                handled: handled,
                type: "auto.core.capture_console"
            });
            return event;
        });
        if (level === "assert") {
            if (!args[0]) {
                const message2 = `Assertion failed: ${$foFxi.safeJoin(args.slice(1), " ") || "console.assert"}`;
                scope.setExtra("arguments", args.slice(1));
                scope.captureMessage(message2, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $13TrR.captureException(error, captureContext);
            return;
        }
        const message = $foFxi.safeJoin(args, " ");
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $2099d26b534f0549$var$captureConsoleIntegration;

});
parcelRegister("8PsOG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $42zXR = parcelRequire("42zXR");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
const $66d97085e604b789$var$_filter = /* @__PURE__ */ new Set([]);
function $66d97085e604b789$var$addConsoleInstrumentationHandler(handler) {
    const type = "console";
    const removeHandler = $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, $66d97085e604b789$var$instrumentConsole);
    return removeHandler;
}
function $66d97085e604b789$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$66d97085e604b789$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$66d97085e604b789$var$_filter.delete(f);
    };
}
const $66d97085e604b789$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $66d97085e604b789$var$instrumentConsole() {
    if (!("console" in $cqs9v.GLOBAL_OBJ)) return;
    $g31Ce.CONSOLE_LEVELS.forEach(function(level) {
        if ($66d97085e604b789$var$instrumentedLevels.has(level) || !(level in $cqs9v.GLOBAL_OBJ.console)) return;
        $66d97085e604b789$var$instrumentedLevels.add(level);
        $42zXR.fill($cqs9v.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $g31Ce.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $g31Ce.originalConsoleMethods[level];
                const isFiltered = $66d97085e604b789$var$_filter.size && typeof firstArg === "string" && $foFxi.stringMatchesSomePattern(firstArg, $66d97085e604b789$var$_filter);
                if (!isFiltered) $eCBhU.triggerHandlers("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || $3T29C.DEBUG_BUILD && $g31Ce.debug.isEnabled()) log?.apply($cqs9v.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $66d97085e604b789$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $66d97085e604b789$var$addConsoleInstrumentationHandler;
module.exports.instrumentConsole = $66d97085e604b789$var$instrumentConsole;

});

parcelRegister("dbBv0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $999963fca5d2d2fd$var$severityLevelFromString(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}
module.exports.severityLevelFromString = $999963fca5d2d2fd$var$severityLevelFromString;

});


parcelRegister("jFWDT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $1nK9H = parcelRequire("1nK9H");
const $e52f55d1d357b41c$var$INTEGRATION_NAME = "Dedupe";
const $e52f55d1d357b41c$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $e52f55d1d357b41c$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($e52f55d1d357b41c$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $e52f55d1d357b41c$var$dedupeIntegration = $iOdTc.defineIntegration($e52f55d1d357b41c$var$_dedupeIntegration);
function $e52f55d1d357b41c$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($e52f55d1d357b41c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($e52f55d1d357b41c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $e52f55d1d357b41c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$e52f55d1d357b41c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$e52f55d1d357b41c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $e52f55d1d357b41c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $e52f55d1d357b41c$var$_getExceptionFromEvent(previousEvent);
    const currentException = $e52f55d1d357b41c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$e52f55d1d357b41c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$e52f55d1d357b41c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $e52f55d1d357b41c$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $1nK9H.getFramesFromEvent(currentEvent);
    let previousFrames = $1nK9H.getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) return true;
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $e52f55d1d357b41c$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) return true;
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $e52f55d1d357b41c$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $e52f55d1d357b41c$var$_shouldDropEvent;
module.exports.dedupeIntegration = $e52f55d1d357b41c$var$dedupeIntegration;

});

parcelRegister("dwAOK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");

var $fQMpe = parcelRequire("fQMpe");

var $foFxi = parcelRequire("foFxi");
const $9d8ad2b77950e154$var$INTEGRATION_NAME = "ExtraErrorData";
const $9d8ad2b77950e154$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $9d8ad2b77950e154$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $9d8ad2b77950e154$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $9d8ad2b77950e154$var$extraErrorDataIntegration = $iOdTc.defineIntegration($9d8ad2b77950e154$var$_extraErrorDataIntegration);
function $9d8ad2b77950e154$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$cUgOr.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $9d8ad2b77950e154$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $9EvIV.normalize(errorData, depth);
        if ($cUgOr.isPlainObject(normalizedErrorData)) {
            $fQMpe.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
function $9d8ad2b77950e154$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $cUgOr.isError(value) || typeof value === "string" ? maxValueLength ? $foFxi.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        if (captureErrorCause && error.cause !== void 0) {
            if ($cUgOr.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $9d8ad2b77950e154$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $cUgOr.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $9d8ad2b77950e154$var$extraErrorDataIntegration;

});

parcelRegister("dp3IX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $5ZJSQ = parcelRequire("5ZJSQ");

var $cqs9v = parcelRequire("cqs9v");
const $9c207fad3e121ad5$var$INTEGRATION_NAME = "RewriteFrames";
const $9c207fad3e121ad5$var$rewriteFramesIntegration = $iOdTc.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in $cqs9v.GLOBAL_OBJ && !!$cqs9v.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $9c207fad3e121ad5$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $9c207fad3e121ad5$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
function $9c207fad3e121ad5$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "").replace(/\\/g, "/") : frame.filename;
            const base = root ? $5ZJSQ.relative(root, filename) : $5ZJSQ.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $9c207fad3e121ad5$var$generateIteratee;
module.exports.rewriteFramesIntegration = $9c207fad3e121ad5$var$rewriteFramesIntegration;

});
parcelRegister("5ZJSQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $45d63dce37017897$var$normalizeArray(parts, allowAboveRoot) {
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
const $45d63dce37017897$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
function $45d63dce37017897$var$splitPath(filename) {
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $45d63dce37017897$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
function $45d63dce37017897$var$resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    resolvedPath = $45d63dce37017897$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
function $45d63dce37017897$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $45d63dce37017897$var$relative(from, to) {
    from = $45d63dce37017897$var$resolve(from).slice(1);
    to = $45d63dce37017897$var$resolve(to).slice(1);
    const fromParts = $45d63dce37017897$var$trim(from.split("/"));
    const toParts = $45d63dce37017897$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $45d63dce37017897$var$normalizePath(path) {
    const isPathAbsolute = $45d63dce37017897$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    let normalizedPath = $45d63dce37017897$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $45d63dce37017897$var$isAbsolute(path) {
    return path.charAt(0) === "/";
}
function $45d63dce37017897$var$join(...args) {
    return $45d63dce37017897$var$normalizePath(args.join("/"));
}
function $45d63dce37017897$var$dirname(path) {
    const result = $45d63dce37017897$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) return ".";
    if (dir) dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
function $45d63dce37017897$var$basename(path, ext) {
    let f = $45d63dce37017897$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $45d63dce37017897$var$basename;
module.exports.dirname = $45d63dce37017897$var$dirname;
module.exports.isAbsolute = $45d63dce37017897$var$isAbsolute;
module.exports.join = $45d63dce37017897$var$join;
module.exports.normalizePath = $45d63dce37017897$var$normalizePath;
module.exports.relative = $45d63dce37017897$var$relative;
module.exports.resolve = $45d63dce37017897$var$resolve;

});


parcelRegister("QE2yw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8mgFa = parcelRequire("8mgFa");

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $13TrR = parcelRequire("13TrR");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $rzjlZ = parcelRequire("rzjlZ");

var $cUgOr = parcelRequire("cUgOr");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");
const $09e3ea98f4729cb0$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    "reauthenticate",
    "signInAnonymously",
    "signInWithOAuth",
    "signInWithIdToken",
    "signInWithOtp",
    "signInWithPassword",
    "signInWithSSO",
    "signOut",
    "signUp",
    "verifyOtp"
];
const $09e3ea98f4729cb0$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    "createUser",
    "deleteUser",
    "listUsers",
    "getUserById",
    "updateUserById",
    "inviteUserByEmail"
];
const $09e3ea98f4729cb0$var$FILTER_MAPPINGS = {
    eq: "eq",
    neq: "neq",
    gt: "gt",
    gte: "gte",
    lt: "lt",
    lte: "lte",
    like: "like",
    "like(all)": "likeAllOf",
    "like(any)": "likeAnyOf",
    ilike: "ilike",
    "ilike(all)": "ilikeAllOf",
    "ilike(any)": "ilikeAnyOf",
    is: "is",
    in: "in",
    cs: "contains",
    cd: "containedBy",
    sr: "rangeGt",
    nxl: "rangeGte",
    sl: "rangeLt",
    nxr: "rangeLte",
    adj: "rangeAdjacent",
    ov: "overlaps",
    fts: "",
    plfts: "plain",
    phfts: "phrase",
    wfts: "websearch",
    not: "not"
};
const $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT = [
    "select",
    "insert",
    "upsert",
    "update",
    "delete"
];
function $09e3ea98f4729cb0$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {}
}
function $09e3ea98f4729cb0$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
function $09e3ea98f4729cb0$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return void 0;
}
function $09e3ea98f4729cb0$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $09e3ea98f4729cb0$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== void 0;
}
function $09e3ea98f4729cb0$var$getHeader(headers, name) {
    if (!headers) return void 0;
    if (typeof headers.get === "function") return headers.get(name) ?? void 0;
    const plainHeaders = headers;
    const lowerCaseName = name.toLowerCase();
    const key = Object.keys(plainHeaders).find((headerName)=>headerName.toLowerCase() === lowerCaseName);
    return key !== void 0 ? plainHeaders[key] : void 0;
}
function $09e3ea98f4729cb0$var$extractOperation(method, headers = {}) {
    switch(method){
        case "GET":
            return "select";
        case "POST":
            if ($09e3ea98f4729cb0$var$getHeader(headers, "Prefer")?.includes("resolution=")) return "upsert";
            else return "insert";
        case "PATCH":
            return "update";
        case "DELETE":
            return "delete";
        default:
            return "<unknown-op>";
    }
}
function $09e3ea98f4729cb0$var$translateFiltersIntoMethods(key, query) {
    if (query === "" || query === "*") return "select(*)";
    if (key === "select") return `select(${query})`;
    if (key === "or" || key.endsWith(".or")) return `${key}${query}`;
    const [filter, ...value] = query.split(".");
    let method;
    if (filter?.startsWith("fts")) method = "textSearch";
    else if (filter?.startsWith("plfts")) method = "textSearch[plain]";
    else if (filter?.startsWith("phfts")) method = "textSearch[phrase]";
    else if (filter?.startsWith("wfts")) method = "textSearch[websearch]";
    else method = filter && $09e3ea98f4729cb0$var$FILTER_MAPPINGS[filter] || "filter";
    return `${method}(${key}, ${value.join(".")})`;
}
function $09e3ea98f4729cb0$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $5CFne.startSpan({
                name: `auth ${isAdmin ? "(admin) " : ""}${operation.name}`,
                attributes: {
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db",
                    "db.system": "postgresql",
                    "db.operation": `auth.${isAdmin ? "admin." : ""}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if ($cUgOr.isObjectLike(res) && "error" in res && res.error) {
                        span.setStatus({
                            code: $h5H4c.SPAN_STATUS_ERROR
                        });
                        $13TrR.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: "auto.db.supabase.auth"
                            }
                        });
                    } else span.setStatus({
                        code: $h5H4c.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $13TrR.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: "auto.db.supabase.auth"
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $09e3ea98f4729cb0$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $09e3ea98f4729cb0$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $09e3ea98f4729cb0$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === "function") supabaseClientInstance.auth[operation] = $09e3ea98f4729cb0$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $09e3ea98f4729cb0$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === "function") supabaseClientInstance.auth.admin[operation] = $09e3ea98f4729cb0$var$instrumentAuthOperation(authOperation, true);
    }
    $09e3ea98f4729cb0$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $09e3ea98f4729cb0$var$instrumentSupabaseClientConstructor(SupabaseClient, _options) {
    if ($09e3ea98f4729cb0$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $09e3ea98f4729cb0$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options);
            return rv;
        }
    });
    $09e3ea98f4729cb0$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $09e3ea98f4729cb0$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options) {
    if ($09e3ea98f4729cb0$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $09e3ea98f4729cb0$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== "string") return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split("/");
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : "";
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())queryItems.push($09e3ea98f4729cb0$var$translateFiltersIntoMethods(key, value));
            const body = /* @__PURE__ */ Object.create(null);
            if ($cUgOr.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const client = $5JqSP.getClient();
            const shouldSendData = _options.sendOperationData ?? client?.getDataCollectionOptions().databaseQueryData === true;
            const bodyPayload = $09e3ea98f4729cb0$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            const mutationPart = operation === "select" ? "" : `${operation}${$09e3ea98f4729cb0$var$hasMutationBodyForDescription(typedThis.body, body) ? "(...) " : ""}`;
            const queryPart = shouldSendData ? queryItems.join(" ") : queryItems.length > 0 ? "[redacted]" : "";
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(" ");
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                "db.table": table,
                "db.schema": typedThis.schema,
                "db.url": typedThis.url.origin,
                "db.sdk": $09e3ea98f4729cb0$var$getHeader(typedThis.headers, "X-Client-Info"),
                "db.system": "postgresql",
                "db.operation": operation,
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.db.supabase",
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "db"
            };
            if (queryItems.length && shouldSendData) attributes["db.query"] = queryItems;
            if (bodyPayload !== void 0 && shouldSendData) attributes["db.body"] = bodyPayload;
            return $5CFne.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === "object" && "status" in res) $h5H4c.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && shouldSendData) supabaseContext.query = queryItems;
                        if (bodyPayload !== void 0 && shouldSendData) supabaseContext.body = bodyPayload;
                        $13TrR.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $rzjlZ.addExceptionMechanism(e, {
                                    handled: false,
                                    type: "auto.db.supabase.postgres"
                                });
                                return e;
                            });
                            scope.setContext("supabase", supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: "supabase",
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && shouldSendData) data.query = queryItems;
                    if (bodyPayload !== void 0 && shouldSendData) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $8mgFa.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    if (span) {
                        $h5H4c.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $09e3ea98f4729cb0$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $09e3ea98f4729cb0$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder, _options) {
    for (const operation of $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($09e3ea98f4729cb0$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $09e3ea98f4729cb0$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder, _options);
                return rv;
            }
        });
        $09e3ea98f4729cb0$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $09e3ea98f4729cb0$var$instrumentSupabaseClient = (supabaseClient, options = {})=>{
    if (!supabaseClient) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Supabase integration was not installed because no Supabase client was provided.");
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $09e3ea98f4729cb0$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor, options);
    $09e3ea98f4729cb0$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $09e3ea98f4729cb0$var$INTEGRATION_NAME = "Supabase";
const $09e3ea98f4729cb0$var$_supabaseIntegration = (supabaseClient, options)=>{
    return {
        setupOnce () {
            $09e3ea98f4729cb0$var$instrumentSupabaseClient(supabaseClient, options);
        },
        name: $09e3ea98f4729cb0$var$INTEGRATION_NAME
    };
};
const $09e3ea98f4729cb0$var$supabaseIntegration = $iOdTc.defineIntegration((options)=>{
    return $09e3ea98f4729cb0$var$_supabaseIntegration(options.supabaseClient, {
        sendOperationData: options.sendOperationData
    });
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $09e3ea98f4729cb0$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $09e3ea98f4729cb0$var$FILTER_MAPPINGS;
module.exports.extractOperation = $09e3ea98f4729cb0$var$extractOperation;
module.exports.getHeader = $09e3ea98f4729cb0$var$getHeader;
module.exports.instrumentSupabaseClient = $09e3ea98f4729cb0$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $09e3ea98f4729cb0$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $09e3ea98f4729cb0$var$translateFiltersIntoMethods;

});

parcelRegister("f6w5N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $cUgOr = parcelRequire("cUgOr");

var $foFxi = parcelRequire("foFxi");
const $aff04f72d4d86d63$var$DEFAULT_LIMIT = 10;
const $aff04f72d4d86d63$var$INTEGRATION_NAME = "ZodErrors";
function $aff04f72d4d86d63$var$originalExceptionIsZodError(originalException) {
    return $cUgOr.isError(originalException) && originalException.name === "ZodError" && Array.isArray(originalException.issues);
}
function $aff04f72d4d86d63$var$flattenIssue(issue) {
    return {
        ...issue,
        path: "path" in issue && Array.isArray(issue.path) ? issue.path.join(".") : void 0,
        keys: "keys" in issue ? JSON.stringify(issue.keys) : void 0,
        unionErrors: "unionErrors" in issue ? JSON.stringify(issue.unionErrors) : void 0
    };
}
function $aff04f72d4d86d63$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === "number") return "<array>";
        else return p;
    }).join(".");
}
function $aff04f72d4d86d63$var$formatIssueMessage(zodError) {
    const errorKeyMap = /* @__PURE__ */ new Set();
    for (const iss of zodError.issues){
        const issuePath = $aff04f72d4d86d63$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        let rootExpectedType = "variable";
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== void 0 && "expected" in iss && typeof iss.expected === "string") rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$foFxi.truncate(errorKeys.join(", "), 100)}`;
}
function $aff04f72d4d86d63$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$aff04f72d4d86d63$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($aff04f72d4d86d63$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: "zod_issues.json",
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $aff04f72d4d86d63$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                "zoderror.issues": flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        return {
            ...event,
            extra: {
                ...event.extra,
                "zoderrors sentry integration parse error": {
                    message: "an exception was thrown while processing ZodError within applyZodErrorsToEvent()",
                    error: e instanceof Error ? `${e.name}: ${e.message}
${e.stack}` : "unknown"
                }
            }
        };
    }
}
const $aff04f72d4d86d63$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $aff04f72d4d86d63$var$DEFAULT_LIMIT;
    return {
        name: $aff04f72d4d86d63$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $aff04f72d4d86d63$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
const $aff04f72d4d86d63$var$zodErrorsIntegration = $iOdTc.defineIntegration($aff04f72d4d86d63$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $aff04f72d4d86d63$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $aff04f72d4d86d63$var$flattenIssue;
module.exports.flattenIssuePath = $aff04f72d4d86d63$var$flattenIssuePath;
module.exports.formatIssueMessage = $aff04f72d4d86d63$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $aff04f72d4d86d63$var$zodErrorsIntegration;

});

parcelRegister("f87mP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $lFg4k = parcelRequire("lFg4k");

var $j6N8F = parcelRequire("j6N8F");

var $1nK9H = parcelRequire("1nK9H");

var $cqs9v = parcelRequire("cqs9v");
const $b03d515c77c654c6$var$thirdPartyErrorFilterIntegration = $iOdTc.defineIntegration((options)=>{
    return {
        name: "ThirdPartyErrorsFilter",
        setup (client) {
            client.on("beforeEnvelope", (envelope$1)=>{
                $j6N8F.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : void 0;
                        if (event) {
                            $lFg4k.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on("applyFrameMetadata", (event)=>{
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $lFg4k.addMetadataToStackFrames(stackParser, event);
            });
        },
        preprocessEvent (event) {
            if (options.ignoreSentryInternalFrames && ($cqs9v.GLOBAL_OBJ._sentryWrappedDepth ?? 0) > 0) event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                insideSentryWrapped: true
            };
        },
        processEvent (event) {
            const insideSentryWrapped = options.ignoreSentryInternalFrames ? event.sdkProcessingMetadata?.insideSentryWrapped === true && event.exception?.values?.length === 1 : false;
            const frameKeys = $b03d515c77c654c6$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames, insideSentryWrapped);
            if (frameKeys) {
                const arrayMethod = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "apply-tag-if-contains-third-party-frames" ? "some" : "every";
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === "drop-error-if-contains-third-party-frames" || options.behaviour === "drop-error-if-exclusively-contains-third-party-frames";
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
function $b03d515c77c654c6$var$isSentryInternalFrame(frame, frameIndex, insideSentryWrapped) {
    if (frameIndex !== 0) return false;
    if (insideSentryWrapped && $b03d515c77c654c6$var$isLikelyMinifiedSentryWrappedFrame(frame)) return true;
    if (frame.function === "sentryWrapped") return true;
    if (!frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes("sentry") || !frame.filename.includes("helpers") || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($b03d515c77c654c6$var$SENTRY_INTERNAL_FN_APPLY)) return false;
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($b03d515c77c654c6$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $b03d515c77c654c6$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames, insideSentryWrapped) {
    const frames = $1nK9H.getFramesFromEvent(event);
    if (!frames) return void 0;
    return frames.filter((frame, index)=>{
        if (!frame.filename) return false;
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        return !ignoreSentryInternalFrames || !$b03d515c77c654c6$var$isSentryInternalFrame(frame, index, !!insideSentryWrapped);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($b03d515c77c654c6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($b03d515c77c654c6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
function $b03d515c77c654c6$var$isLikelyMinifiedSentryWrappedFrame(frame) {
    return !frame.context_line && !frame.pre_context && !!frame.function && frame.function.length <= 2;
}
const $b03d515c77c654c6$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = "_sentryBundlerPluginAppKey:";
const $b03d515c77c654c6$var$SENTRY_INTERNAL_COMMENT = "Attempt to invoke user-land function";
const $b03d515c77c654c6$var$SENTRY_INTERNAL_FN_APPLY = "fn.apply(this, wrappedArguments)";
module.exports.thirdPartyErrorFilterIntegration = $b03d515c77c654c6$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("dp8LO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8mgFa = parcelRequire("8mgFa");

var $5JqSP = parcelRequire("5JqSP");

var $8PsOG = parcelRequire("8PsOG");

var $iOdTc = parcelRequire("iOdTc");

var $g31Ce = parcelRequire("g31Ce");

var $dbBv0 = parcelRequire("dbBv0");

var $foFxi = parcelRequire("foFxi");

var $cqs9v = parcelRequire("cqs9v");
const $9c2469c12e6fa54b$var$INTEGRATION_NAME = "Console";
const $9c2469c12e6fa54b$var$consoleIntegration = $iOdTc.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $g31Ce.CONSOLE_LEVELS);
    return {
        name: $9c2469c12e6fa54b$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $8PsOG.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($5JqSP.getClient() !== client || !levels.has(level)) return;
                $9c2469c12e6fa54b$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = $8PsOG.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $9c2469c12e6fa54b$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: $dbBv0.severityLevelFromString(level),
        message: $9c2469c12e6fa54b$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$9c2469c12e6fa54b$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    $8mgFa.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $9c2469c12e6fa54b$var$formatConsoleArgs(values) {
    return "util" in $cqs9v.GLOBAL_OBJ && typeof $cqs9v.GLOBAL_OBJ.util.format === "function" ? $cqs9v.GLOBAL_OBJ.util.format(...values) : $foFxi.safeJoin(values, " ");
}
module.exports.addConsoleBreadcrumb = $9c2469c12e6fa54b$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $9c2469c12e6fa54b$var$consoleIntegration;

});

parcelRegister("dCSiT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $eFFx8 = parcelRequire("eFFx8");
const $9eb8f2923fbd736a$var$featureFlagsIntegration = $iOdTc.defineIntegration(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return $eFFx8._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $eFFx8._INTERNAL_insertFlagToScope(name, value);
            $eFFx8._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $9eb8f2923fbd736a$var$featureFlagsIntegration;

});
parcelRegister("eFFx8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
const $aae51cb59fb527e0$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
const $aae51cb59fb527e0$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX = "flag.evaluation.";
function $aae51cb59fb527e0$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) return event;
    const scope = $5JqSP.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === void 0) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
function $aae51cb59fb527e0$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $aae51cb59fb527e0$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $5JqSP.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $aae51cb59fb527e0$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
function $aae51cb59fb527e0$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) flags.splice(index, 1);
    if (flags.length === maxSize) flags.shift();
    flags.push({
        flag: name,
        result: value
    });
}
function $aae51cb59fb527e0$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $aae51cb59fb527e0$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== "boolean") return;
    const span = $6vUrj.getActiveSpan();
    if (!span) return;
    const attributes = $6vUrj.spanToJSON(span).data;
    if (`${$aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$aae51cb59fb527e0$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $aae51cb59fb527e0$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $aae51cb59fb527e0$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $aae51cb59fb527e0$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $aae51cb59fb527e0$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $aae51cb59fb527e0$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $aae51cb59fb527e0$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("i5zdK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iOdTc = parcelRequire("iOdTc");

var $eFFx8 = parcelRequire("eFFx8");

var $42zXR = parcelRequire("42zXR");
const $d2b403b7ada96413$var$growthbookIntegration = $iOdTc.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: "GrowthBook",
        setupOnce () {
            const proto = growthbookClass.prototype;
            if (typeof proto.isOn === "function") $42zXR.fill(proto, "isOn", $d2b403b7ada96413$var$_wrapAndCaptureBooleanResult);
            if (typeof proto.getFeatureValue === "function") $42zXR.fill(proto, "getFeatureValue", $d2b403b7ada96413$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $eFFx8._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $d2b403b7ada96413$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === "string" && typeof result === "boolean") {
            $eFFx8._INTERNAL_insertFlagToScope(flagName, result);
            $eFFx8._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $d2b403b7ada96413$var$growthbookIntegration;

});

parcelRegister("1V5lh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $6vUrj = parcelRequire("6vUrj");
const $165f422d979fd1e0$var$INTEGRATION_NAME = "ConversationId";
const $165f422d979fd1e0$var$_conversationIdIntegration = ()=>{
    return {
        name: $165f422d979fd1e0$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = $5JqSP.getCurrentScope().getScopeData();
                const isolationScopeData = $5JqSP.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $6vUrj.spanToJSON(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute($f3RkF.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
const $165f422d979fd1e0$var$conversationIdIntegration = $iOdTc.defineIntegration($165f422d979fd1e0$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $165f422d979fd1e0$var$conversationIdIntegration;

});

parcelRegister("1hGnJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");
function $0ef8411b4ec8151f$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration["_profiler"] !== "undefined" && typeof integration["_profiler"]["start"] === "function" && typeof integration["_profiler"]["stop"] === "function";
}
function $0ef8411b4ec8151f$var$startProfiler() {
    const client = $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$0ef8411b4ec8151f$var$isProfilingIntegrationWithProfiler(integration)) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.start();
}
function $0ef8411b4ec8151f$var$stopProfiler() {
    const client = $5JqSP.getClient();
    if (!client) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No Sentry client available, profiling is not started");
        return;
    }
    const integration = client.getIntegrationByName("ProfilingIntegration");
    if (!integration) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("ProfilingIntegration is not available");
        return;
    }
    if (!$0ef8411b4ec8151f$var$isProfilingIntegrationWithProfiler(integration)) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Profiler is not available on profiling integration.");
        return;
    }
    integration._profiler.stop();
}
const $0ef8411b4ec8151f$var$profiler = {
    startProfiler: $0ef8411b4ec8151f$var$startProfiler,
    stopProfiler: $0ef8411b4ec8151f$var$stopProfiler
};
module.exports.profiler = $0ef8411b4ec8151f$var$profiler;

});

parcelRegister("jzLgh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $6vUrj = parcelRequire("6vUrj");

var $h5H4c = parcelRequire("h5H4c");

var $cUgOr = parcelRequire("cUgOr");

var $ckhr5 = parcelRequire("ckhr5");

var $gWYwh = parcelRequire("gWYwh");

var $aZ3HH = parcelRequire("aZ3HH");

var $6Xrci = parcelRequire("6Xrci");

var $5CFne = parcelRequire("5CFne");

var $bMiFH = parcelRequire("bMiFH");

var $8gm0h = parcelRequire("8gm0h");

var $dBuCl = parcelRequire("dBuCl");
function $e405f25ee64c11ba$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return void 0;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $ckhr5.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult) {
                $e405f25ee64c11ba$var$endSpan(span2, handlerData);
                $e405f25ee64c11ba$var$_callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const { spanOrigin: spanOrigin = "auto.http.browser", propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $5JqSP.getClient();
    const hasParent = !!$6vUrj.getActiveSpan();
    const shouldEmitSpan = hasParent || !!client && $6Xrci.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $5CFne.startInactiveSpan($e405f25ee64c11ba$var$getSpanStartOptions(url, method, spanOrigin, client)) : new $gWYwh.SentryNonRecordingSpan();
    const spanForTraceHeaders = $5CFne.spanIsIgnored(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $e405f25ee64c11ba$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $ckhr5.hasSpansEnabled() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
        if (headers) {
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
function $e405f25ee64c11ba$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
function $e405f25ee64c11ba$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $8gm0h.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    if (!sentryTrace) return void 0;
    const originalHeaders = fetchOptionsObj.headers || ($cUgOr.isRequest(request) ? request.headers : void 0);
    if (!originalHeaders) return {
        "sentry-trace": sentryTrace,
        ...baggage && {
            baggage: baggage
        },
        ...traceparent && {
            traceparent: traceparent
        }
    };
    else if ($e405f25ee64c11ba$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        if (!newHeaders.get("sentry-trace")) newHeaders.set("sentry-trace", sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) newHeaders.set("traceparent", traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (!prevBaggageHeader) newHeaders.set("baggage", baggage);
            else if (!$e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($e405f25ee64c11ba$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === "sentry-trace")) newHeaders.push([
            "sentry-trace",
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === "traceparent")) newHeaders.push([
            "traceparent",
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === "baggage" && typeof header[1] === "string" && $e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
        const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
        const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
            ...newBaggageHeaders.length > 0 && {
                baggage: newBaggageHeaders.join(",")
            }
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $e405f25ee64c11ba$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $h5H4c.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $h5H4c.SPAN_STATUS_ERROR,
        message: "internal_error"
    });
    span.end();
}
function $e405f25ee64c11ba$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== "string") return false;
    return baggageHeader.split(",").some((baggageEntry)=>baggageEntry.trim().startsWith($aZ3HH.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $e405f25ee64c11ba$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && $cUgOr.isInstanceOf(headers, Headers);
}
function $e405f25ee64c11ba$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === "string");
}
function $e405f25ee64c11ba$var$getSpanStartOptions(url$1, method, spanOrigin, client) {
    if (url$1.startsWith("data:")) {
        const sanitizedUrl2 = $dBuCl.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl2}`,
            attributes: $e405f25ee64c11ba$var$getFetchSpanAttributes(url$1, void 0, method, spanOrigin, client)
        };
    }
    const parsedUrl = $dBuCl.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $dBuCl.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $e405f25ee64c11ba$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin, client)
    };
}
function $e405f25ee64c11ba$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin, client) {
    const attributes$1 = {
        url: $bMiFH.filterCollectedUrl($dBuCl.stripDataUrlContent(url$1), client),
        type: "fetch",
        "http.method": method,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "http.client"
    };
    if (parsedUrl) {
        if (!$dBuCl.isURLObjectRelative(parsedUrl)) {
            attributes$1[$eAISS.HTTP_URL] = $bMiFH.filterCollectedUrl($dBuCl.stripDataUrlContent(parsedUrl.href), client);
            attributes$1[$eAISS.URL_FULL] = $bMiFH.filterCollectedUrl($dBuCl.stripDataUrlContent(parsedUrl.href), client);
            attributes$1["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes$1["http.query"] = $bMiFH.filterCollectedUrlQuery(parsedUrl.search, client);
        if (parsedUrl.hash) attributes$1["http.fragment"] = parsedUrl.hash;
    }
    return attributes$1;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $e405f25ee64c11ba$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $e405f25ee64c11ba$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $e405f25ee64c11ba$var$instrumentFetchRequest;

});

parcelRegister("iqqtV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");
function $d69f326a12551363$var$captureFeedback(params, hint = {}, scope = $5JqSP.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: "feedback",
        level: "info",
        tags: tags
    };
    const client = scope?.getClient() || $5JqSP.getClient();
    if (client) client.emit("beforeSendFeedback", feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $d69f326a12551363$var$captureFeedback;

});

parcelRegister("1XBvb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $krgwg = parcelRequire("krgwg");

var $9eSGE = parcelRequire("9eSGE");
function $16d864420425cf58$var$captureLog(level, message, attributes, scope, severityNumber) {
    $krgwg._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
function $16d864420425cf58$var$trace(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("trace", message, attributes, scope);
}
function $16d864420425cf58$var$debug(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("debug", message, attributes, scope);
}
function $16d864420425cf58$var$info(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("info", message, attributes, scope);
}
function $16d864420425cf58$var$warn(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("warn", message, attributes, scope);
}
function $16d864420425cf58$var$error(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("error", message, attributes, scope);
}
function $16d864420425cf58$var$fatal(message, attributes, { scope: scope } = {}) {
    $16d864420425cf58$var$captureLog("fatal", message, attributes, scope);
}
module.exports.fmt = $9eSGE.fmt;
module.exports.debug = $16d864420425cf58$var$debug;
module.exports.error = $16d864420425cf58$var$error;
module.exports.fatal = $16d864420425cf58$var$fatal;
module.exports.info = $16d864420425cf58$var$info;
module.exports.trace = $16d864420425cf58$var$trace;
module.exports.warn = $16d864420425cf58$var$warn;

});

parcelRegister("dDJiI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $3T29C = parcelRequire("3T29C");

var $8PsOG = parcelRequire("8PsOG");

var $iOdTc = parcelRequire("iOdTc");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");

var $krgwg = parcelRequire("krgwg");

var $dqieo = parcelRequire("dqieo");
const $9ee20eb215bf3662$var$INTEGRATION_NAME = "ConsoleLogs";
const $9ee20eb215bf3662$var$DEFAULT_ATTRIBUTES = {
    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.log.console"
};
const $9ee20eb215bf3662$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $g31Ce.CONSOLE_LEVELS;
    return {
        name: $9ee20eb215bf3662$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            if (!enableLogs) {
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("`enableLogs` is not enabled, ConsoleLogs integration disabled");
                return;
            }
            const unsubscribe = $8PsOG.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($5JqSP.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === "assert") {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$dqieo.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : "Assertion failed";
                        $krgwg._INTERNAL_captureLog({
                            level: "error",
                            message: assertionMessage,
                            attributes: $9ee20eb215bf3662$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === "log";
                const attributes = {
                    ...$9ee20eb215bf3662$var$DEFAULT_ATTRIBUTES
                };
                if ($cUgOr.isPlainObject(firstArg)) {
                    Object.assign(attributes, $9EvIV.normalize(firstArg, normalizeDepth, normalizeMaxBreadth));
                    const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
                    const remainingArgs = args.slice(remainingArgsStartIndex);
                    remainingArgs.forEach((arg, index)=>{
                        attributes[`sentry.message.parameter.${index}`] = $9EvIV.normalize(arg, normalizeDepth, normalizeMaxBreadth);
                    });
                } else {
                    const shouldGenerateTemplate = followingArgs.length > 0 && typeof firstArg === "string" && !$dqieo.hasConsoleSubstitutions(firstArg);
                    if (shouldGenerateTemplate) {
                        const templateAttrs = $dqieo.createConsoleTemplateAttributes(firstArg, followingArgs);
                        for (const [key, value] of Object.entries(templateAttrs))attributes[key] = key.startsWith("sentry.message.parameter.") ? $9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
                    }
                }
                $krgwg._INTERNAL_captureLog({
                    level: isLevelLog ? "info" : level,
                    message: $dqieo.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : void 0,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
const $9ee20eb215bf3662$var$consoleLoggingIntegration = $iOdTc.defineIntegration($9ee20eb215bf3662$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $9ee20eb215bf3662$var$consoleLoggingIntegration;

});
parcelRegister("dqieo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");

var $cqs9v = parcelRequire("cqs9v");
function $9c5bd869679b8bd8$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return "util" in $cqs9v.GLOBAL_OBJ && typeof $cqs9v.GLOBAL_OBJ.util.format === "function" ? $cqs9v.GLOBAL_OBJ.util.format(...values) : $9c5bd869679b8bd8$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
function $9c5bd869679b8bd8$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$cUgOr.isPrimitive(value) ? String(value) : JSON.stringify($9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(" ");
}
function $9c5bd869679b8bd8$var$hasConsoleSubstitutions(str) {
    return /%[sdifocO]/.test(str);
}
function $9c5bd869679b8bd8$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    const template = new Array(followingArgs.length).fill("{}").join(" ");
    attributes["sentry.message.template"] = `${firstArg} ${template}`;
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $9c5bd869679b8bd8$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $9c5bd869679b8bd8$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $9c5bd869679b8bd8$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $9c5bd869679b8bd8$var$safeJoinConsoleArgs;

});


parcelRegister("frFYv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7piEH = parcelRequire("7piEH");
function $b3e9effe1c610c20$var$captureMetric(type, name, value, options) {
    $7piEH._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
function $b3e9effe1c610c20$var$count(name, value = 1, options) {
    $b3e9effe1c610c20$var$captureMetric("counter", name, value, options);
}
function $b3e9effe1c610c20$var$gauge(name, value, options) {
    $b3e9effe1c610c20$var$captureMetric("gauge", name, value, options);
}
function $b3e9effe1c610c20$var$distribution(name, value, options) {
    $b3e9effe1c610c20$var$captureMetric("distribution", name, value, options);
}
module.exports.count = $b3e9effe1c610c20$var$count;
module.exports.distribution = $b3e9effe1c610c20$var$distribution;
module.exports.gauge = $b3e9effe1c610c20$var$gauge;

});

parcelRegister("5eiZy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $krgwg = parcelRequire("krgwg");

var $dqieo = parcelRequire("dqieo");

var $cUgOr = parcelRequire("cUgOr");

var $9EvIV = parcelRequire("9EvIV");
const $3cecfdf04635d9c2$var$DEFAULT_CAPTURED_LEVELS = [
    "trace",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
];
function $3cecfdf04635d9c2$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $3cecfdf04635d9c2$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            const client = providedClient || $5JqSP.getClient();
            if (!client) return;
            const logSeverityLevel = $3cecfdf04635d9c2$var$getLogSeverityLevel(type, level);
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = client.getOptions();
            const attributes = {};
            for (const [key, value] of Object.entries(rest))attributes[key] = $9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes["sentry.origin"] = "auto.log.consola";
            if (tag) attributes["consola.tag"] = tag;
            if (type) attributes["consola.type"] = type;
            if (level != null && typeof level === "number") attributes["consola.level"] = level;
            const extractionResult = $3cecfdf04635d9c2$var$processExtractedAttributes($3cecfdf04635d9c2$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $krgwg._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $dqieo.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || "",
                attributes: attributes
            });
        }
    };
}
const $3cecfdf04635d9c2$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: "trace",
    fatal: "fatal",
    error: "error",
    warn: "warn",
    log: "info",
    info: "info",
    success: "info",
    fail: "error",
    ready: "info",
    start: "info",
    box: "info",
    debug: "debug",
    trace: "trace",
    verbose: "debug",
    // Custom types that might exist
    critical: "fatal",
    notice: "info"
};
const $3cecfdf04635d9c2$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: "fatal",
    // Fatal and Error
    1: "warn",
    // Warnings
    2: "info",
    // Normal logs
    3: "info",
    // Informational logs, success, fail, ready, start, ...
    4: "debug",
    // Debug logs
    5: "trace"
};
function $3cecfdf04635d9c2$var$getLogSeverityLevel(type, level) {
    if (type === "verbose") return "debug";
    if (type === "silent") return "trace";
    if (type) {
        const mappedLevel = $3cecfdf04635d9c2$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    if (typeof level === "number") {
        const mappedLevel = $3cecfdf04635d9c2$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    return "info";
}
function $3cecfdf04635d9c2$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ""
    };
    const message = $dqieo.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($cUgOr.isPlainObject(firstArg)) {
        const remainingArgsStartIndex = typeof args[1] === "string" ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === "string" && !$dqieo.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : void 0,
            messageParameters: shouldAddTemplateAttr ? followingArgs : void 0
        };
    }
}
function $3cecfdf04635d9c2$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $dqieo.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith("sentry.message.parameter.") ? $9EvIV.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $9EvIV.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$9EvIV.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $3cecfdf04635d9c2$var$createConsolaReporter;

});

parcelRegister("cRRDT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $f3RkF = parcelRequire("f3RkF");

var $6atBT = parcelRequire("6atBT");

var $fbkeM = parcelRequire("fbkeM");

var $6vUrj = parcelRequire("6vUrj");

var $5SzUg = parcelRequire("5SzUg");

var $eN9vd = parcelRequire("eN9vd");

var $fbvdA = parcelRequire("fbvdA");

var $6Xrci = parcelRequire("6Xrci");

var $lQFj9 = parcelRequire("lQFj9");

var $9BctP = parcelRequire("9BctP");
function $95e40b91535f4e5b$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $6vUrj.spanToJSON(span);
    if (!name) return;
    if (attributes[$9BctP.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$9BctP.AI_TOOL_CALL_ID_ATTRIBUTE] && name === "ai.toolCall") {
        $95e40b91535f4e5b$var$processToolCallSpan(span, attributes);
        return;
    }
    if (!attributes[$9BctP.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith("ai.")) return;
    if ($fbvdA.SPAN_TO_OPERATION_NAME.get(name) === "generate_content") $fbkeM._INTERNAL_skipAiProviderWrapping([
        $5SzUg.WORKERS_AI_INTEGRATION_NAME
    ]);
    const client = $5JqSP.getClient();
    const integration = client?.getIntegrationByName("VercelAI");
    const enableTruncation = $6atBT.shouldEnableTruncation(integration?.options?.enableTruncation);
    $95e40b91535f4e5b$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $95e40b91535f4e5b$var$vercelAiEventProcessor(event) {
    if (event.type === "transaction" && event.spans) {
        const tokenAccumulator = /* @__PURE__ */ new Map();
        for (const span of event.spans){
            $95e40b91535f4e5b$var$processEndedVercelAiSpan(span);
            $lQFj9.accumulateTokensForParent(span, tokenAccumulator);
        }
        $lQFj9.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        const trace = event.contexts?.trace;
        if (trace?.op === "gen_ai.invoke_agent") $lQFj9.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
function $95e40b91535f4e5b$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== "string") return "stop";
    switch(finishReason){
        case "tool-calls":
            return "tool_call";
        case "stop":
        case "length":
        case "content_filter":
        case "error":
            return finishReason;
        default:
            return finishReason;
    }
}
function $95e40b91535f4e5b$var$buildOutputMessages(attributes) {
    const responseText = attributes[$9BctP.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$9BctP.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$9BctP.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (responseToolCalls != null) try {
        const toolCalls = typeof responseToolCalls === "string" ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: "tool_call",
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
                });
            }
            delete attributes[$9BctP.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {}
    if (parts.length > 0) {
        const outputMessage = {
            role: "assistant",
            parts: parts,
            finish_reason: $95e40b91535f4e5b$var$normalizeFinishReason(finishReason)
        };
        attributes[$eN9vd.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        delete attributes[$9BctP.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
function $95e40b91535f4e5b$var$processVercelAiSpanAttributes(attributes) {
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, "ai.usage.inputTokens", $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, "ai.usage.outputTokens", $eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_USAGE_TOKENS_ATTRIBUTE, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, "ai.response.avgOutputTokensPerSecond", "ai.response.avgCompletionTokensPerSecond");
    const inputTokensAreCacheInclusive = Object.keys(attributes).some((key)=>key.startsWith($9BctP.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX));
    if (!inputTokensAreCacheInclusive && typeof attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number" && typeof attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === "number") attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    if (typeof attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === "number") {
        const outputTokens = typeof attributes[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === "number" ? attributes[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    if (attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE] = $lQFj9.convertAvailableToolsToJsonString(attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE]);
    if (attributes[$9BctP.OPERATION_NAME_ATTRIBUTE]) {
        const rawOperationName = attributes[$9BctP.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$9BctP.AI_OPERATION_ID_ATTRIBUTE] : attributes[$9BctP.OPERATION_NAME_ATTRIBUTE];
        const operationName = $fbvdA.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        delete attributes[$9BctP.OPERATION_NAME_ATTRIBUTE];
    }
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE, $eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    $95e40b91535f4e5b$var$buildOutputMessages(attributes);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_RESPONSE_OBJECT_ATTRIBUTE, "gen_ai.response.object");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_PROMPT_TOOLS_ATTRIBUTE, "gen_ai.request.available_tools");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_ARGS_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_RESULT_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_SCHEMA_ATTRIBUTE, "gen_ai.request.schema");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_MODEL_ID_ATTRIBUTE, $eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    if (Array.isArray(attributes[$9BctP.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$9BctP.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $95e40b91535f4e5b$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        if (key.startsWith("ai.")) $95e40b91535f4e5b$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $95e40b91535f4e5b$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== "auto.vercelai.otel") return;
    if (span.status && span.status !== "ok") span.status = "internal_error";
    $95e40b91535f4e5b$var$processVercelAiSpanAttributes(attributes);
}
function $95e40b91535f4e5b$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== "auto.vercelai.otel") return;
    $95e40b91535f4e5b$var$processVercelAiSpanAttributes(attributes);
    if (attributes[$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP] === "gen_ai.execute_tool" && span.parent_span_id) {
        const descriptions = $fbvdA.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$eN9vd.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    $fbvdA.toolDescriptionMap.delete(span.span_id);
}
function $95e40b91535f4e5b$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        delete attributes[oldKey];
    }
}
function $95e40b91535f4e5b$var$processToolCallSpan(span, attributes) {
    span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP, "gen_ai.execute_tool");
    span.setAttribute($eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE, "execute_tool");
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_NAME_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $95e40b91535f4e5b$var$renameAttributeKey(attributes, $9BctP.AI_TOOL_CALL_ID_ATTRIBUTE, $eN9vd.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    const toolCallId = attributes[$eN9vd.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === "string") $fbvdA.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    if (!attributes[$eN9vd.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($eN9vd.GEN_AI_TOOL_TYPE_ATTRIBUTE, "function");
    const toolName = attributes[$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $95e40b91535f4e5b$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.vercelai.otel");
    const nameWthoutAi = name.replace("ai.", "");
    span.setAttribute("ai.pipeline.name", nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$9BctP.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === "string") span.setAttribute("gen_ai.function_id", functionId);
    $lQFj9.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$9BctP.AI_MODEL_ID_ATTRIBUTE] && !attributes[$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$9BctP.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute("ai.streaming", name.includes("stream"));
    const operationName = $fbvdA.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith("ai.stream")) span.setAttribute($f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP, "ai.run");
    if (operationName === "invoke_agent") {
        if (functionId && typeof functionId === "string") span.updateName(`invoke_agent ${functionId}`);
        else span.updateName("invoke_agent");
        return;
    }
    const modelId = attributes[$9BctP.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    const client = $5JqSP.getClient();
    if (client && $6Xrci.hasSpanStreamingEnabled(client) && attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = /* @__PURE__ */ new Map();
        for (const toolStr of attributes[$9BctP.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === "string" ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {}
        if (descriptions.size > 0) {
            const parentSpanId = $6vUrj.spanToJSON(span).parent_span_id;
            if (parentSpanId) $fbvdA.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
const $95e40b91535f4e5b$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS = /* @__PURE__ */ new WeakSet();
function $95e40b91535f4e5b$var$addVercelAiProcessors(client) {
    if ($95e40b91535f4e5b$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS.has(client)) return;
    $95e40b91535f4e5b$var$CLIENTS_WITH_VERCEL_AI_PROCESSORS.add(client);
    client.on("spanStart", $95e40b91535f4e5b$var$onVercelAiSpanStart);
    client.addEventProcessor(Object.assign($95e40b91535f4e5b$var$vercelAiEventProcessor, {
        id: "VercelAiEventProcessor"
    }));
    client.on("processSpan", (span)=>{
        $95e40b91535f4e5b$var$processVercelAiStreamedSpan(span);
    });
}
function $95e40b91535f4e5b$var$getProviderMetadataAttributes(providerMetadata) {
    const attributes = {};
    if (!providerMetadata || typeof providerMetadata !== "object") return attributes;
    const metadata = providerMetadata;
    const openaiMetadata = metadata.openai ?? metadata.azure;
    if (openaiMetadata) {
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.reasoning", openaiMetadata.reasoningTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_accepted", openaiMetadata.acceptedPredictionTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.output_tokens.prediction_rejected", openaiMetadata.rejectedPredictionTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE, openaiMetadata.responseId);
    }
    if (metadata.anthropic) {
        const cachedInputTokens = metadata.anthropic.usage?.cache_read_input_tokens ?? metadata.anthropic.cacheReadInputTokens;
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
        const cacheWriteInputTokens = metadata.anthropic.usage?.cache_creation_input_tokens ?? metadata.anthropic.cacheCreationInputTokens;
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
    }
    if (metadata.bedrock?.usage) {
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.bedrock.usage.cacheReadInputTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, metadata.bedrock.usage.cacheWriteInputTokens);
    }
    if (metadata.deepseek) {
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, metadata.deepseek.promptCacheHitTokens);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.input_tokens.cache_miss", metadata.deepseek.promptCacheMissTokens);
    }
    const googleUsage = (metadata.google ?? metadata.vertex)?.usageMetadata;
    if (googleUsage && typeof googleUsage.thoughtsTokenCount === "number" && googleUsage.thoughtsTokenCount > 0) {
        attributes[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = (googleUsage.candidatesTokenCount ?? 0) + googleUsage.thoughtsTokenCount;
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, $eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, googleUsage.totalTokenCount);
        $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, "gen_ai.usage.reasoning.output_tokens", googleUsage.thoughtsTokenCount);
    }
    return attributes;
}
const $95e40b91535f4e5b$var$LAST_STEP_ONLY_USAGE_KEYS = /* @__PURE__ */ new Set([
    $eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE,
    $eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE,
    "gen_ai.usage.reasoning.output_tokens"
]);
function $95e40b91535f4e5b$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$9BctP.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (!providerMetadata) return;
    const lastStepOnly = attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE] === "invoke_agent";
    try {
        const derived = $95e40b91535f4e5b$var$getProviderMetadataAttributes(JSON.parse(providerMetadata));
        for (const [key, value] of Object.entries(derived)){
            if (key === $eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE && attributes[key]) continue;
            if (lastStepOnly && $95e40b91535f4e5b$var$LAST_STEP_ONLY_USAGE_KEYS.has(key)) continue;
            attributes[key] = value;
        }
    } catch  {}
}
function $95e40b91535f4e5b$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.LAST_STEP_ONLY_USAGE_KEYS = $95e40b91535f4e5b$var$LAST_STEP_ONLY_USAGE_KEYS;
module.exports.addVercelAiProcessors = $95e40b91535f4e5b$var$addVercelAiProcessors;
module.exports.getProviderMetadataAttributes = $95e40b91535f4e5b$var$getProviderMetadataAttributes;
module.exports.processVercelAiSpanAttributes = $95e40b91535f4e5b$var$processVercelAiSpanAttributes;

});
parcelRegister("6atBT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $5JqSP = parcelRequire("5JqSP");

var $6Xrci = parcelRequire("6Xrci");

var $cUgOr = parcelRequire("cUgOr");

var $eN9vd = parcelRequire("eN9vd");

var $9fi22 = parcelRequire("9fi22");
function $47daa531d791f483$var$resolveAIRecordingOptions(options) {
    const genAI = $5JqSP.getClient()?.getDataCollectionOptions().genAI;
    return {
        ...options,
        recordInputs: options?.recordInputs ?? genAI?.inputs ?? false,
        recordOutputs: options?.recordOutputs ?? genAI?.outputs ?? false
    };
}
function $47daa531d791f483$var$shouldEnableTruncation(enableTruncation) {
    if (enableTruncation !== void 0) return enableTruncation;
    const client = $5JqSP.getClient();
    if (!client) return true;
    return !$6Xrci.hasSpanStreamingEnabled(client) && client.getOptions().streamGenAiSpans === false;
}
function $47daa531d791f483$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
function $47daa531d791f483$var$getTokenUsageAttributes(promptTokens, completionTokens, cacheCreationInputTokens, cacheReadInputTokens, totalTokens) {
    const attributes$1 = {};
    if (typeof promptTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = promptTokens;
    if (typeof cacheCreationInputTokens === "number") attributes$1[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS] = cacheCreationInputTokens;
    if (typeof cacheReadInputTokens === "number") attributes$1[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS] = cacheReadInputTokens;
    if (typeof completionTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = completionTokens;
    if (typeof totalTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = totalTokens;
    else if (typeof promptTokens === "number" || typeof completionTokens === "number") attributes$1[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (typeof promptTokens === "number" ? promptTokens : 0) + (typeof completionTokens === "number" ? completionTokens : 0);
    return attributes$1;
}
function $47daa531d791f483$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$eN9vd.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    Object.assign(attrs, $47daa531d791f483$var$getTokenUsageAttributes(state.promptTokens, state.completionTokens, state.cacheCreationInputTokens, state.cacheReadInputTokens, state.totalTokens));
    if (typeof state.reasoningOutputTokens === "number") attrs[$eAISS.GEN_AI_USAGE_REASONING_OUTPUT_TOKENS] = state.reasoningOutputTokens;
    if (state.finishReasons.length) attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join("");
    if (recordOutputs && state.toolCalls.length) attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
function $47daa531d791f483$var$getTruncatedJsonString(value) {
    if (typeof value === "string") return $9fi22.truncateGenAiStringInput(value);
    try {
        return JSON.stringify(Array.isArray(value) ? $9fi22.truncateGenAiMessages(value) : value);
    } catch  {
        return "[unserializable]";
    }
}
function $47daa531d791f483$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === "object" && "role" in msg && msg.role === "system");
    if (systemMessageIndex === -1) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === "string" ? systemMessage.content : systemMessage.content !== void 0 ? JSON.stringify(systemMessage.content) : void 0;
    if (!systemContent) return {
        systemInstructions: void 0,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: "text",
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
async function $47daa531d791f483$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise) {
    const [instrumentedResult, originalWrapper] = await Promise.all([
        instrumentedPromise,
        originalWithResponse
    ]);
    if (originalWrapper && typeof originalWrapper === "object" && "data" in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
function $47daa531d791f483$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise) {
    if (!$cUgOr.isThenable(originalPromiseLike)) return instrumentedPromise;
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            if (prop === "withResponse" && typeof value === "function") return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $47daa531d791f483$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise);
            };
            return typeof value === "function" ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $47daa531d791f483$var$buildMethodPath;
module.exports.endStreamSpan = $47daa531d791f483$var$endStreamSpan;
module.exports.extractSystemInstructions = $47daa531d791f483$var$extractSystemInstructions;
module.exports.getTokenUsageAttributes = $47daa531d791f483$var$getTokenUsageAttributes;
module.exports.getTruncatedJsonString = $47daa531d791f483$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $47daa531d791f483$var$resolveAIRecordingOptions;
module.exports.shouldEnableTruncation = $47daa531d791f483$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $47daa531d791f483$var$wrapPromiseWithMethods;

});
parcelRegister("eN9vd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ac4d03438b4e4600$var$GEN_AI_PROMPT_ATTRIBUTE = "gen_ai.prompt";
const $ac4d03438b4e4600$var$GEN_AI_SYSTEM_ATTRIBUTE = "gen_ai.system";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = "gen_ai.request.model";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = "gen_ai.request.stream";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = "gen_ai.request.temperature";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = "gen_ai.request.max_tokens";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = "gen_ai.request.frequency_penalty";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = "gen_ai.request.presence_penalty";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = "gen_ai.request.top_p";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = "gen_ai.request.top_k";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = "gen_ai.request.encoding_format";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = "gen_ai.request.dimensions";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = "gen_ai.response.finish_reasons";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = "gen_ai.response.model";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = "gen_ai.response.id";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = "gen_ai.response.stop_reason";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.input_tokens";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = "gen_ai.usage.output_tokens";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = "gen_ai.usage.total_tokens";
const $ac4d03438b4e4600$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = "gen_ai.operation.name";
const $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = "sentry.sdk_meta.gen_ai.input.messages.original_length";
const $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = "gen_ai.input.messages";
const $ac4d03438b4e4600$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = "gen_ai.output.messages";
const $ac4d03438b4e4600$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = "gen_ai.system_instructions";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = "gen_ai.response.text";
const $ac4d03438b4e4600$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = "gen_ai.request.available_tools";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = "gen_ai.response.streaming";
const $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "gen_ai.response.tool_calls";
const $ac4d03438b4e4600$var$GEN_AI_AGENT_NAME_ATTRIBUTE = "gen_ai.agent.name";
const $ac4d03438b4e4600$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = "gen_ai.pipeline.name";
const $ac4d03438b4e4600$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = "gen_ai.usage.input_tokens.cache_write";
const $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = "gen_ai.usage.input_tokens.cached";
const $ac4d03438b4e4600$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = "gen_ai.invoke_agent";
const $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = "gen_ai.embeddings.input";
const $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = "gen_ai.embeddings";
const $ac4d03438b4e4600$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = "gen_ai.execute_tool";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_NAME_ATTRIBUTE = "gen_ai.tool.name";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = "gen_ai.tool.call.id";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = "gen_ai.tool.type";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = "gen_ai.tool.input";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = "gen_ai.tool.output";
const $ac4d03438b4e4600$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = "gen_ai.tool.description";
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $ac4d03438b4e4600$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("9fi22", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1qvHT = parcelRequire("1qvHT");
const $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 2e4;
const $6bb3808b6f6891e2$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
const $6bb3808b6f6891e2$var$jsonBytes = (value)=>{
    return $6bb3808b6f6891e2$var$utf8Bytes(JSON.stringify(value));
};
function $6bb3808b6f6891e2$var$truncateTextByBytes(text, maxBytes) {
    if ($6bb3808b6f6891e2$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = "";
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $6bb3808b6f6891e2$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
function $6bb3808b6f6891e2$var$getItemText(item) {
    if (typeof item === "string") return item;
    if ("text" in item && typeof item.text === "string") return item.text;
    return "";
}
function $6bb3808b6f6891e2$var$withItemText(item, text) {
    if (typeof item === "string") return text;
    return {
        ...item,
        text: text
    };
}
function $6bb3808b6f6891e2$var$isContentMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && typeof message.content === "string";
}
function $6bb3808b6f6891e2$var$isContentArrayMessage(message) {
    return message !== null && typeof message === "object" && "content" in message && Array.isArray(message.content);
}
function $6bb3808b6f6891e2$var$isPartsMessage(message) {
    return message !== null && typeof message === "object" && "parts" in message && Array.isArray(message.parts) && message.parts.length > 0;
}
function $6bb3808b6f6891e2$var$truncateContentMessage(message, maxBytes) {
    const emptyMessage = {
        ...message,
        content: ""
    };
    const overhead = $6bb3808b6f6891e2$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $6bb3808b6f6891e2$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
function $6bb3808b6f6891e2$var$getArrayItems(message) {
    if ("parts" in message && Array.isArray(message.parts)) return {
        key: "parts",
        items: message.parts
    };
    if ("content" in message && Array.isArray(message.content)) return {
        key: "content",
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
function $6bb3808b6f6891e2$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $6bb3808b6f6891e2$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    const emptyItems = items.map((item)=>$6bb3808b6f6891e2$var$withItemText(item, ""));
    const overhead = $6bb3808b6f6891e2$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    const includedItems = [];
    for (const item of items){
        const text = $6bb3808b6f6891e2$var$getItemText(item);
        const textSize = $6bb3808b6f6891e2$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            const truncated = $6bb3808b6f6891e2$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($6bb3808b6f6891e2$var$withItemText(item, truncated));
            break;
        } else break;
    }
    if (includedItems.length <= 0) return [];
    else return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
function $6bb3808b6f6891e2$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    if (typeof message === "string") {
        const truncated = $6bb3808b6f6891e2$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== "object") return [];
    if ($6bb3808b6f6891e2$var$isContentMessage(message)) return $6bb3808b6f6891e2$var$truncateContentMessage(message, maxBytes);
    if ($6bb3808b6f6891e2$var$isContentArrayMessage(message) || $6bb3808b6f6891e2$var$isPartsMessage(message)) return $6bb3808b6f6891e2$var$truncateArrayMessage(message, maxBytes);
    return [];
}
function $6bb3808b6f6891e2$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = void 0;
        if (!!message && typeof message === "object") {
            if ($6bb3808b6f6891e2$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $6bb3808b6f6891e2$var$stripInlineMediaFromMessages(message.content)
            };
            else if ("content" in message && $1qvHT.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $1qvHT.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($6bb3808b6f6891e2$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $6bb3808b6f6891e2$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($1qvHT.isContentMedia(newMessage)) newMessage = $1qvHT.stripInlineMediaFromSingleMessage(newMessage);
            else if ($1qvHT.isContentMedia(message)) newMessage = $1qvHT.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
function $6bb3808b6f6891e2$var$truncateMessagesByBytes(messages, maxBytes) {
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    const effectiveMaxBytes = maxBytes - 2;
    const lastMessage = messages[messages.length - 1];
    const stripped = $6bb3808b6f6891e2$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    const messageBytes = $6bb3808b6f6891e2$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    return $6bb3808b6f6891e2$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
function $6bb3808b6f6891e2$var$truncateGenAiMessages(messages) {
    return $6bb3808b6f6891e2$var$truncateMessagesByBytes(messages, $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
function $6bb3808b6f6891e2$var$truncateGenAiStringInput(input) {
    return $6bb3808b6f6891e2$var$truncateTextByBytes(input, $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $6bb3808b6f6891e2$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $6bb3808b6f6891e2$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $6bb3808b6f6891e2$var$truncateGenAiStringInput;

});
parcelRegister("1qvHT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $10a0d07c489e03fa$var$isContentMedia(part) {
    if (!part || typeof part !== "object") return false;
    return $10a0d07c489e03fa$var$isContentMediaSource(part) || $10a0d07c489e03fa$var$hasInlineData(part) || $10a0d07c489e03fa$var$hasImageUrl(part) || $10a0d07c489e03fa$var$hasInputAudio(part) || $10a0d07c489e03fa$var$hasFileData(part) || $10a0d07c489e03fa$var$hasMediaTypeData(part) || $10a0d07c489e03fa$var$hasVercelFileData(part) || $10a0d07c489e03fa$var$hasVercelImageData(part) || $10a0d07c489e03fa$var$hasBlobOrBase64Type(part) || $10a0d07c489e03fa$var$hasB64Json(part) || $10a0d07c489e03fa$var$hasImageGenerationResult(part) || $10a0d07c489e03fa$var$hasDataUri(part);
}
function $10a0d07c489e03fa$var$hasImageUrl(part) {
    if (!("image_url" in part)) return false;
    if (typeof part.image_url === "string") return part.image_url.startsWith("data:");
    return $10a0d07c489e03fa$var$hasNestedImageUrl(part);
}
function $10a0d07c489e03fa$var$hasNestedImageUrl(part) {
    return "image_url" in part && !!part.image_url && typeof part.image_url === "object" && "url" in part.image_url && typeof part.image_url.url === "string" && part.image_url.url.startsWith("data:");
}
function $10a0d07c489e03fa$var$isContentMediaSource(part) {
    return "type" in part && typeof part.type === "string" && "source" in part && $10a0d07c489e03fa$var$isContentMedia(part.source);
}
function $10a0d07c489e03fa$var$hasInlineData(part) {
    return "inlineData" in part && !!part.inlineData && typeof part.inlineData === "object" && "data" in part.inlineData && typeof part.inlineData.data === "string";
}
function $10a0d07c489e03fa$var$hasInputAudio(part) {
    return "type" in part && part.type === "input_audio" && "input_audio" in part && !!part.input_audio && typeof part.input_audio === "object" && "data" in part.input_audio && typeof part.input_audio.data === "string";
}
function $10a0d07c489e03fa$var$hasFileData(part) {
    return "type" in part && part.type === "file" && "file" in part && !!part.file && typeof part.file === "object" && "file_data" in part.file && typeof part.file.file_data === "string";
}
function $10a0d07c489e03fa$var$hasMediaTypeData(part) {
    return "media_type" in part && typeof part.media_type === "string" && "data" in part;
}
function $10a0d07c489e03fa$var$hasVercelFileData(part) {
    return "type" in part && part.type === "file" && "mediaType" in part && typeof part.mediaType === "string" && "data" in part && typeof part.data === "string" && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith("http://") && !part.data.startsWith("https://");
}
function $10a0d07c489e03fa$var$hasVercelImageData(part) {
    return "type" in part && part.type === "image" && "image" in part && typeof part.image === "string" && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith("http://") && !part.image.startsWith("https://");
}
function $10a0d07c489e03fa$var$hasBlobOrBase64Type(part) {
    return "type" in part && (part.type === "blob" || part.type === "base64");
}
function $10a0d07c489e03fa$var$hasB64Json(part) {
    return "b64_json" in part;
}
function $10a0d07c489e03fa$var$hasImageGenerationResult(part) {
    return "type" in part && "result" in part && part.type === "image_generation";
}
function $10a0d07c489e03fa$var$hasDataUri(part) {
    return "uri" in part && typeof part.uri === "string" && part.uri.startsWith("data:");
}
const $10a0d07c489e03fa$var$REMOVED_STRING = "[Blob substitute]";
const $10a0d07c489e03fa$var$MEDIA_FIELDS = [
    "image_url",
    "data",
    "content",
    "b64_json",
    "result",
    "uri",
    "image"
];
function $10a0d07c489e03fa$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($10a0d07c489e03fa$var$isContentMedia(strip.source)) strip.source = $10a0d07c489e03fa$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($10a0d07c489e03fa$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    if ($10a0d07c489e03fa$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    if ($10a0d07c489e03fa$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    if ($10a0d07c489e03fa$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $10a0d07c489e03fa$var$REMOVED_STRING
    };
    for (const field of $10a0d07c489e03fa$var$MEDIA_FIELDS)if (typeof strip[field] === "string") strip[field] = $10a0d07c489e03fa$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $10a0d07c489e03fa$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $10a0d07c489e03fa$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("5SzUg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $447dd9323a5c83be$var$WORKERS_AI_PROVIDER_NAME = "cloudflare.workers_ai";
const $447dd9323a5c83be$var$WORKERS_AI_ORIGIN = "auto.ai.cloudflare.workers_ai";
const $447dd9323a5c83be$var$WORKERS_AI_INTEGRATION_NAME = "WorkersAI";
module.exports.WORKERS_AI_INTEGRATION_NAME = $447dd9323a5c83be$var$WORKERS_AI_INTEGRATION_NAME;
module.exports.WORKERS_AI_ORIGIN = $447dd9323a5c83be$var$WORKERS_AI_ORIGIN;
module.exports.WORKERS_AI_PROVIDER_NAME = $447dd9323a5c83be$var$WORKERS_AI_PROVIDER_NAME;

});

parcelRegister("fbvdA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b0e0195def17d50b$var$toolCallSpanContextMap = /* @__PURE__ */ new Map();
const $b0e0195def17d50b$var$toolDescriptionMap = /* @__PURE__ */ new Map();
const $b0e0195def17d50b$var$SPAN_TO_OPERATION_NAME = /* @__PURE__ */ new Map([
    [
        "ai.generateText",
        "invoke_agent"
    ],
    [
        "ai.streamText",
        "invoke_agent"
    ],
    [
        "ai.generateObject",
        "invoke_agent"
    ],
    [
        "ai.streamObject",
        "invoke_agent"
    ],
    [
        "ai.generateText.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamText.doStream",
        "generate_content"
    ],
    [
        "ai.generateObject.doGenerate",
        "generate_content"
    ],
    [
        "ai.streamObject.doStream",
        "generate_content"
    ],
    [
        "ai.embed.doEmbed",
        "embeddings"
    ],
    [
        "ai.embedMany.doEmbed",
        "embeddings"
    ],
    [
        "ai.rerank.doRerank",
        "rerank"
    ],
    [
        "ai.toolCall",
        "execute_tool"
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $b0e0195def17d50b$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $b0e0195def17d50b$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $b0e0195def17d50b$var$toolDescriptionMap;

});

parcelRegister("lQFj9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $foFxi = parcelRequire("foFxi");

var $fbvdA = parcelRequire("fbvdA");

var $9BctP = parcelRequire("9BctP");
function $fe7e7f35d805a9e4$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === "number" || typeof outputTokens === "number") {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === "number") existing.inputTokens += inputTokens;
        if (typeof outputTokens === "number") existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
function $fe7e7f35d805a9e4$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data["gen_ai.usage.total_tokens"] = accumulated.inputTokens + accumulated.outputTokens;
}
function $fe7e7f35d805a9e4$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = /* @__PURE__ */ new Map();
    for (const span of spans){
        const availableTools = span.data[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== "string") continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {}
    }
    return toolDescriptions;
}
function $fe7e7f35d805a9e4$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    const toolDescriptions = $fe7e7f35d805a9e4$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === "gen_ai.execute_tool") {
            const toolName = span.data[$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === "string") {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$eN9vd.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === "gen_ai.invoke_agent") $fe7e7f35d805a9e4$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
function $fe7e7f35d805a9e4$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $fbvdA.toolCallSpanContextMap.get(toolCallId);
}
function $fe7e7f35d805a9e4$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $fbvdA.toolCallSpanContextMap.delete(toolCallId);
}
function $fe7e7f35d805a9e4$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === "string") try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
function $fe7e7f35d805a9e4$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === "object" && "role" in m && "content" in m);
}
function $fe7e7f35d805a9e4$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === "object") {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            if (typeof system === "string") result.push({
                role: "system",
                content: system
            });
            if (typeof messages === "string") try {
                messages = JSON.parse(messages);
            } catch  {}
            if (Array.isArray(messages)) {
                result.push(...$fe7e7f35d805a9e4$var$filterMessagesArray(messages));
                return result;
            }
            if (Array.isArray(prompt)) {
                result.push(...$fe7e7f35d805a9e4$var$filterMessagesArray(prompt));
                return result;
            }
            if (typeof prompt === "string") result.push({
                role: "user",
                content: prompt
            });
            if (result.length > 0) return result;
        }
    } catch  {}
    return [];
}
function $fe7e7f35d805a9e4$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$9BctP.AI_PROMPT_ATTRIBUTE] === "string" && !attributes[$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        const userInput = attributes[$9BctP.AI_PROMPT_ATTRIBUTE];
        const messages = $fe7e7f35d805a9e4$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages);
            span.setAttributes({
                [$9BctP.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE] === "string") {
        const originalMessagesJson = attributes[$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE];
        try {
            const messages = JSON.parse(originalMessagesJson);
            if (Array.isArray(messages)) {
                const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
                if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                const messagesJson = !enableTruncation && filteredMessages === messages ? originalMessagesJson : enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages);
                span.setAttributes({
                    [$9BctP.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                    [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                });
            }
        } catch  {}
    }
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $fe7e7f35d805a9e4$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $fe7e7f35d805a9e4$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $fe7e7f35d805a9e4$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $fe7e7f35d805a9e4$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $fe7e7f35d805a9e4$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $fe7e7f35d805a9e4$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $fe7e7f35d805a9e4$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $fe7e7f35d805a9e4$var$requestMessagesFromPrompt;

});
parcelRegister("9BctP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6fd140086dc954f6$var$OPERATION_NAME_ATTRIBUTE = "operation.name";
const $6fd140086dc954f6$var$AI_OPERATION_ID_ATTRIBUTE = "ai.operationId";
const $6fd140086dc954f6$var$AI_PROMPT_ATTRIBUTE = "ai.prompt";
const $6fd140086dc954f6$var$AI_SCHEMA_ATTRIBUTE = "ai.schema";
const $6fd140086dc954f6$var$AI_RESPONSE_OBJECT_ATTRIBUTE = "ai.response.object";
const $6fd140086dc954f6$var$AI_VALUES_ATTRIBUTE = "ai.values";
const $6fd140086dc954f6$var$AI_RESPONSE_TEXT_ATTRIBUTE = "ai.response.text";
const $6fd140086dc954f6$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = "ai.response.toolCalls";
const $6fd140086dc954f6$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = "ai.response.finishReason";
const $6fd140086dc954f6$var$AI_PROMPT_MESSAGES_ATTRIBUTE = "ai.prompt.messages";
const $6fd140086dc954f6$var$AI_PROMPT_TOOLS_ATTRIBUTE = "ai.prompt.tools";
const $6fd140086dc954f6$var$AI_MODEL_ID_ATTRIBUTE = "ai.model.id";
const $6fd140086dc954f6$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = "ai.response.providerMetadata";
const $6fd140086dc954f6$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = "ai.usage.cachedInputTokens";
const $6fd140086dc954f6$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = "ai.usage.inputTokenDetails.";
const $6fd140086dc954f6$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = "ai.telemetry.functionId";
const $6fd140086dc954f6$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = "ai.usage.completionTokens";
const $6fd140086dc954f6$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = "ai.usage.promptTokens";
const $6fd140086dc954f6$var$AI_USAGE_TOKENS_ATTRIBUTE = "ai.usage.tokens";
const $6fd140086dc954f6$var$AI_TOOL_CALL_NAME_ATTRIBUTE = "ai.toolCall.name";
const $6fd140086dc954f6$var$AI_TOOL_CALL_ID_ATTRIBUTE = "ai.toolCall.id";
const $6fd140086dc954f6$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = "ai.toolCall.args";
const $6fd140086dc954f6$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = "ai.toolCall.result";
module.exports.AI_MODEL_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $6fd140086dc954f6$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $6fd140086dc954f6$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $6fd140086dc954f6$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $6fd140086dc954f6$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $6fd140086dc954f6$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $6fd140086dc954f6$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX = $6fd140086dc954f6$var$AI_USAGE_INPUT_TOKEN_DETAILS_ATTRIBUTE_PREFIX;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $6fd140086dc954f6$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $6fd140086dc954f6$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $6fd140086dc954f6$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("gMyai", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $f3RkF = parcelRequire("f3RkF");

var $g31Ce = parcelRequire("g31Ce");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $88Wwg = parcelRequire("88Wwg");

var $5kKGI = parcelRequire("5kKGI");

var $626Kw = parcelRequire("626Kw");
function $c37ba181f0002cd3$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === "object";
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: "web_search_options",
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return void 0;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Failed to serialize OpenAI tools:", error);
        return void 0;
    }
}
function $c37ba181f0002cd3$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: "openai",
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.openai"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        const availableTools = $c37ba181f0002cd3$var$extractAvailableTools(params);
        if (availableTools) attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $626Kw.extractRequestParameters(params));
    } else attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $c37ba181f0002cd3$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings" && "input" in params) {
        const input = params.input;
        if (input == null) return;
        if (typeof input === "string" && input.length === 0) return;
        if (Array.isArray(input) && input.length === 0) return;
        span.setAttribute($eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === "string" ? input : JSON.stringify(input));
        return;
    }
    const src = "input" in params ? params.input : "messages" in params ? params.messages : void 0;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
function $c37ba181f0002cd3$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || "unknown";
        const requestAttributes = $c37ba181f0002cd3$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
        const params = args[0];
        const isStreamRequested = params && typeof params === "object" && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult2;
            const instrumentedPromise2 = $5CFne.startSpanManual(spanConfig, (span)=>{
                originalResult2 = originalMethod.apply(context, args);
                if (options.recordInputs && params) $c37ba181f0002cd3$var$addRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
                return (async ()=>{
                    try {
                        const result = await originalResult2;
                        return $5kKGI.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $h5H4c.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $6atBT.wrapPromiseWithMethods(originalResult2, instrumentedPromise2);
        }
        let originalResult;
        const instrumentedPromise = $5CFne.startSpan(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $c37ba181f0002cd3$var$addRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $626Kw.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
        return $6atBT.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    };
}
function $c37ba181f0002cd3$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $6atBT.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $88Wwg.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) return $c37ba181f0002cd3$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === "function") return value.bind(obj);
            if (value && typeof value === "object") return $c37ba181f0002cd3$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $c37ba181f0002cd3$var$instrumentOpenAiClient(client, options) {
    return $c37ba181f0002cd3$var$createDeepProxy(client, "", $6atBT.resolveAIRecordingOptions(options));
}
module.exports.addRequestAttributes = $c37ba181f0002cd3$var$addRequestAttributes;
module.exports.extractRequestAttributes = $c37ba181f0002cd3$var$extractRequestAttributes;
module.exports.instrumentOpenAiClient = $c37ba181f0002cd3$var$instrumentOpenAiClient;

});
parcelRegister("88Wwg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $5edc76d503b906a2$var$OPENAI_INTEGRATION_NAME = "OpenAI";
const $5edc76d503b906a2$var$OPENAI_METHOD_REGISTRY = {
    "responses.create": {
        operation: "chat"
    },
    "chat.completions.create": {
        operation: "chat"
    },
    "embeddings.create": {
        operation: "embeddings"
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    "conversations.create": {
        operation: "chat"
    }
};
const $5edc76d503b906a2$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    "response.output_item.added",
    "response.function_call_arguments.delta",
    "response.function_call_arguments.done",
    "response.output_item.done"
];
const $5edc76d503b906a2$var$RESPONSE_EVENT_TYPES = [
    "response.created",
    "response.in_progress",
    "response.failed",
    "response.completed",
    "response.incomplete",
    "response.queued",
    "response.output_text.delta",
    ...$5edc76d503b906a2$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $5edc76d503b906a2$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $5edc76d503b906a2$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $5edc76d503b906a2$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $5edc76d503b906a2$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("5kKGI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");

var $88Wwg = parcelRequire("88Wwg");

var $626Kw = parcelRequire("626Kw");
function $3e23094403a2384c$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === void 0 || !toolCall.function) continue;
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ""
            }
        };
        else {
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
function $3e23094403a2384c$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
        state.cacheReadInputTokens = chunk.usage.prompt_tokens_details?.cached_tokens ?? state.cacheReadInputTokens;
        state.cacheCreationInputTokens = chunk.usage.prompt_tokens_details?.cache_write_tokens ?? state.cacheCreationInputTokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            if (choice.delta?.tool_calls) $3e23094403a2384c$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
function $3e23094403a2384c$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === "object")) {
        state.eventTypes.push("unknown:non-object");
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $13TrR.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: "auto.ai.openai.stream-response"
            }
        });
        return;
    }
    if (!("type" in streamEvent)) return;
    const event = streamEvent;
    if (!$88Wwg.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    if (recordOutputs) {
        if (event.type === "response.output_item.done" && "item" in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === "response.output_text.delta" && "delta" in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ("response" in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
            state.cacheReadInputTokens = response.usage.input_tokens_details?.cached_tokens ?? state.cacheReadInputTokens;
            state.cacheCreationInputTokens = response.usage.input_tokens_details?.cache_write_tokens ?? state.cacheCreationInputTokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
async function* $3e23094403a2384c$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0,
        cacheReadInputTokens: void 0,
        cacheCreationInputTokens: void 0,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($626Kw.isChatCompletionChunk(event)) $3e23094403a2384c$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($626Kw.isResponsesApiStreamEvent(event)) $3e23094403a2384c$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $6atBT.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $3e23094403a2384c$var$instrumentStream;

});
parcelRegister("626Kw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $cUgOr = parcelRequire("cUgOr");

var $eN9vd = parcelRequire("eN9vd");
function $46482a481e93ef16$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === "object" && "type" in event && typeof event.type === "string" && event.type.startsWith("response.");
}
function $46482a481e93ef16$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === "object" && "object" in event && event.object === "chat.completion.chunk";
}
function $46482a481e93ef16$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object") return;
    const response = result;
    const attrs = {};
    if (typeof response.id === "string") attrs[$eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    if (typeof response.model === "string") attrs[$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    if (response.object === "conversation" && typeof response.id === "string") attrs[$eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    if (response.usage && typeof response.usage === "object") {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === "number") attrs[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === "number") attrs[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === "number") attrs[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
        const inputDetails = usage.prompt_tokens_details ?? usage.input_tokens_details;
        if ($cUgOr.isObjectLike(inputDetails)) {
            if (typeof inputDetails.cached_tokens === "number") attrs[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS] = inputDetails.cached_tokens;
            if (typeof inputDetails.cache_write_tokens === "number") attrs[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS] = inputDetails.cache_write_tokens;
        }
    }
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === "string");
        if (finishReasons.length > 0) attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || "";
            });
            attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    if (typeof response.status === "string") {
        if (!attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        if (typeof response.output_text === "string" && !attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === "function_call");
            if (functionCalls.length > 0) attrs[$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
function $46482a481e93ef16$var$extractConversationId(params) {
    if ("conversation" in params && typeof params.conversation === "string") return params.conversation;
    if ("previous_response_id" in params && typeof params.previous_response_id === "string") return params.previous_response_id;
    return void 0;
}
function $46482a481e93ef16$var$extractRequestParameters(params) {
    const attributes = {
        [$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? "unknown"
    };
    if ("temperature" in params) attributes[$eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ("top_p" in params) attributes[$eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ("frequency_penalty" in params) attributes[$eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ("presence_penalty" in params) attributes[$eN9vd.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ("stream" in params) attributes[$eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ("encoding_format" in params) attributes[$eN9vd.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ("dimensions" in params) attributes[$eN9vd.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    const conversationId = $46482a481e93ef16$var$extractConversationId(params);
    if (conversationId) attributes[$eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $46482a481e93ef16$var$addResponseAttributes;
module.exports.extractRequestParameters = $46482a481e93ef16$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $46482a481e93ef16$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $46482a481e93ef16$var$isResponsesApiStreamEvent;

});



parcelRegister("5ddno", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $j6AED = parcelRequire("j6AED");

var $ax3NO = parcelRequire("ax3NO");

var $3nLrf = parcelRequire("3nLrf");
let $3cb88ae91b980052$var$suppressDelegatedCreate = false;
const $3cb88ae91b980052$var$INSTRUMENTED_METHODS = /* @__PURE__ */ new WeakSet();
function $3cb88ae91b980052$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: "anthropic",
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.anthropic"
    };
    if (args.length > 0 && typeof args[0] === "object" && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? "unknown";
        if ("temperature" in params) attributes[$eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ("top_p" in params) attributes[$eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ("stream" in params) attributes[$eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ("top_k" in params) attributes[$eN9vd.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ("frequency_penalty" in params) attributes[$eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ("max_tokens" in params) attributes[$eN9vd.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === "models.retrieve" || methodPath === "models.get") attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = "unknown";
    return attributes;
}
function $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $3nLrf.messagesFromParams(params);
    $3nLrf.setMessagesAttribute(span, messages, enableTruncation);
    if ("prompt" in params) span.setAttributes({
        [$eN9vd.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
function $3cb88ae91b980052$var$addContentAttributes(span, response) {
    if ("content" in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join("")
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === "tool_use" || item.type === "server_tool_use") toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    if ("completion" in response) span.setAttributes({
        [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    if ("input_tokens" in response) span.setAttributes({
        [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
function $3cb88ae91b980052$var$addMetadataAttributes(span, response) {
    if ("id" in response && "model" in response) {
        span.setAttributes({
            [$eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ("usage" in response && response.usage) span.setAttributes($6atBT.getTokenUsageAttributes(response.usage.input_tokens + (response.usage.cache_creation_input_tokens ?? 0) + (response.usage.cache_read_input_tokens ?? 0), response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens));
    }
}
function $3cb88ae91b980052$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if ("type" in response && response.type === "error") {
        $3nLrf.handleResponseError(span, response);
        return;
    }
    if (recordOutputs) $3cb88ae91b980052$var$addContentAttributes(span, response);
    $3cb88ae91b980052$var$addMetadataAttributes(span, response);
}
function $3cb88ae91b980052$var$handleStreamingError(error, span) {
    if (span.isRecording()) {
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        span.end();
    }
    throw error;
}
function $3cb88ae91b980052$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $5CFne.startSpanManual(spanConfig, (span)=>{
            originalResult = target.apply(invocationThis, args);
            if (options.recordInputs && params) $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $ax3NO.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $3cb88ae91b980052$var$handleStreamingError(error, span);
                }
            })();
        });
        return $6atBT.wrapPromiseWithMethods(originalResult, instrumentedPromise);
    } else return $5CFne.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, $6atBT.shouldEnableTruncation(options.enableTruncation));
            $3cb88ae91b980052$var$suppressDelegatedCreate = true;
            const messageStream = target.apply(invocationThis, args);
            $3cb88ae91b980052$var$suppressDelegatedCreate = false;
            return $ax3NO.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            $3cb88ae91b980052$var$suppressDelegatedCreate = false;
            return $3cb88ae91b980052$var$handleStreamingError(error, span);
        }
    });
}
function $3cb88ae91b980052$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const invocationThis = thisArg !== void 0 ? thisArg : context;
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (!isStreamingMethod && $3cb88ae91b980052$var$suppressDelegatedCreate) return target.apply(invocationThis, args);
            const operationName = instrumentedMethod.operation || "unknown";
            const requestAttributes = $3cb88ae91b980052$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            const params = typeof args[0] === "object" ? args[0] : void 0;
            const isStreamRequested = Boolean(params?.stream);
            if (isStreamRequested || isStreamingMethod) return $3cb88ae91b980052$var$handleStreamingRequest(target, invocationThis, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $5CFne.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(invocationThis, args);
                if (options.recordInputs && params) $3cb88ae91b980052$var$addPrivateRequestAttributes(span, params, $6atBT.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $3cb88ae91b980052$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                });
            });
            return $6atBT.wrapPromiseWithMethods(originalResult, instrumentedPromise);
        }
    });
}
function $3cb88ae91b980052$var$instrumentClientInPlace(client, options) {
    for (const methodPath of Object.keys($j6AED.ANTHROPIC_METHOD_REGISTRY)){
        const segments = methodPath.split(".");
        const methodName = segments.pop();
        let owner = client;
        for (const segment of segments)owner = owner?.[segment];
        if (!owner || typeof owner[methodName] !== "function") continue;
        const originalMethod = owner[methodName];
        if ($3cb88ae91b980052$var$INSTRUMENTED_METHODS.has(originalMethod)) continue;
        const instrumented = $3cb88ae91b980052$var$instrumentMethod(originalMethod, methodPath, $j6AED.ANTHROPIC_METHOD_REGISTRY[methodPath], owner, options);
        $3cb88ae91b980052$var$INSTRUMENTED_METHODS.add(instrumented);
        owner[methodName] = instrumented;
    }
    return client;
}
function $3cb88ae91b980052$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $3cb88ae91b980052$var$instrumentClientInPlace(anthropicAiClient, $6atBT.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $3cb88ae91b980052$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $3cb88ae91b980052$var$addResponseAttributes;
module.exports.extractRequestAttributes = $3cb88ae91b980052$var$extractRequestAttributes;
module.exports.instrumentAnthropicAiClient = $3cb88ae91b980052$var$instrumentAnthropicAiClient;

});
parcelRegister("j6AED", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $de8b02a86b535776$var$ANTHROPIC_AI_INTEGRATION_NAME = "Anthropic_AI";
const $de8b02a86b535776$var$ANTHROPIC_METHOD_REGISTRY = {
    "messages.create": {
        operation: "chat"
    },
    "messages.stream": {
        operation: "chat",
        streaming: true
    },
    "messages.countTokens": {
        operation: "chat"
    },
    "models.get": {
        operation: "models"
    },
    "completions.create": {
        operation: "chat"
    },
    "models.retrieve": {
        operation: "models"
    },
    "beta.messages.create": {
        operation: "chat"
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $de8b02a86b535776$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $de8b02a86b535776$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("ax3NO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");

var $3nLrf = parcelRequire("3nLrf");
function $7aafef8a6ecaaccf$var$isErrorEvent(event, span) {
    if ("type" in event && typeof event.type === "string") {
        if (event.type === "error") {
            span.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: $3nLrf.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            return true;
        }
    }
    return false;
}
function $7aafef8a6ecaaccf$var$handleMessageMetadata(event, state) {
    if (event.type === "message_delta") {
        if (event.usage && typeof event.usage.output_tokens === "number") state.completionTokens = event.usage.output_tokens;
        if (event.delta?.stop_reason) state.finishReasons.push(event.delta.stop_reason);
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.usage) {
            if (typeof message.usage.input_tokens === "number") state.promptTokens = message.usage.input_tokens + (message.usage.cache_creation_input_tokens ?? 0) + (message.usage.cache_read_input_tokens ?? 0);
            if (typeof message.usage.cache_creation_input_tokens === "number") state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === "number") state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
function $7aafef8a6ecaaccf$var$handleContentBlockStart(event, state) {
    if (event.type !== "content_block_start" || typeof event.index !== "number" || !event.content_block) return;
    if (event.content_block.type === "tool_use" || event.content_block.type === "server_tool_use") state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
function $7aafef8a6ecaaccf$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== "content_block_delta" || !event.delta) return;
    if (typeof event.index === "number" && "partial_json" in event.delta && typeof event.delta.partial_json === "string") {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    if (recordOutputs && typeof event.delta.text === "string") state.responseTexts.push(event.delta.text);
}
function $7aafef8a6ecaaccf$var$handleContentBlockStop(event, state) {
    if (event.type !== "content_block_stop" || typeof event.index !== "number") return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join("");
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: "tool_use",
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    delete state.activeToolBlocks[event.index];
}
function $7aafef8a6ecaaccf$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === "object")) return;
    const isError = $7aafef8a6ecaaccf$var$isErrorEvent(event, span);
    if (isError) return;
    $7aafef8a6ecaaccf$var$handleMessageMetadata(event, state);
    $7aafef8a6ecaaccf$var$handleContentBlockStart(event, state);
    $7aafef8a6ecaaccf$var$handleContentBlockDelta(event, state, recordOutputs);
    $7aafef8a6ecaaccf$var$handleContentBlockStop(event, state);
}
async function* $7aafef8a6ecaaccf$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $7aafef8a6ecaaccf$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $6atBT.endStreamSpan(span, state, recordOutputs);
    }
}
function $7aafef8a6ecaaccf$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: "",
        responseModel: "",
        promptTokens: void 0,
        completionTokens: void 0,
        cacheCreationInputTokens: void 0,
        cacheReadInputTokens: void 0,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on("streamEvent", (event)=>{
        $7aafef8a6ecaaccf$var$processEvent(event, state, recordOutputs, span);
    });
    stream.on("message", ()=>{
        $6atBT.endStreamSpan(span, state, recordOutputs);
    });
    stream.on("error", (error)=>{
        $13TrR.captureException(error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.stream_error"
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $h5H4c.SPAN_STATUS_ERROR,
                message: "internal_error"
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $7aafef8a6ecaaccf$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $7aafef8a6ecaaccf$var$instrumentMessageStream;

});
parcelRegister("3nLrf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");
function $27685164e12c8cb4$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages),
        [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $27685164e12c8cb4$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: "invalid_argument",
    authentication_error: "unauthenticated",
    permission_error: "permission_denied",
    not_found_error: "not_found",
    request_too_large: "failed_precondition",
    rate_limit_error: "resource_exhausted",
    api_error: "internal_error",
    overloaded_error: "unavailable"
};
function $27685164e12c8cb4$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return "internal_error";
    return $27685164e12c8cb4$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || "internal_error";
}
function $27685164e12c8cb4$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: $27685164e12c8cb4$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $13TrR.captureException(response.error, {
            mechanism: {
                handled: false,
                type: "auto.ai.anthropic.anthropic_error"
            }
        });
    }
}
function $27685164e12c8cb4$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === "string" ? [
        {
            role: "system",
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : void 0;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $27685164e12c8cb4$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $27685164e12c8cb4$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $27685164e12c8cb4$var$messagesFromParams;
module.exports.setMessagesAttribute = $27685164e12c8cb4$var$setMessagesAttribute;

});



parcelRegister("9nAI4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $fzE9o = parcelRequire("fzE9o");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $dSnj4 = parcelRequire("dSnj4");

var $leGC4 = parcelRequire("leGC4");

var $1KvWs = parcelRequire("1KvWs");
function $6d42bcdde3c69d49$var$extractModel(params, context) {
    if ("model" in params && typeof params.model === "string") return params.model;
    if (context && typeof context === "object") {
        const contextObj = context;
        if ("model" in contextObj && typeof contextObj.model === "string") return contextObj.model;
        if ("modelVersion" in contextObj && typeof contextObj.modelVersion === "string") return contextObj.modelVersion;
    }
    return "unknown";
}
function $6d42bcdde3c69d49$var$extractConfigAttributes(config) {
    const attributes = {};
    if ("temperature" in config && typeof config.temperature === "number") attributes[$eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ("topP" in config && typeof config.topP === "number") attributes[$eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ("topK" in config && typeof config.topK === "number") attributes[$eN9vd.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ("maxOutputTokens" in config && typeof config.maxOutputTokens === "number") attributes[$eN9vd.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ("frequencyPenalty" in config && typeof config.frequencyPenalty === "number") attributes[$eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ("presencePenalty" in config && typeof config.presencePenalty === "number") attributes[$eN9vd.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
function $6d42bcdde3c69d49$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: $dSnj4.GOOGLE_GENAI_SYSTEM_NAME,
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.google_genai"
    };
    if (params) {
        attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $6d42bcdde3c69d49$var$extractModel(params, context);
        if ("config" in params && typeof params.config === "object" && params.config) {
            const config = params.config;
            Object.assign(attributes, $6d42bcdde3c69d49$var$extractConfigAttributes(config));
            if ("tools" in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $6d42bcdde3c69d49$var$extractModel({}, context);
    return attributes;
}
function $6d42bcdde3c69d49$var$addPrivateRequestAttributes(span, params, operationName, enableTruncation) {
    if (operationName === "embeddings") {
        const contents = params.contents;
        if (contents != null) span.setAttribute($eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === "string" ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    if ("config" in params && params.config && typeof params.config === "object" && "systemInstruction" in params.config && params.config.systemInstruction) messages.push(...$1KvWs.contentUnionToMessages(params.config.systemInstruction, "system"));
    if ("history" in params) messages.push(...$1KvWs.contentUnionToMessages(params.history, "user"));
    if ("contents" in params) messages.push(...$1KvWs.contentUnionToMessages(params.contents, "user"));
    if ("message" in params) messages.push(...$1KvWs.contentUnionToMessages(params.message, "user"));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages)
        });
    }
}
function $6d42bcdde3c69d49$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== "object") return;
    if (response.modelVersion) span.setAttribute($eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    if (response.usageMetadata && typeof response.usageMetadata === "object") {
        const usage = response.usageMetadata;
        const hasOutput = typeof usage.candidatesTokenCount === "number" || typeof usage.thoughtsTokenCount === "number";
        span.setAttributes($6atBT.getTokenUsageAttributes(usage.promptTokenCount, hasOutput ? (usage.candidatesTokenCount ?? 0) + (usage.thoughtsTokenCount ?? 0) : void 0, void 0, usage.cachedContentTokenCount, usage.totalTokenCount));
        if (typeof usage.thoughtsTokenCount === "number") span.setAttribute($eAISS.GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, usage.thoughtsTokenCount);
    }
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === "string" ? part.text : "").filter((text)=>text.length > 0).join("");
            return "";
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join("")
        });
    }
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
function $6d42bcdde3c69d49$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === "embeddings";
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || "unknown";
            const params = args[0];
            const requestAttributes = $6d42bcdde3c69d49$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? "unknown";
            if (instrumentedMethod.streaming) return $5CFne.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $6d42bcdde3c69d49$var$addPrivateRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $leGC4.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    span.end();
                    throw error;
                }
            });
            return $5CFne.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $6d42bcdde3c69d49$var$addPrivateRequestAttributes(span, params, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
                return $fzE9o.handleCallbackErrors(()=>target.apply(context, args), ()=>{}, ()=>{}, (result)=>{
                    if (!isEmbeddings) $6d42bcdde3c69d49$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
function $6d42bcdde3c69d49$var$createDeepProxy(target, currentPath = "", options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $6atBT.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $dSnj4.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === "function" && instrumentedMethod) {
                const wrappedMethod = instrumentedMethod.operation ? $6d42bcdde3c69d49$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === "object") return $6d42bcdde3c69d49$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === "function") return value.bind(t);
            if (value && typeof value === "object") return $6d42bcdde3c69d49$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
function $6d42bcdde3c69d49$var$instrumentGoogleGenAIClient(client, options) {
    return $6d42bcdde3c69d49$var$createDeepProxy(client, "", $6atBT.resolveAIRecordingOptions(options));
}
module.exports.addPrivateRequestAttributes = $6d42bcdde3c69d49$var$addPrivateRequestAttributes;
module.exports.addResponseAttributes = $6d42bcdde3c69d49$var$addResponseAttributes;
module.exports.extractModel = $6d42bcdde3c69d49$var$extractModel;
module.exports.extractRequestAttributes = $6d42bcdde3c69d49$var$extractRequestAttributes;
module.exports.instrumentGoogleGenAIClient = $6d42bcdde3c69d49$var$instrumentGoogleGenAIClient;

});
parcelRegister("dSnj4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $a1a265b3b335d9af$var$GOOGLE_GENAI_INTEGRATION_NAME = "Google_GenAI";
const $a1a265b3b335d9af$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    "models.generateContent": {
        operation: "generate_content"
    },
    "models.generateContentStream": {
        operation: "generate_content",
        streaming: true
    },
    "models.embedContent": {
        operation: "embeddings"
    },
    "chats.create": {
        proxyResultPath: "chat"
    },
    "chat.sendMessage": {
        operation: "chat"
    },
    "chat.sendMessageStream": {
        operation: "chat",
        streaming: true
    }
};
const $a1a265b3b335d9af$var$GOOGLE_GENAI_SYSTEM_NAME = "google_genai";
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $a1a265b3b335d9af$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $a1a265b3b335d9af$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $a1a265b3b335d9af$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("leGC4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $13TrR = parcelRequire("13TrR");

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");
function $f75bf5dbae246aa2$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $h5H4c.SPAN_STATUS_ERROR,
            message: "internal_error"
        });
        $13TrR.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: "auto.ai.google_genai"
            }
        });
        return true;
    }
    return false;
}
function $f75bf5dbae246aa2$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === "string") state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === "string") state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === "number") state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === "number") state.candidateTokens = usage.candidatesTokenCount;
        if (typeof usage.thoughtsTokenCount === "number") state.reasoningOutputTokens = usage.thoughtsTokenCount;
        if (state.candidateTokens !== void 0 || state.reasoningOutputTokens !== void 0) state.completionTokens = (state.candidateTokens ?? 0) + (state.reasoningOutputTokens ?? 0);
        if (typeof usage.totalTokenCount === "number") state.totalTokens = usage.totalTokenCount;
        if (typeof usage.cachedContentTokenCount === "number") state.cacheReadInputTokens = usage.cachedContentTokenCount;
    }
}
function $f75bf5dbae246aa2$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: "function",
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
function $f75bf5dbae246aa2$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $f75bf5dbae246aa2$var$isErrorChunk(chunk, span)) return;
    $f75bf5dbae246aa2$var$handleResponseMetadata(chunk, state);
    $f75bf5dbae246aa2$var$handleCandidateContent(chunk, state, recordOutputs);
}
async function* $f75bf5dbae246aa2$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $f75bf5dbae246aa2$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $6atBT.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $f75bf5dbae246aa2$var$instrumentStream;

});

parcelRegister("1KvWs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1462dd54837da644$var$contentUnionToMessages(content, role = "user") {
    if (typeof content === "string") return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content2)=>$1462dd54837da644$var$contentUnionToMessages(content2, role));
    if (typeof content !== "object" || !content) return [];
    if ("role" in content && typeof content.role === "string") return [
        content
    ];
    if ("parts" in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $1462dd54837da644$var$contentUnionToMessages;

});


parcelRegister("lVCHq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $iYG6e = parcelRequire("iYG6e");

var $aGDGs = parcelRequire("aGDGs");
function $ff6cf0bcb7a93f0d$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $6atBT.resolveAIRecordingOptions(options);
    const enableTruncation = $6atBT.shouldEnableTruncation(options.enableTruncation);
    const spanMap = /* @__PURE__ */ new Map();
    const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_secrets: void 0,
        lc_attributes: void 0,
        lc_aliases: void 0,
        lc_serializable_keys: void 0,
        lc_id: [
            "langchain_core",
            "callbacks",
            "sentry"
        ],
        lc_kwargs: {},
        name: "SentryCallbackHandler",
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $aGDGs.getInvocationParams(tags);
            const attributes = $aGDGs.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $5CFne.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$aGDGs.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $aGDGs.getInvocationParams(tags);
            const attributes = $aGDGs.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $aGDGs.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $5CFne.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: "gen_ai.chat",
                attributes: {
                    ...$aGDGs.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.chat"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $aGDGs.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || "unknown_chain";
            const attributes = {
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: "auto.ai.langchain",
                "langchain.chain.name": chainName
            };
            if (recordInputs) attributes["langchain.chain.inputs"] = JSON.stringify(inputs);
            $5CFne.startSpanManual({
                name: `chain ${chainName}`,
                op: "gen_ai.invoke_agent",
                attributes: {
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.invoke_agent"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) span.setAttributes({
                    "langchain.chain.outputs": JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            if (metadata?.__sentry_langgraph__) return;
            const toolName = runName || tool.name || "unknown_tool";
            const attributes = {
                ...$aGDGs.getAgentNameFromMetadata(metadata),
                [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $iYG6e.LANGCHAIN_ORIGIN,
                [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                [$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$eN9vd.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $5CFne.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: "gen_ai.execute_tool",
                attributes: {
                    ...attributes,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.execute_tool"
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === "object" && "content" in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$eN9vd.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === "string" ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (_error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                exitSpan(runId);
            }
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: "not_implemented",
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $ff6cf0bcb7a93f0d$var$createLangChainCallbackHandler;

});
parcelRegister("iYG6e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $dd0e7caf2ac88560$var$LANGCHAIN_INTEGRATION_NAME = "LangChain";
const $dd0e7caf2ac88560$var$LANGCHAIN_ORIGIN = "auto.ai.langchain";
const $dd0e7caf2ac88560$var$ROLE_MAP = {
    human: "user",
    ai: "assistant",
    assistant: "assistant",
    system: "system",
    function: "function",
    tool: "tool"
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $dd0e7caf2ac88560$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $dd0e7caf2ac88560$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $dd0e7caf2ac88560$var$ROLE_MAP;

});

parcelRegister("aGDGs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $foFxi = parcelRequire("foFxi");

var $cUgOr = parcelRequire("cUgOr");

var $eN9vd = parcelRequire("eN9vd");

var $1qvHT = parcelRequire("1qvHT");

var $6atBT = parcelRequire("6atBT");

var $iYG6e = parcelRequire("iYG6e");
const $7c7c9c05f7ab0056$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
const $7c7c9c05f7ab0056$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
function $7c7c9c05f7ab0056$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === "object" && $1qvHT.isContentMedia(part) ? $1qvHT.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $foFxi.stringify(v, String);
}
function $7c7c9c05f7ab0056$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $iYG6e.ROLE_MAP[normalized] ?? normalized;
}
function $7c7c9c05f7ab0056$var$normalizeRoleNameFromCtor(name) {
    if (name.includes("System")) return "system";
    if (name.includes("Human")) return "user";
    if (name.includes("AI") || name.includes("Assistant")) return "assistant";
    if (name.includes("Function")) return "function";
    if (name.includes("Tool")) return "tool";
    return "user";
}
function $7c7c9c05f7ab0056$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return void 0;
    return tags.invocation_params;
}
function $7c7c9c05f7ab0056$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        const maybeGetType = message._getType;
        if (typeof maybeGetType === "function") {
            const messageType = maybeGetType.call(message);
            return {
                role: $7c7c9c05f7ab0056$var$normalizeMessageRole(messageType),
                content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
            };
        }
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : "";
            const role = typeof messageType === "string" ? $7c7c9c05f7ab0056$var$normalizeRoleNameFromCtor(messageType) : "user";
            return {
                role: $7c7c9c05f7ab0056$var$normalizeMessageRole(role),
                content: $7c7c9c05f7ab0056$var$normalizeContent(message.kwargs?.content)
            };
        }
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $7c7c9c05f7ab0056$var$normalizeMessageRole(role),
                content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
            };
        }
        if (message.role) return {
            role: $7c7c9c05f7ab0056$var$normalizeMessageRole(String(message.role)),
            content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
        };
        const ctor = message.constructor?.name;
        if (ctor && ctor !== "Object") return {
            role: $7c7c9c05f7ab0056$var$normalizeMessageRole($7c7c9c05f7ab0056$var$normalizeRoleNameFromCtor(ctor)),
            content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
        };
        return {
            role: "user",
            content: $7c7c9c05f7ab0056$var$normalizeContent(message.content)
        };
    });
}
function $7c7c9c05f7ab0056$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    const kwargs = "kwargs" in serialized ? serialized.kwargs : void 0;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $7c7c9c05f7ab0056$var$setNumberIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    if (invocationParams && "stream" in invocationParams) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
function $7c7c9c05f7ab0056$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE]: $foFxi.stringify(system ?? "langchain", String),
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "chat",
        [$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $foFxi.stringify(modelName, String),
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $iYG6e.LANGCHAIN_ORIGIN,
        ...$7c7c9c05f7ab0056$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
function $7c7c9c05f7ab0056$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $7c7c9c05f7ab0056$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: "user",
                content: p
            }));
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $6atBT.getTruncatedJsonString(messages) : $foFxi.stringify(messages));
    }
    return attrs;
}
function $7c7c9c05f7ab0056$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? "unknown";
    const attrs = $7c7c9c05f7ab0056$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $7c7c9c05f7ab0056$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(normalized);
        if (systemInstructions) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages));
    }
    return attrs;
}
function $7c7c9c05f7ab0056$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === "tool_use") toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $foFxi.stringify(toolCalls, String));
}
function $7c7c9c05f7ab0056$var$extractMessageTokenUsageAttributes(message) {
    const usage = message.usage_metadata;
    if ($cUgOr.isObjectLike(usage)) {
        const details = $cUgOr.isObjectLike(usage.input_token_details) ? usage.input_token_details : void 0;
        return $6atBT.getTokenUsageAttributes(usage.input_tokens, usage.output_tokens, details?.cache_creation, details?.cache_read, usage.total_tokens);
    }
    const metadata = message.response_metadata;
    const tokenUsage = $cUgOr.isObjectLike(metadata) && $cUgOr.isObjectLike(metadata.tokenUsage) ? metadata.tokenUsage : void 0;
    return $6atBT.getTokenUsageAttributes(tokenUsage?.promptTokens, tokenUsage?.completionTokens, void 0, void 0, tokenUsage?.totalTokens);
}
function $7c7c9c05f7ab0056$var$addTokenUsageAttributes(llmResult, attrs) {
    const normalizedUsage = {};
    const legacyMessageUsage = {};
    for (const generations of llmResult.generations ?? []){
        const message = generations[0]?.message;
        if (message) {
            const usage = $cUgOr.isObjectLike(message.usage_metadata) ? normalizedUsage : legacyMessageUsage;
            for (const [key, value] of Object.entries($7c7c9c05f7ab0056$var$extractMessageTokenUsageAttributes(message)))usage[key] = (usage[key] ?? 0) + value;
        }
    }
    Object.assign(attrs, Object.keys(normalizedUsage).length > 0 ? normalizedUsage : legacyMessageUsage);
    const llmOutput = llmResult.llmOutput;
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (anthropicUsage && Object.keys(normalizedUsage).length === 0 && Object.keys(legacyMessageUsage).length === 0) {
        const { input_tokens: input_tokens, output_tokens: output_tokens, cache_creation_input_tokens: cache_creation_input_tokens, cache_read_input_tokens: cache_read_input_tokens } = anthropicUsage;
        const hasInput = input_tokens !== void 0 || cache_creation_input_tokens !== void 0 || cache_read_input_tokens !== void 0;
        Object.assign(attrs, $6atBT.getTokenUsageAttributes(hasInput ? (input_tokens ?? 0) + (cache_creation_input_tokens ?? 0) + (cache_read_input_tokens ?? 0) : void 0, output_tokens, cache_creation_input_tokens, cache_read_input_tokens));
    } else if (tokenUsage && Object.keys(normalizedUsage).length === 0 && Object.keys(legacyMessageUsage).length === 0) Object.assign(attrs, $6atBT.getTokenUsageAttributes(tokenUsage.promptTokens, tokenUsage.completionTokens, void 0, void 0, tokenUsage.totalTokens));
    if (anthropicUsage) {
        if (typeof anthropicUsage.cache_creation_input_tokens === "number" && !($eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS in attrs)) attrs[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS] = anthropicUsage.cache_creation_input_tokens;
        if (typeof anthropicUsage.cache_read_input_tokens === "number" && !($eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS in attrs)) attrs[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS] = anthropicUsage.cache_read_input_tokens;
    }
}
function $7c7c9c05f7ab0056$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === "string");
        if (finishReasons.length > 0) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $foFxi.stringify(finishReasons, String));
        $7c7c9c05f7ab0056$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === "string");
            if (texts.length > 0) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $foFxi.stringify(texts, String));
        }
    }
    $7c7c9c05f7ab0056$var$addTokenUsageAttributes(llmResult, attrs);
    const llmOutput = llmResult.llmOutput;
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $7c7c9c05f7ab0056$var$setIfDefined(attrs, $eN9vd.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $foFxi.stringify(stopReason, String));
    return attrs;
}
function $7c7c9c05f7ab0056$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === "string") attrs[$eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $7c7c9c05f7ab0056$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return void 0;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: "function",
            name: tool.name ?? fn?.name ?? "",
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
function $7c7c9c05f7ab0056$var$isCallbackManager(value) {
    if (!value || typeof value !== "object") return false;
    const candidate = value;
    return typeof candidate.addHandler === "function" && typeof candidate.copy === "function";
}
function $7c7c9c05f7ab0056$var$isSentryHandler(handler) {
    return typeof handler === "object" && handler?.name === "SentryCallbackHandler";
}
function $7c7c9c05f7ab0056$var$containsSentryHandler(handlers) {
    return handlers.some($7c7c9c05f7ab0056$var$isSentryHandler);
}
function $7c7c9c05f7ab0056$var$_INTERNAL_mergeLangChainCallbackHandler(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if ($7c7c9c05f7ab0056$var$isCallbackManager(existing)) {
        if ($7c7c9c05f7ab0056$var$containsSentryHandler(existing.handlers ?? [])) return existing;
        const copied = existing.copy();
        copied.addHandler(sentryHandler, true);
        return copied;
    }
    const handlers = Array.isArray(existing) ? existing : [
        existing
    ];
    if ($7c7c9c05f7ab0056$var$containsSentryHandler(handlers)) return existing;
    return [
        ...handlers,
        sentryHandler
    ];
}
module.exports._INTERNAL_mergeLangChainCallbackHandler = $7c7c9c05f7ab0056$var$_INTERNAL_mergeLangChainCallbackHandler;
module.exports.extractChatModelRequestAttributes = $7c7c9c05f7ab0056$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $7c7c9c05f7ab0056$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $7c7c9c05f7ab0056$var$extractLlmResponseAttributes;
module.exports.extractMessageTokenUsageAttributes = $7c7c9c05f7ab0056$var$extractMessageTokenUsageAttributes;
module.exports.extractToolDefinitions = $7c7c9c05f7ab0056$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $7c7c9c05f7ab0056$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $7c7c9c05f7ab0056$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $7c7c9c05f7ab0056$var$normalizeLangChainMessages;

});


parcelRegister("fbA8J", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $iYG6e = parcelRequire("iYG6e");
function $b0e3eab0a3f7970b$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? "";
    if (name.includes("OpenAI")) return "openai";
    if (name.includes("Google")) return "google_genai";
    if (name.includes("Mistral")) return "mistralai";
    if (name.includes("Vertex")) return "google_vertexai";
    if (name.includes("Bedrock")) return "aws_bedrock";
    if (name.includes("Ollama")) return "ollama";
    if (name.includes("Cloudflare")) return "cloudflare";
    if (name.includes("Cohere")) return "cohere";
    return "langchain";
}
function $b0e3eab0a3f7970b$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $iYG6e.LANGCHAIN_ORIGIN,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $eN9vd.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "embeddings",
        [$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? "unknown"
    };
    attributes[$eN9vd.GEN_AI_SYSTEM_ATTRIBUTE] = $b0e3eab0a3f7970b$var$inferSystemFromInstance(embeddingsInstance);
    if ("dimensions" in embeddingsInstance) attributes[$eN9vd.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ("encodingFormat" in embeddingsInstance) attributes[$eN9vd.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
function $b0e3eab0a3f7970b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(instance, input, options = {}) {
    const { recordInputs: recordInputs } = $6atBT.resolveAIRecordingOptions(options);
    const attributes = $b0e3eab0a3f7970b$var$extractEmbeddingAttributes(instance);
    const modelName = attributes[$eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || "unknown";
    if (recordInputs && input != null) attributes[$eN9vd.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === "string" ? input : JSON.stringify(input);
    return {
        name: `embeddings ${modelName}`,
        op: $eN9vd.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        attributes: attributes
    };
}
function $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            return $5CFne.startSpan($b0e3eab0a3f7970b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions(thisArg, args[0], options), ()=>{
                return Reflect.apply(target, thisArg, args);
            });
        }
    });
}
function $b0e3eab0a3f7970b$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === "function") embeddingsInstance.embedQuery = $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === "function") embeddingsInstance.embedDocuments = $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports._INTERNAL_getLangChainEmbeddingsSpanOptions = $b0e3eab0a3f7970b$var$_INTERNAL_getLangChainEmbeddingsSpanOptions;
module.exports.instrumentEmbeddingMethod = $b0e3eab0a3f7970b$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $b0e3eab0a3f7970b$var$instrumentLangChainEmbeddings;

});

parcelRegister("lWjTr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f3RkF = parcelRequire("f3RkF");

var $foFxi = parcelRequire("foFxi");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $lVCHq = parcelRequire("lVCHq");

var $aGDGs = parcelRequire("aGDGs");

var $hYL8G = parcelRequire("hYL8G");

var $6OoWC = parcelRequire("6OoWC");
let $ff8e72220f6aa8bb$var$_insideCreateReactAgent = false;
const $ff8e72220f6aa8bb$var$SENTRY_PATCHED = "__sentry_patched__";
function $ff8e72220f6aa8bb$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(agentName) {
    const attributes = {
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hYL8G.LANGGRAPH_ORIGIN,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: "gen_ai.create_agent",
        [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "create_agent"
    };
    if (agentName) attributes[$eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return {
        op: "gen_ai.create_agent",
        name: agentName ? `create_agent ${agentName}` : "create_agent",
        attributes: attributes
    };
}
function $ff8e72220f6aa8bb$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $ff8e72220f6aa8bb$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $lVCHq.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            if ($ff8e72220f6aa8bb$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $5CFne.startSpan($ff8e72220f6aa8bb$var$_INTERNAL_getLangGraphCreateAgentSpanOptions(), (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    if (compileOptions?.name && typeof compileOptions.name === "string") {
                        span.setAttribute($eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === "function") compiledGraph.invoke = $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, void 0, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $ff8e72220f6aa8bb$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $5CFne.startSpan({
                op: "gen_ai.invoke_agent",
                name: "invoke_agent",
                attributes: {
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hYL8G.LANGGRAPH_ORIGIN,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $eN9vd.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "invoke_agent"
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === "string") {
                        span.setAttribute($eN9vd.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($eN9vd.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    const config = args.length > 1 ? args[1] : void 0;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === "string") span.setAttribute($eN9vd.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === "string" ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $aGDGs._INTERNAL_mergeLangChainCallbackHandler(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    const tools = $6OoWC.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($eN9vd.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $aGDGs.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($eN9vd.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $6atBT.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$eN9vd.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages),
                            [$eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $6OoWC.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $h5H4c.SPAN_STATUS_ERROR,
                        message: "internal_error"
                    });
                    throw error;
                }
            });
        }
    });
}
function $ff8e72220f6aa8bb$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $ff8e72220f6aa8bb$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $6atBT.resolveAIRecordingOptions(options);
    const sentryHandler = $lVCHq.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $6OoWC.extractLLMFromParams(args);
            const agentName = $6OoWC.extractAgentNameFromParams(args);
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $6OoWC.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? void 0);
            $ff8e72220f6aa8bb$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $ff8e72220f6aa8bb$var$_insideCreateReactAgent = false;
            }
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === "function") {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $ff8e72220f6aa8bb$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
function $ff8e72220f6aa8bb$var$instrumentStateGraph(stateGraph, options) {
    stateGraph.compile = $ff8e72220f6aa8bb$var$instrumentStateGraphCompile(stateGraph.compile, $6atBT.resolveAIRecordingOptions(options));
    return stateGraph;
}
const $ff8e72220f6aa8bb$var$instrumentLangGraph = $ff8e72220f6aa8bb$var$instrumentStateGraph;
module.exports._INTERNAL_getLangGraphCreateAgentSpanOptions = $ff8e72220f6aa8bb$var$_INTERNAL_getLangGraphCreateAgentSpanOptions;
module.exports.instrumentCompiledGraphInvoke = $ff8e72220f6aa8bb$var$instrumentCompiledGraphInvoke;
module.exports.instrumentCreateReactAgent = $ff8e72220f6aa8bb$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $ff8e72220f6aa8bb$var$instrumentLangGraph;
module.exports.instrumentStateGraph = $ff8e72220f6aa8bb$var$instrumentStateGraph;
module.exports.instrumentStateGraphCompile = $ff8e72220f6aa8bb$var$instrumentStateGraphCompile;

});
parcelRegister("hYL8G", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $d16c9b1958e018a8$var$LANGGRAPH_INTEGRATION_NAME = "LangGraph";
const $d16c9b1958e018a8$var$LANGGRAPH_ORIGIN = "auto.ai.langgraph";
module.exports.LANGGRAPH_INTEGRATION_NAME = $d16c9b1958e018a8$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $d16c9b1958e018a8$var$LANGGRAPH_ORIGIN;

});

parcelRegister("6OoWC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $eN9vd = parcelRequire("eN9vd");

var $aGDGs = parcelRequire("aGDGs");

var $hYL8G = parcelRequire("hYL8G");
function $4f5ac30be815dfe7$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== "object" || !arg || !("llm" in arg) || !arg.llm || typeof arg.llm !== "object") return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== "string" && typeof llm.model !== "string") return null;
    return llm;
}
function $4f5ac30be815dfe7$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === "object" && !!arg && "name" in arg && typeof arg.name === "string") return arg.name;
    return null;
}
function $4f5ac30be815dfe7$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = "__sentry_tool_wrapped__";
    for (const tool of tools){
        if (!tool || typeof tool !== "object") continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== "function" || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === "string" ? t.name : "unknown_tool";
        const toolDescription = typeof t.description === "string" ? t.description : void 0;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $hYL8G.LANGGRAPH_ORIGIN,
                    [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $eN9vd.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$eN9vd.GEN_AI_OPERATION_NAME_ATTRIBUTE]: "execute_tool",
                    [$eN9vd.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$eN9vd.GEN_AI_TOOL_TYPE_ATTRIBUTE]: "function"
                };
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === "string") spanAttributes[$eN9vd.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$eN9vd.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                const input = args[0];
                if (typeof input === "object" && !!input) {
                    if ("id" in input && typeof input.id === "string") spanAttributes[$eN9vd.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = "args" in input && typeof input.args === "object" ? input.args : input;
                        try {
                            spanAttributes[$eN9vd.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {}
                    }
                }
                return $5CFne.startSpan({
                    op: $eN9vd.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === "object" && "content" in resultObj ? resultObj.content : result;
                            span.setAttribute($eN9vd.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === "string" ? content : JSON.stringify(content));
                        } catch  {}
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $h5H4c.SPAN_STATUS_ERROR,
                            message: "internal_error"
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
function $4f5ac30be815dfe7$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === "object") {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
function $4f5ac30be815dfe7$var$extractTokenUsageFromMessage(message) {
    const attributes$1 = $aGDGs.extractMessageTokenUsageAttributes(message);
    return {
        inputTokens: attributes$1[$eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] ?? 0,
        outputTokens: attributes$1[$eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] ?? 0,
        totalTokens: attributes$1[$eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] ?? 0,
        cacheCreationInputTokens: attributes$1[$eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS],
        cacheReadInputTokens: attributes$1[$eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS]
    };
}
function $4f5ac30be815dfe7$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === "object") {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === "string") span.setAttribute($eN9vd.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === "string") span.setAttribute($eN9vd.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
function $4f5ac30be815dfe7$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
function $4f5ac30be815dfe7$var$setResponseAttributes(span, inputMessages, result) {
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    const toolCalls = $4f5ac30be815dfe7$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    const normalizedNewMessages = $aGDGs.normalizeLangChainMessages(newMessages);
    span.setAttribute($eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    let cacheCreationInputTokens;
    let cacheReadInputTokens;
    for (const message of newMessages){
        const tokens = $4f5ac30be815dfe7$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        if (tokens.cacheCreationInputTokens !== void 0) cacheCreationInputTokens = (cacheCreationInputTokens ?? 0) + tokens.cacheCreationInputTokens;
        if (tokens.cacheReadInputTokens !== void 0) cacheReadInputTokens = (cacheReadInputTokens ?? 0) + tokens.cacheReadInputTokens;
        $4f5ac30be815dfe7$var$extractModelMetadata(span, message);
    }
    if (totalInputTokens > 0) span.setAttribute($eN9vd.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($eN9vd.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($eN9vd.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
    if (cacheCreationInputTokens !== void 0) span.setAttribute($eAISS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, cacheCreationInputTokens);
    if (cacheReadInputTokens !== void 0) span.setAttribute($eAISS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, cacheReadInputTokens);
}
module.exports.extractAgentNameFromParams = $4f5ac30be815dfe7$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $4f5ac30be815dfe7$var$extractLLMFromParams;
module.exports.extractModelMetadata = $4f5ac30be815dfe7$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $4f5ac30be815dfe7$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $4f5ac30be815dfe7$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $4f5ac30be815dfe7$var$extractToolsFromCompiledGraph;
module.exports.setResponseAttributes = $4f5ac30be815dfe7$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $4f5ac30be815dfe7$var$wrapToolsWithSpans;

});


parcelRegister("lHZZ7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $h5H4c = parcelRequire("h5H4c");

var $5CFne = parcelRequire("5CFne");

var $fbkeM = parcelRequire("fbkeM");

var $6atBT = parcelRequire("6atBT");

var $5SzUg = parcelRequire("5SzUg");

var $kpt7v = parcelRequire("kpt7v");

var $6HgHS = parcelRequire("6HgHS");
function $fcddb207857a1cab$var$isReadableStream(value) {
    return $cUgOr.isObjectLike(value) && typeof value.pipeThrough === "function" && typeof value.getReader === "function";
}
function $fcddb207857a1cab$var$instrumentRun(originalRun, context, options) {
    return function instrumentedRun(...args) {
        if ($fbkeM._INTERNAL_shouldSkipAiProviderWrapping($5SzUg.WORKERS_AI_INTEGRATION_NAME)) return originalRun.apply(context, args);
        const [model, inputs, runOptions] = args;
        const operationName = $6HgHS.getOperationName(inputs);
        const requestAttributes = $6HgHS.extractRequestAttributes(model, inputs, operationName);
        const modelName = typeof model === "string" ? model : "unknown";
        const isStreamRequested = !!inputs && typeof inputs === "object" && inputs.stream === true;
        const returnsRawResponse = !!runOptions && typeof runOptions === "object" && (runOptions.returnRawResponse === true || runOptions.websocket === true);
        const spanConfig = {
            name: `${operationName} ${modelName}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested && !returnsRawResponse) return $5CFne.startSpanManual(spanConfig, (span)=>{
            const handleError = (error)=>{
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                span.end();
                throw error;
            };
            let originalResult;
            try {
                originalResult = originalRun.apply(context, args);
            } catch (error) {
                return handleError(error);
            }
            if (options.recordInputs) $6HgHS.addRequestAttributes(span, inputs, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if ($fcddb207857a1cab$var$isReadableStream(result)) return $kpt7v.instrumentWorkersAiStream(result, span, options.recordOutputs);
                $6HgHS.addResponseAttributes(span, result, options.recordOutputs);
                span.end();
                return result;
            }, handleError);
        });
        return $5CFne.startSpan(spanConfig, (span)=>{
            const originalResult = originalRun.apply(context, args);
            if (options.recordInputs) $6HgHS.addRequestAttributes(span, inputs, operationName, $6atBT.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                if (!returnsRawResponse) $6HgHS.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            });
        });
    };
}
function $fcddb207857a1cab$var$instrumentWorkersAiClient(client, options) {
    const resolvedOptions = $6atBT.resolveAIRecordingOptions(options);
    const instrumented = new Proxy(client, {
        get (target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (prop === "run" && typeof value === "function") return $fcddb207857a1cab$var$instrumentRun(value, target, resolvedOptions);
            return typeof value === "function" ? value.bind(target) : value;
        }
    });
    return instrumented;
}
module.exports.instrumentWorkersAiClient = $fcddb207857a1cab$var$instrumentWorkersAiClient;

});
parcelRegister("kpt7v", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $h5H4c = parcelRequire("h5H4c");

var $6atBT = parcelRequire("6atBT");

var $6HgHS = parcelRequire("6HgHS");
function $edbcbb12fdaf9afb$var$accumulateStreamingToolCalls(toolCalls, accumulator) {
    for (const toolCall of toolCalls){
        const name = toolCall.function?.name ?? toolCall.name;
        const args = toolCall.function?.arguments ?? toolCall.arguments;
        if (name == null && args == null) continue;
        const index = toolCall.index ?? 0;
        const existing = accumulator[index];
        if (!existing) accumulator[index] = {
            index: index,
            id: toolCall.id,
            type: toolCall.type,
            function: {
                name: name,
                arguments: args ?? ""
            }
        };
        else if (existing.function) {
            if (name && !existing.function.name) existing.function.name = name;
            if (args) existing.function.arguments = `${existing.function.arguments ?? ""}${args}`;
        }
    }
}
function $edbcbb12fdaf9afb$var$processLine(line, state, recordOutputs, toolCallAccumulator) {
    const trimmed = line.trim();
    if (!trimmed.startsWith("data:")) return;
    const data = trimmed.slice(5).trim();
    if (!data || data === "[DONE]") return;
    let parsed;
    try {
        parsed = JSON.parse(data);
    } catch  {
        return;
    }
    if (parsed.usage) {
        if (typeof parsed.usage.prompt_tokens === "number") state.promptTokens = parsed.usage.prompt_tokens;
        if (typeof parsed.usage.completion_tokens === "number") state.completionTokens = parsed.usage.completion_tokens;
        if (typeof parsed.usage.total_tokens === "number") state.totalTokens = parsed.usage.total_tokens;
    }
    if (recordOutputs && typeof parsed.response === "string") state.responseTexts.push(parsed.response);
    if (recordOutputs && Array.isArray(parsed.tool_calls) && parsed.tool_calls.length > 0) state.toolCalls.push(...parsed.tool_calls);
    if (Array.isArray(parsed.choices)) for (const choice of parsed.choices){
        if (recordOutputs && typeof choice.delta?.content === "string" && choice.delta.content) state.responseTexts.push(choice.delta.content);
        if (recordOutputs && Array.isArray(choice.delta?.tool_calls)) $edbcbb12fdaf9afb$var$accumulateStreamingToolCalls(choice.delta.tool_calls, toolCallAccumulator);
        if (typeof choice.finish_reason === "string") state.finishReasons.push(choice.finish_reason);
    }
}
function $edbcbb12fdaf9afb$var$instrumentWorkersAiStream(stream, span, recordOutputs) {
    const reader = stream.getReader();
    const decoder = new TextDecoder();
    const state = {
        responseId: "",
        responseModel: "",
        finishReasons: [],
        responseTexts: [],
        toolCalls: [],
        promptTokens: void 0,
        completionTokens: void 0,
        totalTokens: void 0
    };
    const toolCallAccumulator = {};
    let buffer = "";
    let spanEnded = false;
    const finish = ()=>{
        if (spanEnded) return;
        spanEnded = true;
        if (recordOutputs) {
            const accumulatedToolCalls = Object.values(toolCallAccumulator);
            if (accumulatedToolCalls.length > 0) state.toolCalls.push(...accumulatedToolCalls);
            $6HgHS.setOutputMessagesAttribute(span, {
                responseText: state.responseTexts.join(""),
                toolCalls: state.toolCalls
            });
        }
        $6atBT.endStreamSpan(span, state, recordOutputs);
    };
    const flushBuffer = (isDone)=>{
        const lines = buffer.split("\n");
        buffer = isDone ? "" : lines.pop() ?? "";
        for (const line of lines)$edbcbb12fdaf9afb$var$processLine(line, state, recordOutputs, toolCallAccumulator);
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    buffer += decoder.decode();
                    flushBuffer(true);
                    finish();
                    controller.close();
                    return;
                }
                buffer += decoder.decode(value, {
                    stream: true
                });
                flushBuffer(false);
                controller.enqueue(value);
            } catch (error) {
                span.setStatus({
                    code: $h5H4c.SPAN_STATUS_ERROR,
                    message: "internal_error"
                });
                finish();
                controller.error(error);
            }
        },
        async cancel (reason) {
            finish();
            await reader.cancel(reason);
        }
    });
}
module.exports.instrumentWorkersAiStream = $edbcbb12fdaf9afb$var$instrumentWorkersAiStream;

});
parcelRegister("6HgHS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eAISS = parcelRequire("eAISS");

var $f3RkF = parcelRequire("f3RkF");

var $eN9vd = parcelRequire("eN9vd");

var $6atBT = parcelRequire("6atBT");

var $foFxi = parcelRequire("foFxi");

var $5SzUg = parcelRequire("5SzUg");
function $4e03b7d555326a14$var$getOperationName(inputs) {
    if (inputs && typeof inputs === "object") {
        if ("messages" in inputs || "prompt" in inputs) return "chat";
        if ("text" in inputs) return "embeddings";
    }
    return "chat";
}
function $4e03b7d555326a14$var$extractRequestAttributes(model, inputs, operationName) {
    const attributes$1 = {
        [$eAISS.GEN_AI_PROVIDER_NAME]: $5SzUg.WORKERS_AI_PROVIDER_NAME,
        [$eAISS.GEN_AI_OPERATION_NAME]: operationName,
        [$f3RkF.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $5SzUg.WORKERS_AI_ORIGIN,
        [$eAISS.GEN_AI_REQUEST_MODEL]: typeof model === "string" ? model : "unknown"
    };
    if (inputs && typeof inputs === "object") {
        const params = inputs;
        if (typeof params.temperature === "number") attributes$1[$eAISS.GEN_AI_REQUEST_TEMPERATURE] = params.temperature;
        if (typeof params.max_tokens === "number") attributes$1[$eAISS.GEN_AI_REQUEST_MAX_TOKENS] = params.max_tokens;
        if (typeof params.top_p === "number") attributes$1[$eAISS.GEN_AI_REQUEST_TOP_P] = params.top_p;
        if (typeof params.top_k === "number") attributes$1[$eAISS.GEN_AI_REQUEST_TOP_K] = params.top_k;
        if (typeof params.frequency_penalty === "number") attributes$1[$eAISS.GEN_AI_REQUEST_FREQUENCY_PENALTY] = params.frequency_penalty;
        if (typeof params.presence_penalty === "number") attributes$1[$eAISS.GEN_AI_REQUEST_PRESENCE_PENALTY] = params.presence_penalty;
        if (params.stream === true) attributes$1[$eN9vd.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = true;
    }
    return attributes$1;
}
function $4e03b7d555326a14$var$addRequestAttributes(span, inputs, operationName, enableTruncation) {
    if (!inputs || typeof inputs !== "object") return;
    const params = inputs;
    if (operationName === "embeddings") {
        const text = params.text;
        if (text == null || typeof text === "string" && text.length === 0 || Array.isArray(text) && text.length === 0) return;
        span.setAttribute($eAISS.GEN_AI_EMBEDDINGS_INPUT, typeof text === "string" ? text : JSON.stringify(text));
        return;
    }
    const src = params.messages ?? params.prompt;
    if (src == null || Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $6atBT.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($eAISS.GEN_AI_SYSTEM_INSTRUCTIONS, systemInstructions);
    span.setAttribute($eAISS.GEN_AI_INPUT_MESSAGES, enableTruncation ? $6atBT.getTruncatedJsonString(filteredMessages) : $foFxi.stringify(filteredMessages));
    span.setAttribute($eN9vd.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, Array.isArray(filteredMessages) ? filteredMessages.length : 1);
}
function $4e03b7d555326a14$var$setOutputMessagesAttribute(span, { responseText: responseText, toolCalls: toolCalls }) {
    const parts = [];
    if (typeof responseText === "string" && responseText.length > 0) parts.push({
        type: "text",
        content: responseText
    });
    if (Array.isArray(toolCalls)) for (const toolCall of toolCalls){
        if (!toolCall || typeof toolCall !== "object") continue;
        const call = toolCall;
        const name = call.function?.name ?? call.name;
        const args = call.function?.arguments ?? call.arguments;
        parts.push({
            type: "tool_call",
            id: call.id,
            name: name,
            arguments: typeof args === "string" ? args : JSON.stringify(args ?? {})
        });
    }
    if (parts.length > 0) span.setAttribute($eN9vd.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE, JSON.stringify([
        {
            role: "assistant",
            parts: parts
        }
    ]));
}
function $4e03b7d555326a14$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== "object" || // Raw `Response` objects (from `returnRawResponse`/`websocket`) cannot be introspected without consuming them.
    typeof Response !== "undefined" && result instanceof Response) return;
    const response = result;
    if (response.usage) span.setAttributes($6atBT.getTokenUsageAttributes(response.usage.prompt_tokens, response.usage.completion_tokens));
    if (recordOutputs) {
        let responseText;
        if (typeof response.response === "string") {
            responseText = response.response;
            span.setAttribute($eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, response.response);
        } else if (response.response != null) {
            responseText = JSON.stringify(response.response);
            span.setAttribute($eN9vd.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, responseText);
        }
        const toolCalls = Array.isArray(response.tool_calls) && response.tool_calls.length > 0 ? response.tool_calls : void 0;
        if (toolCalls) span.setAttribute($eN9vd.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
        $4e03b7d555326a14$var$setOutputMessagesAttribute(span, {
            responseText: responseText,
            toolCalls: toolCalls
        });
    }
}
module.exports.addRequestAttributes = $4e03b7d555326a14$var$addRequestAttributes;
module.exports.addResponseAttributes = $4e03b7d555326a14$var$addResponseAttributes;
module.exports.extractRequestAttributes = $4e03b7d555326a14$var$extractRequestAttributes;
module.exports.getOperationName = $4e03b7d555326a14$var$getOperationName;
module.exports.setOutputMessagesAttribute = $4e03b7d555326a14$var$setOutputMessagesAttribute;

});



parcelRegister("4mNpz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $dFAcI = parcelRequire("dFAcI");

var $4LxkX = parcelRequire("4LxkX");

var $sp0kd = parcelRequire("sp0kd");

var $iBvZc = parcelRequire("iBvZc");
const $32df8b92deab68bf$var$MAX_SPANS_PER_ENVELOPE = 1e3;
const $32df8b92deab68bf$var$MAX_TRACE_WEIGHT_IN_BYTES = 5e6;
class $32df8b92deab68bf$var$SpanBuffer {
    constructor(client, options){
        this._traceBuckets = /* @__PURE__ */ new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $32df8b92deab68bf$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $32df8b92deab68bf$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5e3;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $32df8b92deab68bf$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on("flush", ()=>{
            this.drain();
        });
        this._client.on("close", ()=>{
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: /* @__PURE__ */ new Set(),
                size: 0,
                timeout: $dFAcI.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $iBvZc.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("No segment span reference found on span JSON, cannot compute DSC");
            this._removeTrace(traceId);
            return;
        }
        const dsc = $4LxkX.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $sp0kd.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $3T29C.DEBUG_BUILD && $g31Ce.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $3T29C.DEBUG_BUILD && $g31Ce.debug.error("Error while sending streamed span envelope:", reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $32df8b92deab68bf$var$SpanBuffer;

});
parcelRegister("sp0kd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3zkbY = parcelRequire("3zkbY");

var $j6N8F = parcelRequire("j6N8F");

var $hGnwj = parcelRequire("hGnwj");

var $hkF3C = parcelRequire("hkF3C");
function $055602f634007196$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $j6N8F.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date($hkF3C.safeDateNow()).toISOString(),
        ...$055602f634007196$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $3zkbY.dsnToString(dsn$1)
        }
    };
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    const spanContainer = [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ...$hGnwj.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $j6N8F.createEnvelope(headers, [
        spanContainer
    ]);
}
function $055602f634007196$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $055602f634007196$var$createStreamedSpanEnvelope;

});

parcelRegister("iBvZc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7DFGy = parcelRequire("7DFGy");
function $d8b47e7da2586131$var$estimateSerializedSpanSizeInBytes(span) {
    let weight = 156;
    weight += span.name.length * 2;
    weight += $7DFGy.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        const linkWeight = 100 + (attributes$1 ? $7DFGy.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $d8b47e7da2586131$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("3OVuZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $iOdTc = parcelRequire("iOdTc");

var $dvzf1 = parcelRequire("dvzf1");

var $4wQxQ = parcelRequire("4wQxQ");

var $6Xrci = parcelRequire("6Xrci");

var $4mNpz = parcelRequire("4mNpz");

var $g31Ce = parcelRequire("g31Ce");

var $6vUrj = parcelRequire("6vUrj");
const $2c82a4b157672b6b$var$spanStreamingIntegration = $iOdTc.defineIntegration(()=>{
    return {
        name: "SpanStreaming",
        setup (client) {
            const initialMessage = "SpanStreaming integration requires";
            const fallbackMsg = "Falling back to static trace lifecycle.";
            const clientOptions = client.getOptions();
            if (!$6Xrci.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = "static";
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$dvzf1.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = "static";
                $3T29C.DEBUG_BUILD && $g31Ce.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $4mNpz.SpanBuffer(client);
            client.on("afterSpanEnd", (span)=>{
                if (!$6vUrj.spanIsSampled(span)) return;
                buffer.add($4wQxQ.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $2c82a4b157672b6b$var$spanStreamingIntegration;

});

parcelRegister("fJLhk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $b74fbb81e6121da4$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $b74fbb81e6121da4$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("9TAZi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $7345f114e738003a$var$SentryError extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $7345f114e738003a$var$SentryError;

});

parcelRegister("as54b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5JqSP = parcelRequire("5JqSP");

var $cUgOr = parcelRequire("cUgOr");

var $42zXR = parcelRequire("42zXR");

var $2AGy2 = parcelRequire("2AGy2");

var $5L5uH = parcelRequire("5L5uH");

var $cqs9v = parcelRequire("cqs9v");

var $eCBhU = parcelRequire("eCBhU");
function $79c07301d857e59e$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, ()=>$79c07301d857e59e$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $79c07301d857e59e$var$addFetchEndInstrumentationHandler(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = $eCBhU.addHandler(type, handler);
    $eCBhU.maybeInstrument(type, ()=>$79c07301d857e59e$var$instrumentFetch($79c07301d857e59e$var$streamHandler));
    return removeHandler;
}
function $79c07301d857e59e$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$2AGy2.supportsNativeFetch()) return;
    $42zXR.fill($cqs9v.GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $79c07301d857e59e$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $5L5uH.timestampInSeconds() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $79c07301d857e59e$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) $eCBhU.triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($cqs9v.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $eCBhU.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $5L5uH.timestampInSeconds() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                $eCBhU.triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: $5L5uH.timestampInSeconds() * 1e3,
                    error: error
                });
                if ($cUgOr.isError(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    $42zXR.addNonEnumerableProperty(error, "framesToPop", 1);
                }
                const client = $5JqSP.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && $cUgOr.isError(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else $42zXR.addNonEnumerableProperty(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $79c07301d857e59e$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $79c07301d857e59e$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $79c07301d857e59e$var$resolveResponse(clonedResponseForResolving, ()=>{
        $eCBhU.triggerHandlers("fetch-body-resolved", {
            endTimestamp: $5L5uH.timestampInSeconds() * 1e3,
            response: response
        });
    });
}
function $79c07301d857e59e$var$hasProp(obj, prop) {
    return $cUgOr.isObjectLike(obj) && !!obj[prop];
}
function $79c07301d857e59e$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($79c07301d857e59e$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $79c07301d857e59e$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $79c07301d857e59e$var$getUrlFromResource(resource),
            method: $79c07301d857e59e$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            $cUgOr.isRequest(resource) && $79c07301d857e59e$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $79c07301d857e59e$var$getUrlFromResource(arg),
        method: $79c07301d857e59e$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $79c07301d857e59e$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($cUgOr.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}
module.exports.addFetchEndInstrumentationHandler = $79c07301d857e59e$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $79c07301d857e59e$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $79c07301d857e59e$var$parseFetchArgs;

});
parcelRegister("2AGy2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3T29C = parcelRequire("3T29C");

var $g31Ce = parcelRequire("g31Ce");

var $cqs9v = parcelRequire("cqs9v");
const $1e2ff2b42bb2c1f5$var$WINDOW = $cqs9v.GLOBAL_OBJ;
function $1e2ff2b42bb2c1f5$var$supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$supportsDOMError() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$supportsHistory() {
    return "history" in $1e2ff2b42bb2c1f5$var$WINDOW && !!$1e2ff2b42bb2c1f5$var$WINDOW.history;
}
const $1e2ff2b42bb2c1f5$var$supportsFetch = $1e2ff2b42bb2c1f5$var$_isFetchSupported;
function $1e2ff2b42bb2c1f5$var$_isFetchSupported() {
    if (!("fetch" in $1e2ff2b42bb2c1f5$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $1e2ff2b42bb2c1f5$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $1e2ff2b42bb2c1f5$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$1e2ff2b42bb2c1f5$var$_isFetchSupported()) return false;
    if ($1e2ff2b42bb2c1f5$var$isNativeFunction($1e2ff2b42bb2c1f5$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $1e2ff2b42bb2c1f5$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $1e2ff2b42bb2c1f5$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $3T29C.DEBUG_BUILD && $g31Ce.debug.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $1e2ff2b42bb2c1f5$var$supportsReportingObserver() {
    return "ReportingObserver" in $1e2ff2b42bb2c1f5$var$WINDOW;
}
function $1e2ff2b42bb2c1f5$var$supportsReferrerPolicy() {
    if (!$1e2ff2b42bb2c1f5$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $1e2ff2b42bb2c1f5$var$isNativeFunction;
module.exports.supportsDOMError = $1e2ff2b42bb2c1f5$var$supportsDOMError;
module.exports.supportsDOMException = $1e2ff2b42bb2c1f5$var$supportsDOMException;
module.exports.supportsErrorEvent = $1e2ff2b42bb2c1f5$var$supportsErrorEvent;
module.exports.supportsFetch = $1e2ff2b42bb2c1f5$var$supportsFetch;
module.exports.supportsHistory = $1e2ff2b42bb2c1f5$var$supportsHistory;
module.exports.supportsNativeFetch = $1e2ff2b42bb2c1f5$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $1e2ff2b42bb2c1f5$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $1e2ff2b42bb2c1f5$var$supportsReportingObserver;

});


parcelRegister("dRLB0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a1852521ba1d10d2$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== "function") return;
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, "default", {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $a1852521ba1d10d2$var$replaceExports;

});

parcelRegister("jFOY1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
class $e52961ade961520f$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $e52961ade961520f$var$LRUMap;

});

parcelRegister("48AmV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $30341ed51c34bbe7$var$escapeStringForRegex(regexString) {
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
module.exports.escapeStringForRegex = $30341ed51c34bbe7$var$escapeStringForRegex;

});

parcelRegister("01r7k", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cUgOr = parcelRequire("cUgOr");

var $cqs9v = parcelRequire("cqs9v");
const $00452108504bca55$var$WINDOW = $cqs9v.GLOBAL_OBJ;
const $00452108504bca55$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $00452108504bca55$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $00452108504bca55$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $00452108504bca55$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $00452108504bca55$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($00452108504bca55$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $cUgOr.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $00452108504bca55$var$getLocationHref() {
    try {
        return $00452108504bca55$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $00452108504bca55$var$getComponentName(elem, maxTraverseHeight = 5) {
    if (!$00452108504bca55$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $00452108504bca55$var$getComponentName;
module.exports.getLocationHref = $00452108504bca55$var$getLocationHref;
module.exports.htmlTreeAsString = $00452108504bca55$var$htmlTreeAsString;

});


parcelRegister("iWMq1", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $hrBlh = parcelRequire("hrBlh");
function isNodeEnv() {
    return !(0, $hrBlh.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("hrBlh", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $cb31ecaf7a8a70ed$export$2928c40372e623c0; });
function $cb31ecaf7a8a70ed$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $cb31ecaf7a8a70ed$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


parcelRegister("hJFhm", function(module, exports) {
module.exports = $parcel$import("9OUCt").then(()=>parcelRequire('1Cg2t'));

});

var $ff5db0bcdf6d4ae1$exports = {};
$parcel$extendImportMap({
    "9OUCt": "rapidoc-min.1cc45d44.js"
});

var $be7ebd92b118fa32$exports = {};
!function(n) {
    "use strict";
    function e(n, e, r) {
        return r.a = n, r.f = e, r;
    }
    function F2(n) {
        return e(2, n, function(e) {
            return function(r) {
                return n(e, r);
            };
        });
    }
    function F3(n) {
        return e(3, n, function(e) {
            return function(r) {
                return function(t) {
                    return n(e, r, t);
                };
            };
        });
    }
    function F4(n) {
        return e(4, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return n(e, r, t, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return e(5, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return n(e, r, t, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return e(6, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(e, r, t, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return e(7, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return n(e, r, t, u, a, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return e(8, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(e, r, t, u, a, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return e(9, n, function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return n(e, r, t, u, a, i, c, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, e, r) {
        return 2 === n.a ? n.f(e, r) : n(e)(r);
    }
    function A3(n, e, r, t) {
        return 3 === n.a ? n.f(e, r, t) : n(e)(r)(t);
    }
    function A4(n, e, r, t, u) {
        return 4 === n.a ? n.f(e, r, t, u) : n(e)(r)(t)(u);
    }
    function A5(n, e, r, t, u, a) {
        return 5 === n.a ? n.f(e, r, t, u, a) : n(e)(r)(t)(u)(a);
    }
    function A6(n, e, r, t, u, a, i) {
        return 6 === n.a ? n.f(e, r, t, u, a, i) : n(e)(r)(t)(u)(a)(i);
    }
    function A7(n, e, r, t, u, a, i, c) {
        return 7 === n.a ? n.f(e, r, t, u, a, i, c) : n(e)(r)(t)(u)(a)(i)(c);
    }
    var r = F3(function(n, e, r) {
        for(var t = Array(n), u = 0; n > u; u++)t[u] = r(e + u);
        return t;
    }), t = F2(function(n, e) {
        for(var r = Array(n), t = 0; n > t && e.b; t++)r[t] = e.a, e = e.b;
        return r.length = t, v(r, e);
    }), u = F2(function(n, e) {
        return e[n];
    }), a = F3(function(n, e, r) {
        for(var t = r.length, u = 0; t > u; u++)e = A2(n, r[u], e);
        return e;
    }), i = F3(function(n, e, r) {
        for(var t = r.length - 1; t >= 0; t--)e = A2(n, r[t], e);
        return e;
    }), c = F2(function(n, e) {
        for(var r = e.length, t = Array(r), u = 0; r > u; u++)t[u] = n(e[u]);
        return t;
    }), o = F3(function(n, e, r) {
        for(var t = r.length, u = Array(t), a = 0; t > a; a++)u[a] = A2(n, e + a, r[a]);
        return u;
    });
    function f(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function s(n, e) {
        for(var r, t = [], u = l(n, e, 0, t); u && (r = t.pop()); u = l(r.a, r.b, 0, t));
        return u;
    }
    function l(n, e, r, t) {
        if (n === e) return !0;
        if ("object" != typeof n || null === n || null === e) return "function" == typeof n && f(5), !1;
        if (r > 100) return t.push(v(n, e)), !0;
        for(var u in 0 > n.$ && (n = Kr(n), e = Kr(e)), n)if (!l(n[u], e[u], r + 1, t)) return !1;
        return !0;
    }
    var d = F2(s), b = F2(function(n, e) {
        return !s(n, e);
    });
    function m(n, e, r) {
        if ("object" != typeof n) return n === e ? 0 : e > n ? -1 : 1;
        if (void 0 === n.$) return (r = m(n.a, e.a)) || (r = m(n.b, e.b)) ? r : m(n.c, e.c);
        for(; n.b && e.b && !(r = m(n.a, e.a)); n = n.b, e = e.b);
        return r || (n.b ? 1 : e.b ? -1 : 0);
    }
    var p = F2(function(n, e) {
        var r = m(n, e);
        return 0 > r ? Vr : r ? Wr : Gr;
    });
    function v(n, e) {
        return {
            a: n,
            b: e
        };
    }
    function g(n, e, r) {
        return {
            a: n,
            b: e,
            c: r
        };
    }
    function h(n) {
        return n;
    }
    function $(n, e) {
        var r = {};
        for(var t in n)r[t] = n[t];
        for(var t in e)r[t] = e[t];
        return r;
    }
    var x = F2(k);
    function k(n, e) {
        if ("string" == typeof n) return n + e;
        if (!n.b) return e;
        var r = y(n.a, e);
        n = n.b;
        for(var t = r; n.b; n = n.b)t = t.b = y(n.a, e);
        return r;
    }
    var w = {
        $: 0
    };
    function y(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }
    var j = F2(y);
    function E(n) {
        for(var e = w, r = n.length; r--;)e = y(n[r], e);
        return e;
    }
    function A(n) {
        for(var e = []; n.b; n = n.b)e.push(n.a);
        return e;
    }
    var C = F3(function(n, e, r) {
        for(var t = []; e.b && r.b; e = e.b, r = r.b)t.push(A2(n, e.a, r.a));
        return E(t);
    }), P = F4(function(n, e, r, t) {
        for(var u = []; e.b && r.b && t.b; e = e.b, r = r.b, t = t.b)u.push(A3(n, e.a, r.a, t.a));
        return E(u);
    }), T = F2(function(n, e) {
        return E(A(e).sort(function(e, r) {
            return m(n(e), n(r));
        }));
    }), S = F2(function(n, e) {
        return E(A(e).sort(function(e, r) {
            var t = A2(n, e, r);
            return t === Gr ? 0 : t === Vr ? -1 : 1;
        }));
    }), I = F2(function(n, e) {
        return n + e;
    }), O = F2(function(n, e) {
        return n * e;
    }), q = F2(Math.pow), L = F2(function(n, e) {
        var r = e % n;
        return 0 === n ? f(11) : r > 0 && 0 > n || 0 > r && n > 0 ? r + n : r;
    }), M = Math.ceil, _ = Math.floor, R = Math.round, H = Math.log, U = isNaN, z = F2(function(n, e) {
        return n + e;
    }), D = F2(function(n, e) {
        return n + e;
    }), N = F2(function(n, e) {
        for(var r = [], t = e.length, u = 0; t > u;){
            var a = e[u], i = e.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += e[u], u++), n(h(a)) && r.push(a);
        }
        return r.join("");
    }), F = F3(function(n, e, r) {
        for(var t = r.length, u = 0; t > u;){
            var a = r[u], i = r.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += r[u], u++), e = A2(n, h(a), e);
        }
        return e;
    }), K = F3(function(n, e, r) {
        for(var t = r.length; t--;){
            var u = r[t], a = r.charCodeAt(t);
            56320 > a || a > 57343 || (u = r[--t] + u), e = A2(n, h(u), e);
        }
        return e;
    }), G = F2(function(n, e) {
        return e.split(n);
    }), W = F2(function(n, e) {
        return e.join(n);
    }), V = F3(function(n, e, r) {
        return r.slice(n, e);
    }), J = F2(function(n, e) {
        for(var r = e.length; r--;){
            var t = e[r], u = e.charCodeAt(r);
            if (56320 > u || u > 57343 || (t = e[--r] + t), !n(h(t))) return !1;
        }
        return !0;
    }), B = F2(function(n, e) {
        return e.indexOf(n) > -1;
    }), X = F2(function(n, e) {
        return 0 === e.indexOf(n);
    }), Q = F2(function(n, e) {
        return e.length >= n.length && e.lastIndexOf(n) === e.length - n.length;
    }), Z = F2(function(n, e) {
        var r = n.length;
        if (1 > r) return w;
        for(var t = 0, u = []; (t = e.indexOf(n, t)) > -1;)u.push(t), t += r;
        return E(u);
    });
    function Y(n) {
        return n + "";
    }
    function nn(n) {
        return {
            $: 2,
            b: n
        };
    }
    var en = nn(function(n) {
        return "number" != typeof n ? $n("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Zr(n) : !isFinite(n) || n % 1 ? $n("an INT", n) : Zr(n);
    }), rn = nn(function(n) {
        return "boolean" == typeof n ? Zr(n) : $n("a BOOL", n);
    }), tn = nn(function(n) {
        return "number" == typeof n ? Zr(n) : $n("a FLOAT", n);
    }), un = nn(function(n) {
        return Zr(n);
    }), an = nn(function(n) {
        return "string" == typeof n ? Zr(n) : n instanceof String ? Zr(n + "") : $n("a STRING", n);
    }), cn = F2(function(n, e) {
        return {
            $: 6,
            d: n,
            b: e
        };
    });
    function on(n, e) {
        return {
            $: 9,
            f: n,
            g: e
        };
    }
    var fn = F2(function(n, e) {
        return {
            $: 10,
            b: e,
            h: n
        };
    }), sn = F2(function(n, e) {
        return on(n, [
            e
        ]);
    }), ln = F3(function(n, e, r) {
        return on(n, [
            e,
            r
        ]);
    }), dn = F4(function(n, e, r, t) {
        return on(n, [
            e,
            r,
            t
        ]);
    }), bn = F2(function(n, e) {
        try {
            return pn(n, JSON.parse(e));
        } catch (n) {
            return Jr(A2(Br, "This is not valid JSON! " + n.message, e));
        }
    }), mn = F2(function(n, e) {
        return pn(n, e);
    });
    function pn(n, e) {
        switch(n.$){
            case 2:
                return n.b(e);
            case 5:
                return null === e ? Zr(n.c) : $n("null", e);
            case 3:
                return gn(e) ? vn(n.b, e, E) : $n("a LIST", e);
            case 4:
                return gn(e) ? vn(n.b, e, hn) : $n("an ARRAY", e);
            case 6:
                var r = n.d;
                if ("object" != typeof e || null === e || !(r in e)) return $n("an OBJECT with a field named `" + r + "`", e);
                var t = pn(n.b, e[r]);
                return Xt(t) ? t : Jr(A2(Xr, r, t.a));
            case 7:
                var u = n.e;
                return gn(e) ? e.length > u ? (t = pn(n.b, e[u]), Xt(t) ? t : Jr(A2(Qr, u, t.a))) : $n("a LONGER array. Need index " + u + " but only see " + e.length + " entries", e) : $n("an ARRAY", e);
            case 8:
                if ("object" != typeof e || null === e || gn(e)) return $n("an OBJECT", e);
                var a = w;
                for(var i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
                    if (t = pn(n.b, e[i]), !Xt(t)) return Jr(A2(Xr, i, t.a));
                    a = y(v(i, t.a), a);
                }
                return Zr(xt(a));
            case 9:
                for(var c = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (t = pn(o[f], e), !Xt(t)) return t;
                    c = c(t.a);
                }
                return Zr(c);
            case 10:
                return t = pn(n.b, e), Xt(t) ? pn(n.h(t.a), e) : t;
            case 11:
                for(var s = w, l = n.g; l.b; l = l.b){
                    if (t = pn(l.a, e), Xt(t)) return t;
                    s = y(t.a, s);
                }
                return Jr(Yr(xt(s)));
            case 1:
                return Jr(A2(Br, n.a, e));
            case 0:
                return Zr(n.a);
        }
    }
    function vn(n, e, r) {
        for(var t = e.length, u = Array(t), a = 0; t > a; a++){
            var i = pn(n, e[a]);
            if (!Xt(i)) return Jr(A2(Qr, a, i.a));
            u[a] = i.a;
        }
        return Zr(r(u));
    }
    function gn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function hn(n) {
        return A2(Bt, n.length, function(e) {
            return n[e];
        });
    }
    function $n(n, e) {
        return Jr(A2(Br, "Expecting " + n, e));
    }
    function xn(n, e) {
        if (n === e) return !0;
        if (n.$ !== e.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === e.a;
            case 2:
                return n.b === e.b;
            case 5:
                return n.c === e.c;
            case 3:
            case 4:
            case 8:
                return xn(n.b, e.b);
            case 6:
                return n.d === e.d && xn(n.b, e.b);
            case 7:
                return n.e === e.e && xn(n.b, e.b);
            case 9:
                return n.f === e.f && kn(n.g, e.g);
            case 10:
                return n.h === e.h && xn(n.b, e.b);
            case 11:
                return kn(n.g, e.g);
        }
    }
    function kn(n, e) {
        var r = n.length;
        if (r !== e.length) return !1;
        for(var t = 0; r > t; t++)if (!xn(n[t], e[t])) return !1;
        return !0;
    }
    var wn = F2(function(n, e) {
        return JSON.stringify(e, null, n) + "";
    });
    function yn(n) {
        return n;
    }
    function jn(n) {
        return n;
    }
    var En = F3(function(n, e, r) {
        return "toJSON" === n && "function" == typeof e || (r[n] = e), r;
    });
    function An(n) {
        return F2(function(e, r) {
            return r.push(n(e)), r;
        });
    }
    function Cn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Pn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Tn = F2(function(n, e) {
        return {
            $: 3,
            b: n,
            d: e
        };
    }), Sn = F2(function(n, e) {
        return {
            $: 4,
            b: n,
            d: e
        };
    }), In = 0;
    function On(n) {
        var e = {
            $: 0,
            e: In++,
            f: n,
            g: null,
            h: []
        };
        return Hn(e), e;
    }
    function qn(n) {
        return Pn(function(e) {
            e(Cn(On(n)));
        });
    }
    function Ln(n, e) {
        n.h.push(e), Hn(n);
    }
    var Mn = F2(function(n, e) {
        return Pn(function(r) {
            Ln(n, e), r(Cn(0));
        });
    }), _n = !1, Rn = [];
    function Hn(n) {
        if (Rn.push(n), !_n) {
            for(_n = !0; n = Rn.shift();)Un(n);
            _n = !1;
        }
    }
    function Un(n) {
        for(; n.f;){
            var e = n.f.$;
            if (0 === e || 1 === e) {
                for(; n.g && n.g.$ !== e;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === e) return void (n.f.c = n.f.b(function(e) {
                    n.f = e, Hn(n);
                }));
                if (5 === e) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === e ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function zn(n) {
        return Pn(function(e) {
            var r = setTimeout(function() {
                e(Cn(0));
            }, n);
            return function() {
                clearTimeout(r);
            };
        });
    }
    var Dn = {};
    function Nn(n, e, r, t, u) {
        return {
            b: n,
            c: e,
            d: r,
            e: t,
            f: u
        };
    }
    function Fn(n, e) {
        var r = {
            g: e,
            h: void 0
        }, t = n.c, u = n.d, a = n.e, i = n.f;
        function c(n) {
            return A2(Tn, c, {
                $: 5,
                b: function(e) {
                    var c = e.a;
                    return 0 === e.$ ? A3(u, r, c, n) : a && i ? A4(t, r, c.i, c.j, n) : A3(t, r, a ? c.i : c.j, n);
                }
            });
        }
        return r.h = On(A2(Tn, c, n.b));
    }
    var Kn = F2(function(n, e) {
        return Pn(function(r) {
            n.g(e), r(Cn(0));
        });
    }), Gn = F2(function(n, e) {
        return A2(Mn, n.h, {
            $: 0,
            a: e
        });
    });
    function Wn(n) {
        return function(e) {
            return {
                $: 1,
                k: n,
                l: e
            };
        };
    }
    function Vn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Jn = F2(function(n, e) {
        return {
            $: 3,
            n: n,
            o: e
        };
    }), Bn = [], Xn = !1;
    function Qn(n, e, r) {
        if (Bn.push({
            p: n,
            q: e,
            r: r
        }), !Xn) {
            Xn = !0;
            for(var t; t = Bn.shift();)Zn(t.p, t.q, t.r);
            Xn = !1;
        }
    }
    function Zn(n, e, r) {
        var t = {};
        for(var u in Yn(!0, e, t, null), Yn(!1, r, t, null), n)Ln(n[u], {
            $: "fx",
            a: t[u] || {
                i: w,
                j: w
            }
        });
    }
    function Yn(n, e, r, t) {
        switch(e.$){
            case 1:
                var u = e.k, a = function(n, e, r, t) {
                    function u(n) {
                        for(var e = r; e; e = e.t)n = e.s(n);
                        return n;
                    }
                    return A2(n ? Dn[e].e : Dn[e].f, u, t);
                }(n, u, t, e.l);
                return void (r[u] = function(n, e, r) {
                    return r = r || {
                        i: w,
                        j: w
                    }, n ? r.i = y(e, r.i) : r.j = y(e, r.j), r;
                }(n, a, r[u]));
            case 2:
                for(var i = e.m; i.b; i = i.b)Yn(n, i.a, r, t);
                return;
            case 3:
                return void Yn(n, e.o, r, {
                    s: e.n,
                    t: t
                });
        }
    }
    function ne(n) {
        Dn[n] && f(3);
    }
    function ee(n, e) {
        return ne(n), Dn[n] = {
            e: re,
            u: e,
            a: te
        }, Wn(n);
    }
    var re = F2(function(n, e) {
        return e;
    });
    function te(n) {
        var e = [], r = Dn[n].u, t = zn(0);
        return Dn[n].b = t, Dn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = e, i = jn(r(u.a)), c = 0; a.length > c; c++)a[c](i);
            return t;
        }), {
            subscribe: function(n) {
                e.push(n);
            },
            unsubscribe: function(n) {
                var r = (e = e.slice()).indexOf(n);
                0 > r || e.splice(r, 1);
            }
        };
    }
    var ue, ae = F2(function(n, e) {
        return function(r) {
            return n(e(r));
        };
    });
    var ie = "undefined" != typeof document ? document : {};
    function ce(n, e) {
        n.appendChild(e);
    }
    function oe(n) {
        return {
            $: 0,
            a: n
        };
    }
    var fe = F2(function(n, e) {
        return F2(function(r, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: e,
                d: Ce(r),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), se = F2(function(n, e) {
        return F2(function(r, t) {
            for(var u = [], a = 0; t.b; t = t.b){
                var i = t.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: e,
                d: Ce(r),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), le = F2(function(n, e) {
        return {
            $: 4,
            j: n,
            k: e,
            b: 1 + (e.b || 0)
        };
    });
    var de = F4(function(n, e, r, t) {
        return {
            $: 5,
            l: [
                n,
                e,
                r,
                t
            ],
            m: function() {
                return A3(n, e, r, t);
            },
            k: void 0
        };
    }), be = F2(function(n, e) {
        return {
            $: "a0",
            n: n,
            o: e
        };
    }), me = F2(function(n, e) {
        return {
            $: "a1",
            n: n,
            o: e
        };
    }), pe = F2(function(n, e) {
        return {
            $: "a2",
            n: n,
            o: e
        };
    }), ve = F2(function(n, e) {
        return {
            $: "a3",
            n: n,
            o: e
        };
    }), ge = /^script$/i, he = /^(on|formAction$)/i, $e = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, xe = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function ke(n) {
        return ge.test(n) ? "p" : n;
    }
    function we(n) {
        return xe.test(n) ? "" : n;
    }
    var ye, je = F2(function(n, e) {
        return "a0" === e.$ ? A2(be, e.n, function(n, e) {
            var r = eu(e);
            return {
                $: e.$,
                a: r ? A3(Yt, 3 > r ? Ee : Ae, nu(n), e.a) : A2(Zt, n, e.a)
            };
        }(n, e.o)) : e;
    }), Ee = F2(function(n, e) {
        return v(n(e.a), e.b);
    }), Ae = F2(function(n, e) {
        return {
            ef: n(e.ef),
            hc: e.hc,
            g_: e.g_
        };
    });
    function Ce(n) {
        for(var e = {}; n.b; n = n.b){
            var r = n.a, t = r.$, u = r.n, a = r.o;
            if ("a2" !== t) {
                var i = e[t] || (e[t] = {});
                "a3" === t && "class" === u ? Pe(i, u, a) : i[u] = a;
            } else "className" === u ? Pe(e, u, jn(a)) : e[u] = jn(a);
        }
        return e;
    }
    function Pe(n, e, r) {
        var t = n[e];
        n[e] = t ? t + " " + r : r;
    }
    function Te(n, e) {
        var r = n.$;
        if (5 === r) return Te(n.k || (n.k = n.m()), e);
        if (0 === r) return ie.createTextNode(n.a);
        if (4 === r) {
            for(var t = n.k, u = n.j; 4 === t.$;)"object" != typeof u ? u = [
                u,
                t.j
            ] : u.push(t.j), t = t.k;
            var a = {
                j: u,
                p: e
            };
            return (i = Te(t, a)).elm_event_node_ref = a, i;
        }
        if (3 === r) return Se(i = n.h(n.g), e, n.d), i;
        var i = n.f ? ie.createElementNS(n.f, n.c) : ie.createElement(n.c);
        ue && "a" == n.c && i.addEventListener("click", ue(i)), Se(i, e, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)ce(i, Te(1 === r ? c[o] : c[o].b, e));
        return i;
    }
    function Se(n, e, r) {
        for(var t in r){
            var u = r[t];
            "a1" === t ? Ie(n, u) : "a0" === t ? Le(n, e, u) : "a3" === t ? Oe(n, u) : "a4" === t ? qe(n, u) : ("value" !== t && "checked" !== t || n[t] !== u) && (n[t] = u);
        }
    }
    function Ie(n, e) {
        var r = n.style;
        for(var t in e)r[t] = e[t];
    }
    function Oe(n, e) {
        for(var r in e){
            var t = e[r];
            void 0 !== t ? n.setAttribute(r, t) : n.removeAttribute(r);
        }
    }
    function qe(n, e) {
        for(var r in e){
            var t = e[r], u = t.f, a = t.o;
            void 0 !== a ? n.setAttributeNS(u, r, a) : n.removeAttributeNS(u, r);
        }
    }
    function Le(n, e, r) {
        var t = n.elmFs || (n.elmFs = {});
        for(var u in r){
            var a = r[u], i = t[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Me(e, a), n.addEventListener(u, i, ye && {
                    passive: 2 > eu(a)
                }), t[u] = i;
            } else n.removeEventListener(u, i), t[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                ye = !0;
            }
        }));
    } catch (n) {}
    function Me(n, e) {
        function r(e) {
            var t = r.q, u = pn(t.a, e);
            if (Xt(u)) {
                for(var a, i = eu(t), c = u.a, o = i ? 3 > i ? c.a : c.ef : c, f = 1 == i ? c.b : 3 == i && c.hc, s = (f && e.stopPropagation(), (2 == i ? c.b : 3 == i && c.g_) && e.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var l = a.length; l--;)o = a[l](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return r.q = e, r;
    }
    function _e(n, e) {
        return n.$ == e.$ && xn(n.a, e.a);
    }
    function Re(n, e, r, t) {
        var u = {
            $: e,
            r: r,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function He(n, e, r, t) {
        if (n !== e) {
            var u = n.$, a = e.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Re(r, 0, t, e);
                e = function(n) {
                    for(var e = n.e, r = e.length, t = Array(r), u = 0; r > u; u++)t[u] = e[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(e), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, c = e.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (e.k = n.k);
                    e.k = e.m();
                    var s = [];
                    return He(n.k, e.k, s, 0), void (s.length > 0 && Re(r, 1, t, s));
                case 4:
                    for(var l = n.j, d = e.j, b = !1, m = n.k; 4 === m.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        m.j
                    ] : l.push(m.j), m = m.k;
                    for(var p = e.k; 4 === p.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        p.j
                    ] : d.push(p.j), p = p.k;
                    return b && l.length !== d.length ? void Re(r, 0, t, e) : ((b ? function(n, e) {
                        for(var r = 0; n.length > r; r++)if (n[r] !== e[r]) return !1;
                        return !0;
                    }(l, d) : l === d) || Re(r, 2, t, d), void He(m, p, r, t + 1));
                case 0:
                    return void (n.a !== e.a && Re(r, 3, t, e.a));
                case 1:
                    return void Ue(n, e, r, t, De);
                case 2:
                    return void Ue(n, e, r, t, Ne);
                case 3:
                    if (n.h !== e.h) return void Re(r, 0, t, e);
                    var v = ze(n.d, e.d);
                    v && Re(r, 4, t, v);
                    var g = e.i(n.g, e.g);
                    return void (g && Re(r, 5, t, g));
            }
        }
    }
    function Ue(n, e, r, t, u) {
        if (n.c === e.c && n.f === e.f) {
            var a = ze(n.d, e.d);
            a && Re(r, 4, t, a), u(n, e, r, t);
        } else Re(r, 0, t, e);
    }
    function ze(n, e, r) {
        var t;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in e) {
                var a = n[u], i = e[u];
                a === i && "value" !== u && "checked" !== u || "a0" === r && _e(a, i) || ((t = t || {})[u] = i);
            } else (t = t || {})[u] = r ? "a1" === r ? "" : "a0" === r || "a3" === r ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var c = ze(n[u], e[u] || {}, u);
            c && ((t = t || {})[u] = c);
        }
        for(var o in e)o in n || ((t = t || {})[o] = e[o]);
        return t;
    }
    function De(n, e, r, t) {
        var u = n.e, a = e.e, i = u.length, c = a.length;
        i > c ? Re(r, 6, t, {
            v: c,
            i: i - c
        }) : c > i && Re(r, 7, t, {
            v: i,
            e: a
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = u[f];
            He(s, a[f], r, ++t), t += s.b || 0;
        }
    }
    function Ne(n, e, r, t) {
        for(var u = [], a = {}, i = [], c = n.e, o = e.e, f = c.length, s = o.length, l = 0, d = 0, b = t; f > l && s > d;){
            var m = (A = c[l]).a, p = (C = o[d]).a, v = A.b, g = C.b, h = void 0, $ = void 0;
            if (m !== p) {
                var x = c[l + 1], k = o[d + 1];
                if (x) {
                    var w = x.a, y = x.b;
                    $ = p === w;
                }
                if (k) {
                    var j = k.a, E = k.b;
                    h = m === j;
                }
                if (h && $) He(v, E, u, ++b), Ke(a, u, m, g, d, i), b += v.b || 0, Ge(a, u, m, y, ++b), b += y.b || 0, l += 2, d += 2;
                else if (h) b++, Ke(a, u, p, g, d, i), He(v, E, u, b), b += v.b || 0, l += 1, d += 2;
                else if ($) Ge(a, u, m, v, ++b), b += v.b || 0, He(y, g, u, ++b), b += y.b || 0, l += 2, d += 1;
                else {
                    if (!x || w !== j) break;
                    Ge(a, u, m, v, ++b), Ke(a, u, p, g, d, i), b += v.b || 0, He(y, E, u, ++b), b += y.b || 0, l += 2, d += 2;
                }
            } else He(v, g, u, ++b), b += v.b || 0, l++, d++;
        }
        for(; f > l;){
            var A;
            b++, Ge(a, u, (A = c[l]).a, v = A.b, b), b += v.b || 0, l++;
        }
        for(; s > d;){
            var C, P = P || [];
            Ke(a, u, (C = o[d]).a, C.b, void 0, P), d++;
        }
        (u.length > 0 || i.length > 0 || P) && Re(r, 8, t, {
            w: u,
            x: i,
            y: P
        });
    }
    var Fe = "_elmW6BL";
    function Ke(n, e, r, t, u, a) {
        var i = n[r];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: t,
                r: u,
                s: void 0
            }
        }), void (n[r] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var c = [];
            return He(i.z, t, c, i.r), i.r = u, void (i.s.s = {
                w: c,
                A: i
            });
        }
        Ke(n, e, r + Fe, t, u, a);
    }
    function Ge(n, e, r, t, u) {
        var a = n[r];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return He(t, a.z, i, u), void Re(e, 9, u, {
                    w: i,
                    A: a
                });
            }
            Ge(n, e, r + Fe, t, u);
        } else {
            var c = Re(e, 9, u, void 0);
            n[r] = {
                c: 1,
                z: t,
                r: u,
                s: c
            };
        }
    }
    function We(n, e, r, t) {
        Ve(n, e, r, 0, 0, e.b, t);
    }
    function Ve(n, e, r, t, u, a, i) {
        for(var c = r[t], o = c.r; o === u;){
            var f = c.$;
            if (1 === f) We(n, e.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && Ve(n, e, s, 0, u, a, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, l = c.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Ve(n, e, s, 0, u, a, i));
            } else c.t = n, c.u = i;
            if (!(c = r[++t]) || (o = c.r) > a) return t;
        }
        var d = e.$;
        if (4 === d) {
            for(var b = e.k; 4 === b.$;)b = b.k;
            return Ve(n, b, r, t, u + 1, a, n.elm_event_node_ref);
        }
        for(var m = e.e, p = n.childNodes, v = 0; m.length > v; v++){
            u++;
            var g = 1 === d ? m[v] : m[v].b, h = u + (g.b || 0);
            if (!(u > o || o > h || (c = r[t = Ve(p[v], g, r, t, u, h, i)]) && (o = c.r) <= a)) return t;
            u = h;
        }
        return t;
    }
    function Je(n, e) {
        for(var r = 0; e.length > r; r++){
            var t = e[r], u = t.t, a = Be(u, t);
            u === n && (n = a);
        }
        return n;
    }
    function Be(n, e) {
        switch(e.$){
            case 0:
                return function(n, e, r) {
                    var t = n.parentNode, u = Te(e, r);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), t && u !== n && t.replaceChild(u, n), u;
                }(n, e.s, e.u);
            case 4:
                return Se(n, e.u, e.s), n;
            case 3:
                return n.replaceData(0, n.length, e.s), n;
            case 1:
                return Je(n, e.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = e.s : n.elm_event_node_ref = {
                    j: e.s,
                    p: e.u
                }, n;
            case 6:
                for(var r = e.s, t = 0; r.i > t; t++)n.removeChild(n.childNodes[r.v]);
                return n;
            case 7:
                for(var u = (r = e.s).e, a = n.childNodes[t = r.v]; u.length > t; t++)n.insertBefore(Te(u[t], e.u), a);
                return n;
            case 9:
                if (!(r = e.s)) return n.parentNode.removeChild(n), n;
                var i = r.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Je(n, r.w), n;
            case 8:
                return function(n, e) {
                    var r = e.s, t = function(n, e) {
                        if (n) {
                            for(var r = ie.createDocumentFragment(), t = 0; n.length > t; t++){
                                var u = n[t].A;
                                ce(r, 2 === u.c ? u.s : Te(u.z, e.u));
                            }
                            return r;
                        }
                    }(r.y, e);
                    n = Je(n, r.w);
                    for(var u = r.x, a = 0; u.length > a; a++){
                        var i = u[a], c = i.A, o = 2 === c.c ? c.s : Te(c.z, e.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return t && ce(n, t), n;
                }(n, e);
            case 5:
                return e.s(n);
            default:
                f(10);
        }
    }
    function Xe(n) {
        if (3 === n.nodeType) return oe(n.textContent);
        if (1 !== n.nodeType) return oe("");
        for(var e = w, r = n.attributes, t = r.length; t--;){
            var u = r[t];
            e = y(A2(ve, u.name, u.value), e);
        }
        var a = n.tagName.toLowerCase(), i = w, c = n.childNodes;
        for(t = c.length; t--;)i = y(Xe(c[t]), i);
        return A3(fe, a, e, i);
    }
    var Qe = F4(function(n, e, r, t) {
        return function(n, e, r, t, u, a) {
            var i = A2(mn, n, e ? e.flags : void 0);
            Xt(i) || f(2);
            var c = {}, o = r(i.a), s = o.a, l = a(b, s), d = function(n, e) {
                var r;
                for(var t in Dn){
                    var u = Dn[t];
                    u.a && ((r = r || {})[t] = u.a(t, e)), n[t] = Fn(u, e);
                }
                return r;
            }(c, b);
            function b(n, e) {
                var r = A2(t, n, s);
                l(s = r.a, e), Qn(c, r.b, u(s));
            }
            return Qn(c, o.b, u(s)), d ? {
                ports: d
            } : {};
        }(e, t, n.mn, n.pd, n.oK, function(e, r) {
            var t = n.g9 && n.g9(e), u = n.pI, a = ie.title, i = ie.body, c = Xe(i);
            return function(n, e) {
                e(n);
                var r = 0;
                function t() {
                    r = 1 === r ? 0 : (Ze(t), e(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (e(n), 2 === r && (r = 1)) : (0 === r && Ze(t), r = 2);
                };
            }(r, function(n) {
                ue = t;
                var r = u(n), o = fe("body")(w)(r.kK), f = function(n, e) {
                    var r = [];
                    return He(n, e, r, 0), r;
                }(c, o);
                i = function(n, e, r, t) {
                    return 0 === r.length ? n : (We(n, e, r, t), Je(n, r));
                }(i, c, f, e), c = o, ue = 0, a !== r.eC && (ie.title = a = r.eC);
            });
        });
    }), Ze = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Ye() {
        return hu(ie.location.href).a || f(1);
    }
    var nr = F2(function(n, e) {
        return A2(Ou, $u, Pn(function() {
            history.pushState({}, "", e), n();
        }));
    }), er = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, rr = "undefined" != typeof document ? document : er, tr = "undefined" != typeof window ? window : er, ur = F3(function(n, e, r) {
        return qn(Pn(function() {
            function t(n) {
                On(r(n));
            }
            return n.addEventListener(e, t, ye && {
                passive: !0
            }), function() {
                n.removeEventListener(e, t);
            };
        }));
    }), ar = F2(function(n, e) {
        var r = pn(n, e);
        return Xt(r) ? Rr(r.a) : Hr;
    });
    var ir = F2(function(n, e) {
        return function(n, e) {
            return Pn(function(r) {
                Ze(function() {
                    var t = document.getElementById(n);
                    r(t ? Cn(e(t)) : {
                        $: 1,
                        a: tu(n)
                    });
                });
            });
        }(e, function(e) {
            return e[n](), 0;
        });
    }), cr = F3(function(n, e, r) {
        return Pn(function(t) {
            function u(n) {
                t(e(r.lQ.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Vu);
            }), a.addEventListener("timeout", function() {
                u(Xu);
            }), a.addEventListener("load", function() {
                u(function(n, e) {
                    return A2(e.status >= 200 && 300 > e.status ? Wu : Ku, function(n) {
                        return {
                            a6: n.responseURL,
                            j0: n.status,
                            oE: n.statusText,
                            l8: or(n.getAllResponseHeaders())
                        };
                    }(e), n(e.response));
                }(r.lQ.b, a));
            }), Yu(r.o8) && function(n, e, r) {
                e.upload.addEventListener("progress", function(t) {
                    e.c || On(A2(na, n, v(r, Bu({
                        ou: t.loaded,
                        oA: t.total
                    }))));
                }), e.addEventListener("progress", function(t) {
                    e.c || On(A2(na, n, v(r, Ju({
                        nW: t.loaded,
                        oA: t.lengthComputable ? Rr(t.total) : Hr
                    }))));
                });
            }(n, a, r.o8.a);
            try {
                a.open(r.mZ, r.a6, !0);
            } catch (n) {
                return u(Gu(r.a6));
            }
            return function(n, e) {
                for(var r = e.l8; r.b; r = r.b)n.setRequestHeader(r.a.a, r.a.b);
                n.timeout = e.oU.a || 0, n.responseType = e.lQ.d, n.withCredentials = e.kx;
            }(a, r), r.kK.a && a.setRequestHeader("Content-Type", r.kK.a), a.send(r.kK.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function or(n) {
        if (!n) return Zu;
        for(var e = Zu, r = n.split("\r\n"), t = r.length; t--;){
            var u = r[t], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), c = u.substring(a + 2);
                e = A3(ma, i, function(n) {
                    return Rr(Yu(n) ? c + ", " + n.a : c);
                }, e);
            }
        }
        return e;
    }
    var fr, sr = F3(function(n, e, r) {
        return {
            $: 0,
            d: n,
            b: e,
            a: r
        };
    }), lr = F2(function(n, e) {
        return {
            $: 0,
            d: e.d,
            b: e.b,
            a: function(r) {
                return n(e.a(r));
            }
        };
    }), dr = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), br = F2(function(n, e) {
        return Pn(function() {
            var r = setInterval(function() {
                On(e);
            }, n);
            return function() {
                clearInterval(r);
            };
        });
    }), mr = F2(function(n, e) {
        var r = "g";
        n.m4 && (r += "m"), n.kO && (r += "i");
        try {
            return Rr(RegExp(e, r));
        } catch (n) {
            return Hr;
        }
    }), pr = F2(function(n, e) {
        return null !== e.match(n);
    }), vr = F3(function(n, e, r) {
        for(var t, u = [], a = 0, i = r, c = e.lastIndex, o = -1; a++ < n && (t = e.exec(i)) && o != e.lastIndex;){
            for(var f = t.length - 1, s = Array(f); f > 0;){
                var l = t[f];
                s[--f] = l ? Rr(l) : Hr;
            }
            u.push(A4(As, t[0], t.index, a, E(s))), o = e.lastIndex;
        }
        return e.lastIndex = c, E(u);
    }), gr = F4(function(n, e, r, t) {
        var u = 0;
        return t.replace(e, function(e) {
            if (u++ >= n) return e;
            for(var t = arguments.length - 3, a = Array(t); t > 0;){
                var i = arguments[t];
                a[--t] = i ? Rr(i) : Hr;
            }
            return r(A4(As, e, arguments[arguments.length - 2], u, E(a)));
        });
    }), hr = F3(function(n, e, r) {
        for(var t = r, u = [], a = e.lastIndex, i = e.lastIndex; n--;){
            var c = e.exec(t);
            if (!c) break;
            u.push(t.slice(a, c.index)), a = e.lastIndex;
        }
        return u.push(t.slice(a)), e.lastIndex = i, E(u);
    }), $r = 1 / 0, xr = F5(function(n, e, r, t, u) {
        for(var a = n.length, i = u.length >= e + a, c = 0; i && a > c;){
            var o = u.charCodeAt(e);
            i = n[c++] === u[e++] && (10 === o ? (r++, t = 1) : (t++, 55296 == (63488 & o) ? n[c++] === u[e++] : 1));
        }
        return g(i ? e : -1, r, t);
    }), kr = F3(function(n, e, r) {
        return r.length > e ? 55296 == (63488 & r.charCodeAt(e)) ? n(r.substr(e, 2)) ? e + 2 : -1 : n(r[e]) ? "\n" === r[e] ? -2 : e + 1 : -1 : -1;
    }), wr = F5(function(n, e, r, t, u) {
        for(var a = u.indexOf(n, e), i = 0 > a ? u.length : a + n.length; i > e;){
            var c = u.charCodeAt(e++);
            10 === c ? (t = 1, r++) : (t++, 55296 == (63488 & c) && e++);
        }
        return g(a, r, t);
    });
    nn(function(n) {
        return "undefined" != typeof File && n instanceof File ? Zr(n) : $n("a FILE", n);
    });
    var yr = F3(function(n, e, r) {
        return Pn(function() {
            var t = new Blob([
                r
            ], {
                type: e
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(t, n);
            else {
                var u = fr || (fr = document.createElement("a")), a = URL.createObjectURL(t);
                u.href = a, u.download = n, function(n) {
                    if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
                    else {
                        var e = document.createEvent("MouseEvents");
                        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(e), document.body.removeChild(n);
                    }
                }(u), URL.revokeObjectURL(a);
            }
        });
    });
    function jr(n) {
        return n.byteLength;
    }
    var Er = F3(function(n, e, r) {
        return n.setInt8(e, r), e + 1;
    }), Ar = F4(function(n, e, r, t) {
        return n.setInt16(e, r, t), e + 2;
    }), Cr = F4(function(n, e, r, t) {
        return n.setInt32(e, r, t), e + 4;
    }), Pr = F3(function(n, e, r) {
        return n.setUint8(e, r), e + 1;
    }), Tr = F4(function(n, e, r, t) {
        return n.setUint16(e, r, t), e + 2;
    }), Sr = F4(function(n, e, r, t) {
        return n.setUint32(e, r, t), e + 4;
    }), Ir = F4(function(n, e, r, t) {
        return n.setFloat32(e, r, t), e + 4;
    }), Or = F4(function(n, e, r, t) {
        return n.setFloat64(e, r, t), e + 8;
    }), qr = F3(function(n, e, r) {
        for(var t = 0, u = r.byteLength, a = u - 4; a >= t; t += 4)n.setUint32(e + t, r.getUint32(t));
        for(; u > t; t++)n.setUint8(e + t, r.getUint8(t));
        return e + u;
    }), Lr = F3(function(n, e, r) {
        for(var t = 0; r.length > t; t++){
            var u = r.charCodeAt(t);
            e += 128 > u ? (n.setUint8(e, u), 1) : 2048 > u ? (n.setUint16(e, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(e, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(e + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + r.charCodeAt(++t) - 56320 + 65536, n.setUint32(e, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return e;
    }), Mr = F2(function(n, e) {
        try {
            return Rr(A2(n, e, 0).b);
        } catch (n) {
            return Hr;
        }
    }), _r = F3(function(n, e, r) {
        for(var t = "", u = r + n; u > r;){
            var a = e.getUint8(r++);
            t += 128 > a ? String.fromCharCode(a) : 192 == (224 & a) ? String.fromCharCode((31 & a) << 6 | 63 & e.getUint8(r++)) : 224 == (240 & a) ? String.fromCharCode((15 & a) << 12 | (63 & e.getUint8(r++)) << 6 | 63 & e.getUint8(r++)) : (a = ((7 & a) << 18 | (63 & e.getUint8(r++)) << 12 | (63 & e.getUint8(r++)) << 6 | 63 & e.getUint8(r++)) - 65536, String.fromCharCode(Math.floor(a / 1024) + 55296, a % 1024 + 56320));
        }
        return v(r, t);
    }), Rr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hr = {
        $: 1
    }, Ur = j, zr = i, Dr = F3(function(n, e, r) {
        var t = r.c, u = r.d, a = F2(function(e, r) {
            return A3(zr, e.$ ? n : a, r, e.a);
        });
        return A3(zr, a, A3(zr, n, e, u), t);
    }), Nr = function(n) {
        return A3(Dr, Ur, w, n);
    }, Fr = F3(function(n, e, r) {
        for(;;){
            if (-2 === r.$) return e;
            var t = r.d, u = n, a = A3(n, r.b, r.c, A3(Fr, n, e, r.e));
            n = u, e = a, r = t;
        }
    }), Kr = function(n) {
        return A3(Fr, F3(function(n, e, r) {
            return A2(Ur, v(n, e), r);
        }), w, n);
    }, Gr = 1, Wr = 2, Vr = 0, Jr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Br = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), Xr = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Qr = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Zr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nt = I, et = J, rt = x, tt = wn, ut = Y, at = F2(function(n, e) {
        return A2(W, n, A(e));
    }), it = F2(function(n, e) {
        return E(A2(G, n, e));
    }), ct = function(n) {
        return A2(at, "\n    ", A2(it, "\n", n));
    }, ot = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return e;
            var t = r.b, u = n, a = A2(n, r.a, e);
            n = u, e = a, r = t;
        }
    }), ft = function(n) {
        return A3(ot, F2(function(n, e) {
            return e + 1;
        }), 0, n);
    }, st = C, lt = F3(function(n, e, r) {
        for(;;){
            if (m(n, e) >= 1) return r;
            var t = n, u = e - 1, a = A2(Ur, e, r);
            n = t, e = u, r = a;
        }
    }), dt = F2(function(n, e) {
        return A3(lt, n, e, w);
    }), bt = F2(function(n, e) {
        return A3(st, n, A2(dt, 0, ft(e) - 1), e);
    }), mt = function(n) {
        var e = n.charCodeAt(0);
        return 55296 > e || e > 56319 ? e : 1024 * (e - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, pt = function(n) {
        var e = mt(n);
        return e >= 97 && 122 >= e;
    }, vt = function(n) {
        var e = mt(n);
        return 90 >= e && e >= 65;
    }, gt = function(n) {
        return pt(n) || vt(n);
    }, ht = function(n) {
        var e = mt(n);
        return 57 >= e && e >= 48;
    }, $t = function(n) {
        return pt(n) || vt(n) || ht(n);
    }, xt = function(n) {
        return A3(ot, Ur, w, n);
    }, kt = function(n) {
        var e = n.charCodeAt(0);
        return isNaN(e) ? Hr : Rr(55296 > e || e > 56319 ? v(n[0], n.slice(1)) : v(n[0] + n[1], n.slice(2)));
    }, wt = F2(function(n, e) {
        return "\n\n(" + ut(n + 1) + ") " + ct(yt(e));
    }), yt = function(n) {
        return A2(jt, n, w);
    }, jt = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                var r = n.a, t = n.b, u = function() {
                    var n = kt(r);
                    if (1 === n.$) return !1;
                    var e = n.a, t = e.b;
                    return gt(e.a) && A2(et, $t, t);
                }();
                n = t, e = A2(Ur, u ? "." + r : "['" + r + "']", e);
                continue n;
            case 1:
                t = n.b;
                var a = "[" + ut(n.a) + "]";
                n = t, e = A2(Ur, a, e);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var c = function() {
                            return e.b ? "The Json.Decode.oneOf at json" + A2(at, "", xt(e)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + ut(ft(i)) + " ways:";
                        return A2(at, "\n\n", A2(Ur, c, A2(bt, wt, i)));
                    }
                    n = t = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return e.b ? " at json" + A2(at, "", xt(e)) : "!";
                }();
            default:
                var o = n.a, f = n.b;
                return (c = function() {
                    return e.b ? "Problem with the value at json" + A2(at, "", xt(e)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (ct(A2(tt, 4, f)) + "\n\n") + o;
        }
    }), Et = 32, At = F4(function(n, e, r, t) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), Ct = [], Pt = M, Tt = F2(function(n, e) {
        return H(e) / H(n);
    }), St = function(n) {
        return n;
    }, It = Pt(A2(Tt, 2, Et)), Ot = A4(At, 0, It, Ct, Ct), qt = r, Lt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mt = F2(function(n, e) {
        return n(e);
    }), _t = F2(function(n, e) {
        return e(n);
    }), Rt = d, Ht = _, Ut = function(n) {
        return n.length;
    }, zt = F2(function(n, e) {
        return m(n, e) > 0 ? n : e;
    }), Dt = O, Nt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ft = t, Kt = F2(function(n, e) {
        for(;;){
            var r = A2(Ft, Et, n), t = r.b, u = A2(Ur, Nt(r.a), e);
            if (!t.b) return xt(u);
            n = t, e = u;
        }
    }), Gt = function(n) {
        return n.a;
    }, Wt = F2(function(n, e) {
        for(;;){
            var r = Pt(e / Et);
            if (1 === r) return A2(Ft, Et, n).a;
            n = A2(Kt, n, w), e = r;
        }
    }), Vt = F2(function(n, e) {
        if (e.N) {
            var r = e.N * Et, t = Ht(A2(Tt, Et, r - 1)), u = n ? xt(e.V) : e.V, a = A2(Wt, u, e.N);
            return A4(At, Ut(e.R) + r, A2(zt, 5, t * It), a, e.R);
        }
        return A4(At, Ut(e.R), It, Ct, e.R);
    }), Jt = F5(function(n, e, r, t, u) {
        for(;;){
            if (0 > e) return A2(Vt, !1, {
                V: t,
                N: r / Et | 0,
                R: u
            });
            var a = Lt(A3(qt, Et, e, n));
            e -= Et, t = A2(Ur, a, t);
        }
    }), Bt = F2(function(n, e) {
        if (n > 0) {
            var r = n % Et;
            return A5(Jt, e, n - r - Et, n, w, A3(qt, r, n - r, e));
        }
        return Ot;
    }), Xt = function(n) {
        return !n.$;
    }, Qt = fn, Zt = sn, Yt = ln, nu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eu = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, ru = function(n) {
        return n;
    }, tu = ru, uu = F6(function(n, e, r, t, u, a) {
        return {
            iz: a,
            iJ: e,
            jf: t,
            nK: r,
            nQ: n,
            g1: u
        };
    }), au = B, iu = function(n) {
        return n.length;
    }, cu = V, ou = F2(function(n, e) {
        return 1 > n ? e : A3(cu, n, iu(e), e);
    }), fu = Z, su = function(n) {
        return "" === n;
    }, lu = F2(function(n, e) {
        return 1 > n ? "" : A3(cu, 0, n, e);
    }), du = function(n) {
        for(var e = 0, r = n.charCodeAt(0), t = 43 == r || 45 == r ? 1 : 0, u = t; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Hr;
            e = 10 * e + a - 48;
        }
        return u == t ? Hr : Rr(45 == r ? -e : e);
    }, bu = F5(function(n, e, r, t, u) {
        if (su(u) || A2(au, "@", u)) return Hr;
        var a = A2(fu, ":", u);
        if (a.b) {
            if (a.b.b) return Hr;
            var i = a.a, c = du(A2(ou, i + 1, u));
            if (1 === c.$) return Hr;
            var o = c;
            return Rr(A6(uu, n, A2(lu, i, u), o, e, r, t));
        }
        return Rr(A6(uu, n, u, Hr, e, r, t));
    }), mu = F4(function(n, e, r, t) {
        if (su(t)) return Hr;
        var u = A2(fu, "/", t);
        if (u.b) {
            var a = u.a;
            return A5(bu, n, A2(ou, a, t), e, r, A2(lu, a, t));
        }
        return A5(bu, n, "/", e, r, t);
    }), pu = F3(function(n, e, r) {
        if (su(r)) return Hr;
        var t = A2(fu, "?", r);
        if (t.b) {
            var u = t.a;
            return A4(mu, n, Rr(A2(ou, u + 1, r)), e, A2(lu, u, r));
        }
        return A4(mu, n, Hr, e, r);
    }), vu = F2(function(n, e) {
        if (su(e)) return Hr;
        var r = A2(fu, "#", e);
        if (r.b) {
            var t = r.a;
            return A3(pu, n, Rr(A2(ou, t + 1, e)), A2(lu, t, e));
        }
        return A3(pu, n, Hr, e);
    }), gu = X, hu = function(n) {
        return A2(gu, "http://", n) ? A2(vu, 0, A2(ou, 7, n)) : A2(gu, "https://", n) ? A2(vu, 1, A2(ou, 8, n)) : Hr;
    }, $u = function() {
        for(;;);
    }, xu = Cn, ku = xu(0), wu = F4(function(n, e, r, t) {
        if (t.b) {
            var u = t.a, a = t.b;
            if (a.b) {
                var i = a.a, c = a.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, f.a, r > 500 ? A3(ot, n, e, xt(s)) : A4(wu, n, e, r + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, e)));
                }
                return A2(n, u, A2(n, i, e));
            }
            return A2(n, u, e);
        }
        return e;
    }), yu = F3(function(n, e, r) {
        return A4(wu, n, e, 0, r);
    }), ju = F2(function(n, e) {
        return A3(yu, F2(function(e, r) {
            return A2(Ur, n(e), r);
        }), w, e);
    }), Eu = Tn, Au = F2(function(n, e) {
        return A2(Eu, function(e) {
            return xu(n(e));
        }, e);
    }), Cu = F3(function(n, e, r) {
        return A2(Eu, function(e) {
            return A2(Eu, function(r) {
                return xu(A2(n, e, r));
            }, r);
        }, e);
    }), Pu = function(n) {
        return A3(yu, Cu(Ur), xu(w), n);
    }, Tu = Kn, Su = F2(function(n, e) {
        var r = e;
        return qn(A2(Eu, Tu(n), r));
    });
    Dn.Task = Nn(ku, F3(function(n, e) {
        return A2(Au, function() {
            return 0;
        }, Pu(A2(ju, Su(n), e)));
    }), F3(function() {
        return xu(0);
    }), F2(function(n, e) {
        return A2(Au, n, e);
    }));
    var Iu = Wn("Task"), Ou = F2(function(n, e) {
        return Iu(A2(Au, n, e));
    }), qu = rn, Lu = cn, Mu = {
        $: 1
    }, _u = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Ru = null, Hu = ee("appStarted", function() {
        return Ru;
    }), Uu = Vn, zu = {
        $: 0
    }, Du = {
        bR: zu,
        cV: zu,
        fc: zu,
        d4: zu,
        d5: zu,
        d6: zu,
        d7: zu,
        el: zu,
        em: zu,
        en: zu,
        W: zu,
        ex: zu,
        ey: zu,
        ez: zu,
        eA: zu,
        af: zu,
        eQ: zu,
        eR: zu,
        eS: zu
    }, Nu = F3(function(n, e, r) {
        return {
            $: 11,
            a: n,
            b: e,
            c: r
        };
    }), Fu = F3(function(n, e, r) {
        return e(n(r));
    }), Ku = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), Gu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wu = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Vu = {
        $: 2
    }, Ju = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Bu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xu = {
        $: 1
    }, Qu = {
        $: -2
    }, Zu = Qu, Yu = function(n) {
        return !n.$;
    }, na = Gn, ea = p, ra = F2(function(n, e) {
        n: for(;;){
            if (-2 === e.$) return Hr;
            var r = e.c, t = e.d, u = e.e;
            switch(A2(ea, n, e.b)){
                case 0:
                    e = t;
                    continue n;
                case 1:
                    return Rr(r);
                default:
                    e = u;
                    continue n;
            }
        }
    }), ta = F5(function(n, e, r, t, u) {
        return {
            $: -1,
            a: n,
            b: e,
            c: r,
            d: t,
            e: u
        };
    }), ua = F5(function(n, e, r, t, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(ta, n, e, r, t, u);
            var a = t.d;
            return i = t.e, A5(ta, 0, t.b, t.c, A5(ta, 1, a.b, a.c, a.d, a.e), A5(ta, 1, e, r, i, u));
        }
        var i, c = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== t.$ || t.a ? A5(ta, n, c, o, A5(ta, 0, e, r, t, f), s) : A5(ta, 0, e, r, A5(ta, 1, t.b, t.c, t.d, i = t.e), A5(ta, 1, c, o, f, s));
    }), aa = F3(function(n, e, r) {
        if (-2 === r.$) return A5(ta, 0, n, e, Qu, Qu);
        var t = r.a, u = r.b, a = r.c, i = r.d, c = r.e;
        switch(A2(ea, n, u)){
            case 0:
                return A5(ua, t, u, a, A3(aa, n, e, i), c);
            case 1:
                return A5(ta, t, u, e, i, c);
            default:
                return A5(ua, t, u, a, i, A3(aa, n, e, c));
        }
    }), ia = F3(function(n, e, r) {
        var t = A3(aa, n, e, r);
        return -1 !== t.$ || t.a ? t : A5(ta, 1, t.b, t.c, t.d, t.e);
    }), ca = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var e = n.d, r = n.e;
                return i = r.b, c = r.c, t = r.d, s = r.e, A5(ta, 1, n.b, n.c, A5(ta, 0, e.b, e.c, e.d, e.e), A5(ta, 0, i, c, t, s));
            }
            var t, u = n.d, a = n.e, i = a.b, c = a.c, o = (t = a.d).d, f = t.e, s = a.e;
            return A5(ta, 0, t.b, t.c, A5(ta, 1, n.b, n.c, A5(ta, 0, u.b, u.c, u.d, u.e), o), A5(ta, 1, i, c, f, s));
        }
        return n;
    }, oa = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var e = n.d, r = n.e;
                return f = r.b, s = r.c, l = r.d, d = r.e, A5(ta, 1, t = n.b, u = n.c, A5(ta, 0, e.b, e.c, e.d, c = e.e), A5(ta, 0, f, s, l, d));
            }
            var t = n.b, u = n.c, a = n.d, i = a.d, c = a.e, o = n.e, f = o.b, s = o.c, l = o.d, d = o.e;
            return A5(ta, 0, a.b, a.c, A5(ta, 1, i.b, i.c, i.d, i.e), A5(ta, 1, t, u, c, A5(ta, 0, f, s, l, d)));
        }
        return n;
    }, fa = F7(function(n, e, r, t, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return oa(e);
                        break n;
                    }
                    return oa(e);
                }
                break n;
            }
            return e;
        }
        return A5(ta, r, a.b, a.c, a.d, A5(ta, 0, t, u, a.e, i));
    }), sa = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var e = n.a, r = n.b, t = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var c = ca(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(ua, c.a, c.b, c.c, sa(c.d), o);
                    }
                    return Qu;
                }
                return A5(ta, e, r, t, sa(u), i);
            }
            return A5(ta, e, r, t, sa(u), i);
        }
        return Qu;
    }, la = F2(function(n, e) {
        if (-2 === e.$) return Qu;
        var r = e.a, t = e.b, u = e.c, a = e.d, i = e.e;
        if (0 > m(n, t)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var o = ca(e);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(ua, o.a, o.b, o.c, A2(la, n, o.d), f);
                    }
                    return Qu;
                }
                return A5(ta, r, t, u, A2(la, n, a), i);
            }
            return A5(ta, r, t, u, A2(la, n, a), i);
        }
        return A2(da, n, A7(fa, n, e, r, t, u, a, i));
    }), da = F2(function(n, e) {
        if (-1 === e.$) {
            var r = e.a, t = e.b, u = e.c, a = e.d, i = e.e;
            if (s(n, t)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === c.$ ? A5(ua, r, c.b, c.c, a, sa(i)) : Qu;
            }
            return A5(ua, r, t, u, a, A2(la, n, i));
        }
        return Qu;
    }), ba = F2(function(n, e) {
        var r = A2(la, n, e);
        return -1 !== r.$ || r.a ? r : A5(ta, 1, r.b, r.c, r.d, r.e);
    }), ma = F3(function(n, e, r) {
        var t = e(A2(ra, n, r));
        return t.$ ? A2(ba, n, r) : A3(ia, n, t.a, r);
    }), pa = F2(function(n, e) {
        return A3(sr, "", ru, A2(Fu, e, n));
    }), va = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ga = {
        $: 2
    }, ha = {
        $: 1
    }, $a = F2(function(n, e) {
        return e.$ ? Jr(n(e.a)) : Zr(e.a);
    }), xa = F2(function(n, e) {
        switch(e.$){
            case 0:
                return Jr({
                    $: 0,
                    a: e.a
                });
            case 1:
                return Jr(ha);
            case 2:
                return Jr(ga);
            case 3:
                return Jr(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(e.a.j0));
            default:
                return A2($a, va, n(e.b));
        }
    }), ka = function(n) {
        return A2(pa, n, xa(Zr));
    }, wa = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ya = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ja = function(n) {
        return 1 === n.$ ? wa(n.a) : ya(n.a);
    }, Ea = {
        $: 0
    }, Aa = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ca = F2(function(n, e) {
        return {
            jC: n,
            j3: e
        };
    }), Pa = xu(A2(Ca, Zu, w)), Ta = function(n) {
        return Pn(function(e) {
            var r = n.f;
            2 === r.$ && r.c && r.c(), n.f = null, e(Cn(0));
        });
    }, Sa = qn, Ia = F3(function(n, e, r) {
        n: for(;;){
            if (e.b) {
                var t = e.a, u = e.b;
                if (t.$) {
                    var a = t.a;
                    return A2(Eu, function(e) {
                        var t = a.o8;
                        return A3(Ia, n, u, 1 === t.$ ? r : A3(ia, t.a, e, r));
                    }, Sa(A3(cr, n, Tu(n), a)));
                }
                var i = t.a, c = A2(ra, i, r);
                if (1 === c.$) {
                    e = u;
                    continue n;
                }
                return A2(Eu, function() {
                    return A3(Ia, n, u, A2(ba, i, r));
                }, Ta(c.a));
            }
            return xu(r);
        }
    }), Oa = F4(function(n, e, r, t) {
        return A2(Eu, function(n) {
            return xu(A2(Ca, n, r));
        }, A3(Ia, n, e, t.jC));
    }), qa = F3(function(n, e, r) {
        var t = n(e);
        return t.$ ? r : A2(Ur, t.a, r);
    }), La = F2(function(n, e) {
        return A3(yu, qa(n), w, e);
    }), Ma = F4(function(n, e, r, t) {
        var u = t.b;
        return s(e, t.a) ? Rr(A2(Tu, n, u(r))) : Hr;
    }), _a = F3(function(n, e, r) {
        return A2(Eu, function() {
            return xu(r);
        }, Pu(A2(La, A3(Ma, n, e.a, e.b), r.j3)));
    }), Ra = F2(function(n, e) {
        if (e.$) {
            var r = e.a;
            return Aa({
                kx: r.kx,
                kK: r.kK,
                lQ: A2(lr, n, r.lQ),
                l8: r.l8,
                mZ: r.mZ,
                oU: r.oU,
                o8: r.o8,
                a6: r.a6
            });
        }
        return {
            $: 0,
            a: e.a
        };
    }), Ha = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    });
    Dn.Http = Nn(Pa, Oa, _a, Ra, F2(function(n, e) {
        return A2(Ha, e.a, A2(Fu, e.b, n));
    }));
    var Ua = Wn("Http"), za = (Wn("Http"), function(n) {
        return Ua(Aa({
            kx: !1,
            kK: n.kK,
            lQ: n.lQ,
            l8: n.l8,
            mZ: n.mZ,
            oU: n.oU,
            o8: n.o8,
            a6: n.a6
        }));
    }), Da = function(n) {
        return za({
            kK: Ea,
            lQ: n.lQ,
            l8: w,
            mZ: "GET",
            oU: Hr,
            o8: Hr,
            a6: n.a6
        });
    }, Na = {
        $: 1
    }, Fa = F2(function(n, e) {
        switch(e.$){
            case 3:
                return ya(n(e.a));
            case 1:
                return Na;
            case 0:
                return zu;
            default:
                return wa(e.a);
        }
    }), Ka = ru, Ga = F2(function(n, e) {
        return Da({
            lQ: ka(A2(Fu, ja, A2(Fu, Fa(Ka), e))),
            a6: n
        });
    }), Wa = ee("loadJeDonneMonAvis", function() {
        return Ru;
    }), Va = F2(function(n, e) {
        return {
            gx: n,
            fN: e
        };
    }), Ja = Yt(_t), Ba = F3(function(n, e, r) {
        return A2(Ja, A2(Lu, n, e), r);
    }), Xa = Yt(_t), Qa = F2(function(n, e) {
        return e.$ ? Hr : n(e.a);
    }), Za = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Ya = function(n) {
        return {
            $: 11,
            g: n
        };
    }, ni = mn, ei = un, ri = F2(function(n, e) {
        return A2(Qt, function(r) {
            return A2(ni, A2(Lu, n, ei), r).$ ? nu(Hr) : A2(Zt, Rr, A2(Lu, n, e));
        }, ei);
    }), ti = F2(function(n, e) {
        return A2(Zt, Qa(ru), A2(ri, n, function(n) {
            return Ya(E([
                Za(Hr),
                A2(Zt, Rr, n)
            ]));
        }(e)));
    }), ui = F2(function(n, e) {
        return Xa(A2(ti, n, e));
    }), ai = an, ii = A3(ui, "tag", ai, A3(Ba, "hash", ai, nu(Va))), ci = bn, oi = F2(function(n, e) {
        return A2(pa, n, xa(function(n) {
            return A2($a, yt, A2(ci, e, n));
        }));
    }), fi = function(n) {
        return Ua(Aa({
            kx: !0,
            kK: n.kK,
            lQ: n.lQ,
            l8: n.l8,
            mZ: n.mZ,
            oU: n.oU,
            o8: n.o8,
            a6: n.a6
        }));
    }, si = function(n) {
        return n.dr ? fi : za;
    }, li = F6(function(n, e, r, t, u, a) {
        return A2(si, e, {
            kK: a,
            lQ: A2(oi, A2(Fu, ja, t), u),
            l8: e.l8,
            mZ: n,
            oU: e.oU,
            o8: e.o8,
            a6: r
        });
    }), di = F4(function(n, e, r, t) {
        return A6(li, "GET", n, e, r, t, Ea);
    }), bi = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), mi = bi, pi = {
        l8: E([
            A2(mi, "Accept", "application/json")
        ]),
        dr: !1,
        oU: Hr,
        o8: Hr
    }, vi = di($(pi, {
        l8: A2(Ur, A2(mi, "Cache-Control", "no-store, must-revalidate, no-cache, max-age=0"), pi.l8)
    })), gi = function(n) {
        return A3(vi, "version.json", n, ii);
    }, hi = {
        e$: 0,
        bn: w
    }, $i = F3(function(n, e, r) {
        var t;
        return v({
            by: Du,
            bc: !1,
            c7: n,
            ch: !1,
            m6: r,
            H: Mu,
            bo: hi,
            a6: e
        }, Uu(E([
            Hu(0),
            gi(_u),
            (t = {
                c7: n,
                m6: r,
                a6: e
            }, Uu(A2(ju, function(n) {
                return A2(Ga, n.a, A2(Nu, t, n.b));
            }, E([
                v("/data/countries.json", F2(function(n, e) {
                    return $(e, {
                        bR: n
                    });
                })),
                v("/data/impacts.json", F2(function(n, e) {
                    return $(e, {
                        cV: n
                    });
                })),
                v("/data/food2/components.json", F2(function(n, e) {
                    return $(e, {
                        fc: n
                    });
                })),
                v("/data/food2/categories.json", F2(function(n, e) {
                    return $(e, {
                        d5: n
                    });
                })),
                v("/data/food2/examples.json", F2(function(n, e) {
                    return $(e, {
                        d4: n
                    });
                })),
                v("/data/food/ingredients.json", F2(function(n, e) {
                    return $(e, {
                        d6: n
                    });
                })),
                v("/data/food/examples.json", F2(function(n, e) {
                    return $(e, {
                        d7: n
                    });
                })),
                v("/data/object/categories.json", F2(function(n, e) {
                    return $(e, {
                        en: n
                    });
                })),
                v("/data/object/components.json", F2(function(n, e) {
                    return $(e, {
                        el: n
                    });
                })),
                v("/data/object/examples.json", F2(function(n, e) {
                    return $(e, {
                        em: n
                    });
                })),
                v("/data/processes.json", F2(function(n, e) {
                    return $(e, {
                        W: n
                    });
                })),
                v("/data/textile/components.json", F2(function(n, e) {
                    return $(e, {
                        ex: n
                    });
                })),
                v("/data/textile/examples.json", F2(function(n, e) {
                    return $(e, {
                        ez: n
                    });
                })),
                v("/data/textile/materials.json", F2(function(n, e) {
                    return $(e, {
                        ey: n
                    });
                })),
                v("/data/textile/products.json", F2(function(n, e) {
                    return $(e, {
                        eA: n
                    });
                })),
                v("/data/transports.json", F2(function(n, e) {
                    return $(e, {
                        af: n
                    });
                })),
                v("/data/veli/categories.json", F2(function(n, e) {
                    return $(e, {
                        eS: n
                    });
                })),
                v("/data/veli/components.json", F2(function(n, e) {
                    return $(e, {
                        eQ: n
                    });
                })),
                v("/data/veli/examples.json", F2(function(n, e) {
                    return $(e, {
                        eR: n
                    });
                }))
            ])))),
            Wa(0)
        ])));
    }), xi = en, ki = {
        $: 3
    }, wi = function(n) {
        return {
            $: 7,
            a: n
        };
    }, yi = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ji = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ei = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Ai = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Ci = {
        $: 17
    }, Pi = Vn, Ti = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Si = F3(function(n, e, r) {
        return s(r, n) ? nu(e) : Ti(ut(r));
    }), Ii = F2(function(n, e) {
        return A2(Qt, A2(Si, n, e), A2(Lu, "keyCode", xi));
    }), Oi = function(n) {
        return A2(Ii, 27, n);
    }, qi = Jn, Li = Pi(w), Mi = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), _i = F2(function(n, e) {
        return {
            jj: e,
            j3: n
        };
    }), Ri = xu(A2(_i, w, Zu)), Hi = function(n) {
        return v(k(n.a ? "w_" : "d_", n.b), n);
    }, Ui = function(n) {
        return A3(ot, F2(function(n, e) {
            return A3(ia, n.a, n.b, e);
        }), Zu, n);
    }, zi = F3(function(n, e, r) {
        for(;;){
            if (-2 === r.$) return e;
            var t = r.e, u = n, a = A3(n, r.b, r.c, A3(zi, n, e, r.d));
            n = u, e = a, r = t;
        }
    }), Di = F6(function(n, e, r, t, u, a) {
        var i = A3(zi, F3(function(t, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var o = i.a, f = o.a, s = o.b, l = i.b;
                    if (0 > m(f, t)) {
                        a = v(l, A3(n, f, s, c));
                        continue n;
                    }
                    return m(f, t) > 0 ? v(i, A3(r, t, u, c)) : v(l, A4(e, f, s, u, c));
                }
                return v(i, A3(r, t, u, c));
            }
        }), v(Kr(t), a), u), c = i.a, o = i.b;
        return A3(ot, F2(function(e, r) {
            return A3(n, e.a, e.b, r);
        }), o, c);
    }), Ni = F2(function(n, e) {
        return {
            d1: e,
            fh: n
        };
    }), Fi = F3(function(n, e, r) {
        return A2(Au, function(n) {
            return v(e, n);
        }, A3(ur, r.a ? tr : rr, r.b, function(r) {
            return A2(na, n, A2(Ni, e, r));
        }));
    }), Ki = F2(function(n, e) {
        return A3(zi, ia, e, n);
    });
    Dn["Browser.Events"] = Nn(Ri, F3(function(n, e, r) {
        var t = F3(function(e, r, t) {
            var u = t.c;
            return g(t.a, t.b, A2(Ur, A3(Fi, n, e, r), u));
        }), u = F3(function(n, e, r) {
            var t = r.b, u = r.c;
            return g(A2(Ur, e, r.a), t, u);
        }), a = F4(function(n, e, r, t) {
            var u = t.c;
            return g(t.a, A3(ia, n, e, t.b), u);
        }), i = A2(ju, Hi, e), c = A6(Di, u, a, t, r.jj, Ui(i), g(w, Zu, w)), o = c.b, f = c.c;
        return A2(Eu, function(n) {
            return xu(A2(_i, i, A2(Ki, o, Ui(n))));
        }, A2(Eu, function() {
            return Pu(f);
        }, Pu(A2(ju, Ta, c.a))));
    }), F3(function(n, e, r) {
        var t = e.fh, u = e.d1, a = A2(La, function(n) {
            var e = n.b.c;
            return s(n.a, t) ? A2(ar, e, u) : Hr;
        }, r.j3);
        return A2(Eu, function() {
            return xu(r);
        }, Pu(A2(ju, Tu(n), a)));
    }), 0, F2(function(n, e) {
        return A3(Mi, e.a, e.b, A2(Zt, n, e.c));
    }));
    var Gi, Wi = Wn("Browser.Events"), Vi = F3(function(n, e, r) {
        return Wi(A3(Mi, n, e, r));
    }), Ji = A2(Vi, 0, "keydown"), Bi = F2(function(n) {
        return n;
    }), Xi = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Qi = F2(function(n, e) {
        return {
            W: e,
            j5: n
        };
    }), Zi = xu(A2(Qi, Zu, Zu)), Yi = F2(function(n, e) {
        var r = n.a, t = n.b, u = A2(ra, r, e);
        return A3(ia, r, 1 === u.$ ? E([
            t
        ]) : A2(Ur, t, u.a), e);
    }), nc = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), ec = br, rc = F3(function(n, e, r) {
        if (e.b) {
            var t = e.a, u = e.b, a = Sa(A2(ec, t, A2(na, n, t)));
            return A2(Eu, function(e) {
                return A3(rc, n, u, A3(ia, t, e, r));
            }, a);
        }
        return xu(r);
    }), tc = F3(function(n, e, r) {
        var t = r.W, u = F3(function(n, e, r) {
            var t = r.c;
            return g(r.a, r.b, A2(Eu, function() {
                return t;
            }, Ta(e)));
        }), a = A3(ot, Yi, Zu, e), i = A6(Di, F3(function(n, e, r) {
            var t = r.b, u = r.c;
            return g(A2(Ur, n, r.a), t, u);
        }), F4(function(n, e, r, t) {
            var u = t.c;
            return g(t.a, A3(ia, n, r, t.b), u);
        }), u, a, t, g(w, Zu, xu(0))), c = i.a, o = i.b;
        return A2(Eu, function(n) {
            return xu(A2(Qi, a, n));
        }, A2(Eu, function() {
            return A3(rc, n, c, o);
        }, i.c));
    }), uc = ru, ac = (Gi = uc, Pn(function(n) {
        n(Cn(Gi(Date.now())));
    })), ic = F3(function(n, e, r) {
        var t = A2(ra, e, r.j5);
        if (1 === t.$) return xu(r);
        var u = t.a;
        return A2(Eu, function() {
            return xu(r);
        }, A2(Eu, function(e) {
            return Pu(A2(ju, function(r) {
                return A2(Tu, n, r(e));
            }, u));
        }, ac));
    }), cc = F3(function(n, e, r) {
        return n(e(r));
    });
    Dn.Time = Nn(Zi, tc, ic, 0, F2(function(n, e) {
        return A2(Xi, e.a, A2(cc, n, e.b));
    }));
    var oc, fc, sc, lc, dc, bc = Wn("Time"), mc = F2(function(n, e) {
        return bc(A2(Xi, n, e));
    }), pc = function(n) {
        return A2(Fu, Bi, mc(1e3 * n));
    }, vc = (oc = "storeChanged", fc = ai, ne(oc), Dn[oc] = {
        f: ae,
        u: fc,
        a: function(n, e) {
            var r = w, t = Dn[n].u, u = Cn(null);
            return Dn[n].b = u, Dn[n].c = F3(function(n, e) {
                return r = e, u;
            }), {
                send: function(n) {
                    var u = A2(mn, t, n);
                    Xt(u) || f(4);
                    for(var a = u.a, i = r; i.b; i = i.b)e(i.a(a));
                }
            };
        }
    }, Wn(oc)), gc = {
        $: 0
    }, hc = function(n) {
        n: for(;;)switch(n.$){
            case 0:
            case 4:
            case 6:
            case 7:
                if (n.b.$) break n;
                return !0;
            default:
                if (n.a.$) break n;
                return !0;
        }
        return !1;
    }, $c = function(n) {
        return hc(n.az) ? Ji(Oi(gc)) : Li;
    }, xc = {
        $: 5
    }, kc = function(n) {
        return {
            $: 32,
            a: n
        };
    }, wc = function(n) {
        return 5 === n.ad.$ ? Li : Ji(Oi(kc(xc)));
    }, yc = function(n) {
        return {
            $: 37,
            a: n
        };
    }, jc = F2(function(n, e) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    n -= 1, e = e.b;
                    continue n;
                }
                return e;
            }
            return e;
        }
    }), Ec = function(n) {
        var e = n.M;
        return e.b ? Ji(Oi(yc(A2(jc, 1, e)))) : Li;
    }, Ac = {
        $: 5
    }, Cc = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Pc = function(n) {
        return 5 === n.ad.$ ? Li : Ji(Oi(Cc(Ac)));
    }, Tc = Uu(w), Sc = b, Ic = yn, Oc = ee("saveStore", Ic), qc = yn, Lc = F2(function(n, e) {
        return e.$ ? Hr : Rr(n(e.a));
    }), Mc = function(n) {
        return A3(ot, F2(function(n, e) {
            return A3(En, n.a, n.b, e);
        }), {}, n);
    }, _c = F2(function(n, e) {
        return e.$ ? n : e.a;
    }), Rc = yn, Hc = function(n) {
        return A2(at, "", n);
    }, Uc = L, zc = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Dc = F3(function(n, e, r) {
        n: for(;;){
            if (n > 0) {
                if (e.b) {
                    var t = e.a;
                    n -= 1, e = e.b, r = A2(Ur, t, r);
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Nc = F2(function(n, e) {
        return xt(A3(Dc, n, e, w));
    }), Fc = F3(function(n, e, r) {
        if (e > 0) {
            var t = v(e, r);
            n: for(;;){
                e: for(;;){
                    if (!t.b.b) return r;
                    if (!t.b.b.b) {
                        if (1 === t.a) break n;
                        break e;
                    }
                    switch(t.a){
                        case 1:
                            break n;
                        case 2:
                            var u = t.b;
                            return E([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (t.b.b.b.b) {
                                var a = t.b, i = a.b;
                                return E([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break e;
                        default:
                            if (t.b.b.b.b && t.b.b.b.b.b) {
                                var c = t.b, o = c.b, f = o.b, s = f.b, l = s.b;
                                return A2(Ur, c.a, A2(Ur, o.a, A2(Ur, f.a, A2(Ur, s.a, n > 1e3 ? A2(Nc, e - 4, l) : A3(Fc, n + 1, e - 4, l)))));
                            }
                            break e;
                    }
                }
                return r;
            }
            return E([
                t.b.a
            ]);
        }
        return w;
    }), Kc = F2(function(n, e) {
        return A3(Fc, 0, n, e);
    }), Gc = function(n) {
        return Hc(A2(Kc, 3, A2(it, "", n)));
    }, Wc = F3(function(n, e, r) {
        var t = function() {
            switch(n){
                case 0:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "January";
                            case 1:
                                return "February";
                            case 2:
                                return "March";
                            case 3:
                                return "April";
                            case 4:
                                return "May";
                            case 5:
                                return "June";
                            case 6:
                                return "July";
                            case 7:
                                return "August";
                            case 8:
                                return "September";
                            case 9:
                                return "October";
                            case 10:
                                return "November";
                            default:
                                return "December";
                        }
                    }(r);
                case 1:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Janvier";
                            case 1:
                                return "F\xe9vrier";
                            case 2:
                                return "Mars";
                            case 3:
                                return "Avril";
                            case 4:
                                return "Mai";
                            case 5:
                                return "Juin";
                            case 6:
                                return "Juillet";
                            case 7:
                                return "Aout";
                            case 8:
                                return "Septembre";
                            case 9:
                                return "Octobre";
                            case 10:
                                return "Novembre";
                            default:
                                return "D\xe9cembre";
                        }
                    }(r);
                case 2:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Enero";
                            case 1:
                                return "Febrero";
                            case 2:
                                return "Marzo";
                            case 3:
                                return "Abril";
                            case 4:
                                return "Mayo";
                            case 5:
                                return "Junio";
                            case 6:
                                return "Julio";
                            case 7:
                                return "Agosto";
                            case 8:
                                return "Septiembre";
                            case 9:
                                return "Octubre";
                            case 10:
                                return "Noviembre";
                            default:
                                return "Diciembre";
                        }
                    }(r);
                case 3:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januari";
                            case 1:
                                return "Februari";
                            case 2:
                                return "Maart";
                            case 3:
                                return "April";
                            case 4:
                                return "Mei";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "Augustus";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "December";
                        }
                    }(r);
                case 4:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Tammikuu";
                            case 1:
                                return "Helmikuu";
                            case 2:
                                return "Maaliskuu";
                            case 3:
                                return "Huhtikuu";
                            case 4:
                                return "Toukokuu";
                            case 5:
                                return "Kes\xe4kuu";
                            case 6:
                                return "Hein\xe4kuu";
                            case 7:
                                return "Elokuu";
                            case 8:
                                return "Syyskuu";
                            case 9:
                                return "Lokakuu";
                            case 10:
                                return "Marraskuu";
                            default:
                                return "Joulukuu";
                        }
                    }(r);
                case 5:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2";
                            case 1:
                                return "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2";
                            case 2:
                                return "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2";
                            case 3:
                                return "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2";
                            case 4:
                                return "\u039C\u03AC\u03B9\u03BF\u03C2";
                            case 5:
                                return "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2";
                            case 6:
                                return "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2";
                            case 7:
                                return "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2";
                            case 8:
                                return "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2";
                            case 9:
                                return "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2";
                            case 10:
                                return "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2";
                            default:
                                return "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2";
                        }
                    }(r);
                case 6:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Gennaio";
                            case 1:
                                return "Febbraio";
                            case 2:
                                return "Marzo";
                            case 3:
                                return "Aprile";
                            case 4:
                                return "Maggio";
                            case 5:
                                return "Giugno";
                            case 6:
                                return "Luglio";
                            case 7:
                                return "Agosto";
                            case 8:
                                return "Settembre";
                            case 9:
                                return "Ottobre";
                            case 10:
                                return "Novembre";
                            default:
                                return "Dicembre";
                        }
                    }(r);
                case 7:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januar";
                            case 1:
                                return "Februar";
                            case 2:
                                return "Mars";
                            case 3:
                                return "April";
                            case 4:
                                return "Mai";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "August";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "Desember";
                        }
                    }(r);
                case 8:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Janeiro";
                            case 1:
                                return "Fevereiro";
                            case 2:
                                return "Mar\xe7o";
                            case 3:
                                return "Abril";
                            case 4:
                                return "Maio";
                            case 5:
                                return "Junho";
                            case 6:
                                return "Julho";
                            case 7:
                                return "Agosto";
                            case 8:
                                return "Setembro";
                            case 9:
                                return "Outubro";
                            case 10:
                                return "Novembro";
                            default:
                                return "Dezembro";
                        }
                    }(r);
                case 9:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januari";
                            case 1:
                                return "Februari";
                            case 2:
                                return "Mars";
                            case 3:
                                return "April";
                            case 4:
                                return "Maj";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "Augusti";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "December";
                        }
                    }(r);
                case 10:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Januar";
                            case 1:
                                return "Februar";
                            case 2:
                                return "M\xe4rz";
                            case 3:
                                return "April";
                            case 4:
                                return "Mai";
                            case 5:
                                return "Juni";
                            case 6:
                                return "Juli";
                            case 7:
                                return "August";
                            case 8:
                                return "September";
                            case 9:
                                return "Oktober";
                            case 10:
                                return "November";
                            default:
                                return "Dezember";
                        }
                    }(r);
                default:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u042F\u043D\u0432\u0430\u0440\u044C";
                            case 1:
                                return "\u0424\u0435\u0432\u0440\u0430\u043B\u044C";
                            case 2:
                                return "\u041C\u0430\u0440\u0442";
                            case 3:
                                return "\u0410\u043F\u0440\u0435\u043B\u044C";
                            case 4:
                                return "\u041C\u0430\u0439";
                            case 5:
                                return "\u0418\u044E\u043D\u044C";
                            case 6:
                                return "\u0418\u044E\u043B\u044C";
                            case 7:
                                return "\u0410\u0432\u0433\u0443\u0441\u0442";
                            case 8:
                                return "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C";
                            case 9:
                                return "\u041E\u043A\u0442\u044F\u0431\u0440\u044C";
                            case 10:
                                return "\u041D\u043E\u044F\u0431\u0440\u044C";
                            default:
                                return "\u0414\u0435\u043A\u0430\u0431\u0440\u044C";
                        }
                    }(r);
            }
        }();
        return e ? t : Gc(t);
    }), Vc = z, Jc = function(n) {
        return A2(Vc, n, "");
    }, Bc = F3(function(n, e, r) {
        return n > 0 ? A3(Bc, n >> 1, k(e, e), 1 & n ? k(r, e) : r) : r;
    }), Xc = F2(function(n, e) {
        return A3(Bc, n, e, "");
    }), Qc = F3(function(n, e, r) {
        return k(A2(Xc, n - iu(r), Jc(e)), r);
    }), Zc = F2(function(n, e) {
        return Ht(n / e);
    }), Yc = function(n) {
        return n;
    }, no = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return e + n;
            var t = r.a, u = r.b;
            if (0 > m(t.w, e)) return e + t.h;
            r = u;
        }
    }), eo = F2(function(n, e) {
        var r = n.b;
        return A3(no, n.a, A2(Zc, e, 6e4), r);
    }), ro = function(n) {
        return -n;
    }, to = function(n) {
        var e = A2(Zc, n, 1440) + 719468, r = (0 > e ? e - 146096 : e) / 146097 | 0, t = e - 146097 * r, u = (t - (t / 1460 | 0) + (t / 36524 | 0) - (t / 146096 | 0)) / 365 | 0, a = t - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, c = i + (10 > i ? 3 : -9);
        return {
            ia: a - ((153 * i + 2) / 5 | 0) + 1,
            i2: c,
            ko: u + 400 * r + (c > 2 ? 0 : 1)
        };
    }, uo = F2(function(n, e) {
        return to(A2(eo, n, e)).ia;
    }), ao = F2(function(n, e) {
        return A2(Uc, 24, A2(Zc, A2(eo, n, e), 60));
    }), io = F2(function(n, e) {
        return A2(Uc, 1e3, e);
    }), co = F2(function(n, e) {
        return A2(Uc, 60, A2(eo, n, e));
    }), oo = F2(function(n, e) {
        switch(to(A2(eo, n, e)).i2){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), fo = F2(function(n, e) {
        return A2(Uc, 60, A2(Zc, e, 1e3));
    }), so = F2(function(n, e) {
        switch(A2(Uc, 7, A2(Zc, A2(eo, n, e), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), lo = F2(function(n, e) {
        return to(A2(eo, n, e)).ko;
    }), bo = F3(function(n, e, r) {
        var t = function() {
            switch(n){
                case 0:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Monday";
                            case 1:
                                return "Tuesday";
                            case 2:
                                return "Wednesday";
                            case 3:
                                return "Thursday";
                            case 4:
                                return "Friday";
                            case 5:
                                return "Saturday";
                            default:
                                return "Sunday";
                        }
                    }(r);
                case 1:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Lundi";
                            case 1:
                                return "Mardi";
                            case 2:
                                return "Mercredi";
                            case 3:
                                return "Jeudi";
                            case 4:
                                return "Vendredi";
                            case 5:
                                return "Samedi";
                            default:
                                return "Dimanche";
                        }
                    }(r);
                case 2:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Lunes";
                            case 1:
                                return "Martes";
                            case 2:
                                return "Mi\xe9rcoles";
                            case 3:
                                return "Jueves";
                            case 4:
                                return "Viernes";
                            case 5:
                                return "S\xe1bado";
                            default:
                                return "Domingo";
                        }
                    }(r);
                case 3:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Maandag";
                            case 1:
                                return "Dinsdag";
                            case 2:
                                return "Woensdag";
                            case 3:
                                return "Donderdag";
                            case 4:
                                return "Vrijdag";
                            case 5:
                                return "Zaterdag";
                            default:
                                return "Zondag";
                        }
                    }(r);
                case 4:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Maanantai";
                            case 1:
                                return "Tiistai";
                            case 2:
                                return "Keskiviikko";
                            case 3:
                                return "Torstai";
                            case 4:
                                return "Perjantai";
                            case 5:
                                return "Lauantai";
                            default:
                                return "Sunnuntai";
                        }
                    }(r);
                case 5:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1";
                            case 1:
                                return "\u03A4\u03C1\u03AF\u03C4\u03B7";
                            case 2:
                                return "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7";
                            case 3:
                                return "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7";
                            case 4:
                                return "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE";
                            case 5:
                                return "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF";
                            default:
                                return "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE";
                        }
                    }(r);
                case 6:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Luned\xec";
                            case 1:
                                return "Marted\xec";
                            case 2:
                                return "Mercoled\xec";
                            case 3:
                                return "Gioved\xec";
                            case 4:
                                return "Venerd\xec";
                            case 5:
                                return "Sabato";
                            default:
                                return "Domenica";
                        }
                    }(r);
                case 7:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Mandag";
                            case 1:
                                return "Tirsdag";
                            case 2:
                                return "Onsdag";
                            case 3:
                                return "Torsdag";
                            case 4:
                                return "Fredag";
                            case 5:
                                return "L\xf8rdag";
                            default:
                                return "S\xf8ndag";
                        }
                    }(r);
                case 8:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Segunda-feira";
                            case 1:
                                return "Ter\xe7a-feira";
                            case 2:
                                return "Quarta-feira";
                            case 3:
                                return "Quinta-feira";
                            case 4:
                                return "Sexta-feira";
                            case 5:
                                return "S\xe1bado";
                            default:
                                return "Domingo";
                        }
                    }(r);
                case 9:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "M\xe5ndag";
                            case 1:
                                return "Tisdag";
                            case 2:
                                return "Onsdag";
                            case 3:
                                return "Torsdag";
                            case 4:
                                return "Fredag";
                            case 5:
                                return "L\xf6rdag";
                            default:
                                return "S\xf6ndag";
                        }
                    }(r);
                case 10:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "Montag";
                            case 1:
                                return "Dienstag";
                            case 2:
                                return "Mittwoch";
                            case 3:
                                return "Donnerstag";
                            case 4:
                                return "Freitag";
                            case 5:
                                return "Samstag";
                            default:
                                return "Sonntag";
                        }
                    }(r);
                default:
                    return function(n) {
                        switch(n){
                            case 0:
                                return "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A";
                            case 1:
                                return "\u0432\u0442\u043E\u0440\u043D\u0438\u043A";
                            case 2:
                                return "\u0441\u0440\u0435\u0434\u0430";
                            case 3:
                                return "\u0447\u0435\u0442\u0432\u0435\u0440\u0433";
                            case 4:
                                return "\u043F\u044F\u0442\u043D\u0438\u0446\u0430";
                            case 5:
                                return "\u0441\u0443\u0431\u0431\u043E\u0442\u0430";
                            default:
                                return "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435";
                        }
                    }(r);
            }
        }();
        return e ? t : Gc(t);
    }), mo = F4(function(n, e, r, t) {
        var u = function(n) {
            return 12 === n ? 12 : A2(Uc, 12, n);
        }, a = F2(function(n, e) {
            return Hc(A2(Kc, n, A2(it, "", ut(e))));
        }), i = function(n) {
            return A3(Qc, 2, "0", ut(n));
        };
        switch(t){
            case "d":
                return ut(A2(uo, n, e));
            case "dd":
                return i(A2(uo, n, e));
            case "ddd":
                return A3(bo, r, 0, A2(so, n, e));
            case "dddd":
                return A3(bo, r, 1, A2(so, n, e));
            case "h":
                return ut(u(A2(ao, n, e)));
            case "hh":
                return i(u(A2(ao, n, e)));
            case "H":
                return ut(A2(ao, n, e));
            case "HH":
                return i(A2(ao, n, e));
            case "m":
                return ut(A2(co, n, e));
            case "mm":
                return i(A2(co, n, e));
            case "M":
                return ut(zc(A2(oo, n, e)));
            case "MM":
                return i(zc(A2(oo, n, e)));
            case "MMM":
                return A3(Wc, r, 0, A2(oo, n, e));
            case "MMMM":
                return A3(Wc, r, 1, A2(oo, n, e));
            case "s":
                return ut(A2(fo, n, e));
            case "ss":
                return i(A2(fo, n, e));
            case "t":
                return 12 > A2(ao, n, e) ? "A" : "P";
            case "tt":
                return 12 > A2(ao, n, e) ? "AM" : "PM";
            case "yy":
                return i(A2(Uc, 100, A2(lo, n, e)));
            case "yyyy":
                return ut(A2(lo, n, e));
            case "f":
                return A2(a, 1, A2(io, n, e));
            case "ff":
                return A2(a, 2, A2(io, n, e));
            case "fff":
                return A2(a, 3, A2(io, n, e));
            default:
                return t;
        }
    }), po = F2(function(n, e) {
        n: for(;;){
            if (!e.b) return xt(n);
            var r = e.a, t = e.b;
            if (n.b) {
                if (n.a.b) {
                    var u = n.a, a = u.a, i = u.b, c = n.b;
                    if (s(r, a)) {
                        n = A2(Ur, A2(Ur, r, A2(Ur, a, i)), c), e = t;
                        continue n;
                    }
                    n = A2(Ur, E([
                        r
                    ]), A2(Ur, A2(Ur, a, i), c)), e = t;
                    continue n;
                }
                return n;
            }
            n = E([
                E([
                    r
                ])
            ]), e = t;
        }
    }), vo = po(w), go = F4(function(n, e, r, t) {
        return Hc(A2(ju, A3(mo, r, t, n), A2(ju, Hc, vo(A2(it, "", e)))));
    }), ho = F3(function(n, e, r) {
        return A4(go, 0, n, e, r);
    }), $o = A2(nc, 0, w), xo = A2(Fu, A2(ho, "yyyy-MM-ddTHH:mm:ss.fffZ", $o), Ic), ko = function(n) {
        return n;
    }, wo = A2(Fu, ko, Ic), yo = wo, jo = function(n) {
        switch(n.$){
            case 0:
                return "association";
            case 1:
                return "business";
            case 2:
                return "education";
            case 3:
                return "individual";
            case 4:
                return "localAuthority";
            case 5:
                return "media";
            case 6:
                return "public";
            default:
                return "student";
        }
    }, Eo = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 4:
            case 5:
            case 6:
            default:
                return function(e) {
                    return Mc(E([
                        v("type", Ic(jo(n))),
                        v("name", Ic(e))
                    ]));
                }(e = n.a);
            case 1:
                var e = n.a, r = n.b;
                return Mc(E([
                    v("type", Ic(jo(n))),
                    v("name", Ic(e)),
                    v("siren", Ic(r))
                ]));
            case 3:
                return Mc(E([
                    v("type", Ic(jo(n)))
                ]));
        }
    }, Ao = function(n) {
        return Mc(E([
            v("assignedAt", xo(n.hM)),
            v("roleId", Ic(n.jG)),
            v("roleName", Ic(n.jH)),
            v("roleSlug", Ic(n.jI))
        ]));
    }, Co = F2(function(n, e) {
        return A3(ot, An(n), [], e);
    }), Po = function(n) {
        var e, r, t, u;
        return Mc(E([
            v("accessTokenData", (u = n.f$, Mc(E([
                v("access_token", Ic(u.kr)),
                v("expires_in", A2(_c, Ru, A2(Lc, qc, u.iu))),
                v("refresh_token", A2(_c, Ru, A2(Lc, Ic, u.jy))),
                v("token_type", Ic(u.ka))
            ])))),
            v("user", (e = n.fZ, Mc(E([
                v("email", Ic(e.c1)),
                v("hasActiveToken", Rc(e.iE)),
                v("id", (t = e.mf, yo(t))),
                v("isActive", Rc(e.iS)),
                v("isBetauser", Rc(e.iU)),
                v("isSuperuser", Rc(e.mt)),
                v("isVerified", Rc(e.iV)),
                v("magicLinkSentAt", A2(_c, Ru, A2(Lc, xo, e.i0))),
                v("joinedAt", A2(_c, Ru, A2(Lc, xo, e.iY))),
                v("profile", (r = e.nP, Mc(E([
                    v("emailOptin", Rc(r.aY)),
                    v("firstName", Ic(r.aC)),
                    v("lastName", Ic(r.aD)),
                    v("organization", Eo(r.ck)),
                    v("termsAccepted", Rc(r.oS))
                ])))),
                v("roles", A2(Co, Ao, e.jJ))
            ]))))
        ]));
    }, To = function(n) {
        switch(n){
            case 0:
                return "food2";
            case 1:
                return "object";
            default:
                return "veli";
        }
    }, So = A2(Fu, To, Ic), Io = function(n) {
        switch(n.a){
            case 0:
                return "ambient";
            case 1:
                return "fresh";
            default:
                return "frozen";
        }
    }, Oo = A2(cc, Ic, Io), qo = function(n) {
        return Ic(n);
    }, Lo = function(n) {
        return n;
    }, Mo = A2(Fu, Lo, Ic), _o = yn, Ro = function(n) {
        return n;
    }, Ho = function(n) {
        return 1e3 * n;
    }, Uo = A2(Fu, Ho, _o), zo = function(n) {
        switch(n){
            case 0:
                return Rr(Ic("byPlane"));
            case 1:
                return Rr(Ic("noPlane"));
            default:
                return Hr;
        }
    }, Do = A2(cc, Mc, La(function(n) {
        var e = n.a;
        return A2(Lc, function(n) {
            return v(e, n);
        }, n.b);
    })), No = function(n) {
        var e;
        return Do(E([
            v("id", Rr((e = n.mf, yo(e)))),
            v("mass", Rr(Uo(n.P))),
            v("country", A2(Lc, Mo, n.i)),
            v("byPlane", zo(n.jk))
        ]));
    }, Fo = function(n) {
        return yo(n);
    }, Ko = function(n) {
        var e;
        return Mc(E([
            v("id", Fo(n.mf)),
            v("amount", (e = n.j, _o(e)))
        ]));
    }, Go = function(n) {
        return Mc(E([
            v("id", Fo(n.mf)),
            v("mass", Uo(n.P))
        ]));
    }, Wo = function(n) {
        var e, r;
        return Do(E([
            v("ingredients", Rr(A2(Co, No, n.mm))),
            v("transform", A2(Lc, Go, n.fT)),
            v("packaging", (r = n.cm, r.b ? Rr(A2(Co, Ko, r)) : Hr)),
            v("distribution", A2(Lc, Oo, n.E)),
            v("preparation", (e = n.bj, e.b ? Rr(A2(Co, qo, e)) : Hr))
        ]));
    }, Vo = function(n) {
        switch(n){
            case 0:
                return "average";
            case 1:
                return "continuous";
            default:
                return "discontinuous";
        }
    }, Jo = A2(Fu, Vo, Ic), Bo = function(n) {
        switch(n){
            case 0:
                return "knitting-circular";
            case 1:
                return "knitting-fully-fashioned";
            case 2:
                return "knitting-integral";
            case 3:
                return "knitting-mix";
            case 4:
                return "knitting-straight";
            default:
                return "weaving";
        }
    }, Xo = A2(Fu, Bo, Ic), Qo = function(n) {
        return n;
    }, Zo = A2(Fu, Qo, _o), Yo = function(n) {
        return n ? "substantive" : "pigment";
    }, nf = A2(Fu, Yo, Ic), ef = function(n) {
        return Mc(E([
            v("kind", nf(n.gF)),
            v("ratio", Zo(n.nT))
        ]));
    }, rf = function(n) {
        switch(n){
            case 0:
                return "distribution";
            case 1:
                return "end-of-life";
            case 2:
                return "ennobling";
            case 3:
                return "fabric";
            case 4:
                return "making";
            case 5:
                return "material";
            case 6:
                return "spinning";
            default:
                return "use";
        }
    }, tf = A2(Fu, rf, Ic), uf = function(n) {
        switch(n){
            case 0:
                return "large-business-with-services";
            case 1:
                return "large-business-without-services";
            default:
                return "small-business";
        }
    }, af = A2(Fu, uf, Ic), cf = function(n) {
        return n;
    }, of = A2(Fu, cf, _o), ff = function(n) {
        var e = n.i;
        return e.$ ? Fo(n.mf) : Mc(E([
            v("country", Mo(e.a)),
            v("id", Fo(n.mf))
        ]));
    }, sf = function(n) {
        return ff(n);
    }, lf = function(n) {
        return !n.b;
    }, df = function(n) {
        return Do(E([
            v("amount", Rr(of(n.j))),
            v("material", Rr(ff(n.U))),
            v("transforms", lf(n.J) ? Hr : Rr(A2(Co, sf, n.J)))
        ]));
    }, bf = ko, mf = function(n) {
        return bf(n);
    }, pf = function(n) {
        return n.trim();
    }, vf = function(n) {
        return Do(k(E([
            v("id", A2(Lc, A2(Fu, mf, Ic), n.mf)),
            v("quantity", Rr(qc(n.D))),
            v("unitMass", A2(Lc, A2(Fu, Ro, _o), n.dH))
        ]), function() {
            var e = n.Y;
            if (e.$) return w;
            var r = e.a;
            return E([
                v("name", A2(Lc, Ic, A2(Qa, function(n) {
                    return "" === n ? Hr : Rr(n);
                }, A2(Lc, pf, r.ei)))),
                v("elements", Rr(A2(Co, df, r.r)))
            ]);
        }()));
    }, gf = function(n) {
        switch(n){
            case 0:
                return "ConventionalSpinning";
            case 1:
                return "SyntheticSpinning";
            default:
                return "UnconventionalSpinning";
        }
    }, hf = A2(Fu, gf, Ic), $f = function(n) {
        var e;
        return Do(E([
            v("country", A2(Lc, Mo, n.i)),
            v("id", Rr((e = n.mf, yo(e)))),
            v("share", Rr(Zo(n.aH))),
            v("spinning", A2(Lc, hf, n.dz))
        ]));
    }, xf = function(n) {
        return _o(n);
    }, kf = function(n) {
        return n;
    }, wf = A2(Fu, kf, _o), yf = F2(function(n, e) {
        return n * e;
    }), jf = R, Ef = function(n) {
        return jf(Ho(A2(yf, n, 1)));
    }, Af = function(n) {
        return qc(Ef(n));
    }, Cf = function(n) {
        return .001 * n;
    }, Pf = function(n) {
        return n;
    }, Tf = function(n) {
        return Cf(A2(yf, n, 1));
    }, Sf = A2(Fu, Tf, _o), If = function(n) {
        return n;
    }, Of = function(n) {
        switch(n){
            case 0:
                return "high";
            case 1:
                return "low";
            case 2:
                return "medium";
            case 3:
                return "non-applicable";
            case 4:
                return "very-high";
            default:
                return "very-low";
        }
    }, qf = function(n) {
        var e;
        return Do(E([
            v("airTransportRatio", A2(Lc, Zo, n.cE)),
            v("business", A2(Lc, af, n.hW)),
            v("countryDyeing", A2(Lc, Mo, n.bx)),
            v("countryFabric", A2(Lc, Mo, n.bS)),
            v("countryMaking", A2(Lc, Mo, n.bT)),
            v("countrySpinning", A2(Lc, Mo, n.cT)),
            v("disabledSteps", (e = n.cX, e.b ? Rr(A2(Co, tf, e)) : Hr)),
            v("dyeingProcessType", A2(Lc, Jo, n.cZ)),
            v("fabricProcess", A2(Lc, Xo, n.b1)),
            v("fading", A2(Lc, Rc, n.c6)),
            v("makingComplexity", A2(Lc, A2(Fu, Of, Ic), n.mR)),
            v("makingDeadStock", A2(Lc, Zo, n.dj)),
            v("makingWaste", A2(Lc, Zo, n.dk)),
            v("mass", Rr(_o(n.P))),
            v("materials", Rr(A2(Co, $f, n.fn))),
            v("numberOfReferences", A2(Lc, qc, n.ja)),
            v("physicalDurability", A2(Lc, xf, n.dm)),
            v("price", A2(Lc, wf, n.jn)),
            v("printing", A2(Lc, ef, n.dn)),
            v("product", Rr(Ic(n.aS))),
            v("surfaceMass", A2(Lc, Af, n.hf)),
            v("trims", A2(Lc, Co(vf), n.pb)),
            v("upcycled", Rr(Rc(n.dI))),
            v("yarnSize", A2(Lc, Sf, n.pR))
        ]));
    }, Lf = {
        i: Hr,
        bg: Hr
    }, Mf = function(n) {
        var e = n.j;
        return e.$ ? Fo(n.bk) : Mc(E([
            v("amount", of(e.a)),
            v("processId", Fo(n.bk))
        ]));
    }, _f = function(n) {
        return yo(n);
    }, Rf = function(n) {
        var e;
        return Mc(E([
            v("amount", _o((e = n).j)),
            v("processId", Fo(e.bk))
        ]));
    }, Hf = function(n) {
        return _o(n);
    }, Uf = {
        a8: 0,
        aN: Hr
    }, zf = function(n) {
        return 100 * n;
    }, Df = A2(Fu, zf, _o), Nf = function(n) {
        var e, r, t, u, a;
        return Do(E([
            v("assembly", s(n.q, Lf) ? Hr : Rr((a = n.q, s(a, Lf) ? Ru : Do(E([
                v("country", A2(Lc, Mo, a.i)),
                v("operations", A2(Lc, Co(Fo), a.bg))
            ]))))),
            v("components", Rr(A2(Co, vf, n.mu))),
            v("consumptions", A2(Lc, Co(Mf), n.aM)),
            v("distribution", A2(Lc, Fo, n.E)),
            v("durability", A2(Lc, Hf, n.aO)),
            v("packagings", lf(n.aR) ? Hr : Rr(A2(Co, Rf, n.aR))),
            v("product", A2(Lc, _f, n.aS)),
            v("recyclable", Rr(Rc(n.dq))),
            v("transportOptions", (e = n.aw, r = e.a8, t = e.aN, u = A2(La, ru, E([
                s(r, Uf.a8) ? Hr : Rr(v("byAir", Df(r))),
                A2(Lc, function(n) {
                    return v("cooling", Rc(n));
                }, t)
            ])), lf(u) ? Hr : Rr(Mc(u))))
        ]));
    }, Ff = function(n) {
        switch(n.$){
            case 0:
                return Wo(n.a);
            case 1:
                return Nf(n.b);
            default:
                return qf(n.a);
        }
    }, Kf = function(n) {
        var e;
        return Do(E([
            v("created", Rr(qc(n.gj))),
            v("name", Rr(Ic(n.ei))),
            v("query", Rr(Ff(n.g1))),
            v("subScope", (e = n.g1, 1 === e.$ ? Rr(So(e.a)) : Hr))
        ]));
    }, Gf = Co(A2(Fu, Kf, A2(Fu, tt(0), Ic))), Wf = F3(function(n, e, r) {
        var t = r;
        return A3(zi, F3(function(e, r, t) {
            return A2(n, e, t);
        }), e, t);
    }), Vf = F2(function(n, e) {
        return A3(Wf, An(n), [], e);
    }), Jf = function(n) {
        return Mc(E([
            v("comparedSimulations", A2(Vf, Ic, n.aX)),
            v("bookmarks", Gf(n.ao)),
            v("auth", A2(_c, Ru, A2(Lc, Po, n.aW))),
            v("usageCount", qc(n.hz))
        ]));
    }, Bf = A2(Fu, Jf, tt(0)), Xf = F2(function(n, e) {
        var r = e.a, t = e.b;
        return v(r, function() {
            var e = r.H;
            if (2 === e.$) {
                var u = e.a;
                return s(n.bH, u.bH) ? t : Uu(E([
                    t,
                    Oc(Bf(u.bH))
                ]));
            }
            return t;
        }());
    }), Qf = F3(function(n, e, r) {
        return {
            $: 4,
            a: n,
            b: e,
            c: r
        };
    }), Zf = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Yf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ns = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), es = {
        $: 7
    }, rs = function(n) {
        return {
            $: 13,
            a: n
        };
    }, ts = function(n) {
        switch(n.$){
            case 4:
                return "\xc9chec de l'interpr\xe9tation de la r\xe9ponse HTTP: " + n.a;
            case 3:
                return "Erreur HTTP " + ut(n.a);
            case 0:
                return "URL invalide: " + n.a;
            case 2:
                return "Erreur de communication r\xe9seau. \xcates-vous connect\xe9 ?";
            default:
                return "D\xe9lai d\xe9pass\xe9.";
        }
    }, us = function(n) {
        var e = n.bH.aW;
        return !e.$ && e.a.fZ.nP.oS;
    }, as = F8(function(n, e, r, t, u, a, i, c) {
        return {
            lj: n,
            E: e,
            $9: r,
            aO: t,
            _: u,
            Q: a,
            af: i,
            bK: c
        };
    }), is = F2(function(n, e) {
        return e.$ ? Jr(e.a) : n(e.a);
    }), cs = function(n) {
        return A2(Zt, Ui, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, os = function(n) {
        return {
            l: Zu,
            aJ: n
        };
    }, fs = F3(function(n, e, r) {
        var t = r;
        return $(t, {
            l: A3(ia, t.aJ(n), v(n, e), t.l)
        });
    }), ss = F2(function(n, e) {
        return e.$ ? Jr(e.a) : Zr(n(e.a));
    }), ls = F3(function(n, e, r) {
        return A2(Qt, function(n) {
            return n.$ ? Ti(n.a) : nu(n.a);
        }, A2(Zt, A2(Fr, F2(function(e, r) {
            return is(function(t) {
                return A2(ss, function(n) {
                    return A3(fs, n, r, t);
                }, A2(n, e, r));
            });
        }), Zr(os(e))), cs(r)));
    }), ds = {
        $: 0
    }, bs = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ms = {
        $: 2
    }, ps = function(n) {
        switch(n){
            case "food2":
                return Zr(0);
            case "object":
                return Zr(1);
            case "veli":
                return Zr(2);
            default:
                return Jr("Couldn't decode unknown generic scope " + n);
        }
    }, vs = function(n) {
        switch(n){
            case "food":
                return Zr(ds);
            case "textile":
                return Zr(ms);
            default:
                var e = n, r = ps(e);
                return 1 === r.$ ? Jr("Couldn't decode unknown scope " + e) : Zr(bs(r.a));
        }
    }, gs = function(n) {
        switch(n.$){
            case 0:
                return "food";
            case 1:
                return To(n.a);
            default:
                return "textile";
        }
    }, hs = A2(ls, F2(function(n) {
        return vs(n);
    }), gs), $s = F2(function(n, e) {
        return {
            i: n,
            lk: e
        };
    }), xs = A2(Zt, ru, ai), ks = F2(function(n, e) {
        return A3(yu, F2(function(e, r) {
            return n(e) ? A2(Ur, e, r) : r;
        }), w, e);
    }), ws = F2(function(n, e) {
        return e.$ ? Jr(n) : Zr(e.a);
    }), ys = function(n) {
        return n.b ? Rr(n.a) : Hr;
    }, js = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.cM;
        }, Rt(n))), A2(Fu, ys, ws("Code pays invalide: " + n + ".")));
    }, Es = function(n) {
        return n.$ ? Ti(n.a) : nu(n.a);
    }, As = F4(function(n, e, r, t) {
        return {
            mk: e,
            ee: n,
            ni: r,
            oJ: t
        };
    }), Cs = pr, Ps = mr, Ts = function(n) {
        return A2(Ps, {
            kO: !1,
            m4: !1
        }, n);
    }, Ss = /.^/, Is = A2(_c, Ss, Ts("^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$")), Os = function(n) {
        return n.toLowerCase();
    }, qs = function(n) {
        return A2(Cs, Is, n) ? Rr(Os(n)) : Hr;
    }, Ls = A2(Qt, function(n) {
        var e = qs(n);
        return e.$ ? Ti("Not a valid UUID") : nu(e.a);
    }, ai), Ms = Ls, _s = function(n) {
        return bf(n);
    }, Rs = F2(function(n, e) {
        return A2(ws, "Proc\xe9d\xe9 introuvable par id : " + _s(n), ys(A2(ks, A2(Fu, function(n) {
            return n.mf;
        }, Rt(n)), e)));
    }), Hs = function(n) {
        return A2(Qt, A2(Fu, ru, A2(Fu, function(e) {
            return A2(Rs, e, n);
        }, Es)), Ms);
    }, Us = function(n) {
        return Ya(E([
            A2(Zt, Rr, n),
            nu(Hr)
        ]));
    }, zs = F2(function(n, e) {
        return A3(Ba, "defaultProcess", function(n) {
            return hs(Us(Hs(n)));
        }(n), A3(Ba, "country", function(n) {
            return A2(Qt, function(e) {
                return Es(A2(js, e, n));
            }, xs);
        }(e), nu($s)));
    }), Ds = F2(function(n, e) {
        return {
            ib: n,
            jO: e
        };
    }), Ns = A3(Ba, "scoped", hs(cs(ai)), A3(Ba, "default", cs(ai), nu(Ds))), Fs = A3(Ba, "enabled", hs(qu), nu(function(n) {
        return {
            gp: n
        };
    })), Ks = F3(function(n, e, r) {
        return {
            gp: n,
            oi: e,
            fI: r
        };
    }), Gs = F3(function(n, e, r) {
        return {
            dV: e,
            ib: n,
            ek: r
        };
    }), Ws = F3(function(n, e, r) {
        return {
            ff: n,
            fi: e,
            fy: r
        };
    }), Vs = F3(function(n, e, r) {
        return {
            g: n,
            t: e,
            oD: r
        };
    }), Js = tn, Bs = Y, Xs = function(n) {
        return 0 > n || n > 100 ? Jr("Une part (en pourcentage) doit \xeatre comprise entre 0 et 100 inclus (ici\u202F: " + Bs(n) + ")") : Zr(n / 100);
    }, Qs = A2(Qt, A2(Fu, Xs, Es), Js), Zs = {
        bM: 0,
        bP: 0,
        bY: 0,
        b_: 0,
        b$: 0,
        b5: 0,
        b6: 0,
        b8: 0,
        b9: 0,
        ca: 0,
        cb: 0,
        cd: 0,
        ce: 0,
        cj: 0,
        cl: 0,
        co: 0,
        cp: 0,
        cs: 0,
        cw: 0,
        cA: 0
    }, Ys = A2(Fu, nu, Ja), nl = function(n) {
        return A3(Ba, "percent", Qs, A3(ui, "processId", Hs(n), A2(Ys, Zs, nu(Vs))));
    }, el = F3(function(n, e, r) {
        return Xa(A2(Zt, _c(r), A2(ti, n, e)));
    }), rl = F2(function(n, e) {
        for(;;){
            if (!e.b) return !1;
            var r = e.b;
            if (n(e.a)) return !0;
            e = r;
        }
    }), tl = F2(function(n, e) {
        return A2(rl, function(e) {
            return s(e, n);
        }, e);
    }), ul = function(n) {
        return !n;
    }, al = function(n) {
        return A3(ot, nt, 0, n);
    }, il = function(n) {
        var e, r, t = (e = A2(ju, function(n) {
            return n.oD;
        }, E([
            n.ff,
            n.fi,
            n.fy
        ])), r = al(A2(ju, Qo, e)), A2(tl, r, E([
            1,
            .6 + .3 + .1
        ])) ? Zr(r) : Jr("La somme des parts ne doit pas exc\xe9der 100%; ici\xa0: " + Bs(100 * r) + "%"));
        return 1 === t.$ ? Ti("Strat\xe9gies de fin de vie invalides\xa0: " + t.a) : nu(n);
    }, cl = function(n) {
        var e = {
            g: Zs,
            t: Hr,
            oD: 0
        };
        return A2(Qt, il, A4(el, "recycling", nl(n), e, A4(el, "landfilling", nl(n), e, A4(el, "incinerating", nl(n), e, nu(Ws)))));
    }, ol = function(n) {
        switch(n){
            case "aluminium":
                return Zr(0);
            case "battery_cell_nmc811":
                return Zr(4);
            case "battery_cell_nmc622":
                return Zr(3);
            case "battery_cell_lfp":
                return Zr(2);
            case "battery_alkaline":
                return Zr(1);
            case "composites":
                return Zr(6);
            case "containerboard":
                return Zr(7);
            case "copper":
                return Zr(8);
            case "ferrous_metals":
                return Zr(11);
            case "glass":
                return Zr(14);
            case "hdpe":
                return Zr(15);
            case "ldpe":
                return Zr(16);
            case "organic_fibers":
                return Zr(19);
            case "other":
                return Zr(21);
            case "pet":
                return Zr(22);
            case "pp":
                return Zr(23);
            case "pur_foam":
                return Zr(26);
            case "pwb":
                return Zr(24);
            case "rigid_plastics":
                return Zr(28);
            case "rubber":
                return Zr(29);
            case "synthetic_fibers":
                return Zr(30);
            case "wood":
                return Zr(31);
            case "cereals":
                return Zr(5);
            case "dairy":
                return Zr(9);
            case "eggs":
                return Zr(10);
            case "fish_and_shellfish":
                return Zr(12);
            case "fruits_and_vegetables":
                return Zr(13);
            case "legumes":
                return Zr(17);
            case "offal":
                return Zr(18);
            case "other_food_items":
                return Zr(20);
            case "poultry":
                return Zr(25);
            case "red_meats":
                return Zr(27);
            default:
                return Jr("Type de mati\xe8re non support\xe9: " + n);
        }
    }, fl = function(n) {
        switch(n){
            case 0:
                return "aluminium";
            case 1:
                return "battery_alkaline";
            case 2:
                return "battery_cell_lfp";
            case 3:
                return "battery_cell_nmc622";
            case 4:
                return "battery_cell_nmc811";
            case 5:
                return "cereals";
            case 6:
                return "composites";
            case 7:
                return "containerboard";
            case 8:
                return "copper";
            case 9:
                return "dairy";
            case 10:
                return "eggs";
            case 11:
                return "ferrous_metals";
            case 12:
                return "fish_and_shellfish";
            case 13:
                return "fruits_and_vegetables";
            case 14:
                return "glass";
            case 15:
                return "hdpe";
            case 16:
                return "ldpe";
            case 17:
                return "legumes";
            case 18:
                return "offal";
            case 19:
                return "organic_fibers";
            case 20:
                return "other_food_items";
            case 21:
                return "other";
            case 22:
                return "pet";
            case 23:
                return "pp";
            case 24:
                return "pwb";
            case 25:
                return "poultry";
            case 26:
                return "pur_foam";
            case 27:
                return "red_meats";
            case 28:
                return "rigid_plastics";
            case 29:
                return "rubber";
            case 30:
                return "synthetic_fibers";
            default:
                return "wood";
        }
    }, sl = A2(ls, F2(function(n) {
        return ol(n);
    }), fl), ll = F2(function(n, e) {
        return {
            ie: n,
            $8: e
        };
    }), dl = F2(function(n, e) {
        return A3(yu, Lu, e, n);
    }), bl = F3(function(n, e, r) {
        return A2(Ja, A2(dl, n, e), r);
    }), ml = F2(function(n, e) {
        return {
            id: n,
            m3: e
        };
    }), pl = F6(function(n, e, r, t, u, a) {
        return {
            f1: n,
            g: e,
            ds: r,
            oc: t,
            g7: u,
            om: a
        };
    }), vl = function(n) {
        return 1e3 * n;
    }, gl = A2(Zt, A2(Fu, Lc(vl), _c(0)), Us(Js)), hl = A2(Ys, 0, A3(Ba, "sea", gl, A2(Ys, 0, A3(Ba, "road", gl, A2(Ys, Zs, A3(Ba, "air", gl, nu(pl))))))), $l = F5(function(n, e, r, t, u) {
        return {
            kG: n,
            kH: e,
            mL: r,
            mM: t,
            nH: u
        };
    }), xl = F2(function(n, e) {
        return {
            ie: n,
            $8: e
        };
    }), kl = function(n) {
        var e = n.bR, r = n.W;
        return A3(Ba, "use", function(n) {
            return A3(bl, E([
                "defaultProcesses",
                "heat"
            ]), Hs(n), A3(bl, E([
                "defaultProcesses",
                "elec"
            ]), Hs(n), nu(xl)));
        }(r), A3(Ba, "transports", function(n) {
            return A3(Ba, "modeProcesses", function(n) {
                return A3(Ba, "plane", Hs(n), A3(Ba, "lorryCooling", Hs(n), A3(Ba, "lorry", Hs(n), A3(Ba, "boatCooling", Hs(n), A3(Ba, "boat", Hs(n), nu($l))))));
            }(n), A3(Ba, "defaultDistance", hl, nu(ml)));
        }(r), A3(Ba, "production", function(n) {
            return A3(bl, E([
                "defaultProcesses",
                "heat"
            ]), Hs(n), A3(bl, E([
                "defaultProcesses",
                "elec"
            ]), Hs(n), nu(ll)));
        }(r), A3(Ba, "endOfLife", function(n) {
            return A3(Ba, "strategies", function(n) {
                return A3(Ba, "nonCollected", sl(cl(n)), A3(Ba, "collected", sl(cl(n)), A3(Ba, "default", cl(n), nu(Gs))));
            }(n), A3(Ba, "scopeCollectionRates", hs(Qs), A3(Ba, "enabled", hs(qu), nu(Ks))));
        }(r), A3(Ba, "durability", Fs, A3(Ba, "docLinks", Ns, A3(Ba, "distribution", A2(zs, r, e), A4(el, "defaultExamples", hs(Ms), os(gs), nu(as)))))))));
    }, wl = function(n) {
        return A2(Fu, ci(kl(n)), $a(yt));
    }, yl = function(n) {
        var e = n.bH.aW;
        return e.$ ? w : E([
            A2(mi, "Authorization", "Bearer " + e.a.f$.kr)
        ]);
    }, jl = {
        $: 3
    }, El = {
        $: 4
    }, Al = F5(function(n, e, r, t, u) {
        return {
            il: n,
            l8: e,
            j0: r,
            eC: t,
            a6: u
        };
    }), Cl = F2(function(n, e) {
        return A2(pa, n, function(n) {
            switch(n.$){
                case 3:
                    var r = n.a, t = n.b, u = A2(ci, A2(Ys, (o = r).a6, A3(ui, "title", ai, A3(Ba, "status", xi, A2(Ys, o.l8, A4(el, "detail", ai, "No details were given", nu(Al)))))), t);
                    return Jr(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(1 === u.$ ? {
                        il: "Couldn't decode error response: " + yt(u.a),
                        l8: r.l8,
                        j0: r.j0,
                        eC: Hr,
                        a6: r.a6
                    } : u.a));
                case 0:
                    return Jr(function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(c = n.a));
                case 4:
                    var a = n.a.l8, i = n.a.j0, c = n.a.a6;
                    return t = n.b, A2($a, function(n) {
                        return function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }({
                            il: yt(n),
                            l8: a,
                            j0: i,
                            eC: Rr("Corps de r\xe9ponse invalide"),
                            a6: c
                        });
                    }, A2(ci, e, 204 === i && su(t) ? "null" : t));
                case 2:
                    return Jr(jl);
                default:
                    return Jr(El);
            }
            var o;
        });
    }), Pl = F4(function(n, e, r, t) {
        var u = e.a6;
        return za({
            kK: Ea,
            lQ: A2(Cl, A2(Fu, ja, r), t),
            l8: yl(n),
            mZ: "GET",
            oU: Hr,
            o8: Hr,
            a6: u
        });
    }), Tl = F2(function(n, e) {
        return A4(Pl, n, {
            a6: n.kU + "/processes/processes.json"
        }, e, ai);
    }), Sl = F2(function(n, e) {
        return 1 === n.$ ? e : e + ":" + ut(n.a);
    }), Il = F3(function(n, e, r) {
        return 1 === e.$ ? r : k(r, k(n, e.a));
    }), Ol = function(n) {
        return A3(Il, "#", n.iz, A3(Il, "?", n.g1, k(A2(Sl, n.nK, k(n.nQ ? "https://" : "http://", n.iJ)), n.jf)));
    }, ql = ee("sendPlausibleEvent", function(n) {
        return Mc(E([
            v("name", Ic(n.ei)),
            v("properties", Co(function(n) {
                var e = n.b;
                return A2(Co, ru, E([
                    Ic(n.a),
                    e
                ]));
            })(n.jt))
        ]));
    }), Ll = F2(function(n, e) {
        return v(n, Ic(e));
    }), Ml = function(n) {
        switch(n){
            case 0:
                return "acd";
            case 1:
                return "cch";
            case 2:
                return "etf";
            case 3:
                return "etf-c";
            case 4:
                return "fru";
            case 5:
                return "fwe";
            case 6:
                return "htc";
            case 7:
                return "htc-c";
            case 8:
                return "htn";
            case 9:
                return "htn-c";
            case 10:
                return "ior";
            case 11:
                return "ldu";
            case 12:
                return "mru";
            case 13:
                return "ozd";
            case 14:
                return "pco";
            case 15:
                return "pma";
            case 16:
                return "swe";
            case 17:
                return "tre";
            case 18:
                return "wtu";
            default:
                return "ecs";
        }
    }, _l = F2(function(n, e) {
        return v(n, Rc(e));
    }), Rl = function(n) {
        return !n.bH.aW.$;
    }, Hl = function(n) {
        return n.bH.aW;
    }, Ul = A2(Fu, Hl, A2(Fu, Lc(A2(Fu, function(n) {
        return n.fZ;
    }, function(n) {
        return n.mt;
    })), _c(!1))), zl = F2(function(n, e) {
        return A2(Fu, Lc(n(e)), _c(function(n) {
            return v(n, Ru);
        }(e)));
    }), Dl = F3(function(n, e, r) {
        var t;
        return {
            ei: e,
            jt: A2(Ur, A2(_l, "admin", Ul(n)), A2(Ur, A2(_l, "authenticated", Rl(n)), A2(Ur, A2(Ll, "clientUrl", n.kU), A2(Ur, A3(zl, Ll, "scalingoAppName", n.oh), A2(Ur, A2(Ll, "subsystem", "front-end"), A2(Ur, A3(zl, Ll, "version", (t = n.k9, 2 === t.$ ? t.a.fN : Hr)), r))))))
        };
    }), Nl = F2(function(n, e) {
        return ql(function() {
            switch(e.$){
                case 0:
                    return A3(Dl, n, "auth_api_token_created", E([
                        A2(Ll, "feature", "auth")
                    ]));
                case 1:
                    return A3(Dl, n, "auth_login_ok", E([
                        A2(Ll, "feature", "auth")
                    ]));
                case 2:
                    return A3(Dl, n, "auth_magic_link_sent", E([
                        A2(Ll, "feature", "auth")
                    ]));
                case 3:
                    return A3(Dl, n, "auth_profile_updated", E([
                        A2(Ll, "feature", "auth")
                    ]));
                case 4:
                    return A3(Dl, n, "auth_signup", E([
                        A2(Ll, "feature", "auth")
                    ]));
                case 5:
                    var r = e.a;
                    return A3(Dl, n, "bookmark_saved", E([
                        A2(Ll, "feature", "bookmarks"),
                        A2(Ll, "scope", gs(r))
                    ]));
                case 6:
                    return r = e.a, A3(Dl, n, "comparator_opened", E([
                        A2(Ll, "feature", "comparator"),
                        A2(Ll, "scope", gs(r))
                    ]));
                case 7:
                    r = e.a;
                    var t = e.b;
                    return A3(Dl, n, "comparison_type_selected", E([
                        A2(Ll, "feature", "comparator"),
                        A2(Ll, "scope", gs(r)),
                        A2(Ll, "comparison_type", t)
                    ]));
                case 8:
                    return r = e.a, A3(Dl, n, "component_added", E([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", gs(r))
                    ]));
                case 9:
                    return r = e.a, A3(Dl, n, "component_updated", E([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", gs(r))
                    ]));
                case 10:
                    return r = e.a, A3(Dl, n, "consumption_added", E([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", gs(r))
                    ]));
                case 11:
                    return r = e.a, A3(Dl, n, "example_selected", E([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", gs(r))
                    ]));
                case 12:
                    r = e.a;
                    var u = e.b;
                    return A3(Dl, n, "impact_selected", E([
                        A2(Ll, "feature", "simulator"),
                        A2(Ll, "scope", gs(r)),
                        A2(Ll, "trigram", Ml(u))
                    ]));
                case 13:
                    return A3(Dl, n, "pageview", E([
                        A2(Ll, "url", (i = e.a, Ol(A2(_c, !1, A2(Lc, gu("/auth/"), i.iz)) ? $(i, {
                            iz: Rr("/auth/<***>/")
                        }) : i)))
                    ]));
                default:
                    r = e.a;
                    var a = e.b;
                    return A3(Dl, n, "tab_selected", E([
                        A2(Ll, "feature", "share"),
                        A2(Ll, "scope", gs(r)),
                        A2(Ll, "tab", a)
                    ]));
            }
            var i;
        }());
    }), Fl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Wl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Jl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Bl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Xl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ql = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Zl = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Yl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, nd = {
        $: 8
    }, ed = function(n) {
        return {
            $: 12,
            a: n
        };
    }, rd = function(n) {
        return {
            $: 9,
            a: n
        };
    }, td = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ud = F5(function(n, e, r, t, u) {
        return {
            b4: t,
            cn: r,
            bJ: e,
            eP: u,
            cy: n
        };
    }), ad = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Ur, n.a, ad(n.b)) : w;
    }, id = F2(function(n, e) {
        return Rr(1 === e.$ ? E([
            n
        ]) : A2(Ur, n, e.a));
    }), cd = function(n) {
        try {
            return Rr(decodeURIComponent(n));
        } catch (n) {
            return Hr;
        }
    }, od = F2(function(n, e) {
        var r = A2(it, "=", n);
        if (r.b && r.b.b && !r.b.b.b) {
            var t = r.b.a, u = cd(r.a);
            if (1 === u.$) return e;
            var a = u.a, i = cd(t);
            return 1 === i.$ ? e : A3(ma, a, id(i.a), e);
        }
        return e;
    }), fd = F2(function(n, e) {
        var r;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var e = n.a, r = e.bJ;
                    if (r.b) {
                        if ("" !== r.a || r.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Rr(e.eP);
                    }
                    return Rr(e.eP);
                }
                return Hr;
            }
        }(n(A5(ud, w, function(n) {
            var e = A2(it, "/", n);
            return ad(e.b && "" === e.a ? e.b : e);
        }(e.jf), 1 === (r = e.g1).$ ? Zu : A3(yu, od, Zu, A2(it, "&", r.a)), e.iz, ru)));
    }), sd = {
        $: 0
    }, ld = {
        $: 1
    }, dd = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), bd = {
        $: 3
    }, md = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pd = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), vd = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), gd = function(n) {
        return {
            $: 7,
            a: n
        };
    }, hd = {
        $: 8
    }, $d = {
        $: 12
    }, xd = {
        $: 13
    }, kd = function(n) {
        return {
            $: 15,
            a: n
        };
    }, wd = {
        $: 16
    }, yd = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jd = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Ed = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ad = function(n) {
        switch(n.$){
            case 0:
                return yd(Hr);
            case 1:
                switch(n.a){
                    case 0:
                        return A2(jd, 0, Hr);
                    case 1:
                        return A2(jd, 1, Hr);
                    default:
                        return A2(jd, 2, Hr);
                }
            default:
                return Ed(Hr);
        }
    }, Cd = F2(function(n, e) {
        return A5(ud, e.cy, e.bJ, e.cn, e.b4, n(e.eP));
    }), Pd = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = e.cy, u = e.bJ, a = e.cn, i = e.b4;
            return A2(ju, Cd(e.eP), r(A5(ud, t, u, a, i, n)));
        };
    }), Td = F2(function(n, e) {
        return e.b ? A3(yu, Ur, e, n) : n;
    }), Sd = function(n) {
        return A3(yu, Td, w, n);
    }, Id = F2(function(n, e) {
        return Sd(A2(ju, n, e));
    }), Od = function(n) {
        return function(e) {
            return A2(Id, function(n) {
                return n(e);
            }, n);
        };
    }, qd = F2(function(n, e) {
        return function(n) {
            var r = n.cy, t = n.bJ, u = n.cn, a = n.b4, i = n.eP;
            if (t.b) {
                var c = t.a, o = t.b, f = e(c);
                if (f.$) return w;
                var s = f.a;
                return E([
                    A5(ud, A2(Ur, c, r), o, u, a, i(s))
                ]);
            }
            return w;
        };
    }), Ld = function(n) {
        return n.$ ? Hr : Rr(n.a);
    }, Md = A2(qd, "SCOPE", A2(Fu, vs, Ld)), _d = function(n) {
        switch(iu(n) % 4){
            case 3:
                return n + "=";
            case 2:
                return n + "==";
            default:
                return n;
        }
    }, Rd = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, Hd = A2(Fu, Rd, Jc), Ud = F2(function(n, e) {
        var r = e.a, t = e.b, u = e.c, a = function(n) {
            return 63 & n | r << 6;
        };
        return t ? 1 === t ? g(0, 0, k(u, Hd(a(n)))) : g(a(n), t - 1, u) : 128 & n ? 192 == (224 & n) ? g(31 & n, 1, u) : 224 == (240 & n) ? g(15 & n, 2, u) : g(7 & n, 3, u) : g(0, 0, k(u, Hd(n)));
    }), zd = F2(function(n, e) {
        return g(0, 0, A2(Ud, 255 & n >>> 0, A2(Ud, 255 & n >>> 8, A2(Ud, 255 & n >>> 16, e))));
    }), Dd = F2(function(n, e) {
        var r = e.a, t = e.b, u = e.c, a = function(n) {
            switch(n){
                case "A":
                default:
                    return 0;
                case "B":
                    return 1;
                case "C":
                    return 2;
                case "D":
                    return 3;
                case "E":
                    return 4;
                case "F":
                    return 5;
                case "G":
                    return 6;
                case "H":
                    return 7;
                case "I":
                    return 8;
                case "J":
                    return 9;
                case "K":
                    return 10;
                case "L":
                    return 11;
                case "M":
                    return 12;
                case "N":
                    return 13;
                case "O":
                    return 14;
                case "P":
                    return 15;
                case "Q":
                    return 16;
                case "R":
                    return 17;
                case "S":
                    return 18;
                case "T":
                    return 19;
                case "U":
                    return 20;
                case "V":
                    return 21;
                case "W":
                    return 22;
                case "X":
                    return 23;
                case "Y":
                    return 24;
                case "Z":
                    return 25;
                case "a":
                    return 26;
                case "b":
                    return 27;
                case "c":
                    return 28;
                case "d":
                    return 29;
                case "e":
                    return 30;
                case "f":
                    return 31;
                case "g":
                    return 32;
                case "h":
                    return 33;
                case "i":
                    return 34;
                case "j":
                    return 35;
                case "k":
                    return 36;
                case "l":
                    return 37;
                case "m":
                    return 38;
                case "n":
                    return 39;
                case "o":
                    return 40;
                case "p":
                    return 41;
                case "q":
                    return 42;
                case "r":
                    return 43;
                case "s":
                    return 44;
                case "t":
                    return 45;
                case "u":
                    return 46;
                case "v":
                    return 47;
                case "w":
                    return 48;
                case "x":
                    return 49;
                case "y":
                    return 50;
                case "z":
                    return 51;
                case "0":
                    return 52;
                case "1":
                    return 53;
                case "2":
                    return 54;
                case "3":
                    return 55;
                case "4":
                    return 56;
                case "5":
                    return 57;
                case "6":
                    return 58;
                case "7":
                    return 59;
                case "8":
                    return 60;
                case "9":
                    return 61;
                case "+":
                    return 62;
                case "/":
                    return 63;
            }
        }(n);
        return 3 === t ? A2(zd, r | a, u) : g(a << 6 * (3 - t) | r, t + 1, u);
    }), Nd = F, Fd = g(0, 0, g(0, 0, "")), Kd = F2(function(n, e) {
        return 1 > n ? e : A3(cu, 0, -n, e);
    }), Gd = Q, Wd = F2(function(n, e) {
        return A2(Gd, "==", n) ? A2(Kd, 2, e) : A2(Gd, "=", n) ? A2(Kd, 1, e) : e;
    }), Vd = A2(_c, Ss, Ts("^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$")), Jd = function(n) {
        var e = n.c, r = e.c;
        return e.b > 0 ? Jr("Invalid UTF-16") : Zr(r);
    }, Bd = function(n) {
        return A2(ss, Wd(n), A2(is, A2(Fu, A2(Nd, Dd, Fd), Jd), function(n) {
            return A2(Cs, Vd, n) ? Zr(n) : Jr("Invalid base64");
        }(n)));
    }, Xd = A2(Fu, _d, Bd), Qd = Xd, Zd = F5(function(n, e, r, t, u) {
        return {
            E: n,
            mm: e,
            cm: r,
            bj: t,
            fT: u
        };
    }), Yd = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), nb = function(n) {
        return n;
    }, eb = function(n) {
        return 36e5 * n;
    }, rb = function(n) {
        return .001 * n;
    }, tb = F2(function(n, e) {
        return n / e;
    }), ub = F2(function(n, e) {
        return n / e;
    }), ab = A2(Yd, 0, {
        aN: A2(tb, eb(0), 1),
        c3: A2(tb, eb(123.08), 1),
        eJ: vl(600),
        cz: A2(ub, rb(561.5), 1)
    }), ib = A2(Yd, 1, {
        aN: A2(tb, eb(219.23), 1),
        c3: A2(tb, eb(46.15), 1),
        eJ: vl(600),
        cz: A2(ub, rb(210.6), 1)
    }), cb = A2(Yd, 2, {
        aN: A2(tb, eb(415.38), 1),
        c3: A2(tb, eb(61.54), 1),
        eJ: vl(600),
        cz: A2(ub, rb(280.8), 1)
    }), ob = function(n) {
        switch(n){
            case "ambient":
                return Zr(ab);
            case "fresh":
                return Zr(ib);
            case "frozen":
                return Zr(cb);
            default:
                return Jr("Choix invalide pour la distribution : " + n);
        }
    }, fb = A2(Qt, A2(Fu, ob, Es), ai), sb = function(n) {
        return 1 - n;
    }, lb = .4, db = function(n) {
        return 1e6 * n;
    }, bb = E([
        {
            bq: !0,
            d0: v(eb(.667), 1),
            d9: v(db(0), 0),
            mf: "frying",
            ei: "Friture"
        },
        {
            bq: !0,
            d0: v(eb(.44), lb),
            d9: v(db(1.584), sb(lb)),
            mf: "pan-cooking",
            ei: "Cuisson \xe0 la po\xeale"
        },
        {
            bq: !1,
            d0: v(eb(.08), lb),
            d9: v(db(.288), sb(lb)),
            mf: "pan-warming",
            ei: "R\xe9chauffage \xe0 la po\xeale"
        },
        {
            bq: !0,
            d0: v(eb(.999), 1),
            d9: v(db(0), 0),
            mf: "oven",
            ei: "Cuisson au four"
        },
        {
            bq: !0,
            d0: v(eb(.128), 1),
            d9: v(db(0), 0),
            mf: "microwave",
            ei: "Cuisson au four micro-ondes"
        },
        {
            bq: !1,
            d0: v(eb(.0777), 1),
            d9: v(db(0), 0),
            mf: "refrigeration",
            ei: "R\xe9frig\xe9ration"
        },
        {
            bq: !1,
            d0: v(eb(.294), 1),
            d9: v(db(0), 0),
            mf: "freezing",
            ei: "Cong\xe9lation"
        }
    ]), mb = function(n) {
        return n;
    }, pb = function(n) {
        return "Pr\xe9paration inconnue: " + n;
    }, vb = function(n) {
        return A2(tl, n, A2(ju, mb, A2(ju, function(n) {
            return n.mf;
        }, bb))) ? Zr(n) : Jr(pb(n));
    }, gb = A2(Qt, A2(Fu, vb, Es), ai), hb = F4(function(n, e, r, t) {
        return {
            i: n,
            mf: e,
            P: r,
            jk: t
        };
    }), $b = A2(Zt, ru, Ms), xb = function(n) {
        return .001 * n;
    }, kb = A2(Zt, xb, Js), wb = A2(Qt, function(n) {
        switch(n){
            case "byPlane":
                return nu(0);
            case "noPlane":
                return nu(1);
            default:
                return Ti("Transport par avion inconnu\xa0: " + n);
        }
    }, ai), yb = A4(el, "byPlane", wb, 2, A3(Ba, "mass", kb, A3(Ba, "id", $b, A3(ui, "country", xs, nu(hb))))), jb = F2(function(n, e) {
        return {
            j: n,
            mf: e
        };
    }), Eb = A2(Zt, ru, Ms), Ab = A2(Zt, ru, Js), Cb = A3(Yt, jb, A2(Lu, "amount", Ab), A2(Lu, "id", Eb)), Pb = F2(function(n, e) {
        return {
            mf: n,
            P: e
        };
    }), Tb = A3(Yt, Pb, A2(Lu, "id", Eb), A2(Lu, "mass", kb)), Sb = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Ib = F3(function(n, e, r) {
        var t = function(n) {
            return Ya(E([
                n,
                Za(r)
            ]));
        };
        return A2(Qt, function(u) {
            var a = A2(ni, A2(dl, n, ei), u);
            if (a.$) return nu(r);
            var i = a.a, c = A2(ni, t(e), i);
            return c.$ ? A2(dl, n, t(e)) : nu(c.a);
        }, ei);
    }), Ob = F4(function(n, e, r, t) {
        return A2(Ja, A3(Ib, E([
            n
        ]), e, r), t);
    }), qb = A3(ui, "transform", Tb, A4(Ob, "preparation", Sb(gb), w, A4(Ob, "packaging", Sb(Cb), w, A3(Ba, "ingredients", Sb(yb), A3(ui, "distribution", fb, nu(Zd)))))), Lb = A2(Fu, Qd, is(A2(Fu, ci(qb), $a(yt)))), Mb = A2(qd, "QUERY", A2(Fu, Lb, A2(Fu, Ld, Rr))), _b = F3(function(n, e, r) {
        return {
            $: 9,
            a: n,
            b: e,
            c: r
        };
    }), Rb = F2(function(n, e) {
        return {
            $: 10,
            a: n,
            b: e
        };
    }), Hb = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Ub = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            q: n,
            aM: e,
            E: r,
            aO: t,
            mu: u,
            aR: a,
            aS: i,
            dq: c,
            aw: o
        };
    }), zb = F2(function(n, e) {
        return {
            i: n,
            bg: e
        };
    }), Db = Ya(E([
        A2(Lu, "assembly", A3(ui, "operations", Sb(Eb), A3(ui, "country", xs, nu(zb)))),
        A2(Zt, function(n) {
            return $(Lf, {
                i: Rr(n)
            });
        }, A2(Lu, "assemblyCountry", xs)),
        nu(Lf)
    ])), Nb = F2(function(n, e) {
        return {
            j: n,
            bk: e
        };
    }), Fb = A2(Zt, ru, Js), Kb = Ya(E([
        A2(Zt, Nb(Hr), Eb),
        A3(Ba, "processId", Eb, A3(ui, "amount", Fb, nu(Nb)))
    ])), Gb = function(n) {
        return n.f0;
    }, Wb = function(n) {
        var e = n.lr;
        return e.$ ? Gb(n) : e.a;
    }, Vb = {
        $: 9
    }, Jb = F2(function(n, e) {
        return A2(tl, n, e.cK);
    }), Bb = Jb(Vb), Xb = F3(function(n, e, r) {
        return A2(at, e, A2(it, n, r));
    }), Qb = function(n) {
        var e = n;
        return 0 > e ? Jr("Une quantit\xe9 doit \xeatre sup\xe9rieure ou \xe9gale \xe0 z\xe9ro") : Zr(e);
    }, Zb = F2(function(n, e) {
        return A2(is, function(n) {
            var r = v(e.j, Bb(n));
            return r.a.$ ? r.b ? Zr(e) : Jr(A3(Xb, "{processName}", Wb(n), 'Le proc\xe9d\xe9 "{processName}" n\u2019etant pas productmassdependent, le champ amount est requis')) : r.b ? Jr(A3(Xb, "{processName}", Wb(n), 'Le proc\xe9d\xe9 "{processName}" \xe9tant productmassdependent, le champ amount n\'est pas accept\xe9')) : A2(ss, function(n) {
                return $(e, {
                    j: Rr(n)
                });
            }, Qb(r.a.a));
        }, A2(Rs, e.bk, n));
    }), Yb = A2(Zt, ru, Ms), nm = F4(function(n, e, r, t) {
        return {
            Y: n,
            mf: e,
            D: r,
            dH: t
        };
    }), em = F2(function(n, e) {
        return {
            r: n,
            ei: e
        };
    }), rm = F3(function(n, e, r) {
        return {
            j: n,
            U: e,
            J: r
        };
    }), tm = A3(Ba, "id", Eb, A3(ui, "country", xs, nu(F2(function(n, e) {
        return {
            i: n,
            mf: e
        };
    })))), um = function(n) {
        return {
            i: Hr,
            mf: n
        };
    }, am = Ya(E([
        tm,
        A2(Zt, um, Eb)
    ])), im = Ya(E([
        Sb(tm),
        Sb(A2(Zt, um, Eb))
    ])), cm = A4(Ob, "transforms", im, w, A3(Ba, "material", am, A3(Ba, "amount", Fb, nu(rm)))), om = A3(ui, "name", ai, A3(Ba, "elements", Sb(cm), nu(em))), fm = A2(Qt, function(n) {
        return n.$ ? A2(Qt, function(n) {
            return n.$ ? nu(Hr) : A2(Zt, Rr, om);
        }, A2(ri, "elements", ei)) : nu(Rr(n.a));
    }, A2(ri, "custom", om)), sm = A2(Zt, ru, A2(Qt, function(n) {
        return 1 > n ? Ti("La quantit\xe9 doit \xeatre un nombre entier positif") : nu(n);
    }, xi)), lm = A2(Qt, function(n) {
        return n > 0 ? nu(n) : Ti("La masse unitaire doit \xeatre strictement positive");
    }, Js), dm = A3(ui, "unitMass", lm, A3(Ba, "quantity", sm, A3(ui, "id", A2(Zt, ru, Ms), A2(Ja, fm, nu(nm))))), bm = F2(function(n, e) {
        return {
            j: n,
            bk: e
        };
    }), mm = A3(Ba, "processId", Eb, A3(Ba, "amount", Fb, nu(bm))), pm = A2(Zt, ru, mm), vm = function(n) {
        return n;
    }, gm = A2(Zt, vm, Js), hm = F2(function(n, e) {
        return {
            a8: n,
            aN: e
        };
    }), $m = A3(ui, "cooling", qu, A4(Ob, "byAir", Qs, 0, nu(hm))), xm = function(n) {
        return A2(Qt, function(e) {
            return A4(Ob, "transportOptions", $m, Uf, A4(Ob, "recyclable", qu, !0, A3(ui, "product", Yb, A4(Ob, "packagings", Sb(pm), w, A3(Ba, "components", Sb(dm), A3(ui, "durability", gm, A3(ui, "distribution", Eb, A3(ui, "consumptions", Sb(function(n) {
                return lf(n) ? Kb : function(n) {
                    return A2(Qt, A2(Fu, Zb(n), Es), Kb);
                }(n);
            }(n)), nu(Ub(e))))))))));
        }, Db);
    }, km = A2(Fu, Qd, is(A2(Fu, ci(xm(w)), $a(yt)))), wm = A2(qd, "QUERY", A2(Fu, km, A2(Fu, Ld, Rr))), ym = function(n) {
        switch(n){
            case "acd":
                return Zr(0);
            case "cch":
                return Zr(1);
            case "etf":
                return Zr(2);
            case "etf-c":
                return Zr(3);
            case "fru":
                return Zr(4);
            case "fwe":
                return Zr(5);
            case "htc":
                return Zr(6);
            case "htc-c":
                return Zr(7);
            case "htn":
                return Zr(8);
            case "htn-c":
                return Zr(9);
            case "ior":
                return Zr(10);
            case "ldu":
                return Zr(11);
            case "mru":
                return Zr(12);
            case "ozd":
                return Zr(13);
            case "pco":
                return Zr(14);
            case "pma":
                return Zr(15);
            case "swe":
                return Zr(16);
            case "tre":
                return Zr(17);
            case "wtu":
                return Zr(18);
            case "ecs":
                return Zr(19);
            default:
                return Jr("Trigramme d'impact inconnu\u202F: " + n);
        }
    }, jm = A2(qd, "TRIGRAM", function(n) {
        return Ld(ym(n));
    }), Em = A2(Fu, qs, ws("UUID invalide")), Am = A2(qd, "EXAMPLE", A2(Fu, Em, Ld)), Cm = function(n) {
        return function(e) {
            var r = e.cy, t = e.bJ, u = e.cn, a = e.b4, i = e.eP;
            if (t.b) {
                var c = t.a, o = t.b;
                return s(c, n) ? E([
                    A5(ud, A2(Ur, c, r), o, u, a, i)
                ]) : w;
            }
            return w;
        };
    }, Pm = F2(function(n, e) {
        var r = n, t = e;
        return function(n) {
            return A2(Id, t, r(n));
        };
    }), Tm = F2(function(n, e) {
        return Od(E([
            A2(Pd, Hb(n), A2(Pm, Cm(e), Cm("simulator"))),
            A2(Pd, _b(n), A2(Pm, Cm(e), A2(Pm, Cm("simulator"), A2(Pm, jm, wm)))),
            A2(Pd, Rb(n), A2(Pm, Cm(e), A2(Pm, Cm("edit-example"), Am)))
        ]));
    }), Sm = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Im = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Om = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qm = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Lm = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), Mm = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), _m = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Rm = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Hm = function(n) {
        switch(n){
            case "countries":
                return Im(Hr);
            case "food-examples":
                return yd(Hr);
            case "food-processes":
                return A2(Lm, ds, Hr);
            case "food2-examples":
                return A2(jd, 0, Hr);
            case "food2-processes":
                return A2(Lm, bs(0), Hr);
            case "food2-product-categories":
                return A2(Mm, 0, Hr);
            case "impacts":
                return qm(Hr);
            case "ingredients":
                return Om(Hr);
            case "materials":
                return _m(Hr);
            case "object-components":
                return A2(Sm, bs(1), Hr);
            case "object-examples":
                return A2(jd, 1, Hr);
            case "object-processes":
                return A2(Lm, bs(1), Hr);
            case "object-product-categories":
                return A2(Mm, 1, Hr);
            case "processes":
            case "textile-processes":
                return A2(Lm, ms, Hr);
            case "products":
                return Rm(Hr);
            case "textile-components":
                return A2(Sm, ms, Hr);
            case "veli-components":
                return A2(Sm, bs(2), Hr);
            case "veli-examples":
                return A2(jd, 2, Hr);
            case "veli-processes":
                return A2(Lm, bs(2), Hr);
            case "veli-product-categories":
                return A2(Mm, 2, Hr);
            default:
                return Ed(Hr);
        }
    }, Um = A2(qd, "DATASET", A2(Fu, Hm, Rr)), zm = F2(function(n, e) {
        return {
            $: 14,
            a: n,
            b: e
        };
    }), Dm = function(n) {
        switch(n){
            case "average":
                return Zr(0);
            case "continuous":
                return Zr(1);
            case "discontinuous":
                return Zr(2);
            default:
                return Jr("Type de teinture inconnu\u202F: " + n);
        }
    }, Nm = A2(Qt, A2(Fu, Dm, Es), ai), Fm = function(n) {
        switch(n){
            case "knitting-circular":
                return Zr(0);
            case "knitting-fully-fashioned":
                return Zr(1);
            case "knitting-integral":
                return Zr(2);
            case "knitting-mix":
                return Zr(3);
            case "knitting-straight":
                return Zr(4);
            case "weaving":
                return Zr(5);
            default:
                return Jr("Proc\xe9d\xe9 de tissage/tricotage inconnu: " + n);
        }
    }, Km = A2(Qt, A2(Fu, Fm, Es), ai), Gm = function(n) {
        switch(n){
            case "high":
                return Zr(0);
            case "low":
                return Zr(1);
            case "medium":
                return Zr(2);
            case "not-applicable":
                return Zr(3);
            case "very-high":
                return Zr(4);
            case "very-low":
                return Zr(5);
            default:
                return Jr("Type de complexit\xe9 de fabrication inconnu\xa0: " + n);
        }
    }, Wm = A2(Qt, function(n) {
        return Es(Gm(n));
    }, ai), Vm = F2(function(n, e) {
        return {
            gF: n,
            nT: e
        };
    }), Jm = function(n) {
        switch(n){
            case "pigment":
                return Zr(0);
            case "substantive":
                return Zr(1);
            default:
                return Jr("Type d'impression inconnu: " + n);
        }
    }, Bm = A2(Qt, A2(Fu, Jm, Es), ai), Xm = F3(function(n, e, r) {
        return 0 > m(r, n) || m(r, e) > 0 ? Jr("Cette proportion doit \xeatre comprise entre " + Bs(n) + " et " + Bs(e) + " inclus (ici\u202F: " + Bs(r) + ")") : Zr(r);
    }), Qm = A2(Qt, A2(Fu, A2(Xm, 0, .8), Es), Js), Zm = A4(Ob, "ratio", Qm, .2, A3(Ba, "kind", Bm, nu(Vm))), Ym = function(n) {
        switch(n){
            case "small-business":
                return Zr(2);
            case "large-business-with-services":
                return Zr(0);
            case "large-business-without-services":
                return Zr(1);
            default:
                return Jr("Type d'entreprise inconnu : " + n);
        }
    }, np = A2(Qt, A2(Fu, Ym, Es), ai), ep = A2(Xm, 0, 1), rp = A2(Qt, A2(Fu, ep, Es), Js), tp = function(n) {
        switch(n){
            case "distribution":
                return Zr(0);
            case "ennobling":
                return Zr(2);
            case "end-of-life":
                return Zr(1);
            case "fabric":
                return Zr(3);
            case "making":
                return Zr(4);
            case "material":
                return Zr(5);
            case "spinning":
                return Zr(6);
            case "use":
                return Zr(7);
            default:
                return Jr("Code \xe9tape inconnu: " + n);
        }
    }, up = A2(Qt, A2(Fu, tp, Es), ai), ap = F4(function(n, e, r, t) {
        return {
            i: n,
            mf: e,
            aH: r,
            dz: t
        };
    }), ip = function(n) {
        switch(n){
            case "ConventionalSpinning":
                return Zr(0);
            case "SyntheticSpinning":
                return Zr(1);
            case "UnconventionalSpinning":
                return Zr(2);
            default:
                return Jr("Le proc\xe9d\xe9 de filature ou filage " + n + " n'est pas valide");
        }
    }, cp = A2(Qt, A2(Fu, ip, Es), ai), op = A2(Zt, ru, Ms), fp = A3(ui, "spinning", cp, A3(Ba, "share", rp, A3(Ba, "id", op, A3(ui, "country", xs, nu(ap))))), sp = function(n) {
        return n;
    }, lp = A2(Zt, sp, Js), dp = ru, bp = A2(Zt, dp, Js), mp = function(n) {
        return A2(tb, xb(n), 1);
    }, pp = A2(Zt, mp, xi), vp = vr($r), gp = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Hr;
        var e = +n;
        return e == e ? Rr(e) : Hr;
    }, hp = function(n) {
        return A2(tb, 1e4, xb(n));
    }, $p = function(n) {
        return A2(tb, vl(n), 1);
    }, xp = Ya(E([
        A2(Zt, $p, Js),
        A2(Qt, function(n) {
            return Es(A2(ws, "Titrage invalide: " + n, function(n) {
                var e = A2(_c, Ss, Ts("(\\d+)(Nm|Dtex)")), r = A2(ju, function(n) {
                    return n.oJ;
                }, A2(vp, e, n)), t = gp(n);
                if (t.$) {
                    n: for(; r.b && r.a.b && !r.a.a.$ && r.a.b.b && !r.a.b.a.$ && !r.a.b.b.b && !r.b.b;)switch(r.a.b.a.a){
                        case "Nm":
                            return A2(Lc, $p, gp(r.a.a.a));
                        case "Dtex":
                            return A2(Lc, hp, gp(r.a.a.a));
                        default:
                            break n;
                    }
                    return Hr;
                }
                return Rr($p(t.a));
            }(n)));
        }, ai)
    ])), kp = A3(ui, "yarnSize", xp, A4(Ob, "upcycled", qu, !1, A3(ui, "trims", Sb(dm), A3(ui, "surfaceMass", pp, A3(Ba, "product", A2(Zt, ru, ai), A3(ui, "printing", Zm, A3(ui, "price", bp, A3(ui, "physicalDurability", lp, A3(ui, "numberOfReferences", xi, A3(Ba, "materials", Sb(fp), A3(Ba, "mass", A2(Zt, Pf, Js), A3(ui, "makingWaste", rp, A3(ui, "makingDeadStock", rp, A3(ui, "makingComplexity", Wm, A3(ui, "fading", qu, A3(ui, "fabricProcess", Km, A3(ui, "dyeingProcessType", Nm, A4(Ob, "disabledSteps", Sb(up), w, A3(ui, "countrySpinning", xs, A3(ui, "countryMaking", xs, A3(ui, "countryFabric", xs, A3(ui, "countryDyeing", xs, A3(ui, "business", np, A3(ui, "airTransportRatio", rp, nu(function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return function(w) {
                                                                                                return function(y) {
                                                                                                    return {
                                                                                                        cE: n,
                                                                                                        hW: e,
                                                                                                        bx: r,
                                                                                                        bS: t,
                                                                                                        bT: u,
                                                                                                        cT: a,
                                                                                                        cX: i,
                                                                                                        cZ: c,
                                                                                                        b1: o,
                                                                                                        c6: f,
                                                                                                        mR: s,
                                                                                                        dj: l,
                                                                                                        dk: d,
                                                                                                        P: b,
                                                                                                        fn: m,
                                                                                                        ja: p,
                                                                                                        dm: v,
                                                                                                        jn: g,
                                                                                                        dn: h,
                                                                                                        aS: $,
                                                                                                        hf: x,
                                                                                                        pb: k,
                                                                                                        dI: w,
                                                                                                        pR: y
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))), wp = A2(Fu, Qd, is(A2(Fu, ci(kp), $a(yt)))), yp = A2(qd, "QUERY", A2(Fu, wp, A2(Fu, Ld, Rr))), jp = A2(qd, "STRING", Rr), Ep = A2(Pd, F4(function(n, e, r, t) {
        return A2(zm, n, t);
    }), A2(Pm, Cm("textile"), A2(Pm, Cm("simulator"), A2(Pm, jm, A2(Pm, jp, A2(Pm, jp, yp)))))), Ap = Od(E([
        Ep,
        A2(Pd, zm, A2(Pm, Cm("textile"), A2(Pm, Cm("simulator"), A2(Pm, jm, yp))))
    ])), Cp = function(n) {
        return E([
            n
        ]);
    }, Pp = Od(E([
        A2(Pd, $d, Cp),
        A2(Pd, sd, Cm("api")),
        A2(Pd, ld, Cm("auth")),
        A2(Pd, dd, A2(Pm, Cm("auth"), A2(Pm, jp, jp))),
        A2(Pd, bd, A2(Pm, Cm("auth"), Cm("signup"))),
        A2(Pd, md, A2(Pm, Cm("pages"), jp)),
        A2(Pd, xd, Cm("stats")),
        A2(Pd, function(n) {
            return A2(pd, n, Ad(n));
        }, A2(Pm, Cm("explore"), Md)),
        A2(Pd, pd, A2(Pm, Cm("explore"), A2(Pm, Md, Um))),
        A2(Tm, 0, "food2"),
        A2(Tm, 1, "object"),
        A2(Tm, 2, "veli"),
        A2(Pd, hd, Cm("food")),
        A2(Pd, vd, A2(Pm, Cm("food"), A2(Pm, jm, Mb))),
        A2(Pd, gd, A2(Pm, Cm("food"), A2(Pm, Cm("edit-example"), Am))),
        A2(Pd, wd, A2(Pm, Cm("textile"), Cm("simulator"))),
        Ap,
        A2(Pd, kd, A2(Pm, Cm("textile"), A2(Pm, Cm("edit-example"), Am)))
    ])), Tp = F2(function(n, e) {
        return {
            bp: w,
            bQ: Tc,
            eg: e,
            eu: n
        };
    }), Sp = ee("loadRapidoc", function() {
        return Ru;
    }), Ip = ee("scrollTo", function(n) {
        return Mc(E([
            v("x", _o(n.pP)),
            v("y", _o(n.pQ))
        ]));
    }), Op = F2(function(n, e) {
        return $(e, {
            bQ: Uu(E([
                e.bQ,
                Uu(n)
            ]))
        });
    }), qp = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), Lp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mp = F3(function(n, e, r) {
        return {
            $: 12,
            a: n,
            b: e,
            c: r
        };
    }), _p = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), Rp = {
        bX: !1,
        aY: !1,
        aC: "",
        aD: ""
    }, Hp = F2(function(n, e) {
        return A2(Tp, n, {
            jX: !1,
            u: A3(_p, e, Rp, Zu)
        });
    }), Up = F2(function(n, e) {
        return {
            mf: n,
            mE: e
        };
    }), zp = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Dp = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), Np = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(e);
            if (1 === t.$) return A2(zp, t.a, t.b);
            var u = t.a, a = t.c, i = n(t.b)(a);
            if (1 === i.$) {
                var c = i.a;
                return A2(zp, u || c, i.b);
            }
            return c = i.a, A3(Dp, u || c, i.b, i.c);
        };
    }), Fp = Np, Kp = {
        $: 10
    }, Gp = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), Wp = F4(function(n, e, r, t) {
        return {
            h1: e,
            k$: t,
            nO: r,
            oe: n
        };
    }), Vp = {
        $: 0
    }, Jp = F2(function(n, e) {
        return A2(Gp, Vp, A4(Wp, n.oe, n.h1, e, n.k_));
    }), Bp = function(n) {
        return function(e) {
            return s(iu(e.hb), e.h) ? A3(Dp, !1, 0, e) : A2(zp, !1, A2(Jp, e, n));
        };
    }, Xp = Bp(Kp), Qp = kr, Zp = F5(function(n, e, r, t, u) {
        for(;;){
            var a = A3(Qp, n, e, u.hb);
            if (s(a, -1)) return A3(Dp, 0 > m(u.h, e), 0, {
                h1: t,
                k_: u.k_,
                v: u.v,
                h: e,
                oe: r,
                hb: u.hb
            });
            s(a, -2) ? (e += 1, r += 1, t = 1) : (e = a, t += 1);
        }
    }), Yp = function(n) {
        return function(e) {
            return A5(Zp, n, e.h, e.oe, e.h1, e);
        };
    }, nv = Yp, ev = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(e);
            if (1 === t.$) return A2(zp, t.a, t.b);
            var u = t.b, a = t.c;
            return A3(Dp, t.a, A2(n, A3(cu, e.h, a.h, e.hb), u), a);
        };
    }), rv = function(n) {
        return A2(ev, Bi, n);
    }, tv = rv, uv = function(n) {
        return {
            $: 12,
            a: n
        };
    }, av = function(n) {
        return function(e) {
            return A2(zp, !1, A2(Jp, e, n));
        };
    }, iv = function(n) {
        return av(uv(n));
    }, cv = function(n) {
        return function(e) {
            return A3(Dp, !1, n, e);
        };
    }, ov = cv, fv = A2(Fp, function(n) {
        if (iu(n) > 9) return iv("Expected at most 9 digits, but got " + ut(iu(n)));
        var e = gp("0." + n);
        return e.$ ? iv('Invalid float: "' + n + '"') : ov(jf(1e3 * e.a));
    }, tv(nv(ht))), sv = F6(function(n, e, r, t, u, a) {
        return uc(n + 60 * e * 60000 + 60 * (r - a) * 1e3 + 1e3 * t + u);
    }), lv = F3(function(n, e, r) {
        var t = e, u = r;
        return function(e) {
            var r = t(e);
            if (1 === r.$) return A2(zp, r.a, r.b);
            var a = r.a, i = r.b, c = u(r.c);
            if (1 === c.$) {
                var o = c.a;
                return A2(zp, a || o, c.b);
            }
            o = c.a;
            var f = c.c;
            return A3(Dp, a || o, A2(n, i, c.b), f);
        };
    }), dv = F2(function(n, e) {
        return A3(lv, Bi, n, e);
    }), bv = dv, mv = F2(function(n, e) {
        return A3(lv, Mt, n, e);
    }), pv = mv, vv = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), gv = F3(function(n, e, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, u = (0, r.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    e = A2(vv, e, a.b), r = t;
                    continue n;
                }
                return u;
            }
            return A2(zp, !1, e);
        }
    }), hv = function(n) {
        return function(e) {
            return A3(gv, e, Vp, n);
        };
    }, $v = hv, xv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kv = D, wv = {
        $: 11
    }, yv = F2(function(n, e) {
        return function(r) {
            var t = A3(Qp, n, r.h, r.hb);
            return s(t, -1) ? A2(zp, !1, A2(Jp, r, e)) : s(t, -2) ? A3(Dp, !0, 0, {
                h1: 1,
                k_: r.k_,
                v: r.v,
                h: r.h + 1,
                oe: r.oe + 1,
                hb: r.hb
            }) : A3(Dp, !0, 0, {
                h1: r.h1 + 1,
                k_: r.k_,
                v: r.v,
                h: t,
                oe: r.oe,
                hb: r.hb
            });
        };
    }), jv = F4(function(n, e, r, t) {
        for(;;){
            var u = r(e)(t);
            if (u.$) return a = u.a, A2(zp, n || a, u.b);
            var a = u.a, i = u.b, c = u.c;
            if (i.$) return A3(Dp, n || a, i.a, c);
            n = n || a, e = i.a, t = c;
        }
    }), Ev = F2(function(n, e) {
        return function(r) {
            return A4(jv, !1, n, e, r);
        };
    }), Av = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(e);
            if (t.$) return A2(zp, t.a, t.b);
            var u = t.c;
            return A3(Dp, t.a, n(t.b), u);
        };
    }), Cv = Av, Pv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tv = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Sv = function(n) {
        return n.$ ? Pv(n.a) : Tv(n.a);
    }, Iv = F2(function(n, e) {
        return A2(Ev, n, function(n) {
            return A2(Cv, Sv, e(n));
        });
    }), Ov = function(n) {
        var e = function(e) {
            if (s(iu(e), n)) {
                var r = du(e);
                return r.$ ? iv('Invalid integer: "' + e + '"') : A2(Cv, xv, ov(r.a));
            }
            return A2(Cv, function(n) {
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(A2(kv, e, n));
            }, tv(A2(yv, ht, wv)));
        };
        return A2(Iv, "", e);
    }, qv = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Lv = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Mv = xr, _v = function(n) {
        var e = n.a, r = n.b, t = !su(e);
        return function(n) {
            var u = A5(Mv, e, n.h, n.oe, n.h1, n.hb), a = u.a, i = u.b, c = u.c;
            return s(a, -1) ? A2(zp, !1, A2(Jp, n, r)) : A3(Dp, t, 0, {
                h1: c,
                k_: n.k_,
                v: n.v,
                h: a,
                oe: i,
                hb: n.hb
            });
        };
    }, Rv = _v, Hv = function(n) {
        return Rv(A2(Lv, n, qv(n)));
    }, Uv = function(n) {
        return iv("Invalid day: " + ut(n));
    }, zv = function(n) {
        return !(A2(Uc, 4, n) || !A2(Uc, 100, n) && A2(Uc, 400, n));
    }, Dv = function(n) {
        var e = n - 1;
        return (e / 4 | 0) - (e / 100 | 0) + (e / 400 | 0);
    }, Nv = function(n) {
        var e = n.a, r = n.b, t = n.c;
        if (0 > t) return Uv(t);
        var u = function(n) {
            var u = 31536e6 * (e - 1970), a = 864e5 * ((3 > r || !zv(e) ? t - 1 : t) + (Dv(e) - Dv(1970)));
            return ov(n + u + a);
        };
        switch(r){
            case 1:
                return t > 31 ? Uv(t) : u(0);
            case 2:
                return t > 29 || 29 === t && !zv(e) ? Uv(t) : u(26784e5);
            case 3:
                return t > 31 ? Uv(t) : u(50976e5);
            case 4:
                return t > 30 ? Uv(t) : u(7776e6);
            case 5:
                return t > 31 ? Uv(t) : u(10368e6);
            case 6:
                return t > 30 ? Uv(t) : u(130464e5);
            case 7:
                return t > 31 ? Uv(t) : u(156384e5);
            case 8:
                return t > 31 ? Uv(t) : u(183168e5);
            case 9:
                return t > 30 ? Uv(t) : u(209952e5);
            case 10:
                return t > 31 ? Uv(t) : u(235872e5);
            case 11:
                return t > 30 ? Uv(t) : u(262656e5);
            case 12:
                return t > 31 ? Uv(t) : u(288576e5);
            default:
                return iv('Invalid month: "' + ut(r) + '"');
        }
    }, Fv = A2(Fp, Nv, A2(pv, A2(pv, A2(pv, ov(F3(function(n, e, r) {
        return g(n, e, r);
    })), Ov(4)), $v(E([
        A2(pv, A2(bv, ov(ru), Hv("-")), Ov(2)),
        Ov(2)
    ]))), $v(E([
        A2(pv, A2(bv, ov(ru), Hv("-")), Ov(2)),
        Ov(2)
    ])))), Kv = (sc = F3(function(n, e, r) {
        return n * (60 * e) + r;
    }), A2(pv, ov(ru), $v(E([
        A2(Cv, function() {
            return 0;
        }, Hv("Z")),
        A2(pv, A2(pv, A2(pv, ov(sc), $v(E([
            A2(Cv, function() {
                return 1;
            }, Hv("+")),
            A2(Cv, function() {
                return -1;
            }, Hv("-"))
        ]))), Ov(2)), $v(E([
            A2(pv, A2(bv, ov(ru), Hv(":")), Ov(2)),
            Ov(2),
            ov(0)
        ]))),
        A2(bv, ov(0), Xp)
    ])))), Gv = A2(Fp, function(n) {
        return $v(E([
            A2(pv, A2(pv, A2(pv, A2(pv, A2(pv, A2(bv, ov(sv(n)), Hv("T")), Ov(2)), $v(E([
                A2(pv, A2(bv, ov(ru), Hv(":")), Ov(2)),
                Ov(2)
            ]))), $v(E([
                A2(pv, A2(bv, ov(ru), Hv(":")), Ov(2)),
                Ov(2),
                ov(0)
            ]))), $v(E([
                A2(pv, A2(bv, ov(ru), Hv(".")), fv),
                ov(0)
            ]))), A2(bv, Kv, Xp)),
            A2(bv, ov(A6(sv, n, 0, 0, 0, 0, 0)), Xp)
        ]));
    }, Fv), Wv = F3(function(n, e, r) {
        return {
            h1: e,
            nO: r,
            oe: n
        };
    }), Vv = function(n) {
        return A3(Wv, n.oe, n.h1, n.nO);
    }, Jv = F2(function(n, e) {
        n: for(;;)switch(n.$){
            case 0:
                return e;
            case 1:
                var r = n.b;
                n = n.a, e = A2(Ur, r, e);
                continue n;
            default:
                var t = n.b;
                n = n.a, e = A2(Jv, t, e);
                continue n;
        }
    }), Bv = F2(function(n, e) {
        var r = n({
            h1: 1,
            k_: w,
            v: 1,
            h: 0,
            oe: 1,
            hb: e
        });
        return r.$ ? Jr(A2(Jv, r.b, w)) : Zr(r.b);
    }), Xv = F2(function(n, e) {
        var r = A2(Bv, n, e);
        return r.$ ? Jr(A2(ju, Vv, r.a)) : Zr(r.a);
    }), Qv = A2(Qt, function(n) {
        var e = A2(Xv, Gv, n);
        return e.$ ? Ti("Expecting an ISO-8601 formatted date+time string") : nu(e.a);
    }, ai), Zv = A3(ui, "lastAccessedAt", Qv, A3(Ba, "id", ai, nu(Up))), Yv = F2(function(n, e) {
        return A2(at, "/", E([
            n.kU,
            "backend",
            "api",
            e
        ]));
    }), ng = F4(function(n, e, r, t) {
        return za({
            kK: Ea,
            lQ: A2(Cl, A2(Fu, ja, r), t),
            l8: yl(n),
            mZ: "GET",
            oU: Hr,
            o8: Hr,
            a6: A2(Yv, n, e)
        });
    }), eg = F2(function(n, e) {
        return A4(ng, n, "tokens", e, Sb(Zv));
    }), rg = F5(function(n, e, r, t, u) {
        return {
            aY: n,
            aC: e,
            aD: r,
            ck: t,
            oS: u
        };
    }), tg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ug = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), ag = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ig = {
        $: 3
    }, cg = function(n) {
        return {
            $: 4,
            a: n
        };
    }, og = function(n) {
        return {
            $: 5,
            a: n
        };
    }, fg = function(n) {
        return {
            $: 6,
            a: n
        };
    }, sg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, lg = F2(function(n, e) {
        return A2(Qt, function(n) {
            return s(n, e) ? nu(e) : Ti("Unmatched expected value");
        }, n);
    }), dg = K, bg = function(n) {
        return A3(dg, Ur, w, n);
    }, mg = function(n) {
        if (9 !== iu(n)) return Jr("Le num\xe9ro SIREN doit contenir exactement 9 chiffres");
        if (A2(et, ht, n)) {
            var e = A2(ju, A2(Fu, Jc, A2(Fu, du, _c(0))), bg(n)), r = al(A2(bt, F2(function(n, e) {
                if (1 === A2(Uc, 2, n)) {
                    var r = 2 * e;
                    return r > 9 ? r - 9 : r;
                }
                return e;
            }), e));
            return A2(Uc, 10, r) ? Jr("Le num\xe9ro SIREN est invalide") : Zr(n);
        }
        return Jr("Le num\xe9ro SIREN ne doit contenir que des chiffres");
    }, pg = A2(Qt, A2(Fu, mg, Es), ai), vg = Ya(A2(Ur, A3(Ba, "siren", pg, A3(Ba, "name", ai, A3(Ba, "type", A2(lg, ai, "business"), nu(F3(function(n, e, r) {
        return A2(ug, e, r);
    }))))), k(A2(ju, function(n) {
        var e = n.b;
        return A3(Ba, "name", ai, A3(Ba, "type", A2(lg, ai, n.a), nu(F2(function(n, r) {
            return e(r);
        }))));
    }, E([
        v("association", tg),
        v("education", ag),
        v("localAuthority", cg),
        v("media", og),
        v("public", fg),
        v("student", sg)
    ])), E([
        A3(Ba, "type", A2(lg, ai, "individual"), nu(Bi(ig)))
    ])))), gg = A3(Ba, "termsAccepted", qu, A3(Ba, "organization", vg, A4(el, "lastName", ai, "", A4(el, "firstName", ai, "", A4(el, "emailOptin", qu, !1, nu(rg)))))), hg = F4(function(n, e, r, t) {
        return {
            hM: n,
            jG: e,
            jH: r,
            jI: t
        };
    }), $g = A3(Ba, "roleSlug", ai, A3(Ba, "roleName", ai, A3(Ba, "roleId", ai, A3(Ba, "assignedAt", Qv, nu(hg))))), xg = A3(Ba, "roles", Sb($g), A3(Ba, "profile", gg, A3(ui, "magicLinkSentAt", Qv, A3(ui, "lastLoginAt", Qv, A3(ui, "joinedAt", Qv, A3(Ba, "isVerified", qu, A3(Ba, "isSuperuser", qu, A4(Ob, "isBetauser", qu, !1, A3(Ba, "isActive", qu, A3(Ba, "id", A2(Zt, ru, Ms), A4(Ob, "hasActiveToken", qu, !1, A3(Ba, "email", ai, nu(function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        c1: n,
                                                        iE: e,
                                                        mf: r,
                                                        iS: t,
                                                        iU: u,
                                                        mt: a,
                                                        iV: i,
                                                        iY: c,
                                                        mF: o,
                                                        i0: f,
                                                        nP: s,
                                                        jJ: l
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), kg = F2(function(n, e) {
        return A4(ng, n, "me", e, xg);
    }), wg = F2(function(n, e) {
        return A2(Op, E([
            A2(kg, n, A2(Mp, {
                eO: !1
            }, e.f$)),
            A2(eg, n, Lp)
        ]), A2(Hp, n, e));
    }), yg = F2(function(n, e) {
        return A2(Op, E([
            Ip({
                pP: 0,
                pQ: 0
            }),
            Da({
                lQ: ka(A2(Fu, ja, ru)),
                a6: "pages/" + n + ".md"
            })
        ]), A2(Tp, e, {
            h5: Na,
            aI: n
        }));
    }), jg = ee("addBodyClass", Ic), Eg = ee("removeBodyClass", Ic), Ag = F2(function(n, e) {
        return A2(Op, E([
            hc(e.az) ? jg("prevent-scrolling") : Eg("prevent-scrolling")
        ]), A2(Tp, n, e));
    }), Cg = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Pg = F3(function(n, e, r) {
        var t, u = function() {
            switch(e.$){
                case 0:
                case 1:
                case 6:
                    return "Nom";
                case 2:
                case 4:
                case 8:
                    return "Co\xfbt Environnemental";
                case 3:
                case 9:
                default:
                    return "Identifiant";
                case 5:
                    return "Code";
                case 7:
                    return "Cat\xe9gorie de produit";
            }
        }();
        return A2(Ag, r, {
            az: e,
            c5: Zu,
            as: n,
            du: "",
            fM: (t = u, A2(Cg, t, !1))
        });
    }), Tg = F2(function(n, e) {
        return A2(Op, E([
            5 === e.ad.$ ? Eg("prevent-scrolling") : jg("prevent-scrolling")
        ]), A2(Tp, n, e));
    }), Sg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ig = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.g1;
        }, Rt(n))), ys);
    }, Og = function(n) {
        return Ig(Sg(n));
    }, qg = F5(function(n, e, r, t, u) {
        return {
            E: n,
            mm: e,
            cm: r,
            bj: t,
            fT: u
        };
    }), Lg = F2(function(n, e) {
        var r = v(n, e);
        return 1 === r.b.$ ? Jr(r.b.a) : A2(ss, r.b.a, r.a);
    }), Mg = F3(function(n, e, r) {
        for(;;){
            if (!e.b) return Zr(xt(r));
            var t = e.b, u = n(e.a);
            if (u.$) return Jr(u.a);
            e = t, r = A2(Ur, u.a, r);
        }
    }), _g = F2(function(n, e) {
        return A3(Mg, n, e, w);
    }), Rg = F4(function(n, e, r, t) {
        return {
            i: n,
            a_: e,
            P: r,
            jk: t
        };
    }), Hg = function(n) {
        return 4 === n.gl ? 0 : 2;
    }, Ug = F2(function(n, e) {
        var r = v(n, Hg(e));
        n: for(;;)switch(r.a){
            case 0:
                if (2 === r.b) return Jr("Impossible de sp\xe9cifier un acheminement par avion pour cet ingr\xe9dient, son origine par d\xe9faut ne le permet pas.");
                break n;
            case 2:
                if (r.b) break n;
                return Zr(0);
            default:
                break n;
        }
        return Zr(n);
    }), zg = function(n) {
        return bf(n);
    }, Dg = F2(function(n, e) {
        return A2(ws, "Ingr\xe9dient introuvable par id : " + zg(n), ys(A2(ks, A2(Fu, function(n) {
            return n.mf;
        }, Rt(n)), e)));
    }), Ng = F2(function(n, e) {
        var r, t = e.i, u = e.P, a = e.jk, i = A2(Dg, e.mf, n.l1.mm);
        return A2(Lg, A2(is, Ug(a), i), A2(Lg, Zr(u), A2(Lg, i, A2(Lg, (r = A2(Lc, function(e) {
            return A2(js, e, n.bR);
        }, t)).$ ? Zr(Hr) : r.a.$ ? Jr(r.a.a) : Zr(Rr(r.a.a)), Zr(Rg)))));
    }), Fg = function(n) {
        return A2(Fu, function(n) {
            return n.mm;
        }, _g(Ng(n)));
    }, Kg = F2(function(n, e) {
        return {
            j: n,
            t: e
        };
    }), Gg = F2(function(n, e) {
        var r = n.W, t = e.mf;
        return A2(ss, Kg(e.j), A2(Rs, t, r));
    }), Wg = F2(function(n, e) {
        return A2(_g, Gg(n), e.cm);
    }), Vg = F2(function(n, e) {
        for(;;){
            if (!n.b) return Zr(xt(e));
            var r = n.a, t = n.b;
            if (r.$) return Jr(r.a);
            n = t, e = A2(Ur, r.a, e);
        }
    }), Jg = function(n) {
        return A2(Vg, n, w);
    }, Bg = A2(Fu, function(n) {
        return n.bj;
    }, A2(Fu, ju(function(n) {
        return A2(ws, pb(n), ys(A2(ks, A2(Fu, function(n) {
            return n.mf;
        }, Rt(n)), bb)));
    }), Jg)), Xg = F2(function(n, e) {
        return {
            P: n,
            t: e
        };
    }), Qg = F2(function(n, e) {
        var r = n.W;
        return A2(_c, Zr(Hr), A2(Lc, function(n) {
            var e = n.mf;
            return A2(ss, A2(Fu, Xg(n.P), Rr), A2(Rs, e, r));
        }, e.fT));
    }), Zg = F2(function(n, e) {
        return A2(Lg, A2(Qg, n, e), A2(Lg, Bg(e), A2(Lg, A2(Wg, n, e), A2(Lg, A2(Fg, n, e), A2(Lg, Zr(e.E), Zr(qg))))));
    }), Yg = function(n) {
        return su(n) ? Hr : Rr(n);
    }, nh = function(n) {
        var e = n.mm, r = n.cm, t = n.fT, u = A2(Fu, Ho, A2(Fu, jf, ut));
        return A2(at, "; ", A2(La, ru, E([
            Yg(A2(at, ", ", A2(ju, function(n) {
                return n.a_.ei + " (" + u(n.P) + "g.)";
            }, e))),
            A2(Lc, function(n) {
                var e = n.P;
                return Wb(n.t) + "(" + u(e) + ")";
            }, t),
            A2(Lc, rt("Emballage: "), Yg(A2(at, ", ", A2(ju, A2(Fu, function(n) {
                return n.t;
            }, Wb), r))))
        ])));
    }, eh = F2(function(n, e) {
        return e.$ ? n : e.a;
    }), rh = F2(function(n, e) {
        var r = n.bH;
        return A2(_c, A2(eh, "", A2(ss, nh, A2(Zg, n.C, e))), A2(Lc, function(n) {
            return n.ei;
        }, A2(Og, e, r.ao)));
    }), th = F2(function(n, e) {
        switch(n){
            case 0:
                return e.bM;
            case 1:
                return e.bP;
            case 2:
                return e.b_;
            case 3:
                return e.b$;
            case 4:
                return e.b5;
            case 5:
                return e.b6;
            case 6:
                return e.b8;
            case 7:
                return e.b9;
            case 8:
                return e.ca;
            case 9:
                return e.cb;
            case 10:
                return e.cd;
            case 11:
                return e.ce;
            case 12:
                return e.cj;
            case 13:
                return e.cl;
            case 14:
                return e.co;
            case 15:
                return e.cp;
            case 16:
                return e.cs;
            case 17:
                return e.cw;
            case 18:
                return e.cA;
            default:
                return e.bY;
        }
    }), uh = F2(function(n, e) {
        return $(e, {
            aG: $(e.aG, {
                l1: n
            })
        });
    }), ah = F3(function(n, e, r) {
        var t = A2(_c, n.aG.l1, r), u = A2(th, e, n.C.cV);
        return A2(Tg, A2(uh, t, n), {
            dN: 1,
            cI: Hr,
            bu: Hr,
            bv: Hr,
            bw: A2(rh, n, t),
            dU: 1,
            cO: Rl(n) ? 2 : 1,
            O: u,
            db: t,
            ad: xc
        });
    }), ih = F2(function(n, e) {
        return e + n;
    }), ch = function(n) {
        return A3(ot, ih, 0, n);
    }, oh = {
        ag: Hr,
        aa: Hr,
        ah: Hr,
        aj: Hr,
        ak: Hr,
        al: Hr,
        am: Hr
    }, fh = F2(function(n, e) {
        return A2(th, n, e);
    }), sh = F2(function(n, e) {
        return {
            bM: A2(n, 0, e.bM),
            bP: A2(n, 1, e.bP),
            bY: A2(n, 19, e.bY),
            b_: A2(n, 2, e.b_),
            b$: A2(n, 3, e.b$),
            b5: A2(n, 4, e.b5),
            b6: A2(n, 5, e.b6),
            b8: A2(n, 6, e.b8),
            b9: A2(n, 7, e.b9),
            ca: A2(n, 8, e.ca),
            cb: A2(n, 9, e.cb),
            cd: A2(n, 10, e.cd),
            ce: A2(n, 11, e.ce),
            cj: A2(n, 12, e.cj),
            cl: A2(n, 13, e.cl),
            co: A2(n, 14, e.co),
            cp: A2(n, 15, e.cp),
            cs: A2(n, 16, e.cs),
            cw: A2(n, 17, e.cw),
            cA: A2(n, 18, e.cA)
        };
    }), lh = F2(function(n, e) {
        return A2(sh, n, e);
    }), dh = (lc = F2(function(n, e) {
        return lh(F2(function(r, t) {
            return ch(E([
                A2(fh, r, A2(_c, Zs, e(n))),
                t
            ]));
        }));
    }), dc = F3(function(n, e, r) {
        var t = A3(lc, e, r, A2(_c, Zs, r(n)));
        return s(t, Zs) ? Hr : Rr(t);
    }), A2(ot, F2(function(n, e) {
        return {
            ag: A3(dc, n, e, function(n) {
                return n.ag;
            }),
            aa: A3(dc, n, e, function(n) {
                return n.aa;
            }),
            ah: A3(dc, n, e, function(n) {
                return n.ah;
            }),
            aj: A3(dc, n, e, function(n) {
                return n.aj;
            }),
            ak: A3(dc, n, e, function(n) {
                return n.ak;
            }),
            al: A3(dc, n, e, function(n) {
                return n.al;
            }),
            am: A3(dc, n, e, function(n) {
                return n.am;
            })
        };
    }), oh)), bh = A2(ot, function(n) {
        return lh(F2(function(e, r) {
            return ch(E([
                A2(fh, e, n),
                r
            ]));
        }));
    }, Zs), mh = F2(function(n, e) {
        var r = n, t = e;
        return $(t, {
            S: dh(E([
                r.S,
                t.S
            ])),
            g: bh(E([
                r.g,
                t.g
            ])),
            mu: A2(Ur, r, t.mu),
            P: ch(E([
                r.P,
                t.P
            ])),
            au: Hr
        });
    }), ph = F2(function(n, e) {
        return n * e;
    }), vh = function(n) {
        return n;
    }, gh = F2(function(n, e) {
        return A2(ph, n, e);
    }), hh = function(n) {
        return n / 36e5;
    }, $h = function(n) {
        return n / 1e6;
    }, xh = F2(function(n, e) {
        return e * n;
    }), kh = function(n) {
        return lh(function() {
            return ph(n);
        });
    }, wh = F4(function(n, e, r, t) {
        var u = r.d0, a = r.d9, i = t.j, c = t.ai, o = t.g, f = t.mu, s = t.P, l = t.S, d = A2(kh, i, bh(E([
            e.g,
            A2(kh, hh(e.d0), u.g),
            A2(kh, $h(e.d9), a.g)
        ]))), b = A2(gh, e.g0, s), m = A2(xh, e.g0, i);
        return {
            j: m,
            S: l,
            g: bh(E([
                d,
                o
            ])),
            mu: k(f, E([
                {
                    j: m,
                    S: oh,
                    g: d,
                    mu: w,
                    ai: Rr(Wb(e)),
                    P: b,
                    aE: Hr,
                    D: 1,
                    au: Rr(n)
                }
            ])),
            ai: c,
            P: b,
            aE: Hr,
            D: 1,
            au: Hr
        };
    }), yh = F2(function(n, e) {
        return {
            d0: n,
            d9: e
        };
    }), jh = function(n) {
        return A2(Fu, Lc(function(n) {
            return Zr(A2(yh, n.lK, n.ma));
        }), _c(Zr({
            d0: n.Q.ie,
            d9: n.Q.$8
        })));
    }, Eh = F2(function(n, e) {
        return n.$ ? Zr(Hr) : A2(ss, Rr, A2(js, n.a, e));
    }), Ah = F2(function(n, e) {
        return !A2(rl, A2(cc, ul, n), e);
    }), Ch = function(n) {
        switch(n){
            case 0:
                return "m3";
            case 1:
                return "Item(s)";
            case 2:
                return "kg";
            case 3:
                return "kWh";
            case 4:
                return "L";
            case 5:
                return "MJ";
            case 6:
                return "m2";
            default:
                return "t\u22C5km";
        }
    }, Ph = F4(function(n, e, r, t) {
        var u;
        return A2(is, function(r) {
            return A2(is, A2(Fu, jh(n.ay), is(function(n) {
                return A3(ot, function(e) {
                    return ss(A3(wh, 0, e.t, n));
                }, Zr(t), r);
            })), A2(Eh, e, n.C.bR));
        }, (u = r, A2(Ah, A2(Fu, function(n) {
            return n.t;
        }, A2(Fu, function(n) {
            return n.aL;
        }, Rt(2))), u) ? Zr(u) : Jr("Les proc\xe9d\xe9s d\u2019assemblage doivent \xeatre exprim\xe9s en kg\xa0: " + A2(at, ", ", A2(ju, function(n) {
            var e = n.t;
            return Wb(e) + " (" + Ch(e.aL) + ")";
        }, A2(ks, A2(Fu, function(n) {
            return n.t;
        }, A2(Fu, function(n) {
            return n.aL;
        }, Sc(2))), u))))));
    }), Th = ru, Sh = {
        j: Th(0),
        S: oh,
        g: Zs,
        mu: w,
        ai: Hr,
        P: 0,
        aE: Hr,
        D: 1,
        au: Hr
    }, Ih = F3(function(n, e, r) {
        var t = n.W;
        return A2(is, function(n) {
            return A2(_g, function(e) {
                return A2(ss, function(e) {
                    return {
                        i: n,
                        t: e
                    };
                }, A2(Rs, e, t));
            }, r);
        }, A2(Eh, e, n.bR));
    }), Oh = function(n) {
        return n.P;
    }, qh = function(n) {
        return bf(n);
    }, Lh = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.mf;
        }, Rt(n))), A2(Fu, ys, ws("Cat\xe9gorie de produit introuvable id=" + qh(n) + ".")));
    }, Mh = F2(function(n, e) {
        var r = n.C, t = e.q.bg;
        return t.$ ? A2(_c, w, A2(Qa, function(n) {
            return A2(Lc, function(n) {
                return n.q;
            }, Ld(A2(Lh, n, r.dp)));
        }, e.aS)) : t.a;
    }), _h = F3(function(n, e, r) {
        var t = e.q, u = Oh(r.Q), a = A2(Mh, n, e);
        return lf(a) ? Zr($(r, {
            q: Sh,
            aT: u
        })) : A2(is, function(e) {
            var a;
            return A2(ss, function(n) {
                return $(r, {
                    q: n,
                    aT: Oh(n)
                });
            }, A4(Ph, n, t.i, e, {
                j: Th(a = u),
                S: oh,
                g: Zs,
                mu: w,
                ai: Rr("Assembly"),
                P: a,
                aE: Hr,
                D: 1,
                au: Hr
            }));
        }, A3(Ih, n.C, t.i, a));
    }), Rh = F2(function(n, e) {
        return e / n;
    }), Hh = A2(Fu, Rh(1e3), A2(Fu, Ro, nb)), Uh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zh = {
        $: 1
    }, Dh = {
        $: 1
    }, Nh = function(n) {
        return ks(A2(Fu, function(n) {
            return n.g5;
        }, rl(function(e) {
            return A2(tl, e, n);
        })));
    }, Fh = function(n) {
        return ks(Jb(n));
    }, Kh = F2(function(n, e) {
        return A2(ks, A2(Fu, function(n) {
            return n.aL;
        }, Rt(0)), A2(Fh, Dh, A2(Nh, E([
            e
        ]), n.W)));
    }), Gh = function(n) {
        return n.b;
    }, Wh = F2(function(n, e) {
        var r = e.l;
        return A2(Lc, Gh, A2(ra, (0, e.aJ)(n), r));
    }), Vh = function(n) {
        return Wh(n);
    }, Jh = F2(function(n, e) {
        var r = A2(Vh, n, e);
        return r.$ || r.a.$ ? Hr : Rr(r.a.a);
    }), Bh = F2(function(n, e) {
        var r = n.ay, t = n.C, u = n.as, a = e.E;
        if (a.$) {
            var i = A2(Qa, function(n) {
                return A2(Qa, function(n) {
                    return n.E;
                }, Ld(A2(Lh, n, t.dp)));
            }, e.aS);
            return i.$ ? A2(Lc, function(n) {
                return n.mf;
            }, A2(Jh, u, r.E.lk)) : Rr(i.a);
        }
        return Rr(a.a);
    }), Xh = F2(function(n, e) {
        var r = n.C, t = n.as, u = A2(Bh, n, e);
        return u.$ ? Jr(zh) : A2($a, Uh, A2(Rs, u.a, A2(Kh, r, t)));
    }), Qh = F2(function(n, e) {
        var r = n.lK, t = n.ma, u = e.d9;
        return bh(E([
            e.g,
            A2(kh, hh(e.d0), r.g),
            A2(kh, $h(u), t.g)
        ]));
    }), Zh = function(n) {
        return n;
    }, Yh = F3(function(n, e, r) {
        var t = n.ay, u = r.E, a = Hh(r.aT), i = A2(Xh, n, e);
        if (1 === i.$) return i.a.$ ? Zr($(r, {
            E: $(u, {
                eU: a
            })
        })) : Jr(i.a.a);
        var c = i.a;
        return Zr($(r, {
            E: {
                g: A2(kh, a, A2(Qh, t.E.i, c)),
                t: Rr(c),
                eU: a
            }
        }));
    }), n$ = F2(function(n, e) {
        return A2(ph, e, n);
    }), e$ = F2(function(n, e) {
        var r = e.t;
        return A2(_c, Zs, A2(Lc, A2(Fu, function(n) {
            return n.g;
        }, kh(A2(n$, n, e.oD))), r));
    }), r$ = F2(function(n, e) {
        return {
            l: Ui(A2(ju, function(e) {
                var r = e.a, t = e.b;
                return v(n(r), v(r, t));
            }, e)),
            aJ: n
        };
    }), t$ = F3(function(n, e, r) {
        return e ? A2(_c, 1, A2(Wh, r, n._.oi)) : 0;
    }), u$ = F3(function(n, e, r) {
        var t = r, u = A2(cc, A2(cc, Lc(function(e) {
            return v(n, e);
        }), e), Lc(Gh));
        return $(t, {
            l: A3(ma, t.aJ(n), u, t.l)
        });
    }), a$ = F2(function(n, e) {
        if (-2 === e.$) return Qu;
        var r = e.b, t = e.d, u = e.e;
        return A5(ta, e.a, r, A2(n, r, e.c), A2(a$, n, t), A2(a$, n, u));
    }), i$ = F2(function(n, e) {
        var r = e.l, t = e.aJ;
        return {
            l: A2(a$, F2(function(e, r) {
                var t = r.a;
                return v(t, A2(n, t, r.b));
            }), r),
            aJ: t
        };
    }), c$ = function(n) {
        var e;
        return e = n.l, A3(Fr, F3(function(n, e, r) {
            return A2(Ur, e, r);
        }), w, e);
    }, o$ = F3(function(n, e, r) {
        var t = n.ay, u = n.as, a = Oh(r.Q), i = s(r.aT, 0) ? 1 : r.aT / a, c = A3(t$, t, e, u), o = sb(c), f = F2(function(n, e) {
            var r = e.ff, t = e.fi, u = e.fy;
            return v(n, {
                ff: $(r, {
                    g: A2(e$, n, r)
                }),
                fi: $(t, {
                    g: A2(e$, n, t)
                }),
                fy: $(u, {
                    g: A2(e$, n, u)
                })
            });
        });
        return A2(r$, fl, c$(A2(i$, F2(function(n, e) {
            var r = A2(ph, i, e);
            return {
                dV: A2(f, A2(n$, r, c), A2(_c, t._.fI.ib, A2(Wh, n, t._.fI.dV))),
                ek: A2(f, A2(n$, r, o), A2(_c, t._.fI.ib, A2(Wh, n, t._.fI.ek)))
            };
        }), function(n) {
            var e = n;
            return A3(ot, F2(function(n, e) {
                var r = n.c.aE, t = A2(ph, n.a, n.b);
                return A3(u$, A2(_c, 21, r), A2(Fu, Lc(ih(t)), A2(Fu, _c(t), Rr)), e);
            }), os(fl), A2(ks, function(n) {
                var e = n.c.au;
                return !s(n.c.aE, Hr) && s(e, Rr(1));
            }, A2(Id, function(n) {
                var e = n.a, r = n.b.P;
                return A2(ju, function(n) {
                    return g(e, r, n);
                }, n.b.mu);
            }, A2(Id, function(n) {
                var e = n.D;
                return A2(ju, function(n) {
                    return v(e, n);
                }, n.mu);
            }, e.mu))));
        }(r.Q))));
    }), f$ = function(n) {
        return A2(Fu, function(n) {
            return n.gp;
        }, A2(Fu, Vh(n), _c(!1)));
    }, s$ = A2(cc, ju(Gh), c$), l$ = F3(function(n, e, r) {
        return A2(f$, n.as, n.ay._) ? bh(s$(A2(i$, F2(function(n, e) {
            var r = v(e.dV.b, e.ek.b), t = r.a, u = r.b;
            return bh(A2(ju, function(n) {
                return n.g;
            }, E([
                t.ff,
                t.fi,
                t.fy,
                u.ff,
                u.fi,
                u.fy
            ])));
        }), A3(o$, n, e, r)))) : Zs;
    }), d$ = F3(function(n, e, r) {
        return $(r, {
            _: A3(l$, n, e.dq, r)
        });
    }), b$ = function(n) {
        return n;
    }, m$ = function(n) {
        return n;
    }, p$ = F3(function(n, e, r) {
        return $(r, {
            g: bh(A2(ju, function(n) {
                var r = n.a, t = n.b;
                return A2(lh, F2(function(n, r) {
                    return function(n) {
                        return .001 * n;
                    }(e) * Cf(t) * r;
                }), r.g);
            }, E([
                v(n.mL, r.ds),
                v(n.mM, r.oc),
                v(n.kG, r.g7),
                v(n.kH, r.om),
                v(n.nH, r.f1)
            ])))
        });
    }), v$ = F2(function(n, e) {
        var r = n.a8, t = A2(ph, 2, e.ds), u = s(r, 1) ? v(e.f1, 0) : v(0, e.g7);
        return $(e, {
            f1: u.a,
            ds: t,
            g7: u.b
        });
    }), g$ = F2(function(n, e) {
        return e * n;
    }), h$ = F2(function(n, e) {
        var r = e.f1, t = e.ds, u = e.g7, a = function(n) {
            var e = n.ds, r = n.g7;
            return Cf(e) > 0 && 3e3 > Cf(e) ? 1 : Cf(r) ? 0 : 1;
        }(e), i = sb(a), c = sb(n);
        return $(e, {
            f1: A2(ph, n, r),
            ds: A2(ph, A2(g$, a, c), t),
            g7: A2(ph, A2(g$, i, c), u)
        });
    }), $$ = F3(function(n, e, r) {
        var t = v(A2(Qa, Wh(e.cM), A2(Wh, n.cM, r)), A2(Qa, Wh(n.cM), A2(Wh, e.cM, r)));
        return t.a.$ ? t.b.$ ? Jr("Distances not found between " + n.cM + " to " + e.cM) : Zr(t.b.a) : Zr(t.a.a);
    }), x$ = F4(function(n, e, r, t) {
        var u = n.C, a = n.ay.af.id, i = function(n) {
            var r;
            return Rr((r = $(a, {
                ds: ch(E([
                    a.ds,
                    n.e4
                ]))
            }), s(e, 0) ? $(r, {
                f1: 0
            }) : $(r, {
                g7: 0,
                om: 0
            })));
        }, c = v(r, t);
        if (c.a.$) return Zr(c.b.$ ? Hr : i(f = c.b.a));
        if (1 === c.b.$) return Zr(i(o = c.a.a));
        var o = c.a.a, f = c.b.a;
        return A2(ss, Rr, A2(ss, function(n) {
            return $(n, {
                ds: s(o, f) ? o.e4 : ch(E([
                    o.e4,
                    n.ds,
                    f.e4
                ]))
            });
        }, A2(ss, h$(e), A3($$, o, f, u.ls))));
    }), k$ = function(n) {
        return $(n, {
            ds: 0,
            oc: ch(E([
                n.oc,
                n.ds
            ])),
            g7: 0,
            om: ch(E([
                n.om,
                n.g7
            ]))
        });
    }, w$ = F5(function(n, e, r, t, u) {
        var a = n.ay, i = e.a8, c = e.aN;
        return A2(ss, A2(p$, a.af.m3, u), A2(ss, A2(_c, !1, c) ? k$ : ru, A2(ss, _c(A2(v$, e, a.af.id)), A4(x$, n, i, r, t))));
    }), y$ = F6(function(n, e, r, t, u, a) {
        var i = a;
        return A2(ss, function(n) {
            return $(i, {
                g: bh(E([
                    i.g,
                    n.g
                ])),
                mu: k(i.mu, E([
                    {
                        j: i.j,
                        S: oh,
                        g: n.g,
                        mu: w,
                        ai: Rr("Transport"),
                        P: r,
                        aE: Hr,
                        D: 1,
                        au: Rr(3)
                    }
                ]))
            });
        }, A5(w$, n, e, t, u, r));
    }), j$ = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return Zr(e);
            var t = r.b, u = A2(n, r.a, e);
            if (1 === u.$) return u;
            e = u.a, r = t;
        }
    }), E$ = F2(function(n, e) {
        return A2(Ah, A2(Fu, function(n) {
            return n.t;
        }, A2(Fu, function(n) {
            return n.aL;
        }, Rt(n))), e) ? Zr(e) : Jr("Les proc\xe9d\xe9s de transformation ne partagent pas la m\xeame unit\xe9 que la mati\xe8re source (" + Ch(n) + ")\xa0: " + A2(at, ", ", A2(ju, function(n) {
            var e = n.t;
            return Wb(e) + " (" + Ch(e.aL) + ")";
        }, A2(ks, A2(Fu, function(n) {
            return n.t;
        }, A2(Fu, function(n) {
            return n.aL;
        }, Sc(n))), e))));
    }), A$ = F6(function(n, e, r, t, u, a) {
        return A2(ss, Gh, A2(is, A2(j$, F2(function(r, t) {
            var u = r.i, a = r.t, i = t.a, c = t.b;
            return A2(is, function(r) {
                return A2(ss, function(n) {
                    return v(u, A4(wh, 2, a, r, n));
                }, A6(y$, n, $(e, {
                    a8: 0
                }), Oh(c), i, u, c));
            }, A2(jh, n.ay, u));
        }), v(r, a)), A2(E$, t, u)));
    }), C$ = F2(function(n, e) {
        return e / n;
    }), P$ = F2(function(n, e) {
        return A2(tl, 0, A2(ju, vh, n)) ? Jr("Un ratio de variation de quantit\xe9 ne peut pas \xeatre de 0") : Zr(A3(yu, A2(Fu, vh, C$), e, n));
    }), T$ = F3(function(n, e, r) {
        switch(n){
            case 0:
                return $(r, {
                    bM: e(r.bM)
                });
            case 1:
                return $(r, {
                    bP: e(r.bP)
                });
            case 2:
                return $(r, {
                    b_: e(r.b_)
                });
            case 3:
                return $(r, {
                    b$: e(r.b$)
                });
            case 4:
                return $(r, {
                    b5: e(r.b5)
                });
            case 5:
                return $(r, {
                    b6: e(r.b6)
                });
            case 6:
                return $(r, {
                    b8: e(r.b8)
                });
            case 7:
                return $(r, {
                    b9: e(r.b9)
                });
            case 8:
                return $(r, {
                    ca: e(r.ca)
                });
            case 9:
                return $(r, {
                    cb: e(r.cb)
                });
            case 10:
                return $(r, {
                    cd: e(r.cd)
                });
            case 11:
                return $(r, {
                    ce: e(r.ce)
                });
            case 12:
                return $(r, {
                    cj: e(r.cj)
                });
            case 13:
                return $(r, {
                    cl: e(r.cl)
                });
            case 14:
                return $(r, {
                    co: e(r.co)
                });
            case 15:
                return $(r, {
                    cp: e(r.cp)
                });
            case 16:
                return $(r, {
                    cs: e(r.cs)
                });
            case 17:
                return $(r, {
                    cw: e(r.cw)
                });
            case 18:
                return $(r, {
                    cA: e(r.cA)
                });
            default:
                return $(r, {
                    bY: e(r.bY)
                });
        }
    }), S$ = F3(function(n, e, r) {
        var t = r;
        return A3(T$, n, Bi(e), t);
    }), I$ = F2(function(n, e) {
        return A3(S$, 19, A2(ih, A2(fh, 19, e), n), e);
    }), O$ = F2(function(n, e) {
        return {
            ag: n(e.ag),
            aa: n(e.aa),
            ah: n(e.ah),
            aj: n(e.aj),
            ak: n(e.ak),
            al: n(e.al),
            am: n(e.am)
        };
    }), q$ = F2(function(n, e) {
        return O$(Lc(function(r) {
            return A2(kh, n, A2(I$, r, e));
        }));
    }), L$ = A2(Fu, function(n) {
        return n.cK;
    }, La(function(n) {
        return 6 === n.$ ? Rr(n.a) : Hr;
    })), M$ = F2(function(n, e) {
        return 2 === e.aL ? n : n * A2(_c, 0, e.mV);
    }), _$ = F2(function(n, e) {
        var r = Rr(A2(_c, 21, ys(L$(e)))), t = A2(M$, n, e), u = A2(kh, n, e.g), a = A2(_c, oh, A2(Lc, A2(q$, n, Zs), A2(Qa, function(n) {
            return n.kZ;
        }, e.mY)));
        return {
            j: n,
            S: a,
            g: u,
            mu: E([
                {
                    j: n,
                    S: a,
                    g: u,
                    mu: w,
                    ai: Rr(Wb(e)),
                    P: t,
                    aE: r,
                    D: 1,
                    au: Rr(1)
                }
            ]),
            ai: Rr("Element: " + Wb(e)),
            P: t,
            aE: r,
            D: 1,
            au: Hr
        };
    }), R$ = F3(function(n, e, r) {
        return {
            j: n,
            U: e,
            J: r
        };
    }), H$ = F2(function(n, e) {
        return {
            i: n,
            t: e
        };
    }), U$ = function(n) {
        var e = n.bR, r = n.W;
        return A2(Fu, ju(function(n) {
            var t = n.i;
            return A2(Lg, A2(Rs, n.mf, r), A2(Lg, A2(Eh, t, e), Zr(H$)));
        }), Jg);
    }, z$ = F2(function(n, e) {
        var r = n.bR, t = n.W, u = e.j, a = e.U;
        return A2(Lg, A2(U$, n, e.J), A2(Lg, A2(Lg, A2(Rs, a.mf, t), A2(Lg, A2(Eh, a.i, r), Zr(F2(function(n, e) {
            return {
                i: n,
                t: e
            };
        })))), Zr(R$(u))));
    }), D$ = {
        $: 13
    }, N$ = Jb(D$), F$ = F2(function(n, e) {
        return A2(Fu, z$(n.C), is(function(r) {
            var t = r.j, u = r.U, a = r.J;
            return A2(is, function(r) {
                return A6(A$, n, $(e, {
                    aN: Rr(N$(u.t))
                }), u.i, u.t.aL, a, A2(_$, r, u.t));
            }, A2(P$, A2(ju, A2(Fu, function(n) {
                return n.t;
            }, function(n) {
                return n.g0;
            }), a), t));
        }));
    }), K$ = function(n) {
        var e = n.r;
        return A2(Fu, Lc(function(n) {
            return n.r;
        }), _c(e));
    }, G$ = {
        gd: Hr,
        r: w,
        mf: Hr,
        ei: "",
        ju: !1,
        g5: E([
            bs(1)
        ])
    }, W$ = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.mf;
        }, Rt(Rr(n)))), A2(Fu, ys, ws("Aucun composant avec id=" + mf(n))));
    }, V$ = F3(function(n, e, r) {
        for(;;){
            if (0 >= e) return n;
            n = A2(Ur, r, n), e -= 1;
        }
    }), J$ = F2(function(n, e) {
        return A3(V$, w, n, e);
    }), B$ = function(n) {
        return n;
    }, X$ = F2(function(n, e) {
        return e * n;
    }), Q$ = function(n) {
        return ju(function(e) {
            return $(e, {
                j: A2(X$, n, e.j)
            });
        });
    }, Z$ = F2(function(n, e) {
        return A2(ss, function(n) {
            return A2(M$, n.j, n.U.t);
        }, A2(z$, n, e));
    }), Y$ = F3(function(n, e, r) {
        if (r.$) return Zr(1);
        var t = r.a;
        return A2(is, function(n) {
            return s(n, 0) ? Jr("Impossible de sp\xe9cifier la masse unitaire d\u2019un composant lorsque la masse des \xe9l\xe9ments qui le constituent est nulle") : Zr(t / n);
        }, A2(ss, A2(ot, ih, 0), Jg(A2(ju, Z$(n), e))));
    }), nx = F3(function(n, e, r) {
        return e.$ ? Zr(r) : A2(ss, function(n) {
            return A2(Q$, n, r);
        }, A3(Y$, n, r, e));
    }), ex = F3(function(n, e, r) {
        var t = r.Y, u = r.mf, a = r.D, i = r.dH, c = u.$ ? Zr(G$) : A2(W$, u.a, n.C.dX);
        return A2(ss, function(n) {
            var e, r = n.S, u = n.g, i = n.P, o = n.aE, f = n.mu;
            return {
                j: Th(0),
                S: dh(A2(J$, a, r)),
                g: bh(A2(J$, a, u)),
                mu: f,
                ai: (e = A2(Qa, function(n) {
                    return n.ei;
                }, t), e.$ ? A2(eh, Hr, A2(ss, A2(Fu, function(n) {
                    return n.ei;
                }, Rr), c)) : Rr(e.a)),
                P: ch(A2(J$, a, i)),
                aE: o,
                D: a,
                au: Hr
            };
        }, A2(ss, A2(yu, mh, Sh), A2(is, function(r) {
            return A2(is, A2(Fu, ju(A2(F$, n, e)), Jg), A3(nx, n.C, i, A2(K$, r, t)));
        }, c)));
    }), rx = F2(function(n, e) {
        return {
            j: n,
            t: e
        };
    }), tx = function(n) {
        return A2(Fu, ju(function(e) {
            var r = e.bk;
            return A2(ss, rx(e.j), A2(Rs, r, n));
        }), Jg);
    }, ux = function(n) {
        return A2(Fu, ju(function(n) {
            return n;
        }), tx(n));
    }, ax = F3(function(n, e, r) {
        return A2(ss, function(n) {
            return $(r, {
                cm: A2(ju, function(n) {
                    return A2(kh, n.j, n.t.g);
                }, n)
            });
        }, A2(ux, n.C.W, e.aR));
    }), ix = F2(function(n, e) {
        return {
            eD: n,
            eF: e
        };
    }), cx = function(n) {
        return {
            f1: 0,
            g: n,
            ds: 0,
            oc: 0,
            g7: 0,
            om: 0
        };
    }, ox = {
        eD: cx(Zs),
        eF: cx(Zs)
    }, fx = F2(function(n, e) {
        var r = A2(_c, G$, n);
        return e.$ ? r : $(r, {
            r: e.a.r,
            ei: A2(_c, r.ei, e.a.ei)
        });
    }), sx = function(n) {
        return _g(z$(n));
    }, lx = F4(function(n, e, r, t) {
        return A2(ss, function(n) {
            return {
                h3: A2(fx, Rr(t), e),
                r: n,
                D: r
            };
        }, A2(sx, n, A2(K$, t, e)));
    }), dx = F3(function(n, e, r) {
        return {
            h3: n,
            r: e,
            D: r
        };
    }), bx = F3(function(n, e, r) {
        var t = A2(fx, Hr, e);
        return A2(Lg, Zr(r), A2(Lg, A2(sx, n, A2(K$, t, e)), A2(Lg, Zr(t), Zr(dx))));
    }), mx = F2(function(n, e) {
        var r = e.Y, t = e.mf, u = e.D;
        if (t.$) return A3(bx, n, r, u);
        var a = t.a;
        return A2(is, A3(lx, n, r, u), A2(W$, a, n.dX));
    }), px = function(n) {
        return A2(Fu, ju(mx(n)), Jg);
    }, vx = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return Rr(n.a);
            }
            return Hr;
        }
    }, gx = function(n) {
        return A2(_c, n.U.i, A2(Lc, function(n) {
            return n.i;
        }, vx(n.J)));
    }, hx = function(n) {
        return n.mu;
    }, $x = F2(function(n, e) {
        return 0 > n ? Hr : ys(A2(jc, n, e));
    }), xx = F2(function(n, e) {
        var r = n.a;
        return A2(is, A2(Fu, hx, A2(Fu, $x(n.b), ws("\xc9l\xe9ment introuvable"))), A2(ws, "Item introuvable", A2($x, r, hx(e))));
    }), kx = F2(function(n, e) {
        var r = n.C, t = e.aw.aN;
        return t.$ ? A2(_c, !1, A2(Qa, function(n) {
            return A2(Lc, function(n) {
                return n.aN;
            }, Ld(A2(Lh, n, r.dp)));
        }, e.aS)) : t.a;
    }), wx = F3(function(n, e, r) {
        if (1 === e.$) return Jr(e.a);
        var t = e.a;
        return 1 === r.$ ? Jr(r.a) : Zr(A2(n, t, r.a));
    }), yx = A2(ot, F2(function(n, e) {
        var r = n.g, t = n.ds, u = n.oc, a = n.g7, i = n.om;
        return $(e, {
            f1: A2(ih, n.f1, e.f1),
            g: bh(E([
                e.g,
                r
            ])),
            ds: A2(ih, t, e.ds),
            oc: A2(ih, u, e.oc),
            g7: A2(ih, a, e.g7),
            om: A2(ih, i, e.om)
        });
    }), cx(Zs)), jx = F3(function(n, e, r) {
        var t, u, a = n.ay, i = n.C, c = e.q, o = e.aw;
        return 1 === (t = A3(wx, F2(function(t, u) {
            return lf(e.mu) ? u.$ ? Zr($(r, {
                af: ox
            })) : Jr("Une liste de composants vide ne peut \xeatre assembl\xe9e") : A3(wx, F2(function(n, e) {
                return $(r, {
                    af: A2(ix, n, e)
                });
            }), A2(ss, yx, Jg(A2(ju, function(e) {
                var r = e.a, t = e.b, a = e.c;
                return A5(w$, n, $(o, {
                    a8: 0,
                    aN: Rr(N$(t.U.t))
                }), gx(t), u, A2(ph, r, Oh(a)));
            }, t))), A5(w$, n, $(o, {
                aN: Rr(A2(kx, n, e))
            }), u, Rr(a.E.i), r.aT));
        }), A2(is, (u = r.Q, A2(Fu, bt(F2(function(n, e) {
            return A2(bt, F2(function(r, t) {
                return A2(ss, function(n) {
                    return g(e.D, t, n);
                }, A2(xx, v(n, r), u));
            }), e.r);
        })), A2(Fu, Sd, Jg))), A2(px, i, e.mu)), A2(Eh, c.i, i.bR))).$ ? Jr(t.a) : t.a;
    }), Ex = F2(function(n, e) {
        var r = n.d0, t = n.d9;
        return bh(E([
            e.g,
            A2(kh, hh(e.d0), r.g),
            A2(kh, $h(e.d9), t.g)
        ]));
    }), Ax = function(n) {
        return A2(Fu, ju(function(n) {
            return {
                j: A2(_c, Th(0), n.j),
                bk: n.bk
            };
        }), tx(n));
    }, Cx = F2(function(n, e) {
        var r = n.C, t = e.aM;
        return t.$ ? A2(_c, w, A2(Qa, function(n) {
            return A2(Lc, function(n) {
                return n.aM;
            }, Ld(A2(Lh, n, r.dp)));
        }, e.aS)) : t.a;
    }), Px = F3(function(n, e, r) {
        return A2(tl, Vb, e.cK) ? Th(n.aT) : r;
    }), Tx = F3(function(n, e, r) {
        var t = n.ay;
        return A2(ss, function(n) {
            return $(r, {
                bK: A2(ju, function(n) {
                    var e = n.t;
                    return A2(kh, A3(Px, r, e, n.j), A2(Ex, {
                        d0: t.bK.ie,
                        d9: t.bK.$8
                    }, e));
                }, n)
            });
        }, A2(Ax, n.C.W, A2(Cx, n, e)));
    }), Sx = {
        q: Sh,
        E: {
            g: Zs,
            t: Hr,
            eU: 0
        },
        _: Zs,
        cm: w,
        aT: 0,
        Q: Sh,
        af: ox,
        bK: w
    }, Ix = F2(function(n, e) {
        return A2(is, A2(Tx, n, e), A2(is, A2(jx, n, e), A2(ss, A2(d$, n, e), A2(is, A2(Yh, n, e), A2(is, A2(ax, n, e), A2(is, A2(_h, n, e), A2(ss, function(n) {
            return $(Sx, {
                Q: $(n, {
                    ai: Rr("Production")
                })
            });
        }, A2(ss, A2(yu, mh, Sh), Jg(A2(ju, A2(ex, n, e.aw), e.mu))))))))));
    }), Ox = {
        $: 0
    }, qx = function(n) {
        switch(n.$){
            case 0:
                return "Alimentaire";
            case 1:
                return function(n) {
                    switch(n){
                        case 0:
                            return "Alimentaire B\xc9TA";
                        case 1:
                            return "Objets";
                        default:
                            return "V\xe9hicules";
                    }
                }(n.a);
            default:
                return "Textile";
        }
    }, Lx = F2(function(n, e) {
        var r = n.C, t = n.as, u = A2(Rs, e, A2(Nh, E([
            t
        ]), r.W));
        if (1 === u.$) return Jr("Aucun proc\xe9d\xe9 d\u2019assemblage scop\xe9 " + qx(t) + " avec cet id\u202F: " + _s(e));
        var a = u.a;
        return A2(tl, Ox, a.cK) ? 2 !== a.aL ? Jr("Le proc\xe9d\xe9 d\u2019assemblage doit accepter une masse en kg") : Zr(a.mf) : Jr("Le proc\xe9d\xe9 n\u2019est pas un assemblage");
    }), Mx = F3(function(n, e, r) {
        return A2(is, function(e) {
            var t = e.cM;
            return A2(tl, n, e.g5) ? Zr(t) : Jr("Le code pays " + r + " n\u2019est pas utilisable dans un contexte " + qx(n) + ".");
        }, A2(js, r, e));
    }), _x = F2(function(n, e) {
        var r = n.C, t = n.as;
        return e.$ ? Zr(Hr) : A2(ss, Rr, A3(Mx, t, r.bR, e.a));
    }), Rx = F2(function(n, e) {
        return A2(Lg, A2(ss, Bi(e.q.bg), A2(_g, Lx(n), A2(Mh, n, e))), A2(Lg, A2(_x, n, e.q.i), Zr(zb)));
    }), Hx = F2(function(n, e) {
        var r = n.C, t = n.as;
        return A2($a, Bi("Aucun proc\xe9d\xe9 scop\xe9 " + qx(t) + " avec cet id: " + _s(e)), A2(ss, function(n) {
            return n.mf;
        }, A2(Rs, e, A2(Nh, E([
            t
        ]), r.W))));
    }), Ux = F2(function(n, e) {
        return A2(is, function() {
            return A2(Zb, n.C.W, e);
        }, A2(Hx, n, e.bk));
    }), zx = F2(function(n, e) {
        var r = n.C, t = n.as;
        if (e.$) return Zr(Hr);
        var u = e.a, a = A2(Rs, u, r.W);
        if (1 === a.$) return Jr(a.a);
        var i = a.a;
        return A2(tl, Dh, i.cK) ? i.aL ? Jr("Le proc\xe9d\xe9 de distribution doit accepter un volume") : A2(tl, t, i.g5) ? Zr(Rr(u)) : Jr("Le proc\xe9d\xe9 " + _s(u) + " n'est pas disponible pour le p\xe9rim\xe8tre " + qx(t)) : Jr("Le proc\xe9d\xe9 n'est pas une distribution");
    }), Dx = F2(function(n, e) {
        var r = n.as, t = v(A2(f$, r, n.ay.aO), e);
        return t.a || t.b.$ ? Zr(e) : Jr("La durabilit\xe9 n'est pas activ\xe9e pour le p\xe9rim\xe8tre " + qx(r));
    }), Nx = F2(function(n, e) {
        if (1 > e.D) return Jr("La quantit\xe9 doit \xeatre un nombre entier positif");
        var r = e.mf;
        if (r.$) return Zr(e);
        var t = A2(W$, r.a, n);
        return 1 === t.$ ? Jr(t.a) : Zr(e);
    }), Fx = F2(function(n, e) {
        return A2(Lg, A2(Hx, n, e.bk), A2(Lg, Qb(e.j), Zr(bm)));
    }), Kx = F2(function(n, e) {
        return A2(ss, ru, A2(Fx, n, e));
    }), Gx = F2(function(n, e) {
        if (e.$) return Zr(Hr);
        var r = e.a;
        return A2(ss, Rr, A2(is, function(e) {
            return s(n.as, bs(e.as)) ? Zr(r) : Jr("La cat\xe9gorie de produit " + e.ai + " n\u2019est pas disponible pour le p\xe9rim\xe8tre " + qx(n.as));
        }, A2(Lh, r, n.C.dp)));
    }), Wx = F2(function(n, e) {
        var r = n.C;
        return A2($a, function(n) {
            return "Requ\xeate invalide\u202F: " + n;
        }, A2(Lg, Zr(e.aw), A2(Lg, Zr(e.dq), A2(Lg, A2(Gx, n, e.aS), A2(Lg, A2(_g, Kx(n), e.aR), A2(Lg, A2(_g, Nx(r.dX), e.mu), A2(Lg, A2(Dx, n, e.aO), A2(Lg, A2(zx, n, A2(Bh, n, e)), A2(Lg, A2(ss, Bi(e.aM), A2(_g, Ux(n), A2(Cx, n, e))), A2(Lg, A2(Rx, n, e), Zr(Ub)))))))))));
    }), Vx = function(n) {
        return A2(Fu, Wx(n), is(Ix(n)));
    }, Jx = F2(function(n, e) {
        return A2(Op, E([
            e.M.b ? jg("prevent-scrolling") : Eg("prevent-scrolling")
        ]), A2(Tp, n, e));
    }), Bx = function(n) {
        return ks(A2(Fu, function(n) {
            return n.as;
        }, Rt(n)));
    }, Xx = {
        q: Lf,
        aM: Hr,
        E: Hr,
        aO: Hr,
        mu: w,
        aR: w,
        aS: Hr,
        dq: !0,
        aw: Uf
    }, Qx = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.mf;
        }, Rt(n))), A2(Fu, ys, ws("Exemple introuvable pour l'uuid " + bf(n))));
    }, Zx = F2(function(n, e) {
        switch(n){
            case 0:
                return e.aG.fb;
            case 1:
                return e.aG.gN;
            default:
                return e.aG.f_;
        }
    }), Yx = F2(function(n, e) {
        var r;
        return _c(lf((r = A2(Zx, e, n)).mu) ? A2(_c, Xx, A2(Qa, function(e) {
            return A2(Lc, function(n) {
                return n.g1;
            }, Ld(A2(Qx, e, n.C.l5.lP)));
        }, A2(Vh, bs(e), n.h4.lj))) : r);
    }), nk = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), ek = function(n) {
        return A2(Fu, nk(n), Ig);
    }, rk = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.g1;
        }, Rt(n))), A2(Fu, ys, ws("Exemple introuvable")));
    }, tk = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uk = function(n) {
        return 0 > n ? -n : n;
    }, ak = F5(function(n, e, r, t, u) {
        return {
            le: r,
            iR: e,
            je: n,
            fv: t,
            fJ: u
        };
    }), ik = function(n) {
        return E([
            n
        ]);
    }, ck = N, ok = F2(function(n, e) {
        var r = iu(e), t = 0 > m(r, n) ? uk(n - r) : 0;
        return k(e, A2(Xc, t, "0"));
    }), fk = F2(function(n, e) {
        return 1 > n ? "" : A3(cu, -n, iu(e), e);
    }), sk = function(n) {
        return "0" !== A2(fk, 1, n) ? n : sk(A2(Kd, 1, n));
    }, lk = F2(function(n, e) {
        var r = n.le;
        switch(r.$){
            case 1:
                return sk(e);
            case 2:
                return e;
            default:
                return A2(ok, r.a, e);
        }
    }), dk = F2(function(n, e) {
        var r = A2(rl, function(n) {
            return "0" !== n && "." !== n;
        }, bg(e));
        return k(n && r ? "-" : "", e);
    }), bk = function(n) {
        var e = n.a, r = n.b;
        if ("9" === e) {
            var t = kt(r);
            return 1 === t.$ ? "01" : A2(Vc, "0", bk(t.a));
        }
        var u = mt(e);
        return u >= 48 && 57 > u ? A2(Vc, Rd(u + 1), r) : "0";
    }, mk = function(n) {
        return n === 1 / 0 || n === -1 / 0;
    }, pk = U, vk = F3(function(n, e, r) {
        return k(r, A2(Xc, n - iu(r), Jc(e)));
    }), gk = function(n) {
        for(var e = n.length, r = Array(e), t = 0; e > t;){
            var u = n.charCodeAt(t);
            55296 > u || u > 56319 ? (r[e - t] = n[t], t++) : (r[e - t] = n[t + 1], r[e - ++t] = n[t - 1], t++);
        }
        return r.join("");
    }, hk = function(n) {
        var e = A2(it, ".", n);
        return e.b ? v(e.a, e.b.b ? e.b.a : "0") : v("0", "0");
    }, $k = F2(function(n, e) {
        var r = e.b;
        return v(n(e.a), r);
    }), xk = F3(function(n, e, r) {
        if (mk(r) || pk(r)) return Bs(r);
        var t = 0 > r, u = hk(function(n) {
            var e = A2(it, "e", Bs(uk(n)));
            if (e.b) {
                if (e.b.b) {
                    var r = e.a, t = e.b.a, u = A2(_c, 0, du(A2(gu, "+", t) ? A2(ou, 1, t) : t)), a = hk(r), i = k(a.a, a.b), c = 0 > u ? A2(_c, "0", A2(Lc, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Lc, $k(Jc), kt(k(A2(Xc, uk(u), "0"), i))))) : A3(vk, u + 1, "0", i);
                    return k(0 > n ? "-" : "", c);
                }
                return k(0 > n ? "-" : "", r = e.a);
            }
            return "";
        }(uk(r))), a = u.a, i = u.b, c = iu(a) + e, o = k(A2(Xc, 1 - c, "0"), A3(vk, c, "0", k(a, i))), f = iu(o), s = A2(zt, 1, c), l = A2(n, t, A3(cu, s, f, o)), d = A3(cu, 0, s, o), b = l ? gk(A2(_c, "1", A2(Lc, bk, kt(gk(d))))) : d, p = iu(b), v = "0" === b ? b : e > 0 ? 0 > m(e, iu(i)) ? A3(cu, 0, p - e, b) + "." + A3(cu, p - e, p, b) : k(a + ".", A3(vk, e, "0", i)) : k(b, A2(Xc, uk(e), "0"));
        return A2(dk, t, v);
    })(F2(function(n, e) {
        var r, t = kt(e);
        return 1 !== t.$ && ("5" === t.a.a ? "" !== t.a.b || !n : (r = mt(t.a.a)) > 53 && n || r >= 53 && !n);
    })), kk = function(n) {
        return n.b ? Rr(n.b) : Hr;
    }, wk = F2(function(n, e) {
        var r, t = function() {
            var e = n.le;
            switch(e.$){
                case 1:
                default:
                    return xk(e.a);
                case 0:
                    return Bs;
            }
        }(), u = A2(it, ".", t(e)), a = (r = kk(u)).$ ? "" : A2(_c, "", ys(r.a));
        return v(A2(_c, "", ys(u)), a);
    }), yk = F2(function(n, e) {
        var r, t = A2(wk, n, e), u = function(n) {
            var e = function(n) {
                return iu(n) > 3 ? A2(Ur, A2(fk, 3, n), e(A2(Kd, 3, n))) : E([
                    n
                ]);
            };
            return xt(e(n));
        }(A2(ck, ht, t.a)), a = A5(ak, e, u, A2(lk, n, t.b), "", "");
        switch(A2(et, function(n) {
            return "0" === n;
        }, Hc(A2(Td, (r = a).iR, ik(r.le)))) ? 1 : 0 > r.je ? 2 : 0){
            case 2:
                return $(a, {
                    fv: n.fo,
                    fJ: n.gK
                });
            case 0:
                return $(a, {
                    fv: n.jl,
                    fJ: n.jm
                });
            default:
                return $(a, {
                    fv: n.kp,
                    fJ: n.kq
                });
        }
    }), jk = F2(function(n, e) {
        return "" === e ? "" : k(n.bU, e);
    }), Ek = F2(function(n, e) {
        var r = jk(n), t = A2(at, n.cv, e.iR), u = r(e.le);
        return Hc(E([
            e.fv,
            t,
            u,
            e.fJ
        ]));
    }), Ak = F2(function(n, e) {
        return A2(Ek, n, A2(yk, n, e));
    }), Ck = $({
        bU: ".",
        le: {
            $: 0,
            a: 0
        },
        fo: "\u2212",
        gK: "",
        jl: "",
        jm: "",
        cv: "",
        kp: "",
        kq: ""
    }, {
        bU: ",",
        le: tk(3),
        cv: "\u202F"
    }), Pk = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Tk = {
        $: 1
    }, Sk = A2(_c, Ss, Ts("^-?(\\d+\\.?\\d+|\\d+)$")), Ik = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), Ok = {
        $: 1
    }, qk = Cs(A2(_c, Ss, Ts("^-?\\d+$"))), Lk = A2(ot, F2(function(n, e) {
        return 1 === n.$ ? Hr : A2(Lc, Ur(n.a), e);
    }), Rr(w)), Mk = F3(function(n, e, r) {
        for(;;){
            if ("" === r) return e;
            var t = A2(Kd, n, r);
            e = A2(Ur, A2(fk, n, r), e), r = t;
        }
    }), _k = gr($r), Rk = A2(_k, A2(_c, Ss, Ts("^0*")), function() {
        return "";
    }), Hk = function(n) {
        if (qk(n)) {
            var e = A2(gu, "-", n) ? v(1, Rk(A2(ou, 1, n))) : v(0, Rk(n)), r = e.a, t = e.b;
            return su(t) ? Rr(Ok) : A2(Lc, Ik(r), function(n) {
                return Lk(A2(ju, du, A3(Mk, 7, w, n)));
            }(t));
        }
        return Hr;
    }, Uk = F3(function(n, e, r) {
        return 1 === e.$ || 1 === r.$ ? Hr : Rr(A2(n, e.a, r.a));
    }), zk = A2(_k, A2(_c, Ss, Ts("0*$")), function() {
        return "";
    }), Dk = F2(function(n, e) {
        var r = A2(it, ".", e);
        n: for(;;){
            if (r.b) {
                if (r.b.b) {
                    if (r.b.b.b) break n;
                    i = r.a;
                    var t = zk(r.b.a), u = A2(lu, -n, t), a = Hk(k(i, u));
                    return o = -iu(u), A3(Uk, Pk, a, Rr(o));
                }
                var i, c = zk(i = r.a), o = iu(i) - iu(c);
                return A3(Uk, Pk, Hk(c), Rr(o));
            }
            break n;
        }
        return Hr;
    }), Nk = F2(function(n, e) {
        var r = A2(it, "e", Os(e));
        if (r.b && r.b.b && !r.b.b.b) {
            var t = r.b.a, u = A2(it, ".", r.a);
            n: for(;;){
                if (u.b) {
                    if (u.b.b) {
                        if (u.b.b.b) break n;
                        i = u.a;
                        var a = u.b.a;
                        return c = A2(Qa, function(e) {
                            return 0 > m(e, n) ? Hr : Rr(e);
                        }, A2(Lc, function(n) {
                            return n - iu(a);
                        }, du(t))), A3(Uk, Pk, Hk(k(i, a)), c);
                    }
                    var i;
                    if (iu(i = u.a) > 1) return Hr;
                    var c = A2(Qa, function(e) {
                        return 0 > m(e, n) ? Hr : Rr(e);
                    }, du(t));
                    return "0" === i ? Rr(Tk) : A3(Uk, Pk, Hk(i), c);
                }
                break n;
            }
            return Hr;
        }
        return Hr;
    }), Fk = q, Kk = A2(Fk, 10, 7), Gk = F2(function(n, e) {
        for(;;){
            var r = e / Kk | 0;
            if (!r) return xt(A2(Ur, e, n));
            n = A2(Ur, e % Kk, n), e = r;
        }
    })(w), Wk = function(n) {
        switch(A2(ea, n, 0)){
            case 2:
                return A2(Ik, 0, Gk(n));
            case 1:
                return Ok;
            default:
                return A2(Ik, 1, Gk(uk(n)));
        }
    }, Vk = function(n) {
        if (1 === n.$) return "0";
        var e = n.b;
        return k(1 === n.a ? "-" : "", Rk(A3(ot, rt, "", A2(ju, A2(Fu, ut, A2(Qc, 7, "0")), e))));
    }, Jk = Ok, Bk = function(n) {
        var e = zk(Vk(n)), r = Vk(n);
        return v(A2(_c, Jk, Hk(e)), iu(r) - iu(e));
    }, Xk = F2(function(n, e) {
        for(;;){
            if (1 === e.$) return Tk;
            var r = e.b, t = Bk(e.a), u = t.a, a = t.b, i = A2(zt, r + a, n), c = 0 > m(r + a, n) ? A3(Fu, Vk, A2(Fu, Kd(n - (r + a)), A2(Fu, Hk, _c(Jk))), u) : u;
            if (s(c, Wk(0))) return Tk;
            if (!A3(Fu, Vk, Gd("0"), c)) return A2(Pk, c, i);
            e = A2(Pk, c, i);
        }
    }), Qk = A2(_c, Ss, Ts("^-?\\d{1}(\\.\\d*[1-9]|)e{1}-?\\d+$")), Zk = F2(function(n, e) {
        return "0" === e ? Rr(Tk) : A2(Cs, Sk, e) ? A2(Lc, Xk(n), A2(Dk, n, e)) : A2(Cs, Qk, e) ? A2(Lc, Xk(n), A2(Nk, n, e)) : Hr;
    })(-32), Yk = function(n) {
        var e = Vk(n);
        return iu(A2(gu, "-", e) ? A2(ou, 1, e) : e);
    }, nw = F3(function(n, e, r) {
        n: for(;;){
            var t = v(n, e);
            if (t.a.b) {
                if (t.b.b) {
                    var u = t.a, a = t.b;
                    n = u.b, e = a.b, r = A2(Ur, u.a + a.a, r);
                    continue n;
                }
                return k(xt(r), n);
            }
            return t.b.b ? k(xt(r), e) : xt(r);
        }
    }), ew = F2(function(n, e) {
        var r = e.b, t = n + e.a;
        return v(0 > t ? -1 : t / Kk | 0, A2(Ur, A2(Uc, Kk, t), r));
    }), rw = A2(yu, F2(function(n, e) {
        return !n && lf(e) ? w : A2(Ur, n, e);
    }), w), tw = function(n) {
        return rw(xt(function(n) {
            var e = n.a, r = n.b;
            if (e) {
                if (r.b) {
                    var t = r.b;
                    return r.a + e ? A2(Ur, e, r) : t;
                }
                return w;
            }
            return r;
        }(A3(ot, ew, v(0, w), n))));
    }, uw = F2(function(n, e) {
        return tw(A3(nw, n, e, w));
    }), aw = F2(function(n, e) {
        n: for(;;){
            var r = v(n, e);
            if (!r.a.b) return r.b.b ? 0 : 1;
            if (!r.b.b) return 2;
            var t = r.a, u = t.b, a = r.b, i = a.b;
            switch(A2(ea, t.a, a.a)){
                case 2:
                    return 2;
                case 1:
                    n = u, e = i;
                    continue n;
                default:
                    return 0;
            }
        }
    }), iw = F2(function(n, e) {
        switch(A2(ea, ft(n), ft(e))){
            case 2:
                return 2;
            case 0:
                return 0;
            default:
                return A2(aw, xt(n), xt(e));
        }
    }), cw = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;){
            if (1 === r.a.$) return e;
            if (1 === r.b.$) return n;
            if (r.a.a) {
                if (r.b.a) break n;
                switch(A2(iw, t = r.a.b, u = r.b.b)){
                    case 2:
                        return A2(Ik, 1, A2(uw, t, A2(ju, ro, u)));
                    case 1:
                        return Ok;
                    default:
                        return A2(Ik, 0, A2(uw, A2(ju, ro, t), u));
                }
            } else {
                if (1 !== r.b.a) break n;
                switch(A2(iw, t = r.a.b, u = r.b.b)){
                    case 2:
                        return A2(Ik, 0, A2(uw, t, A2(ju, ro, u)));
                    case 1:
                        return Ok;
                    default:
                        return A2(Ik, 1, A2(uw, A2(ju, ro, t), u));
                }
            }
        }
        var t, u, a = r.a;
        return A2(Ik, a.a, A2(uw, t = a.b, u = r.b.b));
    }), ow = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;){
            if (1 === r.a.$) return 1 === r.b.$ ? 1 : r.b.a ? 2 : 0;
            if (1 === r.b.$) return r.a.a ? 0 : 2;
            if (r.a.a) {
                if (r.b.a) break n;
                return 0;
            }
            if (1 === r.b.a) return 2;
            break n;
        }
        var t = r.a, u = t.a, a = r.b, i = a.a, c = A2(iw, t.b, a.b);
        return 1 === u && 1 === i ? function(n) {
            switch(n){
                case 2:
                    return 0;
                case 1:
                    return 1;
                default:
                    return 2;
            }
        }(c) : c;
    }), fw = function(n) {
        return 1 === n.$ ? Ok : n.a ? A2(Ik, 0, n.b) : n;
    }, sw = function(n) {
        return 1 === n.$ ? Ok : A2(Ik, n.a ? 0 : 1, n.b);
    }, lw = F3(function(n, e, r) {
        var t = r.a, u = r.b, a = v(n, e);
        n: for(; !a.a.$;){
            if (a.a.a) {
                if (a.b.$) break n;
                return v(a.b.a ? t : sw(t), sw(u));
            }
            if (a.b.$ || 1 !== a.b.a) break n;
            return v(sw(t), u);
        }
        return v(t, u);
    }), dw = F2(function(n, e) {
        return A2(ju, function(e) {
            return A2(ju, Dt(e), n);
        }, e);
    }), bw = F2(function(n, e) {
        var r;
        return tw(function(n) {
            return A3(ot, uw, w, n);
        }((r = A2(dw, n, e), A3(ot, F2(function(n, e) {
            var r = e.a, t = e.b;
            return v(r + 1, A2(Ur, A2(Td, A2(J$, r, 0), n), t));
        }), v(0, w), r).b)));
    }), mw = F2(function(n, e) {
        var r = v(n, e);
        if (1 === r.a.$) return Ok;
        if (1 === r.b.$) return Ok;
        var t = r.a, u = t.b, a = r.b, i = a.b, c = s(t.a, a.a) ? 0 : 1, o = 2 === A2(ea, ft(u), ft(i)) ? A2(bw, u, i) : A2(bw, i, u);
        return A2(Ik, c, o);
    }), pw = A2(Ik, 0, E([
        1
    ])), vw = F2(function(n, e) {
        var r = v(n, e);
        return 1 === r.a.$ ? sw(e) : 1 === r.b.$ ? n : A2(cw, n, sw(e));
    }), gw = F4(function(n, e, r, t) {
        n: for(;;)switch(A2(ow, n, e)){
            case 0:
                return v(t, n);
            case 1:
                return v(A2(cw, t, pw), Ok);
            default:
                var u = A2(mw, e, Wk(r));
                switch(A2(ow, n, u)){
                    case 0:
                        n = a = n, e = i = e, r = c = r / 2 | 0, t = o = t;
                        continue n;
                    case 1:
                        return v(A2(cw, t, Wk(r)), Ok);
                    default:
                        var a = A2(vw, n, u), i = e, c = r, o = A2(cw, t, Wk(r));
                        n = a, e = i, r = c, t = o;
                        continue n;
                }
        }
    }), hw = function(n) {
        if (1 === n.$) return v(Ok, Ok);
        var e = n.a, r = xt(n.b);
        if (r.b) {
            if (r.b.b) {
                var t = r.b;
                return v(Wk(r.a), A2(Ik, e, xt(t)));
            }
            return v(Wk(r.a), Ok);
        }
        return v(Ok, Ok);
    }, $w = F2(function(n, e) {
        for(;;){
            if (1 === e.$) return Ok;
            if (0 >= n) return e;
            n -= 1, e = A2(Ik, e.a, A2(Ur, 0, e.b));
        }
    }), xw = F4(function(n, e, r, t) {
        for(;;){
            if (1 === v(n, e).a.$) return Rr(v(r, t));
            var u = hw(n), a = u.b, i = A4(gw, A2(cw, u.a, A2($w, 1, t)), e, Kk, Ok), c = i.b;
            n = a, r = A2(cw, i.a, A2($w, 1, r)), t = c;
        }
    }), kw = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;){
            e: for(;;){
                if (1 === r.b.$) {
                    if (1 === r.a.$) break n;
                    return Hr;
                }
                if (1 === r.a.$) break n;
                if (r.b.a) {
                    if (r.b.b.b && 1 === r.b.b.a && !r.b.b.b.b) return Rr(v(sw(n), Ok));
                    break e;
                }
                if (r.b.b.b && 1 === r.b.b.a && !r.b.b.b.b) return Rr(v(n, Ok));
                break e;
            }
            var t = r.a, u = t.a, a = r.b, i = a.a;
            switch(A2(iw, t.b, a.b)){
                case 0:
                    return Rr(v(Ok, n));
                case 1:
                    var c = s(u, i) ? 0 : 1;
                    return Rr(v(A2(Ik, c, E([
                        1
                    ])), Ok));
                default:
                    return A2(Lc, A2(lw, n, e), A4(xw, fw(n), fw(e), Ok, Ok));
            }
        }
        return Rr(v(Ok, Ok));
    }), ww = F2(function(n, e) {
        return 1 === A2(ow, n, e);
    }), yw = F2(function(n, e) {
        return !A2(ow, n, e);
    }), jw = F2(function(n, e) {
        var r = Jk, t = s(A2(yw, n, r), A2(yw, e, r)), u = A2(_c, v(Jk, Jk), A2(kw, n, e)), a = u.a;
        if (A2(ww, u.b, r)) return a;
        switch(A2(ow, a, r)){
            case 0:
                return A2(cw, a, Wk(-1));
            case 1:
                return A2(cw, a, t ? pw : Wk(-1));
            default:
                return A2(cw, a, pw);
        }
    }), Ew = F2(function(n, e) {
        var r = Jk, t = s(A2(yw, n, r), A2(yw, e, r)), u = A2(_c, v(Jk, Jk), A2(kw, n, e)), a = u.a;
        if (A2(ww, u.b, r)) return a;
        switch(A2(ow, a, r)){
            case 0:
                return A2(cw, a, Wk(-1));
            case 1:
                return t ? a : A2(cw, a, Wk(-1));
            default:
                return a;
        }
    }), Aw = F2(function(n, e) {
        return A2(Lc, Gh, A2(kw, n, e));
    }), Cw = F2(function(n, e) {
        var r = A2(_c, v(Jk, Jk), A2(kw, n, e)), t = r.a, u = r.b, a = function() {
            switch(A2(ow, fw(A2(mw, Wk(2), u)), fw(e))){
                case 0:
                    return Jk;
                case 1:
                    if (s(A2(_c, Jk, A2(Aw, t, Wk(2))), Jk)) return Jk;
                    switch(A2(ow, n, Jk)){
                        case 0:
                            return Wk(-1);
                        case 1:
                            return Jk;
                        default:
                            return pw;
                    }
                default:
                    switch(A2(ow, n, Jk)){
                        case 0:
                            return Wk(-1);
                        case 1:
                            return Jk;
                        default:
                            return pw;
                    }
            }
        }();
        return A2(cw, t, a);
    }), Pw = F2(function(n, e) {
        return A2(_c, v(Jk, Jk), A2(kw, n, e)).a;
    }), Tw = F2(function(n, e) {
        var r = Jk, t = s(A2(yw, n, r), A2(yw, e, r)), u = A2(_c, v(Jk, Jk), A2(kw, n, e)), a = u.a;
        if (A2(ww, u.b, r)) return a;
        switch(A2(ow, a, r)){
            case 0:
                return a;
            case 1:
                return t ? A2(cw, a, pw) : a;
            default:
                return A2(cw, a, pw);
        }
    }), Sw = F3(function(n, e, r) {
        switch(n){
            case 0:
                return A2(Ew, e, r);
            case 1:
                return A2(Tw, e, r);
            case 2:
                return A2(Pw, e, r);
            case 3:
                return A2(jw, e, r);
            default:
                return A2(Cw, e, r);
        }
    }), Iw = F2(function(n, e) {
        return 0 > m(n, e) ? n : e;
    }), Ow = F2(function(n, e) {
        if (1 === e.$) return Tk;
        var r = e.a, t = e.b;
        if (1 > m(n.aP, t)) return e;
        if (m(n.aP, Yk(r) + t) > 0) return Tk;
        var u = n.aP - t, a = 11 > u ? Wk(A2(Fk, 10, u)) : A2(_c, Jk, Hk("1" + A2(Xc, u, "0"))), i = A3(Sw, n.ci, r, a);
        return A2(ww, i, Jk) ? Tk : A2(Xk, A2(Iw, n.aP, -32), A2(Pk, i, n.aP));
    }), qw = function(n) {
        return Ow({
            aP: n,
            ci: 4
        });
    }, Lw = F2(function(n, e) {
        switch(A2(ow, n, e)){
            case 2:
            case 1:
                return !0;
            default:
                return !1;
        }
    }), Mw = F2(function(n, e) {
        if (1 === e.$) return "0";
        var r = e.a, t = e.b;
        if (1 === n) {
            var u = function(n) {
                if (1 === n.$) return v(Tk, 0);
                var e = n.a, r = n.b, t = -(Yk(e) - 1);
                return v(A2(Pk, e, t), r - t);
            }(e), a = u.a, i = u.b;
            return k(_w()(a), "e" + ut(i));
        }
        var c = A2(Lw, r, Jk) ? "" : "-", o = Vk(fw(r)), f = function() {
            switch(A2(ea, t, 0)){
                case 2:
                    return k(o, A2(Xc, t, "0"));
                case 1:
                    return o;
                default:
                    switch(A2(ea, iu(o), -t)){
                        case 2:
                            return A2(at, ".", E([
                                A2(Kd, -t, o),
                                A2(fk, -t, o)
                            ]));
                        case 1:
                            return "0." + o;
                        default:
                            return "0." + A3(Qc, -t, "0", o);
                    }
            }
        }();
        return k(c, f);
    });
    function _w() {
        return Mw(0);
    }
    var Rw = _w();
    _w = function() {
        return Rw;
    };
    var Hw, Uw, zw = F2(function(n, e) {
        var r, t = function(n) {
            return A2(Fu, Ak($(Ck, {
                le: tk(n)
            })), A2(Xb, "\u2212", "-"));
        };
        if (pk(e)) return "N/A";
        if (mk(e)) return (0 > e ? "-" : "") + "\u221E";
        if (e) {
            if (s(jf(e), e)) return A2(t, 0, e);
            if (100 > uk(e)) {
                if (.01 > uk(e)) {
                    var u = A2(Mw, 1, A2(qw, -12, (r = e, A2(_c, A2(Pk, Jk, 0), Zk(Bs(r)))))), a = A2(Fu, gp, A2(Fu, _c(0), t(2))), i = A2(it, "e", u);
                    if (i.b && i.b.b && !i.b.b.b) {
                        var c = i.b.a;
                        return a(i.a) + "e" + c;
                    }
                    return A2(t, n, e);
                }
                return A2(t, n, e);
            }
            return A2(t, 0, e);
        }
        return "0";
    }), Dw = F2(function(n, e) {
        return A2(zw, 5, n) + (Ch(e.aL) + " ") + Wb(e);
    }), Nw = F2(function(n, e) {
        return A2(ss, Dw(e.j), A2(Rs, e.U.mf, n));
    }), Fw = F2(function(n, e) {
        var r = e.Y, t = e.mf, u = e.D, a = function(e) {
            return A2(ss, function(n) {
                return ut(u) + " " + A2(fx, Rr(e), r).ei + " [ " + n + " ]";
            }, A2(ss, at(" | "), A2(_g, Nw(n.W), A2(K$, e, r))));
        };
        return t.$ ? a(A2(fx, Hr, r)) : A2(is, a, A2(W$, t.a, n.dX));
    }), Kw = function(n) {
        return A2(Fu, _g(Fw(n)), ss(at(", ")));
    }, Gw = F4(function(n, e, r, t) {
        var u = n.C, a = v(A3(ek, e, t, n.bH.ao), Ld(A2(rk, t, r)));
        return a.a.$ ? a.b.$ ? A2(eh, "N/A", A2(Kw, u, t.mu)) : a.b.a.ei : a.a.a.ei;
    }), Ww = F3(function(n, e, r) {
        var t = r.aG;
        switch(n){
            case 0:
                return $(r, {
                    aG: $(t, {
                        fb: e
                    })
                });
            case 1:
                return $(r, {
                    aG: $(t, {
                        gN: e
                    })
                });
            default:
                return $(r, {
                    aG: $(t, {
                        f_: e
                    })
                });
        }
    }), Vw = F4(function(n, e, r, t) {
        var u = A3(Yx, t, n, r), a = A2(Bx, bs(n), t.C.l5.lP);
        return A2(Op, r.$ ? E([
            Ip({
                pP: 0,
                pQ: 0
            })
        ]) : w, A2(Jx, A3(Ww, n, u, t), {
            dN: 1,
            cI: Hr,
            bu: Hr,
            bv: Hr,
            bw: A4(Gw, t, n, a, u),
            dU: 1,
            cO: Rl(t) ? 2 : 1,
            cQ: "",
            cR: "",
            a9: !1,
            bV: w,
            lP: a,
            b2: Hr,
            iA: n,
            O: A2(th, e, t.C.cV),
            db: u,
            ac: A2(Vx, {
                ay: t.h4,
                C: t.C,
                as: bs(n)
            }, u),
            M: w
        }));
    }), Jw = F3(function(n, e, r) {
        var t = r / e, u = v(.33, 1), a = u.a, i = u.b, c = 0 > m(t, a) ? 1 : m(t, i) > 0 ? 0 : (e - r / i) / (r / a - r / i);
        return function() {
            switch(n){
                case 0:
                    return .67 * c + .33;
                case 1:
                    return .67 * c;
                default:
                    return c;
            }
        }();
    }), Bw = function(n) {
        return n(1.45);
    }, Xw = function(n) {
        return n(.67);
    }, Qw = function(n) {
        return n;
    }, Zw = function(n) {
        return A2(Iw, n.gX, n.i8);
    }, Yw = function(n) {
        var e, r, t, u, a, i, c, o = n.A, f = {
            i8: (e = {
                hW: A2(_c, o.aS.lG.hW, o.hW),
                ja: A2(_c, o.aS.lG.ja, o.ja),
                jn: A2(_c, o.aS.lG.jn, o.jn),
                jB: o.aS.lG.jB
            }, u = A2(Fu, Dt(100), A2(Fu, jf, function(n) {
                return n / 100;
            })), a = al(A2(ju, function(n) {
                return n.a * n.b;
            }, E([
                v(.5, (r = e.ja, t = F2(function(n, e) {
                    return (e - r) / (e - n);
                }), r > 1e3 ? r > 7e3 ? r > 16e3 ? 0 : .5 * A2(t, 7e3, 16e3) : .5 + .5 * A2(t, 1e3, 7e3) : 1)),
                v(.5, A3(Jw, e.hW, e.jn, e.jB))
            ]))), i = v(Xw(ru), Bw(ru)), u((c = i.a) + a * (i.b - c))),
            gX: n.aO.gX
        };
        return $(n, {
            gk: A2(ph, Zw(f), n.gk),
            aO: f,
            pG: jf(n.pG * Zw(f))
        });
    }, ny = function(n) {
        return A2(eh, 1, function() {
            switch(n){
                case 0:
                    return Xs(19);
                case 1:
                    return Xs(5);
                default:
                    return Xs(37);
            }
        }());
    }, ey = F3(function(n, e, r) {
        var t = e, u = v(A2(ph, t, r.d0), A2(ph, t, r.d9)), a = u.a, i = u.b;
        return {
            c3: bh(E([
                A2(kh, hh(a), n.lK.g),
                A2(kh, $h(i), n.ma.g)
            ])),
            d9: i,
            a$: a,
            bg: ik(r),
            o7: A2(kh, A2(g$, t, ny(n.hL)), r.g)
        };
    }), ry = {
        c3: Zs,
        d9: 0,
        a$: 0,
        bg: w,
        o7: Zs
    }, ty = F2(function(n, e) {
        var r = e.hS, t = e.ii, u = e.kk;
        switch(n){
            case 0:
                return E([
                    r
                ]);
            case 1:
            case 2:
                return E([
                    r,
                    t
                ]);
            default:
                return E([
                    u
                ]);
        }
    }), uy = F4(function(n, e, r, t) {
        for(;;){
            if (!r.b) return xt(t);
            var u = r.a, a = r.b, i = n(u);
            A2(tl, i, e) ? r = a : (e = A2(Ur, i, e), r = a, t = A2(Ur, u, t));
        }
    }), ay = function(n) {
        return A4(uy, ru, w, n, w);
    }, iy = F3(function(n, e, r) {
        var t = r.i, u = r.dc;
        return A3(ot, F2(function(n, e) {
            var r = n.d9, t = n.a$, u = n.bg, a = n.o7;
            return $(e, {
                c3: bh(E([
                    e.c3,
                    n.c3
                ])),
                d9: A2(ih, r, e.d9),
                a$: A2(ih, t, e.a$),
                bg: ay(k(e.bg, u)),
                o7: bh(E([
                    e.o7,
                    a
                ]))
            });
        }), ry, A2(Id, function(e) {
            var r = e.U;
            return A2(ju, A2(ey, t, A2(n$, u, e.aH)), A2(ty, r.jd, n));
        }, e));
    }), cy = F2(function(n, e) {
        return e / n;
    }), oy = function(n) {
        return yf(A2(cy, eb(1), n));
    }, fy = function(n) {
        return yf(A2(cy, 1, n));
    }, sy = function(n) {
        return yf(A2(cy, db(1), n));
    }, ly = function(n) {
        return A2(Fu, function(n) {
            return n.g;
        }, fh(n));
    }, dy = F5(function(n, e, r, t, u) {
        var a = eb(u * hh(e.d0)), i = db(u * $h(e.d9));
        return {
            d9: i,
            g: A2(lh, F2(function(n) {
                return ch(E([
                    A2(fy, A2(ly, n, e), u),
                    A2(sy, A2(ly, n, r), i),
                    A2(oy, A2(ly, n, t), a)
                ]));
            }), n),
            a$: a
        };
    }), by = F2(function(n, e) {
        return 2 === e.hC ? n.iF : n.iG;
    }), my = function(n) {
        return 3 === n;
    }, py = F4(function(n, e, r, t) {
        var u = e.hL, a = e.lF;
        return A2(lh, F2(function(n) {
            var e;
            return e = A2(ph, ny(u), A2(fy, A2(ly, n, a), r)), A2(n$, e, t);
        }), n);
    }), vy = F2(function(n, e) {
        var r = n.lB, t = n.lC, u = n.lD;
        n: for(; !e.$;)switch(e.a){
            case 1:
                return t;
            case 2:
                return u;
            default:
                break n;
        }
        return r;
    }), gy = F2(function(n, e) {
        return $(e, {
            ac: n(e.ac)
        });
    }), hy = c, $y = F2(function(n, e) {
        var r = e.d, t = function(e) {
            return e.$ ? Lt(A2(hy, n, e.a)) : Nt(A2(hy, t, e.a));
        };
        return A4(At, e.a, e.b, A2(hy, t, e.c), A2(hy, n, r));
    }), xy = F2(function(n, e) {
        return $y(function(r) {
            return s(r.ai, n) ? e(r) : r;
        });
    }), ky = F2(function(n, e) {
        return gy(A2(xy, n, e));
    }), wy = F2(function(n, e) {
        var r = n.oT, t = e.A;
        return A3(ky, 2, function(n) {
            var e = n.i, u = n.cZ, a = A3(iy, r.pM, t.fn, n), i = A2(by, r.pM, e), c = bh(A2(ju, function(e) {
                var t = e.aH;
                return A4(py, n.g, {
                    hL: n.i.hL,
                    lF: my(e.U.jd) ? r.pM.lE : r.pM.lA
                }, n.nE, t);
            }, t.fn)), o = A5(dy, n.g, A2(vy, r.pM, u), i, e.lK, n.nE), f = o.g, s = o.a$;
            return $(n, {
                d9: ch(E([
                    n.d9,
                    o.d9,
                    a.d9
                ])),
                g: bh(E([
                    n.g,
                    f,
                    c,
                    a.c3,
                    a.o7
                ])),
                a$: ch(E([
                    n.a$,
                    s,
                    a.a$
                ])),
                nL: a
            });
        }, e);
    }), yy = F3(function(n, e, r) {
        var t = e.cS, u = e._, a = e.ma, i = e.nF, c = A2(Rh, .2, e.eU), o = v(ch(E([
            A2(ph, c, i.d0),
            A2(ph, r, u.d0)
        ])), ch(E([
            A2(ph, c, i.d9),
            A2(ph, r, u.d9)
        ]))), f = o.a, s = o.b;
        return {
            d9: s,
            g: A2(lh, F2(function(n) {
                return ch(E([
                    A2(ph, c, A2(ly, n, i)),
                    A2(oy, A2(ly, n, t), f),
                    A2(sy, A2(ly, n, a), s),
                    A2(fy, A2(ly, n, u), r)
                ]));
            }), n),
            a$: f
        };
    }), jy = F2(function(n, e) {
        var r = n.oT;
        return A3(ky, 1, function(n) {
            var t = n.i, u = A3(yy, n.g, {
                cS: t.lK,
                _: r.pM._,
                ma: t.ma,
                nF: r.pM.nF,
                eU: e.A.aS._.eU
            }, n.nE);
            return $(n, {
                d9: u.d9,
                g: u.g,
                a$: u.a$
            });
        }, e);
    }), Ey = F2(function(n, e) {
        switch(e){
            case 0:
                return n.mw;
            case 1:
                return n.mx;
            case 2:
                return n.mz;
            case 3:
                return n.my;
            case 4:
                return n.mA;
            default:
                return n.pL;
        }
    }), Ay = F3(function(n, e, r) {
        for(;;){
            var t = A2(Ft, Et, n), u = t.a, a = t.b;
            if (0 > m(Ut(u), Et)) return A2(Vt, !0, {
                V: e,
                N: r,
                R: u
            });
            n = a, e = A2(Ur, Lt(u), e), r += 1;
        }
    }), Cy = function(n) {
        return n.b ? A3(Ay, n, w, 0) : Ot;
    }, Py = F2(function(n, e) {
        return Cy(A3(Dr, F2(function(e, r) {
            return n(e) ? A2(Ur, e, r) : r;
        }), w, e));
    }), Ty = 4294967295 >>> 32 - It, Sy = u, Iy = F3(function(n, e, r) {
        for(;;){
            var t = A2(Sy, Ty & e >>> n, r);
            if (t.$) return A2(Sy, Ty & e, t.a);
            n -= It, r = t.a;
        }
    }), Oy = function(n) {
        return n >>> 5 << 5;
    }, qy = F2(function(n, e) {
        var r = e.a, t = e.b, u = e.c, a = e.d;
        return 0 > n || m(n, r) > -1 ? Hr : m(n, Oy(r)) > -1 ? Rr(A2(Sy, Ty & n, a)) : Rr(A3(Iy, t, n, u));
    }), Ly = function(n) {
        return A2(Fu, Py(A2(Fu, function(n) {
            return n.ai;
        }, Rt(n))), qy(0));
    }, My = F3(function(n, e, r) {
        return A2(Fu, Ly(n), A2(Fu, Lc(e), _c(r)));
    }), _y = F3(function(n, e, r) {
        var t = e.cS, u = eb(r * hh(e.d0));
        return {
            g: A2(lh, F2(function(n) {
                return A2(oy, A2(ly, n, t), u);
            }), n),
            a$: u,
            ji: Hr,
            j8: Hr
        };
    }), Ry = function(n) {
        return n;
    }, Hy = function(n) {
        return n;
    }, Uy = F2(function(n, e) {
        return jf(n * e * 100);
    }), zy = ru, Dy = F2(function(n, e) {
        return zy(Ef(n) * Tf(e) / 100 / 2 / 1.08);
    }), Ny = F2(function(n, e) {
        return e / n;
    }), Fy = F2(function(n, e) {
        return A2(Ny, n, e);
    }), Ky = F2(function(n, e) {
        var r = e.cS, t = e.nE, u = e.nG, a = e.hf, i = A2(Dy, a, e.pR), c = A2(Uy, i, A2(Fy, a, t)), o = eb(u * c);
        return {
            g: A2(lh, F2(function(n) {
                return A2(oy, A2(ly, n, r), o);
            }), n),
            a$: o,
            ji: Rr(c),
            j8: Rr(i)
        };
    }), Gy = F2(function(n, e) {
        var r = n.oT, t = e.A, u = A4(My, 3, function(n) {
            return n.nE;
        }, 0, e.ac);
        return A3(ky, 3, function(n) {
            var e = n.i, a = A2(Ey, r.pM, A2(_c, t.aS.iv, t.b1)), i = 5 !== A2(_c, t.aS.iv, t.b1) ? A3(_y, n.g, {
                cS: e.lK,
                d0: a.d0
            }, n.nE) : A2(Ky, n.g, {
                cS: e.lK,
                nE: u,
                nG: 3145e-7,
                hf: A2(_c, t.aS.hf, t.hf),
                pR: A2(_c, t.aS.pR, t.pR)
            });
            return $(n, {
                g: i.g,
                a$: i.a$,
                ji: i.ji,
                j8: i.j8
            });
        }, e);
    }), Wy = F2(function(n, e) {
        return e - n;
    }), Vy = F2(function(n, e) {
        var r = A2(Rh, n, e);
        return {
            P: r,
            pK: A2(Wy, e, r)
        };
    }), Jy = F2(function(n, e) {
        return $(e, {
            dc: n,
            nE: n
        });
    }), By = F3(function(n, e, r) {
        return A3(ot, function(n) {
            return A2(xy, n, e);
        }, r, n);
    }), Xy = F2(function(n, e) {
        return gy(A2(By, n, e));
    }), Qy = F2(function(n, e) {
        return n - e;
    }), Zy = F3(function(n, e, r) {
        return $(r, {
            dc: e,
            nE: A2(Qy, e, n),
            pK: n
        });
    }), Yy = F2(function(n, e) {
        var r = e.A, t = e.ac, u = A2(Vy, A2(Ey, n.oT.pM, A2(_c, r.aS.iv, r.b1)).g0, A4(My, 4, function(n) {
            return n.dc;
        }, 0, t)), a = u.P, i = u.pK;
        return A3(Xy, E([
            5,
            6
        ]), Jy(a), A3(ky, 3, A2(Zy, i, a), e));
    }), nj = a, ej = F3(function(n, e, r) {
        var t = r.c, u = r.d, a = F2(function(e, r) {
            return A3(nj, e.$ ? n : a, r, e.a);
        });
        return A3(nj, n, A3(nj, a, e, t), u);
    }), rj = A2(ej, F2(function(n, e) {
        var r = n.g, t = n.eJ;
        return n.gp ? A2(lh, F2(function(n, e) {
            return ch(E([
                A2(fh, n, r),
                e,
                A2(fh, n, t.g)
            ]));
        }), e) : e;
    }), Zs), tj = function(n) {
        return lh(function() {
            return Rh(n);
        });
    }, uj = function(n) {
        return O$(Lc(Rh(n)));
    }, aj = E([
        function(n) {
            return n.ag;
        },
        function(n) {
            return n.aa;
        },
        function(n) {
            return n.ah;
        },
        function(n) {
            return n.aj;
        },
        function(n) {
            return n.ak;
        },
        function(n) {
            return n.al;
        },
        function(n) {
            return n.am;
        }
    ]), ij = function(n) {
        return A2(ju, function(e) {
            return e(n);
        }, aj);
    }, cj = A2(Fu, ij, A2(Fu, ju(_c(0)), ch)), oj = F2(function(n, e) {
        var r = cj(n);
        return A3(S$, 19, A2(ih, r, A2(fh, 19, e)), e);
    }), fj = F3(function(n, e, r) {
        return {
            ag: A2(n, e.ag, r.ag),
            aa: A2(n, e.aa, r.aa),
            ah: A2(n, e.ah, r.ah),
            aj: A2(n, e.aj, r.aj),
            ak: A2(n, e.ak, r.ak),
            al: A2(n, e.al, r.al),
            am: A2(n, e.am, r.am)
        };
    }), sj = F2(function(n, e) {
        return A3(fj, F2(function(n, e) {
            var r = v(n, e);
            return r.a.$ ? r.b.$ ? Hr : Rr(r.b.a) : Rr(r.b.$ ? r.a.a : A2(ih, r.a.a, r.b.a));
        }), n, e);
    }), lj = {
        ag: Hr,
        aa: Hr,
        ah: Hr,
        aj: Hr,
        ak: Hr,
        al: Hr,
        am: Hr
    }, dj = A2(Fu, Nr, A2(Fu, ks(function(n) {
        return n.gp;
    }), A2(Fu, ju(function(n) {
        return n.S;
    }), A2(ot, sj, lj)))), bj = function(n) {
        var e = n.aO, r = n.ac, t = A2(uj, Zw(e), dj(A2(Py, function(n) {
            return n.gp;
        }, r)));
        return $(n, {
            S: t,
            g: bh(E([
                n.g,
                A2(oj, t, A2(tj, Zw(e), rj(r)))
            ]))
        });
    }, mj = F3(function(n, e, r) {
        var t = e.iq, u = e.l0, a = e.ma, i = v(A2(ph, r, u.d9), A2(ph, r, u.d0)), c = i.a, o = i.b;
        return {
            d9: c,
            g: A2(lh, F2(function(n) {
                return ch(E([
                    A2(fy, A2(ly, n, u), r),
                    A2(sy, A2(ly, n, a), c),
                    A2(oy, A2(ly, n, t), o)
                ]));
            }), n),
            a$: o
        };
    }), pj = F2(function(n, e) {
        var r = n.oT;
        return A3(ky, 2, function(n) {
            var e = n.i, t = A3(mj, n.g, {
                iq: e.lK,
                l0: r.pM.l$,
                ma: A2(by, r.pM, e)
            }, n.nE), u = t.g, a = t.a$;
            return $(n, {
                d9: A2(ih, t.d9, n.d9),
                g: bh(E([
                    n.g,
                    u
                ])),
                a$: A2(ih, a, n.a$)
            });
        }, e);
    }), vj = ru, gj = function(n) {
        var e = n.aO, r = n.A;
        return A3(ky, 4, function(n) {
            var t, u;
            return $(n, {
                cE: (t = r.cE, t.$ ? (u = n.i, 2 === u.hC || s(u.cM, vj("TR")) ? 0 : 1 > Zw(e) ? 1 : .33) : t.a)
            });
        }, n);
    }, hj = F3(function(n, e, r) {
        var t = v(r, e);
        n: for(;;){
            if (!t.b.$) return t.b.a;
            if (t.a.$) break n;
            switch(t.a.a){
                case 1:
                    return 5;
                case 2:
                    return 3;
                default:
                    break n;
            }
        }
        return n;
    }), $j = function(n) {
        return n / 60;
    }, xj = function(n) {
        return 60 * n;
    }, kj = function(n) {
        switch(n){
            case 0:
                return xj(60);
            case 1:
                return xj(15);
            case 2:
                return xj(30);
            case 3:
                return xj(0);
            case 4:
                return xj(120);
            default:
                return xj(5);
        }
    }, wj = F3(function(n, e, r) {
        var t = e.cS, u = e.k5, a = e.lZ, i = e.mR, c = eb(.029), o = A2(ph, $j(kj(i)), c), f = v(A2(ph, r, A2(_c, 0, A2(Lc, function(n) {
            return n.d0;
        }, a))), A2(ph, r, A2(_c, 0, A2(Lc, function(n) {
            return n.d9;
        }, a)))), s = f.a, l = f.b;
        return {
            d9: l,
            g: A2(lh, F2(function(n) {
                return ch(E([
                    A2(oy, A2(ly, n, t), o),
                    A2(fy, A2(_c, 0, A2(Lc, ly(n), a)), r),
                    A2(oy, A2(ly, n, t), s),
                    A2(sy, A2(ly, n, u), l)
                ]));
            }), n),
            a$: ch(E([
                o,
                s
            ]))
        };
    }), yj = F2(function(n, e) {
        var r = n.oT, t = e.A;
        return A3(ky, 4, function(n) {
            var e = n.i, u = A3(wj, n.g, {
                cS: e.lK,
                k5: e.ma,
                lZ: s(t.c6, Rr(!0)) ? Rr(r.pM.c6) : Hr,
                mR: A3(hj, t.aS.gH.ge, t.mR, t.b1)
            }, n.nE);
            return $(n, {
                d9: u.d9,
                g: u.g,
                a$: u.a$
            });
        }, e);
    }), jj = .15, Ej = F2(function(n, e) {
        var r = A2(Rh, sb(n), e);
        return {
            lc: A2(Wy, e, r),
            P: r
        };
    }), Aj = E([
        5,
        6,
        3,
        2
    ]), Cj = F3(function(n, e, r) {
        return $(r, {
            lc: n,
            dc: e,
            nE: A2(Qy, e, n)
        });
    }), Pj = function(n) {
        var e = n.ac, r = A2(Ej, A2(_c, jj, n.A.dj), A4(My, 4, function(n) {
            return n.dc;
        }, 0, e)), t = r.lc, u = r.P;
        return A3(Xy, Aj, Jy(u), A3(ky, 4, A2(Cj, t, u), n));
    }, Tj = F3(function(n, e, r) {
        var t = v(r, e);
        n: for(;;){
            if (!t.b.$) return t.b.a;
            if (t.a.$) break n;
            switch(t.a.a){
                case 1:
                    return .02;
                case 2:
                    return 0;
                default:
                    break n;
            }
        }
        return n;
    }), Sj = function(n) {
        return n;
    }, Ij = function(n) {
        var e = n.A, r = A2(Vy, function(n) {
            return 1 - n;
        }(A3(Tj, e.aS.gH.jg, e.dk, e.b1)), e.P), t = r.P, u = r.pK;
        return A3(Xy, Aj, Jy(t), A3(ky, 4, A2(Zy, u, t), n));
    }, Oj = function(n) {
        return bf(n);
    }, qj = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.mf;
        }, Rt(n))), A2(Fu, ys, ws("Mati\xe8re non trouv\xe9e id=" + Oj(n) + ".")));
    }, Lj = F2(function(n, e) {
        return v(n, e);
    }), Mj = F2(function(n, e) {
        return A3(Uk, Lj, A2(Qa, function(n) {
            return Ld(A2(qj, n, e));
        }, n.g3), n.kP);
    }), _j = F3(function(n, e, r) {
        return A2(lh, F2(function(n) {
            return A2(fy, A2(ly, n, e), r);
        }), n);
    }), Rj = F3(function(n, e, r) {
        var t = e.kP, u = e.nh, a = e.nY, i = t.mS, c = t.nZ;
        return A2(lh, F2(function(n) {
            var e = v(A2(ly, n, a), A2(ly, n, u)), t = e.b;
            return r * (A2(g$, e.a, i) + A2(g$, c, sb(i)) * t);
        }), n);
    }), Hj = F3(function(n, e, r) {
        var t = A2(Mj, e, n.oT.fn);
        if (t.$) return A3(_j, r.g, e.t, r.nE);
        var u = t.a;
        return A3(Rj, r.g, {
            kP: u.b,
            nh: u.a.t,
            nY: e.t
        }, r.nE);
    }), Uj = F2(function(n, e) {
        var r = e.A;
        return A3(ky, 5, function(e) {
            return $(e, {
                g: bh(A2(ju, function(r) {
                    var t = r.aH;
                    return A2(lh, function() {
                        return ph(t);
                    }, A3(Hj, n, r.U, e));
                }, r.fn))
            });
        }, e);
    }), zj = function(n) {
        var e, r = n.A, t = (e = A4(My, 6, function(n) {
            return n.dc;
        }, 0, n.ac), A3(ot, F2(function(n, e) {
            return {
                P: A2(ih, e.P, n.P),
                pK: A2(ih, e.pK, n.pK)
            };
        }), {
            P: 0,
            pK: 0
        }, A2(ju, function(n) {
            return A2(Vy, n.U.t.g0, A2(ph, n.aH, e));
        }, r.fn)));
        return A3(ky, 5, A2(Zy, t.pK, t.P), n);
    }, Dj = F2(function(n, e) {
        return n ? {
            nM: e.jr,
            nN: e.jo
        } : {
            nM: e.jq,
            nN: e.jp
        };
    }), Nj = function(n) {
        return yf(A2(cy, 1, n));
    }, Fj = F4(function(n, e, r, t) {
        var u = e.hL, a = e.nN, i = e.hf;
        return A2(lh, F2(function(n) {
            var e;
            return e = A2(ph, ny(u), A2(Nj, A2(ly, n, a), A2(Fy, i, t))), A2(n$, e, r);
        }), n);
    }), Kj = F3(function(n, e, r) {
        var t = e.iq, u = e.ma, a = e.nM, i = e.nT, c = A2(n$, A2(Fy, e.hf, r), i), o = c, f = v(A2(ph, o, a.d9), A2(ph, o, a.d0)), s = f.a, l = f.b;
        return {
            d9: s,
            g: A2(lh, F2(function(n) {
                return ch(E([
                    A2(Nj, A2(ly, n, a), c),
                    A2(sy, A2(ly, n, u), s),
                    A2(oy, A2(ly, n, t), l)
                ]));
            }), n),
            a$: l
        };
    }), Gj = F2(function(n, e) {
        var r = n.oT, t = e.A;
        return A3(ky, 2, function(n) {
            var e = n.i, u = n.dn;
            if (u.$) return n;
            var a = u.a.nT, i = A2(Dj, u.a.gF, r.pM), c = i.nM, o = A4(Fj, n.g, {
                hL: n.i.hL,
                nN: i.nN,
                hf: A2(_c, t.aS.hf, t.hf)
            }, a, n.nE), f = A3(Kj, n.g, {
                iq: e.lK,
                ma: A2(by, r.pM, e),
                nM: c,
                nT: a,
                hf: A2(_c, t.aS.hf, t.hf)
            }, n.nE), s = f.g, l = f.a$;
            return $(n, {
                d9: A2(ih, f.d9, n.d9),
                g: bh(E([
                    n.g,
                    s,
                    o
                ])),
                a$: A2(ih, l, n.a$)
            });
        }, e);
    }), Wj = function(n) {
        return 3 === n ? 1 : 0;
    }, Vj = {
        gf: {
            i9: 4,
            pK: A2(eh, 0, Xs(12))
        },
        hh: {
            i9: 1.5,
            pK: A2(eh, 0, Xs(3))
        },
        hx: {
            i9: 2,
            pK: A2(eh, 0, Xs(12))
        }
    }, Jj = F3(function(n, e, r) {
        return Tf(e) / 50 * function(n) {
            switch(n){
                case 0:
                    return Vj.gf.i9;
                case 1:
                    return Vj.hh.i9;
                default:
                    return Vj.hx.i9;
            }
        }(r) * n;
    }), Bj = F2(function(n, e) {
        var r = e.cS, t = e.oC;
        return {
            d9: 0,
            g: A2(lh, F2(function(n) {
                return A2(oy, A2(ly, n, r), t);
            }), n),
            a$: t
        };
    }), Xj = F4(function(n, e, r, t) {
        var u = A2(_c, r.pR, t.pR), a = A2(_c, Wj(n.jd), e), i = eb(A3(Jj, t.nE, u, a));
        return A2(Bj, t.g, {
            cS: t.i.lK,
            oC: i
        });
    }), Qj = function(n) {
        var e = n.A;
        return A3(ky, 6, function(n) {
            return $(n, {
                g: bh(A2(ju, function(r) {
                    var t = r.aH;
                    return A2(lh, function() {
                        return ph(t);
                    }, A4(Xj, r.U, r.dz, e.aS, n).g);
                }, e.fn)),
                a$: A3(ot, ih, 0, A2(ju, function(r) {
                    return A2(ph, r.aH, A4(Xj, r.U, r.dz, e.aS, n).a$);
                }, e.fn))
            });
        }, n);
    }, Zj = F2(function(n, e) {
        return n / e;
    }), Yj = function(n) {
        var e, r = n.A, t = (e = A4(My, 3, function(n) {
            return n.dc;
        }, 0, n.ac), A3(ot, F2(function(n, e) {
            return {
                P: A2(ih, e.P, n.P),
                pK: A2(ih, e.pK, n.pK)
            };
        }), {
            P: 0,
            pK: 0
        }, A2(ju, function(n) {
            var r = n.aH, t = n.dz, u = function(n) {
                switch(n){
                    case 0:
                        return Vj.gf.pK;
                    case 1:
                        return Vj.hh.pK;
                    default:
                        return Vj.hx.pK;
                }
            }(A2(_c, Wj(n.U.jd), t)), a = A2(ph, r, e), i = A2(Zj, a, sb(u));
            return {
                P: i,
                pK: A2(Qy, i, a)
            };
        }, r.fn)));
        return A3(ky, 6, A2(Zy, t.pK, t.P), n);
    }, nE = 1 / 0, eE = F4(function(n, e, r, t) {
        var u = v(A2(Qa, Wh(r), A2(Wh, e, t)), A2(Qa, Wh(e), A2(Wh, r, t)));
        return u.a.$ ? u.b.$ ? function(n) {
            return {
                f1: nE,
                g: n,
                ds: nE,
                oc: nE,
                g7: nE,
                om: nE
            };
        }(n) : $(u.b.a, {
            g: n
        }) : $(u.a.a, {
            g: n
        });
    }), rE = F3(function(n, e, r) {
        var t = r.i, u = r.U;
        return s(r.aH, 0) ? cx(Zs) : A4(eE, Zs, A2(_c, u.ic, A2(Lc, function(n) {
            return n.cM;
        }, t)), e, n);
    }), tE = F3(function(n, e, r) {
        return A2(ph, Cf(e), A2(fy, n, A2(Rh, 1e3, r)));
    }), uE = F5(function(n, e, r, t, u) {
        var a = e.cD, i = e.dt, c = u.f1, o = u.ds, f = u.g7;
        return {
            f1: c,
            g: A2(lh, F2(function(n) {
                var e = g(A3(tE, A2(ly, n, r), o, t), A3(tE, A2(ly, n, i), f, t), A3(tE, A2(ly, n, a), c, t));
                return ch(E([
                    e.a,
                    e.b,
                    e.c
                ]));
            }), n),
            ds: o,
            oc: 0,
            g7: f,
            om: 0
        };
    }), aE = F4(function(n, e, r, t) {
        var u = n.ls, a = n.oT;
        return A5(uE, Zs, a.pM, a.pM.cr, A2(n$, r, t.aH), A2(h$, 0, A3(rE, u, e.cM, t)));
    }), iE = F2(function(n, e) {
        return $(e, {
            f1: A2(ih, n.f1, e.f1),
            ds: A2(ih, n.ds, e.ds),
            g7: A2(ih, n.g7, e.g7)
        });
    }), cE = F2(function(n, e) {
        var r = cx(n.eJ.g);
        switch(n.ai){
            case 0:
                return A2(iE, $(r, {
                    ds: vl(500)
                }), r);
            case 1:
            case 7:
                return r;
            case 4:
                return A2(h$, n.cE, e);
            default:
                return A2(h$, 0, e);
        }
    }), oE = F2(function(n, e) {
        return 4 === e.ai ? n.P : e.nE;
    }), fE = F4(function(n, e, r, t) {
        var u = t.aF, a = 5 === t.ai ? yx(A2(ju, A3(aE, n, r.i, t.nE), e.fn)) : A5(uE, t.eJ.g, n.oT.pM, n.oT.pM.cr, A2(oE, e, t), A2(cE, t, A4(eE, t.eJ.g, t.i.cM, r.i.cM, n.ls)));
        return $(t, {
            aF: $(u, {
                cD: Rr(Wb(n.oT.pM.cD)),
                cr: Rr(Wb(n.oT.pM.cr)),
                dt: Rr(Wb(n.oT.pM.dt))
            }),
            eJ: a
        });
    }), sE = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return Hr;
            var t = r.b;
            if (e(r.a)) return Rr(n);
            n += 1, r = t;
        }
    }), lE = sE(0), dE = F2(function(n, e) {
        return v(A2(Kc, n, e), A2(jc, n, e));
    }), bE = F2(function(n, e) {
        return A2(Lc, function(n) {
            return A2(dE, n, e);
        }, A2(lE, n, e));
    }), mE = function(n) {
        return A2(Fu, Nr, A2(Fu, bE(A2(Fu, function(n) {
            return n.ai;
        }, Rt(n))), A2(Fu, Lc(Gh), Qa(A2(Fu, ks(function(n) {
            return n.gp;
        }), A2(Fu, jc(1), ys))))));
    }, pE = F3(function(n, e, r) {
        return A2($y, function(t) {
            return t.gp ? A4(fE, n, e, A2(_c, t, A2(mE, t.ai, r)), t) : t;
        }, r);
    }), vE = F2(function(n, e) {
        return A2(gy, A2(pE, n, e.A), e);
    }), gE = A2(ej, F2(function(n, e) {
        var r = n.eJ;
        return $(e, {
            f1: A2(ih, r.f1, e.f1),
            g: A2(lh, F2(function(n, e) {
                return ch(E([
                    e,
                    A2(fh, n, r.g)
                ]));
            }), e.g),
            ds: A2(ih, r.ds, e.ds),
            g7: A2(ih, r.g7, e.g7)
        });
    }), cx(Zs)), hE = function(n) {
        return $(n, {
            eJ: gE(n.ac)
        });
    }, $E = function(n) {
        return n.g;
    }, xE = F2(function(n, e) {
        var r = e.q;
        return $(e, {
            q: $(r, {
                i: lf(n) ? Hr : r.i
            }),
            mu: n
        });
    }), kE = F2(function(n, e) {
        var r = e.h4, t = e.aO, u = e.A;
        return A2(ss, function(n) {
            return $(e, {
                g: bh(E([
                    e.g,
                    A2(tj, Zw(t), n)
                ])),
                dF: n
            });
        }, A2(ss, A2(Fu, function(n) {
            return n.Q;
        }, $E), A2(Ix, {
            ay: r,
            C: n,
            as: ms
        }, A2(xE, u.pb, Xx))));
    }), wE = F3(function(n, e, r) {
        var t = e.cS, u = e.ng, a = e.pG, i = A2(ph, a, ch(E([
            e.ms,
            A2(ph, r, u.d0)
        ])));
        return {
            d9: 0,
            g: A2(lh, F2(function(n) {
                return ch(E([
                    A2(oy, A2(ly, n, t), i),
                    A2(ph, a, A2(fy, A2(ly, n, u), r))
                ]));
            }), n),
            a$: i
        };
    }), yE = F2(function(n, e) {
        var r = n.oT, t = e.A, u = e.pG;
        return A3(ky, 7, function(n) {
            var e = A3(wE, n.g, {
                cS: r.pM.mQ,
                ms: t.aS.bK.ms,
                ng: t.aS.bK.ng,
                pG: u
            }, n.nE);
            return $(n, {
                g: e.g,
                a$: e.a$
            });
        }, e);
    }), jE = F2(function(n, e) {
        var r = e.h4, t = e.A, u = A2(eh, 0, A2(ss, A2(Fu, function(n) {
            return n.Q;
        }, Oh), A2(Ix, {
            ay: r,
            C: n,
            as: ms
        }, A2(xE, t.pb, Xx))));
        return A3(Xy, E([
            5,
            6,
            3,
            2
        ]), function(n) {
            return $(n, {
                dc: A2(Wy, u, n.dc),
                nE: A2(Wy, u, n.nE)
            });
        }, e);
    }), EE = F3(function(n, e, r) {
        return 0 > m(r, n) ? n : m(r, e) > 0 ? e : r;
    }), AE = function(n) {
        return n / 86400;
    }, CE = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return function(w) {
                                                                                                return function(y) {
                                                                                                    return function(j) {
                                                                                                        return function(E) {
                                                                                                            return function(A) {
                                                                                                                return function(C) {
                                                                                                                    return {
                                                                                                                        cE: n,
                                                                                                                        hW: e,
                                                                                                                        gg: r,
                                                                                                                        bx: t,
                                                                                                                        gh: u,
                                                                                                                        bS: a,
                                                                                                                        bT: i,
                                                                                                                        h7: c,
                                                                                                                        cT: o,
                                                                                                                        gi: f,
                                                                                                                        cX: s,
                                                                                                                        cZ: l,
                                                                                                                        b1: d,
                                                                                                                        c6: b,
                                                                                                                        mR: m,
                                                                                                                        dj: p,
                                                                                                                        dk: v,
                                                                                                                        P: g,
                                                                                                                        fn: h,
                                                                                                                        ja: $,
                                                                                                                        dm: x,
                                                                                                                        jn: k,
                                                                                                                        dn: w,
                                                                                                                        aS: y,
                                                                                                                        hf: j,
                                                                                                                        pb: E,
                                                                                                                        dI: A,
                                                                                                                        pR: C
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, PE = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.mf;
        }, Rt(n))), A2(Fu, ys, ws("Produit non trouv\xe9 id=" + n + ".")));
    }, TE = vj("FR"), SE = F2(function(n, e) {
        return A2(Fu, ju(function(r) {
            var t = r.i, u = r.mf, a = r.aH, i = r.dz, c = t.$ ? Zr(Hr) : A2(ss, Rr, A2(js, t.a, e));
            return A3(wx, F2(function(n, e) {
                return {
                    i: e,
                    U: n,
                    aH: a,
                    dz: i
                };
            }), A2(qj, u, n), c);
        }), Jg);
    }), IE = T, OE = A2(Fu, IE(A2(Fu, function(n) {
        return n.aH;
    }, Qo)), A2(Fu, xt, A2(Fu, ys, A2(Fu, Lc(function(n) {
        return n.U;
    }), ws("La liste de mati\xe8res est vide."))))), qE = F2(function(n, e) {
        return 1 === n.$ ? e : n;
    }), LE = F2(function(n, e) {
        return A2(qE, e, n);
    }), ME = "---", _E = F2(function(n, e) {
        var r, t = n.bR, u = n.oT, a = A2(js, ME, t), i = (r = e.pb).$ ? A2(ss, function(n) {
            return n.pb;
        }, A2(PE, e.aS, u.dp)) : Zr(r.a), c = A3(SE, u.fn, t, e.fn), o = A2(LE, a, A2(is, function(n) {
            return A2(Fu, OE, is(function(e) {
                return A2(js, e.ic, n);
            }));
        }(t), c)), f = F2(function(n, e) {
            return e.$ ? n : A2(js, e.a, t);
        }), s = A2(js, TE, t);
        return A2(Lg, Zr(e.pR), A2(Lg, Zr(e.dI), A2(Lg, i, A2(Lg, Zr(e.hf), A2(Lg, A2(PE, e.aS, u.dp), A2(Lg, Zr(e.dn), A2(Lg, Zr(e.jn), A2(Lg, Zr(e.dm), A2(Lg, Zr(e.ja), A2(Lg, c, A2(Lg, Zr(e.P), A2(Lg, Zr(e.dk), A2(Lg, Zr(e.dj), A2(Lg, Zr(e.mR), A2(Lg, Zr(e.c6), A2(Lg, Zr(e.b1), A2(Lg, Zr(e.cZ), A2(Lg, Zr(e.cX), A2(Lg, s, A2(Lg, A2(f, a, e.cT), A2(Lg, o, A2(Lg, A2(f, a, e.bT), A2(Lg, A2(f, a, e.bS), A2(Lg, s, A2(Lg, A2(f, a, e.bx), A2(Lg, s, A2(Lg, Zr(e.hW), A2(Lg, Zr(e.cE), Zr(CE)))))))))))))))))))))))))))));
    }), RE = function(n) {
        return n.dI ? $(n, {
            cX: ay(k(Aj, n.cX)),
            mR: Rr(A2(_c, 0, n.mR))
        }) : n;
    }, HE = {
        cD: Hr,
        cE: Hr,
        ba: Hr,
        dZ: Hr,
        E: Hr,
        gn: Hr,
        _: Hr,
        iv: Hr,
        c6: Hr,
        gH: Hr,
        nF: Hr,
        dn: Hr,
        cr: Hr,
        dt: Hr,
        fX: Hr,
        fY: Hr
    }, UE = function(n) {
        return n(1);
    }, zE = function(n) {
        return A2(Fu, La(function(e) {
            var r = e.aH;
            return s(e.U.jd, n) ? Rr(zf(r)) : Hr;
        }), A2(Fu, al, A2(Fu, Xs, eh(0))));
    }, DE = function(n) {
        return A2(eh, 0, ep(50 > zf(A2(zE, 3, n)) ? .049 : .121));
    }, NE = function(n) {
        var e = n.P, r = DE(n.fn) * e * 5e3;
        return s(r, 0) ? Hr : Rr(r);
    }, FE = function(n) {
        switch(n){
            case 0:
                return 330;
            case 1:
                return 390;
            case 2:
                return 250;
            default:
                return 820;
        }
    }, KE = F2(function(n, e) {
        var r = e.U;
        return A2(ph, A2(n$, n, e.aH), FE(r.jd));
    }), GE = function(n) {
        var e = n.fn, r = ch(A2(ju, KE(n.P), e));
        return s(r, 0) ? Hr : Rr(r);
    }, WE = F3(function(n, e, r) {
        var t, u = n.pM, a = r.i, i = r.S, c = e.cZ, o = e.mR, f = e.dj, s = e.dk, l = e.dn, d = e.hf, b = e.pR;
        switch(r.ai){
            case 0:
                return $(r, {
                    aF: $(HE, {
                        E: Rr(Wb(u.E))
                    })
                });
            case 1:
                return $(r, {
                    S: $(i, {
                        ak: NE(e)
                    }),
                    aF: $(HE, {
                        ba: Rr(Wb(a.lK)),
                        dZ: Rr(Wb(a.ma)),
                        _: Rr(Wb(u._)),
                        nF: Rr("Transport en voiture vers point de collecte (1km)")
                    })
                });
            case 2:
                return $(r, {
                    cZ: c,
                    dn: l,
                    aF: $(HE, {
                        ba: Rr(Wb(a.lK)),
                        dZ: Rr(Wb(a.ma)),
                        gn: Hr,
                        dn: A2(Lc, function(n) {
                            return Wb(A2(Dj, n.gF, u).nM);
                        }, l)
                    })
                });
            case 3:
                return $(r, {
                    aF: $(HE, {
                        ba: Rr(Wb(a.lK)),
                        iv: Rr(Wb(A2(Ey, u, e.aS.iv)))
                    }),
                    hf: d,
                    pR: b
                });
            case 4:
                return $(r, {
                    mR: o,
                    dj: f,
                    dk: s,
                    aF: $(HE, {
                        ba: Rr(Wb(a.lK)),
                        c6: Rr(Wb(u.c6))
                    })
                });
            case 5:
                return $(r, {
                    S: $(i, {
                        aj: GE(e)
                    })
                });
            case 6:
                return $(r, {
                    aF: $(HE, {
                        ba: Rr(Wb(a.lK))
                    }),
                    pR: b
                });
            default:
                return $(r, {
                    aF: $(HE, {
                        ba: Rr(Wb(u.mQ)),
                        fX: Rr((t = A2(zw, 4, hh(e.aS.bK.ms)), "Repassage\xa0: " + t + "\xa0kWh")),
                        fY: Rr(Wb(e.aS.bK.ng))
                    })
                });
        }
    }), VE = F2(function(n, e) {
        return Cy(A2(ju, A2(WE, n.oT, e), A3(st, F2(function(n, r) {
            var t = n.a;
            return function(n) {
                var e = n.lJ, r = n.gp, t = n.ai, u = Zs;
                return {
                    cE: 0,
                    S: lj,
                    i: n.i,
                    lc: 0,
                    aO: UE(ru),
                    cZ: Hr,
                    lJ: e,
                    gp: r,
                    d9: 0,
                    g: u,
                    dc: 0,
                    a$: 0,
                    ai: t,
                    mR: Hr,
                    dj: Hr,
                    dk: Hr,
                    nE: 0,
                    ji: Hr,
                    nL: ry,
                    dn: Hr,
                    aF: HE,
                    hf: Hr,
                    j8: Hr,
                    eJ: cx(u),
                    pK: 0,
                    pR: Hr
                };
            }({
                i: r,
                lJ: n.b,
                gp: !A2(tl, t, e.cX),
                ai: t
            });
        }), E([
            v(5, !1),
            v(6, !0),
            v(3, !0),
            v(2, !0),
            v(4, !0),
            v(0, !1),
            v(7, !1),
            v(1, !1)
        ]), function(n) {
            return E([
                n.h7,
                n.cT,
                n.bS,
                n.bx,
                n.bT,
                n.gg,
                n.gi,
                n.gh
            ]);
        }(e))));
    }), JE = F2(function(n, e) {
        return A2(Fu, RE, A2(Fu, _E(n), ss(function(r) {
            var t, u, a, i = r.aS;
            return t = A2(VE, n, r), {
                S: lj,
                h4: e,
                gk: r.aS.bK.gk,
                aO: {
                    i8: UE(ru),
                    gX: A2(_c, Bw(ru), r.dm)
                },
                g: Zs,
                A: r,
                ac: t,
                eJ: cx(Zs),
                dF: Zs,
                pG: (u = i.bK, a = u.hA, jf(AE(u.gk) / A3(EE, 1, a, a)))
            };
        })));
    }), BE = E([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ]), XE = function(n) {
        return A3(Xy, BE, Jy(n.A.P), n);
    }, QE = F3(function(n, e, r) {
        var t = function(n) {
            return ss(n);
        }, u = F2(function(n, e) {
            return A2(tl, n, r.cX) ? ru : t(e);
        }), a = function(e) {
            return t(e(n));
        }, i = F2(function(n, e) {
            return A2(tl, n, r.cX) ? ru : a(e);
        });
        return A2(t, bj, A2(function(e) {
            return function(n) {
                return is(n);
            }(e(n));
        }, kE, A2(t, hE, A2(a, vE, A3(i, 1, jy, A3(i, 7, yE, A3(i, 4, yj, A3(i, 2, pj, A3(i, 2, Gj, A3(i, 2, wy, A3(i, 3, Gy, A3(u, 6, Qj, A3(u, 5, Uj(n), A2(a, jE, A3(u, 4, gj, A2(t, Yw, A2(t, zj, A3(u, 6, Yj, A3(i, 3, Yy, A3(u, 4, Pj, A3(u, 4, Ij, A2(t, XE, A3(JE, n, e, r)))))))))))))))))))))));
    }), ZE = F2(function(n, e) {
        return A2(Op, E([
            5 === e.ad.$ ? Eg("prevent-scrolling") : jg("prevent-scrolling")
        ]), A2(Tp, n, e));
    }), YE = function(n) {
        return A2(rl, ru, E([
            !s(n.cZ, Hr) && !s(n.cZ, Rr(0)),
            !s(n.b1, Hr),
            !s(n.mR, Hr),
            !s(n.dj, Hr),
            !s(n.dk, Hr),
            A2(rl, A2(Fu, function(n) {
                return n.dz;
            }, Sc(Hr)), n.fn),
            !s(n.dm, Hr),
            !s(n.hf, Hr),
            !s(n.pb, Hr),
            !n.dI && !lf(n.cX),
            !s(n.pR, Hr)
        ]));
    }, nA = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eA = function(n) {
        return Ig(nA(n));
    }, rA = function(n) {
        return A2(zw, 3, n) + "kg";
    }, tA = function(n) {
        switch(n){
            case 0:
                return "Elev\xe9e";
            case 1:
                return "Faible";
            case 2:
                return "Moyenne";
            case 3:
                return "Non applicable";
            case 4:
                return "Tr\xe8s \xe9lev\xe9e";
            default:
                return "Tr\xe8s faible";
        }
    }, uA = function(n) {
        return A2(Fu, zf, Ak($(Ck, {
            le: tk(n)
        })));
    }, aA = function(n) {
        var e, r = n.cE, t = n.c6, u = n.mR, a = n.dj, i = n.dk;
        return "" !== (e = A2(at, ", ", A2(La, ru, E([
            A2(Lc, A2(Fu, uA(0), function(n) {
                return n + "\u202F% de perte";
            }), i),
            A2(Lc, A2(Fu, uA(0), function(n) {
                return n + "\u202F% de stocks dormants";
            }), a),
            A2(Lc, function(n) {
                return "complexit\xe9 de confection " + tA(n);
            }, u),
            A2(Qa, function(n) {
                return zf(n) ? Rr(A2(uA, 0, n) + " de transport a\xe9rien") : Hr;
            }, r),
            s(t, Rr(!0)) ? Rr("d\xe9lav\xe9") : Hr
        ])))) ? " (" + e + ")" : "";
    }, iA = function(n) {
        return n ? "Fix\xe9-lav\xe9" : "Pigmentaire";
    }, cA = function(n) {
        switch(n){
            case 0:
                return "Tricotage Circulaire";
            case 1:
                return "Tricotage Fully fashioned / Seamless";
            case 2:
                return "Tricotage Int\xe9gral / Whole garment";
            case 3:
                return "Tricotage moyen (par d\xe9faut)";
            case 4:
                return "Tricotage Rectiligne";
            default:
                return "Tissage";
        }
    }, oA = F2(function(n, e) {
        var r, t, u, a, i = F2(function(n, r) {
            return A2(tl, n, e.cX) ? w : r;
        });
        return A2(ks, A2(cc, ul, lf), E([
            E([
                k(e.aS.ei, k(e.dI ? " remanufactur\xe9" : "", (a = e.dm, a.$ ? "" : ", durabilit\xe9 physique " + A2(zw, 3, a.a)))),
                rA(e.P)
            ]),
            A2(i, 5, E([
                "mati\xe8re",
                (u = e.fn, A2(at, ", ", A2(ju, function(n) {
                    var e = n.U, r = n.aH, t = A2(_c, " par d\xe9faut (" + e.l6 + ")", A2(Lc, function(n) {
                        return n.ei;
                    }, n.i));
                    return A2(uA, 0, r) + "% " + e.ei + " provenance " + t;
                }, A2(ks, function(n) {
                    return n.aH > 0;
                }, u))))
            ])),
            A2(i, 6, E([
                "filature",
                e.cT.ei
            ])),
            (t = e.pR, t.$ ? w : E([
                "titrage",
                A2(zw, 3, Tf(t.a)) + "Nm"
            ])),
            A2(i, 3, E([
                cA(A2(_c, e.aS.iv, e.b1)),
                e.bS.ei
            ])),
            A2(i, 2, E([
                "ennoblissement\xa0: " + Wb(A2(vy, n, e.cZ)),
                e.bx.ei
            ])),
            A2(i, 2, E([
                "impression",
                (r = e.dn, r.$ ? "non" : "impression " + function(n) {
                    var e = n.nT;
                    return iA(n.gF) + " (" + A2(uA, 0, e) + "%)";
                }(r.a) + "\xa0: " + e.bx.ei)
            ])),
            A2(i, 4, E([
                "confection",
                k(e.bT.ei, aA(e))
            ])),
            A2(i, 0, E([
                "distribution",
                e.gg.ei
            ])),
            A2(i, 7, E([
                "utilisation",
                e.gi.ei
            ])),
            A2(i, 1, E([
                "fin de vie",
                e.gh.ei
            ]))
        ]));
    }), fA = F2(function(n, e) {
        return A2(at, ", ", A2(ju, at("\xa0: "), A2(oA, n, e)));
    }), sA = F2(function(n, e) {
        var r = n.C, t = v(A2(eA, e, n.bH.ao), Ld(A2(rk, e, r.oT.lP)));
        return t.a.$ ? t.b.$ ? A2(eh, "", A2(ss, fA(r.oT.pM), A2(_E, r, e))) : t.b.a.ei : t.a.a.ei;
    }), lA = F2(function(n, e) {
        return $(e, {
            aG: $(e.aG, {
                oT: n
            })
        });
    }), dA = F3(function(n, e, r) {
        var t = A2(_c, r.aG.oT, e), u = A3(QE, r.C, r.h4, t);
        return A2(Op, E([
            e.$ ? Ip({
                pP: 0,
                pQ: 0
            }) : Tc
        ]), A2(ZE, A2(lA, t, r), {
            dN: 1,
            aV: YE(t) ? 0 : 1,
            cI: Hr,
            bu: Hr,
            bv: Hr,
            bw: A2(sA, r, t),
            dU: 1,
            cO: Rl(r) ? 2 : 1,
            O: A2(th, n, r.C.cV),
            db: t,
            ad: Ac,
            dx: u
        }));
    }), bA = {
        E: Hr,
        mm: w,
        cm: w,
        bj: w,
        fT: Hr
    }, mA = F2(function(n, e) {
        var r = A2(eh, bA, A2(ss, function(n) {
            return n.g1;
        }, A2(Qx, e, n.C.l1.lP)));
        return A2(Op, E([
            Ip({
                pP: 0,
                pQ: 0
            })
        ]), A2(Tg, A2(uh, r, n), {
            dN: 1,
            cI: Hr,
            bu: Hr,
            bv: Hr,
            bw: A2(rh, n, r),
            dU: 1,
            cO: 2,
            O: A2(th, 19, n.C.cV),
            db: r,
            ad: xc
        }));
    }), pA = F2(function(n, e) {
        return {
            eb: 0,
            ef: e,
            er: !0,
            eC: Rr(n)
        };
    }), vA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gA = F2(function(n, e) {
        return $(e, {
            bp: k(e.bp, n)
        });
    }), hA = function(n) {
        return gA(E([
            vA(n)
        ]));
    }, $A = F2(function(n, e) {
        return hA(A2(pA, n, e));
    }), xA = F3(function(n, e, r) {
        return n ? A2($A, e, r) : ru;
    }), kA = F3(function(n, e, r) {
        var t = bs(e), u = A2(Bx, t, n.C.l5.lP), a = A2(Qx, r, u), i = A2(eh, Xx, A2(ss, function(n) {
            return n.g1;
        }, a));
        return A2(Op, E([
            Ip({
                pP: 0,
                pQ: 0
            })
        ]), A4(xA, !!a.$, "Exemple introuvable", "L\u2019exemple de produit " + bf(r) + " n\u2019existe pas.", A2(Jx, A3(Ww, e, i, n), {
            dN: 1,
            cI: Hr,
            bu: Hr,
            bv: Hr,
            bw: A4(Gw, n, e, u, i),
            dU: 1,
            cO: 2,
            cQ: "",
            cR: "",
            a9: !1,
            bV: w,
            lP: u,
            b2: Hr,
            iA: e,
            O: A2(th, 19, n.C.cV),
            db: i,
            ac: A2(Vx, {
                ay: n.h4,
                C: n.C,
                as: t
            }, i),
            M: w
        })));
    }), wA = F2(function(n, e) {
        var r = A2(eh, n.aG.oT, A2(ss, function(n) {
            return n.g1;
        }, A2(Qx, e, n.C.oT.lP))), t = A3(QE, n.C, n.h4, r);
        return A2(Op, E([
            Ip({
                pP: 0,
                pQ: 0
            })
        ]), A2(ZE, A2(lA, r, n), {
            dN: 1,
            aV: YE(r) ? 0 : 1,
            cI: Hr,
            bu: Hr,
            bv: Hr,
            bw: A2(sA, n, r),
            dU: 1,
            cO: 2,
            O: A2(th, 19, n.C.cV),
            db: r,
            ad: Ac,
            dx: t
        }));
    }), yA = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), jA = nr, EA = function(n) {
        switch(n){
            case 0:
                return "A";
            case 1:
                return "B";
            case 2:
                return "C";
            case 3:
                return "D";
            case 4:
                return "E";
            case 5:
                return "F";
            case 6:
                return "G";
            case 7:
                return "H";
            case 8:
                return "I";
            case 9:
                return "J";
            case 10:
                return "K";
            case 11:
                return "L";
            case 12:
                return "M";
            case 13:
                return "N";
            case 14:
                return "O";
            case 15:
                return "P";
            case 16:
                return "Q";
            case 17:
                return "R";
            case 18:
                return "S";
            case 19:
                return "T";
            case 20:
                return "U";
            case 21:
                return "V";
            case 22:
                return "W";
            case 23:
                return "X";
            case 24:
                return "Y";
            case 25:
                return "Z";
            case 26:
                return "a";
            case 27:
                return "b";
            case 28:
                return "c";
            case 29:
                return "d";
            case 30:
                return "e";
            case 31:
                return "f";
            case 32:
                return "g";
            case 33:
                return "h";
            case 34:
                return "i";
            case 35:
                return "j";
            case 36:
                return "k";
            case 37:
                return "l";
            case 38:
                return "m";
            case 39:
                return "n";
            case 40:
                return "o";
            case 41:
                return "p";
            case 42:
                return "q";
            case 43:
                return "r";
            case 44:
                return "s";
            case 45:
                return "t";
            case 46:
                return "u";
            case 47:
                return "v";
            case 48:
                return "w";
            case 49:
                return "x";
            case 50:
                return "y";
            case 51:
                return "z";
            case 52:
                return "0";
            case 53:
                return "1";
            case 54:
                return "2";
            case 55:
                return "3";
            case 56:
                return "4";
            case 57:
                return "5";
            case 58:
                return "6";
            case 59:
                return "7";
            case 60:
                return "8";
            case 61:
                return "9";
            case 62:
                return "+";
            default:
                return "/";
        }
    }, AA = F2(function(n, e) {
        var r, t = e.a, u = e.b, a = e.c << 8 | n;
        return 2 === u ? g(k(t, k(EA(63 & (r = a) >>> 18), k(EA(63 & r >>> 12), k(EA(63 & r >>> 6), EA(63 & r >>> 0))))), 0, 0) : g(t, u + 1, a);
    }), CA = F2(function(n, e) {
        var r = mt(n);
        return 128 > r ? A2(AA, r, e) : A2(AA, 128 | 63 & r, 2048 > r ? A2(AA, 192 | r >>> 6, e) : A2(AA, 128 | 63 & r >>> 6, 55296 > r || r >= 57344 && 65535 >= r ? A2(AA, 224 | r >>> 12, e) : A2(AA, 128 | 63 & r >>> 12, A2(AA, 240 | r >>> 18, e))));
    }), PA = g("", 0, 0), TA = function(n) {
        return function(n) {
            var e = n.a, r = n.c;
            switch(n.b){
                case 1:
                    return e + (EA(63 & r >>> 2) + (EA(63 & r << 4) + "=="));
                case 2:
                    return e + (EA(63 & r >>> 10) + (EA(63 & r >>> 4) + (EA(63 & r << 2) + "=")));
                default:
                    return e;
            }
        }(A3(Nd, CA, PA, n));
    }, SA = A2(Fu, Wo, A2(Fu, tt(0), TA)), IA = A2(Fu, qf, A2(Fu, tt(0), TA)), OA = A2(Fu, Nf, A2(Fu, tt(0), TA)), qA = function(n) {
        switch(n.$){
            case 0:
                return {
                    ai: "Composants",
                    aI: gs(n.a) + "-components"
                };
            case 1:
                return {
                    ai: "Pays",
                    aI: "countries"
                };
            case 2:
                return {
                    ai: "Exemples",
                    aI: "food-examples"
                };
            case 3:
                return {
                    ai: "Ingr\xe9dients",
                    aI: "ingredients"
                };
            case 4:
                return {
                    ai: "Exemples",
                    aI: gs(bs(n.a)) + "-examples"
                };
            case 5:
                return {
                    ai: "Impacts",
                    aI: "impacts"
                };
            case 6:
                return {
                    ai: "Proc\xe9d\xe9s",
                    aI: gs(n.a) + "-processes"
                };
            case 7:
                return {
                    ai: "Produits",
                    aI: gs(bs(n.a)) + "-product-categories"
                };
            case 8:
                return {
                    ai: "Exemples",
                    aI: "textile-examples"
                };
            case 9:
                return {
                    ai: "Mati\xe8res",
                    aI: "materials"
                };
            default:
                return {
                    ai: "Produits",
                    aI: "products"
                };
        }
    }, LA = A2(Fu, qA, function(n) {
        return n.aI;
    }), MA = function(n) {
        var e = function() {
            n: for(;;)switch(n.$){
                case 0:
                    return E([
                        "api"
                    ]);
                case 1:
                    return E([
                        "auth"
                    ]);
                case 2:
                    return E([
                        "auth",
                        n.a,
                        n.b
                    ]);
                case 3:
                    return E([
                        "auth",
                        "signup"
                    ]);
                case 4:
                    return E([
                        "pages",
                        n.a
                    ]);
                case 5:
                    switch(n.a.$){
                        case 0:
                            if (2 === n.b.$ && 1 === n.b.a.$) return E([
                                "explore",
                                "food"
                            ]);
                            break n;
                        case 2:
                            if (8 === n.b.$ && 1 === n.b.a.$) return E([
                                "explore",
                                "textile"
                            ]);
                            break n;
                        default:
                            break n;
                    }
                case 6:
                    if (1 === n.b.$) return E([
                        "food",
                        Ml(r = n.a)
                    ]);
                    var e = n.b.a;
                    return E([
                        "food",
                        Ml(r = n.a),
                        SA(e)
                    ]);
                case 7:
                    return E([
                        "food",
                        "edit-example",
                        bf(t = n.a)
                    ]);
                case 8:
                    return E([
                        "food"
                    ]);
                case 9:
                    if (n.c.$) return r = n.b, E([
                        gs(bs(n.a)),
                        "simulator",
                        Ml(r)
                    ]);
                    var r = n.b;
                    return e = n.c.a, E([
                        gs(bs(n.a)),
                        "simulator",
                        Ml(r),
                        OA(e)
                    ]);
                case 10:
                    var t = n.b;
                    return E([
                        gs(bs(n.a)),
                        "edit-example",
                        bf(t)
                    ]);
                case 11:
                    return E([
                        gs(bs(n.a)),
                        "simulator"
                    ]);
                case 12:
                    return w;
                case 13:
                    return E([
                        "stats"
                    ]);
                case 14:
                    return n.b.$ ? E([
                        "textile",
                        "simulator",
                        Ml(r = n.a)
                    ]) : (e = n.b.a, E([
                        "textile",
                        "simulator",
                        Ml(r = n.a),
                        IA(e)
                    ]));
                case 15:
                    return E([
                        "textile",
                        "edit-example",
                        bf(t = n.a)
                    ]);
                default:
                    return E([
                        "textile",
                        "simulator"
                    ]);
            }
            var u = n.b;
            return A2(Ur, "explore", A2(Ur, gs(n.a), function(n) {
                switch(n.$){
                    case 0:
                        if (n.b.$) return E([
                            LA(n)
                        ]);
                        var e = n.b.a;
                        return E([
                            LA(n),
                            mf(e)
                        ]);
                    case 1:
                        if (n.a.$) return E([
                            LA(n)
                        ]);
                        var r = n.a.a;
                        return E([
                            LA(n),
                            r
                        ]);
                    case 2:
                    case 8:
                        return n.a.$ ? E([
                            LA(n)
                        ]) : (e = n.a.a, E([
                            LA(n),
                            bf(e)
                        ]));
                    case 3:
                        return n.a.$ ? E([
                            LA(n)
                        ]) : (e = n.a.a, E([
                            LA(n),
                            zg(e)
                        ]));
                    case 4:
                        return n.b.$ ? E([
                            LA(n)
                        ]) : (e = n.b.a, E([
                            LA(n),
                            bf(e)
                        ]));
                    case 5:
                        if (n.a.$) return E([
                            LA(n)
                        ]);
                        var t = n.a.a;
                        return E([
                            LA(n),
                            Ml(t)
                        ]);
                    case 6:
                        return n.b.$ ? E([
                            LA(n)
                        ]) : (e = n.b.a, E([
                            LA(n),
                            _s(e)
                        ]));
                    case 7:
                        return n.b.$ ? E([
                            LA(n)
                        ]) : (e = n.b.a, E([
                            LA(n),
                            qh(e)
                        ]));
                    case 9:
                        return n.a.$ ? E([
                            LA(n)
                        ]) : (e = n.a.a, E([
                            LA(n),
                            Oj(e)
                        ]));
                    default:
                        return n.a.$ ? E([
                            LA(n)
                        ]) : (e = n.a.a, E([
                            LA(n),
                            e
                        ]));
                }
            }(u)));
        }();
        return "#/" + A2(at, "/", e);
    }, _A = function(n) {
        return A2(Fu, Hp(n), Op(E([
            A2(jA, n.m6, MA(ld))
        ])));
    }, RA = F3(function(n, e, r) {
        var t = Hl(n);
        return t.$ ? A2(Tp, n, {
            jX: !1,
            u: A2(yA, e, r)
        }) : A2(_A, n, t.a);
    }), HA = F3(function(n, e, r) {
        return {
            $: 7,
            a: n,
            b: e,
            c: r
        };
    }), UA = {
        bX: !1,
        c1: "",
        aY: !1,
        aC: "",
        aD: "",
        ck: ig,
        oS: !1
    }, zA = function(n) {
        return {
            $: 1,
            a: n
        };
    }, DA = Jn, NA = F2(function(n, e) {
        return A2(Ou, function() {
            return n(e);
        }, xu(0));
    }), FA = function(n) {
        return A2(Fu, function(n) {
            return n.bp;
        }, A2(Fu, ju(NA(n)), Uu));
    }, KA = F5(function(n, e, r, t, u) {
        return v($(n, {
            H: A2(ns, u.eu, r(u.eg))
        }), Uu(E([
            e,
            A2(DA, t, u.bQ),
            A2(FA, zA, u)
        ])));
    }), GA = F4(function(n, e, r, t) {
        var u = t.a, a = t.b, i = function(n) {
            var e, r = 1 === n.nQ ? "https" : "http", t = (e = n.nK).$ ? "" : ":" + ut(e.a);
            return A2(fd, Pp, A2(_c, n, hu(r + "://" + (n.iJ + (t + A2(_c, "/", n.iz))))));
        }(n);
        if (i.$) return v($(u, {
            H: A2(ns, e, nd)
        }), Tc);
        switch(i.a.$){
            case 0:
                return A5(KA, u, a, Kl, Fl, function(n) {
                    return A2(Op, E([
                        Sp(0),
                        Ip({
                            pP: 0,
                            pQ: 0
                        })
                    ]), A2(Tp, n, 0));
                }(e));
            case 1:
                var c = A5(KA, u, a, Wl, Gl, function(n) {
                    var e = Hl(n);
                    return e.$ ? A2(Tp, n, {
                        jX: !1,
                        u: A2(qp, "", zu)
                    }) : A2(wg, n, e.a);
                }(e));
                if (1 === r.$) {
                    var o = r.a;
                    return o.jX && Rl(e) ? v($(u, {
                        H: A2(ns, e, Wl($(o, {
                            jX: !1
                        })))
                    }), a) : c;
                }
                return c;
            case 2:
                var f = i.a;
                return A5(KA, u, a, Wl, Gl, A3(RA, e, f.a, f.b));
            case 3:
                return A5(KA, u, a, Wl, Gl, function(n) {
                    var e = Hl(n);
                    return e.$ ? A2(Tp, n, {
                        jX: !1,
                        u: A3(HA, UA, Zu, zu)
                    }) : A2(_A, n, e.a);
                }(e));
            case 4:
                return A5(KA, u, a, Jl, Vl, A2(yg, i.a.a, e));
            case 5:
                var s = i.a;
                return A5(KA, u, a, Bl, wi, A3(Pg, s.a, s.b, e));
            case 6:
                var l = i.a;
                return A5(KA, u, a, Xl, yi, A3(ah, e, l.a, l.b));
            case 7:
                return A5(KA, u, a, Xl, yi, A2(mA, e, i.a.a));
            case 8:
                return A5(KA, u, a, Xl, yi, A3(ah, e, 19, Hr));
            case 9:
                var d = i.a;
                return A5(KA, u, a, Ql, ji, A4(Vw, d.a, d.b, d.c, e));
            case 10:
                var b = i.a;
                return A5(KA, u, a, Ql, ji, A3(kA, e, b.a, b.b));
            case 12:
                return A5(KA, u, a, Yl, Zl, function(n) {
                    return A2(Op, E([
                        Ip({
                            pP: 0,
                            pQ: 0
                        })
                    ]), A2(Tp, n, 0));
                }(e));
            case 11:
                return A5(KA, u, a, Ql, ji, A4(Vw, i.a.a, 19, Hr, e));
            case 13:
                return A5(KA, u, a, rd, ed, function(n) {
                    return A2(Op, E([
                        Ip({
                            pP: 0,
                            pQ: 0
                        })
                    ]), A2(Tp, n, 0));
                }(e));
            case 14:
                var m = i.a;
                return A5(KA, u, a, td, Ai, A3(dA, m.a, m.b, e));
            case 15:
                return A5(KA, u, a, td, Ai, A2(wA, e, i.a.a));
            default:
                return A5(KA, u, a, td, Ai, A3(dA, 19, Hr, e));
        }
    }), WA = {
        $: 1
    }, VA = F4(function(n, e, r, t) {
        return {
            aW: n,
            ao: e,
            aX: r,
            hz: t
        };
    }), JA = F2(function(n, e) {
        return {
            f$: n,
            fZ: e
        };
    }), BA = F4(function(n, e, r, t) {
        return {
            kr: n,
            iu: e,
            jy: r,
            ka: t
        };
    }), XA = A3(Ba, "token_type", ai, A3(ui, "refresh_token", ai, A3(ui, "expires_in", xi, A3(Ba, "access_token", ai, nu(BA))))), QA = A3(Ba, "user", xg, A3(Ba, "accessTokenData", XA, nu(JA))), ZA = F4(function(n, e, r, t) {
        return {
            gj: n,
            iA: e,
            ei: r,
            g1: t
        };
    }), YA = A2(Qt, A2(Fu, ps, Es), ai), nC = Ya(E([
        A2(Zt, Sg, qb),
        A2(Zt, nk(1), xm(w)),
        A2(Zt, nA, kp)
    ])), eC = A2(Zt, function(n) {
        var e = v(n.g1, n.iA);
        return 1 !== e.a.$ || e.b.$ ? n : $(n, {
            g1: A2(nk, e.b.a, e.a.b)
        });
    }, A3(Ba, "query", nC, A3(Ba, "name", ai, A4(el, "subScope", Us(YA), Hr, A3(Ba, "created", A2(Zt, uc, xi), nu(ZA)))))), rC = A2(Zt, A2(Fu, ci(eC), Ld), ai), tC = A2(Zt, La(ru), Sb(Ya(E([
        rC,
        A2(Zt, Rr, eC),
        nu(Hr)
    ])))), uC = Zu, aC = F2(function(n, e) {
        return A3(ia, n, 0, e);
    }), iC = function(n) {
        return A3(ot, aC, uC, n);
    }, cC = A4(Ob, "usageCount", xi, 0, A4(Ob, "comparedSimulations", A2(Zt, iC, Sb(ai)), uC, A4(Ob, "bookmarks", tC, w, A3(ui, "auth", QA, nu(VA))))), oC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fC = F2(function(n, e) {
        return $(e, {
            a1: k(e.a1, E([
                oC(n)
            ]))
        });
    }), sC = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), lC = F3(function(n, e, r) {
        return $(r, {
            a1: k(r.a1, E([
                A2(sC, n, e)
            ]))
        });
    }), dC = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            dX: n,
            bR: e,
            cV: r,
            ls: t,
            l1: u,
            l5: a,
            W: i,
            dp: c,
            oT: o
        };
    }), bC = A2(Fu, function(n) {
        return n.mY;
    }, Qa(function(n) {
        return n.gl;
    })), mC = F2(function(n, e) {
        var r = function(e) {
            return e.i.$ ? $(e, {
                i: A2(eh, Hr, A2(ss, bC, A2(Rs, e.mf, n)))
            }) : e;
        };
        return $(e, {
            r: A2(ju, function(n) {
                var e = n.J;
                return $(n, {
                    U: r(n.U),
                    J: A2(ju, r, e)
                });
            }, e.r)
        });
    }), pC = F3(function(n, e, r) {
        return {
            lP: n,
            mm: e,
            pM: r
        };
    }), vC = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return {
                                                                    hI: n,
                                                                    cK: e,
                                                                    h8: r,
                                                                    gl: t,
                                                                    lo: u,
                                                                    lH: a,
                                                                    mf: i,
                                                                    ml: c,
                                                                    mC: o,
                                                                    ei: f,
                                                                    t: s,
                                                                    nV: l,
                                                                    jM: d,
                                                                    hv: b,
                                                                    kj: m
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, gC = F4(function(n, e, r, t) {
        return {
            ag: n,
            ah: e,
            al: r,
            am: t
        };
    }), hC = A2(Zt, b$, Js), $C = function(n) {
        return -n;
    }, xC = A2(Zt, $C, hC), kC = A4(Ob, "plotSize", xC, 0, A4(Ob, "permanentPasture", xC, 0, A4(Ob, "hedges", xC, 0, A4(Ob, "cropDiversity", xC, 0, nu(gC))))), wC = function(n) {
        switch(n){
            case "animal_product":
                return Zr(0);
            case "conventional":
                return Zr(2);
            case "dairy_product":
                return Zr(3);
            case "grain_raw":
                return Zr(5);
            case "grain_processed":
                return Zr(4);
            case "misc":
                return Zr(6);
            case "nut_oilseed_raw":
                return Zr(8);
            case "nut_oilseed_processed":
                return Zr(7);
            case "spice_condiment_additive":
                return Zr(10);
            case "vegetable_fresh":
                return Zr(11);
            case "vegetable_processed":
                return Zr(12);
            case "organic":
                return Zr(9);
            case "bleublanccoeur":
                return Zr(1);
            default:
                return Jr("Categorie d'ingr\xe9dient invalide : " + n);
        }
    }, yC = A2(Qt, A2(Fu, wC, Es), ai), jC = function(n) {
        switch(n){
            case "ARBORICULTURE":
                return Zr(0);
            case "AUTRES GELS":
                return Zr(14);
            case "ORGE":
                return Zr(1);
            case "CANNE A SUCRE":
                return Zr(23);
            case "MAIS GRAIN ET ENSILAGE":
                return Zr(2);
            case "ESTIVES LANDES":
                return Zr(24);
            case "PLANTES A FIBRES":
                return Zr(3);
            case "FOURRAGE":
                return Zr(4);
            case "GEL (surfaces gel\xe9es sans production)":
                return Zr(5);
            case "GEL INDUSTRIEL":
                return Zr(7);
            case "LEGUMINEUSES A GRAIN":
                return Zr(6);
            case "LEGUMES-FLEURS":
                return Zr(27);
            case "DIVERS":
                return Zr(8);
            case "":
                return Zr(9);
            case "FRUITS A COQUES":
                return Zr(10);
            case "OLIVIERS":
                return Zr(11);
            case "VERGERS":
                return Zr(12);
            case "AUTRES CEREALES":
                return Zr(13);
            case "AUTRES CULTURES INDUSTRIELLES":
                return Zr(15);
            case "AUTRES OLEAGINEUX":
                return Zr(16);
            case "PRAIRIES PERMANENTES":
                return Zr(17);
            case "PROTEAGINEUX":
                return Zr(18);
            case "COLZA":
                return Zr(19);
            case "RIZ":
                return Zr(20);
            case "SEMENCES":
                return Zr(21);
            case "BLE TENDRE":
                return Zr(22);
            case "TOURNESOL":
                return Zr(25);
            case "PRAIRIES TEMPORAIRES":
                return Zr(26);
            case "VIGNES":
                return Zr(28);
            default:
                return Jr("Groupe de culture invalide : " + n);
        }
    }, EC = A2(Qt, A2(Fu, jC, Es), ai), AC = function(n) {
        switch(n){
            case "reference":
                return Zr(3);
            case "organic":
                return Zr(2);
            case "import":
                return Zr(0);
            case "":
                return Zr(1);
            default:
                return Jr("Sc\xe9nario invalide : " + n);
        }
    }, CC = A2(Qt, A2(Fu, AC, Es), ai), PC = function(n) {
        switch(n){
            case "EuropeAndMaghreb":
                return Zr(0);
            case "France":
                return Zr(1);
            case "FranceOutreMer":
                return Zr(2);
            case "OutOfEuropeAndMaghreb":
                return Zr(3);
            case "OutOfEuropeAndMaghrebByPlane":
                return Zr(4);
            default:
                return Jr("Origine g\xe9ographique inconnue : " + n);
        }
    }, TC = A2(Qt, A2(Fu, PC, Es), ai), SC = A2(Qt, function(n) {
        switch(n){
            case "none":
                return nu(2);
            case "always":
                return nu(0);
            case "once_transformed":
                return nu(1);
            default:
                return Ti("Valeur de transport frigorifique invalide : " + n);
        }
    }, ai), IC = {
        ag: 0,
        ah: 0,
        al: 0,
        am: 0
    }, OC = function(n) {
        return 1e3 * n;
    }, qC = A2(Fu, Em, ss(ru)), LC = F6(function(n, e, r, t, u, a) {
        return {
            hY: n,
            mf: e,
            ei: r,
            g1: t,
            dq: u,
            as: a
        };
    }), MC = A2(Qt, A2(Fu, vs, Es), ai), _C = function(n) {
        return A2(Fu, ci(Sb(function(n) {
            return A3(Ba, "scope", MC, A4(el, "recyclable", qu, !0, A3(Ba, "query", n, A3(Ba, "name", ai, A3(Ba, "id", Ms, A3(Ba, "category", ai, nu(LC)))))));
        }(n))), $a(yt));
    }, RC = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            kI: n,
            kJ: e,
            k3: r,
            lx: t,
            mN: u,
            mO: a,
            mP: i,
            jk: c,
            cz: o
        };
    }), HC = F3(function(n, e, r) {
        return A2(Lg, function(n) {
            var e = A2(Fu, qC, A2(Fu, is(function(e) {
                return A2(Rs, e, n);
            }), Lg));
            return A2(e, "7e1fb122-1320-519c-8751-2d926eb435da", A2(e, "326369d9-792a-5ab5-8276-c54108c80cb1", A2(e, "931c9bb0-619a-5f75-b41b-ab8061e2ad92", A2(e, "46e96f29-9ca5-5475-bb3c-6397f43b7a5b", A2(e, "219b986c-9751-58cf-977e-7ba8f0b4ae2b", A2(e, "6cbd45fb-83ff-5852-97a7-87fffecc20f5", A2(e, "a2836bb8-7f45-5cfa-bb00-8b38046291cf", A2(e, "20a62b2c-a543-5076-83aa-c5b7d340206a", A2(e, "3cb99d44-24f6-5f6e-a8f8-f754fe44d641", Zr(RC))))))))));
        }(r), A2(Lg, A2($a, yt, A2(ci, function(n) {
            return A2(Zt, ks(function(n) {
                return n.kj;
            }), Sb(function(n) {
                return A3(Ba, "visible", qu, A3(Ba, "transportCooling", SC, A4(Ob, "scenario", CC, 1, A3(Ba, "rawToCookedRatio", gm, A3(Ba, "processId", function(n) {
                    return A2(Qt, A2(Fu, qC, A2(Fu, is(function(e) {
                        return A2(Rs, e, n);
                    }), Es)), ai);
                }(n), A3(Ba, "name", ai, A3(Ba, "landOccupation", Js, A3(Ba, "inediblePart", rp, A3(Ba, "id", $b, A4(Ob, "ecosystemicServices", kC, IC, A3(Ba, "density", A2(Zt, OC, Js), A3(Ba, "defaultOrigin", TC, A4(Ob, "cropGroup", EC, 9, A3(Ba, "categories", Sb(yC), A3(Ba, "alias", ai, nu(vC))))))))))))))));
            }(n)));
        }(r), e)), A2(Lg, A2(_C, qb, n), Zr(pC))));
    }), UC = function(n) {
        return {
            lP: n
        };
    }, zC = F4(function(n, e, r, t) {
        return A2(ss, A2(Fu, Sd, UC), A2(_g, _C(xm(t)), E([
            n,
            e,
            r
        ])));
    }), DC = F4(function(n, e, r, t) {
        return {
            lP: n,
            fn: e,
            dp: r,
            pM: t
        };
    }), NC = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            hI: n,
            kP: e,
            ic: r,
            l6: t,
            mf: u,
            ei: a,
            jd: i,
            t: c,
            g3: o
        };
    }), FC = A2(Qt, A2(Fu, function(n) {
        switch(n){
            case "ArtificialFromOrganic":
                return Zr(0);
            case "NaturalFromAnimal":
                return Zr(1);
            case "NaturalFromVegetal":
                return Zr(2);
            case "Synthetic":
                return Zr(3);
            default:
                return Jr("Origine inconnue: " + n);
        }
    }, Es), ai), KC = A3(Ba, "recycledQualityRatio", rp, A3(Ba, "manufacturerAllocation", rp, nu(F2(function(n, e) {
        return {
            mS: n,
            nZ: e
        };
    })))), GC = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                lG: n,
                                                _: e,
                                                iv: r,
                                                mf: t,
                                                gH: u,
                                                ei: a,
                                                hf: i,
                                                pb: c,
                                                bK: o,
                                                pR: f
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, WC = A3(Ba, "repairCost", bp, A3(Ba, "price", bp, A3(Ba, "numberOfReferences", xi, A3(Ba, "business", np, nu(F4(function(n, e, r, t) {
        return {
            hW: n,
            ja: e,
            jn: r,
            jB: t
        };
    })))))), VC = A3(Ba, "volume", A2(Zt, nb, Js), nu(function(n) {
        return {
            eU: n
        };
    })), JC = A3(Ba, "pcrWaste", rp, A3(Ba, "complexity", Wm, nu(F2(function(n, e) {
        return {
            ge: n,
            jg: e
        };
    })))), BC = F8(function(n, e, r, t, u, a, i, c) {
        return {
            gk: n,
            ih: e,
            ms: r,
            ng: t,
            jv: u,
            jw: a,
            j9: i,
            hA: c
        };
    }), XC = function(n) {
        return 86400 * n;
    }, QC = function(n) {
        return 3600 * n;
    }, ZC = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return function(x) {
                                                                                        return function(k) {
                                                                                            return function(w) {
                                                                                                return function(y) {
                                                                                                    return function(j) {
                                                                                                        return function(E) {
                                                                                                            return function(A) {
                                                                                                                return function(C) {
                                                                                                                    return function(P) {
                                                                                                                        return function(T) {
                                                                                                                            return {
                                                                                                                                cD: n,
                                                                                                                                hS: e,
                                                                                                                                ii: r,
                                                                                                                                E: t,
                                                                                                                                lA: u,
                                                                                                                                lB: a,
                                                                                                                                lC: i,
                                                                                                                                lD: c,
                                                                                                                                lE: o,
                                                                                                                                _: f,
                                                                                                                                c6: s,
                                                                                                                                l$: l,
                                                                                                                                iF: d,
                                                                                                                                iG: b,
                                                                                                                                mw: m,
                                                                                                                                mx: p,
                                                                                                                                my: v,
                                                                                                                                mz: g,
                                                                                                                                mA: h,
                                                                                                                                mQ: $,
                                                                                                                                nF: x,
                                                                                                                                jo: k,
                                                                                                                                jp: w,
                                                                                                                                jq: y,
                                                                                                                                jr: j,
                                                                                                                                cr: E,
                                                                                                                                dt: A,
                                                                                                                                o9: C,
                                                                                                                                kk: P,
                                                                                                                                pL: T
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, YC = F4(function(n, e, r, t) {
        return A2(Lg, function(n) {
            var e = A2(Fu, qC, A2(Fu, is(function(e) {
                return A2(Rs, e, n);
            }), Lg));
            return A2(e, "235b3488-6157-50ed-b74a-45e5d447dd85", A2(e, "7cdc9616-7fb4-5a69-9436-78e5b84ebf31", A2(e, "cdc841c2-493f-56d6-8fc2-ae5fad2a4917", A2(e, "20a62b2c-a543-5076-83aa-c5b7d340206a", A2(e, "46e96f29-9ca5-5475-bb3c-6397f43b7a5b", A2(e, "5c21e378-b941-57f7-98c9-67345847dbda", A2(e, "9418bfb4-34e5-5bba-920f-b50e2feff1bd", A2(e, "97c209ec-7782-5a29-8c47-af7f17c82d11", A2(e, "cfdc5e31-25fc-56ff-9a54-04670ecad301", A2(e, "2fd6b74f-600a-577c-ba37-b84d8f0482c2", A2(e, "931c9bb0-619a-5f75-b41b-ab8061e2ad92", A2(e, "8343adad-0350-5895-a701-4db41a235ba9", A2(e, "b2dba726-83d2-55b2-8107-91c9e47bdca7", A2(e, "29dc6c73-8d82-5056-8ac0-faf212bc0367", A2(e, "66ef36be-7691-5adc-a684-e83d45e53452", A2(e, "ddcf4b23-1283-57d3-854b-be3121452d50", A2(e, "3561ace1-f710-50ce-a69c-9cf842e729e4", A2(e, "f6ea2983-e024-5de2-b323-273f2436deba", A2(e, "3c66588d-fffb-55cb-b9d5-c197b7e2e591", A2(e, "24edc372-b238-5426-8ac9-059218936641", A2(e, "ab96b73f-8534-59ad-9f34-a579abe3b023", A2(e, "e5e43c57-bd12-5ab7-8a22-7d12cdcece58", A2(e, "7e17b44d-108a-504f-9e0d-0cfe5b5db054", A2(e, "c8be445c-ae33-5240-9007-e7973e97fc24", A2(e, "b7fa51fc-0421-57b0-bb0a-e0573e293c7a", A2(e, "c49a5379-95c4-599a-84da-b5faaa345b97", A2(e, "46e96f29-9ca5-5475-bb3c-6397f43b7a5b", A2(e, "1746b5e1-1d0d-5858-a968-2ade8d778623", A2(e, "b4251621-1747-526a-a54f-e4be7500efff", A2(e, "326369d9-792a-5ab5-8276-c54108c80cb1", Zr(ZC)))))))))))))))))))))))))))))));
        }(t), A2(Lg, A2($a, yt, A2(ci, function(n) {
            return Sb(function(n) {
                return A3(Ba, "yarnSize", xp, A3(Ba, "use", function(n) {
                    return A3(Ba, "wearsPerCycle", xi, A3(Ba, "timeIroning", A2(Zt, QC, Js), A3(Ba, "ratioIroning", rp, A3(Ba, "ratioDryer", rp, A3(Ba, "nonIroningProcessUuid", Hs(n), A3(Ba, "ironingElecInMJ", A2(Zt, db, Js), A3(Ba, "defaultNbCycles", xi, A3(Ba, "daysOfWear", A2(Zt, XC, Js), nu(BC)))))))));
                }(n), A3(Ba, "trims", Sb(dm), A3(Ba, "surfaceMass", pp, A3(Ba, "name", ai, A3(Ba, "making", JC, A3(Ba, "id", A2(Zt, ru, ai), A3(Ba, "fabric", Km, A3(Ba, "endOfLife", VC, A3(Ba, "economics", WC, nu(GC)))))))))));
            }(n));
        }(t), r)), A2(Lg, A2($a, yt, A2(ci, function(n) {
            return Sb(function(n) {
                return A3(Ba, "recycledFrom", Us(op), A3(Ba, "processId", Hs(n), A3(Ba, "origin", FC, A3(Ba, "name", ai, A3(Ba, "id", op, A3(Ba, "geographicOrigin", ai, A3(Ba, "defaultCountry", A2(Zt, vj, ai), A3(Ba, "cff", Us(KC), A3(Ba, "alias", ai, nu(NC))))))))));
            }(n));
        }(t), e)), A2(Lg, A2(_C, kp, n), Zr(DC)))));
    }), nP = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return function($) {
                                                                                    return {
                                                                                        bM: n,
                                                                                        bP: e,
                                                                                        bY: $,
                                                                                        b_: r,
                                                                                        b$: t,
                                                                                        b5: u,
                                                                                        b6: a,
                                                                                        b8: i,
                                                                                        b9: c,
                                                                                        ca: o,
                                                                                        cb: f,
                                                                                        cd: s,
                                                                                        ce: l,
                                                                                        cj: d,
                                                                                        cl: b,
                                                                                        co: m,
                                                                                        cp: p,
                                                                                        cs: v,
                                                                                        cw: g,
                                                                                        cA: h
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, eP = F6(function(n, e, r, t, u, a) {
        return {
            le: u,
            ik: r,
            ip: a,
            ai: e,
            kf: n,
            aL: t
        };
    }), rP = A4(dn, F3(function(n, e, r) {
        return {
            dW: n,
            i9: e,
            kl: r
        };
    }), A2(Lu, "color", ai), A2(Lu, "normalization", hC), A2(Lu, "weighting", rp)), tP = A2(Hw = function(n) {
        return A2(Ba, n, function(n) {
            return A3(Ba, "ecoscore", Us(rP), A3(Ba, "decimals", xi, A3(Ba, "short_unit", ai, A3(Ba, "description_fr", ai, A3(Ba, "label_fr", ai, A2(Ja, Es(ym(n)), nu(eP)))))));
        }(n));
    }, "ecs", A2(Hw, "wtu", A2(Hw, "tre", A2(Hw, "swe", A2(Hw, "pma", A2(Hw, "pco", A2(Hw, "ozd", A2(Hw, "mru", A2(Hw, "ldu", A2(Hw, "ior", A2(Hw, "htn-c", A2(Hw, "htn", A2(Hw, "htc-c", A2(Hw, "htc", A2(Hw, "fwe", A2(Hw, "fru", A2(Hw, "etf-c", A2(Hw, "etf", A2(Hw, "cch", A2(Hw, "acd", nu(nP))))))))))))))))))))), uP = F3(function(n, e, r) {
        return A2(Zt, A2(Fr, F3(function(e, r, t) {
            return A3(fs, A2(n, e, r), r, t);
        }), os(e)), cs(r));
    }), aP = A3(uP, F2(function(n) {
        return vj(n);
    }), Lo, hl), iP = A3(uP, F2(function(n) {
        return vj(n);
    }), Lo, aP), cP = A2(Zt, ru, Ya(E([
        A3(Ba, "ecs", hC, A3(Ba, "wtu", hC, A3(Ba, "tre", hC, A3(Ba, "swe", hC, A3(Ba, "pma", hC, A3(Ba, "pco", hC, A3(Ba, "ozd", hC, A3(Ba, "mru", hC, A3(Ba, "ldu", hC, A3(Ba, "ior", hC, A3(Ba, "htn-c", hC, A3(Ba, "htn", hC, A3(Ba, "htc-c", hC, A3(Ba, "htc", hC, A3(Ba, "fwe", hC, A3(Ba, "fru", hC, A3(Ba, "etf-c", hC, A3(Ba, "etf", hC, A3(Ba, "cch", hC, A3(Ba, "acd", hC, nu(nP))))))))))))))))))))),
        A3(Ba, "ecs", hC, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, A2(Ys, 0, nu(nP)))))))))))))))))))))
    ]))), oP = F9(function(n, e, r, t, u, a, i, c, o) {
        return {
            hL: n,
            cM: e,
            gd: r,
            e4: t,
            lK: u,
            ma: a,
            ei: i,
            g5: c,
            hC: o
        };
    }), fP = A2(Qt, A2(Fu, function(n) {
        switch(n){
            case "Africa":
                return Zr(0);
            case "Asia":
                return Zr(1);
            case "Europe":
                return Zr(2);
            case "Middle_East":
                return Zr(3);
            case "North_America":
                return Zr(4);
            case "Oceania":
                return Zr(5);
            case "South_America":
                return Zr(6);
            default:
                return Jr("Zone g\xe9ographique inconnue : " + n);
        }
    }, Es), ai), sP = A2(Qt, Es, A2(Zt, function(n) {
        switch(n){
            case "Average":
                return Zr(0);
            case "Best":
                return Zr(1);
            case "Worst":
                return Zr(2);
            default:
                return Jr("Le scenario '" + n + "' n'est pas un sc\xe9nario de pollution aquatique valide (choix entre ['Best', 'Average', 'Worst']");
        }
    }, ai)), lP = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return {
                                                                                    f0: n,
                                                                                    hI: e,
                                                                                    cK: r,
                                                                                    gd: t,
                                                                                    lr: u,
                                                                                    d0: a,
                                                                                    d9: i,
                                                                                    mf: c,
                                                                                    g: o,
                                                                                    mC: f,
                                                                                    i$: s,
                                                                                    mV: l,
                                                                                    mY: d,
                                                                                    g0: b,
                                                                                    g5: m,
                                                                                    jQ: p,
                                                                                    ha: v,
                                                                                    aL: g,
                                                                                    kj: h
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, dP = ru, bP = A2(_c, Ss, Ts("[\\W_]+")), mP = E([
        v("\u24B6", "A"),
        v("\uFF21", "A"),
        v("\xc0", "A"),
        v("\xc1", "A"),
        v("\xc2", "A"),
        v("\u1EA6", "A"),
        v("\u1EA4", "A"),
        v("\u1EAA", "A"),
        v("\u1EA8", "A"),
        v("\xc3", "A"),
        v("\u0100", "A"),
        v("\u0102", "A"),
        v("\u1EB0", "A"),
        v("\u1EAE", "A"),
        v("\u1EB4", "A"),
        v("\u1EB2", "A"),
        v("\u0226", "A"),
        v("\u01E0", "A"),
        v("\xc4", "A"),
        v("\u01DE", "A"),
        v("\u1EA2", "A"),
        v("\xc5", "A"),
        v("\u01FA", "A"),
        v("\u01CD", "A"),
        v("\u0200", "A"),
        v("\u0202", "A"),
        v("\u1EA0", "A"),
        v("\u1EAC", "A"),
        v("\u1EB6", "A"),
        v("\u1E00", "A"),
        v("\u0104", "A"),
        v("\u023A", "A"),
        v("\u2C6F", "A"),
        v("\uA732", "AA"),
        v("\xc6", "AE"),
        v("\u01FC", "AE"),
        v("\u01E2", "AE"),
        v("\uA734", "AO"),
        v("\uA736", "AU"),
        v("\uA738", "AV"),
        v("\uA73A", "AV"),
        v("\uA73C", "AY"),
        v("\u24B7", "B"),
        v("\uFF22", "B"),
        v("\u1E02", "B"),
        v("\u1E04", "B"),
        v("\u1E06", "B"),
        v("\u0243", "B"),
        v("\u0182", "B"),
        v("\u0181", "B"),
        v("\u24B8", "C"),
        v("\uFF23", "C"),
        v("\u0106", "C"),
        v("\u0108", "C"),
        v("\u010A", "C"),
        v("\u010C", "C"),
        v("\xc7", "C"),
        v("\u1E08", "C"),
        v("\u0187", "C"),
        v("\u023B", "C"),
        v("\uA73E", "C"),
        v("\u24B9", "D"),
        v("\uFF24", "D"),
        v("\u1E0A", "D"),
        v("\u010E", "D"),
        v("\u1E0C", "D"),
        v("\u1E10", "D"),
        v("\u1E12", "D"),
        v("\u1E0E", "D"),
        v("\u0110", "D"),
        v("\u018B", "D"),
        v("\u018A", "D"),
        v("\u0189", "D"),
        v("\uA779", "D"),
        v("\u01F1", "DZ"),
        v("\u01C4", "DZ"),
        v("\u01F2", "Dz"),
        v("\u01C5", "Dz"),
        v("\u24BA", "E"),
        v("\uFF25", "E"),
        v("\xc8", "E"),
        v("\xc9", "E"),
        v("\xca", "E"),
        v("\u1EC0", "E"),
        v("\u1EBE", "E"),
        v("\u1EC4", "E"),
        v("\u1EC2", "E"),
        v("\u1EBC", "E"),
        v("\u0112", "E"),
        v("\u1E14", "E"),
        v("\u1E16", "E"),
        v("\u0114", "E"),
        v("\u0116", "E"),
        v("\xcb", "E"),
        v("\u1EBA", "E"),
        v("\u011A", "E"),
        v("\u0204", "E"),
        v("\u0206", "E"),
        v("\u1EB8", "E"),
        v("\u1EC6", "E"),
        v("\u0228", "E"),
        v("\u1E1C", "E"),
        v("\u0118", "E"),
        v("\u1E18", "E"),
        v("\u1E1A", "E"),
        v("\u0190", "E"),
        v("\u018E", "E"),
        v("\u24BB", "F"),
        v("\uFF26", "F"),
        v("\u1E1E", "F"),
        v("\u0191", "F"),
        v("\uA77B", "F"),
        v("\u24BC", "G"),
        v("\uFF27", "G"),
        v("\u01F4", "G"),
        v("\u011C", "G"),
        v("\u1E20", "G"),
        v("\u011E", "G"),
        v("\u0120", "G"),
        v("\u01E6", "G"),
        v("\u0122", "G"),
        v("\u01E4", "G"),
        v("\u0193", "G"),
        v("\uA7A0", "G"),
        v("\uA77D", "G"),
        v("\uA77E", "G"),
        v("\u24BD", "H"),
        v("\uFF28", "H"),
        v("\u0124", "H"),
        v("\u1E22", "H"),
        v("\u1E26", "H"),
        v("\u021E", "H"),
        v("\u1E24", "H"),
        v("\u1E28", "H"),
        v("\u1E2A", "H"),
        v("\u0126", "H"),
        v("\u2C67", "H"),
        v("\u2C75", "H"),
        v("\uA78D", "H"),
        v("\u24BE", "I"),
        v("\uFF29", "I"),
        v("\xcc", "I"),
        v("\xcd", "I"),
        v("\xce", "I"),
        v("\u0128", "I"),
        v("\u012A", "I"),
        v("\u012C", "I"),
        v("\u0130", "I"),
        v("\xcf", "I"),
        v("\u1E2E", "I"),
        v("\u1EC8", "I"),
        v("\u01CF", "I"),
        v("\u0208", "I"),
        v("\u020A", "I"),
        v("\u1ECA", "I"),
        v("\u012E", "I"),
        v("\u1E2C", "I"),
        v("\u0197", "I"),
        v("\u24BF", "J"),
        v("\uFF2A", "J"),
        v("\u0134", "J"),
        v("\u0248", "J"),
        v("\u24C0", "K"),
        v("\uFF2B", "K"),
        v("\u1E30", "K"),
        v("\u01E8", "K"),
        v("\u1E32", "K"),
        v("\u0136", "K"),
        v("\u1E34", "K"),
        v("\u0198", "K"),
        v("\u2C69", "K"),
        v("\uA740", "K"),
        v("\uA742", "K"),
        v("\uA744", "K"),
        v("\uA7A2", "K"),
        v("\u24C1", "L"),
        v("\uFF2C", "L"),
        v("\u013F", "L"),
        v("\u0139", "L"),
        v("\u013D", "L"),
        v("\u1E36", "L"),
        v("\u1E38", "L"),
        v("\u013B", "L"),
        v("\u1E3C", "L"),
        v("\u1E3A", "L"),
        v("\u0141", "L"),
        v("\u023D", "L"),
        v("\u2C62", "L"),
        v("\u2C60", "L"),
        v("\uA748", "L"),
        v("\uA746", "L"),
        v("\uA780", "L"),
        v("\u01C7", "LJ"),
        v("\u01C8", "Lj"),
        v("\u24C2", "M"),
        v("\uFF2D", "M"),
        v("\u1E3E", "M"),
        v("\u1E40", "M"),
        v("\u1E42", "M"),
        v("\u2C6E", "M"),
        v("\u019C", "M"),
        v("\u24C3", "N"),
        v("\uFF2E", "N"),
        v("\u01F8", "N"),
        v("\u0143", "N"),
        v("\xd1", "N"),
        v("\u1E44", "N"),
        v("\u0147", "N"),
        v("\u1E46", "N"),
        v("\u0145", "N"),
        v("\u1E4A", "N"),
        v("\u1E48", "N"),
        v("\u0220", "N"),
        v("\u019D", "N"),
        v("\uA790", "N"),
        v("\uA7A4", "N"),
        v("\u01CA", "NJ"),
        v("\u01CB", "Nj"),
        v("\u24C4", "O"),
        v("\uFF2F", "O"),
        v("\xd2", "O"),
        v("\xd3", "O"),
        v("\xd4", "O"),
        v("\u1ED2", "O"),
        v("\u1ED0", "O"),
        v("\u1ED6", "O"),
        v("\u1ED4", "O"),
        v("\xd5", "O"),
        v("\u1E4C", "O"),
        v("\u022C", "O"),
        v("\u1E4E", "O"),
        v("\u014C", "O"),
        v("\u1E50", "O"),
        v("\u1E52", "O"),
        v("\u014E", "O"),
        v("\u022E", "O"),
        v("\u0230", "O"),
        v("\xd6", "O"),
        v("\u022A", "O"),
        v("\u1ECE", "O"),
        v("\u0150", "O"),
        v("\u01D1", "O"),
        v("\u020C", "O"),
        v("\u020E", "O"),
        v("\u01A0", "O"),
        v("\u1EDC", "O"),
        v("\u1EDA", "O"),
        v("\u1EE0", "O"),
        v("\u1EDE", "O"),
        v("\u1EE2", "O"),
        v("\u1ECC", "O"),
        v("\u1ED8", "O"),
        v("\u01EA", "O"),
        v("\u01EC", "O"),
        v("\xd8", "O"),
        v("\u01FE", "O"),
        v("\u0186", "O"),
        v("\u019F", "O"),
        v("\uA74A", "O"),
        v("\uA74C", "O"),
        v("\u01A2", "OI"),
        v("\uA74E", "OO"),
        v("\u0222", "OU"),
        v("\x8c", "OE"),
        v("\u0152", "OE"),
        v("\x9c", "oe"),
        v("\u0153", "oe"),
        v("\u24C5", "P"),
        v("\uFF30", "P"),
        v("\u1E54", "P"),
        v("\u1E56", "P"),
        v("\u01A4", "P"),
        v("\u2C63", "P"),
        v("\uA750", "P"),
        v("\uA752", "P"),
        v("\uA754", "P"),
        v("\u24C6", "Q"),
        v("\uFF31", "Q"),
        v("\uA756", "Q"),
        v("\uA758", "Q"),
        v("\u024A", "Q"),
        v("\u24C7", "R"),
        v("\uFF32", "R"),
        v("\u0154", "R"),
        v("\u1E58", "R"),
        v("\u0158", "R"),
        v("\u0210", "R"),
        v("\u0212", "R"),
        v("\u1E5A", "R"),
        v("\u1E5C", "R"),
        v("\u0156", "R"),
        v("\u1E5E", "R"),
        v("\u024C", "R"),
        v("\u2C64", "R"),
        v("\uA75A", "R"),
        v("\uA7A6", "R"),
        v("\uA782", "R"),
        v("\u24C8", "S"),
        v("\uFF33", "S"),
        v("\u1E9E", "S"),
        v("\u015A", "S"),
        v("\u1E64", "S"),
        v("\u015C", "S"),
        v("\u1E60", "S"),
        v("\u0160", "S"),
        v("\u1E66", "S"),
        v("\u1E62", "S"),
        v("\u1E68", "S"),
        v("\u0218", "S"),
        v("\u015E", "S"),
        v("\u2C7E", "S"),
        v("\uA7A8", "S"),
        v("\uA784", "S"),
        v("\u24C9", "T"),
        v("\uFF34", "T"),
        v("\u1E6A", "T"),
        v("\u0164", "T"),
        v("\u1E6C", "T"),
        v("\u021A", "T"),
        v("\u0162", "T"),
        v("\u1E70", "T"),
        v("\u1E6E", "T"),
        v("\u0166", "T"),
        v("\u01AC", "T"),
        v("\u01AE", "T"),
        v("\u023E", "T"),
        v("\uA786", "T"),
        v("\uA728", "TZ"),
        v("\u24CA", "U"),
        v("\uFF35", "U"),
        v("\xd9", "U"),
        v("\xda", "U"),
        v("\xdb", "U"),
        v("\u0168", "U"),
        v("\u1E78", "U"),
        v("\u016A", "U"),
        v("\u1E7A", "U"),
        v("\u016C", "U"),
        v("\xdc", "U"),
        v("\u01DB", "U"),
        v("\u01D7", "U"),
        v("\u01D5", "U"),
        v("\u01D9", "U"),
        v("\u1EE6", "U"),
        v("\u016E", "U"),
        v("\u0170", "U"),
        v("\u01D3", "U"),
        v("\u0214", "U"),
        v("\u0216", "U"),
        v("\u01AF", "U"),
        v("\u1EEA", "U"),
        v("\u1EE8", "U"),
        v("\u1EEE", "U"),
        v("\u1EEC", "U"),
        v("\u1EF0", "U"),
        v("\u1EE4", "U"),
        v("\u1E72", "U"),
        v("\u0172", "U"),
        v("\u1E76", "U"),
        v("\u1E74", "U"),
        v("\u0244", "U"),
        v("\u24CB", "V"),
        v("\uFF36", "V"),
        v("\u1E7C", "V"),
        v("\u1E7E", "V"),
        v("\u01B2", "V"),
        v("\uA75E", "V"),
        v("\u0245", "V"),
        v("\uA760", "VY"),
        v("\u24CC", "W"),
        v("\uFF37", "W"),
        v("\u1E80", "W"),
        v("\u1E82", "W"),
        v("\u0174", "W"),
        v("\u1E86", "W"),
        v("\u1E84", "W"),
        v("\u1E88", "W"),
        v("\u2C72", "W"),
        v("\u24CD", "X"),
        v("\uFF38", "X"),
        v("\u1E8A", "X"),
        v("\u1E8C", "X"),
        v("\u24CE", "Y"),
        v("\uFF39", "Y"),
        v("\u1EF2", "Y"),
        v("\xdd", "Y"),
        v("\u0176", "Y"),
        v("\u1EF8", "Y"),
        v("\u0232", "Y"),
        v("\u1E8E", "Y"),
        v("\u0178", "Y"),
        v("\u1EF6", "Y"),
        v("\u1EF4", "Y"),
        v("\u01B3", "Y"),
        v("\u024E", "Y"),
        v("\u1EFE", "Y"),
        v("\u24CF", "Z"),
        v("\uFF3A", "Z"),
        v("\u0179", "Z"),
        v("\u1E90", "Z"),
        v("\u017B", "Z"),
        v("\u017D", "Z"),
        v("\u1E92", "Z"),
        v("\u1E94", "Z"),
        v("\u01B5", "Z"),
        v("\u0224", "Z"),
        v("\u2C7F", "Z"),
        v("\u2C6B", "Z"),
        v("\uA762", "Z"),
        v("\u24D0", "a"),
        v("\uFF41", "a"),
        v("\u1E9A", "a"),
        v("\xe0", "a"),
        v("\xe1", "a"),
        v("\xe2", "a"),
        v("\u1EA7", "a"),
        v("\u1EA5", "a"),
        v("\u1EAB", "a"),
        v("\u1EA9", "a"),
        v("\xe3", "a"),
        v("\u0101", "a"),
        v("\u0103", "a"),
        v("\u1EB1", "a"),
        v("\u1EAF", "a"),
        v("\u1EB5", "a"),
        v("\u1EB3", "a"),
        v("\u0227", "a"),
        v("\u01E1", "a"),
        v("\xe4", "a"),
        v("\u01DF", "a"),
        v("\u1EA3", "a"),
        v("\xe5", "a"),
        v("\u01FB", "a"),
        v("\u01CE", "a"),
        v("\u0201", "a"),
        v("\u0203", "a"),
        v("\u1EA1", "a"),
        v("\u1EAD", "a"),
        v("\u1EB7", "a"),
        v("\u1E01", "a"),
        v("\u0105", "a"),
        v("\u2C65", "a"),
        v("\u0250", "a"),
        v("\uA733", "aa"),
        v("\xe6", "ae"),
        v("\u01FD", "ae"),
        v("\u01E3", "ae"),
        v("\uA735", "ao"),
        v("\uA737", "au"),
        v("\uA739", "av"),
        v("\uA73B", "av"),
        v("\uA73D", "ay"),
        v("\u24D1", "b"),
        v("\uFF42", "b"),
        v("\u1E03", "b"),
        v("\u1E05", "b"),
        v("\u1E07", "b"),
        v("\u0180", "b"),
        v("\u0183", "b"),
        v("\u0253", "b"),
        v("\u24D2", "c"),
        v("\uFF43", "c"),
        v("\u0107", "c"),
        v("\u0109", "c"),
        v("\u010B", "c"),
        v("\u010D", "c"),
        v("\xe7", "c"),
        v("\u1E09", "c"),
        v("\u0188", "c"),
        v("\u023C", "c"),
        v("\uA73F", "c"),
        v("\u2184", "c"),
        v("\u24D3", "d"),
        v("\uFF44", "d"),
        v("\u1E0B", "d"),
        v("\u010F", "d"),
        v("\u1E0D", "d"),
        v("\u1E11", "d"),
        v("\u1E13", "d"),
        v("\u1E0F", "d"),
        v("\u0111", "d"),
        v("\u018C", "d"),
        v("\u0256", "d"),
        v("\u0257", "d"),
        v("\uA77A", "d"),
        v("\u01F3", "dz"),
        v("\u01C6", "dz"),
        v("\u24D4", "e"),
        v("\uFF45", "e"),
        v("\xe8", "e"),
        v("\xe9", "e"),
        v("\xea", "e"),
        v("\u1EC1", "e"),
        v("\u1EBF", "e"),
        v("\u1EC5", "e"),
        v("\u1EC3", "e"),
        v("\u1EBD", "e"),
        v("\u0113", "e"),
        v("\u1E15", "e"),
        v("\u1E17", "e"),
        v("\u0115", "e"),
        v("\u0117", "e"),
        v("\xeb", "e"),
        v("\u1EBB", "e"),
        v("\u011B", "e"),
        v("\u0205", "e"),
        v("\u0207", "e"),
        v("\u1EB9", "e"),
        v("\u1EC7", "e"),
        v("\u0229", "e"),
        v("\u1E1D", "e"),
        v("\u0119", "e"),
        v("\u1E19", "e"),
        v("\u1E1B", "e"),
        v("\u0247", "e"),
        v("\u025B", "e"),
        v("\u01DD", "e"),
        v("\u24D5", "f"),
        v("\uFF46", "f"),
        v("\u1E1F", "f"),
        v("\u0192", "f"),
        v("\uA77C", "f"),
        v("\u24D6", "g"),
        v("\uFF47", "g"),
        v("\u01F5", "g"),
        v("\u011D", "g"),
        v("\u1E21", "g"),
        v("\u011F", "g"),
        v("\u0121", "g"),
        v("\u01E7", "g"),
        v("\u0123", "g"),
        v("\u01E5", "g"),
        v("\u0260", "g"),
        v("\uA7A1", "g"),
        v("\u1D79", "g"),
        v("\uA77F", "g"),
        v("\u24D7", "h"),
        v("\uFF48", "h"),
        v("\u0125", "h"),
        v("\u1E23", "h"),
        v("\u1E27", "h"),
        v("\u021F", "h"),
        v("\u1E25", "h"),
        v("\u1E29", "h"),
        v("\u1E2B", "h"),
        v("\u1E96", "h"),
        v("\u0127", "h"),
        v("\u2C68", "h"),
        v("\u2C76", "h"),
        v("\u0265", "h"),
        v("\u0195", "hv"),
        v("\u24D8", "i"),
        v("\uFF49", "i"),
        v("\xec", "i"),
        v("\xed", "i"),
        v("\xee", "i"),
        v("\u0129", "i"),
        v("\u012B", "i"),
        v("\u012D", "i"),
        v("\xef", "i"),
        v("\u1E2F", "i"),
        v("\u1EC9", "i"),
        v("\u01D0", "i"),
        v("\u0209", "i"),
        v("\u020B", "i"),
        v("\u1ECB", "i"),
        v("\u012F", "i"),
        v("\u1E2D", "i"),
        v("\u0268", "i"),
        v("\u0131", "i"),
        v("\u24D9", "j"),
        v("\uFF4A", "j"),
        v("\u0135", "j"),
        v("\u01F0", "j"),
        v("\u0249", "j"),
        v("\u24DA", "k"),
        v("\uFF4B", "k"),
        v("\u1E31", "k"),
        v("\u01E9", "k"),
        v("\u1E33", "k"),
        v("\u0137", "k"),
        v("\u1E35", "k"),
        v("\u0199", "k"),
        v("\u2C6A", "k"),
        v("\uA741", "k"),
        v("\uA743", "k"),
        v("\uA745", "k"),
        v("\uA7A3", "k"),
        v("\u24DB", "l"),
        v("\uFF4C", "l"),
        v("\u0140", "l"),
        v("\u013A", "l"),
        v("\u013E", "l"),
        v("\u1E37", "l"),
        v("\u1E39", "l"),
        v("\u013C", "l"),
        v("\u1E3D", "l"),
        v("\u1E3B", "l"),
        v("\u017F", "l"),
        v("\u0142", "l"),
        v("\u019A", "l"),
        v("\u026B", "l"),
        v("\u2C61", "l"),
        v("\uA749", "l"),
        v("\uA781", "l"),
        v("\uA747", "l"),
        v("\u01C9", "lj"),
        v("\u24DC", "m"),
        v("\uFF4D", "m"),
        v("\u1E3F", "m"),
        v("\u1E41", "m"),
        v("\u1E43", "m"),
        v("\u0271", "m"),
        v("\u026F", "m"),
        v("\u24DD", "n"),
        v("\uFF4E", "n"),
        v("\u01F9", "n"),
        v("\u0144", "n"),
        v("\xf1", "n"),
        v("\u1E45", "n"),
        v("\u0148", "n"),
        v("\u1E47", "n"),
        v("\u0146", "n"),
        v("\u1E4B", "n"),
        v("\u1E49", "n"),
        v("\u019E", "n"),
        v("\u0272", "n"),
        v("\u0149", "n"),
        v("\uA791", "n"),
        v("\uA7A5", "n"),
        v("\u01CC", "nj"),
        v("\u24DE", "o"),
        v("\uFF4F", "o"),
        v("\xf2", "o"),
        v("\xf3", "o"),
        v("\xf4", "o"),
        v("\u1ED3", "o"),
        v("\u1ED1", "o"),
        v("\u1ED7", "o"),
        v("\u1ED5", "o"),
        v("\xf5", "o"),
        v("\u1E4D", "o"),
        v("\u022D", "o"),
        v("\u1E4F", "o"),
        v("\u014D", "o"),
        v("\u1E51", "o"),
        v("\u1E53", "o"),
        v("\u014F", "o"),
        v("\u022F", "o"),
        v("\u0231", "o"),
        v("\xf6", "o"),
        v("\u022B", "o"),
        v("\u1ECF", "o"),
        v("\u0151", "o"),
        v("\u01D2", "o"),
        v("\u020D", "o"),
        v("\u020F", "o"),
        v("\u01A1", "o"),
        v("\u1EDD", "o"),
        v("\u1EDB", "o"),
        v("\u1EE1", "o"),
        v("\u1EDF", "o"),
        v("\u1EE3", "o"),
        v("\u1ECD", "o"),
        v("\u1ED9", "o"),
        v("\u01EB", "o"),
        v("\u01ED", "o"),
        v("\xf8", "o"),
        v("\u01FF", "o"),
        v("\u0254", "o"),
        v("\uA74B", "o"),
        v("\uA74D", "o"),
        v("\u0275", "o"),
        v("\u01A3", "oi"),
        v("\u0223", "ou"),
        v("\uA74F", "oo"),
        v("\u24DF", "p"),
        v("\uFF50", "p"),
        v("\u1E55", "p"),
        v("\u1E57", "p"),
        v("\u01A5", "p"),
        v("\u1D7D", "p"),
        v("\uA751", "p"),
        v("\uA753", "p"),
        v("\uA755", "p"),
        v("\u24E0", "q"),
        v("\uFF51", "q"),
        v("\u024B", "q"),
        v("\uA757", "q"),
        v("\uA759", "q"),
        v("\u24E1", "r"),
        v("\uFF52", "r"),
        v("\u0155", "r"),
        v("\u1E59", "r"),
        v("\u0159", "r"),
        v("\u0211", "r"),
        v("\u0213", "r"),
        v("\u1E5B", "r"),
        v("\u1E5D", "r"),
        v("\u0157", "r"),
        v("\u1E5F", "r"),
        v("\u024D", "r"),
        v("\u027D", "r"),
        v("\uA75B", "r"),
        v("\uA7A7", "r"),
        v("\uA783", "r"),
        v("\u24E2", "s"),
        v("\uFF53", "s"),
        v("\xdf", "s"),
        v("\u015B", "s"),
        v("\u1E65", "s"),
        v("\u015D", "s"),
        v("\u1E61", "s"),
        v("\u0161", "s"),
        v("\u1E67", "s"),
        v("\u1E63", "s"),
        v("\u1E69", "s"),
        v("\u0219", "s"),
        v("\u015F", "s"),
        v("\u023F", "s"),
        v("\uA7A9", "s"),
        v("\uA785", "s"),
        v("\u1E9B", "s"),
        v("\u24E3", "t"),
        v("\uFF54", "t"),
        v("\u1E6B", "t"),
        v("\u1E97", "t"),
        v("\u0165", "t"),
        v("\u1E6D", "t"),
        v("\u021B", "t"),
        v("\u0163", "t"),
        v("\u1E71", "t"),
        v("\u1E6F", "t"),
        v("\u0167", "t"),
        v("\u01AD", "t"),
        v("\u0288", "t"),
        v("\u2C66", "t"),
        v("\uA787", "t"),
        v("\uA729", "tz"),
        v("\u24E4", "u"),
        v("\uFF55", "u"),
        v("\xf9", "u"),
        v("\xfa", "u"),
        v("\xfb", "u"),
        v("\u0169", "u"),
        v("\u1E79", "u"),
        v("\u016B", "u"),
        v("\u1E7B", "u"),
        v("\u016D", "u"),
        v("\xfc", "u"),
        v("\u01DC", "u"),
        v("\u01D8", "u"),
        v("\u01D6", "u"),
        v("\u01DA", "u"),
        v("\u1EE7", "u"),
        v("\u016F", "u"),
        v("\u0171", "u"),
        v("\u01D4", "u"),
        v("\u0215", "u"),
        v("\u0217", "u"),
        v("\u01B0", "u"),
        v("\u1EEB", "u"),
        v("\u1EE9", "u"),
        v("\u1EEF", "u"),
        v("\u1EED", "u"),
        v("\u1EF1", "u"),
        v("\u1EE5", "u"),
        v("\u1E73", "u"),
        v("\u0173", "u"),
        v("\u1E77", "u"),
        v("\u1E75", "u"),
        v("\u0289", "u"),
        v("\u24E5", "v"),
        v("\uFF56", "v"),
        v("\u1E7D", "v"),
        v("\u1E7F", "v"),
        v("\u028B", "v"),
        v("\uA75F", "v"),
        v("\u028C", "v"),
        v("\uA761", "vy"),
        v("\u24E6", "w"),
        v("\uFF57", "w"),
        v("\u1E81", "w"),
        v("\u1E83", "w"),
        v("\u0175", "w"),
        v("\u1E87", "w"),
        v("\u1E85", "w"),
        v("\u1E98", "w"),
        v("\u1E89", "w"),
        v("\u2C73", "w"),
        v("\u24E7", "x"),
        v("\uFF58", "x"),
        v("\u1E8B", "x"),
        v("\u1E8D", "x"),
        v("\u24E8", "y"),
        v("\uFF59", "y"),
        v("\u1EF3", "y"),
        v("\xfd", "y"),
        v("\u0177", "y"),
        v("\u1EF9", "y"),
        v("\u0233", "y"),
        v("\u1E8F", "y"),
        v("\xff", "y"),
        v("\u1EF7", "y"),
        v("\u1E99", "y"),
        v("\u1EF5", "y"),
        v("\u01B4", "y"),
        v("\u024F", "y"),
        v("\u1EFF", "y"),
        v("\u24E9", "z"),
        v("\uFF5A", "z"),
        v("\u017A", "z"),
        v("\u1E91", "z"),
        v("\u017C", "z"),
        v("\u017E", "z"),
        v("\u1E93", "z"),
        v("\u1E95", "z"),
        v("\u01B6", "z")
    ]), pP = Ui(mP), vP = function(n) {
        return n.b ? Rr(A3(ot, zt, n.a, n.b)) : Hr;
    }, gP = A2(_c, 1114111, vP(A2(ju, mt, A2(ju, Gt, mP)))), hP = Cy(A2(ju, function(n) {
        var e = A2(ra, Rd(n), pP);
        return 1 === e.$ ? Jc(Rd(n)) : e.a;
    }, A2(dt, 0, gP))), $P = A2(_c, 0, (Uw = A2(ju, mt, A2(ju, Gt, mP))).b ? Rr(A3(ot, Iw, Uw.a, Uw.b)) : Hr), xP = function(n) {
        return A3(Nd, F2(function(n, e) {
            if (0 > m(mt(n), $P)) return k(e, Jc(n));
            var r = A2(qy, mt(n), hP);
            return k(e, r.$ ? Jc(n) : r.a);
        }), "", n);
    }, kP = A2(Fu, Os, A2(Fu, xP, A2(Fu, A2(_k, bP, function() {
        return " ";
    }), pf))), wP = function(n) {
        switch(n){
            case 0:
                return "Aluminium";
            case 1:
                return "Pile Alcaline";
            case 2:
                return "Cellule de batteries LFP";
            case 3:
                return "Cellule de batteries NMC622";
            case 4:
                return "Cellule de batteries NMC811";
            case 5:
                return "Cereals";
            case 6:
                return "Composites";
            case 7:
                return "Carton";
            case 8:
                return "Cuivre";
            case 9:
                return "Produits laitiers";
            case 10:
                return "\u0152ufs";
            case 11:
                return "M\xe9taux ferreux";
            case 12:
                return "Poissons et crustac\xe9es";
            case 13:
                return "Fruits et l\xe9gumes frais";
            case 14:
                return "Verre";
            case 15:
                return "PEHD";
            case 16:
                return "PEBD";
            case 17:
                return "Legumes";
            case 18:
                return "Abats";
            case 19:
                return "Fibres organiques";
            case 20:
                return "Divers ingr\xe9dients";
            case 21:
                return "Autre type de mati\xe8re";
            case 22:
                return "PET";
            case 23:
                return "PP";
            case 24:
                return "Carte de circuit imprim\xe9";
            case 25:
                return "Volailles et viandes blanches";
            case 26:
                return "PUR";
            case 27:
                return "Viandes rouges";
            case 28:
                return "Plastiques rigides";
            case 29:
                return "Caoutchouc";
            case 30:
                return "Fibres synth\xe9tiques";
            default:
                return "Bois";
        }
    }, yP = function(n) {
        switch(n.$){
            case 0:
                return "Assemblage";
            case 1:
                return "Distribution";
            case 2:
                return "Fin de vie";
            case 3:
                return "\xc9nergie";
            case 4:
                return "Ingr\xe9dient";
            case 5:
                return "Mat\xe9riau";
            case 6:
                return "Type de mat\xe9riau:" + wP(n.a);
            case 7:
                return "Emballage";
            case 8:
                return "Type d\u2019emballage:" + function(n) {
                    switch(n){
                        case 0:
                            return "Sachet";
                        case 1:
                            return "Bouteille";
                        case 2:
                            return "Bo\xeete";
                        case 3:
                            return "Etui";
                        case 4:
                            return "Flacon";
                        case 5:
                            return "Pot & bocal";
                        case 6:
                            return "Autres";
                        case 7:
                            return "Lot";
                        case 8:
                            return "Feuille";
                        default:
                            return "Barquette";
                    }
                }(n.a);
            case 9:
                return "D\xe9pendant de la masse produit";
            case 10:
                return "Mat\xe9riau textile";
            case 11:
                return "Transformation";
            case 12:
                return "Transport";
            case 13:
                return "Transport r\xe9frig\xe9r\xe9";
            case 14:
                return "Utilisation";
            default:
                return "Traitement des d\xe9chets";
        }
    }, jP = A2(Fu, function(n) {
        return A2(at, " ", E([
            _s(n.mf),
            Wb(n),
            Gb(n),
            A2(at, " ", A2(ju, yP, n.cK)),
            A2(at, " ", A2(ju, gs, n.g5)),
            n.gd,
            n.ha
        ]));
    }, kP), EP = function(n) {
        return $(n, {
            jQ: jP(n)
        });
    }, AP = F3(function(n, e, r) {
        return {
            kZ: n,
            gl: e,
            iy: r
        };
    }), CP = A3(ui, "plotSize", hC, A3(ui, "permanentPasture", hC, A3(ui, "outOfEuropeEOL", hC, A3(ui, "microfibers", hC, A3(ui, "hedges", hC, A3(ui, "forest", hC, A3(ui, "cropDiversity", hC, nu(F7(function(n, e, r, t, u, a, i) {
        return {
            ag: n,
            aa: e,
            ah: r,
            aj: t,
            ak: u,
            al: a,
            am: i
        };
    }))))))))), PP = A3(ui, "forestManagement", A2(Qt, A2(cc, Es, function(n) {
        switch(n){
            case "certifiedDiversifiedForest":
                return Zr(0);
            case "certifiedSustainableManagement":
                return Zr(1);
            case "diversifiedForest":
                return Zr(2);
            case "intensivePlantation":
                return Zr(3);
            case "sustainableManagement":
                return Zr(4);
            default:
                return Jr("Invalid or non-supported forest management value: " + n);
        }
    }), ai), A3(ui, "defaultOrigin", xs, A3(ui, "complements", CP, nu(AP)))), TP = {
        $: 2
    }, SP = {
        $: 3
    }, IP = {
        $: 4
    }, OP = {
        $: 5
    }, qP = function(n) {
        return {
            $: 6,
            a: n
        };
    }, LP = {
        $: 7
    }, MP = function(n) {
        return {
            $: 8,
            a: n
        };
    }, _P = {
        $: 10
    }, RP = {
        $: 11
    }, HP = {
        $: 12
    }, UP = {
        $: 14
    }, zP = {
        $: 15
    }, DP = Sb(A2(Qt, A2(Fu, function(n) {
        switch(n){
            case "assembly":
                return Zr(Ox);
            case "distribution":
                return Zr(Dh);
            case "end-of-life":
                return Zr(TP);
            case "energy":
                return Zr(SP);
            case "ingredient":
                return Zr(IP);
            case "material":
                return Zr(OP);
            case "packaging":
                return Zr(LP);
            case "productmassdependent":
                return Zr(Vb);
            case "textile_material":
                return Zr(_P);
            case "transformation":
                return Zr(RP);
            case "transport":
                return Zr(HP);
            case "transported_cooled":
                return Zr(D$);
            case "use":
                return Zr(UP);
            case "waste treatment":
                return Zr(zP);
            default:
                return A2(gu, "material_type:", n) ? A2(ss, qP, ol(A2(ou, 14, n))) : A2(gu, "packaging_type:", n) ? A2(ss, MP, function(n) {
                    switch(n){
                        case "bag":
                            return Zr(0);
                        case "bottle":
                            return Zr(1);
                        case "box":
                            return Zr(2);
                        case "case":
                            return Zr(3);
                        case "flask":
                            return Zr(4);
                        case "jar":
                            return Zr(5);
                        case "other":
                            return Zr(6);
                        case "pack":
                            return Zr(7);
                        case "sheet":
                            return Zr(8);
                        case "tray":
                            return Zr(9);
                        default:
                            return Jr("Type d\u2019emballage non support\xe9\u202F: " + n);
                    }
                }(A2(ou, 15, n))) : Jr("Cat\xe9gorie de proc\xe9d\xe9 invalide: " + n);
        }
    }, Es), ai)), NP = A2(Qt, function(n) {
        return "" === pf(n) ? Ti("String can't be empty") : nu(pf(n));
    }, ai), FP = A2(Zt, Sj, Js), KP = function(n) {
        switch(n){
            case "item":
                return Zr(1);
            case "kg":
                return Zr(2);
            case "kWh":
                return Zr(3);
            case "L":
                return Zr(4);
            case "m2":
                return Zr(6);
            case "m3":
                return Zr(0);
            case "MJ":
                return Zr(5);
            case "t\u22C5km":
                return Zr(7);
            default:
                return Jr("Invalid or non-supported process unit: " + n);
        }
    }, GP = function(n) {
        return A2(tl, Vb, n.cK) && 2 !== n.aL ? Jr("A ProductMassDependent process with a non-mass unit makes no sense") : Zr(n);
    }, WP = A2(Fu, function(n) {
        return A2(Zt, EP, A2(Qt, A2(Fu, GP, Es), A4(Ob, "visible", qu, !0, A3(Ba, "unit", A2(Qt, A2(cc, Es, KP), ai), A3(Ba, "source", ai, A2(Ys, "", A3(Ba, "scopes", Sb(MC), A3(Ba, "qtyVariationRatio", FP, A3(ui, "metadata", PP, A3(Ba, "massPerUnit", Us(Js), A3(Ba, "location", Us(ai), A3(ui, "landOccupation", Js, A3(Ba, "impacts", n, A3(Ba, "id", Eb, A3(Ba, "heatMJ", A2(Zt, db, Js), A3(Ba, "elecKwh", A2(Zt, eb, Js), A3(ui, "displayName", NP, A3(Ba, "comment", ai, A3(Ba, "categories", DP, A3(ui, "alias", NP, A3(Ba, "activityName", A2(Zt, dP, NP), nu(lP))))))))))))))))))))));
    }, Sb), VP = F6(function(n, e, r, t, u, a) {
        return {
            gd: n,
            r: e,
            mf: r,
            ei: t,
            ju: u,
            g5: a
        };
    }), JP = A3(Ba, "scopes", A2(Zt, function(n) {
        return lf(n) ? E([
            bs(1)
        ]) : n;
    }, Sb(MC)), A4(Ob, "published", qu, !0, A3(Ba, "name", ai, A3(ui, "id", A2(Zt, ru, Ms), A3(Ba, "elements", Sb(cm), A3(ui, "comment", ai, nu(VP))))))), BP = Sb(JP), XP = A2(Fu, ci(BP), $a(yt)), QP = F7(function(n, e, r, t, u, a, i) {
        return {
            q: n,
            aM: e,
            aN: r,
            E: t,
            mf: u,
            ai: a,
            as: i
        };
    }), ZP = A3(Ba, "scope", YA, A3(Ba, "label", ai, A3(Ba, "id", Yb, A3(ui, "distribution", Eb, A3(Ba, "cooling", qu, A4(el, "consumptions", Sb(Kb), w, A4(el, "assembly", Sb(Eb), w, nu(QP)))))))), YP = Sb(ZP), nT = A2(Fu, ci(YP), $a(yt)), eT = function(n) {
        return n;
    }, rT = function(n) {
        return A2(is, function(e) {
            return A2(Lg, A4(YC, n.ez, n.ey, n.eA, e), A2(Lg, A2(ss, Sd, Jg(A2(ju, A2(Fu, eT, nT), E([
                n.d5,
                n.en,
                n.eS
            ])))), A2(Lg, Zr(e), A2(Lg, A4(zC, n.d4, n.em, n.eR, e), A2(Lg, A3(HC, n.d7, n.d6, e), A2(Lg, A2($a, yt, A2(ci, iP, n.af)), A2(Lg, A2($a, yt, A2(ci, tP, n.cV)), A2(Lg, A2($a, yt, A2(ci, function(n) {
                return Sb(function(n) {
                    return A3(Ba, "zone", fP, A4(Ob, "scopes", Sb(MC), E([
                        ds,
                        ms
                    ]), A3(Ba, "name", ai, A3(Ba, "heatProcessId", Hs(n), A3(Ba, "electricityProcessId", Hs(n), A3(Ba, "distanceToHub", A2(Zt, vl, Js), A3(ui, "comment", ai, A3(Ba, "code", xs, A3(Ba, "aquaticPollutionScenario", sP, nu(oP))))))))));
                }(n));
            }(e), n.bR)), A2(Lg, A2(ss, A2(Fu, Sd, ju(mC(e))), Jg(A2(ju, A2(Fu, eT, XP), E([
                n.fc,
                n.el,
                n.ex,
                n.eQ
            ])))), Zr(dC))))))))));
        }, A2($a, yt, A2(ci, WP(cP), n.W)));
    }, tT = F3(function(n, e, r) {
        var t = e.d$;
        return A2(ss, function(e) {
            return $(n, {
                h4: e,
                C: r,
                d$: t
            });
        }, A2(wl, r, n.fw.ay));
    }), uT = F2(function(n, e) {
        if (us(n) && !us(e)) {
            var r = A2(is, A2(tT, t = e, {
                d$: !1
            }), A2(is, rT, A2(ws, "Aucune donn\xe9e brute disponible en session pour reconstruire la base de donn\xe9es", t.fw.C)));
            return 1 === r.$ ? A3(lC, "Impossible de recharger la base avec les donn\xe9es publiques", r.a, e) : r.a;
        }
        var t;
        return e;
    }), aT = F2(function(n, e) {
        var r = A2(ci, cC, n);
        return 1 === r.$ ? A2(fC, r.a, e) : A2(uT, e, $(e, {
            bH: r.a
        }));
    }), iT = vj("CN"), cT = {
        cE: Hr,
        hW: Hr,
        bx: Rr(iT),
        bS: Rr(iT),
        bT: Rr(iT),
        cT: Rr(iT),
        cX: w,
        cZ: Hr,
        b1: Hr,
        c6: Hr,
        mR: Hr,
        dj: Hr,
        dk: Hr,
        P: .17,
        fn: w,
        ja: Hr,
        dm: Hr,
        jn: Hr,
        dn: Hr,
        aS: "tshirt",
        hf: Hr,
        pb: Hr,
        dI: !1,
        pR: Hr
    }, oT = {
        aW: Hr,
        ao: w,
        aX: uC,
        hz: 0
    }, fT = function(n) {
        return A2(Fu, ks(A2(Fu, function(n) {
            return n.ei;
        }, Rt(n))), A2(Fu, ys, ws("Exemple introuvable avec le nom " + n)));
    }, sT = function(n) {
        return function(e) {
            return function(r) {
                return function(t) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(m) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function(g) {
                                                                            return function(h) {
                                                                                return {
                                                                                    bR: n,
                                                                                    cV: e,
                                                                                    fc: r,
                                                                                    d4: t,
                                                                                    d5: u,
                                                                                    d6: a,
                                                                                    d7: i,
                                                                                    el: c,
                                                                                    em: o,
                                                                                    en: f,
                                                                                    W: s,
                                                                                    ex: l,
                                                                                    ey: d,
                                                                                    ez: b,
                                                                                    eA: m,
                                                                                    af: p,
                                                                                    eQ: v,
                                                                                    eR: g,
                                                                                    eS: h
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, lT = F2(function(n, e) {
        var r = v(e, n);
        n: for(;;){
            e: for(;;){
                r: for(;;){
                    t: for(;;)switch(r.a.$){
                        case 3:
                            switch(r.b.$){
                                case 3:
                                    return ya((0, r.a.a)(r.b.a));
                                case 2:
                                    break n;
                                case 1:
                                    break r;
                                default:
                                    return zu;
                            }
                        case 2:
                            return wa(r.a.a);
                        case 1:
                            if (2 === r.b.$) break n;
                            break e;
                        default:
                            switch(r.b.$){
                                case 2:
                                    break n;
                                case 1:
                                    break r;
                                default:
                                    break t;
                            }
                    }
                    return zu;
                }
                return Na;
            }
            return Na;
        }
        return wa(r.b.a);
    }), dT = ya, bT = function(n) {
        return A2(lT, n.eS, A2(lT, n.eR, A2(lT, n.eQ, A2(lT, n.af, A2(lT, n.eA, A2(lT, n.ez, A2(lT, n.ey, A2(lT, n.ex, A2(lT, n.W, A2(lT, n.en, A2(lT, n.em, A2(lT, n.el, A2(lT, n.d7, A2(lT, n.d6, A2(lT, n.d5, A2(lT, n.d4, A2(lT, n.fc, A2(lT, n.cV, A2(lT, n.bR, dT(sT))))))))))))))))))));
    }, mT = function(n) {
        var e = bT(n);
        return 3 === e.$ ? Rr(e.a) : Hr;
    }, pT = F5(function(n, e, r, t, u) {
        var a = n.c7;
        return A2(aT, a.g2, {
            kU: a.kU,
            h4: u,
            k9: WA,
            C: r,
            d$: !1,
            lN: a.lN,
            mW: a.mW,
            m6: n.m6,
            a1: w,
            nI: a.nI,
            aG: {
                l1: bA,
                fb: Xx,
                gN: Xx,
                oT: A2(eh, cT, A2(ss, function(n) {
                    return n.g1;
                }, A2(fT, "Tshirt coton (150g) - Majorant par d\xe9faut", r.oT.lP))),
                f_: Xx
            },
            fw: {
                ay: t,
                C: mT(e)
            },
            oh: a.oh,
            bH: oT,
            pH: a.pH
        });
    }), vT = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gT = F2(function(n, e) {
        var r, t = function(n) {
            return "Impossible de charger la configuration des composants: " + n;
        };
        switch(n.$){
            case 4:
                var u = n.a, a = n.b, i = n.c;
                switch(i.$){
                    case 2:
                        return v($(e, {
                            H: Yf(t(ts(i.a)))
                        }), Tc);
                    case 1:
                    case 0:
                        return v(e, Tc);
                    default:
                        var c = i.a, o = A2(wl, u, c);
                        if (1 === o.$) return v($(e, {
                            H: Yf(t(o.a))
                        }), Tc);
                        var f = A5(pT, a, e.by, u, c, o.a);
                        return A4(GA, a.a6, f, es, v($(e, {
                            H: A2(ns, f, es)
                        }), Uu(E([
                            us(f) ? A2(Tl, f, Zf) : Tc,
                            A2(Nl, f, rs(a.a6))
                        ]))));
                }
            case 11:
                a = n.a;
                var s = A2(n.b, n.c, e.by), l = function(n) {
                    var e = bT(n);
                    switch(e.$){
                        case 2:
                            return Rr(Jr(function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(e.a)));
                        case 1:
                        case 0:
                            return Hr;
                        default:
                            return Rr(A2($a, vT, rT(e.a)));
                    }
                }(s);
                return l.$ ? v($(e, {
                    by: s
                }), Tc) : l.a.$ ? v($(e, {
                    by: s,
                    H: Yf((r = l.a.a, r.$ ? "Erreur de d\xe9codage des donn\xe9es\xa0: " + r.a : "Erreur de t\xe9l\xe9chargement des donn\xe9es\xa0: " + ts(r.a)))
                }), Tc) : (u = l.a.a, v($(e, {
                    by: s
                }), Da({
                    lQ: ka(A2(Fu, ja, A2(Qf, u, a))),
                    a6: "/data/components/config.json"
                })));
            default:
                return v(e, Tc);
        }
    }), hT = function(n) {
        return A2(Ou, $u, Pn(function() {
            try {
                tr.location = n;
            } catch (n) {
                ie.location.reload(!1);
            }
        }));
    }, $T = F2(function(n, e) {
        return v(e.a, n(e.b));
    }), xT = F2(function(n, e) {
        return $(e, {
            ac: A2(Vx, {
                ay: n.h4,
                C: n.C,
                as: bs(e.iA)
            }, A2(Zx, e.iA, n))
        });
    }), kT = F2(function(n, e) {
        return $(e, {
            dx: A3(QE, n.C, n.h4, n.aG.oT)
        });
    }), wT = F2(function(n, e) {
        switch(e.$){
            case 5:
                return Ql(A2(xT, n, e.a));
            case 10:
                return td(A2(kT, n, e.a));
            default:
                return e;
        }
    }), yT = F2(function(n, e) {
        return $(e, {
            bH: n(e.bH)
        });
    }), jT = F2(function(n, e) {
        var r = e.a, t = e.b;
        if (!n) return v(r, t);
        var u = r.H;
        switch(u.$){
            case 0:
            case 1:
                return v(r, t);
            default:
                var a = u.a, i = u.b, c = function() {
                    if (0 > m(a.bH.hz, 100)) {
                        var n = a.bH.hz + 1;
                        return v(s(n, 100), A2(yT, function(e) {
                            return $(e, {
                                hz: n
                            });
                        }, a));
                    }
                    return v(!1, a);
                }();
                return v($(r, {
                    bc: r.bc || c.a,
                    H: A2(ns, c.b, i)
                }), t);
        }
    }), ET = F3(function(n, e, r) {
        return A2(Tp, n, r);
    }), AT = function(n) {
        return {
            $: 3,
            a: n
        };
    }, CT = {
        $: 1
    }, PT = {
        $: 2
    }, TT = ee("copyToClipboard", Ic), ST = function(n) {
        return {
            $: 0,
            a: n
        };
    }, IT = F2(function(n, e) {
        return $(e, {
            a1: k(e.a1, E([
                ST(n)
            ]))
        });
    }), OT = function(n) {
        return {
            eb: 1,
            ef: n,
            er: !1,
            eC: Hr
        };
    }, qT = function(n) {
        return hA(OT(n));
    }, LT = {
        $: 3
    }, MT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, _T = function(n) {
        return $(n, {
            a1: w
        });
    }, RT = function(n) {
        return -2 === n.$;
    }, HT = F2(function(n, e) {
        return A2(uT, e, A2(yT, function(e) {
            return $(e, {
                aW: n
            });
        }, e));
    }), UT = HT(Hr), zT = function(n) {
        switch(n.$){
            case 0:
            case 1:
                return n.a;
            case 2:
                var e = n.a;
                return {
                    il: "L'URL semble mal form\xe9e et n'a pas pu \xeatre charg\xe9e\xa0: " + e,
                    l8: Zu,
                    j0: 0,
                    eC: Hr,
                    a6: e
                };
            case 3:
                return {
                    il: "Erreur de communication r\xe9seau. \xcates-vous connect\xe9\xa0?",
                    l8: Zu,
                    j0: 0,
                    eC: Hr,
                    a6: ""
                };
            default:
                return {
                    il: "Le temps maximum d'attente de la r\xe9ponse a \xe9t\xe9 d\xe9pass\xe9.",
                    l8: Zu,
                    j0: 0,
                    eC: Hr,
                    a6: ""
                };
        }
    }, DT = F2(function(n, e) {
        return {
            bp: e.bp,
            bQ: e.bQ,
            eg: e.eg,
            eu: n(e.eu)
        };
    }), NT = F2(function(n, e) {
        return n ? qT(e) : ru;
    }), FT = function(n) {
        var e = n.nP;
        return {
            bX: e.oS,
            aY: e.aY,
            aC: e.aC,
            aD: e.aD
        };
    }, KT = F2(function(n, e) {
        return A2(uT, e, A2(yT, function(e) {
            return $(e, {
                aW: A2(Lc, n, e.aW)
            });
        }, e));
    }), GT = F2(function(n, e) {
        return A2(Tp, n, e);
    }), WT = function(n) {
        return A2(dr, "application/json", A2(tt, 0, n));
    }, VT = F5(function(n, e, r, t, u) {
        return za({
            kK: WT(u),
            lQ: A2(Cl, A2(Fu, ja, r), t),
            l8: yl(n),
            mZ: "PATCH",
            oU: Hr,
            o8: Hr,
            a6: A2(Yv, n, e)
        });
    }), JT = F3(function(n, e, r) {
        return A5(VT, n, "me", e, xg, function(n) {
            return Mc(E([
                v("emailOptin", Rc(n.aY)),
                v("firstName", Ic(n.aC)),
                v("lastName", Ic(n.aD)),
                v("termsAccepted", Rc(n.bX))
            ]));
        }(r));
    }), BT = F3(function(n, e, r) {
        return r ? A2(ia, n, e) : ru;
    }), XT = function(n) {
        var e = "Le champ est obligatoire", r = A2(Fu, pf, su);
        return A4(BT, "lastName", e, r(n.aD), A4(BT, "firstName", e, r(n.aC), Zu));
    }, QT = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 8:
                return A2(Op, E([
                    hT(MA(ld))
                ]), A2(qT, "Vous avez \xe9t\xe9 deconnect\xe9", A2(Tp, UT(n), u)));
            case 12:
                switch(t.c.$){
                    case 3:
                        var a = t.a.eO, i = t.c.a, c = A2(KT, function(n) {
                            return $(n, {
                                fZ: i
                            });
                        }, n);
                        return A2(Op, E([
                            a ? A2(Nl, n, LT) : Tc,
                            i.nP.oS && !c.d$ ? A2(Tl, c, MT) : Tc
                        ]), A3(NT, a, "Votre profil a \xe9t\xe9 mis \xe0 jour avec succ\xe8s", A2(Tp, c, $(u, {
                            u: A3(_p, $(e, {
                                fZ: i
                            }), FT(i), Zu)
                        }))));
                    case 2:
                        var o = t.c.a;
                        return 401 === zT(o).j0 ? A2(qT, "Session invalide ou expir\xe9e, vous avez \xe9t\xe9 deconnect\xe9. Vous devrez vous reconnecter.", A2(DT, UT, A2(Tp, n, $(u, {
                            u: A2(qp, "", zu)
                        })))) : A2(Tp, A2(IT, o, n), u);
                    default:
                        break n;
                }
            case 13:
                var f = XT(r), s = $(u, {
                    u: A3(_p, e, r, f)
                });
                return RT(f) ? A2(Op, E([
                    A3(JT, n, A2(Mp, {
                        eO: !0
                    }, e.f$), r)
                ]), A2(Tp, _T(n), s)) : A3($A, "Erreur de sauvegarde", "Veuillez corriger les champs en erreur", A2(Tp, n, s));
            case 18:
                return A2(Tp, n, $(u, {
                    u: A3(_p, e, t.a, Zu)
                }));
            default:
                break n;
        }
        return A2(GT, n, u);
    }), ZT = function(n) {
        return {
            $: 5,
            a: n
        };
    }, YT = F3(function(n, e, r) {
        var t;
        return za({
            kK: Ea,
            lQ: (t = A2(Fu, ja, r), A2(Cl, t, nu(0))),
            l8: yl(n),
            mZ: "DELETE",
            oU: Hr,
            o8: Hr,
            a6: A2(Yv, n, e)
        });
    }), nS = F3(function(n, e, r) {
        return A3(YT, n, "tokens/" + e.mf, r);
    }), eS = function(n) {
        return hA(function(n) {
            return {
                eb: 2,
                ef: n,
                er: !1,
                eC: Hr
            };
        }(n));
    }, rS = F3(function(n, e, r) {
        n: for(;;)switch(e.$){
            case 4:
                return A2(Op, E([
                    A3(nS, n, e.a, ZT)
                ]), A2(Tp, n, r));
            case 5:
                switch(e.a.$){
                    case 3:
                        return A2(Op, E([
                            A2(eg, n, Lp)
                        ]), A2(eS, "Le jeton d\u2019API a \xe9t\xe9 supprim\xe9", A2(Tp, n, $(r, {
                            u: AT(Na)
                        }))));
                    case 2:
                        return A2(Tp, A2(IT, e.a.a, n), r);
                    default:
                        break n;
                }
            default:
                break n;
        }
        return A2(GT, n, r);
    }), tS = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uS = {
        $: 0
    }, aS = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iS = A2(Zt, ru, ai), cS = F5(function(n, e, r, t, u) {
        return za({
            kK: WT(u),
            lQ: A2(Cl, A2(Fu, ja, r), t),
            l8: yl(n),
            mZ: "POST",
            oU: Hr,
            o8: Hr,
            a6: A2(Yv, n, e)
        });
    }), oS = F2(function(n, e) {
        return A5(cS, n, "tokens", e, A2(dl, E([
            "token"
        ]), iS), Ru);
    }), fS = F3(function(n, e, r) {
        n: for(;;)switch(e.$){
            case 0:
                return A2(Tp, n, $(r, {
                    u: AT(e.a)
                }));
            case 2:
                return A2(Op, E([
                    A2(oS, n, aS)
                ]), A2(Tp, n, r));
            case 3:
                switch(e.a.$){
                    case 3:
                        var t = e.a.a;
                        return A2(Op, E([
                            A2(eg, n, Lp),
                            A2(Nl, n, uS)
                        ]), A2(Tp, n, $(r, {
                            u: tS(t)
                        })));
                    case 2:
                        return A2(Tp, A2(IT, e.a.a, n), r);
                    default:
                        break n;
                }
            case 16:
                if (3 === e.a.$) return A2(Op, E([
                    A2(eg, n, Lp)
                ]), A2(Tp, n, $(r, {
                    u: AT(Na)
                })));
                break n;
            default:
                break n;
        }
        return A2(GT, n, r);
    }), sS = F2(function(n, e) {
        var r = A2(is, A2(tT, e, {
            d$: !0
        }), A2(is, function(e) {
            return rT($(e, {
                W: Ka(n)
            }));
        }, A2(ws, "Aucune donn\xe9e brute disponible en session pour reconstruire la base de donn\xe9es", e.fw.C)));
        return 1 === r.$ ? A3(lC, "Impossible de recharger la db avec les nouveaux proc\xe9d\xe9s", r.a, e) : r.a;
    }), lS = function(n) {
        return {
            $: 10,
            a: n
        };
    }, dS = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bS = F3(function(n, e, r) {
        return A5(cS, n, "access/magic_link/login", e, nu(0), Mc(E([
            v("email", Ic(r))
        ])));
    }), mS = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 10:
                switch(t.a.$){
                    case 3:
                        return A2(Tp, n, $(u, {
                            u: dS(e)
                        }));
                    case 2:
                        return A2(Tp, A2(IT, t.a.a, n), u);
                    default:
                        break n;
                }
            case 11:
                return A2(Op, E([
                    A3(bS, n, lS, pf(e))
                ]), A2(Tp, n, $(u, {
                    u: A2(qp, e, Na)
                })));
            case 17:
                return A2(Tp, n, $(u, {
                    u: A2(qp, t.a, r)
                }));
            default:
                break n;
        }
        return A2(GT, n, u);
    }), pS = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vS = F4(function(n, e, r, t) {
        return A4(ng, n, "access/login?email=" + r + "&token=" + t, e, XA);
    }), gS = F3(function(n, e, r) {
        return za({
            kK: Ea,
            lQ: A2(Cl, A2(Fu, ja, e), xg),
            l8: E([
                A2(mi, "Authorization", "Bearer " + r)
            ]),
            mZ: "GET",
            oU: Hr,
            o8: Hr,
            a6: n.kU + "/backend/api/me"
        });
    }), hS = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 7:
                switch(t.a.$){
                    case 3:
                        return A2(Op, E([
                            A3(gS, n, A2(Mp, {
                                eO: !1
                            }, i = t.a.a), i.kr)
                        ]), A2(Tp, n, $(u, {
                            u: A2(yA, e, r)
                        })));
                    case 2:
                        var a = t.a.a;
                        return A2(Op, E([
                            hT(MA(ld))
                        ]), A2(Tp, Rl(n) && 403 === zT(a).j0 ? n : A2(IT, a, n), u));
                    default:
                        break n;
                }
            case 9:
                return A2(Op, E([
                    A4(vS, n, pS, e, r)
                ]), A2(Tp, n, u));
            case 12:
                switch(t.c.$){
                    case 3:
                        var i, c = t.c.a, o = A2(HT, Rr({
                            f$: i = t.b,
                            fZ: c
                        }), n), f = us(o);
                        return A2(Op, E([
                            f ? A2(Tl, o, MT) : A2(jA, o.m6, MA(ld))
                        ]), A3(NT, !f, "Vous devez valider les CGU Ecoinvent/Base Empreinte pour avoir acc\xe8s aux impacts d\xe9taill\xe9s", A2(Tp, o, $(u, {
                            jX: !f,
                            u: A3(_p, {
                                f$: i,
                                fZ: c
                            }, FT(c), Zu)
                        }))));
                    case 2:
                        return a = t.c.a, A2(Op, E([
                            hT(MA(ld))
                        ]), A2(Tp, A2(IT, a, n), u));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return A2(GT, n, u);
    }), $S = {
        $: 4
    }, xS = function(n) {
        return {
            $: 8,
            a: n
        };
    }, kS = function(n) {
        return {
            $: 14,
            a: n
        };
    }, wS = F3(function(n, e, r) {
        var t;
        return A5(cS, n, "access/magic_link/signup", e, xg, Mc(E([
            v("email", Ic((t = r).c1)),
            v("emailOptin", Rc(t.aY)),
            v("firstName", Ic(t.aC)),
            v("lastName", Ic(t.aD)),
            v("organization", Eo(t.ck)),
            v("termsAccepted", Rc(t.bX))
        ])));
    }), yS = F3(function(n, e, r) {
        return 1 === e.$ ? A4(BT, n, e.a, !0, r) : r;
    }), jS = function(n) {
        switch(n.$){
            case 0:
            case 1:
            case 2:
            case 4:
            case 5:
            case 6:
            default:
                return Rr(n.a);
            case 3:
                return Hr;
        }
    }, ES = ru, AS = function(n) {
        return A4(BT, "email", "L'adresse e-mail est invalide", A2(_c, !1, A2(Lc, function(e) {
            return !A2(Cs, e, n);
        }, Ts("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"))), Zu);
    }, CS = function(n) {
        var e, r = "Le champ est obligatoire", t = A2(Fu, pf, su);
        return A4(BT, "termsAccepted", "Les CGU doivent \xeatre accept\xe9es", !n.oS, A3(yS, "organization.siren", 1 === (e = n.ck).$ ? mg(e.b) : Zr(ES("")), A4(BT, "organization.name", r, A2(_c, !1, A2(Lc, t, jS(n.ck))), A4(BT, "lastName", r, t(n.aD), A4(BT, "firstName", r, t(n.aC), AS(n.c1))))));
    }, PS = F5(function(n, e, r, t, u) {
        n: for(;;)switch(t.$){
            case 14:
                switch(t.a.$){
                    case 3:
                        return A2(Op, E([
                            A2(Nl, n, $S)
                        ]), A2(Tp, n, $(u, {
                            u: xS(e.c1)
                        })));
                    case 2:
                        return A2(Tp, A2(IT, t.a.a, n), $(u, {
                            u: A3(HA, e, Zu, zu)
                        }));
                    default:
                        break n;
                }
            case 15:
                var a = CS(e);
                return RT(a) ? A2(Op, E([
                    A3(wS, n, kS, e)
                ]), A2(Tp, _T(n), $(u, {
                    u: A3(HA, e, a, Na)
                }))) : A3($A, "Erreur de sauvegarde", "Veuillez corriger les champs en erreur", A2(Tp, n, $(u, {
                    u: A3(HA, e, a, zu)
                })));
            case 19:
                return A2(Tp, n, $(u, {
                    u: A3(HA, t.a, Zu, r)
                }));
            default:
                break n;
        }
        return A2(GT, n, u);
    }), TS = F3(function(n, e, r) {
        n: for(;;)switch(e.$){
            case 1:
                return A2(qT, "Le jeton d\u2019API a \xe9t\xe9 copi\xe9 dans le presse-papiers", A2(Op, E([
                    TT(e.a)
                ]), A2(Tp, n, r)));
            case 6:
                switch(e.a.$){
                    case 3:
                        var t = A2(sS, e.a.a, n);
                        return A2(Op, E([
                            A2(jA, t.m6, MA(ld)),
                            A2(Nl, n, CT)
                        ]), A2(Tp, t, $(r, {
                            jX: !0
                        })));
                    case 2:
                        return A2(Tp, A2(IT, e.a.a, n), r);
                    default:
                        break n;
                }
            case 16:
                switch(e.a.$){
                    case 0:
                        return A2(Op, E([
                            A2(kg, n, A2(Mp, {
                                eO: !1
                            }, (i = e.a.a).f$))
                        ]), A2(Tp, n, $(r, {
                            u: A3(_p, i, Rp, Zu)
                        })));
                    case 3:
                        return A2(Op, E([
                            A2(eg, n, Lp)
                        ]), A2(Tp, n, $(r, {
                            u: AT(Na)
                        })));
                    default:
                        return A2(Tp, n, $(r, {
                            u: e.a
                        }));
                }
            default:
                break n;
        }
        var u = e, a = r.u;
        switch(a.$){
            case 0:
                var i;
                return A5(QT, n, i = a.a, a.b, u, r);
            case 1:
                return A2(Tp, n, r);
            case 2:
                return A3(rS, n, u, r);
            case 3:
                return A3(fS, n, u, r);
            case 4:
                return A5(mS, n, a.a, a.b, u, r);
            case 5:
                return A5(hS, n, a.a, a.b, u, r);
            case 6:
                return A2(Op, E([
                    A2(Nl, n, PT)
                ]), A2(Tp, n, r));
            case 7:
                return A5(PS, n, a.a, a.c, u, r);
            default:
                return A2(GT, n, r);
        }
    }), SS = F3(function(n, e, r) {
        return A2(Tp, n, $(r, {
            h5: e
        }));
    }), IS = function(n) {
        switch(n.$){
            case 0:
                return A2(Sm, n.a, Hr);
            case 1:
                return Im(Hr);
            case 2:
                return yd(Hr);
            case 3:
                return Om(Hr);
            case 4:
                return A2(jd, n.a, Hr);
            case 5:
                return qm(Hr);
            case 6:
                return A2(Lm, n.a, Hr);
            case 7:
                return A2(Mm, n.a, Hr);
            case 8:
                return Ed(Hr);
            case 9:
                return _m(Hr);
            default:
                return Rm(Hr);
        }
    }, OS = ee("scrollIntoView", Ic), qS = A2(Fu, Em, ss(ru)), LS = A2(Fu, Em, ss(ru)), MS = A2(Fu, Em, ss(ru)), _S = A2(Fu, Em, ss(ru)), RS = F2(function(n, e) {
        switch(e.$){
            case 0:
                return A2(Sm, e.a, Ld(qS(n)));
            case 1:
                return Im(Rr(vj(n)));
            case 2:
                return yd(Ld(Em(n)));
            case 3:
                return Om(Ld(MS(n)));
            case 4:
                return A2(jd, e.a, Ld(Em(n)));
            case 5:
                return qm(Ld(ym(n)));
            case 6:
                return A2(Lm, e.a, Ld(qC(n)));
            case 7:
                return A2(Mm, e.a, Ld(LS(n)));
            case 8:
                return Ed(Ld(Em(n)));
            case 9:
                return _m(Ld(_S(n)));
            default:
                return Rm(Rr(n));
        }
    }), HS = F3(function(n, e, r) {
        return A2(Ou, $u, A3(yr, n, e, r));
    }), US = function(n) {
        return 1 === n.$ ? Rr(n.a) : Hr;
    }, zS = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return jr(n.a);
        }
    }, DS = F3(function(n, e, r) {
        switch(n.$){
            case 0:
                return A3(Er, e, r, n.a);
            case 1:
                return A4(Ar, e, r, n.b, !n.a);
            case 2:
                return A4(Cr, e, r, n.b, !n.a);
            case 3:
                return A3(Pr, e, r, n.a);
            case 4:
                return A4(Tr, e, r, n.b, !n.a);
            case 5:
                return A4(Sr, e, r, n.b, !n.a);
            case 6:
                return A4(Ir, e, r, n.b, !n.a);
            case 7:
                return A4(Or, e, r, n.b, !n.a);
            case 8:
                return A3(NS, n.b, e, r);
            case 9:
                return A3(Lr, e, r, n.b);
            default:
                return A3(qr, e, r, n.a);
        }
    }), NS = F3(function(n, e, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.b, u = e, a = A3(DS, n.a, e, r);
            n = t, e = u, r = a;
        }
    }), FS = F2(function(n, e) {
        return A2(Mr, n, e);
    }), KS = {
        f5: !0,
        e3: ","
    }, GS = function(n) {
        var e = new DataView(new ArrayBuffer(zS(n)));
        return DS(n)(e)(0), e;
    }, WS = F2(function(n, e) {
        return {
            $: 9,
            a: n,
            b: e
        };
    }), VS = function(n) {
        return A2(WS, function(n) {
            for(var e = 0, r = 0; n.length > r; r++){
                var t = n.charCodeAt(r);
                e += 128 > t ? 1 : 2048 > t ? 2 : 55296 > t || t > 56319 ? 3 : (r++, 4);
            }
            return e;
        }(n), n);
    }, JS = VS("\r\n"), BS = A2(Fu, it('"'), at('""')), XS = F2(function(n, e) {
        return n.f5 || A2(au, n.e3, e) ? '"' + BS(e) + '"' : BS(e);
    }), QS = F2(function(n, e) {
        if (e.b) {
            var r = e.b;
            return A2(Ur, e.a, A3(yu, F2(function(e, r) {
                return A2(Ur, n, A2(Ur, e, r));
            }), w, r));
        }
        return w;
    }), ZS = F2(function(n, e) {
        return {
            $: 8,
            a: n,
            b: e
        };
    }), YS = F2(function(n, e) {
        for(;;){
            if (!e.b) return n;
            var r = e.b;
            n += zS(e.a), e = r;
        }
    }), nI = function(n) {
        return A2(ZS, A2(YS, 0, n), n);
    }, eI = function(n) {
        return A2(Fu, ju(function(n) {
            var e = n.e3;
            return A2(Fu, ju(XS(n)), A2(Fu, QS(e), A2(Fu, ju(VS), nI)));
        }(n)), A2(Fu, QS(JS), nI));
    }, rI = F2(function(n, e) {
        return nI(E([
            A2(eI, n, A2(Ur, e.l8, e.nX)),
            JS
        ]));
    }), tI = function(n) {
        return A2(Fu, rI(n), GS);
    }, uI = jr, aI = F2(function(n, e) {
        var r, t = A2(tI, n, e), u = A2(FS, (r = uI(t), _r(r)), t);
        return u.$ ? iI()(e) : u.a;
    });
    function iI() {
        return aI(KS);
    }
    var cI = iI();
    iI = function() {
        return cI;
    };
    var oI, fI, sI, lI = F2(function(n, e) {
        return A2(ba, n, e);
    }), dI = F3(function(n, e, r) {
        return A2(ma, n, A2(Fu, _c(uC), A2(Fu, r ? aC(e) : lI(e), Rr)));
    }), bI = F3(function(n, e, r) {
        switch(e.$){
            case 0:
                return A2(Ag, n, $(r, {
                    az: IS(r.az)
                }));
            case 1:
                return A2(Op, E([
                    A3(HS, e.a, "text/csv", cI(e.b))
                ]), A2(Ag, n, r));
            case 2:
                return A2(Ag, n, r);
            case 3:
                return A2(Ag, n, $(r, {
                    az: A2(RS, e.a, r.az)
                }));
            case 4:
                var t = e.a;
                return A2(Op, E([
                    A2(jA, n.m6, MA(A2(pd, t, function() {
                        switch(r.az.$){
                            case 1:
                                return Im(Hr);
                            case 5:
                                return qm(Hr);
                            case 6:
                                return A2(Lm, t, Hr);
                            case 7:
                                var n = US(t);
                                return n.$ ? Ad(t) : A2(Mm, n.a, Hr);
                            default:
                                return Ad(t);
                        }
                    }())))
                ]), A2(Ag, n, $(r, {
                    c5: Zu,
                    as: t
                })));
            case 5:
                return A2(Ag, n, $(r, {
                    fM: e.a
                }));
            case 6:
                var u = e.a, a = e.b, i = e.c;
                return A2(Op, E([
                    i ? OS(A3(Xb, "{key}", u, '[data-scroll-id="{key}"] label:first-child')) : Tc
                ]), A2(Ag, n, $(r, {
                    c5: A4(dI, u, a, i, r.c5)
                })));
            default:
                return A2(Ag, n, $(r, {
                    du: e.a
                }));
        }
    }), mI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pI = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), vI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gI = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), hI = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $I = {
        $: 2
    }, xI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, kI = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), wI = function(n) {
        return {
            $: 11,
            a: n
        };
    }, yI = F2(function(n, e) {
        return {
            $: 12,
            a: n,
            b: e
        };
    }), jI = {
        $: 13
    }, EI = function(n) {
        return {
            $: 14,
            a: n
        };
    }, AI = function(n) {
        return {
            $: 15,
            a: n
        };
    }, CI = function(n) {
        return {
            $: 16,
            a: n
        };
    }, PI = F3(function(n, e, r) {
        return {
            $: 29,
            a: n,
            b: e,
            c: r
        };
    }), TI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, SI = F2(function(n, e) {
        return {
            $: 14,
            a: n,
            b: e
        };
    }), II = function(n) {
        return $(n, {
            fT: A2(Lc, function(e) {
                var r;
                return $(e, {
                    P: (r = n.mm, ch(A2(ju, function(n) {
                        return n.P;
                    }, r)))
                });
            }, n.fT)
        });
    }, OI = F2(function(n, e) {
        return II($(e, {
            mm: k(e.mm, E([
                n
            ]))
        }));
    }), qI = F2(function(n, e) {
        return $(e, {
            cm: k(e.cm, E([
                n
            ]))
        });
    }), LI = F2(function(n, e) {
        return $(e, {
            bj: k(e.bj, E([
                n
            ]))
        });
    }), MI = F3(function(n, e, r) {
        var t = r.bp, u = r.eg, a = r.eu;
        return A2(Op, E([
            r.bQ
        ]), A2(gA, t, A3(n, a, e, u)));
    }), _I = F2(function(n, e) {
        return A3(zi, F3(function(e, r, t) {
            return A2(n, e, r) ? A3(ia, e, r, t) : t;
        }), Zu, e);
    }), RI = F2(function(n, e) {
        var r = e;
        return A2(_I, F2(function(e) {
            return n(e);
        }), r);
    }), HI = function(n) {
        return RT(n);
    }, UI = A2(Fu, IE(A2(Fu, function(n) {
        return n.gj;
    }, Yc)), xt), zI = function(n) {
        return gs(function(n) {
            var e = n.g1;
            switch(e.$){
                case 0:
                    return ds;
                case 1:
                    return bs(e.a);
                default:
                    return ms;
            }
        }(n)) + ":" + n.ei;
    }, DI = yT(function(n) {
        var e = n.ao, r = n.aX;
        return $(n, {
            aX: HI(r) ? iC(A2(ju, zI, UI(e))) : A2(RI, function(n) {
                return A2(tl, n, A2(ju, zI, e));
            }, r)
        });
    }), NI = function(n) {
        return n.h$;
    }, FI = function(n) {
        switch(n){
            case 0:
                return "Impacts";
            case 1:
                return "\xc9tapes";
            case 2:
                return "Sous-scores";
            default:
                return "Total";
        }
    }, KI = function(n) {
        return {
            j: 2 === n.aL ? .1 : 1,
            mf: n.mf
        };
    }, GI = function(n) {
        return yT(function(e) {
            return $(e, {
                ao: A2(ks, Sc(n), e.ao)
            });
        });
    }, WI = F2(function(n, e) {
        return II($(e, {
            mm: A2(ks, A2(Fu, function(n) {
                return n.mf;
            }, Sc(n)), e.mm)
        }));
    }), VI = F2(function(n, e) {
        return $(e, {
            cm: A2(ks, A2(Fu, function(n) {
                return n.mf;
            }, Sc(n)), e.cm)
        });
    }), JI = F2(function(n, e) {
        return $(e, {
            bj: A2(ks, Sc(n), e.bj)
        });
    }), BI = ee("exportBookmarks", function() {
        return Ru;
    }), XI = Sn, QI = F2(function(n, e) {
        return Iu(A2(XI, A2(cc, A2(cc, xu, n), Jr), A2(Eu, A2(cc, A2(cc, xu, n), Zr), e)));
    }), ZI = ir("focus"), YI = function(n) {
        return A2(QI, Bi(n), ZI("element-search"));
    }, nO = A2(Fu, function(n) {
        return n.W;
    }, A2(Fu, Fh(RP), A2(Fu, Nh(E([
        ds
    ])), IE(Wb)))), eO = ee("importBookmarks", function() {
        return Ru;
    }), rO = function(n) {
        return lE(Rt(n));
    }, tO = F3(function(n, e, r) {
        return Sd(E([
            A2(Kc, n, r),
            E([
                e
            ]),
            A2(jc, n, r)
        ]));
    }), uO = F2(function(n, e) {
        return A3(ot, Ur, e, n);
    }), aO = F4(function(n, e, r, t) {
        for(;;){
            if (!r.b) return n;
            var u = r.a, a = r.b;
            if (s(e, u)) return A2(uO, t, a);
            r = a, t = A2(Ur, u, t);
        }
    }), iO = F2(function(n, e) {
        return A4(aO, e, n, e, w);
    }), cO = F3(function(n, e, r) {
        var t = A2(rO, e, r);
        return t.$ ? r : A3(tO, t.a, n, A2(iO, n, r));
    }), oO = F2(function(n, e) {
        return yT(function(r) {
            return $(r, {
                ao: A3(cO, n, e, r.ao)
            });
        });
    }), fO = function(n) {
        return {
            mf: n.mf,
            P: xb(100)
        };
    }, sO = F3(function(n, e, r) {
        return A2(ju, function(r) {
            return n(r) ? e(r) : r;
        }, r);
    }), lO = function(n) {
        return A2(sO, A2(Fu, function(n) {
            return n.g1;
        }, Rt(n.g1)), Bi(n));
    }, dO = function(n) {
        return yT(function(e) {
            return $(e, {
                ao: A2(lO, n, e.ao)
            });
        });
    }, bO = function(n) {
        return yT(function(e) {
            return $(e, {
                ao: A2(Ur, n, e.ao)
            });
        });
    }, mO = yT(function(n) {
        return $(n, {
            aX: iC(A2(ju, zI, n.ao))
        });
    }), pO = yT(function(n) {
        return $(n, {
            aX: uC
        });
    }), vO = function(n) {
        var e = n;
        return A2(Qa, ys, A2(Lc, function(n) {
            return A2(jc, n, e.h$);
        }, e.ot));
    }, gO = F3(function(n, e, r) {
        return e ? A2(Nl, n, r) : Tc;
    }), hO = F2(function(n, e) {
        return $(e, {
            E: Rr(n)
        });
    }), $O = F2(function(n, e) {
        return $(e, {
            fT: Rr(n)
        });
    }), xO = function(n) {
        switch(n){
            case 0:
                return "Impacts";
            case 1:
                return "\xc9tapes";
            default:
                return "Sous-scores";
        }
    }, kO = F2(function(n, e) {
        return yT(function(r) {
            return $(r, {
                aX: A2(e ? aC : lI, zI(n), r.aX)
            });
        });
    }), wO = function(n) {
        return ks(function(e) {
            return !A2(tl, e.mf, n);
        });
    }, yO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, EO = {
        $: 3
    }, AO = {
        $: 1
    }, CO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, PO = F2(function(n, e) {
        return 0 > e ? n - 1 : m(e, n) > -1 ? 0 : e;
    }), TO = F3(function(n, e, r) {
        if (0 >= n) return Hr;
        var t = v(e, r);
        switch(t.b){
            case 0:
                return Rr(1 === t.a.$ ? n - 1 : A2(PO, n, t.a.a - 1));
            case 1:
                return Rr(1 === t.a.$ ? 0 : A2(PO, n, t.a.a + 1));
            default:
                return e;
        }
    }), SO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, IO = zn, OO = F2(function(n, e) {
        return A2(Ou, function() {
            return e;
        }, IO(n));
    }), qO = F3(function(n, e, r) {
        var t = r, u = $(t, {
            bd: A2(Ur, e, t.bd)
        }), a = function() {
            var e = n.oH;
            switch(e.$){
                case 0:
                    var r = e.a;
                    return t.ed ? Tc : A2(OO, r, SO(Hr));
                case 1:
                    r = e.a;
                    var a = e.b;
                    return t.ed ? Tc : A2(OO, r, SO(Rr(a)));
                default:
                    return A2(OO, a = e.a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(function(n) {
                        return ft(n.bd);
                    }(u)));
            }
        }();
        return v(u, A2(DA, n.fT, a));
    }), LO = F3(function(n, e) {
        return v(w, n(e));
    }), MO = F4(function(n, e, r, t) {
        var u = t;
        switch(r.$){
            case 0:
                return v(u, Tc);
            case 1:
                var a = r.a, i = u.bd;
                if (i.b) {
                    var c = i.a, o = i.b, f = function() {
                        if (a.$) return Tc;
                        var n = a.a;
                        return A2(OO, n, SO(Rr(n)));
                    }(), s = A2(e, c, o), l = s.b;
                    return v($(u, {
                        bd: s.a,
                        ed: !0
                    }), Uu(E([
                        l,
                        A2(DA, n.fT, f)
                    ])));
                }
                return v($(u, {
                    ed: !1
                }), Tc);
            default:
                var d = r.a, b = v(1 > m(ft(u.bd), d), u.bd);
                if (b.a && b.b.b) {
                    var p = b.b, g = A2(e, c = p.a, o = p.b), h = g.b;
                    return v($(u, {
                        bd: g.a
                    }), h);
                }
                return v(u, Tc);
        }
    }), _O = F2(function(n, e) {
        var r = e;
        switch(n.$){
            case 0:
                var t = n.a, u = A3(qO, r.e0, t, r.cU), a = u.b;
                return v($(r, {
                    cU: u.a,
                    g1: t,
                    ot: Hr,
                    dL: AO
                }), a);
            case 6:
                var i = n.a, c = A4(MO, r.e0, LO(function(n) {
                    return A2(Ou, yO, xu({
                        h$: r.h$,
                        mg: r.mg,
                        g1: n
                    }));
                }), i, r.cU);
                return a = c.b, v($(r, {
                    cU: c.a
                }), a);
            case 1:
                return v(r, A2(QI, CO, r.e9(o = n.a)));
            case 2:
                var o, f = n.a;
                return 1 === f.$ ? v($(r, {
                    dL: jO(f.a)
                }), Tc) : s((o = f.a).g1, r.g1) ? v($(r, {
                    h$: A2(ks, function(n) {
                        return !A2(tl, n, o.mg);
                    }, o.h$),
                    mg: o.mg,
                    dL: EO
                }), Tc) : v(r, Tc);
            case 3:
                var l = n.a;
                return v($(r, {
                    ot: A3(TO, ft(r.h$), r.ot, l)
                }), Tc);
            case 4:
                return v($(r, {
                    eh: Rr(n.a)
                }), Tc);
            default:
                var d = n.a;
                return s(r.eh, Rr(d)) ? v($(r, {
                    eh: Hr,
                    ot: Rr(d)
                }), Tc) : v(r, Tc);
        }
    }), RO = F2(function(n, e) {
        return $(e, {
            E: Rr(A2(eh, ab, ob(n)))
        });
    }), HO = F3(function(n, e, r) {
        return II($(r, {
            mm: A2(ju, function(r) {
                return s(r.mf, n) ? e : r;
            }, r.mm)
        }));
    }), UO = F3(function(n, e, r) {
        return $(r, {
            cm: A2(ju, function(r) {
                return s(r.mf, n) ? e : r;
            }, r.cm)
        });
    }), zO = F3(function(n, e, r) {
        return $(r, {
            bj: A2(ju, function(r) {
                return s(r, n) ? e : r;
            }, r.bj)
        });
    }), DO = F2(function(n, e) {
        var r = e.eu, t = $(e.eg, {
            bw: A2(rh, r, n)
        });
        return $(e, {
            eg: t,
            eu: A2(uh, n, r)
        });
    }), NO = F2(function(n, e) {
        return $(e, {
            fT: Rr(n)
        });
    }), FO = F2(function(n, e) {
        return n ? Op(E([
            e
        ])) : ru;
    }), KO = F3(function(n, e, r) {
        var t = r.ad;
        switch(t.$){
            case 0:
                return A5(QO, n, r, e, t.a, t.b);
            case 1:
                return A5(ZO, n, r, e, t.a, t.b);
            case 6:
                return A2(GO, t.a, A2(Tg, e, r));
            default:
                return A2(Tg, e, r);
        }
    }), GO = F2(function(n, e) {
        var r = function(n) {
            return {
                $: 12,
                a: n
            };
        }(A2(_c, bA, vO(n)));
        return A2(Op, E([
            A2(Nl, e.eu, wI(ds))
        ]), A3(JO, e.eu, r, e.eg));
    }), WO = F2(function(n, e) {
        var r = A2(_c, ys(NI(n)), A2(Lc, Rr, vO(n)));
        return A3(JO, e.eu, A2(_c, jI, A2(Lc, mI, r)), e.eg);
    }), VO = F2(function(n, e) {
        var r = A2(_c, ys(NI(n)), A2(Lc, Rr, vO(n)));
        return A3(JO, e.eu, A2(_c, jI, A2(Lc, vI, r)), e.eg);
    }), JO = F3(function(n, e, r) {
        var t, u = n.C, a = n.aG.l1, i = F2(function(e, t) {
            return A2(_c, A2(Tg, n, r), A2(Lc, function(t) {
                return A2(DO, e(t), A2(Tg, n, r));
            }, t));
        });
        switch(e.$){
            case 0:
                return A2(DO, A2(hO, ab, a), A2(Tg, n, r));
            case 1:
                return A2(DO, A2(OI, {
                    i: Hr,
                    mf: (t = e.a).mf,
                    P: xb(100),
                    jk: Hg(t)
                }, a), A3(MI, JO, kc(xc), A2(Tg, n, r)));
            case 2:
                return A2(DO, A2(qI, KI(e.a), a), A3(MI, JO, kc(xc), A2(Tg, n, r)));
            case 3:
                return A2(i, function(n) {
                    return A2(LI, n.mf, a);
                }, ys(A2(wO, a.bj, bb)));
            case 4:
                var c = ch(A2(ju, function(n) {
                    return n.P;
                }, a.mm));
                return A2(i, function(n) {
                    return A2($O, n, a);
                }, A2(Lc, A2(Fu, fO, function(n) {
                    return $(n, {
                        P: c
                    });
                }), ys(nO(u))));
            case 5:
                return A2(Op, E([
                    TT(e.a)
                ]), A2(Tg, n, r));
            case 6:
                return A2(DT, GI(e.a), A2(DO, a, A2(Tg, n, r)));
            case 7:
                return A2(DO, A2(WI, e.a, a), A2(Tg, n, r));
            case 8:
                return A2(DO, A2(VI, e.a, a), A2(Tg, n, r));
            case 9:
                return A2(DO, A2(JI, e.a, a), A2(Tg, n, r));
            case 10:
                return A2(Op, E([
                    BI(0)
                ]), A2(Tg, n, r));
            case 11:
                return A2(Op, E([
                    eO(0)
                ]), A2(Tg, n, r));
            case 12:
                var o = e.a, f = $(r, {
                    db: o
                });
                return A2(DO, o, A3(MI, JO, kc(xc), A2(Tg, n, f)));
            case 13:
                return A2(Tg, n, r);
            case 14:
                var s = e.a, l = r.ad;
                if (6 === l.$) {
                    var d = A2(_O, s, l.a), b = d.a;
                    return A2(Op, E([
                        A2(DA, EI, d.b)
                    ]), A2(Tg, n, $(r, {
                        ad: TI(b)
                    })));
                }
                return A2(Tg, n, r);
            case 15:
                s = e.a;
                var m = r.ad;
                if (m.$) return A2(Tg, n, r);
                var p = m.a, v = A2(_O, s, m.b);
                return b = v.a, A2(Op, E([
                    A2(DA, AI, v.b)
                ]), A2(Tg, n, $(r, {
                    ad: A2(pI, p, b)
                })));
            case 16:
                s = e.a;
                var g = r.ad;
                if (1 === g.$) {
                    var h = g.a, x = A2(_O, s, g.b);
                    return b = x.a, A2(Op, E([
                        A2(DA, CI, x.b)
                    ]), A2(Tg, n, $(r, {
                        ad: A2(gI, h, b)
                    })));
                }
                return A2(Tg, n, r);
            case 17:
                return A3(KO, a, n, r);
            case 18:
                return A2(Tg, n, $(r, {
                    bu: Hr
                }));
            case 19:
                return A2(Tg, n, $(r, {
                    bu: Rr(e.a)
                }));
            case 20:
                return A2(Tg, n, $(r, {
                    cI: Rr(e.a)
                }));
            case 21:
                var k = e.a, w = r.cI;
                return w.$ ? A2(Tg, n, r) : A2(Tg, A3(oO, w.a, k, n), $(r, {
                    cI: Hr,
                    bu: Hr
                }));
            case 22:
                return A2(Op, E([
                    OS("#" + e.a)
                ]), A2(Tg, n, r));
            case 23:
                return A2(Op, E([
                    A2(Nl, n, xI(ds))
                ]), A2(Tg, DI(n), $(r, {
                    ad: $I
                })));
            case 24:
                var y = r.bv;
                return y.$ ? A2(Tg, n, r) : A2(Tg, A2(dO, y.a, n), $(r, {
                    bv: Hr
                }));
            case 25:
                return A2(DO, r.db, A2(Tg, n, r));
            case 26:
                return A2(DO, function(n) {
                    return $(n, {
                        E: Hr
                    });
                }(a), A2(Tg, n, r));
            case 27:
                return A2(DO, function(n) {
                    return $(n, {
                        fT: Hr
                    });
                }(a), A2(Tg, n, r));
            case 28:
                return A2(Op, E([
                    A2(Ou, A2(PI, r.bw, Sg(a)), ac),
                    A2(Nl, n, hI(ds))
                ]), A2(Tg, n, r));
            case 29:
                var j = e.b;
                return A2(Tg, A2(bO, {
                    gj: e.c,
                    iA: Hr,
                    ei: pf(e.a),
                    g1: j
                }, n), r);
            case 30:
                return A2(Tg, mO(n), r);
            case 31:
                return A2(Tg, pO(n), r);
            case 32:
                var A = e.a;
                return A3(FO, function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                        case 6:
                            return !0;
                        default:
                            return !1;
                    }
                }(A), YI(jI), A2(Tg, n, $(r, {
                    ad: A
                })));
            case 33:
                var C = e.a;
                return A2(Op, E([
                    A3(gO, n, 2 === C, A2(SI, ds, "Partager"))
                ]), A2(Tg, n, $(r, {
                    dU: C
                })));
            case 34:
                var P = e.a;
                return A2(Op, E([
                    A2(Nl, n, A2(kI, ds, FI(P)))
                ]), A2(Tg, n, $(r, {
                    cO: P
                })));
            case 35:
                if (e.a.$) return A3($A, "Erreur de s\xe9lection d'impact", e.a.a, A2(Tg, n, r));
                var T = e.a.a;
                return A2(Op, E([
                    A2(jA, n.m6, MA(A2(vd, T, Rr(a)))),
                    A2(Nl, n, A2(yI, ds, T))
                ]), A2(Tg, n, r));
            case 36:
                var S = e.a;
                return A2(Op, E([
                    A2(Nl, n, A2(SI, ds, xO(S)))
                ]), A2(Tg, n, $(r, {
                    dN: S
                })));
            case 37:
                return A2(Tg, A3(kO, e.a, e.b, n), r);
            case 38:
                return A2(Tg, n, $(r, {
                    bw: e.a
                }));
            case 39:
                return A2(DO, A2(RO, e.a, a), A2(Tg, n, r));
            case 40:
                return A2(DO, A3(HO, e.a.mf, e.b, a), A2(Tg, n, r));
            case 41:
                return A2(DO, A3(UO, e.a, e.b, a), A2(Tg, n, r));
            case 42:
                return A2(DO, A3(zO, e.a, e.b, a), A2(Tg, n, r));
            case 43:
                return A2(Tg, n, $(r, {
                    bv: Rr($(e.a, {
                        ei: e.b
                    }))
                }));
            default:
                return A2(DO, A2(NO, e.a, a), A2(Tg, n, r));
        }
    }), BO = F5(function(n, e, r, t, u) {
        var a = {
            i: Hr,
            mf: u.mf,
            P: t.P,
            jk: Hg(u)
        };
        return A2(DO, A3(HO, t.a_.mf, a, n), A3(MI, JO, kc(xc), A2(Tg, r, e)));
    }), XO = F5(function(n, e, r, t, u) {
        return A2(DO, A3(UO, t.mf, KI(u), n), A3(MI, JO, kc(xc), A2(Tg, r, e)));
    }), QO = F5(function(n, e, r, t, u) {
        var a = vO(u);
        return A2(_c, A2(WO, u, A3(MI, JO, kc(xc), A2(Tg, r, e))), A3(Uk, A3(BO, n, e, r), t, a));
    }), ZO = F5(function(n, e, r, t, u) {
        var a = vO(u);
        return A2(_c, A2(VO, u, A3(MI, JO, kc(xc), A2(Tg, r, e))), A3(Uk, A3(XO, n, e, r), t, a));
    }), YO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nq = {
        $: 1
    }, eq = function(n) {
        return {
            $: 9,
            a: n
        };
    }, rq = function(n) {
        return {
            $: 10,
            a: n
        };
    }, tq = function(n) {
        return {
            $: 4,
            a: n
        };
    }, uq = {
        $: 7
    }, aq = function(n) {
        return {
            $: 8,
            a: n
        };
    }, iq = function(n) {
        return {
            $: 9,
            a: n
        };
    }, cq = F4(function(n, e, r, t) {
        return {
            $: 10,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), oq = function(n) {
        return {
            $: 11,
            a: n
        };
    }, fq = function(n) {
        return {
            $: 12,
            a: n
        };
    }, sq = function(n) {
        return {
            $: 13,
            a: n
        };
    }, lq = F3(function(n, e, r) {
        return {
            $: 33,
            a: n,
            b: e,
            c: r
        };
    }), dq = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bq = function(n) {
        return {
            $: 4,
            a: n
        };
    }, mq = function(n) {
        return {
            $: 5,
            a: n
        };
    }, pq = function(n) {
        return {
            $: 6,
            a: n
        };
    }, vq = F4(function(n, e, r, t) {
        return {
            $: 7,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), gq = F3(function(n, e, r) {
        return $(r, {
            q: $(r.q, {
                bg: Rr(k(A2(Mh, n, r), E([
                    e.mf
                ])))
            })
        });
    }), hq = function(n) {
        return {
            j: A2(Jb, Vb, n) ? Hr : Rr(Th(1)),
            bk: n.mf
        };
    }, $q = F3(function(n, e, r) {
        return $(r, {
            aM: Rr(k(A2(Cx, n, r), E([
                hq(e)
            ])))
        });
    }), xq = function(n) {
        return n;
    }, kq = function(n) {
        return {
            Y: Hr,
            mf: n,
            D: 1,
            dH: Hr
        };
    }, wq = F2(function(n, e) {
        return k(e, E([
            kq(n)
        ]));
    }), yq = F2(function(n, e) {
        return !!n.mf.$ || A2(rl, ru, E([
            !s(e.r, n.r),
            !s(e.ei, Hr) && !s(e.ei, Rr(n.ei))
        ]));
    }), jq = F3(function(n, e, r) {
        if (r.$) return Rr(e({
            r: n.r,
            ei: Hr
        }));
        var t = e(r.a);
        return A2(yq, n, t) ? Rr(t) : Hr;
    }), Eq = F3(function(n, e, r) {
        if (0 > n) return r;
        var t = A2(jc, n, r);
        if (t.b) {
            var u = t.a, a = t.b;
            return k(A2(Kc, n, r), A2(Ur, e(u), a));
        }
        return r;
    }), Aq = function(n) {
        return Eq(n);
    }, Cq = F2(function(n, e) {
        var r = n.a;
        return A2(Aq, n.b, function(n) {
            return $(n, {
                Y: A3(jq, r, e, n.Y)
            });
        });
    }), Pq = F3(function(n, e, r) {
        return A2(tl, OP, e.cK) ? Zr(A3(Cq, n, function(n) {
            var r;
            return $(n, {
                r: k(n.r, E([
                    {
                        j: Th(1),
                        U: {
                            i: bC(e),
                            mf: e.mf
                        },
                        J: w
                    }
                ])),
                ei: (r = v(n.ei, n.r), 1 !== r.a.$ || r.b.b ? n.ei : e.lr)
            });
        }, r)) : Jr("L'ajout d'un \xe9l\xe9ment ne peut se faire qu'\xe0 partir d'un proc\xe9d\xe9 mati\xe8re");
    }), Tq = F2(function(n, e) {
        var r = n.a, t = r.a, u = n.b;
        return A2(Aq, r.b, function(n) {
            return $(n, {
                Y: A3(jq, t, function(n) {
                    return $(n, {
                        r: A3(Eq, u, e, n.r)
                    });
                }, n.Y)
            });
        });
    }), Sq = F4(function(n, e, r, t) {
        return A2(tl, RP, r.cK) ? Zr(A3(Tq, n, function(n) {
            return $(n, {
                J: k(n.J, E([
                    {
                        i: e,
                        mf: r.mf
                    }
                ]))
            });
        }, t)) : Jr("Seuls les proc\xe9d\xe9s de cat\xe9gorie `transformation` sont mobilisables comme proc\xe9d\xe9s de transformation");
    }), Iq = function(n) {
        var e = n.a;
        return A2(Fu, $x(n.b), A2(Fu, Qa(function(n) {
            return n.Y;
        }), K$(e)));
    }, Oq = F3(function(n, e, r) {
        return A2(Qa, function(n) {
            var e = n.U, r = vx(n.J);
            return r.$ ? e.i : r.a.i;
        }, A2(Qa, function(e) {
            return A2($x, e, A2(Iq, n, r));
        }, e));
    }), qq = F4(function(n, e, r, t) {
        return A2(tl, OP, r.cK) ? Zr(A3(Tq, e, function(e) {
            var t = ys(L$(r));
            return $(e, {
                U: {
                    i: e.U.i,
                    mf: r.mf
                },
                J: A2(eh, w, A2(ss, ju(Gt), A2(ss, ks(function(n) {
                    var e = n.b;
                    return !s(t, Hr) && s(ys(L$(e)), t);
                }), Jg(A2(ju, function(e) {
                    return A2(ss, function(n) {
                        return v(e, n);
                    }, A2(Rs, e.mf, n.W));
                }, e.J)))))
            });
        }, t)) : Jr("Seuls les proc\xe9d\xe9s de cat\xe9gorie `material` sont mobilisables comme mati\xe8re");
    }), Lq = F6(function(n, e, r, t, u, a) {
        var i = v(e, t);
        n: for(;;)if (i.b.$) switch(i.a.$){
            case 5:
                return A3(Pq, r, u, a);
            case 11:
                return Jr("Un proc\xe9d\xe9 de transformation ne peut \xeatre ajout\xe9 qu'\xe0 un \xe9l\xe9ment existant");
            default:
                break n;
        }
        else switch(i.a.$){
            case 5:
                return A4(qq, n, v(r, c = i.b.a), u, a);
            case 11:
                var c = i.b.a, o = A3(Oq, r, t, a);
                return A4(Sq, v(r, c), o, u, a);
            default:
                break n;
        }
        return Jr("Cat\xe9gorie de proc\xe9d\xe9 non support\xe9e\xa0: " + yP(e));
    }), Mq = F2(function(n, e) {
        var r = n.mf;
        return n.cY.$ ? A2(Qa, function(n) {
            return s(n.mf, r) ? Hr : Rr(n);
        }, e) : Rr(n);
    }), _q = F2(function(n, e) {
        return $(e, {
            b2: A2(Mq, n, e.b2)
        });
    }), Rq = F3(function(n, e, r) {
        var t = r.a, u = A2(_q, n, r.b), a = n.eP;
        return a.$ ? A2(Jx, t, u) : A2(e, u, Th(a.a));
    }), Hq = F4(function(n, e, r, t) {
        var u = e.a, a = u.a, i = u.b, c = e.b, o = A2($x, i, t);
        if (o.$) return Zr(t);
        var f = o.a, l = A2(K$, a, f.Y);
        return 0 > c || m(c, ft(l)) > -1 ? Zr(t) : A2(ss, function(n) {
            var e = A2(bt, F2(function(e, t) {
                return s(e, c) ? $(t, {
                    j: r
                }) : $(t, {
                    j: A2(X$, n, t.j)
                });
            }), l);
            return A3(Aq, i, function(n) {
                return $(n, {
                    Y: A3(jq, a, function(n) {
                        return $(n, {
                            r: e
                        });
                    }, n.Y),
                    dH: Hr
                });
            }, t);
        }, A3(Y$, n, l, f.dH));
    }), Uq = F2(function(n, e) {
        var r = e.eg, t = e.eu, u = bs(r.iA);
        return $(e, {
            eg: $(r, {
                bw: A4(Gw, t, r.iA, r.lP, n),
                db: n,
                ac: A2(Vx, {
                    ay: t.h4,
                    C: t.C,
                    as: u
                }, n)
            }),
            eu: A3(Ww, r.iA, n, t)
        });
    }), zq = F5(function(n, e, r, t, u) {
        var a = A4(Hq, n.C, t, u, r.mu);
        return 1 === a.$ ? A3($A, "Erreur de mise \xe0 jour de la quantit\xe9", a.a, A2(Jx, n, e)) : A2(Uq, A2(xE, a.a, r), A2(Jx, n, e));
    }), Dq = function(n) {
        var e = n.P, r = n.D;
        return r ? A2(Rh, r, e) : e;
    }, Nq = F2(function(n, e) {
        return m(e, n) > 0;
    }), Fq = F2(function(n, e) {
        return A2(xE, n(e.mu), e);
    }), Kq = F5(function(n, e, r, t, u) {
        var a = A2(Nq, 0, u), i = A2(_c, !0, A2(Lc, function(n) {
            return Dq(n) > 0;
        }, A2(Qa, A2(Fu, function(n) {
            return n.Q;
        }, A2(Fu, hx, $x(t))), Ld(e.ac))));
        return a && i ? A2(Uq, A2(Fq, A2(Aq, t, function(n) {
            return $(n, {
                dH: Rr(u)
            });
        }), r), A2(Jx, n, e)) : A2(Jx, n, e);
    }), Gq = F5(function(n, e, r, t, u) {
        var a = A2(_q, u, e), i = u.eP;
        return i.$ ? A2(Jx, n, a) : A5(Kq, n, a, r, t, i.a);
    }), Wq = F2(function(n, e) {
        return {
            kL: n,
            nR: e
        };
    }), Vq = A3(Ba, "pullRequestUrl", ai, A3(Ba, "branchName", ai, nu(Wq))), Jq = F3(function(n, e, r) {
        return A5(cS, n, "contrib/examples", r, Vq, function(n) {
            return Mc(E([
                v("description", Ic(n.ik)),
                v("name", Ic(n.ei)),
                v("query", Nf(n.g1)),
                v("scope", Ic(gs(n.as)))
            ]));
        }(e));
    }), Bq = function(n) {
        switch(n.$){
            case 0:
                return "\xc9chec de l'interpr\xe9tation de la r\xe9ponse HTTP: " + n.a.il;
            case 1:
                var e = n.a.il, r = n.a.eC;
                return pf("Erreur HTTP " + ut(n.a.j0) + ": " + e + ". " + A2(_c, "", r));
            case 2:
                return "URL invalide: " + n.a;
            case 3:
                return "Erreur de communication r\xe9seau. \xcates-vous connect\xe9 ?";
            default:
                return "D\xe9lai d\xe9pass\xe9.";
        }
    }, Xq = function(n) {
        switch(n.$){
            case 0:
            case 3:
            case 4:
            case 5:
            case 7:
                return !0;
            default:
                return !1;
        }
    }, Qq = function(n) {
        return hA(function(n) {
            return {
                eb: 3,
                ef: n,
                er: !1,
                eC: Hr
            };
        }(n));
    }, Zq = function(n) {
        return A2(Fu, bm(n), ru);
    }, Yq = F2(function(n, e) {
        if (0 > n) return e;
        var r = A2(jc, n, e);
        if (r.b) {
            var t = r.b;
            return k(A2(Kc, n, e), t);
        }
        return e;
    }), nL = F3(function(n, e, r) {
        return $(r, {
            q: $(r.q, {
                bg: Rr(A2(Yq, e, A2(Mh, n, r)))
            })
        });
    }), eL = F3(function(n, e, r) {
        return $(r, {
            aM: Rr(A2(Yq, e, A2(Cx, n, r)))
        });
    }), rL = F2(function(n, e) {
        return A2(Tq, n, function(n) {
            return $(n, {
                J: A2(Yq, e, n.J)
            });
        });
    }), tL = F2(function(n, e) {
        return $(e, {
            aR: A2(Yq, n, e.aR)
        });
    }), uL = F2(function(n, e) {
        var r = e.q, t = e.aw, u = function(n) {
            return $(e, {
                q: $(r, {
                    bg: Hr
                }),
                aM: Hr,
                E: Hr,
                aS: n,
                aw: $(t, {
                    aN: Hr
                })
            });
        };
        if (n.$) return u(Hr);
        var a = n.a;
        return s(e.aS, Rr(a.mf)) ? e : u(Rr(a.mf));
    }), aL = F3(function(n, e, r) {
        if (r.$) return Uq(A2(uL, Hr, e));
        var t = A2(Lh, r.a, n.C.dp);
        return 1 === t.$ ? A2($A, "Cat\xe9gorie de produit introuvable", t.a) : Uq(A2(uL, Rr(t.a), e));
    }), iL = F2(function(n, e) {
        return $(e, {
            aw: $(e.aw, {
                a8: n
            })
        });
    }), cL = F2(function(n, e) {
        return $(e, {
            aw: $(e.aw, {
                aN: Rr(n)
            })
        });
    }), oL = F2(function(n, e) {
        return A2(ss, function(n) {
            return A2(xE, n, e);
        }, n(e.mu));
    }), fL = F2(function(n, e) {
        return $(e, {
            q: $(e.q, {
                i: n
            })
        });
    }), sL = F4(function(n, e, r, t) {
        return $(t, {
            aM: Rr(A3(Eq, e, function(n) {
                return n.j.$ ? n : $(n, {
                    j: Rr(r)
                });
            }, A2(Cx, n, t)))
        });
    }), lL = F2(function(n, e) {
        return $(e, {
            E: n
        });
    }), dL = F2(function(n, e) {
        return $(e, {
            aO: s(n, 1) ? Hr : Rr(n)
        });
    }), bL = F2(function(n, e) {
        return A2(Tq, n, function(n) {
            return $(n, {
                U: $(n.U, {
                    i: e
                })
            });
        });
    }), mL = F3(function(n, e, r) {
        return A2(Tq, n, function(n) {
            return $(n, {
                J: A3(Eq, e, function(n) {
                    return $(n, {
                        i: r
                    });
                }, n.J)
            });
        });
    }), pL = F2(function(n, e) {
        return A2(Cq, n, function(n) {
            return $(n, {
                ei: Rr(e)
            });
        });
    }), vL = F3(function(n, e, r) {
        return $(r, {
            aR: A3(Eq, n, function(n) {
                return $(n, {
                    j: e
                });
            }, r.aR)
        });
    }), gL = F2(function(n, e) {
        return $(e, {
            dq: n
        });
    }), hL = F3(function(n, e, r) {
        var t = vO(e);
        if (t.$) return A2(Qq, "Aucun composant s\xe9lectionn\xe9", r);
        var u = t.a;
        return A3(MI, jL, yc(w), A2(Uq, $(n, {
            aR: k(n.aR, E([
                A2(Zq, Th(1), u.mf)
            ]))
        }), r));
    }), $L = F4(function(n, e, r, t) {
        var u = vO(r);
        if (u.$) return A2(Qq, "Aucun proc\xe9d\xe9 d\u2019assemblage s\xe9lectionn\xe9", t);
        var a = u.a;
        return A3(MI, jL, yc(w), A2(Uq, A3(gq, n, a, e), t));
    }), xL = F4(function(n, e, r, t) {
        var u = t.eg, a = vO(r);
        if (a.$) return A2(Qq, "Aucun composant s\xe9lectionn\xe9", t);
        var i = a.a;
        return A2(Op, E([
            A2(Nl, t.eu, rq(bs(u.iA)))
        ]), A3(MI, jL, yc(w), A2(Uq, A3($q, n, i, e), t)));
    }), kL = F2(function(n, e) {
        var r = e.eg, t = A2(_c, Xx, vO(n));
        return A2(Op, E([
            A2(Nl, e.eu, wI(bs(r.iA)))
        ]), A3(MI, jL, yc(w), A2(Uq, t, e)));
    }), wL = F6(function(n, e, r, t, u, a) {
        var i = a.eg, c = a.eu, o = vO(t);
        if (o.$) return A2(Qq, "Aucun composant s\xe9lectionn\xe9", a);
        var f = A2(oL, A5(Lq, c.C, n, e, r, o.a), u);
        if (1 === f.$) return A3($A, "Erreur", f.a, a);
        var s = f.a;
        return A2(Op, E([
            A2(Nl, a.eu, eq(bs(i.iA)))
        ]), A3(MI, jL, yc(A2(jc, 1, i.M)), A2(Uq, s, a)));
    }), yL = F3(function(n, e, r) {
        var t = r.eu, u = A2(Nl, r.eu, function(n) {
            return {
                $: 8,
                a: n
            };
        }(bs(r.eg.iA))), a = vO(e);
        if (a.$) return A2(Qq, "Aucun composant s\xe9lectionn\xe9", r);
        if (a.a.$) {
            var i = a.a.a, c = ft(n.mu), o = v(G$, c), f = {
                Y: Hr,
                mf: Hr,
                D: 1,
                dH: Hr
            }, s = A2(oL, A5(Lq, t.C, OP, o, Hr, i), $(n, {
                mu: k(n.mu, E([
                    f
                ]))
            }));
            if (1 === s.$) return A3($A, "Erreur", s.a, r);
            var l = s.a;
            return A2(Op, E([
                u
            ]), A3(MI, jL, yc(w), A2(Uq, l, r)));
        }
        var d = a.a.a;
        return A2(Op, E([
            u
        ]), A3(MI, jL, yc(w), A2(Uq, A2(Fq, wq(d.mf), n), r)));
    }), jL = F3(function(n, e, r) {
        var t = n.m6, u = A2(Zx, r.iA, n), a = bs(r.iA), i = {
            ay: n.h4,
            C: n.C,
            as: a
        }, c = v(e, r.M);
        switch(c.a.$){
            case 0:
                return A2(Jx, n, $(r, {
                    M: A2(Ur, c.a.a, N = c.b)
                }));
            case 1:
                return A2(Op, E([
                    TT(c.a.a)
                ]), A2(Jx, n, r));
            case 2:
                var o = v(Rl(n), function(n) {
                    var e = v(pf(n.cQ), pf(n.cR)), r = e.a, t = e.b;
                    return su(t) ? Jr(E([
                        "Le nom de la contribution est requis"
                    ])) : su(r) ? Jr(E([
                        "La description de la contribution est requise"
                    ])) : Zr({
                        ik: r,
                        ei: t,
                        g1: n.db,
                        as: bs(n.iA)
                    });
                }(r));
                return o.a ? o.b.$ ? A3($A, "Erreur lors de la cr\xe9ation de votre contribution", A2(at, ", ", o.b.a), A2(Jx, n, $(r, {
                    a9: !1
                }))) : A2(Op, E([
                    A3(Jq, n, o.b.a, tq)
                ]), A2(Jx, n, $(r, {
                    a9: !0
                }))) : A2(Qq, "Vous devez \xeatre authentifi\xe9 pour soumettre une contribution", A2(Jx, n, $(r, {
                    a9: !1
                })));
            case 3:
                return A2(Jx, A2(GI, c.a.a, n), r);
            case 4:
                switch(c.a.a.$){
                    case 2:
                        return A3($A, "Erreur de contribution", Bq(c.a.a.a), A2(Jx, n, $(r, {
                            a9: !1
                        })));
                    case 3:
                        return A2(eS, A3(Xb, "pr_url", c.a.a.a.nR, "La contribution est soumise \xe0 validation par l\u2019\xe9quipe m\xe9thode d\u2019Ecobalyse.\n                        Vous pouvez suivre [sur ce lien](pr_url) l\u2019\xe9tat d\u2019avancement de l\u2019int\xe9gration de votre exemple de produit.\n                        "), A2(Jx, n, $(r, {
                            a9: !1
                        })));
                    default:
                        return A2(Jx, n, r);
                }
            case 5:
                return A2(Op, E([
                    BI(0)
                ]), A2(Jx, n, r));
            case 6:
                return A2(Op, E([
                    eO(0)
                ]), A2(Jx, n, r));
            case 7:
                return A2(Jx, n, r);
            case 11:
                if (c.b.b && !c.b.a.$) {
                    var f = c.b, s = f.b, l = A2(_O, c.a.a, f.a.a), d = l.a;
                    return A2(Op, E([
                        A2(DA, oq, C = l.b)
                    ]), A2(Jx, n, $(r, {
                        M: A2(Ur, YO(d), s)
                    })));
                }
                return A2(Jx, n, r);
            case 8:
                if (c.b.b && 3 === c.b.a.$) {
                    var b = c.b, p = (s = b.b, A2(_O, c.a.a, b.a.a));
                    return d = p.a, A2(Op, E([
                        A2(DA, aq, C = p.b)
                    ]), A2(Jx, n, $(r, {
                        M: A2(Ur, dq(d), s)
                    })));
                }
                return A2(Jx, n, r);
            case 9:
                if (c.b.b && 4 === c.b.a.$) {
                    var g = c.b, h = (s = g.b, A2(_O, c.a.a, g.a.a));
                    return d = h.a, A2(Op, E([
                        A2(DA, iq, C = h.b)
                    ]), A2(Jx, n, $(r, {
                        M: A2(Ur, bq(d), s)
                    })));
                }
                return A2(Jx, n, r);
            case 10:
                if (c.b.b && 7 === c.b.a.$) {
                    var x = c.a, k = x.a, w = x.b, y = x.c, j = c.b, A = (s = j.b, A2(_O, x.d, j.a.d)), C = (d = A.a, A.b);
                    return A2(Op, E([
                        A2(DA, A3(cq, k, w, y), C)
                    ]), A2(Jx, n, $(r, {
                        M: A2(Ur, A4(vq, k, w, y, d), s)
                    })));
                }
                return A2(Jx, n, r);
            case 12:
                if (c.b.b && 5 === c.b.a.$) {
                    var P = c.b, T = (s = P.b, A2(_O, c.a.a, P.a.a));
                    return d = T.a, A2(Op, E([
                        A2(DA, fq, C = T.b)
                    ]), A2(Jx, n, $(r, {
                        M: A2(Ur, mq(d), s)
                    })));
                }
                return A2(Jx, n, r);
            case 13:
                if (c.b.b && 6 === c.b.a.$) {
                    var S = c.b, I = (s = S.b, A2(_O, c.a.a, S.a.a));
                    return d = I.a, A2(Op, E([
                        A2(DA, sq, C = I.b)
                    ]), A2(Jx, n, $(r, {
                        M: A2(Ur, pq(d), s)
                    })));
                }
                return A2(Jx, n, r);
            case 19:
                return c.b.b && !c.b.a.$ ? A3(yL, u, c.b.a.a, A2(Jx, n, r)) : A2(Jx, n, r);
            case 14:
                return c.b.b && 3 === c.b.a.$ ? A4($L, i, u, c.b.a.a, A2(Jx, n, r)) : A2(Jx, n, r);
            case 15:
                return c.b.b && 4 === c.b.a.$ ? A4(xL, i, u, c.b.a.a, A2(Jx, n, r)) : A2(Jx, n, r);
            case 16:
                return c.b.b && 5 === c.b.a.$ ? A2(kL, c.b.a.a, A2(Jx, n, r)) : A2(Jx, n, r);
            case 17:
                return c.b.b && 6 === c.b.a.$ ? A3(hL, u, c.b.a.a, A2(Jx, n, r)) : A2(Jx, n, r);
            case 18:
                if (c.b.b && 7 === c.b.a.$) {
                    var O = c.a;
                    return A6(wL, k = O.a, w = O.b, O.c, c.b.a.d, u, A2(Jx, n, r));
                }
                return A2(Jx, n, r);
            case 20:
                return A2(Jx, n, $(r, {
                    bu: Hr
                }));
            case 21:
                return A2(Jx, n, $(r, {
                    bu: Rr(c.a.a)
                }));
            case 22:
                return A2(Jx, n, $(r, {
                    cI: Rr(c.a.a)
                }));
            case 23:
                var q = c.a.a, L = r.cI;
                return L.$ ? A2(Jx, n, r) : A2(Jx, A3(oO, L.a, q, n), $(r, {
                    cI: Hr,
                    bu: Hr
                }));
            case 24:
                return A2(Op, E([
                    A2(Nl, n, xI(a))
                ]), A2(Jx, DI(n), $(r, {
                    M: E([
                        nq
                    ])
                })));
            case 26:
                var M = c.a.a;
                return A2(Op, E([
                    A2(Nl, n, eq(a))
                ]), A2(Uq, A2(Fq, Yq(M), u), A2(Jx, n, $(r, {
                    bV: A3(sO, function(n) {
                        return m(n, M) > 0;
                    }, function(n) {
                        return n - 1;
                    }, A2(iO, M, r.bV))
                }))));
            case 25:
                return A2(Uq, A3(nL, i, Z = c.a.a, u), A2(Jx, n, r));
            case 27:
                return A2(Uq, A3(eL, i, Z = c.a.a, u), A2(Jx, n, r));
            case 28:
                var _ = c.a.a;
                return A2(Op, E([
                    A2(Nl, n, eq(a))
                ]), A2(Uq, A2(Fq, function(n) {
                    var e = n.b;
                    return A2(Cq, n.a, function(n) {
                        return $(n, {
                            r: A2(Yq, e, n.r)
                        });
                    });
                }(_), u), A2(Jx, n, r)));
            case 29:
                var R = c.a, H = (_ = R.a, R.b);
                return A2(Op, E([
                    A2(Nl, n, eq(a))
                ]), A2(Uq, A2(Fq, A2(rL, _, H), u), A2(Jx, n, r)));
            case 30:
                return A2(Uq, A2(tL, Z = c.a.a, u), A2(Jx, n, r));
            case 31:
                var U = r.bv;
                return U.$ ? A2(Jx, n, r) : A2(Jx, A2(dO, U.a, n), $(r, {
                    bv: Hr
                }));
            case 32:
                return A2(Op, E([
                    A2(Ou, A2(lq, r.bw, A2(nk, r.iA, u)), ac),
                    A2(Nl, n, hI(a))
                ]), A2(Jx, n, r));
            case 33:
                var z = c.a, D = z.b;
                return A2(Jx, A2(bO, {
                    gj: z.c,
                    iA: Hr,
                    ei: pf(z.a),
                    g1: D
                }, n), r);
            case 34:
                return A2(Jx, mO(n), r);
            case 35:
                return A2(Jx, pO(n), r);
            case 36:
                return A2(Jx, n, $(r, {
                    bV: c.a.a
                }));
            case 37:
                var N;
                return A3(FO, A2(rl, Xq, N = c.a.a), YI(uq), A2(Jx, n, $(r, {
                    M: N
                })));
            case 38:
                var F = c.a.a;
                return A2(Op, E([
                    A3(gO, n, 2 === F, A2(SI, bs(r.iA), "Partager"))
                ]), A2(Jx, n, $(r, {
                    dU: F
                })));
            case 39:
                var K = c.a.a;
                return A2(Op, E([
                    A2(Nl, n, A2(kI, a, FI(K)))
                ]), A2(Jx, n, $(r, {
                    cO: K
                })));
            case 40:
                if (1 === c.a.a.$) return A3($A, "Erreur de s\xe9lection d'impact", c.a.a.a, A2(Jx, n, r));
                var G = c.a.a.a;
                return A2(Op, E([
                    A2(jA, t, MA(A3(_b, r.iA, G, Rr(u)))),
                    A2(Nl, n, A2(yI, a, G))
                ]), A2(Jx, n, r));
            case 41:
                var W = c.a.a;
                return A2(Op, E([
                    A2(Nl, n, A2(SI, a, xO(W)))
                ]), A2(Jx, n, $(r, {
                    dN: W
                })));
            case 42:
                var V = c.a;
                return A2(Jx, A3(kO, V.a, V.b, n), r);
            case 43:
                return A2(Uq, A2(iL, c.a.a, u), A2(Jx, n, r));
            case 44:
                return A2(Uq, A2(cL, c.a.a, u), A2(Jx, n, r));
            case 45:
                return A2(Uq, A2(fL, c.a.a, u), A2(Jx, n, r));
            case 46:
                return A2(Jx, n, $(r, {
                    bw: c.a.a
                }));
            case 47:
                var J = c.a;
                return A2(Uq, A2(Fq, A2(pL, w = J.a, J.b), u), A2(Jx, n, r));
            case 48:
                var B = c.a, X = (M = B.a, B.b);
                return A2(Op, E([
                    A2(Nl, n, eq(a))
                ]), A2(Uq, A2(Fq, A2(Aq, M, function(n) {
                    return $(n, {
                        D: X
                    });
                }), u), A2(Jx, n, r)));
            case 49:
                var Q = c.a, Z = Q.a;
                return A3(Rq, Q.b, F2(function(e, r) {
                    return A2(Uq, A4(sL, i, Z, r, u), A2(Jx, n, e));
                }), v(n, r));
            case 50:
                return A2(Jx, n, $(r, {
                    cQ: c.a.a
                }));
            case 51:
                return A2(Jx, n, $(r, {
                    cR: c.a.a
                }));
            case 52:
                return c.a.a.$ ? A3($A, "Erreur de s\xe9lection du proc\xe9d\xe9 de distribution", c.a.a.a, A2(Jx, n, r)) : A2(Uq, A2(lL, Rr(c.a.a.a), u), A2(Jx, n, r));
            case 53:
                return c.a.a.$ ? A3($A, "Erreur de durabilit\xe9", c.a.a.a, A2(Jx, n, r)) : A2(Uq, A2(dL, c.a.a.a, u), A2(Jx, n, r));
            case 54:
                var Y = c.a;
                return _ = Y.a, A3(Rq, Y.b, function(e) {
                    return A4(zq, n, e, u, _);
                }, v(n, r));
            case 57:
                var nn = c.a;
                return A5(Gq, n, r, u, M = nn.a, nn.b);
            case 55:
                var en = c.a, rn = (_ = en.a, en.b);
                return A2(Op, E([
                    A2(Nl, n, eq(a))
                ]), A2(Uq, A2(Fq, A2(bL, _, rn), u), A2(Jx, n, r)));
            case 56:
                var tn = c.a;
                return _ = tn.a, H = tn.b, rn = tn.c, A2(Op, E([
                    A2(Nl, n, eq(a))
                ]), A2(Uq, A2(Fq, A3(mL, _, H, rn), u), A2(Jx, n, r)));
            case 58:
                var un = c.a;
                return Z = un.a, A3(Rq, un.b, F2(function(e, r) {
                    return A2(Uq, A3(vL, Z, r, u), A2(Jx, n, e));
                }), v(n, r));
            case 59:
                return A4(aL, n, u, c.a.a, A2(Jx, n, r));
            case 60:
                return A2(Uq, A2(gL, c.a.a, u), A2(Jx, n, r));
            default:
                var an = c.a;
                return A2(Jx, n, $(r, {
                    bv: Rr($(an.a, {
                        ei: an.b
                    }))
                }));
        }
    }), EL = F3(function(n, e, r) {
        if (e.$) {
            if (e.a.$) {
                var t = e.a.a;
                return A2(Op, E([
                    Ip({
                        pP: 0,
                        pQ: 0
                    }),
                    hT(MA(t))
                ]), A2(Tp, n, r));
            }
            return A2(Op, E([
                hT(e.a.a)
            ]), A2(Tp, n, r));
        }
        return A2(Tp, n, r);
    }), AL = F3(function(n, e, r) {
        return A2(Tp, n, r);
    }), CL = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), PL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, TL = {
        $: 2
    }, SL = {
        $: 3
    }, IL = {
        $: 5
    }, OL = function(n) {
        return {
            $: 6,
            a: n
        };
    }, qL = function(n) {
        return {
            $: 7,
            a: n
        };
    }, LL = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ML = function(n) {
        return {
            $: 10,
            a: n
        };
    }, _L = F3(function(n, e, r) {
        return {
            $: 22,
            a: n,
            b: e,
            c: r
        };
    }), RL = function(n) {
        return {
            $: 6,
            a: n
        };
    }, HL = function(n) {
        return {
            $: 7,
            a: n
        };
    }, UL = F2(function(n, e) {
        return $(e, {
            fn: k(e.fn, E([
                {
                    i: Hr,
                    mf: n.mf,
                    aH: 0,
                    dz: Hr
                }
            ]))
        });
    }), zL = F3(function(n, e, r) {
        return $(r, {
            fn: A3(sO, A2(Fu, function(n) {
                return n.mf;
            }, Rt(n)), e, r.fn)
        });
    }), DL = F2(function(n, e) {
        return A2(zL, n, function(n) {
            return $(n, {
                aH: e
            });
        });
    }), NL = F2(function(n, e) {
        var r;
        return r = $(e, {
            fn: A2(ks, function(e) {
                return !s(e.mf, n);
            }, e.fn)
        }), 1 === ft(r.fn) ? A2(_c, r, A2(Lc, function(n) {
            return A3(DL, n.mf, 1, r);
        }, ys(r.fn))) : r;
    }), FL = F2(function(n, e) {
        return $(e, {
            cX: A2(tl, n, e.cX) ? A2(ks, Sc(n), e.cX) : A2(Ur, n, e.cX)
        });
    }), KL = F2(function(n, e) {
        return A2(zL, n, function(n) {
            return $(n, {
                i: e.i,
                mf: e.mf,
                aH: e.aH,
                dz: Hr
            });
        });
    }), GL = F3(function(n, e, r) {
        return $(r, {
            fn: A2(ju, function(r) {
                return s(r.mf, n.mf) ? $(r, {
                    dz: Rr(e)
                }) : r;
            }, r.fn)
        });
    }), WL = F2(function(n, e) {
        return s(n.mf, e.aS) ? e : $(e, {
            cZ: Hr,
            b1: Hr,
            mR: Hr,
            dj: Hr,
            dk: Hr,
            jn: Hr,
            dn: Hr,
            aS: n.mf,
            hf: Hr,
            pb: Hr,
            pR: Hr
        });
    }), VL = F2(function(n, e) {
        var r = e.eu;
        return $(e, {
            eg: $(e.eg, {
                bw: A2(sA, r, n),
                dx: A3(QE, r.C, r.h4, n)
            }),
            eu: A2(lA, n, r)
        });
    }), JL = F3(function(n, e, r) {
        var t = s(e, ME) ? Hr : Rr(e);
        switch(n){
            case 2:
                return $(r, {
                    bx: t
                });
            case 3:
                return $(r, {
                    bS: t
                });
            case 4:
                return $(r, {
                    cE: s(r.bT, t) ? r.cE : Hr,
                    bT: t
                });
            case 6:
                return $(r, {
                    cT: t
                });
            default:
                return r;
        }
    }), BL = F3(function(n, e, r) {
        var t = v(r.pb, A2(ss, function(n) {
            return n.pb;
        }, A2(PE, r.aS, n)));
        if (t.b.$) return $(r, {
            pb: Hr
        });
        if (t.a.$) return $(r, {
            pb: Rr(e(a = t.b.a))
        });
        var u = t.a.a, a = t.b.a;
        return $(r, {
            pb: s(e(u), a) ? Hr : Rr(e(u))
        });
    }), XL = F2(function(n, e) {
        var r = e.eg, t = e.eu, u = A2(_c, cT, vO(n));
        return A2(Op, E([
            A2(Nl, t, wI(ms))
        ]), A2(VL, u, A3(MI, nM, Cc(Ac), A2(ZE, A2(lA, u, t), $(r, {
            db: u
        })))));
    }), QL = F2(function(n, e) {
        var r = e.eu, t = vO(n);
        return t.$ ? A3($A, "Erreur", "Aucun mat\xe9riau s\xe9lectionn\xe9", e) : A2(VL, A2(UL, t.a, r.aG.oT), A3(MI, nM, Cc(Ac), e));
    }), ZL = F2(function(n, e) {
        var r = e.eu, t = vO(n);
        return t.$ ? A3($A, "Erreur", "Aucun produit s\xe9lectionn\xe9", e) : A2(VL, A2(WL, t.a, r.aG.oT), A3(MI, nM, Cc(Ac), e));
    }), YL = F2(function(n, e) {
        var r = e.eu, t = vO(n);
        return t.$ ? A3($A, "Erreur", "Aucun accessoire s\xe9lectionn\xe9", e) : t.a.$ ? A3($A, "Erreur", "Un mat\xe9riau brut ne peut pas \xeatre ajout\xe9 comme accessoire", e) : A2(VL, A3(BL, r.C.oT.dp, wq(t.a.a.mf), r.aG.oT), A3(MI, nM, Cc(Ac), e));
    }), nM = F3(function(n, e, r) {
        var t, u = n.C, a = n.m6, i = n.aG.oT, c = v(e, r.ad);
        switch(c.a.$){
            case 0:
                return A2(VL, function(n) {
                    return $(n, {
                        cX: w,
                        cZ: Hr,
                        b1: Hr,
                        mR: Hr,
                        dj: Hr,
                        dk: Hr,
                        fn: A2(ju, function(n) {
                            return $(n, {
                                dz: Hr
                            });
                        }, n.fn),
                        dm: Hr,
                        hf: Hr,
                        pb: Hr,
                        pR: Hr
                    });
                }(i), A3(MI, nM, Cc(Ac), A2(ZE, n, $(r, {
                    aV: 1
                }))));
            case 1:
                return A2(Op, E([
                    TT(c.a.a)
                ]), A2(ZE, n, r));
            case 2:
                return A2(ZE, A2(GI, c.a.a, n), r);
            case 3:
                return A2(Op, E([
                    BI(0)
                ]), A2(ZE, n, r));
            case 4:
                return A2(Op, E([
                    eO(0)
                ]), A2(ZE, n, r));
            case 5:
                return A2(ZE, n, r);
            case 16:
                return A2(Op, E([
                    A2(Nl, n, xI(ms))
                ]), A2(ZE, DI(n), $(r, {
                    ad: TL
                })));
            case 10:
                if (1 === c.b.$) {
                    var o = A2(_O, c.a.a, c.b.a), f = o.a;
                    return A2(Op, E([
                        A2(DA, ML, o.b)
                    ]), A2(ZE, n, $(r, {
                        ad: PL(f)
                    })));
                }
                return A2(ZE, n, r);
            case 6:
                if (6 === c.b.$) {
                    var s = A2(_O, c.a.a, c.b.a);
                    return f = s.a, A2(Op, E([
                        A2(DA, OL, s.b)
                    ]), A2(ZE, n, $(r, {
                        ad: RL(f)
                    })));
                }
                return A2(ZE, n, r);
            case 8:
                if (7 === c.b.$) {
                    var l = A2(_O, c.a.a, c.b.a);
                    return f = l.a, A2(Op, E([
                        A2(DA, LL, l.b)
                    ]), A2(ZE, n, $(r, {
                        ad: HL(f)
                    })));
                }
                return A2(ZE, n, r);
            case 7:
                if (c.b.$) return A2(ZE, n, r);
                var d = c.b, b = d.a, m = A2(_O, c.a.a, d.b);
                return f = m.a, A2(Op, E([
                    A2(DA, qL, m.b)
                ]), A2(ZE, n, $(r, {
                    ad: A2(CL, b, f)
                })));
            case 9:
                switch(c.b.$){
                    case 0:
                        var p = c.b;
                        return A4(rM, i, b = p.a, p.b, A2(ZE, n, r));
                    case 1:
                        return A2(YL, c.b.a, A2(ZE, n, r));
                    case 6:
                        return A2(XL, c.b.a, A2(ZE, n, r));
                    case 7:
                        return A2(ZL, c.b.a, A2(ZE, n, r));
                    default:
                        return A2(ZE, n, r);
                }
            case 11:
                return A2(ZE, n, $(r, {
                    bu: Hr
                }));
            case 12:
                return A2(ZE, n, $(r, {
                    bu: Rr(c.a.a)
                }));
            case 13:
                return A2(ZE, n, $(r, {
                    cI: Rr(c.a.a)
                }));
            case 14:
                var g = c.a.a, h = r.cI;
                return h.$ ? A2(ZE, n, r) : A2(ZE, A3(oO, h.a, g, n), $(r, {
                    cI: Hr,
                    bu: Hr
                }));
            case 15:
                return A2(Op, E([
                    OS("#" + c.a.a)
                ]), A2(ZE, n, r));
            case 17:
                return A2(VL, A2(NL, c.a.a, i), A2(ZE, n, r));
            case 18:
                return A2(VL, A3(BL, u.oT.dp, Yq(c.a.a), i), A2(ZE, n, r));
            case 19:
                var x = r.bv;
                return x.$ ? A2(ZE, n, r) : A2(ZE, A2(dO, x.a, n), $(r, {
                    bv: Hr
                }));
            case 20:
                return A2(VL, r.db, A2(ZE, n, r));
            case 21:
                return A2(Op, E([
                    A2(Ou, A2(_L, r.bw, nA(i)), ac),
                    A2(Nl, n, hI(ms))
                ]), A2(ZE, n, r));
            case 22:
                var k = c.a, y = k.b;
                return A2(ZE, A2(bO, {
                    gj: k.c,
                    iA: Hr,
                    ei: pf(k.a),
                    g1: y
                }, n), r);
            case 23:
                return A2(ZE, mO(n), r);
            case 24:
                return A2(ZE, pO(n), r);
            case 25:
                var j = c.a.a;
                return A3(FO, function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                        case 6:
                        case 7:
                            return !0;
                        default:
                            return !1;
                    }
                }(j), YI(IL), A2(ZE, n, $(r, {
                    ad: j
                })));
            case 26:
                var A = c.a.a;
                return A2(Op, E([
                    A3(gO, n, 2 === A, A2(SI, ms, "Partager"))
                ]), A2(ZE, n, $(r, {
                    dU: A
                })));
            case 27:
                var C = c.a.a;
                return A2(Op, E([
                    A2(Nl, n, A2(kI, ms, FI(C)))
                ]), A2(ZE, n, $(r, {
                    cO: C
                })));
            case 28:
                if (c.a.a.$) return A3($A, "Erreur de s\xe9lection d'impact: ", c.a.a.a, A2(ZE, n, r));
                var P = c.a.a.a;
                return A2(Op, E([
                    A2(jA, a, MA(A2(zm, P, Rr(i)))),
                    A2(Nl, n, A2(yI, ms, P))
                ]), A2(ZE, n, r));
            case 29:
                var T = c.a.a;
                return A2(Op, E([
                    A2(Nl, n, A2(SI, ms, xO(T)))
                ]), A2(ZE, n, $(r, {
                    dN: T
                })));
            case 30:
                return 1 === c.a.a ? A2(Op, E([
                    A2(Nl, n, A2(SI, ms, "Regulatory"))
                ]), A2(ZE, n, YE(i) ? $(r, {
                    ad: SL
                }) : $(r, {
                    aV: 1
                }))) : A2(Op, E([
                    A2(Nl, n, A2(SI, ms, "Exploratory"))
                ]), A2(ZE, n, $(r, {
                    aV: 0
                })));
            case 31:
                var S = c.a;
                return A2(ZE, A3(kO, S.a, S.b, n), r);
            case 32:
                return A2(VL, $(i, {
                    c6: Rr(c.a.a)
                }), A2(ZE, n, r));
            case 33:
                return A2(VL, A2(FL, c.a.a, i), A2(ZE, n, r));
            case 34:
                return A2(VL, $(i, {
                    cE: c.a.a
                }), A2(ZE, n, r));
            case 35:
                return A2(ZE, n, $(r, {
                    bw: c.a.a
                }));
            case 36:
                return c.a.a.$ ? A3($A, "Erreur de type d'entreprise", c.a.a.a, A2(ZE, n, r)) : A2(VL, $(i, {
                    hW: Rr(c.a.a.a)
                }), A2(ZE, n, r));
            case 37:
                return A2(VL, $(i, {
                    cZ: Rr(c.a.a)
                }), A2(ZE, n, r));
            case 38:
                return A2(VL, $(i, {
                    b1: Rr(c.a.a)
                }), A2(ZE, n, r));
            case 46:
                return A2(VL, $(i, {
                    dm: c.a.a
                }), A2(ZE, n, r));
            case 39:
                return A2(VL, $(i, {
                    mR: Rr(c.a.a)
                }), A2(ZE, n, r));
            case 41:
                return A2(VL, $(i, {
                    dk: c.a.a
                }), A2(ZE, n, r));
            case 40:
                return A2(VL, $(i, {
                    dj: c.a.a
                }), A2(ZE, n, r));
            case 42:
                return ((t = A2(Lc, xb, gp(c.a.a))).$ ? ru : VL($(i, {
                    P: t.a
                })))(A2(ZE, n, r));
            case 43:
                var I = c.a;
                return A2(VL, A3(KL, I.a.mf, I.b, i), A2(ZE, n, r));
            case 44:
                var O = c.a;
                return A2(VL, A3(GL, O.a, O.b, i), A2(ZE, n, r));
            case 45:
                return A2(VL, $(i, {
                    ja: c.a.a
                }), A2(ZE, n, r));
            case 47:
                return A2(VL, $(i, {
                    jn: c.a.a
                }), A2(ZE, n, r));
            case 48:
                return A2(VL, $(i, {
                    dn: c.a.a
                }), A2(ZE, n, r));
            case 49:
                var q = c.a;
                return A2(ZE, n, $(r, {
                    bv: Rr($(q.a, {
                        ei: q.b
                    }))
                }));
            case 50:
                var L = c.a;
                return A2(VL, A3(JL, L.a, L.b, i), A2(ZE, n, r));
            case 51:
                return A2(VL, $(i, {
                    hf: c.a.a
                }), A2(ZE, n, r));
            case 52:
                var M = c.a, _ = M.b;
                return A2(VL, A3(BL, u.oT.dp, A2(Aq, M.a, function(n) {
                    return $(n, {
                        D: _
                    });
                }), i), A2(ZE, n, r));
            case 53:
                return A2(VL, $(i, {
                    dI: c.a.a
                }), A2(ZE, n, r));
            default:
                return A2(VL, $(i, {
                    pR: c.a.a
                }), A2(ZE, n, r));
        }
    }), eM = F4(function(n, e, r, t) {
        return A2(VL, A3(KL, r.U.mf, {
            i: Hr,
            mf: t.mf,
            aH: r.aH,
            dz: Hr
        }, n), A3(MI, nM, Cc(Ac), e));
    }), rM = F4(function(n, e, r, t) {
        var u = vO(r);
        return A2(_c, A2(QL, r, A3(MI, nM, Cc(Ac), t)), A3(Uk, A2(eM, n, t), e, u));
    }), tM = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), uM = F2(function(n, e) {
        if (3 !== e.$) return n;
        var r = e.a;
        switch(n.$){
            case 0:
                return n;
            case 1:
                return function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(r);
            default:
                var t = n.a;
                return s(t.gx, r.gx) && s(t.fN, r.fN) ? n : A2(tM, t, r);
        }
    }), aM = F4(function(n, e, r, t) {
        switch(n.$){
            case 2:
                return v(t, A2(NA, zA, vA(A2(pA, "Erreur", "Impossible de charger les impacts d\xe9taill\xe9s; les impacts agr\xe9g\xe9s seront utilis\xe9s."))));
            case 1:
            case 0:
                return v(t, Tc);
            default:
                var u = A2(sS, n.a, e);
                return v($(t, {
                    H: A2(ns, u, A2(wT, u, r))
                }), Tc);
        }
    }), iM = function(n) {
        return {
            $: 8,
            a: n
        };
    }, cM = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), oM = F2(function(n, e) {
        return A2(Ou, Bi(e), IO(n));
    }), fM = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sM = F2(function(n, e) {
        switch(e.$){
            case 0:
                return w;
            case 1:
                return E([
                    A2(oM, e.a, A2(cM, 2, n))
                ]);
            default:
                return E([
                    A2(oM, e.a, fM(n))
                ]);
        }
    }), lM = F2(function(n, e) {
        return v(e, Uu(n));
    }), dM = F2(function(n, e) {
        var r, t = n.e$, u = k(n.bn, E([
            $(e, {
                mf: t
            })
        ]));
        return A2(lM, A2(Ur, A2(oM, 100, A2(cM, 1, t)), A2(sM, t, e.fk)), $(n, {
            e$: (r = t, r + 1),
            bn: u
        }));
    }), bM = F2(function(n, e) {
        return A2(dM, n, e);
    }), mM = F2(function(n, e) {
        var r = e.a1;
        return $(e, {
            a1: A2(ks, Sc(n), r)
        });
    }), pM = F2(function(n, e) {
        return {
            bO: 0,
            h5: e,
            e6: 0,
            mf: -1,
            be: 1,
            fk: n,
            bi: 0
        };
    }), vM = function(n) {
        return pM(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, gM = pM({
        $: 0
    }), hM = A2(Ou, $u, Pn(function() {
        ie.location.reload(true);
    })), $M = function(n) {
        return A2(lM, function(n) {
            var e = n.fk;
            return 2 === e.$ ? E([
                A2(oM, e.a, fM(n.mf))
            ]) : w;
        }(n), $(n, {
            bO: n.bO + 1,
            be: 1
        }));
    }, xM = function(n) {
        return v(n, Tc);
    }, kM = function(n) {
        return !n.be || n.bO > 0 ? xM($(n, {
            bO: n.bO - 1
        })) : v(n, A2(Ou, ru, xu(A2(cM, 2, n.mf))));
    }, wM = function(n) {
        return v($(n, {
            bi: 2
        }), A2(oM, n.e6, function(n) {
            return {
                $: 3,
                a: n
            };
        }(n.mf)));
    }, yM = F2(function(n, e) {
        return $(n, {
            bn: e
        });
    }), jM = F2(function(n, e) {
        return xM(A2(yM, e, A2(ks, function(e) {
            return !s(e.mf, n);
        }, e.bn)));
    }), EM = F3(function(n, e, r) {
        n: for(;;){
            if (r.b) {
                var t = r.a, u = r.b, a = n(t);
                if (a.$) {
                    e = A2(Ur, t, e), r = u;
                    continue n;
                }
                var i = a.a, c = i.a, o = i.b;
                return v(k(xt(e), A2(Ur, c, u)), Rr(o));
            }
            return v(xt(e), Hr);
        }
    }), AM = F3(function(n, e, r) {
        var t = r.b;
        return v(n(r.a), e(t));
    }), CM = F3(function(n, e, r) {
        var t = function(r) {
            return s(r.mf, e) ? Rr(n(r)) : Hr;
        };
        return A3(AM, yM(r), _c(Tc), A3(EM, t, w, r.bn));
    }), PM = function(n) {
        return CM(A2(Fu, n, xM));
    }, TM = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 1:
                        return A2(PM, function(n) {
                            return $(n, {
                                bi: 1
                            });
                        }, n.b);
                    case 0:
                        return A2(PM, function(n) {
                            return $(n, {
                                bi: 0
                            });
                        }, n.b);
                    default:
                        return A2(CM, wM, n.b);
                }
            case 1:
                return n.a ? A2(CM, $M, n.b) : A2(PM, function(n) {
                    return $(n, {
                        be: 0
                    });
                }, n.b);
            case 2:
                return A2(CM, kM, n.a);
            default:
                return jM(n.a);
        }
    }, SM = F2(function(n, e) {
        return A2($k, ru, A2(TM, n, e));
    }), IM = F4(function(n, e, r, t) {
        switch(r.$){
            case 0:
                var u = A2(bM, t.bo, (i = r.a).eb ? A2(vM, 5e3, i) : gM(i)), a = u.b;
                return v($(t, {
                    bo: u.a
                }), A2(DA, A2(cc, zA, iM), a));
            case 1:
                return v($(t, {
                    ch: !1
                }), Tc);
            case 2:
                var i;
                return v($(t, {
                    H: A2(ns, A2(mM, i = r.a, n), e)
                }), Tc);
            case 3:
                return v(t, hT(r.a));
            case 4:
                return v($(t, {
                    ch: !0
                }), Tc);
            case 5:
                return v(t, hM);
            case 6:
                var c = $(n, {
                    a1: w,
                    bH: oT
                });
                return v($(t, {
                    bc: !1,
                    H: A2(ns, c, e)
                }), A2(NA, zA, vA(OT("La session a \xe9t\xe9 r\xe9initialis\xe9e."))));
            case 7:
                return v(t, hT("/versions/" + r.a + "/#" + A2(_c, "", t.a6.iz)));
            default:
                var o = A2(SM, r.a, t.bo);
                return a = o.b, v($(t, {
                    bo: o.a
                }), A2(DA, A2(cc, zA, iM), a));
        }
    }), OM = F4(function(n, e, r, t) {
        switch(r.$){
            case 0:
                var u = r.a;
                return e.$ ? v(t, Tc) : A5(KA, t, Tc, Kl, Fl, A3(ET, n, u, e.a));
            case 1:
                return A4(IM, n, e, r.a, t);
            case 2:
                return 1 === e.$ ? A5(KA, t, Tc, Wl, Gl, A3(TS, n, r.a, e.a)) : v(t, Tc);
            case 3:
                return v($(t, {
                    bc: !1
                }), Tc);
            case 4:
            case 11:
                return v(t, Tc);
            case 5:
                return A4(aM, r.a, n, e, t);
            case 6:
                return 2 === e.$ ? A5(KA, t, Tc, Jl, Vl, A3(SS, n, r.a, e.a)) : v(t, Tc);
            case 7:
                return 3 === e.$ ? A5(KA, t, Tc, Bl, wi, A3(bI, n, r.a, e.a)) : v(t, Tc);
            case 8:
                var a = r.a;
                if (4 === e.$) {
                    var i = e.a;
                    return A2(jT, function(n) {
                        switch(n.$){
                            case 0:
                            case 3:
                            case 4:
                            case 7:
                            case 8:
                            case 9:
                            case 17:
                            case 26:
                            case 27:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            default:
                                return !0;
                            case 1:
                            case 2:
                            case 5:
                            case 6:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 25:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 38:
                            case 43:
                                return !1;
                        }
                    }(a), A5(KA, t, Tc, Xl, yi, A3(JO, n, a, i)));
                }
                return v(t, Tc);
            case 9:
                var c = r.a;
                if (5 === e.$) {
                    var o = e.a;
                    return A2(jT, function(n) {
                        switch(n.$){
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 46:
                            case 47:
                            case 50:
                            case 51:
                            case 53:
                            default:
                                return !1;
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 45:
                            case 48:
                            case 49:
                            case 52:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                            case 60:
                                return !0;
                        }
                    }(c), A5(KA, t, Tc, Ql, ji, A3(jL, n, c, o)));
                }
                return v(t, Tc);
            case 10:
                return 6 === e.$ ? A5(KA, t, Tc, Yl, Zl, A3(EL, n, r.a, e.a)) : v(t, Tc);
            case 12:
                return 9 === e.$ ? A5(KA, t, Tc, rd, ed, A3(AL, n, r.a, e.a)) : v(t, Tc);
            case 13:
                var f = A2(aT, r.a, n), l = s(n.d$, f.d$) ? e : A2(wT, f, e);
                return v($(t, {
                    H: A2(ns, f, l)
                }), Tc);
            case 14:
                var d = r.a;
                if (10 === e.$) {
                    var b = e.a;
                    return A2(jT, function(n) {
                        switch(n.$){
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 25:
                            case 26:
                            case 30:
                            case 34:
                            case 35:
                            case 42:
                            case 49:
                                return !1;
                            default:
                                return !0;
                        }
                    }(d), A5(KA, t, Tc, td, Ai, A3(nM, n, d, b)));
                }
                return v(t, Tc);
            case 15:
                return A2($T, function(e) {
                    return Uu(E([
                        e,
                        A2(Nl, n, rs(m))
                    ]));
                }, A4(GA, m = r.a, n, e, v($(t, {
                    ch: !1,
                    a6: m
                }), Tc)));
            case 16:
                var m;
                return r.a.$ ? v(t, hT(r.a.a)) : v($(t, {
                    a6: m = r.a.a
                }), A2(jA, n.m6, Ol(m)));
            case 17:
                return v(t, gi(_u));
            default:
                return v($(t, {
                    H: A2(ns, $(n, {
                        k9: A2(uM, n.k9, r.a)
                    }), e)
                }), Tc);
        }
    }), qM = F2(function(n, e) {
        var r = e.H;
        switch(r.$){
            case 0:
                return v(e, Tc);
            case 1:
                return A2(gT, n, e);
            default:
                var t = r.a;
                return A2(Xf, t, A4(OM, t, r.b, n, e));
        }
    }), LM = {
        $: 0
    }, MM = {
        $: 1
    }, _M = function(n) {
        return {
            $: 2,
            a: n
        };
    }, RM = {
        $: 3
    }, HM = {
        $: 4
    }, UM = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zM = {
        $: 6
    }, DM = {
        $: 7
    }, NM = {
        $: 8
    }, FM = {
        $: 9
    }, KM = fe("a"), GM = F2(function(n, e) {
        return A2(pe, n, Ic(e));
    }), WM = GM("className"), VM = fe("div"), JM = function(n) {
        return VM(A2(Ur, WM("container"), n));
    }, BM = fe("h1"), XM = function(n) {
        var e;
        return A2(GM, "href", $e.test(e = n) ? "" : e);
    }, QM = function(n) {
        return XM(MA(n));
    }, ZM = F2(function(n, e) {
        return A2(ve, function(n) {
            return he.test(n) ? "data-" + n : n;
        }(n), we(e));
    }), YM = fe("button"), n_ = function(n) {
        return WM(A2(at, " ", A2(ju, Gt, A2(ks, Gh, n))));
    }, e_ = fe("h3"), r_ = be, t_ = F2(function(n, e) {
        return A2(r_, n, function(n) {
            return {
                $: 0,
                a: n
            };
        }(e));
    }), u_ = function(n) {
        return A2(t_, "click", nu(n));
    }, a_ = oe, i_ = GM("type"), c_ = function(n) {
        var e = n.h0, r = n.h5, t = n.eb, u = n.eC;
        return A2(VM, k(n.hO, k(E([
            WM("fr-alert shadow-sm"),
            n_(E([
                v("fr-alert--success", 2 === t),
                v("fr-alert--info", 1 === t),
                v("fr-alert--warning", 3 === t),
                v("fr-alert--error", !t)
            ])),
            A2(ZM, "aria-atomic", "true")
        ]), E(t && 3 !== t ? [
            A2(ZM, "role", "status"),
            A2(ZM, "aria-live", "polite")
        ] : [
            A2(ZM, "role", "alert"),
            A2(ZM, "aria-live", "assertive")
        ]))), E([
            function() {
                if (u.$) return a_("");
                var n = u.a;
                return A2(e_, E([
                    WM("h5 mb-2")
                ]), E([
                    a_(n)
                ]));
            }(),
            A2(VM, E([
                WM("mb-1")
            ]), r),
            function() {
                if (e.$) return a_("");
                var n = e.a;
                return A2(YM, E([
                    i_("button"),
                    WM("fr-link fr-link--close"),
                    A2(ZM, "aria-label", "Fermer"),
                    u_(n)
                ]), E([
                    a_("Masquer le message")
                ]));
            }()
        ]));
    }, o_ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, f_ = fe("i"), s_ = function(n) {
        return A2(f_, E([
            A2(ZM, "aria-hidden", "true"),
            WM("icon icon-" + n)
        ]), w);
    }, l_ = s_("info"), d_ = fe("span"), b_ = F2(function(n, e) {
        return A2(VM, A2(Ur, WM("page-notice shadow-inner-top"), A2(Ur, A2(ZM, "role", "notice"), n)), E([
            A2(VM, E([
                WM("container px-4")
            ]), E([
                A2(d_, E([
                    WM("d-flex align-items-center gap-1")
                ]), e)
            ]))
        ]));
    }), m_ = b_(E([
        WM("page-notice-info")
    ])), p_ = A2(Fu, it("\n\n"), A2(Fu, ju(pf), at("\n\n"))), v_ = function(n) {
        return "Problem at row " + ut(n.oe) + "\n" + function(n) {
            switch(n.$){
                case 0:
                    return "Expecting " + n.a;
                case 1:
                    return "Expecting int";
                case 2:
                    return "Expecting hex";
                case 3:
                    return "Expecting octal";
                case 4:
                    return "Expecting binary";
                case 5:
                    return "Expecting float";
                case 6:
                    return "Expecting number";
                case 7:
                    return "Expecting variable";
                case 8:
                    return "Expecting symbol " + n.a;
                case 9:
                    return "Expecting keyword " + n.a;
                case 10:
                    return "Expecting keyword end";
                case 11:
                    return "Unexpected char";
                case 12:
                    return n.a;
                default:
                    return "Bad repeat";
            }
        }(n.nO);
    }, g_ = GM("align"), h_ = GM("alt"), $_ = fe("blockquote"), x_ = fe("br"), k_ = F2(function(n, e) {
        return A2(pe, n, Rc(e));
    }), w_ = k_("checked"), y_ = fe("code"), j_ = fe("del"), E_ = k_("disabled"), A_ = fe("em"), C_ = fe("h2"), P_ = fe("h4"), T_ = fe("h5"), S_ = fe("h6"), I_ = fe("hr"), O_ = fe("img"), q_ = fe("input"), L_ = fe("li"), M_ = fe("ol"), __ = F2(function(n, e) {
        return 1 === n.$ ? e.$ ? Jr(A2(Ur, n.a, e.a)) : Zr(e.a) : Zr(n.a);
    }), R_ = F2(function(n, e) {
        return lf(e) ? "<" + n + ">" : "<" + n + " " + function(n) {
            return A2(at, " ", A2(ju, function(n) {
                return n.ei + '="' + n.eP + '"';
            }, n));
        }(e) + ">";
    }), H_ = fe("p"), U_ = fe("pre"), z_ = function(n) {
        return A2(GM, "src", we(n));
    }, D_ = fe("strong"), N_ = fe("table"), F_ = fe("tbody"), K_ = fe("td"), G_ = fe("th"), W_ = fe("thead"), V_ = GM("title"), J_ = fe("tr"), B_ = fe("ul"), X_ = function(n) {
        return E(n.trim().split(/\s+/g));
    }, Q_ = {
        f7: $_(w),
        gb: function(n) {
            var e, r = n.kK, t = !(e = A2(Lc, X_, n.mD)).$ && e.a.b ? E([
                WM("language-" + e.a.a)
            ]) : w;
            return A2(U_, w, E([
                A2(y_, t, E([
                    a_(r)
                ]))
            ]));
        },
        gc: function(n) {
            return A2(y_, w, E([
                a_(n)
            ]));
        },
        go: function(n) {
            return A2(A_, w, n);
        },
        gw: A2(x_, w, w),
        gy: function(n) {
            var e = n.kR;
            switch(n.eb){
                case 0:
                    return A2(BM, w, e);
                case 1:
                    return A2(C_, w, e);
                case 2:
                    return A2(e_, w, e);
                case 3:
                    return A2(P_, w, e);
                case 4:
                    return A2(T_, w, e);
                default:
                    return A2(S_, w, e);
            }
        },
        gA: (oI = w, sI = A2(ju, function(n) {
            return n;
        }, oI), fI = A3(ot, F2(function(n, e) {
            return F3(function(r, t, u) {
                return A2(__, A3(n, r, t, u), A3(e, r, t, u));
            });
        }), F3(function() {
            return Jr(w);
        }), sI), F3(function(n, e, r) {
            return A2($a, function(r) {
                if (r.b) {
                    if (r.b.b) return "oneOf failed parsing this value:\n    " + A2(R_, n, e) + "\n\nParsing failed in the following 2 ways:\n\n\n" + A2(at, "\n\n", A2(bt, F2(function(n, e) {
                        return "(" + ut(n + 1) + ") " + e;
                    }), r)) + "\n";
                    var t = r.a;
                    return "Problem with the given value:\n\n" + A2(R_, n, e) + "\n\n" + t + "\n";
                }
                return "Ran into a oneOf with no possibilities!";
            }, A3(fI, n, e, r));
        })),
        gB: function(n) {
            var e = n.eC;
            if (e.$) return A2(O_, E([
                z_(n.hb),
                h_(n.f4)
            ]), w);
            var r = e.a;
            return A2(O_, E([
                z_(n.hb),
                h_(n.f4),
                V_(r)
            ]), w);
        },
        di: F2(function(n, e) {
            var r = n.eC;
            if (r.$) return A2(KM, E([
                XM(n.lp)
            ]), e);
            var t = r.a;
            return A2(KM, E([
                XM(n.lp),
                V_(t)
            ]), e);
        }),
        gT: F2(function(n, e) {
            var r;
            return A2(M_, 1 === n ? E([
                (r = n, A2(GM, "start", ut(r)))
            ]) : w, A2(ju, function(n) {
                return A2(L_, w, n);
            }, e));
        }),
        gV: H_(w),
        hd: function(n) {
            return A2(j_, w, n);
        },
        he: function(n) {
            return A2(D_, w, n);
        },
        hi: N_(w),
        hj: F_(w),
        hk: function(n) {
            return K_(A2(_c, w, A2(Lc, ik, A2(Lc, g_, A2(Lc, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        hl: W_(w),
        hm: function(n) {
            return G_(A2(_c, w, A2(Lc, ik, A2(Lc, g_, A2(Lc, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        fL: J_(w),
        z: a_,
        hq: A2(I_, w, w),
        hy: function(n) {
            return A2(B_, w, A2(ju, function(n) {
                var e = n.a, r = n.b, t = function() {
                    switch(e){
                        case 0:
                            return a_("");
                        case 1:
                            return A2(q_, E([
                                E_(!0),
                                w_(!1),
                                i_("checkbox")
                            ]), w);
                        default:
                            return A2(q_, E([
                                E_(!0),
                                w_(!0),
                                i_("checkbox")
                            ]), w);
                    }
                }();
                return A2(L_, w, A2(Ur, t, r));
            }, n));
        }
    }, Z_ = {
        $: 10
    }, Y_ = function(n) {
        return {
            $: 11,
            a: n
        };
    }, nR = function(n) {
        return {
            $: 4,
            a: n
        };
    }, eR = function(n) {
        return {
            $: 7,
            a: n
        };
    }, rR = function(n) {
        return {
            $: 5,
            a: n
        };
    }, tR = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uR = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), aR = {
        $: 0
    }, iR = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cR = {
        $: 8
    }, oR = F2(function(n, e) {
        return {
            $: 4,
            a: n,
            b: e
        };
    }), fR = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), sR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lR = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bR = F2(function(n, e) {
        return {
            $: 3,
            a: n,
            b: e
        };
    }), mR = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), pR = F3(function(n, e, r) {
        return {
            $: 2,
            a: n,
            b: e,
            c: r
        };
    }), vR = function(n) {
        return {
            $: 6,
            a: n
        };
    }, gR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hR = F3(function(n, e, r) {
        return {
            $: 1,
            a: n,
            b: e,
            c: r
        };
    }), $R = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), xR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kR = F3(function(n, e, r) {
        return {
            $: 2,
            a: n,
            b: e,
            c: r
        };
    }), wR = F6(function(n, e, r, t, u, a) {
        return {
            $: 4,
            a: n,
            b: e,
            c: r,
            d: t,
            e: u,
            f: a
        };
    }), yR = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ER = function(n) {
        return {
            $: 12,
            a: n
        };
    }, AR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, CR = function(n) {
        return {
            $: 4,
            a: n
        };
    }, PR = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), TR = function(n) {
        return {
            $: 8,
            a: n
        };
    }, SR = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), IR = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), OR = {
        $: 8
    }, qR = {
        $: 7
    }, LR = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), MR = F4(function(n, e, r, t) {
        return {
            $: 3,
            a: n,
            b: e,
            c: r,
            d: t
        };
    }), _R = F2(function(n, e) {
        return {
            a: A2(Ur, e, n.a),
            b: n.b
        };
    }), RR = function(n) {
        var e = n;
        return function(n) {
            var r = e(n);
            return 1 === r.$ ? A2(zp, !1, r.b) : A3(Dp, !1, r.b, r.c);
        };
    }, HR = function(n) {
        switch(n){
            case " ":
            case "\t":
                return !0;
            default:
                return !1;
        }
    }, UR = A2(Lv, "\r", iR("a carriage return")), zR = A2(Lv, "\n", iR("a newline")), DR = hv(E([
        _v(zR),
        A2(dv, _v(UR), hv(E([
            _v(zR),
            cv(0)
        ])))
    ])), NR = A2(Av, function() {
        return Z_;
    }, A2(dv, RR(Yp(HR)), DR)), FR = A2(Lv, " ", iR("a space")), KR = E([
        Rv(A2(Lv, ">", iR(">"))),
        A2(dv, RR(Rv(FR)), hv(E([
            Rv(A2(Lv, ">", iR(" >"))),
            Rv(A2(Lv, " >", iR("  >"))),
            Rv(A2(Lv, "  >", iR("   >")))
        ])))
    ]), GR = function(n) {
        switch(n){
            case "\n":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, WR = Yp(A2(cc, ul, GR)), VR = Bp(iR("the end of the input")), JR = hv(E([
        DR,
        VR
    ])), BR = A2(mv, A2(dv, A2(dv, cv(Y_), hv(KR)), hv(E([
        Rv(FR),
        cv(0)
    ]))), A2(dv, rv(WR), JR)), XR = function(n) {
        return A2(at, "\n", A2(ju, v_, n));
    }, QR = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !A2(Gd, n.a, "\n");
            case 12:
                if ((r = n.a).b) {
                    n = r.a;
                    continue n;
                }
                return !1;
            case 4:
                var e = n.e;
                if (e.b) {
                    var r;
                    if ((r = e.a).b) {
                        n = r.a;
                        continue n;
                    }
                    return !1;
                }
                return !1;
            case 0:
                return !0;
            default:
                return !1;
        }
    }, ZR = function(n) {
        return {
            $: 3,
            a: n
        };
    }, YR = F3(function(n, e, r) {
        return {
            $: 0,
            a: n,
            b: e,
            c: r
        };
    }), nH = iR("at least 1 tag name character"), eH = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "\t":
            case "/":
            case "<":
            case ">":
            case '"':
            case "'":
            case "=":
                return !1;
            default:
                return !0;
        }
    }, rH = A2(ev, F2(function(n) {
        return Os(n);
    }), A2(dv, A2(yv, eH, nH), Yp(eH))), tH = rH, uH = function(n) {
        return _v(A2(Lv, n, qv(n)));
    }, aH = Ui(E([
        v("amp", "&"),
        v("lt", "<"),
        v("gt", ">"),
        v("apos", "'"),
        v("quot", '"')
    ])), iH = F3(function(n, e, r) {
        n: for(;;){
            if (!e.b) return Zr(r);
            var t = e.a, u = e.b;
            switch(t){
                case "0":
                    n = a = n - 1, e = i = u, r = c = r;
                    continue n;
                case "1":
                    var a = n - 1, i = u, c = r + A2(Fk, 16, n);
                    n = a, e = i, r = c;
                    continue n;
                case "2":
                    a = n - 1, i = u, c = r + 2 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "3":
                    a = n - 1, i = u, c = r + 3 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "4":
                    a = n - 1, i = u, c = r + 4 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "5":
                    a = n - 1, i = u, c = r + 5 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "6":
                    a = n - 1, i = u, c = r + 6 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "7":
                    a = n - 1, i = u, c = r + 7 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "8":
                    a = n - 1, i = u, c = r + 8 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "9":
                    a = n - 1, i = u, c = r + 9 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "a":
                    a = n - 1, i = u, c = r + 10 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "b":
                    a = n - 1, i = u, c = r + 11 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "c":
                    a = n - 1, i = u, c = r + 12 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "d":
                    a = n - 1, i = u, c = r + 13 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "e":
                    a = n - 1, i = u, c = r + 14 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                case "f":
                    a = n - 1, i = u, c = r + 15 * A2(Fk, 16, n), n = a, e = i, r = c;
                    continue n;
                default:
                    return Jr(Jc(t) + " is not a valid hexadecimal character.");
            }
        }
    }), cH = function(n) {
        var e = function(n) {
            var e, r = A2(gu, "#x", e = n) ? A2($a, uv, A2(ss, Rd, function(n) {
                if (su(n)) return Jr("Empty strings are not valid hexadecimal strings.");
                var e = function() {
                    if (A2(gu, "-", n)) {
                        var e = A2(_c, w, kk(bg(n)));
                        return A2(ss, ro, A3(iH, ft(e) - 1, e, 0));
                    }
                    return A3(iH, iu(n) - 1, bg(n), 0);
                }();
                return A2($a, function(e) {
                    return A2(at, " ", E([
                        '"' + n + '"',
                        "is not a valid hexadecimal string because",
                        e
                    ]));
                }, e);
            }(A2(ou, 2, e)))) : A2(gu, "#", e) ? A2(ws, uv("Invalid escaped character: " + e), A2(Lc, Rd, du(A2(ou, 1, e)))) : A2(ws, uv('No entity named "&' + e + ';" found.'), A2(ra, e, aH));
            return r.$ ? av(r.a) : cv(r.a);
        }, r = function(e) {
            return !s(e, n) && ";" !== e;
        };
        return A2(mv, A2(dv, cv(ru), uH("&")), A2(dv, A2(Np, e, rv(A2(dv, A2(yv, r, iR("an entity character")), Yp(r)))), uH(";")));
    }, oH = F3(function(n, e, r) {
        return A2(Np, function(e) {
            return hv(E([
                A2(Av, function(n) {
                    return Tv(k(r, k(e, Jc(n))));
                }, cH(n)),
                cv(Pv(k(r, e)))
            ]));
        }, rv(Yp(e)));
    }), fH = function(n) {
        return A2(Ev, "", A2(oH, n, function(e) {
            return !s(e, n) && "&" !== e;
        }));
    }, sH = hv(E([
        A2(mv, A2(dv, cv(ru), uH('"')), A2(dv, fH('"'), uH('"'))),
        A2(mv, A2(dv, cv(ru), uH("'")), A2(dv, fH("'"), uH("'")))
    ])), lH = F2(function(n, e) {
        return Rr(e.$ ? n : e.a);
    }), dH = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "\t":
                return !0;
            default:
                return !1;
        }
    }, bH = Yp(dH), mH = function(n) {
        var e = F2(function(e, r) {
            return Tv(A3(ma, Os(e), lH(r), n));
        });
        return hv(E([
            A2(mv, A2(mv, cv(e), A2(dv, A2(dv, A2(dv, tH, bH), uH("=")), bH)), A2(dv, sH, bH)),
            cv(Pv(n))
        ]));
    }, pH = A2(Av, A2(zi, F3(function(n, e, r) {
        return A2(Ur, {
            ei: n,
            eP: e
        }, r);
    }), w), A2(Ev, Zu, mH)), vH = function(n) {
        return function(e) {
            var r = A5(wr, n, e.h, e.oe, e.h1, e.hb), t = r.a, u = r.b, a = r.c, i = 0 > t ? iu(e.hb) : t;
            return A3(Dp, 0 > m(e.h, i), 0, {
                h1: a,
                k_: e.k_,
                v: e.v,
                h: i,
                oe: u,
                hb: e.hb
            });
        };
    }, gH = A2(mv, A2(dv, cv(ru), uH("<![CDATA[")), A2(dv, rv(vH("]]>")), uH("]]>"))), hH = F2(function(n, e) {
        return A2(Av, function(n) {
            return n(e);
        }, hv(n));
    }), $H = function(n) {
        var e = A2(Np, function(e) {
            return s(n, e) ? cv(0) : av(uv("tag name mismatch: " + n + " and " + e));
        }, rH);
        return A2(dv, A2(dv, A2(dv, A2(dv, uH("</"), bH), e), bH), uH(">"));
    }, xH = function(n) {
        return A2(Lv, n, iR(n));
    }, kH = A2(mv, A2(dv, cv(function(n) {
        return {
            $: 2,
            a: n
        };
    }), _v(xH("\x3c!--"))), A2(dv, rv(vH("--\x3e")), _v(xH("--\x3e")))), wH = F2(function(n, e) {
        return {
            $: 5,
            a: n,
            b: e
        };
    }), yH = iR("at least 1 uppercase character"), jH = rv(A2(dv, A2(yv, vt, yH), Yp(vt))), EH = A2(dv, A2(yv, dH, iR("at least one whitespace")), Yp(dH)), AH = A2(mv, A2(mv, A2(dv, cv(wH), uH("<!")), A2(dv, jH, EH)), A2(dv, rv(vH(">")), uH(">"))), CH = A2(mv, A2(dv, cv(function(n) {
        return {
            $: 4,
            a: n
        };
    }), uH("<?")), A2(dv, rv(vH("?>")), uH("?>"))), PH = function(n) {
        switch(n){
            case "<":
            case "&":
                return !1;
            default:
                return !0;
        }
    }, TH = E([
        A2(Av, function() {
            return Tv(0);
        }, A2(dv, A2(yv, PH, iR("is not & or <")), Yp(PH))),
        A2(Av, function() {
            return Tv(0);
        }, cH("<")),
        cv(Pv(0))
    ]), SH = rv(A2(Ev, 0, function() {
        return hv(TH);
    })), IH = function(n) {
        return A2(Ev, w, hH(OH(n)));
    }, OH = function(n) {
        return E([
            A2(Av, F2(function(n, e) {
                return Pv(xt(e));
            }), $H(n)),
            A2(Np, function(e) {
                return su(e) ? A2(Av, F2(function(n, e) {
                    return Pv(xt(e));
                }), $H(n)) : cv(function(n) {
                    return Tv(A2(Ur, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(e), n));
                });
            }, SH),
            A2(Av, F2(function(n, e) {
                return Tv(A2(Ur, n, e));
            }), LH())
        ]);
    }, qH = function(n) {
        return A2(mv, A2(mv, A2(dv, cv(YR(n)), bH), A2(dv, pH, bH)), hv(E([
            A2(Av, function() {
                return w;
            }, uH("/>")),
            A2(mv, A2(dv, cv(ru), uH(">")), IH(n))
        ])));
    };
    function LH() {
        return hv(E([
            A2(Av, ZR, gH),
            CH,
            kH,
            AH,
            MH()
        ]));
    }
    function MH() {
        return A2(mv, A2(dv, cv(ru), uH("<")), A2(Np, qH, rH));
    }
    var _H = LH();
    LH = function() {
        return _H;
    };
    var RH = MH();
    MH = function() {
        return RH;
    };
    var HH, UH, zH, DH = A2(Lv, "\t", iR("a tab")), NH = hv(E([
        Rv(DH),
        A2(dv, RR(Rv(FR)), hv(E([
            Rv(A2(Lv, "   ", qv("Indentation"))),
            Rv(A2(Lv, " \t", qv("Indentation"))),
            Rv(A2(Lv, "  \t", qv("Indentation")))
        ])))
    ])), FH = A2(mv, A2(dv, cv(vR), NH), A2(dv, rv(WR), JR)), KH = function(n) {
        return !A2(Uc, 2, n);
    }, GH = function(n) {
        return n ? 1 : 0;
    }, WH = F3(function(n, e, r) {
        var t = v(e, r);
        return "" === t.a ? r : "" === t.b ? e : k(e, k(n, r));
    }), VH = F2(function(n, e) {
        return n + "\n" + e;
    }), JH = A2(ev, F2(function(n) {
        return xR(n);
    }), WR), BH = A2(dv, JH, JR), XH = F4(function(n, e, r, t) {
        return {
            kK: t,
            mq: e,
            mU: r,
            nD: n
        };
    }), QH = function(n) {
        return A3(Dp, !1, n.h1, n);
    }, ZH = A2(mv, cv(function(n) {
        return v(n, "");
    }), A2(dv, QH, JR)), YH = function(n) {
        return A2(dv, A2(yv, n, uv("Expected one or more character")), Yp(n));
    }, nU = A2(mv, A2(mv, A2(dv, cv(F2(function(n, e) {
        return v(n, e);
    })), YH(HR)), QH), A2(dv, rv(WR), JR)), eU = A2(Lv, ")", iR("a `)`")), rU = A2(Lv, ".", iR("a `.`")), tU = hv(E([
        A2(dv, cv(0), Rv(rU)),
        A2(dv, cv(1), Rv(eU))
    ])), uU = A2(ev, F2(function(n) {
        return A2(_c, 0, du(n));
    }), YH(ht)), aU = A2(Np, function(n) {
        return n > 999999999 ? av(uv("Starting numbers must be nine digits or less.")) : cv(n);
    }, uU), iU = _v(FR), cU = F2(function(n, e) {
        var r = A2(J$, n, e);
        if (r.b) {
            var t = r.a, u = r.b;
            return A3(ot, F2(function(n, e) {
                return hv(E([
                    A2(dv, n, e),
                    cv(0)
                ]));
            }), hv(E([
                t,
                cv(0)
            ])), u);
        }
        return cv(0);
    }), oU = function(n) {
        return 1 === n ? cv(n) : av(uv("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
    }, fU = function(n) {
        return A2(Av, function(n) {
            return A6(wR, !0, n.mq, n.mU, n.nD, w, n.kK);
        }, function(n) {
            return A2(mv, A2(mv, A2(mv, A2(mv, A2(mv, cv(F5(function(n, e, r, t, u) {
                var a = u.a, i = u.b;
                return a - t > 4 ? A4(XH, e, t - n + 1, r, k(A2(Xc, a - t - 1, " "), i)) : A4(XH, e, a - n, r, i);
            })), QH), RR(function(n) {
                return n ? A2(Np, oU, A2(mv, A2(dv, cv(ru), A2(cU, 3, iU)), aU)) : A2(mv, A2(dv, cv(ru), A2(cU, 3, iU)), aU);
            }(n))), RR(tU)), QH), n ? nU : hv(E([
                ZH,
                nU
            ])));
        }(n));
    }, sU = {
        $: 1
    }, lU = F3(function(n, e, r) {
        return {
            $: 4,
            a: n,
            b: e,
            c: r
        };
    }), dU = F3(function(n, e, r) {
        return {
            $: 3,
            a: n,
            b: e,
            c: r
        };
    }), bU = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mU = function(n) {
        var e = n, r = e.G;
        switch(r.$){
            case 0:
                return bU(e.z);
            case 1:
                return sU;
            case 2:
                return function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(e.z);
            case 3:
                var t = r.a;
                return A3(dU, t.b, Hr, E([
                    bU(t.a)
                ]));
            case 4:
                var u = r.a;
                return A3(dU, u.a, u.b, pU(e.T));
            case 5:
                var a = r.a;
                return A3(lU, a.a, a.b, pU(e.T));
            case 6:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(r.a);
            case 7:
                return A2(uR, r.a, pU(e.T));
            default:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(pU(e.T));
        }
    }, pU = function(n) {
        return A2(ju, mU, n);
    }, vU = F2(function(n, e) {
        return {
            s: e.s - n.X,
            T: e.T,
            w: e.w - n.X,
            z: e.z,
            av: e.av - n.X,
            X: e.X - n.X,
            G: e.G
        };
    }), gU = F2(function(n, e) {
        return {
            s: n.s,
            T: A2(Ur, A2(vU, n, e), n.T),
            w: n.w,
            z: n.z,
            av: n.av,
            X: n.X,
            G: n.G
        };
    }), hU = function(n) {
        var e = n;
        return {
            s: e.s,
            T: $U(e.T),
            w: e.w,
            z: e.z,
            av: e.av,
            X: e.X,
            G: e.G
        };
    }, $U = function(n) {
        var e = A2(IE, function(n) {
            return n.w;
        }, n);
        return e.b ? A3(xU, e.b, e.a, w) : w;
    }, xU = F3(function(n, e, r) {
        for(;;){
            var t = e;
            if (!n.b) return A2(Ur, hU(t), r);
            var u = n.a, a = n.b;
            1 > m(t.s, u.w) ? (n = a, e = u, r = A2(Ur, hU(t), r)) : 0 > m(t.w, u.w) && m(t.s, u.s) > 0 ? (n = a, e = A2(gU, t, u)) : (n = a, e = t);
        }
    }), kU = {
        $: 0
    }, wU = A2(_c, Ss, Ts("&#([0-9]{1,8});")), yU = function(n) {
        return function(n) {
            return 9 === n || 10 === n || 13 === n || 133 === n || n >= 32 && 126 >= n || n >= 160 && 55295 >= n || n >= 57344 && 64975 >= n || n >= 65008 && 65533 >= n || n >= 65536 && 1114109 >= n;
        }(n) && !function(n) {
            var e = A2(Uc, 16, n), r = A2(Uc, 131070, n);
            return !(131070 > n || (0 > r || r > 15) && (65536 > r || r > 65551) || 14 !== e && 15 !== e);
        }(n) ? Jc(Rd(n)) : Jc(Rd(65533));
    }, jU = A2(_k, wU, function(n) {
        var e = n.oJ;
        if (e.b && !e.a.$) {
            var r = du(e.a.a);
            return r.$ ? n.ee : yU(r.a);
        }
        return n.ee;
    }), EU = A2(_c, Ss, Ts("&([0-9a-zA-Z]+);")), AU = Ui(E([
        v("quot", 34),
        v("amp", 38),
        v("apos", 39),
        v("lt", 60),
        v("gt", 62),
        v("nbsp", 160),
        v("iexcl", 161),
        v("cent", 162),
        v("pound", 163),
        v("curren", 164),
        v("yen", 165),
        v("brvbar", 166),
        v("sect", 167),
        v("uml", 168),
        v("copy", 169),
        v("ordf", 170),
        v("laquo", 171),
        v("not", 172),
        v("shy", 173),
        v("reg", 174),
        v("macr", 175),
        v("deg", 176),
        v("plusmn", 177),
        v("sup2", 178),
        v("sup3", 179),
        v("acute", 180),
        v("micro", 181),
        v("para", 182),
        v("middot", 183),
        v("cedil", 184),
        v("sup1", 185),
        v("ordm", 186),
        v("raquo", 187),
        v("frac14", 188),
        v("frac12", 189),
        v("frac34", 190),
        v("iquest", 191),
        v("Agrave", 192),
        v("Aacute", 193),
        v("Acirc", 194),
        v("Atilde", 195),
        v("Auml", 196),
        v("Aring", 197),
        v("AElig", 198),
        v("Ccedil", 199),
        v("Egrave", 200),
        v("Eacute", 201),
        v("Ecirc", 202),
        v("Euml", 203),
        v("Igrave", 204),
        v("Iacute", 205),
        v("Icirc", 206),
        v("Iuml", 207),
        v("ETH", 208),
        v("Ntilde", 209),
        v("Ograve", 210),
        v("Oacute", 211),
        v("Ocirc", 212),
        v("Otilde", 213),
        v("Ouml", 214),
        v("times", 215),
        v("Oslash", 216),
        v("Ugrave", 217),
        v("Uacute", 218),
        v("Ucirc", 219),
        v("Uuml", 220),
        v("Yacute", 221),
        v("THORN", 222),
        v("szlig", 223),
        v("agrave", 224),
        v("aacute", 225),
        v("acirc", 226),
        v("atilde", 227),
        v("auml", 228),
        v("aring", 229),
        v("aelig", 230),
        v("ccedil", 231),
        v("egrave", 232),
        v("eacute", 233),
        v("ecirc", 234),
        v("euml", 235),
        v("igrave", 236),
        v("iacute", 237),
        v("icirc", 238),
        v("iuml", 239),
        v("eth", 240),
        v("ntilde", 241),
        v("ograve", 242),
        v("oacute", 243),
        v("ocirc", 244),
        v("otilde", 245),
        v("ouml", 246),
        v("divide", 247),
        v("oslash", 248),
        v("ugrave", 249),
        v("uacute", 250),
        v("ucirc", 251),
        v("uuml", 252),
        v("yacute", 253),
        v("thorn", 254),
        v("yuml", 255),
        v("OElig", 338),
        v("oelig", 339),
        v("Scaron", 352),
        v("scaron", 353),
        v("Yuml", 376),
        v("fnof", 402),
        v("circ", 710),
        v("tilde", 732),
        v("Alpha", 913),
        v("Beta", 914),
        v("Gamma", 915),
        v("Delta", 916),
        v("Epsilon", 917),
        v("Zeta", 918),
        v("Eta", 919),
        v("Theta", 920),
        v("Iota", 921),
        v("Kappa", 922),
        v("Lambda", 923),
        v("Mu", 924),
        v("Nu", 925),
        v("Xi", 926),
        v("Omicron", 927),
        v("Pi", 928),
        v("Rho", 929),
        v("Sigma", 931),
        v("Tau", 932),
        v("Upsilon", 933),
        v("Phi", 934),
        v("Chi", 935),
        v("Psi", 936),
        v("Omega", 937),
        v("alpha", 945),
        v("beta", 946),
        v("gamma", 947),
        v("delta", 948),
        v("epsilon", 949),
        v("zeta", 950),
        v("eta", 951),
        v("theta", 952),
        v("iota", 953),
        v("kappa", 954),
        v("lambda", 955),
        v("mu", 956),
        v("nu", 957),
        v("xi", 958),
        v("omicron", 959),
        v("pi", 960),
        v("rho", 961),
        v("sigmaf", 962),
        v("sigma", 963),
        v("tau", 964),
        v("upsilon", 965),
        v("phi", 966),
        v("chi", 967),
        v("psi", 968),
        v("omega", 969),
        v("thetasym", 977),
        v("upsih", 978),
        v("piv", 982),
        v("ensp", 8194),
        v("emsp", 8195),
        v("thinsp", 8201),
        v("zwnj", 8204),
        v("zwj", 8205),
        v("lrm", 8206),
        v("rlm", 8207),
        v("ndash", 8211),
        v("mdash", 8212),
        v("lsquo", 8216),
        v("rsquo", 8217),
        v("sbquo", 8218),
        v("ldquo", 8220),
        v("rdquo", 8221),
        v("bdquo", 8222),
        v("dagger", 8224),
        v("Dagger", 8225),
        v("bull", 8226),
        v("hellip", 8230),
        v("permil", 8240),
        v("prime", 8242),
        v("Prime", 8243),
        v("lsaquo", 8249),
        v("rsaquo", 8250),
        v("oline", 8254),
        v("frasl", 8260),
        v("euro", 8364),
        v("image", 8465),
        v("weierp", 8472),
        v("real", 8476),
        v("trade", 8482),
        v("alefsym", 8501),
        v("larr", 8592),
        v("uarr", 8593),
        v("rarr", 8594),
        v("darr", 8595),
        v("harr", 8596),
        v("crarr", 8629),
        v("lArr", 8656),
        v("uArr", 8657),
        v("rArr", 8658),
        v("dArr", 8659),
        v("hArr", 8660),
        v("forall", 8704),
        v("part", 8706),
        v("exist", 8707),
        v("empty", 8709),
        v("nabla", 8711),
        v("isin", 8712),
        v("notin", 8713),
        v("ni", 8715),
        v("prod", 8719),
        v("sum", 8721),
        v("minus", 8722),
        v("lowast", 8727),
        v("radic", 8730),
        v("prop", 8733),
        v("infin", 8734),
        v("ang", 8736),
        v("and", 8743),
        v("or", 8744),
        v("cap", 8745),
        v("cup", 8746),
        v("int", 8747),
        v("there4", 8756),
        v("sim", 8764),
        v("cong", 8773),
        v("asymp", 8776),
        v("ne", 8800),
        v("equiv", 8801),
        v("le", 8804),
        v("ge", 8805),
        v("sub", 8834),
        v("sup", 8835),
        v("nsub", 8836),
        v("sube", 8838),
        v("supe", 8839),
        v("oplus", 8853),
        v("otimes", 8855),
        v("perp", 8869),
        v("sdot", 8901),
        v("lceil", 8968),
        v("rceil", 8969),
        v("lfloor", 8970),
        v("rfloor", 8971),
        v("lang", 9001),
        v("rang", 9002),
        v("loz", 9674),
        v("spades", 9824),
        v("clubs", 9827),
        v("hearts", 9829),
        v("diams", 9830)
    ])), CU = A2(_k, EU, function(n) {
        var e = n.oJ;
        if (e.b && !e.a.$) {
            var r = A2(ra, e.a.a, AU);
            return r.$ ? n.ee : Jc(Rd(r.a));
        }
        return n.ee;
    }), PU = A2(_k, A2(_c, Ss, Ts("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])")), function(n) {
        var e = n.oJ;
        if (e.b && !e.a.$ && e.b.b && !e.b.a.$) {
            var r = e.b.a.a;
            return k(A2(Xc, iu(e.a.a) / 2 | 0, "\\"), r);
        }
        return n.ee;
    }), TU = A2(_k, A2(_c, Ss, Ts("&#[Xx]([0-9a-fA-F]{1,8});")), function(n) {
        var e, r = n.oJ;
        return r.b && !r.a.$ ? yU((e = r.a.a, A3(Nd, F2(function(n, e) {
            return 16 * e + A2(Uc, 39, mt(n)) - 9;
        }), 0, Os(e)))) : n.ee;
    }), SU = function(n) {
        var e = PU(n);
        return A2(au, "&", e) ? TU(jU(CU(e))) : e;
    }, IU = function(n) {
        return {
            s: 0,
            T: w,
            w: 0,
            z: SU(n),
            av: 0,
            X: 0,
            G: kU
        };
    }, OU = F3(function(n, e, r) {
        var t = e, u = {
            s: t.s,
            T: A3(qU, t.z, w, t.T),
            w: t.w,
            z: t.z,
            av: t.av,
            X: t.X,
            G: t.G
        };
        if (r.b) {
            var a = r.a;
            return a.G.$ ? s(t.s, a.w) ? A2(Ur, u, r) : 0 > m(t.s, a.w) ? A2(Ur, u, A2(Ur, IU(A3(cu, t.s, a.w, n)), r)) : r : A2(Ur, u, r);
        }
        var i = A2(ou, t.s, n);
        return su(i) ? E([
            u
        ]) : E([
            u,
            IU(i)
        ]);
    }), qU = F3(function(n, e, r) {
        for(;;){
            if (!r.b) {
                if (e.b) {
                    var t = e.a;
                    return t.w > 0 ? A2(Ur, IU(A2(lu, t.w, n)), e) : e;
                }
                return su(n) ? w : E([
                    IU(n)
                ]);
            }
            var u = r.b, a = n, i = A3(OU, n, r.a, e);
            n = a, e = i, r = u;
        }
    }), LU = F3(function(n, e, r) {
        n: for(;;){
            if (!e.b) return w;
            var t = e.a, u = e.b;
            if (n.b) {
                var a = n.a, i = n.b;
                if (0 > m(a.mk, t.mk)) {
                    if (r) {
                        n = i, r += 1;
                        continue n;
                    }
                    return A2(Ur, a, A3(LU, i, e, r + 1));
                }
                if (r > 1) {
                    e = u, r -= 1;
                    continue n;
                }
                if (1 === r) return A2(Ur, t, A3(LU, n, u, r - 1));
                e = u, r = 0;
            } else if (r > 1) e = u, r -= 1;
            else {
                if (1 === r) return A2(Ur, t, A3(LU, n, u, r - 1));
                e = u, r = 0;
            }
        }
    }), MU = A2(_c, Ss, Ts("(\\\\*)(\\<)")), _U = {
        $: 4
    }, RU = function(n) {
        var e = n.oJ;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = A2(_c, 0, A2(Lc, iu, e.a));
            return KH(r) ? Rr({
                mk: n.mk + r,
                gG: 1,
                n: _U
            }) : Hr;
        }
        return Hr;
    }, HU = A2(_c, Ss, Ts("(\\\\*)(\\>)")), UU = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zU = function(n) {
        var e = n.oJ;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = A2(_c, 0, A2(Lc, iu, e.a));
            return Rr({
                mk: n.mk + r,
                gG: 1,
                n: KH(r) ? UU(1) : UU(0)
            });
        }
        return Hr;
    }, DU = A2(_c, Ss, Ts("(\\\\*)([^*])?(\\*+)([^*])?")), NU = F2(function(n, e) {
        return {
            $: 7,
            a: n,
            b: e
        };
    }), FU = A2(Nd, F2(function(n, e) {
        return e || function(n) {
            switch(n){
                case "!":
                case '"':
                case "#":
                case "%":
                case "&":
                case "'":
                case "(":
                case ")":
                case "*":
                case ",":
                case "-":
                case ".":
                case "/":
                case ":":
                case ";":
                case "?":
                case "@":
                case "[":
                case "]":
                case "_":
                case "{":
                case "}":
                case "~":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), KU = A2(Nd, F2(function(n, e) {
        return e || function(n) {
            switch(n){
                case " ":
                case "\f":
                case "\n":
                case "\r":
                case "\t":
                case "\v":
                case "\xa0":
                case "\u2028":
                case "\u2029":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), GU = function(n) {
        if (n.$) return 0;
        var e = n.a;
        return su(e) || KU(e) ? 0 : FU(e) ? 1 : 2;
    }, WU = F3(function(n, e, r) {
        var t = r.oJ;
        if (t.b && t.b.b && t.b.b.b && !t.b.b.a.$ && t.b.b.b.b) {
            var u = t.a, a = t.b, i = a.a, c = a.b, o = c.a.a, f = GU(c.b.a), s = i.$ ? 0 : iu(i.a), l = r.mk && !s ? Rr(A3(cu, r.mk - 1, r.mk, e)) : i, d = u.$ ? 0 : iu(u.a), b = !KH(d) && !s || !l.$ && "\\" === l.a, m = b ? iu(o) - 1 : iu(o), p = b ? 1 : GU(l);
            return 0 >= m || "_" === n && 2 === p && 2 === f ? Hr : Rr({
                mk: r.mk + d + s + (b ? 1 : 0),
                gG: m,
                n: A2(NU, n, {
                    fj: p,
                    fD: f
                })
            });
        }
        return Hr;
    }), VU = A2(_c, Ss, Ts("(\\\\*)(\\`+)")), JU = function(n) {
        return {
            $: 0,
            a: n
        };
    }, BU = function(n) {
        var e = n.oJ;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = e.b.a.a, t = A2(_c, 0, A2(Lc, iu, e.a));
            return Rr({
                mk: n.mk + t,
                gG: iu(r),
                n: KH(t) ? JU(1) : JU(0)
            });
        }
        return Hr;
    }, XU = A2(_c, Ss, Ts("(?:(\\\\+)|( {2,}))\\n")), QU = {
        $: 8
    }, ZU = function(n) {
        var e = n.oJ;
        n: for(;;){
            if (e.b) {
                if (e.a.$) {
                    if (e.b.b && !e.b.a.$) return Rr({
                        mk: n.mk,
                        gG: iu(n.ee),
                        n: QU
                    });
                    break n;
                }
                var r = iu(e.a.a);
                return KH(r) ? Hr : Rr({
                    mk: n.mk + r - 1,
                    gG: 2,
                    n: QU
                });
            }
            break n;
        }
        return Hr;
    }, YU = (Ts("(?:(\\\\+)|( *))\\n"), A2(_c, Ss, Ts("(\\\\*)(\\])"))), nz = {
        $: 3
    }, ez = function(n) {
        var e = n.oJ;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = A2(_c, 0, A2(Lc, iu, e.a));
            return KH(r) ? Rr({
                mk: n.mk + r,
                gG: 1,
                n: nz
            }) : Hr;
        }
        return Hr;
    }, rz = A2(_c, Ss, Ts("(\\\\*)(\\!)?(\\[)")), tz = {
        $: 2
    }, uz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, az = function(n) {
        var e = n.oJ;
        if (e.b && e.b.b && e.b.b.b && !e.b.b.a.$) {
            var r = e.b.a, t = A2(_c, 0, A2(Lc, iu, e.a)), u = !KH(t), a = u ? n.mk + t + 1 : n.mk + t;
            return u ? r.$ ? Hr : Rr({
                mk: a,
                gG: 1,
                n: uz(0)
            }) : Rr(r.$ ? {
                mk: a,
                gG: 1,
                n: uz(0)
            } : {
                mk: a,
                gG: 2,
                n: tz
            });
        }
        return Hr;
    }, iz = function(n) {
        return {
            $: 9,
            a: n
        };
    }, cz = function(n) {
        var e = n.oJ;
        if (e.b && e.b.b && !e.b.a.$) {
            var r = e.b.a.a, t = A2(_c, 0, A2(Lc, iu, e.a)), u = KH(t) ? v(iu(r), iz(1)) : v(iu(r), iz(0));
            return Rr({
                mk: n.mk + t,
                gG: u.a,
                n: u.b
            });
        }
        return Hr;
    }, oz = A2(_c, Ss, Ts("(\\\\*)(~{2,})([^~])?")), fz = A2(_c, Ss, Ts("(\\\\*)([^_])?(\\_+)([^_])?")), sz = F2(function(n, e) {
        if (n.b) {
            var r = n.a, t = n.b;
            if (e.b) {
                var u = e.a, a = e.b;
                return 0 > m(r.mk, u.mk) ? A2(Ur, r, A2(sz, t, e)) : A2(Ur, u, A2(sz, n, a));
            }
            return n;
        }
        return e;
    }), lz = {
        $: 2
    }, dz = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bz = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pz = {
        $: 8
    }, vz = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gz = A2(_c, Ss, Ts("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)")), hz = function(n) {
        return encodeURIComponent(n);
    }, $z = A2(Fu, hz, A2(_k, gz, function(n) {
        return A2(_c, n.ee, cd(n.ee));
    })), xz = A2(_c, Ss, Ts("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$")), kz = vr, wz = A2(_c, Ss, Ts("^\\[\\s*([^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*)\\s*\\]")), yz = function(n) {
        return n;
    }, jz = A2(Fu, yz, Os), Ez = F2(function(n, e) {
        return v($z(SU(n)), A2(Lc, SU, e));
    }), Az = F3(function(n, e, r) {
        var t, u = su(t = A2(_c, n.z, A2(_c, Hr, A2(Qa, A2(Fu, function(n) {
            return n.oJ;
        }, ys), r)))) ? n.z : t, a = A2(ra, jz(u), e);
        if (1 === a.$) return Hr;
        var i = a.a, c = i.a, o = i.b, f = 5 === n.G.$ ? bz(A2(Ez, c, o)) : mz(A2(Ez, c, o)), s = r.$ ? 0 : iu(r.a.ee);
        return Rr($(n, {
            s: n.s + s,
            G: f
        }));
    }), Cz = F3(function(n, e, r) {
        return A3(Az, e, r, ys(A3(kz, 1, wz, n)));
    }), Pz = " \\t\\f\\v\\r\\n", Tz = A2(_c, Ss, Ts("^\\(\\s*(?:<([^<>\\f\\v\\r\\n]*)>|([^" + Pz + "\\(\\)\\\\]*(?:\\\\.[^" + Pz + "\\(\\)\\\\]*)*))(?:[" + Pz + "]+(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?\\s*\\)")), Sz = function(n) {
        var e = F2(function(n, e) {
            return e.$ ? n : Rr(e.a);
        });
        return A3(ot, e, Hr, n);
    }, Iz = F2(function(n, e) {
        var r, t = e.oJ;
        if (t.b && t.b.b && t.b.b.b && t.b.b.b.b && t.b.b.b.b.b) {
            var u = t.a, a = t.b, i = a.a, c = a.b, o = c.b, f = Sz(E([
                c.a,
                o.a,
                o.b.a
            ])), s = Sz(E([
                u,
                i
            ]));
            return Rr((r = A2(_c, "", s), $(n, {
                s: n.s + iu(e.ee),
                G: (5 === n.G.$ ? bz : mz)(A2(Ez, r, f))
            })));
        }
        return Hr;
    }), Oz = F3(function(n, e, r) {
        var t = e, u = A3(kz, 1, Tz, n);
        if (u.b) {
            var a = A2(Iz, t, u.a);
            return a.$ ? A3(Cz, n, t, r) : Rr(a.a);
        }
        return A3(Cz, n, t, r);
    }), qz = F2(function(n, e) {
        var r = n, t = ks(function(n) {
            var e = n;
            return m(r.s, e.w) > 0 && 0 > m(r.s, e.s);
        });
        return lf(e) || lf(t(e)) ? Rr(A2(Ur, r, e)) : Hr;
    }), Lz = A2(_c, Ss, Ts("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$")), Mz = function(n) {
        var e = n;
        return A2(Cs, Lz, e.z) ? Zr($(e, {
            G: vz(v(e.z, "mailto:" + $z(e.z)))
        })) : Jr(e);
    }, _z = F3(function(n, e, r) {
        for(;;){
            if (!r.b) return Hr;
            var t = r.a, u = r.b;
            if (e(t)) return Rr(g(t, xt(n), u));
            n = A2(Ur, t, n), r = u;
        }
    }), Rz = F2(function(n, e) {
        return A3(_z, w, n, e);
    }), Hz = F2(function(n, e) {
        return {
            $: 6,
            a: n,
            b: e
        };
    }), Uz = function(n) {
        return A3(Dp, !1, n.h, n);
    }, zz = F2(function(n, e) {
        var r = e, t = A2(mv, A2(mv, A2(mv, cv(F3(function(n, e, r) {
            return {
                iK: e,
                gG: r - n
            };
        })), Uz), _H), Uz), u = A2(Bv, t, A2(ou, r.w, n));
        return u.$ ? Hr : Rr({
            mk: r.w,
            gG: u.a.gG,
            n: A2(Hz, 0, u.a.iK)
        });
    }), Dz = F2(function(n, e) {
        return e.$ ? n(e.a) : e;
    }), Nz = F2(function(n, e) {
        var r = e.n;
        return !r.$ && s(r.a ? e.gG : e.gG - 1, n.gG);
    }), Fz = function(n) {
        switch(n.n.$){
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, Kz = F2(function(n, e) {
        var r = e.n;
        if (7 === r.$) {
            var t = r.b, u = n.n;
            if (7 === u.$) {
                var a = u.b;
                return !(!s(r.a, u.a) || (s(t.fj, t.fD) || s(a.fj, a.fD)) && !A2(Uc, 3, n.gG + e.gG) && (A2(Uc, 3, n.gG) || A2(Uc, 3, e.gG)));
            }
            return !1;
        }
        return !1;
    }), Gz = F2(function(n, e) {
        var r, t, u = 9 === (t = e.n).$ ? v(!0, t.a ? e.gG : e.gG - 1) : v(!1, 0), a = u.a, i = u.b, c = 9 === (r = n.n).$ ? v(!0, r.a ? n.gG : n.gG - 1) : v(!1, 0);
        return c.a && a && s(c.b, i);
    }), Wz = {
        $: 1
    }, Vz = F2(function(n, e) {
        return {
            s: n.mk + n.gG,
            T: w,
            w: n.mk,
            z: "",
            av: 0,
            X: 0,
            G: e
        };
    }), Jz = F2(function(n, e) {
        for(;;){
            if (!n.b) return e;
            var r = n.a, t = n.b;
            8 !== r.n.$ ? n = t : (n = t, e = A2(Ur, A2(Vz, r, Wz), e));
        }
    }), Bz = F2(function(n, e) {
        var r = n;
        return A2(ks, function(n) {
            return m(n.mk, r.s) > -1;
        }, e);
    }), Xz = F6(function(n, e, r, t, u, a) {
        var i, c = a.c, o = A2(Dz, Mz, A2(Cs, xz, (i = A7(iD, t, u, function(n) {
            return n;
        }, lz, a.a, n, w)).z) ? Zr($(i, {
            G: vz(v(i.z, $z(i.z)))
        })) : Jr(i));
        if (1 === o.$) {
            if (1 === e) {
                var f = A2(zz, u, o.a);
                return f.$ ? Hr : Rr(v(A2(Ur, f.a, c), r));
            }
            return Hr;
        }
        return Rr(v(c, A2(Ur, o.a, r)));
    }), Qz = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A5(eD, xt(e), w, r, t, u);
            var a = n.a, i = n.b, c = a.n;
            switch(c.$){
                case 0:
                    var o = A2(Rz, Nz(a), e);
                    if (o.$) {
                        n = i, e = A2(Ur, a, e);
                        continue n;
                    }
                    var f = A5(Zz, a, r, t, u, o.a);
                    n = i, e = p = f.a, r = v = f.b;
                    continue n;
                case 5:
                    var s = c.a, l = function(n) {
                        return 4 === n.n.$;
                    }, d = A2(Rz, l, e);
                    if (d.$) {
                        n = i, e = A2(ks, A2(cc, ul, l), e);
                        continue n;
                    }
                    var b = A6(Xz, a, s, r, t, u, d.a);
                    if (b.$) {
                        n = i, e = A2(ks, A2(cc, ul, l), e);
                        continue n;
                    }
                    var m = b.a, p = m.a, v = m.b;
                    n = i, e = A2(ks, A2(cc, ul, l), p), r = v;
                    continue n;
                default:
                    n = i, e = A2(Ur, a, e);
                    continue n;
            }
        }
    }), Zz = F5(function(n, e, r, t, u) {
        var a, i = u.a, c = u.c, o = (a = i.n).$ || a.a ? i : $(i, {
            mk: i.mk + 1,
            gG: i.gG - 1
        });
        return v(c, A2(Ur, A7(iD, r, t, yz, lz, o, n, w), e));
    }), Yz = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A5(uD, xt(e), w, r, t, u);
            var a = n.a, i = n.b, c = a.n;
            if (7 !== c.$) n = i, e = A2(Ur, a, e);
            else {
                var o = c.a, f = c.b.fj, l = c.b.fD;
                if (s(f, l)) {
                    if (!l || "_" === o && 1 !== l) {
                        n = i;
                        continue n;
                    }
                    var d = A2(Rz, Kz(a), e);
                    if (d.$) {
                        n = i, e = A2(Ur, a, e);
                        continue n;
                    }
                    var b = A5(nD, t, u, a, i, d.a);
                    n = b.a, e = b.c, r = A2(Ur, b.b, r);
                    continue n;
                }
                if (0 > m(f, l)) {
                    n = i, e = A2(Ur, a, e);
                    continue n;
                }
                var p = A2(Rz, Kz(a), e);
                if (p.$) {
                    n = i;
                    continue n;
                }
                var v = A5(nD, t, u, a, i, p.a);
                n = v.a, e = v.c, r = A2(Ur, v.b, r);
            }
        }
    }), nD = F5(function(n, e, r, t, u) {
        var a = u.a, i = u.b, c = u.c, o = a.gG - r.gG, f = o ? o > 0 ? {
            e_: r,
            ep: $(a, {
                mk: a.mk + o,
                gG: r.gG
            }),
            fz: A2(Ur, $(a, {
                gG: o
            }), c),
            fS: t
        } : {
            e_: $(r, {
                gG: a.gG
            }),
            ep: a,
            fz: c,
            fS: A2(Ur, $(r, {
                mk: r.mk + a.gG,
                gG: -o
            }), t)
        } : {
            e_: r,
            ep: a,
            fz: c,
            fS: t
        }, s = A7(iD, n, e, function(n) {
            return n;
        }, function(n) {
            return {
                $: 7,
                a: n
            };
        }(f.ep.gG), f.ep, f.e_, xt(i));
        return g(f.fS, s, f.fz);
    }), eD = F5(function(n, e, r, t, u) {
        for(;;){
            if (!n.b) return A5(rD, xt(e), w, r, t, u);
            var a = n.a, i = n.b, c = a.n;
            6 !== c.$ ? (n = i, e = A2(Ur, a, e)) : (n = i, r = A2(Ur, A2(Vz, a, dz(c.b)), r));
        }
    }), rD = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A5(Yz, xt(e), w, r, t, u);
            var a = n.a, i = n.b;
            if (3 !== a.n.$) n = i, e = A2(Ur, a, e);
            else {
                var c = A2(Rz, Fz, e);
                if (c.$) {
                    n = i;
                    continue n;
                }
                var o = A6(tD, a, i, r, t, u, c.a);
                if (o.$) {
                    n = i;
                    continue n;
                }
                var f = o.a;
                n = f.a, e = f.c, r = f.b;
            }
        }
    }), tD = F6(function(n, e, r, t, u, a) {
        var i = a.a, c = a.b, o = a.c, f = g(e, r, k(c, o)), s = A2(ou, n.mk + 1, u), l = function(n) {
            return 1 === n.n.$ ? $(n, {
                n: uz(1)
            }) : n;
        }, d = function(e) {
            return A7(iD, t, u, function(n) {
                return n;
            }, e ? mz(v("", Hr)) : bz(v("", Hr)), i, n, xt(c));
        }, b = i.n;
        switch(b.$){
            case 2:
                var m = d(!1), p = A3(Oz, s, m, t);
                if (1 === p.$) return Rr(f);
                var h = A2(qz, y = p.a, r);
                if (h.$) return Rr(f);
                var x = h.a;
                return Rr(g(A2(Bz, y, e), x, o));
            case 1:
                if (b.a) return Rr(f);
                m = d(!0);
                var w = A3(Oz, s, m, t);
                if (1 === w.$) return Rr(f);
                var y, j = A2(qz, y = w.a, r);
                return j.$ ? Rr(f) : (x = j.a, Rr(g(A2(Bz, y, e), x, A2(ju, l, o))));
            default:
                return Hr;
        }
    }), uD = F5(function(n, e, r, t, u) {
        n: for(;;){
            if (!n.b) return A2(Jz, xt(e), r);
            var a = n.a, i = n.b;
            if (9 !== a.n.$) n = i, e = A2(Ur, a, e);
            else {
                var c = A2(Rz, Gz(a), e);
                if (c.$) {
                    n = i, e = A2(Ur, a, e);
                    continue n;
                }
                var o = A5(aD, a, r, t, u, c.a);
                n = i, e = o.a, r = o.b;
            }
        }
    }), aD = F5(function(n, e, r, t, u) {
        var a, i = u.a, c = u.c, o = 9 !== (a = i.n).$ || a.a ? i : $(i, {
            mk: i.mk + 1,
            gG: i.gG - 1
        });
        return v(c, A2(Ur, A7(iD, r, t, yz, pz, o, n, w), e));
    }), iD = F7(function(n, e, r, t, u, a, i) {
        var c = u.mk + u.gG, o = a.mk, f = r(A3(cu, c, o, e)), s = u.mk, l = a.mk + a.gG, d = {
            s: l,
            T: w,
            w: s,
            z: f,
            av: o,
            X: c,
            G: t
        };
        return {
            s: l,
            T: A2(ju, function(n) {
                return A2(vU, d, n);
            }, A4(cD, i, w, n, e)),
            w: s,
            z: f,
            av: o,
            X: c,
            G: t
        };
    }), cD = F4(function(n, e, r, t) {
        return A5(Qz, n, w, e, r, t);
    }), oD = F2(function(n, e) {
        var r = pf(e), t = function(n) {
            var e;
            return A2(sz, A3(LU, A2(IE, function(n) {
                return n.mk;
            }, A2(La, RU, A2(vp, MU, n))), A2(IE, function(n) {
                return n.mk;
            }, A2(La, zU, A2(vp, HU, n))), 0), A2(sz, (e = n, A2(La, ZU, A2(vp, XU, e))), A2(sz, function(n) {
                return A2(La, ez, A2(vp, YU, n));
            }(n), A2(sz, function(n) {
                return A2(La, az, A2(vp, rz, n));
            }(n), A2(sz, function(n) {
                return A2(La, cz, A2(vp, oz, n));
            }(n), A2(sz, function(n) {
                return A2(La, A2(WU, "_", n), A2(vp, fz, n));
            }(n), A2(sz, function(n) {
                return A2(La, A2(WU, "*", n), A2(vp, DU, n));
            }(n), function(n) {
                return A2(La, BU, A2(vp, VU, n));
            }(n))))))));
        }(r);
        return pU(A3(qU, r, w, $U(A4(cD, t, w, n, r))));
    }), fD = hv(E([
        _v(A2(Lv, " ", iR(" "))),
        _v(A2(Lv, ">", iR(">"))),
        A2(dv, A2(dv, A2(yv, gt, iR("Alpha")), Yp(function(n) {
            return $t(n) || "-" === n;
        })), hv(E([
            _v(A2(Lv, ":", iR(":"))),
            _v(A2(Lv, "@", iR("@"))),
            _v(A2(Lv, "\\", iR("\\"))),
            _v(A2(Lv, "+", iR("+"))),
            _v(A2(Lv, ".", iR(".")))
        ])))
    ])), sD = RR(A2(ev, F2(function(n) {
        return xR(n);
    }), A2(dv, A2(dv, A2(dv, _v(A2(Lv, "<", iR("<"))), fD), WR), JR))), lD = function(n) {
        return _v(A2(Lv, n, iR(n)));
    }, dD = function(n) {
        var e = n.a, r = n.b, t = A2(_c, Pv(r), A2(Lc, function(n) {
            return Pv(A2(Ur, n, r));
        }, e)), u = A2(_c, Tv(v(Hr, r)), A2(Lc, function(n) {
            return Tv(v(Hr, A2(Ur, n, r)));
        }, e)), a = function(n) {
            return Tv(v(Rr(function(n) {
                return k(A2(_c, "", e), n);
            }(n)), r));
        };
        return hv(E([
            A2(Av, function() {
                return t;
            }, lD("|\n")),
            A2(Av, function() {
                return t;
            }, lD("\n")),
            A2(Av, function() {
                return t;
            }, Bp(iR("end"))),
            A2(dv, RR(cv(a("|"))), lD("\\\\|")),
            A2(dv, RR(cv(a("\\"))), lD("\\\\")),
            A2(dv, RR(cv(a("|"))), lD("\\|")),
            A2(dv, RR(cv(u)), lD("|")),
            A2(ev, F2(function(n) {
                return a(n);
            }), A2(yv, Bi(!0), uv("No character found")))
        ]));
    }, bD = A2(Av, A2(ot, F2(function(n, e) {
        return A2(Ur, pf(n), e);
    }), w), A2(Ev, v(Hr, w), dD)), mD = A2(mv, A2(dv, cv(ru), hv(E([
        lD("|"),
        cv(0)
    ]))), bD), pD = F2(function(n, e) {
        var r, t = n.b, u = A2(Bv, mD, e);
        return u.$ ? Jr("Unable to parse previous line as a table header") : s(ft(r = u.a), ft(t)) ? Zr(function(n) {
            return A3(st, F2(function(n, e) {
                return {
                    eV: e,
                    ai: n
                };
            }), n, t);
        }(r)) : Jr("Tables must have the same number of header columns (" + ut(ft(r)) + ") as delimiter columns (" + ut(ft(t)) + ")");
    }), vD = F2(function(n, e) {
        return {
            kK: e,
            mD: n
        };
    }), gD = {
        eY: "`",
        gF: 0,
        fR: A2(Lv, "`", iR("a '`'"))
    }, hD = function(n) {
        switch(n){
            case 1:
                return cv(0);
            case 2:
                return cv(1);
            case 3:
                return cv(2);
            case 4:
                return cv(3);
            default:
                return av(iR("Fenced code blocks should be indented no more than 3 spaces"));
        }
    }, $D = F2(function(n, e) {
        var r = A3(ot, F2(function(n, e) {
            return A2(dv, e, n);
        }), cv(0), A2(J$, n, _v(e.fR)));
        return A2(ev, F2(function(n) {
            return v(e, iu(n));
        }), A2(dv, r, Yp(Rt(e.eY))));
    }), xD = {
        eY: "~",
        gF: 1,
        fR: A2(Lv, "~", iR("a `~`"))
    }, kD = hv(E([
        A2(dv, A2(dv, iU, hv(E([
            iU,
            cv(0)
        ]))), hv(E([
            iU,
            cv(0)
        ]))),
        cv(0)
    ])), wD = A2(mv, A2(mv, A2(dv, cv(F2(function(n, e) {
        return {
            eZ: e.a,
            gC: n,
            gG: e.b
        };
    })), kD), A2(Np, hD, QH)), hv(E([
        A2($D, 3, gD),
        A2($D, 3, xD)
    ]))), yD = Rt(" "), jD = F2(function(n, e) {
        return A2(dv, A2(dv, A2(dv, A2(dv, cv(0), kD), A2($D, n, e)), Yp(yD)), JR);
    }), ED = function(n) {
        return A3(Dp, !1, n.hb, n);
    }, AD = function(n) {
        var e, r = n.a, t = n.b;
        return hv(E([
            A2(dv, cv(Pv(t)), Bp(Kp)),
            A2(ev, F2(function(n) {
                return Tv(v(r, k(t, n)));
            }), DR),
            RR(A2(dv, cv(Pv(t)), A2(jD, r.gG, r.eZ))),
            A2(mv, A2(mv, A2(mv, cv(F3(function(n, e, u) {
                return Tv(v(r, k(t, A3(cu, n, e, u))));
            })), (e = r.gC, A2(mv, A2(dv, cv(ru), A2(cU, e, iU)), A2(dv, A2(dv, Uz, WR), JR)))), Uz), ED)
        ]));
    }, CD = A2(Np, function(n) {
        var e;
        return A2(mv, A2(mv, cv(vD), A2(dv, (e = n.eZ, A2(ev, F2(function(n) {
            var e = pf(n);
            return "" === e ? Hr : Rr(e);
        }), Yp(e.gF ? A2(cc, ul, GR) : function(n) {
            return "`" !== n && !GR(n);
        }))), JR)), function(n) {
            return A2(Ev, v(n, ""), AD);
        }(n));
    }, wD), PD = A2(Lv, "#", iR("a `#`")), TD = Yp(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), SD = A2(mv, A2(mv, A2(dv, A2(dv, cv(fR), A2(Np, function(n) {
        var e = iu(n);
        return 4 > e ? cv(e) : av(iR("heading with < 4 spaces in front"));
    }, rv(TD))), Rv(PD)), A2(Np, function(n) {
        var e = iu(n) + 1;
        return 7 > e ? cv(e) : av(iR("heading with < 7 #'s"));
    }, rv(Yp(function(n) {
        return "#" === n;
    })))), hv(E([
        A2(dv, cv(""), Rv(zR)),
        A2(mv, A2(dv, cv(ru), hv(E([
            Rv(FR),
            Rv(DH)
        ]))), A2(ev, F2(function(n) {
            var e, r;
            return e = pf(n), r = function(n) {
                for(;;){
                    if (!A2(Gd, "#", n)) return n;
                    n = A2(Kd, 1, n);
                }
            }(e), A2(Gd, " ", r) || su(r) ? r.replace(/\s+$/, "") : e;
        }), WR))
    ]))), ID = wr, OD = F4(function(n, e, r, t) {
        return A2(Gp, Vp, A4(Wp, n, e, r, t));
    }), qD = function(n) {
        var e = n.a, r = n.b;
        return function(n) {
            var t = A5(ID, e, n.h, n.oe, n.h1, n.hb), u = t.a, a = t.b, i = t.c;
            return s(u, -1) ? A2(zp, !1, A4(OD, a, i, r, n.k_)) : A3(Dp, 0 > m(n.h, u), 0, {
                h1: i,
                k_: n.k_,
                v: n.v,
                h: u,
                oe: a,
                hb: n.hb
            });
        };
    }, LD = A2(Lv, ">", iR("a `>`")), MD = F3(function(n, e, r) {
        return {
            h1: e,
            k_: r,
            oe: n
        };
    }), _D = F2(function(n, e) {
        return {
            h1: e.h1,
            k_: n,
            v: e.v,
            h: e.h,
            oe: e.oe,
            hb: e.hb
        };
    }), RD = F2(function(n, e) {
        var r = e;
        return function(e) {
            var t = r(A2(_D, A2(Ur, A3(MD, e.oe, e.h1, n), e.k_), e));
            return t.$ ? t : A3(Dp, t.a, t.b, A2(_D, e.k_, t.c));
        };
    }), HD = function(n) {
        switch(n){
            case " ":
            case "\n":
            case "\t":
            case "\v":
            case "\f":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, UD = A2(Lv, "<", iR("a `<`")), zD = A2(RD, "link destination", hv(E([
        A2(mv, A2(dv, cv(hz), Rv(UD)), A2(dv, rv(qD(LD)), Rv(LD))),
        rv(YH(A2(cc, ul, HD)))
    ]))), DD = A2(Lv, "]", iR("a `]`")), ND = A2(Lv, "[", iR("a `[`")), FD = A2(mv, A2(dv, cv(jz), Rv(ND)), A2(dv, rv(qD(DD)), Rv(A2(Lv, "]:", iR("]:"))))), KD = A2(Lv, '"', iR("a double quote")), GD = function(n) {
        return A2(au, "\n\n", n) ? av(iR("no blank line")) : cv(n);
    }, WD = A2(dv, Yp(function(n) {
        return !GR(n) && HD(n);
    }), JR), VD = A2(dv, A2(yv, HD, iR("Required whitespace")), Yp(HD)), JD = A2(Lv, "'", iR("a single quote")), BD = (HH = A2(mv, A2(dv, cv(Rr), Rv(JD)), A2(dv, A2(dv, A2(Np, GD, rv(qD(JD))), Rv(JD)), WD)), UH = A2(mv, A2(dv, cv(Rr), Rv(KD)), A2(dv, A2(dv, A2(Np, GD, rv(qD(KD))), Rv(KD)), WD)), A2(RD, "title", hv(E([
        RR(A2(mv, A2(dv, cv(ru), VD), hv(E([
            UH,
            HH,
            cv(Hr)
        ])))),
        A2(dv, cv(Hr), WD)
    ])))), XD = A2(RD, "link reference definition", A2(mv, A2(mv, A2(mv, A2(dv, cv(F3(function(n, e, r) {
        return v(n, {
            lp: e,
            eC: r
        });
    })), kD), A2(dv, A2(dv, A2(dv, FD, Yp(HR)), hv(E([
        DR,
        cv(0)
    ]))), Yp(HR))), zD), BD)), QD = Yp(HR), ZD = function(n) {
        var e = lD(Jc(n));
        return A2(dv, A2(dv, A2(dv, A2(dv, A2(dv, A2(dv, A2(dv, cv(0), e), QD), e), QD), e), Yp(function(e) {
            return s(e, n) || HR(e);
        })), JR);
    }, YD = hv(E([
        ZD("-"),
        ZD("*"),
        ZD("_")
    ])), nN = hv(E([
        A2(mv, A2(dv, A2(dv, A2(dv, cv(ru), iU), hv(E([
            iU,
            cv(0)
        ]))), hv(E([
            iU,
            cv(0)
        ]))), YD),
        YD
    ])), eN = F2(function(n, e) {
        return {
            $: 13,
            a: n,
            b: e
        };
    }), rN = A2(Lv, "=", iR("a `=`")), tN = A2(Lv, "-", iR("a `-`")), uN = (zH = F3(function(n, e, r) {
        return A2(dv, A2(dv, cv(n), _v(e)), Yp(Rt(r)));
    }), A2(ev, F2(function(n, e) {
        return A2(eN, e, n);
    }), A2(mv, A2(dv, cv(ru), kD), A2(dv, A2(dv, hv(E([
        A3(zH, 0, rN, "="),
        A3(zH, 1, tN, "-")
    ])), Yp(HR)), JR)))), aN = function(n) {
        return {
            $: 9,
            a: n
        };
    }, iN = Yp(HR), cN = function(n) {
        return hv(E([
            A2(yv, n, uv("Character not found")),
            cv(0)
        ]));
    }, oN = function(n) {
        var e;
        return hv(E([
            RR(A2(Av, function() {
                return Pv(n);
            }, lD("|\n"))),
            A2(Av, function() {
                return Pv(n);
            }, lD("\n")),
            A2(Av, function() {
                return Pv(n);
            }, Bp(iR("end"))),
            RR(A2(dv, A2(dv, cv(Pv(n)), lD("|")), Bp(iR("end")))),
            A2(mv, A2(dv, A2(dv, cv(function(e) {
                return Tv(A2(Ur, e, n));
            }), (e = n, lf(e) ? hv(E([
                lD("|"),
                cv(0)
            ])) : lD("|"))), iN), A2(dv, rv(A2(dv, A2(dv, A2(dv, cv(0), cN(function(n) {
                return ":" === n;
            })), YH(function(n) {
                return "-" === n;
            })), cN(function(n) {
                return ":" === n;
            }))), iN))
        ]));
    }, fN = function(n) {
        var e = v(A2(gu, ":", n), A2(Gd, ":", n));
        return e.a ? Rr(e.b ? 2 : 0) : e.b ? Rr(1) : Hr;
    }, sN = A2(Av, aN, A2(Np, function(n) {
        var e = n.a.kg, r = n.b;
        return lf(r) ? av(iR("Must have at least one column in delimiter row.")) : 1 !== ft(r) || A2(gu, "|", e) && A2(Gd, "|", e) ? cv(n) : av(uv("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity."));
    }, A2(ev, F2(function(n, e) {
        return A2(IR, {
            jx: n,
            kg: pf(n)
        }, A2(ju, fN, xt(e)));
    }), A2(Ev, w, oN)))), lN = F2(function(n, e) {
        var r = ft(e);
        switch(A2(ea, n, r)){
            case 0:
                return A2(Kc, n, e);
            case 1:
                return e;
            default:
                return k(e, A2(J$, n - r, ""));
        }
    }), dN = function(n) {
        var e, r = n.a, t = n.b;
        return A2(Av, function(n) {
            return TR(A2(SR, r, k(t, E([
                n
            ]))));
        }, (e = ft(r), A2(Np, function(n) {
            return lf(n) || A2(Ah, su, n) ? av(uv("A line must have at least one column")) : cv(A2(lN, e, n));
        }, mD)));
    }, bN = {
        $: 2
    }, mN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pN = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), vN = F4(function(n, e, r, t) {
        var u = t.a, a = t.b, i = u - r;
        return i > 4 ? g(e, r - n + 1, function() {
            switch(a.$){
                case 0:
                    var n = a.b;
                    return A2(pN, a.a, k(A2(Xc, i - 1, " "), n));
                case 1:
                    return n = a.a, mN(k(A2(Xc, i - 1, " "), n));
                default:
                    return bN;
            }
        }()) : g(e, u - n, a);
    }), gN = A2(mv, cv(function(n) {
        return v(n, bN);
    }), A2(dv, QH, JR)), hN = hv(E([
        A2(dv, cv(1), Rv(A2(Lv, "[x] ", qv("[x] ")))),
        A2(dv, cv(1), Rv(A2(Lv, "[X] ", qv("[X] ")))),
        A2(dv, cv(0), Rv(A2(Lv, "[ ] ", qv("[ ] "))))
    ])), $N = A2(mv, hv(E([
        A2(mv, cv(pN), A2(dv, hN, Yp(HR))),
        cv(mN)
    ])), A2(dv, rv(WR), JR)), xN = A2(mv, A2(mv, A2(dv, cv(F2(function(n, e) {
        return v(n, e);
    })), YH(HR)), QH), $N), kN = hv(E([
        A2(dv, A2(dv, cv(0), A2(cU, 3, iU)), Rv(A2(Lv, "-", qv("-")))),
        A2(dv, cv(1), Rv(A2(Lv, "+", qv("+")))),
        A2(dv, cv(2), Rv(A2(Lv, "*", qv("*"))))
    ])), wN = function(n) {
        var e = F2(function(n, e) {
            switch(e.$){
                case 0:
                    return {
                        kK: e.b,
                        mU: n,
                        I: Rr(1 === e.a)
                    };
                case 1:
                    return {
                        kK: e.a,
                        mU: n,
                        I: Hr
                    };
                default:
                    return {
                        kK: "",
                        mU: n,
                        I: Hr
                    };
            }
        });
        return A2(Av, function(n) {
            return A4(MR, !0, n.b, w, A2(e, n.a, n.c));
        }, function(n) {
            return A2(mv, A2(mv, A2(mv, A2(mv, cv(vN), QH), RR(kN)), QH), n ? xN : hv(E([
                gN,
                xN
            ])));
        }(n));
    }, yN = F2(function(n, e) {
        switch(n.$){
            case 0:
                var r = n.a, t = n.b, u = TN(n.c);
                if (u.$) return Jr(u.a);
                var a = lR(A3(mR, r, t, u.a));
                return Zr(A2(Ur, a, e));
            case 1:
                var i = IN(n.a);
                return i.$ ? Jr(iR(A2(at, "\n", A2(ju, v_, i.a)))) : Zr(k(xt(i.a), e));
            case 2:
                return Zr(A2(Ur, lR(dR(n.a)), e));
            case 3:
                return Zr(A2(Ur, lR(nR(n.a)), e));
            case 4:
                return Zr(A2(Ur, lR(AR(n.a)), e));
            default:
                return Zr(A2(Ur, lR(A2(bR, n.a, n.b)), e));
        }
    }), jN = function(n) {
        var e = n.b;
        n: for(; e.b;)switch(e.a.$){
            case 11:
                var r = e.a.a, t = e.b, u = A2(Bv, DN(), r);
                return u.$ ? av(uv(XR(u.a))) : cv({
                    a: k(n.a, ($ = u.a).a),
                    b: A2(Ur, ER($.b), t)
                });
            case 3:
                var a = e.a, i = a.a, c = a.b, o = a.c, f = a.d, s = (t = e.b, A2(Bv, DN(), f.kK));
                if (s.$) return av(uv(XR(s.a)));
                var l = !A2(tl, Z_, ($ = s.a).b) && i;
                return cv({
                    a: k(n.a, $.a),
                    b: A2(Ur, A4(MR, l, c, A2(Ur, {
                        kK: $.b,
                        I: f.I
                    }, o), f), t)
                });
            case 4:
                var d = e.a, b = (i = d.a, c = d.b, d.c), m = d.d, p = (o = d.e, f = d.f, t = e.b, A2(Bv, DN(), f));
                return p.$ ? av(uv(XR(p.a))) : (l = !A2(tl, Z_, ($ = p.a).b) && i, cv({
                    a: k(n.a, $.a),
                    b: A2(Ur, A6(wR, l, c, b, m, A2(Ur, $.b, o), f), t)
                }));
            case 10:
                if (!e.b.b) break n;
                switch(e.b.a.$){
                    case 3:
                        var v = e.b, g = v.a, h = (i = g.a, c = g.b, o = g.c, f = g.d, t = v.b, A2(Bv, DN(), f.kK));
                        return h.$ ? av(uv(XR(h.a))) : (l = !A2(tl, Z_, ($ = h.a).b) && i, cv({
                            a: k(n.a, $.a),
                            b: A2(Ur, A4(MR, l, c, A2(Ur, {
                                kK: $.b,
                                I: f.I
                            }, o), f), t)
                        }));
                    case 4:
                        var $, x = e.b, w = x.a, y = (i = w.a, c = w.b, b = w.c, m = w.d, o = w.e, f = w.f, t = x.b, A2(Bv, DN(), f));
                        return y.$ ? av(uv(XR(y.a))) : (l = !A2(tl, Z_, ($ = y.a).b) && i, cv({
                            a: k(n.a, $.a),
                            b: A2(Ur, A6(wR, l, c, b, m, A2(Ur, $.b, o), f), t)
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return cv(n);
    }, EN = F2(function(n, e) {
        var r = v(e, n.b);
        n: for(; r.b.b;)switch(r.b.a.$){
            case 5:
                if (5 === r.a.$) {
                    var t = r.b, u = t.b;
                    return cv({
                        a: n.a,
                        b: A2(Ur, rR({
                            kK: A2(VH, t.a.a.kK, r.a.a.kK),
                            mD: Hr
                        }), u)
                    });
                }
                break n;
            case 6:
                switch(r.a.$){
                    case 6:
                        var a = r.b;
                        return u = a.b, cv({
                            a: n.a,
                            b: A2(Ur, vR(A2(VH, a.a.a, r.a.a)), u)
                        });
                    case 10:
                        var i = r.b;
                        return u = i.b, cv({
                            a: n.a,
                            b: A2(Ur, vR(A2(VH, i.a.a, "\n")), u)
                        });
                    default:
                        break n;
                }
            case 11:
                var c = r.b, o = c.a.a;
                switch(u = c.b, e.$){
                    case 11:
                        return cv({
                            a: n.a,
                            b: A2(Ur, Y_(A2(VH, o, f = e.a)), u)
                        });
                    case 1:
                        var f = e.a, l = A2(Bv, DN(), o);
                        if (l.$) return av(uv(XR(l.a)));
                        var d = (nn = l.a).b;
                        if (d.b) {
                            if (QR(d.a) && !A2(Gd, "\n", o)) return cv({
                                a: n.a,
                                b: A2(Ur, Y_(A2(VH, o, f)), u)
                            });
                            var b = A2(Bv, DN(), o);
                            if (b.$) return av(uv(XR(b.a)));
                            var m = b.a;
                            return cv({
                                a: k(n.a, nn.a),
                                b: A2(Ur, e, A2(Ur, ER(m.b), u))
                            });
                        }
                        var p = A2(Bv, DN(), o);
                        return p.$ ? av(uv(XR(p.a))) : (m = p.a, cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, ER(m.b), u))
                        }));
                    case 6:
                        f = e.a;
                        var g = A2(Bv, DN(), o);
                        if (g.$) return av(uv(XR(g.a)));
                        var h = (nn = g.a).b;
                        if (h.b && 1 === h.a.$) return cv({
                            a: n.a,
                            b: A2(Ur, Y_(A3(WH, " ", o, f)), u)
                        });
                        var x = A2(Bv, DN(), o);
                        return x.$ ? av(uv(XR(x.a))) : (m = x.a, cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, ER(m.b), u))
                        }));
                    default:
                        var y = A2(Bv, DN(), o);
                        return y.$ ? av(uv(XR(y.a))) : cv({
                            a: k(n.a, (nn = y.a).a),
                            b: A2(Ur, e, A2(Ur, ER(nn.b), u))
                        });
                }
            case 3:
                var j = r.b, E = j.a, A = E.a, C = E.b, P = E.c, T = E.d;
                switch(u = j.b, e.$){
                    case 3:
                        var S = e.b;
                        if (s(T.mU, (U = e.d).mU)) {
                            var I = A2(Bv, DN(), T.kK);
                            return I.$ ? av(uv(XR(I.a))) : cv(A2(tl, Z_, (nn = I.a).b) ? {
                                a: k(n.a, nn.a),
                                b: A2(Ur, A4(MR, !1, S, A2(Ur, {
                                    kK: nn.b,
                                    I: T.I
                                }, P), U), u)
                            } : {
                                a: k(n.a, nn.a),
                                b: A2(Ur, A4(MR, A, S, A2(Ur, {
                                    kK: nn.b,
                                    I: T.I
                                }, P), U), u)
                            });
                        }
                        var O = A2(Bv, DN(), T.kK);
                        if (O.$) return av(uv(XR(O.a)));
                        var q = !A2(tl, Z_, (nn = O.a).b) && A;
                        return cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, A4(MR, q, C, A2(Ur, {
                                kK: nn.b,
                                I: T.I
                            }, P), U), u))
                        });
                    case 1:
                        return cv({
                            a: n.a,
                            b: A2(Ur, A4(MR, A, C, P, $(T, {
                                kK: A3(WH, "\n", T.kK, f = e.a)
                            })), u)
                        });
                    default:
                        var L = A2(Bv, DN(), T.kK);
                        return L.$ ? av(uv(XR(L.a))) : (q = !A2(tl, Z_, (nn = L.a).b) && A, cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, A4(MR, q, C, A2(Ur, {
                                kK: nn.b,
                                I: T.I
                            }, P), T), u))
                        }));
                }
            case 4:
                var M = r.b, _ = M.a, R = (A = _.a, C = _.b, _.c), H = _.d;
                switch(P = _.e, T = _.f, u = M.b, e.$){
                    case 4:
                        S = e.b;
                        var U = e.f;
                        if (s(R, e.c)) {
                            var z = A2(Bv, DN(), T);
                            return z.$ ? av(uv(XR(z.a))) : (q = !A2(tl, Z_, (nn = z.a).b) && A, cv({
                                a: k(n.a, nn.a),
                                b: A2(Ur, A6(wR, q, S, R, H, A2(Ur, nn.b, P), U), u)
                            }));
                        }
                        var D = A2(Bv, DN(), T);
                        return D.$ ? av(uv(XR(D.a))) : (q = !A2(tl, Z_, (nn = D.a).b) && A, cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, A6(wR, q, C, R, H, A2(Ur, nn.b, P), T), u))
                        }));
                    case 1:
                        return cv({
                            a: n.a,
                            b: A2(Ur, A6(wR, A, C, R, H, P, T + "\n" + (f = e.a)), u)
                        });
                    default:
                        var N = A2(Bv, DN(), T);
                        return N.$ ? av(uv(XR(N.a))) : (q = !A2(tl, Z_, (nn = N.a).b) && A, cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, A6(wR, q, C, R, H, A2(Ur, nn.b, P), T), u))
                        }));
                }
            case 1:
                switch(r.a.$){
                    case 1:
                        var F = r.b;
                        return u = F.b, cv({
                            a: n.a,
                            b: A2(Ur, xR(A3(WH, "\n", o = F.a.a, f = r.a.a)), u)
                        });
                    case 13:
                        if (r.a.a) {
                            var K = r.b;
                            return u = K.b, cv({
                                a: n.a,
                                b: A2(Ur, A2(fR, 2, K.a.a), u)
                            });
                        }
                        var G = r.b;
                        u = G.b;
                        return cv({
                            a: n.a,
                            b: A2(Ur, A2(fR, 1, G.a.a), u)
                        });
                    case 9:
                        var W = r.a.a, V = W.a, J = r.b, B = J.a.a, X = (u = J.b, A2(pD, A2(IR, V, W.b), B));
                        return cv(X.$ ? {
                            a: n.a,
                            b: A2(Ur, xR(A3(WH, "\n", B, V.jx)), u)
                        } : {
                            a: n.a,
                            b: A2(Ur, TR(A2(SR, X.a, w)), u)
                        });
                    default:
                        break n;
                }
            case 8:
                if (8 === r.a.$) return u = r.b.b, cv({
                    a: n.a,
                    b: A2(Ur, TR(r.a.a), u)
                });
                break n;
            case 10:
                if (!r.b.b.b) break n;
                switch(r.b.b.a.$){
                    case 4:
                        var Q = r.b.b, Z = Q.a, Y = (A = Z.a, C = Z.b, R = Z.c, H = Z.d, P = Z.e, T = Z.f, u = Q.b, A2(Bv, DN(), T));
                        if (Y.$) return av(uv(XR(Y.a)));
                        var nn = Y.a;
                        if (4 === e.$) {
                            S = e.b;
                            var en = e.f;
                            return cv({
                                a: k(n.a, nn.a),
                                b: A2(Ur, A6(wR, !1, S, R, H, A2(Ur, nn.b, P), en), u)
                            });
                        }
                        return cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, Z_, A2(Ur, A6(wR, A, C, R, H, A2(Ur, nn.b, P), T), u)))
                        });
                    case 3:
                        var rn = r.b.b, tn = rn.a, un = (A = tn.a, C = tn.b, P = tn.c, T = tn.d, u = rn.b, A2(Bv, DN(), T.kK));
                        return un.$ ? av(uv(XR(un.a))) : (nn = un.a, 3 === e.$ ? (en = e.d, cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, A4(MR, !1, C, A2(Ur, {
                                kK: nn.b,
                                I: T.I
                            }, P), en), u)
                        })) : cv({
                            a: k(n.a, nn.a),
                            b: A2(Ur, e, A2(Ur, Z_, A2(Ur, A4(MR, A, C, A2(Ur, {
                                kK: nn.b,
                                I: T.I
                            }, P), T), u)))
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return cv({
            a: n.a,
            b: A2(Ur, e, n.b)
        });
    }), AN = F2(function(n, e) {
        var r = e, t = Ui(A2(ju, $T(function(n) {
            return v(n.lp, n.eC);
        }), n));
        return A2(ju, CN, A2(oD, t, r));
    }), CN = function(n) {
        switch(n.$){
            case 0:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(n.a);
            case 1:
                return cR;
            case 2:
                return function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(n.a);
            case 3:
                return A3(hR, n.a, n.b, A2(ju, CN, r = n.c));
            case 4:
                return A3(pR, n.a, n.b, A2(ju, CN, r = n.c));
            case 5:
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(PN(n.a));
            case 6:
                var e = n.a, r = n.b;
                switch(e){
                    case 1:
                        return tR(A2(ju, CN, r));
                    case 2:
                        return CR(A2(ju, CN, r));
                    default:
                        return KH(e) ? CR(E([
                            CN(A2(uR, e - 2, r))
                        ])) : tR(E([
                            CN(A2(uR, e - 1, r))
                        ]));
                }
            default:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(A2(ju, CN, r = n.a));
        }
    }, PN = function(n) {
        switch(n.$){
            case 1:
                return dR("TODO this never happens, but use types to drop this case.");
            case 0:
                return A3(mR, n.a, n.b, A2(Id, function(n) {
                    return 1 === n.$ ? UN(n.a) : E([
                        lR(PN(n))
                    ]);
                }, n.c));
            case 2:
                return dR(n.a);
            case 3:
                return nR(n.a);
            case 4:
                return AR(n.a);
            default:
                return A2(bR, n.a, n.b);
        }
    }, TN = function(n) {
        return A2(SN, n, w);
    }, SN = F2(function(n, e) {
        for(;;){
            if (!n.b) return Zr(xt(e));
            var r = n.b, t = A2(yN, n.a, e);
            if (t.$) return Jr(t.a);
            n = r, e = t.a;
        }
    }), IN = function(n) {
        var e = A2(Bv, A2(dv, DN(), VR), n);
        if (1 === e.$) return Jr(e.a);
        var r = ON(e.a);
        return 1 === r.$ ? A2(Bv, av(r.a), "") : Zr(A2(ks, function(n) {
            return !(5 === n.$ && !n.a.b);
        }, r.a));
    }, ON = function(n) {
        return A3(qN, n, n.b, w);
    }, qN = F3(function(n, e, r) {
        n: for(;;){
            if (!e.b) return Zr(r);
            var t = e.b, u = A2(MN, n.a, e.a);
            switch(u.$){
                case 1:
                    e = t, r = A2(Ur, u.a, r);
                    continue n;
                case 0:
                    e = t;
                    continue n;
                default:
                    return Jr(u.a);
            }
        }
    }), LN = F2(function(n, e) {
        return A2(ju, function(e) {
            var r = e.eV;
            return A3(_N, n, function(n) {
                return {
                    eV: r,
                    ai: n
                };
            }, e.ai);
        }, e);
    }), MN = F2(function(n, e) {
        switch(e.$){
            case 0:
                var r = e.b, t = function(n) {
                    switch(n){
                        case 1:
                            return Zr(0);
                        case 2:
                            return Zr(1);
                        case 3:
                            return Zr(2);
                        case 4:
                            return Zr(3);
                        case 5:
                            return Zr(4);
                        case 6:
                            return Zr(5);
                        default:
                            return Jr(iR("A heading with 1 to 6 #'s, but found " + ut(n)));
                    }
                }(e.a);
                return t.$ ? gR(t.a) : jR(A2(oR, t.a, A2(AN, n, r)));
            case 1:
                return jR(yR(A2(AN, n, r = e.a)));
            case 2:
                return jR(lR(e.a));
            case 3:
                var u = e.a, a = e.c, i = F2(function(e, r) {
                    var t, u = e.$ ? 0 : e.a ? 2 : 1, a = (t = ON({
                        a: n,
                        b: r
                    })).$ ? w : t.a;
                    return A2($R, u, a);
                });
                return jR(A2(LR, GH(u), xt(A2(ju, function(n) {
                    return A2(i, n.I, n.kK);
                }, a))));
            case 4:
                var c = e.d;
                return a = e.e, i = function(e) {
                    var r = ON({
                        a: n,
                        b: e
                    });
                    return r.$ ? w : r.a;
                }, jR(A3(kR, GH(u = e.a), c, xt(A2(ju, i, a))));
            case 5:
                return jR(eR(e.a));
            case 7:
                return jR(OR);
            case 10:
            case 11:
                return aR;
            case 12:
                var o = ON({
                    a: n,
                    b: e.a
                });
                return o.$ ? gR(o.a) : jR(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(o.a));
            case 6:
                return jR(eR({
                    kK: e.a,
                    mD: Hr
                }));
            case 8:
                var f = e.a, s = f.b;
                return jR(A2(PR, A2(LN, n, f.a), A2(RN, n, s)));
            case 9:
                return jR(yR(A2(AN, n, e.a.a.jx)));
            default:
                return jR(yR(A2(AN, n, e.b)));
        }
    }), _N = F3(function(n, e, r) {
        return e(A2(AN, n, r));
    }), RN = F2(function(n, e) {
        return A2(ju, function(e) {
            return A2(ju, function(e) {
                return A3(_N, n, ru, e);
            }, e);
        }, e);
    }), HN = function(n) {
        return hv(E([
            A2(Av, function() {
                return Pv(n);
            }, VR),
            A2(Av, function(e) {
                return Tv(A2(_R, n, e));
            }, RR(XD)),
            function() {
                var e = n.b;
                n: for(; e.b;)switch(e.a.$){
                    case 1:
                        return A2(Av, function(n) {
                            return Tv(n);
                        }, A2(Np, EN(n), FN()));
                    case 8:
                        var r = e.a.a;
                        return A2(Av, function(n) {
                            return Tv(n);
                        }, A2(Np, EN(n), hv(E([
                            NN(),
                            dN(r)
                        ]))));
                    case 3:
                        var t = e.a, u = t.a, a = t.b, i = t.c, c = t.d, o = e.b, f = F2(function(n, e) {
                            return $(n, {
                                b: A2(Ur, Z_, A2(Ur, A4(MR, u, a, i, $(c, {
                                    kK: A3(WH, "", c.kK, e)
                                })), o))
                            });
                        }), s = F2(function(n, e) {
                            return $(n, {
                                b: A2(Ur, A4(MR, u, a, i, $(c, {
                                    kK: A3(WH, "\n", c.kK, e)
                                })), o)
                            });
                        });
                        return hv(E([
                            A2(Av, function(n) {
                                return Tv(n);
                            }, A2(Av, function() {
                                return A2(f, n, "\n");
                            }, NR)),
                            A2(Av, function(n) {
                                return Tv(n);
                            }, A2(Av, s(n), A2(mv, A2(dv, cv(ru), Rv(A2(Lv, A2(Xc, a, " "), qv("Indentation")))), A2(dv, rv(WR), JR)))),
                            A2(Av, function(n) {
                                return Tv(n);
                            }, A2(Np, EN(n), KN()))
                        ]));
                    case 4:
                        var l = e.a, d = (u = l.a, a = l.b, l.c), b = l.d;
                        return i = l.e, c = l.f, o = e.b, f = F2(function(n, e) {
                            return $(n, {
                                b: A2(Ur, Z_, A2(Ur, A6(wR, u, a, d, b, i, c + "\n" + e), o))
                            });
                        }), s = F2(function(n, e) {
                            return $(n, {
                                b: A2(Ur, A6(wR, u, a, d, b, i, c + "\n" + e), o)
                            });
                        }), hv(E([
                            A2(Av, function(n) {
                                return Tv(n);
                            }, A2(Av, function() {
                                return A2(f, n, "\n");
                            }, NR)),
                            A2(Av, function(n) {
                                return Tv(n);
                            }, A2(Av, s(n), A2(mv, A2(dv, cv(ru), Rv(A2(Lv, A2(Xc, a, " "), qv("Indentation")))), A2(dv, rv(WR), JR)))),
                            A2(Av, function(n) {
                                return Tv(n);
                            }, A2(Np, EN(n), KN()))
                        ]));
                    case 10:
                        if (!e.b.b) break n;
                        switch(e.b.a.$){
                            case 3:
                                var m = e.b, p = m.a;
                                return u = p.a, a = p.b, i = p.c, c = p.d, o = m.b, f = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Ur, Z_, A2(Ur, A4(MR, u, a, i, $(c, {
                                            kK: A3(WH, "", c.kK, e)
                                        })), o))
                                    });
                                }), s = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Ur, A4(MR, u, a, i, $(c, {
                                            kK: A3(WH, "\n", c.kK, e)
                                        })), o)
                                    });
                                }), "" === pf(c.kK) ? A2(Av, function(n) {
                                    return Tv(n);
                                }, A2(Np, EN(n), NN())) : hv(E([
                                    A2(Av, function(n) {
                                        return Tv(n);
                                    }, A2(Av, function() {
                                        return A2(f, n, "\n");
                                    }, NR)),
                                    A2(Av, function(n) {
                                        return Tv(n);
                                    }, A2(Av, s(n), A2(mv, A2(dv, cv(ru), Rv(A2(Lv, A2(Xc, a, " "), qv("Indentation")))), A2(dv, rv(WR), JR)))),
                                    A2(Av, function(n) {
                                        return Tv(n);
                                    }, A2(Np, EN(n), NN()))
                                ]));
                            case 4:
                                var v = e.b, g = v.a;
                                return u = g.a, a = g.b, d = g.c, b = g.d, i = g.e, c = g.f, o = v.b, f = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Ur, Z_, A2(Ur, A6(wR, u, a, d, b, i, c + "\n" + e), o))
                                    });
                                }), s = F2(function(n, e) {
                                    return $(n, {
                                        b: A2(Ur, A6(wR, u, a, d, b, i, c + "\n" + e), o)
                                    });
                                }), "" === pf(c) ? A2(Av, function(n) {
                                    return Tv(n);
                                }, A2(Np, EN(n), NN())) : hv(E([
                                    A2(Av, function(n) {
                                        return Tv(n);
                                    }, A2(Av, function() {
                                        return A2(f, n, "\n");
                                    }, NR)),
                                    A2(Av, function(n) {
                                        return Tv(n);
                                    }, A2(Av, s(n), A2(mv, A2(dv, cv(ru), Rv(A2(Lv, A2(Xc, a, " "), qv("Indentation")))), A2(dv, rv(WR), JR)))),
                                    A2(Av, function(n) {
                                        return Tv(n);
                                    }, A2(Np, EN(n), NN()))
                                ]));
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return A2(Av, function(n) {
                    return Tv(n);
                }, A2(Np, EN(n), NN()));
            }(),
            A2(Av, function(n) {
                return Tv(n);
            }, A2(Np, EN(n), BH))
        ]));
    }, UN = function(n) {
        return A2(eh, w, IN(n));
    }, zN = function(n) {
        switch(n.$){
            case 1:
                return cv(xR(n.a));
            case 0:
                var e = n.a, r = n.b, t = TN(n.c);
                return t.$ ? av(t.a) : cv(sR(A3(mR, e, r, t.a)));
            case 2:
                return cv(sR(dR(n.a)));
            case 3:
                return cv(sR(nR(n.a)));
            case 4:
                return cv(sR(AR(n.a)));
            default:
                return cv(sR(A2(bR, n.a, n.b)));
        }
    };
    function DN() {
        return A2(Np, jN, A2(Ev, {
            a: w,
            b: w
        }, HN));
    }
    function NN() {
        return hv(E([
            sD,
            NR,
            BR,
            A2(Av, rR, RR(CD)),
            FH,
            A2(Av, function() {
                return qR;
            }, RR(nN)),
            wN(!1),
            fU(!1),
            RR(SD),
            GN()
        ]));
    }
    function FN() {
        return hv(E([
            sD,
            NR,
            BR,
            A2(Av, rR, RR(CD)),
            RR(uN),
            A2(Av, function() {
                return qR;
            }, RR(nN)),
            wN(!0),
            fU(!0),
            RR(SD),
            GN(),
            RR(sN)
        ]));
    }
    function KN() {
        return hv(E([
            sD,
            NR,
            BR,
            A2(Av, rR, RR(CD)),
            A2(Av, function() {
                return qR;
            }, RR(nN)),
            wN(!1),
            fU(!1),
            RR(SD),
            GN()
        ]));
    }
    function GN() {
        return A2(Np, zN, _H);
    }
    var WN = DN();
    DN = function() {
        return WN;
    };
    var VN = NN();
    NN = function() {
        return VN;
    };
    var JN = FN();
    FN = function() {
        return JN;
    };
    var BN = KN();
    KN = function() {
        return BN;
    };
    var XN = GN();
    GN = function() {
        return XN;
    };
    var QN, ZN, YN, nF, eF, rF = A2(yu, wx(Ur), Zr(w)), tF = F3(function(n, e, r) {
        n: for(;;){
            if (!r.b) return e;
            var t = r.a, u = r.b;
            switch(t.$){
                case 0:
                    var a = t.a;
                    if (a.$) {
                        c = n, o = A2(n, t, e), n = c, e = o, r = u;
                        continue n;
                    }
                    var i = a.c, c = n, o = A2(n, t, e);
                    n = c, e = o, r = k(i, u);
                    continue n;
                case 1:
                    var f = A2(Id, function(n) {
                        return n.b;
                    }, s = t.b);
                    c = n, o = A2(n, t, e), n = c, e = o, r = k(f, u);
                    continue n;
                case 2:
                    var s = t.c;
                    c = n, o = A2(n, t, e), n = c, e = o, r = k(Sd(s), u);
                    continue n;
                case 3:
                    s = t.a, c = n, o = A2(n, t, e), n = c, e = o, r = k(s, u);
                    continue n;
                default:
                    c = n, o = A2(n, t, e), n = c, e = o, r = u;
                    continue n;
            }
        }
    }), uF = function(n) {
        switch(n.$){
            case 5:
                return aF(n.a);
            case 0:
                var e = n.a;
                if (e.$) return "";
                var r = e.c;
                return A3(tF, F2(function(n, e) {
                    return k(e, uF(n));
                }), "", r);
            case 1:
                return A2(at, "\n", A2(ju, function(n) {
                    return A2(at, "\n", A2(ju, uF, n.b));
                }, n.b));
            case 2:
                return A2(at, "\n", A2(ju, function(n) {
                    return A2(at, "\n", A2(ju, uF, n));
                }, n.c));
            case 3:
                return A2(at, "\n", A2(ju, uF, r = n.a));
            case 4:
                return aF(n.b);
            case 6:
                var t = n.b;
                return A2(at, "\n", Sd(E([
                    A2(ju, aF, A2(ju, function(n) {
                        return n.ai;
                    }, n.a)),
                    Sd(A2(ju, ju(aF), t))
                ])));
            case 7:
                return n.a.kK;
            default:
                return "";
        }
    }, aF = function(n) {
        return A3(ot, iF, "", n);
    }, iF = F2(function(n, e) {
        switch(n.$){
            case 7:
            case 6:
                return k(e, n.a);
            case 8:
                return e + " ";
            case 1:
            case 2:
                return k(e, aF(n.c));
            case 0:
                var r = n.a;
                if (r.$) return e;
                var t = r.c;
                return A3(tF, F2(function(n, e) {
                    return k(e, uF(n));
                }), e, t);
            default:
                return k(e, aF(n.a));
        }
    }), cF = F5(function(n, e, r, t, u) {
        var a = t;
        return A2(is, function(t) {
            return A2(ss, function(n) {
                return n(t);
            }, A3(a, n, e, r));
        }, rF(u));
    }), oF = F3(function(n, e, r) {
        var t = A2(dF, n, e);
        return t.$ ? r : A2(Ur, t.a, r);
    }), fF = F2(function(n, e) {
        return A2(La, sF(n), e);
    }), sF = function(n) {
        return function(e) {
            switch(e.$){
                case 4:
                    var r = e.a;
                    return Rr(A2(ss, function(e) {
                        return n.gy({
                            kR: e,
                            eb: r,
                            nU: aF(t)
                        });
                    }, A2(bF, n, t = e.b)));
                case 5:
                    var t;
                    return Rr(A2(ss, n.gV, A2(bF, n, t = e.a)));
                case 0:
                    var u = e.a;
                    return u.$ ? Hr : Rr(A4(lF, n, u.a, u.b, u.c));
                case 1:
                    var a = e.a;
                    return Rr(A2(ss, function(e) {
                        return n.hy(A2(ju, function(n) {
                            return A2($R, n.a, Sd(n.b));
                        }, e));
                    }, rF(A2(ju, function(e) {
                        var r = e.b;
                        return A2(ss, $R(e.a), rF(A2(La, function(e) {
                            var r = v(a, e);
                            return 1 === r.a && 5 === r.b.$ ? Rr(A2(bF, n, r.b.a)) : A2(Lc, ss(ik), A2(sF, n, e));
                        }, r)));
                    }, e.b))));
                case 2:
                    a = e.a;
                    var i = e.b;
                    return Rr(A2(ss, function(e) {
                        return A2(n.gT, i, A2(ju, function(n) {
                            return Sd(n);
                        }, e));
                    }, rF(A2(ju, function(e) {
                        return rF(A2(La, function(e) {
                            var r = v(a, e);
                            return 1 === r.a && 5 === r.b.$ ? Rr(A2(bF, n, r.b.a)) : A2(Lc, ss(ik), A2(sF, n, e));
                        }, e));
                    }, e.c))));
                case 7:
                    return Rr(Zr(n.gb(e.a)));
                case 8:
                    return Rr(Zr(n.hq));
                case 3:
                    return Rr(A2(ss, n.f7, rF(A2(fF, n, e.a))));
                default:
                    var c = e.a, o = e.b, f = rF(A2(ju, function(e) {
                        var r = e.ai;
                        return A2(ss, Lj(e.eV), A2(bF, n, r));
                    }, c)), s = A2(ss, function(e) {
                        return n.hl(ik(n.fL(A2(ju, function(e) {
                            return A2(n.hm, e.a, e.b);
                        }, e))));
                    }, f), l = function(e) {
                        return A2(ss, n.fL, A2(ss, bt(F2(function(e, r) {
                            return A2(n.hk, A2(Qa, function(n) {
                                return n.eV;
                            }, ys(A2(jc, e, c))), r);
                        })), rF(A2(ju, bF(n), e))));
                    }, d = rF(A2(ju, l, o));
                    return Rr(A3(wx, F2(function(e, r) {
                        return n.hi(A2(Ur, e, function(e) {
                            return lf(e) ? w : E([
                                n.hj(e)
                            ]);
                        }(r)));
                    }), s, d));
            }
        };
    }, lF = F4(function(n, e, r, t) {
        return A5(cF, e, r, t, n.gA, A2(fF, n, t));
    }), dF = F2(function(n, e) {
        switch(e.$){
            case 4:
                return Rr(A2(ss, n.he, A2(bF, n, e.a)));
            case 3:
                return Rr(A2(ss, n.go, A2(bF, n, e.a)));
            case 5:
                return Rr(A2(ss, n.hd, A2(bF, n, e.a)));
            case 2:
                var r = e.a, t = e.b;
                return Rr(Zr(n.gB({
                    f4: aF(e.c),
                    hb: r,
                    eC: t
                })));
            case 7:
                return Rr(Zr(n.z(e.a)));
            case 6:
                return Rr(Zr(n.gc(e.a)));
            case 1:
                var u = e.a;
                return t = e.b, Rr(A2(is, function(e) {
                    return Zr(A2(n.di, {
                        lp: u,
                        eC: t
                    }, e));
                }, A2(bF, n, e.c)));
            case 8:
                return Rr(Zr(n.gw));
            default:
                var a = e.a;
                return a.$ ? Hr : Rr(A4(lF, n, a.a, a.b, a.c));
        }
    }), bF = F2(function(n, e) {
        return rF(A3(yu, oF(n), w, e));
    }), mF = F2(function(n, e) {
        return rF(A2(fF, n, e));
    }), pF = A2(Fu, p_, A2(Fu, IN, A2(Fu, $a(A2(Fu, ju(v_), at("\n"))), is(mF(Q_))))), vF = F2(function(n, e) {
        var r = pF(e);
        if (1 === r.$) {
            var t = r.a;
            return A2(VM, E([
                WM("fr-alert fr-alert--warning")
            ]), E([
                a_(t)
            ]));
        }
        var u = r.a;
        return A2(VM, A2(Ur, WM("Markdown bottomed-paragraphs"), n), u);
    }), gF = "/versions/v7.0.0/", hF = F2(function(n, e) {
        switch(e.$){
            case 4:
                return m_(E([
                    l_,
                    A2(vF, w, "**M\xe9thodologie stabilis\xe9e.** Calculette en cours de d\xe9veloppement")
                ]));
            case 5:
                switch(e.a){
                    case 0:
                        return m_(E([
                            l_,
                            A2(vF, w, "**M\xe9thodologie stabilis\xe9e. Cette version de la calculette remplacera \xe0 terme la version initiale.**"),
                            A2(vF, w, "Contribuez via notre [forum utilisateur](https://chat.ecobalyse.fr/ecobalyse/channels/02_alimentaire_general).")
                        ]));
                    case 1:
                        return m_(E([
                            l_,
                            A2(vF, w, "**Cette version est en cours de d\xe9veloppement.**"),
                            A2(vF, w, "Contribuez via notre [forum utilisateur](https://chat.ecobalyse.fr/ecobalyse/channels/41_ameublement)")
                        ]));
                    default:
                        return m_(E([
                            l_,
                            A2(vF, w, "**Cette version est en cours de d\xe9veloppement.** Elle est r\xe9serv\xe9e \xe0 des beta-testeurs.")
                        ]));
                }
            case 9:
                return m_(E([
                    l_,
                    A2(vF, w, "**Cette version est en cours de d\xe9veloppement.** La version r\xe9glementaire est la v7.0.0.\n                    "),
                    A2(YM, E([
                        i_("button"),
                        WM("btn btn-link p-0 m-0"),
                        u_(n(o_(gF + "#/textile/simulator"))),
                        WM("ms-1")
                    ]), E([
                        a_("Acc\xe9der \xe0 la version r\xe9glementaire")
                    ]))
                ]));
            default:
                return a_("");
        }
    }), $F = fe("main"), xF = {
        $: 1
    }, kF = GM("id"), wF = F2(function(n, e) {
        return {
            $: 0,
            a: n,
            b: e
        };
    }), yF = F3(function(n, e, r) {
        return {
            $: 1,
            a: n,
            b: e,
            c: r
        };
    }), jF = F2(function(n, e) {
        return {
            $: 2,
            a: n,
            b: e
        };
    }), EF = "https://fabrique-numerique.gitbook.io/ecobalyse/communaute", AF = "ecobalyse@beta.gouv.fr", CF = "https://fabrique-numerique.gitbook.io/ecobalyse", PF = F2(function(n, e) {
        return n ? Rr(e) : Hr;
    }), TF = fe("sup"), SF = function(n) {
        return A2(La, ru, E([
            Rr(A3(yF, E([
                a_("Accueil")
            ]), $d, zM)),
            A2(PF, n.oT, A3(yF, E([
                a_("Textile")
            ]), wd, FM)),
            A2(PF, n.l1, A3(yF, E([
                a_("Alimentaire")
            ]), hd, HM)),
            A2(PF, n.fb, A3(yF, E([
                a_("Alimentaire"),
                A2(TF, w, E([
                    a_("B\xc9TA")
                ]))
            ]), Hb(0), UM(0))),
            A2(PF, n.nj, A3(yF, E([
                a_("Objets")
            ]), Hb(1), UM(1))),
            A2(PF, n.f_, A3(yF, E([
                a_("V\xe9hicules")
            ]), Hb(2), UM(2))),
            Rr(A3(yF, E([
                a_("Explorateur")
            ]), A2(pd, ms, Ed(Hr)), RM)),
            Rr(A3(yF, E([
                a_("API")
            ]), sd, LM)),
            Rr(A2(jF, "Contact", AF))
        ]));
    }, IF = me, OF = IF, qF = ve("rel"), LF = GM("target"), MF = function(n) {
        return KM(k(n, E([
            LF("_blank"),
            WM("link-external"),
            qF("noopener noreferrer")
        ])));
    }, _F = "https://github.com/MTES-MCT/ecobalyse", RF = function(n) {
        if (2 === n.$) {
            var e = n.a;
            return A2(F2(function(n, e) {
                return A2(MF, E([
                    WM("text-decoration-none"),
                    XM(n)
                ]), E([
                    a_("Version\xa0: " + e)
                ]));
            }), _F + "/commit/" + e.gx, e.gx);
        }
        return a_("");
    }, HF = function(n) {
        return KM(n);
    }, UF = F2(function(n, e) {
        switch(e.$){
            case 0:
                var r = e.a, t = e.b;
                return A2(MF, E([
                    WM("nav-link link-external-muted"),
                    XM(t)
                ]), E([
                    a_(r)
                ]));
            case 1:
                r = e.a;
                var u = e.b, a = e.c;
                return A2(HF, A2(Ur, WM("nav-link"), A2(Ur, n_(E([
                    v("active", s(a, n))
                ])), A2(Ur, QM(u), s(a, n) ? E([
                    A2(ZM, "aria-current", "page")
                ]) : w))), r);
            default:
                r = e.a;
                var i = e.b;
                return A2(KM, E([
                    WM("nav-link"),
                    XM("mailto:" + i)
                ]), E([
                    a_(r)
                ]));
        }
    }), zF = function(n) {
        var e, r, t = n.hG, u = n.oW;
        return A2(VM, w, E([
            A2(VM, E([
                WM("offcanvas offcanvas-start show"),
                A2(OF, "visibility", "visible"),
                kF("navigation"),
                A2(ZM, "tabindex", "-1"),
                A2(ZM, "aria-labelledby", "navigationLabel"),
                A2(ZM, "arial-modal", "true"),
                A2(ZM, "role", "dialog")
            ]), E([
                A2(VM, E([
                    WM("offcanvas-header")
                ]), E([
                    A2(e_, E([
                        WM("h5 offcanvas-title"),
                        kF("navigationLabel")
                    ]), E([
                        a_("Navigation")
                    ])),
                    A2(YM, E([
                        i_("button"),
                        WM("btn-close text-reset"),
                        A2(ZM, "aria-label", "Close"),
                        u_(u(xF))
                    ]), w)
                ])),
                A2(VM, E([
                    WM("offcanvas-body")
                ]), E([
                    A2(VM, E([
                        WM("nav nav-pills flex-column")
                    ]), A2(ju, UF(t), (e = n, r = e.iT, k(SF(e.lN), E([
                        A2(wF, "Documentation", CF),
                        A2(wF, "Communaut\xe9", EF),
                        A2(jF, "Contact", AF),
                        A3(yF, E(r ? [
                            a_("Mon compte")
                        ] : [
                            a_("Connexion ou inscription")
                        ]), ld, MM)
                    ]))))),
                    A2(P_, E([
                        WM("h6 mt-3")
                    ]), E([
                        a_("Versions")
                    ])),
                    RF(n.k9),
                    A2(KM, E([
                        WM("nav-link"),
                        XM(gF),
                        u_(u(o_(gF)))
                    ]), E([
                        a_("Version stable textile")
                    ]))
                ]))
            ])),
            A2(VM, E([
                WM("offcanvas-backdrop fade show")
            ]), w)
        ]));
    }, DF = {
        $: 5
    }, NF = function(n) {
        var e = n.k9, r = n.oW;
        if (e.$) return a_("");
        var t = e.b.fN;
        return A2(VM, E([
            WM("NewVersionAlert d-block align-items-center")
        ]), E([
            a_(t.$ ? "Une nouvelle version de l'application est disponible." : "La nouvelle version " + t.a + " de l'application est disponible."),
            A2(YM, E([
                i_("button"),
                WM("btn btn-outline-primary"),
                u_(r(DF))
            ]), E([
                a_("Mettre \xe0 jour")
            ]))
        ]));
    }, FF = {
        $: 6
    }, KF = fe("details"), GF = A2(Fu, A2(Xb, " ", "%20"), A2(Fu, A2(Xb, "\n", "%0A"), A2(Fu, A2(Xb, "\r", "%0D"), A2(Fu, A2(Xb, "\t", "%09"), A2(Fu, A2(Xb, '"', "%22"), A2(Fu, A2(Xb, "'", "%27"), A2(Fu, A2(Xb, "<", "%3C"), A2(Fu, A2(Xb, ">", "%3E"), A2(Xb, "&", "%26"))))))))), WF = function(n) {
        return A2(H_, E([
            WM("fs-7 mt-1 mb-0")
        ]), E([
            A2(KM, E([
                XM("mailto:" + AF + "?Subject=" + GF("[Ecobalyse] Erreur rencontr\xe9e") + "&Body=" + (GF("Bonjour, j'ai rencontr\xe9 une erreur sur le site Ecobalyse. En voici les d\xe9tails:\n\n") + GF(n)))
            ]), E([
                a_("Envoyer un rapport d'incident par email")
            ]))
        ]));
    }, VF = fe("summary"), JF = F3(function(n, e, r) {
        var t = zT(r), u = t.il, a = t.l8, i = t.j0, c = t.eC, o = t.a6, f = A2(at, "\n", A2(La, function(n) {
            var e = n.a;
            return A2(Lc, function(n) {
                return e + ": " + n;
            }, n.b);
        }, E([
            v("Title", c),
            v("Message", Rr(u)),
            v("URL", su(o) ? Hr : Rr(o)),
            v("Status code", i ? Rr(ut(i)) : Hr),
            v("En-t\xeates", RT(a) ? Hr : Rr(Hc(A2(ju, function(n) {
                return "\n- " + n.a + ": " + n.b;
            }, Kr(a)))))
        ])));
        return c_({
            hO: w,
            h0: e,
            h5: E([
                A2(VM, w, E([
                    A2(H_, E([
                        WM("mb-2 text-truncate")
                    ]), E([
                        function() {
                            if (c.$) return a_(u);
                            var n = c.a;
                            return s(n, u) || su(n) ? a_(u) : A2(d_, w, E([
                                A2(D_, w, E([
                                    a_(n + "\xa0: ")
                                ])),
                                a_(u)
                            ]));
                        }()
                    ])),
                    A2(KF, w, E([
                        A2(VF, w, E([
                            a_("D\xe9tails de l'erreur")
                        ])),
                        A2(U_, E([
                            WM("mt-1 mb-0 ms-3")
                        ]), E([
                            a_(f)
                        ]))
                    ])),
                    WF(u + " " + f)
                ])),
                A2(VM, E([
                    WM("fs-8 text-muted")
                ]), E([
                    A2(A_, w, E([
                        a_("Backend url: " + n + "/backend/api")
                    ]))
                ]))
            ]),
            eb: 0,
            eC: Rr("Une erreur serveur a \xe9t\xe9 rencontr\xe9e")
        });
    }), BF = F2(function(n, e) {
        var r = n.kU, t = n.oW, u = t(function(n) {
            return {
                $: 2,
                a: n
            };
        }(e));
        switch(e.$){
            case 0:
                var a = e.a, i = A3(JF, r, Rr(u), a);
                if (1 === a.$) {
                    var c = a.a.j0, o = a.a.eC;
                    return 409 === c && A2(au, "user already exists", a.a.il) ? c_({
                        hO: w,
                        h0: Rr(u),
                        h5: E([
                            a_("Un compte associ\xe9 \xe0 cette adresse email existe d\xe9j\xe0.")
                        ]),
                        eb: 3,
                        eC: Rr("Compte utilisateur existant")
                    }) : 403 === c && A2(_c, !1, A2(Lc, au("already used"), o)) ? c_({
                        hO: w,
                        h0: Rr(u),
                        h5: E([
                            a_("Ce lien d'authentification \xe0 usage unique a d\xe9j\xe0 \xe9t\xe9 utilis\xe9.\n                                          Vous pouvez en redemander un nouveau via le formulaire de connexion ci-dessous.")
                        ]),
                        eb: 3,
                        eC: Rr("Lien d'identification expir\xe9")
                    }) : i;
                }
                return i;
            case 1:
                o = e.a;
                var f = e.b;
                return c_({
                    hO: w,
                    h0: Rr(u),
                    h5: E([
                        A2(vF, E([
                            WM("mb-1")
                        ]), f)
                    ]),
                    eb: 0,
                    eC: Rr(o)
                });
            default:
                var s = e.a;
                return c_({
                    hO: w,
                    h0: Hr,
                    h5: E([
                        A2(H_, E([
                            WM("fw-bold mb-2")
                        ]), E([
                            a_("Vos pr\xe9c\xe9dente session n'a pas pu \xeatre r\xe9cup\xe9r\xe9e et doit \xeatre r\xe9initialis\xe9e.")
                        ])),
                        A2(H_, E([
                            WM("fs-7 d-flex align-items-baseline gap-1")
                        ]), E([
                            a_("\u24D8 Cela se produit g\xe9n\xe9ralement lorsque de nouvelles fonctionnalit\xe9s ou correctifs appliqu\xe9s introduisent des incompatibilit\xe9s avec le format de ces donn\xe9es.")
                        ])),
                        A2(H_, w, E([
                            A2(YM, E([
                                WM("btn btn-primary"),
                                u_(t(FF))
                            ]), E([
                                a_("D\u2019accord, r\xe9initialiser la session")
                            ]))
                        ])),
                        A2(KF, E([
                            WM("fs-8")
                        ]), E([
                            A2(VF, w, E([
                                a_("Afficher les d\xe9tails techniques de l'erreur")
                            ])),
                            A2(U_, E([
                                WM("card p-2 mt-2 bg-light")
                            ]), E([
                                A2(y_, w, E([
                                    a_(yt(s))
                                ]))
                            ]))
                        ]))
                    ]),
                    eb: 1,
                    eC: Rr("Probl\xe8me de r\xe9cup\xe9ration de la session")
                });
        }
    }), XF = function(n) {
        var e = n.a1;
        if (e.b) {
            var r = e;
            return A2(JM, E([
                WM("bg-white pt-3")
            ]), A2(ju, BF(n), r));
        }
        return a_("");
    }, QF = fe("footer"), ZF = function(n) {
        return A2(au, "ecobalyse-pr", n) || A2(au, "staging-ecobalyse", n);
    }, YF = E([
        A3(yF, E([
            a_("Accessibilit\xe9\xa0: non conforme")
        ]), md("accessibilit\xe9"), _M("accessibilit\xe9")),
        A3(yF, E([
            a_("Mentions l\xe9gales")
        ]), md("mentions-l\xe9gales"), _M("mentions-l\xe9gales")),
        A3(yF, E([
            a_("Politique de confidentialit\xe9")
        ]), md("politique-de-confidentialite"), _M("politique-de-confidentialite")),
        A2(jF, "Contact", AF)
    ]), nK = "https://fabrique-numerique.gitbook.io/ecobalyse/conditions-dutilisation", eK = function(n) {
        return A2(La, ru, E([
            Rr(A3(yF, E([
                a_("Derni\xe8res mises \xe0 jour")
            ]), md("maj"), _M("maj"))),
            Rr(A3(yF, E([
                a_("Statistiques")
            ]), xd, NM)),
            Rr(A2(wF, "Documentation", CF)),
            Rr(A2(wF, "Communaut\xe9", EF)),
            Rr(A2(wF, "Code source", _F)),
            Rr(A2(wF, "CGU", nK)),
            A2(PF, n.fb, A3(yF, E([
                a_("Alimentaire\xb2")
            ]), Hb(0), UM(0)))
        ]));
    }, rK = function(n) {
        var e = n.kU, r = n.lN, t = function(n) {
            switch(n.$){
                case 0:
                    var e = n.a, r = n.b;
                    return A2(MF, E([
                        WM("text-decoration-none"),
                        XM(r)
                    ]), E([
                        a_(e)
                    ]));
                case 1:
                    e = n.a;
                    var t = n.b;
                    return A2(HF, E([
                        WM("text-decoration-none"),
                        QM(t)
                    ]), e);
                default:
                    e = n.a;
                    var u = n.b;
                    return A2(KM, E([
                        WM("text-decoration-none"),
                        XM("mailto:" + u)
                    ]), E([
                        a_(e)
                    ]));
            }
        };
        return A2(QF, A2(Ur, WM("Footer"), ZF(e) ? E([
            WM("pb-5")
        ]) : w), E([
            A2(VM, E([
                WM("FooterNavigation")
            ]), E([
                A2(JM, w, E([
                    A2(VM, E([
                        WM("row")
                    ]), E([
                        A2(VM, E([
                            WM("col-6 col-sm-4 col-md-3 col-lg-2")
                        ]), E([
                            A2(B_, E([
                                WM("list-unstyled")
                            ]), A2(ju, A2(Fu, ik, L_(w)), A2(ju, t, SF(r))))
                        ])),
                        A2(VM, E([
                            WM("col-6 col-sm-4 col-md-3 col-lg-2")
                        ]), E([
                            A2(B_, E([
                                WM("list-unstyled")
                            ]), A2(ju, A2(Fu, ik, L_(w)), A2(ju, t, eK(r))))
                        ]))
                    ]))
                ]))
            ])),
            A2(JM, E([
                WM("d-flex flex-wrap justify-content-center justify-content-sm-between align-items-center gap-3")
            ]), E([
                A2(KM, E([
                    WM("FooterBrand py-3"),
                    XM("https://www.ecologie.gouv.fr/")
                ]), E([
                    A2(O_, E([
                        WM("FooterLogo"),
                        h_("Minist\xe8re de la Transition \xe9cologique et de la Coh\xe9sion des Territoires"),
                        z_("img/logo_mte.svg"),
                        A2(OF, "width", "201px"),
                        A2(OF, "height", "135px"),
                        A2(OF, "aspect-ratio", "auto 201 / 135")
                    ]), w)
                ])),
                A2(KM, E([
                    WM("FooterBrand py-3"),
                    XM("https://www.ademe.fr/")
                ]), E([
                    A2(O_, E([
                        WM("FooterLogo"),
                        h_("Ademe"),
                        z_("img/logo_ademe.svg"),
                        A2(OF, "height", "120px"),
                        A2(OF, "aspect-ratio", "auto 79.41 / 93.61")
                    ]), w)
                ])),
                A2(VM, E([
                    WM("d-flex justify-content-end align-items-center gap-4 mt-2")
                ]), E([
                    A2(MF, E([
                        WM("FooterInstitutionLink"),
                        XM("https://www.ademe.fr/")
                    ]), E([
                        a_("ademe.fr")
                    ])),
                    A2(MF, E([
                        WM("FooterInstitutionLink"),
                        XM("https://beta.gouv.fr/startups/ecobalyse.html")
                    ]), E([
                        a_("beta.gouv.fr")
                    ])),
                    A2(MF, E([
                        WM("FooterInstitutionLink"),
                        XM("https://www.ecologie.gouv.fr/fabrique-numerique")
                    ]), E([
                        a_("Fabrique Num\xe9rique")
                    ])),
                    A2(MF, E([
                        WM("FooterInstitutionLink"),
                        XM("https://www.economie.gouv.fr/plan-de-relance")
                    ]), E([
                        a_("France Relance")
                    ]))
                ]))
            ])),
            A2(JM, w, E([
                A2(B_, E([
                    WM("FooterLegal d-flex justify-content-start flex-wrap gap-2 list-unstyled mt-3 pt-2 border-top")
                ]), A2(QS, A2(L_, E([
                    A2(ZM, "aria-hidden", "true"),
                    WM("text-muted")
                ]), E([
                    a_("|")
                ])), A2(ju, A2(Fu, ik, L_(w)), A2(ju, t, YF)))),
                A2(VM, E([
                    WM("d-flex align-items-center gap-1 fs-9 mb-2")
                ]), E([
                    RF(n.k9),
                    a_("\xa0|\xa0"),
                    A2(MF, E([
                        XM(_F)
                    ]), E([
                        a_("technical changelog")
                    ]))
                ]))
            ]))
        ]));
    }, tK = {
        $: 4
    }, uK = function(n) {
        return {
            $: 7,
            a: n
        };
    }, aK = function(n) {
        return VM(A2(Ur, WM("container-fluid"), n));
    }, iK = s_("ham"), cK = fe("header"), oK = fe("nav"), fK = function(n) {
        return v(n, !0);
    }, sK = F2(function(n, e) {
        return A2(r_, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(e));
    }), lK = A2(dl, E([
        "target",
        "value"
    ]), ai), dK = function(n) {
        return A2(sK, "input", A2(Zt, fK, A2(Zt, n, lK)));
    }, bK = fe("option"), mK = fe("select"), pK = k_("selected"), vK = GM("value"), gK = function(n) {
        var e, r = n.hG, t = n.oW;
        return A2(cK, E([
            WM("Header shadow-sm"),
            n_(E([
                v("mb-2", !s(r, zM))
            ])),
            A2(ZM, "role", "banner")
        ]), E([
            A2(VM, E([
                WM("MobileMenuButton")
            ]), E([
                A2(YM, E([
                    i_("button"),
                    WM("d-inline-block d-sm-none btn m-0 p-0"),
                    A2(ZM, "aria-label", "Ouvrir la navigation"),
                    V_("Ouvrir la navigation"),
                    u_(t(tK))
                ]), E([
                    A2(d_, E([
                        WM("fs-3")
                    ]), E([
                        iK
                    ]))
                ]))
            ])),
            A2(JM, E([
                WM("d-flex justify-content-between align-items-center gap-2")
            ]), E([
                A2(KM, E([
                    WM("HeaderBrand text-decoration-none d-flex align-items-center gap-3 gap-sm-5 pe-3"),
                    A2(ZM, "data-testid", "header-brand"),
                    WM("fr-header__brand"),
                    QM($d)
                ]), E([
                    A2(O_, E([
                        WM("HeaderLogo"),
                        h_("R\xe9publique Fran\xe7aise"),
                        z_("img/republique-francaise.svg")
                    ]), w),
                    A2(BM, E([
                        WM("HeaderTitle")
                    ]), E([
                        A2(O_, E([
                            WM("HeaderSubLogo"),
                            h_("BetaGouv"),
                            z_("img/logo_betagouv.jpg")
                        ]), w),
                        a_("Ecobalyse")
                    ]))
                ])),
                A2(mK, E([
                    WM("VersionSelector d-none d-sm-block form-select form-select-sm w-auto"),
                    A2(ZM, "data-testid", "version-selector"),
                    dK(A2(cc, t, uK))
                ]), E([
                    A2(bK, E([
                        pK(!0)
                    ]), E([
                        a_("Version courante")
                    ])),
                    A2(bK, E([
                        vK("v7.0.0")
                    ]), E([
                        a_("Version stable textile")
                    ]))
                ])),
                A2(VM, E([
                    WM("HeaderAuthLink flex-fill")
                ]), E([
                    A2(KM, E([
                        WM("d-none d-sm-block flex-fill text-end"),
                        QM(ld),
                        A2(ZM, "data-testid", "auth-link")
                    ]), E([
                        a_(n.iT ? "Mon compte" : "Connexion ou inscription")
                    ]))
                ]))
            ])),
            A2(aK, E([
                WM("border-top")
            ]), E([
                A2(VM, E([
                    WM("container")
                ]), E([
                    A2(oK, E([
                        WM("text-end text-sm-start"),
                        A2(ZM, "role", "navigation"),
                        A2(ZM, "aria-label", "Menu principal")
                    ]), E([
                        A2(VM, E([
                            WM("HeaderNavigation d-none d-sm-flex navbar-nav flex-row overflow-auto")
                        ]), A2(ju, UF(r), (e = n, k(SF(e.lN), E([
                            A2(wF, "Communaut\xe9", EF),
                            A2(wF, "Documentation", CF)
                        ])))))
                    ]))
                ]))
            ]))
        ]));
    }, hK = b_(E([
        WM("page-notice-warning")
    ])), $K = function(n) {
        return n.iT && !n.oS ? hK(E([
            A2(vF, w, A3(Xb, "{url}", MA(ld), "Attention, vous \xeates connect\xe9 mais n\u2019avez pas accept\xe9 les conditions d\u2019utilisation ecoinvent, vous privant ainsi\n                 de **l\u2019acc\xe8s aux impacts d\xe9taill\xe9s** (changement climatique, consommation d'eau, etc). **Vous pouvez\n                 les lire et les accepter depuis [votre espace personnel]({url}).**"))
        ])) : a_("");
    }, xK = function(n) {
        return se(ke(n));
    }, kK = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), wK = je, yK = wK, jK = function(n) {
        return ju(yK(n));
    }, EK = function(n) {
        return A2(t_, "blur", nu(n));
    }, AK = function(n) {
        return A2(t_, "focus", nu(n));
    }, CK = function(n) {
        return A2(t_, "mouseleave", nu(n));
    }, PK = F2(function(n, e) {
        var r;
        return A2(jK, n, E([
            A2(ve, "tabIndex", ut(0)),
            (r = A2(kK, 0, e), A2(t_, "mouseenter", nu(r))),
            CK(A2(kK, 1, e)),
            AK(A2(kK, 0, e)),
            EK(A2(kK, 1, e))
        ]));
    }), TK = F2(function(n, e) {
        return e ? w : n.d3;
    }), SK = F2(function(n, e) {
        switch(e){
            case 0:
                return n.bZ;
            case 1:
                return w;
            default:
                return n.b0;
        }
    }), IK = F2(function(n, e) {
        return Sd(E([
            n.eI,
            A2(TK, n, e.be),
            A2(SK, n, e.bi),
            A2(PK, n.hr, e.mf)
        ]));
    }), OK = F3(function(n, e, r) {
        return v("toast-" + ut(r.mf), A2(n, A2(IK, e, r), function(n) {
            return {
                h5: n.h5,
                mf: n.mf,
                be: n.be,
                bi: n.bi
            };
        }(r)));
    }), qK = F3(function(n, e, r) {
        var t = e;
        return A3(xK, r.fU, r.eK, A2(ju, A2(OK, n, r), t.bn));
    }), LK = cM(2), MK = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, _K = F3(function(n, e, r) {
        var t = n.oW, u = r.h5, a = r.mf;
        return c_({
            hO: k(e, E([
                WM("Toast")
            ])),
            h0: Rr(t(iM(LK(a)))),
            h5: E([
                A2(vF, E([
                    WM("mb-1")
                ]), u.ef)
            ]),
            eb: MK(u.eb),
            eC: u.eC
        });
    }), RK = F2(function(n, e) {
        var r = e;
        return $(r, {
            bZ: k(r.bZ, n),
            b0: k(r.b0, n)
        });
    }), HK = F2(function(n, e) {
        return $(e, {
            eK: k(e.eK, n)
        });
    }), UK = function(n) {
        var e = n.oW, r = n.bo;
        return A3(qK, _K(n), r, A2(RK, E([
            WM("fade")
        ]), A2(HK, E([
            WM("ToastTray")
        ]), {
            bZ: w,
            b0: w,
            d3: w,
            hr: A2(Fu, iM, e),
            eI: w,
            eK: w,
            fU: "div"
        })));
    }, zK = F2(function(n, e) {
        var r, t, u = n.hG;
        return E([
            (r = n, t = r.oW, ZF(r.kU) ? A2(VM, E([
                WM("StagingAlert d-block d-sm-flex justify-content-center align-items-center mt-3")
            ]), E([
                a_("Vous \xeates sur un environnement de recette. "),
                A2(YM, E([
                    i_("button"),
                    WM("btn btn-link"),
                    u_(t(o_("https://ecobalyse.beta.gouv.fr/")))
                ]), E([
                    a_("Retourner vers l'environnement de production")
                ]))
            ])) : a_("")),
            NF(n),
            gK(n),
            A2(hF, n.oW, u),
            $K(n),
            n.ch ? zF(n) : a_(""),
            A2($F, E([
                WM("PageContent bg-white highcharts-light")
            ]), E([
                XF(n),
                UK(n),
                A2(VM, E([
                    s(u, zM) ? WM("") : WM("pt-2 pt-sm-5")
                ]), e)
            ])),
            rK(n)
        ]);
    }), DK = fe("form"), NK = function(n) {
        return v(n, !0);
    }, FK = F2(function(n, e) {
        return A2(r_, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(e));
    }), KK = function(n) {
        return A2(FK, "submit", A2(Zt, NK, nu(n)));
    }, GK = function(n) {
        var e, r = E([
            WM("modal-content")
        ]), t = (e = n.l3).$ ? VM(r) : DK(k(r, E([
            KK(e.a)
        ])));
        return A2(VM, E([
            WM("Modal")
        ]), E([
            A2(VM, E([
                WM("modal d-block fade show"),
                A2(ZM, "tabindex", "-1"),
                A2(ZM, "aria-modal", "true"),
                A2(ZM, "role", "dialog"),
                A2(ZM, "data-dismiss", "modal"),
                A2(t_, "click", A2(Zt, Bi(n.h0), A2(dl, E([
                    "target",
                    "dataset",
                    "dismiss"
                ]), ai)))
            ]), E([
                A2(VM, E([
                    WM("modal-dialog modal-dialog-centered modal-dialog-scrollable"),
                    n_(E([
                        v("modal-xl", !n.oA),
                        v("modal-lg", 2 === n.oA),
                        v("modal-sm", 3 === n.oA),
                        v("modal-fluid", 1 === n.oA)
                    ])),
                    A2(ZM, "aria-modal", "true")
                ]), E([
                    t(E([
                        A2(VM, E([
                            WM("modal-header d-flex justify-content-between align-items-center gap-2")
                        ]), E([
                            A2(d_, E([
                                WM("h5 mb-0"),
                                A2(ZM, "aria-hidden", "true")
                            ]), E([
                                a_("\u2192")
                            ])),
                            A2(VM, E([
                                WM("d-flex flex-column gap-1")
                            ]), E([
                                A2(T_, E([
                                    WM("modal-title lh-sm")
                                ]), E([
                                    a_(n.eC)
                                ])),
                                function() {
                                    var e = n.oI;
                                    if (e.$) return a_("");
                                    var r = e.a;
                                    return A2(VM, E([
                                        WM("text-muted fs-7 fw-normal")
                                    ]), E([
                                        a_(r)
                                    ]));
                                }()
                            ])),
                            A2(YM, E([
                                i_("button"),
                                WM("btn-close"),
                                A2(ZM, "aria-label", "Fermer"),
                                u_(n.h0)
                            ]), w)
                        ])),
                        A2(VM, E([
                            WM("modal-body no-scroll-chaining p-0")
                        ]), n.h5),
                        lf(n.l2) ? a_("") : A2(VM, E([
                            WM("modal-footer bg-light")
                        ]), n.l2)
                    ]))
                ]))
            ])),
            A2(VM, E([
                WM("modal-backdrop fade show")
            ]), w)
        ]));
    }, WK = F2(function(n, e) {
        var r;
        return $(e, {
            kK: k(e.kK, n.bc ? E([
                (r = n.kW, GK({
                    h0: r,
                    h5: E([
                        A2(VM, E([
                            WM("d-flex flex-column align-items-center gap-3 p-4 text-center")
                        ]), E([
                            A2(H_, E([
                                WM("mb-0")
                            ]), E([
                                a_("Vous avez r\xe9alis\xe9 vos premiers calculs de co\xfbt environnemental.\n                              Dites-nous comment cela s\u2019est pass\xe9 en cliquant sur le bouton ci-dessous.")
                            ])),
                            A2(KM, E([
                                WM("d-inline-block"),
                                XM("https://jedonnemonavis.numerique.gouv.fr/Demarches/4223?button=4973"),
                                u_(r),
                                qF("noopener noreferrer"),
                                LF("_blank"),
                                V_("Je donne mon avis - nouvelle fen\xeatre")
                            ]), E([
                                A2(O_, E([
                                    h_("Je donne mon avis"),
                                    WM("img-fluid"),
                                    z_("https://jedonnemonavis.numerique.gouv.fr/static/bouton-bleu-clair.svg")
                                ]), w)
                            ]))
                        ]))
                    ]),
                    l2: w,
                    l3: Hr,
                    m8: r,
                    oA: 4,
                    oI: Hr,
                    eC: "Donnez-nous votre avis !"
                }))
            ]) : w)
        });
    }), VK = F2(function(n, e) {
        var r = e.a;
        return A2(WK, n, {
            kK: A2(zK, n, e.b),
            eC: r + " | Ecobalyse"
        });
    }), JK = E([
        function(n) {
            return n.bR;
        },
        function(n) {
            return n.cV;
        },
        function(n) {
            return n.d5;
        },
        function(n) {
            return n.d4;
        },
        function(n) {
            return n.d6;
        },
        function(n) {
            return n.d7;
        },
        function(n) {
            return n.en;
        },
        function(n) {
            return n.el;
        },
        function(n) {
            return n.em;
        },
        function(n) {
            return n.W;
        },
        function(n) {
            return n.ex;
        },
        function(n) {
            return n.ey;
        },
        function(n) {
            return n.ez;
        },
        function(n) {
            return n.eA;
        },
        function(n) {
            return n.af;
        },
        function(n) {
            return n.eS;
        },
        function(n) {
            return n.eQ;
        },
        function(n) {
            return n.eR;
        }
    ]), BK = function(n) {
        return {
            mK: ft(A2(ks, function(e) {
                return 3 === e(n).$;
            }, JK)),
            bI: ft(JK)
        };
    }, XK = a_("Chargement\u2026"), QK = function(n) {
        return A2(VM, E([
            WM("d-flex flex-column gap-3 justify-content-center align-items-center"),
            A2(OF, "min-height", "25vh")
        ]), E([
            A2(VM, E([
                WM("spinner-border text-primary"),
                A2(ZM, "role", "status")
            ]), w),
            A2(VM, E([
                WM("text-muted")
            ]), E([
                function() {
                    if (n.$) return XK;
                    var e = n.a.mK, r = n.a.bI;
                    return r > 0 ? A2(VM, E([
                        WM("d-flex flex-column gap-1")
                    ]), E([
                        a_("R\xe9cup\xe9ration des donn\xe9es\xa0: " + ut(e) + "/" + ut(r)),
                        A2(VM, E([
                            WM("progress w-100"),
                            A2(ZM, "role", "progressbar"),
                            A2(ZM, "aria-label", "Progression du chargement des donn\xe9es"),
                            A2(ZM, "aria-valuenow", ut(e)),
                            A2(ZM, "aria-valuemin", "0"),
                            A2(ZM, "aria-valuemax", ut(r))
                        ]), E([
                            A2(VM, E([
                                WM("progress-bar"),
                                A2(OF, "width", Bs(100 * e / r) + "%")
                            ]), w)
                        ]))
                    ])) : XK;
                }()
            ]))
        ]));
    }, ZK = function(n) {
        return A2(JM, E([
            WM("pb-5")
        ]), E([
            QK(n)
        ]));
    }, YK = le, nG = YK, eG = A2(JM, E([
        WM("pb-5")
    ]), E([
        A2(BM, E([
            WM("mb-3")
        ]), E([
            a_("Page non trouv\xe9e")
        ])),
        A2(H_, w, E([
            a_("La page que vous avez demand\xe9 n'existe pas.")
        ])),
        A2(KM, E([
            QM($d)
        ]), E([
            a_("Retour \xe0 l'accueil")
        ]))
    ])), rG = function(n) {
        return n.kU + "/api";
    }, tG = function(n) {
        return fe(ke(n));
    }, uG = function(n) {
        return A3(tG, "rapi-doc", E([
            A2(ZM, "spec-url", rG(n)),
            A2(ZM, "server-url", rG(n)),
            A2(ZM, "default-api-server", rG(n)),
            A2(ZM, "theme", "light"),
            A2(ZM, "font-size", "largest"),
            A2(ZM, "load-fonts", "false"),
            A2(ZM, "layout", "column"),
            A2(ZM, "show-info", "false"),
            A2(ZM, "update-route", "false"),
            A2(ZM, "render-style", "view"),
            A2(ZM, "show-header", "false"),
            A2(ZM, "show-components", "true"),
            A2(ZM, "schema-description-expanded", "true"),
            A2(ZM, "allow-authentication", "false"),
            A2(ZM, "allow-server-selection", "false"),
            A2(ZM, "allow-api-list-style-selection", "false"),
            A2(ZM, "allow-authentication", "true"),
            A2(ZM, "persist-auth", "true")
        ]), w);
    }, aG = function(n) {
        var e = F2(function(n, e) {
            return c_({
                hO: w,
                h0: Hr,
                h5: E([
                    A2(vF, E([
                        WM("fs-7")
                    ]), e)
                ]),
                eb: n,
                eC: Hr
            });
        });
        return Rl(n) ? A2(e, 2, A3(Xb, "{route}", MA(ld), "Vous \xeates connect\xe9, vous pouvez utiliser l'API avec un jeton d\xe9di\xe9.\n                Vous pouvez cr\xe9er et g\xe9rer ces jetons depuis votre [compte utilisateur]({route}).")) : A2(e, 1, A3(Xb, "{route}", MA(ld), "Les requ\xeates non authentifi\xe9es \xe0 l'API ne sont pas autoris\xe9es et n\xe9cessitent l\u2019utilisation d\u2019un jeton.\n               **Pour acc\xe9der \xe0 l\u2019API, il est n\xe9cessaire de fournir un jeton d'API**,\n               accessible dans votre [compte utilisateur]({route}) une fois connect\xe9. **Pour acc\xe9der au d\xe9tail\n               des impact, vous devez \xe9galement [accepter les conditions d\u2019utilisation ecoinvent]({route})**."));
    }, iG = E([
        {
            d: "7 septembre 2026",
            e: E([
                "G\xe9n\xe9rique"
            ]),
            eb: "major",
            f: "Ajout de l\u2019API du calculateur g\xe9n\xe9rique pour les p\xe9rim\xe8tres `food2`, `object` et `veli` en version b\xeata\xa0:\n\n- `POST /api/{food2|object|veli}/simulator` calcule les impacts \xe0 partir d\u2019une requ\xeate JSON identique \xe0 celle du simulateur web\n- des points d\u2019acc\xe8s `GET` listent les ressources n\xe9cessaires pour construire une requ\xeate (ingr\xe9dients/mat\xe9riaux, pays, cat\xe9gories, proc\xe9d\xe9s)\n"
        },
        {
            d: "23 f\xe9vrier 2026",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Ajout de l'impact des accessoires textiles dans les r\xe9ponses de l\u2019API."
        },
        {
            d: "17 f\xe9vrier 2026",
            e: E([
                "Textile",
                "Alimentaire",
                "Objets"
            ]),
            eb: "major",
            f: A3(Xb, "{route}", MA(ld), "- Les requ\xeates non authentifi\xe9es \xe0 l'API ne sont plus autoris\xe9es et n\xe9cessitent l\u2019utilisation d\u2019un jeton.\n               **Pour acc\xe9der \xe0 l\u2019API, il est maintenant n\xe9cessaire de fournir un jeton d'API**,\n               accessible dans votre [compte utilisateur]({route}) une fois connect\xe9.\n\n- **Pour acc\xe9der au d\xe9tail des impact, vous devez \xe9galement [accepter les conditions d\u2019utilisation ecoinvent]({route})**.\n")
        },
        {
            d: "11 d\xe9cembre 2025",
            e: E([
                "Textile",
                "Alimentaire",
                "Objets"
            ]),
            eb: "major",
            f: "Suppression de l\u2019indicateur PEF obsol\xe8te dans les r\xe9ponses de l\u2019API."
        },
        {
            d: "22 juillet 2025",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe9trage de la surface d'impression interdit d\xe9sormais les valeurs sup\xe9rieures \xe0 80%."
        },
        {
            d: "9 juillet 2025",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre `traceability` est supprim\xe9."
        },
        {
            d: "15 avril 2025",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "Afin de permettre une meilleure gestion des donn\xe9es et d'\xe9viter des calculs redondants, **Les identifiants des proc\xe9d\xe9s alimentaires (transformation ou emballage) ont \xe9t\xe9 modifi\xe9s.** Les anciens identifiants ne sont plus valides et doivent \xeatre remplac\xe9s par les nouveaux. Les identifiants des ingr\xe9dients sont inchang\xe9s."
        },
        {
            d: "26 f\xe9vrier 2025",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Les points d'entr\xe9e utilisant les param\xe8tres pass\xe9s en query string pour effectuer des calculs\n      sont d\xe9pr\xe9ci\xe9s, leur \xe9quivalent `POST`/`JSON` leur \xe9tant d\xe9sormais pr\xe9f\xe9r\xe9s\xa0:\n- `GET /food` est d\xe9pr\xe9ci\xe9\n- `GET /textile/simulator` est d\xe9pr\xe9ci\xe9\n- `GET /textile/simulator/{impact}` est d\xe9pr\xe9ci\xe9\n- `GET /textile/simulator/detailed` est d\xe9pr\xe9ci\xe9\n\n                **Note: ces points d'entr\xe9e seront supprim\xe9s dans la prochaine version majeure de l'application.**\n\n                D'autre part et par souci de coh\xe9rence et de consistance, certains noms de champs utilisent\n                d\xe9sormais le `camelCase` dans les r\xe9ponses API\xa0:\n- `elec_kWh` devient `elecKWh`\n- `heat_MJ` devient `heatMJ`"
        },
        {
            d: "17 f\xe9vrier 2025",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre `dyeingMedium`, qui permettait de s\xe9lectionner le support de teinture,\n                est remplac\xe9 par le nouveau param\xe8tre `dyeingProcessType` permettant de sp\xe9cifier\n                le type de teinture directement (continue, discontinue, moyenne)."
        },
        {
            d: "2 janvier 2025",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Un nouveau param\xe8tre `trims` est disponible dans l'API textile pour pr\xe9ciser les\n                accessoires pr\xe9sents sur le v\xeatement. Un nouveau point d'entr\xe9e `/textile/trims`\n                a \xe9galement \xe9t\xe9 ajout\xe9 pour lister les accessoires disponibles."
        },
        {
            d: "5 d\xe9cembre 2024",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "Les identifiants de proc\xe9d\xe9s alimentaires sont d\xe9sormais au format UUID. Le pr\xe9cedent champ\n                `code` pour lier les proc\xe9d\xe9s d'emballage et de transformation est remplac\xe9 par la cl\xe9 `id`\n                exploitant ce format."
        },
        {
            d: "13 novembre 2024",
            e: w,
            eb: "minor",
            f: "Ajout d'une [FAQ](/#/pages/api-faq) d\xe9di\xe9e \xe0 l'API."
        },
        {
            d: "29 octobre 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Ajout du champ `impactsWithoutDurability` dans la r\xe9ponse des calculs d\xe9taill\xe9s. Ce champ a le m\xeame format que le champ `impacts` mais contient les scores avant application du coefficient de durabilit\xe9."
        },
        {
            d: "5 septembre 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Ajout du champ `physicalDurability` qui permet de pr\xe9ciser la durabilit\xe9 physique d'un v\xeatement."
        },
        {
            d: "29 ao\xfbt 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: 'Ajout du champ bool\xe9en `upcycled` qui permet de pr\xe9ciser si un v\xeatement est remanufactur\xe9.\n                En pareil cas, les \xe9tape Mati\xe8res, Filature, Tissage/Tricotage et Ennoblissement sont\n                d\xe9sactiv\xe9es et la complexit\xe9 en confection est automatiquement positionn\xe9e sur "\xc9lev\xe9e".\n             '
        },
        {
            d: "28 ao\xfbt 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: 'Les champs `countryFabric`, `countryDyeing` at `countryMaking` sont d\xe9sormais optionnels et prennent pour valeur par d\xe9faut celles du *Pays inconnu* (voir la\n               [documentation m\xe9thodologique](https://fabrique-numerique.gitbook.io/ecobalyse/textile/cycle-de-vie-des-produits-textiles/transport#pays-par-defaut-etapes-de-transformation)).\n               Techniquement, stipuler le code `"---"` pour ces param\xe8tres ou les omettre revient d\xe9sormais au m\xeame.\n            '
        },
        {
            d: "18 juillet 2024",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le champ `marketingDuration` a \xe9t\xe9 supprim\xe9 et n'est d\xe9sormais plus op\xe9rant.\n            "
        },
        {
            d: "6 juin 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Le champ `fabricProcess` n'est plus requis et prend d\xe9sormais la valeur par\n            d\xe9faut associ\xe9e \xe0 la cat\xe9gorie de produit.\n            "
        },
        {
            d: "10 avril 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Les compl\xe9ments sont d\xe9sormais expos\xe9s de fa\xe7on \xe0 mieux mat\xe9rialiser leurs\n               effets\xa0; une d\xe9gradation est d\xe9sormais exprim\xe9e par un nombre positif\n               (qui additionn\xe9e au co\xfbt le fait augmenter), tandis qu'une am\xe9lioration\n               s'exprime par une valeur n\xe9gative (qui additionn\xe9e au co\xfbt le fait baisser).\n            "
        },
        {
            d: "9 avril 2024",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "En mode d\xe9taill\xe9, le co\xfbt environnemental d'une \xe9tape du cycle de vie textile\n               inclut d\xe9sormais l'impact des compl\xe9ments associ\xe9s."
        },
        {
            d: "25 mars 2024",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "La documentation de l'API alimentaire est temporairement mise hors-ligne."
        },
        {
            d: "21 f\xe9vrier 2024",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre `ennoblingHeatSourceParam` est supprim\xe9. La source\n            de chaleur est donn\xe9e par la zone France, Europe ou World,\n            calcul\xe9e depuis le pays."
        },
        {
            d: "31 janvier 2024",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre `durability` r\xe9cemment introduit est remplac\xe9 par 5 nouveaux\n            param\xe8tres permettant de calculer cet indice\xa0: `business`, `marketingDuration`,\n            `numberOfReferences`, `price`, `repairCost` et `traceability`."
        },
        {
            d: "16 janvier 2024",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "Les param\xe8tres permettant de sp\xe9cifier des compl\xe9ments (ou bonus)\n            personnalis\xe9s par ingr\xe9dient ont \xe9t\xe9 retir\xe9s, il sont remplac\xe9s par la\n            gestion automatis\xe9e des services \xe9cosyst\xe9miques."
        },
        {
            d: "15 janvier 2024",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Les param\xe8tres `quality` et `reparability` on \xe9t\xe9 supprim\xe9s. Il sont\n            remplac\xe9s par le champ `durability`."
        },
        {
            d: "21 d\xe9cembre 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Le param\xe8tre `makingDeadStock` a \xe9t\xe9 rajout\xe9 pour repr\xe9senter\n            le taux de stocks dormants lors de la phase de confection. La valeur par d\xe9faut\n            est de 15% (0.15)."
        },
        {
            d: "20 d\xe9cembre 2023",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre `disabledFading` a \xe9t\xe9 renomm\xe9 en `fading` et repr\xe9sente\n            l'oppos\xe9. S\xe9lectionner `true` pour **activer** le d\xe9lavage."
        },
        {
            d: "20 d\xe9cembre 2023",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre optionnel `knittingProcess` a \xe9t\xe9 remplac\xe9 par le\n            param\xe8tre requis `fabricProcess`, qui prend en compte les diff\xe9rents\n            proc\xe9d\xe9s de tricotage ainsi que le proc\xe9d\xe9 de tissage."
        },
        {
            d: "19 d\xe9cembre 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Le param\xe8tre `disabledFading` peut maintenant \xeatre configur\xe9 pour\n            tous les produits."
        },
        {
            d: "9 novembre 2023",
            e: E([
                "Alimentaire",
                "Textile"
            ]),
            eb: "minor",
            f: "La liste des mati\xe8res premi\xe8res textiles et des ingr\xe9dients\n            alimentaires peuvent maintenant \xeatre vides."
        },
        {
            d: "24 octobre 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "Les identifiants de certains proc\xe9d\xe9s ont \xe9t\xe9 modifi\xe9s:\n\n- `durumwheat-semolina` devient `durum-wheat-semolina`;\n- `durumwheat` devient `durum-wheat`;\n- `Flank-steak` devient `flank-steak`;\n- `frenchbean` devient `french-bean`;\n- `huilecolza` devient `rapeseed-oil`;\n- `huilecolza-organic` devient `rapeseed-oil-organic`;\n- `soybeanBRdeforestation` devient `soybean-br-deforestation`;\n- `soybeanBRno-deforestation` devient `soybean-br-no-deforestation`;\n- `sunfloweroil` devient `sunflower-oil`;\n- `sunfloweroil-organic` devient `sunflower-oil-organic`;\n- `tapwater` devient `tap-water`;\n- `comte-AOP` devient `comte-aop`.\n"
        },
        {
            d: "12 octobre 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Le param\xe9trage optionnel `country` du code de pays d'origine pour la\n            mati\xe8re a \xe9t\xe9 rajout\xe9."
        },
        {
            d: "4 septembre 2023",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le choix de valeurs pour le param\xe9trage `knittingProcess` a chang\xe9.\n            Il faut maintenant choisir entre\xa0:\n\n- `mix` : Tricotage moyen (mix de m\xe9tiers circulaire & rectiligne)\n- `fully-fashioned` : Tricotage fully-fashioned / seamless\n- `integral` : Tricotage int\xe9gral / whole garment\n- `circular` : Tricotage circulaire, inventaire d\xe9sagr\xe9g\xe9\n- `straight` : Tricotage rectiligne, inventaire d\xe9sagr\xe9g\xe9\n"
        },
        {
            d: "29 ao\xfbt 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Le param\xe9trage optionnel `spinning` du proc\xe9d\xe9 de filature ou filage pour la\n            mati\xe8re a \xe9t\xe9 rajout\xe9.\n"
        },
        {
            d: "6 juillet 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "Le param\xe9trage de la variante a \xe9t\xe9 supprim\xe9 du mode de requ\xeatage en query string;\n            l\xe0 o\xf9 on passait `?ingredients=carrot;100;organic;ES` pour 100g de carrot bio\n            d'espagne, on passe d\xe9sormais `?ingredients=carrot;100;ES`; le segment d\xe9finissant\n            la variante \u2014 `organic` \u2014 a \xe9t\xe9 l\xe9gitimement supprim\xe9.\n"
        },
        {
            d: "25 mai 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "major",
            f: "Le param\xe8tre `category`, qui permettait d'\xe9tablir des scores intra-cat\xe9goriques,\n            a \xe9t\xe9 supprim\xe9. De la m\xeame fa\xe7on, les notes lettr\xe9es et les scores sur 100 ont \xe9t\xe9\n            retir\xe9s des r\xe9sultats. Le scoring ne contient d\xe9sormais par cons\xe9quent que les\n            impacts par aires de protection.\n"
        },
        {
            d: "17 mai 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "minor",
            f: "Le calcul de l'\xe9coscore dans le r\xe9sultat de l'API alimentaire de constructeur\n            de recette prend maintenant correctement en compte les bonus des ingr\xe9dients.\n\n            Par ailleurs, le bonus total a \xe9t\xe9 rajout\xe9 sous l'entr\xe9e `recipe.totalBonusImpact`.\n"
        },
        {
            d: "16 mai 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Les points d'acc\xe8s de simulation textile acceptent d\xe9sormais le verbe\n            `POST` assorti d'une requ\xeate au format JSON.\n"
        },
        {
            d: "3 mai 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "minor",
            f: "Un nouveau point d'acc\xe8s `POST /api/food/recipe` a \xe9t\xe9 cr\xe9\xe9,\n            acceptant les requ\xeates au format JSON.\n"
        },
        {
            d: "28 avril 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Le param\xe8tre permettant de choisir la complexit\xe9 de la confection\n            `makingComplexity` a \xe9t\xe9 rajout\xe9.\n\n            D'autre part, le param\xe8tre de titrage `yarnSize` peut maintenant \xeatre exprim\xe9\n            avec une unit\xe9, permettant de sp\xe9cifier le titrage en d\xe9citex (Dtex).\n"
        },
        {
            d: "25 avril 2023",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: 'Le param\xe8tre de choix du proc\xe9d\xe9 de tricotage `knittingProcess`\n            permettant de choisir un proc\xe9d\xe9 autre que le "mix" par d\xe9faut a \xe9t\xe9\n            rajout\xe9.\n'
        },
        {
            d: "13 avril 2023",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le param\xe8tre de simulation `picking` permettant de d\xe9finir le\n            duitage a \xe9t\xe9 supprim\xa0; il est remplac\xe9 par un nouveau param\xe8tre\n            `yarnSize`, permettant de d\xe9finir le titrage du fil utilis\xe9 pour\n            l'\xe9tape de tissage, exprim\xe9 en *num\xe9ro m\xe9trique* (`Nm`).\n\n            Le num\xe9ro m\xe9trique indique un nombre de kilom\xe8tres de fil correspondant\n            \xe0 un poids d'un kilogramme (ex\xa0: 50Nm = 50km de ce fil p\xe8sent 1 kg).\n"
        },
        {
            d: "12 avril 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "minor",
            f: "Il est d\xe9sormais possible de param\xe9trer les bonus appliqu\xe9s \xe0\n            la diversit\xe9 agricole, aux infrastructures agro-\xe9cologiques et\n            aux conditions d'\xe9levage dans les param\xe8tres d'ingr\xe9dient.\n"
        },
        {
            d: "20 mars 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "minor",
            f: "Le mode de distribution a \xe9t\xe9 rendu facultatif\n"
        },
        {
            d: "8 mars 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "minor",
            f: "Une \xe9tape a \xe9t\xe9 ajout\xe9e au constructeur de recette pour tenir\n            compte de l'impact de la consommation. Un nouveau param\xe8tre\n            optionnel `preparation` a \xe9t\xe9 ajout\xe9 sur le point d'entr\xe9e\n            `/food/recipe`, qui accepte une liste de techniques de pr\xe9paration\n            (`freezing` pour cong\xe9lation, `frying` pour friture, etc.)\n"
        },
        {
            d: "21 f\xe9vrier 2023",
            e: E([
                "Alimentaire"
            ]),
            eb: "minor",
            f: "Une \xe9tape a \xe9t\xe9 ajout\xe9e au constructeur de recette pour tenir\n            compte de l'impact de la distribution. Elle se mat\xe9rialise par un\n            param\xe8tre optionnel `distribution` sur le point d'entr\xe9e\n            `/food/recipe` qui prend `ambient` comme valeur par d\xe9faut pour\n            indiquer qu'il s'agit d'une stockage sec \xe0 temp\xe9rature ambiante, ou\n            `fresh` pour un produit r\xe9frig\xe9r\xe9, ou `frozen` pour un produit\n            surgel\xe9.\n"
        },
        {
            d: "21 d\xe9cembre 2022",
            e: E([
                "Alimentaire",
                "Textile"
            ]),
            eb: "major",
            f: "La liste des pays est d\xe9sormais distinctement accessible en fonction du domaine\xa0:\n\n- pour le textile, au point d'entr\xe9e `textile/countries`\n- pour l'alimentaire, au point d'entr\xe9e `food/countries`\n\nDe la m\xeame fa\xe7on, l'ensemble des points d'entr\xe9e textile sont d\xe9sormais pr\xe9fix\xe9s par `textile`, en\ncoh\xe9rence avec ceux de l'alimentaire qui le sont par `food`.\n\nL'ancien point d'entr\xe9e `/countries` est donc redirig\xe9 vers `textile/countries`.\n"
        },
        {
            d: "30 novembre 2022",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Un nouveau param\xe8tre `ennoblingHeatSource` a \xe9t\xe9 ajout\xe9, permettant si besoin de pr\xe9ciser\n            la source de chaleur \xe0 l'\xe9tape d'ennoblissement\xa0; il peut prendre les valeurs\n            suivantes\xa0:\n\n- `coal`: Vapeur \xe0 partir de charbon\n- `naturalgas`: Vapeur \xe0 partir de gaz naturel\n- `lightfuel`: Vapeur \xe0 partir de fioul l\xe9ger\n- `heavyfuel`: Vapeur \xe0 partir de fioul lourd\n\nEn l'absence d'utilisation explicite du param\xe8tre, la source de chaleur utilis\xe9e sera celle du mix r\xe9gional.\n"
        },
        {
            d: "22 novembre 2022",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Un nouveau param\xe8tre `printing` a \xe9t\xe9 ajout\xe9, permettant si besoin de pr\xe9ciser\n            le proc\xe9d\xe9 d'impression utilis\xe9 sur le v\xeatement\xa0; les valeurs possibles\n            sont\xa0:\n\n- `pigment`\xa0: Impression pigmentaire\n- `substantive`\xa0: Impression Fix\xe9-Lav\xe9\n\nD'autre part, le param\xe8tre `surfaceMass` permettant de d\xe9finir le grammage de l'\xe9toffe est\nd\xe9sormais op\xe9rant quand le param\xe8tre `printing` est fourni\xa0; en effet, le proc\xe9d\xe9 d'impression\nest appliqu\xe9 en fonction de la surface du v\xeatement, calcul\xe9e au moyen de cette valeur et\nqui peut d\xe9sormais varier.\n\nEnfin, l'identification de l'\xe9tape d'ennoblissement a \xe9t\xe9 renomm\xe9e de `dyeing` \xe0 `ennobling`. Cela\nimpacte le param\xe8tre `disabledSteps` qui n'accepte d\xe9sormais plus `dyeing` mais bien `ennobling` en\nremplacement.\n"
        },
        {
            d: "14 novembre 2022",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Un nouveau param\xe8tre `dyeingMedium` a \xe9t\xe9 ajout\xe9 pour permettre de pr\xe9ciser le\n            support de teinture, parmi les trois valeurs possibles suivantes\xa0:\n\n- `article` lorsque la teinture est effectu\xe9e sur pi\xe8ce\xa0;\n- `fabric` lorsqu'elle est effectu\xe9e sur le tissu\xa0;\n- `yarn` lorsqu'elle est effectu\xe9e sur fil.\n"
        },
        {
            d: "9 novembre 2022",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le support du param\xe8tre `dyeingWeighting` a \xe9t\xe9 supprim\xe9. Son utilisation est\n            d\xe9sormais inop\xe9rante."
        },
        {
            d: "15 septembre 2022",
            e: E([
                "Alimentaire",
                "Textile"
            ]),
            eb: "major",
            f: "Les scores PEF renvoy\xe9s par l'API sont d\xe9sormais exprim\xe9s en `\xb5Pt` (micropoints)\n            au lieu de `mPt` (millipoints).\n\n            Pour m\xe9moire, `1 Pt = 1\u202F000 mPt = 1\u202F000\u202F000 \xb5Pt`."
        },
        {
            d: "5 juillet 2022",
            e: E([
                "Textile"
            ]),
            eb: "minor",
            f: "Un nouveau param\xe8tre optionnel `disabledSteps` a \xe9t\xe9 ajout\xe9 aux endpoints de\n            simulation, permettant de d\xe9finir la liste des \xe9tapes du cycle de vie \xe0 d\xe9sactiver,\n            s\xe9par\xe9e par des virgules. Chaque \xe9tape est identifi\xe9e par un code\xa0:\n- `material`: Mati\xe8re\n- `spinning`: Filature\n- `fabric`: Tissage/Tricotage\n- `ennobling`: Ennoblissement\n- `making`: Confection\n- `distribution`: Distribution\n- `use`: Utilisation\n- `eol`: Fin de vie\n\n            Par exemple, pour d\xe9sactiver les \xe9tapes de filature et d'ennoblissement, on peut passer\n            `disabledSteps=spinning,ennobling`."
        },
        {
            d: "2 juin 2022",
            e: E([
                "Textile"
            ]),
            eb: "major",
            f: "Le format de d\xe9finition de la liste des mati\xe8res a \xe9volu\xe9\xa0;\n            l\xe0 o\xf9 vous d\xe9finissiez une liste de mati\xe8res en y incluant le pourcentage de mati\xe8re\n            recycl\xe9e, par ex. `materials[]=coton;0.3;0.5&\u2026` pour *30% coton \xe0 50% recycl\xe9*,\n            vous devez d\xe9sormais \xe9crire `materials[]=coton;0.15&materials[]=coton-rdp;0.15&\u2026`\n            (soit *15% coton, 15% coton recycl\xe9*, ce qui revient au m\xeame)."
        }
    ]), cG = function(n) {
        return {
            $: 16,
            a: n
        };
    }, oG = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;)switch(r.a.$){
            case 0:
                if (r.b.$) break n;
                return !0;
            case 3:
                switch(r.b.$){
                    case 3:
                    case 1:
                    case 2:
                        return !0;
                    default:
                        break n;
                }
            case 2:
            case 1:
                if (3 === r.b.$) return !0;
                break n;
            case 5:
                if (4 === r.b.$) return !0;
                break n;
            case 4:
                switch(r.b.$){
                    case 5:
                    case 4:
                    case 6:
                        return !0;
                    default:
                        break n;
                }
            case 6:
                if (4 === r.b.$) return !0;
                break n;
            case 7:
                switch(r.b.$){
                    case 7:
                    case 8:
                        return !0;
                    default:
                        break n;
                }
            default:
                if (7 === r.b.$) return !0;
                break n;
        }
        return !1;
    }), fG = {
        $: 8
    }, sG = {
        $: 13
    }, lG = function(n) {
        return {
            $: 18,
            a: n
        };
    }, dG = E([
        A2(vF, w, A3(Xb, "{url_privacy}", MA(md("politique-de-confidentialite")), A3(Xb, "{url_ecoinvent}", MA(md("cgu-ecoinvent")), "Pour acc\xe9der aux impacts d\xe9taill\xe9s, je m\u2019engage \xe0 respecter les [Conditions d\u2019utilisation des donn\xe9es \xab\u202Fecoinvent\u202F\xbb et \xab\u202FBase Empreinte\u202F\xbb pour l\u2019outil Ecobalyse]({url_ecoinvent})\n         et accepte que les informations recueillies sur ce formulaire soient enregistr\xe9es dans un fichier\n         informatis\xe9 par l\u2019ADEME pour\u202F:\n\n           - l\u2019authentification des utilisateurs sur la plateforme web ou via l\u2019API afin d\u2019acc\xe9der aux impacts d\xe9taill\xe9s (ex: changement climatique),\n\n           - la d\xe9livrance de licences nominatives par ecoinvent aux utilisateurs des donn\xe9es ecoinvent via Ecobalyse (les donn\xe9es sont transmises si l\u2019utilisateur consent au moins une fois via son compte Ecobalyse dans l\u2019ann\xe9e).\n\n         Pour plus d\u2019informations veuillez consulter la [politique de confidentialit\xe9]({url_privacy}).")))
    ]), bG = GM("htmlFor"), mG = fe("label"), pG = F2(function(n, e) {
        return !A2(ra, n, e).$;
    }), vG = A2(dl, E([
        "target",
        "checked"
    ]), qu), gG = function(n) {
        return A2(t_, "change", A2(Zt, n, vG));
    }, hG = GM("placeholder"), $G = k_("required"), xG = fe("small"), kG = F2(function(n, e) {
        var r = A2(ra, n, e);
        if (r.$) return a_("");
        var t = r.a;
        return A2(VM, E([
            WM("invalid-feedback")
        ]), E([
            a_(t)
        ]));
    }), wG = function(n) {
        switch(n.$){
            case 0:
                return "Association\xa0: " + n.a;
            case 1:
                return "Entreprise\xa0: " + n.a + "(" + n.b + ")";
            case 2:
                return "\xc9tablissement\xa0: " + n.a;
            case 3:
                return "Particulier";
            case 4:
                return "Collectivit\xe9\xa0: " + n.a;
            case 5:
                return "M\xe9dia\xa0: " + n.a;
            case 6:
                return "\xc9tablissement public\xa0: " + n.a;
            default:
                return "\xc9tudiant\xb7e\xa0: " + n.a;
        }
    }, yG = F3(function(n, e, r) {
        var t = n.fZ;
        return A2(VM, w, E([
            A2(DK, E([
                KK(sG),
                WM("mt-3 view-account-form")
            ]), E([
                A2(VM, E([
                    WM("row")
                ]), E([
                    A2(VM, E([
                        WM("col-md-6 mb-3")
                    ]), E([
                        A2(mG, E([
                            bG("email"),
                            WM("form-label")
                        ]), E([
                            a_("Adresse email")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            kF("email"),
                            hG("nom@example.com"),
                            vK(t.c1),
                            E_(!0)
                        ]), w),
                        A2(xG, E([
                            WM("d-flex align-items-center gap-1 text-muted")
                        ]), E([
                            l_,
                            a_("Vous ne pouvez pas encore modifier votre email")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-md-6  mb-3")
                    ]), E([
                        A2(VM, E([
                            WM("form-label")
                        ]), E([
                            a_("Organisation")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            kF("organization"),
                            hG("ACME Inc."),
                            vK(wG(t.nP.ck)),
                            E_(!0)
                        ]), w),
                        A2(xG, E([
                            WM("d-flex align-items-center gap-1 text-muted")
                        ]), E([
                            l_,
                            a_("Vous ne pouvez pas modifier votre organisation")
                        ]))
                    ]))
                ])),
                A2(VM, E([
                    WM("row")
                ]), E([
                    A2(VM, E([
                        WM("col-md-6 mb-3")
                    ]), E([
                        A2(mG, E([
                            bG("firstName"),
                            WM("form-label")
                        ]), E([
                            a_("Pr\xe9nom")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            n_(E([
                                v("is-invalid", A2(pG, "firstName", r))
                            ])),
                            kF("firstName"),
                            hG("Jos\xe9phine"),
                            vK(e.aC),
                            dK(function(n) {
                                return lG($(e, {
                                    aC: n
                                }));
                            }),
                            $G(!0)
                        ]), w),
                        A2(kG, "firstName", r)
                    ])),
                    A2(VM, E([
                        WM("col-md-6 mb-3")
                    ]), E([
                        A2(mG, E([
                            bG("lastName"),
                            WM("form-label")
                        ]), E([
                            a_("Nom")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            n_(E([
                                v("is-invalid", A2(pG, "lastName", r))
                            ])),
                            kF("lastName"),
                            hG("Durand"),
                            vK(e.aD),
                            dK(function(n) {
                                return lG($(e, {
                                    aD: n
                                }));
                            }),
                            $G(!0)
                        ]), w),
                        A2(kG, "lastName", r)
                    ]))
                ])),
                A2(VM, E([
                    WM("mb-3 form-check")
                ]), E([
                    A2(q_, E([
                        i_("checkbox"),
                        WM("form-check-input"),
                        n_(E([
                            v("is-invalid", A2(pG, "emailOptin", r))
                        ])),
                        kF("emailOptin"),
                        w_(e.aY),
                        gG(function(n) {
                            return lG($(e, {
                                aY: n
                            }));
                        })
                    ]), w),
                    A2(mG, E([
                        WM("form-check-label"),
                        bG("emailOptin")
                    ]), E([
                        a_("J\u2019accepte de recevoir des informations de la part d\u2019Ecobalyse par email.")
                    ])),
                    A2(kG, "emailOptin", r)
                ])),
                A2(VM, E([
                    WM("mb-3 form-check")
                ]), E([
                    A2(q_, E([
                        i_("checkbox"),
                        WM("form-check-input"),
                        n_(E([
                            v("is-invalid", A2(pG, "termsAccepted", r))
                        ])),
                        kF("termsAccepted"),
                        w_(e.bX),
                        gG(function(n) {
                            return lG($(e, {
                                bX: n
                            }));
                        })
                    ]), w),
                    A2(mG, E([
                        WM("form-check-label"),
                        bG("termsAccepted")
                    ]), dG),
                    A2(kG, "termsAccepted", r)
                ])),
                A2(VM, E([
                    WM("d-grid")
                ]), E([
                    A2(YM, E([
                        i_("submit"),
                        WM("btn btn-primary"),
                        E_(s(e, Rp) || !RT(r)),
                        A2(ZM, "data-testid", "auth-signup-submit")
                    ]), E([
                        a_("Mettre \xe0 jour mes informations")
                    ]))
                ]))
            ])),
            A2(I_, E([
                WM("mt-3 mb-0")
            ]), w),
            A2(VM, E([
                WM("d-flex justify-content-center align-items-center gap-3")
            ]), E([
                A2(KM, E([
                    QM($d)
                ]), E([
                    a_("Retour \xe0 l\u2019accueil")
                ])),
                A2(YM, E([
                    i_("button"),
                    WM("btn btn-primary my-3"),
                    u_(fG)
                ]), E([
                    a_("D\xe9connexion")
                ]))
            ]))
        ]));
    }), jG = function(n) {
        return {
            $: 1,
            a: n
        };
    }, EG = s_("clipboard"), AG = k_("readOnly"), CG = function(n) {
        return {
            $: 4,
            a: n
        };
    }, PG = A3(go, 1, "dd/MM/yyyy \xe0 HH:mm:ss (UTC)", $o), TG = s_("warning"), SG = function(n) {
        return {
            $: 2,
            a: n
        };
    }, IG = {
        $: 2
    }, OG = s_("trash"), qG = E([
        0,
        1,
        2
    ]), LG = s_("check"), MG = function(n) {
        var e = A2(at, ", ", A2(ju, A2(Fu, bs, qx), qG));
        return A2(_c, !1, A2(Lc, function(n) {
            var e = n.fZ;
            return e.iU || e.mt;
        }, Hl(n))) ? A2(H_, E([
            WM("alert alert-success d-flex align-items-center gap-1")
        ]), E([
            LG,
            A2(d_, w, E([
                a_("Votre compte dispose d\u2019un acc\xe8s b\xeata \xe0 "),
                A2(KM, E([
                    QM(sd)
                ]), E([
                    a_("l\u2019API g\xe9n\xe9rique")
                ])),
                a_(" (" + e + ").")
            ]))
        ])) : a_("");
    }, _G = F2(function(n, e) {
        switch(e.$){
            case 2:
                var r = e.a;
                return A2(H_, E([
                    WM("alert alert-danger")
                ]), E([
                    a_("Erreur lors de la r\xe9cup\xe9ration des jetons d\u2019API : " + Bq(r))
                ]));
            case 1:
                return QK(Hr);
            case 0:
                return a_("");
            default:
                var t = e.a;
                return A2(VM, w, E([
                    MG(n),
                    lf(t) ? A2(H_, w, E([
                        a_("Aucun jeton d\u2019API actif.")
                    ])) : A2(VM, E([
                        WM("table-responsive border shadow-sm"),
                        A2(ZM, "data-testid", "auth-api-tokens-table")
                    ]), E([
                        A2(N_, E([
                            WM("table table-striped mb-0")
                        ]), E([
                            A2(W_, w, E([
                                A2(J_, w, E([
                                    A2(G_, w, E([
                                        a_("ID")
                                    ])),
                                    A2(G_, E([
                                        WM("text-end")
                                    ]), E([
                                        a_("Date de derni\xe8re utilisation")
                                    ])),
                                    A2(G_, E([
                                        WM("text-end")
                                    ]), w)
                                ]))
                            ])),
                            A2(F_, w, A2(ju, function(n) {
                                return A2(J_, w, E([
                                    A2(K_, E([
                                        WM("align-middle")
                                    ]), E([
                                        a_(n.mf)
                                    ])),
                                    A2(K_, E([
                                        WM("align-middle text-end")
                                    ]), E([
                                        a_(A2(_c, "Jamais utilis\xe9", A2(Lc, PG, n.mE)))
                                    ])),
                                    A2(K_, E([
                                        WM("align-middle text-end")
                                    ]), E([
                                        A2(YM, E([
                                            WM("btn btn-sm btn-danger"),
                                            V_("Supprimer ce jeton"),
                                            u_(cG(SG(n)))
                                        ]), E([
                                            OG
                                        ]))
                                    ]))
                                ]));
                            }, t))
                        ]))
                    ])),
                    A2(VM, E([
                        WM("d-grid mt-3")
                    ]), E([
                        A2(YM, E([
                            WM("btn btn-primary"),
                            u_(IG)
                        ]), E([
                            a_("Cr\xe9er un jeton d\u2019API")
                        ]))
                    ]))
                ]));
        }
    }), RG = {
        $: 11
    }, HG = function(n) {
        return {
            $: 17,
            a: n
        };
    }, UG = c_({
        hO: w,
        h0: Hr,
        h5: E([
            A2(vF, w, "Notre politique de confidentialit\xe9 de donn\xe9es personnelles a chang\xe9 depuis le **9 d\xe9cembre 2025**.\n            Pour continuer \xe0 acc\xe9der aux impacts d\xe9taill\xe9s, connectez-vous et consentez au traitement particulier de vos\n            donn\xe9es personnelles li\xe9es \xe0 l\u2019usage des impacts d\xe9taill\xe9s.")
        ]),
        eb: 1,
        eC: Hr
    }), zG = F2(function(n, e) {
        return A2(VM, E([
            WM("d-flex flex-column gap-3")
        ]), E([
            UG,
            A2(DK, E([
                KK(RG),
                A2(ZM, "data-testid", "auth-magic-link-form")
            ]), E([
                A2(H_, w, E([
                    a_(" Recevez un lien de connexion en soumettant votre adresse email ci-dessous.\n                       ")
                ])),
                A2(VM, E([
                    WM("mb-3")
                ]), E([
                    A2(mG, E([
                        bG("email"),
                        WM("form-label")
                    ]), E([
                        a_("Adresse email")
                    ])),
                    A2(q_, E([
                        i_("email"),
                        WM("form-control"),
                        kF("email"),
                        hG("nom@example.com"),
                        vK(n),
                        dK(HG),
                        $G(!0)
                    ]), w)
                ])),
                A2(VM, E([
                    WM("d-grid")
                ]), E([
                    A2(YM, E([
                        i_("submit"),
                        WM("btn btn-primary"),
                        E_("" === n || !RT(AS(n)) || s(e, Na)),
                        A2(ZM, "data-testid", "auth-magic-link-submit")
                    ]), E([
                        a_(1 === e.$ ? "Email de connexion en cours d\u2019envoi\u2026" : "Recevoir un email de connexion")
                    ]))
                ]))
            ]))
        ]));
    }), DG = {
        $: 9
    }, NG = {
        $: 15
    }, FG = function(n) {
        return {
            $: 19,
            a: n
        };
    }, KG = E([
        A2(vF, w, A3(Xb, "{url_privacy}", MA(md("politique-de-confidentialite")), A3(Xb, "{url_cgu}", nK, " Je m\u2019engage \xe0 respecter les [CGU d\u2019Ecobalyse]({url_cgu}) et accepte que l\u2019ADEME collecte et traite mes donn\xe9es \xe0 caract\xe8re personnel pour cr\xe9er un compte et me connecter \xe0 Ecobalyse, mesurer la fr\xe9quentation sur le site, suivre les erreurs informatiques et techniques. Pour plus d\u2019informations veuillez consulter la [politique de confidentialit\xe9]({url_privacy}).")))
    ]), GG = E([
        v("association", "Association"),
        v("business", "Entreprise"),
        v("education", "Enseignement/Recherche"),
        v("individual", "Particulier"),
        v("localAuthority", "Collectivit\xe9 ou EPCI"),
        v("media", "M\xe9dia"),
        v("public", "Autre \xe9tablissement public et \xc9tat"),
        v("student", "\xc9tudiant\xb7e")
    ]), WG = F2(function(n, e) {
        switch(e.$){
            case 0:
                return tg(n);
            case 1:
                return A2(ug, n, e.b);
            case 2:
                return ag(n);
            case 3:
                return ig;
            case 4:
                return cg(n);
            case 5:
                return og(n);
            case 6:
                return fg(n);
            default:
                return sg(n);
        }
    }), VG = F2(function(n, e) {
        return 1 === e.$ ? A2(ug, e.a, ES(n)) : e;
    }), JG = F2(function(n, e) {
        var r = A2(_c, "", jS(e));
        switch(n){
            case "association":
                return tg(r);
            case "business":
                return A2(ug, r, ES(""));
            case "education":
                return ag(r);
            case "individual":
                return ig;
            case "localAuthority":
                return cg(r);
            case "media":
                return og(r);
            case "public":
                return fg(r);
            case "student":
                return sg(r);
            default:
                return e;
        }
    }), BG = F2(function(n, e) {
        return A2(VM, E([
            WM("row")
        ]), E([
            A2(VM, E([
                WM("col-md-6")
            ]), E([
                A2(VM, E([
                    WM("mb-3")
                ]), E([
                    A2(mG, E([
                        bG("organizationType"),
                        WM("form-label")
                    ]), E([
                        a_("Type d\u2019organisation")
                    ])),
                    A2(mK, E([
                        WM("form-select"),
                        kF("organizationType"),
                        dK(function(e) {
                            return FG($(n, {
                                ck: A2(JG, e, n.ck)
                            }));
                        })
                    ]), A2(ju, function(e) {
                        var r = e.a, t = e.b;
                        return A2(bK, E([
                            vK(r),
                            pK(s(r, jo(n.ck)))
                        ]), E([
                            a_(t)
                        ]));
                    }, A2(IE, Gh, GG))),
                    A2(kG, "organization.type", e)
                ]))
            ])),
            s(n.ck, ig) ? a_("") : A2(VM, E([
                WM("col-md-6")
            ]), E([
                A2(VM, E([
                    WM("mb-3")
                ]), E([
                    A2(mG, E([
                        bG("organization"),
                        WM("form-label")
                    ]), E([
                        a_("Nom de l\u2019organisation")
                    ])),
                    A2(q_, E([
                        i_("text"),
                        WM("form-control"),
                        n_(E([
                            v("is-invalid", A2(pG, "organization.name", e))
                        ])),
                        kF("organization"),
                        hG("ACME Inc."),
                        vK(A2(_c, "", jS(n.ck))),
                        dK(function(e) {
                            return FG($(n, {
                                ck: A2(WG, e, n.ck)
                            }));
                        }),
                        $G(!0)
                    ]), w),
                    A2(kG, "organization.name", e)
                ]))
            ])),
            function() {
                var r = n.ck;
                if (1 === r.$) {
                    var t = r.b;
                    return A2(VM, E([
                        WM("d-grid mb-3")
                    ]), E([
                        A2(mG, E([
                            bG("siren"),
                            WM("form-label")
                        ]), E([
                            a_("Num\xe9ro SIREN")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            n_(E([
                                v("is-invalid", A2(pG, "organization.siren", e))
                            ])),
                            kF("siren"),
                            hG("123456789"),
                            vK(t),
                            dK(function(e) {
                                return FG($(n, {
                                    ck: A2(VG, e, n.ck)
                                }));
                            }),
                            $G(!0)
                        ]), w),
                        A2(kG, "organization.siren", e),
                        A2(H_, E([
                            WM("fs-8 text-muted mt-1 mb-0")
                        ]), E([
                            a_("Vous pouvez rechercher le num\xe9ro SIREN \xe0 9 chiffres d\u2019une entreprise sur le "),
                            A2(KM, E([
                                XM("https://annuaire-entreprises.data.gouv.fr/"),
                                LF("_blank")
                            ]), E([
                                a_("service d\u2019annuaire des entreprises data.gouv.fr")
                            ]))
                        ]))
                    ]));
                }
                return a_("");
            }()
        ]));
    }), XG = F3(function(n, e, r) {
        return A2(DK, E([
            KK(NG),
            A2(ZM, "data-testid", "auth-signup-form"),
            WM("signup-form")
        ]), E([
            A2(H_, E([
                WM("fs-8")
            ]), E([
                a_("Sauf mention contraire, tous les champs sont obligatoires.")
            ])),
            A2(VM, E([
                WM("mb-3")
            ]), E([
                A2(mG, E([
                    bG("email"),
                    WM("form-label")
                ]), E([
                    a_("Adresse email")
                ])),
                A2(q_, E([
                    i_("email"),
                    WM("form-control"),
                    n_(E([
                        v("is-invalid", A2(pG, "email", e))
                    ])),
                    kF("email"),
                    hG("nom@example.com"),
                    vK(n.c1),
                    dK(function(e) {
                        return FG($(n, {
                            c1: e
                        }));
                    }),
                    $G(!0)
                ]), w),
                A2(kG, "email", e)
            ])),
            A2(VM, E([
                WM("row")
            ]), E([
                A2(VM, E([
                    WM("col-md-6")
                ]), E([
                    A2(VM, E([
                        WM("mb-3")
                    ]), E([
                        A2(mG, E([
                            bG("firstName"),
                            WM("form-label")
                        ]), E([
                            a_("Pr\xe9nom")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            n_(E([
                                v("is-invalid", A2(pG, "firstName", e))
                            ])),
                            kF("firstName"),
                            hG("Jos\xe9phine"),
                            vK(n.aC),
                            dK(function(e) {
                                return FG($(n, {
                                    aC: e
                                }));
                            }),
                            $G(!0)
                        ]), w),
                        A2(kG, "firstName", e)
                    ]))
                ])),
                A2(VM, E([
                    WM("col-md-6")
                ]), E([
                    A2(VM, E([
                        WM("mb-3")
                    ]), E([
                        A2(mG, E([
                            bG("lastName"),
                            WM("form-label")
                        ]), E([
                            a_("Nom")
                        ])),
                        A2(q_, E([
                            i_("text"),
                            WM("form-control"),
                            n_(E([
                                v("is-invalid", A2(pG, "lastName", e))
                            ])),
                            kF("lastName"),
                            hG("Durand"),
                            vK(n.aD),
                            dK(function(e) {
                                return FG($(n, {
                                    aD: e
                                }));
                            }),
                            $G(!0)
                        ]), w),
                        A2(kG, "lastName", e)
                    ]))
                ]))
            ])),
            A2(BG, n, e),
            A2(VM, E([
                WM("mb-3 form-check")
            ]), E([
                A2(q_, E([
                    i_("checkbox"),
                    WM("form-check-input"),
                    n_(E([
                        v("is-invalid", A2(pG, "termsAccepted", e))
                    ])),
                    kF("termsAccepted"),
                    w_(n.oS),
                    gG(function(e) {
                        return FG($(n, {
                            oS: e
                        }));
                    })
                ]), w),
                A2(mG, E([
                    WM("form-check-label"),
                    bG("termsAccepted")
                ]), KG),
                A2(kG, "termsAccepted", e)
            ])),
            A2(VM, E([
                WM("mb-3 form-check")
            ]), E([
                A2(q_, E([
                    i_("checkbox"),
                    WM("form-check-input"),
                    n_(E([
                        v("is-invalid", A2(pG, "emailOptin", e))
                    ])),
                    kF("emailOptin"),
                    w_(n.aY),
                    gG(function(e) {
                        return FG($(n, {
                            aY: e
                        }));
                    })
                ]), w),
                A2(mG, E([
                    WM("form-check-label"),
                    bG("emailOptin")
                ]), E([
                    a_("J\u2019accepte de recevoir des informations de la part d\u2019Ecobalyse par email.")
                ])),
                A2(kG, "emailOptin", e)
            ])),
            A2(VM, E([
                WM("mb-3 form-check")
            ]), E([
                A2(q_, E([
                    i_("checkbox"),
                    WM("form-check-input"),
                    n_(E([
                        v("is-invalid", A2(pG, "ecoinventTermsAccepted", e))
                    ])),
                    kF("ecoinventTermsAccepted"),
                    w_(n.bX),
                    gG(function(e) {
                        return FG($(n, {
                            bX: e
                        }));
                    })
                ]), w),
                A2(mG, E([
                    WM("form-check-label"),
                    bG("ecoinventTermsAccepted")
                ]), dG),
                A2(kG, "ecoinventTermsAccepted", e)
            ])),
            A2(VM, E([
                WM("d-grid")
            ]), E([
                A2(YM, E([
                    i_("submit"),
                    WM("btn btn-primary"),
                    E_(s(n, UA) || !RT(e) || s(r, Na)),
                    A2(ZM, "data-testid", "auth-signup-submit")
                ]), E([
                    a_(1 === r.$ ? "Envoi de la demande d\u2019inscription en cours\u2026" : "Valider mon inscription")
                ]))
            ]))
        ]));
    }), QG = F2(function(n, e) {
        var r, t = (r = Hl(n)).$ ? v("Connexion / Inscription", E([
            v("Inscription", A3(HA, UA, Zu, zu)),
            v("Connexion", A2(qp, "", zu))
        ])) : v("Mon compte", E([
            v("Compte", A3(_p, r.a, Rp, Zu)),
            v("Jetons d\u2019API", AT(Na))
        ])), u = t.a, a = t.b;
        return A2(VM, w, E([
            A2(BM, E([
                WM("mb-4")
            ]), E([
                a_(u)
            ])),
            A2(VM, E([
                WM("card shadow-sm px-0")
            ]), E([
                A2(VM, E([
                    WM("card-header px-0 pb-0 border-bottom-0")
                ]), E([
                    A2(B_, E([
                        WM("Tabs nav nav-tabs nav-fill justify-content-end gap-2 px-2")
                    ]), A2(ju, function(n) {
                        var r = n.a, t = n.b;
                        return A2(L_, E([
                            WM("TabsTab nav-item"),
                            n_(E([
                                v("active", A2(oG, e, t))
                            ]))
                        ]), E([
                            A2(YM, E([
                                i_("button"),
                                WM("nav-link no-outline border-top-0"),
                                n_(E([
                                    v("active", A2(oG, e, t))
                                ])),
                                u_(cG(t))
                            ]), E([
                                a_(r)
                            ]))
                        ]));
                    }, a))
                ])),
                A2(VM, E([
                    WM("card-body")
                ]), E([
                    function() {
                        switch(e.$){
                            case 0:
                                return A3(yG, e.a, e.b, e.c);
                            case 1:
                                return u = e.a, A2(VM, w, E([
                                    A2(C_, E([
                                        WM("h5 mb-3")
                                    ]), E([
                                        a_("\u2705\xa0Un nouveau jeton d\u2019API a \xe9t\xe9 cr\xe9\xe9")
                                    ])),
                                    A2(H_, w, E([
                                        a_("Il vous permet d\u2019effectuer des requ\xeates sur "),
                                        A2(KM, E([
                                            QM(sd),
                                            LF("_blank")
                                        ]), E([
                                            a_("l\u2019API Ecobalyse")
                                        ])),
                                        a_(".")
                                    ])),
                                    A2(vF, E([
                                        WM("alert alert-warning d-flex align-items-center gap-1 mb-3")
                                    ]), "Attention, **ce jeton d\u2019API ne vous sera affich\xe9 qu\u2019une seule et unique fois ci-dessous**.\n             Conservez-le pr\xe9cieusement."),
                                    A2(VM, E([
                                        WM("input-group")
                                    ]), E([
                                        A2(q_, E([
                                            i_("text"),
                                            WM("form-control"),
                                            A2(ZM, "data-testid", "auth-api-token"),
                                            AG(!0),
                                            vK(u)
                                        ]), w),
                                        A2(YM, E([
                                            WM("input-group-text"),
                                            V_("Copier dans le presse-papiers"),
                                            u_(jG(u))
                                        ]), E([
                                            EG
                                        ]))
                                    ])),
                                    A2(H_, E([
                                        WM("fs-8 text-muted mt-1 mb-0")
                                    ]), E([
                                        a_("Vous pouvez copier le jeton d\u2019API ci-dessus en cliquant sur le bouton copier \xe0 droite du champ.")
                                    ])),
                                    A2(VM, E([
                                        WM("d-grid mt-2")
                                    ]), E([
                                        A2(YM, E([
                                            WM("btn btn-link"),
                                            u_(cG(AT(Na)))
                                        ]), E([
                                            a_("\xab\xa0Retour \xe0 la liste des jetons d\u2019API")
                                        ]))
                                    ]))
                                ]));
                            case 2:
                                return t = e.a, A2(VM, w, E([
                                    A2(C_, E([
                                        WM("h5 mb-3")
                                    ]), E([
                                        a_("Supprimer et invalider ce jeton d\u2019API")
                                    ])),
                                    A2(H_, w, E([
                                        A2(vF, w, "\xcates-vous s\xfbr de vouloir supprimer et invalider ce jeton d\u2019API\xa0?\n                 Vous ne pourrez plus l\u2019utiliser.")
                                    ])),
                                    function() {
                                        var n = t.mE;
                                        if (n.$) return A2(H_, E([
                                            WM("alert alert-success d-flex align-items-center gap-1")
                                        ]), E([
                                            l_,
                                            a_("Le token n\u2019a jamais \xe9t\xe9 utilis\xe9")
                                        ]));
                                        var e = n.a;
                                        return A2(H_, E([
                                            WM("alert alert-warning d-flex align-items-center gap-1")
                                        ]), E([
                                            TG,
                                            a_("Derni\xe8re utilisation\xa0:\xa0"),
                                            a_(PG(e))
                                        ]));
                                    }(),
                                    A2(VM, E([
                                        WM("d-flex justify-content-center gap-2 mt-1")
                                    ]), E([
                                        A2(YM, E([
                                            WM("btn btn-link"),
                                            u_(cG(AT(Na)))
                                        ]), E([
                                            a_("Annuler")
                                        ])),
                                        A2(YM, E([
                                            WM("btn btn-danger"),
                                            u_(CG(t))
                                        ]), E([
                                            a_("Supprimer et invalider ce jeton d\u2019API")
                                        ]))
                                    ]))
                                ]));
                            case 3:
                                return A2(_G, n, e.a);
                            case 4:
                                return A2(zG, e.a, e.b);
                            case 5:
                                return r = e.a, A2(DK, E([
                                    WM("d-flex flex-column justify-content-center p-3"),
                                    KK(DG)
                                ]), E([
                                    A2(H_, E([
                                        WM("d-flex align-items-baseline gap-1")
                                    ]), E([
                                        l_,
                                        a_("Vous allez \xeatre connect\xe9 avec l\u2019adresse email suivante\xa0: "),
                                        A2(D_, w, E([
                                            a_(A2(_c, r, cd(r)))
                                        ]))
                                    ])),
                                    A2(YM, E([
                                        i_("submit"),
                                        A2(ZM, "data-testid", "auth-login-confirm"),
                                        WM("btn btn-primary")
                                    ]), E([
                                        a_("Confirmer la connexion")
                                    ]))
                                ]));
                            case 6:
                            default:
                                return function(n) {
                                    return c_({
                                        hO: w,
                                        h0: Hr,
                                        h5: E([
                                            A2(vF, w, A3(Xb, "{email}", n, "Si vous poss\xe9dez un compte, un email contenant un lien de connexion au service a \xe9t\xe9 envoy\xe9 \xe0 l\u2019adresse **`{email}`**."))
                                        ]),
                                        eb: 1,
                                        eC: Rr("Email de connexion envoy\xe9")
                                    });
                                }(e.a);
                            case 7:
                                return A3(XG, e.a, e.b, e.c);
                        }
                        var r, t, u;
                    }()
                ]))
            ]))
        ]));
    }), ZG = F2(function(n, e) {
        return v("Authentification", E([
            A2(JM, E([
                WM("pb-5")
            ]), E([
                A2(VM, E([
                    WM("row")
                ]), E([
                    A2(VM, E([
                        WM("col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 d-flex flex-column gap-3")
                    ]), E([
                        A2(QG, n, e.u)
                    ]))
                ]))
            ]))
        ]));
    }), YG = A2(Fu, qA, function(n) {
        return n.ai;
    }), nW = F2(function(n, e) {
        var r = v(n, e);
        n: for(;;)switch(r.a.$){
            case 1:
                if (1 === r.b.$) return !0;
                break n;
            case 2:
                if (2 === r.b.$) return !0;
                break n;
            case 3:
                if (3 === r.b.$) return !0;
                break n;
            case 6:
                if (6 === r.b.$) return s(r.a.a, r.b.a);
                break n;
            case 7:
                if (7 === r.b.$) return s(r.a.a, r.b.a);
                break n;
            case 5:
                if (5 === r.b.$) return !0;
                break n;
            case 8:
                if (8 === r.b.$) return !0;
                break n;
            case 0:
                if (r.b.$) break n;
                return s(r.a.a, r.b.a);
            case 4:
                if (4 === r.b.$) return s(r.a.a, r.b.a);
                break n;
            case 9:
                if (9 === r.b.$) return !0;
                break n;
            default:
                if (10 === r.b.$) return !0;
                break n;
        }
        return !1;
    }), eW = function(n) {
        var e = n.as, r = n.az;
        return A2(oK, E([
            WM("Tabs nav nav-tabs d-flex justify-content-end align-items-center gap-0 gap-sm-2")
        ]), A2(ju, function(n) {
            return A2(KM, E([
                WM("TabsTab nav-link"),
                n_(E([
                    v("active", A2(nW, n, r))
                ])),
                QM(A2(pd, e, n))
            ]), E([
                a_(YG(n))
            ]));
        }, function(n) {
            switch(n.$){
                case 0:
                    return E([
                        yd(Hr),
                        qm(Hr),
                        Om(Hr),
                        Im(Hr),
                        A2(Lm, ds, Hr)
                    ]);
                case 1:
                    switch(n.a){
                        case 0:
                            return E([
                                A2(jd, 0, Hr),
                                qm(Hr),
                                Im(Hr),
                                A2(Lm, bs(0), Hr),
                                A2(Mm, 0, Hr)
                            ]);
                        case 1:
                            return E([
                                A2(jd, 1, Hr),
                                A2(Sm, bs(1), Hr),
                                Im(Hr),
                                A2(Lm, bs(1), Hr),
                                qm(Hr),
                                A2(Mm, 1, Hr)
                            ]);
                        default:
                            return E([
                                A2(jd, 2, Hr),
                                A2(Sm, bs(2), Hr),
                                Im(Hr),
                                qm(Hr),
                                A2(Lm, bs(2), Hr),
                                A2(Mm, 2, Hr)
                            ]);
                    }
                default:
                    return E([
                        Ed(Hr),
                        A2(Sm, ms, Hr),
                        qm(Hr),
                        _m(Hr),
                        Im(Hr),
                        A2(Lm, ms, Hr),
                        Rm(Hr)
                    ]);
            }
        }(e)));
    }, rW = F2(function(n, e) {
        return {
            $: 1,
            a: n,
            b: e
        };
    }), tW = function(n) {
        return {
            $: 5,
            a: n
        };
    }, uW = F3(function(n, e, r) {
        return {
            $: 6,
            a: n,
            b: e,
            c: r
        };
    }), aW = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iW = function(n) {
        return A2(VM, E([
            WM("p-3 pb-0")
        ]), E([
            c_({
                hO: w,
                h0: Hr,
                h5: E([
                    a_(n)
                ]),
                eb: 0,
                eC: Rr("Erreur")
            })
        ]));
    }, cW = {
        $: 2
    }, oW = function(n) {
        return GK({
            h0: gc,
            h5: E([
                n
            ]),
            l2: w,
            l3: Hr,
            m8: cW,
            oA: 2,
            oI: Hr,
            eC: "D\xe9tail de l'enregistrement"
        });
    }, fW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sW = function(n) {
        return {
            $: 3,
            a: n
        };
    }, lW = F3(function(n, e, r) {
        return A2(d_, w, E([
            a_(A2(zw, n, r)),
            A2(d_, E([
                WM("fs-unit")
            ]), E([
                a_("\u202F"),
                a_(e)
            ]))
        ]));
    }), dW = A2(Fu, Zh, A2(lW, 3, "m\xb3")), bW = A2(Fu, Ro, A2(lW, 3, "kg")), mW = function(n) {
        return 1e3 * n;
    }, pW = A2(Fu, mW, A2(lW, 3, "L")), vW = A2(Fu, Ry, A2(lW, 3, "m\xb2")), gW = F2(function(n, e) {
        var r = n.aL, t = e;
        switch(r){
            case 0:
                return dW(t);
            case 2:
                return bW(t);
            case 4:
                return pW(rb(t));
            case 6:
                return vW(t);
            default:
                return a_(Bs(t) + " " + Ch(r));
        }
    }), hW = "\u2014", $W = function(n) {
        return A2(lW, n.le, n.aL);
    }, xW = F2(function(n, e) {
        return A2(Fu, function(n) {
            return n.r;
        }, A2(Fu, ju(A2(F$, n, e)), A2(Fu, Jg, ss(A2(yu, mh, Sh)))));
    }), kW = F2(function(n, e) {
        return A2(Fu, A2(xW, {
            ay: n.h4,
            C: n.C,
            as: e
        }, Uf), ss(A2(Fu, $E, A2(Fu, fh(19), m$))));
    }), wW = F2(function(n, e) {
        return A2(ss, at(" | "), A2(_g, Nw(n.W), e.r));
    }), yW = F2(function(n, e) {
        return A2(at, " ", E([
            A2(_c, "", A2(Lc, mf, e.mf)),
            e.ei,
            A2(_c, "", e.gd),
            A2(eh, "", A2(wW, n, e))
        ]));
    }), jW = A2(Fu, cf, Bs), EW = F2(function(n, e) {
        var r = n.C, t = e.as;
        return {
            kX: E([
                {
                    ai: "Identifiant",
                    eE: function(n) {
                        var e = n.mf;
                        return e.$ ? a_(hW) : A2(y_, w, E([
                            a_(mf(e.a))
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.mf;
                    }, A2(Fu, Lc(mf), _c(hW))))
                },
                {
                    ai: "Nom",
                    eE: A2(Fu, function(n) {
                        return n.ei;
                    }, A2(Fu, a_, A2(Fu, ik, D_(w)))),
                    eH: sW(function(n) {
                        return n.ei;
                    })
                },
                {
                    ai: "\xc9l\xe9ments",
                    eE: function(n) {
                        var e = A2(sx, r, n.r);
                        if (1 === e.$) return c_({
                            hO: w,
                            h0: Hr,
                            h5: E([
                                a_(e.a)
                            ]),
                            eb: 0,
                            eC: Hr
                        });
                        if (e.a.b) {
                            var t = e.a;
                            return A2(B_, E([
                                WM("m-0 px-2")
                            ]), A2(ju, function(n) {
                                var e = n.U, r = n.J;
                                return A2(L_, w, E([
                                    A2(gW, e.t, n.j),
                                    a_(" de " + Wb(e.t)),
                                    A2(B_, w, A2(ju, A2(Fu, function(n) {
                                        return n.t;
                                    }, A2(Fu, Wb, A2(Fu, a_, A2(Fu, ik, L_(w))))), r))
                                ]));
                            }, t));
                        }
                        return A2(A_, w, E([
                            a_("Aucun \xe9l\xe9ment")
                        ]));
                    },
                    eH: sW(function(n) {
                        var e = A2(sx, r, n.r);
                        return 1 === e.$ ? "" : A2(at, ", ", A2(ju, function(n) {
                            var e = n.U;
                            return jW(n.j) + (Ch(e.t.aL) + " de ") + Wb(e.t);
                        }, e.a));
                    })
                },
                {
                    ai: "Commentaire",
                    eE: A2(Fu, function(n) {
                        return n.gd;
                    }, A2(Fu, _c(hW), a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.gd;
                    }, _c(hW)))
                },
                {
                    ai: "Co\xfbt environnemental",
                    eE: A2(Fu, A2(kW, n, t), A2(Fu, ss($W({
                        le: 2,
                        aL: "Pts par composant"
                    })), eh(a_(hW)))),
                    eH: fW(A2(Fu, A2(kW, n, t), eh(0)))
                }
            ]),
            lX: w,
            l_: "components",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Lc(mf), _c(""))),
            oX: A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Sm(t), pd(t))),
            oY: A2(Fu, yW(r), kP)
        };
    }), AW = F2(function(n, e) {
        return A2(VM, E([
            WM("DatasetTable table-responsive table-scroll position-relative")
        ]), E([
            A2(N_, A2(Ur, WM("table table-striped table-hover mb-0"), n), e)
        ]));
    }), CW = F3(function(n, e, r) {
        var t = e({
            lq: !0,
            as: n
        }), u = t.mI, a = t.kX;
        return A2(VM, w, E([
            A2(VM, E([
                WM("text-muted fs-7")
            ]), u),
            A2(AW, E([
                WM("view-details")
            ]), E([
                A2(F_, w, A2(ju, function(n) {
                    var e = n.eE;
                    return A2(J_, w, E([
                        A2(G_, w, E([
                            a_(n.ai)
                        ])),
                        A2(K_, w, E([
                            e(r)
                        ]))
                    ]));
                }, a))
            ]))
        ]));
    }), PW = F2(function(n, e) {
        var r = n.os;
        return ks(function(n) {
            return A2(Ah, function(e) {
                var t = e.fQ;
                return A2(_c, !0, A2(Lc, function(e) {
                    return !!HI(e) || A2(rl, function(e) {
                        return A2(tl, e, t(n));
                    }, function(n) {
                        var e;
                        return e = n, A3(Fr, F3(function(n, e, r) {
                            return A2(Ur, n, r);
                        }), w, e);
                    }(e));
                }, A2(ra, e.fh, r)));
            }, e);
        });
    }), TW = F3(function(n, e, r) {
        return A2(Ah, function(e) {
            return A2(n, e, r);
        }, e);
    }), SW = F2(function(n, e) {
        return A2(au, " " + n + " ", " " + e + " ");
    }), IW = F2(function(n, e) {
        return A3(yu, F2(function(e, r) {
            var t = r.a, u = r.b;
            return n(e) ? v(A2(Ur, e, t), u) : v(t, A2(Ur, e, u));
        }), v(w, w), e);
    }), OW = hr($r), qW = A2(Fu, Os, A2(Fu, xP, OW(bP))), LW = F2(function(n, e) {
        var r = n.m1, t = n.oY, u = pf(n.g1);
        if ("" === u || 0 > m(iu(u), r)) return e;
        var a = A2(ks, A2(Fu, su, ul), qW(u)), i = A2(IW, A2(Fu, Gt, A2(TW, SW, a)), A2(ju, function(n) {
            return v(t(n), n);
        }, e)), c = i.a, o = i.b, f = A2(IW, A2(Fu, Gt, A2(TW, au, a)), o).a;
        return k(A2(ju, Gh, c), A2(ju, Gh, f));
    }), MW = F2(function(n, e) {
        return LW({
            m1: 2,
            g1: n.du,
            oY: e
        });
    }), _W = F3(function(n, e, r) {
        return A2(Fu, A2(PW, n, e), A2(MW, n, r));
    }), RW = function(n) {
        return function(n) {
            return {
                $: 3,
                a: n
            };
        }(IE(n));
    }, HW = F2(function(n, e) {
        switch(e.$){
            case 0:
                return Bs((0, e.a)(n));
            case 1:
                return ut((0, e.a)(n));
            case 2:
                return hW;
            default:
                return (0, e.a)(n);
        }
    }), UW = F2(function(n, e) {
        var r = n.kX, t = A2(ks, A2(Fu, function(n) {
            return n.ai;
        }, Sc("")), r);
        return {
            l8: A2(ju, function(n) {
                return n.ai;
            }, t),
            nX: A2(ju, function(n) {
                return A2(ju, A2(Fu, function(n) {
                    return n.eH;
                }, HW(n)), t);
            }, e)
        };
    }), zW = {
        $: 0
    }, DW = ru, NW = fe("caption"), FW = F3(function(n, e, r) {
        switch(e.$){
            case 0:
                return r;
            case 1:
                return (t = e.a)(r);
            case 2:
                return xt((t = e.a)(r));
            case 3:
                var t = e.a;
                return n ? xt(t(r)) : t(r);
            default:
                return t = e.a, n ? t(r) : xt(t(r));
        }
    }), KW = F2(function(n, e) {
        for(;;){
            if (!e.b) return Hr;
            var r = e.a.oB, t = e.b;
            if (s(e.a.ei, n)) return Rr(r);
            e = t;
        }
    }), GW = F3(function(n, e, r) {
        var t = n.b, u = A2(KW, n.a, e);
        return 1 === u.$ ? r : A3(FW, t, u.a, r);
    }), WW = fe("tfoot"), VW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, JW = {
        $: 0
    }, BW = F3(function(n, e, r) {
        return A2(t_, "click", A2(Zt, r, A3(Yt, Cg, nu(n), nu(e))));
    }), XW = F3(function(n, e, r) {
        var t = n.a, u = n.b, a = r.ei;
        switch(r.oB.$){
            case 0:
                return g(a, JW, A3(BW, t, u, e));
            case 1:
            case 2:
                return g(a, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(s(a, t)), A3(BW, a, !1, e));
            default:
                return s(a, t) ? g(a, VW(Rr(u)), A3(BW, a, !u, e)) : g(a, VW(Hr), A3(BW, a, !1, e));
        }
    }), QW = de, ZW = QW, YW = F2(function(n, e) {
        var r = (0, e.pJ)(n);
        return A2(K_, r.hO, r.kR);
    }), nV = F3(function(n, e, r) {
        return A2(J_, e(r), A2(ju, YW(r), n));
    }), eV = F4(function(n, e, r, t) {
        return v(n(t), A4(ZW, nV, e, r, t));
    }), rV = F3(function(n, e, r) {
        var t, u, a = n.oV, i = n.kX, c = n.lb, o = c.j7(A2(ju, A2(XW, e, n.oW), i)), f = A2(W_, o.hO, o.kR), s = A3(GW, e, i, r), l = A3(xK, "tbody", c.hn, A2(ju, A3(eV, a, i, c.of), s)), d = 1 === (t = c.hp).$ ? A2(Ur, l, w) : A2(Ur, A2(WW, t.a.hO, t.a.kR), A2(Ur, l, w));
        return A2(N_, c.oO, 1 === (u = c.f8).$ ? A2(Ur, f, d) : A2(Ur, A2(NW, u.a.hO, u.a.kR), A2(Ur, f, d)));
    }), tV = F2(function(n, e) {
        return A2(pG, n, e);
    }), uV = IE(A2(Fu, Os, xP)), aV = F4(function(n, e, r, t) {
        return A2(mG, E([
            WM("form-check d-flex align-items-start gap-2 cursor-pointer"),
            n_(E([
                v("fw-semibold", e)
            ])),
            V_(t)
        ]), E([
            A2(q_, E([
                i_("checkbox"),
                WM("form-check-input mt-1 no-outline"),
                w_(e),
                gG(A2(n.no, r, t))
            ]), w),
            A2(d_, E([
                WM("form-check-label text-truncate")
            ]), E([
                a_(t)
            ]))
        ]));
    }), iV = F3(function(n, e, r) {
        var t = r.fh, u = r.fQ, a = A2(_c, uC, A2(ra, t, n.os)), i = A3(AM, uV, uV, A3(ot, F2(function(n, e) {
            var r = e.a, t = e.b;
            return A2(tV, n, a) ? v(A2(Ur, n, r), t) : v(r, A2(Ur, n, t));
        }), v(w, w), ay(A2(Id, u, e)))), c = i.a, o = i.b, f = k(c, o);
        return lf(f) || s(f, E([
            hW
        ])) ? a_("") : A2(VM, E([
            WM("FacetCard card")
        ]), E([
            A2(VM, E([
                WM("card-header fw-bold py-2")
            ]), E([
                a_(t)
            ])),
            A2(VM, E([
                WM("FacetCardBody card-body d-flex flex-column gap-1 p-2 no-scroll-chaining"),
                A2(ZM, "data-scroll-id", t)
            ]), Sd(E([
                A2(ju, A3(aV, n, !0, t), c),
                lf(c) ? w : E([
                    A2(VM, E([
                        WM("FacetCardSeparator border-bottom")
                    ]), w)
                ]),
                A2(ju, A3(aV, n, !1, t), o)
            ])))
        ]));
    }), cV = F3(function(n, e, r) {
        return A2(VM, E([
            WM("d-flex flex-column gap-2")
        ]), A2(ju, A2(iV, n, r), e));
    }), oV = F6(function(n, e, r, t, u, a) {
        var i, c = u({
            lq: !1,
            as: t
        }), o = c.l_, f = c.oV, s = c.oY, l = c.lX, d = c.kX, b = c.mI, p = !lf(l), g = A4(_W, e, l, s, a), h = {
            h5: A2(UW, c, g),
            l_: "ecobalyse-" + gs(t) + "-" + o + ".csv"
        }, x = A2(Kc, 100, g), y = ft(g), j = (i = $(e.lb, {
            of: A2(Fu, n, A2(Fu, u_, ik))
        }), $(i, {
            j7: function(n) {
                var e = i.j7(n);
                return $(e, {
                    hO: k(e.hO, E([
                        WM("sticky-md-top bg-white")
                    ]))
                });
            }
        })), A = function(n) {
            var e = n.oV, r = n.oW, t = n.lb;
            return {
                kX: A2(ju, function(n) {
                    return n;
                }, n.kX),
                lb: t,
                oV: e,
                oW: r
            };
        }({
            kX: A2(ju, function(n) {
                var r = n.eE, t = n.eH;
                return DW({
                    ei: n.ai,
                    oB: function() {
                        if ("" !== pf(e.du)) return zW;
                        switch(t.$){
                            case 0:
                            case 1:
                                return RW(t.a);
                            case 2:
                                return zW;
                            default:
                                return RW(A2(Fu, t.a, A2(Fu, Os, xP)));
                        }
                    }(),
                    pJ: function(n) {
                        return {
                            hO: w,
                            kR: E([
                                r(n)
                            ])
                        };
                    }
                });
            }, d),
            lb: j,
            oV: f,
            oW: e.oW
        });
        return lf(a) ? c_({
            hO: w,
            h0: Hr,
            h5: E([
                a_("Aucun enregistrement disponible pour le secteur "),
                A2(D_, w, E([
                    a_(qx(t))
                ]))
            ]),
            eb: 1,
            eC: Hr
        }) : A2(VM, E([
            WM("row g-3")
        ]), E([
            A2(VM, E([
                n_(E([
                    v("col-xxl-10 col-xl-9 col-lg-9 col-md-12 col-sm-12", p)
                ]))
            ]), E([
                m(y, 100) > 0 ? A2(vF, E([
                    WM("text-muted fs-7 mb-2")
                ]), A3(Xb, "{resultCount}", ut(y), A3(Xb, "{maxRows}", ut(100), "Affichage des {maxRows} premiers r\xe9sultats sur {resultCount} r\xe9sultats"))) : a_(""),
                A2(VM, E([
                    WM("DatasetTable table-responsive table-scroll position-relative")
                ]), E([
                    lf(g) ? c_({
                        hO: w,
                        h0: Hr,
                        h5: E([
                            a_("Cette recherche n\u2019a retourn\xe9 aucun r\xe9sultat")
                        ]),
                        eb: 1,
                        eC: Hr
                    }) : A3(rV, A, r, x),
                    A2(VM, E([
                        WM("text-muted fs-7")
                    ]), b)
                ])),
                A2(VM, E([
                    WM("text-end pt-3")
                ]), E([
                    A2(YM, E([
                        WM("btn btn-secondary"),
                        u_(A2(e.lz, h.l_, h.h5))
                    ]), E([
                        a_("T\xe9l\xe9charger ces donn\xe9es au format CSV")
                    ]))
                ]))
            ])),
            A2(VM, E([
                WM("col-xxl-2 col-xl-3 col-lg-3 col-md-12 col-sm-12 overflow-y-scroll sticky-top")
            ]), E([
                A3(cV, e, l, a)
            ]))
        ]));
    }), fV = F5(function(n, e, r, t, u) {
        var a = A2(ks, A2(Fu, function(n) {
            return n.g5;
        }, tl(e)), n.C.dX);
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Lc(mf), A2(Fu, _c(""), aW))), r, t, e, EW(n), A2(IE, function(n) {
                return n.ei;
            }, a)),
            function() {
                if (u.$) return a_("");
                var r = u.a;
                return oW(function() {
                    var t = A2(W$, r, a);
                    if (1 === t.$) return iW(t.a);
                    var u = t.a;
                    return A3(CW, e, EW(n), u);
                }());
            }()
        ]);
    }), sV = F2(function(n, e) {
        return {
            fh: n,
            fQ: e
        };
    }), lV = A2(Fu, Cf, A2(lW, 0, "km")), dV = F3(function(n, e, r) {
        var t = function(n) {
            return s(n, 0) ? a_(hW) : lV(n);
        };
        return A2(J_, w, E([
            A2(K_, E([
                V_(A2(eh, "", A2(ss, function(n) {
                    return n.ei;
                }, A2(js, n, e))))
            ]), E([
                a_(n)
            ])),
            A2(K_, w, E([
                t(r.f1)
            ])),
            A2(K_, w, E([
                t(r.ds)
            ])),
            A2(K_, w, E([
                t(r.g7)
            ]))
        ]));
    }), bV = F4(function(n, e, r, t) {
        return A2(Ur, A3(dV, e, n, r), t);
    }), mV = F3(function(n, e, r) {
        var t = r.l;
        return A3(zi, F2(function(e, r) {
            return A2(n, r.a, r.b);
        }), e, t);
    }), pV = F3(function(n, e, r) {
        var t = A2(Wh, r.cM, e);
        if (t.$) return a_("");
        var u, a = t.a;
        return u = A3(mV, bV(n), w, a), A2(N_, E([
            WM("table table-striped table-hover text-center w-100")
        ]), E([
            A2(W_, w, E([
                A2(J_, w, E([
                    A2(G_, w, E([
                        a_("Code pays")
                    ])),
                    A2(G_, w, E([
                        a_("A\xe9rien")
                    ])),
                    A2(G_, w, E([
                        a_("Routier")
                    ])),
                    A2(G_, w, E([
                        a_("Maritime")
                    ]))
                ]))
            ])),
            A2(F_, w, xt(u))
        ]));
    }), vV = function(n) {
        switch(n){
            case 0:
                return "alimentaire/impacts-consideres/complements-hors-acv-en-construction";
            case 1:
                return "alimentaire/etapes-du-cycles-de-vie/vente-au-detail";
            case 2:
                return "alimentaire/part-non-comestible";
            case 3:
                return "alimentaire/donnees";
            case 4:
                return "alimentaire/etapes-du-cycles-de-vie/emballage";
            case 5:
                return "alimentaire/rapport-cru-cuit";
            case 6:
                return "alimentaire/etapes-du-cycles-de-vie/transformation";
            case 7:
                return "alimentaire/transport";
            case 8:
                return "alimentaire/etapes-du-cycles-de-vie/consommation";
            case 9:
                return "textile/cycle-de-vie-des-produits-textiles/circular-footpring-formula-cff";
            case 10:
                return "textile/complements-hors-acv/microfibres";
            case 11:
                return "textile/etapes-du-cycle-de-vie/distribution";
            case 12:
                return "textile/complements-hors-acv/durabilite";
            case 13:
                return "textile/parametres-transverses/electricite";
            case 14:
                return "textile/etapes-du-cycle-de-vie/etape-7-fin-de-vie";
            case 15:
                return "textile/limites-methodologiques/fin-de-vie-hors-europe";
            case 16:
                return "textile/cycle-de-vie-des-produits-textiles/ennoblissement-1";
            case 17:
                return "textile/etapes-du-cycle-de-vie/ennoblissement/inventaires-enrichis#pays-less-than-greater-than-taux-de-pollution-aquatique";
            case 18:
                return "textile/etapes-du-cycle-de-vie/ennoblissement/inventaires-enrichis";
            case 19:
                return "textile/exemples";
            case 20:
                return "textile/etapes-du-cycle-de-vie/tricotage-tissage";
            case 21:
                return "textile/cycle-de-vie-des-produits-textiles/tricotage-tissage#taux-de-perte";
            case 22:
                return "textile/parametres-transverses/chaleur";
            case 23:
                return "textile/etapes-du-cycle-de-vie/confection";
            case 24:
                return "textile/etapes-du-cycle-de-vie/confection#electricite-consommee-mj-kwh";
            case 25:
                return "textile/cas-particuliers/stocks-dormants-deadstock";
            case 26:
                return "textile/parametres-transverses/pertes-et-rebus";
            case 27:
                return "textile/etapes-du-cycle-de-vie/etape-1-matieres";
            case 28:
                return "textile/cycle-de-vie-des-produits-textiles/etape-2-fabrication-du-fil";
            case 29:
                return "textile/parametres-transverses/transport";
            case 30:
                return "textile/cycle-de-vie-des-produits-textiles/accessoires";
            default:
                return "textile/etapes-du-cycle-de-vie/etape-6-utilisation";
        }
    }, gV = function(n) {
        return CF + "/" + n;
    }, hV = A2(Fu, vV, gV), $V = function(n) {
        return KM(A2(Ur, LF("_blank"), A2(Ur, qF("noopener noreferrer"), A2(Ur, WM("btn btn-sm text-secondary text-decoration-none btn-link p-0 ms-1"), n))));
    }, xV = F2(function(n, e) {
        return a_(A2(uA, n, e) + "\u202F%");
    }), kV = function(n) {
        switch(n){
            case 0:
                return "Afrique";
            case 1:
                return "Asie";
            case 2:
                return "Europe";
            case 3:
                return "Moyen-Orient";
            case 4:
                return "Am\xe9rique du Nord";
            case 5:
                return "Oc\xe9anie";
            default:
                return "Am\xe9rique du Sud";
        }
    }, wV = function(n) {
        return A2(at, " ", E([
            n.cM,
            n.ei,
            Wb(n.lK),
            Wb(n.ma),
            A2(at, " ", A2(ju, qx, n.g5)),
            kV(n.hC)
        ]));
    }, yV = F3(function(n, e, r) {
        var t = r.lq, u = r.as;
        return {
            kX: A2(La, ru, E([
                Rr({
                    ai: "Code",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(n.cM)
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.cM;
                    }, Lo))
                }),
                Rr({
                    ai: "Nom",
                    eE: A2(Fu, function(n) {
                        return n.ei;
                    }, a_),
                    eH: sW(function(n) {
                        return n.ei;
                    })
                }),
                Rr({
                    ai: "Mix \xe9lectrique",
                    eE: A2(Fu, function(n) {
                        return n.lK;
                    }, A2(Fu, Wb, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.lK;
                    }, Wb))
                }),
                Rr({
                    ai: "Chaleur",
                    eE: A2(Fu, function(n) {
                        return n.ma;
                    }, A2(Fu, Wb, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.ma;
                    }, Wb))
                }),
                s(u, ms) ? Rr({
                    ai: "Taux de pollution aquatique",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-end", !t)
                            ]))
                        ]), E([
                            A2(xV, 2, ny(n.hL)),
                            A2($V, E([
                                XM(hV(17))
                            ]), E([
                                l_
                            ]))
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.hL;
                    }, A2(Fu, ny, zf)))
                }) : Hr,
                t ? Rr({
                    ai: "Distances",
                    eE: A2(pV, e, n),
                    eH: sW(Bi(""))
                }) : Hr
            ])),
            lX: E([
                A2(sV, "Mix \xe9lectrique", A2(Fu, function(n) {
                    return n.lK;
                }, A2(Fu, Wb, ik))),
                A2(sV, "Chaleur", A2(Fu, function(n) {
                    return n.ma;
                }, A2(Fu, Wb, ik))),
                A2(sV, "Taux de pollution aquatique", A2(Fu, function(n) {
                    return n.hL;
                }, A2(Fu, ny, A2(Fu, uA(0), function(n) {
                    return E([
                        n + "%"
                    ]);
                }))))
            ]),
            l_: "countries",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.cM;
            }, Lo),
            oX: A2(Fu, function(n) {
                return n.cM;
            }, A2(Fu, Rr, A2(Fu, Im, pd(u)))),
            oY: A2(Fu, wV, kP)
        };
    }), jV = F5(function(n, e, r, t, u) {
        var a = n.ls, i = n.bR;
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.cM;
            }, A2(Fu, Lo, aW)), e, r, t, A2(yV, a, i), A2(ks, A2(Fu, function(n) {
                return n.g5;
            }, tl(t)), i)),
            function() {
                if (u.$) return a_("");
                var n = u.a;
                return oW(function() {
                    var e = A2(js, n, i);
                    if (1 === e.$) return iW(e.a);
                    var r = e.a;
                    return A3(CW, t, A2(yV, a, i), r);
                }());
            }()
        ]);
    }), EV = F2(function(n, e) {
        return {
            hO: n,
            kR: e
        };
    }), AV = function(n) {
        return A2(d_, E([
            A2(OF, "color", "#555")
        ]), E([
            a_(" " + n)
        ]));
    }, CV = function(n) {
        return A2(d_, E([
            A2(OF, "color", "#ccc")
        ]), E([
            a_(" " + n)
        ]));
    }, PV = function(n) {
        var e = n.a, r = n.b, t = n.c, u = function() {
            switch(r.$){
                case 0:
                    return E([
                        a_(e)
                    ]);
                case 1:
                    var n = r.a;
                    return E([
                        a_(e),
                        n ? AV("\u2193") : CV("\u2193")
                    ]);
                default:
                    if (1 === r.a.$) return E([
                        a_(e),
                        CV("\u2195")
                    ]);
                    var t = r.a.a;
                    return E([
                        a_(e),
                        AV(t ? "\u2191" : "\u2193")
                    ]);
            }
        }();
        return A2(G_, E([
            t
        ]), u);
    }, TV = {
        f8: Hr,
        of: function() {
            return w;
        },
        oO: w,
        hn: w,
        hp: Hr,
        j7: function(n) {
            return A2(EV, w, A2(ju, PV, n));
        }
    }, SV = F3(function(n, e, r) {
        return bh(E([
            A2(lh, function() {
                return A2(Fu, m$, A2(Fu, Dt(hh(r.d0.a)), A2(Fu, Dt(e), A2(Fu, Dt(r.d0.b), b$))));
            }, n.mP.g),
            A2(lh, function() {
                return A2(Fu, m$, A2(Fu, Dt($h(r.d9.a)), A2(Fu, Dt(e), A2(Fu, Dt(r.d9.b), b$))));
            }, n.lx.g)
        ]));
    }), IV = E([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19
    ]), OV = F3(function(n, e, r) {
        return A3(ot, F2(function(e, t) {
            return A3(n, e, A2(th, e, r), t);
        }), e, IV);
    }), qV = F2(function(n, e) {
        return A2(Fu, Rh(n), A2(Fu, ph(e), ph(1e6)));
    }), LV = F3(function(n, e, r) {
        var t = r;
        return A3(OV, function() {
            return ih;
        }, 0, A2(sh, F2(function(r, t) {
            return A2(_c, 0, A2(Lc, function(n) {
                return A3(qV, n.i9, n.kl, t);
            }, e(A2(th, r, n))));
        }), t));
    }), MV = F3(function(n, e, r) {
        return A3(ot, F2(function(r, t) {
            return n(r) ? t : A3(T$, r, e, t);
        }), r, IV);
    }), _V = F2(function(n, e) {
        var r = e, t = function(e) {
            return A3(LV, n, function(n) {
                return n.ip;
            }, A3(MV, function(n) {
                return A2(tl, n, e);
            }, Bi(0), r));
        };
        return {
            kF: t(E([
                0,
                17,
                5,
                16,
                3,
                11
            ])),
            kV: t(E([
                1
            ])),
            l9: t(E([
                13,
                10,
                14,
                9,
                7,
                15
            ])),
            n7: t(E([
                18,
                4,
                12
            ]))
        };
    }), RV = F3(function(n, e, r) {
        var t = A2(_V, n, r), u = A2(fh, 19, r);
        return {
            kw: A2(ih, u, e),
            f3: u,
            kF: t.kF,
            kV: t.kV,
            kZ: e,
            l9: t.l9,
            n7: t.n7
        };
    }), HV = F2(function(n, e) {
        return A2(Fu, function(n) {
            return n.g;
        }, lh(F2(function(r, t) {
            return hh(A2(yf, n, e)) * t;
        })));
    }), UV = F2(function(n, e) {
        return A2(Fu, function(n) {
            return n.g;
        }, lh(F2(function(r, t) {
            return mW(A2(ph, n, e)) * t;
        })));
    }), zV = F3(function(n, e, r) {
        var t = e.b;
        return bh(E([
            A3(UV, t.cz, n, r.cz),
            A3(HV, t.aN, n, r.mP),
            A3(HV, t.c3, n, r.mP)
        ]));
    }), DV = F2(function(n) {
        return A2(Fu, m$, A2(Fu, Dt(n), b$));
    }), NV = F3(function(n, e, r) {
        return $(r, e ? {
            oc: A2(ih, n, r.oc)
        } : {
            ds: A2(ih, n, r.ds)
        });
    }), FV = A2(ju, vj, E([
        "RAF",
        "RAS",
        "RLA",
        "RME",
        "RNA",
        "ROC"
    ])), KV = 2e3, GV = F3(function(n, e, r) {
        var t = r.cM, u = e ? 0 : 1, a = Zs, i = cx(a);
        return s(t, ME) ? $(i, {
            ds: vl(KV),
            g7: vl(18e3)
        }) : (A2(tl, t, FV) ? A2(NV, vl(KV), !1) : ru)(A2(h$, u, A4(eE, a, t, TE, n.ls)));
    }), WV = function(n) {
        return {
            kG: n.kJ,
            kH: n.kI,
            mL: n.mO,
            mM: n.mN,
            nH: n.jk
        };
    }, VV = F2(function(n, e) {
        var r = cx(Zs);
        switch(e){
            case 0:
                return $(r, {
                    ds: vl(KV)
                });
            case 1:
                return r;
            case 2:
                return $(r, n ? {
                    g7: vl(8315)
                } : {
                    f1: vl(8401)
                });
            case 3:
                return $(r, {
                    ds: vl(KV),
                    g7: vl(18e3)
                });
            default:
                return $(r, n ? {
                    ds: vl(KV),
                    g7: vl(18e3)
                } : {
                    f1: vl(18e3),
                    ds: vl(KV)
                });
        }
    }), JV = vj("ROF"), BV = F2(function(n, e) {
        var r, t, u = e.i, a = e.a_, i = e.P, c = e.jk, o = WV(n.l1.pM), f = function(n) {
            if (u.$) return 2 === a.gl ? n : A3(NV, vl(500), 1 !== a.gl ? !a.hv : function(n) {
                return A2(tl, n.hv, E([
                    0,
                    1
                ]));
            }(a), n);
            var e = u.a.cM;
            return s(e, TE) || s(e, JV) ? n : A3(NV, vl(500), !a.hv, n);
        }((t = (r = A2(_c, A2(VV, c, a.gl), A2(Lc, A2(GV, n, c), u)), 2 !== a.hv ? $(r, {
            ds: 0,
            oc: r.ds,
            g7: 0,
            om: r.g7
        }) : r), A3(NV, vl(160), !a.hv, t)));
        return A3(p$, o, i, f);
    }), XV = F2(function(n, e) {
        var r = n.ag, t = n.ah, u = n.al, a = n.am, i = ph(e);
        return {
            ag: Rr(i(r)),
            aa: Hr,
            ah: Rr(i(t)),
            aj: Hr,
            ak: Hr,
            al: Rr(i(u)),
            am: Rr(i(a))
        };
    }), QV = A2(ot, F2(function(n, e) {
        return A2(sj, e, A2(XV, n.a_.lH, n.P));
    }), lj), ZV = function(n) {
        return A2(kh, n.j, n.t.g);
    }, YV = function(n) {
        return A2(lh, DV(n.P), n.t.g);
    }, nJ = F2(function(n, e) {
        return A3(NV, n.b.eJ, e, cx(Zs));
    }), eJ = function(n) {
        return ch(A2(ju, function(n) {
            var e = n.j, r = n.t;
            return 2 === r.aL ? e : e * A2(_c, 1, r.mV);
        }, n.cm));
    }, rJ = F2(function(n, e) {
        return s(A2(Lc, function(n) {
            return n.t;
        }, e), Rr(n.k3));
    }), tJ = ju(function(n) {
        return $(n, {
            P: A2(ph, 1 - n.a_.ml, n.P)
        });
    }), uJ = F2(function(n, e) {
        var r = e.fT;
        return ch(A2(ju, function(e) {
            var t = e.a_, u = e.P;
            return A2(rJ, n, r) ? A2(ph, t.nV, u) : u;
        }, tJ(e.mm)));
    }), aJ = F2(function(n, e) {
        return ch(E([
            A2(uJ, n, e),
            eJ(e)
        ]));
    }), iJ = F2(function(n, e) {
        var r = e.mm, t = e.fT, u = A2(rl, function(n) {
            return n.bq;
        }, e.bj);
        return !A2(rJ, n, t) && u ? ch(A2(ju, function(n) {
            return A2(ph, n.a_.nV, n.P);
        }, r)) : A2(uJ, n, e);
    }), cJ = F2(function(n, e) {
        return A2(Ny, function(n) {
            var e = n.mm;
            if (e.b && !e.b.b) {
                var r = e.a;
                return s(n.fT, Hr) ? r.a_.lo : OC(1);
            }
            return OC(1);
        }(e), A2(uJ, n, e));
    }), oJ = function(n) {
        return lh(function() {
            return Rh(n);
        });
    }, fJ = function(n) {
        var e = n.l1;
        return A2(Fu, Zg(n), ss(function(r) {
            var t, u, a = r.mm, i = r.fT, c = r.cm, o = r.E, f = r.bj, s = A2(uJ, e.pM, r), l = A2(_c, Zs, A2(Lc, YV, i)), d = QV(a), b = A2(iJ, e.pM, r), m = A2(O$, Lc(Rh(b)), d), p = bh(A2(ju, A2(SV, e.pM, s), f)), g = bh(A2(ju, ZV, c)), h = yx(A2(ju, BV(n), a)), $ = A2(ju, function(n) {
                var e, r;
                return A2(Lj, n, (r = (e = n).a_, A2(lh, DV(e.P), r.t.g)));
            }, a), x = bh(A2(ju, Gh, $)), k = bh(E([
                x,
                l,
                h.g
            ])), w = A2(rl, A2(Fu, function(n) {
                return n.a_;
            }, A2(Fu, function(n) {
                return n.hv;
            }, Sc(2))), a), y = (t = A2(_c, cx(Zs), A2(Lc, function(n) {
                return A2(nJ, n, w);
            }, o)), u = WV(n.l1.pM), A3(p$, u, A2(aJ, e.pM, r), t)), j = A2(_c, Zs, A2(Lc, function(n) {
                return A3(zV, A2(cJ, e.pM, r), n, e.pM);
            }, o)), A = bh(E([
                k,
                g,
                j,
                y.g,
                p
            ])), C = A2(oJ, b, A), P = A3(RV, n.cV, cj(m), C), T = function(n) {
                return A2(I$, cj(d), n);
            }, S = T(A);
            return v(r, {
                E: {
                    bI: j,
                    af: y
                },
                cm: g,
                gW: A2(oJ, b, S),
                bj: p,
                gZ: b,
                bl: {
                    lI: ch(A2(ju, function(n) {
                        return n.P;
                    }, tJ(r.mm))),
                    mm: $,
                    gD: T(x),
                    mo: ch(A2(ju, function(n) {
                        return n.P;
                    }, r.mm)),
                    bI: T(k),
                    kb: d,
                    o4: m,
                    fT: l,
                    pa: s,
                    af: h
                },
                g6: P,
                bI: S,
                hu: A2(aJ, e.pM, r),
                af: yx(E([
                    h,
                    y
                ]))
            });
        }));
    }, sJ = function(n) {
        return A2(Fu, function(n) {
            return n.g1;
        }, A2(Fu, fJ(n), A2(Fu, ss(A2(Fu, Gh, A2(Fu, function(n) {
            return n.bI;
        }, A2(Fu, fh(19), m$)))), eh(0))));
    }, lJ = function(n) {
        return A2(Fu, function(n) {
            return n.g1;
        }, A2(Fu, fJ(n), A2(Fu, ss(A2(Fu, Gh, A2(Fu, function(n) {
            return n.gW;
        }, A2(Fu, fh(19), function(n) {
            return n / 10;
        })))), eh(0))));
    }, dJ = {
        $: 2
    }, bJ = F3(function(n, e, r) {
        var t = r / e * 100;
        return A2(VM, E([
            WM("d-flex justify-content-center align-items-center gap-2"),
            A2(OF, "min-width", "calc(100% - 76px)")
        ]), E([
            A2(VM, E([
                n_(E([
                    v("text-end", !n)
                ])),
                A2(OF, "min-width", "76px")
            ]), E([
                A3(lW, 2, "Pts", r)
            ])),
            A2(VM, E([
                WM("progress"),
                A2(OF, "min-width", "calc(100% - 76px)")
            ]), E([
                A2(VM, E([
                    WM("progress-bar bg-secondary"),
                    A2(OF, "width", Bs(t) + "%")
                ]), w)
            ]))
        ]));
    }), mJ = s_("search"), pJ = function(n) {
        return A2(at, " ", E([
            bf(n.mf),
            n.ei,
            gs(n.as)
        ]));
    }, vJ = F2(function(n, e) {
        var r = n.gJ, t = n.gI, u = e.lq, a = e.as;
        return {
            kX: E([
                {
                    ai: "Nom",
                    eE: A2(Fu, Gt, A2(Fu, function(n) {
                        return n.ei;
                    }, a_)),
                    eH: sW(A2(Fu, Gt, function(n) {
                        return n.ei;
                    }))
                },
                {
                    ai: "Cat\xe9gorie",
                    eE: A2(Fu, Gt, A2(Fu, function(n) {
                        return n.hY;
                    }, a_)),
                    eH: sW(A2(Fu, Gt, function(n) {
                        return n.hY;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental",
                    eE: function(n) {
                        return A3(bJ, u, r, n.b.bm);
                    },
                    eH: fW(A2(Fu, Gh, function(n) {
                        return n.bm;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental/100g",
                    eE: function(n) {
                        return A3(bJ, u, t, n.b.bh);
                    },
                    eH: fW(A2(Fu, Gh, function(n) {
                        return n.bh;
                    }))
                },
                {
                    ai: "",
                    eE: function(n) {
                        var e = n.a.mf, r = n.a.ei;
                        return A2(KM, E([
                            WM("btn btn-light btn-sm w-100"),
                            QM(gd(e)),
                            V_("Charger " + r)
                        ]), E([
                            mJ
                        ]));
                    },
                    eH: dJ
                }
            ]),
            lX: w,
            l_: "examples",
            mI: w,
            oV: A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, bf)),
            oX: A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, yd, pd(a))))),
            oY: A2(Fu, Gt, A2(Fu, pJ, kP))
        };
    }), gJ = F4(function(n, e, r, t) {
        var u = A2(IE, A2(Fu, Gt, function(n) {
            return n.ei;
        }), A2(ju, function(e) {
            return v(e, {
                bh: A2(lJ, n, e),
                bm: A2(sJ, n, e)
            });
        }, n.l1.lP)), a = {
            gI: A2(_c, 0, vP(A2(ju, A2(Fu, Gh, function(n) {
                return n.bh;
            }), u))),
            gJ: A2(_c, 0, vP(A2(ju, A2(Fu, Gh, function(n) {
                return n.bm;
            }), u)))
        };
        return E([
            A6(oV, A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, bf, aW))), e, r, ds, vJ(a), A2(IE, A2(Fu, Gt, function(n) {
                return n.ei;
            }), A2(ks, A2(Fu, Gt, A2(Fu, function(n) {
                return n.g1;
            }, Sc(bA))), u))),
            function() {
                if (t.$) return a_("");
                var e = t.a;
                return oW(function() {
                    var r = A2(Qx, e, n.l1.lP);
                    if (1 === r.$) return iW(r.a);
                    var t = r.a;
                    return A3(CW, ds, vJ(a), v(t, {
                        bh: A2(lJ, n, t),
                        bm: A2(sJ, n, t)
                    }));
                }());
            }()
        ]);
    }), hJ = "Diversit\xe9 culturale", $J = "Haies", xJ = "Prairies permanentes", kJ = "Taille de parcelles", wJ = A2(lW, 2, "%"), yJ = s_("question"), jJ = function(n) {
        switch(n){
            case 0:
                return "Viandes, \u0153ufs, poissons, et d\xe9riv\xe9s";
            case 1:
                return "Bleu-Blanc-C\u0153ur";
            case 2:
                return "Conventionnel";
            case 3:
                return "Lait et ingr\xe9dients laitiers";
            case 4:
                return "C\xe9r\xe9ales transform\xe9es";
            case 5:
                return "C\xe9r\xe9ales brutes";
            case 6:
                return "Divers";
            case 7:
                return "Graisses v\xe9g\xe9tales et ol\xe9oprot\xe9agineux transform\xe9s";
            case 8:
                return "Fruits \xe0 coque et ol\xe9oprot\xe9agineux bruts";
            case 9:
                return "Bio";
            case 10:
                return "Condiments, \xe9pices, additifs";
            case 11:
                return "Fruits et l\xe9gumes frais";
            default:
                return "Fruits et l\xe9gumes transform\xe9s";
        }
    }, EJ = function(n) {
        switch(n){
            case 0:
                return "Arboriculture";
            case 1:
                return "Orge";
            case 2:
                return "Ma\xefs grain et ensilage";
            case 3:
                return "Plantes \xe0 fibres";
            case 4:
                return "Fourrage";
            case 5:
                return "Gel (surfaces gel\xe9es sans production)";
            case 6:
                return "L\xe9gumineuses \xe0 grain";
            case 7:
                return "Gel industriel";
            case 8:
                return "Divers";
            case 9:
                return "N/A";
            case 10:
                return "Fruits \xe0 coques";
            case 11:
                return "Oliviers";
            case 12:
                return "Vergers";
            case 13:
                return "Autres c\xe9r\xe9ales";
            case 14:
                return "Autres gels";
            case 15:
                return "Autres cultures industrielles";
            case 16:
                return "Autres ol\xe9agineux";
            case 17:
                return "Prairies permanentes";
            case 18:
                return "Prot\xe9agineux";
            case 19:
                return "Colza";
            case 20:
                return "Riz";
            case 21:
                return "Semences";
            case 22:
                return "Bl\xe9 tendre";
            case 23:
                return "Canne \xe0 sucre";
            case 24:
                return "Estives landes";
            case 25:
                return "Tournesol";
            case 26:
                return "Prairies temporaires";
            case 27:
                return "L\xe9gumes et fleurs";
            default:
                return "Vignes";
        }
    }, AJ = function(n) {
        switch(n){
            case 0:
                return "Import";
            case 1:
                return "N/A";
            case 2:
                return "Biologique";
            default:
                return "R\xe9f\xe9rence";
        }
    }, CJ = function(n) {
        switch(n){
            case 0:
                return "Europe et Maghreb";
            case 1:
                return "France";
            case 2:
                return "France d\u2019outre-mer";
            case 3:
                return "Hors Europe et Maghreb";
            default:
                return "Hors Europe et Maghreb par avion";
        }
    }, PJ = function(n) {
        switch(n){
            case 0:
                return "Toujours frigorifique";
            case 1:
                return "Frigorifique apr\xe8s transformation";
            default:
                return "Non frigorifique";
        }
    }, TJ = function(n) {
        return A2(at, " ", E([
            n.hI,
            A2(at, " ", A2(ju, jJ, n.cK)),
            EJ(n.h8),
            CJ(n.gl),
            n.ei,
            Wb(n.t),
            Gb(n.t),
            AJ(n.jM),
            PJ(n.hv)
        ]));
    }, SJ = function(n) {
        var e = n.lq, r = n.as;
        return {
            kX: E([
                {
                    ai: "Identifiant",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(zg(n.mf))
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.mf;
                    }, zg))
                },
                {
                    ai: "Nom",
                    eE: A2(Fu, function(n) {
                        return n.ei;
                    }, a_),
                    eH: sW(function(n) {
                        return n.ei;
                    })
                },
                {
                    ai: "Alias",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(n.hI)
                        ]));
                    },
                    eH: sW(function(n) {
                        return n.hI;
                    })
                },
                {
                    ai: "Cat\xe9gories",
                    eE: A2(Fu, function(n) {
                        return n.cK;
                    }, A2(Fu, ju(function(n) {
                        return A2(L_, w, E([
                            a_(jJ(n))
                        ]));
                    }), B_(E([
                        WM("mb-0")
                    ])))),
                    eH: sW(A2(Fu, function(n) {
                        return n.cK;
                    }, A2(Fu, ju(jJ), at(","))))
                },
                {
                    ai: "Origine par d\xe9faut",
                    eE: A2(Fu, function(n) {
                        return n.gl;
                    }, A2(Fu, CJ, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.gl;
                    }, CJ))
                },
                {
                    ai: "Groupe de culture",
                    eE: A2(Fu, function(n) {
                        return n.h8;
                    }, A2(Fu, EJ, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.h8;
                    }, EJ))
                },
                {
                    ai: "Sc\xe9nario",
                    eE: A2(Fu, function(n) {
                        return n.jM;
                    }, A2(Fu, AJ, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.jM;
                    }, AJ))
                },
                {
                    ai: "Surface mobilis\xe9e",
                    eE: A2(Fu, function(n) {
                        return n.mC;
                    }, A2(Fu, function(n) {
                        return A2(zw, 2, n) + " m2.an";
                    }, a_)),
                    eH: fW(function(n) {
                        return n.mC;
                    })
                },
                {
                    ai: "Part non-comestible",
                    eE: function(n) {
                        var r = n.ml;
                        return A2(VM, E([
                            n_(E([
                                v("text-end", !e)
                            ]))
                        ]), E([
                            wJ(zf(r)),
                            A2($V, E([
                                XM(hV(2))
                            ]), E([
                                yJ
                            ]))
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.ml;
                    }, zf))
                },
                {
                    ai: "Rapport cru/cuit",
                    eE: function(n) {
                        var r = n.nV;
                        return A2(VM, E([
                            n_(E([
                                v("text-end", !e)
                            ]))
                        ]), E([
                            a_(Bs(r)),
                            A2($V, E([
                                XM(hV(5))
                            ]), E([
                                yJ
                            ]))
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.nV;
                    }, B$))
                },
                {
                    ai: "Transport frigorifique",
                    eE: A2(Fu, function(n) {
                        return n.hv;
                    }, A2(Fu, PJ, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.hv;
                    }, PJ))
                },
                {
                    ai: "Proc\xe9d\xe9",
                    eE: function(n) {
                        var r = n.t;
                        return A2(VM, w, E([
                            A2(VM, E([
                                WM("cursor-help"),
                                V_(Gb(r))
                            ]), E([
                                a_(Wb(r)),
                                e ? A2(A_, w, E([
                                    a_(" ("),
                                    a_(Gb(r)),
                                    a_(")")
                                ])) : a_("")
                            ])),
                            A2(VM, E([
                                WM("cursor-help"),
                                V_(r.gd)
                            ]), E([
                                a_(r.gd)
                            ]))
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.t;
                    }, Wb))
                },
                {
                    ai: "Source",
                    eE: A2(Fu, function(n) {
                        return n.t;
                    }, A2(Fu, function(n) {
                        return n.ha;
                    }, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.t;
                    }, function(n) {
                        return n.ha;
                    }))
                },
                {
                    ai: "Services \xe9cosyst\xe9miques",
                    eE: function(n) {
                        var e = n.lH;
                        return A2(VM, E([
                            WM("overflow-scroll")
                        ]), E([
                            A2(VM, E([
                                WM("d-flex gap-2")
                            ]), A2(ju, function(n) {
                                var e = n.b;
                                return A2(d_, w, E([
                                    a_(n.a + ": "),
                                    A2($W, {
                                        le: 2,
                                        aL: "Pts/kg"
                                    }, e)
                                ]));
                            }, E([
                                v($J, e.ah),
                                v(kJ, e.am),
                                v(hJ, e.ag),
                                v(xJ, e.al)
                            ])))
                        ]));
                    },
                    eH: sW(Bi(hW))
                }
            ]),
            lX: w,
            l_: "ingredients",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, zg),
            oX: A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, Om, pd(r)))),
            oY: A2(Fu, TJ, kP)
        };
    }, IJ = A2(CW, ds, SJ), OJ = F4(function(n, e, r, t) {
        var u, a = n.l1;
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, zg, aW)), e, r, ds, SJ, A2(IE, function(n) {
                return n.ei;
            }, a.mm)),
            t.$ ? a_("") : oW(1 === (u = A2(Dg, t.a, a.mm)).$ ? iW(u.a) : IJ(u.a))
        ]);
    }), qJ = function(n) {
        return n.S;
    }, LJ = A2(Fu, ij, A2(Fu, La(ru), bh)), MJ = function(n) {
        return bh(E([
            $E(n.Q),
            LJ(qJ(n.Q)),
            $E(n.q),
            n.E.g,
            n._,
            bh(n.cm),
            n.af.eD.g,
            n.af.eF.g,
            bh(n.bK)
        ]));
    }, _J = F3(function(n, e, r) {
        var t = n.h4, u = n.C, a = r.g1;
        return A2(eh, 0, A2(ss, A2(Fu, MJ, A2(Fu, fh(19), m$)), A2(Vx, {
            ay: t,
            C: u,
            as: e
        }, a)));
    }), RJ = function(n) {
        return A2(Fu, oJ(n), lh(function() {
            return Rh(10);
        }));
    }, HJ = F3(function(n, e, r) {
        return A2(eh, 0, A2(ss, function(n) {
            return A2(fh, 19, A2(RJ, n.aT, MJ(n)));
        }, A2(Vx, {
            ay: n.h4,
            C: n.C,
            as: e
        }, r.g1)));
    }), UJ = F3(function(n, e, r) {
        var t = n.gJ, u = n.gI, a = r.lq, i = r.as;
        return {
            kX: E([
                {
                    ai: "Nom",
                    eE: A2(Fu, Gt, A2(Fu, function(n) {
                        return n.ei;
                    }, a_)),
                    eH: sW(A2(Fu, Gt, function(n) {
                        return n.ei;
                    }))
                },
                {
                    ai: "Famille",
                    eE: A2(Fu, Gt, A2(Fu, function(n) {
                        return n.as;
                    }, A2(Fu, qx, a_))),
                    eH: sW(A2(Fu, Gt, A2(Fu, function(n) {
                        return n.as;
                    }, qx)))
                },
                {
                    ai: "Cat\xe9gorie",
                    eE: function(n) {
                        var e = n.a.hY;
                        return "" === e ? A2(f_, E([
                            WM("text-muted")
                        ]), E([
                            a_("non-renseign\xe9")
                        ])) : a_(e);
                    },
                    eH: sW(A2(Fu, Gt, function(n) {
                        return n.hY;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental",
                    eE: function(n) {
                        return A3(bJ, a, t, n.b.bm);
                    },
                    eH: fW(A2(Fu, Gh, function(n) {
                        return n.bm;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental/100g",
                    eE: function(n) {
                        return A3(bJ, a, u, n.b.bh);
                    },
                    eH: fW(A2(Fu, Gh, function(n) {
                        return n.bh;
                    }))
                },
                {
                    ai: "",
                    eE: function(n) {
                        var r = n.a;
                        return A2(KM, E([
                            WM("btn btn-light btn-sm w-100"),
                            QM(A2(Rb, e, r.mf)),
                            V_("Charger " + r.ei)
                        ]), E([
                            mJ
                        ]));
                    },
                    eH: dJ
                }
            ]),
            lX: w,
            l_: gs(i) + "-examples",
            mI: w,
            oV: A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, bf)),
            oX: A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, jd(e), pd(i))))),
            oY: A2(Fu, Gt, A2(Fu, pJ, kP))
        };
    }), zJ = F5(function(n, e, r, t, u) {
        var a = bs(t), i = A2(IE, A2(Fu, Gt, function(n) {
            return n.ei;
        }), A2(ju, function(e) {
            return v(e, {
                bh: A3(HJ, n, a, e),
                bm: A3(_J, n, a, e)
            });
        }, A2(ks, function(n) {
            return s(n.as, a);
        }, n.C.l5.lP))), c = {
            gI: A2(_c, 0, vP(A2(ju, A2(Fu, Gh, function(n) {
                return n.bh;
            }), i))),
            gJ: A2(_c, 0, vP(A2(ju, A2(Fu, Gh, function(n) {
                return n.bm;
            }), i)))
        };
        return E([
            A6(oV, A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, bf, aW))), e, r, a, A2(UJ, c, t), A2(IE, A2(Fu, Gt, function(n) {
                return n.ei;
            }), A2(ks, A2(Fu, Gt, A2(Fu, function(n) {
                return n.g1;
            }, Sc(Xx))), i))),
            function() {
                if (u.$) return a_("");
                var e = u.a;
                return oW(function() {
                    var r = A2(Qx, e, n.C.l5.lP);
                    if (1 === r.$) return iW(r.a);
                    var u = r.a;
                    return A3(CW, a, A2(UJ, c, t), v(u, {
                        bh: A3(HJ, n, a, u),
                        bm: A3(_J, n, a, u)
                    }));
                }());
            }()
        ]);
    }), DJ = function(n) {
        return A2(at, " ", E([
            Ml(n.kf),
            n.ik,
            n.ai,
            n.aL
        ]));
    }, NJ = function(n) {
        var e = n.lq, r = n.as;
        return {
            kX: E([
                {
                    ai: "Code",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(Ml(n.kf))
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.kf;
                    }, Ml))
                },
                {
                    ai: "Nom",
                    eE: function(n) {
                        return A2(d_, E([
                            V_(n.ai)
                        ]), E([
                            a_(n.ai)
                        ]));
                    },
                    eH: sW(function(n) {
                        return n.ai;
                    })
                },
                {
                    ai: "Unit\xe9",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(n.aL)
                        ]));
                    },
                    eH: sW(function(n) {
                        return n.aL;
                    })
                },
                {
                    ai: "Normalisation (Co\xfbt Evt)",
                    eE: function(n) {
                        return A2(_c, a_(hW), A2(Lc, A2(Fu, function(n) {
                            return n.i9;
                        }, A2(Fu, m$, A2(lW, 2, n.aL))), n.ip));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.ip;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.i9;
                    }, m$)), _c(0))))
                },
                {
                    ai: "Pond\xe9ration (Co\xfbt Evt)",
                    eE: A2(Fu, function(n) {
                        return n.ip;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.kl;
                    }, xV(2))), _c(a_(hW)))),
                    eH: fW(A2(Fu, function(n) {
                        return n.ip;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.kl;
                    }, Qo)), _c(0))))
                },
                {
                    ai: "Description",
                    eE: function(n) {
                        return e ? A2(vF, w, n.ik) : A2(d_, E([
                            V_(n.ik)
                        ]), E([
                            a_(A3(Xb, "*", "", n.ik))
                        ]));
                    },
                    eH: sW(function(n) {
                        return n.ik;
                    })
                }
            ]),
            lX: E([
                A2(sV, "Unit\xe9", A2(Fu, function(n) {
                    return n.aL;
                }, ik))
            ]),
            l_: "impacts",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.kf;
            }, Ml),
            oX: A2(Fu, function(n) {
                return n.kf;
            }, A2(Fu, Rr, A2(Fu, qm, pd(r)))),
            oY: A2(Fu, DJ, kP)
        };
    }, FJ = function(n) {
        return A2(ju, function(e) {
            return A2(th, e, n);
        }, IV);
    }, KJ = F5(function(n, e, r, t, u) {
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.kf;
            }, A2(Fu, Ml, aW)), e, r, t, NJ, A2(IE, A2(Fu, function(n) {
                return n.kf;
            }, Ml), FJ(n))),
            A2(_c, a_(""), A2(Lc, oW, A2(Lc, A2(CW, t, NJ), A2(Lc, function(e) {
                return A2(th, e, n);
            }, u))))
        ]);
    }), GJ = F2(function(n, e) {
        return n || 1 > m(iu(e), 80) ? a_(e) : a_(A2(lu, 80, e) + "\u2026");
    }), WJ = A2(Fu, hh, A2(lW, 2, "kWh")), VJ = function(n) {
        var e = n.mV;
        if (e.$) return a_("N/A");
        var r = e.a;
        return 2 !== n.aL ? A3(lW, 2, "kg/" + Ch(n.aL), r) : a_("N/A");
    }, JJ = A2(Fu, $h, A2(lW, 2, "MJ")), BJ = function(n) {
        return a_(Bs(n));
    }, XJ = F2(function(n, e) {
        var r = n.C, t = A2(js, vj(e), r.bR);
        return 1 === t.$ ? e : t.a.ei + " (" + e + ")";
    }), QJ = function(n) {
        return A2(d_, E([
            WM("cursor-help"),
            V_(n)
        ]), E([
            a_(n)
        ]));
    }, ZJ = F2(function(n, e) {
        return E([
            {
                ai: "Identifiant",
                eE: function(n) {
                    return A2(y_, w, E([
                        a_(_s(n.mf))
                    ]));
                },
                eH: sW(A2(Fu, function(n) {
                    return n.mf;
                }, _s))
            },
            {
                ai: "Nom",
                eE: function(n) {
                    return A2(VM, E([
                        WM("d-flex flex-column"),
                        V_(Wb(n))
                    ]), A2(La, ru, E([
                        Rr(a_(Wb(n))),
                        A2(Lc, function(n) {
                            return A2(y_, E([
                                WM("fs-9")
                            ]), E([
                                a_(n)
                            ]));
                        }, n.hI)
                    ])));
                },
                eH: sW(Wb)
            },
            {
                ai: "Nom technique",
                eE: A2(Fu, Gb, QJ),
                eH: sW(Gb)
            },
            {
                ai: "Source",
                eE: A2(Fu, function(n) {
                    return n.ha;
                }, a_),
                eH: sW(function(n) {
                    return n.ha;
                })
            },
            {
                ai: "R\xe9gion",
                eE: A2(Fu, function(n) {
                    return n.i$;
                }, A2(Fu, Lc(XJ(n)), A2(Fu, _c(hW), a_))),
                eH: sW(A2(Fu, function(n) {
                    return n.i$;
                }, _c(hW)))
            },
            {
                ai: "Cat\xe9gories",
                eE: A2(Fu, function(n) {
                    return n.cK;
                }, A2(Fu, ju(yP), A2(Fu, at(", "), QJ))),
                eH: sW(A2(Fu, function(n) {
                    return n.cK;
                }, A2(Fu, ju(yP), at(", "))))
            },
            {
                ai: "Unit\xe9",
                eE: A2(Fu, function(n) {
                    return n.aL;
                }, A2(Fu, Ch, a_)),
                eH: sW(A2(Fu, function(n) {
                    return n.aL;
                }, Ch))
            },
            {
                ai: "\xc9lectricit\xe9",
                eE: A2(Fu, function(n) {
                    return n.d0;
                }, WJ),
                eH: fW(A2(Fu, function(n) {
                    return n.d0;
                }, hh))
            },
            {
                ai: "Chaleur",
                eE: A2(Fu, function(n) {
                    return n.d9;
                }, JJ),
                eH: fW(A2(Fu, function(n) {
                    return n.d9;
                }, $h))
            },
            {
                ai: "Ratio de variation de quantit\xe9",
                eE: A2(Fu, function(n) {
                    return n.g0;
                }, BJ),
                eH: fW(A2(Fu, function(n) {
                    return n.g0;
                }, vh))
            },
            {
                ai: "Masse par unit\xe9",
                eE: VJ,
                eH: sW(A2(Fu, function(n) {
                    return n.mV;
                }, A2(Fu, Lc(Bs), _c(hW))))
            },
            {
                ai: "Commentaire",
                eE: A2(Fu, function(n) {
                    return n.gd;
                }, GJ(e)),
                eH: sW(function(n) {
                    return n.gd;
                })
            }
        ]);
    }), YJ = {
        ag: "Diversit\xe9 culturale",
        aa: "For\xeat",
        ah: "Haies",
        aj: "Microfibres",
        ak: "Export hors-Europe",
        al: "Prairies permanentes",
        am: "Taille de parcelles"
    }, nB = function(n) {
        var e = n.C, r = function(n) {
            return A2(Fu, function(n) {
                return n.mY;
            }, A2(Fu, Qa(function(n) {
                return n.kZ;
            }), A2(Fu, Qa(n), Lc(m$))));
        };
        return A3(st, F2(function(n, t) {
            return {
                ai: t,
                eE: A2(Fu, r(n), A2(Fu, Lc($W(A2(th, 19, e.cV))), _c(a_(hW)))),
                eH: fW(A2(Fu, r(n), _c(0)))
            };
        }), aj, ij(YJ));
    }, eB = function(n) {
        var e = n.le, r = n.aL;
        return A2(Fu, fh(n.kf), A2(Fu, m$, A2(lW, e, r)));
    }, rB = F2(function(n, e) {
        return {
            ai: Ml(e),
            eE: A2(Fu, function(n) {
                return n.g;
            }, eB(A2(th, e, n))),
            eH: fW(A2(Fu, function(n) {
                return n.g;
            }, A2(Fu, fh(e), m$)))
        };
    }), tB = function(n) {
        var e = n.C;
        return Ul(n) ? A2(ju, rB(e.cV), IV) : ik(A2(rB, e.cV, 19));
    }, uB = F2(function(n, e) {
        var r = e.as;
        return {
            kX: k(A2(ZJ, n, e.lq), k(tB(n), nB(n))),
            lX: E([
                A2(sV, "Cat\xe9gories", A2(Fu, function(n) {
                    return n.cK;
                }, ju(yP))),
                A2(sV, "Unit\xe9s", A2(Fu, function(n) {
                    return n.aL;
                }, A2(Fu, Ch, ik))),
                A2(sV, "R\xe9gion", A2(Fu, function(n) {
                    return n.i$;
                }, A2(Fu, Lc(XJ(n)), A2(Fu, _c(hW), ik))))
            ]),
            l_: "processes",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, _s),
            oX: A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, Lm(r), pd(r)))),
            oY: function(n) {
                return n.jQ;
            }
        };
    }), aB = F5(function(n, e, r, t, u) {
        var a = A2(Nh, E([
            e
        ]), n.C.W);
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, _s, aW)), r, t, e, uB(n), A2(IE, Wb, a)),
            function() {
                if (u.$) return a_("");
                var r = u.a;
                return oW(function() {
                    var t = A2(Rs, r, a);
                    if (1 === t.$) return iW(t.a);
                    var u = t.a;
                    return A3(CW, e, uB(n), u);
                }());
            }()
        ]);
    }), iB = function(n) {
        return ks(A2(Fu, function(n) {
            return n.as;
        }, Rt(n)));
    }, cB = F2(function(n, e) {
        var r = A2(ss, Wb, A2(Rs, e, n));
        return 1 === r.$ ? "Erreur\xa0: " + r.a : r.a;
    }), oB = F2(function(n, e) {
        return lf(e.q) ? w : A2(ju, cB(n), e.q);
    }), fB = F2(function(n, e) {
        return lf(e.q) ? hW : A2(at, ", ", A2(ju, cB(n), e.q));
    }), sB = F2(function(n, e) {
        return lf(e.aM) ? w : A2(ju, A2(Fu, function(n) {
            return n.bk;
        }, cB(n)), e.aM);
    }), lB = F2(function(n, e) {
        return lf(e.aM) ? hW : A2(at, ", ", A2(ju, A2(Fu, function(n) {
            return n.bk;
        }, cB(n)), e.aM));
    }), dB = F2(function(n, e) {
        var r = e.E;
        return r.$ ? hW : A2(cB, n, r.a);
    }), bB = function(n) {
        return A2(at, " ", E([
            qh(n.mf),
            n.ai,
            To(n.as)
        ]));
    }, mB = function(n) {
        return n ? "Oui" : "Non";
    }, pB = F3(function(n, e) {
        var r = n.C;
        return {
            kX: E([
                {
                    ai: "Identifiant",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(qh(n.mf))
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.mf;
                    }, qh))
                },
                {
                    ai: "Cat\xe9gorie de produit",
                    eE: A2(Fu, function(n) {
                        return n.ai;
                    }, a_),
                    eH: sW(function(n) {
                        return n.ai;
                    })
                },
                {
                    ai: "Assemblage",
                    eE: A2(Fu, fB(r.W), a_),
                    eH: sW(fB(r.W))
                },
                {
                    ai: "Transport r\xe9frig\xe9r\xe9",
                    eE: A2(Fu, function(n) {
                        return n.aN;
                    }, A2(Fu, mB, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.aN;
                    }, mB))
                },
                {
                    ai: "Distribution",
                    eE: A2(Fu, dB(r.W), a_),
                    eH: sW(dB(r.W))
                },
                {
                    ai: "Consommations",
                    eE: A2(Fu, lB(r.W), a_),
                    eH: sW(lB(r.W))
                }
            ]),
            lX: E([
                {
                    fh: "Assemblage",
                    fQ: oB(r.W)
                },
                {
                    fh: "Transport r\xe9frig\xe9r\xe9",
                    fQ: function(n) {
                        return E([
                            mB(n.aN)
                        ]);
                    }
                },
                {
                    fh: "Distribution",
                    fQ: A2(Fu, dB(r.W), ik)
                },
                {
                    fh: "Consommations",
                    fQ: sB(r.W)
                }
            ]),
            l_: To(e) + "-product-categories",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, qh),
            oX: function(n) {
                var r = n.mf;
                return A2(pd, bs(e), A2(Mm, e, Rr(r)));
            },
            oY: A2(Fu, bB, kP)
        };
    }), vB = F5(function(n, e, r, t, u) {
        var a = bs(e);
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, qh, aW)), r, t, a, A2(pB, n, e), A2(iB, e, n.C.dp)),
            function() {
                if (u.$) return a_("");
                var r = u.a;
                return oW(function() {
                    var t = A2(Lh, r, n.C.dp);
                    if (1 === t.$) return iW(t.a);
                    var u = t.a;
                    return A3(CW, a, A2(pB, n, e), u);
                }());
            }()
        ]);
    }), gB = F2(function(n, e) {
        var r = n.h4, t = n.C, u = e.g1;
        return A2(eh, 0, A2(ss, A2(Fu, function(n) {
            return n.g;
        }, A2(Fu, fh(19), m$)), A3(QE, t, r, u)));
    }), hB = F2(function(n, e) {
        var r = n.h4, t = n.C, u = e.g1;
        return A2(eh, 0, A2(ss, A2(Fu, function(n) {
            return n.g;
        }, A2(Fu, RJ(u.P), A2(Fu, fh(19), m$))), A3(QE, t, r, u)));
    }), $B = F3(function(n, e, r) {
        var t = n.C, u = e.gJ, a = e.gI, i = r.lq, c = r.as;
        return {
            kX: E([
                {
                    ai: "Nom",
                    eE: A2(Fu, Gt, A2(Fu, function(n) {
                        return n.ei;
                    }, a_)),
                    eH: sW(A2(Fu, Gt, function(n) {
                        return n.ei;
                    }))
                },
                {
                    ai: "Cat\xe9gorie",
                    eE: A2(Fu, Gt, A2(Fu, function(n) {
                        return n.hY;
                    }, a_)),
                    eH: sW(A2(Fu, Gt, function(n) {
                        return n.hY;
                    }))
                },
                {
                    ai: "Accessoires",
                    eE: function(n) {
                        var e = n.a, r = e.g1.pb;
                        if (r.$) {
                            var u = A2(is, A2(Fu, function(n) {
                                return n.pb;
                            }, Kw(t)), A2(PE, e.g1.aS, t.oT.dp));
                            if (1 === u.$) {
                                var a = u.a;
                                return A2(VM, E([
                                    WM("text-danger")
                                ]), E([
                                    a_("Erreur : " + a)
                                ]));
                            }
                            return a_(u.a);
                        }
                        var i = r.a;
                        return A2(eh, a_("Aucun"), A2(ss, A2(Fu, at(", "), function(n) {
                            return su(n) ? a_("Aucun") : A2(d_, E([
                                WM("cursor-help"),
                                V_(n)
                            ]), E([
                                a_(n)
                            ]));
                        }), Jg(A2(ju, Fw(t), i))));
                    },
                    eH: dJ
                },
                {
                    ai: "Co\xfbt Environnemental",
                    eE: function(n) {
                        return A3(bJ, i, u, n.b.bm);
                    },
                    eH: fW(A2(Fu, Gh, function(n) {
                        return n.bm;
                    }))
                },
                {
                    ai: "Co\xfbt Environnemental/100g",
                    eE: function(n) {
                        return A3(bJ, i, a, n.b.bh);
                    },
                    eH: fW(A2(Fu, Gh, function(n) {
                        return n.bh;
                    }))
                },
                {
                    ai: "",
                    eE: function(n) {
                        var e = n.a.mf, r = n.a.ei;
                        return A2(KM, E([
                            WM("btn btn-light btn-sm w-100"),
                            QM(kd(e)),
                            V_("Charger " + r)
                        ]), E([
                            mJ
                        ]));
                    },
                    eH: dJ
                }
            ]),
            lX: E([
                A2(sV, "Cat\xe9gorie", A2(Fu, Gt, A2(Fu, function(n) {
                    return n.hY;
                }, ik)))
            ]),
            l_: "examples",
            mI: w,
            oV: A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, bf)),
            oX: A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, Ed, pd(c))))),
            oY: A2(Fu, Gt, A2(Fu, pJ, kP))
        };
    }), xB = F4(function(n, e, r, t) {
        var u = A2(IE, A2(Fu, Gt, function(n) {
            return n.ei;
        }), A2(ju, function(e) {
            return v(e, {
                bh: A2(hB, n, e),
                bm: A2(gB, n, e)
            });
        }, n.C.oT.lP)), a = {
            gI: A2(_c, 0, vP(A2(ju, A2(Fu, Gh, function(n) {
                return n.bh;
            }), u))),
            gJ: A2(_c, 0, vP(A2(ju, A2(Fu, Gh, function(n) {
                return n.bm;
            }), u)))
        };
        return E([
            A6(oV, A2(Fu, Gt, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, bf, aW))), e, r, ms, A2($B, n, a), A2(IE, A2(Fu, Gt, function(n) {
                return n.ei;
            }), u)),
            function() {
                if (t.$) return a_("");
                var e = t.a;
                return oW(function() {
                    var r = A2(Qx, e, n.C.oT.lP);
                    if (1 === r.$) return iW(r.a);
                    var t = r.a;
                    return A3(CW, ms, A2($B, n, a), v(t, {
                        bh: A2(hB, n, t),
                        bm: A2(gB, n, t)
                    }));
                }());
            }()
        ]);
    }), kB = F2(function(n, e) {
        return A2(Qa, function(e) {
            return A2(Lc, function(n) {
                return n.t;
            }, Ld(A2(qj, e, n)));
        }, e.g3);
    }), wB = function(n) {
        return 1 !== n.$;
    }, yB = A2(Fu, wB, mB), jB = F2(function(n, e) {
        return a_(A2(zw, n, e));
    }), EB = function(n) {
        return 3 === n ? "Filage" : "Filature";
    }, AB = function(n) {
        switch(n){
            case 0:
                return "Mati\xe8re artificielle d'origine organique";
            case 1:
                return "Mati\xe8re naturelle d'origine animale";
            case 2:
                return "Mati\xe8re naturelle d'origine v\xe9g\xe9tale";
            default:
                return "Mati\xe8re synth\xe9tique";
        }
    }, CB = function(n) {
        switch(n){
            case 0:
                return "ArtificialFromOrganic";
            case 1:
                return "NaturalFromAnimal";
            case 2:
                return "NaturalFromVegetal";
            default:
                return "Synthetic";
        }
    }, PB = F2(function(n, e) {
        return A2(at, " ", E([
            Oj(e.mf),
            e.ei,
            e.hI,
            CB(e.jd),
            Wb(e.t),
            e.t.ha,
            e.ic,
            A2(eh, "", A2(ss, function(n) {
                return n.ei;
            }, A2(js, e.ic, n)))
        ]));
    }), TB = F2(function(n, e) {
        var r = e.lq, t = e.as, u = F2(function(n, e) {
            return A2(VM, E([
                n_(E([
                    v("text-center", !r)
                ]))
            ]), E([
                e,
                A2($V, E([
                    XM(hV(n))
                ]), E([
                    yJ
                ]))
            ]));
        });
        return {
            kX: E([
                {
                    ai: "Identifiant",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(Oj(n.mf))
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.mf;
                    }, Oj))
                },
                {
                    ai: "Nom",
                    eE: A2(Fu, function(n) {
                        return n.ei;
                    }, a_),
                    eH: sW(function(n) {
                        return n.ei;
                    })
                },
                {
                    ai: "Proc\xe9d\xe9",
                    eE: A2(Fu, function(n) {
                        return n.t;
                    }, A2(Fu, Wb, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.t;
                    }, Wb))
                },
                {
                    ai: "Source",
                    eE: A2(Fu, function(n) {
                        return n.t;
                    }, A2(Fu, function(n) {
                        return n.ha;
                    }, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.t;
                    }, function(n) {
                        return n.ha;
                    }))
                },
                {
                    ai: "Origine",
                    eE: A2(Fu, function(n) {
                        return n.jd;
                    }, A2(Fu, AB, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.jd;
                    }, AB))
                },
                {
                    ai: "Recycl\xe9e ?",
                    eE: A2(Fu, function(n) {
                        return n.g3;
                    }, A2(Fu, yB, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.g3;
                    }, yB))
                },
                {
                    ai: "Compl\xe9ment Microfibres",
                    eE: A2(Fu, function(n) {
                        return n.jd;
                    }, A2(Fu, FE, A2(Fu, m$, A2(Fu, $W({
                        le: 2,
                        aL: "\u202FPts/kg"
                    }), u(10))))),
                    eH: fW(A2(Fu, function(n) {
                        return n.jd;
                    }, A2(Fu, FE, m$)))
                },
                {
                    ai: "Proc\xe9d\xe9 de fabrication du fil",
                    eE: A2(Fu, function(n) {
                        return n.jd;
                    }, A2(Fu, EB, A2(Fu, a_, u(28)))),
                    eH: sW(A2(Fu, function(n) {
                        return n.jd;
                    }, EB))
                },
                {
                    ai: "Proc\xe9d\xe9 de recyclage",
                    eE: A2(Fu, kB(n.oT.fn), A2(Fu, Lc(A2(Fu, Wb, a_)), _c(a_(hW)))),
                    eH: sW(A2(Fu, kB(n.oT.fn), A2(Fu, Lc(Wb), _c(hW))))
                },
                {
                    ai: "Origine g\xe9ographique",
                    eE: A2(Fu, function(n) {
                        return n.l6;
                    }, a_),
                    eH: sW(function(n) {
                        return n.l6;
                    })
                },
                {
                    ai: "Pays de production et de filature par d\xe9faut",
                    eE: function(e) {
                        var r = A2(js, e.ic, n.bR);
                        return 1 === r.$ ? c_({
                            hO: w,
                            h0: Hr,
                            h5: E([
                                a_(r.a)
                            ]),
                            eb: 0,
                            eC: Hr
                        }) : a_(r.a.ei);
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.ic;
                    }, A2(Fu, function(e) {
                        return A2(js, e, n.bR);
                    }, A2(Fu, ss(function(n) {
                        return n.ei;
                    }), A2(Fu, Ld, _c("error"))))))
                },
                {
                    ai: "CFF: Coefficient d'allocation",
                    eE: A2(Fu, function(n) {
                        return n.kP;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.mS;
                    }, A2(Fu, jB(1), u(9)))), _c(a_(hW)))),
                    eH: fW(A2(Fu, function(n) {
                        return n.kP;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.mS;
                    }, Qo)), _c(0))))
                },
                {
                    ai: "CFF: Rapport de qualit\xe9",
                    eE: A2(Fu, function(n) {
                        return n.kP;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.nZ;
                    }, A2(Fu, jB(1), u(9)))), _c(a_(hW)))),
                    eH: fW(A2(Fu, function(n) {
                        return n.kP;
                    }, A2(Fu, Lc(A2(Fu, function(n) {
                        return n.nZ;
                    }, Qo)), _c(0))))
                }
            ]),
            lX: E([
                A2(sV, "Origine de la mati\xe8re", A2(Fu, function(n) {
                    return n.jd;
                }, A2(Fu, AB, ik))),
                A2(sV, "Origine g\xe9ographique", A2(Fu, function(n) {
                    return n.l6;
                }, ik)),
                A2(sV, "Recyclage", A2(Fu, function(n) {
                    return n.g3;
                }, A2(Fu, yB, ik))),
                A2(sV, "Pays de production et de filature par d\xe9faut", A2(Fu, function(n) {
                    return n.ic;
                }, A2(Fu, function(e) {
                    return A2(js, e, n.bR);
                }, A2(Fu, ss(function(n) {
                    return n.ei + " (" + n.cM + ")";
                }), A2(Fu, eh(hW), ik)))))
            ]),
            l_: "materials",
            mI: w,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, Oj),
            oX: A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, _m, pd(t)))),
            oY: A2(Fu, PB(n.bR), kP)
        };
    }), SB = function(n) {
        return A2(CW, ms, TB(n));
    }, IB = F4(function(n, e, r, t) {
        var u;
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Oj, aW)), e, r, ms, TB(n), n.oT.fn),
            t.$ ? a_("") : oW(1 === (u = A2(qj, t.a, n.oT.fn)).$ ? iW(u.a) : A2(SB, n, u.a))
        ]);
    }), OB = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qB = function(n) {
        switch(n){
            case 0:
                return "Grande entreprise avec service de r\xe9paration";
            case 1:
                return "Grande entreprise sans service de r\xe9paration";
            default:
                return "PME/TPE";
        }
    }, LB = A2(Fu, AE, A2(lW, 0, "j")), MB = A2(Fu, function(n) {
        return n.gH;
    }, A2(Fu, function(n) {
        return n.ge;
    }, kj)), _B = function(n) {
        return n / 3600;
    }, RB = A2(Fu, _B, A2(lW, 2, "h")), HB = A2(Fu, $j, A2(lW, 0, "min")), UB = A2(Fu, kf, A2(lW, 2, "\u20AC")), zB = A2(Fu, Ef, A2(Fu, St, A2(lW, 0, "g/m\xb2"))), DB = function(n) {
        return A3(lW, 0, "#/cm", n);
    }, NB = function(n) {
        return A2(at, " ", E([
            n.mf,
            n.ei,
            cA(n.iv),
            Bo(n.iv)
        ]));
    }, FB = function(n) {
        return A2(d_, E([
            V_(n)
        ]), E([
            a_(n)
        ]));
    }, KB = A2(Fu, Tf, A2(lW, 0, "Nm")), GB = F2(function(n, e) {
        var r, t = n.C, u = e.lq, a = e.as;
        return {
            kX: E([
                {
                    ai: "Identifiant",
                    eE: function(n) {
                        return A2(y_, w, E([
                            a_(n.mf)
                        ]));
                    },
                    eH: sW(A2(Fu, function(n) {
                        return n.mf;
                    }, If))
                },
                {
                    ai: "Produit(s) concern\xe9(s)",
                    eE: A2(Fu, function(n) {
                        return n.ei;
                    }, a_),
                    eH: sW(function(n) {
                        return n.ei;
                    })
                },
                {
                    ai: "Accessoires par d\xe9faut",
                    eE: function(n) {
                        var e = n.pb;
                        if (lf(e)) return a_("Aucun");
                        var r = A2(Kw, t, e);
                        if (1 === r.$) {
                            var u = r.a;
                            return A2(d_, E([
                                WM("text-danger")
                            ]), E([
                                a_("Erreur: " + u)
                            ]));
                        }
                        return a_(r.a);
                    },
                    eH: dJ
                },
                {
                    ai: "Titrage*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            KB(n.pR)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.pR;
                    }, Tf))
                },
                {
                    ai: "Grammage*",
                    eE: function(n) {
                        var e = n.hf;
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            zB(e)
                        ]));
                    },
                    eH: OB(A2(Fu, function(n) {
                        return n.hf;
                    }, Ef))
                },
                (r = function(n) {
                    return A2(Dy, n.hf, n.pR);
                }, {
                    ai: "Densit\xe9 de fils**",
                    eE: A2(Fu, r, DB),
                    eH: fW(A2(Fu, r, Hy))
                }),
                {
                    ai: "Volume*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            dW(n._.eU)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n._;
                    }, A2(Fu, function(n) {
                        return n.eU;
                    }, Zh)))
                },
                {
                    ai: "\xc9toffe*",
                    eE: A2(Fu, function(n) {
                        return n.iv;
                    }, A2(Fu, cA, a_)),
                    eH: sW(A2(Fu, function(n) {
                        return n.iv;
                    }, cA))
                },
                {
                    ai: "Stocks dormants",
                    eE: Bi(A2(VM, E([
                        n_(E([
                            v("text-center", !u)
                        ]))
                    ]), E([
                        A2(xV, 0, jj)
                    ]))),
                    eH: fW(Bi(zf(jj)))
                },
                {
                    ai: "Confection (complexit\xe9)*",
                    eE: A2(Fu, function(n) {
                        return n.gH;
                    }, A2(Fu, function(n) {
                        return n.ge;
                    }, A2(Fu, tA, a_))),
                    eH: sW(A2(Fu, function(n) {
                        return n.gH;
                    }, A2(Fu, function(n) {
                        return n.ge;
                    }, tA)))
                },
                {
                    ai: "Confection (# minutes)*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            HB(MB(n))
                        ]));
                    },
                    eH: fW(A2(Fu, MB, $j))
                },
                {
                    ai: "Confection (taux de perte)*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            A2(xV, 2, n.gH.jg)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.gH;
                    }, A2(Fu, function(n) {
                        return n.jg;
                    }, zf)))
                },
                {
                    ai: "Nombre de jours port\xe9*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            LB(n.bK.gk)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.gk;
                    }, AE)))
                },
                {
                    ai: "Utilisations avant lavage*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            a_(ut(n.bK.hA))
                        ]));
                    },
                    eH: OB(A2(Fu, function(n) {
                        return n.bK;
                    }, function(n) {
                        return n.hA;
                    }))
                },
                {
                    ai: "Cycles d'entretien (par d\xe9faut)**",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            a_(ut(n.bK.ih))
                        ]));
                    },
                    eH: OB(A2(Fu, function(n) {
                        return n.bK;
                    }, function(n) {
                        return n.ih;
                    }))
                },
                {
                    ai: "Repassage*",
                    eE: A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.ms;
                    }, WJ)),
                    eH: fW(A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.ms;
                    }, hh)))
                },
                {
                    ai: "Proc\xe9d\xe9 d'utilisation hors-repassage**",
                    eE: A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.ng;
                    }, A2(Fu, Wb, FB))),
                    eH: sW(A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.ng;
                    }, Wb)))
                },
                {
                    ai: "S\xe9chage \xe9lectrique*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            A2(xV, 0, n.bK.jv)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.jv;
                    }, zf)))
                },
                {
                    ai: "Repassage (part)*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            A2(xV, 0, n.bK.jw)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.jw;
                    }, zf)))
                },
                {
                    ai: "Repassage (temps)*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            RB(n.bK.j9)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.bK;
                    }, A2(Fu, function(n) {
                        return n.j9;
                    }, _B)))
                },
                {
                    ai: "Prix par d\xe9faut",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            UB(n.lG.jn)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.lG;
                    }, A2(Fu, function(n) {
                        return n.jn;
                    }, kf)))
                },
                {
                    ai: "Co\xfbt de r\xe9paration par d\xe9faut*",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            UB(n.lG.jB)
                        ]));
                    },
                    eH: fW(A2(Fu, function(n) {
                        return n.lG;
                    }, A2(Fu, function(n) {
                        return n.jB;
                    }, kf)))
                },
                {
                    ai: "Type d'entreprise",
                    eE: A2(Fu, function(n) {
                        return n.lG;
                    }, A2(Fu, function(n) {
                        return n.hW;
                    }, A2(Fu, qB, a_))),
                    eH: sW(A2(Fu, function(n) {
                        return n.lG;
                    }, A2(Fu, function(n) {
                        return n.hW;
                    }, qB)))
                },
                {
                    ai: "Nombre de r\xe9f\xe9rences",
                    eE: function(n) {
                        return A2(VM, E([
                            n_(E([
                                v("text-center", !u)
                            ]))
                        ]), E([
                            a_(ut(n.lG.ja)),
                            a_(" r\xe9f\xe9rences")
                        ]));
                    },
                    eH: OB(A2(Fu, function(n) {
                        return n.lG;
                    }, function(n) {
                        return n.ja;
                    }))
                }
            ]),
            lX: E([
                A2(sV, "Confection (complexit\xe9)", A2(Fu, function(n) {
                    return n.gH;
                }, A2(Fu, function(n) {
                    return n.ge;
                }, A2(Fu, tA, ik)))),
                A2(sV, "\xc9toffe", A2(Fu, function(n) {
                    return n.iv;
                }, A2(Fu, cA, ik))),
                A2(sV, "Jours de port\xe9e", A2(Fu, function(n) {
                    return n.bK;
                }, A2(Fu, function(n) {
                    return n.gk;
                }, A2(Fu, AE, A2(Fu, Bs, ik)))))
            ]),
            l_: "products",
            mI: E([
                A2(B_, E([
                    WM("list-unstyled text-muted p-2 m-0")
                ]), E([
                    A2(L_, w, E([
                        A2(D_, w, E([
                            a_("*")
                        ])),
                        a_(" Modifi\xe9 au changement de cat\xe9gorie de produit")
                    ])),
                    A2(L_, w, E([
                        A2(D_, w, E([
                            a_("**")
                        ])),
                        a_(" Modifi\xe9 au changement de cat\xe9gorie, car d\xe9pendant d\u2019autres param\xe8tres")
                    ]))
                ]))
            ]),
            oV: A2(Fu, function(n) {
                return n.mf;
            }, If),
            oX: A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, Rr, A2(Fu, Rm, pd(a)))),
            oY: A2(Fu, NB, kP)
        };
    }), WB = F4(function(n, e, r, t) {
        return E([
            A6(oV, A2(Fu, function(n) {
                return n.mf;
            }, A2(Fu, If, aW)), e, r, ms, GB(n), n.C.oT.dp),
            function() {
                if (t.$) return a_("");
                var e = t.a;
                return oW(function() {
                    var r = A2(PE, e, n.C.oT.dp);
                    if (1 === r.$) return iW(r.a);
                    var t = r.a;
                    return A3(CW, ms, GB(n), t);
                }());
            }()
        ]);
    }), VB = F2(function(n, e) {
        var r = n.C, t = e.c5, u = e.as, a = e.az, i = e.fM, c = e.du, o = {
            kX: w,
            lb: $(TV, {
                oO: E([
                    WM("table table-striped table-hover mb-0 view-list cursor-pointer")
                ])
            }),
            lz: rW,
            no: uW,
            du: c,
            os: t,
            oV: Bi(""),
            oW: tW
        };
        switch(a.$){
            case 0:
                return A5(fV, n, a.a, o, i, a.b);
            case 1:
                return A5(jV, r, o, i, u, a.a);
            case 2:
                return A4(gJ, r, o, i, a.a);
            case 3:
                return A4(OJ, r, o, i, a.a);
            case 4:
                return A5(zJ, n, o, i, a.a, a.b);
            case 5:
                return A5(KJ, r.cV, o, i, u, a.a);
            case 6:
                return A5(aB, n, a.a, o, i, a.b);
            case 7:
                return A5(vB, n, a.a, o, i, a.b);
            case 8:
                return A4(xB, n, o, i, a.a);
            case 9:
                return A4(IB, r, o, i, a.a);
            default:
                return A4(WB, n, o, i, a.a);
        }
    }), JB = function(n) {
        return {
            $: 4,
            a: n
        };
    }, BB = F2(function(n, e) {
        var r = n.lN;
        return A2(VM, E([
            WM("d-flex align-items-center gap-3")
        ]), E([
            A2(mG, E([
                WM("fw-bold d-none d-sm-block"),
                bG("scope-selector")
            ]), E([
                a_("Secteur")
            ])),
            A2(mK, E([
                WM("form-select"),
                kF("scope-selector"),
                dK(A2(Fu, vs, A2(Fu, Ld, A2(Fu, _c(ms), JB))))
            ]), A2(ju, function(n) {
                var r = n.a;
                return A2(bK, E([
                    pK(s(e.as, r)),
                    vK(gs(r))
                ]), E([
                    a_(qx(r))
                ]));
            }, A2(ks, Gh, E([
                v(ds, r.l1),
                v(bs(0), r.fb),
                v(bs(1), r.nj),
                v(ms, !0),
                v(bs(2), r.f_)
            ]))))
        ]));
    }), XB = function(n) {
        return {
            $: 7,
            a: n
        };
    }, QB = F2(function(n, e) {
        var r, t;
        return v(YG(e.az) + " | Explorer ", E([
            A2(JM, E([
                WM("pb-3")
            ]), E([
                A2(VM, E([
                    WM("row d-flex align-item-end")
                ]), E([
                    A2(VM, E([
                        WM("col-sm-8 mb-1")
                    ]), E([
                        A2(BM, w, E([
                            a_("Explorateur")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-sm-4 mt-2")
                    ]), E([
                        A2(BB, n, e)
                    ]))
                ])),
                A2(VM, E([
                    WM("row d-flex align-items-end mt-1 mx-0 g-0")
                ]), E([
                    A2(VM, E([
                        WM("col-12 col-xl-3 col-xxl-4 border-bottom")
                    ]), E([
                        (r = e, t = r.du, A2(VM, E([
                            WM("d-flex justify-content-start align-items-center gap-2")
                        ]), E([
                            A2(mG, E([
                                bG("search-field"),
                                WM("visually-hidden")
                            ]), E([
                                a_("Rechercher")
                            ])),
                            A2(q_, E([
                                i_("search"),
                                WM("form-control mb-1"),
                                kF("search-field"),
                                hG("Rechercher"),
                                vK(t),
                                dK(XB)
                            ]), w)
                        ])))
                    ])),
                    A2(VM, E([
                        WM("col-12 col-xl-9 col-xxl-8 pe-0 me-0")
                    ]), E([
                        eW(e)
                    ]))
                ])),
                A2(VM, E([
                    WM("mt-3")
                ]), A2(VB, n, e))
            ]))
        ]));
    }), ZB = {
        $: 17
    }, YB = {
        $: 18
    }, nX = function(n) {
        return {
            $: 19,
            a: n
        };
    }, eX = function(n) {
        return {
            $: 20,
            a: n
        };
    }, rX = function(n) {
        return {
            $: 21,
            a: n
        };
    }, tX = {
        $: 30
    }, uX = {
        $: 31
    }, aX = function(n) {
        return {
            $: 34,
            a: n
        };
    }, iX = F2(function(n, e) {
        return {
            $: 37,
            a: n,
            b: e
        };
    }), cX = F2(function(n, e) {
        return Mc(A2(ju, function(r) {
            return v(Ml(r), n(A2(th, r, e)));
        }, IV));
    }), oX = A2(Fu, m$, _o), fX = function(n) {
        return A2(cX, oX, n);
    }, sX = A2(Fu, Cf, _o), lX = function(n) {
        return Mc(E([
            v("air", sX(n.f1)),
            v("impacts", fX(n.g)),
            v("road", sX(n.ds)),
            v("roadCooled", sX(n.oc)),
            v("sea", sX(n.g7)),
            v("seaCooled", sX(n.om))
        ]));
    }, dX = {
        ag: "cropDiversity",
        aa: "forest",
        ah: "hedges",
        aj: "microfibers",
        ak: "outOfEuropeEOL",
        al: "permanentPasture",
        am: "plotSize"
    }, bX = A2(Fu, ij, A2(Fu, A2(st, F2(function(n, e) {
        return v(n, A2(Lc, oX, e));
    }), ij(dX)), Do)), mX = function(n) {
        var e;
        return Mc(E([
            v("total", fX(n.bI)),
            v("perKg", fX(n.gW)),
            v("scoring", (e = n.g6, Mc(E([
                v("all", oX(e.kw)),
                v("climate", oX(e.kV)),
                v("biodiversity", oX(e.kF)),
                v("health", oX(e.l9)),
                v("resources", oX(e.n7))
            ])))),
            v("totalMass", _o(n.hu)),
            v("preparedMass", _o(n.gZ)),
            v("recipe", Mc(E([
                v("total", fX(n.bl.bI)),
                v("ingredientsTotal", fX(n.bl.gD)),
                v("totalBonusImpact", bX(n.bl.kb)),
                v("transform", fX(n.bl.fT)),
                v("transports", lX(n.bl.af))
            ]))),
            v("packaging", fX(n.cm)),
            v("preparation", fX(n.bj)),
            v("transports", lX(n.af)),
            v("distribution", Mc(E([
                v("total", fX(n.E.bI)),
                v("transports", lX(n.E.af))
            ])))
        ]));
    }, pX = A2(Fu, Wo, tt(2)), vX = F2(function(n, e) {
        var r = A2(Fu, a_, A2(Fu, ik, U_(w)));
        return A2(KF, w, E([
            A2(VF, w, E([
                a_("Debug")
            ])),
            A2(VM, E([
                WM("row")
            ]), E([
                A2(VM, E([
                    WM("col-7")
                ]), E([
                    r(pX(e))
                ])),
                A2(VM, E([
                    WM("col-5")
                ]), E([
                    r(A2(eh, "Error serializing the impacts", A2(ss, A2(Fu, Gh, A2(Fu, mX, tt(2))), A2(fJ, n, e))))
                ]))
            ]))
        ]));
    }), gX = function(n) {
        return c_({
            hO: w,
            h0: Hr,
            h5: E([
                a_(n)
            ]),
            eb: 0,
            eC: Hr
        });
    }, hX = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $X = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xX = {
        $: 10
    }, kX = {
        $: 11
    }, wX = function(n) {
        return {
            $: 22,
            a: n
        };
    }, yX = {
        $: 23
    }, jX = {
        $: 24
    }, EX = {
        $: 28
    }, AX = function(n) {
        return {
            $: 33,
            a: n
        };
    }, CX = function(n) {
        return {
            $: 35,
            a: n
        };
    }, PX = function(n) {
        return {
            $: 36,
            a: n
        };
    }, TX = function(n) {
        return {
            $: 38,
            a: n
        };
    }, SX = F2(function(n, e) {
        return {
            $: 43,
            a: n,
            b: e
        };
    }), IX = {
        kw: 0,
        f3: 0,
        kF: 0,
        kV: 0,
        kZ: 0,
        l9: 0,
        n7: 0
    }, OX = {
        q: Hr,
        E: Hr,
        _: Hr,
        fn: Hr,
        cm: Hr,
        fT: Hr,
        af: Hr,
        pb: Hr,
        kh: Hr
    }, qX = F5(function(n, e, r, t, u) {
        return {
            dN: r,
            cP: lj,
            cc: e,
            gS: t,
            g6: IX,
            eu: n,
            ev: OX,
            hg: u,
            bI: Zs
        };
    }), LX = F2(function(n, e) {
        var r = A2(Fu, fh(n), Rr);
        return {
            q: Hr,
            E: r(e.E.bI),
            _: Hr,
            fn: r(e.bl.gD),
            cm: r(e.cm),
            fT: r(e.bl.fT),
            af: r(e.af.g),
            pb: Hr,
            kh: r(e.bj)
        };
    }), MX = F2(function(n, e) {
        return $(e, {
            cP: n.bl.kb,
            g6: n.g6,
            ev: A2(LX, e.cc.kf, n),
            bI: n.bI
        });
    }), _X = function(n) {
        return 19 === n;
    }, RX = fe("optgroup"), HX = F2(function(n, e) {
        var r = e.dv, t = e.oN, u = function(n) {
            var e = n.kf, t = n.ai;
            return A2(bK, E([
                pK(s(r, n.kf)),
                vK(Ml(e))
            ]), E([
                a_(t)
            ]));
        };
        return A2(VM, E([
            WM("ImpactSelector input-group"),
            A2(ZM, "data-testid", "impact-selector")
        ]), E([
            A2(mK, E([
                WM("form-select"),
                dK(A2(Fu, ym, t))
            ]), E([
                A2(RX, E([
                    A2(ZM, "label", "Impacts agr\xe9g\xe9s")
                ]), A2(ju, u, A2(ks, A2(Fu, function(n) {
                    return n.kf;
                }, _X), FJ(n)))),
                A2(RX, E([
                    A2(ZM, "label", "Impacts d\xe9taill\xe9s")
                ]), A2(ju, u, A2(IE, function(n) {
                    return n.ai;
                }, A2(ks, A2(Fu, function(n) {
                    return n.kf;
                }, A2(Fu, _X, ul)), FJ(n)))))
            ]))
        ]));
    }), UX = fe("textarea"), zX = function(n) {
        return 1 === n.$;
    }, DX = GM("pattern"), NX = s_("pencil"), FX = F2(function(n, e) {
        switch(e.$){
            case 0:
                return Sg(n.aG.l1);
            case 1:
                var r = e.a;
                return A2(nk, r, A2(Zx, r, n));
            default:
                return nA(n.aG.oT);
        }
    }), KX = F2(function(n, e) {
        var r = e.g1;
        switch(r.$){
            case 0:
                return A2(eh, e.ei, A2(ss, nh, A2(Zg, n, r.a)));
            case 1:
                return A2(eh, "N/A", A2(Kw, n, r.b.mu));
            default:
                var t = r.a;
                return A2(eh, e.ei, A2(ss, fA(n.oT.pM), A2(_E, n, t)));
        }
    }), GX = F2(function(n, e) {
        var r, t, u = e.ei, a = e.g1, i = A2(FX, n.eu, n.as), c = function() {
            switch(a.$){
                case 0:
                    return A2(vd, n.O.kf, Rr(a.a));
                case 1:
                    return A3(_b, a.a, n.O.kf, Rr(a.b));
                default:
                    return A2(zm, n.O.kf, Rr(a.a));
            }
        }(), o = !(r = n.bv).$ && s(r.a.g1, e.g1);
        return A2(L_, E([
            WM("list-group-item"),
            n_(E([
                v("active", s(a, i))
            ]))
        ]), E([
            A2(DK, E([
                WM("d-flex justify-content-between align-items-center gap-1 fs-7"),
                KK(n.jA)
            ]), E([
                function() {
                    var r = v(o, n.bv);
                    if (r.a && !r.b.$) {
                        var t = r.b.a;
                        return A2(q_, E([
                            i_("text"),
                            WM("form-control form-control-sm"),
                            dK(n.pD(e)),
                            hG("Nom de la simulation"),
                            vK(t.ei),
                            $G(!0),
                            DX("^(?!\\s*$).+")
                        ]), w);
                    }
                    return A2(KM, E([
                        WM("flex-fill text-truncate"),
                        n_(E([
                            v("active text-white", s(a, i))
                        ])),
                        V_(A2(KX, n.eu.C, e)),
                        XM(k(n.eu.kU, MA(c)))
                    ]), E([
                        a_(u)
                    ]));
                }(),
                o ? A2(YM, E([
                    i_("submit"),
                    WM("btn btn-sm btn-success"),
                    A2(OF, "max-width", "30px"),
                    V_("Sauvegarder la simulation dans le stockage local du navigateur")
                ]), E([
                    LG
                ])) : (t = e, A2(YM, E([
                    i_("button"),
                    WM("btn btn-sm btn-info"),
                    V_("Renommer"),
                    A2(ZM, "aria-label", "Renommer"),
                    u_(A2(n.pD, t, t.ei))
                ]), E([
                    NX
                ]))),
                A2(YM, E([
                    i_("button"),
                    WM("btn btn-sm btn-danger"),
                    V_("Supprimer"),
                    A2(ZM, "aria-label", "Supprimer"),
                    u_(n.ll(e))
                ]), E([
                    OG
                ]))
            ]))
        ]));
    }), WX = s_("file-download"), VX = s_("file-upload"), JX = function(n) {
        return !n.g1.$;
    }, BX = F2(function(n, e) {
        var r = e.g1;
        return 1 === r.$ && s(r.a, n);
    }), XX = function(n) {
        return 2 === n.g1.$;
    }, QX = F2(function(n, e) {
        return UI(A2(ks, function() {
            switch(e.$){
                case 0:
                    return JX;
                case 1:
                    return BX(e.a);
                default:
                    return XX;
            }
        }(), n.bH.ao));
    }), ZX = s_("stats"), YX = function(n) {
        var e = n.h2, r = n.as, t = A2(QX, n.eu, r);
        return A2(VM, w, E([
            A2(VM, E([
                WM("card-header border-top rounded-0 d-flex justify-content-between align-items-center gap-1")
            ]), E([
                A2(d_, w, E([
                    a_("Signets")
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill justify-content-end gap-1")
                ]), E([
                    A2(YM, E([
                        WM("btn btn-sm btn-outline-primary d-flex align-items-center"),
                        V_("Exporter les signets"),
                        E_(lf(t)),
                        u_(n.lU)
                    ]), E([
                        WX
                    ])),
                    A2(YM, E([
                        WM("btn btn-sm btn-outline-primary d-flex align-items-center"),
                        V_("Importer les signets"),
                        u_(n.mi)
                    ]), E([
                        VX
                    ])),
                    A2(YM, E([
                        WM("btn btn-sm btn-primary d-flex align-items-center gap-1"),
                        V_("Comparer vos simulations sauvegard\xe9es"),
                        E_(lf(t)),
                        u_(e)
                    ]), E([
                        ZX,
                        a_("Comparer")
                    ]))
                ]))
            ])),
            A2(B_, E([
                WM("list-group list-group-flush rounded-bottom overflow-auto"),
                A2(OF, "max-height", "50vh")
            ]), A2(ju, GX(n), A2(ks, function(n) {
                var e = n.g1;
                switch(e.$){
                    case 0:
                        return s(r, ds);
                    case 1:
                        return s(r, bs(e.a));
                    default:
                        return s(r, ms);
                }
            }, UI(t))))
        ]));
    }, nQ = s_("plus"), eQ = F3(function(n, e, r) {
        return A3(Xb, "%json%", e, A3(Xb, "%apiUrl%", r, A2(at, " \\\n", A2(La, ru, E([
            Rr("curl -sS -X POST %apiUrl%"),
            Rr('  -H "accept: application/json"'),
            Rr('  -H "content-type: application/json"'),
            A2(Lc, function(n) {
                return '  -H "Authorization: Bearer ' + n + '"';
            }, n),
            Rr("  -d '%json%'")
        ])))));
    }), rQ = F3(function(n, e, r) {
        return A3(eQ, n, A2(tt, 0, Wo(r)), e + "/api/food");
    }), tQ = F3(function(n, e, r) {
        return A3(eQ, n, A2(tt, 0, qf(r)), e + "/api/textile/simulator");
    }), uQ = function(n) {
        var e = n.bH;
        return A2(Lc, A2(Fu, function(n) {
            return n.f$;
        }, function(n) {
            return n.kr;
        }), e.aW);
    }, aQ = F4(function(n, e, r, t) {
        return A3(eQ, e, A2(tt, 0, Nf(t)), r + "/api/" + gs(n) + "/simulator");
    }), iQ = F3(function(n, e, r) {
        var t = A2(Zx, r, e);
        return g(k(e.kU, "/" + MA(A3(_b, r, n.kf, Rr(t)))), A4(aQ, bs(r), uQ(e), e.kU, t), A2(tt, 2, Nf(t)));
    }), cQ = function(n) {
        var e = n.kB, r = n.h5, t = n.oQ;
        return A2(VM, E([
            WM("CardTabs card shadow-sm")
        ]), A2(Ur, A2(VM, A2(Ur, WM("card-header px-0 pb-0 border-bottom-0 bg-white"), e), E([
            A2(B_, E([
                WM("Tabs nav nav-tabs nav-fill justify-content-end gap-2 px-2")
            ]), A2(ju, function(n) {
                var e = n.hF, r = n.ai, t = n.jc;
                return A2(L_, E([
                    WM("TabsTab nav-item"),
                    n_(E([
                        v("active", e)
                    ]))
                ]), E([
                    A2(YM, E([
                        WM("nav-link no-outline border-top-0"),
                        n_(E([
                            v("active", e)
                        ])),
                        u_(t)
                    ]), E([
                        r
                    ]))
                ]));
            }, t))
        ])), r));
    }, oQ = F2(function(n, e) {
        return A2(VM, E([
            WM("card-body fs-7")
        ]), E([
            A2(H_, E([
                WM("text-muted")
            ]), E([
                a_(e)
            ])),
            A2(H_, E([
                WM("fw-bold")
            ]), E([
                a_("Comment y acc\xe9der\xa0?")
            ])),
            A2(M_, E([
                WM("ps-3")
            ]), E([
                A2(L_, w, E([
                    a_("S\u2019identifier ou se cr\xe9er un compte.")
                ])),
                A2(L_, w, E([
                    a_("Depuis votre compte, accepter les conditions d\u2019utilisation des donn\xe9es Base empreinte et Ecoinvent.")
                ])),
                A2(L_, w, E([
                    a_("Revenir sur votre simulation en \xe9tant connect\xe9 et avec les conditions d\u2019utilisation accept\xe9es.")
                ]))
            ])),
            A2(VM, E([
                WM("text-center")
            ]), E([
                Rl(n) ? A2(KM, E([
                    WM("btn btn-sm btn-outline-primary"),
                    QM(ld)
                ]), E([
                    a_("Acc\xe9der \xe0 mon compte")
                ])) : A2(KM, E([
                    WM("btn btn-sm btn-outline-primary"),
                    QM(bd)
                ]), E([
                    a_("Cr\xe9er un compte")
                ]))
            ]))
        ]));
    }), fQ = F3(function(n, e, r) {
        var t = r;
        return A3(OV, F3(function(r, t, u) {
            var a = A2(th, r, n), i = e(a);
            return i.$ ? u : A2(Ur, {
                dW: i.a.dW + "bb",
                ei: a.ai,
                eP: A3(qV, i.a.i9, i.a.kl, t)
            }, u);
        }), w, t);
    }), sQ = F2(function(n, e) {
        var r = A2(ju, function(n) {
            return n.eP;
        }, e), t = v(al(r), A2(_c, 0, vP(A2(ju, uk, r)))), u = t.a, a = t.b;
        return u || a ? A2(VM, E([
            WM("table-responsive"),
            A2(OF, "max-height", "400px")
        ]), E([
            A2(N_, E([
                WM("table table-hover w-100 m-0")
            ]), E([
                A2(F_, w, A2(ju, function(e) {
                    var r = e.F, t = e.O, u = e.ei, a = e.jh, i = e.kn;
                    return A2(J_, A2(Ur, V_(u + ": " + A2(zw, 2, a) + "\u202F% (" + A2(zw, 2, t) + "\u202F" + n.aL + ")"), r), E([
                        A2(G_, E([
                            WM("text-truncate fw-normal fs-8"),
                            A2(OF, "max-width", "200px")
                        ]), E([
                            a_(u)
                        ])),
                        A2(K_, E([
                            WM("HorizontalBarChart"),
                            A2(OF, "width", "200px"),
                            A2(OF, "vertical-align", "middle")
                        ]), E([
                            A2(VM, E([
                                WM("ext"),
                                n_(E([
                                    v("pos", a >= 0),
                                    v("neg", 0 > a)
                                ]))
                            ]), E([
                                A2(VM, E([
                                    WM("bar"),
                                    n_(E([
                                        v("bg-secondary", a >= 0),
                                        v("bg-success", 0 > a)
                                    ])),
                                    A2(OF, "width", Bs(i > 0 ? A2(zt, i, 1) : i) + "%")
                                ]), w)
                            ]))
                        ])),
                        A2(K_, E([
                            WM("text-end text-nowrap fs-8")
                        ]), E([
                            wJ(a)
                        ]))
                    ]));
                }, A2(ju, function(n) {
                    var e = n.eP;
                    return {
                        F: n.F,
                        O: e,
                        ei: n.ei,
                        jh: e / u * 100,
                        kn: uk(e) / a * 100
                    };
                }, e)))
            ]))
        ])) : a_("");
    }), lQ = "#ff9500", dQ = "#f5325b", bQ = "#22d2ba", mQ = "#7b4dff", pQ = "#12a5ed", vQ = "#ea60df", gQ = "#71c614", hQ = "#dddddd", $Q = "#ffca00", xQ = function(n) {
        return A2(OF, "border-left", "5px " + n + " solid");
    }, kQ = function(n) {
        return ch(E([
            A2(_c, 0, n.ag),
            A2(_c, 0, n.ah),
            A2(_c, 0, n.al),
            A2(_c, 0, n.am)
        ]));
    }, wQ = function(n) {
        return E(19 === n.kf ? [
            1,
            2,
            0
        ] : [
            1
        ]);
    }, yQ = F2(function(n, e) {
        var r = e.dN, t = e.cP, u = e.cc, a = e.gS, i = e.g6, c = e.eu, o = e.ev, f = e.hg, l = e.bI;
        return cQ({
            kB: w,
            h5: E([
                function() {
                    var e = v(r, us(c));
                    switch(e.a){
                        case 0:
                            return e.b ? A2(sQ, u, xt(A2(IE, function(n) {
                                return n.eP;
                            }, k(E([
                                {
                                    F: w,
                                    ei: "Services \xe9cosyst\xe9miques",
                                    eP: kQ(t)
                                },
                                {
                                    F: w,
                                    ei: "Compl\xe9ment " + Os(YJ.ak),
                                    eP: A2(_c, 0, t.ak)
                                },
                                {
                                    F: w,
                                    ei: "Compl\xe9ment " + Os(YJ.aj),
                                    eP: A2(_c, 0, t.aj)
                                },
                                {
                                    F: w,
                                    ei: "Compl\xe9ment " + Os(YJ.aa),
                                    eP: A2(_c, 0, t.aa)
                                }
                            ]), A2(ju, function(n) {
                                return {
                                    F: w,
                                    ei: n.ei,
                                    eP: n.eP
                                };
                            }, A3(fQ, n, function(n) {
                                return n.ip;
                            }, l)))))) : A2(oQ, c, "Les impacts d\xe9taill\xe9s ne sont pas accessibles.");
                        case 1:
                            return A2(sQ, u, A2(ju, function(n) {
                                var e = n.F, r = n.ei, t = n.eP;
                                return {
                                    F: A2(Ur, A2(OF, "cursor", "pointer"), e),
                                    ei: r,
                                    eP: A2(_c, 0, A2(Lc, m$, t))
                                };
                            }, E([
                                {
                                    F: E([
                                        xQ(hQ),
                                        u_(a("trims-stage"))
                                    ]),
                                    ei: "Accessoires",
                                    eP: o.pb
                                },
                                {
                                    F: E([
                                        xQ(mQ),
                                        u_(a("materials-stage"))
                                    ]),
                                    ei: "Mati\xe8res premi\xe8res",
                                    eP: o.fn
                                },
                                {
                                    F: E([
                                        xQ(vQ),
                                        u_(a("transform-stage"))
                                    ]),
                                    ei: "Transformation",
                                    eP: o.fT
                                },
                                {
                                    F: E([
                                        xQ(lQ),
                                        u_(a("assembly-stage"))
                                    ]),
                                    ei: "Assemblage",
                                    eP: o.q
                                },
                                {
                                    F: E([
                                        xQ(pQ),
                                        u_(a("packaging-stage"))
                                    ]),
                                    ei: "Emballage",
                                    eP: o.cm
                                },
                                {
                                    F: E([
                                        xQ(gQ),
                                        u_(a("transport-stage"))
                                    ]),
                                    ei: "Transports",
                                    eP: o.af
                                },
                                {
                                    F: E([
                                        xQ(dQ),
                                        u_(a("distribution-stage"))
                                    ]),
                                    ei: "Distribution",
                                    eP: o.E
                                },
                                {
                                    F: E([
                                        xQ($Q),
                                        u_(a("usage-stage"))
                                    ]),
                                    ei: "Utilisation",
                                    eP: o.kh
                                },
                                {
                                    F: E([
                                        xQ(bQ),
                                        u_(a("end-of-life-stage"))
                                    ]),
                                    ei: "Fin de vie",
                                    eP: o._
                                }
                            ])));
                        default:
                            return e.b ? A2(sQ, u, E([
                                {
                                    F: w,
                                    ei: "Climat",
                                    eP: i.kV
                                },
                                {
                                    F: w,
                                    ei: "Biodiversit\xe9",
                                    eP: i.kF
                                },
                                {
                                    F: w,
                                    ei: "Sant\xe9 environnementale",
                                    eP: i.l9
                                },
                                {
                                    F: w,
                                    ei: "Ressource",
                                    eP: i.n7
                                },
                                {
                                    F: w,
                                    ei: "Compl\xe9ments",
                                    eP: i.kZ
                                }
                            ])) : A2(oQ, c, "Les sous-scores ne sont pas accessibles.");
                    }
                }()
            ]),
            oQ: A2(ju, function(n) {
                return {
                    hF: s(r, n),
                    ai: a_(xO(n)),
                    jc: f(n)
                };
            }, wQ(u))
        });
    }), jQ = function(n) {
        var e, r, t, u, a, i, c, o, f, l = n.eu.C;
        return A2(VM, E([
            WM("d-flex flex-column gap-3 mb-3 sticky-md-top"),
            A2(OF, "top", "7px")
        ]), E([
            n.eu.d$ ? A2(HX, l.cV, {
                dv: n.dv.kf,
                oN: n.oN
            }) : a_(""),
            (e = {
                h9: n.la,
                cc: n.dv,
                P: n.aT,
                bm: n.o5,
                jP: n.o6
            }, r = e.h9, t = e.cc, u = e.P, a = e.bm, i = e.jP, A2(VM, E([
                WM("Score card bg-secondary shadow-sm"),
                A2(ZM, "data-testid", "score-card"),
                A2(ZM, "data-score", Bs(A2(fh, t.kf, a)))
            ]), E([
                A2(VM, E([
                    WM("card-body text-center text-nowrap text-white")
                ]), E([
                    A2(VM, E([
                        WM("display-3 lh-1")
                    ]), E([
                        A2(eB, t, a)
                    ])),
                    A2(VM, w, E([
                        A2(_c, a_(""), A2(Lc, function(n) {
                            return A2(d_, w, E([
                                A2(eB, t, n),
                                a_(" hors durabilit\xe9")
                            ]));
                        }, i))
                    ])),
                    A2(xG, w, E([
                        a_("Pour "),
                        bW(u)
                    ]))
                ])),
                function() {
                    if (r.$) return a_("");
                    var n = r.a;
                    return A2(VM, E([
                        WM("card-footer text-white text-center")
                    ]), E([
                        n
                    ]));
                }()
            ]))),
            function() {
                var e = n.mh;
                return e.$ ? a_("") : A2(yQ, l.cV, e.a);
            }(),
            (c = {
                aV: n.ks,
                bv: n.bv,
                bw: n.bw,
                h2: n.kY,
                k0: n.k0,
                k1: n.k1,
                k2: n.k2,
                k4: n.k4,
                k6: n.k6,
                ll: n.lm,
                lU: n.lU,
                O: n.dv,
                mi: n.mi,
                m8: n.m8,
                jA: n.n5,
                jL: n.og,
                as: n.as,
                eu: n.eu,
                j4: n.oL,
                pd: n.pg,
                pi: n.pi,
                pj: n.pj,
                pD: n.pD
            }, o = E([
                v(1, a_("Sauvegarder")),
                v(2, a_("Partager"))
            ]), f = zX(c.as) ? k(o, E([
                v(0, a_("Contribuer"))
            ])) : o, cQ({
                kB: w,
                h5: E([
                    function() {
                        switch(c.aV){
                            case 0:
                                return function(n) {
                                    var e, r = n.as, t = n.eu, u = Rl(t), a = F2(function(n, e) {
                                        return A2(VM, E([
                                            WM("text-danger fs-7")
                                        ]), E([
                                            n,
                                            a_("\xa0" + e)
                                        ]));
                                    }), i = (e = US(r)).$ ? Xx : A2(Zx, e.a, t), c = A2(rl, A2(Fu, function(n) {
                                        return n.g1;
                                    }, Rt(i)), t.C.l5.lP), o = s(i, Xx), f = n.k2 || !u || o || c;
                                    return A2(VM, E([
                                        WM("card-body d-flex flex-column gap-2")
                                    ]), E([
                                        A2(VM, E([
                                            WM("fs-7 text-muted")
                                        ]), E([
                                            a_("Proposez l\u2019ajout de votre simulation \xe0 la base de donn\xe9es d\u2019exemples " + qx(r) + " sur Ecobalyse.")
                                        ])),
                                        A2(q_, E([
                                            WM("form-control form-control-sm"),
                                            i_("text"),
                                            vK(n.k1),
                                            hG("Nom de l\u2019exemple"),
                                            dK(n.pj),
                                            E_(f)
                                        ]), w),
                                        A2(UX, E([
                                            WM("form-control form-control-sm"),
                                            A2(ve, "rows", ut(3)),
                                            vK(n.k0),
                                            hG("D\xe9crivez ce que simule cet exemple et pourquoi il est pertinent de le proposer aux autres utilisateurs"),
                                            dK(n.pi),
                                            E_(f)
                                        ]), w),
                                        u ? o ? A2(a, TG, "La simulation ne peut \xeatre vide.") : c ? A2(a, TG, "Cette simulation existe d\xe9j\xe0 dans la base de donn\xe9es d\u2019exemples.") : a_("") : A2(a, l_, "Connectez-vous pour proposer une contribution."),
                                        A2(YM, E([
                                            WM("btn btn-primary btn-sm"),
                                            i_("button"),
                                            E_(f),
                                            u_(n.k6)
                                        ]), E([
                                            a_(n.k2 ? "Envoi\u2026" : "Contribuer")
                                        ]))
                                    ]));
                                }(c);
                            case 1:
                                return function(n) {
                                    var e = A2(QX, n.eu, n.as), r = v(A2(tl, A2(FX, n.eu, n.as), A2(ju, function(n) {
                                        return n.g1;
                                    }, e)), A2(tl, n.bw, A2(ju, function(n) {
                                        return n.ei;
                                    }, e))), t = r.a, u = r.b;
                                    return A2(VM, w, E([
                                        A2(VM, E([
                                            WM("card-body pb-2")
                                        ]), E([
                                            A2(DK, E([
                                                KK(n.jL)
                                            ]), E([
                                                A2(VM, E([
                                                    WM("input-group")
                                                ]), E([
                                                    A2(q_, E([
                                                        i_("text"),
                                                        WM("form-control"),
                                                        dK(n.pd),
                                                        hG("Nom de la simulation"),
                                                        vK(n.bw),
                                                        $G(!0),
                                                        DX("^(?!\\s*$).+"),
                                                        AG(t)
                                                    ]), w),
                                                    A2(YM, E([
                                                        i_("submit"),
                                                        WM("btn btn-primary"),
                                                        V_("Sauvegarder la simulation dans le stockage local au navigateur"),
                                                        E_(t || u)
                                                    ]), E([
                                                        nQ
                                                    ]))
                                                ]))
                                            ])),
                                            A2(VM, E([
                                                WM("form-text fs-7 pb-0")
                                            ]), E([
                                                t ? A2(d_, E([
                                                    WM("d-flex align-items-center gap-1")
                                                ]), E([
                                                    l_,
                                                    a_("Cette simulation est d\xe9j\xe0 sauvegard\xe9e")
                                                ])) : u ? A2(d_, E([
                                                    WM("d-flex align-items-center gap-1")
                                                ]), E([
                                                    l_,
                                                    a_("Une simulation portant ce nom existe d\xe9j\xe0")
                                                ])) : a_("Donnez un nom \xe0 cette simulation pour la retrouver plus tard")
                                            ]))
                                        ])),
                                        YX(n)
                                    ]));
                                }(c);
                            default:
                                return function(n) {
                                    var e = n.k4, r = n.O, t = n.as, u = n.eu, a = function() {
                                        switch(t.$){
                                            case 0:
                                                return g(k(u.kU, "/" + MA(A2(vd, r.kf, Rr(n = u.aG.l1)))), A3(rQ, uQ(u), u.kU, n), A2(tt, 2, Wo(n)));
                                            case 1:
                                                return A3(iQ, r, u, t.a);
                                            default:
                                                var n;
                                                return g(k(u.kU, "/" + MA(A2(zm, r.kf, Rr(n = u.aG.oT)))), A3(tQ, uQ(u), u.kU, n), A2(tt, 2, qf(n)));
                                        }
                                    }(), i = a.a, c = a.b, o = a.c;
                                    return A2(VM, w, E([
                                        A2(VM, E([
                                            WM("card-body pt-0 pb-2")
                                        ]), E([
                                            A2(C_, E([
                                                WM("h5 mt-2")
                                            ]), E([
                                                a_("Web")
                                            ])),
                                            A2(VM, E([
                                                WM("input-group")
                                            ]), E([
                                                A2(q_, E([
                                                    i_("url"),
                                                    WM("form-control"),
                                                    vK(i)
                                                ]), w),
                                                A2(YM, E([
                                                    WM("input-group-text"),
                                                    V_("Copier l'adresse"),
                                                    u_(e(i))
                                                ]), E([
                                                    EG
                                                ]))
                                            ])),
                                            A2(VM, E([
                                                WM("form-text fs-7")
                                            ]), E([
                                                a_("Copiez cette adresse pour partager ou sauvegarder votre simulation")
                                            ]))
                                        ])),
                                        A2(VM, E([
                                            WM("card-body border-top pt-0 pb-2")
                                        ]), E([
                                            A2(C_, E([
                                                WM("h5 mt-2")
                                            ]), E([
                                                a_("API")
                                            ])),
                                            A2(U_, E([
                                                WM("bg-dark text-white p-2 m-0")
                                            ]), E([
                                                A2(y_, w, E([
                                                    a_("$ " + c)
                                                ]))
                                            ])),
                                            A2(YM, E([
                                                WM("btn btn-outline-dark btn-sm w-100 d-flex justify-content-center align-items-center gap-1"),
                                                u_(e(c))
                                            ]), E([
                                                EG,
                                                a_("Copier la commande")
                                            ])),
                                            A2(VM, E([
                                                WM("form-text fs-7")
                                            ]), E([
                                                a_("Cette commande utilise l'"),
                                                A2(KM, E([
                                                    QM(sd)
                                                ]), E([
                                                    a_("API Ecobalyse")
                                                ]))
                                            ]))
                                        ])),
                                        A2(VM, E([
                                            WM("card-body border-top pt-0")
                                        ]), E([
                                            A2(C_, E([
                                                WM("h5 mt-2")
                                            ]), E([
                                                a_("Param\xe8tres de simulation JSON")
                                            ])),
                                            A2(U_, E([
                                                WM("bg-dark text-white p-2 m-0"),
                                                A2(OF, "max-height", "200px")
                                            ]), E([
                                                A2(y_, w, E([
                                                    a_(o)
                                                ]))
                                            ])),
                                            A2(YM, E([
                                                WM("btn btn-outline-dark btn-sm w-100 d-flex justify-content-center align-items-center gap-1"),
                                                u_(e(o))
                                            ]), E([
                                                EG,
                                                a_("Copier")
                                            ]))
                                        ]))
                                    ]));
                                }(c);
                        }
                    }()
                ]),
                oQ: A2(ju, function(n) {
                    var e = n.a, r = n.b;
                    return {
                        hF: s(c.aV, e),
                        ai: r,
                        jc: c.j4(e)
                    };
                }, f)
            }))
        ]));
    }, EQ = F3(function(n, e, r) {
        return jQ({
            ks: e.dU,
            bv: e.bv,
            bw: e.bw,
            kY: yX,
            k0: "",
            k1: "",
            k2: !1,
            k4: hX,
            k6: jI,
            la: Hr,
            lm: $X,
            lU: xX,
            mh: Rr(A2(MX, r, A5(qX, n, e.O, e.dN, wX, PX))),
            mi: kX,
            m8: jI,
            aT: r.gZ,
            n5: jX,
            og: EX,
            as: ds,
            dv: e.O,
            eu: n,
            oL: AX,
            oN: CX,
            o5: r.bI,
            o6: Hr,
            pg: TX,
            pi: Bi(jI),
            pj: Bi(jI),
            pD: SX
        });
    }), AQ = {
        $: 25
    }, CQ = {
        $: 3
    }, PQ = function(n) {
        return {
            $: 9,
            a: n
        };
    }, TQ = F2(function(n, e) {
        return {
            $: 42,
            a: n,
            b: e
        };
    }), SQ = function(n) {
        var e = n.ea, r = n.d1, t = n.gF;
        return A2(L_, E([
            WM("list-group-item p-0")
        ]), E([
            A2(YM, E([
                WM("btn btn-outline-primary"),
                WM("d-flex justify-content-center align-items-center"),
                WM("gap-1 w-100"),
                E_(e),
                u_(r)
            ]), E([
                A2(f_, E([
                    WM("icon icon-plus")
                ]), w),
                a_("Ajouter " + t)
            ]))
        ]));
    }, IQ = F2(function(n, e) {
        var r = n.bW;
        return A2(YM, E([
            i_("button"),
            WM("ElementDelete d-flex justify-content-center align-items-center btn btn-outline-primary"),
            V_("Supprimer ce composant"),
            u_(e),
            E_(r)
        ]), E([
            OG
        ]));
    }), OQ = "d-inline-flex align-items-center btn btn-sm gap-1 rounded-pill", qQ = OQ + " btn-primary fs-7 py-0", LQ = function(n) {
        return KM(A2(Ur, WM(qQ), n));
    }, MQ = F4(function(n, e, r, t) {
        var u = n.l1;
        return E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between"),
                xQ($Q)
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0"),
                    kF("usage-stage")
                ]), E([
                    a_("Consommation")
                ])),
                A2(d_, w, E([
                    A2(eB, e, t.bj),
                    A2(LQ, E([
                        WM("btn btn-secondary ms-2 py-1"),
                        XM(hV(8)),
                        V_("Documentation"),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ])),
            A2(B_, E([
                WM("CardList list-group list-group-flush")
            ]), k(lf(r.bj) ? E([
                A2(L_, E([
                    WM("list-group-item")
                ]), E([
                    a_("Aucune pr\xe9paration")
                ]))
            ]) : A2(ju, function(n) {
                return A2(L_, E([
                    WM("list-group-item d-flex justify-content-between align-items-center gap-2 pb-3")
                ]), E([
                    A2(mK, E([
                        WM("form-select form-select w-50"),
                        dK(A2(Fu, ru, TQ(n.mf)))
                    ]), A2(ju, function(e) {
                        var t = e.mf, u = e.ei;
                        return A2(bK, E([
                            pK(s(n.mf, t)),
                            vK(t),
                            E_(A2(tl, t, A2(ju, function(n) {
                                return n.mf;
                            }, r.bj)))
                        ]), E([
                            a_(u)
                        ]));
                    }, A2(IE, function(n) {
                        return n.ei;
                    }, bb))),
                    A2(d_, E([
                        WM("w-50 text-end")
                    ]), E([
                        A2(eB, e, A3(SV, u.pM, t.bl.pa, n))
                    ])),
                    A2(IQ, {
                        bW: !1
                    }, PQ(n.mf))
                ]));
            }, r.bj), E([
                SQ({
                    d1: CQ,
                    ea: 2 === ft(r.bj),
                    gF: "une technique de pr\xe9paration"
                })
            ])))
        ]);
    }), _Q = {
        $: 0
    }, RQ = {
        $: 26
    }, HQ = function(n) {
        return {
            $: 39,
            a: n
        };
    }, UQ = E([
        ab,
        ib,
        cb
    ]), zQ = F2(function(n, e) {
        return A2(ub, e, n(1));
    }), DQ = function(n) {
        var e = n.b, r = Bs(e.cz / A2(ub, rb(1), 1));
        return "\xc9nergie: " + Bs(A2(zQ, A2(Fu, eb, cy(1)), e.c3)) + " kWh/m\xb3, R\xe9frig\xe9ration: " + Bs(A2(zQ, A2(Fu, eb, cy(1)), e.aN)) + " kWh/m\xb3, Eau " + r + " L/m\xb3";
    }, NQ = function(n) {
        switch(n.a){
            case 0:
                return "Sec";
            case 1:
                return "Frais";
            default:
                return "Surgel\xe9";
        }
    }, FQ = F3(function(n, e, r) {
        var t = A2(eB, n, r.E.bI);
        return E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between"),
                xQ(dQ)
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0"),
                    kF("distribution-stage")
                ]), E([
                    a_("Distribution")
                ])),
                A2(d_, w, E([
                    A2(eB, n, r.E.bI),
                    A2(LQ, E([
                        WM("btn btn-secondary ms-2 py-1"),
                        XM(hV(1)),
                        V_("Documentation"),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ])),
            A2(B_, E([
                WM("CardList list-group list-group-flush border-top-0 border-bottom-0")
            ]), function() {
                var n = e.E;
                if (n.$) return E([
                    SQ({
                        d1: _Q,
                        ea: !1,
                        gF: "un mode de distribution"
                    })
                ]);
                var r = n.a;
                return E([
                    A2(L_, E([
                        WM("ElementFormWrapper list-group-item")
                    ]), E([
                        A2(mK, E([
                            WM("form-select form-select"),
                            dK(HQ)
                        ]), A2(ju, function(n) {
                            return A2(bK, E([
                                pK(s(e.E, Rr(n))),
                                vK(Io(n))
                            ]), E([
                                a_(NQ(n))
                            ]));
                        }, UQ)),
                        A2(d_, E([
                            WM("text-end ImpactDisplay fs-7")
                        ]), E([
                            t
                        ])),
                        A2(IQ, {
                            bW: !1
                        }, RQ)
                    ])),
                    A2(L_, E([
                        WM("list-group-item fs-7 pt-2")
                    ]), E([
                        a_(DQ(r))
                    ]))
                ]);
            }())
        ]);
    }), KQ = function(n) {
        return ks(function(e) {
            return !A2(tl, e.mf, n);
        });
    }, GQ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, WQ = {
        $: 0
    }, VQ = {
        bd: w,
        ed: !1
    }, JQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BQ = F2(function(n, e) {
        return {
            h$: n.h$,
            e0: {
                oH: JQ(200),
                fT: GQ
            },
            cU: VQ,
            e9: e,
            mg: n.mg,
            eh: Hr,
            g1: n.g1,
            ot: Hr,
            dL: WQ
        };
    }), XQ = F2(function(n, e) {
        return A2(BQ, {
            h$: e,
            mg: w,
            g1: ""
        }, function(r) {
            return xu($(r, {
                h$: A2(LW, {
                    m1: 1,
                    g1: r.g1,
                    oY: A2(Fu, n, kP)
                }, e)
            }));
        });
    }), QQ = F2(function(n, e) {
        return {
            $: 40,
            a: n,
            b: e
        };
    }), ZQ = function(n) {
        var e = A2(zw, 2, n);
        return A2(d_, w, E([
            a_(A2(gu, "-", e) ? e : "+" + e),
            A2(d_, E([
                WM("fs-unit")
            ]), E([
                a_("\u202FPts")
            ]))
        ]));
    }, YQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nZ = GM("min"), eZ = function(n) {
        return A2(GM, "step", n);
    }, rZ = function(n) {
        var e = n.bW, r = n.P, t = n.fs;
        return A2(VM, E([
            WM("input-group")
        ]), E([
            A2(q_, E([
                WM("form-control text-end incdec-arrows-left"),
                i_("number"),
                eZ("1"),
                vK(ut(jf(Ho(r)))),
                V_("Quantit\xe9 en grammes"),
                dK(function(n) {
                    return t("" === n ? Hr : A2(Lc, xb, gp(n)));
                }),
                nZ("0"),
                E_(e)
            ]), w),
            A2(d_, E([
                WM("input-group-text"),
                V_("grammes")
            ]), E([
                a_("g")
            ]))
        ]));
    }, tZ = F3(function(n, e, r) {
        var t = r.bb, u = r.fx, a = r.O, i = r.dv;
        return {
            ky: !0,
            kE: {
                i: u.i,
                ir: u.a_,
                D: u.P
            },
            C: {
                bR: A2(IE, function(n) {
                    return n.ei;
                }, A2(Nh, E([
                    ds
                ]), n.bR)),
                cV: n.cV,
                r: n.l1.mm
            },
            ic: CJ(u.a_.gl),
            ll: function(n) {
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(n.mf);
            },
            bb: A2(ks, function(n) {
                return A2(tl, n.mf, t);
            }, n.l1.mm),
            O: a,
            nv: A2(Fu, YQ, kc),
            nS: function(n) {
                return rZ({
                    bW: !1,
                    P: n.D,
                    fs: n.fs
                });
            },
            op: F2(function(n, e) {
                return kc(A2(pI, Rr(u), e));
            }),
            dv: i,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, zg),
            oZ: function(n) {
                return n.ei;
            },
            o_: A2(Fu, function(n) {
                return n.t;
            }, Gb),
            pd: F2(function(n, r) {
                return A2(QQ, e, $(e, {
                    i: A2(Lc, function(n) {
                        return n.cM;
                    }, r.i),
                    mf: r.ir.mf,
                    P: r.D
                }));
            })
        };
    }), uZ = s_("ship"), aZ = s_("snow"), iZ = A2(f_, E([
        A2(ZM, "aria-hidden", "true"),
        WM("icon icon-ship")
    ]), E([
        aZ
    ])), cZ = s_("truck"), oZ = A2(f_, E([
        A2(ZM, "aria-hidden", "true"),
        WM("icon icon-truck")
    ]), E([
        aZ
    ])), fZ = function(n) {
        var e = n.im, r = n.iL, t = n.ai, u = n.eo;
        return A2(d_, E([
            WM("d-flex align-items-center gap-1"),
            V_(t)
        ]), E([
            A2(d_, E([
                A2(OF, "cursor", "help")
            ]), E([
                r
            ])),
            u ? a_("") : lV(e)
        ]));
    }, sZ = s_("plane"), lZ = F2(function(n, e) {
        var r = n.gz, t = n.eo, u = n.g4, a = n.g8, i = e.ds, c = e.oc, o = e.g7, f = e.om;
        return A2(La, function(n) {
            var e = n.im, u = n.iL, a = n.ai;
            return !Cf(e) && r ? Hr : Rr(fZ({
                im: e,
                iL: u,
                ai: a,
                eo: t
            }));
        }, E([
            {
                im: e.f1,
                iL: sZ,
                ai: A2(_c, "Transport a\xe9rien", n.f2)
            },
            {
                im: o,
                iL: uZ,
                ai: A2(_c, "Transport maritime", a)
            },
            {
                im: f,
                iL: iZ,
                ai: "Transport maritime r\xe9frig\xe9r\xe9"
            },
            {
                im: i,
                iL: cZ,
                ai: A2(_c, "Transport routier", u)
            },
            {
                im: c,
                iL: oZ,
                ai: "Transport routier r\xe9frig\xe9r\xe9"
            }
        ]));
    }), dZ = F4(function(n, e, r, t) {
        return A2(d_, E([
            WM("text-muted d-flex fs-7 gap-3 justify-content-left ElementTransportDistances")
        ]), function() {
            if (2 !== e.jk) {
                var u = 2 !== e.a_.hv, a = !r.jk, i = A2(BV, n, e), c = i.ds, o = i.oc, f = i.f1, l = i.g7, d = i.om;
                return E([
                    A2(VM, E([
                        WM("IngredientPlaneOrBoatSelector")
                    ]), E([
                        A2(mG, E([
                            WM("PlaneSelector")
                        ]), E([
                            A2(q_, E([
                                i_("radio"),
                                A2(ZM, "role", "switch"),
                                w_(a),
                                dK(Bi(t($(r, {
                                    jk: 0
                                }))))
                            ]), w),
                            sZ
                        ])),
                        A2(mG, E([
                            WM("BoatSelector")
                        ]), E([
                            A2(q_, E([
                                i_("radio"),
                                A2(ZM, "role", "switch"),
                                w_(!a),
                                dK(Bi(t($(r, {
                                    jk: 1
                                }))))
                            ]), w),
                            u ? iZ : uZ
                        ])),
                        a ? A2(d_, E([
                            WM("ps-1 align-items-center gap-1"),
                            V_("Tranport a\xe9rien")
                        ]), E([
                            lV(f)
                        ])) : u ? A2(d_, E([
                            WM("ps-1 align-items-center gap-1"),
                            V_("Tranport maritime r\xe9frig\xe9r\xe9")
                        ]), E([
                            lV(d)
                        ])) : A2(d_, E([
                            WM("ps-1 align-items-center gap-1"),
                            V_("Tranport maritime")
                        ]), E([
                            lV(l)
                        ]))
                    ])),
                    s(c, vl(0)) ? a_("") : fZ({
                        im: c,
                        iL: cZ,
                        ai: "Transport routier",
                        eo: !1
                    }),
                    s(o, vl(0)) ? a_("") : fZ({
                        im: o,
                        iL: oZ,
                        ai: "Transport routier r\xe9frig\xe9r\xe9",
                        eo: !1
                    })
                ]);
            }
            return A2(lZ, {
                f2: Hr,
                gu: !1,
                gz: !0,
                eo: !1,
                g4: Hr,
                g8: Hr
            }, A2(BV, n, e));
        }());
    }), bZ = OQ + " text-secondary text-decoration-none btn-link p-0 ms-1", mZ = function(n) {
        return KM(A2(Ur, WM(bZ), n));
    }, pZ = F2(function(n, e) {
        var r = n.nv, t = n.oV, u = n.oZ, a = n.o_, i = n.kE.ir;
        return A2(VM, E([
            WM("input-group")
        ]), E([
            A2(YM, E([
                WM("form-select ElementSelector text-start"),
                kF("selector-" + t(i)),
                V_(a(i)),
                u_(e)
            ]), E([
                A2(d_, w, E([
                    a_(u(i))
                ]))
            ])),
            A2(YM, E([
                i_("button"),
                WM("input-group-text"),
                V_("Ouvrir les informations d\xe9taill\xe9es"),
                u_(r(i))
            ]), E([
                yJ
            ]))
        ]));
    }), vZ = function(n) {
        var e = n.kE, r = n.C, t = n.O, u = n.pd(e), a = n.ll(e.ir), i = A2(XQ, n.oZ, A2(IE, n.oZ, A2(ks, function(e) {
            return !A2(tl, e, n.bb);
        }, r.r)));
        return E([
            A2(d_, E([
                WM("QuantityInputWrapper")
            ]), E([
                n.nS({
                    fs: function(n) {
                        return u(n.$ ? e : $(e, {
                            D: n.a
                        }));
                    },
                    D: e.D
                })
            ])),
            A2(pZ, n, A2(n.op, e.ir, i)),
            A2(mK, E([
                WM("form-select form-select CountrySelector"),
                dK(function(n) {
                    var t;
                    return u($(e, {
                        i: "" !== n ? Ld((t = vj(n), A2(js, t, r.bR))) : Hr
                    }));
                })
            ]), A2(Ur, A2(bK, E([
                vK(""),
                pK(s(e.i, Hr))
            ]), E([
                a_("Par d\xe9faut (" + n.ic + ")")
            ])), A2(ju, function(n) {
                var r = n.cM, t = n.ei;
                return A2(bK, E([
                    pK(s(A2(Lc, function(n) {
                        return n.cM;
                    }, e.i), Rr(r))),
                    vK(r)
                ]), E([
                    a_(t)
                ]));
            }, A2(IE, function(n) {
                return n.ei;
            }, r.bR)))),
            A2(d_, E([
                WM("text-end ImpactDisplay fs-7")
            ]), E([
                A2(eB, n.dv, t)
            ])),
            A2(IQ, {
                bW: 1 === ft(n.bb) && !n.ky
            }, a)
        ]);
    }, gZ = F2(function(n, e) {
        var r = n.S, t = n.ai;
        return A2(KF, E([
            WM("ComplementsDetails fs-7")
        ]), A2(Ur, A2(VF, w, E([
            A2(VM, E([
                WM("ComplementsTable d-flex justify-content-between w-100")
            ]), E([
                A2(d_, E([
                    V_("Cliquez pour plier/d\xe9plier")
                ]), E([
                    a_(t)
                ])),
                A2(d_, E([
                    WM("text-muted text-end"),
                    V_("Total des compl\xe9ments")
                ]), E([
                    ZQ(cj(r))
                ]))
            ]))
        ])), e));
    }), hZ = F2(function(n, e) {
        var r = e.fx, t = e.dv, u = e.hw, a = {
            i: A2(Lc, function(n) {
                return n.cM;
            }, r.i),
            mf: r.a_.mf,
            P: r.P,
            jk: r.jk
        }, i = QQ(a), c = A3(tZ, n, a, e);
        return A2(L_, E([
            WM("ElementFormWrapper list-group-item")
        ]), k(vZ(c), E([
            function() {
                if (19 === t.kf) {
                    var n = A2(XV, r.a_.lH, r.P);
                    return A2(gZ, {
                        S: n,
                        ai: "Services ecosyst\xe9miques"
                    }, A2(ju, function(n) {
                        var e = n.ei, r = n.dY;
                        return A2(VM, E([
                            WM("ElementComplement"),
                            V_(e)
                        ]), E([
                            A2(d_, E([
                                WM("ComplementName d-flex align-items-center text-nowrap text-muted")
                            ]), E([
                                a_(e),
                                A2(mZ, E([
                                    XM(hV(0)),
                                    LF("_blank")
                                ]), E([
                                    yJ
                                ]))
                            ])),
                            A2(VM, E([
                                WM("ComplementValue d-flex justify-content-end align-items-center text-muted")
                            ]), w),
                            A2(VM, E([
                                WM("ComplementImpact text-black-50 text-muted text-end")
                            ]), E([
                                a_("("),
                                ZQ(r),
                                a_(")")
                            ]))
                        ]));
                    }, E([
                        {
                            dY: A2(_c, 0, n.ah),
                            ei: $J
                        },
                        {
                            dY: A2(_c, 0, n.am),
                            ei: kJ
                        },
                        {
                            dY: A2(_c, 0, n.ag),
                            ei: hJ
                        },
                        {
                            dY: A2(_c, 0, n.al),
                            ei: xJ
                        }
                    ])));
                }
                return a_("");
            }(),
            A4(dZ, n, r, a, i),
            A2(d_, E([
                WM("text-black-50 text-end ElementTransportImpact fs-8"),
                V_("Impact du transport pour cet ingr\xe9dient")
            ]), E([
                a_("(+ "),
                u,
                a_(")")
            ]))
        ])));
    }), $Z = F4(function(n, e, r, t) {
        var u = A2(IE, function(n) {
            return n.ei;
        }, A2(KQ, A2(ju, A2(Fu, function(n) {
            return n.a_;
        }, function(n) {
            return n.mf;
        }), r.mm), n.l1.mm)), a = A2(XQ, function(n) {
            return n.ei;
        }, u);
        return E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between"),
                xQ(mQ)
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0"),
                    kF("materials-stage")
                ]), E([
                    a_("Ingr\xe9dients"),
                    A2($V, E([
                        QM(A2(pd, ds, Om(Hr))),
                        V_("Explorer"),
                        A2(ZM, "aria-label", "Explorer")
                    ]), E([
                        mJ
                    ]))
                ])),
                A2(d_, w, E([
                    A2(eB, e, t.bl.gD),
                    A2(LQ, E([
                        WM("btn btn-secondary ms-2 py-1"),
                        XM(hV(3)),
                        V_("Documentation"),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ])),
            A2(B_, E([
                WM("CardList list-group list-group-flush")
            ]), k(lf(r.mm) ? E([
                A2(L_, E([
                    WM("list-group-item")
                ]), E([
                    a_("Aucun ingr\xe9dient")
                ]))
            ]) : A2(ju, function(u) {
                return A2(hZ, n, {
                    bb: A2(ju, A2(Fu, function(n) {
                        return n.a_;
                    }, function(n) {
                        return n.mf;
                    }), r.mm),
                    O: A2(_c, Zs, A2(Lc, Gh, ys(A2(ks, function(n) {
                        return s(n.a, u);
                    }, t.bl.mm)))),
                    fx: u,
                    dv: e,
                    hw: A2(eB, e, A2(BV, n, u).g)
                });
            }, r.mm), E([
                A2(L_, E([
                    WM("list-group-item p-0")
                ]), E([
                    A2(YM, E([
                        WM("btn btn-outline-primary"),
                        WM("d-flex justify-content-center align-items-center"),
                        WM(" gap-1 w-100"),
                        kF("add-new-element"),
                        E_(lf(u)),
                        u_(kc(A2(pI, Hr, a)))
                    ]), E([
                        A2(f_, E([
                            WM("icon icon-plus")
                        ]), w),
                        a_("Ajouter un ingr\xe9dient")
                    ]))
                ]))
            ])))
        ]);
    }), xZ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, kZ = F2(function(n, e) {
        return {
            $: 41,
            a: n,
            b: e
        };
    }), wZ = function(n) {
        return A2(Fu, Fh(LP), ks(function(e) {
            return !A2(tl, e.mf, n);
        }));
    }, yZ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jZ = F2(function(n, e) {
        return A2(VM, E([
            WM("input-group")
        ]), E([
            A2(YM, E([
                WM("form-select ElementSelector text-start"),
                kF("selector-" + _s(n.mf)),
                V_(Gb(n)),
                u_(e)
            ]), E([
                A2(d_, w, E([
                    a_(Wb(n))
                ]))
            ])),
            A2(YM, E([
                i_("button"),
                WM("input-group-text"),
                V_("Ouvrir les informations d\xe9taill\xe9es"),
                u_(kc(yZ(n)))
            ]), E([
                yJ
            ]))
        ]));
    }), EZ = F4(function(n, e, r, t) {
        var u = A2(IE, Wb, A2(wZ, A2(ju, A2(Fu, function(n) {
            return n.t;
        }, function(n) {
            return n.mf;
        }), r.cm), n.W)), a = A2(XQ, Wb, u);
        return E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between"),
                xQ(pQ)
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0"),
                    kF("packaging-stage")
                ]), E([
                    a_("Emballage")
                ])),
                A2(d_, w, E([
                    A2(eB, e, t.cm),
                    A2(LQ, E([
                        WM("btn btn-secondary ms-2 py-1"),
                        XM(hV(4)),
                        V_("Documentation"),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ])),
            A2(B_, E([
                WM("CardList list-group list-group-flush")
            ]), k(lf(r.cm) ? E([
                A2(L_, E([
                    WM("list-group-item")
                ]), E([
                    a_("Aucun emballage")
                ]))
            ]) : A2(ju, function(t) {
                return function(n) {
                    var e = n.cF, r = n.cm, t = n.O, u = n.dJ, a = n.cW;
                    return A2(L_, E([
                        WM("ElementFormWrapper list-group-item")
                    ]), E([
                        A2(d_, E([
                            WM("QuantityInputWrapper")
                        ]), E([
                            1 === r.t.aL ? A2(VM, E([
                                WM("input-group")
                            ]), E([
                                A2(q_, E([
                                    WM("form-control text-end incdec-arrows-left"),
                                    i_("number"),
                                    eZ("1"),
                                    vK(Bs(r.j)),
                                    V_("Nombre d\u2019\xe9l\xe9ments"),
                                    dK(function(n) {
                                        var e = gp(n);
                                        return e.$ ? jI : u({
                                            j: e.a,
                                            mf: r.t.mf
                                        });
                                    }),
                                    nZ("0")
                                ]), w)
                            ])) : rZ({
                                bW: !1,
                                P: r.j,
                                fs: function(n) {
                                    return n.$ ? jI : u({
                                        j: n.a,
                                        mf: r.t.mf
                                    });
                                }
                            })
                        ])),
                        A2(jZ, r.t, kc(A2(gI, Rr({
                            j: r.j,
                            mf: r.t.mf
                        }), e))),
                        A2(d_, E([
                            WM("text-end ImpactDisplay fs-7")
                        ]), E([
                            t
                        ])),
                        A2(IQ, {
                            bW: !1
                        }, a)
                    ]));
                }({
                    cF: a,
                    cW: xZ(t.t.mf),
                    bb: A2(ju, A2(Fu, function(n) {
                        return n.t;
                    }, function(n) {
                        return n.mf;
                    }), r.cm),
                    O: A2(eB, e, ZV(t)),
                    cm: t,
                    W: A2(Fh, LP, n.W),
                    dJ: kZ(t.t.mf)
                });
            }, r.cm), E([
                A2(L_, E([
                    WM("list-group-item p-0")
                ]), E([
                    A2(YM, E([
                        WM("btn btn-outline-primary"),
                        WM("d-flex justify-content-center align-items-center"),
                        WM(" gap-1 w-100"),
                        kF("add-new-element"),
                        E_(lf(u)),
                        u_(kc(A2(gI, Hr, a)))
                    ]), E([
                        A2(f_, E([
                            WM("icon icon-plus")
                        ]), w),
                        a_("Ajouter un emballage")
                    ]))
                ]))
            ])))
        ]);
    }), AZ = {
        $: 4
    }, CZ = {
        $: 27
    }, PZ = function(n) {
        return {
            $: 44,
            a: n
        };
    }, TZ = F4(function(n, e, r, t) {
        return A2(mK, E([
            WM("form-select form-select"),
            dK(A2(Fu, qC, A2(Fu, ss(e), eh(jI))))
        ]), A2(ju, function(e) {
            return A2(bK, E([
                pK(s(n, e.mf)),
                vK(_s(e.mf)),
                E_(A2(tl, e.mf, r))
            ]), E([
                a_(Wb(e))
            ]));
        }, A2(IE, function(n) {
            return Wb(n);
        }, A2(Nh, E([
            ds
        ]), t))));
    }), SZ = F4(function(n, e, r, t) {
        var u = A2(eB, e, t.bl.fT);
        return E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between"),
                xQ(vQ)
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0"),
                    kF("transform-stage")
                ]), E([
                    a_("Transformation")
                ])),
                A2(d_, w, E([
                    u,
                    A2(LQ, E([
                        WM("btn btn-secondary ms-2 py-1"),
                        XM(hV(6)),
                        V_("Documentation"),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ])),
            A2(B_, E([
                WM("CardList list-group list-group-flush border-top-0 border-bottom-0")
            ]), E([
                function() {
                    var e = r.fT;
                    if (e.$) return SQ({
                        d1: AZ,
                        ea: !1,
                        gF: "une transformation"
                    });
                    var t = e.a;
                    return function(n) {
                        var e = n.W, r = n.bb, t = n.g$, u = n.O, a = n.dJ, i = n.cW;
                        return A2(L_, E([
                            WM("ElementFormWrapper list-group-item")
                        ]), E([
                            A2(d_, E([
                                WM("QuantityInputWrapper")
                            ]), E([
                                rZ({
                                    bW: !1,
                                    P: t.P,
                                    fs: function(n) {
                                        return n.$ ? jI : a($(t, {
                                            P: n.a
                                        }));
                                    }
                                })
                            ])),
                            A4(TZ, t.mf, function(n) {
                                return a($(t, {
                                    mf: n
                                }));
                            }, r, A2(IE, Wb, e)),
                            A2(d_, E([
                                WM("text-end ImpactDisplay fs-7")
                            ]), E([
                                u
                            ])),
                            A2(IQ, {
                                bW: !1
                            }, i)
                        ]));
                    }({
                        cW: CZ,
                        bb: E([
                            t.t.mf
                        ]),
                        O: u,
                        g$: {
                            mf: t.t.mf,
                            P: t.P
                        },
                        W: nO(n),
                        dJ: PZ
                    });
                }()
            ]))
        ]);
    }), IZ = function(n) {
        return E([
            a_(" + Emballage : "),
            bW(eJ(n))
        ]);
    }, OZ = F2(function(n, e) {
        return A2(VM, E([
            WM("d-flex justify-content-between text-muted")
        ]), E([
            A2(d_, E([
                WM("w-50 fs-7 py-4 text-end"),
                A2(OF, "padding", ".5rem 1rem")
            ]), n),
            A2(VM, E([
                WM("DownArrow")
            ]), w),
            A2(VM, E([
                WM("w-50 fs-7 py-4"),
                A2(OF, "padding", ".5rem 1rem")
            ]), e)
        ]));
    }), qZ = F2(function(n, e) {
        return A2(OZ, w, k(E([
            a_("Masse : "),
            bW(e.gZ)
        ]), IZ(n)));
    }), LZ = F2(function(n, e) {
        return A2(OZ, w, k(E([
            a_("Masse : "),
            bW(A2(uJ, n, e))
        ]), IZ(e)));
    }), MZ = F4(function(n, e, r, t) {
        return A2(OZ, w, E([
            A2(VM, w, k(E([
                a_("Masse : "),
                bW(A2(uJ, n, r))
            ]), IZ(r))),
            A2(VM, E([
                WM("d-flex justify-content-between")
            ]), E([
                A2(VM, w, A2(lZ, {
                    f2: Hr,
                    gu: !1,
                    gz: !0,
                    eo: !1,
                    g4: Hr,
                    g8: Hr
                }, t.E.af)),
                A2(d_, w, E([
                    A2(eB, e, t.E.af.g),
                    A2(mZ, E([
                        XM(hV(7)),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ]))
        ]));
    }), _Z = F3(function(n, e, r) {
        var t;
        return A2(OZ, w, E([
            A2(VM, w, E([
                a_("Masse comestible\xa0: "),
                bW(r.bl.lI),
                A2($V, E([
                    XM(hV(2)),
                    V_("Acc\xe9der \xe0 la documentation"),
                    A2(ZM, "aria-label", "Acc\xe9der \xe0 la documentation")
                ]), E([
                    yJ
                ]))
            ])),
            (t = e.fT, t.$ ? a_("") : A2(VM, w, E([
                A2(d_, E([
                    V_("(" + Wb(t.a.t) + ")")
                ]), E([
                    a_("Masse apr\xe8s transformation : ")
                ])),
                bW(A2(uJ, n, e)),
                A2($V, E([
                    XM(hV(5)),
                    V_("Acc\xe9der \xe0 la documentation"),
                    A2(ZM, "aria-label", "Acc\xe9der \xe0 la documentation")
                ]), E([
                    yJ
                ]))
            ])))
        ]));
    }), RZ = F2(function(n, e) {
        return A2(OZ, w, E([
            A2(VM, w, E([
                a_("Masse : "),
                bW(e.bl.mo)
            ])),
            A2(VM, E([
                WM("d-flex justify-content-between")
            ]), E([
                A2(VM, E([
                    WM("d-flex justify-content-between gap-3")
                ]), A2(lZ, {
                    f2: Hr,
                    gu: !1,
                    gz: !0,
                    eo: !0,
                    g4: Hr,
                    g8: Hr
                }, e.bl.af)),
                A2(d_, w, E([
                    A2(eB, n, e.bl.af.g),
                    A2(mZ, E([
                        XM(hV(7)),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ]))
            ]))
        ]));
    }), HZ = F5(function(n, e, r, t, u) {
        var a = n.l1, i = r.O, c = r.db;
        return A2(VM, w, E([
            A2(VM, E([
                WM("card shadow-sm")
            ]), A4($Z, n, i, t, u)),
            A2(RZ, i, u),
            A2(VM, E([
                WM("card shadow-sm")
            ]), A4(SZ, n, i, t, u)),
            A3(_Z, a.pM, t, u),
            A2(VM, E([
                WM("card shadow-sm")
            ]), A4(EZ, n, i, t, u)),
            A4(MZ, a.pM, i, t, u),
            A2(VM, E([
                WM("card shadow-sm")
            ]), A3(FQ, i, t, u)),
            A2(LZ, a.pM, t),
            A2(VM, E([
                WM("card shadow-sm")
            ]), A4(MQ, n, i, t, u)),
            A2(qZ, t, u),
            A2(VM, E([
                WM("d-flex align-items-center justify-content-between mt-3 mb-5")
            ]), E([
                A2(KM, E([
                    QM($d)
                ]), E([
                    a_("\xab Retour \xe0 l'accueil")
                ])),
                A2(YM, E([
                    WM("btn btn-secondary"),
                    u_(AQ),
                    E_(s(e.aG.l1, c))
                ]), E([
                    a_("R\xe9initialiser le produit")
                ]))
            ]))
        ]));
    }), UZ = F2(function(n, e) {
        return A2(_c, "Produit personnalis\xe9", ys(A2(La, function(n) {
            var r = n.ei;
            return s(e, n.g1) ? Rr(r) : Hr;
        }, n)));
    }), zZ = function(n) {
        var e = A2(XQ, UZ(n.lP), A2(ju, function(n) {
            return n.g1;
        }, A2(IE, function(n) {
            return n.ei;
        }, n.lP)));
        return A2(VM, E([
            WM("d-flex flex-row justify-content-between align-items-start gap-3")
        ]), E([
            A2(mG, E([
                bG("selector-example"),
                WM("form-label fw-bold lh-lg mb-0")
            ]), E([
                a_("Exemples")
            ])),
            A2(VM, E([
                WM("d-flex justify-content-between align-items-center flex-fill text-truncate")
            ]), E([
                A2(YM, E([
                    WM("form-select ElementSelector text-start"),
                    kF("selector-example"),
                    V_("Les simulations propos\xe9es ici constituent des exemples. Elles doivent \xeatre adapt\xe9es pour chaque produit mod\xe9lis\xe9"),
                    u_(n.nq(e))
                ]), E([
                    a_(A2(UZ, n.lP, n.k8))
                ])),
                function() {
                    var e = n.mb;
                    if (e.$) return a_("");
                    var r = e.a;
                    return A2(d_, E([
                        WM("input-group-text")
                    ]), E([
                        A2(KM, E([
                            WM("text-secondary text-decoration-none p-0"),
                            XM(hV(r)),
                            LF("_blank")
                        ]), E([
                            l_
                        ]))
                    ]));
                }()
            ]))
        ]));
    }, DZ = F2(function(n, e) {
        var r = n.C, t = A2(fJ, r, n.aG.l1);
        return A2(VM, E([
            WM("row gap-3 gap-lg-0")
        ]), E([
            A2(VM, E([
                WM("col-lg-8 d-flex flex-column gap-3")
            ]), E([
                zZ({
                    k8: n.aG.l1,
                    lM: bA,
                    lP: r.l1.lP,
                    mb: Hr,
                    nq: A2(Fu, TI, kc),
                    od: {
                        lS: A2(pd, ds, yd(Hr)),
                        mJ: gd,
                        oj: hd
                    }
                }),
                function() {
                    if (1 === t.$) return gX(t.a);
                    var u = t.a;
                    return A5(HZ, r, n, e, u.a, u.b);
                }(),
                A2(vX, r, n.aG.l1)
            ])),
            A2(VM, E([
                WM("col-lg-4 d-flex flex-column gap-3")
            ]), E([
                1 === t.$ ? gX(t.a) : A3(EQ, n, e, t.a.b)
            ]))
        ]));
    }), NZ = F2(function(n, e) {
        return A2(_c, "", ys(A2(La, function(n) {
            var r = n.hY;
            return s(e, n.g1) ? Rr(r) : Hr;
        }, n)));
    }), FZ = function(n) {
        return A2(GM, "autocomplete", n ? "on" : "off");
    }, KZ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, GZ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, WZ = F2(function(n, e) {
        var r, t = n.mT;
        return E([
            u_(n.nr),
            A2(FK, "mousedown", nu(v(t(KZ(e)), !0))),
            (r = t(GZ(e)), A2(t_, "mouseup", nu(r)))
        ]);
    }), VZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, JZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, BZ = function(n) {
        var e = n.nr, r = n.mT;
        return A2(Qt, function(n) {
            switch(n){
                case "ArrowUp":
                    return nu(v(r(JZ(0)), !0));
                case "ArrowDown":
                    return nu(v(r(JZ(1)), !0));
                case "Enter":
                    return nu(v(e, !0));
                default:
                    return Ti("Ignore other keys");
            }
        }, A2(Lu, "key", ai));
    }, XZ = function(n) {
        return E([
            dK(A2(cc, n.mT, VZ)),
            A2(FK, "keydown", BZ(n))
        ]);
    }, QZ = F2(function(n, e) {
        return 1 !== n.$ && s(n.a, e);
    }), ZZ = F5(function(n, e, r, t, u) {
        var a = n.hs, i = n.ht, c = A2(QZ, r, t);
        return A2(YM, k(e(t), E([
            i_("button"),
            WM("AutocompleteChoice"),
            WM("d-flex justify-content-between align-items-center gap-1 w-100"),
            WM("btn btn-outline-primary border-0 border-bottom text-start no-outline"),
            n_(E([
                v("btn-primary selected", c)
            ])),
            A2(ZM, "role", "option"),
            A2(ZM, "aria-selected", c ? "true" : "false")
        ])), E([
            A2(d_, E([
                WM("text-nowrap")
            ]), E([
                a_(i(u))
            ])),
            A2(d_, E([
                WM("text-muted fs-8 text-truncate")
            ]), E([
                a_(a(u))
            ]))
        ]));
    }), YZ = function(n) {
        var e, r, t, u, a, i, c, o = n.l2, f = n.m8, s = n.gP, l = n.gQ, d = n.gY, b = n.eC;
        return GK({
            h0: n.ga,
            h5: (r = function(n) {
                return {
                    h$: n.h$,
                    mg: n.mg,
                    g1: n.g1,
                    ot: n.ot,
                    j$: n.dL
                };
            }(n.cF), t = r.h$, u = r.g1, a = r.ot, i = {
                kS: WZ(e = {
                    mT: s,
                    nr: l
                }),
                mp: XZ(e)
            }, c = i.kS, E([
                A2(q_, k(i.mp, E([
                    i_("search"),
                    kF("element-search"),
                    WM("form-control"),
                    FZ(!1),
                    A2(ZM, "role", "combobox"),
                    A2(ZM, "aria-autocomplete", "list"),
                    A2(ZM, "aria-owns", "element-autocomplete-choices"),
                    hG(d),
                    vK(u)
                ])), w),
                A2(VM, E([
                    WM("ElementAutocomplete"),
                    kF("element-autocomplete-choices")
                ]), A2(bt, A3(ZZ, n, c, a), t))
            ])),
            l2: o,
            l3: Hr,
            m8: f,
            oA: 2,
            oI: Hr,
            eC: b
        });
    }, nY = F2(function(n, e) {
        return {
            q: n(e.q),
            E: n(e.E),
            _: n(e._),
            fn: n(e.fn),
            cm: n(e.cm),
            fT: n(e.fT),
            af: n(e.af),
            pb: n(e.pb),
            kh: n(e.kh)
        };
    }), eY = function(n) {
        var e, r;
        return A3(ot, F2(function(n, e) {
            var r = n.g, t = n.au;
            if (t.$) return e;
            switch(t.a){
                case 0:
                    return $(e, {
                        q: A2(Lc, function(n) {
                            return bh(E([
                                n,
                                r
                            ]));
                        }, e.q)
                    });
                case 1:
                    return $(e, {
                        fn: A2(Lc, function(n) {
                            return bh(E([
                                n,
                                r
                            ]));
                        }, e.fn)
                    });
                case 2:
                    return $(e, {
                        fT: A2(Lc, function(n) {
                            return bh(E([
                                n,
                                r
                            ]));
                        }, e.fT)
                    });
                default:
                    return $(e, {
                        af: A2(Lc, function(n) {
                            return bh(E([
                                n,
                                r
                            ]));
                        }, e.af)
                    });
            }
        }), {
            q: (r = $E(n.q), s(r, Zs) ? Hr : Rr(r)),
            E: Rr(n.E.g),
            _: Rr(n._),
            fn: Rr(Zs),
            cm: Rr(bh(n.cm)),
            fT: Rr(Zs),
            af: Rr((e = n.af, bh(E([
                e.eD.g,
                e.eF.g
            ])))),
            pb: Hr,
            kh: Rr(bh(n.bK))
        }, A2(Id, hx, A2(Id, hx, hx(n.Q))));
    }, rY = function(n) {
        return A2(Fu, eY, nY(Lc(fh(n))));
    }, tY = function(n) {
        return nY(Lc(Rh(n)));
    }, uY = F2(function(n, e) {
        var r = function(n) {
            return A2(_c, Zs, A2(Lc, function(n) {
                return n.g;
            }, A2(Ly, n, A2(Py, function(n) {
                return n.gp;
            }, e.ac))));
        }, t = A2(Fu, fh(n), Rr), u = function(r) {
            return 19 === n ? Lc(ih(A2(ph, Zw(e.aO), A2(_c, 0, r)))) : ru;
        };
        return A2(tY, Zw(e.aO), {
            q: Hr,
            E: Hr,
            _: A2(u, e.S.ak, t(r(1))),
            fn: A2(u, e.S.aj, t(r(5))),
            cm: Hr,
            fT: t(bh(E([
                r(6),
                r(3),
                r(2),
                r(4)
            ]))),
            af: t(e.eJ.g),
            pb: t(e.dF),
            kh: t(r(7))
        });
    }), aY = F2(function(n, e) {
        var r = n.h4, t = n.C, u = e.ei, a = e.g1;
        switch(a.$){
            case 0:
                return A2(ss, function(n) {
                    var e = n.b;
                    return {
                        cP: e.bl.kb,
                        g: e.bI,
                        ai: u,
                        ev: A2(LX, 19, e)
                    };
                }, A2(fJ, t, a.a));
            case 1:
                var i = a.b;
                return A2(ss, function(n) {
                    return {
                        cP: A2(O$, Lc(fh(19)), qJ(n.Q)),
                        g: MJ(n),
                        ai: u,
                        ev: A2(rY, 19, n)
                    };
                }, A2(Vx, {
                    ay: r,
                    C: t,
                    as: bs(a.a)
                }, i));
            default:
                return A2(ss, function(n) {
                    return {
                        cP: n.S,
                        g: n.g,
                        ai: u,
                        ev: A2(uY, 19, n)
                    };
                }, A3(QE, t, r, a.a));
        }
    }), iY = function(n) {
        switch(n){
            case 0:
                return "individual-impacts";
            case 1:
                return "stages-impacts";
            case 2:
                return "grouped-impacts";
            default:
                return "total-impacts";
        }
    }, cY = function(n) {
        return Mc(E([
            v("name", Ic(n.ei)),
            v("y", _o(n.eP)),
            v("color", Ic(n.dW))
        ]));
    }, oY = function(n) {
        return A2(Fu, Co(function(e) {
            return Mc(E([
                v("label", Ic(e.ai)),
                v("data", A2(Co, cY, n(e)))
            ]));
        }), tt(0));
    }, fY = S, sY = F2(function(n, e) {
        var r, t = e.cP, u = e.g, a = Ui(A2(bt, F2(function(n, e) {
            return v(e, n);
        }), E([
            "Changement climatique",
            "Biodiversit\xe9 locale",
            "Acidification",
            "Eutrophisation terrestre",
            "Eutrophisation eaux douces",
            "Eutrophisation marine",
            "\xc9cotoxicit\xe9 de l'eau douce, corrig\xe9e",
            "Utilisation des sols",
            "Appauvrissement de la couche d'ozone",
            "Radiations ionisantes",
            "Formation d'ozone photochimique",
            "Toxicit\xe9 humaine - non-cancer, corrig\xe9e",
            "Toxicit\xe9 humaine - cancer, corrig\xe9e",
            "Particules",
            "Utilisation de ressources en eau",
            "Utilisation de ressources fossiles",
            "Utilisation de ressources min\xe9rales et m\xe9talliques"
        ]))), i = F2(function(n, e) {
            var r = function(n) {
                return A2(ra, n.ei, a);
            }, t = v(r(n), r(e));
            return t.a.$ || t.b.$ ? 1 : m(t.a.a, t.b.a) > 0 ? 2 : 0;
        });
        return xt(k(E([
            {
                dW: "#606060",
                ei: "Services \xe9cosyst\xe9miques",
                eP: kQ(r = t)
            },
            {
                dW: "#c0c0c0",
                ei: "Compl\xe9ment microfibres",
                eP: A2(_c, 0, A2(Lc, m$, r.aj))
            },
            {
                dW: "#e0e0e0",
                ei: "Compl\xe9ment export hors-Europe",
                eP: A2(_c, 0, A2(Lc, m$, r.ak))
            },
            {
                dW: "#f1f1f1",
                ei: "Compl\xe9ment " + YJ.aa,
                eP: A2(_c, 0, A2(Lc, m$, r.aa))
            }
        ]), A2(fY, i, A3(fQ, n, function(n) {
            return n.ip;
        }, u))));
    }), lY = function(n) {
        var e;
        return xt(A2(ju, function(n) {
            return {
                dW: n.c,
                ei: n.a,
                eP: A2(_c, 0, A2(Lc, m$, n.b))
            };
        }, E([
            g("Accessoires", (e = n.ev).pb, hQ),
            g("Mati\xe8res premi\xe8res", e.fn, mQ),
            g("Transformation", e.fT, vQ),
            g("Assemblage", e.q, lQ),
            g("Emballage", e.cm, pQ),
            g("Transports", e.af, gQ),
            g("Distribution", e.E, dQ),
            g("Utilisation", e.kh, $Q),
            g("Fin de vie", e._, bQ)
        ])));
    }, dY = F2(function(n, e) {
        var r, t, u, a, i, c, o = e.cP;
        return u = (r = A2(_V, n, e.g)).kF, a = r.kV, i = r.l9, c = r.n7, xt(E([
            (t = o, {
                dW: "#808080",
                ei: "Compl\xe9ments",
                eP: cj(t)
            }),
            {
                dW: "#9025be",
                ei: "Climat",
                eP: a
            },
            {
                dW: "#00b050",
                ei: "Biodiversit\xe9",
                eP: u
            },
            {
                dW: "#ffc000",
                ei: "Sant\xe9 environnementale",
                eP: i
            },
            {
                dW: "#0070c0",
                ei: "Ressource",
                eP: c
            }
        ]));
    }), bY = function(n) {
        return E([
            {
                dW: "#333333",
                ei: "Impact total",
                eP: A2(fh, 19, n.g)
            }
        ]);
    }, mY = F2(function(n, e) {
        switch(n){
            case 0:
                return sY(e);
            case 1:
                return lY;
            case 2:
                return dY(e);
            default:
                return bY;
        }
    }), pY = function(n) {
        var e = n.eu, r = Jg(A2(La, function(n) {
            return A2(tV, zI(n), e.bH.aX) ? Rr(A2(aY, function(n) {
                return {
                    h4: n.h4,
                    C: n.C
                };
            }(e), n)) : Hr;
        }, e.bH.ao));
        return E([
            A2(B_, E([
                WM("Tabs nav nav-tabs nav-fill justify-content-end gap-3 mt-2 px-2")
            ]), A2(ju, function(e) {
                var r = e.a, t = e.b;
                return A2(L_, E([
                    WM("TabsTab nav-item"),
                    n_(E([
                        v("active", s(n.cO, t))
                    ]))
                ]), E([
                    A2(YM, E([
                        WM("nav-link no-outline border-top-0 py-1"),
                        n_(E([
                            v("active", s(n.cO, t))
                        ])),
                        u_(n.oM(t))
                    ]), E([
                        a_(r)
                    ]))
                ]));
            }, k(Rl(e) ? E([
                v("Sous-scores", 2),
                v("Impacts", 0)
            ]) : w, E([
                v("\xc9tapes", 1),
                v("Total", 3)
            ])))),
            function() {
                if (1 === r.$) return c_({
                    hO: w,
                    h0: Hr,
                    h5: E([
                        a_(r.a)
                    ]),
                    eb: 0,
                    eC: Rr("Erreur")
                });
                if (r.a.b) {
                    var t = r.a;
                    return A2(VM, E([
                        WM("h-100 " + iY(n.cO))
                    ]), E([
                        A3(tG, "chart-food-comparator", E([
                            A2(ZM, "data", A2(oY, A2(mY, n.cO, e.C.cV), t))
                        ]), w)
                    ]));
                }
                return A2(H_, E([
                    WM("d-flex h-100 justify-content-center align-items-center pb-5")
                ]), E([
                    a_("S\xe9lectionnez une ou plusieurs simulations pour les comparer")
                ]));
            }()
        ]);
    }, vY = ve("draggable"), gY = function(n) {
        return A2(t_, "dragleave", nu(n));
    }, hY = function(n) {
        return A2(FK, "dragover", nu(v(n, !0)));
    }, $Y = function(n) {
        return A2(FK, "drop", nu(v(n, !0)));
    }, xY = function(n) {
        return E([
            A2(VM, E([
                WM("p-2 ps-3 mb-0 text-muted")
            ]), E([
                a_("S\xe9lectionnez des simulations pour les comparer")
            ])),
            A2(VM, E([
                WM("text-center")
            ]), E([
                A2(YM, E([
                    WM("btn btn-sm btn-link pt-0"),
                    u_(n.oo)
                ]), E([
                    a_("tout s\xe9lectionner")
                ])),
                A2(YM, E([
                    WM("btn btn-sm btn-link pt-0"),
                    u_(n.oq)
                ]), E([
                    a_("tout d\xe9s\xe9lectionner")
                ]))
            ])),
            A2(VM, E([
                WM("list-group list-group-flush overflow-x-hidden ComparatorList")
            ]), A2(ju, function(e) {
                var r, t = v(A2(KX, n.eu.C, e), A2(tV, zI(e), n.eu.bH.aX)), u = t.a, a = t.b;
                return A2(mG, E([
                    WM("form-check-label list-group-item text-nowrap ps-3 ms-1"),
                    n_(E([
                        v("over", s(n.bu, Rr(e)))
                    ])),
                    V_(u),
                    vY("true"),
                    (r = n.nm(e), A2(t_, "dragstart", nu(r))),
                    gY(n.nk),
                    hY(n.nl(e)),
                    $Y(n.nn(e))
                ]), E([
                    A2(q_, E([
                        i_("checkbox"),
                        WM("form-check-input"),
                        gG(n.o$(e)),
                        w_(a)
                    ]), w),
                    A2(d_, E([
                        WM("d-inline-flex align-middle gap-2 ps-2")
                    ]), E([
                        A2(d_, E([
                            WM("me-2 fw-500")
                        ]), E([
                            a_(e.ei)
                        ])),
                        s(u, e.ei) ? a_("") : A2(d_, E([
                            WM("text-muted fs-7")
                        ]), E([
                            a_(u)
                        ]))
                    ]))
                ]));
            }, n.eu.bH.ao))
        ]);
    }, kY = function(n) {
        return A2(aK, w, E([
            A2(VM, E([
                WM("row")
            ]), E([
                A2(VM, E([
                    WM("col-lg-4 border-end fs-7 p-0")
                ]), xY(n)),
                A2(VM, E([
                    WM("col-lg-8 px-4 py-2 overflow-auto"),
                    A2(OF, "min-height", "500px")
                ]), pY(n))
            ]))
        ]));
    }, wY = F2(function(n, e) {
        return v("Constructeur de recette", E([
            A2(JM, E([
                WM("pb-3")
            ]), E([
                A2(DZ, n, e),
                function() {
                    var r = e.ad;
                    switch(r.$){
                        case 0:
                            return YZ({
                                cF: r.b,
                                ga: kc(xc),
                                l2: w,
                                m8: jI,
                                gP: AI,
                                gQ: ZB,
                                gY: "tapez ici le nom de la mati\xe8re premi\xe8re pour la rechercher",
                                eC: "S\xe9lectionnez un ingr\xe9dient",
                                hs: A2(Fu, function(n) {
                                    return n.cK;
                                }, A2(Fu, ys, A2(Fu, Lc(jJ), _c("")))),
                                ht: function(n) {
                                    return n.ei;
                                }
                            });
                        case 1:
                            return YZ({
                                cF: r.b,
                                ga: kc(xc),
                                l2: w,
                                m8: jI,
                                gP: CI,
                                gQ: ZB,
                                gY: "tapez ici le nom de de l\u2019emballage pour le rechercher",
                                eC: "S\xe9lectionnez un emballage",
                                hs: A2(Fu, function(n) {
                                    return n.cK;
                                }, A2(Fu, ys, A2(Fu, Lc(yP), _c("")))),
                                ht: Wb
                            });
                        case 2:
                            return GK({
                                h0: kc(xc),
                                h5: E([
                                    kY({
                                        bu: e.bu,
                                        cO: e.cO,
                                        O: e.O,
                                        nk: YB,
                                        nl: nX,
                                        nm: eX,
                                        nn: rX,
                                        oo: tX,
                                        oq: uX,
                                        eu: n,
                                        oM: aX,
                                        o$: iX
                                    })
                                ]),
                                l2: w,
                                l3: Hr,
                                m8: jI,
                                oA: 0,
                                oI: Rr("Co\xfbt environnemental, par produit \u26A0\uFE0F\xa0Attention, ces r\xe9sultats sont provisoires"),
                                eC: "Comparateur de simulations sauvegard\xe9es"
                            });
                        case 3:
                            var t = r.a;
                            return GK({
                                h0: kc(xc),
                                h5: E([
                                    IJ(t)
                                ]),
                                l2: w,
                                l3: Hr,
                                m8: jI,
                                oA: 2,
                                oI: Hr,
                                eC: t.ei
                            });
                        case 4:
                            var u = r.a;
                            return GK({
                                h0: kc(xc),
                                h5: E([
                                    A3(CW, ds, uB(n), u)
                                ]),
                                l2: w,
                                l3: Hr,
                                m8: jI,
                                oA: 2,
                                oI: Hr,
                                eC: Wb(u)
                            });
                        case 5:
                            return a_("");
                        default:
                            return YZ({
                                cF: r.a,
                                ga: kc(xc),
                                l2: w,
                                m8: jI,
                                gP: EI,
                                gQ: ZB,
                                gY: "tapez ici le nom du produit pour le rechercher",
                                eC: "S\xe9lectionnez un produit",
                                hs: NZ(n.C.l1.lP),
                                ht: UZ(n.C.l1.lP)
                            });
                    }
                }()
            ]))
        ]));
    }), yY = {
        $: 14
    }, jY = {
        $: 15
    }, EY = {
        $: 16
    }, AY = {
        $: 17
    }, CY = F3(function(n, e, r) {
        return {
            $: 18,
            a: n,
            b: e,
            c: r
        };
    }), PY = {
        $: 19
    }, TY = {
        $: 20
    }, SY = function(n) {
        return {
            $: 21,
            a: n
        };
    }, IY = function(n) {
        return {
            $: 22,
            a: n
        };
    }, OY = function(n) {
        return {
            $: 23,
            a: n
        };
    }, qY = {
        $: 34
    }, LY = {
        $: 35
    }, MY = function(n) {
        return {
            $: 39,
            a: n
        };
    }, _Y = F2(function(n, e) {
        return {
            $: 42,
            a: n,
            b: e
        };
    }), RY = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HY = function(n) {
        return {
            $: 25,
            a: n
        };
    }, UY = function(n) {
        return {
            $: 26,
            a: n
        };
    }, zY = function(n) {
        return {
            $: 27,
            a: n
        };
    }, DY = function(n) {
        return {
            $: 28,
            a: n
        };
    }, NY = F2(function(n, e) {
        return {
            $: 29,
            a: n,
            b: e
        };
    }), FY = function(n) {
        return {
            $: 30,
            a: n
        };
    }, KY = function(n) {
        return {
            $: 36,
            a: n
        };
    }, GY = function(n) {
        return {
            $: 43,
            a: n
        };
    }, WY = function(n) {
        return {
            $: 44,
            a: n
        };
    }, VY = function(n) {
        return {
            $: 45,
            a: n
        };
    }, JY = F2(function(n, e) {
        return {
            $: 47,
            a: n,
            b: e
        };
    }), BY = F2(function(n, e) {
        return {
            $: 48,
            a: n,
            b: e
        };
    }), XY = F2(function(n, e) {
        return {
            $: 49,
            a: n,
            b: e
        };
    }), QY = function(n) {
        return {
            $: 52,
            a: n
        };
    }, ZY = F2(function(n, e) {
        return {
            $: 54,
            a: n,
            b: e
        };
    }), YY = F2(function(n, e) {
        return {
            $: 55,
            a: n,
            b: e
        };
    }), n1 = F3(function(n, e, r) {
        return {
            $: 56,
            a: n,
            b: e,
            c: r
        };
    }), e1 = F2(function(n, e) {
        return {
            $: 57,
            a: n,
            b: e
        };
    }), r1 = F2(function(n, e) {
        return {
            $: 58,
            a: n,
            b: e
        };
    }), t1 = function(n) {
        return {
            $: 60,
            a: n
        };
    }, u1 = rl(function(n) {
        return 2 === n.$;
    }), a1 = F2(function(n, e) {
        return n ? {
            cB: "Ajouter un accessoire",
            cC: "Ajouter un \xe9l\xe9ment",
            c_: "\xc9l\xe9ment",
            c$: "\xc9l\xe9ments",
            c2: "Aucun accessoire",
            de: "Libell\xe9 de l'accessoire",
            bC: "Nom de l'accessoire",
            fp: "Accessoire",
            fq: "Accessoires",
            $7: "Accessoires",
            du: "tapez ici le nom de l\u2019accessoire pour le rechercher",
            on: "S\xe9lectionnez un accessoire"
        } : 1 !== e.$ || e.a ? {
            cB: "Ajouter un mat\xe9riau",
            cC: "Ajouter un sous-mat\xe9riau",
            c_: "Sous-mat\xe9riau",
            c$: "Sous-mat\xe9riaux",
            c2: "Aucun mat\xe9riau",
            de: "Libell\xe9 du mat\xe9riau",
            bC: "Nom du mat\xe9riau",
            fp: "Mat\xe9riau",
            fq: "Mat\xe9riaux",
            $7: "Production des mat\xe9riaux",
            du: "tapez ici le nom du mat\xe9riau pour le rechercher",
            on: "S\xe9lectionnez un mat\xe9riau"
        } : {
            cB: "Ajouter un ingr\xe9dient",
            cC: "Ajouter un sous-ingr\xe9dient",
            c_: "Sous-ingr\xe9dient",
            c$: "Sous-ingr\xe9dients",
            c2: "Aucun ingr\xe9dient",
            de: "Libell\xe9 de l'ingr\xe9dient",
            bC: "Nom de l'ingr\xe9dient",
            fp: "Ingr\xe9dient",
            fq: "Ingr\xe9dients",
            $7: "Recette",
            du: "tapez ici le nom de l\u2019ingr\xe9dient pour le rechercher",
            on: "S\xe9lectionnez un ingr\xe9dient"
        };
    }), i1 = F2(function(n, e) {
        var r = e.iA, t = bs(r);
        return {
            h4: n.h4,
            k_: 0,
            C: n.C,
            ld: !0,
            lq: e.bV,
            lu: Hr,
            lT: Rr(A2(pd, t, A2(Sm, t, Hr))),
            b2: e.b2,
            O: e.O,
            mB: A2(a1, 0, t),
            ac: e.ac,
            m8: uq,
            nw: function(n) {
                return RY(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(n));
            },
            nx: A2(Fu, dq, RY),
            ny: A2(Fu, bq, RY),
            nz: A2(Fu, pq, RY),
            nA: F4(function(n, e, r, t) {
                return RY(A4(vq, n, e, r, t));
            }),
            nB: A2(Fu, YO, RY),
            g1: A2(Zx, r, n),
            n$: HY,
            n0: zY,
            n1: DY,
            n2: NY,
            n3: UY,
            n4: FY,
            as: t,
            ov: KY,
            o2: GY,
            o3: WY,
            pc: u1(e.M),
            pf: VY,
            ph: XY,
            pl: QY,
            pn: ZY,
            po: YY,
            pp: n1,
            ps: JY,
            pt: BY,
            pu: e1,
            pA: r1,
            pC: t1
        };
    }), c1 = F2(function(n, e) {
        return c_({
            hO: w,
            h0: Hr,
            h5: E([
                a_(e)
            ]),
            eb: 0,
            eC: n
        });
    }), o1 = F3(function(n, e, r) {
        return A2(IE, Wb, A2(Fh, e, A2(Nh, E([
            n
        ]), A2(ks, function(n) {
            return n.kj;
        }, r))));
    }), f1 = F2(function(n, e) {
        return A2(XQ, Wb, A2(ks, function(n) {
            return !A2(tl, LP, n.cK);
        }, A3(o1, e, OP, n.W)));
    }), s1 = F2(function(n, e) {
        return A2(YM, E([
            i_("button"),
            WM("btn btn-primary"),
            WM("d-flex justify-content-center align-items-center gap-1"),
            u_(A4(n.nA, OP, e, Hr, A2(f1, n.C, n.as)))
        ]), E([
            nQ,
            a_(n.mB.cC)
        ]));
    }), l1 = function(n) {
        return A2(ve, "colspan", ut(n));
    }, d1 = fe("dd"), b1 = fe("dt"), m1 = function(n) {
        return A2(Fu, ks(function(e) {
            return !A2(tl, e.mf, n);
        }), IE(Wb));
    }, p1 = function(n) {
        var e = n.b;
        return A2(Fu, Iq(n.a), A2(Fu, $x(e), A2(Fu, Lc(function(n) {
            return n.J;
        }), A2(Fu, Lc(ju(function(n) {
            return n.mf;
        })), _c(w)))));
    }, v1 = function(n) {
        var e = L$(n), r = F2(function(n, e) {
            return A2(ks, function(n) {
                return A2(tl, n, e);
            }, n);
        });
        return A2(Fu, Fh(RP), A2(Fu, La(function(n) {
            var t = L$(n);
            return t.b ? lf(A2(r, e, t)) ? Hr : Rr(n) : Hr;
        }), ks(A2(Fu, function(n) {
            return n.aL;
        }, Rt(n.aL)))));
    }, g1 = F3(function(n, e, r) {
        var t = n.C, u = n.nA, a = n.g1, i = n.as, c = r.a, o = r.b, f = A2(m1, A2(p1, v(c, o), a.mu), A2(IE, Wb, A2(v1, e, A2(Nh, E([
            i
        ]), A2(ks, function(n) {
            return n.kj;
        }, t.W))))), s = A2(XQ, Wb, f);
        return A2(YM, E([
            i_("button"),
            WM("btn btn-sm btn-outline-primary text-nowrap"),
            WM("d-flex align-items-center gap-1"),
            E_(lf(f)),
            u_(A4(u, RP, c, Rr(o), s))
        ]), E([
            nQ,
            a_("Ajouter une transformation")
        ]));
    }), h1 = {
        hE: a_(""),
        j: a_(""),
        i: a_(""),
        O: a_(""),
        ai: a_(""),
        pK: a_("")
    }, $1 = F2(function(n, e) {
        return A2(J_, n, E([
            A2(K_, E([
                WM("text-end align-middle text-nowrap ps-3 py-2"),
                A2(OF, "min-width", "130px"),
                A2(OF, "max-width", "150px")
            ]), E([
                e.j
            ])),
            A2(K_, E([
                WM("align-middle"),
                A2(OF, "min-width", "16rem")
            ]), E([
                e.ai
            ])),
            A2(K_, E([
                WM("text-end align-middle text-nowrap")
            ]), E([
                e.pK
            ])),
            A2(K_, E([
                WM("align-middle"),
                A2(OF, "min-width", "12rem")
            ]), E([
                e.i
            ])),
            A2(K_, E([
                WM("text-end align-middle text-nowrap")
            ]), E([
                e.O
            ])),
            A2(K_, E([
                WM("pe-3 text-end align-middle text-nowrap")
            ]), E([
                e.hE
            ]))
        ]));
    }), x1 = F2(function(n, e) {
        return A2(J_, E([
            WM("composition-section")
        ]), E([
            A2(K_, E([
                WM("p-3 pb-2"),
                l1(6)
            ]), E([
                A2(VM, E([
                    WM("d-flex justify-content-between align-items-center gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fw-bold")
                    ]), E([
                        a_(n)
                    ])),
                    A2(_c, a_(""), e)
                ]))
            ]))
        ]));
    }), k1 = {
        $: 1
    }, w1 = function(n) {
        return A3(Xb, ".", ",", Bs(n));
    }, y1 = function(n) {
        var e = n.mf, r = n.eP, t = n.H;
        if (t.$) return w1(r);
        var u = t.a;
        return s(u.mf, e) ? A2(_c, w1(r), u.cY) : w1(r);
    }, j1 = et(ht), E1 = function(n) {
        var e = A2(it, ".", A3(Xb, ",", ".", n));
        n: for(;;){
            if (e.b) {
                if (e.b.b) {
                    if (e.b.b.b) break n;
                    var r = e.b.a;
                    return j1(e.a) && j1(r);
                }
                return j1(e.a);
            }
            break n;
        }
        return !1;
    }, A1 = function(n) {
        var e = A3(Xb, ",", ".", n);
        return su(e) || A2(Gd, ".", e) || A2(gu, ".", e) ? Hr : gp(e);
    }, C1 = F2(function(n, e) {
        var r = n.mf, t = n.eP;
        return E1(e) ? Rr({
            cY: Rr(e),
            mf: r,
            eP: A2(Qa, function(n) {
                return n > 0 && !s(n, t) ? Rr(n) : Hr;
            }, A1(e))
        }) : Hr;
    }), P1 = function(n) {
        var e = n.H;
        if (e.$) return !0;
        var r = e.a;
        if (s(r.mf, n.mf)) {
            var t = r.cY;
            if (t.$) return !0;
            var u = A1(t.a);
            return !u.$ && u.a > 0;
        }
        return !0;
    }, T1 = F4(function(n, e, r, t) {
        return A2(Ja, A3(Ib, n, e, r), t);
    }), S1 = function(n) {
        var e = n.m8;
        return A2(FK, "beforeinput", A2(Qt, function(n) {
            var r = n.a;
            return "insertText" !== r && "insertFromPaste" !== r || E1(n.b) ? Ti("accepted input") : nu(v(e, !0));
        }, A4(T1, E([
            "target",
            "selectionEnd"
        ]), xi, 0, A4(T1, E([
            "target",
            "selectionStart"
        ]), xi, 0, A3(bl, E([
            "target",
            "value"
        ]), ai, A4(Ob, "data", ai, "", A3(Ba, "inputType", ai, nu(F5(function(n, e, r, t, u) {
            return v(n, k(A2(lu, t, r), k(e, A2(ou, u, r))));
        })))))))));
    }, I1 = k_("spellcheck"), O1 = function(n) {
        return A2(q_, k(function(n) {
            var e = n.pO;
            if (e.$) return E([
                n_(E([
                    v("bg-warning-subtle", !P1(n))
                ])),
                vK(y1(n)),
                dK(function(e) {
                    return A2(_c, n.m8, A2(Lc, n.np, A2(C1, n, e)));
                }),
                EK(n.np((r = n.mf, {
                    cY: Hr,
                    mf: r,
                    eP: Hr
                }))),
                S1(n)
            ]);
            var r, t = e.a;
            return E([
                WM("cursor-not-allowed"),
                AG(!0),
                V_(t),
                vK(w1(n.eP))
            ]);
        }(n), E([
            i_("text"),
            WM("form-control form-control-sm text-end"),
            kF(n.mf),
            A2(ZM, "aria-label", n.ai),
            A2(ZM, "autocomplete", "off"),
            A2(ZM, "inputmode", "decimal"),
            I1(!1)
        ])), w);
    }, q1 = F2(function(n, e) {
        return A2(VM, E([
            WM("AmountInput input-group")
        ]), E([
            O1({
                mf: n.mf,
                ai: n.ai,
                m8: n.m8,
                np: n.np,
                H: n.H,
                eP: e,
                pO: n.pO
            }),
            A2(xG, E([
                WM("input-group-text fs-8")
            ]), E([
                a_(Ch(n.aL))
            ]))
        ]));
    }), L1 = F4(function(n, e, r, t) {
        var u = e.a.b, a = e.b;
        return s(n.as, ms) ? A2(gW, r, t) : A2(q1, {
            mf: "element-" + ut(u) + "-" + ut(a),
            ai: "Quantit\xe9",
            m8: n.m8,
            np: n.pn(e),
            H: n.b2,
            aL: r.aL,
            pO: k1
        }, t);
    }), M1 = F2(function(n, e) {
        return A2(YM, E([
            i_("button"),
            WM("btn btn-sm btn-outline-secondary text-nowrap"),
            WM("d-flex align-items-center gap-1"),
            A2(ZM, "aria-label", "Supprimer l\u2019\xe9l\xe9ment"),
            u_(n.n1(e))
        ]), E([
            OG,
            a_("Supprimer")
        ]));
    }), _1 = F2(function(n, e) {
        var r = e.a.a, t = e.b;
        return A2(J_, w, E([
            A2(K_, E([
                WM("py-2 px-3"),
                l1(6)
            ]), E([
                A2(VM, E([
                    WM("d-flex justify-content-between align-items-center gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fw-bold")
                    ]), E([
                        a_(n.mB.c_ + " " + ut(t + 1))
                    ])),
                    ft(r.r) > 1 ? A2(M1, n, e) : a_("")
                ]))
            ]))
        ]));
    }), R1 = F2(function(n, e) {
        return s(e, 0) ? 0 : A2(eh, 0, ep(A3(EE, 0, 1, n / e)));
    }), H1 = function(n) {
        return n.j;
    }, U1 = function(n) {
        return n.au;
    }, z1 = fe("abbr"), D1 = s_("package"), N1 = F6(function(n, e, r, t, u, a) {
        var i = n.g1.aw, c = A5(w$, function(n) {
            return {
                ay: n.h4,
                C: n.C,
                as: n.as
            };
        }(n), $(i, {
            a8: 0,
            aN: Rr(r)
        }), u, a, t);
        if (1 === c.$) {
            var o = c.a;
            return A2($1, e, $(h1, {
                ai: A2(c1, Rr("Erreur de calcul de distance"), o)
            }));
        }
        var f = c.a, s = F2(function(n, e) {
            return A2(Nq, 0, e) ? E([
                n,
                lV(e)
            ]) : w;
        }), l = function(n) {
            if (n.$) return a_("R\xe9gion inconnue");
            var e = n.a.cM;
            return A2(z1, E([
                V_(n.a.ei)
            ]), E([
                a_(e)
            ]));
        };
        return A2($1, A2(Ur, WM("fs-7 text-muted"), e), $(h1, {
            i: A2(VM, E([
                WM("d-flex flex-wrap justify-content-end align-items-center gap-2")
            ]), k(A2(s, sZ, f.f1), k(A2(s, uZ, f.g7), k(A2(s, iZ, f.om), k(A2(s, cZ, f.ds), k(A2(s, oZ, f.oc), E([
                D1,
                bW(t)
            ]))))))),
            O: A2(eB, n.O, f.g),
            ai: A2(VM, E([
                WM("d-flex align-items-center gap-1 text-nowrap text-muted")
            ]), E([
                a_("Transport\xa0"),
                l(u),
                a_(" \u2192 "),
                l(a)
            ]))
        }));
    }), F1 = F4(function(n, e, r, t) {
        var u = n.C, a = n.g1, i = n.as;
        return A2(eh, w, A2(ss, ik, A2(ss, A5(N1, n, E([
            WM("subdued")
        ]), e, t, r), A2(Eh, a.q.i, A2(Nh, E([
            i
        ]), u.bR)))));
    }), K1 = function(n) {
        return bh(E([
            n.g,
            LJ(n.S)
        ]));
    }, G1 = F2(function(n, e) {
        return A2(d_, E([
            WM("ImpactPill bg-info-subtle")
        ]), E([
            A2(eB, n.O, e)
        ]));
    }), W1 = s_("calculator"), V1 = F2(function(n, e) {
        return A2(at, "\n", A2(La, ru, A3(st, F2(function(e, r) {
            var t, u;
            return A2(Lc, A2(Fu, (u = (t = n).le, A2(Fu, fh(t.kf), A2(Fu, m$, zw(u)))), rt(r + "\xa0: ")), e);
        }), ij(e), ij(YJ))));
    }), J1 = F2(function(n, e) {
        var r = e.a, t = e.b;
        return A2(YM, E([
            i_("button"),
            WM("btn btn-sm btn-outline-primary text-nowrap"),
            A2(ZM, "aria-label", "Changer de mati\xe8re premi\xe8re"),
            u_(A4(n.nA, OP, r, Rr(t), A2(XQ, Wb, A3(o1, n.as, OP, n.C.W))))
        ]), E([
            NX
        ]));
    }), B1 = function(n) {
        var e = n.b;
        return A2(at, "-", E([
            ut(n.a.b),
            ut(e)
        ]));
    }, X1 = F3(function(n, e, r) {
        var t = v(n, r);
        return t.a && !t.b.$ ? e + " (" + t.b.a + ")" : e;
    }), Q1 = function(n) {
        return A2(mK, k(E([
            WM(pf("form-select " + n.kT)),
            kF(n.lw),
            FZ(!1),
            E_(n.bW),
            dK(function(e) {
                return n.on(su(e) ? Hr : Rr(vj(e)));
            })
        ]), n.kB), A2(ju, function(e) {
            var r = e.a, t = e.b;
            return A2(bK, E([
                vK(A2(_c, "", A2(Lc, Lo, t))),
                pK(s(n.or, t))
            ]), E([
                a_(A3(X1, n.oy, r, t))
            ]));
        }, A2(Ur, v(n.lL, Hr), A2(ju, function(n) {
            return v(n.ei, Rr(n.cM));
        }, A2(IE, function(n) {
            return n.ei;
        }, A2(Nh, E([
            n.as
        ]), n.bR))))));
    }, Z1 = function(n) {
        var e = n.ai;
        if (e.$) return Q1(n);
        var r = e.a;
        return A2(VM, w, E([
            A2(mG, E(n.md ? [
                WM("visually-hidden"),
                bG(n.lw)
            ] : [
                bG(n.lw)
            ]), E([
                a_(r)
            ])),
            Q1(n)
        ]));
    }, Y1 = F4(function(n, e, r, t) {
        var u = A2($1, E([
            WM("fs-7")
        ]), $(h1, {
            hE: A2(J1, n, e),
            j: A2(gW, t.t, H1(r)),
            i: Z1({
                kB: w,
                kT: "RegionSelector form-select-sm w-100",
                bR: n.C.bR,
                bW: !1,
                lw: "material-country-" + B1(e),
                lL: "---",
                md: !0,
                ai: Rr("R\xe9gion"),
                as: n.as,
                on: n.po(e),
                or: A2(Lc, function(n) {
                    return n.cM;
                }, t.i),
                oy: !0
            }),
            O: A2(G1, n, K1(r)),
            ai: A2(d_, E([
                WM("fw-bold"),
                V_(Wb(t.t))
            ]), E([
                a_(Wb(t.t))
            ]))
        })), a = qJ(r), i = s(a, oh) ? w : E([
            A2($1, E([
                WM("fs-7 text-muted")
            ]), $(h1, {
                O: A2(eB, n.O, LJ(a)),
                ai: A2(d_, E([
                    WM("cursor-help fs-8"),
                    V_(A2(V1, n.O, a))
                ]), E([
                    A2(d_, E([
                        WM("ComponentElementIcon")
                    ]), E([
                        W1
                    ])),
                    a_("Dont compl\xe9ments")
                ]))
            }))
        ]);
        return A2(Ur, u, i);
    }), n0 = F5(function(n, e, r, t, u) {
        if (u.b) {
            var a = u.a;
            return E([
                A6(N1, n, w, e, Oh(r), t.i, a.i)
            ]);
        }
        return A4(F1, n, e, t.i, Oh(r));
    }), e0 = function(n) {
        return wJ(100 * (1 - n));
    }, r0 = F5(function(n, e, r, t, u) {
        return Sd(A2(bt, F2(function(a, i) {
            var c = A2(_c, Sh, A2($x, a, t)), o = "Proc\xe9d\xe9\xa0: " + (Wb(i.t) + A2(eh, "", A2(ss, function(n) {
                var e = n.d9;
                return "\n\xc9lectricit\xe9\xa0: " + Wb(n.d0) + "\nChaleur\xa0: " + Wb(e);
            }, A2(jh, n.h4, i.i))));
            return k(function() {
                if (a) {
                    var r = a, c = Oh(A2(_c, Sh, A2($x, r - 1, t)));
                    return E([
                        A6(N1, n, w, e, c, A2(Qa, function(n) {
                            return n.i;
                        }, A2($x, r - 1, u)), i.i)
                    ]);
                }
                return w;
            }(), E([
                A2($1, E([
                    WM("fs-7 border-top")
                ]), $(h1, {
                    hE: A2(YM, E([
                        i_("button"),
                        WM("btn btn-sm btn-outline-secondary"),
                        A2(ZM, "aria-label", "Supprimer la transformation"),
                        u_(A2(n.n2, r, a))
                    ]), E([
                        OG
                    ])),
                    j: A2(gW, i.t, H1(c)),
                    i: Z1({
                        kB: w,
                        kT: "RegionSelector form-select-sm w-100",
                        bR: n.C.bR,
                        bW: !1,
                        lw: "transform-country-" + B1(r) + "-" + ut(a),
                        lL: "---",
                        md: !0,
                        ai: Rr("R\xe9gion"),
                        as: n.as,
                        on: A2(n.pp, r, a),
                        or: A2(Lc, function(n) {
                            return n.cM;
                        }, i.i),
                        oy: !0
                    }),
                    O: A2(G1, n, $E(c)),
                    ai: A2(d_, E([
                        WM("fw-bold cursor-help"),
                        V_(o)
                    ]), E([
                        a_(Wb(i.t))
                    ])),
                    pK: e0(i.t.g0)
                }))
            ]));
        }), u));
    }), t0 = F5(function(n, e, r, t, u) {
        var a, i = r.U, c = r.J, o = A2(G1, n, K1(u)), f = hx(u), l = A2(ks, A2(Fu, U1, Rt(Rr(2))), f), d = bh(A2(ju, $E, A2(ks, A2(Fu, U1, Rt(Rr(3))), f))), b = A2(_c, Sh, ys(A2(ks, A2(Fu, U1, Rt(Rr(1))), f))), m = Oh(u), p = A2(R1, m, Dq(t)), v = A2($1, E([
            WM("fs-7")
        ]), $(h1, {
            j: A4(L1, n, e, i.t, H1(u)),
            O: s(d, Zs) ? o : A2(d_, w, E([
                o,
                A2(d_, E([
                    WM("text-muted fw-normal")
                ]), E([
                    a_(" (dont transport "),
                    A2(eB, n.O, d),
                    a_(")")
                ]))
            ])),
            ai: A2(d_, E([
                WM("text-muted")
            ]), E([
                a_("Poids du " + Os(n.mB.c_) + "\xa0: "),
                A2(d_, E([
                    WM("fw-bold")
                ]), E([
                    bW(m)
                ])),
                a_(" ("),
                A2(xV, 0, p),
                a_(")")
            ]))
        })), g = N$(i.t), h = lf(c) ? E([
            A2($1, E([
                WM("fs-7 text-muted")
            ]), $(h1, {
                ai: a_("Aucune transformation")
            }))
        ]) : A2(Ur, (a = {
            j: "Quantit\xe9",
            i: "Origine",
            ai: "Intitul\xe9",
            pK: "Pertes"
        }, A2($1, E([
            WM("fs-8 fw-normal text-muted")
        ]), $(h1, {
            j: a_(a.j),
            i: a_(a.i),
            O: a_("Impact"),
            ai: a_(a.ai),
            pK: a_(a.pK)
        }))), k(A5(r0, n, g, e, l, c), A4(F1, n, g, gx(r), A2(_c, Oh(b), A2(Lc, Oh, vx(l))))));
        return A2(Ur, A2(_1, n, e), A2(Ur, v, A2(Ur, A2(x1, "Mati\xe8re premi\xe8re", Hr), k(A4(Y1, n, e, b, i), k(A5(n0, n, g, b, i, c), A2(Ur, A2(x1, "\xc9tape de transformation", Rr(A3(g1, n, i.t, e))), h))))));
    }), u0 = P, a0 = F4(function(n, e, r, t) {
        var u = r.h3, a = r.r, i = ft(a), c = F2(function(n, e) {
            return A2(VM, E([
                WM("d-flex flex-column")
            ]), E([
                A2(b1, E([
                    WM("fs-8 text-muted order-2 mb-0")
                ]), E([
                    a_(n)
                ])),
                A2(d1, E([
                    WM("fw-bold text-secondary order-1 mb-0 ps-0")
                ]), e)
            ]));
        });
        return A2(VM, E([
            WM("d-flex flex-column gap-3 p-3")
        ]), E([
            A2(VM, E([
                WM("d-flex flex-row align-items-center gap-2")
            ]), E([
                A2(mG, E([
                    WM("text-nowrap"),
                    bG("item-label")
                ]), E([
                    a_(n.mB.de)
                ])),
                A2(q_, E([
                    i_("text"),
                    WM("form-control"),
                    kF("item-label"),
                    hG(n.mB.bC),
                    vK(u.ei),
                    dK(n.ps(e))
                ]), w)
            ])),
            A2(VM, E([
                WM("d-flex flex-wrap gap-4 align-items-center bg-info-subtle border rounded row-gap-1 column-gap-2 column-gap-lg-5 p-3"),
                A2(ZM, "aria-live", "polite")
            ]), E([
                A2(d_, E([
                    WM("d-flex align-items-center gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fs-4 mt-1 text-secondary opacity-75"),
                        A2(ZM, "aria-hidden", "true")
                    ]), E([
                        l_
                    ])),
                    A2(d_, E([
                        WM("fw-bold text-secondary")
                    ]), E([
                        a_("D\xe9tails de la composition")
                    ]))
                ])),
                A2(c, Os(1 === i ? n.mB.c_ : n.mB.c$), E([
                    a_(ut(i))
                ])),
                A2(c, "masse unitaire", E([
                    bW(Dq(t))
                ])),
                A2(c, "impact total", E([
                    A2(eB, n.O, K1(t))
                ]))
            ])),
            A2(VM, E([
                WM("d-flex justify-content-between align-items-center gap-2")
            ]), E([
                A2(e_, E([
                    WM("h5 mb-0")
                ]), E([
                    a_("Liste des " + Os(n.mB.c$) + " et leurs \xe9tapes de transformation")
                ])),
                A2(s1, n, e)
            ])),
            A2(VM, E([
                WM("table-responsive")
            ]), E([
                A2(N_, E([
                    WM("CompositionElements table table-sm table-borderless mb-0 w-100")
                ]), A2(Ur, A2(NW, E([
                    WM("visually-hidden")
                ]), E([
                    a_("Composition des " + Os(n.mB.c$))
                ])), lf(a) ? E([
                    A2(F_, w, E([
                        A2($1, w, $(h1, {
                            ai: a_("Aucun \xe9l\xe9ment")
                        }))
                    ]))
                ]) : A2(QS, A2(F_, E([
                    WM("composition-element-gap")
                ]), E([
                    A2(J_, E([
                        A2(ZM, "aria-hidden", "true")
                    ]), E([
                        A2(K_, E([
                            l1(6)
                        ]), w)
                    ]))
                ])), A4(u0, F3(function(r, u, a) {
                    return A2(F_, E([
                        WM("composition-element")
                    ]), A5(t0, n, v(e, r), u, t, a));
                }), A2(dt, 0, i - 1), a, hx(t)))))
            ]))
        ]));
    }), i0 = F2(function(n, e) {
        var r = n.ac, t = e.b, u = A2(px, n.C, n.g1.mu);
        if (1 === u.$) {
            var a = u.a;
            return A2(c1, Rr("Erreur"), a);
        }
        var i = A2($x, t, u.a);
        if (i.$) return A2(c1, Rr("Erreur"), "Composant introuvable");
        var c = i.a;
        return A4(a0, n, v(c.h3, t), c, A2(_c, Sh, A2($x, t, hx(r.Q))));
    }), c0 = F2(function(n, e) {
        var r = n.ac;
        if (1 === r.$) {
            var t = r.a;
            return A2(c1, Rr("Erreur"), t);
        }
        return A2(i0, {
            h4: n.h4,
            C: n.C,
            b2: n.b2,
            O: n.O,
            mB: {
                cC: n.mB.cC,
                c_: n.mB.c_,
                c$: n.mB.c$,
                de: n.mB.de,
                bC: n.mB.bC
            },
            ac: r.a,
            m8: n.m8,
            nA: n.nA,
            g1: n.g1,
            n1: n.n1,
            n2: n.n2,
            as: n.as,
            pn: n.pn,
            po: n.po,
            pp: n.pp,
            ps: n.ps
        }, e);
    }), o0 = function(n) {
        return n.$ ? Wb(n.a) : n.a.ei;
    }, f0 = F3(function(n, e, r) {
        var t = e.M, u = A2(a1, 0, bs(e.iA));
        switch(r.$){
            case 0:
                return YZ({
                    cF: o = r.a,
                    ga: yc(A2(jc, 1, t)),
                    l2: w,
                    m8: uq,
                    gP: oq,
                    gQ: PY,
                    gY: u.du,
                    eC: u.on,
                    hs: Bi(""),
                    ht: o0
                });
            case 1:
                return GK({
                    h0: yc(A2(jc, 1, t)),
                    h5: E([
                        kY({
                            bu: e.bu,
                            cO: e.cO,
                            O: e.O,
                            nk: TY,
                            nl: SY,
                            nm: IY,
                            nn: OY,
                            oo: qY,
                            oq: LY,
                            eu: n,
                            oM: MY,
                            o$: _Y
                        })
                    ]),
                    l2: w,
                    l3: Hr,
                    m8: uq,
                    oA: 0,
                    oI: Rr("Co\xfbt environnemental, par produit"),
                    eC: "Comparateur de simulations sauvegard\xe9es"
                });
            case 2:
                var a = r.a;
                return GK({
                    h0: yc(A2(jc, 1, t)),
                    h5: E([
                        A2(c0, A2(i1, n, e), a)
                    ]),
                    l2: w,
                    l3: Hr,
                    m8: uq,
                    oA: 1,
                    oI: Hr,
                    eC: "Param\xe8tres et composition"
                });
            case 3:
                return YZ({
                    cF: o = r.a,
                    ga: yc(A2(jc, 1, t)),
                    l2: w,
                    m8: uq,
                    gP: aq,
                    gQ: yY,
                    gY: "tapez ici le nom d'un proc\xe9d\xe9 d'assemblage pour le rechercher",
                    eC: "S\xe9lectionnez un proc\xe9d\xe9 d'assemblage",
                    hs: A2(Fu, function(n) {
                        return n.aL;
                    }, Ch),
                    ht: Wb
                });
            case 4:
                return YZ({
                    cF: o = r.a,
                    ga: yc(A2(jc, 1, t)),
                    l2: w,
                    m8: uq,
                    gP: iq,
                    gQ: jY,
                    gY: "tapez ici le nom d'un proc\xe9d\xe9 de consommation pour le rechercher",
                    eC: "S\xe9lectionnez une consommation",
                    hs: A2(Fu, function(n) {
                        return n.aL;
                    }, Ch),
                    ht: Wb
                });
            case 5:
                return YZ({
                    cF: o = r.a,
                    ga: yc(A2(jc, 1, t)),
                    l2: w,
                    m8: uq,
                    gP: fq,
                    gQ: EY,
                    gY: "tapez ici le nom du produit pour le rechercher",
                    eC: "S\xe9lectionnez un produit",
                    hs: NZ(e.lP),
                    ht: UZ(e.lP)
                });
            case 6:
                return YZ({
                    cF: o = r.a,
                    ga: yc(A2(jc, 1, t)),
                    l2: w,
                    m8: uq,
                    gP: sq,
                    gQ: AY,
                    gY: "tapez ici le nom d'un emballage pour le rechercher",
                    eC: "S\xe9lectionnez un emballage",
                    hs: A2(Fu, function(n) {
                        return n.aL;
                    }, Ch),
                    ht: Wb
                });
            default:
                var i = r.a, c = (a = r.b, r.c), o = r.d, f = function() {
                    switch(i.$){
                        case 5:
                            return v("tapez ici le nom d'une mati\xe8re premi\xe8re pour la rechercher", "S\xe9lectionnez une mati\xe8re premi\xe8re");
                        case 11:
                            return v("tapez ici le nom d'un proc\xe9d\xe9 de transformation pour le rechercher", "S\xe9lectionnez un proc\xe9d\xe9 de transformation");
                        default:
                            return v("tapez ici le nom d'un proc\xe9d\xe9 pour le rechercher", "S\xe9lectionnez un proc\xe9d\xe9");
                    }
                }(), s = f.a, l = f.b;
                return YZ({
                    cF: o,
                    ga: yc(A2(jc, 1, t)),
                    l2: w,
                    m8: uq,
                    gP: A3(cq, i, a, c),
                    gQ: A3(CY, i, a, c),
                    gY: s,
                    eC: l,
                    hs: A2(Fu, function(n) {
                        return n.aL;
                    }, Ch),
                    ht: Wb
                });
        }
    }), s0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, l0 = {
        $: 2
    }, d0 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, b0 = {
        $: 5
    }, m0 = {
        $: 6
    }, p0 = {
        $: 24
    }, v0 = {
        $: 31
    }, g0 = {
        $: 32
    }, h0 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, $0 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, x0 = function(n) {
        return {
            $: 41,
            a: n
        };
    }, k0 = function(n) {
        return {
            $: 46,
            a: n
        };
    }, w0 = function(n) {
        return {
            $: 50,
            a: n
        };
    }, y0 = function(n) {
        return {
            $: 51,
            a: n
        };
    }, j0 = function(n) {
        return {
            $: 59,
            a: n
        };
    }, E0 = F2(function(n, e) {
        return {
            $: 61,
            a: n,
            b: e
        };
    }), A0 = F2(function(n, e) {
        return n.$ ? e : A2(tj, n.a, e);
    }), C0 = function(n) {
        return A2(Fu, MJ, A0(n));
    }, P0 = function(n) {
        return {
            $: 53,
            a: n
        };
    }, T0 = s_("cross-rounded"), S0 = GM("max"), I0 = function(n) {
        return A2(q_, A2(Ur, i_("range"), A2(Ur, WM("form-range"), n)), w);
    }, O0 = F2(function(n, e) {
        return I0(k(n, E([
            dK(A2(Fu, e.l4, e.pd)),
            nZ(e.oZ(e.m_)),
            S0(e.oZ(e.mX)),
            eZ(e.oF),
            vK(e.oZ(e.eP)),
            E_(e.bW)
        ])));
    }), q0 = F3(function(n, e, r) {
        var t = n.$9, u = A2(Qa, ra(r), A2(Vh, e, t.jO));
        return u.$ ? A2(ra, r, t.ib) : Rr(u.a);
    }), L0 = q0, M0 = F3(function(n, e, r) {
        if (A2(f$, e, n.aO)) {
            var t = A2(_c, 1, r);
            return A2(VM, E([
                WM("card shadow-sm pb-2 mb-3")
            ]), E([
                A2(VM, E([
                    WM("card-header d-flex justify-content-between align-items-center")
                ]), E([
                    A2(C_, E([
                        WM("h5 mb-1 text-truncate")
                    ]), E([
                        a_("Durabilit\xe9")
                    ])),
                    A2(VM, E([
                        WM("d-flex align-items-center gap-2")
                    ]), E([
                        function() {
                            var r = A3(L0, n, e, "durability");
                            if (r.$) return a_("");
                            var t = r.a;
                            return A2(LQ, E([
                                WM("bg-secondary"),
                                A2(OF, "height", "24px"),
                                XM(t),
                                V_("Documentation"),
                                LF("_blank")
                            ]), E([
                                yJ
                            ]));
                        }()
                    ]))
                ])),
                A2(VM, E([
                    WM("card-body pb-1 row g-3 align-items-start flex-md-columns")
                ]), E([
                    A2(VM, E([
                        WM("col-sm-6 col-md-4")
                    ]), E([
                        A2(mG, E([
                            bG("durability"),
                            WM("text-truncate")
                        ]), E([
                            a_("Coefficient de durabilit\xe9")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-sm-2 col-md-2")
                    ]), E([
                        a_(A2(zw, 2, t))
                    ])),
                    A2(VM, E([
                        WM("col-sm-4 col-md-6 text-nowrap d-flex align-items-center gap-2")
                    ]), E([
                        A2(O0, E([
                            kF("durability")
                        ]), {
                            bW: !1,
                            l4: A2(Fu, gp, A2(Fu, ws("Durabilit\xe9 invalide (un nombre est requis)"), A2(Fu, is(function(n) {
                                return .5 > n ? Jr("Durabilit\xe9 trop faible (minimum: 0.5)") : n > 1.5 ? Jr("Durabilit\xe9 trop \xe9lev\xe9e (maximum: 1.5)") : Zr(n);
                            }), ss(vm)))),
                            mX: 1.5,
                            m_: .5,
                            oF: "0.01",
                            oZ: A2(Fu, B$, Bs),
                            pd: P0,
                            eP: t
                        }),
                        A2(YM, E([
                            i_("button"),
                            WM("btn text-primary p-0 border-0"),
                            u_(P0(Zr(1))),
                            V_("R\xe9initialiser la durabilit\xe9"),
                            E_(s(r, Hr) || s(r, Rr(1)))
                        ]), E([
                            T0
                        ]))
                    ]))
                ]))
            ]));
        }
        return a_("");
    }), _0 = function(n) {
        return {
            ay: n.h4,
            C: n.C,
            as: n.as
        };
    }, R0 = function(n) {
        var e = n.nx, r = n.g1, t = A2(ks, function(e) {
            return !A2(tl, e.mf, A2(Mh, _0(n), r));
        }, A3(o1, n.as, Ox, n.C.W)), u = A2(XQ, Wb, t);
        return A2(YM, E([
            i_("button"),
            WM("btn btn-outline-primary w-100 rounded-0 gap-1"),
            WM("d-flex justify-content-center align-items-center"),
            E_(lf(t)),
            u_(e(u))
        ]), E([
            nQ,
            a_("Ajouter un proc\xe9d\xe9 d\u2019assemblage")
        ]));
    }, H0 = F2(function(n, e) {
        var r = A3(L0, n.h4, n.as, e);
        if (r.$) return a_("");
        var t = r.a;
        return A2(LQ, E([
            WM("bg-secondary"),
            A2(OF, "height", "24px"),
            XM(t),
            V_("Documentation"),
            LF("_blank")
        ]), E([
            yJ
        ]));
    }), U0 = GM("scope"), z0 = F2(function(n, e) {
        var r = n.C, t = n.O, u = n.g1, a = n.as;
        return A2(VM, E([
            WM("card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between gap-2")
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0")
                ]), E([
                    a_("Assemblage")
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), E([
                    A2(eB, t, $E(e.q))
                ])),
                A2(H0, n, "assembly")
            ])),
            A2(VM, E([
                WM("card-body d-flex flex-column gap-3 p-0")
            ]), E([
                A2(VM, E([
                    WM("d-flex align-items-center gap-2 px-3 pt-3")
                ]), E([
                    A2(mG, E([
                        bG("assembly-country")
                    ]), E([
                        a_("Pays d\u2019assemblage")
                    ])),
                    Z1({
                        kB: w,
                        kT: "w-33",
                        bR: r.bR,
                        bW: !1,
                        lw: "assembly-country",
                        lL: "Inconnu",
                        md: !0,
                        ai: Hr,
                        as: a,
                        on: n.pf,
                        or: u.q.i,
                        oy: !1
                    })
                ])),
                function() {
                    var a = A3(Ih, r, u.q.i, A2(Mh, _0(n), u));
                    if (1 === a.$) {
                        var i = a.a;
                        return A2(VM, E([
                            WM("px-3 pb-3")
                        ]), E([
                            A2(c1, Rr("Erreur"), i)
                        ]));
                    }
                    var c = a.a;
                    return lf(c) ? A2(VM, E([
                        WM("px-3 pb-3 text-muted")
                    ]), E([
                        a_("Aucun proc\xe9d\xe9 d\u2019assemblage")
                    ])) : A2(N_, E([
                        WM("table table-sm mb-0 border-top")
                    ]), E([
                        A2(W_, w, E([
                            A2(J_, E([
                                WM("fs-7 text-muted bg-light")
                            ]), E([
                                A2(G_, E([
                                    WM("bg-light ps-3 align-middle"),
                                    U0("col")
                                ]), E([
                                    a_("Op\xe9ration")
                                ])),
                                A2(G_, E([
                                    WM("bg-light align-middle text-end"),
                                    U0("col")
                                ]), E([
                                    a_("Pertes")
                                ])),
                                A2(G_, E([
                                    WM("bg-light align-middle text-end"),
                                    U0("col")
                                ]), E([
                                    a_("Masse")
                                ])),
                                A2(G_, E([
                                    WM("bg-light align-middle text-end"),
                                    U0("col")
                                ]), E([
                                    a_("Impact")
                                ])),
                                A2(G_, E([
                                    WM("bg-light align-middle"),
                                    U0("col")
                                ]), w)
                            ]))
                        ])),
                        A2(F_, w, A2(bt, F2(function(r, u) {
                            var a = u.t, i = A2(_c, Sh, A2($x, r, hx(e.q)));
                            return A2(J_, w, E([
                                A2(K_, E([
                                    WM("ps-3 align-middle w-100")
                                ]), E([
                                    a_(Wb(a))
                                ])),
                                A2(K_, E([
                                    WM("align-middle text-end text-nowrap")
                                ]), E([
                                    e0(a.g0)
                                ])),
                                A2(K_, E([
                                    WM("align-middle text-end text-nowrap")
                                ]), E([
                                    bW(Oh(i))
                                ])),
                                A2(K_, E([
                                    WM("align-middle text-end text-nowrap")
                                ]), E([
                                    A2(eB, t, $E(i))
                                ])),
                                A2(K_, E([
                                    WM("align-middle pe-3 text-end")
                                ]), E([
                                    A2(YM, E([
                                        i_("button"),
                                        WM("btn btn-sm btn-outline-secondary"),
                                        V_("Supprimer ce proc\xe9d\xe9 d\u2019assemblage"),
                                        u_(n.n$(r))
                                    ]), E([
                                        OG
                                    ]))
                                ]))
                            ]));
                        }), c))
                    ]));
                }(),
                R0(n)
            ]))
        ]));
    }), D0 = s_("fork-way"), N0 = s_("lock"), F0 = F2(function(n, e) {
        var r = n.h4, t = n.C, u = n.O, a = n.g1, i = n.as, c = n.pl;
        return A2(VM, E([
            WM("card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between gap-2")
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0")
                ]), E([
                    a_("Distribution")
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), E([
                    A2(eB, u, e.E.g)
                ])),
                A2(H0, n, "distribution")
            ])),
            A2(VM, E([
                WM("card-body d-flex justify-content-between align-items-center gap-2")
            ]), A2(La, ru, E([
                Rr(A2(VM, E([
                    WM("d-flex align-items-center gap-1")
                ]), E([
                    N0,
                    a_("France")
                ]))),
                Rr(A2(VM, E([
                    WM("d-flex align-items-center w-33 justify-content-end gap-1")
                ]), E([
                    D1,
                    dW(e.E.eU)
                ]))),
                function() {
                    var n = A2(Kh, t, i);
                    if (n.b) {
                        var e = n, u = A2(Bh, {
                            ay: r,
                            C: t,
                            as: i
                        }, a);
                        return Rr(A2(mK, E([
                            WM("form-select w-50"),
                            dK(A2(Fu, qC, c))
                        ]), A2(ju, function(n) {
                            return A2(bK, E([
                                vK(_s(n.mf)),
                                pK(s(u, Rr(n.mf)))
                            ]), E([
                                a_(Wb(n))
                            ]));
                        }, e)));
                    }
                    return Hr;
                }()
            ])))
        ]));
    }), K0 = F2(function(n, e) {
        var r = n.h4, t = n.g1, u = n.as, a = e.a, i = e.b.dV, c = e.b.ek, o = F2(function(e, r) {
            var t = r.g, u = r.t, a = r.oD;
            if (s(a, 0)) return a_("-");
            var i = A2(fh, n.O.kf, t), c = A2(eB, n.O, t);
            return A2(VM, w, E([
                function() {
                    if (e && !i) return A2(d_, E([
                        WM("cursor-help"),
                        V_("Le recyclage est ici consid\xe9r\xe9 sans impact")
                    ]), E([
                        c,
                        a_("*")
                    ]));
                    if (u.$) return c;
                    var n = u.a;
                    return A2(d_, E([
                        WM("cursor-help"),
                        V_(Gb(n))
                    ]), E([
                        c
                    ]));
                }(),
                A2(xG, w, E([
                    a_("\xa0("),
                    A2(xV, 0, a),
                    a_(")")
                ]))
            ]));
        }), f = A3(t$, r, t.dq, u), l = sb(f);
        return E([
            A2(J_, E([
                WM("table-active")
            ]), E([
                A2(G_, E([
                    WM("text-end")
                ]), E([
                    a_(wP(a))
                ])),
                A2(K_, E([
                    WM("text-end"),
                    l1(4)
                ]), w),
                A2(K_, E([
                    WM("text-end pe-3 fw-bold")
                ]), E([
                    A2(eB, n.O, bh(E([
                        i.b.fy.g,
                        i.b.ff.g,
                        i.b.fi.g,
                        c.b.fy.g,
                        c.b.ff.g,
                        c.b.fi.g
                    ])))
                ]))
            ])),
            A2(J_, w, E([
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    a_("Collect\xe9 \xe0 "),
                    A2(xV, 0, f)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    bW(i.a)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    A2(o, !0, i.b.fy)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    A2(o, !1, i.b.ff)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    A2(o, !1, i.b.fi)
                ])),
                A2(K_, E([
                    WM("text-end pe-3")
                ]), E([
                    A2(eB, n.O, bh(E([
                        i.b.fy.g,
                        i.b.ff.g,
                        i.b.fi.g
                    ])))
                ]))
            ])),
            A2(J_, w, E([
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    a_("Non-collect\xe9 \xe0 "),
                    A2(xV, 0, l)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    bW(c.a)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    A2(o, !0, c.b.fy)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    A2(o, !1, c.b.ff)
                ])),
                A2(K_, E([
                    WM("text-end")
                ]), E([
                    A2(o, !1, c.b.fi)
                ])),
                A2(K_, E([
                    WM("text-end pe-3")
                ]), E([
                    A2(eB, n.O, bh(E([
                        c.b.fy.g,
                        c.b.ff.g,
                        c.b.fi.g
                    ])))
                ]))
            ]))
        ]);
    }), G0 = GM("name"), W0 = F2(function(n, e) {
        var r = n.h4, t = n.g1, u = n.as, a = n.pC;
        return A2(VM, E([
            WM("card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between gap-2")
            ]), E([
                A2(VM, E([
                    WM("IngredientPlaneOrBoatSelector")
                ]), E([
                    A2(VM, E([
                        WM("mb-0 d-flex")
                    ]), E([
                        A2(VM, E([
                            WM("h5")
                        ]), E([
                            a_("Fin de vie")
                        ]))
                    ]))
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill align-items-center justify-content-center")
                ]), E([
                    A2(d_, E([
                        WM("pe-3")
                    ]), E([
                        a_("Ce produit est-il recyclable\xa0?")
                    ])),
                    A2(VM, E([
                        WM("form-check form-check-inline")
                    ]), E([
                        A2(q_, E([
                            i_("radio"),
                            WM("form-check-input"),
                            G0("recyclable"),
                            kF("recyclable-yes"),
                            u_(a(!0)),
                            w_(t.dq)
                        ]), w),
                        A2(mG, E([
                            WM("form-check-label"),
                            bG("recyclable-yes")
                        ]), E([
                            a_("Oui")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("form-check form-check-inline")
                    ]), E([
                        A2(q_, E([
                            i_("radio"),
                            WM("form-check-input"),
                            G0("recyclable"),
                            kF("recyclable-no"),
                            u_(a(!1)),
                            w_(!t.dq)
                        ]), w),
                        A2(mG, E([
                            WM("form-check-label"),
                            bG("recyclable-no")
                        ]), E([
                            a_("Non")
                        ]))
                    ]))
                ])),
                A2(eB, n.O, e._),
                A2(H0, n, "eol")
            ])),
            A2(VM, E([
                WM("card-body table-responsive p-0")
            ]), E([
                A2(f$, u, n.h4._) ? A2(VM, w, E([
                    A2(N_, E([
                        WM("table mb-0 fs-7")
                    ]), E([
                        A2(W_, w, E([
                            A2(J_, w, E([
                                A2(G_, E([
                                    WM("text-end")
                                ]), E([
                                    a_("Mati\xe8re")
                                ])),
                                A2(G_, E([
                                    WM("text-end")
                                ]), E([
                                    a_("Masse")
                                ])),
                                A2(G_, E([
                                    WM("text-end")
                                ]), E([
                                    a_("Recyclage")
                                ])),
                                A2(G_, E([
                                    WM("text-end")
                                ]), E([
                                    a_("Incin\xe9ration")
                                ])),
                                A2(G_, E([
                                    WM("text-end")
                                ]), E([
                                    a_("Enfouissement")
                                ])),
                                A2(G_, E([
                                    WM("text-end pe-3")
                                ]), E([
                                    a_("Impact")
                                ]))
                            ]))
                        ])),
                        A2(F_, w, A2(Id, K0(n), A2(IE, A2(Fu, Gt, wP), c$(A3(o$, {
                            ay: r,
                            C: n.C,
                            as: n.as
                        }, t.dq, e)))))
                    ]))
                ])) : A2(VM, E([
                    WM("card-body d-flex align-items-center justify-content-start gap-2")
                ]), E([
                    l_,
                    a_("Fin de vie non disponible pour le p\xe9rim\xe8tre " + qx(n.as))
                ]))
            ]))
        ]));
    }), V0 = A2(OZ, w, w), J0 = function(n) {
        return n.bk;
    }, B0 = function(n) {
        var e = n.g1, r = A2(ks, function(n) {
            return !A2(tl, n.mf, A2(ju, J0, e.aR));
        }, A3(o1, n.as, LP, n.C.W)), t = A2(XQ, Wb, r);
        return A2(YM, E([
            i_("button"),
            WM("btn btn-outline-primary w-100"),
            WM("d-flex justify-content-center align-items-center"),
            WM("gap-1 w-100"),
            u_(n.nz(t)),
            E_(lf(r))
        ]), E([
            nQ,
            a_("Ajouter un emballage")
        ]));
    }, X0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Q0 = F4(function(n, e, r, t) {
        var u = n.C, a = n.b2, i = n.O, c = n.m8;
        return lf(t) ? A2(VM, E([
            WM("card-body")
        ]), E([
            a_(r.e5)
        ])) : A2(VM, E([
            WM("QuantifiedProcessList table-responsive table-scroll position-relative")
        ]), E([
            A2(N_, E([
                WM("table table-hover mb-0")
            ]), E([
                function() {
                    var n = A2(r.e7, u.W, t);
                    if (1 === n.$) return A2(c1, Hr, n.a);
                    var o = n.a;
                    return A2(F_, w, A2(bt, F2(function(n, t) {
                        var u = t.j, o = t.t;
                        return A2(J_, w, E([
                            A2(K_, E([
                                WM("ps-3 align-middle text-nowrap"),
                                A2(OF, "min-width", "160px")
                            ]), E([
                                A2(q1, {
                                    mf: r.fd + "-" + ut(n),
                                    ai: "Quantit\xe9",
                                    m8: c,
                                    np: r.fW(n),
                                    H: a,
                                    aL: o.aL,
                                    pO: A2(tl, Vb, o.cK) ? X0("Cette quantit\xe9 n\u2019est pas modifiable") : k1
                                }, A3(Px, e, o, u))
                            ])),
                            A2(K_, E([
                                WM("align-middle text-truncate w-66 cursor-help "),
                                A2(OF, "max-width", "0"),
                                V_(A2(at, "\n", E([
                                    Wb(o),
                                    Gb(o)
                                ])))
                            ]), E([
                                a_(Wb(o))
                            ])),
                            A2(K_, E([
                                WM("align-middle text-end text-nowrap")
                            ]), E([
                                A2(eB, i, A2(_c, Zs, A2($x, n, r.fe)))
                            ])),
                            A2(K_, E([
                                WM("align-middle pe-3 pt-2")
                            ]), E([
                                A2(YM, E([
                                    i_("button"),
                                    WM("btn btn-sm btn-outline-secondary"),
                                    V_(r.e2),
                                    u_(r.fA(n))
                                ]), E([
                                    OG
                                ]))
                            ]))
                        ]));
                    }), o));
                }()
            ]))
        ]));
    }), Z0 = F2(function(n, e) {
        var r = n.g1;
        return A2(VM, E([
            WM("card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between gap-2")
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0")
                ]), E([
                    a_("Emballage")
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), E([
                    A2(eB, n.O, bh(e.cm))
                ])),
                A2(H0, n, "packaging")
            ])),
            A4(Q0, n, e, {
                e2: "Supprimer cet emballage",
                e5: "Aucun emballage",
                e7: ux,
                fd: "packaging",
                fe: e.cm,
                fA: n.n4,
                fW: n.pA
            }, r.aR),
            B0(n)
        ]));
    }), Y0 = function(n) {
        return n ? 1 : 0;
    }, n2 = function(n) {
        var e = n.f9, r = n.mf, t = n.ai, u = n.gR;
        return A2(VM, E([
            WM("d-flex justify-content-end align-items-center gap-2")
        ]), E([
            A2(q_, E([
                i_("checkbox"),
                WM("form-check-input"),
                kF(r),
                w_(e),
                gG(u)
            ]), w),
            A2(mG, E([
                WM("form-check-label"),
                bG(r)
            ]), E([
                a_(t)
            ]))
        ]));
    }, e2 = function(n) {
        return n2({
            f9: s(n.g1.aw.a8, 1),
            mf: "transportByAirSwitch",
            ai: "par avion",
            gR: A2(Fu, Y0, n.o2)
        });
    }, r2 = function(n) {
        var e = n.g1;
        return n2({
            f9: A2(kx, _0(n), e),
            mf: "transportCoolingSwitch",
            ai: "r\xe9frig\xe9r\xe9",
            gR: n.o3
        });
    }, t2 = F2(function(n, e) {
        var r = A3(L0, n.h4, n.as, e);
        if (r.$) return a_("");
        var t = r.a;
        return A2(mZ, E([
            WM("text-muted"),
            XM(t),
            V_("Documentation"),
            LF("_blank")
        ]), E([
            yJ
        ]));
    }), u2 = F3(function(n, e, r) {
        var t = n.h4, u = n.O, a = n.as, i = A2(Ah, function(n) {
            return A2(tl, a, n.g5);
        }, E([
            t.af.m3.kH,
            t.af.m3.mM
        ])), c = A2(tl, a, t.af.m3.nH.g5);
        return A2(OZ, E([
            A2(VM, E([
                WM("d-flex justify-content-end align-items-center gap-2")
            ]), E([
                a_("Transport"),
                D1,
                bW(e),
                i ? r2(n) : a_(""),
                c ? e2(n) : a_("")
            ]))
        ]), E([
            A2(VM, E([
                WM("d-flex align-items-center gap-2")
            ]), E([
                A2(VM, E([
                    WM("d-flex gap-2")
                ]), A2(lZ, {
                    f2: Rr("avion"),
                    gu: !0,
                    gz: !0,
                    eo: !1,
                    g4: Hr,
                    g8: Hr
                }, r)),
                A2(eB, u, r.g),
                A2(t2, n, "transport")
            ]))
        ]));
    }), a2 = function(n) {
        var e = n.ny, r = n.g1, t = A2(ks, function(e) {
            return !A2(tl, e.mf, A2(ju, function(n) {
                return n.bk;
            }, A2(Cx, _0(n), r)));
        }, A3(o1, n.as, UP, n.C.W)), u = A2(XQ, Wb, t);
        return A2(YM, E([
            i_("button"),
            WM("btn btn-outline-primary w-100"),
            WM("d-flex justify-content-center align-items-center"),
            WM("gap-1 w-100"),
            E_(lf(t)),
            u_(e(u))
        ]), E([
            nQ,
            a_("Ajouter une consommation")
        ]));
    }, i2 = F2(function(n, e) {
        var r = n.O, t = n.g1;
        return A2(VM, E([
            WM("card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between gap-2")
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0")
                ]), E([
                    a_("Utilisation")
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), E([
                    A2(eB, r, bh(e.bK))
                ])),
                A2(H0, n, "use")
            ])),
            A2(VM, E([
                WM("d-flex flex-column p-0")
            ]), E([
                A4(Q0, n, e, {
                    e2: "Supprimer cette consommation",
                    e5: "Aucune consommation",
                    e7: Ax,
                    fd: "consumption",
                    fe: e.bK,
                    fA: n.n0,
                    fW: n.ph
                }, A2(Cx, _0(n), t)),
                a2(n)
            ]))
        ]));
    }), c2 = F2(function(n, e) {
        return A2(VM, w, E([
            V0,
            A2(Z0, n, e),
            A3(u2, n, e.aT, e.af.eF),
            A2(F0, n, e),
            V0,
            A2(i2, n, e),
            V0,
            A2(W0, n, e)
        ]));
    }), o2 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, f2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, s2 = function(n) {
        return lf(n.r);
    }, l2 = function(n) {
        var e = n.C, r = 1 === n.k_ ? w : A2(ju, f2, A2(ks, function(n) {
            return !A2(tl, LP, n.cK);
        }, A3(o1, n.as, OP, e.W))), t = k(A2(ju, o2, A2(ks, A2(Fu, function(n) {
            return n.g5;
        }, tl(n.as)), A2(ks, A2(cc, ul, s2), e.dX))), r), u = A2(XQ, o0, A2(IE, o0, t));
        return A2(YM, E([
            i_("button"),
            WM("btn btn-outline-primary w-100"),
            WM("d-flex justify-content-center align-items-center"),
            WM("gap-1 w-100"),
            E_(lf(t)),
            u_(n.nB(u))
        ]), E([
            nQ,
            a_(n.mB.cB)
        ]));
    }, d2 = function(n) {
        return A2(J_, E([
            WM("fs-8 fw-normal text-muted border-bottom")
        ]), E([
            A2(G_, E([
                WM("ps-2 py-2 align-middle"),
                U0("col")
            ]), E([
                A2(d_, E([
                    WM("visually-hidden")
                ]), E([
                    a_("D\xe9tails")
                ]))
            ])),
            A2(G_, E([
                WM("py-2 text-end align-middle text-nowrap"),
                U0("col")
            ]), E([
                a_("Masse unitaire")
            ])),
            A2(G_, E([
                WM("py-2 align-middle text-truncate w-100"),
                A2(OF, "max-width", "0"),
                U0("col")
            ]), E([
                a_(n.mB.bC)
            ])),
            A2(G_, E([
                WM("py-2 align-middle text-center"),
                U0("col")
            ]), E([
                a_("Quantit\xe9")
            ])),
            A2(G_, E([
                WM("py-2 text-end align-middle text-nowrap"),
                U0("col")
            ]), E([
                a_("Masse totale")
            ])),
            A2(G_, E([
                WM("py-2 text-end align-middle text-nowrap"),
                A2(OF, "min-width", "80px"),
                U0("col")
            ]), E([
                a_("Impacts")
            ])),
            A2(G_, E([
                WM("py-2 pe-3 text-end align-middle text-nowrap"),
                U0("col")
            ]), E([
                A2(d_, E([
                    WM("visually-hidden")
                ]), E([
                    a_("Actions")
                ]))
            ]))
        ]));
    }, b2 = function(n) {
        return "item-table-" + ut(n);
    }, m2 = F3(function(n, e, r) {
        var t = r ? "D\xe9plier les d\xe9tails" : "Replier les d\xe9tails";
        return A2(YM, E([
            i_("button"),
            WM("btn btn-link text-muted text-decoration-none font-monospace fs-6 p-0 m-0"),
            V_(t),
            A2(ZM, "aria-label", t),
            A2(ZM, "aria-expanded", r ? "false" : "true"),
            A2(ZM, "aria-controls", b2(e)),
            u_(n.ov(r ? ay(A2(Ur, e, n.lq)) : A2(ks, Sc(e), n.lq)))
        ]), E([
            a_(r ? "\u25B6" : "\u25BC")
        ]));
    }), p2 = k_("hidden"), v2 = F3(function(n, e, r) {
        var t = A2(YM, E([
            i_("button"),
            WM("btn btn-sm btn-outline-secondary"),
            A2(ZM, "aria-label", "Modifier la composition"),
            u_(n.nw(v(r, e)))
        ]), E([
            NX
        ])), u = A2(YM, E([
            i_("button"),
            WM("btn btn-sm btn-outline-secondary"),
            A2(ZM, "aria-label", "Supprimer"),
            u_(n.n3(e))
        ]), E([
            OG
        ]));
        return A2(VM, E([
            WM("btn-group")
        ]), E(1 !== n.k_ ? [
            t,
            u
        ] : [
            u
        ]));
    }), g2 = {
        hE: a_(""),
        gq: a_(""),
        g: a_(""),
        ai: a_(""),
        D: a_(""),
        hu: a_(""),
        dH: a_("")
    }, h2 = A2(Fu, ju(function(n) {
        var e = n.i;
        return k(Wb(n.t), e.$ ? "" : " (" + e.a.ei + ")");
    }), at(", ")), $2 = F2(function(n, e) {
        return A2(J_, n, E([
            A2(K_, E([
                WM("ps-2 py-2 align-middle")
            ]), E([
                e.gq
            ])),
            A2(K_, E([
                WM("py-2 text-end align-middle text-nowrap")
            ]), E([
                e.dH
            ])),
            A2(K_, E([
                WM("py-2 align-middle text-truncate w-100"),
                A2(OF, "max-width", "0")
            ]), E([
                e.ai
            ])),
            A2(K_, E([
                WM("py-2 align-middle text-center")
            ]), E([
                e.D
            ])),
            A2(K_, E([
                WM("py-2 text-end align-middle text-nowrap")
            ]), E([
                e.hu
            ])),
            A2(K_, E([
                WM("py-2 text-end align-middle text-nowrap"),
                A2(OF, "min-width", "80px")
            ]), E([
                e.g
            ])),
            A2(K_, E([
                WM("py-2 pe-3 text-end align-middle text-nowrap")
            ]), E([
                e.hE
            ]))
        ]));
    }), x2 = F4(function(n, e, r, t) {
        var u = r.U, a = r.J, i = function(n) {
            var e = n.i;
            return A2(at, " ", E([
                Wb(n.t),
                "(" + A2(_c, "Inconnu", A2(Lc, function(n) {
                    return n.ei;
                }, e)) + ")"
            ]));
        }, c = Oh(t), o = H1(t), f = A2(d_, E([
            WM("d-flex text-muted fs-8")
        ]), E([
            2 !== u.t.aL ? A2(d_, w, E([
                a_("("),
                A2(gW, u.t, o),
                a_(")\xa0")
            ])) : a_(""),
            bW(c)
        ]));
        return A2($2, E([
            WM("fs-7 border-top")
        ]), $(g2, {
            g: A2(eB, n.O, K1(t)),
            ai: A2(VM, E([
                WM("d-flex flex-column")
            ]), E([
                A2(VM, E([
                    V_(i(u))
                ]), E([
                    a_(i(u))
                ])),
                A2(VM, E([
                    WM("d-flex align-items-center gap-1 text-muted"),
                    V_(h2(a))
                ]), E([
                    lf(a) ? a_("Aucune transformation") : a_(h2(a))
                ]))
            ])),
            dH: A2(VM, E([
                WM("d-flex flex-column align-items-end")
            ]), E([
                A2(xV, 1, A2(R1, c, Dq(e))),
                f
            ]))
        }));
    }), k2 = F3(function(n, e, r) {
        return lf(e) ? ik(A2($2, E([
            WM("bg-light border-bottom")
        ]), $(g2, {
            ai: a_("Aucun \xe9l\xe9ment")
        }))) : A3(st, A2(x2, n, r), e, hx(r));
    }), w2 = F3(function(n, e, r) {
        return A2(VM, E([
            WM("input-group"),
            A2(OF, "width", "70px")
        ]), E([
            A2(q_, E([
                i_("number"),
                WM("form-control form-control-sm text-end"),
                vK(ut(r)),
                eZ("1"),
                nZ("1"),
                dK(function(r) {
                    return A2(_c, n.m8, A2(Lc, A2(Fu, xq, n.pt(e)), A2(Qa, function(n) {
                        return n > 0 ? Rr(n) : Hr;
                    }, du(r))));
                })
            ]), w)
        ]));
    }), y2 = function(n) {
        return 2 === n.aL || !s(n.mV, Hr);
    }, j2 = F4(function(n, e, r, t) {
        var u = A2(_c, Dq(t), A2(Qa, function(n) {
            return n.dH;
        }, A2($x, e, n.g1.mu))), a = A2(rl, A2(Fu, function(n) {
            return n.U;
        }, A2(Fu, function(n) {
            return n.t;
        }, A2(Fu, y2, ul))), r) ? X0("La masse par unit\xe9 du proc\xe9d\xe9 mobilis\xe9 n\u2019est pas connue \xe0 ce jour") : s(u, 0) ? X0("La masse des \xe9l\xe9ments du composant est nulle, \xe9dition impossible") : n.pc ? X0("La masse unitaire n\u2019est pas modifiable tant que la modale d\u2019\xe9dition du composant est ouverte") : k1;
        return A2(q1, {
            mf: "unit-mass-" + ut(e),
            ai: "Masse unitaire",
            m8: n.m8,
            np: n.pu(e),
            H: n.b2,
            aL: 2,
            pO: a
        }, Th(u));
    }), E2 = F4(function(n, e, r, t) {
        var u = r.h3, a = r.r, i = r.D, c = !A2(tl, e, n.lq);
        return E([
            A2(F_, e > 0 ? E([
                A2(OF, "border-top", "1px solid #777")
            ]) : w, E([
                A2($2, E([
                    WM("border-bottom"),
                    n_(E([
                        v("table-info", !c)
                    ]))
                ]), {
                    hE: A3(v2, n, e, u),
                    gq: 1 === n.k_ ? a_("") : A3(m2, n, e, c),
                    g: A2(eB, n.O, K1(t)),
                    ai: A2(d_, E([
                        V_(u.ei)
                    ]), E([
                        a_(u.ei)
                    ])),
                    D: A3(w2, n, e, i),
                    hu: bW(Oh(t)),
                    dH: 1 === n.k_ ? bW(Dq(t)) : A4(j2, n, e, a, t)
                })
            ])),
            A2(F_, E([
                WM("table-light"),
                kF(b2(e)),
                p2(c)
            ]), A3(k2, n, a, t))
        ]);
    }), C2 = F2(function(n, e) {
        var r = n.lu, t = n.lT, u = n.g1;
        return A2(VM, E([
            WM("card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("card-header d-flex align-items-center justify-content-between gap-2")
            ]), E([
                A2(C_, E([
                    WM("h5 mb-0")
                ]), E([
                    a_(n.mB.$7),
                    t.$ ? a_("") : A2($V, E([
                        QM(t.a),
                        V_("Explorer"),
                        A2(ZM, "aria-label", "Explorer")
                    ]), E([
                        mJ
                    ]))
                ])),
                A2(VM, E([
                    WM("d-flex flex-fill justify-content-end align-items-center gap-2")
                ]), E([
                    A2(d_, E([
                        WM("cursor-help"),
                        V_("Hors transports")
                    ]), E([
                        A2(eB, n.O, K1(e))
                    ])),
                    r.$ ? a_("") : A2(LQ, E([
                        XM(r.a),
                        LF("_blank"),
                        A2(OF, "height", "24px")
                    ]), E([
                        yJ
                    ]))
                ])),
                n.lv
            ])),
            function() {
                if (lf(u.mu)) return A2(VM, E([
                    WM("card-body")
                ]), E([
                    a_(n.mB.c2)
                ]));
                var r = A2(px, n.C, u.mu);
                if (1 === r.$) {
                    var t = r.a;
                    return A2(c1, Rr("Erreur"), t);
                }
                var a = r.a;
                return A2(VM, E([
                    WM("table-responsive")
                ]), E([
                    A2(N_, E([
                        WM("table table-sm table-borderless mb-0")
                    ]), A2(Ur, A2(W_, w, E([
                        d2(n)
                    ])), Sd(A4(u0, E2(n), A2(dt, 0, ft(u.mu) - 1), a, hx(e)))))
                ]));
            }(),
            l2(n)
        ]));
    }), P2 = F2(function(n, e) {
        return n.$ ? e : A2(O$, Lc(tj(n.a)), e);
    }), T2 = A2(Fu, LJ, fh(19)), S2 = F2(function(n, e) {
        return Mc(E([
            v("ecs", oX(n)),
            v("complements", oX(e))
        ]));
    }), I2 = function(n) {
        return A2(Fu, ij, A2(Fu, A2(st, F2(function(e, r) {
            return v(e, A2(Lc, A2(Fu, fh(n), oX), r));
        }), ij(dX)), Do));
    }, O2 = F2(function(n, e) {
        var r = e;
        return Mc(A2(ju, function(n) {
            return v(Ml(n), oX(A2(th, n, r)));
        }, A2(ks, function(e) {
            return !A2(tl, e, n);
        }, IV)));
    }), q2 = A2(Fu, mf, Ic), L2 = F3(function(n, e, r) {
        var t = r, u = A2(A0, n, K1(t)), a = A2(P2, n, t.S);
        return Do(E([
            v("id", A2(Lc, q2, e.mf)),
            v("name", A2(Lc, Ic, t.ai)),
            v("quantity", Rr(qc(t.D))),
            v("mass", Rr(_o(t.P))),
            v("score", Rr(A2(S2, A2(fh, 19, u), T2(a)))),
            v("impacts", Rr(A2(O2, E([
                19
            ]), u))),
            v("complements", Rr(A2(I2, 19, a)))
        ]));
    }), M2 = F3(function(n, e, r) {
        return A2(Co, ru, A3(st, L2(n), e.mu, hx(r.Q)));
    }), _2 = F2(function(n, e) {
        var r = eY(e), t = A2(Fu, _c(Zs), A2(Fu, A0(n), A2(Fu, fh(19), oX)));
        return Mc(E([
            v("materials", t(r.fn)),
            v("transform", t(r.fT)),
            v("assembly", t(r.q)),
            v("packaging", t(r.cm)),
            v("transports", t(r.af)),
            v("distribution", t(r.E)),
            v("usage", t(r.kh)),
            v("endOfLife", t(r._))
        ]));
    }), R2 = F2(function(n, e) {
        return n.$ ? e : A2(Rh, n.a, e);
    }), H2 = F4(function(n, e, r, t) {
        var u = function(n) {
            return oX(A2(R2, e, n));
        }, a = A2(fh, 19, LJ(qJ(t.Q))), i = A2(_V, n, r);
        return Mc(E([
            v("biodiversity", u(i.kF)),
            v("climate", u(i.kV)),
            v("health", u(i.l9)),
            v("resources", u(i.n7)),
            v("complements", u(a))
        ]));
    }), U2 = F3(function(n, e, r) {
        var t = MJ(r), u = A2(A0, e.aO, t), a = A2(P2, e.aO, qJ(r.Q));
        return E([
            v("productMass", _o(r.aT)),
            v("score", A2(S2, A2(fh, 19, u), T2(a))),
            v("impacts", A2(O2, E([
                19
            ]), u)),
            v("complements", A2(I2, 19, a)),
            v("subscores", A4(H2, n, e.aO, t, r)),
            v("stages", A2(_2, e.aO, r)),
            v("composition", A3(M2, e.aO, e, r))
        ]);
    }), z2 = F2(function(n, e) {
        var r = function(e) {
            return n.$ ? fX(e) : oX(A2(fh, n.a, e));
        };
        return Do(E([
            v("cropDiversity", A2(Lc, r, e.ag)),
            v("forest", A2(Lc, r, e.aa)),
            v("hedges", A2(Lc, r, e.ah)),
            v("microfibers", A2(Lc, r, e.aj)),
            v("outOfEuropeEOL", A2(Lc, r, e.ak)),
            v("permanentPasture", A2(Lc, r, e.al)),
            v("plotSize", A2(Lc, r, e.am))
        ]));
    }), D2 = function(n) {
        switch(n){
            case 0:
                return "assembly";
            case 1:
                return "material";
            case 2:
                return "transformation";
            default:
                return "transport";
        }
    }, N2 = F2(function(n, e) {
        var r = e;
        return Do(E([
            v("label", A2(Lc, Ic, r.ai)),
            v("stage", A2(Lc, A2(Fu, D2, Ic), r.au)),
            v("mass", Rr(_o(r.P))),
            v("materialType", A2(Lc, A2(Fu, fl, Ic), r.aE)),
            v("quantity", Rr(qc(r.D))),
            v("complementsImpacts", Rr(A2(z2, n, r.S))),
            v("impacts", Rr(n.$ ? fX(r.g) : oX(A2(fh, n.a, r.g)))),
            v("items", Rr(A2(Co, N2(n), r.mu)))
        ]));
    }), K2 = F2(function(n, e) {
        var r, t;
        return Mc(E([
            v("endOfLife", n.$ ? fX(e._) : oX(A2(fh, n.a, e._))),
            v("distribution", (t = e.E, Do(E([
                v("impacts", Rr(fX(t.g))),
                v("process", A2(Lc, A2(Fu, function(n) {
                    return n.mf;
                }, Fo), t.t)),
                v("volume", Rr(_o(t.eU)))
            ])))),
            v("production", A2(N2, n, e.Q)),
            v("transport", (r = e.af, Mc(E([
                v("toAssembly", lX(r.eD)),
                v("toDistribution", lX(r.eF))
            ])))),
            v("use", A2(Co, fX, e.bK))
        ]));
    }), G2 = F3(function(n, e, r) {
        return A2(VM, w, E([
            A2(KF, E([
                WM("card-body py-2")
            ]), E([
                A2(VF, w, E([
                    a_("Debug")
                ])),
                A2(VM, E([
                    WM("row g-2")
                ]), E([
                    A2(VM, E([
                        WM("col-6")
                    ]), E([
                        A2(T_, w, E([
                            a_("Results")
                        ])),
                        A2(U_, E([
                            WM("p-2 bg-light")
                        ]), E([
                            a_(A2(tt, 2, A2(K2, Rr(19), r)))
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-6")
                    ]), E([
                        A2(T_, w, E([
                            a_("API response")
                        ])),
                        A2(U_, E([
                            WM("p-2 bg-light")
                        ]), E([
                            a_(A2(tt, 2, Mc(A3(U2, n.C.cV, e, r))))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), W2 = F2(function(n, e) {
        var r = n.O, t = n.g1, u = n.as;
        return A2(VM, E([
            WM("d-flex flex-column")
        ]), E([
            A2(C2, {
                k_: n.k_,
                C: n.C,
                lq: n.lq,
                lu: n.lu,
                lv: A2(H0, n, "production"),
                lT: n.lT,
                b2: n.b2,
                O: n.O,
                mB: {
                    cB: n.mB.cB,
                    c2: n.mB.c2,
                    bC: n.mB.bC,
                    $7: n.mB.$7
                },
                m8: n.m8,
                nw: n.nw,
                nB: n.nB,
                g1: n.g1,
                n3: n.n3,
                as: n.as,
                ov: n.ov,
                pc: n.pc,
                pt: n.pt,
                pu: n.pu
            }, e.Q),
            zX(u) && !lf(t.mu) ? A2(VM, w, E([
                A2(OZ, E([
                    A2(VM, E([
                        WM("d-flex justify-content-end align-items-center gap-1")
                    ]), E([
                        a_("Transport"),
                        A2(d_, w, E([
                            D1,
                            D0,
                            D1
                        ]))
                    ]))
                ]), E([
                    A2(VM, E([
                        WM("d-flex gap-2")
                    ]), E([
                        A2(eB, r, e.af.eD.g),
                        A2(t2, n, "transport")
                    ]))
                ])),
                A2(z0, n, e)
            ])) : a_(""),
            n.k_ || lf(t.mu) ? a_("") : A2(c2, n, e),
            n.ld ? A3(G2, n, t, e) : a_("")
        ]));
    }), V2 = function(n) {
        var e = n.ac;
        if (1 === e.$) {
            var r = e.a;
            return A2(c1, Rr("Erreur de chargement du calculateur"), r);
        }
        return A2(W2, n, e.a);
    }, J2 = F2(function(n, e) {
        var r = g($E(e.Q), e.aT, A2(fh, 19, LJ(qJ(e.Q))));
        return A3(RV, n, r.c, A2(tj, r.b, r.a));
    }), B2 = F3(function(n, e, r) {
        return $(r, {
            cP: A2(O$, Lc(fh(r.cc.kf)), qJ(e.Q)),
            g6: A2(J2, n, e),
            ev: A2(nY, Lc(fh(r.cc.kf)), eY(e)),
            bI: MJ(e)
        });
    }), X2 = F2(function(n, e) {
        var r, t, u, a, i, c = n.h4, o = e.iA, f = bs(o), l = A2(Zx, o, n);
        return A2(VM, E([
            WM("row")
        ]), E([
            A2(VM, E([
                WM("col-lg-8 bg-white")
            ]), E([
                A2(BM, E([
                    WM("visually-hidden")
                ]), E([
                    a_("Simulateur ")
                ])),
                A2(VM, E([
                    WM("sticky-md-top bg-white pb-3")
                ]), E([
                    zZ({
                        k8: l,
                        lM: Xx,
                        lP: e.lP,
                        mb: Hr,
                        nq: A2(Fu, mq, RY),
                        od: {
                            lS: A2(pd, f, A2(jd, o, Hr)),
                            mJ: Rb(o),
                            oj: Hb(o)
                        }
                    }),
                    (t = {
                        nr: j0,
                        dp: n.C.dp,
                        g1: l,
                        as: o
                    }, u = t.nr, a = t.g1, i = A2(IE, function(n) {
                        return n.ai;
                    }, A2(iB, t.as, t.dp)), lf(i) || lf(a.mu) ? a_("") : A2(VM, E([
                        WM("d-flex flex-row align-items-center gap-2 my-3")
                    ]), E([
                        A2(mG, E([
                            bG("product-category"),
                            WM("form-label fw-bold text-nowrap")
                        ]), E([
                            a_("Cat\xe9gorie de produit")
                        ])),
                        A2(mK, E([
                            kF("product-category"),
                            WM("form-select"),
                            dK(function(n) {
                                return su(n) ? u(Hr) : A2(eh, u(Hr), A2(ss, A2(Fu, Rr, u), LS(n)));
                            })
                        ]), A2(Ur, A2(bK, E([
                            vK(""),
                            pK(s(a.aS, Hr))
                        ]), E([
                            a_("Autres")
                        ])), A2(ju, function(n) {
                            return A2(bK, E([
                                vK(qh(n.mf)),
                                pK(s(a.aS, Rr(n.mf)))
                            ]), E([
                                a_(n.ai)
                            ]));
                        }, i)))
                    ])))
                ])),
                A3(M0, c, f, l.aO),
                V2(A2(i1, n, e))
            ])),
            A2(VM, E([
                WM("col-lg-4 bg-white")
            ]), E([
                (r = A2(eh, Sx, e.ac), jQ({
                    ks: e.dU,
                    bv: e.bv,
                    bw: e.bw,
                    kY: p0,
                    k0: e.cQ,
                    k1: e.cR,
                    k2: e.a9,
                    k4: s0,
                    k6: l0,
                    la: Hr,
                    lm: d0,
                    lU: b0,
                    mh: lf(l.mu) ? Hr : Rr(A3(B2, n.C.cV, r, A5(qX, n, e.O, e.dN, Bi(uq), x0))),
                    mi: m0,
                    m8: uq,
                    aT: r.aT,
                    n5: v0,
                    og: g0,
                    as: f,
                    dv: e.O,
                    eu: n,
                    oL: h0,
                    oN: $0,
                    o5: A2(C0, l.aO, r),
                    o6: Rr(MJ(r)),
                    pg: k0,
                    pi: w0,
                    pj: y0,
                    pD: E0
                }))
            ]))
        ]));
    }), Q2 = F2(function(n, e) {
        return v("Simulateur", E([
            A2(JM, E([
                WM("Simulator pb-3")
            ]), E([
                A2(X2, n, e),
                A2(_c, a_(""), A2(Lc, A2(f0, n, e), ys(e.M)))
            ]))
        ]));
    }), Z2 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Y2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, n3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, e3 = fe("cite"), r3 = function(n) {
        var e = n.lN;
        return A2(JM, E([
            WM("pt-4 pb-5")
        ]), E([
            A2(VM, E([
                WM("px-5")
            ]), E([
                A2(C_, E([
                    WM("h1")
                ]), E([
                    a_("Calculez le co\xfbt environnemental de vos produits")
                ])),
                A2(VM, E([
                    WM("fs-5 mt-3 mb-5")
                ]), E([
                    A2(vF, w, "Ecobalyse permet de comprendre et d\u2019exprimer les impacts environnementaux des produits distribu\xe9s en France\n                     par le calcul d\u2019un co\xfbt en points d\u2019impact\u202F: **le co\xfbt environnemental**.\n                     D\xe9couvrez nos outils et notre p\xe9rim\xe8tre d\u2019action\u202F!")
                ])),
                A2(VM, E([
                    WM("d-flex flex-column flex-lg-row gap-3 mb-4")
                ]), A2(La, function(n) {
                    return n.a ? Rr(function(n) {
                        var e = n.ai, r = n.dA, t = n.cJ, u = n.di, a = n.dB;
                        return A2(YM, E([
                            i_("button"),
                            WM("btn btn-lg d-flex flex-column align-items-center justify-content-center"),
                            n_(E([
                                v("btn-primary", t),
                                v("btn-outline-primary", !t)
                            ])),
                            u_(n3(u)),
                            A2(ZM, "data-testid", a)
                        ]), E([
                            a_(e),
                            function() {
                                if (r.$) return a_("");
                                var n = r.a;
                                return A2(e3, E([
                                    WM("fw-normal fs-7 d-block")
                                ]), E([
                                    a_(n)
                                ]));
                            }()
                        ]));
                    }(n.b)) : Hr;
                }, E([
                    v(!0, {
                        cJ: !0,
                        ai: "Calculer l\u2019impact d\u2019un v\xeatement",
                        di: Z2(gF + "#/textile/simulator"),
                        dA: Rr("Version r\xe9glementaire"),
                        dB: "textile-callout-button"
                    }),
                    v(e.l1, {
                        cJ: !1,
                        ai: "Calculer l\u2019impact de l\u2019alimentation",
                        di: Y2(hd),
                        dA: Rr("M\xe9thodologie stabilis\xe9e"),
                        dB: "food-callout-button"
                    }),
                    v(e.nj, {
                        cJ: !1,
                        ai: "Calculer l\u2019impact d\u2019un objet",
                        di: Y2(Hb(1)),
                        dA: Rr("Simulateur en construction"),
                        dB: "object-callout-button"
                    }),
                    v(e.f_, {
                        cJ: !1,
                        ai: "Calculer l\u2019impact d\u2019un v\xe9hicule",
                        di: Y2(Hb(2)),
                        dA: Rr("Simulateur en construction"),
                        dB: "veli-callout-button"
                    })
                ])))
            ]))
        ]));
    }, t3 = A2(JM, w, E([
        A2(VM, E([
            WM("d-flex flex-column gap-2 p-0 px-md-5")
        ]), E([
            A2(C_, E([
                WM("h3")
            ]), E([
                a_("Afficher le co\xfbt environnemental")
            ])),
            A2(vF, w, "Le co\xfbt environnemental peut \xeatre utilis\xe9 pour comprendre, informer, enrichir un bilan carbone\nou pour diff\xe9rentes politiques publiques (march\xe9s publics, eco-modulation\u2026)\n\nL\u2019affichage du co\xfbt environnemental d\u2019un produit permet d\u2019**informer le consommateur**. Depuis la loi Climat et\nR\xe9silience de 2021, des travaux sont engag\xe9s pour permettre cet affichage. Ils portent sur les v\xeatements, les\nproduits alimentaires ou encore l\u2019ameublement. Pour plus d\u2019informations, vous pouvez consulter\u202F:\n\n- le [site de l\u2019ADEME](https://affichage-environnemental.ademe.fr)\n- le site du [minist\xe8re en charge de l\u2019\xe9cologie](https://www.ecologie.gouv.fr/politiques-publiques/affichage-environnemental-v\xeatements)"),
            A2(VM, E([
                WM("d-flex flex-column flex-lg-row gap-3")
            ]), E([
                A2(d_, E([
                    WM("home-illustration")
                ]), E([
                    A2(O_, E([
                        z_("img/etiquette-exemple.png"),
                        h_("Exemple d'\xe9tiquetage environnemental r\xe9glementaire de 930 points d'impact")
                    ]), w)
                ])),
                A2(VM, E([
                    WM("row g-3")
                ]), E([
                    A2(VM, E([
                        WM("col-lg-6 d-flex flex-column justify-content-between gap-2 h-100")
                    ]), E([
                        A2(vF, w, "Pour les v\xeatements, **un cadre r\xe8glementaire complet a \xe9t\xe9 publi\xe9 le 9 septembre 2025**.\n                             Il encadre l\u2019affichage volontaire du co\xfbt environnemental des v\xeatements. Une m\xe9thodologie\n                             de calcul r\xe8glementaire est ainsi arr\xeat\xe9e, la **v7.0.0**."),
                        A2(YM, E([
                            WM("btn btn-primary"),
                            u_(n3(Z2(gF + "#/textile/simulator")))
                        ]), E([
                            a_("Utiliser la version r\xe9glementaire 7.0.0")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-lg-6 d-flex flex-column justify-content-between gap-3 h-100")
                    ]), E([
                        A2(vF, w, "Pour afficher le co\xfbt environnemental sur vos produits textiles, il est n\xe9cessaire de **d\xe9clarer leur co\xfbt**\n                             sur un portail d\xe9di\xe9\u202F!"),
                        A2(MF, E([
                            WM("btn btn-outline-primary"),
                            XM("https://affichage-environnemental.ecobalyse.beta.gouv.fr/declarations")
                        ]), E([
                            a_("Acc\xe9der au portail de d\xe9claration")
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ])), u3 = s_("material"), a3 = A2(JM, w, E([
        A2(VM, E([
            WM("row px-md-5 gap-5 gap-md-0")
        ]), E([
            A2(VM, E([
                WM("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), E([
                A2(e_, E([
                    WM("h4 d-flex align-items-baseline gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fs-5")
                    ]), E([
                        mJ
                    ])),
                    a_("Les dessous du co\xfbt environnemental")
                ])),
                A2(vF, E([
                    WM("flex-fill")
                ]), A3(Xb, "{url_pef}", "https://eplca.jrc.ec.europa.eu/EnvironmentalFootprint.html", A3(Xb, "{url_acv}", "https://fr.wikipedia.org/wiki/Analyse_du_cycle_de_vie", 'Le co\xfbt environnemental s\u2019appuie sur la m\xe9thodologie [ACV]({url_acv} "Analyse en Cycle de Vie")\n                     du [PEF]({url_pef} "Product Environmental Footprint")\n                     **compl\xe9t\xe9e sur les aspects qu\u2019elle ne couvre pas encore**. Il est issu du travail des pouvoirs publics\n                     en s\u2019appuyant sur des **experts** et parties prenantes mobilis\xe9s lors de concertations.'))),
                A2(VM, E([
                    WM("d-flex mt-3 gap-3")
                ]), E([
                    A2(MF, E([
                        WM("btn btn-primary text-truncate"),
                        XM(CF)
                    ]), E([
                        a_("Parcourir la documentation m\xe9thodologique")
                    ]))
                ]))
            ])),
            A2(VM, E([
                WM("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), E([
                A2(e_, E([
                    WM("h4 d-flex align-items-baseline gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fs-5")
                    ]), E([
                        u3
                    ])),
                    a_("Impacts et donn\xe9es d\xe9taill\xe9es")
                ])),
                A2(vF, E([
                    WM("flex-fill")
                ]), "Acc\xe9dez aux **impacts environnementaux d\xe9taill\xe9s** de vos simulations en cr\xe9ant un compte utilisateur\n                     et \xe0 l'ensemble des mod\xe9lisations et **donn\xe9es sources** en parcourant l\u2019explorateur."),
                A2(VM, E([
                    WM("d-flex mt-3 gap-3")
                ]), E([
                    A2(MF, E([
                        WM("btn btn-primary"),
                        XM(MA(bd))
                    ]), E([
                        a_("Cr\xe9er un compte Ecobalyse")
                    ])),
                    A2(YM, E([
                        WM("btn btn-outline-primary"),
                        u_(n3(Y2(A2(pd, ms, Ed(Hr)))))
                    ]), E([
                        a_("Explorer les donn\xe9es")
                    ]))
                ]))
            ]))
        ]))
    ])), i3 = s_("plug"), c3 = A2(JM, w, E([
        A2(VM, E([
            WM("row px-md-5 gap-5 gap-md-0")
        ]), E([
            A2(VM, E([
                WM("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), E([
                A2(e_, E([
                    WM("h4 d-flex align-items-baseline gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fs-5")
                    ]), E([
                        i3
                    ])),
                    a_("L'API Ecobalyse")
                ])),
                A2(vF, w, A3(Xb, "{api_url}", MA(sd), "[L\u2019API HTTP Ecobalyse]({api_url}) permet de calculer les impacts environnementaux des diff\xe9rents produits.\n             Elle est exp\xe9rimentale et donc ne garantit pas de continuit\xe9 de service \xe0 ce stade.")),
                A2(vF, w, A3(Xb, "{api_faq_url}", MA(md("api-faq")), "Des questions\u202F? Consultez notre [\u202FFAQ d\xe9di\xe9e \xe0 l\u2019API\u202F]({api_faq_url})."))
            ])),
            A2(VM, E([
                WM("col-md-6 d-flex flex-column justify-content-between gap-2")
            ]), E([
                A2(e_, E([
                    WM("h4 d-flex align-items-baseline gap-2")
                ]), E([
                    A2(d_, E([
                        WM("fs-5")
                    ]), E([
                        yJ
                    ])),
                    a_("Des questions\xa0?")
                ])),
                A2(vF, E([
                    WM("flex-fill")
                ]), "Ecobalyse est un outil **ouvert et gratuit**. Vos retours sur la m\xe9thode ou sur notre outil nous sont pr\xe9cieux."),
                A2(VM, E([
                    WM("d-flex flex-column flex-xl-row mt-3 gap-3")
                ]), E([
                    A2(MF, E([
                        WM("btn btn-primary text-truncate"),
                        XM(EF)
                    ]), E([
                        a_("Rejoindre la communaut\xe9")
                    ])),
                    A2(MF, E([
                        WM("btn btn-outline-primary text-truncate"),
                        XM("https://fabrique-numerique.gitbook.io/ecobalyse/textile/nous-contacter")
                    ]), E([
                        a_("Contacter l\u2019\xe9quipe \xc9cobalyse")
                    ]))
                ]))
            ]))
        ]))
    ])), o3 = fe("iframe"), f3 = F2(function(n) {
        var e = n.nI;
        return v("Statistiques", E([
            A2(JM, E([
                WM("pb-5")
            ]), E([
                A2(BM, E([
                    WM("mb-3")
                ]), E([
                    a_("Statistiques")
                ])),
                A2(VM, E([
                    WM("border rounded p-2")
                ]), function() {
                    var n = e.iJ;
                    if (n.$) return E([
                        A2(VM, E([
                            WM("alert alert-info")
                        ]), E([
                            a_("\u26A0\uFE0F Le service de statistiques n\u2019est pas configur\xe9, affichage impossible.")
                        ]))
                    ]);
                    var r = n.a;
                    return E([
                        A2(o3, E([
                            A2(ZM, "plausible-embed", ""),
                            z_("https://" + r + "/share/ecobalyse.beta.gouv.fr?auth=x5YPtaLjZQymaV_F4p8NF&embed=true&theme=light"),
                            A2(ZM, "scrolling", "no"),
                            A2(ZM, "frameborder", "0"),
                            A2(ZM, "loading", "lazy"),
                            A2(OF, "width", "1px"),
                            A2(OF, "min-width", "100%"),
                            A2(OF, "height", "2000px")
                        ]), E([
                            A2(VM, E([
                                WM("alert alert-info")
                            ]), E([
                                A2(vF, w, "Votre adblocker est activ\xe9. Veuillez le d\xe9sactiver ou whitelister *https://" + r + "* pour voir les statistiques.")
                            ]))
                        ])),
                        A3(tG, "script", E([
                            A2(ZM, "async", ""),
                            z_(r + "/js/embed.host.js")
                        ]), w)
                    ]);
                }())
            ]))
        ]));
    }), s3 = {
        $: 0
    }, l3 = {
        $: 9
    }, d3 = {
        $: 11
    }, b3 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, m3 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, p3 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, v3 = {
        $: 23
    }, g3 = {
        $: 24
    }, h3 = function(n) {
        return {
            $: 27,
            a: n
        };
    }, $3 = F2(function(n, e) {
        return {
            $: 31,
            a: n,
            b: e
        };
    }), x3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, k3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w3 = {
        $: 3
    }, y3 = {
        $: 4
    }, j3 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, E3 = {
        $: 16
    }, C3 = {
        $: 19
    }, P3 = {
        $: 21
    }, T3 = function(n) {
        return {
            $: 26,
            a: n
        };
    }, S3 = function(n) {
        return {
            $: 28,
            a: n
        };
    }, I3 = function(n) {
        return {
            $: 29,
            a: n
        };
    }, O3 = function(n) {
        return {
            $: 30,
            a: n
        };
    }, q3 = function(n) {
        return {
            $: 35,
            a: n
        };
    }, L3 = F2(function(n, e) {
        return {
            $: 49,
            a: n,
            b: e
        };
    }), M3 = function(n) {
        return bh(E([
            n.g,
            n.eJ.g
        ]));
    }, _3 = F3(function(n, e, r) {
        var t, u, a = (u = (t = e).ac, A2(tj, Zw(t.aO), bh(Nr(A2($y, M3, A2(Py, function(n) {
            return n.gp;
        }, u))))));
        return $(r, {
            cP: e.S,
            g6: A3(RV, n, cj(e.S), a),
            ev: A2(uY, r.cc.kf, e),
            bI: a
        });
    }), R3 = function(n) {
        return {
            $: 18,
            a: n
        };
    }, H3 = {
        $: 20
    }, U3 = F2(function(n, e) {
        return {
            $: 52,
            a: n,
            b: e
        };
    }), z3 = function(n) {
        return {
            $: 53,
            a: n
        };
    }, D3 = function(n) {
        return {
            $: 36,
            a: n
        };
    }, N3 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, K3 = function(n) {
        return {
            $: 17,
            a: n
        };
    }, G3 = function(n) {
        return {
            $: 32,
            a: n
        };
    }, W3 = function(n) {
        return {
            $: 33,
            a: n
        };
    }, V3 = function(n) {
        return {
            $: 34,
            a: n
        };
    }, J3 = function(n) {
        return {
            $: 37,
            a: n
        };
    }, B3 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, X3 = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Q3 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Z3 = function(n) {
        return {
            $: 41,
            a: n
        };
    }, Y3 = F2(function(n, e) {
        return {
            $: 43,
            a: n,
            b: e
        };
    }), n5 = F2(function(n, e) {
        return {
            $: 44,
            a: n,
            b: e
        };
    }), e5 = function(n) {
        return {
            $: 48,
            a: n
        };
    }, r5 = F2(function(n, e) {
        return {
            $: 50,
            a: n,
            b: e
        };
    }), t5 = function(n) {
        return {
            $: 51,
            a: n
        };
    }, u5 = function(n) {
        return {
            $: 54,
            a: n
        };
    }, a5 = o, i5 = F2(function(n, e) {
        var r = e.c, t = e.d, u = {
            V: w,
            N: 0,
            R: A3(a5, n, Oy(e.a), t)
        }, a = F2(function(e, r) {
            if (e.$) {
                var t = Lt(A3(a5, n, r.N * Et, e.a));
                return {
                    V: A2(Ur, t, r.V),
                    N: r.N + 1,
                    R: r.R
                };
            }
            return A3(nj, a, r, e.a);
        });
        return A2(Vt, !0, A3(nj, a, u, r));
    }), c5 = function(n) {
        return !n.gp || 4 === n.ai && s(n.i.cM, TE);
    }, o5 = function(n) {
        return jf(zf(n)) ? A2(uA, 0, n) + "% de transport a\xe9rien" : "Aucun transport a\xe9rien";
    }, f5 = function(n) {
        var e = n.hO, r = n.mf, t = n.ai;
        return A2(VM, E([
            WM("RangeSlider row")
        ]), E([
            A2(VM, E([
                WM("col-xxl-6")
            ]), E([
                A2(mG, E([
                    bG(r),
                    WM("form-label text-nowrap fs-7 mb-0")
                ]), E([
                    a_(t)
                ]))
            ])),
            A2(VM, E([
                WM("col-xxl-6")
            ]), E([
                I0(A2(Ur, kF(r), e))
            ]))
        ]));
    }, s5 = function(n) {
        return f5({
            hO: E([
                dK(A2(Fu, gp, A2(Fu, Qa(A2(Fu, Xs, Ld)), n.pd))),
                nZ(ut(n.m_)),
                S0(ut(n.mX)),
                eZ("1"),
                vK(Bs(zf(n.eP))),
                E_(n.bW)
            ]),
            mf: n.mf,
            ai: n.oZ(n.eP)
        });
    }, l5 = function(n) {
        var e = n.k7, r = n.pe;
        return A2(d_, E([
            V_("Part de transport a\xe9rien pour le transport entre la confection et l'entrep\xf4t en France.")
        ]), E([
            s5({
                bW: c5(e),
                mf: "airTransportRatio",
                mX: 100,
                m_: 0,
                oZ: o5,
                pd: r,
                eP: e.cE
            })
        ]));
    }, d5 = function(n) {
        var e = n.hO, r = n.bR, t = n.nr, u = n.as, a = n.jT;
        return A2(mK, A2(Ur, WM("form-select"), A2(Ur, dK(A2(Fu, vj, t)), e)), A2(ju, function(n) {
            var e = n.cM, r = n.ei;
            return A2(bK, E([
                pK(s(a, e)),
                vK(e)
            ]), E([
                a_(r)
            ]));
        }, A2(IE, function(n) {
            return n.ei;
        }, A2(Nh, E([
            u
        ]), r))));
    }, b5 = function(n) {
        var e = n.k7, r = n.C, t = n.pk;
        return A2(VM, w, E([
            e.lJ ? d5({
                hO: E([
                    WM("form-select"),
                    E_(!e.gp),
                    dK(A2(Fu, vj, t(e.ai)))
                ]),
                bR: r.bR,
                nr: t(e.ai),
                as: ms,
                jT: e.i.cM
            }) : A2(VM, E([
                WM("fs-6 text-muted d-flex align-items-center gap-2 ")
            ]), E([
                A2(d_, E([
                    WM("cursor-help"),
                    V_("Le pays n'est pas modifiable \xe0 cette \xe9tape")
                ]), E([
                    N0
                ])),
                a_(e.i.ei)
            ]))
        ]));
    }, m5 = function(n) {
        var e = n.gk, r = n.pG;
        return A2(xG, E([
            WM("d-flex align-items-center fs-7 cursor-help"),
            V_("Nombre d\xe9pendant de la cat\xe9gorie de v\xeatement et du coefficient de durabilit\xe9")
        ]), E([
            A2(d_, E([
                WM("pe-1 text-muted")
            ]), E([
                l_
            ])),
            LB(e),
            a_("\xa0port\xe9s, "),
            a_(ut(r)),
            a_(" cycle" + (r > 1 ? "s" : "") + " d'entretien")
        ]));
    }, p5 = function(n) {
        return A2(mZ, E([
            XM(hV(n)),
            LF("_blank")
        ]), E([
            yJ
        ]));
    }, v5 = F2(function(n, e) {
        return n ? e : a_("");
    }), g5 = F2(function(n, e) {
        return A2(v5, 4 === n.k7.ai, A2(L_, E([
            WM("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), s(e, 0) ? E([
            a_("Aucun stock dormant.")
        ]) : E([
            a_("Dont stocks dormants\xa0:\xa0"),
            a_(rA(e)),
            p5(25)
        ])));
    }), h5 = function(n) {
        var e = n.k7, r = n.A, t = n.pB;
        return A2(VM, E([
            WM("d-flex justify-content-between align-items-center fs-7")
        ]), E([
            A2(mG, E([
                WM("text-truncate w-33"),
                bG("ennobling-printing"),
                V_("Impression")
            ]), E([
                a_("Impression")
            ])),
            A2(VM, E([
                WM("d-flex justify-content-between align-items-center gap-1 w-75")
            ]), E([
                A2(mK, E([
                    kF("ennobling-printing"),
                    WM("form-select form-select-sm"),
                    A2(OF, "flex", "2"),
                    E_(!e.gp),
                    dK(function(n) {
                        return t(function() {
                            var e = Jm(n);
                            if (1 === e.$) return Hr;
                            var t = e.a, u = r.dn;
                            return Rr(u.$ ? {
                                gF: t,
                                nT: .2
                            } : $(u.a, {
                                gF: t
                            }));
                        }());
                    })
                ]), A2(Ur, A2(bK, E([
                    pK(s(r.dn, Hr))
                ]), E([
                    a_("Aucune")
                ])), A2(ju, function(n) {
                    return A2(bK, E([
                        vK(Yo(n)),
                        pK(s(A2(Lc, function(n) {
                            return n.gF;
                        }, r.dn), Rr(n)))
                    ]), E([
                        a_(iA(n))
                    ]));
                }, E([
                    0,
                    1
                ])))),
                function() {
                    var n = r.dn;
                    if (n.$) return a_("");
                    var e = n.a.nT;
                    return A2(mK, E([
                        WM("form-select form-select-sm"),
                        A2(OF, "flex", "1"),
                        E_(s(r.dn, Hr)),
                        dK(function(n) {
                            var e = gp(n);
                            if (e.$) return t(Hr);
                            var u = e.a;
                            return t(A2(Lc, function(n) {
                                return $(n, {
                                    nT: A2(_c, 0, Ld(Xs(u)))
                                });
                            }, r.dn));
                        })
                    ]), A2(ju, function(n) {
                        return A2(bK, E([
                            vK(Bs(n)),
                            pK(s(Zr(e), Xs(n)))
                        ]), E([
                            a_(Bs(n) + "%")
                        ]));
                    }, E([
                        80,
                        50,
                        20,
                        5,
                        1
                    ])));
                }()
            ]))
        ]));
    }, $5 = function(n) {
        var e, r, t, u, a;
        return A2(VM, E([
            WM("d-flex flex-column gap-1")
        ]), E([
            A2(v5, n.ox, (e = n, r = e.k7, t = e.C, u = e.A, a = e.pm, A2(VM, E([
                WM("d-flex justify-content-between align-items-center fs-7")
            ]), E([
                A2(mG, E([
                    WM("text-truncate w-33"),
                    bG("dyeing-process-type"),
                    V_("Type de teinture")
                ]), E([
                    a_("Type de teinture")
                ])),
                A2(mK, E([
                    kF("dyeing-process-type"),
                    WM("form-select form-select-sm w-75"),
                    E_(!r.gp),
                    dK(A2(Fu, Dm, A2(Fu, eh(0), a)))
                ]), A2(ju, function(n) {
                    return A2(bK, E([
                        vK(Vo(n)),
                        pK(s(n, A2(_c, 0, u.cZ)))
                    ]), E([
                        a_(Wb(A2(vy, t.oT.pM, Rr(n))))
                    ]));
                }, E([
                    2,
                    1,
                    0
                ])))
            ])))),
            h5(n)
        ]));
    }, x5 = F3(function(n, e, r) {
        var t, u, a, i = e.A, c = e.dv;
        return A2(v5, 2 === r.ai, (t = function() {
            var e = r.dn;
            if (e.$) return Zs;
            var t = e.a.nT;
            return A4(Fj, r.g, {
                hL: r.i.hL,
                nN: A2(Dj, e.a.gF, n.oT.pM).nN,
                hf: A2(_c, i.aS.hf, i.hf)
            }, t, r.nE);
        }(), u = bh(A2(ju, function(e) {
            var t = e.aH;
            return A4(py, r.g, {
                hL: r.i.hL,
                lF: my(e.U.jd) ? n.oT.pM.lE : n.oT.pM.lA
            }, r.nE, t);
        }, i.fn)), a = E([
            v("Pr\xe9-traitements", r.nL.o7),
            v("Teinture", u),
            v("Impression", t)
        ]), A2(L_, E([
            WM("list-group-item text-muted")
        ]), E([
            A2(KF, w, E([
                A2(VF, w, E([
                    A2(d_, w, E([
                        a_("Dont inventaires enrichis\xa0:")
                    ])),
                    A2(d_, E([
                        WM("text-end ImpactDisplay text-black-50 fs-7")
                    ]), E([
                        a_("\xa0(+\xa0"),
                        A2(eB, c, bh(A2(ju, Gh, a))),
                        a_(")"),
                        p5(18)
                    ]))
                ])),
                A2(VM, w, A2(ju, function(n) {
                    var e = n.b;
                    return A2(VM, w, E([
                        a_(n.a + "\xa0: "),
                        A3(lW, 2, "Pts", A2(fh, 19, e))
                    ]));
                }, a))
            ]))
        ]))));
    }), k5 = E([
        3,
        1,
        2,
        0,
        4,
        5
    ]), w5 = function(n) {
        var e = n.k7, r = n.A, t = n.pq;
        return A2(L_, E([
            WM("list-group-item d-flex align-items-center gap-2")
        ]), E([
            A2(mG, E([
                WM("text-nowrap w-25"),
                bG("fabric-process")
            ]), E([
                a_("Proc\xe9d\xe9")
            ])),
            A2(mK, E([
                kF("fabric-process"),
                WM("form-select form-select-sm w-75"),
                E_(!e.gp),
                dK(A2(Fu, Fm, A2(Fu, eh(3), t)))
            ]), A2(ju, function(n) {
                var e;
                return A2(bK, E([
                    vK(Bo(n)),
                    pK((e = r.b1, s(n, e.$ ? r.aS.iv : e.a)))
                ]), E([
                    a_(cA(n))
                ]));
            }, k5))
        ]));
    }, y5 = function(n) {
        var e = n.A, r = n.o0;
        return A2(mG, E([
            WM("form-check form-switch form-check-label fs-7 pt-1 text-truncate"),
            V_("D\xe9lavage")
        ]), E([
            A2(q_, E([
                i_("checkbox"),
                WM("form-check-input no-outline"),
                w_(A2(_c, !1, e.c6)),
                gG(r)
            ]), w),
            s(e.c6, Rr(!0)) ? a_("D\xe9lavage activ\xe9") : a_("D\xe9lavage d\xe9sactiv\xe9")
        ]));
    }, j5 = F2(function(n, e) {
        return s(n, A2(_c, e.aS.iv, e.b1));
    }), E5 = function(n) {
        var e = n.k7, r = n.A, t = n.pv, u = A3(hj, r.aS.gH.ge, r.mR, r.b1);
        return A2(L_, E([
            WM("list-group-item d-flex align-items-center gap-2")
        ]), E([
            A2(mG, E([
                WM("text-nowrap w-25"),
                bG("making-complexity")
            ]), E([
                a_("Complexit\xe9")
            ])),
            p5(24),
            A2(j5, 2, r) ? a_("Non applicable") : A2(mK, E([
                kF("making-complexity"),
                WM("form-select form-select-sm w-75"),
                E_(!e.gp),
                dK(A2(Fu, Gm, A2(Fu, eh(r.aS.gH.ge), t)))
            ]), A2(ju, function(n) {
                return A2(bK, E([
                    vK(Of(n)),
                    pK(s(n, u))
                ]), E([
                    a_(tA(n))
                ]));
            }, E([
                4,
                0,
                2,
                1,
                5
            ])))
        ]));
    }, C5 = function(n) {
        return s(n, 0) ? "Aucun stock dormant" : A2(uA, 0, n) + "% de stocks dormants";
    }, P5 = function(n) {
        var e = n.k7, r = n.pw;
        return A2(v5, n.ox, A2(d_, E([
            V_("Taux moyen de stocks dormants (v\xeatements non vendus + produits semi-finis non utilis\xe9s) sur l\u2019ensemble de la cha\xeene de valeur")
        ]), E([
            s5({
                bW: !e.gp,
                mf: "makingDeadStock",
                mX: jf(zf(.3)),
                m_: jf(zf(0)),
                oZ: C5,
                pd: r,
                eP: A2(_c, jj, e.dj)
            })
        ])));
    }, T5 = function(n) {
        return s(n, 0) ? "Aucune perte en confection" : A2(uA, 0, n) + "% de pertes";
    }, S5 = function(n) {
        var e = n.k7, r = n.A, t = n.px;
        return A2(d_, E([
            V_("Taux moyen de pertes en confection")
        ]), E([
            s5({
                bW: !e.gp,
                mf: "makingWaste",
                mX: jf(zf(.4)),
                m_: jf(zf(0)),
                oZ: T5,
                pd: t,
                eP: A3(Tj, r.aS.gH.jg, r.dk, r.b1)
            })
        ]));
    }, I5 = function(n) {
        if (n.$) return a_("");
        var e = n.a;
        return A2(L_, E([
            WM("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), E([
            a_("Duitage\xa0:\xa0"),
            A3(lW, 0, "duites.m", e)
        ]));
    }, O5 = function(n) {
        switch(n){
            case 0:
                return "Filature conventionnelle";
            case 1:
                return "Filage";
            default:
                return "Filature non conventionnelle";
        }
    }, q5 = function(n) {
        var e = n.k7, r = n.A, t = n.pz;
        return A2(L_, E([
            WM("list-group-item d-flex align-items-center gap-2")
        ]), E([
            A2(VM, E([
                WM("d-flex flex-column gap-1 w-100")
            ]), A2(ju, function(n) {
                var r = n.U, u = n.dz;
                return A2(VM, E([
                    WM("d-flex justify-content-between align-items-center fs-7")
                ]), E([
                    A2(mG, E([
                        bG("spinning-for-" + Oj(r.mf)),
                        WM("text-truncate w-25")
                    ]), E([
                        a_(r.ei)
                    ])),
                    function() {
                        var n = E(3 === r.jd ? [
                            1
                        ] : [
                            0,
                            2
                        ]);
                        if (n.b && !n.b.b) {
                            var a = n.a;
                            return A2(d_, E([
                                WM(" w-75")
                            ]), E([
                                a_(O5(a))
                            ]));
                        }
                        var i = n;
                        return A2(mK, E([
                            WM("form-select form-select-sm w-75"),
                            kF("spinning-for-" + Oj(r.mf)),
                            E_(!e.gp),
                            dK(A2(Fu, ip, A2(Fu, eh(Wj(r.jd)), t(r))))
                        ]), A2(ju, function(n) {
                            return A2(bK, E([
                                vK(gf(n)),
                                pK(s(Rr(n), u))
                            ]), E([
                                a_(O5(n))
                            ]));
                        }, i));
                    }()
                ]));
            }, r.fn))
        ]));
    }, L5 = F2(function(n, e) {
        var r = e.dc;
        return A2(Fy, A2(_c, n.aS.hf, n.hf), r);
    }), M5 = F2(function(n, e) {
        var r = e.nE;
        return A2(Fy, A2(_c, n.aS.hf, n.hf), r);
    }), _5 = F2(function(n, e) {
        var r = 3 === e.ai ? Rr(v("sortante", A2(M5, n, e))) : 2 === e.ai ? Rr(v("entrante", A2(L5, n, e))) : Hr;
        if (r.$) return a_("");
        var t = r.a, u = t.a, a = t.b;
        return A2(L_, E([
            WM("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), E([
            A2(d_, w, E([
                a_("Surface \xe9toffe (" + u + ")\xa0:")
            ])),
            A2(d_, w, E([
                vW(a)
            ]))
        ]));
    }), R5 = mp(500), H5 = mp(80), U5 = function(n) {
        return "Grammage\xa0: " + ut(Ef(n)) + "\u202Fg/m\xb2";
    }, z5 = function(n) {
        var e, r = n.k7, t = n.A, u = n.pE;
        return A2(VM, E([
            WM("mt-2"),
            V_("Le grammage de l'\xe9toffe, exprim\xe9 en g/m\xb2, repr\xe9sente sa masse surfacique.")
        ]), E([
            (e = {
                bW: !r.gp,
                mf: "surface-density",
                oZ: U5,
                pd: u,
                eP: A2(_c, t.aS.hf, r.hf)
            }, f5({
                hO: E([
                    dK(A2(Fu, du, A2(Fu, Lc(mp), e.pd))),
                    nZ(ut(Ef(H5))),
                    S0(ut(Ef(R5))),
                    eZ("1"),
                    vK(ut(Ef(e.eP))),
                    E_(e.bW)
                ]),
                mf: e.mf,
                ai: e.oZ(e.eP)
            }))
        ]));
    }, D5 = zy(80), N5 = zy(10), K5 = function(n) {
        return jf(n);
    }, G5 = function(n) {
        if (n.$) return a_("");
        var e = n.a;
        return A2(L_, E([
            WM("list-group-item text-muted")
        ]), E([
            A2(d_, E([
                WM("d-flex justify-content-center gap-2")
            ]), E([
                a_("Densit\xe9 de fils (approx.)\xa0:\xa0"),
                A3(lW, 0, "fils/cm", e)
            ])),
            0 > m(jf(e), K5(N5)) ? a_("\u26A0\uFE0F la densit\xe9 de fils semble tr\xe8s faible") : m(jf(e), K5(D5)) > 0 ? a_("\u26A0\uFE0F la densit\xe9 de fils semble tr\xe8s \xe9lev\xe9e") : a_("")
        ]));
    }, W5 = function(n) {
        if (n.$) return a_("");
        var e = n.a;
        return A2(L_, E([
            WM("list-group-item text-truncate"),
            V_(e),
            A2(OF, "cursor", "help")
        ]), E([
            a_(e)
        ]));
    }, V5 = F2(function(n, e) {
        var r = n.k7;
        return A2(v5, 4 === r.ai || 3 === r.ai, A2(L_, E([
            WM("list-group-item text-muted d-flex justify-content-center gap-2")
        ]), s(e, 0) ? E([
            a_("Aucune perte en " + (3 === r.ai ? "tissage/tricotage" : "confection") + ".")
        ]) : E([
            a_("Pertes\xa0:\xa0"),
            a_(rA(e)),
            p5(3 === r.ai ? 21 : 26)
        ])));
    }), J5 = $p(200), B5 = $p(9), X5 = function(n) {
        return "Titrage\xa0: " + Bs(Tf(n)) + "\u202FNm (" + function(n) {
            return A2(zw, 2, function(n) {
                return Ho(A2(Ny, n, 1e4));
            }(n)) + "\u202FDtex";
        }(n) + ")";
    }, Q5 = function(n) {
        var e, r = n.k7, t = n.A, u = n.pF;
        return A2(d_, E([
            V_("Le titrage indique la grosseur d\u2019un fil textile")
        ]), E([
            (e = {
                bW: !r.gp,
                mf: "yarnSize",
                oZ: X5,
                pd: u,
                eP: A2(_c, t.aS.pR, r.pR)
            }, f5({
                hO: E([
                    dK(A2(Fu, gp, A2(Fu, Lc($p), e.pd))),
                    nZ(Bs(Tf(B5))),
                    S0(Bs(Tf(J5))),
                    eZ("1"),
                    vK(Bs(Tf(e.eP))),
                    E_(e.bW)
                ]),
                mf: e.mf,
                ai: e.oZ(e.eP)
            }))
        ]));
    }, Z5 = function(n) {
        var e, r = n.C, t = n.A, u = n.dv, a = n.k7, i = B_(E([
            WM("StageBody list-group list-group-flush fs-7 border-bottom-0"),
            n_(E([
                v("disabled", !a.gp)
            ]))
        ]));
        return A2(VM, E([
            WM("card-group")
        ]), E([
            A2(VM, E([
                WM("card border-start-0 border-top-0 border-bottom-0")
            ]), E([
                i(E([
                    A2(L_, E([
                        WM("list-group-item")
                    ]), E([
                        b5(n)
                    ])),
                    W5(A2(Lc, rt("Elec : "), a.aF.ba)),
                    W5(A2(Lc, rt("Chaleur : "), a.aF.dZ)),
                    W5(a.aF.E),
                    W5(a.aF.fX),
                    W5(a.aF.fY),
                    W5(a.aF.nF),
                    W5(a.aF._),
                    A2(v5, 6 === a.ai, q5(n)),
                    A2(v5, 3 === a.ai, w5(n)),
                    A2(v5, 4 === a.ai, E5(n)),
                    A2(v5, s(t.c6, Rr(!0)), W5(a.aF.c6))
                ])),
                A2(B_, E([
                    WM("StageBody p-0 list-group list-group-flush border-bottom-0 border-top"),
                    n_(E([
                        v("disabled", !a.gp)
                    ]))
                ]), A2(ju, function(n) {
                    return A2(L_, E([
                        WM("list-group-item fs-7")
                    ]), E([
                        n
                    ]));
                }, function() {
                    switch(a.ai){
                        case 2:
                            return E([
                                (e = a.nL, r = e.bg, A2(d_, w, E([
                                    a_("Pr\xe9-traitement" + (ft(r) > 1 ? "s" : "") + "\xa0: "),
                                    lf(r) ? a_("Aucun") : a_(A2(at, ", ", A2(ju, Wb, r)))
                                ]))),
                                $5(n),
                                A2(VM, E([
                                    WM("mt-2")
                                ]), E([
                                    a_("Finition\xa0: appr\xeat chimique")
                                ]))
                            ]);
                        case 3:
                            return E([
                                z5(n)
                            ]);
                        case 4:
                            return E([
                                S5(n),
                                P5(n),
                                l5(n),
                                y5(n)
                            ]);
                        case 6:
                            return E([
                                Q5(n)
                            ]);
                        case 7:
                            return E([
                                m5(n)
                            ]);
                        default:
                            return w;
                    }
                    var e, r;
                }()))
            ])),
            A2(VM, E([
                WM("card border-end-0 border-top-0 border-bottom-0 text-center mb-0")
            ]), E([
                A2(B_, E([
                    WM("StageBody list-group list-group-flush fs-7"),
                    n_(E([
                        v("disabled", !a.gp)
                    ]))
                ]), E([
                    A2(v5, (e = a.d9, e / 1e3 > 0 || hh(a.a$) > 0), A2(L_, E([
                        WM("list-group-item text-muted d-flex flex-wrap justify-content-around")
                    ]), E([
                        A2(d_, E([
                            WM("d-flex align-items-center")
                        ]), E([
                            A2(d_, E([
                                WM("me-1")
                            ]), E([
                                a_("Chaleur")
                            ])),
                            JJ(a.d9),
                            p5(22)
                        ])),
                        A2(d_, E([
                            WM("d-flex align-items-center")
                        ]), E([
                            A2(d_, E([
                                WM("me-1")
                            ]), E([
                                a_("\xc9lectricit\xe9")
                            ])),
                            WJ(a.a$),
                            p5(13)
                        ]))
                    ]))),
                    A2(_5, t, a),
                    A3(x5, r, n, a),
                    I5(a.ji),
                    G5(a.j8),
                    A2(V5, n, a.pK),
                    A2(g5, n, a.lc),
                    A2(v5, 1 === a.ai, A2(L_, E([
                        WM("list-group-item text-muted")
                    ]), E([
                        A2(VM, E([
                            WM("d-flex justify-content-between")
                        ]), E([
                            a_("Fin de vie"),
                            A2(eB, u, a.g)
                        ])),
                        A2(v5, 19 === u.kf, A2(VM, E([
                            WM("text-start mt-2")
                        ]), E([
                            A2(d_, E([
                                WM("fw-bold")
                            ]), E([
                                a_("Compl\xe9ment")
                            ])),
                            A2(VM, E([
                                WM("d-flex justify-content-between")
                            ]), E([
                                a_("-\xa0Export hors-Europe"),
                                ZQ(A2(_c, 0, a.S.ak))
                            ])),
                            A2(VM, E([
                                WM("d-flex justify-content-between")
                            ]), E([
                                A2(d_, E([
                                    WM("me-2 text-truncate")
                                ]), E([
                                    a_("-\xa0Probabilit\xe9 de fin de vie hors-Europe")
                                ])),
                                A2(d_, E([
                                    WM("text-nowrap")
                                ]), E([
                                    A2(xV, 2, DE(t.fn)),
                                    p5(15)
                                ]))
                            ]))
                        ])))
                    ])))
                ]))
            ]))
        ]));
    }, Y5 = function(n) {
        var e = n.k7;
        return A2(VM, E([
            WM("StageBody card-body row align-items-center")
        ]), E([
            A2(VM, E([
                WM("col-lg-7")
            ]), E([
                b5(n),
                function() {
                    switch(e.ai){
                        case 2:
                            return A2(VM, E([
                                WM("mt-2")
                            ]), E([
                                $5(n)
                            ]));
                        case 4:
                            return A2(VM, E([
                                WM("mt-2")
                            ]), E([
                                l5(n),
                                y5(n)
                            ]));
                        case 7:
                            return A2(VM, E([
                                WM("mt-2")
                            ]), E([
                                m5(n)
                            ]));
                        default:
                            return a_("");
                    }
                }()
            ]))
        ]));
    }, n4 = F2(function(n, e) {
        return n && A2(tl, e, Aj);
    }), e4 = function(n) {
        switch(n){
            case 0:
                return 11;
            case 1:
                return 14;
            case 2:
                return 16;
            case 3:
                return 20;
            case 4:
                return 23;
            case 5:
                return 27;
            case 6:
                return 28;
            default:
                return 31;
        }
    }, r4 = F2(function(n, e) {
        var r = n.k7, t = n.A, u = n.ox, a = n.o1;
        return A2(VM, E([
            WM("StageActions ms-2")
        ]), E([
            A2(VM, E([
                WM("btn-group")
            ]), E([
                A2(LQ, E([
                    WM("btn btn-secondary py-1 rounded"),
                    XM(hV(e4(e))),
                    V_("Documentation"),
                    LF("_blank")
                ]), E([
                    yJ
                ])),
                A2(v5, u, A2(q_, E([
                    i_("checkbox"),
                    WM("form-check-input ms-1 no-outline"),
                    A2(ZM, "role", "switch"),
                    w_(r.gp),
                    gG(Bi(a(r.ai))),
                    E_(A2(n4, t.dI, r.ai)),
                    V_(r.gp ? "\xc9tape activ\xe9e, cliquez pour la d\xe9sactiver" : "\xc9tape desactiv\xe9e, cliquez pour la r\xe9activer")
                ]), w))
            ]))
        ]));
    }), t4 = function(n) {
        switch(n){
            case 0:
                return dQ;
            case 1:
                return bQ;
            case 2:
            case 3:
            case 4:
            case 6:
                return vQ;
            case 5:
                return mQ;
            default:
                return $Q;
        }
    }, u4 = function(n) {
        switch(n){
            case 0:
                return "distribution-stage";
            case 1:
                return "end-of-life-stage";
            case 2:
                return "transform-stage-ennobling";
            case 3:
                return "transform-stage-fabric";
            case 4:
                return "transform-stage-making";
            case 5:
                return "materials-stage";
            case 6:
                return "transform-stage";
            default:
                return "usage-stage";
        }
    }, a4 = function(n) {
        switch(n){
            case 2:
                return "Transformation\xa0- Ennoblissement";
            case 3:
                return "Transformation\xa0- Tissage / Tricotage";
            case 4:
                return "Transformation\xa0- Confection";
            case 6:
                return "Transformation\xa0- Filature";
            default:
                return function(n) {
                    switch(n){
                        case 0:
                            return "Distribution";
                        case 1:
                            return "Fin de vie";
                        case 2:
                            return "Ennoblissement";
                        case 3:
                            return "Tissage & Tricotage";
                        case 4:
                            return "Confection";
                        case 5:
                            return "Mati\xe8res premi\xe8res";
                        case 6:
                            return "Filature";
                        default:
                            return "Utilisation";
                    }
                }(n);
        }
    }, i4 = F2(function(n, e) {
        var r, t, u = e.S, a = e.g;
        return A2(v5, function(n) {
            return n > 0;
        }(A2(fh, n.kf, a)), (r = cj(u), t = A2(I$, r, a), A2(VM, w, E([
            A2(d_, E([
                WM("flex-fill")
            ]), E([
                A2(eB, n, t)
            ]))
        ]))));
    }), c4 = F2(function(n, e) {
        var r = n.k7, t = n.ox;
        return A2(VM, E([
            WM("Stage card shadow-sm")
        ]), E([
            A2(VM, E([
                WM("StageHeader card-header"),
                xQ(t4(r.ai)),
                kF(u4(r.ai))
            ]), E([
                A2(VM, E([
                    WM("row d-flex align-items-center")
                ]), E([
                    A2(VM, E([
                        WM("col-9 col-sm-6")
                    ]), E([
                        A2(VM, E([
                            WM("d-flex align-items-center gap-2 text-dark"),
                            n_(E([
                                v("text-secondary", !r.gp)
                            ]))
                        ]), E([
                            A2(C_, E([
                                WM("h5 mb-0"),
                                n_(E([
                                    v("text-body-tertiary", !r.gp)
                                ]))
                            ]), E([
                                a_(a4(r.ai)),
                                A2(v5, 5 === r.ai, A2($V, E([
                                    QM(A2(pd, ms, _m(Hr))),
                                    V_("Explorer"),
                                    A2(ZM, "aria-label", "Explorer")
                                ]), E([
                                    mJ
                                ])))
                            ]))
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-3 col-sm-6 d-flex text-end justify-content-end")
                    ]), E([
                        A2(VM, E([
                            WM("d-none d-sm-block text-center")
                        ]), E([
                            A2(v5, r.gp || t, A2(i4, n.dv, r))
                        ])),
                        A2(r4, n, r.ai)
                    ]))
                ]))
            ])),
            e
        ]));
    }), o4 = F2(function(n, e) {
        var r = {
            i: A2(Lc, function(n) {
                return n.cM;
            }, e.i),
            mf: e.U.mf,
            aH: e.aH,
            dz: e.dz
        }, t = A2(lh, function() {
            return ph(e.aH);
        }, A3(Hj, n.C, e.U, n.k7)), u = A2(ju, function(n) {
            return n.U;
        }, n.A.fn);
        return {
            ky: !1,
            kE: {
                i: e.i,
                ir: e.U,
                D: e.aH
            },
            C: {
                bR: A2(IE, function(n) {
                    return n.ei;
                }, A2(Nh, E([
                    ms
                ]), n.C.bR)),
                cV: n.C.cV,
                r: n.C.oT.fn
            },
            ic: e.U.l6,
            ll: n.ln,
            bb: u,
            O: t,
            nv: n.nv,
            nS: function(n) {
                return function(n) {
                    var e = n.bW, r = n.fs, t = n.aH;
                    return A2(VM, E([
                        WM("input-group")
                    ]), E([
                        A2(q_, E([
                            WM("form-control text-end incdec-arrows-left"),
                            i_("number"),
                            eZ("1"),
                            vK(Bs(zf(t))),
                            V_("Quantit\xe9 en pourcents"),
                            dK(function(n) {
                                return r("" === n ? Hr : A2(Qa, A2(Fu, Xs, Ld), gp(n)));
                            }),
                            nZ("0"),
                            E_(e)
                        ]), w),
                        A2(d_, E([
                            WM("input-group-text"),
                            V_("pourcents")
                        ]), E([
                            a_("%")
                        ]))
                    ]));
                }({
                    bW: !1,
                    fs: n.fs,
                    aH: n.D
                });
            },
            op: F2(function(r, t) {
                return n.ow(A2(n.ku, Rr(e), t));
            }),
            dv: n.dv,
            oV: A2(Fu, function(n) {
                return n.mf;
            }, Oj),
            oZ: function(n) {
                return n.ei;
            },
            o_: A2(Fu, function(n) {
                return n.t;
            }, Wb),
            pd: F2(function(e, t) {
                return A2(n.py, r, $(r, {
                    i: A2(Lc, function(n) {
                        return n.cM;
                    }, t.i),
                    mf: t.ir.mf,
                    aH: t.D
                }));
            })
        };
    }), f4 = F2(function(n, e) {
        var r = A2(KE, n, e), t = $(lj, {
            aj: Rr(r)
        });
        return A2(gZ, {
            S: t,
            ai: "Compl\xe9ments"
        }, E([
            A2(VM, E([
                WM("ElementComplement"),
                V_("Microfibres")
            ]), E([
                A2(d_, E([
                    WM("ComplementName d-flex align-items-center text-nowrap text-muted")
                ]), E([
                    a_("Microfibres"),
                    A2(mZ, E([
                        XM(hV(10)),
                        LF("_blank")
                    ]), E([
                        yJ
                    ]))
                ])),
                A2(d_, E([
                    WM("ComplementRange")
                ]), w),
                A2(VM, E([
                    WM("ComplementValue d-flex")
                ]), w),
                A2(VM, E([
                    WM("ComplementImpact text-black-50 text-muted text-end")
                ]), E([
                    a_("("),
                    ZQ(r),
                    a_(")")
                ]))
            ]))
        ]));
    }), s4 = function(n) {
        var e, r, t, u, a;
        return A2(B_, E([
            WM("CardList list-group list-group-flush")
        ]), k(A2(ju, function(e) {
            var r = A4(aE, n.C, A2(_c, n.k7, n.m7).i, n.k7.nE, e);
            return A2(L_, E([
                WM("ElementFormWrapper list-group-item")
            ]), Sd(E([
                vZ(A2(o4, n, e)),
                19 === n.dv.kf ? E([
                    A2(f4, n.A.P, e)
                ]) : w,
                E([
                    A2(d_, E([
                        WM("text-muted d-flex fs-7 gap-3 justify-content-left ElementTransportDistances")
                    ]), A2(lZ, {
                        f2: Hr,
                        gu: !1,
                        gz: !0,
                        eo: !1,
                        g4: Hr,
                        g8: Hr
                    }, r)),
                    A2(d_, E([
                        WM("text-black-50 text-end ElementTransportImpact fs-8"),
                        V_("Impact du transport pour cette mati\xe8re")
                    ]), E([
                        a_("(+ "),
                        A2(eB, n.dv, r.g),
                        a_(")")
                    ]))
                ])
            ])));
        }, n.A.fn), E([
            (e = al(A2(ju, A2(Fu, function(n) {
                return n.aH;
            }, A2(Fu, Qo, A2(EE, 0, 1))), n.A.fn)), r = 100 === jf(100 * e), t = ft(n.A.fn), u = A2(ju, function(n) {
                return n.U;
            }, n.A.fn), a = A2(ks, function(n) {
                return !A2(tl, n, u);
            }, n.C.oT.fn), A2(L_, E([
                WM("input-group AddElementFormWrapper ps-3")
            ]), E([
                A2(d_, E([
                    WM("SharesTotal ext-end"),
                    WM("d-flex justify-content-between align-items-center gap-1"),
                    n_(E([
                        v("text-success feedback-valid", r),
                        v("text-danger feedback-invalid", !r)
                    ]))
                ]), E([
                    r ? LG : TG,
                    a_(ut(jf(100 * e))),
                    a_("%")
                ])),
                A2(YM, E([
                    WM("AddElementButton btn btn-outline-primary flex-fill"),
                    WM("d-flex justify-content-center align-items-center gap-1 no-outline"),
                    kF("add-new-element"),
                    u_(n.ow(A2(n.ku, Hr, A2(XQ, function(n) {
                        return n.ei;
                    }, A2(IE, function(n) {
                        return n.ei;
                    }, a))))),
                    E_(m(t, 5) > -1)
                ]), E([
                    nQ,
                    m(t, 5) > -1 ? a_("Nombre maximal de mati\xe8res atteint") : a_("Ajouter une mati\xe8re")
                ]))
            ])))
        ])));
    }, l4 = function(n) {
        return Cf(ch(E([
            n.ds,
            n.g7,
            n.f1
        ])));
    }, d4 = F3(function(n, e, r) {
        var t = e.aV, u = e.O;
        return A2(VM, E([
            WM("pt-1"),
            A2(ZM, "data-testid", "life-cycle-stages")
        ]), xt(A2(jc, 1, xt(A2(Id, function(n) {
            return E([
                n.au,
                A2(OZ, w, E([
                    n.eJ
                ]))
            ]);
        }, Nr(A2(i5, F2(function(e, a) {
            return function(n) {
                var e, r, t, u;
                return {
                    au: A2(c4, n, 5 === n.k7.ai ? s4(n) : n.ox ? Z5(n) : Y5(n)),
                    eJ: (e = n, r = e.k7, t = e.A, u = e.dv, A2(VM, w, E([
                        A2(d_, w, E([
                            a_("Masse\xa0: "),
                            bW(A2(oE, t, r))
                        ])),
                        A2(v5, l4(r.eJ) > 0, A2(VM, E([
                            WM("d-flex justify-content-between gap-3 align-items-center")
                        ]), E([
                            A2(VM, E([
                                WM("d-flex justify-content-between gap-3 flex-column flex-md-row")
                            ]), A2(lZ, {
                                f2: Hr,
                                gu: !1,
                                gz: !0,
                                eo: !1,
                                g4: Hr,
                                g8: Hr
                            }, r.eJ)),
                            A2(d_, w, E([
                                A2(eB, u, r.eJ.g),
                                p5(29)
                            ]))
                        ])))
                    ])))
                };
            }({
                ku: CL,
                k7: a,
                gk: r.gk,
                C: n,
                ln: A2(Fu, function(n) {
                    return n.mf;
                }, K3),
                mk: e,
                A: r.A,
                m7: A2(mE, a.ai, r.ac),
                nv: A2(Fu, N3, Cc),
                dv: u,
                ow: Cc,
                ox: !t,
                o0: G3,
                o1: W3,
                pe: V3,
                pk: r5,
                pm: J3,
                pq: B3,
                pv: X3,
                pw: Q3,
                px: Z3,
                py: Y3,
                pz: n5,
                pB: e5,
                pE: t5,
                pF: u5,
                pG: r.pG
            });
        }), r.ac)))))));
    }), b4 = function(n) {
        return {
            $: 42,
            a: n
        };
    }, m4 = function(n) {
        return {
            $: 45,
            a: n
        };
    }, p4 = function(n) {
        return {
            $: 46,
            a: n
        };
    }, v4 = F2(function(n, e) {
        var r = n.dp, t = A2(XQ, function(n) {
            return n.ei;
        }, A2(IE, function(n) {
            return n.ei;
        }, r));
        return A2(VM, E([
            WM("d-flex flex-column")
        ]), E([
            A2(VM, E([
                WM("d-flex justify-content-between align-items-center")
            ]), E([
                A2(mG, E([
                    bG("selector-product"),
                    WM("form-label text-truncate")
                ]), E([
                    a_("Cat\xe9gorie de produit")
                ])),
                A2(mZ, E([
                    WM("text-primary"),
                    QM(A2(pd, ms, Rm(Hr))),
                    V_("Explorer les cat\xe9gories de produit"),
                    LF("_blank")
                ]), E([
                    yJ
                ]))
            ])),
            A2(YM, E([
                kF("selector-product"),
                WM("form-select ElementSelector text-start w-auto"),
                u_(Cc(HL(t)))
            ]), E([
                a_(A2(eh, "", A2(ss, function(n) {
                    return n.ei;
                }, A2(PE, e.aS, r))))
            ]))
        ]));
    }), g4 = function(n) {
        return {
            $: 47,
            a: n
        };
    }, h4 = function(n) {
        return s(n, ME) ? Hr : Rr(n);
    }, $4 = ju(function(n) {
        var e = n.i, r = n.U, t = n.aH, u = n.dz;
        return {
            i: A2(Qa, A2(Fu, function(n) {
                return n.cM;
            }, h4), e),
            mf: r.mf,
            aH: t,
            dz: u
        };
    }), x4 = function(n) {
        return {
            cE: n.cE,
            hW: n.hW,
            bx: h4(n.bx.cM),
            bS: h4(n.bS.cM),
            bT: h4(n.bT.cM),
            cT: h4(n.cT.cM),
            cX: n.cX,
            cZ: n.cZ,
            b1: n.b1,
            c6: n.c6,
            mR: n.mR,
            dj: n.dj,
            dk: n.dk,
            P: n.P,
            fn: $4(n.fn),
            ja: n.ja,
            dm: n.dm,
            jn: n.jn,
            dn: n.dn,
            aS: n.aS.mf,
            hf: n.hf,
            pb: s(n.pb, n.aS.pb) ? Hr : Rr(n.pb),
            dI: n.dI,
            pR: n.pR
        };
    }, k4 = F3(function(n, e, r) {
        var t, u, a, i, c, o, f, l, d, b, m = r.A;
        return E([
            A2(VM, E([
                WM("row align-items-start flex-md-columns g-2")
            ]), E([
                A2(VM, E([
                    WM("col-md-6")
                ]), E([
                    A2(v4, n.C.oT, x4(m))
                ])),
                A2(VM, E([
                    WM("col-md-3")
                ]), E([
                    (c = ut(jf(Ho(m.P))), A2(VM, E([
                        WM("d-flex flex-column")
                    ]), E([
                        A2(mG, E([
                            bG("mass"),
                            WM("form-label text-truncate")
                        ]), E([
                            a_("Masse du produit fini")
                        ])),
                        A2(VM, E([
                            WM("input-group"),
                            V_("Masse du produit fini, en grammes")
                        ]), E([
                            A2(q_, E([
                                i_("number"),
                                WM("form-control text-end"),
                                kF("mass"),
                                nZ("1"),
                                eZ("1"),
                                vK(c),
                                dK(b4)
                            ]), w),
                            A2(d_, E([
                                WM("input-group-text")
                            ]), E([
                                a_("g")
                            ]))
                        ]))
                    ])))
                ])),
                A2(VM, E([
                    WM("col-md-3 d-flex align-items-end flex-row")
                ]), E([
                    A2(VM, E([
                        WM("d-flex flex-column")
                    ]), E([
                        A2(mG, E([
                            WM("form-label d-none d-md-block"),
                            A2(ZM, "aria-hidden", "true")
                        ]), E([
                            a_("\xa0")
                        ])),
                        A2(VM, E([
                            WM("UpcycledCheck form-check text-truncate ms-1")
                        ]), E([
                            A2(q_, E([
                                i_("checkbox"),
                                WM("form-check-input"),
                                kF("upcycled"),
                                w_(m.dI),
                                gG(z3)
                            ]), w),
                            A2(mG, E([
                                bG("upcycled"),
                                WM("form-check-label text-truncate"),
                                V_("Le v\xeatement est-il upcycl\xe9\xa0?")
                            ]), E([
                                a_("Remanufactur\xe9")
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            V2({
                h4: n.h4,
                k_: 1,
                C: n.C,
                ld: !1,
                lq: w,
                lu: Rr(hV(30)),
                lT: Rr(A2(pd, ms, A2(Sm, ms, Hr))),
                b2: Hr,
                O: e.O,
                mB: A2(a1, 1, ms),
                ac: A2(Ix, {
                    ay: n.h4,
                    C: n.C,
                    as: ms
                }, A2(xE, m.pb, Xx)),
                m8: IL,
                nw: function() {
                    return IL;
                },
                nx: function() {
                    return IL;
                },
                ny: function() {
                    return IL;
                },
                nz: function() {
                    return IL;
                },
                nA: F4(function() {
                    return Cc(Ac);
                }),
                nB: A2(Fu, PL, Cc),
                g1: A2(xE, m.pb, Xx),
                n$: function() {
                    return IL;
                },
                n0: function() {
                    return IL;
                },
                n1: function() {
                    return IL;
                },
                n2: F2(function() {
                    return IL;
                }),
                n3: R3,
                n4: function() {
                    return IL;
                },
                as: ms,
                ov: function() {
                    return IL;
                },
                o2: function() {
                    return IL;
                },
                o3: function() {
                    return IL;
                },
                pc: !1,
                pf: function() {
                    return IL;
                },
                ph: F2(function() {
                    return IL;
                }),
                pl: function() {
                    return IL;
                },
                pn: F2(function() {
                    return IL;
                }),
                po: F2(function() {
                    return IL;
                }),
                pp: F3(function() {
                    return IL;
                }),
                ps: F2(function() {
                    return IL;
                }),
                pt: U3,
                pu: F2(function() {
                    return IL;
                }),
                pA: F2(function() {
                    return IL;
                }),
                pC: function() {
                    return IL;
                }
            }),
            A2(VM, E([
                WM("card shadow-sm pb-2")
            ]), E([
                A2(VM, E([
                    WM("card-header d-flex justify-content-between align-items-center")
                ]), E([
                    A2(C_, E([
                        WM("h5 mb-1 text-truncate")
                    ]), E([
                        a_("Durabilit\xe9")
                    ])),
                    A2(VM, E([
                        WM("d-flex align-items-center gap-2")
                    ]), E([
                        A2(d_, E([
                            WM("d-none d-sm-flex text-truncate")
                        ]), E([
                            a_("Coefficient de durabilit\xe9\xa0:")
                        ])),
                        a_(A2(zw, 2, Zw(r.aO))),
                        A2(LQ, E([
                            WM("bg-secondary"),
                            A2(OF, "height", "24px"),
                            XM(hV(12)),
                            V_("Documentation"),
                            LF("_blank")
                        ]), E([
                            yJ
                        ]))
                    ]))
                ])),
                A2(VM, E([
                    WM("card-body pt-3 py-2 row g-3 align-items-start flex-md-columns")
                ]), E([
                    A2(VM, E([
                        WM("col-md-2")
                    ]), E([
                        A2(mG, E([
                            bG("product-price"),
                            WM("col-form-label text-truncate")
                        ]), E([
                            a_("Prix neuf")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-md-3")
                    ]), E([
                        (i = A2(_c, m.aS.lG.jn, m.jn), A2(VM, E([
                            WM("input-group")
                        ]), E([
                            A2(q_, E([
                                i_("number"),
                                kF("product-price"),
                                WM("form-control"),
                                nZ(Bs(1)),
                                S0(Bs(1e3)),
                                vK(Bs(i)),
                                dK(A2(Fu, gp, A2(Fu, Lc(dp), g4)))
                            ]), w),
                            A2(d_, E([
                                WM("input-group-text")
                            ]), E([
                                a_("\u20AC")
                            ]))
                        ])))
                    ])),
                    A2(VM, E([
                        WM("col-md-4")
                    ]), E([
                        A2(mG, E([
                            bG("number-of-references"),
                            WM("col-form-label text-truncate")
                        ]), E([
                            a_("Nombre de r\xe9f\xe9rences")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-md-3")
                    ]), E([
                        (a = A2(_c, m.aS.lG.ja, m.ja), A2(q_, E([
                            i_("number"),
                            kF("number-of-references"),
                            WM("form-control"),
                            nZ(ut(1)),
                            S0(ut(999999)),
                            eZ("1"),
                            vK(ut(a)),
                            dK(A2(Fu, du, m4))
                        ]), w))
                    ]))
                ])),
                A2(VM, E([
                    WM("card-body py-2 row g-3 align-items-start flex-md-columns")
                ]), E([
                    A2(VM, E([
                        WM("col-md-2")
                    ]), E([
                        A2(mG, E([
                            bG("business"),
                            WM("col-form-label text-truncate")
                        ]), E([
                            a_("Entreprise")
                        ]))
                    ])),
                    A2(VM, E([
                        WM("col-md-10")
                    ]), E([
                        (u = A2(_c, m.aS.lG.hW, m.hW), A2(mK, E([
                            kF("business"),
                            WM("form-select"),
                            dK(A2(Fu, Ym, D3))
                        ]), A2(ju, function(n) {
                            return A2(bK, E([
                                vK(uf(n)),
                                pK(s(u, n))
                            ]), E([
                                a_(qB(n))
                            ]));
                        }, E([
                            2,
                            1,
                            0
                        ]))))
                    ]))
                ])),
                e.aV ? a_("") : A2(VM, w, E([
                    A2(VM, E([
                        WM("card-body py-2 row g-3 align-items-start flex-md-columns")
                    ]), E([
                        A2(VM, E([
                            WM("col-md-4")
                        ]), E([
                            a_("Durabilit\xe9 non physique")
                        ])),
                        A2(VM, E([
                            WM("col-md-8")
                        ]), E([
                            a_(Bs(r.aO.i8))
                        ]))
                    ])),
                    A2(VM, E([
                        WM("card-body py-2 row g-3 align-items-start flex-md-columns")
                    ]), E([
                        A2(VM, E([
                            WM("col-md-4")
                        ]), E([
                            a_("Durabilit\xe9 physique")
                        ])),
                        A2(VM, E([
                            WM("col-md-8")
                        ]), E([
                            (t = r.aO.gX, A2(VM, E([
                                WM("input-group")
                            ]), E([
                                (o = {
                                    bW: !1,
                                    mf: "physicalDurability",
                                    oZ: A2(Fu, Qw, Bs),
                                    pd: p4,
                                    eP: t
                                }, l = (f = {
                                    hO: E([
                                        dK(A2(Fu, gp, A2(Fu, Lc(sp), o.pd))),
                                        nZ(Bs(Xw(ru))),
                                        S0(Bs(Bw(ru))),
                                        eZ("0.01"),
                                        vK(Bs(o.eP)),
                                        E_(o.bW)
                                    ]),
                                    mf: o.mf,
                                    ai: o.oZ(o.eP)
                                }).hO, d = f.mf, b = f.ai, A2(VM, E([
                                    WM("RangeSlider row"),
                                    A2(OF, "flex-grow", "1")
                                ]), E([
                                    A2(VM, E([
                                        WM("col-xxl-2")
                                    ]), E([
                                        A2(mG, E([
                                            bG(d),
                                            WM("form-label text-nowrap mb-0")
                                        ]), E([
                                            a_(b)
                                        ]))
                                    ])),
                                    A2(VM, E([
                                        WM("col-xxl-10")
                                    ]), E([
                                        I0(A2(Ur, kF(d), l))
                                    ]))
                                ])))
                            ])))
                        ]))
                    ]))
                ]))
            ])),
            A2(VM, w, E([
                A3(d4, n.C, e, r),
                A2(VM, E([
                    WM("d-flex align-items-center justify-content-between mt-3")
                ]), E([
                    A2(KM, E([
                        QM($d)
                    ]), E([
                        a_("\xab Retour \xe0 l'accueil")
                    ])),
                    A2(YM, E([
                        WM("btn btn-secondary"),
                        u_(H3),
                        E_(s(n.aG.oT, e.db))
                    ]), E([
                        a_("R\xe9initialiser le produit")
                    ]))
                ]))
            ]))
        ]);
    }), w4 = F3(function(n, e, r) {
        var t, u, a, i, c = r.A, o = r.g, f = F2(function(n, e) {
            return A2(d_, E([
                WM("d-flex justify-content-between align-items-center gap-1")
            ]), E([
                A2(d_, E([
                    WM("d-flex flex-fill justify-content-center")
                ]), E([
                    a_(e)
                ])),
                A2(d_, E([
                    WM("text-muted fs-8 cursor-help opacity-50"),
                    V_(n)
                ]), E([
                    yJ
                ]))
            ]));
        });
        return A2(VM, E([
            WM("row")
        ]), E([
            A2(VM, E([
                WM("col-lg-8 bg-white")
            ]), E([
                A2(BM, E([
                    WM("visually-hidden")
                ]), E([
                    a_("Simulateur ")
                ])),
                A2(VM, E([
                    WM("sticky-md-top bg-white pb-3")
                ]), E([
                    zZ({
                        k8: n.aG.oT,
                        lM: cT,
                        lP: n.C.oT.lP,
                        mb: Rr(19),
                        nq: A2(Fu, RL, Cc),
                        od: {
                            lS: A2(pd, ms, Ed(Hr)),
                            mJ: kd,
                            oj: wd
                        }
                    })
                ])),
                A2(VM, E([
                    WM("d-flex flex-column bg-white")
                ]), E([
                    cQ({
                        kB: E([
                            WM("sticky-md-top"),
                            A2(OF, "top", "50px")
                        ]),
                        h5: E([
                            A2(VM, E([
                                WM("card-body p-2 d-flex flex-column gap-3")
                            ]), A3(k4, n, e, r))
                        ]),
                        oQ: E([
                            {
                                hF: 1 === e.aV,
                                ai: A2(f, "N\u2019affiche que les champs propos\xe9s dans le projet de cadre r\xe9glementaire", "Mode r\xe8glementaire"),
                                jc: O3(1)
                            },
                            {
                                hF: !e.aV,
                                ai: A2(f, "Affiche des champs suppl\xe9mentaires, hors cadre r\xe9glementaire", "Mode exploratoire"),
                                jc: O3(0)
                            }
                        ])
                    })
                ]))
            ])),
            A2(VM, E([
                WM("col-lg-4 bg-white")
            ]), E([
                jQ({
                    ks: e.dU,
                    bv: e.bv,
                    bw: e.bw,
                    kY: E3,
                    k0: "",
                    k1: "",
                    k2: !1,
                    k4: x3,
                    k6: IL,
                    la: Rr(A2(VM, E([
                        WM("fs-8")
                    ]), E([
                        a_("Pour 100g\xa0:\xa0"),
                        A2(eB, e.O, A2(RJ, c.P, o))
                    ]))),
                    lm: k3,
                    lU: w3,
                    mh: Rr(A3(_3, n.C.cV, r, A5(qX, n, e.O, e.dN, j3, I3))),
                    mi: y3,
                    m8: IL,
                    aT: c.P,
                    n5: C3,
                    og: P3,
                    as: ms,
                    dv: e.O,
                    eu: n,
                    oL: T3,
                    oN: S3,
                    o5: o,
                    o6: Rr((t = r, u = t.ac, a = t.dF, i = dj(A2(Py, function(n) {
                        return n.gp;
                    }, u)), bh(E([
                        A2(oj, i, rj(u)),
                        a
                    ])))),
                    pg: q3,
                    pi: Bi(IL),
                    pj: Bi(IL),
                    pD: L3
                })
            ]))
        ]));
    }), y4 = F2(function(n, e) {
        var r;
        return v("Simulateur", E([
            A2(JM, E([
                WM("Simulator pb-3")
            ]), (r = e.dx, E(1 === r.$ ? [
                c_({
                    hO: w,
                    h0: Hr,
                    h5: E([
                        a_(r.a)
                    ]),
                    eb: 0,
                    eC: Rr("Erreur")
                })
            ] : [
                A3(w4, n, e, r.a),
                function() {
                    var r = e.ad;
                    switch(r.$){
                        case 0:
                            return YZ({
                                cF: r.b,
                                ga: Cc(Ac),
                                l2: w,
                                m8: IL,
                                gP: qL,
                                gQ: l3,
                                gY: "tapez ici le nom de la mati\xe8re premi\xe8re pour la rechercher",
                                eC: "S\xe9lectionnez une mati\xe8re premi\xe8re",
                                hs: A2(Fu, function(n) {
                                    return n.jd;
                                }, AB),
                                ht: function(n) {
                                    return n.ei;
                                }
                            });
                        case 1:
                            return YZ({
                                cF: r.a,
                                ga: Cc(Ac),
                                l2: w,
                                m8: IL,
                                gP: ML,
                                gQ: l3,
                                gY: "tapez ici un nom d'accesoire pour le rechercher",
                                eC: "S\xe9lectionnez un accessoire",
                                hs: Bi(""),
                                ht: o0
                            });
                        case 2:
                            return GK({
                                h0: Cc(Ac),
                                h5: E([
                                    kY({
                                        bu: e.bu,
                                        cO: e.cO,
                                        O: e.O,
                                        nk: d3,
                                        nl: b3,
                                        nm: m3,
                                        nn: p3,
                                        oo: v3,
                                        oq: g3,
                                        eu: n,
                                        oM: h3,
                                        o$: $3
                                    })
                                ]),
                                l2: w,
                                l3: Hr,
                                m8: IL,
                                oA: 0,
                                oI: Rr("Co\xfbt environnemental, par produit"),
                                eC: "Comparateur de simulations sauvegard\xe9es"
                            });
                        case 3:
                            return GK({
                                h0: Cc(Ac),
                                h5: E([
                                    A2(VM, E([
                                        WM("p-3")
                                    ]), E([
                                        A2(vF, w, "Basculer en mode r\xe8glementaire r\xe9initialisera les valeurs renseign\xe9es\n                                             pour les champs avanc\xe9s du mode exploratoire."),
                                        A2(H_, E([
                                            WM("d-flex justify-content-center align-items-center gap-1 mt-4")
                                        ]), E([
                                            A2(YM, E([
                                                WM("btn btn-primary"),
                                                u_(s3)
                                            ]), E([
                                                a_("Confirmer")
                                            ])),
                                            a_("ou"),
                                            A2(YM, E([
                                                WM("btn btn-link ps-0"),
                                                u_(Cc(Ac))
                                            ]), E([
                                                a_("rester en mode exploratoire")
                                            ]))
                                        ]))
                                    ]))
                                ]),
                                l2: w,
                                l3: Hr,
                                m8: IL,
                                oA: 4,
                                oI: Hr,
                                eC: "Avertissement"
                            });
                        case 4:
                            var t = r.a;
                            return GK({
                                h0: Cc(Ac),
                                h5: E([
                                    A2(SB, n.C, t)
                                ]),
                                l2: w,
                                l3: Hr,
                                m8: IL,
                                oA: 2,
                                oI: Hr,
                                eC: t.ei
                            });
                        case 5:
                            return a_("");
                        case 6:
                            return YZ({
                                cF: r.a,
                                ga: Cc(Ac),
                                l2: w,
                                m8: IL,
                                gP: OL,
                                gQ: l3,
                                gY: "tapez ici le nom du produit pour le rechercher",
                                eC: "S\xe9lectionnez un produit",
                                hs: NZ(n.C.oT.lP),
                                ht: UZ(n.C.oT.lP)
                            });
                        default:
                            return YZ({
                                cF: r.a,
                                ga: Cc(Ac),
                                l2: E([
                                    A2(KM, E([
                                        WM("d-flex justify-content-between gap-2 align-items-center btn btn-primary"),
                                        XM("https://forms.gle/JY6QYMppqRTiCM6g8"),
                                        LF("_blank")
                                    ]), E([
                                        nQ,
                                        a_("Sugg\xe9rer une nouvelle cat\xe9gorie")
                                    ]))
                                ]),
                                m8: IL,
                                gP: LL,
                                gQ: l3,
                                gY: "tapez ici une cat\xe9gorie pour la rechercher",
                                eC: "S\xe9lectionnez une cat\xe9gorie de produit",
                                hs: Bi(""),
                                ht: function(n) {
                                    return n.ei;
                                }
                            });
                    }
                }()
            ])))
        ]));
    }), j4 = (ZN = {
        mn: $i,
        ns: function(n) {
            return {
                $: 15,
                a: n
            };
        },
        nt: function(n) {
            return {
                $: 16,
                a: n
            };
        },
        oK: function(n) {
            var e = n.bc, r = n.H;
            return Pi(E([
                vc(Ei),
                e ? Ji(Oi(ki)) : Li,
                2 === r.$ ? A2(pc, r.a.pH, Ci) : Li,
                function() {
                    n: for(; 2 === r.$;)switch(r.b.$){
                        case 3:
                            return A2(qi, wi, $c(r.b.a));
                        case 4:
                            return A2(qi, yi, wc(r.b.a));
                        case 5:
                            return A2(qi, ji, Ec(r.b.a));
                        case 10:
                            return A2(qi, Ai, Pc(r.b.a));
                        default:
                            break n;
                    }
                    return Li;
                }()
            ]));
        },
        pd: qM,
        pI: function(n) {
            var e, r = n.by, t = n.c7, u = n.H, a = n.bo, i = {
                hG: DM,
                kU: t.kU,
                kW: ki,
                k9: WA,
                lN: t.lN,
                bc: n.bc,
                iT: !1,
                mt: !1,
                ch: n.ch,
                a1: w,
                oS: !1,
                oW: zA,
                bo: a
            };
            switch(u.$){
                case 0:
                    return A2(VK, i, v("Erreur", E([
                        (e = u.a, A2(JM, E([
                            WM("pb-5")
                        ]), E([
                            A2(BM, E([
                                WM("mb-3")
                            ]), E([
                                a_("Erreur")
                            ])),
                            c_({
                                hO: w,
                                h0: Hr,
                                h5: E([
                                    a_(e)
                                ]),
                                eb: 0,
                                eC: Hr
                            }),
                            A2(KM, E([
                                QM($d)
                            ]), E([
                                a_("Retour \xe0 l'accueil")
                            ]))
                        ])))
                    ])));
                case 1:
                    return A2(VK, i, v("Chargement des donn\xe9es Ecobalyse", E([
                        ZK(Rr(BK(r)))
                    ])));
                default:
                    var c = u.a, o = u.b, f = F2(function(n, e) {
                        var r = e.b;
                        return v(e.a, A2(ju, nG(n), r));
                    }), s = function(n) {
                        return VK($(i, {
                            hG: n,
                            k9: c.k9,
                            iT: Rl(c),
                            mt: Ul(c),
                            a1: c.a1,
                            oS: us(c),
                            bo: a
                        }));
                    };
                    switch(o.$){
                        case 0:
                            return A2(s, LM, A2(f, Fl, function(n) {
                                return v("API", E([
                                    A2(JM, E([
                                        WM("pb-5")
                                    ]), E([
                                        A2(BM, E([
                                            WM("mb-3")
                                        ]), E([
                                            a_("API Ecobalyse")
                                        ])),
                                        A2(VM, E([
                                            WM("row")
                                        ]), E([
                                            A2(VM, E([
                                                WM("col-xl-8 d-flex flex-column gap-3")
                                            ]), E([
                                                A2(vF, E([
                                                    WM("fw-bold")
                                                ]), "L'API HTTP Ecobalyse permet de calculer les impacts environnementaux des produits textiles, alimentaires, objets et v\xe9hicules. "),
                                                A2(H_, E([
                                                    WM("mb-0")
                                                ]), E([
                                                    a_("Elle est accessible \xe0 l'adresse "),
                                                    A2(y_, w, E([
                                                        a_(rG(n))
                                                    ])),
                                                    a_(" et "),
                                                    A2(KM, E([
                                                        XM(rG(n)),
                                                        LF("_blank")
                                                    ]), E([
                                                        a_("document\xe9e")
                                                    ])),
                                                    a_(" au format "),
                                                    A2(KM, E([
                                                        XM("https://swagger.io/specification/"),
                                                        LF("_blank")
                                                    ]), E([
                                                        a_("OpenAPI")
                                                    ])),
                                                    a_(".")
                                                ])),
                                                aG(n),
                                                A2(VM, E([
                                                    WM("height-auto")
                                                ]), E([
                                                    uG(n)
                                                ]))
                                            ])),
                                            A2(VM, E([
                                                WM("col-xl-4 d-flex flex-column gap-3")
                                            ]), E([
                                                c_({
                                                    hO: w,
                                                    h0: Hr,
                                                    h5: E([
                                                        A2(vF, E([
                                                            WM("fs-7")
                                                        ]), "Cette API est **exp\xe9rimentale** et n'offre \xe0 ce stade **aucune garantie de disponibilit\xe9 ni de\n             stabilit\xe9** du service, le contrat d'interface restant susceptible de changer \xe0 tout moment en\n             fonction des retours et demandes d'\xe9volutions. **Il est vivement d\xe9conseill\xe9 de vous reposer sur\n             cette API en production et/ou pour des missions critiques.**"),
                                                        A2(H_, E([
                                                            WM("fs-8 mb-0 text-end")
                                                        ]), E([
                                                            A2(KM, E([
                                                                QM(md("api-faq"))
                                                            ]), E([
                                                                a_("Acc\xe9der \xe0 la FAQ \xbb")
                                                            ]))
                                                        ]))
                                                    ]),
                                                    eb: 1,
                                                    eC: Rr("Avertissement")
                                                }),
                                                A2(VM, E([
                                                    WM("card")
                                                ]), E([
                                                    A2(VM, E([
                                                        WM("card-header")
                                                    ]), E([
                                                        a_("Derni\xe8res mises \xe0 jour")
                                                    ])),
                                                    A2(B_, E([
                                                        WM("list-group list-group-flush")
                                                    ]), A2(ju, function(n) {
                                                        var e = n.d, r = n.eb, t = n.e, u = n.f;
                                                        return A2(L_, E([
                                                            WM("list-group-item")
                                                        ]), E([
                                                            A2(VM, E([
                                                                WM("d-flex justify-content-between align-items-right mb-1")
                                                            ]), E([
                                                                A2(VM, E([
                                                                    WM("text-nowrap")
                                                                ]), E([
                                                                    a_(e)
                                                                ])),
                                                                A2(VM, E([
                                                                    WM("d-flex gap-1 flex-wrap justify-content-end")
                                                                ]), A2(Ur, A2(d_, E([
                                                                    WM("badge"),
                                                                    n_(E([
                                                                        v("badge-danger", "major" === r),
                                                                        v("badge-success", "major" !== r)
                                                                    ]))
                                                                ]), E([
                                                                    a_(r)
                                                                ])), A2(ju, function(n) {
                                                                    return A2(d_, E([
                                                                        WM("badge badge-info")
                                                                    ]), E([
                                                                        a_(n)
                                                                    ]));
                                                                }, t)))
                                                            ])),
                                                            A2(vF, E([
                                                                WM("fs-7")
                                                            ]), u)
                                                        ]));
                                                    }, iG))
                                                ]))
                                            ]))
                                        ]))
                                    ]))
                                ]));
                            }(c)));
                        case 1:
                            return A2(s, MM, A2(f, Gl, A2(ZG, c, o.a)));
                        case 2:
                            var l = o.a;
                            return A2(s, _M(l.aI), A2(f, Vl, function(n) {
                                var e, r = n.h5;
                                switch(r.$){
                                    case 2:
                                        return v("Erreur de chargement", E([
                                            (e = ts(r.a), c_({
                                                hO: w,
                                                h0: Hr,
                                                h5: function() {
                                                    var n = E(e.split(/\r\n|\r|\n/g));
                                                    if (n.b) {
                                                        if (n.b.b) {
                                                            var r = n.a, t = n.b;
                                                            return E([
                                                                A2(VM, w, E([
                                                                    A2(H_, E([
                                                                        WM("mb-2")
                                                                    ]), E([
                                                                        a_("Une erreur serveur a \xe9t\xe9 rencontr\xe9e\xa0:")
                                                                    ])),
                                                                    A2(U_, E([
                                                                        WM("mb-1")
                                                                    ]), E([
                                                                        a_(r)
                                                                    ])),
                                                                    A2(KF, E([
                                                                        WM("mb-2")
                                                                    ]), E([
                                                                        A2(VF, w, E([
                                                                            a_("Afficher les d\xe9tails de l'erreur")
                                                                        ])),
                                                                        A2(U_, E([
                                                                            WM("mt-1")
                                                                        ]), E([
                                                                            a_(pf(A2(at, "\n", t)))
                                                                        ]))
                                                                    ])),
                                                                    WF(e)
                                                                ]))
                                                            ]);
                                                        }
                                                        return E([
                                                            a_(n.a)
                                                        ]);
                                                    }
                                                    return w;
                                                }(),
                                                eb: 1,
                                                eC: Rr("Le serveur a retourn\xe9 une erreur")
                                            }))
                                        ]));
                                    case 1:
                                        return v("Chargement\u2026", E([
                                            QK(Hr)
                                        ]));
                                    case 0:
                                        return v("", w);
                                    default:
                                        var t = r.a;
                                        return v(A2(_c, "Sans titre", A2(Qa, A2(Fu, it("# "), vx), ys(A2(it, "\n", t)))), E([
                                            A2(JM, w, E([
                                                A2(vF, E([
                                                    WM("pb-5")
                                                ]), t)
                                            ]))
                                        ]));
                                }
                            }(l)));
                        case 3:
                            return A2(s, RM, A2(f, wi, A2(QB, c, o.a)));
                        case 4:
                            return A2(s, HM, A2(f, yi, A2(wY, c, o.a)));
                        case 5:
                            return A2(s, UM((d = o.a).iA), A2(f, ji, A2(Q2, c, d)));
                        case 6:
                            return A2(s, zM, A2(f, Zl, function(n) {
                                return v("Accueil", E([
                                    A2(VM, E([
                                        WM("d-flex flex-column")
                                    ]), E([
                                        A2(VM, E([
                                            WM("bg-light pt-5 shadow-inner-top")
                                        ]), E([
                                            r3(n)
                                        ])),
                                        A2(VM, E([
                                            WM("p-5")
                                        ]), E([
                                            t3
                                        ])),
                                        A2(VM, E([
                                            WM("bg-light p-5")
                                        ]), E([
                                            a3
                                        ])),
                                        A2(VM, E([
                                            WM("p-5")
                                        ]), E([
                                            c3
                                        ]))
                                    ]))
                                ]));
                            }(c)));
                        case 7:
                            return A2(s, DM, v("Chargement\u2026", E([
                                ZK(Hr)
                            ])));
                        case 8:
                            return A2(s, DM, v("404", E([
                                eG
                            ])));
                        case 9:
                            return A2(s, NM, A2(f, ed, A2(f3, c, o.a)));
                        default:
                            var d;
                            return A2(s, FM, A2(f, Ai, A2(y4, c, d = o.a)));
                    }
            }
        }
    }, YN = ZN.ns, nF = ZN.nt, eF = function() {
        eF.a(YN(Ye()));
    }, Qe({
        g9: function(n) {
            return eF.a = n, tr.addEventListener("popstate", eF), 0 > tr.navigator.userAgent.indexOf("Trident") || tr.addEventListener("hashchange", eF), F2(function(e, r) {
                if (!(r.ctrlKey || r.metaKey || r.shiftKey || r.button >= 1 || e.target || e.hasAttribute("download"))) {
                    r.preventDefault();
                    var t = e.href, u = Ye(), a = hu(t).a;
                    n(nF(a && u.nQ === a.nQ && u.iJ === a.iJ && u.nK.a === a.nK.a ? function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(a) : function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(t)));
                }
            });
        },
        mn: function(n) {
            return A3(ZN.mn, n, Ye(), eF);
        },
        pI: ZN.pI,
        pd: ZN.pd,
        oK: ZN.oK
    }));
    QN = {
        Main: {
            init: j4(A2(Qt, function(n) {
                return A2(Qt, function(e) {
                    return A2(Qt, function(r) {
                        return A2(Qt, function(t) {
                            return A2(Qt, function(u) {
                                return A2(Qt, function(a) {
                                    return A2(Qt, function(i) {
                                        return nu({
                                            kU: i,
                                            lN: a,
                                            mW: u,
                                            nI: t,
                                            g2: r,
                                            oh: e,
                                            pH: n
                                        });
                                    }, A2(Lu, "clientUrl", ai));
                                }, A2(Lu, "enabledSections", A2(Qt, function(n) {
                                    return A2(Qt, function(e) {
                                        return A2(Qt, function(r) {
                                            return A2(Qt, function(t) {
                                                return A2(Qt, function(u) {
                                                    return nu({
                                                        l1: u,
                                                        fb: t,
                                                        nj: r,
                                                        oT: e,
                                                        f_: n
                                                    });
                                                }, A2(Lu, "food", qu));
                                            }, A2(Lu, "food2", qu));
                                        }, A2(Lu, "objects", qu));
                                    }, A2(Lu, "textile", qu));
                                }, A2(Lu, "veli", qu))));
                            }, A2(Lu, "matomo", A2(Qt, function(n) {
                                return A2(Qt, function(e) {
                                    return nu({
                                        iJ: e,
                                        oz: n
                                    });
                                }, A2(Lu, "host", ai));
                            }, A2(Lu, "siteId", ai))));
                        }, A2(Lu, "plausible", A2(Qt, function(n) {
                            return nu({
                                iJ: n
                            });
                        }, A2(Lu, "host", Ya(E([
                            Za(Hr),
                            A2(Zt, Rr, ai)
                        ]))))));
                    }, A2(Lu, "rawStore", ai));
                }, A2(Lu, "scalingoAppName", Ya(E([
                    Za(Hr),
                    A2(Zt, Rr, ai)
                ]))));
            }, A2(Lu, "versionPollSeconds", xi)))(0)
        }
    }, n.Elm ? function n(e, r) {
        for(var t in r)t in e ? "init" == t ? f(6) : n(e[t], r[t]) : e[t] = r[t];
    }(n.Elm, QN) : n.Elm = QN;
}($be7ebd92b118fa32$exports);


var $873eefa173eeba59$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$873eefa173eeba59$exports = (parcelRequire("31N0p"));


const $d67c357688f604e0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $7297b28254e7319a$export$31499a9cd224b78c = "10.76.2";


const $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1 = globalThis;


function $caaab4f0240c1a5f$export$19eade501500c6c1() {
    $caaab4f0240c1a5f$export$c8bfa33e4e8ae492((0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1));
    return 0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1;
}
function $caaab4f0240c1a5f$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $7297b28254e7319a$export$31499a9cd224b78c);
    return __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] = __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] || {};
}
function $caaab4f0240c1a5f$export$7e223ec222791509(name, creator, obj = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] = __SENTRY__[0, $7297b28254e7319a$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}




const $169ad50b2cdc7abf$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $169ad50b2cdc7abf$var$PREFIX = "Sentry Logger ";
const $169ad50b2cdc7abf$export$77c4ce905194557b = {};
function $169ad50b2cdc7abf$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($169ad50b2cdc7abf$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $169ad50b2cdc7abf$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $169ad50b2cdc7abf$var$enable() {
    $169ad50b2cdc7abf$var$_getLoggerSettings().enabled = true;
}
function $169ad50b2cdc7abf$var$disable() {
    $169ad50b2cdc7abf$var$_getLoggerSettings().enabled = false;
}
function $169ad50b2cdc7abf$var$isEnabled() {
    return $169ad50b2cdc7abf$var$_getLoggerSettings().enabled;
}
function $169ad50b2cdc7abf$var$log(...args) {
    $169ad50b2cdc7abf$var$_maybeLog("log", ...args);
}
function $169ad50b2cdc7abf$var$warn(...args) {
    $169ad50b2cdc7abf$var$_maybeLog("warn", ...args);
}
function $169ad50b2cdc7abf$var$error(...args) {
    $169ad50b2cdc7abf$var$_maybeLog("error", ...args);
}
function $169ad50b2cdc7abf$var$_maybeLog(level, ...args) {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return;
    if ($169ad50b2cdc7abf$var$isEnabled()) $169ad50b2cdc7abf$export$cda52e2a8927a2ca(()=>{
        (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1).console[level](`${$169ad50b2cdc7abf$var$PREFIX}[${level}]:`, ...args);
    });
}
function $169ad50b2cdc7abf$var$_getLoggerSettings() {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $caaab4f0240c1a5f$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $169ad50b2cdc7abf$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $169ad50b2cdc7abf$var$enable,
    disable: /** Disable logging. */ $169ad50b2cdc7abf$var$disable,
    isEnabled: /** Check if logging is enabled. */ $169ad50b2cdc7abf$var$isEnabled,
    log: /** Log a message. */ $169ad50b2cdc7abf$var$log,
    warn: /** Log a warning. */ $169ad50b2cdc7abf$var$warn,
    error: /** Log an error. */ $169ad50b2cdc7abf$var$error
};


const $b7086141421221a8$var$STACKTRACE_FRAME_LIMIT = 50;
const $b7086141421221a8$export$27c7e15d453fc0ac = "?";
const $b7086141421221a8$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $b7086141421221a8$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $b7086141421221a8$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $b7086141421221a8$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($b7086141421221a8$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $b7086141421221a8$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $b7086141421221a8$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $b7086141421221a8$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $b7086141421221a8$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $b7086141421221a8$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($b7086141421221a8$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($b7086141421221a8$var$STRIP_FRAME_REGEXP.test($b7086141421221a8$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($b7086141421221a8$var$STRIP_FRAME_REGEXP.test($b7086141421221a8$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $b7086141421221a8$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $b7086141421221a8$var$getLastStackFrame(localStack).filename,
            function: frame.function || $b7086141421221a8$export$27c7e15d453fc0ac
        }));
}
function $b7086141421221a8$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $b7086141421221a8$var$defaultFunctionName = "<anonymous>";
function $b7086141421221a8$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $b7086141421221a8$var$defaultFunctionName;
        return fn.name || $b7086141421221a8$var$defaultFunctionName;
    } catch  {
        return $b7086141421221a8$var$defaultFunctionName;
    }
}
function $b7086141421221a8$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $b7086141421221a8$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


const $915c7efdb0533300$var$handlers = {};
const $915c7efdb0533300$var$instrumented = {};
function $915c7efdb0533300$export$a4e09611e30da72e(type, handler) {
    $915c7efdb0533300$var$handlers[type] = $915c7efdb0533300$var$handlers[type] || [];
    $915c7efdb0533300$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $915c7efdb0533300$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $915c7efdb0533300$export$b17eab759a1cb5fe() {
    Object.keys($915c7efdb0533300$var$handlers).forEach((key)=>{
        $915c7efdb0533300$var$handlers[key] = void 0;
    });
}
function $915c7efdb0533300$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$915c7efdb0533300$var$instrumented[type]) {
        $915c7efdb0533300$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $915c7efdb0533300$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $915c7efdb0533300$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $b7086141421221a8$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}



const $6f219f5f8ad60f48$var$objectToString = Object.prototype.toString;
function $6f219f5f8ad60f48$export$e6127cc7fe7395c3(wat) {
    switch($6f219f5f8ad60f48$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $6f219f5f8ad60f48$export$49034edbe6b62415(wat, Error);
    }
}
function $6f219f5f8ad60f48$var$isBuiltin(wat, className) {
    return $6f219f5f8ad60f48$var$objectToString.call(wat) === `[object ${className}]`;
}
function $6f219f5f8ad60f48$export$9f9636d330b71954(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "ErrorEvent");
}
function $6f219f5f8ad60f48$export$ef9e2056653f0c8e(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "DOMError");
}
function $6f219f5f8ad60f48$export$12e869b2a583f783(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "DOMException");
}
function $6f219f5f8ad60f48$export$844ec244b1367d54(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "String");
}
function $6f219f5f8ad60f48$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $6f219f5f8ad60f48$export$c3825b437cbdea5c(wat) {
    return wat === null || $6f219f5f8ad60f48$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $6f219f5f8ad60f48$export$53b83ca8eaab0383(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "Object");
}
function $6f219f5f8ad60f48$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $6f219f5f8ad60f48$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $6f219f5f8ad60f48$export$49034edbe6b62415(wat, Event);
}
function $6f219f5f8ad60f48$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $6f219f5f8ad60f48$export$49034edbe6b62415(wat, Element);
}
function $6f219f5f8ad60f48$export$49841c62b9eff15(wat) {
    return $6f219f5f8ad60f48$var$isBuiltin(wat, "RegExp");
}
function $6f219f5f8ad60f48$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $6f219f5f8ad60f48$export$bc2894c7158efbac(wat) {
    return $6f219f5f8ad60f48$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $6f219f5f8ad60f48$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $6f219f5f8ad60f48$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $6f219f5f8ad60f48$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $6f219f5f8ad60f48$export$49034edbe6b62415(request, Request);
}


function $73ebe44591c0f61f$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $73ebe44591c0f61f$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $73ebe44591c0f61f$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $73ebe44591c0f61f$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $73ebe44591c0f61f$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $73ebe44591c0f61f$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($73ebe44591c0f61f$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $73ebe44591c0f61f$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $73ebe44591c0f61f$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $73ebe44591c0f61f$export$62ff257738bf57f5(value) {
    if ((0, $6f219f5f8ad60f48$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$73ebe44591c0f61f$var$getOwnProperties(value)
    };
    if ((0, $6f219f5f8ad60f48$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$73ebe44591c0f61f$var$getOwnProperties(value)
        };
    }
    return value;
}
function $73ebe44591c0f61f$var$getOwnProperties(obj) {
    if ((0, $6f219f5f8ad60f48$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $73ebe44591c0f61f$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($73ebe44591c0f61f$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $73ebe44591c0f61f$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $73ebe44591c0f61f$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $73ebe44591c0f61f$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($73ebe44591c0f61f$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($73ebe44591c0f61f$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $73ebe44591c0f61f$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $73ebe44591c0f61f$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $73ebe44591c0f61f$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




const $6aeaaf927d53c892$var$WINDOW = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
function $6aeaaf927d53c892$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$1c08bd1a7eb3c472() {
    try {
        new DOMError("");
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$67fc34576016d6ec() {
    return "history" in $6aeaaf927d53c892$var$WINDOW && !!$6aeaaf927d53c892$var$WINDOW.history;
}
const $6aeaaf927d53c892$export$edf3cb81fd7d2a3e = $6aeaaf927d53c892$var$_isFetchSupported;
function $6aeaaf927d53c892$var$_isFetchSupported() {
    if (!("fetch" in $6aeaaf927d53c892$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $6aeaaf927d53c892$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $6aeaaf927d53c892$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$6aeaaf927d53c892$var$_isFetchSupported()) return false;
    if ($6aeaaf927d53c892$export$d5f608b368e73f38($6aeaaf927d53c892$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $6aeaaf927d53c892$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $6aeaaf927d53c892$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $6aeaaf927d53c892$export$531055a6c684a70a() {
    return "ReportingObserver" in $6aeaaf927d53c892$var$WINDOW;
}
function $6aeaaf927d53c892$export$2d308b428295192f() {
    if (!$6aeaaf927d53c892$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}



const $e5af6672c42ca74f$export$56d8a8a25bd48b81 = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);


let $b6b753cdb356d243$var$lastHref;
function $b6b753cdb356d243$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, $b6b753cdb356d243$export$d9b613a6254a184e);
}
function $b6b753cdb356d243$export$d9b613a6254a184e() {
    (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).location.href;
        const from = $b6b753cdb356d243$var$lastHref;
        $b6b753cdb356d243$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $915c7efdb0533300$export$b18c893e424d3127)("history", handlerData);
    });
    if (!(0, $6aeaaf927d53c892$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $b6b753cdb356d243$var$lastHref;
                const to = $b6b753cdb356d243$var$getAbsoluteUrl(String(url));
                $b6b753cdb356d243$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $915c7efdb0533300$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $73ebe44591c0f61f$export$9563e054e6f787fb)((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $73ebe44591c0f61f$export$9563e054e6f787fb)((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $b6b753cdb356d243$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}


let $31d8160eeba1365b$var$RESOLVED_RUNNER;
function $31d8160eeba1365b$export$ff239213cb80e2da(cb) {
    if ($31d8160eeba1365b$var$RESOLVED_RUNNER !== void 0) return $31d8160eeba1365b$var$RESOLVED_RUNNER ? $31d8160eeba1365b$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $31d8160eeba1365b$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $31d8160eeba1365b$var$RESOLVED_RUNNER(cb);
    }
    $31d8160eeba1365b$var$RESOLVED_RUNNER = null;
    return cb();
}
function $31d8160eeba1365b$export$9869d72de32a3917() {
    return $31d8160eeba1365b$export$ff239213cb80e2da(()=>Math.random());
}
function $31d8160eeba1365b$export$65b1bada40c91b34() {
    return $31d8160eeba1365b$export$ff239213cb80e2da(()=>Date.now());
}



const $832ed7dc58639895$var$ONE_SECOND_IN_MS = 1e3;
function $832ed7dc58639895$export$7740643b9eeaf0c4() {
    return (0, $31d8160eeba1365b$export$65b1bada40c91b34)() / $832ed7dc58639895$var$ONE_SECOND_IN_MS;
}
function $832ed7dc58639895$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $832ed7dc58639895$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $31d8160eeba1365b$export$ff239213cb80e2da)(()=>performance.now())) / $832ed7dc58639895$var$ONE_SECOND_IN_MS;
    };
}
let $832ed7dc58639895$var$_cachedTimestampInSeconds;
function $832ed7dc58639895$export$ee52dced521e3e18() {
    const func = $832ed7dc58639895$var$_cachedTimestampInSeconds ?? ($832ed7dc58639895$var$_cachedTimestampInSeconds = $832ed7dc58639895$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $832ed7dc58639895$var$cachedTimeOrigin = null;
function $832ed7dc58639895$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $31d8160eeba1365b$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $31d8160eeba1365b$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === "number") {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    return dateNow - performanceNow;
}
function $832ed7dc58639895$export$baf075a948ffc0bf() {
    if ($832ed7dc58639895$var$cachedTimeOrigin === null) $832ed7dc58639895$var$cachedTimeOrigin = $832ed7dc58639895$var$getBrowserTimeOrigin();
    return $832ed7dc58639895$var$cachedTimeOrigin;
}








const $7f5b43a8934525be$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $7f5b43a8934525be$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $7f5b43a8934525be$export$280812de8e91ea53(obj) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(obj, $7f5b43a8934525be$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $7f5b43a8934525be$export$610d1422c4bdc4c1(obj, depth) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(obj, $7f5b43a8934525be$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $7f5b43a8934525be$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$7f5b43a8934525be$var$SENTRY_SKIP_NORMALIZATION]);
}
function $7f5b43a8934525be$export$fe95a19841c4b155(value) {
    const v = value[$7f5b43a8934525be$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}




let $252cc08b60bbad6f$var$stringifier;
function $252cc08b60bbad6f$export$575c40989754ba4d(newStringifier) {
    $252cc08b60bbad6f$var$stringifier = newStringifier;
}
function $252cc08b60bbad6f$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $252cc08b60bbad6f$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $252cc08b60bbad6f$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $252cc08b60bbad6f$export$a3295358bff77e(object, depth);
    if ($252cc08b60bbad6f$var$jsonSize(normalized) > maxSize) return $252cc08b60bbad6f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $252cc08b60bbad6f$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $252cc08b60bbad6f$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $252cc08b60bbad6f$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $7f5b43a8934525be$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $7f5b43a8934525be$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $252cc08b60bbad6f$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $73ebe44591c0f61f$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $252cc08b60bbad6f$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $252cc08b60bbad6f$export$a110e5bc79f44a84(key, value) {
    try {
        if ($252cc08b60bbad6f$var$stringifier) {
            const stringified = $252cc08b60bbad6f$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $b7086141421221a8$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $252cc08b60bbad6f$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $252cc08b60bbad6f$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $252cc08b60bbad6f$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $252cc08b60bbad6f$var$jsonSize(value) {
    return $252cc08b60bbad6f$var$utf8Length(JSON.stringify(value));
}
function $252cc08b60bbad6f$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $252cc08b60bbad6f$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $240729c9e87a40a8$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $240729c9e87a40a8$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $240729c9e87a40a8$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $240729c9e87a40a8$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $252cc08b60bbad6f$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $240729c9e87a40a8$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6f219f5f8ad60f48$export$844ec244b1367d54)(value)) return false;
    if ((0, $6f219f5f8ad60f48$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $6f219f5f8ad60f48$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $240729c9e87a40a8$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($240729c9e87a40a8$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $b7774ea50e5fc610$var$getCrypto() {
    const gbl = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $b7774ea50e5fc610$var$emptyUuid;
function $b7774ea50e5fc610$var$getRandomByte() {
    return (0, $31d8160eeba1365b$export$9869d72de32a3917)() * 16;
}
function $b7774ea50e5fc610$export$19f53698e68b2496(crypto = $b7774ea50e5fc610$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $31d8160eeba1365b$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$b7774ea50e5fc610$var$emptyUuid) $b7774ea50e5fc610$var$emptyUuid = "10000000100040008000100000000000";
    return $b7774ea50e5fc610$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($b7774ea50e5fc610$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $b7774ea50e5fc610$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $b7774ea50e5fc610$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $b7774ea50e5fc610$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $b7774ea50e5fc610$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $b7774ea50e5fc610$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $b7774ea50e5fc610$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
const $b7774ea50e5fc610$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $b7774ea50e5fc610$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $b7774ea50e5fc610$export$d364f2020ab30578(input) {
    const match = input.match($b7774ea50e5fc610$var$SEMVER_REGEXP) || [];
    const major = $b7774ea50e5fc610$var$_parseInt(match[1]);
    const minor = $b7774ea50e5fc610$var$_parseInt(match[2]);
    const patch = $b7774ea50e5fc610$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $b7774ea50e5fc610$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $240729c9e87a40a8$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $240729c9e87a40a8$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $240729c9e87a40a8$export$4215662d762d6f9d)(line, 0));
}
function $b7774ea50e5fc610$export$6de4ffac6a2f1098(exception) {
    if ($b7774ea50e5fc610$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $b7774ea50e5fc610$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}



function $147ead9012039c3a$export$14a186326edbb264(context) {
    const startingTime = (0, $832ed7dc58639895$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $b7774ea50e5fc610$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$147ead9012039c3a$var$sessionToJSON(session)
    };
    if (context) $147ead9012039c3a$export$531818e825e774db(session, context);
    return session;
}
function $147ead9012039c3a$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $832ed7dc58639895$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $b7774ea50e5fc610$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $147ead9012039c3a$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $147ead9012039c3a$export$531818e825e774db(session, context);
}
function $147ead9012039c3a$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




function $bdef46c1949b0f5f$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $bdef46c1949b0f5f$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10() {
    return (0, $b7774ea50e5fc610$export$19f53698e68b2496)();
}
function $c36ec88dc0f9fe8f$export$295213bc4d0c54ad() {
    return (0, $b7774ea50e5fc610$export$19f53698e68b2496)().substring(16);
}





function $3d6c79bec07a66e3$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $3d6c79bec07a66e3$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $1322a11ccbaccbb5$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $1322a11ccbaccbb5$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(scope, $1322a11ccbaccbb5$var$SCOPE_SPAN_FIELD, (0, $3d6c79bec07a66e3$export$f0b98edec95fcb33)(span));
    else delete scope[$1322a11ccbaccbb5$var$SCOPE_SPAN_FIELD];
}
function $1322a11ccbaccbb5$export$91f063ebb8eff307(scope) {
    return (0, $3d6c79bec07a66e3$export$a0592ad8c3586cf)(scope[$1322a11ccbaccbb5$var$SCOPE_SPAN_FIELD]);
}




const $60fa6d98704d30f2$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $60fa6d98704d30f2$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $31d8160eeba1365b$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $60fa6d98704d30f2$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $1322a11ccbaccbb5$export$3f25fa50c18e20ca)(newScope, (0, $1322a11ccbaccbb5$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $147ead9012039c3a$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $60fa6d98704d30f2$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $6f219f5f8ad60f48$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   *
   * @deprecated This method will be removed in v11. To reset scope state, re-initialize the SDK or run
   * your code in a fresh scope via `withScope` instead.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $1322a11ccbaccbb5$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $31d8160eeba1365b$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $60fa6d98704d30f2$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $832ed7dc58639895$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $240729c9e87a40a8$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $1322a11ccbaccbb5$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $bdef46c1949b0f5f$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $b7774ea50e5fc610$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $b7774ea50e5fc610$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $b7774ea50e5fc610$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $de18f94873bd9e63$export$6f1b9191db9c4d5() {
    return (0, $caaab4f0240c1a5f$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $60fa6d98704d30f2$export$775b6bb06e53a214)());
}
function $de18f94873bd9e63$export$de9862929b76bf57() {
    return (0, $caaab4f0240c1a5f$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $60fa6d98704d30f2$export$775b6bb06e53a214)());
}



const $4edc0d7ce1c2a0e2$var$isActualPromise = (p)=>p instanceof Promise && !p[$4edc0d7ce1c2a0e2$var$kChainedCopy];
const $4edc0d7ce1c2a0e2$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $4edc0d7ce1c2a0e2$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $4edc0d7ce1c2a0e2$var$isActualPromise(chained) && $4edc0d7ce1c2a0e2$var$isActualPromise(original) ? chained : $4edc0d7ce1c2a0e2$var$copyProps(original, chained);
};
const $4edc0d7ce1c2a0e2$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$4edc0d7ce1c2a0e2$var$kChainedCopy]: true
    });
    return chained;
};




class $79cc82e71adc604c$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $60fa6d98704d30f2$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $60fa6d98704d30f2$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $6f219f5f8ad60f48$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $4edc0d7ce1c2a0e2$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $79cc82e71adc604c$var$getAsyncContextStack() {
    const registry = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const sentry = (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $79cc82e71adc604c$export$d36ec451f120cfba((0, $de18f94873bd9e63$export$6f1b9191db9c4d5)(), (0, $de18f94873bd9e63$export$de9862929b76bf57)());
}
function $79cc82e71adc604c$var$withScope(callback) {
    return $79cc82e71adc604c$var$getAsyncContextStack().withScope(callback);
}
function $79cc82e71adc604c$var$withSetScope(scope, callback) {
    const stack = $79cc82e71adc604c$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $79cc82e71adc604c$var$withIsolationScope(callback) {
    return $79cc82e71adc604c$var$getAsyncContextStack().withScope(()=>{
        return callback($79cc82e71adc604c$var$getAsyncContextStack().getIsolationScope());
    });
}
function $79cc82e71adc604c$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $79cc82e71adc604c$var$withIsolationScope,
        withScope: $79cc82e71adc604c$var$withScope,
        withSetScope: $79cc82e71adc604c$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $79cc82e71adc604c$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$79cc82e71adc604c$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$79cc82e71adc604c$var$getAsyncContextStack().getIsolationScope()
    };
}


function $b32f8dd6526a279e$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const sentry = (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $b32f8dd6526a279e$export$f639b0c2752203be(carrier) {
    const sentry = (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $79cc82e71adc604c$export$329d4d4d54e42710)();
}





let $bf0da3485a76f55c$var$_externalPropagationContextProvider;
function $bf0da3485a76f55c$export$b5defb3466e9689b(fn) {
    $bf0da3485a76f55c$var$_externalPropagationContextProvider = fn;
}
function $bf0da3485a76f55c$export$92547f779c920a71() {
    return $bf0da3485a76f55c$var$_externalPropagationContextProvider?.();
}
function $bf0da3485a76f55c$export$53f0ae651a1c4298() {
    return $bf0da3485a76f55c$var$_externalPropagationContextProvider !== void 0;
}
function $bf0da3485a76f55c$export$c7be4b0125a10cba() {
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const acs = (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $bf0da3485a76f55c$export$68f3af03034c9e90() {
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const acs = (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $bf0da3485a76f55c$export$aa55d5ab8e05984f() {
    return (0, $caaab4f0240c1a5f$export$7e223ec222791509)("globalScope", ()=>new (0, $60fa6d98704d30f2$export$775b6bb06e53a214)());
}
function $bf0da3485a76f55c$export$ec58d9285c204497(...rest) {
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const acs = (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $bf0da3485a76f55c$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const acs = (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $bf0da3485a76f55c$export$6bb76d6eba7e258c() {
    return $bf0da3485a76f55c$export$c7be4b0125a10cba().getClient();
}
function $bf0da3485a76f55c$export$1e83db7ee4876dc4(scope) {
    const externalContext = $bf0da3485a76f55c$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $c36ec88dc0f9fe8f$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


const $f9cdc34f66cb8508$export$59adc876c1ebd512 = "[Filtered]";
const $f9cdc34f66cb8508$export$8d9b1945e94c47d = [
    "forwarded",
    "-ip",
    "remote-",
    "via",
    "-user"
];
const $f9cdc34f66cb8508$export$cdee6254fbd57505 = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $f9cdc34f66cb8508$export$6f34743829a9a6fb = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];



function $b9e4e45c6ecb2255$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $b9e4e45c6ecb2255$export$1a2b255c1788eeeb(key, behavior, additionalDenyTerms) {
    if (behavior === false) return true;
    const lowerKey = key.toLowerCase();
    const denySnippets = additionalDenyTerms != null ? [
        ...(0, $f9cdc34f66cb8508$export$cdee6254fbd57505),
        ...additionalDenyTerms
    ] : (0, $f9cdc34f66cb8508$export$cdee6254fbd57505);
    if ($b9e4e45c6ecb2255$var$isSensitiveKey(lowerKey, denySnippets)) return true;
    if (behavior === true) return false;
    const terms = "deny" in behavior ? behavior.deny : behavior.allow;
    const matchesConfiguredTerm = terms.some((term)=>lowerKey.includes(term.toLowerCase()));
    return "deny" in behavior ? matchesConfiguredTerm : !matchesConfiguredTerm;
}
function $b9e4e45c6ecb2255$export$73acb6f35c15da01(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const result = {};
    for (const key of Object.keys(data))result[key] = $b9e4e45c6ecb2255$export$1a2b255c1788eeeb(key, behavior, additionalDenyTerms) ? (0, $f9cdc34f66cb8508$export$59adc876c1ebd512) : data[key];
    return result;
}


function $d9f54eeac9736862$export$7e88e8c4177d6404(queryString, behavior) {
    if (!queryString || behavior === false) return void 0;
    return queryString.split("&").map((pair)=>{
        const separatorIndex = pair.indexOf("=");
        const encodedKey = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
        const key = new URLSearchParams(`${encodedKey}=`).keys().next().value;
        return key !== void 0 && (0, $b9e4e45c6ecb2255$export$1a2b255c1788eeeb)(key, behavior) ? `${encodedKey}=${0, $f9cdc34f66cb8508$export$59adc876c1ebd512}` : pair;
    }).join("&");
}



function $6ed8ed44759296c6$export$55957a65a66aa868(url, behavior) {
    const fragmentStart = url.indexOf("#");
    const queryEnd = fragmentStart === -1 ? url.length : fragmentStart;
    const queryStart = url.indexOf("?");
    if (queryStart === -1 || queryStart > queryEnd) return url;
    const prefix = url.slice(0, queryStart);
    const query = url.slice(queryStart + 1, queryEnd);
    const suffix = url.slice(queryEnd);
    const filtered = (0, $d9f54eeac9736862$export$7e88e8c4177d6404)(query, behavior);
    return filtered ? `${prefix}?${filtered}${suffix}` : `${prefix}${suffix}`;
}


function $316dd9f7cb631407$var$urlQueryParamsBehavior(client) {
    return (client ?? (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)())?.getDataCollectionOptions().urlQueryParams ?? true;
}
function $316dd9f7cb631407$export$9dbd5b9f0d1db392(url, client) {
    return url === void 0 ? void 0 : (0, $6ed8ed44759296c6$export$55957a65a66aa868)(url, $316dd9f7cb631407$var$urlQueryParamsBehavior(client));
}
function $316dd9f7cb631407$export$8cbd6331b69d8fe6(query, client) {
    if (!query) return query;
    const hasPrefix = query.startsWith("?");
    const filtered = (0, $d9f54eeac9736862$export$7e88e8c4177d6404)(hasPrefix ? query.slice(1) : query, $316dd9f7cb631407$var$urlQueryParamsBehavior(client));
    return filtered && hasPrefix ? `?${filtered}` : filtered;
}



function $b9f63c0e5bd394fa$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $b9f63c0e5bd394fa$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $b9f63c0e5bd394fa$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $b9f63c0e5bd394fa$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $b9f63c0e5bd394fa$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $b9f63c0e5bd394fa$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $b9f63c0e5bd394fa$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $b9f63c0e5bd394fa$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(val)) weight += $b9f63c0e5bd394fa$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $b9f63c0e5bd394fa$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $b9f63c0e5bd394fa$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}




const $262ea1feb4b3c3f2$export$d7a7d984b0791405 = "sentry.source";
const $262ea1feb4b3c3f2$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $262ea1feb4b3c3f2$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $262ea1feb4b3c3f2$export$1a413bd9a88fdb09 = "sentry.op";
const $262ea1feb4b3c3f2$export$cca8dd30f57f805e = "sentry.origin";
const $262ea1feb4b3c3f2$export$d9e02c0285078f88 = "sentry.status.message";
const $262ea1feb4b3c3f2$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $262ea1feb4b3c3f2$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $262ea1feb4b3c3f2$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $262ea1feb4b3c3f2$export$f5cefb258679b29e = "sentry.release";
const $262ea1feb4b3c3f2$export$d1b1dbb47f5ba57c = "sentry.environment";
const $262ea1feb4b3c3f2$export$4626f2be16112c1c = "sentry.segment.name";
const $262ea1feb4b3c3f2$export$25fa4a1832d3736a = "sentry.segment.id";
const $262ea1feb4b3c3f2$export$87a4807042e1f1bb = "sentry.sdk.name";
const $262ea1feb4b3c3f2$export$301ebe936458e291 = "sentry.sdk.version";
const $262ea1feb4b3c3f2$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $262ea1feb4b3c3f2$export$1f9cc1d34ea098a0 = "user.id";
const $262ea1feb4b3c3f2$export$b7466609ef46c07e = "user.email";
const $262ea1feb4b3c3f2$export$8d592bdaea63b930 = "user.ip_address";
const $262ea1feb4b3c3f2$export$c05ee933d3f74b2b = "user.name";
const $262ea1feb4b3c3f2$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $262ea1feb4b3c3f2$export$1efec95406bbe327 = "sentry.profile_id";
const $262ea1feb4b3c3f2$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $262ea1feb4b3c3f2$export$b016f89ac1066ec = "cache.hit";
const $262ea1feb4b3c3f2$export$3110e4c3f4386399 = "cache.key";
const $262ea1feb4b3c3f2$export$86be76deee227ff2 = "cache.item_size";
const $262ea1feb4b3c3f2$export$be7a251980e7e946 = "http.request.method";
const $262ea1feb4b3c3f2$export$25dfd73e0e32c6e1 = "url.full";
const $262ea1feb4b3c3f2$export$ff77b5fd5b2d627b = "sentry.link.type";
const $262ea1feb4b3c3f2$export$71a4a707257f2774 = "gen_ai.conversation.id";


const $973ca8728f347b7f$export$136e25984ba4a383 = 0;
const $973ca8728f347b7f$export$58f7963109c806fc = 1;
const $973ca8728f347b7f$export$f966a0446ece71e = 2;
function $973ca8728f347b7f$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $973ca8728f347b7f$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $973ca8728f347b7f$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $973ca8728f347b7f$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $973ca8728f347b7f$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $973ca8728f347b7f$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




const $4af3f5dbd49d01cc$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $4af3f5dbd49d01cc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $4af3f5dbd49d01cc$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $4af3f5dbd49d01cc$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $4af3f5dbd49d01cc$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $4af3f5dbd49d01cc$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(span, $4af3f5dbd49d01cc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $3d6c79bec07a66e3$export$f0b98edec95fcb33)(isolationScope));
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(span, $4af3f5dbd49d01cc$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $4af3f5dbd49d01cc$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$4af3f5dbd49d01cc$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $3d6c79bec07a66e3$export$a0592ad8c3586cf)(spanWithScopes[$4af3f5dbd49d01cc$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $4af3f5dbd49d01cc$export$d135494e80cbbcae(span) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(span, $4af3f5dbd49d01cc$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $4af3f5dbd49d01cc$export$2e69b79005fc86eb(span) {
    return span[$4af3f5dbd49d01cc$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $4af3f5dbd49d01cc$export$c45f16c039fb5033(span) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(span, $4af3f5dbd49d01cc$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $4af3f5dbd49d01cc$export$aceb4106f395d20e(span) {
    return span[$4af3f5dbd49d01cc$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $4af3f5dbd49d01cc$export$6ba79447c0a2d852(span) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(span, $4af3f5dbd49d01cc$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $4af3f5dbd49d01cc$export$a9ba2a501dbf6a56(span) {
    return span[$4af3f5dbd49d01cc$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}









const $9dc3c94210b331cf$export$6e69537d67fa20f = "sentry-";
const $9dc3c94210b331cf$export$eb0401070c617ea5 = /^sentry-/;
const $9dc3c94210b331cf$export$bdd844ddb2def819 = 8192;
function $9dc3c94210b331cf$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $9dc3c94210b331cf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($9dc3c94210b331cf$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($9dc3c94210b331cf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $9dc3c94210b331cf$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9dc3c94210b331cf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9dc3c94210b331cf$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $9dc3c94210b331cf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $6f219f5f8ad60f48$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9dc3c94210b331cf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $9dc3c94210b331cf$var$baggageHeaderToObject(baggageHeader);
}
function $9dc3c94210b331cf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $9dc3c94210b331cf$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9dc3c94210b331cf$export$bdd844ddb2def819) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $9dc3c94210b331cf$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $9dc3c94210b331cf$export$397de414d189db00(existing);
    const incomingEntries = $9dc3c94210b331cf$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($9dc3c94210b331cf$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($9dc3c94210b331cf$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $9dc3c94210b331cf$export$12a7349a29a6e3c2(merged);
}




const $8793b0e0916282a8$var$ORG_ID_REGEX = /^o(\d+)\./;
const $8793b0e0916282a8$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $8793b0e0916282a8$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $8793b0e0916282a8$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $8793b0e0916282a8$export$b892860177f70a30(str) {
    const match = $8793b0e0916282a8$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $169ad50b2cdc7abf$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $8793b0e0916282a8$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $8793b0e0916282a8$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $8793b0e0916282a8$var$validateDsn(dsn) {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$8793b0e0916282a8$var$isValidProtocol(protocol)) {
        (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $8793b0e0916282a8$export$5914f4e7748c29c9(host) {
    const match = host.match($8793b0e0916282a8$var$ORG_ID_REGEX);
    return match?.[1];
}
function $8793b0e0916282a8$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $8793b0e0916282a8$export$5914f4e7748c29c9(host);
    return org_id;
}
function $8793b0e0916282a8$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $8793b0e0916282a8$export$b892860177f70a30(from) : $8793b0e0916282a8$var$dsnFromComponents(from);
    if (!components || !$8793b0e0916282a8$var$validateDsn(components)) return void 0;
    return components;
}


function $a59632605f3da4e2$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $8e829119ae04d50d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $8e829119ae04d50d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($8e829119ae04d50d$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $8e829119ae04d50d$export$d6559160aa7f14fa(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $8e829119ae04d50d$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $8e829119ae04d50d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9dc3c94210b331cf$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $31d8160eeba1365b$export$9869d72de32a3917)()
    };
    const sampleRand = $8e829119ae04d50d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $8e829119ae04d50d$export$f35d907436da45cf(traceId = (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)(), spanId = (0, $c36ec88dc0f9fe8f$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $8e829119ae04d50d$export$1aff3752542747dd(traceId = (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)(), spanId = (0, $c36ec88dc0f9fe8f$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $8e829119ae04d50d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $a59632605f3da4e2$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $a59632605f3da4e2$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $31d8160eeba1365b$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $31d8160eeba1365b$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $31d8160eeba1365b$export$9869d72de32a3917)();
}
function $8e829119ae04d50d$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $8793b0e0916282a8$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




const $ca720f03249a0481$export$208d5b368507fb8b = 0;
const $ca720f03249a0481$export$eb571cd9b5d98de8 = 1;
let $ca720f03249a0481$var$hasShownSpanDropWarning = false;
function $ca720f03249a0481$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $ca720f03249a0481$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $ca720f03249a0481$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $ca720f03249a0481$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $4af3f5dbd49d01cc$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $c36ec88dc0f9fe8f$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $ca720f03249a0481$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ca720f03249a0481$export$5caecac1caaf3a71(span);
    return (0, $8e829119ae04d50d$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $ca720f03249a0481$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $ca720f03249a0481$export$5caecac1caaf3a71(span);
    return (0, $8e829119ae04d50d$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $ca720f03249a0481$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $ca720f03249a0481$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $ca720f03249a0481$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $ca720f03249a0481$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $ca720f03249a0481$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $ca720f03249a0481$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $ca720f03249a0481$var$ensureTimestampInSeconds(input.getTime());
    return (0, $832ed7dc58639895$export$ee52dced521e3e18)();
}
function $ca720f03249a0481$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $ca720f03249a0481$export$92d8c23565496537(span) {
    if ($ca720f03249a0481$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($ca720f03249a0481$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $ca720f03249a0481$var$getOtelParentSpanId(span),
            start_timestamp: $ca720f03249a0481$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $ca720f03249a0481$export$3f7581298f56c6d7(endTime) || void 0,
            status: $ca720f03249a0481$export$e238a77ea3a8cd66(status),
            op: attributes[0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09],
            origin: attributes[0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e],
            links: $ca720f03249a0481$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $ca720f03249a0481$export$db0cad9e44f67af8(span) {
    if ($ca720f03249a0481$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($ca720f03249a0481$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $ca720f03249a0481$var$getOtelParentSpanId(span),
            start_timestamp: $ca720f03249a0481$export$3f7581298f56c6d7(startTime),
            end_timestamp: $ca720f03249a0481$export$3f7581298f56c6d7(endTime),
            is_segment: span === $ca720f03249a0481$export$7a3106f345d83bb6(span),
            status: $ca720f03249a0481$export$d3856a3187d34821(status),
            attributes: $ca720f03249a0481$export$1464a9cb828ba99f(attributes, status),
            links: $ca720f03249a0481$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $ca720f03249a0481$export$7a3106f345d83bb6(span)
    };
}
function $ca720f03249a0481$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $ca720f03249a0481$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $b9f63c0e5bd394fa$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $b9f63c0e5bd394fa$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $ca720f03249a0481$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $ca720f03249a0481$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $ca720f03249a0481$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $ca720f03249a0481$export$eb571cd9b5d98de8;
}
function $ca720f03249a0481$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $973ca8728f347b7f$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $973ca8728f347b7f$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $ca720f03249a0481$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $973ca8728f347b7f$export$58f7963109c806fc) || status.code === (0, $973ca8728f347b7f$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $ca720f03249a0481$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $ca720f03249a0481$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $262ea1feb4b3c3f2$export$d9e02c0285078f88)]: statusMessage
        },
        ...attributes
    };
}
const $ca720f03249a0481$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $ca720f03249a0481$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $ca720f03249a0481$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$ca720f03249a0481$var$ROOT_SPAN_FIELD] || span;
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(childSpan, $ca720f03249a0481$var$ROOT_SPAN_FIELD, rootSpan);
    if (!$ca720f03249a0481$export$5caecac1caaf3a71(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$ca720f03249a0481$var$CHILD_SPANS_FIELD]) span[$ca720f03249a0481$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(span, $ca720f03249a0481$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $ca720f03249a0481$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$ca720f03249a0481$var$CHILD_SPANS_FIELD]) span[$ca720f03249a0481$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $ca720f03249a0481$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($ca720f03249a0481$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$ca720f03249a0481$var$CHILD_SPANS_FIELD] ? Array.from(span2[$ca720f03249a0481$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $ca720f03249a0481$export$c4c6a79b1260ca1b = $ca720f03249a0481$export$7a3106f345d83bb6;
function $ca720f03249a0481$export$7a3106f345d83bb6(span) {
    return span[$ca720f03249a0481$var$ROOT_SPAN_FIELD] || span;
}
function $ca720f03249a0481$export$1be426a8e585c83e() {
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const acs = (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $1322a11ccbaccbb5$export$91f063ebb8eff307)((0, $bf0da3485a76f55c$export$c7be4b0125a10cba)());
}
function $ca720f03249a0481$export$d11691ff45a3e535() {
    if (!$ca720f03249a0481$var$hasShownSpanDropWarning) {
        (0, $169ad50b2cdc7abf$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $ca720f03249a0481$var$hasShownSpanDropWarning = true;
    }
}
function $ca720f03249a0481$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $262ea1feb4b3c3f2$export$d7a7d984b0791405)]: "custom",
        [(0, $262ea1feb4b3c3f2$export$165ce9a229f6f050)]: name
    });
}



const $37ff30eb277ba31f$var$WINDOW = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1);
const $37ff30eb277ba31f$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $37ff30eb277ba31f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $37ff30eb277ba31f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $37ff30eb277ba31f$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $37ff30eb277ba31f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($37ff30eb277ba31f$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $37ff30eb277ba31f$export$1cfafeee2987818b() {
    try {
        return $37ff30eb277ba31f$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $37ff30eb277ba31f$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$37ff30eb277ba31f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


var $eAISS = parcelRequire("eAISS");


const $a84a12f71fcd2e74$var$DEFAULT_BASE_URL = "thismessage:/";
function $a84a12f71fcd2e74$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $a84a12f71fcd2e74$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $a84a12f71fcd2e74$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $a84a12f71fcd2e74$export$5339fcdc8e2a427c(url) {
    if ($a84a12f71fcd2e74$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $a84a12f71fcd2e74$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $a84a12f71fcd2e74$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $a84a12f71fcd2e74$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName, client) {
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $262ea1feb4b3c3f2$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $262ea1feb4b3c3f2$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $262ea1feb4b3c3f2$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = (0, $316dd9f7cb631407$export$8cbd6331b69d8fe6)(urlObject.search, client);
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $262ea1feb4b3c3f2$export$d7a7d984b0791405] = "route";
        }
        if (!$a84a12f71fcd2e74$export$e258e13805402ba7(urlObject)) {
            attributes[0, $eAISS.URL_FULL] = (0, $316dd9f7cb631407$export$9dbd5b9f0d1db392)(urlObject.href, client);
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $a84a12f71fcd2e74$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $a84a12f71fcd2e74$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $a84a12f71fcd2e74$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $a84a12f71fcd2e74$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $a84a12f71fcd2e74$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}





function $af068cc29089130f$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $ca720f03249a0481$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $262ea1feb4b3c3f2$export$69cd5c610c7bb96a)]: value,
            [(0, $262ea1feb4b3c3f2$export$f5f95cff026507b5)]: unit
        });
    }
}
function $af068cc29089130f$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $262ea1feb4b3c3f2$export$f5f95cff026507b5];
        const value = attributes[0, $262ea1feb4b3c3f2$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $519e8d19cc16330e$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $519e8d19cc16330e$var$accessors = {};
try {
    if (typeof Node !== "undefined") $519e8d19cc16330e$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $519e8d19cc16330e$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $519e8d19cc16330e$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $519e8d19cc16330e$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $519e8d19cc16330e$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $519e8d19cc16330e$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $519e8d19cc16330e$var$_safeRead(el, prop, arg) {
    const fn = $519e8d19cc16330e$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $519e8d19cc16330e$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $519e8d19cc16330e$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $519e8d19cc16330e$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $519e8d19cc16330e$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $519e8d19cc16330e$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $519e8d19cc16330e$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $519e8d19cc16330e$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$519e8d19cc16330e$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $519e8d19cc16330e$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $519e8d19cc16330e$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $519e8d19cc16330e$var$_safeRead(el, "className");
        if (className && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $519e8d19cc16330e$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}




const $fd229e17678bfd20$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $8659a9368a456d8e$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $8659a9368a456d8e$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $8659a9368a456d8e$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




const $d05968deb75a93e3$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $0de1d6d397151f24$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $d05968deb75a93e3$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



function $75b0920d6d85e459$export$26d3d892edc56833(type, listener, options) {
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document) (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $75b0920d6d85e459$export$324d7b4b46528191(type, listener, options) {
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document) (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


let $d0d9672b1890eaa7$var$firstHiddenTime = -1;
const $d0d9672b1890eaa7$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $d0d9672b1890eaa7$var$initHiddenTime = ()=>{
    return (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $d0d9672b1890eaa7$var$onVisibilityUpdate = (event)=>{
    if ($d0d9672b1890eaa7$var$isPageHidden(event) && $d0d9672b1890eaa7$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $d0d9672b1890eaa7$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($d0d9672b1890eaa7$var$firstHiddenTime)) {
            $d0d9672b1890eaa7$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $75b0920d6d85e459$export$324d7b4b46528191)("prerenderingchange", $d0d9672b1890eaa7$var$onVisibilityUpdate, true);
        }
    }
};
const $d0d9672b1890eaa7$export$443f86b2c77012c4 = ()=>{
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document && $d0d9672b1890eaa7$var$firstHiddenTime < 0) {
        const activationStart = (0, $0de1d6d397151f24$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $d0d9672b1890eaa7$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $d0d9672b1890eaa7$var$initHiddenTime();
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("visibilitychange", $d0d9672b1890eaa7$var$onVisibilityUpdate, true);
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("pagehide", $d0d9672b1890eaa7$var$onVisibilityUpdate, true);
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("prerenderingchange", $d0d9672b1890eaa7$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $d0d9672b1890eaa7$var$firstHiddenTime;
        },
        onHidden (cb) {
            $d0d9672b1890eaa7$var$onHiddenFunctions.add(cb);
        }
    };
};
function $d0d9672b1890eaa7$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.visibilityState === "hidden";
}



const $45f352632edde7f7$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $db1ae63585367fae$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $d05968deb75a93e3$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.prerendering || (0, $0de1d6d397151f24$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $45f352632edde7f7$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $5e424f568738128e$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $5e424f568738128e$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$5e424f568738128e$var$instanceMap.get(identityObj)) $5e424f568738128e$var$instanceMap.set(identityObj, new ClassObj());
        return $5e424f568738128e$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $d135b99de4b7b785$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $daa0fcd2e73d2c43$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};


const $5f99fbcfcafd9517$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








const $4a4bbec51fc7ae9a$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $0f74a772bb82eeed$export$e610c735b5510cec = [
    1800,
    3e3
];
const $0f74a772bb82eeed$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $4a4bbec51fc7ae9a$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $d0d9672b1890eaa7$export$443f86b2c77012c4)();
        const metric = (0, $db1ae63585367fae$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $0de1d6d397151f24$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $daa0fcd2e73d2c43$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $8659a9368a456d8e$export$17679dccdd551979)(onReport, metric, $0f74a772bb82eeed$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $4be871ee509322ce$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $4be871ee509322ce$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $0f74a772bb82eeed$export$fe3c86b74e15d5de)((0, $5f99fbcfcafd9517$export$b841d51e31c12bab)(()=>{
        const metric = (0, $db1ae63585367fae$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $d0d9672b1890eaa7$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $5e424f568738128e$export$7c74c9b2462ddb3c)(opts, (0, $d135b99de4b7b785$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $daa0fcd2e73d2c43$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $8659a9368a456d8e$export$17679dccdd551979)(onReport, metric, $4be871ee509322ce$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







let $b8e97080306d906f$var$interactionCountEstimate = 0;
let $b8e97080306d906f$var$minKnownInteractionId = Infinity;
let $b8e97080306d906f$var$maxKnownInteractionId = 0;
const $b8e97080306d906f$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $b8e97080306d906f$var$minKnownInteractionId = Math.min($b8e97080306d906f$var$minKnownInteractionId, e.interactionId);
            $b8e97080306d906f$var$maxKnownInteractionId = Math.max($b8e97080306d906f$var$maxKnownInteractionId, e.interactionId);
            $b8e97080306d906f$var$interactionCountEstimate = $b8e97080306d906f$var$maxKnownInteractionId ? ($b8e97080306d906f$var$maxKnownInteractionId - $b8e97080306d906f$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $b8e97080306d906f$var$po;
const $b8e97080306d906f$export$8a962f2683a476d1 = ()=>{
    return $b8e97080306d906f$var$po ? $b8e97080306d906f$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $b8e97080306d906f$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $b8e97080306d906f$var$po) return;
    $b8e97080306d906f$var$po = (0, $daa0fcd2e73d2c43$export$d1203567a167490e)("event", $b8e97080306d906f$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $08ce4a0c8d901914$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $08ce4a0c8d901914$var$prevInteractionCount = 0;
const $08ce4a0c8d901914$var$getInteractionCountForNavigation = ()=>{
    return (0, $b8e97080306d906f$export$8a962f2683a476d1)() - $08ce4a0c8d901914$var$prevInteractionCount;
};
class $08ce4a0c8d901914$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $08ce4a0c8d901914$var$prevInteractionCount = (0, $b8e97080306d906f$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($08ce4a0c8d901914$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $08ce4a0c8d901914$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $08ce4a0c8d901914$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($08ce4a0c8d901914$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








const $c4a2423438059f45$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).requestIdleCallback || (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        cb = (0, $5f99fbcfcafd9517$export$b841d51e31c12bab)(cb);
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("visibilitychange", cb, {
            once: true,
            capture: true
        });
        (0, $75b0920d6d85e459$export$26d3d892edc56833)("pagehide", cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            (0, $75b0920d6d85e459$export$324d7b4b46528191)("visibilitychange", cb, {
                capture: true
            });
            (0, $75b0920d6d85e459$export$324d7b4b46528191)("pagehide", cb, {
                capture: true
            });
        });
    }
};


const $ad1fea66d5bbad1d$export$7f4cb060ded9173c = [
    200,
    500
];
const $ad1fea66d5bbad1d$var$DEFAULT_DURATION_THRESHOLD = 40;
const $ad1fea66d5bbad1d$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $d0d9672b1890eaa7$export$443f86b2c77012c4)();
    (0, $4a4bbec51fc7ae9a$export$8bdb38a5671b594e)(()=>{
        (0, $b8e97080306d906f$export$67d90cda6b78a2eb)();
        const metric = (0, $db1ae63585367fae$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $5e424f568738128e$export$7c74c9b2462ddb3c)(opts, (0, $08ce4a0c8d901914$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $c4a2423438059f45$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $daa0fcd2e73d2c43$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $ad1fea66d5bbad1d$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $8659a9368a456d8e$export$17679dccdd551979)(onReport, metric, $ad1fea66d5bbad1d$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








class $a5cbd4d65101f36b$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






const $0831c6462681d3f2$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $0831c6462681d3f2$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $4a4bbec51fc7ae9a$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $d0d9672b1890eaa7$export$443f86b2c77012c4)();
        const metric = (0, $db1ae63585367fae$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $5e424f568738128e$export$7c74c9b2462ddb3c)(opts, (0, $a5cbd4d65101f36b$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                if (!entry) continue;
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $0de1d6d397151f24$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $daa0fcd2e73d2c43$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $8659a9368a456d8e$export$17679dccdd551979)(onReport, metric, $0831c6462681d3f2$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $5f99fbcfcafd9517$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $c4a2423438059f45$export$d3314d5863fc1fef)(stopListening);
                    (0, $75b0920d6d85e459$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $75b0920d6d85e459$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









const $3896b5861f56d55e$export$65c59ea8064668fc = [
    800,
    1800
];
const $3896b5861f56d55e$var$whenReady = (callback)=>{
    if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.prerendering) (0, $4a4bbec51fc7ae9a$export$8bdb38a5671b594e)(()=>$3896b5861f56d55e$var$whenReady(callback));
    else if ((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$3896b5861f56d55e$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $3896b5861f56d55e$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $db1ae63585367fae$export$3c29b44508a0612b)("TTFB");
    const report = (0, $8659a9368a456d8e$export$17679dccdd551979)(onReport, metric, $3896b5861f56d55e$export$65c59ea8064668fc, opts.reportAllChanges);
    $3896b5861f56d55e$var$whenReady(()=>{
        const navigationEntry = (0, $d05968deb75a93e3$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $0de1d6d397151f24$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $f632639e2f71bdc9$var$handlers = {};
const $f632639e2f71bdc9$var$instrumented = {};
let $f632639e2f71bdc9$var$_previousCls;
let $f632639e2f71bdc9$var$_previousLcp;
let $f632639e2f71bdc9$var$_previousTtfb;
let $f632639e2f71bdc9$var$_previousInp;
function $f632639e2f71bdc9$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $f632639e2f71bdc9$var$addMetricObserver("cls", callback, $f632639e2f71bdc9$var$instrumentCls, $f632639e2f71bdc9$var$_previousCls, stopOnCallback);
}
function $f632639e2f71bdc9$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $f632639e2f71bdc9$var$addMetricObserver("lcp", callback, $f632639e2f71bdc9$var$instrumentLcp, $f632639e2f71bdc9$var$_previousLcp, stopOnCallback);
}
function $f632639e2f71bdc9$export$699d9529c099a797(callback) {
    return $f632639e2f71bdc9$var$addMetricObserver("ttfb", callback, $f632639e2f71bdc9$var$instrumentTtfb, $f632639e2f71bdc9$var$_previousTtfb);
}
function $f632639e2f71bdc9$export$da3b76aa2022cbd7(callback) {
    return $f632639e2f71bdc9$var$addMetricObserver("inp", callback, $f632639e2f71bdc9$var$instrumentInp, $f632639e2f71bdc9$var$_previousInp);
}
function $f632639e2f71bdc9$export$69816c1a049f8db6(type, callback) {
    $f632639e2f71bdc9$var$addHandler(type, callback);
    if (!$f632639e2f71bdc9$var$instrumented[type]) {
        $f632639e2f71bdc9$var$instrumentPerformanceObserver(type);
        $f632639e2f71bdc9$var$instrumented[type] = true;
    }
    return $f632639e2f71bdc9$var$getCleanupCallback(type, callback);
}
function $f632639e2f71bdc9$var$triggerHandlers(type, data) {
    const typeHandlers = $f632639e2f71bdc9$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $b7086141421221a8$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}
function $f632639e2f71bdc9$var$instrumentCls() {
    return (0, $4be871ee509322ce$export$a7873055838e5ad8)((metric)=>{
        $f632639e2f71bdc9$var$triggerHandlers("cls", {
            metric: metric
        });
        $f632639e2f71bdc9$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $f632639e2f71bdc9$var$instrumentLcp() {
    return (0, $0831c6462681d3f2$export$947b1626ab8d5632)((metric)=>{
        $f632639e2f71bdc9$var$triggerHandlers("lcp", {
            metric: metric
        });
        $f632639e2f71bdc9$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $f632639e2f71bdc9$var$instrumentTtfb() {
    return (0, $3896b5861f56d55e$export$33a01e6c5f2c7e33)((metric)=>{
        $f632639e2f71bdc9$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $f632639e2f71bdc9$var$_previousTtfb = metric;
    });
}
function $f632639e2f71bdc9$var$instrumentInp() {
    return (0, $ad1fea66d5bbad1d$export$7df4b36ecaed99e1)((metric)=>{
        $f632639e2f71bdc9$var$triggerHandlers("inp", {
            metric: metric
        });
        $f632639e2f71bdc9$var$_previousInp = metric;
    });
}
function $f632639e2f71bdc9$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $f632639e2f71bdc9$var$addHandler(type, callback);
    let stopListening;
    if (!$f632639e2f71bdc9$var$instrumented[type]) {
        stopListening = instrumentFn();
        $f632639e2f71bdc9$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $f632639e2f71bdc9$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $f632639e2f71bdc9$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $daa0fcd2e73d2c43$export$d1203567a167490e)(type, (entries)=>{
        $f632639e2f71bdc9$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $f632639e2f71bdc9$var$addHandler(type, handler) {
    $f632639e2f71bdc9$var$handlers[type] = $f632639e2f71bdc9$var$handlers[type] || [];
    $f632639e2f71bdc9$var$handlers[type].push(handler);
}
function $f632639e2f71bdc9$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $f632639e2f71bdc9$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $f632639e2f71bdc9$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}











function $bc242c899ae0e059$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $bc242c899ae0e059$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $bc242c899ae0e059$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $6f219f5f8ad60f48$export$f5b060c2914b97c8)(value)) return (0, $4edc0d7ce1c2a0e2$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}



function $34a580a99f2a7004$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $c8d346bbfcccc6ec$var$logIgnoredSpan(droppedSpan) {
    (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $c8d346bbfcccc6ec$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($c8d346bbfcccc6ec$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $240729c9e87a40a8$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $d67c357688f604e0$export$16a28057038b10ef) && $c8d346bbfcccc6ec$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $240729c9e87a40a8$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $240729c9e87a40a8$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$c8d346bbfcccc6ec$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && $c8d346bbfcccc6ec$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $c8d346bbfcccc6ec$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $240729c9e87a40a8$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $c8d346bbfcccc6ec$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $c8d346bbfcccc6ec$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $494e2f7f6c41c106$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}








const $13ee6cd924a4581d$export$849dbeeeda01ae98 = "production";
const $13ee6cd924a4581d$export$6829f580e78306fa = "development";












const $73799ec07d2a76c5$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $73799ec07d2a76c5$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $c36ec88dc0f9fe8f$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(this, $73799ec07d2a76c5$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $ca720f03249a0481$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $73799ec07d2a76c5$export$61cc547d99783aa7(span) {
    return !!span && span[$73799ec07d2a76c5$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $5473a9af6a42008d$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $5473a9af6a42008d$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(spanWithMaybeDsc, $5473a9af6a42008d$var$FROZEN_DSC_FIELD, dsc);
}
function $5473a9af6a42008d$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $13ee6cd924a4581d$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $8793b0e0916282a8$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $5473a9af6a42008d$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $5473a9af6a42008d$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $5473a9af6a42008d$export$a117f995597e25df(span) {
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $ca720f03249a0481$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $262ea1feb4b3c3f2$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $262ea1feb4b3c3f2$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$5473a9af6a42008d$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $73799ec07d2a76c5$export$61cc547d99783aa7)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $34a580a99f2a7004$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $4af3f5dbd49d01cc$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$5473a9af6a42008d$export$89ef1736f08c6b2b(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $9dc3c94210b331cf$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $5473a9af6a42008d$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $262ea1feb4b3c3f2$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $34a580a99f2a7004$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $ca720f03249a0481$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $4af3f5dbd49d01cc$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $5473a9af6a42008d$export$95cf936fdacaff7b(span) {
    const dsc = $5473a9af6a42008d$export$a117f995597e25df(span);
    return (0, $9dc3c94210b331cf$export$56766feef403f365)(dsc);
}





function $e2fafaa9fa5f6d69$export$2f3d84e767c9592b(span) {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $ca720f03249a0481$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $ca720f03249a0481$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $ca720f03249a0481$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $e2fafaa9fa5f6d69$export$b77c830667a4d630(span) {
    if (!(0, $d67c357688f604e0$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $ca720f03249a0481$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(msg);
}






function $5077b6074f278781$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $34a580a99f2a7004$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $a59632605f3da4e2$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}







function $a3b68276aeabacc0$export$d3f49b33a1f44720(callback) {
    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(callback, "_streamed", true);
    return callback;
}
function $a3b68276aeabacc0$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}








function $21dee4fea99df652$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $21dee4fea99df652$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $21dee4fea99df652$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $21dee4fea99df652$export$604a45d95a155e2b(envelope, types) {
    return $21dee4fea99df652$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $21dee4fea99df652$var$encodeUTF8(input) {
    const carrier = (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)((0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $21dee4fea99df652$var$decodeUTF8(input) {
    const carrier = (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)((0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $21dee4fea99df652$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $21dee4fea99df652$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $21dee4fea99df652$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $252cc08b60bbad6f$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $21dee4fea99df652$var$concatBuffers(parts);
}
function $21dee4fea99df652$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $21dee4fea99df652$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $21dee4fea99df652$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($21dee4fea99df652$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $21dee4fea99df652$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $21dee4fea99df652$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $21dee4fea99df652$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $21dee4fea99df652$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $21dee4fea99df652$var$_isOverriddenType(type) {
    return type in $21dee4fea99df652$var$DATA_CATEGORY_OVERRIDES;
}
function $21dee4fea99df652$export$b11169581eeaf237(type) {
    return $21dee4fea99df652$var$_isOverriddenType(type) ? $21dee4fea99df652$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $21dee4fea99df652$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $21dee4fea99df652$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $31d8160eeba1365b$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8793b0e0916282a8$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





function $ba45e01a5d4a8932$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $ba45e01a5d4a8932$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $21dee4fea99df652$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $31d8160eeba1365b$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8793b0e0916282a8$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $21dee4fea99df652$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $ba45e01a5d4a8932$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $21dee4fea99df652$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $ba45e01a5d4a8932$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $21dee4fea99df652$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $21dee4fea99df652$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $ba45e01a5d4a8932$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $5473a9af6a42008d$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $31d8160eeba1365b$export$65b1bada40c91b34)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8793b0e0916282a8$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $ca720f03249a0481$export$92d8c23565496537)(span);
        return !(0, $c8d346bbfcccc6ec$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $ca720f03249a0481$export$92d8c23565496537)(span);
        const processedSpan = !(0, $a3b68276aeabacc0$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $ca720f03249a0481$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $ca720f03249a0481$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $21dee4fea99df652$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $21dee4fea99df652$export$f93f7f385160c44e)(headers, items);
}











function $e7ecd4a1f6dff8bc$export$39f842ff1b89e918(strategy) {
    (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)((0, $caaab4f0240c1a5f$export$19eade501500c6c1)()).segmentSpanCaptureStrategy = strategy;
}
function $e7ecd4a1f6dff8bc$export$ccd123f3ffd8eb3() {
    return (0, $caaab4f0240c1a5f$export$c8bfa33e4e8ae492)((0, $caaab4f0240c1a5f$export$19eade501500c6c1)()).segmentSpanCaptureStrategy;
}




const $cd19922f7a3b35e5$var$MAX_SPAN_COUNT = 1e3;
class $cd19922f7a3b35e5$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $c36ec88dc0f9fe8f$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $832ed7dc58639895$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "manual",
            [(0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $ca720f03249a0481$export$eb571cd9b5d98de8) : (0, $ca720f03249a0481$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === (0, $262ea1feb4b3c3f2$export$d7a7d984b0791405) && value !== void 0 && (0, $4af3f5dbd49d01cc$export$2e69b79005fc86eb)(this)) (0, $4af3f5dbd49d01cc$export$c45f16c039fb5033)(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = (0, $ca720f03249a0481$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!(0, $4af3f5dbd49d01cc$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $262ea1feb4b3c3f2$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = (0, $4af3f5dbd49d01cc$export$a9ba2a501dbf6a56)(this);
            return;
        }
        this._endTime = (0, $ca720f03249a0481$export$3f7581298f56c6d7)(endTimestamp);
        (0, $e2fafaa9fa5f6d69$export$b77c830667a4d630)(this);
        this._onSpanEnded();
        this._frozen = (0, $4af3f5dbd49d01cc$export$a9ba2a501dbf6a56)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $ca720f03249a0481$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $262ea1feb4b3c3f2$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $262ea1feb4b3c3f2$export$fea48ba9f4550879],
            measurements: (0, $af068cc29089130f$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $ca720f03249a0481$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(this),
            status: (0, $ca720f03249a0481$export$d3856a3187d34821)(this._status),
            attributes: (0, $ca720f03249a0481$export$1464a9cb828ba99f)(this._attributes, this._status),
            links: (0, $ca720f03249a0481$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log("[Tracing] Adding an event to span:", name);
        const time = $cd19922f7a3b35e5$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $832ed7dc58639895$export$ee52dced521e3e18)();
        const attributes = $cd19922f7a3b35e5$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $ca720f03249a0481$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $cd19922f7a3b35e5$var$sendSpanEnvelope((0, $ba45e01a5d4a8932$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = (0, $e7ecd4a1f6dff8bc$export$ccd123f3ffd8eb3)();
            if (strategy2) {
                const scope2 = (0, $4af3f5dbd49d01cc$export$c08fbc656a245d03)(this).scope || (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && (0, $494e2f7f6c41c106$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = (0, $4af3f5dbd49d01cc$export$c08fbc656a245d03)(this).scope || (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)();
        const strategy = (0, $e7ecd4a1f6dff8bc$export$ccd123f3ffd8eb3)();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$cd19922f7a3b35e5$var$isFullFinishedSpan((0, $ca720f03249a0481$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4af3f5dbd49d01cc$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of (0, $ca720f03249a0481$export$340c5c8a13ffc680)(this)){
            if (descendant === this || $cd19922f7a3b35e5$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = (0, $ca720f03249a0481$export$92d8c23565496537)(descendant);
            if (!$cd19922f7a3b35e5$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[0, $262ea1feb4b3c3f2$export$d7a7d984b0791405];
        delete this._attributes[0, $262ea1feb4b3c3f2$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $262ea1feb4b3c3f2$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $ca720f03249a0481$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $cd19922f7a3b35e5$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $cd19922f7a3b35e5$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $5473a9af6a42008d$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $af068cc29089130f$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $cd19922f7a3b35e5$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $cd19922f7a3b35e5$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $cd19922f7a3b35e5$var$isStandaloneSpan(span) {
    return span instanceof $cd19922f7a3b35e5$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $cd19922f7a3b35e5$var$sendSpanEnvelope(envelope) {
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $48d187ac8000fdfc$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $48d187ac8000fdfc$export$a1bd95187356f372(options, callback) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $48d187ac8000fdfc$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $bf0da3485a76f55c$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $48d187ac8000fdfc$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)();
            const parentSpan = $48d187ac8000fdfc$var$getParentSpan(scope, customParentSpan);
            const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $48d187ac8000fdfc$var$startMissingRequiredParentSpan(scope, client) : $48d187ac8000fdfc$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$48d187ac8000fdfc$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $1322a11ccbaccbb5$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $bc242c899ae0e059$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $ca720f03249a0481$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $973ca8728f347b7f$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $48d187ac8000fdfc$export$c10292ad04b92aea(options, callback) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $48d187ac8000fdfc$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $bf0da3485a76f55c$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $48d187ac8000fdfc$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)();
            const parentSpan = $48d187ac8000fdfc$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $48d187ac8000fdfc$var$startMissingRequiredParentSpan(scope, (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)()) : $48d187ac8000fdfc$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$48d187ac8000fdfc$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $1322a11ccbaccbb5$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $bc242c899ae0e059$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $ca720f03249a0481$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $973ca8728f347b7f$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $48d187ac8000fdfc$export$63dbba021a6b4047(options) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $48d187ac8000fdfc$var$_startInactiveSpanImpl(options);
}
function $48d187ac8000fdfc$export$8672cc6c19af377a(options) {
    return $48d187ac8000fdfc$var$_startInactiveSpanImpl(options);
}
function $48d187ac8000fdfc$var$_startInactiveSpanImpl(options) {
    const spanArguments = $48d187ac8000fdfc$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $bf0da3485a76f55c$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$48d187ac8000fdfc$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)();
        const parentSpan = $48d187ac8000fdfc$var$getParentSpan(scope, customParentSpan);
        const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $48d187ac8000fdfc$var$startMissingRequiredParentSpan(scope, client);
        return $48d187ac8000fdfc$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $48d187ac8000fdfc$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    const acs = (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $9dc3c94210b331cf$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $8e829119ae04d50d$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $48d187ac8000fdfc$export$f90b03291402f553(callback);
    return (0, $bf0da3485a76f55c$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $8e829119ae04d50d$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $1322a11ccbaccbb5$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $48d187ac8000fdfc$export$e57ac09b143d92a2(span, callback) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $bf0da3485a76f55c$export$ec58d9285c204497)((scope)=>{
        (0, $1322a11ccbaccbb5$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $48d187ac8000fdfc$export$869298f9835abc68(callback) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $bf0da3485a76f55c$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$48d187ac8000fdfc$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$48d187ac8000fdfc$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $48d187ac8000fdfc$export$7d5f2376f7cf513(scope = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)()) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$48d187ac8000fdfc$export$61ab4e30f2201736] === true;
}
function $48d187ac8000fdfc$export$f90b03291402f553(callback) {
    const acs = $48d187ac8000fdfc$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $bf0da3485a76f55c$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $c36ec88dc0f9fe8f$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $31d8160eeba1365b$export$9869d72de32a3917)()
        });
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $48d187ac8000fdfc$export$e57ac09b143d92a2(null, callback);
    });
}
function $48d187ac8000fdfc$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $73799ec07d2a76c5$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $4af3f5dbd49d01cc$export$cddb4027e3b0dd66)(span, scope, (0, $bf0da3485a76f55c$export$68f3af03034c9e90)());
    return span;
}
function $48d187ac8000fdfc$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $bf0da3485a76f55c$export$68f3af03034c9e90)();
    if (!(0, $34a580a99f2a7004$export$1f70765132c3c225)()) {
        const scopePropagationContext = scope.getPropagationContext();
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $73799ec07d2a76c5$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $ca720f03249a0481$export$81397d924722cc65)(parentSpan, span2);
        (0, $4af3f5dbd49d01cc$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    if ($48d187ac8000fdfc$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$48d187ac8000fdfc$export$7d5f2376f7cf513(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new (0, $73799ec07d2a76c5$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) (0, $ca720f03249a0481$export$81397d924722cc65)(parentSpan, ignoredSpan);
        (0, $4af3f5dbd49d01cc$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $48d187ac8000fdfc$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $ca720f03249a0481$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $5473a9af6a42008d$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $ca720f03249a0481$export$5caecac1caaf3a71)(parentSpan);
        span = $48d187ac8000fdfc$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        (0, $5473a9af6a42008d$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = scope.getPropagationContext();
        span = $48d187ac8000fdfc$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) (0, $5473a9af6a42008d$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $e2fafaa9fa5f6d69$export$2f3d84e767c9592b)(span);
    return span;
}
function $48d187ac8000fdfc$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $ca720f03249a0481$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $48d187ac8000fdfc$var$getAcs() {
    const carrier = (0, $caaab4f0240c1a5f$export$19eade501500c6c1)();
    return (0, $b32f8dd6526a279e$export$f639b0c2752203be)(carrier);
}
function $48d187ac8000fdfc$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $48d187ac8000fdfc$export$7d5f2376f7cf513(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : (0, $5077b6074f278781$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $a59632605f3da4e2$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $cd19922f7a3b35e5$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $262ea1feb4b3c3f2$export$d7a7d984b0791405)]: "custom",
            [(0, $262ea1feb4b3c3f2$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $494e2f7f6c41c106$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $4af3f5dbd49d01cc$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $48d187ac8000fdfc$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $48d187ac8000fdfc$export$7d5f2376f7cf513(scope);
    const sampled = _isTracingSuppressed ? false : (0, $ca720f03249a0481$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $cd19922f7a3b35e5$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $73799ec07d2a76c5$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $ca720f03249a0481$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $4af3f5dbd49d01cc$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $494e2f7f6c41c106$export$6ea47215d699c04a)(client) && (0, $73799ec07d2a76c5$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $73799ec07d2a76c5$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $48d187ac8000fdfc$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $1322a11ccbaccbb5$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $48d187ac8000fdfc$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $48d187ac8000fdfc$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $48d187ac8000fdfc$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $494e2f7f6c41c106$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $c8d346bbfcccc6ec$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $48d187ac8000fdfc$export$b0b1bd7d4bdbd54e(span) {
    return (0, $73799ec07d2a76c5$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}





const $f5c2fd2bb6c29047$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    (0, $75b0920d6d85e459$export$26d3d892edc56833)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $75b0920d6d85e459$export$26d3d892edc56833)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $7d092614a1827671$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $7d092614a1827671$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $ca720f03249a0481$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $48d187ac8000fdfc$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $48d187ac8000fdfc$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
function $7d092614a1827671$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {}
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0,
        ...passedAttributes
    };
    return (0, $48d187ac8000fdfc$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $7d092614a1827671$export$f72a13c439a30cab() {
    return (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).addEventListener && (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).performance;
}
function $7d092614a1827671$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $7d092614a1827671$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $7d092614a1827671$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
function $7d092614a1827671$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $f5c2fd2bb6c29047$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $af6db5a7343b6c83$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $7d092614a1827671$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $f632639e2f71bdc9$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $7d092614a1827671$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $af6db5a7343b6c83$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $af6db5a7343b6c83$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $7d092614a1827671$export$b4785dbd4a81b33f)(((0, $832ed7dc58639895$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $832ed7dc58639895$export$ee52dced521e3e18)();
    const routeName = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $262ea1feb4b3c3f2$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $7d092614a1827671$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $262ea1feb4b3c3f2$export$f5f95cff026507b5)]: "",
            [(0, $262ea1feb4b3c3f2$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}








const $9ca543aec53af59b$export$ccce4d286bdc973b = 6e4;
function $9ca543aec53af59b$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $9ca543aec53af59b$export$ccce4d286bdc973b;
}
function $9ca543aec53af59b$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $7d092614a1827671$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $f632639e2f71bdc9$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$9ca543aec53af59b$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $7d092614a1827671$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $9ca543aec53af59b$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $9ca543aec53af59b$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$9ca543aec53af59b$export$e59775b7d17699ba(lcpValue)) return;
    (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(((0, $832ed7dc58639895$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $262ea1feb4b3c3f2$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $7d092614a1827671$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $262ea1feb4b3c3f2$export$f5f95cff026507b5)]: "millisecond",
            [(0, $262ea1feb4b3c3f2$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}




function $a00d3ad642f1f2e8$var$getAbsoluteTime(time) {
    return time ? (((0, $832ed7dc58639895$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $a00d3ad642f1f2e8$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $7d092614a1827671$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $832ed7dc58639895$export$baf075a948ffc0bf)() || (0, $7d092614a1827671$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $a00d3ad642f1f2e8$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        "http.request.redirect_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $a00d3ad642f1f2e8$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    });
}
function $a00d3ad642f1f2e8$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}








var $eAISS = parcelRequire("eAISS");
const $3566357a12adc1a6$var$MAX_INT_AS_BYTES = 2147483647;
let $3566357a12adc1a6$var$_performanceCursor = 0;
let $3566357a12adc1a6$var$_measurements = {};
let $3566357a12adc1a6$var$_lcpEntry;
let $3566357a12adc1a6$var$_clsEntry;
function $3566357a12adc1a6$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $7d092614a1827671$export$f72a13c439a30cab)();
    if (performance && (0, $832ed7dc58639895$export$baf075a948ffc0bf)()) {
        if (performance.mark) (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $9ca543aec53af59b$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $3566357a12adc1a6$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $af6db5a7343b6c83$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $3566357a12adc1a6$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $3566357a12adc1a6$var$_trackTtfb();
        const fpFcpCleanupCallback = $3566357a12adc1a6$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>void 0;
}
function $3566357a12adc1a6$export$f396d19077034ad2() {
    (0, $f632639e2f71bdc9$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $ca720f03249a0481$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $ca720f03249a0481$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)((0, $832ed7dc58639895$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $7d092614a1827671$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $3566357a12adc1a6$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $ca720f03249a0481$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)((0, $832ed7dc58639895$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $ca720f03249a0481$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $7d092614a1827671$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $3566357a12adc1a6$export$e27543e0976315e4() {
    (0, $f632639e2f71bdc9$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $ca720f03249a0481$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)((0, $832ed7dc58639895$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $37ff30eb277ba31f$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $7d092614a1827671$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $3566357a12adc1a6$var$_trackCLS() {
    return (0, $f632639e2f71bdc9$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $3566357a12adc1a6$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $3566357a12adc1a6$var$_clsEntry = entry;
    }, true);
}
function $3566357a12adc1a6$var$_trackLCP() {
    return (0, $f632639e2f71bdc9$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $9ca543aec53af59b$export$e59775b7d17699ba)(metric.value)) return;
        $3566357a12adc1a6$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $3566357a12adc1a6$var$_lcpEntry = entry;
    }, true);
}
function $3566357a12adc1a6$var$_trackTtfb() {
    return (0, $f632639e2f71bdc9$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $3566357a12adc1a6$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $3566357a12adc1a6$var$_trackFpFcp() {
    return (0, $f632639e2f71bdc9$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $d0d9672b1890eaa7$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $3566357a12adc1a6$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $3566357a12adc1a6$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $3566357a12adc1a6$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $7d092614a1827671$export$f72a13c439a30cab)();
    const origin = (0, $832ed7dc58639895$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $ca720f03249a0481$export$92d8c23565496537)(span);
    performanceEntries.slice($3566357a12adc1a6$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $3566357a12adc1a6$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $3566357a12adc1a6$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $3566357a12adc1a6$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $3566357a12adc1a6$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $3566357a12adc1a6$var$_trackNavigator(span, spanStreamingEnabled);
}
function $3566357a12adc1a6$export$d14e394b690acc17(span, options) {
    const origin = (0, $832ed7dc58639895$export$baf075a948ffc0bf)();
    if (!(0, $7d092614a1827671$export$f72a13c439a30cab)()?.getEntries || !origin) {
        $3566357a12adc1a6$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(origin);
    if ((0, $ca720f03249a0481$export$92d8c23565496537)(span).op === "pageload") {
        $3566357a12adc1a6$var$_addTtfbRequestTimeToMeasurements($3566357a12adc1a6$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($3566357a12adc1a6$var$_measurements[measurementName]) setAttr(measurementName, $3566357a12adc1a6$var$_measurements[measurementName].value);
            });
            if ($3566357a12adc1a6$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $3566357a12adc1a6$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $3566357a12adc1a6$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $3566357a12adc1a6$var$_measurements.lcp;
            Object.entries($3566357a12adc1a6$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $af068cc29089130f$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $3566357a12adc1a6$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $0de1d6d397151f24$export$d3e828b3c7b5b845)());
    }
    $3566357a12adc1a6$var$resetWebVitalState();
}
function $3566357a12adc1a6$var$resetWebVitalState() {
    $3566357a12adc1a6$var$_lcpEntry = void 0;
    $3566357a12adc1a6$var$_clsEntry = void 0;
    $3566357a12adc1a6$var$_measurements = {};
}
function $3566357a12adc1a6$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
function $3566357a12adc1a6$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($3566357a12adc1a6$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $240729c9e87a40a8$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $d05968deb75a93e3$export$6431553786c94949)(false);
    const requestTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $3566357a12adc1a6$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $7d092614a1827671$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $3566357a12adc1a6$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {}
            }
            return;
        }
        if ((0, $6f219f5f8ad60f48$export$c3825b437cbdea5c)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {}
    } catch  {}
}
function $3566357a12adc1a6$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $3566357a12adc1a6$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $3566357a12adc1a6$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $3566357a12adc1a6$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $3566357a12adc1a6$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $3566357a12adc1a6$var$_addRequest(span, entry, timeOrigin);
}
function $3566357a12adc1a6$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $3566357a12adc1a6$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $7d092614a1827671$export$7567a67bdb69a23d)(span, timeOrigin + (0, $7d092614a1827671$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $7d092614a1827671$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $3566357a12adc1a6$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $3566357a12adc1a6$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $7d092614a1827671$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $7d092614a1827671$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $7d092614a1827671$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $3566357a12adc1a6$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $a84a12f71fcd2e74$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).location.origin);
    attributes[0, $eAISS.URL_FULL] = (0, $316dd9f7cb631407$export$9dbd5b9f0d1db392)(resourceUrl);
    $3566357a12adc1a6$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $a00d3ad642f1f2e8$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $7d092614a1827671$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $3566357a12adc1a6$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $7d092614a1827671$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $ca720f03249a0481$export$92d8c23565496537)(span).op === "pageload") (0, $af068cc29089130f$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $7d092614a1827671$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $7d092614a1827671$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $3566357a12adc1a6$var$_setWebVitalAttributes(span, options) {
    if ($3566357a12adc1a6$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($3566357a12adc1a6$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $519e8d19cc16330e$export$5647df6b7814ac86)($3566357a12adc1a6$var$_lcpEntry.element));
        if ($3566357a12adc1a6$var$_lcpEntry.id) span.setAttribute("lcp.id", $3566357a12adc1a6$var$_lcpEntry.id);
        if ($3566357a12adc1a6$var$_lcpEntry.url) span.setAttribute("lcp.url", $3566357a12adc1a6$var$_lcpEntry.url.trim().slice(0, 200));
        if ($3566357a12adc1a6$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $3566357a12adc1a6$var$_lcpEntry.loadTime);
        if ($3566357a12adc1a6$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $3566357a12adc1a6$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $3566357a12adc1a6$var$_lcpEntry.size);
    }
    if ($3566357a12adc1a6$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $3566357a12adc1a6$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $519e8d19cc16330e$export$5647df6b7814ac86)(source.node)));
}
function $3566357a12adc1a6$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $3566357a12adc1a6$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $3566357a12adc1a6$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $d05968deb75a93e3$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}


const $b784161f263a7c57$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




const $a50070dc9fce1766$export$56d8a8a25bd48b81 = (0, $873eefa173eeba59$exports.GLOBAL_OBJ);
let $a50070dc9fce1766$var$ignoreOnError = 0;
function $a50070dc9fce1766$export$b79738ab10c590b2() {
    return $a50070dc9fce1766$var$ignoreOnError > 0;
}
function $a50070dc9fce1766$export$1265a142ff5ba165() {
    $a50070dc9fce1766$var$ignoreOnError++;
    setTimeout(()=>{
        $a50070dc9fce1766$var$ignoreOnError--;
    });
}
function $a50070dc9fce1766$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $873eefa173eeba59$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$a50070dc9fce1766$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $a50070dc9fce1766$export$1265a142ff5ba165();
            (0, $873eefa173eeba59$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $873eefa173eeba59$exports.addExceptionTypeValue)(event, void 0, void 0);
                        (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $873eefa173eeba59$exports.captureException)(ex);
            });
            throw ex;
        } finally{
            (0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth = ((0, $873eefa173eeba59$exports.GLOBAL_OBJ)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $873eefa173eeba59$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $873eefa173eeba59$exports.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $a50070dc9fce1766$export$a3c4a8453e8936f0() {
    const url = (0, $873eefa173eeba59$exports.getLocationHref)();
    const { referrer: referrer } = $a50070dc9fce1766$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $a50070dc9fce1766$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}









function $ce721ffd1bf382af$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, ()=>$ce721ffd1bf382af$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $ce721ffd1bf382af$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, ()=>$ce721ffd1bf382af$var$instrumentFetch($ce721ffd1bf382af$var$streamHandler));
    return removeHandler;
}
function $ce721ffd1bf382af$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $6aeaaf927d53c892$export$c82d238e23c40b21)()) return;
    (0, $73ebe44591c0f61f$export$9563e054e6f787fb)((0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $ce721ffd1bf382af$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $ce721ffd1bf382af$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $915c7efdb0533300$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $915c7efdb0533300$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $915c7efdb0533300$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                    error: error
                });
                if ((0, $6f219f5f8ad60f48$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && (0, $6f219f5f8ad60f48$export$e6127cc7fe7395c3)(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $ce721ffd1bf382af$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $ce721ffd1bf382af$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $ce721ffd1bf382af$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $915c7efdb0533300$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $ce721ffd1bf382af$var$hasProp(obj, prop) {
    return (0, $6f219f5f8ad60f48$export$c10d0b04eaa80a43)(obj) && !!obj[prop];
}
function $ce721ffd1bf382af$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($ce721ffd1bf382af$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $ce721ffd1bf382af$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $ce721ffd1bf382af$var$getUrlFromResource(resource),
            method: $ce721ffd1bf382af$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $6f219f5f8ad60f48$export$6d3d1f317d7cda57)(resource) && $ce721ffd1bf382af$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $ce721ffd1bf382af$var$getUrlFromResource(arg),
        method: $ce721ffd1bf382af$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $ce721ffd1bf382af$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $6f219f5f8ad60f48$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}




const $faacac5ad0147d17$export$b14a8888f80a0b3e = [];
function $faacac5ad0147d17$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $faacac5ad0147d17$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $faacac5ad0147d17$var$filterDuplicates(integrations);
}
function $faacac5ad0147d17$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $faacac5ad0147d17$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $faacac5ad0147d17$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $faacac5ad0147d17$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$faacac5ad0147d17$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $faacac5ad0147d17$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $faacac5ad0147d17$export$2d8f5188773bcddd(integration) {
    const client = (0, $bf0da3485a76f55c$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $d67c357688f604e0$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $faacac5ad0147d17$export$2323046b9414659f(fn) {
    return fn;
}
function $faacac5ad0147d17$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}


const $fe96afdbb79e7fe9$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $fe96afdbb79e7fe9$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $fe96afdbb79e7fe9$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $fe96afdbb79e7fe9$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $fe96afdbb79e7fe9$export$b49e0d1a48dc8754 = (0, $faacac5ad0147d17$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $ce721ffd1bf382af$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $fe96afdbb79e7fe9$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $fe96afdbb79e7fe9$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $ce721ffd1bf382af$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    const contentType = handlerData.response.headers?.get("content-type") || "";
                    if (handlerData.response.headers?.get("content-length") || !$fe96afdbb79e7fe9$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = handlerData.fetchData?.url || "";
                    const method = handlerData.fetchData?.method || "GET";
                    const parsedUrl = (0, $a84a12f71fcd2e74$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $a84a12f71fcd2e74$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $a84a12f71fcd2e74$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $48d187ac8000fdfc$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $316dd9f7cb631407$export$9dbd5b9f0d1db392)((0, $a84a12f71fcd2e74$export$8abd806fcaf234fa)(url)),
                            "http.method": method,
                            type: "fetch",
                            [(0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $fe96afdbb79e7fe9$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $fe96afdbb79e7fe9$var$STREAM_RESOLVE_FALLBACK_MS);
                    $fe96afdbb79e7fe9$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});




var $iWMq1 = parcelRequire("iWMq1");

function $3ed21bcf6474e99c$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $iWMq1.isNodeEnv)() || $3ed21bcf6474e99c$var$isElectronNodeRenderer());
}
function $3ed21bcf6474e99c$var$isElectronNodeRenderer() {
    const process = (0, $8ff4b8ea1fe80582$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}






const $084b99d1a1d9ded8$var$LAST_INTERACTIONS = [];
const $084b99d1a1d9ded8$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $084b99d1a1d9ded8$export$619786413bcce1e1 = 60;
function $084b99d1a1d9ded8$export$f17d06681a4744a3() {
    const performance = (0, $7d092614a1827671$export$f72a13c439a30cab)();
    if (performance && (0, $832ed7dc58639895$export$baf075a948ffc0bf)()) {
        const inpCallback = $084b99d1a1d9ded8$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $084b99d1a1d9ded8$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $084b99d1a1d9ded8$export$eeab203db0ed99a9() {
    return (0, $f632639e2f71bdc9$export$da3b76aa2022cbd7)($084b99d1a1d9ded8$export$7bcb98fe01441521);
}
const $084b99d1a1d9ded8$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $084b99d1a1d9ded8$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $084b99d1a1d9ded8$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $084b99d1a1d9ded8$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)((0, $832ed7dc58639895$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $ca720f03249a0481$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $084b99d1a1d9ded8$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $ca720f03249a0481$export$92d8c23565496537)(spanToUse).description : (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $262ea1feb4b3c3f2$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $7d092614a1827671$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $262ea1feb4b3c3f2$export$f5f95cff026507b5)]: "millisecond",
            [(0, $262ea1feb4b3c3f2$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $084b99d1a1d9ded8$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $084b99d1a1d9ded8$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $084b99d1a1d9ded8$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($084b99d1a1d9ded8$export$7cd941f925ded42f);
    if ((0, $3ed21bcf6474e99c$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        $084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $084b99d1a1d9ded8$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $ca720f03249a0481$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $f632639e2f71bdc9$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($084b99d1a1d9ded8$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            if ($084b99d1a1d9ded8$var$LAST_INTERACTIONS.length > 10) {
                const last = $084b99d1a1d9ded8$var$LAST_INTERACTIONS.shift();
                $084b99d1a1d9ded8$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $084b99d1a1d9ded8$var$LAST_INTERACTIONS.push(interactionId);
            $084b99d1a1d9ded8$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $f632639e2f71bdc9$export$69816c1a049f8db6)("event", handleEntries);
    (0, $f632639e2f71bdc9$export$69816c1a049f8db6)("first-input", handleEntries);
}










var $eAISS = parcelRequire("eAISS");
function $39c4a8211723cec7$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $262ea1feb4b3c3f2$export$cca8dd30f57f805e)]: origin,
        [(0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09)]: op,
        [(0, $262ea1feb4b3c3f2$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        // oxlint-disable-next-line typescript-eslint/no-deprecated
        [(0, $eAISS.SENTRY_TRANSACTION)]: routeName,
        [(0, $eAISS.SENTRY_SEGMENT_NAME)]: routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $ca720f03249a0481$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $262ea1feb4b3c3f2$export$1a413bd9a88fdb09] === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $48d187ac8000fdfc$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
function $39c4a8211723cec7$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $7d092614a1827671$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $f632639e2f71bdc9$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $9ca543aec53af59b$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $7d092614a1827671$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $39c4a8211723cec7$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $39c4a8211723cec7$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $9ca543aec53af59b$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $832ed7dc58639895$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.element) : "Largest contentful paint";
    const attributes = {};
    entry?.element && (attributes["browser.web_vital.lcp.element"] = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.element));
    entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
    entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
    entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $39c4a8211723cec7$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $39c4a8211723cec7$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $7d092614a1827671$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $f632639e2f71bdc9$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $7d092614a1827671$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $39c4a8211723cec7$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $39c4a8211723cec7$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $7d092614a1827671$export$b4785dbd4a81b33f)(((0, $832ed7dc58639895$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $832ed7dc58639895$export$ee52dced521e3e18)();
    const name = entry ? (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(source.node);
    });
    $39c4a8211723cec7$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $39c4a8211723cec7$export$4a8cbc644515d57b() {
    const performance = (0, $7d092614a1827671$export$f72a13c439a30cab)();
    if (!performance || !(0, $832ed7dc58639895$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $084b99d1a1d9ded8$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $084b99d1a1d9ded8$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $39c4a8211723cec7$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $f632639e2f71bdc9$export$da3b76aa2022cbd7)(onInp);
}
function $39c4a8211723cec7$export$bd315e549441b68a(inpValue, entry) {
    (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $7d092614a1827671$export$b4785dbd4a81b33f)((0, $832ed7dc58639895$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $7d092614a1827671$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $084b99d1a1d9ded8$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $084b99d1a1d9ded8$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $ca720f03249a0481$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $ca720f03249a0481$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $ca720f03249a0481$export$db0cad9e44f67af8)(spanToUse).name : (0, $bf0da3485a76f55c$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $519e8d19cc16330e$export$5647df6b7814ac86)(entry.target);
    $39c4a8211723cec7$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $262ea1feb4b3c3f2$export$fea48ba9f4550879)]: entry.duration,
            // oxlint-disable-next-line typescript-eslint/no-deprecated
            [(0, $eAISS.SENTRY_TRANSACTION)]: routeName,
            [(0, $eAISS.SENTRY_SEGMENT_NAME)]: routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $b499a57c59dd3fde$export$8748555bacc7091c = "WebVitals";
const $b499a57c59dd3fde$export$1ab4995602e8adaa = (0, $873eefa173eeba59$exports.defineIntegration)((options = {})=>{
    const ignored = new Set(options.ignore ?? []);
    return {
        name: $b499a57c59dd3fde$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $873eefa173eeba59$exports.hasSpanStreamingEnabled)(client);
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = options._experiments ?? {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $3566357a12adc1a6$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $3566357a12adc1a6$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $39c4a8211723cec7$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $39c4a8211723cec7$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $39c4a8211723cec7$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $084b99d1a1d9ded8$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $084b99d1a1d9ded8$export$e4e04d43e223cce2)();
        }
    };
});





function $6df92446e2e423bf$export$6f18f55521af71a1() {
    if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $873eefa173eeba59$exports.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $873eefa173eeba59$exports.getRootSpan)(activeSpan);
        if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $873eefa173eeba59$exports.spanToJSON)(rootSpan);
            if (0, $b784161f263a7c57$export$16a28057038b10ef) (0, $873eefa173eeba59$exports.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $873eefa173eeba59$exports.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}














const $cdbcb685a0ce472e$export$c8d616af96ac729f = 3600;
const $cdbcb685a0ce472e$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $cdbcb685a0ce472e$export$237518aee8726f02 = "sentry.previous_trace";
function $cdbcb685a0ce472e$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $cdbcb685a0ce472e$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $873eefa173eeba59$exports.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $873eefa173eeba59$exports.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $cdbcb685a0ce472e$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $cdbcb685a0ce472e$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $873eefa173eeba59$exports.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($cdbcb685a0ce472e$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $cdbcb685a0ce472e$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
function $cdbcb685a0ce472e$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $873eefa173eeba59$exports.spanToJSON)(span);
    function getSampleRate() {
        try {
            const oldSampleRate = Number(spanJson.data?.[0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? oldPropagationContext.dsc?.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $cdbcb685a0ce472e$export$c8d616af96ac729f) {
        if (0, $b784161f263a7c57$export$16a28057038b10ef) (0, $873eefa173eeba59$exports.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $873eefa173eeba59$exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: "previous_trace"
            }
        });
        span.setAttribute($cdbcb685a0ce472e$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$cdbcb685a0ce472e$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $cdbcb685a0ce472e$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).sessionStorage.setItem($cdbcb685a0ce472e$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $cdbcb685a0ce472e$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).sessionStorage?.getItem($cdbcb685a0ce472e$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch  {
        return void 0;
    }
}
function $cdbcb685a0ce472e$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}





const $f8496e812cd386ad$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $f8496e812cd386ad$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, $f8496e812cd386ad$export$c67d533bf77cbf54);
}
function $f8496e812cd386ad$export$c67d533bf77cbf54() {
    if (!(0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            let virtualError = new Error();
            const startTimestamp = (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $f8496e812cd386ad$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $915c7efdb0533300$export$b18c893e424d3127)("xhr", handlerData);
                    virtualError = void 0;
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(header) && (0, $6f219f5f8ad60f48$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$f8496e812cd386ad$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $832ed7dc58639895$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $915c7efdb0533300$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $f8496e812cd386ad$var$parseXhrUrlArg(url) {
    if ((0, $6f219f5f8ad60f48$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}



const $7bcbf2590ce26361$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $7bcbf2590ce26361$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $7bcbf2590ce26361$export$945a2d5364608d5(body, _debug = (0, $169ad50b2cdc7abf$export$1c9f709888824e05)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $7bcbf2590ce26361$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $fd229e17678bfd20$export$16a28057038b10ef) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $7bcbf2590ce26361$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$7bcbf2590ce26361$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $7bcbf2590ce26361$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



function $ee6ed8d54f2baf5f$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $ee6ed8d54f2baf5f$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return void 0;
    }
}
function $ee6ed8d54f2baf5f$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $ee6ed8d54f2baf5f$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        return void 0;
    }
}



var $eAISS = parcelRequire("eAISS");
const $360907223a210170$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $360907223a210170$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$360907223a210170$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$360907223a210170$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $873eefa173eeba59$exports.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $873eefa173eeba59$exports.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $ee6ed8d54f2baf5f$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $873eefa173eeba59$exports.parseUrl)(fullUrl).host : void 0;
            const sanitizedFullUrl = fullUrl ? (0, $873eefa173eeba59$exports.stripDataUrlContent)(fullUrl) : void 0;
            createdSpan.setAttributes({
                // oxlint-disable-next-line typescript/no-deprecated
                [(0, $eAISS.HTTP_URL)]: (0, $873eefa173eeba59$exports.filterCollectedUrl)(sanitizedFullUrl),
                // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
                // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
                [(0, $eAISS.URL_FULL)]: (0, $873eefa173eeba59$exports.filterCollectedUrl)(sanitizedFullUrl),
                "server.address": host
            });
            if (enableHTTPTimings) $360907223a210170$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $f8496e812cd386ad$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $360907223a210170$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $360907223a210170$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $ee6ed8d54f2baf5f$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
const $360907223a210170$var$HTTP_TIMING_WAIT_MS = 300;
function $360907223a210170$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $873eefa173eeba59$exports.spanToJSON)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $873eefa173eeba59$exports.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $873eefa173eeba59$exports.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $360907223a210170$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $f632639e2f71bdc9$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $ee6ed8d54f2baf5f$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $a00d3ad642f1f2e8$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $360907223a210170$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $873eefa173eeba59$exports.getLocationHref)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $873eefa173eeba59$exports.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $873eefa173eeba59$exports.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $873eefa173eeba59$exports.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $360907223a210170$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $f8496e812cd386ad$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $873eefa173eeba59$exports.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $873eefa173eeba59$exports.setHttpStatus)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd?.(span2, {
                    headers: (0, $ee6ed8d54f2baf5f$export$9dc5b8b2fb320da0)((0, $7bcbf2590ce26361$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $ee6ed8d54f2baf5f$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $873eefa173eeba59$exports.parseUrl)(fullUrl) : (0, $873eefa173eeba59$exports.parseUrl)(url);
    const sanitizedFullUrl = fullUrl ? (0, $873eefa173eeba59$exports.stripDataUrlContent)(fullUrl) : void 0;
    const urlForSpanName = (0, $873eefa173eeba59$exports.stripDataUrlContent)((0, $873eefa173eeba59$exports.stripUrlQueryAndFragment)(url));
    const client = (0, $873eefa173eeba59$exports.getClient)();
    const hasParent = !!(0, $873eefa173eeba59$exports.getActiveSpan)();
    const shouldEmitSpan = hasParent || !!client && (0, $873eefa173eeba59$exports.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $873eefa173eeba59$exports.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $873eefa173eeba59$exports.filterCollectedUrl)((0, $873eefa173eeba59$exports.stripDataUrlContent)(url)),
            type: "xhr",
            "http.method": method,
            "http.url": (0, $873eefa173eeba59$exports.filterCollectedUrl)(sanitizedFullUrl),
            // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            [(0, $eAISS.URL_FULL)]: (0, $873eefa173eeba59$exports.filterCollectedUrl)(sanitizedFullUrl),
            "server.address": parsedUrl?.host,
            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": (0, $873eefa173eeba59$exports.filterCollectedUrlQuery)(parsedUrl?.search)
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $873eefa173eeba59$exports.SentryNonRecordingSpan)();
    const spanForTraceHeaders = (0, $873eefa173eeba59$exports.spanIsIgnored)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $360907223a210170$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $873eefa173eeba59$exports.hasSpansEnabled)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $360907223a210170$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $873eefa173eeba59$exports.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $360907223a210170$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $360907223a210170$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.["traceparent"]) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !(0, $ee6ed8d54f2baf5f$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch  {}
}



var $eAISS = parcelRequire("eAISS");
const $86439d66f81a91b2$export$bbd2089f30bd3708 = "BrowserTracing";
const $86439d66f81a91b2$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $86439d66f81a91b2$export$e189d11d152c4191() {
    const nav = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $86439d66f81a91b2$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $86439d66f81a91b2$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $873eefa173eeba59$exports.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $360907223a210170$export$cc17fb3c0bc95cd7)
};
const $86439d66f81a91b2$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $873eefa173eeba59$exports.consoleSandbox)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$86439d66f81a91b2$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $86439d66f81a91b2$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true, url) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const urlObject = (0, $873eefa173eeba59$exports.parseStringToURLObject)(url || (0, $873eefa173eeba59$exports.getLocationHref)());
        const attributes = {
            ...urlObject?.pathname && {
                [(0, $eAISS.URL_PATH)]: urlObject.pathname
            },
            ...urlObject && !(0, $873eefa173eeba59$exports.isURLObjectRelative)(urlObject) && {
                [(0, $eAISS.URL_FULL)]: (0, $316dd9f7cb631407$export$9dbd5b9f0d1db392)(urlObject.href)
            },
            ...finalStartSpanOptions.attributes
        };
        if (initialSpanName !== finalStartSpanOptions.name) attributes[0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
        finalStartSpanOptions.attributes = attributes;
        if (!makeActive) {
            const now = (0, $873eefa173eeba59$exports.dateTimestampInSeconds)();
            (0, $873eefa173eeba59$exports.startInactiveSpan)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $873eefa173eeba59$exports.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $3566357a12adc1a6$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $873eefa173eeba59$exports.hasSpanStreamingEnabled)(client)
                });
                $86439d66f81a91b2$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $873eefa173eeba59$exports.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $873eefa173eeba59$exports.spanIsSampled)(idleSpan),
                    dsc: (0, $873eefa173eeba59$exports.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $86439d66f81a91b2$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $86439d66f81a91b2$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $873eefa173eeba59$exports.registerSpanErrorInstrumentation)();
            if (enableLongAnimationFrame && (0, $873eefa173eeba59$exports.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) (0, $3566357a12adc1a6$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $3566357a12adc1a6$export$f396d19077034ad2)();
            if (enableInteractions) (0, $3566357a12adc1a6$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $873eefa173eeba59$exports.timestampInSeconds)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $86439d66f81a91b2$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $873eefa173eeba59$exports.spanToJSON)(activeSpan).timestamp) {
                    (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).log(`[Tracing] Finishing current active span with op: ${(0, $873eefa173eeba59$exports.spanToJSON)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, {
                        op: "navigation.redirect",
                        ...startSpanOptions
                    }, false, navigationOptions.url);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                const scope = (0, $873eefa173eeba59$exports.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $873eefa173eeba59$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $873eefa173eeba59$exports.hasSpansEnabled)() ? void 0 : (0, $873eefa173eeba59$exports.generateSpanId)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }, true, navigationOptions?.url);
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $86439d66f81a91b2$export$f147b32b03c9cf11("sentry-trace") || $86439d66f81a91b2$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $86439d66f81a91b2$export$f147b32b03c9cf11("baggage") || $86439d66f81a91b2$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $873eefa173eeba59$exports.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $873eefa173eeba59$exports.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $873eefa173eeba59$exports.hasSpansEnabled)()) scope.getPropagationContext().propagationSpanId = (0, $873eefa173eeba59$exports.generateSpanId)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $a50070dc9fce1766$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            if (client.addIntegration && !client.getIntegrationByName?.((0, $b499a57c59dd3fde$export$8748555bacc7091c))) client.addIntegration((0, $b499a57c59dd3fde$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $873eefa173eeba59$exports.getLocationHref)();
            if (linkPreviousTrace !== "off") (0, $cdbcb685a0ce472e$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $873eefa173eeba59$exports.browserPerformanceTimeOrigin)();
                    $86439d66f81a91b2$export$aa44a07f82af519f(client, {
                        name: (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $b6b753cdb356d243$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $873eefa173eeba59$exports.parseStringToURLObject)(to);
                    const activeSpan = $86439d66f81a91b2$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $86439d66f81a91b2$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $86439d66f81a91b2$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $6df92446e2e423bf$export$6f18f55521af71a1)();
            if (enableInteractions) $86439d66f81a91b2$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $360907223a210170$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $fe96afdbb79e7fe9$export$b49e0d1a48dc8754)());
        }
    };
};
function $86439d66f81a91b2$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $873eefa173eeba59$exports.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $86439d66f81a91b2$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $86439d66f81a91b2$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    const scope = (0, $873eefa173eeba59$exports.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $a50070dc9fce1766$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $86439d66f81a91b2$var$getActiveIdleSpan(client);
}
function $86439d66f81a91b2$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || void 0;
}
function $86439d66f81a91b2$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    const entry = navigation?.serverTiming?.find((entry2)=>entry2.name === name);
    return entry?.description;
}
function $86439d66f81a91b2$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $86439d66f81a91b2$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $873eefa173eeba59$exports.spanToJSON)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $873eefa173eeba59$exports.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $873eefa173eeba59$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $86439d66f81a91b2$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $86439d66f81a91b2$var$getActiveIdleSpan(client) {
    return client[$86439d66f81a91b2$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $86439d66f81a91b2$var$setActiveIdleSpan(client, span) {
    (0, $873eefa173eeba59$exports.addNonEnumerableProperty)(client, $86439d66f81a91b2$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $86439d66f81a91b2$var$REDIRECT_THRESHOLD = 1.5;
function $86439d66f81a91b2$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $873eefa173eeba59$exports.spanToJSON)(activeSpan);
    const now = (0, $873eefa173eeba59$exports.dateTimestampInSeconds)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $86439d66f81a91b2$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $86439d66f81a91b2$var$REDIRECT_THRESHOLD) return false;
    return true;
}




function $c512194462555a6d$export$a6c2d27607295951(stackParser, ex) {
    const frames = $c512194462555a6d$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $c512194462555a6d$export$2e9ae379995d99e3(ex),
        value: $c512194462555a6d$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $c512194462555a6d$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $873eefa173eeba59$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $c512194462555a6d$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $873eefa173eeba59$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $c512194462555a6d$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $873eefa173eeba59$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $c512194462555a6d$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $c512194462555a6d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $c512194462555a6d$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $c512194462555a6d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $c512194462555a6d$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $c512194462555a6d$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $c512194462555a6d$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $c512194462555a6d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $c512194462555a6d$var$getSkipFirstStackStringLines(ex) {
    if (ex && $c512194462555a6d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $c512194462555a6d$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $c512194462555a6d$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $c512194462555a6d$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $c512194462555a6d$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $c512194462555a6d$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($c512194462555a6d$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $873eefa173eeba59$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $873eefa173eeba59$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
function $c512194462555a6d$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $c512194462555a6d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $873eefa173eeba59$exports.addExceptionMechanism)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $873eefa173eeba59$exports.resolvedSyncPromise)(event);
}
function $c512194462555a6d$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $c512194462555a6d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $873eefa173eeba59$exports.resolvedSyncPromise)(event);
}
function $c512194462555a6d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $873eefa173eeba59$exports.isErrorEvent)(exception) && exception.error) {
        const errorEvent = exception;
        return $c512194462555a6d$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $873eefa173eeba59$exports.isDOMError)(exception) || (0, $873eefa173eeba59$exports.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $c512194462555a6d$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $c512194462555a6d$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $873eefa173eeba59$exports.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c512194462555a6d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $873eefa173eeba59$exports.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $873eefa173eeba59$exports.isError)(exception)) return $c512194462555a6d$var$eventFromError(stackParser, exception);
    if ((0, $873eefa173eeba59$exports.isPlainObject)(exception) || (0, $873eefa173eeba59$exports.isEvent)(exception)) {
        const objectException = exception;
        event = $c512194462555a6d$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    event = $c512194462555a6d$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $873eefa173eeba59$exports.addExceptionTypeValue)(event, `${exception}`, void 0);
    (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $c512194462555a6d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $c512194462555a6d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $873eefa173eeba59$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $873eefa173eeba59$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $c512194462555a6d$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $873eefa173eeba59$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $873eefa173eeba59$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $873eefa173eeba59$exports.isEvent)(exception)) {
        const className = $c512194462555a6d$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c512194462555a6d$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $c512194462555a6d$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $873eefa173eeba59$exports.isError));
}



class $3a30d428a485b560$export$1df9218a526d318d extends (0, $873eefa173eeba59$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $3a30d428a485b560$export$4e107b20a7f977(options);
        const sdkSource = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $873eefa173eeba59$exports.getSDKSource)();
        (0, $873eefa173eeba59$exports.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $873eefa173eeba59$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $c512194462555a6d$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $c512194462555a6d$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $3a30d428a485b560$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





const $4ae36ed1a9e48935$var$DEBOUNCE_DURATION = 1e3;
let $4ae36ed1a9e48935$var$debounceTimerID;
let $4ae36ed1a9e48935$var$lastCapturedEventType;
let $4ae36ed1a9e48935$var$lastCapturedEventTargetId;
function $4ae36ed1a9e48935$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $915c7efdb0533300$export$a4e09611e30da72e)(type, handler);
    (0, $915c7efdb0533300$export$e18d6c5462c01368)(type, $4ae36ed1a9e48935$export$3014bbf0af0e1d4a);
}
function $4ae36ed1a9e48935$export$3014bbf0af0e1d4a() {
    if (!(0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $915c7efdb0533300$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $4ae36ed1a9e48935$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $73ebe44591c0f61f$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $4ae36ed1a9e48935$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $73ebe44591c0f61f$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $4ae36ed1a9e48935$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $4ae36ed1a9e48935$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $4ae36ed1a9e48935$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $4ae36ed1a9e48935$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $4ae36ed1a9e48935$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $4ae36ed1a9e48935$var$getEventTarget(event);
        if ($4ae36ed1a9e48935$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $73ebe44591c0f61f$export$e73679ffaf56810e)(target, "_sentryId", (0, $b7774ea50e5fc610$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$4ae36ed1a9e48935$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $4ae36ed1a9e48935$var$lastCapturedEventType = event.type;
            $4ae36ed1a9e48935$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($4ae36ed1a9e48935$var$debounceTimerID);
        $4ae36ed1a9e48935$var$debounceTimerID = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).setTimeout(()=>{
            $4ae36ed1a9e48935$var$lastCapturedEventTargetId = void 0;
            $4ae36ed1a9e48935$var$lastCapturedEventType = void 0;
        }, $4ae36ed1a9e48935$var$DEBOUNCE_DURATION);
    };
}
function $4ae36ed1a9e48935$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}




const $f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $f7f740a4fbe59686$var$INTEGRATION_NAME = "Breadcrumbs";
const $f7f740a4fbe59686$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $f7f740a4fbe59686$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $873eefa173eeba59$exports.addConsoleInstrumentationHandler)($f7f740a4fbe59686$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $4ae36ed1a9e48935$export$5aeffd3db2cf9df7)($f7f740a4fbe59686$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $f8496e812cd386ad$export$26ace48dd54c9aea)($f7f740a4fbe59686$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $873eefa173eeba59$exports.addFetchInstrumentationHandler)($f7f740a4fbe59686$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $b6b753cdb356d243$export$3f18c56c58114e75)($f7f740a4fbe59686$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $f7f740a4fbe59686$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $f7f740a4fbe59686$export$c079d904b326663a = (0, $873eefa173eeba59$exports.defineIntegration)($f7f740a4fbe59686$var$_breadcrumbsIntegration);
function $f7f740a4fbe59686$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        (0, $873eefa173eeba59$exports.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $873eefa173eeba59$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
function $f7f740a4fbe59686$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $f7f740a4fbe59686$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $f7f740a4fbe59686$var$_isEvent(event) ? event.target : event;
            target = (0, $519e8d19cc16330e$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $873eefa173eeba59$exports.getComponentName)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $f7f740a4fbe59686$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $873eefa173eeba59$exports.severityLevelFromString)(handlerData.level),
            message: (0, $873eefa173eeba59$exports.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $873eefa173eeba59$exports.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function $f7f740a4fbe59686$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $f8496e812cd386ad$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $873eefa173eeba59$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
function $f7f740a4fbe59686$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $873eefa173eeba59$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $873eefa173eeba59$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
function $f7f740a4fbe59686$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $873eefa173eeba59$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $873eefa173eeba59$exports.parseUrl)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $873eefa173eeba59$exports.parseUrl)(from) : void 0;
        const parsedTo = (0, $873eefa173eeba59$exports.parseUrl)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $873eefa173eeba59$exports.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $f7f740a4fbe59686$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $8af5ba196f611cdb$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $8af5ba196f611cdb$var$INTEGRATION_NAME = "BrowserApiErrors";
const $8af5ba196f611cdb$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $8af5ba196f611cdb$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $873eefa173eeba59$exports.fill)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81), "setTimeout", $8af5ba196f611cdb$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $873eefa173eeba59$exports.fill)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81), "setInterval", $8af5ba196f611cdb$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $873eefa173eeba59$exports.fill)((0, $a50070dc9fce1766$export$56d8a8a25bd48b81), "requestAnimationFrame", $8af5ba196f611cdb$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $a50070dc9fce1766$export$56d8a8a25bd48b81)) (0, $873eefa173eeba59$exports.fill)(XMLHttpRequest.prototype, "send", $8af5ba196f611cdb$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $8af5ba196f611cdb$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$8af5ba196f611cdb$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $8af5ba196f611cdb$export$59bfe9f1c76150e = (0, $873eefa173eeba59$exports.defineIntegration)($8af5ba196f611cdb$var$_browserApiErrorsIntegration);
function $8af5ba196f611cdb$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $a50070dc9fce1766$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $873eefa173eeba59$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $8af5ba196f611cdb$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $a50070dc9fce1766$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $873eefa173eeba59$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $8af5ba196f611cdb$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $873eefa173eeba59$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $873eefa173eeba59$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $873eefa173eeba59$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $873eefa173eeba59$exports.getFunctionName)(originalFunction);
                return (0, $a50070dc9fce1766$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $8af5ba196f611cdb$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $873eefa173eeba59$exports.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($8af5ba196f611cdb$var$isEventListenerObject(fn)) fn.handleEvent = (0, $a50070dc9fce1766$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $873eefa173eeba59$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $8af5ba196f611cdb$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $a50070dc9fce1766$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $873eefa173eeba59$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $873eefa173eeba59$exports.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $8af5ba196f611cdb$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $8af5ba196f611cdb$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}






const $51ecc2a8233ee5e8$export$1baa7880e357371c = (0, $873eefa173eeba59$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? "route";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $873eefa173eeba59$exports.startSession)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $c4a2423438059f45$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $873eefa173eeba59$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $873eefa173eeba59$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $873eefa173eeba59$exports.captureSession)();
                }
            });
            if (lifecycle === "route") (0, $b6b753cdb356d243$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $873eefa173eeba59$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $873eefa173eeba59$exports.captureSession)();
                    initialSessionSent = true;
                }
            });
        }
    };
});




const $0182c93812b892bb$var$INTEGRATION_NAME = "CultureContext";
const $0182c93812b892bb$var$_cultureContextIntegration = ()=>{
    return {
        name: $0182c93812b892bb$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $0182c93812b892bb$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $0182c93812b892bb$var$getCultureContext();
            if (culture) (0, $873eefa173eeba59$exports.safeSetSpanJSONAttributes)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $0182c93812b892bb$export$ec5976aacdc85985 = (0, $873eefa173eeba59$exports.defineIntegration)($0182c93812b892bb$var$_cultureContextIntegration);
function $0182c93812b892bb$var$getCultureContext() {
    try {
        const intl = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}






const $877fe9a43d6aa4f0$var$INTEGRATION_NAME = "GlobalHandlers";
const $877fe9a43d6aa4f0$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $877fe9a43d6aa4f0$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $877fe9a43d6aa4f0$var$_installGlobalOnErrorHandler(client);
                $877fe9a43d6aa4f0$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $877fe9a43d6aa4f0$var$_installGlobalOnUnhandledRejectionHandler(client);
                $877fe9a43d6aa4f0$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $877fe9a43d6aa4f0$export$66acc70e8cf2b71a = (0, $873eefa173eeba59$exports.defineIntegration)($877fe9a43d6aa4f0$var$_globalHandlersIntegration);
function $877fe9a43d6aa4f0$var$_installGlobalOnErrorHandler(client) {
    (0, $873eefa173eeba59$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $877fe9a43d6aa4f0$var$getOptions();
        if ((0, $873eefa173eeba59$exports.getClient)() !== client || (0, $a50070dc9fce1766$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $877fe9a43d6aa4f0$var$_enhanceEventWithInitialFrame((0, $c512194462555a6d$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $873eefa173eeba59$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $877fe9a43d6aa4f0$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $873eefa173eeba59$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $877fe9a43d6aa4f0$var$getOptions();
        if ((0, $873eefa173eeba59$exports.getClient)() !== client || (0, $a50070dc9fce1766$export$b79738ab10c590b2)()) return;
        const error = $877fe9a43d6aa4f0$export$b2cc40fa8241780(e);
        const event = (0, $873eefa173eeba59$exports.isPrimitive)(error) ? $877fe9a43d6aa4f0$export$1353b5b36844a9ed(error) : (0, $c512194462555a6d$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $873eefa173eeba59$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $877fe9a43d6aa4f0$export$b2cc40fa8241780(error) {
    if ((0, $873eefa173eeba59$exports.isPrimitive)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $877fe9a43d6aa4f0$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $877fe9a43d6aa4f0$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $877fe9a43d6aa4f0$var$getFilenameFromUrl(url) ?? (0, $873eefa173eeba59$exports.getLocationHref)(),
        function: (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $877fe9a43d6aa4f0$var$globalHandlerLog(type) {
    (0, $b784161f263a7c57$export$16a28057038b10ef) && (0, $873eefa173eeba59$exports.debug).log(`Global Handler attached: ${type}`);
}
function $877fe9a43d6aa4f0$var$getOptions() {
    const client = (0, $873eefa173eeba59$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $877fe9a43d6aa4f0$var$getFilenameFromUrl(url) {
    if (!(0, $873eefa173eeba59$exports.isString)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $873eefa173eeba59$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}





var $eAISS = parcelRequire("eAISS");
const $c08cb1f601d03b51$export$1378794447170364 = (0, $873eefa173eeba59$exports.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            if (!(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).navigator && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $a50070dc9fce1766$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSpan (span) {
            if (!(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).navigator && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).location && !(0, $a50070dc9fce1766$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $a50070dc9fce1766$export$a3c4a8453e8936f0)();
            (0, $873eefa173eeba59$exports.safeSetSpanJSONAttributes)(span, {
                // This attribute is used by the "Filter out events from legacy browsers and crawlers" features on the Sentry backend.
                // Therefore, it's set on every span.
                [(0, $eAISS.USER_AGENT_ORIGINAL)]: reqData.headers["User-Agent"],
                // These attributes, we only need on the segment span (analogous to the `request` context for events)
                ...span.is_segment && {
                    // Coerce empty string to undefined so the helper's nullish check drops it,
                    // rather than writing an empty `url.full` attribute onto the span.
                    [(0, $eAISS.URL_FULL)]: span.attributes?.[0, $eAISS.SENTRY_OP] !== "http.client" ? (0, $873eefa173eeba59$exports.filterCollectedUrl)(reqData.url) : void 0,
                    [`${0, $eAISS.HTTP_REQUEST_HEADER_KEY_BASE}.referer`]: reqData.headers["Referer"]
                }
            });
        }
    };
});




const $eb7d5d4896892e78$var$DEFAULT_KEY = "cause";
const $eb7d5d4896892e78$var$DEFAULT_LIMIT = 5;
const $eb7d5d4896892e78$var$INTEGRATION_NAME = "LinkedErrors";
const $eb7d5d4896892e78$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $eb7d5d4896892e78$var$DEFAULT_LIMIT;
    const key = options.key || $eb7d5d4896892e78$var$DEFAULT_KEY;
    return {
        name: $eb7d5d4896892e78$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $873eefa173eeba59$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $c512194462555a6d$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $eb7d5d4896892e78$export$ebabb00eb7f3a395 = (0, $873eefa173eeba59$exports.defineIntegration)($eb7d5d4896892e78$var$_linkedErrorsIntegration);



const $14062789fbcfb5db$var$OPERA10_PRIORITY = 10;
const $14062789fbcfb5db$var$OPERA11_PRIORITY = 20;
const $14062789fbcfb5db$var$CHROME_PRIORITY = 30;
const $14062789fbcfb5db$var$WINJS_PRIORITY = 40;
const $14062789fbcfb5db$var$GECKO_PRIORITY = 50;
function $14062789fbcfb5db$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $14062789fbcfb5db$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $14062789fbcfb5db$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $14062789fbcfb5db$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $14062789fbcfb5db$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $14062789fbcfb5db$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($14062789fbcfb5db$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $14062789fbcfb5db$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $14062789fbcfb5db$var$createFrame(filename, (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +line2, +col);
    }
    const parts = $14062789fbcfb5db$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $14062789fbcfb5db$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $14062789fbcfb5db$var$extractSafariExtensionDetails(parts[1] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), parts[2]);
        return $14062789fbcfb5db$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $14062789fbcfb5db$export$263a749fff749872 = [
    $14062789fbcfb5db$var$CHROME_PRIORITY,
    $14062789fbcfb5db$var$chromeStackParserFn
];
const $14062789fbcfb5db$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $14062789fbcfb5db$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $14062789fbcfb5db$var$gecko = (line)=>{
    const parts = $14062789fbcfb5db$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $14062789fbcfb5db$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION);
        [func, filename] = $14062789fbcfb5db$var$extractSafariExtensionDetails(func, filename);
        return $14062789fbcfb5db$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $14062789fbcfb5db$export$cdba47a5dd2804d = [
    $14062789fbcfb5db$var$GECKO_PRIORITY,
    $14062789fbcfb5db$var$gecko
];
const $14062789fbcfb5db$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $14062789fbcfb5db$var$winjs = (line)=>{
    const parts = $14062789fbcfb5db$var$winjsRegex.exec(line);
    return parts ? $14062789fbcfb5db$var$createFrame(parts[2], parts[1] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $14062789fbcfb5db$export$179460296da408e8 = [
    $14062789fbcfb5db$var$WINJS_PRIORITY,
    $14062789fbcfb5db$var$winjs
];
const $14062789fbcfb5db$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $14062789fbcfb5db$var$opera10 = (line)=>{
    const parts = $14062789fbcfb5db$var$opera10Regex.exec(line);
    return parts ? $14062789fbcfb5db$var$createFrame(parts[2], parts[3] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +parts[1]) : void 0;
};
const $14062789fbcfb5db$export$f892b52c880ffc7a = [
    $14062789fbcfb5db$var$OPERA10_PRIORITY,
    $14062789fbcfb5db$var$opera10
];
const $14062789fbcfb5db$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $14062789fbcfb5db$var$opera11 = (line)=>{
    const parts = $14062789fbcfb5db$var$opera11Regex.exec(line);
    return parts ? $14062789fbcfb5db$var$createFrame(parts[5], parts[3] || parts[4] || (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : void 0;
};
const $14062789fbcfb5db$export$af11af13f09fb0dc = [
    $14062789fbcfb5db$var$OPERA11_PRIORITY,
    $14062789fbcfb5db$var$opera11
];
const $14062789fbcfb5db$export$7197c0fe6554c079 = [
    $14062789fbcfb5db$export$263a749fff749872,
    $14062789fbcfb5db$export$cdba47a5dd2804d
];
const $14062789fbcfb5db$export$2b2b997d81bf3907 = (0, $873eefa173eeba59$exports.createStackParser)(...$14062789fbcfb5db$export$7197c0fe6554c079);
const $14062789fbcfb5db$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $873eefa173eeba59$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






const $3eb93b694eb01679$var$cachedImplementations = {};
function $3eb93b694eb01679$export$e464f4a514ac28a8(name) {
    const cached = $3eb93b694eb01679$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81)[name];
    if ((0, $6aeaaf927d53c892$export$d5f608b368e73f38)(impl)) return $3eb93b694eb01679$var$cachedImplementations[name] = impl.bind((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81));
    const document = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $3eb93b694eb01679$var$cachedImplementations[name] = impl.bind((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81));
}
function $3eb93b694eb01679$export$8aa36702e8c8978(name) {
    $3eb93b694eb01679$var$cachedImplementations[name] = void 0;
}
function $3eb93b694eb01679$export$e7aa7bc5c1b3cfb3(...rest) {
    return $3eb93b694eb01679$export$e464f4a514ac28a8("fetch")(...rest);
}
function $3eb93b694eb01679$export$831dc9f2ab0a617b(...rest) {
    try {
        return $3eb93b694eb01679$export$e464f4a514ac28a8("setTimeout")(...rest);
    } catch (e) {
        (0, $fd229e17678bfd20$export$16a28057038b10ef) && (0, $169ad50b2cdc7abf$export$1c9f709888824e05).warn("Could not use native setTimeout implementation, falling back to window.setTimeout: ", e);
        const fallback = (0, $e5af6672c42ca74f$export$56d8a8a25bd48b81).setTimeout.bind((0, $e5af6672c42ca74f$export$56d8a8a25bd48b81));
        $3eb93b694eb01679$var$cachedImplementations.setTimeout = fallback;
        return fallback(...rest);
    }
}


const $af57be7b00d81af5$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $af57be7b00d81af5$export$b2311068c46d7cc8(options, nativeFetch = (0, $3eb93b694eb01679$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $3eb93b694eb01679$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $873eefa173eeba59$exports.createTransport)(options, makeRequest, (0, $873eefa173eeba59$exports.makePromiseBuffer)(options.bufferSize || $af57be7b00d81af5$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $b0118be6a67310ff$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $fb7c90f9ce98560e$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $fb7c90f9ce98560e$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $b0118be6a67310ff$export$45a5e7f76e0caa8d)(value)) {
        const objName = $fb7c90f9ce98560e$var$getConstructorName(value);
        if ($fb7c90f9ce98560e$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $519e8d19cc16330e$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $fb7c90f9ce98560e$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}





function $8bff6e4a5c09e026$export$dc236a86065879fc() {
    if ($8bff6e4a5c09e026$var$_isEmbeddedBrowserExtension()) {
        if (0, $b784161f263a7c57$export$16a28057038b10ef) (0, $873eefa173eeba59$exports.consoleSandbox)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $8bff6e4a5c09e026$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $873eefa173eeba59$exports.getLocationHref)();
    const isDedicatedExtensionPage = (0, $a50070dc9fce1766$export$56d8a8a25bd48b81) === (0, $a50070dc9fce1766$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $620d70b04505c050$export$5783b2920b1d62b9(_options) {
    return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line typescript/no-deprecated
        (0, $873eefa173eeba59$exports.inboundFiltersIntegration)(),
        (0, $873eefa173eeba59$exports.functionToStringIntegration)(),
        (0, $873eefa173eeba59$exports.conversationIdIntegration)(),
        (0, $8af5ba196f611cdb$export$59bfe9f1c76150e)(),
        (0, $f7f740a4fbe59686$export$c079d904b326663a)(),
        (0, $877fe9a43d6aa4f0$export$66acc70e8cf2b71a)(),
        (0, $eb7d5d4896892e78$export$ebabb00eb7f3a395)(),
        (0, $873eefa173eeba59$exports.dedupeIntegration)(),
        (0, $c08cb1f601d03b51$export$1378794447170364)(),
        (0, $0182c93812b892bb$export$ec5976aacdc85985)(),
        (0, $51ecc2a8233ee5e8$export$1baa7880e357371c)()
    ];
}
function $620d70b04505c050$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $8bff6e4a5c09e026$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $620d70b04505c050$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $873eefa173eeba59$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $14062789fbcfb5db$export$2b2b997d81bf3907)),
        integrations: (0, $873eefa173eeba59$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $af57be7b00d81af5$export$b2311068c46d7cc8)
    };
    (0, $873eefa173eeba59$exports.setNormalizeStringifier)((0, $fb7c90f9ce98560e$export$4c88c355e6072df5));
    return (0, $873eefa173eeba59$exports.initAndBind)((0, $3a30d428a485b560$export$1df9218a526d318d), clientOptions);
}
function $620d70b04505c050$export$a3f323d81eede727() {}
function $620d70b04505c050$export$4e4d8b287d028b6b(callback) {
    callback();
}


var $f633eb68188f0218$exports = {};
!/**
 * Highcharts JS v13.1.1 (2026-09-20)
 * @module highcharts/highcharts
 *
 * (c) 2009-2026 Highsoft AS
 *
 * A commercial license may be required depending on use,
 * see www.highcharts.com/license
 */ function(t, e) {
    t._Highcharts = e(), $f633eb68188f0218$exports = t._Highcharts;
}("u" < typeof window ? $f633eb68188f0218$exports : window, ()=>(()=>{
        "use strict";
        let t, e, i, s, o, r = {};
        r.d = (t, e)=>{
            for(var i in e)r.o(e, i) && !r.o(t, i) && Object.defineProperty(t, i, {
                enumerable: !0,
                get: e[i]
            });
        }, r.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        let a = {};
        r.d(a, {
            default: ()=>s0
        }), (ic = e3 || (e3 = {})).SVG_NS = "http://www.w3.org/2000/svg", ic.product = "Highcharts", ic.version = "13.1.1", ic.win = "u" > typeof window ? window : {}, ic.doc = ic.win.document, ic.svg = !!ic.doc?.createElementNS?.(ic.SVG_NS, "svg")?.createSVGRect, ic.pageLang = ic.doc?.documentElement?.closest("[lang]")?.lang, ic.userAgent = ic.win.navigator?.userAgent || "", ic.isChrome = ic.win.chrome, ic.isFirefox = -1 !== ic.userAgent.indexOf("Firefox"), ic.isMS = /(edge|msie|trident)/i.test(ic.userAgent) && !ic.win.opera, ic.isSafari = !ic.isChrome && -1 !== ic.userAgent.indexOf("Safari"), ic.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(ic.userAgent), ic.isWebKit = -1 !== ic.userAgent.indexOf("AppleWebKit"), ic.deg2rad = 2 * Math.PI / 360, ic.marginNames = [
            "plotTop",
            "marginRight",
            "marginBottom",
            "plotLeft"
        ], ic.noop = function() {}, ic.supportsPassiveEvents = function() {
            let t = !1;
            if (!ic.isMS) {
                let e = {
                    get passive () {
                        return t = !0;
                    }
                };
                ic.win.addEventListener && ic.win.removeEventListener && (ic.win.addEventListener("testPassive", ic.noop, e), ic.win.removeEventListener("testPassive", ic.noop, e));
            }
            return t;
        }(), ic.charts = [], ic.composed = [], ic.dateFormats = {}, ic.seriesTypes = {}, ic.symbolSizes = {}, ic.chartCount = 0;
        let n = e3, h = {
            dark: {
                backgroundColor: "#141414",
                neutralColor: "#ffffff",
                highlightColor: "#2caffe"
            },
            light: {
                backgroundColor: "#ffffff",
                neutralColor: "#000000",
                highlightColor: "#0022ff",
                positiveColor: "#06b535",
                negativeColor: "#f21313"
            }
        }, { doc: l, win: d } = n;
        function c(t, e, i, s = {}) {
            let o = "function" == typeof t && t.prototype || t;
            Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {});
            let r = o.hcEvents;
            n.Point && t instanceof n.Point && t.series && t.series.chart && (t.series.chart.runTrackerClick = !0);
            let a = t.addEventListener;
            a && a.call(t, e, i, !!n.supportsPassiveEvents && {
                passive: void 0 === s.passive ? -1 !== e.indexOf("touch") : s.passive,
                capture: !1
            }), r[e] || (r[e] = []);
            let h = {
                fn: i,
                order: "number" == typeof s.order ? s.order : 1 / 0
            };
            return r[e].push(h), r[e].sort((t, e)=>t.order - e.order), function() {
                q(t, e, i);
            };
        }
        function p(t) {
            let e = t.length, i = t[0];
            for(; e--;)t[e] < i && (i = t[e]);
            return i;
        }
        function g(t) {
            let e = t.length, i = t[0];
            for(; e--;)t[e] > i && (i = t[e]);
            return i;
        }
        function u(t, e, i) {
            let s, o = W(e) && !v(i), r = (e, i)=>{
                v(e) ? t.setAttribute(i, e) : o ? (s = t.getAttribute(i)) || "class" !== i || (s = t.getAttribute(i + "Name")) : t.removeAttribute(i);
            };
            return W(e) ? r(i, e) : j(e, r), s;
        }
        function f(t, e, i) {
            return t > e ? t < i ? t : i : e;
        }
        function m(t, e) {
            return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
        }
        function x(t, e, i, s, o) {
            let r = l.createElement(t);
            return e && S(r, e), o && b(r, {
                padding: "0",
                border: "none",
                margin: "0"
            }), i && b(r, i), s && s.appendChild(r), r;
        }
        function y(t, e = 0, i) {
            let s = e % 2 / 2, o = i ? -1 : 1;
            return (Math.round(t * o - s) + s) * o;
        }
        function b(t, e) {
            S(t.style, e);
        }
        function v(t) {
            return null != t;
        }
        function k(t, e, i) {
            j(t, function(s, o) {
                s !== e && s?.destroy && s.destroy(), (s?.destroy || !i) && delete t[o];
            });
        }
        function w(t) {
            t?.parentElement?.removeChild(t);
        }
        function M(t, e, i, s) {
            let o = {};
            return !function t(e, o, r, a) {
                let n = i ? o : e;
                j(e, function(i, h) {
                    if (!a && s && s.indexOf(h) > -1 && o[h]) {
                        i = J(i), r[h] = [];
                        for(let e = 0; e < Math.max(i.length, o[h].length); e++)o[h][e] && (void 0 === i[e] ? r[h][e] = o[h][e] : (r[h][e] = {}, t(i[e], o[h][e], r[h][e], a + 1)));
                    } else X(i, !0) && !i.nodeType ? (r[h] = H(i) ? [] : {}, t(i, o[h] || {}, r[h], a + 1), 0 === Object.keys(r[h]).length && ("colorAxis" !== h || 0 !== a) && delete r[h]) : (e[h] !== o[h] || h in e && !(h in o)) && "__proto__" !== h && "constructor" !== h && (r[h] = n[h]);
                });
            }(t, e, o, 0), o;
        }
        function C(t, e) {
            let i = t.length;
            for(; i--;)if (t[i] === e) {
                t.splice(i, 1);
                break;
            }
        }
        function S(t, e) {
            let i;
            for(i in t || (t = {}), e)"__proto__" !== i && "constructor" !== i && (t[i] = e[i]);
            return t;
        }
        function T(t, e) {
            let i = function() {};
            return i.prototype = new t, S(i.prototype, e), i;
        }
        function P(t, e, i, s) {
            if (i = i || {}, l?.createEvent && (t.dispatchEvent || t.fireEvent && t !== n)) {
                let s = l.createEvent("Events");
                s.initEvent(e, !0, !0), i = S(s, i), t.dispatchEvent ? t.dispatchEvent(i) : t.fireEvent(e, i);
            } else if (t.hcEvents) {
                i.target || S(i, {
                    preventDefault: function() {
                        i.defaultPrevented = !0;
                    },
                    target: t,
                    type: e
                });
                let s = [], o = t, r = !1;
                for(; o.hcEvents;)Object.hasOwnProperty.call(o, "hcEvents") && o.hcEvents[e] && (s.length && (r = !0), s.unshift.apply(s, o.hcEvents[e])), o = Object.getPrototypeOf(o);
                r && s.sort((t, e)=>t.order - e.order), s.forEach((e)=>{
                    !1 === e.fn.call(t, i, t) && i.preventDefault();
                });
            }
            s && !i.defaultPrevented && s.call(t, i);
        }
        let A = (t = "")=>({
                center: .5,
                right: 1,
                middle: .5,
                bottom: 1
            })[t] || 0;
        function L(t, e) {
            let i, s, o, r, a = !e;
            return t.forEach((t)=>{
                if (t.length > 1) for(r = s = t.length - 1; r > 0; r--)(o = t[r] - t[r - 1]) < 0 && !a ? (e?.(), e = void 0) : o && (void 0 === i || o < i) && (i = o);
            }), i;
        }
        function O(t) {
            return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
        }
        function E(t, e) {
            let i = t.split(".");
            for(; i.length && v(e);){
                let t = i.shift();
                if (void 0 === t || "__proto__" === t) return;
                if ("this" === t) {
                    let t;
                    return X(e) && (t = e["@this"]), t ?? e;
                }
                let s = e[t.replace(/[\\'"]/g, "")];
                if (!v(s) || "function" == typeof s || "number" == typeof s.nodeType || s === d) return;
                e = s;
            }
            return e;
        }
        function I(t, e, i) {
            let s;
            if ("width" === e) {
                let e = Math.min(t.offsetWidth, t.scrollWidth), i = t.getBoundingClientRect?.().width;
                return i < e && i >= e - 1 && (e = Math.floor(i)), Math.max(0, e - (I(t, "padding-left", !0) || 0) - (I(t, "padding-right", !0) || 0));
            }
            if ("height" === e) return Math.max(0, Math.min(t.offsetHeight, t.scrollHeight) - (I(t, "padding-top", !0) || 0) - (I(t, "padding-bottom", !0) || 0));
            let o = d.getComputedStyle(t, void 0);
            return o && (s = o.getPropertyValue(e), (i ?? "opacity" !== e) && (s = U(s))), s;
        }
        let D = Array.prototype.find ? function(t, e) {
            return t.find(e);
        } : function(t, e) {
            let i, s = t.length;
            for(i = 0; i < s; i++)if (e(t[i], i)) return t[i];
        };
        function B(t) {
            v(t) && clearTimeout(t);
        }
        function z(t) {
            return X(t) && "number" == typeof t.nodeType;
        }
        function R(t) {
            let e = t?.constructor;
            return !!(X(t, !0) && !z(t) && e?.name && "Object" !== e.name);
        }
        function N(t) {
            return "number" == typeof t && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
        }
        function W(t) {
            return "string" == typeof t;
        }
        function H(t) {
            let e = Object.prototype.toString.call(t);
            return "[object Array]" === e || "[object Array Iterator]" === e;
        }
        function G(t) {
            return "function" == typeof t;
        }
        function X(t, e) {
            return !!t && "object" == typeof t && (!e || !H(t));
        }
        function F(t, ...e) {
            let i, s = [
                t,
                ...e
            ], o = {}, r = function(t, e) {
                return "object" != typeof t && (t = {}), j(e, function(i, s) {
                    "__proto__" !== s && "constructor" !== s && (!X(i, !0) || R(i) || z(i) ? t[s] = e[s] : t[s] = r(t[s] || {}, i));
                }), t;
            };
            !0 === t && (o = s[1], s = Array.prototype.slice.call(s, 2));
            let a = s.length;
            for(i = 0; i < a; i++)o = r(o, s[i]);
            return o;
        }
        function Y(t, e, i, s, o) {
            let r, a = t;
            i = i ?? O(t);
            let n = t / i;
            for(!e && (e = o ? [
                1,
                1.2,
                1.5,
                2,
                2.5,
                3,
                4,
                5,
                6,
                8,
                10
            ] : [
                1,
                2,
                2.5,
                5,
                10
            ], !1 === s && (1 === i ? e = e.filter(function(t) {
                return t % 1 == 0;
            }) : i <= .1 && (e = [
                1 / i
            ]))), r = 0; r < e.length && (a = e[r], (!o || !(a * i >= t)) && (o || !(n <= (e[r] + (e[r + 1] || e[r])) / 2))); r++);
            return m(a * i, -Math.round(Math.log(.001) / Math.LN10));
        }
        function j(t, e, i) {
            for(let s in t)Object.hasOwnProperty.call(t, s) && e.call(i || t[s], t[s], s, t);
        }
        function $(t) {
            let e = l.documentElement, i = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
                top: 0,
                left: 0,
                width: 0,
                height: 0
            };
            return {
                top: i.top + (d.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                left: i.left + (d.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                width: i.width,
                height: i.height
            };
        }
        function V(t, e, i) {
            return Array((e || 2) + 1 - String(t).replace("-", "").length).join(i || "0") + t;
        }
        function U(t, e) {
            return parseInt(t, e || 10);
        }
        function _(t, e) {
            return 0 > t.indexOf(e) && !!t.push(e);
        }
        function Z(t, e, i) {
            return /%$/.test(t) ? e * parseFloat(t) / 100 + (i || 0) : parseFloat(t);
        }
        function K(t, ...e) {
            let i, s;
            do for (s of (i = t, e))t = t.replace(s[0], s[1]);
            while (t !== i);
            return t;
        }
        function q(t, e, i) {
            function s(e, i) {
                let s = t.removeEventListener;
                s && s.call(t, e, i, !1);
            }
            function o(i) {
                let o, r;
                t.nodeName && (e ? (o = {})[e] = !0 : o = i, j(o, function(t, e) {
                    if (i[e]) for(r = i[e].length; r--;)s(e, i[e][r].fn);
                }));
            }
            let r = "function" == typeof t && t.prototype || t;
            if (Object.hasOwnProperty.call(r, "hcEvents")) {
                let t = r.hcEvents;
                if (e) {
                    let r = t[e] || [];
                    i ? (t[e] = r.filter(function(t) {
                        return i !== t.fn;
                    }), s(e, i)) : (o(t), t[e] = []);
                } else o(t), delete r.hcEvents;
            }
        }
        function J(t) {
            return H(t) ? t : [
                t
            ];
        }
        function Q(t, e) {
            let i, s, o = t.length;
            for(s = 0; s < o; s++)t[s].safeI = s;
            for(t.sort(function(t, s) {
                return 0 === (i = e(t, s)) ? t.safeI - s.safeI : i;
            }), s = 0; s < o; s++)delete t[s].safeI;
        }
        function tt(t, e, i) {
            return e > 0 ? setTimeout(t, e, i) : (t.call(0, i), -1);
        }
        function te(t) {
            return W(t) ? t.substring(0, 1).toUpperCase() + t.substring(1) : String(t);
        }
        let { charts: ti, win: ts } = n;
        function to(t, e, i, s) {
            let o = e ? "Highcharts error" : "Highcharts warning";
            32 === t && (t = `${o}: Deprecated member`);
            let r = N(t), a = r ? `${o} #${t}: www.highcharts.com/errors/${t}/` : t.toString();
            if (void 0 !== s) {
                let t = "";
                r && (a += "?"), j(s, function(e, i) {
                    t += `
 - ${i}: ${e}`, r && (a += encodeURI(i) + "=" + encodeURI(e));
                }), a += t;
            }
            P(n, "displayError", {
                chart: i,
                code: t,
                message: a,
                params: s
            }, function() {
                if (e) throw Error(a);
                ts.console && -1 === to.messages.indexOf(a) && console.warn(a);
            }), to.messages.push(a);
        }
        function tr(t, e) {
            let i, s = t.options.index, o = e.length;
            for(i = t.options.isInternal ? o : 0; i < o + 1; i++)if (!e[i] || N(s) && s < (e[i].options.index ?? e[i]._i) || e[i].options.isInternal) {
                e.splice(i, 0, t);
                break;
            }
            return i;
        }
        (to || (to = {})).messages = [];
        let ta = {
            millisecond: 1,
            second: 1e3,
            minute: 6e4,
            hour: 36e5,
            day: 864e5,
            week: 6048e5,
            month: 24192e5,
            year: 314496e5
        };
        Math.easeInOutSine = function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        };
        let tn = (i = Math.random().toString(36).substring(2, 9) + "-", s = 0, function() {
            return "highcharts-" + (t ? "" : i) + s++;
        });
        ts.jQuery && (ts.jQuery.fn.highcharts = function() {
            let t = [].slice.call(arguments);
            if (this[0]) return t[0] ? (new n[W(t[0]) ? t.shift() : "Chart"](this[0], t[0], t[1]), this) : ti[u(this[0], "data-highcharts-chart")];
        });
        let { pageLang: th, win: tl } = n, td = n.isSafari && tl.Intl && !tl.Intl.DateTimeFormat.prototype.formatRange, tc = class {
            constructor(t, e){
                this.options = {
                    timezone: "UTC"
                }, this.variableTimezone = !1, this.Date = tl.Date, this.lang = e, this.update(t);
            }
            update(t = {}) {
                this.dTLCache = {}, this.options = t = F(!0, this.options, t);
                let { timezoneOffset: e, useUTC: i, locale: s } = t;
                this.Date = t.Date || tl.Date || Date;
                let o = t.timezone;
                v(i) && (o = i ? "UTC" : void 0), e && e % 60 == 0 && (o = "Etc/GMT" + (e > 0 ? "+" : "") + e / 60), this.variableTimezone = "UTC" !== o && o?.indexOf("Etc/GMT") !== 0, this.timezone = o, this.lang && s && (this.lang.locale = s), [
                    "months",
                    "shortMonths",
                    "weekdays",
                    "shortWeekdays"
                ].forEach((t)=>{
                    let e = /months/i.test(t), i = /short/.test(t), s = {
                        timeZone: "UTC"
                    };
                    s[e ? "month" : "weekday"] = i ? "short" : "long", this[t] = (e ? [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ] : [
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9
                    ]).map((t)=>this.dateFormat(s, (e ? 31 : 1) * 864e5 * t));
                });
            }
            toParts(t) {
                let [e, i, s, o, r, a, n] = this.dateTimeFormat({
                    weekday: "narrow",
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric"
                }, t, "es").split(/(?:, | |\/|:)/g);
                return [
                    +o,
                    s - 1,
                    +i,
                    +r,
                    +a,
                    +n,
                    Math.floor(Number(t) || 0) % 1e3,
                    "DLMXJVS".indexOf(e)
                ];
            }
            dateTimeFormat(t, e, i = this.options.locale || this.lang?.locale || th) {
                let s = JSON.stringify(t) + i;
                W(t) && (t = this.str2dtf(t));
                let o = this.dTLCache[s];
                if (!o) {
                    t.timeZone ?? (t.timeZone = this.timezone);
                    try {
                        o = new Intl.DateTimeFormat(i, t);
                    } catch (e) {
                        /Invalid time zone/i.test(e.message) ? (to(34), t.timeZone = "UTC", o = new Intl.DateTimeFormat(i, t)) : to(e.message, !1);
                    }
                }
                return this.dTLCache[s] = o, o?.format(e) || "";
            }
            str2dtf(t, e = {}) {
                let i = {
                    L: {
                        fractionalSecondDigits: 3
                    },
                    S: {
                        second: "2-digit"
                    },
                    M: {
                        minute: "numeric"
                    },
                    H: {
                        hour: "2-digit"
                    },
                    k: {
                        hour: "numeric"
                    },
                    E: {
                        weekday: "narrow"
                    },
                    a: {
                        weekday: "short"
                    },
                    A: {
                        weekday: "long"
                    },
                    d: {
                        day: "2-digit"
                    },
                    e: {
                        day: "numeric"
                    },
                    b: {
                        month: "short"
                    },
                    B: {
                        month: "long"
                    },
                    m: {
                        month: "2-digit"
                    },
                    o: {
                        month: "numeric"
                    },
                    y: {
                        year: "2-digit"
                    },
                    Y: {
                        year: "numeric"
                    }
                };
                return Object.keys(i).forEach((s)=>{
                    -1 !== t.indexOf(s) && S(e, i[s]);
                }), e;
            }
            makeTime(t, e, i = 1, s = 0, o, r, a) {
                let n = this.Date.UTC(t, e, i, s, o || 0, r || 0, a || 0);
                if ("UTC" !== this.timezone) {
                    let t = this.getTimezoneOffset(n), i = (s - t / ta.hour + 24) % 24;
                    if (n += t, -1 !== [
                        2,
                        3,
                        8,
                        9,
                        10,
                        11
                    ].indexOf(e) && (i < 5 || i > 20)) {
                        let e = this.getTimezoneOffset(n);
                        t !== e ? n += e - t : t - 36e5 !== this.getTimezoneOffset(n - 36e5) || td || (n -= 36e5);
                    }
                }
                return n;
            }
            parse(t) {
                if (!W(t)) return t ?? void 0;
                let e = (t = t.replace(/\//g, "-").replace(/(GMT|UTC)/, "")).indexOf("Z") > -1 || /([+-][0-9]{2}):?[0-9]{2}$/.test(t), i = /^[0-9]{4}-[0-9]{2}(-[0-9]{2}|)$/.test(t);
                e || i || (t += "Z");
                let s = Date.parse(t);
                if (N(s)) return s + (!e || i ? this.getTimezoneOffset(s) : 0);
            }
            getTimezoneOffset(t) {
                if ("UTC" !== this.timezone) {
                    let [e, i, s, o, r = 0] = this.dateTimeFormat({
                        timeZoneName: "shortOffset"
                    }, t, "en").split(/(GMT|:)/).map(Number), a = -(60 * (s + r / 60) * 6e4);
                    if (N(a)) return a;
                }
                return 0;
            }
            dateFormat(t, e, i) {
                let s = this.lang;
                if (!v(e) || isNaN(e)) return s?.invalidDate || "";
                if (W(t = t ?? "%Y-%m-%d %H:%M:%S")) {
                    let i, o = /%\[([a-zA-Z]+)\]/g;
                    for(; i = o.exec(t);)t = t.replace(i[0], this.dateTimeFormat(i[1], e, s?.locale));
                }
                if (W(t) && -1 !== t.indexOf("%")) {
                    let i = this, [o, r, a, h, l, d, c, p] = this.toParts(e), g = s?.weekdays || this.weekdays, u = s?.shortWeekdays || this.shortWeekdays, f = s?.months || this.months, m = s?.shortMonths || this.shortMonths;
                    j(S({
                        a: u ? u[p] : g[p].substr(0, 3),
                        A: g[p],
                        d: V(a),
                        e: V(a, 2, " "),
                        w: p,
                        v: s?.weekFrom ?? "",
                        b: m[r],
                        B: f[r],
                        m: V(r + 1),
                        o: r + 1,
                        y: o.toString().substr(2, 2),
                        Y: o,
                        H: V(h),
                        k: h,
                        I: V(h % 12 || 12),
                        l: h % 12 || 12,
                        M: V(l),
                        p: h < 12 ? "AM" : "PM",
                        P: h < 12 ? "am" : "pm",
                        S: V(d),
                        L: V(c, 3)
                    }, n.dateFormats), function(s, o) {
                        if (W(t)) for(; -1 !== t.indexOf("%" + o);)t = t.replace("%" + o, "function" == typeof s ? s.call(i, e, i) : s);
                    });
                } else if (X(t)) {
                    let i = (this.getTimezoneOffset(e) || 0) / 36e5, s = this.timezone || "Etc/GMT" + (i >= 0 ? "+" : "") + i, { prefix: o = "", suffix: r = "" } = t;
                    t = o + this.dateTimeFormat(S({
                        timeZone: s
                    }, t), e) + r;
                }
                return i ? te(t) : t;
            }
            resolveDTLFormat(t) {
                return X(t, !0) ? X(t, !0) && void 0 === t.main ? {
                    main: t
                } : t : {
                    main: (t = J(t))[0],
                    from: t[1],
                    to: t[2]
                };
            }
            getDateFormat(t, e, i, s) {
                let o = this.dateFormat("%m-%d %H:%M:%S.%L", e), r = "01-01 00:00:00.000", a = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                }, n = "millisecond", h = n;
                for(n in ta){
                    if (t && t === ta.week && +this.dateFormat("%w", e) === i && o.substr(6) === r.substr(6)) {
                        n = "week";
                        break;
                    }
                    if (t && ta[n] > t) {
                        n = h;
                        break;
                    }
                    if (a[n] && o.substr(a[n]) !== r.substr(a[n])) break;
                    "week" !== n && (h = n);
                }
                return this.resolveDTLFormat(s[n]).main;
            }
        }, tp = class extends tc {
            getBoundaryTicks(t, e, i, s) {
                let o = {};
                if (e === ta.year) return o;
                let r = v(i) && v(s), a = e < ta.hour, n = e < ta.day, h = e < ta.month, l = e >= ta.hour ? 9e5 : e >= ta.minute ? 6e4 : e >= ta.second && 1e3;
                if (t.length < 1e4) {
                    let d = !0;
                    for(let c = 0; c < t.length; c++){
                        let p = t[c];
                        if (r) {
                            if (p < i) continue;
                            if (p > s) break;
                        }
                        if (d) {
                            if (e === ta.month) {
                                o[p] = "year", d = !1;
                                continue;
                            }
                            if (e === ta.hour) {
                                o[p] = "day", d = !1;
                                continue;
                            }
                        }
                        if (l && p % l != 0) {
                            d = !1;
                            continue;
                        }
                        let [, g, u, f, m, x, y] = this.toParts(p), b = !f && !m && !x && !y;
                        a && 0 === m && (o[p] = "hour"), n && b && (o[p] = "day"), h && 1 === u && b && (o[p] = "month"), 0 === g && 1 === u && b && (o[p] = "year"), d = !1;
                    }
                }
                return o;
            }
            getTimeTicks(t, e, i, s) {
                let o = [], { count: r = 1, unitRange: a } = t, n = e, [h, l, d, c, p, g] = this.toParts(e), u = (e || 0) % 1e3, f;
                if (s ?? (s = 1), v(e)) {
                    if (u = a >= ta.second ? 0 : r * Math.floor(u / r), a >= ta.second && (g = a >= ta.minute ? 0 : r * Math.floor(g / r)), a >= ta.minute && (p = a >= ta.hour ? 0 : r * Math.floor(p / r)), a >= ta.hour && (c = a >= ta.day ? 0 : r * Math.floor(c / r)), a >= ta.day && (d = a >= ta.month ? 1 : Math.max(1, r * Math.floor(d / r))), a >= ta.month && (l = a >= ta.year ? 0 : r * Math.floor(l / r)), a >= ta.year && (h -= h % r), a === ta.week) {
                        r && (e = this.makeTime(h, l, d, c, p, g, u));
                        let t = this.dateTimeFormat({
                            timeZone: this.timezone,
                            weekday: "narrow"
                        }, e, "es"), i = "DLMXJVS".indexOf(t);
                        d += -i + s + (i < s ? -7 : 0);
                    }
                    e = this.makeTime(h, l, d, c, p, g, u), this.variableTimezone && v(i) && (f = i - e > 4 * ta.month || this.getTimezoneOffset(e) !== this.getTimezoneOffset(i));
                    let t = e, n = 1;
                    for(; t < i;)o.push(t), a === ta.year ? t = this.makeTime(h + n * r, 0) : a === ta.month ? t = this.makeTime(h, l + n * r) : f && (a === ta.day || a === ta.week) ? t = this.makeTime(h, l, d + n * r * (a === ta.day ? 1 : 7)) : f && a === ta.hour && r > 1 ? t = this.makeTime(h, l, d, c + n * r) : t += a * r, n++;
                    o.push(t);
                }
                return o.info = S(t, {
                    boundaryTicks: this.getBoundaryTicks(o, a, n, i),
                    totalRange: a * r
                }), o;
            }
        }, { isTouchDevice: tg } = n, tu = {
            palette: h,
            colors: Array(10).fill(1).map((t, e)=>`var(--highcharts-color-${e})`),
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                weekFrom: "week from",
                chartTitle: "Chart title",
                locale: void 0,
                loading: "Loading...",
                months: void 0,
                seriesName: "Series {add index 1}",
                shortMonths: void 0,
                weekdays: void 0,
                numericSymbols: [
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E"
                ],
                pieSliceName: "Slice",
                resetZoom: "Reset zoom",
                yAxisTitle: "Values",
                resetZoomTitle: "Reset zoom level 1:1"
            },
            global: {
                buttonTheme: {
                    fill: "var(--highcharts-neutral-color-3)",
                    padding: 8,
                    r: 2,
                    stroke: "var(--highcharts-neutral-color-20)",
                    "stroke-width": 1,
                    style: {
                        color: "var(--highcharts-neutral-color-80)",
                        cursor: "pointer",
                        fontSize: "0.8em",
                        fontWeight: "normal"
                    },
                    states: {
                        hover: {
                            fill: "var(--highcharts-neutral-color-10)"
                        },
                        select: {
                            fill: "var(--highcharts-highlight-color-10)",
                            style: {
                                color: "var(--highcharts-neutral-color-100)",
                                fontWeight: "bold"
                            }
                        },
                        disabled: {
                            style: {
                                color: "var(--highcharts-neutral-color-20)"
                            }
                        }
                    }
                }
            },
            time: {
                Date: void 0,
                timezone: "UTC",
                timezoneOffset: 0,
                useUTC: void 0
            },
            chart: {
                alignThresholds: !1,
                panning: {
                    enabled: !1,
                    type: "x"
                },
                styledMode: !1,
                borderRadius: 0,
                colorCount: 10,
                allowMutatingData: !0,
                ignoreHiddenSeries: !0,
                spacing: [
                    10,
                    10,
                    15,
                    10
                ],
                resetZoomButton: {
                    theme: {},
                    position: {}
                },
                reflow: !0,
                selectionMarkerFill: "color-mix(in srgb, var(--highcharts-highlight-color-80) 25%, transparent)",
                type: "line",
                zooming: {
                    singleTouch: !1,
                    resetButton: {
                        theme: {
                            zIndex: 6
                        },
                        position: {
                            align: "right",
                            x: -10,
                            y: 10
                        }
                    }
                },
                width: null,
                height: null,
                borderColor: "var(--highcharts-highlight-color-80)",
                backgroundColor: "var(--highcharts-background-color)",
                plotBorderColor: "var(--highcharts-neutral-color-20)"
            },
            title: {
                style: {
                    color: "var(--highcharts-neutral-color-80)",
                    fontWeight: "bold"
                },
                text: "Chart title",
                margin: 15,
                minScale: .67
            },
            subtitle: {
                style: {
                    color: "var(--highcharts-neutral-color-60)",
                    fontSize: "0.8em"
                },
                text: ""
            },
            caption: {
                margin: 15,
                style: {
                    color: "var(--highcharts-neutral-color-60)",
                    fontSize: "0.8em"
                },
                text: "",
                align: "left",
                verticalAlign: "bottom"
            },
            plotOptions: {},
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                events: {},
                layout: "horizontal",
                itemMarginBottom: 2,
                itemMarginTop: 2,
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "var(--highcharts-neutral-color-40)",
                borderRadius: 0,
                navigation: {
                    style: {
                        fontSize: "0.8em"
                    },
                    activeColor: "var(--highcharts-highlight-color-100)",
                    inactiveColor: "var(--highcharts-neutral-color-20)"
                },
                itemStyle: {
                    color: "var(--highcharts-neutral-color-80)",
                    cursor: "pointer",
                    fontSize: "0.8em",
                    textDecoration: "none",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "var(--highcharts-neutral-color-100)"
                },
                itemHiddenStyle: {
                    color: "var(--highcharts-neutral-color-60)",
                    textDecoration: "line-through"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        color: "var(--highcharts-neutral-color-80)",
                        fontSize: "0.8em",
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "var(--highcharts-background-color)",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: {
                    duration: 300,
                    easing: (t)=>Math.sqrt(1 - Math.pow(t - 1, 2))
                },
                borderColor: "light-dark(var(--highcharts-neutral-color-5), var(--highcharts-neutral-color-20))",
                borderRadius: 5,
                dateTimeLabelFormats: {
                    millisecond: "%[AebHMSL]",
                    second: "%[AebHMS]",
                    minute: "%[AebHM]",
                    hour: "%[AebHM]",
                    day: "%[AebY]",
                    week: "%v %[AebY]",
                    month: "%[BY]",
                    year: "%[Y]"
                },
                footerFormat: "",
                header: {
                    distance: 5,
                    shape: "callout",
                    style: {
                        fontSize: "1em"
                    }
                },
                hideDelay: 500,
                showDelay: 0,
                padding: 8,
                position: {
                    x: 0,
                    y: 3
                },
                shared: !1,
                snap: tg ? 25 : 10,
                headerFormat: '<span style="font-size: 0.8em">{ucfirst point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                backgroundColor: "var(--highcharts-background-color)",
                borderWidth: void 0,
                stickOnContact: !1,
                style: {
                    color: "var(--highcharts-neutral-color-80)",
                    cursor: "default",
                    fontSize: "0.8em"
                },
                useHTML: !1
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                    align: "right",
                    verticalAlign: "bottom",
                    x: -10,
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "var(--highcharts-neutral-color-40)",
                    fontSize: "0.6em"
                },
                text: "Highcharts.com"
            }
        }, tf = new tp(tu.time, tu.lang), tm = {
            defaultOptions: tu,
            defaultTime: tf,
            getOptions: function() {
                return tu;
            },
            setOptions: function(t) {
                return P(n, "setOptions", {
                    options: t
                }), F(!0, tu, t), t.time && tf.update(tu.time), t.lang && "locale" in t.lang && tf.update({
                    locale: t.lang.locale
                }), t.lang?.chartTitle && (tu.title = {
                    ...tu.title,
                    text: t.lang.chartTitle
                }), tu;
            }
        }, { win: tx } = n, ty = (t, e, i)=>0 === i ? t : 1 === i ? e : `color-mix(in srgb,${t},${e} ${100 * i}%)`, tb = (t)=>W(t) && !!t && "none" !== t;
        class tv {
            static parse(t) {
                return t ? new tv(t) : tv.None;
            }
            constructor(t){
                let e, i, s, o;
                this.rgba = [
                    0 / 0,
                    0 / 0,
                    0 / 0,
                    0 / 0
                ], this.input = t;
                let r = n.Color;
                if (r && r !== tv) return new r(t);
                if ("object" == typeof t && void 0 !== t.stops) this.stops = t.stops.map((t)=>new tv(t[1]));
                else if ("string" == typeof t) for(this.input = t = tv.names[t.toLowerCase()] || t, s = tv.parsers.length; s-- && !i;)(e = (o = tv.parsers[s]).regex.exec(t)) && (i = o.parse(e));
                i && (this.rgba = i);
            }
            get(t) {
                let e = this.input, i = this.rgba;
                if (this.output) return this.output;
                if ("object" == typeof e && void 0 !== this.stops) {
                    let i = F(e);
                    return i.stops = [].slice.call(i.stops), this.stops.forEach((e, s)=>{
                        i.stops[s] = [
                            i.stops[s][0],
                            e.get(t)
                        ];
                    }), i;
                }
                return i && N(i[0]) ? "rgb" !== t && (t || 1 !== i[3]) ? "a" === t ? `${i[3]}` : "rgba(" + i.join(",") + ")" : "rgb(" + i[0] + "," + i[1] + "," + i[2] + ")" : e;
            }
            brighten(t) {
                let e = this.rgba;
                if (this.stops) this.stops.forEach(function(e) {
                    e.brighten(t);
                });
                else if (N(t) && 0 !== t) {
                    if (N(e[0])) for(let i = 0; i < 3; i++)e[i] += U(255 * t), e[i] < 0 && (e[i] = 0), e[i] > 255 && (e[i] = 255);
                    else tv.useColorMix && tb(this.input) && (this.output = ty(this.input, t > 0 ? "white" : "black", Math.abs(t)));
                }
                return this;
            }
            setOpacity(t) {
                return N(this.rgba[0]) ? this.rgba[3] = t : tv.useColorMix && tb(this.input) && (this.output = ty(this.input, "#0000", 1 - t)), this;
            }
            tweenTo(t, e) {
                let i = this.rgba, s = t.rgba;
                if (!N(i[0]) || !N(s[0])) return tv.useColorMix && tb(this.input) && tb(t.input) && e < .99 ? ty(this.input, t.input, e) : t.input || "none";
                let o = 1 !== s[3] || 1 !== i[3], r = (t, s)=>t + (i[s] - t) * (1 - e), a = s.slice(0, 3).map(r).map(Math.round);
                return o && a.push(r(s[3], 3)), (o ? "rgba(" : "rgb(") + a.join(",") + ")";
            }
        }
        tv.names = {
            white: "#ffffff",
            black: "#000000"
        }, tv.parsers = [
            {
                regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/,
                parse: function(t) {
                    return [
                        U(t[1]),
                        U(t[2]),
                        U(t[3]),
                        parseFloat(t[4], 10)
                    ];
                }
            },
            {
                regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/,
                parse: function(t) {
                    return [
                        U(t[1]),
                        U(t[2]),
                        U(t[3]),
                        1
                    ];
                }
            },
            {
                regex: /^#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?$/i,
                parse: function(t) {
                    return [
                        U(t[1] + t[1], 16),
                        U(t[2] + t[2], 16),
                        U(t[3] + t[3], 16),
                        v(t[4]) ? U(t[4] + t[4], 16) / 255 : 1
                    ];
                }
            },
            {
                regex: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?$/i,
                parse: function(t) {
                    return [
                        U(t[1], 16),
                        U(t[2], 16),
                        U(t[3], 16),
                        v(t[4]) ? U(t[4], 16) / 255 : 1
                    ];
                }
            }
        ], tv.useColorMix = tx.CSS?.supports("color", "color-mix(in srgb,red,blue 9%)"), tv.None = new tv("");
        let { parse: tk } = tv, { win: tw } = n;
        class tM {
            constructor(t, e, i){
                this.pos = 0 / 0, this.options = e, this.elem = t, this.prop = i;
            }
            dSetter() {
                let t = this.paths, e = t?.[0], i = t?.[1], s = this.now || 0, o = [];
                if (1 !== s && e && i) {
                    if (e.length === i.length && s < 1) for(let t = 0; t < i.length; t++){
                        let r = e[t], a = i[t], n = [];
                        for(let t = 0; t < a.length; t++){
                            let e = r[t], i = a[t];
                            N(e) && N(i) && ("A" !== a[0] || 4 !== t && 5 !== t) ? n[t] = e + s * (i - e) : n[t] = i;
                        }
                        o.push(n);
                    }
                    else o = i;
                } else o = this.toD || [];
                this.elem.attr("d", o, void 0, !0);
            }
            update() {
                let t = this.elem, e = this.prop, i = this.now ?? 1, s = this.options.step;
                this[e + "Setter"] ? this[e + "Setter"]() : t && t.attr ? t.element && t.attr(e, i, void 0, !0) : t && (t.style[e] = i + (this.unit || "")), s?.call(t, i, this);
            }
            run(t, e, i) {
                let { elem: s, options: o } = this, { complete: r, curAnim: a = {} } = o, n = (t)=>!n.stopped && this.step(t), h = tw.requestAnimationFrame || function(t) {
                    setTimeout(t, 13);
                }, l = ()=>{
                    for(let t = 0; t < tM.timers.length; t++)tM.timers[t]() || tM.timers.splice(t--, 1);
                    tM.timers.length && h(l);
                };
                t !== e || s["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = t, this.end = e, this.unit = i, this.now = this.start, this.pos = 0, n.elem = s, n.prop = this.prop, n() && 1 === tM.timers.push(n) && h(l)) : (delete a[this.prop], r && 0 === Object.keys(a).length && r.call(s));
            }
            step(t) {
                let e, i, s = +new Date, o = this.options, r = this.elem, a = o.complete, n = o.duration, h = o.curAnim;
                return r?.attr && !r.element ? e = !1 : t || s >= n + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), h[this.prop] = !0, i = !0, j(h, function(t) {
                    !0 !== t && (i = !1);
                }), i && a && a.call(r), e = !1) : (this.pos = o.easing((s - this.startTime) / n), this.now = this.start + (this.end - this.start) * this.pos, this.update(), e = !0), e;
            }
            initPath(t, e, i) {
                let s = t.startX, o = t.endX, r = i.slice(), a = t.isArea, n = a ? 2 : 1, h = e && i.length > e.length && i.hasStackedCliffs, l, d, c, p, g = e?.slice();
                if (!g || h) return [
                    r,
                    r
                ];
                function u(t, e) {
                    for(; t.length < d;){
                        let i = t[0], s = e[d - t.length];
                        if (s && "M" === i[0] && ("C" === s[0] ? t[0] = [
                            "C",
                            i[1],
                            i[2],
                            i[1],
                            i[2],
                            i[1],
                            i[2]
                        ] : t[0] = [
                            "L",
                            i[1],
                            i[2]
                        ]), t.unshift(i), a) {
                            let e = t.pop();
                            t.push(t[t.length - 1], e);
                        }
                    }
                }
                function f(t) {
                    for(; t.length < d;){
                        let e = t[Math.floor(t.length / n) - 1].slice();
                        if ("C" === e[0] && (e[1] = e[5], e[2] = e[6]), a) {
                            let i = t[Math.floor(t.length / n)].slice();
                            t.splice(t.length / 2, 0, e, i);
                        } else t.push(e);
                    }
                }
                if (s && o && o.length) {
                    for(c = 0; c < s.length; c++)if (s[c] === o[0]) {
                        l = c;
                        break;
                    } else if (s[0] === o[o.length - s.length + c]) {
                        l = c, p = !0;
                        break;
                    } else if (s[s.length - 1] === o[o.length - s.length + c]) {
                        l = s.length - c;
                        break;
                    }
                    void 0 === l && (g = []);
                }
                return g.length && N(l) && (d = r.length + l * n, p ? (u(g, r), f(r)) : (u(r, g), f(g))), [
                    g,
                    r
                ];
            }
            fillSetter() {
                tM.prototype.strokeSetter.apply(this, arguments);
            }
            strokeSetter() {
                this.elem.attr(this.prop, tk(this.start).tweenTo(tk(this.end), this.pos), void 0, !0);
            }
        }
        function tC(t, e) {
            e.renderer.globalAnimation = t ?? e.options.chart.animation ?? !0;
        }
        function tS(t) {
            return X(t) ? F({
                duration: 500,
                defer: 0
            }, t) : {
                duration: 500 * !!t,
                defer: 0
            };
        }
        function tT(t, e, i) {
            let s = tS(e), o = i ? [
                i
            ] : t.series, r = 0, a = 0;
            return o.forEach((t)=>{
                let i = tS(t.options.animation);
                r = X(e) && v(e.defer) ? s.defer : Math.max(r, i.duration + i.defer), a = Math.min(s.duration, i.duration);
            }), t.renderer.forExport && (r = 0), {
                defer: Math.max(0, r - a),
                duration: Math.min(r, a)
            };
        }
        function tP(t, e = {
            pos: 1
        }, i) {
            X(i) || (i = {
                duration: arguments[2],
                easing: arguments[3],
                complete: arguments[4]
            }), N(i.duration) || (i.duration = 400), i.easing = "function" == typeof i.easing ? i.easing : Math[i.easing] || Math.easeInOutSine, i.curAnim = F(e), j(e, (s, o)=>{
                t && tA(t, o);
                let r = new tM(t, i, o), a = e.d, n = "dashstyle" === o, h = 0, l, d = "";
                "d" === o && H(a) ? (r.paths = r.initPath(t, t.pathArray, a), r.toD = a, l = 1) : t?.attr ? (h = t.attr(o), n && t.attr(o, s)) : t && (h = +(I(t, o) || 0), "opacity" !== o && (d = "px")), l || (l = s), "string" == typeof l && l.match("px") && (l = l.replace(/px/g, "")), v(l) && !n && r.run(h, l, d);
            });
        }
        tM.timers = [];
        let tA = (t, e)=>tM.timers.forEach((i)=>{
                i.elem !== t || e && e !== i.prop || (i.stopped = !0);
            }), { SVG_NS: tL, win: tO } = n, { trustedTypes: tE } = tO, tI = tE && G(tE.createPolicy) && tE.createPolicy("highcharts", {
            createHTML: (t)=>t
        }), tD = tI ? tI.createHTML("") : "";
        class tB {
            static filterUserAttributes(t) {
                return j(t, (e, i)=>{
                    let s = !0;
                    -1 === tB.allowedAttributes.indexOf(i) && (s = !1), -1 !== [
                        "background",
                        "dynsrc",
                        "href",
                        "lowsrc",
                        "src",
                        "xlink:href"
                    ].indexOf(i) && (s = W(e) && tB.allowedReferences.some((t)=>0 === e.indexOf(t))), s || (to(33, !1, void 0, {
                        "Invalid attribute in config": `${i}`
                    }), delete t[i]), W(e) && t[i] && (t[i] = e.replace(/</g, "&lt;"));
                }), t;
            }
            static parseStyle(t) {
                return t.split(";").reduce((t, e)=>{
                    let i = e.split(":").map((t)=>t.trim()), s = i.shift();
                    return s && i.length && (t[s.replace(/-([a-z])/g, (t)=>t[1].toUpperCase())] = i.join(":")), t;
                }, {});
            }
            static setElementHTML(t, e) {
                t.innerHTML = tB.emptyHTML, e && new tB(e).addToDOM(t);
            }
            constructor(t){
                this.nodes = "string" == typeof t ? this.parseMarkup(t) : t;
            }
            addToDOM(t) {
                return function t(e, i) {
                    let s;
                    return J(e).forEach(function(e) {
                        let o, r = e.tagName, a = e.textContent ? n.doc.createTextNode(e.textContent) : void 0, h = tB.bypassHTMLFiltering;
                        if (r) {
                            if ("#text" === r) o = a;
                            else if (-1 !== tB.allowedTags.indexOf(r) || h) {
                                let s = "svg" === r ? tL : i.namespaceURI || tL, l = n.doc.createElementNS(s, r), d = e.attributes || {};
                                j(e, function(t, e) {
                                    "tagName" !== e && "attributes" !== e && "children" !== e && "style" !== e && "textContent" !== e && (d[e] = t);
                                }), u(l, h ? d : tB.filterUserAttributes(d)), e.style && b(l, e.style), a && l.appendChild(a), t(e.children || [], l), o = l;
                            } else to(33, !1, void 0, {
                                "Invalid tagName in config": r
                            });
                        }
                        o && i.appendChild(o), s = o;
                    }), s;
                }(this.nodes, t);
            }
            parseMarkup(t) {
                let e, i = [];
                t = t.trim().replace(/ style=(["'])/g, " data-style=$1");
                try {
                    e = new DOMParser().parseFromString(tI ? tI.createHTML(t) : t, "text/html");
                } catch  {
                    try {
                        e = new DOMParser().parseFromString(t, "text/html");
                    } catch  {}
                }
                e || ((e = n.doc.implementation.createHTMLDocument("")).body.innerHTML = t);
                let s = (t, e)=>{
                    let i = t.localName || t.nodeName.toLowerCase(), o = {
                        tagName: i
                    };
                    "#text" === i && (o.textContent = t.textContent || "");
                    let r = t.attributes;
                    if (r) {
                        let t = {};
                        [].forEach.call(r, (e)=>{
                            "data-style" === e.name ? o.style = tB.parseStyle(e.value) : t[e.name] = e.value;
                        }), o.attributes = t;
                    }
                    if (t.childNodes.length) {
                        let e = [];
                        [].forEach.call(t.childNodes, (t)=>{
                            s(t, e);
                        }), e.length && (o.children = e);
                    }
                    e.push(o);
                };
                return [].forEach.call(e.body.childNodes, (t)=>s(t, i)), i;
            }
        }
        tB.allowedAttributes = [
            "alt",
            "aria-controls",
            "aria-describedby",
            "aria-expanded",
            "aria-haspopup",
            "aria-hidden",
            "aria-label",
            "aria-labelledby",
            "aria-live",
            "aria-pressed",
            "aria-readonly",
            "aria-roledescription",
            "aria-selected",
            "aria-sort",
            "class",
            "clip-path",
            "color",
            "colspan",
            "cx",
            "cy",
            "d",
            "disabled",
            "dx",
            "dy",
            "fill",
            "filterUnits",
            "flood-color",
            "flood-opacity",
            "height",
            "href",
            "id",
            "in",
            "in2",
            "markerHeight",
            "markerWidth",
            "offset",
            "opacity",
            "operator",
            "orient",
            "padding",
            "paddingLeft",
            "paddingRight",
            "patternUnits",
            "r",
            "radius",
            "refX",
            "refY",
            "result",
            "role",
            "rowspan",
            "scope",
            "slope",
            "src",
            "startOffset",
            "stdDeviation",
            "stop-color",
            "stop-opacity",
            "stroke-linecap",
            "stroke-width",
            "stroke",
            "style",
            "summary",
            "tabindex",
            "tableValues",
            "target",
            "text-align",
            "text-anchor",
            "textAnchor",
            "textLength",
            "title",
            "type",
            "valign",
            "width",
            "x",
            "x1",
            "x2",
            "xlink:href",
            "y",
            "y1",
            "y2",
            "zIndex"
        ], tB.allowedReferences = [
            "https://",
            "http://",
            "mailto:",
            "/",
            "../",
            "./",
            "#"
        ], tB.allowedTags = [
            "#text",
            "a",
            "abbr",
            "b",
            "br",
            "button",
            "caption",
            "circle",
            "clipPath",
            "code",
            "dd",
            "defs",
            "div",
            "dl",
            "dt",
            "em",
            "feComponentTransfer",
            "feComposite",
            "feDropShadow",
            "feFlood",
            "feFuncA",
            "feFuncB",
            "feFuncG",
            "feFuncR",
            "feGaussianBlur",
            "feMerge",
            "feMergeNode",
            "feMorphology",
            "feOffset",
            "filter",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "i",
            "img",
            "li",
            "linearGradient",
            "marker",
            "ol",
            "p",
            "path",
            "pattern",
            "pre",
            "rect",
            "small",
            "span",
            "stop",
            "strong",
            "sub",
            "sup",
            "svg",
            "table",
            "tbody",
            "td",
            "text",
            "textPath",
            "th",
            "thead",
            "title",
            "tr",
            "tspan",
            "u",
            "ul"
        ], tB.emptyHTML = tD, tB.bypassHTMLFiltering = !1;
        let { defaultOptions: tz, defaultTime: tR } = tm, { pageLang: tN } = n, tW = {
            add: (t, e)=>t + e,
            divide: (t, e)=>0 !== e ? m(t / e) : "",
            eq: (t, e)=>t == e,
            each: function(t) {
                let e = arguments[arguments.length - 1];
                return !!H(t) && t.map((i, s)=>tG(e.body, S(X(i) ? i : {
                        "@this": i
                    }, {
                        "@index": s,
                        "@first": 0 === s,
                        "@last": s === t.length - 1
                    }))).join("");
            },
            ge: (t, e)=>t >= e,
            gt: (t, e)=>t > e,
            if: (t)=>!!t,
            le: (t, e)=>t <= e,
            lt: (t, e)=>t < e,
            multiply: (t, e)=>m(t * e, 15),
            ne: (t, e)=>t != e,
            subtract: (t, e)=>t - e,
            ucfirst: te,
            unless: (t)=>!t
        }, tH = {};
        function tG(t = "", e, i) {
            let s = /\{([^{}]+)\}/g, o = /\(([^()]+)\)/g, r = [], a = /f$/, n = /\.(\d)/, h = i?.options?.lang || tz.lang, l = i?.time || tR, d = i?.numberFormatter || tX.bind(i), c = (t = "")=>{
                let i;
                return "true" === t || "false" !== t && ((i = Number(t)).toString() === t ? i : /^["'].+["']$/.test(t) ? t.slice(1, -1) : E(t, e));
            }, p, g, u = 0, f;
            for(; null !== (p = s.exec(t));){
                let i = p, s = o.exec(p[1]);
                s && (p = s, f = !0), g?.isBlock || (g = {
                    ctx: e,
                    expression: p[1],
                    find: p[0],
                    isBlock: "#" === p[1].charAt(0),
                    start: p.index,
                    startInner: p.index + p[0].length,
                    length: p[0].length
                });
                let a = (g.isBlock ? i : p)[1].split(" ")[0].replace("#", "");
                tW[a] && (g.isBlock && a === g.fn && u++, g.fn || (g.fn = a));
                let n = "else" === p[1];
                if (g.isBlock && g.fn && (p[1] === `/${g.fn}` || n)) {
                    if (u) !n && u--;
                    else {
                        let e = g.startInner, i = t.substr(e, p.index - e);
                        void 0 === g.body ? (g.body = i, g.startInner = p.index + p[0].length) : g.elseBody = i, g.find += i + p[0], n || (r.push(g), g = void 0);
                    }
                } else g.isBlock || r.push(g);
                if (s && !g?.isBlock) break;
            }
            return r.forEach((s)=>{
                let r, p, { body: g, elseBody: u, expression: f, fn: m } = s;
                if (m) {
                    let t = [
                        s
                    ], o = [], a = f.length, n = 0, h;
                    for(p = 0; p <= a; p++){
                        let t = f.charAt(p);
                        h || '"' !== t && "'" !== t ? h === t && (h = "") : h = t, h || " " !== t && p !== a || (o.push(f.substr(n, p - n)), n = p + 1);
                    }
                    for(p = tW[m].length; p--;)t.unshift(c(o[p + 1]));
                    r = tW[m].apply(e, t), s.isBlock && "boolean" == typeof r && (r = tG(r ? g : u, e, i));
                } else {
                    let t = /^["'].+["']$/.test(f) ? [
                        f
                    ] : f.split(":");
                    if (r = c(t.shift() || ""), t.length && "number" == typeof r) {
                        let e = t.join(":");
                        if (a.test(e)) {
                            let t = parseInt((e.match(n) || [
                                "",
                                "-1"
                            ])[1], 10);
                            null !== r && (r = d(r, t, h.decimalPoint, e.indexOf(",") > -1 ? h.thousandsSep : ""));
                        } else r = l.dateFormat(e, r);
                    }
                    o.lastIndex = 0, o.test(s.find) && W(r) && (r = `"${r}"`);
                }
                t = t.replace(s.find, r ?? "");
            }), f ? tG(t, e, i) : t;
        }
        function tX(t, e, i, s) {
            e *= 1;
            let o, r, [a, n] = (t = +t || 0).toString().split("e").map(Number), h = this?.options?.lang || tz.lang, l = (t.toString().split(".")[1] || "").split("e")[0].length, d = e, c = {};
            i ?? (i = h.decimalPoint), s ?? (s = h.thousandsSep), -1 === e ? e = Math.min(l, 20) : N(e) ? e && n < 0 && ((r = e + n) >= 0 ? (a = +a.toExponential(r).split("e")[0], e = r) : (a = Math.floor(a), t = e < 20 ? +(a * Math.pow(10, n)).toFixed(e) : 0, n = 0)) : e = 2, n && (e ?? (e = 2), t = a), N(e) && e >= 0 && (c.minimumFractionDigits = e, c.maximumFractionDigits = e), "" === s && (c.useGrouping = !1);
            let p = s || i, g = p ? "en" : this?.locale || h.locale || tN, u = JSON.stringify(c) + g;
            return o = (tH[u] ?? (tH[u] = new Intl.NumberFormat(g, c))).format(t), p && (o = o.replace(/([,\.])/g, "_$1").replace(/_\,/g, s ?? ",").replace("_.", i ?? ".")), (e || 0 != +o) && (!(n < 0) || d) || (o = "0"), n && 0 != +o && (o += "e" + (n < 0 ? "" : "+") + n), o;
        }
        let tF = {
            dateFormat: function(t, e, i) {
                return tR.dateFormat(t, e, i);
            },
            format: tG,
            helpers: tW,
            numberFormat: tX
        };
        (e9 || (e9 = {})).distribute = function t(e, i, s) {
            let o = e, r = o.reducedLen || i, a = (t, e)=>t.target - e.target, n = [], h = e.length, l = [], d = n.push, c, p = !0, g, u, m = 0;
            for(c = h; c--;)m += e[c].size;
            if (m > r) {
                if (Q(e, (t, e)=>(e.rank || 0) - (t.rank || 0)), e[0].rank === e[e.length - 1].rank) {
                    let t = [
                        [
                            0,
                            h - 1
                        ]
                    ];
                    for(; t.length && m > r;){
                        let i = t.shift();
                        if (!i) break;
                        g = e[c = Math.floor((i[0] + i[1]) / 2)], _(l, c) && (m -= g.size), i[0] < c && t.push([
                            i[0],
                            c - 1
                        ]), c < i[1] && t.push([
                            c + 1,
                            i[1]
                        ]);
                    }
                } else for(c = h - 1; m > r && c >= 0;)g = e[c], _(l, c) && (m -= g.size), c--;
                l.sort((t, e)=>e - t).forEach((t)=>d.apply(n, e.splice(t, 1)));
            }
            for(Q(e, a), e = e.map((t)=>({
                    size: t.size,
                    targets: [
                        t.target
                    ],
                    align: t.align ?? .5
                })); p;){
                for(c = e.length; c--;)g = e[c], u = (Math.min.apply(0, g.targets) + Math.max.apply(0, g.targets)) / 2, g.pos = f(u - g.size * g.align, 0, i - g.size);
                for(c = e.length, p = !1; c--;)c > 0 && e[c - 1].pos + e[c - 1].size > e[c].pos && (e[c - 1].size += e[c].size, e[c - 1].targets = e[c - 1].targets.concat(e[c].targets), e[c - 1].align = .5, e[c - 1].pos + e[c - 1].size > i && (e[c - 1].pos = i - e[c - 1].size), e.splice(c, 1), p = !0);
            }
            return d.apply(o, n), c = 0, e.some((e)=>{
                let r = 0;
                return (e.targets || []).some(()=>(o[c].pos = e.pos + r, void 0 !== s && Math.abs(o[c].pos - o[c].target) > s) ? (o.slice(0, c + 1).forEach((t)=>delete t.pos), o.reducedLen = (o.reducedLen || i) - .1 * i, o.reducedLen > .1 * i && t(o, i, s), !0) : (r += o[c].size, c++, !1));
            }), Q(o, a), o;
        };
        let tY = e9, { deg2rad: tj, doc: t$, svg: tV, SVG_NS: tU, win: t_, isFirefox: tZ } = n;
        class tK {
            _defaultGetter(t) {
                let e = this[t + "Value"] ?? this[t] ?? (this.element ? this.element.getAttribute(t) : null) ?? this.box?.[t] ?? 0;
                return /^-?[\d\.]+$/.test(e) && (e = parseFloat(e)), e;
            }
            _defaultSetter(t, e, i) {
                i.setAttribute(e, t);
            }
            add(t) {
                let e, i = this.renderer, s = this.element;
                return t && (this.parentGroup = t), void 0 !== this.textStr && "text" === this.element.nodeName && i.buildText(this), this.added = !0, (!t || t.handleZ || this.zIndex) && (e = this.zIndexSetter()), e || (t ? t.element : i.box).appendChild(s), this.onAdd && this.onAdd(), this;
            }
            addClass(t, e) {
                let i = e ? "" : this.attr("class") || "";
                return (t = (t || "").split(/ /g).reduce(function(t, e) {
                    return -1 === i.indexOf(e) && t.push(e), t;
                }, i ? [
                    i
                ] : []).join(" ")) !== i && this.attr("class", t), this;
            }
            afterSetters() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            }
            align(t, e, i, s = !0) {
                let o = this.renderer, r = o.alignedObjects, a = !!t;
                t ? (this.alignOptions = t, this.alignByTranslate = e, this.alignTo = i) : (t = this.alignOptions || {}, e = this.alignByTranslate, i = this.alignTo);
                let n = !i || W(i) ? i || "renderer" : void 0;
                n && (a && _(r, this), i = void 0);
                let h = i ?? o[n] ?? o, l = (h.x || 0) + (t.x || 0) + ((h.width || 0) - (t.width || 0)) * A(t.align), d = (h.y || 0) + (t.y || 0) + ((h.height || 0) - (t.height || 0)) * A(t.verticalAlign), c = {};
                return t.align && (c["text-align"] = t.align), c[e ? "translateX" : "x"] = Math.round(l), c[e ? "translateY" : "y"] = Math.round(d), s && (this[this.placed ? "animate" : "attr"](c), this.placed = !0), this.alignAttr = c, this;
            }
            alignSetter(t) {
                let e = {
                    left: "start",
                    center: "middle",
                    right: "end"
                };
                e[t] && (this.alignValue = t, this.element.setAttribute("text-anchor", e[t]));
            }
            animate(t, e, i) {
                let s = tS(e ?? this.renderer.globalAnimation ?? !0), o = s.defer;
                return t$.hidden && (s.duration = 0), 0 !== s.duration ? (i && (s.complete = i), tt(()=>{
                    this.element && tP(this, t, s);
                }, o)) : (this.attr(t, void 0, i || s.complete), j(t, function(t, e) {
                    s.step && s.step.call(this, t, {
                        prop: e,
                        pos: 1,
                        elem: this
                    });
                }, this)), this;
            }
            applyTextOutline(t) {
                let e = this.element;
                -1 !== t.indexOf("contrast") && (t = t.replace(/contrast/g, this.renderer.getContrast(e.style.fill)));
                let i = t.indexOf(" "), s = t.substring(i + 1), o = t.substring(0, i);
                if (o && "none" !== o && n.svg) {
                    this.fakeTS = !0, o = o.replace(/(^[\d\.]+)(.*?)$/g, function(t, e, i) {
                        return 2 * Number(e) + i;
                    }), this.removeTextOutline();
                    let t = t$.createElementNS(tU, "tspan");
                    u(t, {
                        class: "highcharts-text-outline",
                        fill: s,
                        stroke: s,
                        "stroke-width": o,
                        "stroke-linejoin": "round"
                    });
                    let i = e.querySelector("textPath") || e;
                    [].forEach.call(i.childNodes, (e)=>{
                        let i = e.cloneNode(!0);
                        i.removeAttribute && [
                            "fill",
                            "stroke",
                            "stroke-width",
                            "stroke"
                        ].forEach((t)=>i.removeAttribute(t)), t.appendChild(i);
                    });
                    let r = 0;
                    [].forEach.call(i.querySelectorAll("text tspan"), (t)=>{
                        r += Number(t.getAttribute("dy"));
                    });
                    let a = t$.createElementNS(tU, "tspan");
                    a.textContent = "\u200B", u(a, {
                        x: Number(e.getAttribute("x")),
                        dy: -r
                    }), t.appendChild(a), i.insertBefore(t, i.firstChild);
                }
            }
            attr(t, e, i, s) {
                let { element: o } = this, r = tK.symbolCustomAttribs, a, n, h = this, l;
                return "string" == typeof t && void 0 !== e && (a = t, (t = {})[a] = e), "string" == typeof t ? h = (this[t + "Getter"] || this._defaultGetter).call(this, t, o) : (j(t, function(e, i) {
                    l = !1, s || tA(this, i), this.symbolName && -1 !== r.indexOf(i) && (n || (this.symbolAttr(t), n = !0), l = !0), this.rotation && ("x" === i || "y" === i) && (this.doTransform = !0), l || (this[i + "Setter"] || this._defaultSetter).call(this, e, i, o);
                }, this), this.afterSetters()), i && i.call(this), h;
            }
            clip(t) {
                if (t && !t.clipPath) {
                    let e = tn() + "-", i = this.renderer.createElement("clipPath").attr({
                        id: e
                    }).add(this.renderer.defs);
                    S(t, {
                        clipPath: i,
                        id: e,
                        count: 0
                    }), t.add(i);
                }
                return this.attr("clip-path", t ? `url(${this.renderer.url}#${t.id})` : "none");
            }
            crisp(t, e) {
                e = Math.round(e || t.strokeWidth || 0);
                let i = t.x || this.x || 0, s = t.y || this.y || 0, o = (t.width || this.width || 0) + i, r = (t.height || this.height || 0) + s, a = y(i, e), n = y(s, e);
                return S(t, {
                    x: a,
                    y: n,
                    width: y(o, e) - a,
                    height: y(r, e) - n
                }), v(t.strokeWidth) && (t.strokeWidth = e), t;
            }
            complexColor(t, e, i) {
                let s = this.renderer, o, r, a, n, h, l, d, c, p, g = [], u;
                P(this.renderer, "complexColor", {
                    args: arguments
                }, ()=>{
                    if (t.radialGradient ? r = "radialGradient" : t.linearGradient && (r = "linearGradient"), r) {
                        if (a = t[r], h = s.gradients, l = t.stops, c = i.radialReference, H(a) && (t[r] = a = {
                            x1: a[0],
                            y1: a[1],
                            x2: a[2],
                            y2: a[3],
                            gradientUnits: "userSpaceOnUse"
                        }), "radialGradient" === r && c && !v(a.gradientUnits) && (n = a, a = F(a, s.getRadialAttr(c, n), {
                            gradientUnits: "userSpaceOnUse"
                        })), j(a, function(t, e) {
                            "id" !== e && g.push(e, t);
                        }), j(l, function(t) {
                            g.push(t);
                        }), h[g = g.join(",")]) p = h[g].attr("id");
                        else {
                            a.id = p = tn();
                            let t = h[g] = s.createElement(r).attr(a).add(s.defs);
                            t.radAttr = n, t.stops = [], l.forEach(([e, i])=>{
                                0 === i.indexOf("rgba") ? (i = (o = tv.parse(i)).get("rgb"), d = o.get("a")) : d = 1;
                                let r = s.createElement("stop").attr({
                                    offset: e,
                                    "stop-color": i,
                                    "stop-opacity": d
                                }).add(t);
                                t.stops.push(r);
                            });
                        }
                        u = "url(" + s.url + "#" + p + ")", i.setAttribute(e, u), i.gradient = g, t.toString = function() {
                            return u;
                        };
                    }
                });
            }
            css(t) {
                let e = this.styles, i = {}, s = this.element, o = this.renderer, r, a = !e;
                if (e && j(t, function(t, s) {
                    e && e[s] !== t && (i[s] = t, a = !0);
                }), a) {
                    e && (t = S(e, i)), null === t.width || "auto" === t.width ? delete this.textWidth : "text" === s.nodeName.toLowerCase() && t.width && (r = this.textWidth = U(t.width)), S(this.styles, t), r && !tV && o.forExport && delete t.width;
                    let a = tZ && t.fontSize || null;
                    a && (N(a) || /^\d+$/.test(a)) && (t.fontSize += "px");
                    let n = F(t);
                    s.namespaceURI === this.SVG_NS && ([
                        "textOutline",
                        "textOverflow",
                        "whiteSpace",
                        "width"
                    ].forEach((t)=>n && delete n[t]), n.color && (n.fill = n.color, delete n.color)), b(s, n);
                }
                return this.added && ("text" === this.element.nodeName && o.buildText(this), t.textOutline && this.applyTextOutline(t.textOutline)), this;
            }
            dashstyleSetter(t) {
                let e, i = this["stroke-width"];
                if ("inherit" === i && (i = 1), t) {
                    let s = (t = t.toLowerCase()).replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(e = s.length; e--;)s[e] = "" + U(s[e]) * (i ?? 0 / 0);
                    t = s.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", t);
                }
            }
            destroy() {
                let t = this, { element: e = {}, renderer: i, stops: s } = t, o = e.ownerSVGElement;
                if (e.onclick = e.onmouseout = e.onmouseover = e.onmousemove = e.point = null, tA(t), t.clipPath && o) {
                    let e = t.clipPath;
                    [].forEach.call(o.querySelectorAll("[clip-path],[CLIP-PATH]"), function(t) {
                        t.getAttribute("clip-path").indexOf(e.element.id) > -1 && t.removeAttribute("clip-path");
                    }), t.clipPath = e.destroy();
                }
                if (s) {
                    for (let t of s)t.destroy();
                    s.length = 0;
                }
                t.safeRemoveChild(e), t.alignOptions && C(i.alignedObjects, t), j(t, (e, i)=>{
                    (t[i]?.parentGroup === t || -1 !== [
                        "connector",
                        "foreignObject"
                    ].indexOf(i)) && t[i]?.destroy?.(), delete t[i];
                });
            }
            dSetter(t, e, i) {
                H(t) && ("string" == typeof t[0] && (t = this.renderer.pathToSegments(t)), this.pathArray = t, t = t.reduce((t, e, i)=>e?.join ? (i ? t + " " : "") + e.join(" ") : (e || "").toString(), "")), /(NaN| {2}|^$)/.test(t) && (t = "M 0 0"), this[e] !== t && (i.setAttribute(e, t), this[e] = t);
            }
            fillSetter(t, e, i) {
                "string" == typeof t ? i.setAttribute(e, t) : t && this.complexColor(t, e, i);
            }
            hrefSetter(t, e, i) {
                i.setAttributeNS("http://www.w3.org/1999/xlink", e, t);
            }
            getBBox(t, e) {
                let i, s, o, { element: r, renderer: a, styles: n, textStr: h } = this, { cache: l, cacheKeys: d } = a, c = r.namespaceURI === this.SVG_NS, p = e ?? this.rotation ?? 0, g = a.styledMode ? r && tK.prototype.getStyle.call(r, "font-size") : n.fontSize, u = this.getBBoxCacheKey([
                    a.rootFontSize,
                    this.textWidth,
                    this.alignValue,
                    n.fontWeight,
                    n.lineClamp,
                    n.textOverflow,
                    g,
                    p
                ]);
                if (u && !t && (i = l[u]), !i || i.polygon) {
                    if (c || a.forExport) {
                        try {
                            o = this.fakeTS && function(t) {
                                let e = r.querySelector(".highcharts-text-outline");
                                e && b(e, {
                                    display: t
                                });
                            }, G(o) && o("none"), i = r.getBBox ? S({}, r.getBBox()) : {
                                width: r.offsetWidth,
                                height: r.offsetHeight,
                                x: 0,
                                y: 0
                            }, G(o) && o("");
                        } catch  {}
                        (!i || i.width < 0) && (i = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        });
                    } else i = this.htmlGetBBox();
                    s = i.height, c && (i.height = s = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[`${g || ""},${Math.round(s)}`] || s), p && (i = this.getRotatedBox(i, p));
                    let t = {
                        bBox: i
                    };
                    P(this, "afterGetBBox", t), i = t.bBox;
                }
                if (u && ("" === h || i.height > 0)) {
                    for(; d.length > 250;)delete l[d.shift()];
                    l[u] || d.push(u), l[u] = i;
                }
                return i;
            }
            getBBoxCacheKey(t) {
                if (v(this.textStr)) {
                    let e = "" + this.textStr;
                    return -1 === e.indexOf("<") && (e = e.replace(/\d/g, "0")), [
                        e,
                        ...t
                    ].join(",");
                }
            }
            getRotatedBox(t, e) {
                let { x: i, y: s, width: o, height: r } = t, { alignValue: a, translateY: n, rotationOriginX: h = 0, rotationOriginY: l = 0 } = this, d = A(a), c = Number(this.element.getAttribute("y") || 0) - (n ? 0 : s), p = e * tj, g = (e - 90) * tj, u = Math.cos(p), f = Math.sin(p), m = o * u, x = o * f, y = Math.cos(g), b = Math.sin(g), [[v, k], [w, M]] = [
                    h,
                    l
                ].map((t)=>[
                        t - t * u,
                        t * f
                    ]), C = i + d * (o - m) + v + M + c * y, S = C + m, T = S - r * y, P = T - m, L = s + c - d * x - k + w + c * b, O = L + x, E = O - r * b, I = E - x, D = Math.min(C, S, T, P), B = Math.min(L, O, E, I), z = Math.max(C, S, T, P) - D, R = Math.max(L, O, E, I) - B;
                return {
                    x: D,
                    y: B,
                    width: z,
                    height: R,
                    polygon: [
                        [
                            C,
                            L
                        ],
                        [
                            S,
                            O
                        ],
                        [
                            T,
                            E
                        ],
                        [
                            P,
                            I
                        ]
                    ]
                };
            }
            getStyle(t) {
                return t_.getComputedStyle(this.element || this, "").getPropertyValue(t);
            }
            hasClass(t) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(t);
            }
            hide() {
                return this.attr({
                    visibility: "hidden"
                });
            }
            htmlGetBBox() {
                return {
                    height: 0,
                    width: 0,
                    x: 0,
                    y: 0
                };
            }
            constructor(t, e){
                this.onEvents = {}, this.opacity = 1, this.SVG_NS = tU, this.element = "div" === e || "body" === e ? x(e) : t$.createElementNS(this.SVG_NS, e), this.renderer = t, this.styles = {}, P(this, "afterInit");
            }
            on(t, e) {
                let { onEvents: i } = this;
                return i[t] && i[t](), i[t] = c(this.element, t, e), this;
            }
            opacitySetter(t, e, i) {
                let s = Number(Number(t).toFixed(3));
                this.opacity = s, i.setAttribute(e, s);
            }
            reAlign() {
                this.alignOptions?.width && "left" !== this.alignOptions.align && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
            }
            removeClass(t) {
                return this.attr("class", ("" + this.attr("class")).replace(W(t) ? RegExp(`(^| )${t}( |$)`) : t, " ").replace(/ +/g, " ").trim());
            }
            removeTextOutline() {
                let t = this.element.querySelector("tspan.highcharts-text-outline");
                t && this.safeRemoveChild(t);
            }
            safeRemoveChild(t) {
                let e = t.parentNode;
                e && e.removeChild(t);
            }
            setRadialReference(t) {
                let e = this.element.gradient && this.renderer.gradients[this.element.gradient] || void 0;
                return this.element.radialReference = t, e?.radAttr && e.animate(this.renderer.getRadialAttr(t, e.radAttr)), this;
            }
            shadow(t) {
                let { renderer: e } = this, i = F(this.parentGroup?.rotation === 90 ? {
                    offsetX: -1,
                    offsetY: -1
                } : {}, X(t) ? t : {}), s = e.shadowDefinition(i);
                return this.attr({
                    filter: t ? `url(${e.url}#${s})` : "none"
                });
            }
            show(t = !0) {
                return this.attr({
                    visibility: t ? "inherit" : "visible"
                });
            }
            "stroke-widthSetter"(t, e, i) {
                this[e] = t, i.setAttribute(e, t);
            }
            strokeWidth() {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                let t = this.getStyle("stroke-width"), e = 0, i;
                return /px$/.test(t) ? e = U(t) : "" !== t && (u(i = t$.createElementNS(tU, "rect"), {
                    width: t,
                    "stroke-width": 0
                }), this.element.parentNode.appendChild(i), e = i.getBBox().width, i.parentNode.removeChild(i)), e;
            }
            symbolAttr(t) {
                let e = this;
                tK.symbolCustomAttribs.forEach(function(i) {
                    e[i] = t[i] ?? e[i];
                }), e.attr({
                    d: e.renderer.symbols[e.symbolName](e.x, e.y, e.width, e.height, e)
                });
            }
            textSetter(t) {
                t !== this.textStr && (delete this.textPxLength, this.textStr = t, this.added && this.renderer.buildText(this), this.reAlign());
            }
            titleSetter(t) {
                let e = this.element, i = e.getElementsByTagName("title")[0] || t$.createElementNS(this.SVG_NS, "title");
                e.insertBefore ? e.insertBefore(i, e.firstChild) : e.appendChild(i), i.textContent = K(t ?? "", [
                    /<[^>]*>/g,
                    ""
                ]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
            }
            toFront() {
                let t = this.element;
                return t.parentNode.appendChild(t), this;
            }
            translate(t, e) {
                return this.attr({
                    translateX: t,
                    translateY: e
                });
            }
            updateTransform(t = "transform") {
                let { element: e, foreignObject: i, matrix: s, rotation: o = 0, rotationOriginX: r, rotationOriginY: a, scaleX: n, scaleY: h, text: l, translateX: d = 0, translateY: c = 0 } = this, p = [
                    `translate(${d},${c})`
                ];
                v(s) && p.push("matrix(" + s.join(",") + ")"), o && p.push("rotate(" + o + " " + (r ?? e.getAttribute("x") ?? this.x ?? 0) + " " + (a ?? e.getAttribute("y") ?? this.y ?? 0) + ")"), (v(n) || v(h)) && p.push(`scale(${n ?? 1} ${h ?? 1})`), p.length && !(l || this).textPath && (i?.element || e).setAttribute(t, p.join(" "));
            }
            visibilitySetter(t, e, i) {
                "inherit" === t ? i.removeAttribute(e) : this[e] !== t && i.setAttribute(e, t), this[e] = t;
            }
            xGetter(t) {
                return "circle" === this.element.nodeName && ("x" === t ? t = "cx" : "y" === t && (t = "cy")), this._defaultGetter(t);
            }
            zIndexSetter(t, e) {
                let { element: i, parentGroup: s, renderer: o } = this, r = s?.element || o.box, a = r === o.box, n, h, l, d = !1, c, p = this.added, g;
                if (v(t) ? (i.setAttribute("data-z-index", t), t *= 1, this[e] === t && (p = !1)) : v(this[e]) && i.removeAttribute("data-z-index"), this[e] = t, p) {
                    for((t = this.zIndex) && s && (s.handleZ = !0), g = (n = r.childNodes).length - 1; g >= 0 && !d; g--)c = !v(l = (h = n[g]).getAttribute("data-z-index")), h !== i && (v(t) && t < 0 && c && !a && !g ? (r.insertBefore(i, n[g]), d = !0) : (v(t) && parseFloat(l || "") <= t || c && (!v(t) || t >= 0)) && (r.insertBefore(i, n[g + 1]), d = !0));
                    d || (r.insertBefore(i, n[3 * !!a]), d = !0);
                }
                return d;
            }
        }
        tK.symbolCustomAttribs = [
            "anchorX",
            "anchorY",
            "clockwise",
            "end",
            "height",
            "innerR",
            "r",
            "start",
            "width",
            "x",
            "y"
        ], tK.prototype.strokeSetter = tK.prototype.fillSetter, tK.prototype.yGetter = tK.prototype.xGetter, tK.prototype.matrixSetter = tK.prototype.rotationOriginXSetter = tK.prototype.rotationOriginYSetter = tK.prototype.rotationSetter = tK.prototype.scaleXSetter = tK.prototype.scaleYSetter = tK.prototype.translateXSetter = tK.prototype.translateYSetter = tK.prototype.verticalAlignSetter = function(t, e) {
            this[e] = t, this.doTransform = !0;
        };
        let tq = tK, { charts: tJ } = n, tQ = [
            "#2caffe",
            "#544fc5",
            "#00e272",
            "#fe6a35",
            "#6b8abc",
            "#d568fb",
            "#2ee0ca",
            "#fa4b42",
            "#feb56a",
            "#91e8e1"
        ], t0 = [
            null,
            "#00e272",
            "#efdf00"
        ];
        class t1 {
            constructor(t, e){
                this.defaultOptions = h, this.options = F(h), this.cssVars = {
                    light: {},
                    dark: {}
                }, this.renderer = t, this.update(e);
            }
            injectCSS(t) {
                let e, i, s, { cssVars: o, renderer: r } = this, a = Object.keys(M(t, this.defaultOptions)).length > 0, n = Math.max(t.colors?.length || 0, tQ.length), h = "light", l = (t, e)=>{
                    W(t) && (e = e.replace(/([0-9]+)/g, "-$1").replace(/[A-Z]/g, (t)=>`-${t.toLowerCase()}`), o[h][`--highcharts-${e}`] = t);
                };
                for (let e of [
                    "light",
                    "dark"
                ]){
                    let i = t[e] || {}, s = {}, r = new tv(i?.neutralColor || ""), a = new tv(i?.backgroundColor || ""), d = new tv(i?.highlightColor || "");
                    h = e, [
                        3,
                        5,
                        10,
                        20,
                        40,
                        60,
                        80,
                        100
                    ].forEach((t)=>{
                        s[`neutralColor${t}`] = a.tweenTo(r, t / 100), s[`highlightColor${t}`] = a.tweenTo(d, t / 100);
                    });
                    for(let s = 0; s < n; s++)l(i?.colors?.[s] || t.colors?.[s] || ("dark" === e ? t0 : [])?.[s] || tQ[s] || "#888a", `color${s}`);
                    j(i, l), j(s, l), "light" === e && S(o.dark, o.light);
                }
                let d = r.defs.element, c = a ? `*[data-highcharts-chart="${r.chartIndex}"]` : "", p = d.querySelector("style.highcharts-palette") || r.box.ownerDocument.createElement("style");
                p.parentNode || (p.nonce = "highcharts", p.className = "highcharts-palette", d.appendChild(p)), i = (e = (t)=>{
                    let e = "";
                    return j(o.light, (i, s)=>{
                        e += t && i !== o.dark[s] ? `  ${s}: light-dark(${i}, ${o.dark[s]});
` : `  ${s}: ${i};
`;
                    }), e;
                })(), s = e(!0), p.textContent = `${c || ":root"} {
${i}
}
@supports (color: light-dark(#fff, #000)) {
  ${c || ":root"} {
${s}
  }
}
.highcharts-container {
  color-scheme: light dark;
}
.highcharts-light .highcharts-container {
  color-scheme: light;
}
.highcharts-dark .highcharts-container {
  color-scheme: dark;
}`;
            }
            update(t) {
                let e = this.renderer.box.parentElement, i = tJ?.[this.renderer.chartIndex];
                t = F(!0, this.options, t), i && (i.options.palette = t), !1 !== t.injectCSS && this.injectCSS(t), e && (W(t.colorScheme) && [
                    "light",
                    "dark",
                    "inherit"
                ].includes(t.colorScheme) ? e.style.colorScheme = t.colorScheme : e.style.removeProperty("color-scheme"));
            }
        }
        class t2 extends tq {
            constructor(t, e, i, s, o, r, a, n, h, l){
                let d;
                super(t, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = e, this.x = i, this.y = s, this.anchorX = r, this.anchorY = a, this.baseline = h, this.className = l, this.addClass("button" === l ? "highcharts-no-tooltip" : "highcharts-label"), l && this.addClass("highcharts-" + l), this.text = t.text(void 0, 0, 0, n).attr({
                    zIndex: 1
                }), "string" == typeof o && ((d = /^url\((.*?)\)$/.test(o)) || this.renderer.symbols[o]) && (this.symbolKey = o), this.bBox = t2.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = t.styledMode || d, this.deferredAttr = {}, this.alignFactor = 0;
            }
            alignSetter(t) {
                let e = A(t);
                this.textAlign = t, e !== this.alignFactor && (this.alignFactor = e, this.bBox && N(this.xSetting) && this.attr({
                    x: this.xSetting
                }), this.updateTextPadding());
            }
            anchorXSetter(t, e) {
                this.anchorX = t, this.boxAttr(e, Math.round(t) - this.getCrispAdjust() - this.xSetting);
            }
            anchorYSetter(t, e) {
                this.anchorY = t, this.boxAttr(e, t - this.ySetting);
            }
            boxAttr(t, e) {
                this.box ? this.box.attr(t, e) : this.deferredAttr[t] = e;
            }
            css(t) {
                if (t) {
                    let e = {};
                    t = F(t), t2.textProps.forEach((i)=>{
                        void 0 !== t[i] && (e[i] = t[i], delete t[i]);
                    }), this.text.css(e), "fontSize" in e || "fontWeight" in e || "width" in e ? this.updateTextPadding() : "textOverflow" in e && this.updateBoxSize(), "color" in e && this.updateBackground();
                }
                return tq.prototype.css.call(this, t);
            }
            destroy() {
                q(this.element, "mouseenter"), q(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), tq.prototype.destroy.call(this);
            }
            fillSetter(t, e) {
                t && (this.needsBox = !0), this.fill = t, this.boxAttr(e, t);
            }
            getBBox(t, e) {
                (this.textStr && 0 === this.bBox.width && 0 === this.bBox.height || this.rotation) && this.updateBoxSize();
                let { padding: i, height: s = 0, translateX: o = 0, translateY: r = 0, width: a = 0 } = this, n = this.paddingLeft ?? i, h = e ?? (this.rotation || 0), l = {
                    width: a,
                    height: s,
                    x: o + this.bBox.x - n,
                    y: r + this.bBox.y - i + this.baselineOffset
                };
                return h && (l = this.getRotatedBox(l, h)), l;
            }
            getCrispAdjust() {
                return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
            }
            heightSetter(t) {
                this.heightSetting = t, this.doUpdate = !0;
            }
            afterSetters() {
                super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1), this.updateBackground();
            }
            onAdd() {
                this.text.add(this), this.attr({
                    text: this.textStr ?? "",
                    x: this.x || 0,
                    y: this.y || 0
                }), this.box && v(this.anchorX) && this.attr({
                    anchorX: this.anchorX,
                    anchorY: this.anchorY
                });
            }
            paddingSetter(t, e) {
                N(t) ? t !== this[e] && (this[e] = t, this.updateTextPadding()) : this[e] = void 0;
            }
            rSetter(t, e) {
                this.boxAttr(e, t);
            }
            strokeSetter(t, e) {
                this.stroke = t, this.boxAttr(e, t);
            }
            "stroke-widthSetter"(t, e) {
                t && (this.needsBox = !0), this["stroke-width"] = t, this.boxAttr(e, t);
            }
            "text-alignSetter"(t) {
                this.textAlign = this["text-align"] = t, this.updateTextPadding();
            }
            textSetter(t) {
                void 0 !== t && this.text.attr({
                    text: t
                }), this.updateTextPadding(), this.reAlign();
            }
            updateBackground() {
                "contrast" === this.fill && this.box?.attr({
                    fill: this.renderer.getContrast(this.text.styles.color || "#000"),
                    "fill-opacity": .65
                });
            }
            updateBoxSize() {
                let t, e = this.text, i = {}, s = this.padding, o = this.bBox = (!N(this.widthSetting) || !N(this.heightSetting) || this.textAlign) && v(e.textStr) ? e.getBBox(void 0, 0) : t2.emptyBBox;
                this.width = this.getPaddedWidth(), this.height = (this.heightSetting || o.height || 0) + 2 * s;
                let r = this.renderer.fontMetrics(e);
                if (this.baselineOffset = s + Math.min((this.text.firstLineMetrics || r).b, o.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - r.h) / 2), this.needsBox && !e.textPath) {
                    if (!this.box) {
                        let t = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                        t.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), t.add(this);
                    }
                    i.x = t = this.getCrispAdjust(), i.y = (this.baseline ? -this.baselineOffset : 0) + t, i.width = Math.round(this.width), i.height = Math.round(this.height), this.box.attr(S(i, this.deferredAttr)), this.deferredAttr = {};
                }
            }
            updateTextPadding() {
                let t = this.text, e = t.styles.textAlign || this.textAlign;
                if (!t.textPath) {
                    this.updateBoxSize();
                    let i = this.baseline ? 0 : this.baselineOffset, s = (this.paddingLeft ?? this.padding) + A(e) * (this.widthSetting ?? this.bBox.width);
                    (s !== t.x || i !== t.y) && (t.attr({
                        align: e,
                        x: s
                    }), void 0 !== i && t.attr("y", i)), t.x = s, t.y = i;
                }
            }
            widthSetter(t) {
                this.widthSetting = N(t) ? t : void 0, this.doUpdate = !0;
            }
            getPaddedWidth() {
                let t = this.padding, e = this.paddingLeft ?? t, i = this.paddingRight ?? t;
                return (this.widthSetting || this.bBox.width || 0) + e + i;
            }
            xSetter(t) {
                this.x = t, this.alignFactor && (t -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.anchorX && (this["forceAnimate:anchorX"] = !0), this.xSetting = Math.round(t), this.attr("translateX", this.xSetting);
            }
            ySetter(t) {
                this.anchorY && (this["forceAnimate:anchorY"] = !0), this.ySetting = this.y = Math.round(t), this.attr("translateY", this.ySetting);
            }
        }
        function t5(t, e, i, s, o) {
            let r = [];
            if (o) {
                let a = o.start || 0, n = o.end || 0, h = o.r ?? i, l = o.r ?? (s || i), d = 1e-4 > Math.abs(n - a - 2 * Math.PI);
                d && (a = Math.PI / 2, n = 2.5 * Math.PI - 1e-4);
                let c = o.innerR, p = o.open ?? d, g = d ? 0 : Math.cos(a), u = d ? 1 : Math.sin(a), f = d ? 0 : Math.cos(n), m = d ? 1 : Math.sin(n), x = o.longArc ?? (n - a - Math.PI < 1e-4 ? 0 : 1), y = [
                    "A",
                    h,
                    l,
                    0,
                    x,
                    o.clockwise ?? 1,
                    t + (d ? .001 : h * f),
                    e + l * m
                ];
                y.params = {
                    start: a,
                    end: n,
                    cx: t,
                    cy: e
                }, r.push([
                    "M",
                    t + h * g,
                    e + l * u
                ], y), v(c) && ((y = [
                    "A",
                    c,
                    c,
                    0,
                    x,
                    v(o.clockwise) ? 1 - o.clockwise : 0,
                    t + (d ? -0.001 : c * g),
                    e + c * u
                ]).params = {
                    start: n,
                    end: a,
                    cx: t,
                    cy: e
                }, r.push(p ? [
                    "M",
                    t + c * f,
                    e + c * m
                ] : [
                    "L",
                    t + c * f,
                    e + c * m
                ], y)), p || r.push([
                    "Z"
                ]);
            }
            return r;
        }
        function t3(t, e, i, s, o) {
            return o?.r ? t9(t, e, i, s, o) : [
                [
                    "M",
                    t,
                    e
                ],
                [
                    "L",
                    t + i,
                    e
                ],
                [
                    "L",
                    t + i,
                    e + s
                ],
                [
                    "L",
                    t,
                    e + s
                ],
                [
                    "Z"
                ]
            ];
        }
        function t9(t, e, i, s, o) {
            let r = o?.r || 0;
            return [
                [
                    "M",
                    t + r,
                    e
                ],
                [
                    "L",
                    t + i - r,
                    e
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t + i,
                    e + r
                ],
                [
                    "L",
                    t + i,
                    e + s - r
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t + i - r,
                    e + s
                ],
                [
                    "L",
                    t + r,
                    e + s
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t,
                    e + s - r
                ],
                [
                    "L",
                    t,
                    e + r
                ],
                [
                    "A",
                    r,
                    r,
                    0,
                    0,
                    1,
                    t + r,
                    e
                ],
                [
                    "Z"
                ]
            ];
        }
        t2.emptyBBox = {
            width: 0,
            height: 0,
            x: 0,
            y: 0
        }, t2.textProps = [
            "color",
            "direction",
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontWeight",
            "lineClamp",
            "lineHeight",
            "textAlign",
            "textDecoration",
            "textOutline",
            "textOverflow",
            "whiteSpace",
            "width"
        ];
        let t6 = {
            arc: t5,
            callout: function(t, e, i, s, o) {
                let r = o?.arrowLength ?? 6, a = Math.min(o?.r || 0, i, s), n = a + 6, h = o?.anchorX, l = o?.anchorY || 0, d = t9(t, e, i, s, {
                    r: a
                });
                if (!N(h) || h < i && h > 0 && l < s && l > 0) return d;
                if (t + h > i - n) {
                    if (l > e + n && l < e + s - n) d.splice(3, 1, [
                        "L",
                        t + i,
                        l - 6
                    ], [
                        "L",
                        t + i + r,
                        l
                    ], [
                        "L",
                        t + i,
                        l + 6
                    ], [
                        "L",
                        t + i,
                        e + s - a
                    ]);
                    else if (h < i) {
                        let o = l < e + n, r = o ? e : e + s;
                        d.splice(o ? 2 : 5, 0, [
                            "L",
                            h,
                            l
                        ], [
                            "L",
                            t + i - a,
                            r
                        ]);
                    } else d.splice(3, 1, [
                        "L",
                        t + i,
                        s / 2
                    ], [
                        "L",
                        h,
                        l
                    ], [
                        "L",
                        t + i,
                        s / 2
                    ], [
                        "L",
                        t + i,
                        e + s - a
                    ]);
                } else if (t + h < n) {
                    if (l > e + n && l < e + s - n) d.splice(7, 1, [
                        "L",
                        t,
                        l + 6
                    ], [
                        "L",
                        t - r,
                        l
                    ], [
                        "L",
                        t,
                        l - 6
                    ], [
                        "L",
                        t,
                        e + a
                    ]);
                    else if (h > 0) {
                        let i = l < e + n, o = i ? e : e + s;
                        d.splice(i ? 1 : 6, 0, [
                            "L",
                            h,
                            l
                        ], [
                            "L",
                            t + a,
                            o
                        ]);
                    } else d.splice(7, 1, [
                        "L",
                        t,
                        s / 2
                    ], [
                        "L",
                        h,
                        l
                    ], [
                        "L",
                        t,
                        s / 2
                    ], [
                        "L",
                        t,
                        e + a
                    ]);
                } else l > s && h < i - n ? d.splice(5, 1, [
                    "L",
                    h + 6,
                    e + s
                ], [
                    "L",
                    h,
                    e + s + r
                ], [
                    "L",
                    h - 6,
                    e + s
                ], [
                    "L",
                    t + a,
                    e + s
                ]) : l < 0 && h > n && d.splice(1, 1, [
                    "L",
                    h - 6,
                    e
                ], [
                    "L",
                    h,
                    e - r
                ], [
                    "L",
                    h + 6,
                    e
                ], [
                    "L",
                    i - a,
                    e
                ]);
                return d;
            },
            circle: function(t, e, i, s) {
                return t5(t + i / 2, e + s / 2, i / 2, s / 2, {
                    start: .5 * Math.PI,
                    end: 2.5 * Math.PI,
                    open: !1
                });
            },
            diamond: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s / 2
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s / 2
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            rect: t3,
            roundedRect: t9,
            square: t3,
            triangle: function(t, e, i, s) {
                return [
                    [
                        "M",
                        t + i / 2,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + s
                    ],
                    [
                        "L",
                        t,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            },
            "triangle-down": function(t, e, i, s) {
                return [
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e
                    ],
                    [
                        "L",
                        t + i / 2,
                        e + s
                    ],
                    [
                        "Z"
                    ]
                ];
            }
        }, { doc: t4, SVG_NS: t8, win: t7 } = n, et = (t, e)=>t.substring(0, e) + "\u2026", ee = class {
            constructor(t){
                let e = t.styles;
                this.renderer = t.renderer, this.svgElement = t, this.width = t.textWidth, this.textLineHeight = e?.lineHeight, this.textOutline = e?.textOutline, this.ellipsis = e?.textOverflow === "ellipsis", this.lineClamp = e?.lineClamp, this.noWrap = e?.whiteSpace === "nowrap";
            }
            buildSVG() {
                let t = this.svgElement, e = t.element, i = t.renderer, s = (t.textStr ?? "").toString(), o = -1 !== s.indexOf("<"), r = e.childNodes, a = !t.added && i.box, n = [
                    s,
                    this.ellipsis,
                    this.noWrap,
                    this.textLineHeight,
                    this.textOutline,
                    t.getStyle("font-size"),
                    t.styles.lineClamp,
                    this.width
                ].join(",");
                if (n !== t.textCache) {
                    t.textCache = n, delete t.actualWidth;
                    for(let t = r.length; t--;)e.removeChild(r[t]);
                    if (o || this.ellipsis || this.width || t.textPath || -1 !== s.indexOf(" ") && (!this.noWrap || /<br.*?>/g.test(s))) {
                        if ("" !== s) {
                            a && a.appendChild(e);
                            let i = new tB(s);
                            this.modifyTree(i.nodes), i.addToDOM(e), this.modifyDOM(), this.ellipsis && -1 !== (e.textContent || "").indexOf("\u2026") && t.attr("title", this.unescapeEntities(t.textStr || "", [
                                "&lt;",
                                "&gt;"
                            ])), a && a.removeChild(e);
                        }
                    } else e.appendChild(t4.createTextNode(this.unescapeEntities(s)));
                    W(this.textOutline) && t.applyTextOutline && t.applyTextOutline(this.textOutline);
                }
            }
            modifyDOM() {
                let t, e = this.svgElement, i = u(e.element, "x");
                for(e.firstLineMetrics = void 0; t = e.element.firstChild;)if (/^[\s\u200B]*$/.test(t.textContent || " ")) e.element.removeChild(t);
                else break;
                [].forEach.call(e.element.querySelectorAll("tspan.highcharts-br"), (t, s)=>{
                    t.nextSibling && t.previousSibling && (0 === s && 1 === t.previousSibling.nodeType && (e.firstLineMetrics = e.renderer.fontMetrics(t.previousSibling)), u(t, {
                        dy: this.getLineHeight(t.nextSibling),
                        x: i
                    }));
                });
                let s = this.width || 0;
                if (!s) return;
                let o = (t, o)=>{
                    let r = t.textContent || "", a = r.replace(/([^\^])-/g, "$1- ").split(" "), n = !this.noWrap && (a.length > 1 || e.element.childNodes.length > 1), h = this.getLineHeight(o), l = Math.max(0, s - .8 * h), d = 0, c = e.actualWidth;
                    if (n) {
                        let r = [], n = [];
                        for(; o.firstChild && o.firstChild !== t;)n.push(o.firstChild), o.removeChild(o.firstChild);
                        for(; a.length;)if (a.length && !this.noWrap && d > 0 && (r.push(t.textContent || ""), t.textContent = a.join(" ").replace(/- /g, "-")), this.truncate(t, void 0, a, 0 === d && c || 0, s, l, (t, e)=>a.slice(0, e).join(" ").replace(/- /g, "-")), c = e.actualWidth, d++, this.lineClamp && d >= this.lineClamp) {
                            a.length && (this.truncate(t, t.textContent || "", void 0, 0, s, l, et), t.textContent && (t.textContent = t.textContent?.replace("\u2026", "") + "\u2026"));
                            break;
                        }
                        n.forEach((e)=>{
                            o.insertBefore(e, t);
                        }), r.forEach((e)=>{
                            o.insertBefore(t4.createTextNode(e), t);
                            let s = t4.createElementNS(t8, "tspan");
                            s.textContent = "\u200B", u(s, {
                                dy: h,
                                x: i
                            }), o.insertBefore(s, t);
                        });
                    } else this.ellipsis && r && this.truncate(t, r, void 0, 0, s, l, et);
                }, r = (t)=>{
                    [].slice.call(t.childNodes).forEach((i)=>{
                        i.nodeType === t7.Node.TEXT_NODE ? o(i, t) : (-1 !== i.className.baseVal.indexOf("highcharts-br") && (e.actualWidth = 0), r(i));
                    });
                };
                r(e.element);
            }
            getLineHeight(t) {
                let e = t.nodeType === t7.Node.TEXT_NODE ? t.parentElement : t;
                return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(e || this.svgElement.element).h;
            }
            modifyTree(t) {
                let e = (i, s)=>{
                    let { attributes: o = {}, children: r, style: a = {}, tagName: n } = i, h = this.renderer.styledMode;
                    if ("b" === n || "strong" === n ? h ? o.class = "highcharts-strong" : a.fontWeight = "bold" : ("i" === n || "em" === n) && (h ? o.class = "highcharts-emphasized" : a.fontStyle = "italic"), a?.color && (a.fill = a.color), "br" === n) {
                        o.class = "highcharts-br", i.textContent = "\u200B";
                        let e = t[s + 1];
                        e?.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""));
                    } else "a" === n && r && r.some((t)=>"#text" === t.tagName) && (i.children = [
                        {
                            children: r,
                            tagName: "tspan"
                        }
                    ]);
                    "#text" !== n && "a" !== n && (i.tagName = "tspan"), S(i, {
                        attributes: o,
                        style: a
                    }), r && r.filter((t)=>"#text" !== t.tagName).forEach(e);
                };
                t.forEach(e), P(this.svgElement, "afterModifyTree", {
                    nodes: t
                });
            }
            truncate(t, e, i, s, o, r, a) {
                let n, h, l = this.svgElement, { rotation: d } = l, c = [], p = i && !s ? 1 : 0, g = (e || i || "").length, u = g;
                i || (o = r);
                let f = function(e, o) {
                    let r = o || e, a = t.parentNode;
                    if (a && void 0 === c[r] && a.getSubStringLength) try {
                        c[r] = s + a.getSubStringLength(0, i ? r + 1 : r);
                    } catch  {}
                    return c[r];
                };
                if (l.rotation = 0, s + (h = f(t.textContent.length)) > o) {
                    for(; p <= g;)u = Math.ceil((p + g) / 2), i && (n = a(i, u)), h = f(u, n && n.length - 1), p === g ? p = g + 1 : h > o ? g = u - 1 : p = u;
                    0 === g ? t.textContent = "" : e && g === e.length - 1 || (t.textContent = n || a(e || i, u)), this.ellipsis && h > o && this.truncate(t, t.textContent || "", void 0, 0, o, r, et);
                }
                i && i.splice(0, u), l.actualWidth = h, l.rotation = d;
            }
            unescapeEntities(t, e) {
                return j(this.renderer.escapes, function(i, s) {
                    e && -1 !== e.indexOf(i) || (t = t.toString().replace(RegExp(i, "g"), s));
                }), t;
            }
        }, { defaultOptions: ei } = tm, { charts: es, deg2rad: eo, doc: er, isFirefox: ea, isMS: en, isWebKit: eh, noop: el, SVG_NS: ed, symbolSizes: ec, win: ep } = n;
        class eg {
            constructor(t, e, i, s, o, r, a, n, h){
                let l, d;
                this.x = 0, this.y = 0;
                let p = this.createElement("svg").attr({
                    version: "1.1",
                    class: "highcharts-root"
                }), g = p.element;
                t.appendChild(g), u(t, "dir", "ltr"), -1 === t.innerHTML.indexOf("xmlns") && u(g, "xmlns", this.SVG_NS), this.box = g, this.boxWrapper = p, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(er.createTextNode("Created with Highcharts 13.1.1")), this.defs = this.createElement("defs").add(), this.allowHTML = r, this.forExport = o, this.styledMode = a, this.chartIndex = h || 0, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.asyncCounter = 0, this.rootFontSize = p.getStyle("font-size"), this.setSize(e, i, !1), a || (p.css(this.getStyle(s || {})), this.palette = new t1(this, n || ei.palette)), ea && t.getBoundingClientRect && ((l = function() {
                    b(t, {
                        left: 0,
                        top: 0
                    }), d = t.getBoundingClientRect(), b(t, {
                        left: Math.ceil(d.left) - d.left + "px",
                        top: Math.ceil(d.top) - d.top + "px"
                    });
                })(), this.unSubPixelFix = c(ep, "resize", l));
            }
            definition(t) {
                return new tB([
                    t
                ]).addToDOM(this.defs.element);
            }
            getReferenceURL() {
                if ((ea || eh) && er.getElementsByTagName("base").length) {
                    if (!v(e)) {
                        let t = tn(), i = new tB([
                            {
                                tagName: "svg",
                                attributes: {
                                    width: 8,
                                    height: 8
                                },
                                children: [
                                    {
                                        tagName: "defs",
                                        children: [
                                            {
                                                tagName: "clipPath",
                                                attributes: {
                                                    id: t
                                                },
                                                children: [
                                                    {
                                                        tagName: "rect",
                                                        attributes: {
                                                            width: 4,
                                                            height: 4
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        tagName: "rect",
                                        attributes: {
                                            id: "hitme",
                                            width: 8,
                                            height: 8,
                                            "clip-path": `url(#${t})`,
                                            fill: "rgba(0,0,0,0.001)"
                                        }
                                    }
                                ]
                            }
                        ]).addToDOM(er.body);
                        b(i, {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            zIndex: 9e5
                        });
                        let s = er.elementFromPoint(6, 6);
                        e = s?.id === "hitme", er.body.removeChild(i);
                    }
                    if (e) return K(ep.location.href.split("#")[0], [
                        /<[^>]*>/g,
                        ""
                    ], [
                        /([\('\)])/g,
                        "\\$1"
                    ], [
                        / /g,
                        "%20"
                    ]);
                }
                return "";
            }
            getStyle(t) {
                return this.style = S({
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
                    fontSize: "1rem"
                }, t), this.style;
            }
            setStyle(t) {
                this.boxWrapper.css(this.getStyle(t));
            }
            isHidden() {
                return !this.boxWrapper.getBBox().width;
            }
            destroy() {
                let t = this.defs;
                return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), k(this.gradients || {}), this.gradients = null, this.defs = t.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects.length = 0, null;
            }
            createElement(t) {
                return new this.Element(this, t);
            }
            getRadialAttr(t, e) {
                return {
                    cx: t[0] - t[2] / 2 + (e.cx || 0) * t[2],
                    cy: t[1] - t[2] / 2 + (e.cy || 0) * t[2],
                    r: (e.r || 0) * t[2]
                };
            }
            shadowDefinition(t) {
                let e = [
                    `highcharts-drop-shadow-${this.chartIndex}`,
                    ...Object.keys(t).map((e)=>`${e}-${t[e]}`)
                ].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), i = F({
                    color: "#000000",
                    offsetX: 0,
                    offsetY: 2,
                    opacity: .05,
                    width: 6
                }, t);
                return this.defs.element.querySelector(`#${e}`) || this.definition({
                    tagName: "filter",
                    attributes: {
                        id: e,
                        filterUnits: i.filterUnits
                    },
                    children: this.getShadowFilterContent(i)
                }), e;
            }
            getShadowFilterContent(t) {
                return [
                    {
                        tagName: "feDropShadow",
                        attributes: {
                            dx: t.offsetX,
                            dy: t.offsetY,
                            "flood-color": t.color,
                            "flood-opacity": Math.min(5 * t.opacity, 1),
                            stdDeviation: t.width / 2
                        }
                    }
                ];
            }
            buildText(t) {
                new ee(t).buildSVG();
            }
            getContrast(t) {
                if ("transparent" === t) return "#000000";
                let e = tv.parse(t).rgba, i = " clamp(0,calc(9e9*(0.5 - (0.2126*r + 0.7152*g + 0.0722*b))),1)";
                if (N(e[0]) || !tv.useColorMix) {
                    let t = e.map((t)=>{
                        let e = t / 255;
                        return e <= .04 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                    }), i = .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
                    return 1.05 / (i + .05) > (i + .05) / .05 ? "#FFFFFF" : "#000000";
                }
                return "color(from " + t + " srgb" + i + i + i + ")";
            }
            button(t, e, i, s, o = {}, r, a, n, h, l) {
                let d = this.label(t, e, i, h, void 0, void 0, l, void 0, "button"), p = this.styledMode, g = arguments, u = 0;
                o = F(ei.global.buttonTheme, o), p && (delete o.fill, delete o.stroke, delete o["stroke-width"]);
                let f = o.states || {}, m = o.style || {};
                delete o.states, delete o.style;
                let x = [
                    tB.filterUserAttributes(o)
                ], y = [
                    m
                ];
                return p || [
                    "hover",
                    "select",
                    "disabled"
                ].forEach((t, e)=>{
                    x.push(F(x[0], tB.filterUserAttributes(g[e + 5] || f[t] || {}))), y.push(x[e + 1].style), delete x[e + 1].style;
                }), c(d.element, en ? "mouseover" : "mouseenter", function() {
                    3 !== u && d.setState(1);
                }), c(d.element, en ? "mouseout" : "mouseleave", function() {
                    3 !== u && d.setState(u);
                }), d.setState = (t = 0)=>{
                    if (1 !== t && (d.state = u = t), d.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][t]), !p) {
                        d.attr(x[t]);
                        let e = y[t];
                        X(e) && d.css(e);
                    }
                }, d.attr(x[0]), !p && (d.css(S({
                    cursor: "default"
                }, m)), l && d.text.css({
                    pointerEvents: "none"
                })), d.on("touchstart", (t)=>t.stopPropagation()).on("click", function(t) {
                    3 !== u && s?.call(d, t);
                });
            }
            crispLine(t, e) {
                let [i, s] = t;
                return v(i[1]) && i[1] === s[1] && (i[1] = s[1] = y(i[1], e)), v(i[2]) && i[2] === s[2] && (i[2] = s[2] = y(i[2], e)), t;
            }
            path(t) {
                let e = this.styledMode ? {} : {
                    fill: "none"
                };
                return H(t) ? e.d = t : X(t) && S(e, t), this.createElement("path").attr(e);
            }
            circle(t, e, i) {
                let s = X(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: i
                }, o = this.createElement("circle");
                return o.xSetter = o.ySetter = function(t, e, i) {
                    i.setAttribute("c" + e, t);
                }, o.attr(s);
            }
            arc(t, e, i, s, o, r) {
                let a;
                X(t) ? (e = (a = t).y, i = a.r, s = a.innerR, o = a.start, r = a.end, t = a.x) : a = {
                    innerR: s,
                    start: o,
                    end: r
                };
                let n = this.symbol("arc", t, e, i, i, a);
                return n.r = i, n;
            }
            rect(t, e, i, s, o, r) {
                let a = X(t) ? t : void 0 === t ? {} : {
                    x: t,
                    y: e,
                    r: o,
                    width: Math.max(i || 0, 0),
                    height: Math.max(s || 0, 0)
                }, n = this.createElement("rect");
                return this.styledMode || (void 0 !== r && (a["stroke-width"] = r, S(a, n.crisp(a))), a.fill = "none"), n.rSetter = function(t, e, i) {
                    n.r = t, u(i, {
                        rx: t,
                        ry: t
                    });
                }, n.rGetter = function() {
                    return n.r || 0;
                }, n.attr(a);
            }
            roundedRect(t) {
                return this.symbol("roundedRect").attr(t);
            }
            setSize(t, e, i) {
                this.width = t, this.height = e, this.boxWrapper.animate({
                    width: t,
                    height: e
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: i ?? !0 ? void 0 : 0
                }), this.alignElements();
            }
            g(t) {
                let e = this.createElement("g");
                return t ? e.attr({
                    class: "highcharts-" + t
                }) : e;
            }
            image(t, e, i, s, o, r) {
                let a = {
                    preserveAspectRatio: "none"
                };
                N(e) && (a.x = e), N(i) && (a.y = i), N(s) && (a.width = s), N(o) && (a.height = o);
                let n = this.createElement("image").attr(a), h = function(e) {
                    n.attr({
                        href: t
                    }), r.call(n, e);
                };
                if (r) {
                    n.attr({
                        href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    });
                    let e = new ep.Image;
                    c(e, "load", h), e.src = t, e.complete && h({});
                } else n.attr({
                    href: t
                });
                return n;
            }
            symbol(t, e, i, s, o, r) {
                let a, n, h, l, d = this, c = /^url\((.*?)\)$/, p = c.test(t), g = !p && (this.symbols[t] ? t : "circle"), f = g && this.symbols[g];
                if (f) "number" == typeof e && (n = f.call(this.symbols, e || 0, i || 0, s || 0, o || 0, r)), a = this.path(n), d.styledMode || a.attr("fill", "none"), S(a, {
                    symbolName: g || void 0,
                    x: e,
                    y: i,
                    width: s,
                    height: o
                }), r && S(a, r);
                else if (p) {
                    h = t.match(c)[1];
                    let s = a = this.image(h);
                    s.imgwidth = r?.width ?? ec[h]?.width, s.imgheight = r?.height ?? ec[h]?.height, l = (t)=>t.attr({
                            width: t.width,
                            height: t.height
                        }), [
                        "width",
                        "height"
                    ].forEach((t)=>{
                        s[`${t}Setter`] = function(t, e) {
                            this[e] = t;
                            let { alignByTranslate: i, element: s, width: o, height: a, imgwidth: n, imgheight: h } = this, l = "width" === e ? n : h, d = 1;
                            r && "within" === r.backgroundSize && o && a && n && h ? (d = Math.min(o / n, a / h), u(s, {
                                width: Math.round(n * d),
                                height: Math.round(h * d)
                            })) : s && l && s.setAttribute(e, l), !i && n && h && this.translate(((o || 0) - n * d) / 2, ((a || 0) - h * d) / 2);
                        };
                    }), v(e) && s.attr({
                        x: e,
                        y: i
                    }), s.isImg = !0, v(s.imgwidth) && v(s.imgheight) ? l(s) : (s.attr({
                        width: 0,
                        height: 0
                    }), x("img", {
                        onload: function() {
                            let t = es[d.chartIndex];
                            0 === this.width && (b(this, {
                                position: "absolute",
                                top: "-999em"
                            }), er.body.appendChild(this)), ec[h] = {
                                width: this.width,
                                height: this.height
                            }, s.imgwidth = this.width, s.imgheight = this.height, s.element && l(s), this.parentNode && this.parentNode.removeChild(this), d.asyncCounter--, d.asyncCounter || !t || t.hasLoaded || t.onload();
                        },
                        src: h
                    }), this.asyncCounter++);
                }
                return a;
            }
            clipRect(t, e, i, s) {
                return this.rect(t, e, i, s, 0);
            }
            text(t, e, i, s) {
                let o = {};
                if (s && (this.allowHTML || !this.forExport)) return this.html(t, e, i);
                o.x = Math.round(e || 0), i && (o.y = Math.round(i)), v(t) && (o.text = t);
                let r = this.createElement("text").attr(o);
                return s && (!this.forExport || this.allowHTML) || (r.xSetter = function(t, e, i) {
                    let s = i.getElementsByTagName("tspan"), o = i.getAttribute(e);
                    for(let i = 0, r; i < s.length; i++)(r = s[i]).getAttribute(e) === o && r.setAttribute(e, t);
                    i.setAttribute(e, t);
                }), r;
            }
            fontMetrics(t) {
                let e = N(t) ? t : U(tq.prototype.getStyle.call(t, "font-size") || 0), i = e < 24 ? e + 3 : Math.round(1.2 * e), s = Math.round(.8 * i);
                return {
                    h: i,
                    b: s,
                    f: e
                };
            }
            rotCorr(t, e, i) {
                let s = t;
                return e && i && (s = Math.max(s * Math.cos(e * eo), 4)), {
                    x: -t / 3 * Math.sin(e * eo),
                    y: s
                };
            }
            pathToSegments(t) {
                let e = [], i = [], s = {
                    A: 8,
                    C: 7,
                    H: 2,
                    L: 3,
                    M: 3,
                    Q: 5,
                    S: 5,
                    T: 3,
                    V: 2
                };
                for(let o = 0; o < t.length; o++)W(i[0]) && N(t[o]) && i.length === s[i[0].toUpperCase()] && t.splice(o, 0, i[0].replace("M", "L").replace("m", "l")), "string" == typeof t[o] && (i.length && e.push(i.slice(0)), i.length = 0), i.push(t[o]);
                return e.push(i.slice(0)), e;
            }
            label(t, e, i, s, o, r, a, n, h) {
                return new t2(this, t, e, i, s, o, r, a, n, h);
            }
            alignElements() {
                this.alignedObjects.forEach((t)=>t.align());
            }
        }
        S(eg.prototype, {
            Element: tq,
            SVG_NS: ed,
            escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
            },
            symbols: t6,
            draw: el
        }), n.Renderer = eg;
        let { composed: eu, isFirefox: ef } = n;
        class em extends tq {
            static compose(t) {
                _(eu, "HTMLElement") && (t.prototype.html = function(t, e, i) {
                    return new em(this, "div").attr({
                        text: t,
                        x: Math.round(e),
                        y: Math.round(i),
                        xmlns: "http://www.w3.org/1999/xhtml"
                    });
                });
            }
            constructor(t, e){
                super(t, e), this.foreignObject = t.createElement("foreignObject").attr({
                    zIndex: 2
                }), this.element.style.whiteSpace = "nowrap";
            }
            getSpanCorrection(t, e, i) {
                this.xCorr = -t * i, this.yCorr = -e;
            }
            css(t) {
                let e, { element: i } = this, s = t && "width" in t, o = s && t.width;
                return s && (delete t.width, this.textWidth = U(o) || void 0, e = !0), t?.textOverflow === "ellipsis" && (t.overflow = "hidden", (t.lineClamp ?? this.styles.lineClamp) || (t.whiteSpace = "nowrap")), t?.lineClamp ? (t.display = "-webkit-box", t.WebkitLineClamp = t.lineClamp, t.WebkitBoxOrient = "vertical", t.overflow = "hidden") : t?.lineClamp === 0 && (t.display = "inline-block"), N(Number(t?.fontSize)) && (t.fontSize += "px"), S(this.styles, t), b(i, t), e && this.updateTransform(), this;
            }
            htmlGetBBox() {
                let { element: t } = this;
                return {
                    x: t.offsetLeft,
                    y: t.offsetTop,
                    width: t.offsetWidth,
                    height: t.offsetHeight
                };
            }
            updateTransform() {
                let t;
                if (!this.added) {
                    this.alignOnAdd = !0;
                    return;
                }
                let { element: e, foreignObject: i, oldTextWidth: s, renderer: o, rotation: r, scaleX: a, styles: { display: n = "inline-block", whiteSpace: h }, textAlign: l = "left", textWidth: d, x: c = 0, y: p = 0 } = this, g = ()=>this.textPxLength ? this.textPxLength : (b(e, {
                        width: "",
                        whiteSpace: h || "nowrap"
                    }), e.offsetWidth), u = [
                    r,
                    l,
                    e.innerHTML,
                    d,
                    this.textAlign
                ].join(",");
                if (b(e, {
                    display: "inline-block",
                    verticalAlign: "top"
                }), d !== s) {
                    let t = g(), i = d || 0, l = !o.styledMode && "" === e.style.textOverflow && e.style.webkitLineClamp;
                    (i > s || t > i || l) && (/[\-\s\u00AD]/.test(e.textContent || e.innerText) || "ellipsis" === e.style.textOverflow) && (b(e, {
                        width: (r || a || t > i) && N(d) ? d + "px" : l ? Math.min(t + 1, i) + "px" : "auto",
                        display: n,
                        whiteSpace: h || "normal"
                    }), this.oldTextWidth = d);
                }
                i.attr({
                    width: o.width,
                    height: o.height
                }), u !== this.cTT && (t = o.fontMetrics(e).b, this.getSpanCorrection(!v(r) && !this.textWidth && this.textPxLength || e.offsetWidth, t, A(l))), super.updateTransform(), N(c) && N(p) ? (i.attr({
                    x: c + (this.xCorr || 0),
                    y: p + (this.yCorr || 0),
                    width: e.offsetWidth + 4,
                    height: e.offsetHeight + 1,
                    "transform-origin": e.getAttribute("transform-origin") || "0 0"
                }), b(e, {
                    display: n,
                    textAlign: l
                })) : ef && i.attr({
                    width: 0,
                    height: 0
                }), this.cTT = u;
            }
            add(t) {
                let { foreignObject: e } = this;
                return e.add(t), super.add(e), this.alignOnAdd && this.updateTransform(), this;
            }
            textSetter(t) {
                t !== this.textStr && (delete this.oldTextWidth, tB.setElementHTML(this.element, t ?? ""), this.textStr = t, this.doTransform = !0);
            }
            alignSetter(t) {
                this.alignValue = this.textAlign = t, this.doTransform = !0;
            }
            xSetter(t, e) {
                this[e] = t, this.doTransform = !0;
            }
            visibilitySetter(t, e) {
                this.foreignObject.attr({
                    [e]: t
                }), this[e] = t;
            }
        }
        let ex = em.prototype;
        ex.ySetter = ex.xSetter, ex.opacitySetter = ex.visibilitySetter, (ip = e6 || (e6 = {})).xAxis = {
            alignTicks: !0,
            allowDecimals: void 0,
            panningEnabled: !0,
            zIndex: 2,
            zoomEnabled: !0,
            dateTimeLabelFormats: {
                millisecond: {
                    main: "%[HMSL]",
                    range: !1
                },
                second: {
                    main: "%[HMS]",
                    range: !1
                },
                minute: {
                    main: "%[HM]",
                    range: !1
                },
                hour: {
                    main: "%[HM]",
                    boundary: void 0,
                    range: !1
                },
                day: {
                    main: "%[eb]",
                    boundary: "%[eb]"
                },
                week: {
                    main: "%[eb]"
                },
                month: {
                    main: "%[bY]",
                    boundary: void 0
                },
                year: {
                    main: "%[Y]",
                    boundary: void 0
                }
            },
            endOnTick: !1,
            gridLineDashStyle: "Solid",
            gridZIndex: 1,
            labels: {
                autoRotationLimit: 80,
                enabled: !0,
                indentation: 10,
                overflow: "justify",
                reserveSpace: void 0,
                rotation: void 0,
                staggerLines: 0,
                step: 0,
                useHTML: !1,
                zIndex: 7,
                style: {
                    color: "var(--highcharts-neutral-color-80)",
                    cursor: "default",
                    fontSize: "0.8em",
                    textOverflow: "ellipsis"
                }
            },
            maxPadding: .01,
            minorGridLineDashStyle: "Solid",
            minorTickLength: 2,
            minorTickPosition: "outside",
            minorTicksPerMajor: 5,
            minPadding: .01,
            offset: void 0,
            reversed: void 0,
            reversedStacks: !1,
            showEmpty: !0,
            showFirstLabel: !0,
            showLastLabel: !0,
            startOfWeek: 1,
            startOnTick: !1,
            tickLength: 10,
            tickmarkPlacement: "between",
            tickPixelInterval: 100,
            tickPosition: "outside",
            title: {
                align: "middle",
                useHTML: !1,
                x: 0,
                y: 0,
                style: {
                    color: "var(--highcharts-neutral-color-60)",
                    fontSize: "0.8em"
                }
            },
            visible: !0,
            minorGridLineColor: "var(--highcharts-neutral-color-5)",
            minorGridLineWidth: 1,
            minorTickColor: "var(--highcharts-neutral-color-40)",
            lineColor: "var(--highcharts-neutral-color-80)",
            lineWidth: 1,
            gridLineColor: "var(--highcharts-neutral-color-10)",
            gridLineWidth: void 0,
            tickColor: "var(--highcharts-neutral-color-80)"
        }, ip.yAxis = {
            reversedStacks: !0,
            endOnTick: !0,
            maxPadding: .05,
            minPadding: .05,
            tickPixelInterval: 72,
            showLastLabel: !0,
            labels: {
                x: void 0
            },
            startOnTick: !0,
            title: {},
            stackLabels: {
                animation: {},
                allowOverlap: !1,
                enabled: !1,
                crop: !0,
                overflow: "justify",
                formatter: function() {
                    return this.axis.chart.numberFormatter(this.total || 0, -1);
                },
                style: {
                    color: "var(--highcharts-neutral-color-100)",
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    textOutline: "1px contrast"
                }
            },
            gridLineWidth: 1,
            lineWidth: 0
        };
        let ey = e6;
        (e4 || (e4 = {})).registerEventOptions = function(t, e) {
            t.eventOptions = t.eventOptions || {}, j(e.events, function(e, i) {
                t.eventOptions[i] !== e && (t.eventOptions[i] && (q(t, i, t.eventOptions[i]), delete t.eventOptions[i]), G(e) && (t.eventOptions[i] = e, c(t, i, e, {
                    order: 0
                })));
            });
        };
        let eb = e4, { deg2rad: ev } = n, ek = class {
            constructor(t, e, i, s, o){
                this.isNew = !0, this.isNewLabel = !0, this.axis = t, this.pos = e, this.type = i || "", this.parameters = o || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, P(this, "init"), i || s || this.addLabel();
            }
            addLabel() {
                let t, e, i, s = this, o = s.axis, r = o.options, a = o.chart, n = o.categories, h = o.logarithmic, l = o.names, d = s.pos, c = s.options?.labels ?? r.labels, p = o.tickPositions, g = d === p[0], u = d === p[p.length - 1], f = p.info, x = f?.boundaryTicks[d], y = r.dateTimeLabelFormats, b = this.parameters.category || (n ? n[d] ?? l[d] ?? d : d);
                if (h && N(b) && (b = m(h.lin2log(b))), o.dateTime && y) {
                    if (f) {
                        let i = f.unitName, s = {
                            millisecond: "hour",
                            second: "hour",
                            minute: "hour",
                            hour: "day",
                            day: "month",
                            week: "month",
                            month: "year",
                            year: "year"
                        }[i], o = !r.grid?.enabled && x && s && y[s]?.boundary || y[i];
                        t = (e = a.time.resolveDTLFormat(o)).main;
                    } else N(b) && (t = o.dateTime.getXDateFormat(b, y || {}));
                }
                s.isFirst = g, s.isLast = u, s.boundary = x;
                let v = {
                    axis: o,
                    chart: a,
                    dateTimeLabelFormat: t,
                    boundary: x,
                    isFirst: g,
                    isLast: u,
                    pos: d,
                    tick: s,
                    tickPositionInfo: f,
                    value: b
                };
                P(this, "labelFormat", v);
                let k = (t)=>c.formatter ? c.formatter.call(t, t) : c.format ? (t.text = o.defaultLabelFormatter.call(t), tF.format(c.format, t, a)) : o.defaultLabelFormatter.call(t);
                s.label = s.createLabel(k.call(v, v), c);
                let w = e?.list, M = s.label;
                w && M ? s.shortenLabel = function() {
                    for(i = 0; i < w.length; i++)if (S(v, {
                        dateTimeLabelFormat: w[i]
                    }), M.attr({
                        text: k.call(v, v)
                    }), M.getBBox().width < o.getSlotWidth(s) - 2 * (c.padding || 0)) return;
                    M.attr({
                        text: ""
                    });
                } : s.shortenLabel = void 0;
            }
            createLabel(t, e, i) {
                let s = this.axis, { renderer: o, styledMode: r } = s.chart, a = e.style, n = a.whiteSpace, h = this.label;
                return v(t) && e.enabled ? h || (h = o.text(t, i?.x, i?.y, e.useHTML).add(s.labelGroup)) : h && (h = h.destroy(), this.isNewLabel = !0), h && (h.labelStyle !== a || t !== h.textStr) && (h.labelStyle = a, t !== h.textStr && (h.attr({
                    text: t
                }), delete h.textPxLength), r || h.css(F(a)), h.textPxLength ?? (h.textPxLength = h.getBBox().width), !r && n && h.css({
                    whiteSpace: n
                })), h;
            }
            destroy() {
                k(this, this.axis);
            }
            getPosition(t, e, i, s) {
                let o = this.axis, r = o.chart, a = s && r.oldChartHeight || r.chartHeight, n = {
                    x: t ? m(o.translate(e + i, void 0, void 0, s) + o.transB) : o.left + o.offset + (o.opposite ? (s && r.oldChartWidth || r.chartWidth) - o.right - o.left : 0),
                    y: t ? a - o.bottom + o.offset - (o.opposite ? o.height : 0) : m(a - o.translate(e + i, void 0, void 0, s) - o.transB)
                };
                return n.y = f(n.y, -1000000000, 1e9), P(this, "afterGetPosition", {
                    pos: n
                }), n;
            }
            getLabelPosition(t, e, i, s, o, r, a, n) {
                let h, l, d = this.axis, { labelAlign: c, side: p, staggerLines: g, transA: u } = d, f = d.linkedParent ? d.linkedParent.reversed : d.reversed, m = d.tickRotCorr || {
                    x: 0,
                    y: 0
                }, x = s || d.reserveSpaceDefault ? 0 : -(d.labelOffset || 0) * ("center" === d.labelAlign ? .5 : 1), y = o.distance ?? ((1 !== p || "right" !== c || o.reserveSpace) && (3 !== p || "left" !== c || o.reserveSpace) ? 15 : 0), b = {};
                return h = 0 === p ? i.rotation ? -y : -i.getBBox().height : 2 === p ? m.y + y : Math.cos(i.rotation * ev) * (m.y - i.getBBox(!1, 0).height / 2), v(o.y) && (h = 0 === p && d.horiz ? o.y + h : o.y), t = t + (o.x ?? [
                    0,
                    1,
                    0,
                    -1
                ][p] * y) + x + m.x - (r && s ? r * u * (f ? -1 : 1) : 0), e = e + h - (r && !s ? r * u * (f ? 1 : -1) : 0), g && (l = a / (n || 1) % g, d.opposite && (l = g - l - 1), e += l * (d.labelOffset / g)), b.x = t, b.y = Math.round(e), P(this, "afterGetLabelPosition", {
                    pos: b,
                    tickmarkOffset: r,
                    index: a
                }), b;
            }
            getLabelSize() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            }
            getMarkPath(t, e, i, s, o = !1, r) {
                return r.crispLine([
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + (o ? 0 : -i),
                        e + (o ? i : 0)
                    ]
                ], s);
            }
            handleOverflow(t) {
                let { axis: e, label: i } = this, s = e.options.labels, o = t.x, { chartWidth: r, spacing: a } = e.chart, n = e.labelLeft ?? Math.min(e.pos, a[3]), h = e.labelRight ?? Math.max(e.isRadial ? 0 : e.pos + e.len, r - a[1]), l = i?.rotation || 0, d = A(e.labelAlign || i?.attr("align")), c = i?.getBBox().width || 0, p = e.getSlotWidth(this), g = p, u = 1, f;
                l || "justify" !== s.overflow ? l < 0 && o - d * c < n ? f = Math.round(o / Math.cos(l * ev) - n) : l > 0 && o + d * c > h && (f = Math.round((r - o) / Math.cos(l * ev))) : (o - d * c < n ? g = t.x + g * (1 - d) - n : o + (1 - d) * c > h && (g = h - t.x + g * d, u = -1), (g = Math.min(p, g)) < p && "center" === e.labelAlign && (t.x += u * (p - g - d * (p - Math.min(c, g)))), (c > g || e.autoRotation && i?.styles?.width) && (f = g)), f && i && (this.shortenLabel ? this.shortenLabel() : i.css({
                    width: Math.floor(f) + "px",
                    lineClamp: +!e.isRadial
                }));
            }
            render(t, e, i) {
                let s = this.axis, o = (e ? s.old?.horiz : void 0) ?? s.horiz, r = this.pos, a = this.tickmarkOffset ?? s.tickmarkOffset, n = this.getPosition(o, r, a, e), h = n.x, l = n.y, d = s.pos, c = d + s.len, p = o ? h : l;
                s.visible || (i = 0);
                let g = i ?? 1;
                !s.chart.polar && (m(p) < d || p > c) && (i = 0), i ?? (i = 1), this.isActive = !0, this.renderGridLine(e, i), this.renderMark(n, i), this.renderLabel(n, e, g, t), this.isNew = !1, P(this, "afterRender");
            }
            renderGridLine(t, e) {
                let i = this.axis, s = i.options, o = {}, r = this.pos, a = this.type, n = this.tickmarkOffset ?? i.tickmarkOffset, { renderer: h, styledMode: l } = i.chart, d = this.gridLine, c = s.gridLineWidth, p = s.gridLineColor, g = s.gridLineDashStyle;
                "minor" === this.type && (c = s.minorGridLineWidth, p = s.minorGridLineColor, g = s.minorGridLineDashStyle), l || (o["stroke-width"] = c || 0), d || (a || (o.zIndex = 1), this.gridLine = d = h.path().attr(o).addClass("highcharts-" + (a ? a + "-" : "") + "grid-line").add(i.gridGroup));
                let u = i.getPlotLinePath({
                    value: r + n,
                    lineWidth: d.strokeWidth(),
                    force: "pass",
                    old: t,
                    acrossPanes: !1
                });
                u && (o.d = u, o.opacity = t ? 0 : e, l || (o.stroke = p, o.dashstyle = g), d[t || this.isNew ? "attr" : "animate"](o));
            }
            renderMark(t, e) {
                let i = this.axis, { chart: s, options: o } = i, r = s.renderer, a = this.type, n = i.tickSize(a ? a + "Tick" : "tick"), h = t.x, l = t.y, d = o["minor" !== a ? "tickWidth" : "minorTickWidth"] ?? (!a && i.isXAxis ? 1 : 0), c = o["minor" !== a ? "tickColor" : "minorTickColor"], p = this.mark, g = p ? "animate" : "attr";
                (n || p) && (i.opposite && n && (n[0] = -n[0]), p || (this.mark = p = r.path().addClass("highcharts-" + (a ? a + "-" : "") + "tick").add(i.axisGroup)), s.styledMode || p[g]({
                    stroke: c,
                    "stroke-width": d
                }), p[g]({
                    d: this.getMarkPath(h, l, n?.[0] || 0, p.strokeWidth(), i.horiz, r),
                    opacity: n ? e : 0
                }));
            }
            renderLabel(t, e, i, s) {
                let o = this.axis, r = o.horiz, a = o.options, n = this.label, h = a.labels, l = h.step, d = this.tickmarkOffset ?? o.tickmarkOffset, c = t.x, p = t.y, g = !0;
                n && N(c) && (n.xy = t = this.getLabelPosition(c, p, n, r, h, d, s, l), (!this.isFirst || this.isLast || a.showFirstLabel) && (!this.isLast || this.isFirst || a.showLastLabel) ? r && !e && 0 !== i && this.handleOverflow(t) : g = !1, l && s % l && (g = !1), g && N(t.y) ? (t.opacity = i, n[this.isNewLabel ? "attr" : "animate"](t).show(!0), this.isNewLabel = !1) : (n.hide(), this.isNewLabel = !0));
            }
        }, { xAxis: ew, yAxis: eM } = ey, { parse: eC } = tv, { defaultOptions: eS } = tm, { registerEventOptions: eT } = eb, { deg2rad: eP } = n, eA = (t, e)=>Y(e, void 0, void 0, t.options.allowDecimals ?? (e < .5 || void 0 !== t.tickAmount), !!t.tickAmount);
        S(eS, {
            xAxis: ew,
            yAxis: F(ew, eM)
        });
        let eL = class {
            constructor(t, e, i){
                this.clippable = !0, this.init(t, e, i);
            }
            init(t, e, i = this.coll) {
                let s = "xAxis" === i, o = this.isZAxis || (t.inverted ? !s : s);
                this.chart = t, this.horiz = o, this.isXAxis = s, this.coll = i, P(this, "init", {
                    userOptions: e
                }), this.opposite = e.opposite ?? this.opposite, this.side = e.side ?? (o ? 2 * !this.opposite : this.opposite ? 1 : 3), this.setOptions(e);
                let r = this.options, a = r.labels;
                this.type = r.type || "linear", this.uniqueNames = r.uniqueNames ?? !0, P(this, "afterSetType"), this.userOptions = e, this.minPixelPadding = 0, this.reversed = r.reversed, this.visible = r.visible, this.zoomEnabled = r.zoomEnabled, this.hasNames = "category" === this.type || !0 === r.categories, this.categories = H(r.categories) && r.categories || (this.hasNames ? [] : void 0), this.names || (this.names = []), this.namesMap || (this.namesMap = {}), this.plotLinesAndBandsGroups || (this.plotLinesAndBandsGroups = {}), this.positiveValuesOnly = !!this.logarithmic, this.ticks || (this.ticks = {}), this.labelEdge || (this.labelEdge = []), this.minorTicks || (this.minorTicks = {}), this.alternateBands || (this.alternateBands = {}), this.len ?? (this.len = 0), this.minRange = this.userMinRange = r.minRange || r.maxZoom, this.range = r.range, this.max = void 0, this.min = void 0;
                let n = r.crosshair ?? J(t.options.tooltip?.crosshairs)[+!s];
                this.crosshair = !0 === n ? {} : n, -1 === t.axes.indexOf(this) && (s ? t.axes.splice(t.xAxis.length, 0, this) : t.axes.push(this), tr(this, t[this.coll])), t.orderItems(this.coll), this.series = this.series || [], t.inverted && !this.isZAxis && s && !v(this.reversed) && (this.reversed = !0), this.labelRotation = N(a.rotation) ? a.rotation : void 0, eT(this, r), P(this, "afterInit");
            }
            setOptions(t) {
                let e = this.horiz ? {
                    labels: {
                        autoRotation: [
                            -45
                        ],
                        padding: 3
                    },
                    margin: 15
                } : {
                    labels: {
                        padding: 1
                    },
                    title: {
                        rotation: 1 === this.side ? 90 : -90
                    }
                };
                this.options = F(e, "yAxis" === this.coll ? {
                    title: {
                        text: this.chart.options.lang.yAxisTitle
                    }
                } : {}, eS[this.coll], t), P(this, "afterSetOptions", {
                    userOptions: t
                });
            }
            defaultLabelFormatter() {
                let t = this.axis, e = this.chart, { numberFormatter: i } = e, s = N(this.value) ? this.value : 0 / 0, o = t.chart.time, r = t.categories, a = this.dateTimeLabelFormat, n = eS.lang, h = n.numericSymbols, l = n.numericSymbolMagnitude || 1e3, d = t.logarithmic ? Math.abs(s) : t.tickInterval, c = h?.length, p, g;
                if (r) g = `${this.value}`;
                else if (a) g = o.dateFormat(a, s, !0);
                else if (c && h && d >= 1e3) for(; c-- && void 0 === g;)d >= (p = Math.pow(l, c + 1)) && 10 * s % p == 0 && null !== h[c] && 0 !== s && (g = i(s / p, -1, void 0, void 0, e) + h[c]);
                return g ?? (g = i(s, -1, void 0, 1e4 > Math.abs(s) ? "" : void 0, e)), g;
            }
            getSeriesExtremes() {
                let t, e = this;
                P(this, "getSeriesExtremes", null, function() {
                    e.hasVisibleSeries = !1, e.dataMin = e.dataMax = e.threshold = void 0, e.softThreshold = !e.isXAxis, e.series.forEach((i)=>{
                        if (i.reserveSpace()) {
                            let s = i.options, o, r = s.threshold, a, n;
                            if (e.hasVisibleSeries = !0, e.positiveValuesOnly && 0 >= (r || 0) && (r = void 0), e.isXAxis) (o = i.getColumn("x")).length && (o = e.logarithmic ? o.filter((t)=>t > 0) : o, a = (t = i.getXExtremes(o)).min, n = t.max, N(a) || a instanceof Date || (o = o.filter(N), a = (t = i.getXExtremes(o)).min, n = t.max), o.length && (e.dataMin = Math.min(e.dataMin ?? a, a), e.dataMax = Math.max(e.dataMax ?? n, n)));
                            else {
                                let t = i.applyExtremes();
                                N(t.dataMin) && (a = t.dataMin, e.dataMin = Math.min(e.dataMin ?? a, a)), N(t.dataMax) && (n = t.dataMax, e.dataMax = Math.max(e.dataMax ?? n, n)), v(r) && (e.threshold = r), (!s.softThreshold || e.positiveValuesOnly) && (e.softThreshold = !1);
                            }
                        }
                    });
                }), P(this, "afterGetSeriesExtremes");
            }
            translate(t, e, i, s, o, r) {
                let a = this.linkedParent || this, n = s && a.old ? a.old.min : a.min;
                if (!N(n)) return 0 / 0;
                let h = a.minPixelPadding, l = (a.isOrdinal || a.brokenAxis?.hasBreaks || a.logarithmic && o) && !!a.lin2val, d = 1, c = 0, p = s && a.old ? a.old.transA : a.transA, g = 0;
                return p || (p = a.transA), i && (d *= -1, c = a.len), a.reversed && (d *= -1, c -= d * (a.sector || a.len)), e ? (g = (t = t * d + c - h) / p + n, l && (g = a.lin2val(g))) : (l && (t = a.val2lin(t)), g = d * (t - n) * p + c + d * h + (N(r) ? p * r : 0), a.isRadial || (g = m(g)), 1e-9 > Math.abs(g) && (g = 0)), g;
            }
            toPixels(t, e) {
                return this.translate(this.chart?.time.parse(t) ?? 0 / 0, !1, !this.horiz, void 0, !0) + (e ? 0 : this.pos);
            }
            toValue(t, e) {
                return this.translate(t - (e ? 0 : this.pos), !0, !this.horiz, void 0, !0);
            }
            getPlotLinePath(t) {
                let e = this, { chart: i, left: s, top: o, transB: r } = e, { lineWidth: a, old: n, value: h } = t, l = (n ? e.old?.horiz : void 0) ?? e.horiz, d = n && i.oldChartHeight || i.chartHeight, c = n && i.oldChartWidth || i.chartWidth, p = t.translatedValue, g = t.force, u, m, x, y, b;
                function v(t, e, i) {
                    return "pass" !== g && (t < e || t > i) && (g ? t = f(t, e, i) : b = !0), t;
                }
                let k = {
                    value: h,
                    lineWidth: a,
                    old: n,
                    force: g,
                    acrossPanes: t.acrossPanes,
                    translatedValue: p
                };
                return P(this, "getPlotLinePath", k, function(t) {
                    u = x = (p = f(p = p ?? e.translate(h, void 0, void 0, n), -1000000000, 1e9)) + r, m = y = d - p - r, N(p) ? l ? (m = o, y = d - e.bottom + (e.options.isInternal ? 0 : i.scrollablePixelsY || 0), u = x = v(u, s, s + e.width)) : (u = s, x = c - e.right + (i.scrollablePixelsX || 0), m = y = v(m, o, o + e.height)) : (b = !0, g = !1), t.path = b && !g ? void 0 : i.renderer.crispLine([
                        [
                            "M",
                            u,
                            m
                        ],
                        [
                            "L",
                            x,
                            y
                        ]
                    ], a || 1);
                }), k.path;
            }
            getLinearTickPositions(t, e, i) {
                let s, o, r, a = m(Math.floor(e / t) * t), n = m(Math.ceil(i / t) * t), h = [];
                if (m(a + t) === a && (r = 20), this.single) return [
                    e
                ];
                for(s = a; s <= n && (h.push(s), (s = m(s + t, r)) !== o);)o = s;
                return h;
            }
            getMinorTickInterval() {
                let { minorTicks: t, minorTickInterval: e } = this.options;
                return !0 === t ? e ?? "auto" : !1 !== t ? e : void 0;
            }
            getMinorTickPositions() {
                let t = this.options, e = this.tickPositions, i = this.minorTickInterval, s = this.pointRangePadding || 0, o = (this.min || 0) - s, r = (this.max || 0) + s, a = this.brokenAxis?.hasBreaks ? this.brokenAxis.unitLength : r - o, n = [], h;
                if (a && a / i < this.len / 3) {
                    let s = this.logarithmic;
                    if (s) this.paddedTicks.forEach(function(t, e, o) {
                        e && n.push.apply(n, s.getLogTickPositions(i, o[e - 1], o[e], !0));
                    });
                    else if (this.dateTime && "auto" === this.getMinorTickInterval()) n = n.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(i), o, r, t.startOfWeek));
                    else for(h = o + (e[0] - o) % i; h <= r && h !== n[0]; h += i)n.push(h);
                }
                return 0 !== n.length && this.trimTicks(n), n;
            }
            adjustForMinRange() {
                let t = this.options, e = this.logarithmic, i = this.chart.time, { max: s, min: o, minRange: r } = this, a, n, h, l;
                this.isXAxis && void 0 === r && !e && (r = v(t.min) || v(t.max) || v(t.floor) || v(t.ceiling) ? null : Math.min(5 * (L(this.series.map((t)=>{
                    let e = t.getColumn("x");
                    return t.xIncrement ? e.slice(0, 2) : e;
                })) || 0), this.dataMax - this.dataMin)), N(s) && N(o) && N(r) && s - o < r && (n = this.dataMax - this.dataMin >= r, a = (r - s + o) / 2, h = [
                    o - a,
                    i.parse(t.min) ?? o - a
                ], n && (h[2] = e ? e.log2lin(this.dataMin) : this.dataMin), l = [
                    (o = g(h)) + r,
                    i.parse(t.max) ?? o + r
                ], n && (l[2] = e ? e.log2lin(this.dataMax) : this.dataMax), (s = p(l)) - o < r && (h[0] = s - r, h[1] = i.parse(t.min) ?? s - r, o = g(h))), this.minRange = r, this.min = o, this.max = s;
            }
            getClosest() {
                let t, e;
                if (this.categories) e = 1;
                else {
                    let i = [];
                    this.series.forEach(function(t) {
                        let s = t.closestPointRange, o = t.getColumn("x");
                        1 === o.length ? i.push(o[0]) : t.sorted && v(s) && t.reserveSpace() && (e = v(e) ? Math.min(e, s) : s);
                    }), i.length && (i.sort((t, e)=>t - e), t = L([
                        i
                    ]));
                }
                return t && e ? Math.min(t, e) : t || e;
            }
            nameToX(t, e) {
                let i, s = H(this.options.categories), { name: o, series: r } = t, a = s ? this.categories : this.names, n = this.namesMap;
                return r.requireSorting = !1, v(e) || (e = this.uniqueNames && a ? s ? a.indexOf(o) : n[o] ?? -1 : r.autoIncrement()), -1 === e ? !s && a && (i = a.length) : N(e) && (i = e), void 0 !== i ? (this.names[i] = t.name, n[t.name] = i) : i = N(t.x) ? t.x : r.autoIncrement(), i;
            }
            updateNames() {
                let t = this, { names: e, namesMap: i } = this;
                e.length > 0 && (Object.keys(i).forEach(function(t) {
                    delete i[t];
                }), e.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((e)=>{
                    if (e.xIncrement = null, delete e.xColumn, !e.points || e.isDirtyData) t.max = Math.max(t.max || 0, e.dataTable.rowCount - 1), e.processData(), e.generatePoints();
                    else {
                        let t = e.getColumn("x");
                        e.points?.forEach((e)=>{
                            e.x = t[e.index];
                        });
                    }
                }));
            }
            setAxisTranslation() {
                let t = this, e = t.max - t.min, i = t.linkedParent, s = !!t.categories, o = t.isXAxis, r = t.axisPointRange || 0, a, n = 0, h = 0, l, d = t.transA;
                (o || s || r) && (a = t.getClosest(), i ? (n = i.minPointOffset, h = i.pointRangePadding) : t.series.forEach(function(e) {
                    let i = s ? 1 : o ? e.options.pointRange ?? a ?? 0 : t.axisPointRange || 0, l = e.options.pointPlacement;
                    if (r = Math.max(r, i), !t.single || s) {
                        let t = e.is("xrange") ? !o : o;
                        n = Math.max(n, t && W(l) ? 0 : i / 2), h = Math.max(h, t && "on" === l ? 0 : i);
                    }
                }), l = t.ordinal?.slope && a ? t.ordinal.slope / a : 1, t.minPointOffset = n *= l, t.pointRangePadding = h *= l, t.pointRange = Math.min(r, t.single && s ? 1 : e), o && (t.closestPointRange = a)), t.translationSlope = t.transA = d = t.staticScale || t.len / (e + h || 1), t.transB = t.horiz ? t.left : t.bottom, t.minPixelPadding = d * n, P(this, "afterSetAxisTranslation");
            }
            minFromRange() {
                let { max: t, min: e } = this;
                return N(t) && N(e) && t - e || void 0;
            }
            setTickInterval(t) {
                let { categories: e, chart: i, dataMax: s, dataMin: o, dateTime: r, isXAxis: a, logarithmic: n, options: h, softThreshold: l } = this, d = i.time, c = N(this.threshold) ? this.threshold : void 0, p = this.minRange || 0, { ceiling: g, floor: u, softMax: f, softMin: x } = h, y = this.linkedParent, b = h.tickPixelInterval, k = h.maxPadding, w = h.minPadding, M = 0, C, S = N(h.tickInterval) && h.tickInterval >= 0 ? h.tickInterval : void 0, T, A, L, O;
                if (r || e || y || this.getTickAmount(), L = this.userMin ?? d.parse(h.min), O = this.userMax ?? d.parse(h.max), y ? (C = y.getExtremes(), this.min = C.min ?? C.dataMin, this.max = C.max ?? C.dataMax, this.type !== y.type && to(11, !0, i)) : (l && v(c) && N(s) && N(o) && (o >= c ? (T = c, w = 0) : s <= c && (A = c, k = 0)), this.min = L ?? T ?? o, this.max = O ?? A ?? s), N(this.max) && N(this.min) && (n && (this.positiveValuesOnly && !t && 0 >= Math.min(this.min, o ?? this.min) && to(10, !0, i), this.min = m(n.log2lin(this.min), 16), this.max = m(n.log2lin(this.max), 16)), this.range && N(o) && (this.userMin = this.min = L = Math.max(o, this.minFromRange() || 0), this.userMax = O = this.max, this.range = void 0)), P(this, "foundExtremes"), this.adjustForMinRange(), N(this.min) && N(this.max)) {
                    if (!N(this.userMin) && N(x) && x < this.min && (this.min = L = x), !N(this.userMax) && N(f) && f > this.max && (this.max = O = f), e || this.axisPointRange || this.stacking?.usePercentage || y || (M = this.max - this.min) && (!v(L) && w && (this.min -= M * w), !v(O) && k && (this.max += M * k)), !N(this.userMin) && N(u) && (this.min = Math.max(this.min, u)), !N(this.userMax) && N(g) && (this.max = Math.min(this.max, g)), l && N(o) && N(s)) {
                        let t = c || 0;
                        !v(L) && this.min < t && o >= t ? this.min = h.minRange ? Math.min(t, this.max - p) : t : !v(O) && this.max > t && s <= t && (this.max = h.minRange ? Math.max(t, this.min + p) : t);
                    }
                    !i.polar && this.min > this.max && (v(h.min) ? this.max = this.min : v(h.max) && (this.min = this.max)), M = this.max - this.min;
                }
                if (this.min !== this.max && N(this.min) && N(this.max) ? y && !S && b === y.options.tickPixelInterval ? this.tickInterval = S = y.tickInterval : this.tickInterval = S ?? (this.tickAmount ? M / Math.max(this.tickAmount - 1, 1) : e ? 1 : M * b / Math.max(this.len, b)) : this.tickInterval = 1, a && !t) {
                    let t = this.min !== this.old?.min || this.max !== this.old?.max;
                    this.series.forEach(function(e) {
                        e.forceCrop = e.forceCropping?.(), e.processData(t);
                    }), P(this, "postProcessData", {
                        hasExtremesChanged: t
                    });
                }
                this.setAxisTranslation(), P(this, "initialAxisTranslation"), this.pointRange && !S && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                let E = h.minTickInterval ?? (r && !this.series.some((t)=>!t.sorted) ? this.closestPointRange : 0);
                !S && E && this.tickInterval < E && (this.tickInterval = E), r || n || S || (this.tickInterval = eA(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
            }
            setTickPositions() {
                let t = this.options, e = t.tickPositions, i = t.tickPositioner, s = this.getMinorTickInterval(), o = !this.isPanning, r = o && t.startOnTick, a = o && t.endOnTick, n = [], h;
                if (this.tickmarkOffset = this.categories && "between" === t.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0, this.single = this.min === this.max && v(this.min) && !this.tickAmount && (this.min % 1 == 0 || !1 !== t.allowDecimals), e) n = e.slice();
                else if (N(this.min) && N(this.max)) {
                    if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) n = [
                        this.min,
                        this.max
                    ], to(19, !1, this.chart);
                    else if (this.dateTime) n = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, t.units), this.min, this.max, t.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
                    else if (this.logarithmic) n = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                    else {
                        let t = this.tickInterval, e = t;
                        for(; e <= 2 * t;)if (n = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && n.length > this.tickAmount) this.tickInterval = eA(this, e *= 1.1);
                        else break;
                    }
                    n.length > this.len && (n = [
                        n[0],
                        n[n.length - 1]
                    ])[0] === n[1] && (n.length = 1), i && (this.tickPositions = n, (h = i.apply(this, [
                        this.min,
                        this.max,
                        this
                    ])) && (n = h));
                }
                this.isDirty || n.length === this.tickPositions?.length || (this.isDirty = !0), this.tickPositions = n, this.minorTickInterval = "auto" === s && this.tickInterval ? this.tickInterval / t.minorTicksPerMajor : s, this.paddedTicks = n.slice(0), this.trimTicks(n, r, a), !this.linkedParent && N(this.min) && N(this.max) && (this.single && n.length < 2 && !this.categories && !this.series.some((t)=>t.is("heatmap") && "between" === t.options.pointPlacement) && (this.min -= .5, this.max += .5), e || h || this.adjustTickAmount()), P(this, "afterSetTickPositions");
            }
            trimTicks(t, e, i) {
                let s = t[0], o = t[t.length - 1], r = !this.isOrdinal && this.minPointOffset || 0;
                if (P(this, "trimTicks"), !this.linkedParent || !this.grid) {
                    if (e && N(s)) this.min = s;
                    else if (t.length) for(; this.min - r > t[0];)t.shift();
                    if (i && N(o)) this.max = o;
                    else for(; this.max + r < t[t.length - 1];)t.pop();
                    0 === t.length && v(s) && !this.options.tickPositions && t.push((o + s) / 2);
                }
            }
            alignToOthers() {
                let t, e = this, i = e.chart, s = [
                    this
                ], o = e.options, r = i.options.chart, a = "yAxis" === this.coll && r.alignThresholds, n = [];
                if (e.thresholdAlignment = void 0, (!1 !== r.alignTicks && o.alignTicks || a) && !1 !== o.startOnTick && !1 !== o.endOnTick && !e.logarithmic) {
                    let o = (t)=>{
                        let { horiz: e, options: i } = t;
                        return [
                            e ? i.left : i.top,
                            i.width,
                            i.height,
                            i.pane
                        ].join(",");
                    }, r = o(this);
                    i[this.coll].forEach(function(i) {
                        let { series: a } = i;
                        a.length && a.some((t)=>t.visible) && i !== e && o(i) === r && (t = !0, s.push(i));
                    });
                }
                if (t && a) {
                    s.forEach((t)=>{
                        let i = t.getThresholdAlignment(e);
                        N(i) && n.push(i);
                    });
                    let t = n.length > 1 ? n.reduce((t, e)=>t += e, 0) / n.length : void 0;
                    s.forEach((e)=>{
                        e.thresholdAlignment = t;
                    });
                }
                return t;
            }
            getThresholdAlignment(t) {
                if ((!N(this.dataMin) || this !== t && this.series.some((t)=>t.isDirty || t.isDirtyData || t.xAxis?.isDirty)) && this.getSeriesExtremes(), N(this.threshold)) {
                    let t = f((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
                    return this.options.reversed && (t = 1 - t), t;
                }
            }
            getTickAmount() {
                let t = this.options, e = t.tickPixelInterval, i = t.tickAmount;
                v(t.tickInterval) || i || !(this.len < e) || this.isRadial || this.logarithmic || !t.startOnTick || !t.endOnTick || (i = 2), !i && this.alignToOthers() && (i = Math.ceil(this.len / e) + 1), i < 4 && (this.finalTickAmt = i, i = 5), this.tickAmount = i;
            }
            adjustTickAmount() {
                let t = this, { finalTickAmt: e, max: i, min: s, options: o, tickPositions: r, tickAmount: a, thresholdAlignment: n } = t, h = r?.length, l = t.threshold ?? (t.softThreshold ? 0 : null), d, c, p = t.tickInterval, g, u = ()=>r.push(m(r[r.length - 1] + p)), x = ()=>r.unshift(m(r[0] - p));
                if (N(n) && (g = 0 === n ? 0 : 1 === n ? a - 1 : Math.round(f(n * (a - 1), 1, a - 2)), o.reversed && (g = a - 1 - g)), t.hasData() && N(s) && N(i)) {
                    let n = ()=>{
                        t.transA *= (h - 1) / (a - 1), t.min = o.startOnTick ? r[0] : Math.min(s, r[0]), t.max = o.endOnTick ? r[r.length - 1] : Math.max(i, r[r.length - 1]);
                    };
                    if (N(g) && N(t.threshold)) {
                        for(; r[g] !== l || r.length !== a || r[0] > s || r[r.length - 1] < i;){
                            for(r.length = 0, r.push(t.threshold); r.length < a;)void 0 === r[g] || r[g] > t.threshold ? x() : u();
                            if (p > 8 * t.tickInterval) break;
                            p *= 2;
                        }
                        n();
                    } else if (h < a) {
                        for(; r.length < a;)r.length % 2 || s === l ? u() : x();
                        n();
                    }
                    if (v(e)) {
                        for(c = d = r.length; c--;)(3 === e && c % 2 == 1 || e <= 2 && c > 0 && c < d - 1) && r.splice(c, 1);
                        t.finalTickAmt = void 0;
                    }
                }
            }
            setScale() {
                let { chart: t, coll: e, options: i, stacking: s } = this, { linkedTo: o } = i, r = t[e] || [], a = r.indexOf(this), n = W(o) ? D(r, (t)=>t.options.id === o) : N(o) ? r[o] : void 0, h = this.linkedParent = n === this ? void 0 : n;
                h && a > -1 && r.indexOf(h) > a && h.setScale();
                let l = !1, d = !1;
                this.series.forEach((t)=>{
                    l = l || t.isDirtyData || t.isDirty, d = d || t.xAxis?.isDirty || !1;
                }), this.setAxisSize();
                let c = this.len !== this.old?.len;
                c || l || d || this.linkedParent || this.forceRedraw || this.userMin !== this.old?.userMin || this.userMax !== this.old?.userMax || this.alignToOthers() ? (s && "yAxis" === e && s.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), s && "xAxis" === e && s.buildStacks(), this.isDirty || (this.isDirty = c || this.min !== this.old?.min || this.max !== this.old?.max)) : s && s.cleanStacks(), l && delete this.allExtremes, P(this, "afterSetScale");
            }
            setExtremes(t, e, i = !0, s, o) {
                let r = this.chart;
                this.series.forEach((t)=>{
                    delete t.kdTree;
                }), t = r.time.parse(t), e = r.time.parse(e), P(this, "setExtremes", o = S(o, {
                    min: t,
                    max: e
                }), (t)=>{
                    this.userMin = t.min, this.userMax = t.max, this.eventArgs = t, i && r.redraw(s);
                });
            }
            setAxisSize() {
                let t = this.chart, e = this.options, i = e.offsets || [
                    0,
                    0,
                    0,
                    0
                ], s = this.horiz, o = this.width = Math.round(Z(e.width ?? t.plotWidth - i[3] + i[1], t.plotWidth)), r = this.height = Math.round(Z(e.height ?? t.plotHeight - i[0] + i[2], t.plotHeight)), a = this.top = Math.round(Z(e.top ?? t.plotTop + i[0], t.plotHeight, t.plotTop)), n = this.left = Math.round(Z(e.left ?? t.plotLeft + i[3], t.plotWidth, t.plotLeft));
                this.bottom = t.chartHeight - r - a, this.right = t.chartWidth - o - n, this.len = Math.max(s ? o : r, 0), this.pos = s ? n : a;
            }
            getExtremes() {
                let t = this.logarithmic;
                return {
                    min: t ? m(t.lin2log(this.min)) : this.min,
                    max: t ? m(t.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            }
            getThreshold(t) {
                let e = this.logarithmic, i = e ? e.lin2log(this.min) : this.min, s = e ? e.lin2log(this.max) : this.max;
                return null === t || -1 / 0 === t ? t = i : 1 / 0 === t ? t = s : i > t ? t = i : s < t && (t = s), this.translate(t, 0, 1, 0, 1);
            }
            autoLabelAlign(t) {
                let e = ((t - 90 * this.side) % 360 + 360) % 360, i = {
                    align: "center"
                };
                return P(this, "autoLabelAlign", i, function(t) {
                    e > 15 && e < 165 ? t.align = "right" : e > 195 && e < 345 && (t.align = "left");
                }), i.align;
            }
            tickSize(t) {
                let e = this.options, i = e["tick" === t ? "tickWidth" : "minorTickWidth"] ?? ("tick" === t && this.isXAxis && !this.categories ? 1 : 0), s = e["tick" === t ? "tickLength" : "minorTickLength"], o;
                i && s && ("inside" === e[t + "Position"] && (s = -s), o = [
                    s,
                    i
                ]);
                let r = {
                    tickSize: o,
                    prefix: t
                };
                return P(this, "afterTickSize", r), r.tickSize;
            }
            labelMetrics() {
                let t = this.chart.renderer, e = this.ticks, i = e[Object.keys(e)[0]] || {};
                return this.chart.renderer.fontMetrics(i.label || t.box);
            }
            unsquish() {
                let t = this.options.labels, e = t.padding || 0, i = this.horiz, s = this.tickInterval, o = this.len / ((+!!this.categories + this.max - this.min) / s), r = t.rotation, a = m(.8 * this.labelMetrics().h), n = Math.max(this.max - this.min, 0), h = function(t) {
                    let i = (t + 2 * e) / (o || 1);
                    return (i = i > 1 ? Math.ceil(i) : 1) * s > n && 1 / 0 !== t && 1 / 0 !== o && n && (i = Math.ceil(n / s)), m(i * s);
                }, l = s, d, c = Number.MAX_VALUE, p;
                if (i) {
                    if (!t.staggerLines && (N(r) ? p = [
                        r
                    ] : o < t.autoRotationLimit && (p = t.autoRotation)), p) {
                        let t, e;
                        for (let i of p)(i === r || i && i >= -90 && i <= 90) && (e = (t = h(Math.abs(a / Math.sin(eP * i)))) + Math.abs(i / 360)) < c && (c = e, d = i, l = t);
                    }
                } else l = h(.75 * a);
                return this.autoRotation = p, this.labelRotation = d ?? (N(r) ? r : 0), t.step ? s : l;
            }
            getSlotWidth(t) {
                let e = this.chart, i = this.horiz, s = this.options.labels, o = Math.max(this.tickPositions.length - !this.categories, 1), r = e.margin[3];
                if (t && N(t.slotWidth)) return t.slotWidth;
                if (i && s.step < 2 && !this.isRadial) return s.rotation ? 0 : (this.staggerLines || 1) * this.len / o;
                if (!i) {
                    let t = s.style.width;
                    if (void 0 !== t) return parseInt(String(t), 10);
                    if (!this.opposite && r) return r - e.spacing[3];
                }
                return .33 * e.chartWidth;
            }
            renderUnsquish() {
                let t = this.chart, e = t.renderer, i = this.tickPositions, s = this.ticks, o = this.options.labels, r = o.style, a = this.horiz, n = this.getSlotWidth(), h = Math.max(1, Math.round(n - (a ? 2 * (o.padding || 0) : o.distance ?? 15))), l = {}, d = this.labelMetrics(), c = r.lineClamp, p, g = c ?? (Math.floor(this.len / (i.length * d.h)) || 1), u = 0;
                W(o.rotation) || (l.rotation = o.rotation || 0), i.forEach(function(t) {
                    u = Math.max(u, s[t].label?.textPxLength || 0);
                }), this.maxLabelLength = u, this.autoRotation ? u > h && u > d.h ? l.rotation = this.labelRotation : this.labelRotation = 0 : n && (p = h), l.rotation && (p = u > .5 * t.chartHeight ? .33 * t.chartHeight : u, c || (g = 1)), this.labelAlign = o.align || this.autoLabelAlign(this.labelRotation || 0), this.labelAlign && (l.align = this.labelAlign), i.forEach(function(t) {
                    let e = s[t], i = e?.label, o = r.width, a = {};
                    i && (i.attr(l), e.shortenLabel ? e.shortenLabel() : p && !o && "nowrap" !== r.whiteSpace && (p < (i.textPxLength || 0) || "DIV" === i.element.tagName) ? i.css(S(a, {
                        width: `${p}px`,
                        lineClamp: g
                    })) : (i.styles.width || i.textWidth || i.styles.lineClamp) && !a.width && !o && i.css({
                        width: "auto",
                        lineClamp: 0
                    }));
                }, this), this.tickRotCorr = e.rotCorr(d.b, this.labelRotation || 0, 0 !== this.side);
            }
            hasData() {
                return this.series.some(function(t) {
                    return t.hasData();
                }) || this.options.showEmpty && v(this.min) && v(this.max);
            }
            addTitle(t) {
                let e = this.chart.renderer, i = this.horiz, s = this.opposite, o = this.options.title, r = this.chart.styledMode, a = o.textAlign || (i ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: s ? "right" : "left",
                    middle: "center",
                    high: s ? "left" : "right"
                })[o.align], n = {
                    text: o.text || "",
                    zIndex: 7,
                    align: a
                }, h = {
                    rotation: o.rotation || 0
                }, l = this.axisTitle;
                if (l ? l.attr(n).animate(h) : ((l = e.text("", 0, 0, o.useHTML).attr(S(n, h)).addClass("highcharts-axis-title")).add(this.axisGroup), l.isNew = !0), !r) {
                    let t = F(o.style);
                    o.style.width || this.isRadial || (t.width = this.len + "px"), l.css(t);
                }
                l[t ? "show" : "hide"](t), this.axisTitle = l;
            }
            generateTick(t) {
                let e = this.ticks;
                e[t] ? e[t].addLabel() : e[t] = new ek(this, t);
            }
            createGroups() {
                let { axisParent: t, chart: e, coll: i, options: s } = this, o = e.renderer, r = (e, r)=>o.g(e).addClass(`highcharts-${i.toLowerCase()}${r} ` + (this.isRadial ? `highcharts-radial-axis${r} ` : "") + (s.className || "")).add(t);
                (this.axisGroup || (this.axisGroup = r("axis", ""))).attr({
                    zIndex: s.zIndex
                }), (this.gridGroup || (this.gridGroup = r("grid", "-grid"))).clip(this.clippable ? e.plotClipInner : void 0).attr({
                    zIndex: s.gridZIndex
                }), (this.labelGroup || (this.labelGroup = r("axis-labels", "-labels"))).attr({
                    zIndex: s.labels.zIndex
                });
            }
            shuffleTicks() {
                let t = this.ticks, e = this.old?.names, i = (t)=>new Set(t).size !== t.length;
                if ("category" === this.type && e && !i(e) && !i(this.names)) {
                    e.forEach((i, s)=>{
                        let o = this.namesMap[i];
                        v(o) && s !== o && (t[s] && (t[s].pos = o, this.isDirty = !0), t[o] && -1 === this.names.indexOf(e[o]) && (t[o].pos = 0 / 0));
                    });
                    let i = Object.values(t);
                    Object.keys(t).forEach((e)=>{
                        delete t[e];
                    }), i.forEach((e)=>{
                        isNaN(e.pos) ? e.destroy() : t[e.pos] = e;
                    });
                }
            }
            getOffset() {
                let { chart: t, horiz: e, options: i, side: s, ticks: o, tickPositions: r, coll: a } = this, n = this.hasData(), h = i.title, l = i.labels, d = N(i.crossing), c = t.axisOffset, p = t.clipOffset, g = [
                    -1,
                    1,
                    1,
                    -1
                ][s], u = l.distance ?? 15, f = this.tickRotCorr || {
                    x: 0,
                    y: 0
                }, m = 0, x, y = 0, b, k = 0, w = 0, M, C, S;
                if (this.showAxis = x = n || i.showEmpty, this.staggerLines = this.horiz && l.staggerLines || void 0, this.createGroups(), n || this.linkedParent ? (this.shuffleTicks(), r.forEach(this.generateTick.bind(this)), this.renderUnsquish(), m = Math.abs((f = this.tickRotCorr).x), S = this.reserveSpaceDefault = 0 === s || 2 === s || ({
                    1: "left",
                    3: "right"
                })[s] === this.labelAlign, (l.reserveSpace ?? (!d && null) ?? ("center" === this.labelAlign || null) ?? S) && r.forEach(function(t) {
                    w = Math.max(o[t].getLabelSize(), w);
                }), this.staggerLines && (w *= this.staggerLines), !e && N(this.labelRotation) && S && (w -= m), this.labelOffset = w * (this.opposite ? -1 : 1)) : j(o, function(t, e) {
                    t.destroy(), delete o[e];
                }), h?.text && !1 !== h.enabled ? (this.addTitle(x), x && !d && !1 !== h.reserveSpace && (this.titleOffset = y = this.axisTitle.getBBox()[e ? "height" : "width"], k = v(b = h.offset) ? 0 : h.margin ?? (e ? 5 : 10))) : this.axisTitle = this.axisTitle?.destroy(), this.renderLine(), this.offset = g * (N(i.offset) ? i.offset : c[s] ? c[s] + (i.margin || 0) : 0), C = 0 === s ? -this.labelMetrics().h : 2 === s ? f.y : 0, M = Math.abs(w) + k, w && (M -= C, M += g * (e ? l.y ?? f.y + g * u : l.x ?? (S ? g * (u - m) : f.x + g * u)), !e && !S && "center" === this.labelAlign && N(this.labelRotation) && (M += m)), this.axisTitleMargin = b ?? M, this.maxLabelDimensions = this.getMaxLabelDimensions?.(o, r), "colorAxis" !== a && p) {
                    let t = this.tickSize("tick");
                    c[s] = Math.max(c[s], Math.max((this.axisTitleMargin || 0) + y, M) + g * this.offset, M, r?.length && t ? t[0] + g * this.offset : 0);
                    let e = !this.axisLine || i.offset ? 0 : this.axisLine.strokeWidth() / 2;
                    p[s] = Math.max(p[s], e);
                }
                P(this, "afterGetOffset");
            }
            getLinePath(t) {
                let e = this.chart, i = this.opposite, s = this.offset, o = this.horiz, r = this.left + (i ? this.width : 0) + s, a = e.chartHeight - this.bottom - (i ? this.height : 0) + s;
                return i && (t *= -1), e.renderer.crispLine([
                    [
                        "M",
                        o ? this.left : r,
                        o ? a : this.top
                    ],
                    [
                        "L",
                        o ? e.chartWidth - this.right : r,
                        o ? a : e.chartHeight - this.bottom
                    ]
                ], t);
            }
            renderLine() {
                let { chart: t, offset: e = 0, options: i } = this, s = this.axisLine ? "animate" : "attr";
                this.axisLine || (this.axisLine = t.renderer.path().addClass("highcharts-axis-line").attr({
                    zIndex: 7
                }).clip(this.clippable && e <= 0 ? t.plotClipOuter : void 0).add(this.axisGroup)), t.styledMode || this.axisLine[s]({
                    stroke: i.lineColor,
                    "stroke-width": i.lineWidth
                });
            }
            getTitlePosition(t) {
                let e = this.horiz, i = this.left, s = this.top, o = this.len, r = this.options.title, a = e ? i : s, n = this.opposite, h = this.offset, l = r.x, d = r.y, c = this.chart.renderer.fontMetrics(t), p = t ? Math.max(t.getBBox(!1, 0).height - c.h - 1, 0) : 0, g = {
                    low: a + (e ? 0 : o),
                    middle: a + o / 2,
                    high: a + (e ? o : 0)
                }[r.align], u = (e ? s + this.height : i) + (e ? 1 : -1) * (n ? -1 : 1) * (this.axisTitleMargin || 0) + [
                    -p,
                    p,
                    c.f,
                    -p
                ][this.side], f = {
                    x: e ? g + l : u + (n ? this.width : 0) + h + l,
                    y: e ? u + d - (n ? this.height : 0) + h : g + d
                };
                return P(this, "afterGetTitlePosition", {
                    titlePosition: f
                }), f;
            }
            renderMinorTick(t, e) {
                let i = this.minorTicks;
                i[t] || (i[t] = new ek(this, t, "minor")), e && i[t].isNew && i[t].render(null, !0), i[t].render(null, !1, 1);
            }
            renderTick(t, e, i) {
                let s = this.ticks;
                (!this.linkedParent || t >= this.min && t <= this.max || this.grid?.isColumn) && (s[t] || (s[t] = new ek(this, t)), i && s[t].isNew && s[t].render(e, !0, -1), s[t].render(e));
            }
            render() {
                let t, e, i = this, s = i.chart, o = i.logarithmic, r = s.renderer, a = i.options, h = i.tickPositions, l = i.axisTitle, d = i.ticks, c = i.minorTicks, p = i.alternateBands, g = a.alternateGridColor, u = a.crossing, f = i.tickmarkOffset, m = i.axisLine, x = i.showAxis, y = +i.visible, b = tS(r.globalAnimation);
                if (i.labelEdge.length = 0, i.overlap = !1, this.createGroups(), [
                    d,
                    c,
                    p
                ].forEach(function(t) {
                    j(t, function(t) {
                        t.isActive = !1;
                    });
                }), N(u)) {
                    let t = this.isXAxis ? s.yAxis[0] : s.xAxis[0], e = [
                        1,
                        -1,
                        -1,
                        1
                    ][this.side];
                    if (t) {
                        let s = t.toPixels(u, !0);
                        i.horiz && (s = t.len - s), i.offset = e * s;
                    }
                }
                if (i.hasData() || i.linkedParent) {
                    let r = i.chart.hasRendered && i.old && N(i.old.min);
                    i.minorTickInterval && !i.categories && i.getMinorTickPositions().forEach(function(t) {
                        i.renderMinorTick(t, r);
                    }), h.length && (h.forEach(function(t, e) {
                        i.renderTick(t, e, r);
                    }), f && (0 === i.min || i.single) && (d[-1] || (d[-1] = new ek(i, -1, null, !0)), d[-1].render(-1))), g && h.forEach(function(r, a) {
                        e = void 0 !== h[a + 1] ? h[a + 1] + f : i.max - f, a % 2 == 0 && r < i.max && e <= i.max + (s.polar ? -f : f) && (p[r] || (p[r] = new n.PlotLineOrBand(i, {}, "plotBands")), t = r + f, p[r].options = {
                            from: o ? o.lin2log(t) : t,
                            to: o ? o.lin2log(e) : e,
                            color: g,
                            className: "highcharts-alternate-grid"
                        }, p[r].render(), p[r].isActive = !0);
                    });
                }
                for (let t of [
                    "plotBands",
                    "plotLines"
                ])for (let e of this[t])e.render();
                [
                    d,
                    c,
                    p
                ].forEach(function(t) {
                    let e = [], i = b.duration;
                    j(t, function(t, i) {
                        t.isActive || (t.render(i, !1, 0), t.isActive = !1, e.push(i));
                    }), tt(function() {
                        let i = e.length;
                        for(; i--;)t[e[i]] && !t[e[i]].isActive && (t[e[i]].destroy(), delete t[e[i]]);
                    }, t !== p && s.hasRendered && i ? i : 0);
                }), m && (m[m.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(m.strokeWidth()),
                    opacity: y
                }), m.isPlaced = !0, m[x ? "show" : "hide"](x)), l && x && (l[l.isNew ? "attr" : "animate"]({
                    opacity: y,
                    ...i.getTitlePosition(l)
                }), l.isNew = !1), i.stacking?.renderStackTotals(), this.old || this.saveOld(), i.isDirty = !1, P(this, "afterRender");
            }
            redraw() {
                (this.visible || this.axisGroup) && this.render(), this.series.forEach(function(t) {
                    t.isDirty = !0;
                });
            }
            saveOld() {
                this.old = N(this.min) ? {
                    horiz: this.horiz,
                    len: this.len,
                    max: this.max,
                    min: this.min,
                    names: this.names.slice(),
                    transA: this.transA,
                    userMax: this.userMax,
                    userMin: this.userMin
                } : void 0;
            }
            destroy() {
                P(this, "destroy"), q(this), [
                    this.ticks,
                    this.minorTicks,
                    this.alternateBands,
                    this.plotBands,
                    this.plotLines,
                    this.plotLinesAndBandsGroups
                ].forEach(k), [
                    "axisLine",
                    "axisTitle",
                    "axisGroup",
                    "gridGroup",
                    "labelGroup",
                    "cross",
                    "scrollbar"
                ].forEach((t)=>{
                    this[t] = this[t]?.destroy();
                }), j(this, (t, e)=>{
                    delete this[e];
                });
            }
            drawCrosshair(t, e) {
                let i, s, o, r, a = this.crosshair, n = a?.snap ?? !0, h = this.chart, l = this.cross;
                if (P(this, "drawCrosshair", {
                    e: t,
                    point: e
                }), t || (t = this.cross?.e), a && !1 !== (v(e) || !n)) {
                    if (clearTimeout(this.crossShowTimer), n ? v(e) && (s = ("colorAxis" !== this.coll ? e.crosshairPos : null) ?? (this.isXAxis ? e.plotX : this.len - e.plotY)) : s = t && (this.horiz ? t.chartX - this.pos : this.len - t.chartY + this.pos), v(s) && (r = {
                        value: e && (this.isXAxis ? e.x : e.stackY ?? e.y ?? void 0),
                        translatedValue: s
                    }, h.polar && S(r, {
                        isCrosshair: !0,
                        chartX: t?.chartX,
                        chartY: t?.chartY,
                        point: e
                    }), i = this.getPlotLinePath(r) || null), !v(i)) return void this.hideCrosshair();
                    o = this.categories && !this.isRadial, this.crossShowTimer = tt(()=>{
                        let e = this.cross;
                        e || (this.cross = e = h.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (o ? "category " : "thin ") + (a.className || "")).attr({
                            zIndex: a.zIndex ?? 2
                        }).clip(!1 === a.clip ? void 0 : h.plotClipInner).add()), h.styledMode || e.attr({
                            stroke: a.color || (o ? eC("var(--highcharts-highlight-color-20)").setOpacity(.25).get() : "var(--highcharts-neutral-color-20)"),
                            "stroke-width": a.width ?? 1,
                            dashstyle: a.dashStyle || "Solid"
                        }).css({
                            "pointer-events": "none"
                        }), e.show().animate({
                            d: i
                        }, tS(a?.animation)), o && !a.width && e.attr({
                            "stroke-width": this.transA
                        }), e.e = t;
                    }, (!l || "hidden" === l.attr("visibility")) && a.showDelay || 0);
                } else this.hideCrosshair();
                P(this, "afterDrawCrosshair", {
                    e: t,
                    point: e
                });
            }
            hideCrosshair() {
                clearTimeout(this.crossShowTimer), this.cross && this.cross.hide(), P(this, "afterHideCrosshair");
            }
            update(t = {}, e = !0) {
                let i = this.chart;
                P(this, "update", {
                    options: t
                }), t = F(this.userOptions, t), this.isDirty = this.forceRedraw = !0, this.init(i, t), i.isDirtyBox = !0, e && i.redraw();
            }
            remove(t) {
                let e = this.chart, i = this.coll, s = this.series, o = s.length;
                for(; o--;)s[o] && s[o].remove(!1);
                C(e.axes, this), C(e[i] || [], this), e.orderItems(i), this.destroy(), e.isDirtyBox = !0, (t ?? !0) && e.redraw();
            }
            setTitle(t, e) {
                this.update({
                    title: t
                }, e);
            }
            setCategories(t, e) {
                this.update({
                    categories: t
                }, e);
            }
        }, { composed: eO } = n;
        !function(t) {
            function e() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
            }
            function i() {
                if ("datetime" !== this.type) {
                    this.dateTime = void 0;
                    return;
                }
                this.dateTime || (this.dateTime = new s(this));
            }
            t.compose = function(t) {
                return _(eO, "Axis.DateTime") && (t.prototype.getTimeTicks = e, c(t, "afterSetType", i)), t;
            };
            class s {
                constructor(t){
                    this.axis = t;
                }
                normalizeTimeTickInterval(t, e) {
                    let i = e || [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                2,
                                3,
                                4,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ], s = i[i.length - 1], o = ta[s[0]], r = s[1], a, n;
                    for(a = 0; a < i.length; a++)if (o = ta[(s = i[a])[0]], r = s[1], i[a + 1]) {
                        let e = (o * r[r.length - 1] + ta[i[a + 1][0]]) / 2;
                        if (t <= e) {
                            n = e / t;
                            break;
                        }
                    }
                    o === ta.year && t < 5 * o && (r = [
                        1,
                        2,
                        5
                    ]);
                    let h = Y(t / o, r, "year" === s[0] ? Math.max(O(t / o), 1) : 1);
                    return {
                        unitRange: o,
                        count: h,
                        unitName: s[0],
                        match: n
                    };
                }
                getXDateFormat(t, e) {
                    let { axis: i } = this, s = i.chart.time;
                    return i.closestPointRange ? s.getDateFormat(i.closestPointRange, t, i.options.startOfWeek, e) || s.resolveDTLFormat(e.year).main : s.resolveDTLFormat(e.day).main;
                }
            }
            t.Additions = s;
        }(e8 || (e8 = {}));
        let eE = e8, { composed: eI } = n;
        !function(t) {
            function e() {
                "logarithmic" !== this.type ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new s(this));
            }
            function i() {
                let t = this.logarithmic;
                t && (this.lin2val = function(e) {
                    return t.lin2log(e);
                }, this.val2lin = function(e) {
                    return t.log2lin(e);
                });
            }
            t.compose = function(t) {
                return _(eI, "Axis.Logarithmic") && (c(t, "afterSetType", e), c(t, "afterInit", i)), t;
            };
            class s {
                constructor(t){
                    this.axis = t;
                }
                getLogTickPositions(t, e, i, s) {
                    let o = this.axis, r = o.len, a = o.options, n = [];
                    if (s || (this.minorAutoInterval = void 0), t >= .5) t = Math.round(t), n = o.getLinearTickPositions(t, e, i);
                    else if (t >= .08) {
                        let o, r, a, h, l, d, c, p = Math.floor(e);
                        for(o = t > .3 ? [
                            1,
                            2,
                            4
                        ] : t > .15 ? [
                            1,
                            2,
                            4,
                            6,
                            8
                        ] : [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ], r = p; r < i + 1 && !c; r++)for(h = o.length, a = 0; a < h && !c; a++)(l = this.log2lin(this.lin2log(r) * o[a])) > e && (!s || d <= i) && void 0 !== d && n.push(d), d > i && (c = !0), d = l;
                    } else {
                        let h = this.lin2log(e), l = this.lin2log(i), d = s ? o.getMinorTickInterval() : a.tickInterval, c = a.tickPixelInterval / (s ? 5 : 1), p = s ? r / o.tickPositions.length : r;
                        t = Y(t = ("auto" === d ? null : d) ?? this.minorAutoInterval ?? (l - h) * c / (p || 1)), n = o.getLinearTickPositions(t, h, l).map(this.log2lin), s || (this.minorAutoInterval = t / 5);
                    }
                    return s || (o.tickInterval = t), n;
                }
                lin2log(t) {
                    return Math.pow(10, t);
                }
                log2lin(t) {
                    return Math.log(t) / Math.LN10;
                }
            }
            t.Additions = s;
        }(e7 || (e7 = {}));
        let eD = e7;
        !function(t) {
            let e, i = (t)=>function(i) {
                    var s;
                    let o = new e(this, i, t);
                    return this.visible && o.render(), (s = this.options)[t] || (s[t] = this.userOptions[t] = []), this.options[t].push(i), this[t].push(o), o;
                };
            function s(t, e, i) {
                i = i || this.options;
                let s = this.getPlotLinePath({
                    value: e,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), o = [], r = this.horiz, a = !N(this.min) || !N(this.max) || t < this.min && e < this.min || t > this.max && e > this.max, n = this.getPlotLinePath({
                    value: t,
                    force: !0,
                    acrossPanes: i.acrossPanes
                }), h, l = 1, d;
                if (n && s) for(a && (d = n.toString() === s.toString(), l = 0), h = 0; h < n.length; h += 2){
                    let t = n[h], e = n[h + 1], i = s[h], a = s[h + 1];
                    ("M" === t[0] || "L" === t[0]) && ("M" === e[0] || "L" === e[0]) && ("M" === i[0] || "L" === i[0]) && ("M" === a[0] || "L" === a[0]) && (r && i[1] === t[1] ? (i[1] += l, a[1] += l) : r || i[2] !== t[2] || (i[2] += l, a[2] += l), o.push([
                        "M",
                        t[1],
                        t[2]
                    ], [
                        "L",
                        e[1],
                        e[2]
                    ], [
                        "L",
                        a[1],
                        a[2]
                    ], [
                        "L",
                        i[1],
                        i[2]
                    ], [
                        "Z"
                    ])), o.isFlat = d;
                }
                return o;
            }
            function o(t) {
                [
                    ...this.plotBands || [],
                    ...this.plotLines || []
                ].find((e)=>e.id === t)?.remove();
            }
            t.compose = function(t, r) {
                let a = r.prototype;
                return a.addPlotBand || (e = t, S(a, {
                    addPlotBand: i("plotBands"),
                    addPlotLine: i("plotLines"),
                    getPlotBandPath: s,
                    removePlotBand: o,
                    removePlotLine: o
                }), c(r, "afterInit", function() {
                    if (!this.plotBands) for (let t of (this.plotLinesAndBandsGroups = {}, [
                        "plotBands",
                        "plotLines"
                    ]))for (let i of (this[t] = [], J(this.options[t] || [])))this[t].push(new e(this, i, t));
                }), c(r, "update", function({ options: t }) {
                    for (let e of [
                        "plotBands",
                        "plotLines"
                    ])if (t[e]) {
                        let i = this[e];
                        J(t[e]).forEach((s = {}, o)=>{
                            let r;
                            s?.id && (r = i.find((t)=>t.id === s.id)), r || (r = i[o]), r ? (r.update(s, !1), t[e][o] = r.options) : r = this["plotBands" === e ? "addPlotBand" : "addPlotLine"](s), r.isActive = !0;
                        });
                        let s = i.length;
                        for(; s--;)i[s].isActive ? delete i[s].isActive : i[s].remove();
                    }
                })), r;
            };
        }(it || (it = {}));
        let eB = it, ez = class t {
            static compose(e, i) {
                return c(e, "afterInit", function() {
                    this.labelCollectors.push(()=>{
                        let t = [];
                        for (let e of this.axes)for (let i of [
                            "plotBands",
                            "plotLines"
                        ])for (let { label: s, options: o } of e[i])s && !o?.label?.allowOverlap && t.push(s);
                        return t;
                    });
                }), eB.compose(t, i);
            }
            constructor(t, e, i){
                this.axis = t, this.options = e, this.id = e.id, this.coll = i;
            }
            render() {
                let t;
                P(this, "render");
                let { axis: e, options: i } = this, { chart: s, horiz: o, logarithmic: r } = e, { color: a, events: n, zIndex: h = 0 } = i, { renderer: l, styledMode: d, time: c } = e.chart, p = c.parse(i.to), g = c.parse(i.from), u = c.parse(i.value), f = i.borderWidth, m = i.label, { label: x, svgElem: y } = this, b, k = "plotBands" === this.coll, w = k ? "band" : "line", M = `${w}s-${h}`, C = !y, S = {
                    class: `highcharts-plot-${w} ${i.className || ""}`
                }, T = k ? f || 0 : i.width ?? 1;
                return d || (S["stroke-width"] = T), (b = e.plotLinesAndBandsGroups[M]) || (e.plotLinesAndBandsGroups[M] = b = l.g("plot-" + M).clip(s.plotClipOuter).attr({
                    zIndex: h
                }).add()), b[C ? "attr" : "animate"]({
                    opacity: +e.visible
                }), y || (this.svgElem = y = l.path().attr(S)), y.parentGroup !== b && y.add(b), !k && v(u) ? t = e.getPlotLinePath({
                    value: r?.log2lin(u) ?? u,
                    lineWidth: y.strokeWidth(),
                    acrossPanes: i.acrossPanes
                }) : k && v(g) && v(p) && (t = e.getPlotBandPath(r?.log2lin(g) ?? g, r?.log2lin(p) ?? p, i)), t && (S.d = t), !d && (k ? (S.fill = a || "var(--highcharts-highlight-color-10)", f && (S.stroke = i.borderColor)) : (S.stroke = a || "var(--highcharts-neutral-color-40)", i.dashStyle && (S.dashstyle = i.dashStyle))), C && n && j(n, (t, e)=>{
                    y?.on(e, (t)=>{
                        n[e].apply(this, [
                            t,
                            this
                        ]);
                    });
                }), (C || !y.d) && t?.length ? y.attr(S) : y && (t ? (y.show(), y.animate(S)) : y.d && (y.hide(), x && (this.label = x = x.destroy()))), m && (v(m.text) || v(m.formatter)) && t?.length && e.width > 0 && e.height > 0 && !t.isFlat ? (m = F({
                    align: o && k ? "center" : void 0,
                    x: o ? !k && 4 : 10,
                    verticalAlign: !o && k ? "middle" : void 0,
                    y: o ? k ? 16 : 10 : k ? 6 : -4,
                    rotation: o && !k ? 90 : 0,
                    ...k ? {
                        inside: !0
                    } : {}
                }, m), this.renderLabel(m, t, k, h)) : x && x.hide(), this;
            }
            renderLabel(t, e, i, s) {
                let o = this.axis, r = o.chart, a = r.renderer, n = t.inside, h = this.label;
                h || (this.label = h = a.text("", 0, 0, t.useHTML).attr({
                    zIndex: s
                })), h.attr({
                    text: this.getLabelText(t),
                    align: t.textAlign || t.align,
                    class: "highcharts-plot-" + (i ? "band" : "line") + "-label " + (t.className || "")
                })[h.placed ? "animate" : "attr"]({
                    opacity: 1,
                    rotation: t.rotation
                }), r.styledMode || h.css(F({
                    color: r.options.title?.style?.color,
                    fontSize: "0.8em",
                    textOverflow: i && !n ? "" : "ellipsis"
                }, t.style)), h.added || h.add();
                let l = e.xBounds || [
                    e[0][1],
                    e[1][1],
                    i ? e[2][1] : e[0][1]
                ], d = e.yBounds || [
                    e[0][2],
                    e[1][2],
                    i ? e[2][2] : e[0][2]
                ], c = p(l), u = p(d), f = g(l) - c;
                h.align(t, !1, {
                    x: c,
                    y: u,
                    width: f,
                    height: g(d) - u
                }), h.alignAttr.y -= a.fontMetrics(h).b, !h.alignValue || "left" === h.alignValue || v(n) ? h.css({
                    width: (t.style?.width || (i && n ? f : 90 === h.rotation ? o.height - (h.alignAttr.y - o.top) : (t.clip ? o.width + o.left : r.chartWidth) - h.alignAttr.x)) + "px"
                }) : h.textWidth && h.css({
                    width: "auto"
                }), h.show(!0);
            }
            update(t, e = !0) {
                F(!0, this.options, t), e && this.render();
            }
            getLabelText(t) {
                return v(t.formatter) ? t.formatter.call(this, this) : t.text;
            }
            destroy() {
                k(this, this.axis);
            }
            remove() {
                C(this.axis[this.coll], this), C(this.axis.options[this.coll] || [], this.options), this.destroy();
            }
        }, { format: eR } = tF, { composed: eN, dateFormats: eW, doc: eH, isSafari: eG } = n, { distribute: eX } = tY, eF = (t)=>{
            clearTimeout(t.hideTimer), clearTimeout(t.showTimer);
        };
        class eY {
            constructor(t, e, i){
                this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = t, this.init(t, e), this.pointer = i;
            }
            bodyFormatter(t) {
                return t.map((t)=>{
                    let e = t.series.tooltipOptions, i = t.formatPrefix || "point";
                    return (e[i + "Formatter"] || t.tooltipFormatter).call(t, e[i + "Format"] || "", t);
                });
            }
            cleanSplit(t) {
                this.chart.series.forEach(function(e) {
                    let i = e?.tt;
                    i && (!i.isActive || t ? e.tt = i.destroy() : i.isActive = !1);
                });
            }
            defaultFormatter(t) {
                let e, i = this.points || J(this);
                return (e = (e = [
                    t.headerFooterFormatter(i[0])
                ]).concat(t.bodyFormatter(i))).push(t.headerFooterFormatter(i[0], !0)), e;
            }
            destroy() {
                this.tracker = this.tracker?.destroy(), this.label = this.label?.destroy(), this.split && (this.cleanSplit(!0), this.tt = this.tt?.destroy()), this.renderer && (this.renderer = this.renderer.destroy(), w(this.container)), B(this.hideTimer), eF(this);
            }
            getAnchor(t, e) {
                let i, { chart: s, pointer: o } = this, r = s.inverted, a = s.plotTop, n = s.plotLeft;
                if (t = J(t), t[0].series?.yAxis && !t[0].series.yAxis.options.reversedStacks && (t = t.slice().reverse()), this.followPointer && e) void 0 === e.chartX && (e = o.normalize(e)), i = [
                    e.chartX - n,
                    e.chartY - a
                ];
                else if (t[0].tooltipPos) i = t[0].tooltipPos;
                else {
                    let s = 0, o = 0;
                    t.forEach(function(t) {
                        let e = t.pos(!0);
                        e && (s += e[0], o += e[1]);
                    }), s /= t.length, o /= t.length, this.shared && t.length > 1 && e && (r ? s = e.chartX : o = e.chartY), i = [
                        s - n,
                        o - a
                    ];
                }
                let h = {
                    point: t[0],
                    ret: i
                };
                return P(this, "getAnchor", h), h.ret.map(Math.round);
            }
            getClassName(t, e, i) {
                let s = this.options, o = t.series, r = o.options;
                return [
                    s.className,
                    "highcharts-label",
                    i && "highcharts-tooltip-header",
                    e ? "highcharts-tooltip-box" : "highcharts-tooltip",
                    !i && "highcharts-color-" + (t.colorIndex ?? o.colorIndex),
                    r?.className
                ].filter(W).join(" ");
            }
            getLabel({ anchorX: t, anchorY: e } = {
                anchorX: 0,
                anchorY: 0
            }) {
                let i = this, s = this.chart.styledMode, o = this.options, r = this.split && this.allowShared, a = this.container, h = this.chart.renderer;
                if (this.label) {
                    let t = !this.label.hasClass("highcharts-label");
                    (!r && t || r && !t) && this.destroy();
                }
                if (!this.label) {
                    if (this.outside) {
                        let t = this.chart, e = t.options.chart.style;
                        this.container = a = n.doc.createElement("div"), a.className = "highcharts-container highcharts-tooltip-container " + (t.renderTo.className.match(/(highcharts[a-zA-Z0-9-]+)\s?/gm) || ""), a.dataset.highchartsChart = t.index.toString(), b(a, {
                            position: "absolute",
                            top: "1px",
                            pointerEvents: "none",
                            zIndex: Math.max(o.style.zIndex || 0, (e?.zIndex || 0) + 3)
                        }), this.renderer = h = new eg(a, 0, 0, e, void 0, void 0, h.styledMode);
                    }
                    if (r ? this.label = h.g("tooltip") : (this.label = h.label("", t, e, o.shape || "callout", void 0, void 0, o.useHTML, void 0, "tooltip").attr({
                        padding: o.padding,
                        r: o.borderRadius
                    }), s || this.label.attr({
                        fill: o.backgroundColor,
                        "stroke-width": o.borderWidth ?? +!o.fixed
                    }).css(o.style).css({
                        pointerEvents: o.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none")
                    })), i.outside) {
                        let t = this.label;
                        [
                            t.xSetter,
                            t.ySetter
                        ].forEach((e, s)=>{
                            t[s ? "ySetter" : "xSetter"] = (o)=>{
                                e.call(t, i.distance), t[s ? "y" : "x"] = o, a && (a.style[s ? "top" : "left"] = `${o}px`);
                            };
                        });
                    }
                    this.label.attr({
                        zIndex: 8
                    }).shadow(o.shadow ?? !o.fixed).add();
                }
                return a && !a.parentElement && n.doc.body.appendChild(a), this.label;
            }
            getPlayingField() {
                let { body: t, documentElement: e } = eH, { chart: i, distance: s, outside: o } = this;
                return {
                    width: o ? Math.max(t.scrollWidth, e.scrollWidth, t.offsetWidth, e.offsetWidth, e.clientWidth) - 2 * s - 2 : i.chartWidth,
                    height: o ? Math.max(t.scrollHeight, e.scrollHeight, t.offsetHeight, e.offsetHeight, e.clientHeight) : i.chartHeight
                };
            }
            getPosition(t, e, i) {
                let { distance: s, chart: o, outside: r, pointer: a } = this, { inverted: n, plotLeft: h, plotTop: l, polar: d } = o, { plotX: c = 0, plotY: p = 0 } = i, g = {}, u = n && i.h || 0, { height: f, width: m } = this.getPlayingField(), x = a.getChartPosition(), y = (i)=>{
                    let a = "x" === i;
                    return [
                        i,
                        a ? m : f,
                        a ? t : e
                    ].concat(r ? [
                        a ? t * x.scaleX : e * x.scaleY,
                        a ? x.left - s + (c + h) * x.scaleX : x.top - s + (p + l) * x.scaleY,
                        0,
                        a ? m : f
                    ] : [
                        a ? t : e,
                        a ? c + h : p + l,
                        a ? h : l,
                        a ? h + o.plotWidth : l + o.plotHeight
                    ]);
                }, b = y("y"), v = y("x"), k, w = !!i.negative;
                !d && o.hoverSeries?.yAxis?.reversed && (w = !w);
                let M = !this.followPointer && (i.ttBelow ?? (!d && !n === w)), C = function(t, e, i, o, a, n, h) {
                    let l = r ? "y" === t ? s * x.scaleY : s * x.scaleX : s, d = (i - o) / 2, c = o < a - s, p = a + s + o < e, f = a - l - i + d, m = a + l - d;
                    if (M && p) g[t] = m;
                    else if (!M && c) g[t] = f;
                    else if (c) g[t] = Math.min(h - o, f - u < 0 ? f : f - u);
                    else {
                        if (!p) return g[t] = 0, !1;
                        g[t] = Math.max(n, m + u + i > e ? m : m + u);
                    }
                }, S = function(t, e, i, o, r) {
                    if (r < s || r > e - s) return !1;
                    r < i / 2 ? g[t] = 1 : r > e - o / 2 ? g[t] = e - o - 2 : g[t] = r - i / 2;
                }, T = function(t) {
                    [b, v] = [
                        v,
                        b
                    ], k = t;
                }, P = ()=>{
                    !1 !== C.apply(0, b) ? !1 !== S.apply(0, v) || k || (T(!0), P()) : k ? g.x = g.y = 0 : (T(!0), P());
                };
                return (n && !d || this.len > 1) && T(), P(), r && (g.x -= x.left, g.y -= x.top), g;
            }
            getFixedPosition(t, e, i) {
                let s = i.series, { chart: o, options: r, split: a } = this, n = r.position, h = n.relativeTo, l = r.shared || s?.yAxis?.isRadial && ("pane" === h || !h) ? "plotBox" : h, d = "chart" === l ? o.renderer : o[l] || o.getClipBox(s, !0);
                return {
                    x: d.x + (d.width - t) * A(n.align) + n.x,
                    y: d.y + (d.height - e) * A(n.verticalAlign) + (!a && n.y || 0)
                };
            }
            hide(t) {
                let e = this;
                eF(this), t = t ?? this.options.hideDelay, this.isHidden || (this.hideTimer = tt(function() {
                    let i = e.getLabel();
                    e.getLabel().animate({
                        opacity: 0
                    }, {
                        duration: t ? 150 : t,
                        complete: ()=>{
                            i.hide(), e.container && e.container.remove();
                        }
                    }), e.isHidden = !0;
                }, t));
            }
            init(t, e) {
                this.chart = t, this.options = e, this.crosshairs = [], this.isHidden = !0, this.split = e.split && !t.inverted && !t.polar, this.shared = e.shared || this.split, this.outside = e.outside ?? !!(t.scrollablePixelsX || t.scrollablePixelsY);
            }
            shouldStickOnContact(t) {
                return !!(!this.followPointer && this.options.stickOnContact && (!t || this.pointer.inClass(t.target, "highcharts-tooltip")));
            }
            move(t, e, i, s) {
                let { followPointer: o, options: r } = this, a = tS(!o && !this.isHidden && !r.fixed && r.animation), n = o || (this.len || 0) > 1, h = {
                    x: t,
                    y: e
                };
                this.anchorX = i, this.anchorY = s, n ? h.anchorX = h.anchorY = 0 / 0 : (h.anchorX = i, h.anchorY = s), a.step = ()=>this.drawTracker(), this.getLabel().animate(h, a);
            }
            refresh(t, e) {
                let i = this, { chart: s, options: o, pointer: r, shared: a } = this, n = J(t), h = n[0], l = o.format, d = o.formatter || i.defaultFormatter, c = s.styledMode, p = i.allowShared;
                if (!o.enabled || !h.series) return;
                eF(this), i.allowShared = !(!H(t) && t.series && t.series.noSharedTooltip), p = p && !i.allowShared, i.followPointer = !i.split && h.series.tooltipOptions.followPointer;
                let g = i.getAnchor(t, e), u = g[0], m = g[1];
                a && i.allowShared && (r.applyInactiveState(n), n.forEach((t)=>t.setState("hover")), h.points = n), this.len = n.length;
                let x = W(l) ? eR(l, h, s) : d.call(h, i, h);
                h.points = void 0;
                let y = h.series;
                this.distance = y.tooltipOptions.distance ?? 16, !1 === x ? this.hide() : this.showTimer = tt(()=>{
                    if (i.split && i.allowShared) i.renderSplit(x, n);
                    else {
                        let t = u, a = m;
                        if (e && r.isDirectTouch && (t = e.chartX - s.plotLeft, a = e.chartY - s.plotTop), !(s.polar || !1 === y.options.clip || n.some((e)=>r.isDirectTouch || e.series.shouldShowTooltip(t, a)))) return void i.hide();
                        {
                            let t = i.getLabel(p && i.tt || {});
                            (!o.style.width || c) && t.css({
                                width: (this.outside ? this.getPlayingField() : s.spacingBox).width - 2 * o.padding + "px"
                            }), t.attr({
                                class: i.getClassName(h),
                                text: H(x) ? x.join("") : x
                            }), this.outside && t.attr({
                                x: f(t.x || 0, 0, this.getPlayingField().width - (t.width || 0) - 1)
                            }), c || t.attr({
                                stroke: o.borderColor || h.color || y.color || "var(--highcharts-neutral-color-60)"
                            }), i.updatePosition({
                                plotX: u,
                                plotY: m,
                                negative: h.negative,
                                ttBelow: h.ttBelow,
                                series: y,
                                h: g[2] || 0
                            });
                        }
                    }
                    i.isHidden && i.label && i.label.attr({
                        opacity: 1
                    }).show(), i.isHidden = !1;
                }, i.isHidden && o.showDelay || 0), P(this, "refresh");
            }
            renderSplit(t, e) {
                let i = this, { chart: s, chart: { chartWidth: o, chartHeight: r, plotHeight: a, plotLeft: n, plotTop: h, scrollablePixelsY: l = 0, scrollablePixelsX: d, styledMode: c }, distance: p, options: g, options: { fixed: u, position: m, positioner: x }, pointer: y } = i, { scrollLeft: b = 0, scrollTop: v = 0 } = s.scrollablePlotArea?.scrollingContainer || {}, k = i.outside && "number" != typeof d ? eH.documentElement.getBoundingClientRect() : {
                    left: b,
                    right: b + o,
                    top: v,
                    bottom: v + r
                }, w = i.getLabel(), M = this.renderer || s.renderer, C = !!s.xAxis[0]?.opposite, { left: T, top: P } = y.getChartPosition(), A = x || u, L = h + v, O = 0, E = a - l, I = function(t, e, s, o, r = [
                    0,
                    0
                ], a = !0) {
                    let n, h;
                    if (s.isHeader) h = C ? 0 : E, n = f(r[0] - t / 2, k.left, k.right - t - (i.outside ? T : 0));
                    else if (u && s) {
                        let o = i.getFixedPosition(t, e, s);
                        n = o.x, h = o.y - L;
                    } else h = r[1] - L, n = f(n = a ? r[0] - t - p : r[0] + p, a ? n : k.left, k.right);
                    return {
                        x: n,
                        y: h
                    };
                };
                W(t) && (t = [
                    !1,
                    t
                ]);
                let D = t.slice(0, e.length + 1).reduce(function(t, s, o) {
                    if (!1 !== s && "" !== s) {
                        let r = e[o - 1] || {
                            isHeader: !0,
                            plotX: e[0].plotX,
                            plotY: a,
                            series: {}
                        }, l = r.isHeader, d = l ? i : r.series, m = d.tt = function(t, e, s) {
                            let o = t, { isHeader: r, series: a } = e, n = a.tooltipOptions || g, h = r ? F(n, n.header) : n;
                            if (!o) {
                                let t = {
                                    padding: n.padding,
                                    r: n.borderRadius
                                };
                                c || (t.fill = h.backgroundColor, t["stroke-width"] = h.borderWidth ?? +!n.fixed), o = M.label("", 0, 0, h.shape || (u && !r ? "rect" : "callout"), void 0, void 0, n.useHTML).addClass(i.getClassName(e, !0, r)).attr(t).add(w);
                            }
                            return o.isActive = !0, c || o.css(h.style), o.attr({
                                text: s
                            }), c || o.attr({
                                stroke: h.borderColor || e.color || a.color || "var(--highcharts-neutral-color-80)"
                            }), o;
                        }(d.tt, r, s.toString()), y = m.getBBox(), b = y.width + m.strokeWidth();
                        l && (O = y.height + g.header.distance, E += O, C && (L -= O));
                        let { anchorX: v, anchorY: S } = function(t) {
                            let e, i, { isHeader: s, plotX: o = 0, plotY: r = 0, series: l } = t;
                            if (s) e = Math.max(n + o, n), i = h + a / 2;
                            else {
                                let { xAxis: t, yAxis: s } = l;
                                e = t.pos + f(o, -p, t.len + p), l.shouldShowTooltip(0, s.pos - h + r, {
                                    ignoreX: !0
                                }) && (i = s.pos + r);
                            }
                            return {
                                anchorX: e = f(e, k.left - p, k.right + p),
                                anchorY: i
                            };
                        }(r);
                        if ("number" == typeof S) {
                            let e = y.height + 1, s = (x || I).call(i, b, e, r, i, [
                                v,
                                S
                            ]);
                            t.push({
                                align: A ? 0 : void 0,
                                anchorX: v,
                                anchorY: S,
                                boxWidth: b,
                                point: r,
                                rank: s.rank ?? +!!l,
                                size: e,
                                target: s.y,
                                tt: m,
                                x: s.x
                            });
                        } else m.isActive = !1;
                    }
                    return t;
                }, []);
                !A && D.some((t)=>{
                    let { outside: e } = i, s = (e ? T : 0) + t.anchorX;
                    return s < k.left && s + t.boxWidth < k.right || s < T - k.left + t.boxWidth && k.right - s > s;
                }) && (D = D.map((t)=>{
                    let { x: e, y: i } = I.call(this, t.boxWidth, t.size, t.point, void 0, [
                        t.anchorX,
                        t.anchorY
                    ], !1);
                    return S(t, {
                        target: i,
                        x: e
                    });
                })), i.cleanSplit(), eX(D, E);
                let B = {
                    left: T,
                    right: T
                };
                D.forEach(function(t) {
                    let { x: e, boxWidth: s, isHeader: o } = t;
                    !o && (i.outside && T + e < B.left && (B.left = T + e), i.outside && B.left + s > B.right && (B.right = T + e));
                }), D.forEach(function(t) {
                    let { x: e, anchorX: s, anchorY: o, pos: r, point: { isHeader: a } } = t, n = {
                        visibility: void 0 === r ? "hidden" : "inherit",
                        x: e,
                        y: (r || 0) + L + (u && m.y || 0),
                        anchorX: s,
                        anchorY: o
                    };
                    if (i.outside && e < s) {
                        let t = T - B.left;
                        t > 0 && (n.x = a ? (B.right - B.left) / 2 : e + t, n.anchorX = s + t);
                    }
                    t.tt.attr(n);
                });
                let { container: z, outside: R, renderer: N } = i;
                if (R && z && N) {
                    let { width: t, height: e, x: i, y: s } = w.getBBox();
                    N.setSize(t + i, e + s, !1), z.style.left = B.left + "px", z.style.top = P + "px";
                }
                eG && w.attr({
                    opacity: 1 === w.opacity ? .999 : 1
                });
            }
            drawTracker() {
                let t = this;
                if (!t.shouldStickOnContact()) {
                    t.tracker = t.tracker?.destroy();
                    return;
                }
                let { chart: e, label: i } = t, s = t.shared ? e.hoverPoints : e.hoverPoint, o = i?.box;
                if (!o || !s) return;
                let { height: r, r: a, width: n, x: h, y: l } = o, { anchorX: d, anchorY: p } = o;
                N(d) || (d = (t.anchorX || 0) - (i.translateX || 0), p = (t.anchorY || 0) - (i.translateY || 0));
                let g = i.renderer.symbols.callout(h, l, n, r, {
                    anchorX: d,
                    anchorY: p,
                    arrowLength: Math.max(d - n, -d, p - r, -p, 0),
                    r: a
                });
                !t.tracker && (t.tracker = i.renderer.path().addClass("highcharts-tracker").add(i), c(t.tracker.element, "mouseenter", ()=>eF(t)), e.styledMode || t.tracker.attr({
                    fill: "rgba(0,0,0,0)",
                    stroke: "rgba(0,0,0,0)",
                    "stroke-linejoin": "round",
                    "stroke-width": 10
                })), t.tracker.attr({
                    d: g
                });
            }
            styledModeFormat(t) {
                return t.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
            }
            headerFooterFormatter(t, e) {
                let i = t.series, s = i.tooltipOptions, o = i.xAxis, r = o?.dateTime, a = {
                    isFooter: e,
                    point: t
                }, n = s.xDateFormat || "", h = s[e ? "footerFormat" : "headerFormat"];
                return P(this, "headerFormatter", a, function(e) {
                    if (r && !n && N(t.key) && (n = r.getXDateFormat(t.key, s.dateTimeLabelFormats)), r && n) {
                        if (X(n)) {
                            let t = n;
                            eW[0] = (e)=>i.chart.time.dateFormat(t, e), n = "%0";
                        }
                        (t.tooltipDateKeys || [
                            "key"
                        ]).forEach((t)=>{
                            h = h.replace(RegExp("point\\." + t + "([ \\)}])"), `(point.${t}:${n})$1`);
                        });
                    }
                    i.chart.styledMode && (h = this.styledModeFormat(h)), e.text = eR(h, t, this.chart);
                }), a.text || "";
            }
            update(t) {
                this.destroy(), this.init(this.chart, F(!0, this.options, t));
            }
            updatePosition(t) {
                let { chart: e, container: i, distance: s, options: o, pointer: r, renderer: a } = this, { height: h = 0, width: l = 0 } = this.getLabel(), { fixed: d, positioner: c } = o, { left: p, top: g, scaleX: u, scaleY: m } = r.getChartPosition(), x = (c || d && this.getFixedPosition || this.getPosition).call(this, l, h, t, this), y = n.doc, v = (t.plotX || 0) + e.plotLeft, k = (t.plotY || 0) + e.plotTop, w;
                if (a && i) {
                    if (x.x += p, x.y += g, c || d) {
                        let { scrollLeft: t = 0, scrollTop: i = 0 } = e.scrollablePlotArea?.scrollingContainer || {};
                        x.x += t, x.y += i;
                    }
                    w = (o.borderWidth ?? +!d) + 2 * s + 2, a.setSize(f(l + w, 0, y.documentElement.clientWidth) - 1, h + w, !1), (1 !== u || 1 !== m) && (b(i, {
                        transform: `scale(${u}, ${m})`
                    }), v *= u, k *= m), v += p - x.x, k += g - x.y;
                }
                this.move(Math.round(x.x), Math.round(x.y || 0), v, k);
            }
        }
        (ig = eY || (eY = {})).compose = function(t) {
            _(eN, "Core.Tooltip") && c(t, "afterInit", function() {
                let t = this.chart;
                t.options.tooltip && (t.tooltip = new ig(t, t.options.tooltip, this));
            });
        };
        let ej = eY, { defaultOptions: e$ } = tm, { format: eV } = tF;
        class eU {
            constructor(t, e, i){
                this.formatPrefix = "point", this.visible = !0, this.point = this, this.series = t, this.applyOptions(e, i), this.id ?? (this.id = tn()), this.resolveColor(), this.dataLabelOnNull ?? (this.dataLabelOnNull = t.options.nullInteraction), t.chart.pointCount++, this.category = t.xAxis?.categories?.[this.x] ?? this.x, this.key = this.name ?? this.category, P(this, "afterInit");
            }
            applyOptions(t, e, i) {
                let s = this.series, o = s.options.pointValKey || s.pointValKey;
                return S(this, t = eU.prototype.optionsToObject.call(this, t)), this.options ? this.options = s.chart.options.chart.allowMutatingData ? S(this.options, t) : F(this.options, t) : this.options = t, o && (this.y = eU.prototype.getNestedProperty.call(this, o)), N(e) && (this.x = e), i || (this.selected && (this.state = "select"), t.group && delete this.group, t.dataLabels && delete this.dataLabels, this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point"), this;
            }
            getOrigin({ x: t = 0, y: e = 0 }, i = {}) {
                let { graphic: s, series: o } = this;
                if (o.chart.inverted && s?.parentGroup && !s?.parentGroup?.rotation) {
                    let i = this.pos(!1, t, e);
                    i && (t = i[0], e = i[1]);
                }
                t -= (i.width || 0) / 2, e -= (i.height || 0) / 2;
                let r = {
                    x: t
                };
                return o.is("column") || this.plotHigh || (r.y = e), r;
            }
            destroy(t) {
                if (!this.destroyed && !this.condemned) {
                    let e = this, i = e.series, s = i.chart, o = s.hoverPoints, { duration: r } = tS(e.series.chart.renderer.globalAnimation), a = ()=>{
                        for(let t in (e.graphic || e.graphics || e.dataLabel || e.dataLabels) && (q(e), e.destroyElements()), e)delete e[t];
                        this.destroyed = !0;
                    };
                    e.legendItem && s.legend.destroyItem(e), o && (e.setState(), C(o, e), o.length || (s.hoverPoints = void 0)), e === s.hoverPoint && e.onMouseOut(), r && !t && i.condemnedPoints ? (i.condemnedPoints.push(this), this.graphic?.addClass("highcharts-point-condemned"), setTimeout(a, r)) : a(), s.pointCount--;
                }
                this.condemned = !0;
            }
            destroyElements(t = {
                graphic: 1,
                dataLabel: 1
            }) {
                let e, i, s = this, o = [];
                for(t.graphic && o.push("graphic", "connector"), t.dataLabel && o.push("dataLabel", "dataLabelPath", "dataLabelUpper"), i = o.length; i--;)s[e = o[i]] && (s[e] = s[e].destroy());
                [
                    "graphic",
                    "dataLabel"
                ].forEach((e)=>{
                    let i = `${e}s`;
                    t[e] && s[i] && (s[i].forEach((t)=>{
                        t?.element && t.destroy();
                    }), delete s[i]);
                });
            }
            firePointEvent(t, e, i) {
                let s = this, o = this.series.options;
                s.manageEvent(t), "click" === t && o.allowPointSelect && (i = function(t) {
                    !s.condemned && s.select && s.select(null, t.ctrlKey || t.metaKey || t.shiftKey);
                }), P(s, t, e, i);
            }
            getClassName() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative && !1 !== this.series.options.negativeColor ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone?.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            }
            getNestedProperty(t) {
                if (t) return 0 === t.indexOf("custom.") ? E(t, this.options) : this[t];
            }
            getZone() {
                let t = this.series, e = t.zones, i = t.zoneAxis || "y", s, o = 0;
                for(s = e[0]; o < e.length && this[i] >= s.value;)s = e[++o];
                return this.nonZonedColor || (this.nonZonedColor = this.color), s?.color && !this.options.color ? this.color = s.color : this.color = this.nonZonedColor, s;
            }
            hasNewShapeType() {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
            }
            isValid() {
                return (N(this.x) || this.x instanceof Date) && N(this.y);
            }
            optionsToObject(t) {
                let e = this.series, i = e.options.keys, s = i || e.pointArrayMap || [
                    "y"
                ], o = s.length, r = {}, a, n = 0, h = 0;
                if (N(t) || null === t) r[s[0]] = t;
                else if (H(t)) for(!i && t.length > o && ("string" == (a = typeof t[0]) ? e.xAxis?.dateTime ? r.x = e.chart.time.parse(t[0]) : r[e.tupleKey || "name"] = t[0] : "number" === a && (r.x = t[0]), n++); h < o;)i && void 0 === t[n] || (r[s[h]] = t[n]), n++, h++;
                else "object" == typeof t && (r = t, t.dataLabels && (e.hasDataLabels = ()=>!0), t.marker && (e._hasPointMarkers = !0));
                return (i || !e.options.data) && Object.keys(r).forEach((t)=>{
                    t.indexOf(".") > 0 && (eU.prototype.setNestedProperty(r, r[t], t), delete r[t]);
                }), r;
            }
            pos(t, e = this.plotX, i = this.plotY) {
                let { series: s } = this, { chart: o, xAxis: r, yAxis: a } = s || {}, n = 0, h = 0;
                if (o && N(e) && N(i)) return t && (n = r ? r.pos : o.plotLeft, h = a ? a.pos : o.plotTop), o.inverted && r && a ? [
                    a.len - i + h,
                    r.len - e + n
                ] : [
                    e + n,
                    i + h
                ];
            }
            resolveColor() {
                let { options: t, series: e } = this, i = e.chart, s = i.options.chart, o = i.styledMode, r, a = s.colorCount, n;
                if (delete this.nonZonedColor, e.options.colorByPoint) {
                    if (!o) {
                        let t = e.options.colors || i.options.colors;
                        r = t?.[e.colorCounter], a = t?.length;
                    }
                    n = e.colorCounter, e.colorCounter++, e.colorCounter === a && (e.colorCounter = 0);
                } else o || (r = e.color), n = e.colorIndex;
                this.colorIndex = t.colorIndex ?? n, this.color = t.color ?? r;
            }
            setNestedProperty(t, e, i) {
                let s = i.split(".");
                return s.some((t)=>"__proto__" === t || "constructor" === t) || s.reduce(function(t, i, s, o) {
                    let r = o.length - 1 === s;
                    return t[i] = r ? e : X(t[i], !0) && Object.hasOwnProperty.call(t, i) ? t[i] : {}, t[i];
                }, t), t;
            }
            shouldDraw() {
                return !this.isNull;
            }
            tooltipFormatter(t) {
                let { chart: e, pointArrayMap: i = [
                    "y"
                ], tooltipOptions: s } = this.series, { valueDecimals: o = "", valuePrefix: r = "", valueSuffix: a = "" } = s;
                return e.styledMode && (t = e.tooltip?.styledModeFormat(t) || t), i.forEach((e)=>{
                    e = "{point." + e, (r || a) && (t = t.replace(RegExp(e + "}", "g"), r + e + "}" + a)), t = t.replace(RegExp(e + "}", "g"), e + ":,." + o + "f}");
                }), eV(t, this, e);
            }
            update(t, e = !0, i, s) {
                let o = this, r = o.series, a = o.graphic, n = r.chart, h = r.options, l = h.data;
                function d() {
                    o.applyOptions(t), a && null === o.y && !o.hasMockGraphic && (o.graphic = a.destroy()), X(t, !0) && (a?.element && t?.marker && void 0 !== t.marker.symbol && (o.graphic = a.destroy()), t?.dataLabels && o.dataLabel && (o.dataLabel = o.dataLabel.destroy()));
                    let s = o.index, d = o.optionsToObject(t);
                    !r.hasProcessedDataTable && (r.dataTable.setRow(d, s), l && (l[s] = X(l[s], !0) || X(t, !0) ? o.options : t ?? l[s])), r.isDirty = r.isDirtyData = !0, "x" in d && (W(d.x) && (r.xColumnIsNumbers = void 0), o.x = r.getX(d.x), o.isNull = o.isValid && !o.isValid(), r.xColumn && (r.xColumn[s] = o.x)), !r.fixedBox && r.hasCartesianSeries && (n.isDirtyBox = !0), "point" === h.legendType && (n.isDirtyLegend = !0), e && n.redraw(i);
                }
                !1 === s ? d() : o.firePointEvent("update", {
                    options: t
                }, d);
            }
            remove(t, e) {
                this.series.removePoint(this.series.data.indexOf(this), t, e);
            }
            select(t, e) {
                let i = this, s = i.series, o = s.chart;
                t = t ?? !i.selected, this.selectedStaging = t, i.firePointEvent(t ? "select" : "unselect", {
                    accumulate: e
                }, function() {
                    i.selected = i.options.selected = t, s.options.data && (s.options.data[s.data.indexOf(i)] = i.options), i.setState(t && "select"), e || o.getSelectedPoints().forEach(function(t) {
                        let e = t.series, s = e.options;
                        t.selected && t !== i && (t.selected = t.options.selected = !1, s.data && (s.data[e.data.indexOf(t)] = t.options), t.setState(o.hoverPoints && s.inactiveOtherPoints ? "inactive" : ""), t.firePointEvent("unselect"));
                    });
                }), delete this.selectedStaging;
            }
            onMouseOver(t) {
                let { inverted: e, pointer: i } = this.series.chart;
                i && (t = t ? i.normalize(t) : i.getChartCoordinatesFromPoint(this, e), i.runPointActions(t, this));
            }
            onMouseOut() {
                if (!this.series) return;
                let t = this.series.chart;
                this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (t.hoverPoints || []).forEach(function(t) {
                    t.setState();
                }), t.hoverPoints = t.hoverPoint = null;
            }
            manageEvent(t) {
                let e = F(this.series.options.point, this.options), i = e.events?.[t];
                G(i) && (!this.hcEvents?.[t] || this.hcEvents?.[t]?.map((t)=>t.fn).indexOf(i) === -1) ? (this.importedUserEvent?.(), this.importedUserEvent = c(this, t, i), this.hcEvents && (this.hcEvents[t].userEvent = !0)) : this.importedUserEvent && !i && this.hcEvents?.[t] && this.hcEvents?.[t].userEvent && (q(this, t), delete this.hcEvents[t], Object.keys(this.hcEvents) || delete this.importedUserEvent);
            }
            setState(t, e) {
                let i = this.series, s = this.state, o = i.options.states?.[t || "normal"] || {}, r = e$.plotOptions?.[i.type]?.marker && i.options.marker, a = r?.enabled === !1, n = r?.states?.[t || "normal"] || {}, h = !1 === n.enabled, l = this.marker || {}, d = i.chart, c = r && i.markerAttribs, p = i.halo, g, u, f, m = i.stateMarkerGraphic, x;
                if ((t = t || "") === this.state && !e || this.selected && "select" !== t || !1 === o.enabled || t && (h || a && !1 === n.enabled) || t && l.states?.[t]?.enabled === !1) return;
                if (this.state = t, c && (g = i.markerAttribs(this, t)), this.graphic && !this.hasMockGraphic) {
                    if (s && this.graphic.removeClass("highcharts-point-" + s), t && this.graphic.addClass("highcharts-point-" + t), !d.styledMode) {
                        u = i.pointAttribs(this, t), f = d.options.chart.animation ?? o.animation;
                        let e = u.opacity;
                        i.options.inactiveOtherPoints && N(e) && (this.dataLabels || []).forEach(function(t) {
                            t && !t.hasClass("highcharts-data-label-hidden") && (t.animate({
                                opacity: e
                            }, f), t.connector && t.connector.animate({
                                opacity: e
                            }, f));
                        }), this.graphic.animate(u, f);
                    }
                    g && this.graphic.animate(g, d.options.chart.animation ?? n.animation ?? r.animation), m && m.hide();
                } else t && n && (x = l.symbol || i.symbol, m && m.currentSymbol !== x && (m = m.destroy()), g && (m ? m[e ? "animate" : "attr"]({
                    x: g.x,
                    y: g.y
                }) : x && (i.stateMarkerGraphic = m = d.renderer.symbol(x, g.x, g.y, g.width, g.height, F(r, n)).add(i.markerGroup), m.currentSymbol = x)), !d.styledMode && m && "inactive" !== this.state && m.attr(i.pointAttribs(this, t))), m && (m[t && this.isInside ? "show" : "hide"](), m.element.point = this, m.addClass(this.getClassName(), !0));
                let y = X(o.halo) ? o.halo : {}, b = this.graphic || m, v = b?.visibility || "inherit";
                y.size && b && "hidden" !== v && !this.isCluster ? (p || (i.halo = p = d.renderer.path().add(b.parentGroup)), p.show()[e ? "animate" : "attr"]({
                    d: this.haloPath(y.size)
                }), p.attr({
                    class: "highcharts-halo highcharts-color-" + (this.colorIndex ?? i.colorIndex) + (this.className ? " " + this.className : ""),
                    visibility: v,
                    zIndex: -1
                }), p.point = this, d.styledMode || p.attr(S({
                    fill: this.color || i.color,
                    "fill-opacity": y.opacity
                }, tB.filterUserAttributes(y.attributes || {})))) : p?.point?.haloPath && !p.point.destroyed && p.animate({
                    d: p.point.haloPath(0)
                }, null, p.hide), P(this, "afterSetState", {
                    state: t
                });
            }
            haloPath(t) {
                let e = this.pos();
                return e ? this.series.chart.renderer.symbols.circle(y(e[0], 1) - t, e[1] - t, 2 * t, 2 * t) : [];
            }
        }
        let e_ = eU, { charts: eZ, composed: eK, isTouchDevice: eq } = n, eJ = (t, e)=>!v(e) || t[`${e}Key`];
        class eQ {
            applyInactiveState(t = []) {
                let e = [];
                for (let i of (t.forEach((t)=>{
                    let i = t.series;
                    e.push(i), i.linkedParent && e.push(i.linkedParent), i.linkedSeries && e.push.apply(e, i.linkedSeries), i.navigatorSeries && e.push(i.navigatorSeries), i.boosted && i.markerGroup && e.push.apply(e, this.chart.series.filter((t)=>t.markerGroup === i.markerGroup));
                }), this.chart.series)){
                    let t = i.options;
                    t.states?.inactive?.enabled !== !1 && (-1 === e.indexOf(i) ? i.setState("inactive", !0) : t.inactiveOtherPoints && i.setAllPointsToState("inactive"));
                }
            }
            destroy() {
                let t = this;
                this.eventsToUnbind.forEach((t)=>t()), this.eventsToUnbind = [], !n.chartCount && (eQ.unbindDocumentMouseUp.forEach((t)=>t.unbind()), eQ.unbindDocumentMouseUp.length = 0, eQ.unbindDocumentTouchEnd && (eQ.unbindDocumentTouchEnd = eQ.unbindDocumentTouchEnd())), j(t, function(e, i) {
                    t[i] = void 0;
                });
            }
            getSelectionMarkerAttrs(t, e) {
                let i = {
                    args: {
                        chartX: t,
                        chartY: e
                    },
                    attrs: {},
                    shapeType: "rect"
                };
                return P(this, "getSelectionMarkerAttrs", i, (i)=>{
                    let s, { chart: o, zoomHor: r, zoomVert: a } = this, { mouseDownX: n = 0, mouseDownY: h = 0 } = o, l = i.attrs;
                    l.x = o.plotLeft, l.y = o.plotTop, l.width = r ? 1 : o.plotWidth, l.height = a ? 1 : o.plotHeight, r && (l.width = Math.max(1, Math.abs(s = t - n)), l.x = (s > 0 ? 0 : s) + n), a && (l.height = Math.max(1, Math.abs(s = e - h)), l.y = (s > 0 ? 0 : s) + h);
                }), i;
            }
            drag(t) {
                let { chart: e } = this, { mouseDownX: i = 0, mouseDownY: s = 0 } = e, { panning: o, panKey: r, selectionMarkerFill: a } = e.options.chart, n = e.plotLeft, h = e.plotTop, l = e.plotWidth, d = e.plotHeight, c = X(o) ? o.enabled : o, p = r && t[`${r}Key`], g = t.chartX, u = t.chartY, f, m = this.selectionMarker;
                if ((!m || !m.touch) && (g < n ? g = n : g > n + l && (g = n + l), u < h ? u = h : u > h + d && (u = h + d), this.hasDragged = Math.sqrt(Math.pow(i - g, 2) + Math.pow(s - u, 2)), this.hasDragged > 10)) {
                    f = e.isInsidePlot(i - n, s - h, {
                        visiblePlotOnly: !0
                    });
                    let { shapeType: l, attrs: d } = this.getSelectionMarkerAttrs(g, u);
                    this.hasZoom && f && !p && !m && (this.selectionMarker = m = e.renderer[l](), m.attr({
                        class: "highcharts-selection-marker",
                        zIndex: 7
                    }).add(), e.styledMode || m.attr({
                        fill: a
                    })), m && m.attr(d), f && !m && c && eJ(t, r) && e.pan(t, o);
                }
            }
            dragStart(t) {
                let e = this.chart;
                e.mouseIsDown = t.type, e.cancelClick = !1, e.mouseDownX = t.chartX, e.mouseDownY = t.chartY;
            }
            getSelectionBox(t) {
                let e = {
                    args: {
                        marker: t
                    },
                    result: t.getBBox()
                };
                return P(this, "getSelectionBox", e), e.result;
            }
            drop(t) {
                let e, { chart: i, selectionMarker: s } = this;
                for (let t of i.axes)t.isPanning && (t.isPanning = !1, (t.options.startOnTick || t.options.endOnTick || t.series.some((t)=>t.boosted)) && (t.forceRedraw = !0, t.setExtremes(t.userMin, t.userMax, !1), e = !0));
                if (t?.type === "touchend" && this.hasDragged && i.transform({
                    trigger: "drop"
                }), e && i.redraw(), s && t) {
                    if (this.hasDragged) {
                        let e = this.getSelectionBox(s);
                        i.transform({
                            axes: i.axes.filter((t)=>t.zoomEnabled && ("xAxis" === t.coll && this.zoomX || "yAxis" === t.coll && this.zoomY)),
                            selection: {
                                originalEvent: t,
                                xAxis: [],
                                yAxis: [],
                                ...e
                            },
                            from: e
                        });
                    }
                    N(i.index) && (this.selectionMarker = s.destroy());
                }
                i && N(i.index) && (b(i.container, {
                    cursor: i._cursor
                }), i.cancelClick = this.hasDragged > 10, i.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = [], this.hasPinchMoved = !1);
            }
            findNearestKDPoint(t, e, i) {
                let s;
                return t.forEach(function(t) {
                    var o;
                    let r, a, n, h = !(t.noSharedTooltip && e) && 0 > t.options.findNearestPointBy.indexOf("y"), l = t.searchPoint(i, h);
                    X(l, !0) && l.series && (!X(s, !0) || (r = (o = s).distX - l.distX, a = o.dist - l.dist, n = l.series.group?.zIndex - o.series.group?.zIndex, (0 !== r && e ? r : 0 !== a ? a : 0 !== n ? n : o.series.index > l.series.index ? -1 : 1) > 0)) && (s = l);
                }), s;
            }
            getChartCoordinatesFromPoint(t, e) {
                let { xAxis: i, yAxis: s } = t.series, o = t.shapeArgs;
                if (i && s) {
                    let r = t.clientX ?? t.plotX ?? 0, a = t.plotY || 0;
                    return t.isNode && o && N(o.x) && N(o.y) && (r = o.x, a = o.y), e ? {
                        chartX: s.len + s.pos - a,
                        chartY: i.len + i.pos - r
                    } : {
                        chartX: r + i.pos,
                        chartY: a + s.pos
                    };
                }
                if (o?.x && o.y) return {
                    chartX: o.x,
                    chartY: o.y
                };
            }
            getChartPosition() {
                if (this.chartPosition) return this.chartPosition;
                let { container: t } = this.chart, e = $(t);
                this.chartPosition = {
                    left: e.left,
                    top: e.top,
                    scaleX: 1,
                    scaleY: 1
                };
                let { offsetHeight: i, offsetWidth: s } = t;
                return s > 2 && i > 2 && (this.chartPosition.scaleX = e.width / s, this.chartPosition.scaleY = e.height / i), this.chartPosition;
            }
            getCoordinates(t) {
                let e = {
                    xAxis: [],
                    yAxis: []
                };
                for (let i of this.chart.axes)e[i.isXAxis ? "xAxis" : "yAxis"].push({
                    axis: i,
                    value: i.toValue(t[i.horiz ? "chartX" : "chartY"])
                });
                return e;
            }
            getHoverData(t, e, i, s, o, r) {
                let a = [], n = function(t) {
                    return t.visible && !(!o && t.directTouch) && (t.options.enableMouseTracking ?? !0);
                }, h = e, l, d = {
                    chartX: r ? r.chartX : void 0,
                    chartY: r ? r.chartY : void 0,
                    shared: o
                };
                P(this, "beforeGetHoverData", d), l = h && !h.stickyTracking ? [
                    h
                ] : i.filter((t)=>t.stickyTracking && (d.filter || n)(t));
                let c = s && t || !r ? t : this.findNearestKDPoint(l, o, r);
                return h = c?.series, c && (o && !h.noSharedTooltip ? (l = i.filter(function(t) {
                    return d.filter ? d.filter(t) : n(t) && !t.noSharedTooltip;
                })).forEach(function(t) {
                    let e = t.options?.nullInteraction, i = D(t.points, function(t) {
                        return t.x === c.x && (!t.isNull || !!e);
                    });
                    X(i) && (t.boosted && t.boost && (i = t.boost.getPoint(i)), a.push(i));
                }) : a.push(c)), P(this, "afterGetHoverData", d = {
                    hoverPoint: c
                }), {
                    hoverPoint: d.hoverPoint,
                    hoverSeries: h,
                    hoverPoints: a
                };
            }
            getPointFromEvent(t) {
                let e = t.target, i;
                for(; e && !i;)i = e.point, e = e.parentNode;
                return i;
            }
            onTrackerMouseOut(t) {
                let e = this.chart, i = t.relatedTarget, s = e.hoverSeries;
                this.isDirectTouch = !1, !s || !i || s.stickyTracking || this.inClass(i, "highcharts-tooltip") || this.inClass(i, "highcharts-series-" + s.index) && this.inClass(i, "highcharts-tracker") || s.onMouseOut();
            }
            inClass(t, e) {
                let i = t, s;
                for(; i;){
                    if (s = u(i, "class")) {
                        if (-1 !== s.indexOf(e)) return !0;
                        if (-1 !== s.indexOf("highcharts-container")) return !1;
                    }
                    i = i.parentElement;
                }
            }
            constructor(t, e){
                this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = e, this.chart = t, this.runChartClick = !!e.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), P(this, "afterInit");
            }
            normalize(t, e) {
                let i = t.touches, s = i ? i.length ? i.item(0) : (i.changedTouches ?? t.changedTouches)[0] : t;
                e || (e = this.getChartPosition());
                let o = s.pageX - e.left, r = s.pageY - e.top;
                return S(t, {
                    chartX: Math.round(o /= e.scaleX),
                    chartY: Math.round(r /= e.scaleY)
                });
            }
            onContainerClick(t) {
                let e = this.chart, i = e.hoverPoint, s = this.normalize(t), o = e.plotLeft, r = e.plotTop;
                !e.cancelClick && (i && this.inClass(s.target, "highcharts-tracker") ? (P(i.series, "click", S(s, {
                    point: i
                })), e.hoverPoint && i.firePointEvent("click", s)) : (S(s, this.getCoordinates(s)), e.isInsidePlot(s.chartX - o, s.chartY - r, {
                    visiblePlotOnly: !0
                }) && P(e, "click", s)));
            }
            onContainerMouseDown(t) {
                let e = (1 & (t.buttons || t.button)) == 1;
                t = this.normalize(t), n.isFirefox && 0 !== t.button && this.onContainerMouseMove(t), (void 0 === t.button || e) && (this.zoomOption(t), e && t.preventDefault?.(), this.dragStart(t));
            }
            onContainerMouseLeave(t) {
                let { pointer: e } = eZ[eQ.hoverChartIndex ?? -1] || {};
                t = this.normalize(t), this.onContainerMouseMove(t), e && !this.inClass(t.relatedTarget, "highcharts-tooltip") && (e.reset(), e.chartPosition = void 0);
            }
            onContainerMouseEnter() {
                delete this.chartPosition;
            }
            onContainerMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.normalize(t);
                this.setHoverChartIndex(t), ("mousedown" === e.mouseIsDown || this.touchSelect(s)) && this.drag(s), !e.exporting?.openMenu && (this.inClass(s.target, "highcharts-tracker") || e.isInsidePlot(s.chartX - e.plotLeft, s.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                })) && !i?.shouldStickOnContact(s) && (this.inClass(s.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(s));
            }
            onDocumentTouchEnd(t) {
                this.onDocumentMouseUp(t);
            }
            onContainerTouchMove(t) {
                this.touchSelect(t) ? this.onContainerMouseMove(t) : this.touch(t);
            }
            onContainerTouchStart(t) {
                this.touchSelect(t) ? this.onContainerMouseDown(t) : (this.zoomOption(t), this.touch(t, !0));
            }
            onDocumentMouseMove(t) {
                let e = this.chart, i = e.tooltip, s = this.chartPosition, o = this.normalize(t, s);
                !s || e.isInsidePlot(o.chartX - e.plotLeft, o.chartY - e.plotTop, {
                    visiblePlotOnly: !0
                }) || i?.shouldStickOnContact(o) || o.target !== e.container.ownerDocument && this.inClass(o.target, "highcharts-tracker") || this.reset();
            }
            onDocumentMouseUp(t) {
                t?.touches && this.hasPinchMoved && t?.preventDefault?.(), eZ[eQ.hoverChartIndex ?? -1]?.pointer?.drop(t);
            }
            pinch(t) {
                let e = this, { chart: i, hasZoom: s, lastTouches: o } = e, r = [].map.call(t.touches || [], (t)=>e.normalize(t)), a = r.length, n = 1 === a && (e.inClass(t.target, "highcharts-tracker") && i.runTrackerClick || e.runChartClick), h = 1 === a && (i.tooltip?.options.followTouchMove ?? !0);
                a > 1 ? e.initiated = !0 : h && (e.initiated = !1), s && e.initiated && !n && !1 !== t.cancelable && t.preventDefault(), "touchstart" === t.type ? (e.pinchDown = r, e.res = !0, i.mouseDownX = t.chartX) : h ? this.runPointActions(e.normalize(t)) : o && (P(i, "touchpan", {
                    originalEvent: t,
                    touches: r
                }, ()=>{
                    let s = (t)=>{
                        let e = t[0], i = t[1] || e;
                        return {
                            x: e.chartX,
                            y: e.chartY,
                            width: i.chartX - e.chartX,
                            height: i.chartY - e.chartY
                        };
                    };
                    i.transform({
                        axes: i.axes.filter((t)=>t.zoomEnabled && (this.zoomHor && t.horiz || this.zoomVert && !t.horiz)),
                        to: s(r),
                        from: s(o),
                        trigger: t.type
                    }), e.hasDragged = 1;
                }), e.res && (e.res = !1, this.reset(!1, 0))), e.lastTouches = r;
            }
            reset(t, e) {
                let i = this.chart, s = i.hoverSeries, o = i.hoverPoint, r = i.hoverPoints, a = i.tooltip, n = a?.shared ? r : o;
                t && n && J(n).forEach(function(e) {
                    e.series.isCartesian && void 0 === e.plotX && (t = !1);
                }), t ? a && n && J(n).length && (a.refresh(n), a.shared && r ? r.forEach(function(t) {
                    t.setState(t.state, !0), t.series.isCartesian && (t.series.xAxis.crosshair && t.series.xAxis.drawCrosshair(null, t), t.series.yAxis.crosshair && t.series.yAxis.drawCrosshair(null, t));
                }) : o && (o.setState(o.state, !0), i.axes.forEach(function(t) {
                    t.crosshair && o.series[t.coll] === t && t.drawCrosshair(null, o);
                }))) : (o && o.onMouseOut(), r && r.forEach(function(t) {
                    t.setState();
                }), s && s.onMouseOut(), a && a.hide(e), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), i.axes.forEach(function(t) {
                    t.hideCrosshair();
                }), i.hoverPoints = i.hoverPoint = void 0);
            }
            runPointActions(t, e, i) {
                let s = this.chart, o = s.series, r = s.tooltip?.options.enabled ? s.tooltip : void 0, a = !!r && r.shared, n = e || s.hoverPoint, h = n?.series || s.hoverSeries, l = (!t || "touchmove" !== t.type) && (!!e || h?.directTouch && this.isDirectTouch), d = this.getHoverData(n, h, o, l, a, t);
                n = d.hoverPoint, h = d.hoverSeries;
                let p = d.hoverPoints, g = h?.tooltipOptions.followPointer && !h.tooltipOptions.split, u = a && h && !h.noSharedTooltip;
                if (n && (i || n !== s.hoverPoint || r?.isHidden)) {
                    if ((s.hoverPoints || []).forEach(function(t) {
                        -1 === p.indexOf(t) && t.setState();
                    }), s.hoverSeries !== h && h.onMouseOver(), this.applyInactiveState(p), (p || []).forEach(function(t) {
                        t.setState("hover");
                    }), s.hoverPoint && s.hoverPoint.firePointEvent("mouseOut"), !n.series) return;
                    s.hoverPoints = p, s.hoverPoint = n, n.firePointEvent("mouseOver", void 0, ()=>{
                        r && n && r.refresh(u ? p : n, t);
                    });
                } else if (g && r && !r.isHidden) {
                    let e = r.getAnchor([
                        {}
                    ], t);
                    s.isInsidePlot(e[0], e[1], {
                        visiblePlotOnly: !0
                    }) && r.updatePosition({
                        plotX: e[0],
                        plotY: e[1]
                    });
                }
                this.unDocMouseMove || (this.unDocMouseMove = c(s.container.ownerDocument, "mousemove", (t)=>eZ[eQ.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(t)), this.eventsToUnbind.push(this.unDocMouseMove)), s.axes.forEach(function(e) {
                    let i, o = e.crosshair?.snap ?? !0;
                    o && ((i = s.hoverPoint) && i.series[e.coll] === e || (i = D(p, (t)=>t.series?.[e.coll] === e))), i || !o ? e.drawCrosshair(t, i) : e.hideCrosshair();
                });
            }
            setDOMEvents() {
                let t = this.chart.container, e = t.ownerDocument, i = (t)=>t.parentElement || t.getRootNode()?.host?.parentElement;
                t.onmousedown = this.onContainerMouseDown.bind(this), t.onmousemove = this.onContainerMouseMove.bind(this), t.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(c(t, "mouseenter", this.onContainerMouseEnter.bind(this)), c(t, "mouseleave", this.onContainerMouseLeave.bind(this))), eQ.unbindDocumentMouseUp.some((t)=>t.doc === e) || eQ.unbindDocumentMouseUp.push({
                    doc: e,
                    unbind: c(e, "mouseup", this.onDocumentMouseUp.bind(this))
                });
                let s = i(this.chart.renderTo);
                for(; s && "BODY" !== s.tagName;)this.eventsToUnbind.push(c(s, "scroll", ()=>{
                    delete this.chartPosition;
                })), s = i(s);
                this.eventsToUnbind.push(c(t, "touchstart", this.onContainerTouchStart.bind(this), {
                    passive: !1
                }), c(t, "touchmove", this.onContainerTouchMove.bind(this), {
                    passive: !1
                })), eQ.unbindDocumentTouchEnd || (eQ.unbindDocumentTouchEnd = c(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                    passive: !1
                })), this.setPointerCapture(), c(this.chart, "redraw", this.setPointerCapture.bind(this));
            }
            setPointerCapture() {
                if (!eq) return;
                let t = this.pointerCaptureEventsToUnbind, e = this.chart, i = e.container, s = (e.options.tooltip?.followTouchMove ?? !0) && e.series.some((t)=>t.options.findNearestPointBy.indexOf("y") > -1);
                !this.hasPointerCapture && s ? (t.push(c(i, "pointerdown", (t)=>{
                    t.target?.hasPointerCapture(t.pointerId) && t.target?.releasePointerCapture(t.pointerId);
                }), c(i, "pointermove", (t)=>{
                    e.pointer?.getPointFromEvent(t)?.onMouseOver(t);
                })), this.hasPointerCapture = !0) : this.hasPointerCapture && !s && (t.forEach((t)=>t()), t.length = 0, this.hasPointerCapture = !1);
            }
            setHoverChartIndex(t) {
                let e = this.chart, i = n.charts[eQ.hoverChartIndex ?? -1];
                if (i && i !== e) {
                    let s = {
                        relatedTarget: e.container
                    };
                    t && !t?.relatedTarget && Object.assign({}, t, s), i.pointer?.onContainerMouseLeave(t || s);
                }
                i?.mouseIsDown || (eQ.hoverChartIndex = e.index);
            }
            touch(t, e) {
                let i, { chart: s, pinchDown: o = [] } = this;
                this.setHoverChartIndex(), 1 === (t = this.normalize(t)).touches.length ? s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop, {
                    visiblePlotOnly: !0
                }) && !s.exporting?.openMenu ? (e && this.runPointActions(t), "touchmove" === t.type && (this.hasPinchMoved = i = !!o[0] && Math.pow(o[0].chartX - t.chartX, 2) + Math.pow(o[0].chartY - t.chartY, 2) >= 16), (i ?? !0) && this.pinch(t), this.hasPointerCapture && "touchmove" === t.type && !(s.scrollablePixelsX || s.scrollablePixelsY) && t.preventDefault()) : e && this.reset() : 2 === t.touches.length && this.pinch(t);
            }
            touchSelect(t) {
                return !!(this.chart.zooming.singleTouch && t.touches && 1 === t.touches.length);
            }
            zoomOption(t) {
                let e = this.chart, i = e.inverted, s = e.zooming.type || "", o, r;
                /touch/.test(t.type) && (s = e.zooming.pinchType ?? s), this.zoomX = o = /x/.test(s), this.zoomY = r = /y/.test(s), this.zoomHor = o && !i || r && i, this.zoomVert = r && !i || o && i, this.hasZoom = (o || r) && eJ(t, e.zooming.key);
            }
        }
        eQ.unbindDocumentMouseUp = [], (iu = eQ || (eQ = {})).compose = function(t) {
            _(eK, "Core.Pointer") && c(t, "beforeRender", function() {
                this.pointer = new iu(this, this.options);
            });
        };
        let e0 = eQ, { setLength: e1, splice: e2 } = {
            convertToNumber: function(t, e) {
                switch(typeof t){
                    case "boolean":
                        return +!!t;
                    case "number":
                        return isNaN(t) && !e ? null : t;
                    default:
                        return isNaN(t = parseFloat(`${t ?? ""}`)) && !e ? null : t;
                }
            },
            setLength: function(t, e, i) {
                return Array.isArray(t) ? (t.length = e, t) : t[i ? "subarray" : "slice"](0, e);
            },
            splice: function(t, e, i, s, o = []) {
                if (Array.isArray(t)) return Array.isArray(o) || (o = Array.from(o)), {
                    removed: t.splice(e, i, ...o),
                    array: t
                };
                let r = Object.getPrototypeOf(t).constructor, a = t[s ? "subarray" : "slice"](e, e + i), n = new r(t.length - i + o.length);
                return n.set(t.subarray(0, e), 0), n.set(o, e), n.set(t.subarray(e + i), e + o.length), {
                    removed: a,
                    array: n
                };
            }
        }, e5 = class {
            constructor(t = {}){
                this.isDataTable = !0;
                let e = this.isPollutingKey(t.id) ? void 0 : t.id;
                this.autoId = !e, this.columns = {}, this.id = e || tn(), this.rowCount = 0, this.versionTag = tn();
                let i = 0;
                j(t.columns || {}, (t, e)=>{
                    "__proto__" !== e && "constructor" !== e && (this.columns[e] = t.slice(), i = Math.max(i, t.length));
                }), this.applyRowCount(i);
            }
            isPollutingKey(t) {
                return "__proto__" === t || "constructor" === t;
            }
            applyRowCount(t) {
                this.rowCount = t, j(this.columns, (e, i)=>{
                    e.length !== t && (this.columns[i] = e1(e, t));
                });
            }
            deleteRows(t, e = 1) {
                if (e > 0 && t < this.rowCount) {
                    let i = 0;
                    j(this.columns, (s, o)=>{
                        this.columns[o] = e2(s, t, e).array, i = s.length;
                    }), this.rowCount = i;
                }
                P(this, "afterDeleteRows", {
                    rowIndex: t,
                    rowCount: e
                }), this.versionTag = tn();
            }
            getColumn(t, e) {
                return this.columns[t];
            }
            getColumns(t, e) {
                return (t || Object.keys(this.columns)).reduce((t, e)=>(t[e] = this.columns[e], t), {});
            }
            getRowObject(t, e) {
                let i = {}, s = this.columns;
                for (let o of (e ?? (e = Object.keys(this.columns)), e))i[o] = s[o]?.[t];
                return i;
            }
            setColumn(t, e = [], i = 0, s) {
                this.setColumns({
                    [t]: e
                }, i, s);
            }
            setColumns(t, e, i) {
                let s = this.rowCount;
                j(t, (t, e)=>{
                    "__proto__" !== e && "constructor" !== e && (this.columns[e] = t.slice(), s = t.length);
                }), this.applyRowCount(s), i?.silent || (P(this, "afterSetColumns"), this.versionTag = tn());
            }
            setRow(t, e = this.rowCount, i, s) {
                let { columns: o } = this, r = i ? this.rowCount + 1 : e + 1, a = Object.keys(t);
                if (s?.addColumns !== !1) for(let t = 0, e = a.length; t < e; t++){
                    let e = a[t];
                    this.isPollutingKey(e) || Object.hasOwnProperty.call(o, e) || (o[e] = Array(this.rowCount));
                }
                j(o, (s, r)=>{
                    s && (i ? s = e2(s, e, 0, !0, [
                        t[r]
                    ]).array : s[e] = r in t ? t[r] : s[e], o[r] = s);
                }), this.applyRowCount(Math.max(r, this.rowCount)), s?.silent || (P(this, "afterSetRows", {
                    rowIndex: e
                }), this.versionTag = tn());
            }
            getModified() {
                return this.modified || this;
            }
        };
        var e3, e9, e6, e4, e8, e7, it, ie, ii, is, io, ir, ia, ih, il, id, ic, ip, ig, iu, im, ix, iy, ib, iv = ie || (ie = {});
        function ik(t, e, i) {
            let s = this.legendItem = this.legendItem || {}, { chart: o, options: r } = this, { baseline: a = 0, symbolWidth: n, symbolHeight: h } = t, l = this.symbol || "circle", d = h / 2, c = o.renderer, p = s.group, g = a - Math.round((t.fontMetrics?.b || h) * (i ? .4 : .3)), u = {}, f, m = r.marker, x = 0;
            if (o.styledMode || (u["stroke-width"] = Math.min(r.lineWidth || 0, 24), r.dashStyle ? u.dashstyle = r.dashStyle : "square" !== r.linecap && (u["stroke-linecap"] = "round")), s.line = c.path().addClass("highcharts-graph").attr(u).add(p), i && (s.area = c.path().addClass("highcharts-area").add(p)), u["stroke-linecap"] && (x = Math.min(s.line.strokeWidth(), n) / 2), n) {
                let t = [
                    [
                        "M",
                        x,
                        g
                    ],
                    [
                        "L",
                        n - x,
                        g
                    ]
                ];
                s.line.attr({
                    d: t
                }), s.area?.attr({
                    d: [
                        ...t,
                        [
                            "L",
                            n - x,
                            a
                        ],
                        [
                            "L",
                            x,
                            a
                        ]
                    ]
                });
            }
            if (m && !1 !== m.enabled && n) {
                let t = Math.min(m.radius ?? d, d);
                0 === l.indexOf("url") && (m = F(m, {
                    width: h,
                    height: h
                }), t = 0), s.symbol = f = c.symbol(l, n / 2 - t, g - t, 2 * t, 2 * t, S({
                    context: "legend"
                }, m)).addClass("highcharts-point").add(p), f.isMarker = !0;
            }
        }
        iv.areaMarker = function(t, e) {
            ik.call(this, t, e, !0);
        }, iv.lineMarker = ik;
        let iw = ie, { defaultOptions: iM } = tm;
        var iC = ii || (ii = {});
        function iS(t, e) {
            let i = iM.plotOptions || {}, s = e.defaultOptions, o = e.prototype;
            return o.type = t, o.pointClass || (o.pointClass = e_), !iC.seriesTypes[t] && (s && (i[t] = s), iC.seriesTypes[t] = e, !0);
        }
        iC.seriesTypes = n.seriesTypes, iC.registerSeriesType = iS, iC.seriesType = function(t, e, i, s, o) {
            let r = iM.plotOptions || {};
            if (e = e || "", r[t] = F(r[e], i), delete iC.seriesTypes[t], iS(t, T(iC.seriesTypes[e] || n.Series, s)), iC.seriesTypes[t].prototype.type = t, o) {
                class e extends e_ {
                }
                S(e.prototype, o), iC.seriesTypes[t].prototype.pointClass = e;
            }
            return iC.seriesTypes[t];
        };
        let iT = ii, { defaultOptions: iP } = tm, { registerEventOptions: iA } = eb, { svg: iL, win: iO } = n, { seriesTypes: iE } = iT, { format: iI } = tF;
        class iD {
            constructor(){
                this.zoneAxis = "y";
            }
            init(t, e) {
                let i;
                P(this, "init", {
                    options: e
                });
                let s = t.series;
                this.eventsToUnbind = [], this.condemnedPoints || (this.condemnedPoints = []), this.chart = t, this.options = this.setOptions(e);
                let o = this.options, r = !1 !== o.visible;
                this.dataTable ?? (this.dataTable = H(o.dataTable) ? new e5 : o.dataTable?.isDataTable ? o.dataTable : new e5(o.dataTable)), this.linkedSeries = [], this.bindAxes(), S(this, {
                    name: o.name,
                    state: "",
                    visible: r,
                    selected: !0 === o.selected
                }), iA(this, o);
                let a = o.events;
                (a?.click || o.point?.events?.click || o.allowPointSelect) && (t.runTrackerClick = !0), this.getColor(), this.getSymbol(), this.isCartesian && (t.hasCartesianSeries = !0), s.length && (i = s[s.length - 1]), this._i = (i?._i ?? -1) + 1, this.opacity = this.options.opacity, t.orderItems("series", tr(this, s)), this.points || this.data || this.setData(o.data, !1), P(this, "afterInit");
            }
            is(t) {
                return iE[t] && this instanceof iE[t];
            }
            bindAxes() {
                let t, e = this, i = e.options, s = e.chart;
                P(this, "bindAxes", null, function() {
                    (e.axisTypes || []).forEach(function(o) {
                        (s[o] || []).forEach(function(s) {
                            t = s.options, ((i[o] ?? 0) === s.index || void 0 !== i[o] && i[o] === t.id) && (tr(e, s.series), e[o] = s, s.isDirty = !0);
                        }), e[o] || e.optionalAxis === o || to(18, !0, s);
                    });
                }), P(this, "afterBindAxes");
            }
            hasData() {
                return this.visible && void 0 !== this.dataMax && void 0 !== this.dataMin || this.visible && this.dataTable.rowCount > 0;
            }
            hasMarkerChanged(t, e) {
                let i = t.marker, s = e.marker;
                return i && s && (s.enabled && !i.enabled || s.symbol !== i.symbol || s.height !== i.height || s.width !== i.width);
            }
            autoIncrement(t) {
                let e, i = this.options, { pointIntervalUnit: s, relativeXValue: o } = this.options, r = this.chart.time, a = this.xIncrement ?? r.parse(i.pointStart) ?? 0;
                if (this.pointInterval = e = this.pointInterval ?? i.pointInterval ?? 1, o && N(t) && (e *= t), s) {
                    let t = r.toParts(a);
                    "day" === s ? t[2] += e : "month" === s ? t[1] += e : "year" === s && (t[0] += e), e = r.makeTime.apply(r, t) - a;
                }
                return o && N(t) ? a + e : (this.xIncrement = a + e, a);
            }
            setOptions(t) {
                let e, i = this.chart, s = i.options.plotOptions, o = i.userOptions || {}, r = F(t), a = i.styledMode, n = {
                    plotOptions: s,
                    userOptions: r
                };
                P(this, "setOptions", n);
                let h = n.plotOptions[this.type], l = o.plotOptions || {}, d = l.series || {}, c = iP.plotOptions[this.type] || {}, p = l[this.type] || {};
                h.dataLabels = this.mergeArrays(c.dataLabels, h.dataLabels), this.userOptions = n.userOptions;
                let g = F(h, s.series, p, r), { negativeColor: u, negativeFillColor: f, zoneAxis: m = "y", zones: x } = g, y = (x || []).map((t)=>({
                        ...t
                    }));
                return this.tooltipOptions = F(iP.tooltip, iP.plotOptions.series?.tooltip, c?.tooltip, i.userOptions.tooltip, l.series?.tooltip, p.tooltip, r.tooltip), this.stickyTracking = r.stickyTracking ?? p.stickyTracking ?? d.stickyTracking ?? (!!this.tooltipOptions.shared && !this.noSharedTooltip || g.stickyTracking), null === h.marker && delete g.marker, this.zones || (this.zones = y), this.zoneAxis = m, (u || f) && !x && (e = {
                    value: g[m + "Threshold"] || g.threshold || 0,
                    className: "highcharts-negative"
                }, a || ("boolean" != typeof u && (e.color = u), e.fillColor = f), y.push(e)), y.length && v(y[y.length - 1].value) && y.push(a ? {} : {
                    color: this.color,
                    fillColor: this.fillColor
                }), P(this, "afterSetOptions", {
                    options: g
                }), g;
            }
            getName() {
                let { chart: t, options: e } = this, { dataMapping: i, name: s } = e, o = i?.y || i?.value, r = W(o) ? o : o?.column;
                return s ?? (W(r) ? r : iI(t.options.lang.seriesName, this, t));
            }
            getCyclic(t, e, i) {
                let s, o, r = this.chart, a = `${t}Index`, n = `${t}Counter`, h = i?.length || r.options.chart.colorCount;
                !e && (v(o = "color" === t ? this.options.colorIndex ?? this[a] : this[a]) ? s = o : (r.series.length || (r[n] = 0), s = r[n] % h, r[n] += 1), i && (e = i[s])), void 0 !== s && (this[a] = s), this[t] = e;
            }
            getColor() {
                let t = this.chart;
                t.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "var(--highcharts-neutral-color-20)" : this.getCyclic("color", this.options.color || iP.plotOptions[this.type]?.color, t.options.colors);
            }
            getPointsCollection() {
                return (this.hasGroupedData ? this.points : this.data) || [];
            }
            getSymbol() {
                let t = this.options.marker;
                this.getCyclic("symbol", t?.symbol, this.chart.options.symbols);
            }
            getColumn(t, e, i) {
                let s = e ? this.dataTable.getModified() : this.dataTable, o = s.rowCount, r = this.dataTable !== s, a = s.getColumn(t, !0);
                if ("x" === t && !r) {
                    if (this.xColumn) return this.xColumn;
                    let t = s.getColumn("name", !0), e = this.options, i = (t)=>{
                        if (void 0 !== this.xColumnIsNumbers) return this.xColumnIsNumbers;
                        for (let e of t)if ("number" != typeof e) return this.xColumnIsNumbers = !1;
                        return this.xColumnIsNumbers = !0;
                    };
                    if (this.xIncrement = null, !a || this.xAxis?.hasNames || e.relativeXValue || a.length < (e.turboThreshold || 1 / 0) && !this.boosted && !i(a)) {
                        let e = [];
                        for(let i = 0; i < o; i++){
                            let s = a?.[i];
                            v(s) || (this.xIncrement ?? (this.xIncrement = e[e.length - 1] ?? null)), e.push(this.getX(s, t?.[i]));
                        }
                        return this.xColumn = e;
                    }
                }
                return a || Array(i ? o : 0);
            }
            getX(t, e) {
                return this.xAxis?.hasNames && this.dataTable.getColumn("name", !0) && v(e) ? this.xAxis.nameToX({
                    name: e,
                    series: this
                }, t) : void 0 === t || N(t) && this.options.relativeXValue ? this.autoIncrement(t) : ("string" == typeof t && N(t = this.chart.time.parse(t)), t);
            }
            matchPoints(t, e, i, s) {
                let { dataTable: o, options: r, requireSorting: a } = this, n = r.dataSorting, h = this.data, l = [], d = [], c = o.rowCount === h.length, p, u, f, m = 0, x = !0;
                this.xIncrement = null, delete this.xColumn;
                let y = o.getColumn("x"), b = o.getColumn("id"), k = n?.matchByName ? o.getColumn("name") : void 0, w = o.getColumn("index");
                for(u = 0; u < o.rowCount; u++){
                    let r = y?.[u], g = b?.[u], f = k?.[u], x = w?.[u], [M, C] = g && e ? [
                        g,
                        e
                    ] : f && i ? [
                        f,
                        i
                    ] : v(x) && s ? [
                        x,
                        s
                    ] : v(r) && t ? [
                        r,
                        t
                    ] : [], S = -1;
                    if (C) {
                        if (-1 === (S = C.indexOf(M, m))) {
                            let e = y?.[u], i = t?.length ?? o.rowCount;
                            for(; i && t && "number" == typeof e && t[i - 1] > e;)i--;
                            l.push({
                                newIndex: i,
                                oldIndex: u
                            });
                        } else h[S] && (d.push({
                            newIndex: S,
                            oldIndex: u
                        }), h[S].touched = !0, a && (m = S + 1));
                        (!c || u !== S || n?.enabled || this.hasDerivedData) && (p = !0);
                    } else l.push({
                        newIndex: u,
                        oldIndex: u
                    });
                }
                if (p) {
                    for(d.forEach((t)=>{
                        h[t.newIndex].applyOptions(o.getRowObject(t.oldIndex));
                    }), l.sort((t, e)=>e.newIndex - t.newIndex), l.forEach((t)=>{
                        h.splice(t.newIndex, 0, void 0);
                    }), u = h.length; u--;)(f = h[u]) && !f.touched && (f.destroy(), h.splice(u, 1));
                    this.isDirtyData = this.isDirty = !0;
                } else if (c && !n?.enabled) {
                    for(u = 0; u < o.rowCount; u++)if (!h[u].destroyed && !h[u].condemned) {
                        let t = o.getRowObject(u);
                        t && (Object.keys(t).forEach((e)=>{
                            void 0 === t[e] && delete t[e];
                        }), Object.keys(t).length && h[u].update(t, !1, void 0, !1));
                    }
                } else x = !1;
                if (h.forEach((t)=>{
                    t && (t.touched = !1);
                }), !x) return !1;
                let M = this.getColumn("x");
                return null === this.xIncrement && M.length && (this.xIncrement = g(M), this.autoIncrement()), !0;
            }
            getDataColumnKeys() {
                return this.dataColumnKeys || [
                    "x",
                    ...this.pointArrayMap || [
                        "y"
                    ]
                ];
            }
            setData(t, e = !0, i, s) {
                let o, r, a, n = this.dataTable, h = this.options, l = this.points, d = l?.length || 0, c = n.getColumn("x"), p = n.getColumn("id"), g = h.dataSorting?.matchByName && l?.map((t)=>t.name) || n.getColumn("name"), u = n.getColumn("index"), f = this.chart, m = this.xAxis;
                if (f.options.chart.allowMutatingData || (h.data && delete this.options.data, this.userOptions.data && delete this.userOptions.data, a = F(!0, t)), t = a || t, this.xIncrement = null, delete this.xColumn, delete this.xColumnIsNumbers, n !== h.dataTable && delete n.columns.x, this.colorCounter = 0, H(t) ? this.setDataFromArray(t) : this.setDataFromTable(t), !1 === s || !d || this.cropped || this.hasGroupedData || !this.visible || this.boosted || (o = this.matchPoints(c, p, g, u)), !o) {
                    for(W(this.getColumn("y")[0]) && to(14, !0, f), this.data = [], r = d; r--;)l[r]?.destroy();
                    m && (m.minRange = m.userMinRange), this.isDirty = f.isDirtyBox = !0, this.isDirtyData = !!l, i = !1;
                }
                H(t) && (this.options.data = this.userOptions.data = t), "point" === h.legendType && (this.processData(), this.generatePoints()), e && f.redraw(i);
            }
            setDataFromArray(t) {
                let e = t.length, { keys: i, turboThreshold: s } = this.options, { pointValKey: o = "y", pointArrayMap: r = [] } = this, a = r.length, n = this.dataTable, h = this.getDataColumnKeys(), l = s && e > s, d = 0, c = 1;
                if (l) {
                    let s = this.getFirstValidPoint(t), p = this.getFirstValidPoint(t, e - 1, -1), g = (t)=>!!(H(t) && (i || N(t[0])));
                    if (N(s) && N(p)) n.setColumn(o, t);
                    else if (g(s) && g(p)) {
                        if (a) {
                            let e = s.length === a, i = Array(s.length).fill(0).map(()=>[]);
                            for (let e of t)for(let t = 0; t <= a; t++)i[t]?.push(e[t]);
                            n.setColumns((e ? r : h).reduce((t, e, s)=>(t[e] = i[s], t), {}));
                        } else {
                            i && (d = i.indexOf("x"), c = i.indexOf("y"), d = d >= 0 ? d : 0, c = c >= 0 ? c : 1), 1 === s.length && (c = 0);
                            let e = [], r = [];
                            if (d === c) {
                                for (let e of t)r.push(e[c]);
                                n.setColumn(o, r);
                            } else {
                                for (let i of t)e.push(i[d]), r.push(i[c]);
                                n.setColumns({
                                    x: e,
                                    [o]: r
                                });
                            }
                        }
                    } else l = !1;
                }
                if (!l) {
                    let i = {};
                    for(let s = 0; s < e; s++){
                        let o = this.pointClass.prototype.optionsToObject.call({
                            series: this
                        }, t[s]);
                        for (let t of Object.keys(o))"__proto__" !== t && "constructor" !== t && (Object.hasOwnProperty.call(i, t) || (i[t] = Array(e)), i[t][s] = o[t]);
                    }
                    e ? n.setColumns(i) : n.deleteRows(0, n.rowCount);
                }
            }
            setDataFromTable(t) {
                let { chart: e, options: i, dataTable: s } = this, o = e.getDataTable(i), r = t ? [
                    t
                ] : o.length ? o : e.dataTable, a = this.getDataColumnKeys(), n = i.dataMapping, h = a.slice();
                n && (Object.keys(n).forEach((t)=>{
                    _(h, t);
                }), this.dataColumnKeys = h), r.forEach((t, e)=>{
                    let i = h.reduce((i, s)=>{
                        let o = n?.[s], r = t.columns || {}, a = t.id, h = W(o) ? 0 === e && r[o] : ((o?.dataTable || 0) === e || a && o?.dataTable === a) && (N(o?.column) ? Object.values(r)[o.column] : r[o?.column || s]);
                        return h && (i[s] = h), i;
                    }, {});
                    (n || t) && s.setColumns(i), t.isDataTable && this.bindDataTableEvents(t, i);
                });
            }
            bindDataTableEvents(t, e) {
                if (this.hasBoundDataTableEvents) return;
                let { chart: i, eventsToUnbind: s } = this, o = ()=>{
                    clearTimeout(i.redrawTimeout), i.redrawTimeout = setTimeout(()=>i.renderer && i.redraw(), 0);
                };
                s.push(c(t, "afterSetRows", (t)=>{
                    let i = t.rowIndex;
                    if (N(i)) {
                        let t = e5.prototype.getRowObject.call({
                            columns: e
                        }, i), s = this.data[i];
                        t && (this.currentDataGrouping ? this.setData() : (s ? s.update(t, !1) : this.addPoint(t, !1), o()));
                    }
                })), s.push(c(t, "afterDeleteRows", (t)=>{
                    let { rowCount: e, rowIndex: i } = t;
                    if (N(i)) {
                        for(let t = i + e - 1; t >= i; t--)this.removePoint(t, !1);
                        o();
                    }
                })), s.push(c(t, "afterSetColumns", (t)=>{
                    this.setData(t.target);
                })), this.hasBoundDataTableEvents = !0;
            }
            getProcessedData(t) {
                let e = this, { dataTable: i, isCartesian: s, options: o, xAxis: r } = e, a = o.cropThreshold, n = t || e.getExtremesFromAll, h = r?.logarithmic, l = i.rowCount, d, c, p = 0, g, u, f, m = e.getColumn("x"), x = i, y = !1;
                return r && (u = (g = r.getExtremes()).min, f = g.max, y = !!(r.categories && !r.names.length), s && e.sorted && !n && (!a || l > a || e.forceCrop) && (m[l - 1] < u || m[0] > f ? x = new e5 : e.getColumn(e.pointValKey || "y").length && (m[0] < u || m[l - 1] > f) && (x = (d = this.cropData(i, u, f)).modified, p = d.start, c = !0))), x !== i && (m = x.getColumn("x", !0) || []), {
                    modified: x,
                    cropped: c,
                    cropStart: p,
                    closestPointRange: L([
                        h ? m.map(h.log2lin) : m
                    ], ()=>e.requireSorting && !y && to(15, !1, e.chart))
                };
            }
            processData(t) {
                let e = this.xAxis, i = this.dataTable;
                if (this.isCartesian && !this.isDirty && !e.isDirty && !this.yAxis.isDirty && !t) return !1;
                let s = this.getProcessedData();
                i.modified = s.modified, this.cropped = s.cropped, this.cropStart = s.cropStart, this.closestPointRange = this.basePointRange = s.closestPointRange, P(this, "afterProcessData");
            }
            cropData(t, e, i) {
                let s = t === this.dataTable ? this.getColumn("x") : t.getColumn("x", !0), o = s.length, r, a, n = 0, h = o;
                for(r = 0; r < o; r++)if (s[r] >= e) {
                    n = Math.max(0, r - 1);
                    break;
                }
                for(a = r; a < o; a++)if (s[a] > i) {
                    h = a + 1;
                    break;
                }
                let l = Object.keys(t.columns).reduce((e, i)=>(e[i] = (t.getColumn(i, !0) || []).slice(n, h), e), {});
                return l.x = s.slice(n, h), {
                    modified: new e5({
                        columns: l
                    }),
                    start: n,
                    end: h
                };
            }
            generatePoints() {
                let t = this.options, e = this.hasProcessedDataTable ? void 0 : t.data, i = this.dataTable.getModified(), s = this.getColumn("x", !0), o = this.pointClass, r = i.rowCount, a = this.cropStart || 0, n = this.hasGroupedData, h = t.keys, l = [], d = t.dataGrouping?.groupAll ? a : 0, c = this.getDataColumnKeys(), p, g, u, f, m = this.data, x;
                if (!m && !n) {
                    let t = [];
                    t.length = e?.length || 0, m = this.data = t;
                }
                for(h && n && (this.options.keys = !1), f = 0; f < r; f++)g = a + f, n ? ((u = new o(this, i.getRowObject(f, c))).dataGroup = this.groupMap?.[d + f], u.dataGroup?.options && (u.options = u.dataGroup.options, S(u, u.dataGroup.options), delete u.dataLabels, u.key = u.name ?? u.category)) : (u = m[g], x = e ? e[g] : i.getRowObject(f), u || void 0 === x ? u && (u.category = this.xAxis?.categories?.[u.x] ?? u.x, u.key = u.name ?? u.category) : m[g] = u = new o(this, x, s[f])), u && (u.index = n ? d + f : g, l[f] = u);
                if (this.options.keys = h, m && (r !== (p = m.length) || n)) for(f = 0; f < p; f++)f !== a || n || (f += r), m[f] && (m[f].destroyElements(), m[f].plotX = void 0);
                this.data = m, this.points = l, P(this, "afterGeneratePoints");
            }
            getXExtremes(t) {
                return {
                    min: p(t),
                    max: g(t)
                };
            }
            getExtremes(t, e) {
                let { options: i, xAxis: s, yAxis: o } = this, r = e || this.getExtremesFromAll || i.getExtremesFromAll, a = r && this.cropped ? this.dataTable : this.dataTable.getModified(), n = a.rowCount, h = t || this.stackedYData, l = h ? [
                    h
                ] : (this.keysAffectYAxis || this.pointArrayMap || [
                    "y"
                ])?.map((t)=>a.getColumn(t, !0) || []) || [], d = this.getColumn("x", !0), c = [], u = this.requireSorting && !this.is("column") ? 1 : 0, f = i.cumulative && i.cumulativeStart && u && !r, m = !!o && o.positiveValuesOnly, x = r || this.cropped || !s, y, b, v, k = 0, w = 0;
                for(s && (k = (y = s.getExtremes()).min, w = y.max), v = 0; v < n; v++)if (b = d[v], (x || (d[v + u] || b) >= k && (d[v - u] || b) <= w) && (!f || b >= k)) for (let t of l){
                    let e = t[v];
                    N(e) && (e > 0 || !m) && c.push(e);
                }
                let M = {
                    activeYData: c,
                    dataMin: p(c),
                    dataMax: g(c)
                };
                return P(this, "afterGetExtremes", {
                    dataExtremes: M
                }), M;
            }
            applyExtremes() {
                let t = this.getExtremes();
                return this.dataMin = t.dataMin, this.dataMax = t.dataMax, t;
            }
            getFirstValidPoint(t, e = 0, i = 1) {
                let s = t.length, o = e;
                for(; o >= 0 && o < s;){
                    if (v(t[o])) return t[o];
                    o += i;
                }
            }
            translate() {
                this.generatePoints();
                let { hasRendered: t, options: e, xAxis: i, yAxis: s } = this, { stacking: o, threshold: r } = e, { polar: a } = this.chart, n = this.points.concat(this.condemnedPoints), h = n.length, l = this.pointPlacementToXValue(), d = !!l, c = e.startFromThreshold ? r : 0, p = e?.nullInteraction && s.len, g, u, x, y, b = Number.MAX_VALUE;
                function k(t) {
                    return f(t, -1000000000, 1e9);
                }
                let w = (t, e)=>{
                    let s = i.translate(t, !1, !1, e, !0, l);
                    return N(s) ? m(k(s)) : void 0;
                }, M = (t, e, i)=>{
                    if (N(t) && void 0 !== e.plotX) {
                        let e = s.translate(t, !1, !0, i, !0);
                        return N(e) ? k(e) : void 0;
                    }
                    if (!N(t) && p) return p;
                };
                for(g = 0; g < h; g++){
                    let e = n[g], h = e.x, p, f, C = e.y, S = e.low, T = o && s.stacking?.stacks[(this.negStacks && C < (c ? 0 : r) ? "-" : "") + this.stackKey];
                    e.plotX = u = w(h), o && this.visible && T && T[h] && (y = this.getStackIndicator(y, h, this.index), !e.isNull && y.key && (f = (p = T[h]).points[y.key]), p && H(f) && (S = f[0], C = f[1], S === c && y.key === T[h].base && (S = N(r) ? r : s.min), s.positiveValuesOnly && v(S) && S <= 0 && (S = void 0), e.total = e.stackTotal = p.total ?? void 0, e.percentage = v(e.y) && p.total ? e.y / p.total * 100 : void 0, e.stackY = C, this.irregularWidths || p.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), e.yBottom = v(S) ? k(s.translate(S, !1, !0, !1, !0)) : void 0, this.dataModify && (C = this.dataModify.modifyValue(C, g)), e.plotY = M(C, e), e.origin = !t || e.graphic || a ? void 0 : {
                        x: w(h, !0),
                        y: M(C, e, !0)
                    }, e.isInside = this.isPointInside(e), e.clientX = d ? m(i.translate(h, !1, !1, !1, !0, l)) : u, e.negative = (e.y || 0) < (r || 0), !e.isNull && !1 !== e.visible && N(u) && (N(x) && (b = Math.min(b, Math.abs(u - x))), x = u), e.zone = this.zones.length ? e.getZone() : void 0;
                }
                this.closestPointRangePx = b, P(this, "afterTranslate");
            }
            getValidPoints(t, e, i) {
                let s = this.chart;
                return (t || this.points || []).filter(function(t) {
                    let { plotX: o, plotY: r } = t;
                    return (!!i || !t.isNull && !!N(r)) && (!e || !!s.isInsidePlot(o, r, {
                        inverted: s.inverted
                    })) && !1 !== t.visible;
                });
            }
            getSharedClipKey() {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
            }
            setClip() {
                let { chart: t, group: e, markerGroup: i, options: s, plotClipGroup: o } = this, r = t.sharedClips, a = t.renderer, n = t.getClipBox(this), h = s.clip ?? !0, l = this.getSharedClipKey(), d = r[l];
                d ? d.animate(n) : r[l] = d = a.clipRect(n), e?.clip(h ? d : void 0), i?.clip(), o?.clip(h && this.yAxis?.clippable ? t.plotClipInner : void 0);
            }
            animate(t) {
                let { chart: e, group: i, markerGroup: s } = this, o = e.inverted, r = tS(this.options.animation), a = [
                    this.getSharedClipKey(),
                    r.duration,
                    r.easing,
                    r.defer
                ].join(","), n = e.sharedClips[a], h = e.sharedClips[a + "m"];
                if (t && i) {
                    let t = e.getClipBox(this);
                    if (n) n.attr("height", t.height);
                    else {
                        t.width = 0, o && (t.x = e.plotHeight), n = e.renderer.clipRect(t), e.sharedClips[a] = n;
                        let i = {
                            x: -99,
                            y: -99,
                            width: o ? e.plotWidth + 199 : 99,
                            height: o ? 99 : e.plotHeight + 199
                        };
                        h = e.renderer.clipRect(i), e.sharedClips[a + "m"] = h;
                    }
                    i.clip(n), s?.clip(h);
                } else if (n && !n.hasClass("highcharts-animating")) {
                    let t = e.getClipBox(this), i = r.step;
                    (s?.element.childNodes.length || e.series.length > 1) && (r.step = function(t, e) {
                        i && i.apply(e, arguments), "width" === e.prop && h?.element && h.attr(o ? "height" : "width", t + 99);
                    }), n.addClass("highcharts-animating").animate(t, r);
                }
            }
            afterAnimate() {
                this.setClip(), j(this.chart.sharedClips, (t, e, i)=>{
                    t && !this.chart.container.querySelector(`[clip-path="url(#${t.id})"]`) && (t.destroy(), delete i[e]);
                }), this.finishedAnimating = !0, P(this, "afterAnimate");
            }
            drawPoints(t) {
                let e, i, s, o, r, a, n;
                t || (t = this.points.concat(this.condemnedPoints));
                let h = this.chart, l = h.styledMode, { colorAxis: d, options: c } = this, p = c.marker || {}, g = c.nullInteraction, u = this[this.specialGroup || "markerGroup"], f = this.xAxis, m = p.enabled ?? (!f || !!f.isRadial || null) ?? (this.closestPointRangePx ?? -1 / 0) >= (p.enabledThreshold ?? 2) * p.radius;
                if (!1 !== p.enabled || this._hasPointMarkers) for(e = 0; e < t.length; e++){
                    o = (s = (i = t[e]).graphic) ? "animate" : "attr", r = i.marker || {}, a = !!i.marker;
                    let c = i.isNull;
                    if ((m && !v(r.enabled) || r.enabled) && (!c || g) && !1 !== i.visible) {
                        let t = r.symbol ?? this.symbol ?? "rect";
                        n = this.markerAttribs(i, i.selected ? "select" : "");
                        let e = !1 !== i.isInside;
                        if (!s && e && ((n.width || 0) > 0 || i.hasImage) && (i.graphic = s = h.renderer.symbol(t, n.x, n.y, n.width, n.height, a ? r : p).add(u), i.origin)) {
                            let t = i.getOrigin(i.origin, n);
                            l || (t.opacity = 0), s.attr(t), o = "animate";
                        }
                        if (s) {
                            "animate" === o && s?.animate(n);
                            let t = this.pointAttribs(i, l || !i.selected ? void 0 : "select");
                            l ? d && s.css({
                                fill: t.fill
                            }) : s[o](t), s.addClass(i.getClassName(), !0);
                        }
                    } else s && (i.graphic = s.destroy());
                }
            }
            markerAttribs(t, e) {
                let i = this.options, s = i.marker ?? {}, o = t.marker || {}, r = o.symbol || s.symbol, a = {}, n, h, l = o.radius ?? s.radius;
                e && (n = s.states?.[e], h = o.states?.[e], l = h?.radius ?? n?.radius ?? (l && l + (n?.radiusPlus || 0))), t.hasImage = r && 0 === r.indexOf("url"), t.hasImage && (l = 0);
                let d = t.pos();
                return N(l) && d && (i.crisp && (d[0] = y(d[0], t.hasImage ? 0 : "rect" === r ? s.lineWidth || 0 : 1)), a.x = d[0] - l, a.y = d[1] - l), l && (a.width = a.height = 2 * l), a;
            }
            pointAttribs(t, e) {
                let i = this.options, s = i.marker ?? {}, o = t?.options, r = o?.marker || {}, a = o?.color, n = t?.color, h = t?.zone?.color, l = this.color, d, c, p = r.lineWidth ?? s.lineWidth, g = t?.isNull && i.nullInteraction ? 0 : 1;
                l = a || h || n || l, d = r.fillColor || s.fillColor || l, c = r.lineColor || s.lineColor || l, e = e || "normal";
                let u = s.states?.[e] || {}, f = r.states?.[e] || {};
                return p = f.lineWidth ?? u.lineWidth ?? (p || 0) + (f.lineWidthPlus ?? u.lineWidthPlus ?? 0), d = f.fillColor || u.fillColor || d, c = f.lineColor || u.lineColor || c, g = f.opacity ?? u.opacity ?? g, {
                    stroke: c,
                    "stroke-width": p,
                    fill: d,
                    opacity: t?.condemned || t?.isInside === !1 ? 0 : g
                };
            }
            destroy(t) {
                let e, i = this, s = i.chart, o = /AppleWebKit\/533/.test(iO.navigator.userAgent);
                for (let s of (P(i, "destroy", {
                    keepEventsForUpdate: t
                }), this.removeEvents(t), i.axisTypes || []))e = i[s], e?.series && (C(e.series, i), e.isDirty = e.forceRedraw = !0);
                for (let t of (i.legendItem && i.chart.legend.destroyItem(i), i.points || []))t?.destroy?.(!0);
                for (let t of i.zones || [])k(t, void 0, !0);
                B(i.animationTimeout), j(i, function(t, e) {
                    t instanceof tq && !t.survive && t[o && "group" === e ? "hide" : "destroy"]();
                }), s.hoverSeries === i && (s.hoverSeries = void 0), C(s.series, i), s.orderItems("series"), j(i, function(e, s) {
                    t && "hcEvents" === s || delete i[s];
                });
            }
            applyZones() {
                let { area: t, chart: e, graph: i, zones: s, points: o, xAxis: r, yAxis: a, zoneAxis: n } = this, { inverted: h, renderer: l } = e, d = this[`${n}Axis`], { isXAxis: c, len: p = 0, minPointOffset: g = 0 } = d || {}, u = (i?.strokeWidth() || 0) / 2 + 1, m = (t, e = 0, i = 0)=>{
                    h && (i = p - i);
                    let { translated: s = 0, lineClip: o, value: r } = t, a = i - s;
                    o?.push([
                        "L",
                        e,
                        Math.abs(a) < u ? i - u * (a < 0 || 0 === a && v(r) ? -1 : 1) : s
                    ]);
                };
                if (s.length && (i || t) && d && N(d.min)) {
                    let e = d.getExtremes().max + g, u = (t)=>{
                        t.forEach((e, i)=>{
                            ("M" === e[0] || "L" === e[0]) && (t[i] = [
                                e[0],
                                c ? p - e[1] : e[1],
                                c ? e[2] : p - e[2]
                            ]);
                        });
                    };
                    if (s.forEach((t)=>{
                        t.lineClip = [], t.translated = f(d.toPixels(t.value ?? e, !0) || 0, 0, p);
                    }), i && !this.showLine && i.hide(), t && t.hide(), "y" === n && o.length < r.len) for (let t of o){
                        let { plotX: e, plotY: i, zone: o } = t, r = o && s[s.indexOf(o) - 1];
                        o && m(o, e, i), r && m(r, e, i);
                    }
                    let x = [], y = d.toPixels(d.getExtremes().min - g, !0);
                    s.forEach((e)=>{
                        let s = e.lineClip || [], o = Math.round(e.translated || 0);
                        r.reversed && s.reverse();
                        let { clip: n, simpleClip: d } = e, p = 0, g = 0, f = r.len, m = a.len;
                        c ? (p = o, f = y) : (g = o, m = y);
                        let b = [
                            [
                                "M",
                                p,
                                g
                            ],
                            [
                                "L",
                                f,
                                g
                            ],
                            [
                                "L",
                                f,
                                m
                            ],
                            [
                                "L",
                                p,
                                m
                            ],
                            [
                                "Z"
                            ]
                        ], v = [
                            b[0],
                            ...s,
                            b[1],
                            b[2],
                            ...x,
                            b[3],
                            b[4]
                        ];
                        x = s.reverse(), y = o, h && (u(v), t && u(b)), n ? (n.animate({
                            d: v
                        }), d?.animate({
                            d: b
                        })) : (n = e.clip = l.path(v), t && (d = e.simpleClip = l.path(b))), i && e.graph?.clip(n), t && e.area?.clip(d);
                    });
                } else this.visible && (i && i.show(), t && t.show());
            }
            plotGroup(t, e, i, s, o) {
                let r = this[t], a = !r, n = {
                    visibility: i,
                    zIndex: s || .1
                };
                return v(this.opacity) && !this.chart.styledMode && "inactive" !== this.state && (n.opacity = this.opacity), r || (this[t] = r = this.chart.renderer.g().add(o)), r.addClass("highcharts-" + e + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (v(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (r.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), r.attr(n)[a ? "attr" : "animate"](this.getPlotBox(e)), r;
            }
            getPlotBox(t) {
                let e = this.xAxis, i = this.yAxis, s = this.chart, o = s.inverted && !s.polar && e && this.invertible && "series" === t;
                s.inverted && (e = i, i = this.xAxis);
                let r = {
                    scale: 1,
                    translateX: e ? e.left : s.plotLeft,
                    translateY: i ? i.top : s.plotTop,
                    name: t
                };
                P(this, "getPlotBox", r);
                let { scale: a, translateX: n, translateY: h } = r;
                return {
                    translateX: n,
                    translateY: h,
                    rotation: 90 * !!o,
                    rotationOriginX: o ? a * (e.len - i.len) / 2 : 0,
                    rotationOriginY: o ? a * (e.len + i.len) / 2 : 0,
                    scaleX: o ? -a : a,
                    scaleY: a
                };
            }
            removeEvents(t) {
                let { eventsToUnbind: e } = this;
                t || q(this), e.length && (e.forEach((t)=>{
                    t();
                }), e.length = 0);
            }
            render() {
                let t = this, { chart: e, options: i, hasRendered: s } = t, o = tS(i.animation), r = t.visible ? "inherit" : "hidden", a = i.zIndex, n = e.seriesGroup, h = t.finishedAnimating ? 0 : o.duration;
                P(this, "render"), e.plotClipInner && (t.plotClipGroup || (t.plotClipGroup = e.renderer.g().add(n))), t.plotGroup("group", "series", r, a, t.plotClipGroup || n), t.markerGroup = t.plotGroup("markerGroup", "markers", r, a, n), !1 !== i.clip && t.setClip(), h && t.animate?.(!0), t.drawGraph && (t.drawGraph(), t.applyZones()), t.visible && t.drawPoints(), t.drawDataLabels?.(), t.redrawPoints?.(), i.enableMouseTracking && t.drawTracker?.(), h && t.animate?.(), s || (h && o.defer && (h += o.defer), t.animationTimeout = tt(()=>{
                    t.afterAnimate();
                }, h || 0)), t.isDirty = !1, t.hasRendered = !0, P(t, "afterRender");
            }
            redraw() {
                let t = this.isDirty || this.isDirtyData;
                this.translate(), this.render(), t && delete this.kdTree, this.condemnedPoints.length = 0;
            }
            reserveSpace() {
                return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
            }
            searchPoint(t, e) {
                let { xAxis: i, yAxis: s } = this, o = this.chart.inverted;
                return this.searchKDTree({
                    clientX: o ? i.len - t.chartY + i.pos : t.chartX - i.pos,
                    plotY: o ? s.len - t.chartX + s.pos : t.chartY - s.pos
                }, e, t);
            }
            buildKDTree(t) {
                this.buildingKdTree = !0;
                let e = this, i = e.options, s = (i.findNearestPointBy ?? "").indexOf("y") > -1 ? 2 : 1;
                delete e.kdTree, tt(function() {
                    e.kdTree = function t(i, s, o) {
                        let r, a, n = i?.length;
                        if (n) return r = e.kdAxisArray[s % o], i.sort((t, e)=>(t[r] || 0) - (e[r] || 0)), {
                            point: i[a = Math.floor(n / 2)],
                            left: t(i.slice(0, a), s + 1, o),
                            right: t(i.slice(a + 1), s + 1, o)
                        };
                    }(e.getValidPoints(void 0, !e.directTouch, i?.nullInteraction), s, s), e.buildingKdTree = !1;
                }, i.kdNow || t?.type === "touchstart" ? 0 : 1);
            }
            searchKDTree(t, e, i, s, o) {
                let r = this, [a, n] = this.kdAxisArray, h = e ? "distX" : "dist", l = (r.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, d = !!r.isBubble, c = s || ((t, e, i)=>{
                    let s = t[i] || 0, o = e[i] || 0;
                    return [
                        s === o && t.index > e.index || s < o ? t : e,
                        !1
                    ];
                }), p = o || ((t, e)=>t < e);
                if (this.kdTree || this.buildingKdTree || this.buildKDTree(i), this.kdTree) return function t(e, i, s, o) {
                    let l, g, u, f, m, x, y, b = i.point, k = r.kdAxisArray[s % o], w = b, M = !1;
                    l = e[a], g = b[a], u = v(l) && v(g) ? l - g : null, f = e[n], m = b[n], x = v(f) && v(m) ? f - m : 0, y = d && b.marker?.radius || 0, b.dist = Math.sqrt((u && u * u || 0) + x * x) - y, b.distX = v(u) ? Math.abs(u) - y : Number.MAX_VALUE;
                    let C = (e[k] || 0) - (b[k] || 0) + (d && b.marker?.radius || 0), S = C < 0 ? "left" : "right", T = C < 0 ? "right" : "left";
                    return i[S] && ([w, M] = c(b, t(e, i[S], s + 1, o), h)), i[T] && p(Math.sqrt(C * C), w[h], M) && (w = c(w, t(e, i[T], s + 1, o), h)[0]), w;
                }(t, this.kdTree, l, l);
            }
            pointPlacementToXValue() {
                let { options: t, xAxis: e } = this, i = t.pointPlacement;
                return "between" === i && (i = e.reversed ? -0.5 : .5), N(i) ? i * (t.pointRange || e.pointRange) : 0;
            }
            isPointInside(t) {
                let { chart: e, xAxis: i, yAxis: s } = this, { plotX: o = -1, plotY: r = -1 } = t;
                return r >= 0 && r <= (s ? s.len : e.plotHeight) && o >= 0 && o <= (i ? i.len : e.plotWidth);
            }
            drawTracker() {
                let t = this, e = t.options, i = e.trackByArea, s = [].concat((i ? t.areaPath : t.graphPath) || []), o = t.chart, r = o.pointer, a = o.renderer, n = o.options.tooltip?.snap || 0, h = ()=>{
                    e.enableMouseTracking && o.hoverSeries !== t && t.onMouseOver();
                }, l = "rgba(192,192,192," + (iL ? 1e-4 : .002) + ")", d = t.tracker;
                d ? d.attr({
                    d: s
                }) : t.graph && (t.tracker = d = a.path(s).attr({
                    visibility: t.visible ? "inherit" : "hidden",
                    zIndex: 2
                }).addClass(i ? "highcharts-tracker-area" : "highcharts-tracker-line").add(t.group), o.styledMode || d.attr({
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    stroke: l,
                    fill: i ? l : "none",
                    "stroke-width": t.graph.strokeWidth() + (i ? 0 : 2 * n)
                }), [
                    t.tracker,
                    t.markerGroup,
                    ...t.dataLabelsGroups || []
                ].forEach((t)=>{
                    t && (t.addClass("highcharts-tracker").on("mouseover", h).on("mouseout", (t)=>{
                        r?.onTrackerMouseOut(t);
                    }), e.cursor && !o.styledMode && t.css({
                        cursor: e.cursor
                    }), t.on("touchstart", h));
                })), P(this, "afterDrawTracker");
            }
            addPoint(t, e, i, s, o) {
                let r, a, n = this.options, { chart: h, data: l, dataTable: d, xAxis: c } = this, p = c?.hasNames && c.names, g = n.data, u = this.getColumn("x");
                e = e ?? !0;
                let { applyOptions: f, optionsToObject: m } = this.pointClass.prototype, x = {
                    series: this
                }, y = m.call(x, t);
                f.call(x, y, void 0, !1);
                let b = x.x;
                if (a = u.length, this.requireSorting && b < u[a - 1]) for(r = !0; a && u[a - 1] > b;)a--;
                d.setRow(y, a, !0), this.xColumn?.splice(a, 0, this.getX(b)), p && x.name && (p[b] = x.name), g?.splice(a, 0, t), (r || this.hasProcessedDataTable) && (this.data.splice(a, 0, null), this.processData()), "point" === n.legendType && this.generatePoints(), i && (l[0] && l[0].remove ? l[0].remove(!1) : ([
                    l,
                    g,
                    this.xColumn
                ].filter(v).forEach((t)=>{
                    t.shift();
                }), d.deleteRows(0))), !1 !== o && P(this, "addPoint", {
                    point: x
                }), this.isDirty = !0, this.isDirtyData = !0, e && h.redraw(s);
            }
            removePoint(t, e, i) {
                let s = this, { chart: o, data: r, points: a, dataTable: n } = s, h = r[t], l = function() {
                    [
                        a?.length === r.length ? a : void 0,
                        r,
                        s.options.data,
                        s.xColumn
                    ].filter(v).forEach((e)=>{
                        e.splice(t, 1);
                    }), n.deleteRows(t), n.modified = n, h?.destroy(), s.isDirty = !0, s.isDirtyData = !0, e && o.redraw();
                };
                tC(i, o), e = e ?? !0, h ? h.firePointEvent("remove", null, l) : l();
            }
            remove(t, e, i, s) {
                let o = this, r = o.chart;
                function a() {
                    o.destroy(s), r.isDirtyLegend = r.isDirtyBox = !0, r.linkSeries(s), (t ?? !0) && r.redraw(e);
                }
                !1 !== i ? P(o, "remove", null, a) : a();
            }
            update(t, e) {
                P(this, "update", {
                    options: t = M(t, this.userOptions)
                });
                let i = this, s = i.chart, o = i.userOptions, r = i.initialType || i.type, a = s.options.plotOptions, n = iE[r].prototype, h = i.finishedAnimating && {
                    animation: !1
                }, l = {}, d = t.data || t.dataTable, c, p, g = iD.keepProps.slice(), u = t.type || o.type || s.options.chart.type, f = !(this.hasDerivedData || u && u !== this.type || void 0 !== t.keys || void 0 !== t.pointStart || void 0 !== t.pointInterval || void 0 !== t.relativeXValue || t.joinBy || t.mapData || [
                    "dataGrouping",
                    "pointStart",
                    "pointInterval",
                    "pointIntervalUnit",
                    "keys"
                ].some((t)=>i.hasOptionChanged(t)));
                u = u || r, f ? (g.push.apply(g, iD.keepPropsForPoints), !1 !== t.visible && (g.push("area", "graph"), "zones" in t || g.push("zones")), i.parallelArrays.forEach(function(t) {
                    g.push(t + "Data");
                }), d && (t.dataSorting && S(i.options.dataSorting, t.dataSorting), this.setData(d, !1))) : this.dataTable.modified = this.dataTable, t.dataLabels && o.dataLabels && (t.dataLabels = this.mergeArrays(o.dataLabels, t.dataLabels)), t = F(o, {
                    index: void 0 === o.index ? i.index : o.index,
                    pointStart: a?.series?.pointStart ?? o.pointStart
                }, !f && {
                    data: i.options.data
                }, t, h), f && t.data && (t.data = i.options.data), (g = [
                    "dataLabelsGroup",
                    "dataLabelsGroups",
                    "dataLabelsParentGroups",
                    "group",
                    "markerGroup",
                    "plotClipGroup",
                    "transformGroup"
                ].concat(g)).forEach(function(t) {
                    g[t] = i[t], delete i[t];
                });
                let m = !1;
                if (iE[u]) {
                    if (m = u !== i.type, i.remove(!1, !1, !1, !0), m) {
                        if (s.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(i, iE[u].prototype);
                        else {
                            let t = Object.hasOwnProperty.call(i, "hcEvents") && i.hcEvents;
                            for(p in n)i[p] = void 0;
                            S(i, iE[u].prototype), t ? i.hcEvents = t : delete i.hcEvents;
                        }
                    }
                } else to(17, !0, s, {
                    missingModuleFor: u
                });
                if (g.forEach(function(t) {
                    i[t] = g[t];
                }), i.init(s, t), f && this.points) for (let t of (!1 === (c = i.options).visible ? (l.graphic = 1, l.dataLabel = 1) : (this.hasMarkerChanged(c, o) && (l.graphic = 1), i.hasDataLabels?.() || (l.dataLabel = 1)), this.points))t?.series && (t.resolveColor(), Object.keys(l).length && t.destroyElements(l), !1 === c.showInLegend && t.legendItem && s.legend.destroyItem(t));
                i.initialType = r, s.linkSeries(), m && i.linkedSeries.length && (i.isDirtyData = !0), P(this, "afterUpdate"), (e ?? !0) && s.redraw(!!f && void 0);
            }
            setName(t) {
                this.name = this.options.name = this.userOptions.name = t, this.chart.isDirtyLegend = !0;
            }
            hasOptionChanged(t) {
                let e = this.chart, i = this.options[t], s = e.options.plotOptions, o = this.userOptions[t], r = s?.[this.type]?.[t] ?? s?.series?.[t];
                return o && !v(r) ? i !== o : i !== (r ?? i);
            }
            onMouseOver() {
                let t = this.chart, e = t.hoverSeries, i = t.pointer;
                i?.setHoverChartIndex(), e && e !== this && e.onMouseOut(), P(this, "mouseOver"), this.setState("hover"), t.hoverSeries = this;
            }
            onMouseOut() {
                let t = this.chart, e = t.tooltip, i = t.hoverPoint;
                t.hoverSeries = null, i && i.onMouseOut(), P(this, "mouseOut"), e && !this.stickyTracking && (!e.shared || this.noSharedTooltip) && e.hide(), t.series.forEach(function(t) {
                    t.setState("", !0);
                });
            }
            setState(t, e) {
                let i = this, { graph: s, options: o } = i, { inactiveOtherPoints: r, states: a = {} } = o, n = a[t || "normal"]?.animation ?? i.chart.options.chart.animation, { lineWidth: h, opacity: l } = o;
                if (t = t || "", i.state !== t && ([
                    i.group,
                    i.markerGroup,
                    ...i.dataLabelsGroups || []
                ].forEach(function(e) {
                    e && (i.state && e.removeClass("highcharts-series-" + i.state), t && e.addClass("highcharts-series-" + t));
                }), i.state = t, !i.chart.styledMode)) {
                    if (a[t]?.enabled === !1) return;
                    if (t && (h = a[t]?.lineWidth ?? (N(h) ? h + (a?.[t]?.lineWidthPlus || 0) : void 0), l = a[t]?.opacity ?? l), s && !s.dashstyle && N(h)) for (let t of [
                        s,
                        ...this.zones.map((t)=>t.graph)
                    ])t?.animate({
                        "stroke-width": h
                    }, n);
                    r || [
                        i.group,
                        i.markerGroup,
                        ...i.dataLabelsGroups || [],
                        i.labelBySeries
                    ].forEach(function(t) {
                        t?.animate({
                            opacity: l
                        }, n);
                    });
                }
                e && r && i.points && i.setAllPointsToState(t || void 0);
            }
            setAllPointsToState(t) {
                this.points.forEach((e)=>e.setState?.(t));
            }
            setVisible(t, e) {
                let i = this, s = i.chart, o = s.options.chart.ignoreHiddenSeries, r = i.visible;
                i.visible = t = i.options.visible = i.userOptions.visible = void 0 === t ? !r : t;
                let a = t ? "show" : "hide";
                [
                    "group",
                    "markerGroup",
                    "tracker",
                    "tt"
                ].forEach((t)=>{
                    i[t]?.[a]();
                }), i.dataLabelsGroups?.forEach((t)=>{
                    t?.[a]();
                }), (s.hoverSeries === i || s.hoverPoint?.series === i) && i.onMouseOut(), i.legendItem && s.legend.colorizeItem(i, t), i.isDirty = !0, i.options.stacking && s.series.forEach((t)=>{
                    t.options.stacking && t.visible && (t.isDirty = !0);
                }), i.linkedSeries.forEach((e)=>{
                    e.setVisible(t, !1);
                }), o && (s.isDirtyBox = !0), P(i, a), !1 !== e && s.redraw();
            }
            show() {
                this.setVisible(!0);
            }
            hide() {
                this.setVisible(!1);
            }
            select(t) {
                this.selected = t = this.options.selected = void 0 === t ? !this.selected : t, this.checkbox && (this.checkbox.checked = t), P(this, t ? "select" : "unselect");
            }
            shouldShowTooltip(t, e, i = {}) {
                return i.series = this, i.visiblePlotOnly = !0, this.chart.isInsidePlot(t, e, i);
            }
            drawLegendSymbol(t, e) {
                let i = this.chart.renderer, s = this.options.legendSymbol || "rectangle", o = e.legendItem || {}, { options: r, symbolHeight: a, symbolWidth: n } = t, h = r.squareSymbol, l = h ? a : n, d = h ? (n - a) / 2 : 0, c = (t.baseline || 0) - a + 1, p = r.symbolRadius ?? a, g = "rectangle" === s ? i.rect(d, c, l, a, p) : i.symbols[s] && i.symbol(s, d, c, l, a, {
                    r: p
                });
                g ? o.symbol = g.addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(o.group) : iw[s]?.call(this, t, e);
            }
        }
        iD.defaultOptions = {
            lineWidth: 2,
            allowPointSelect: !1,
            crisp: !0,
            showCheckbox: !1,
            animation: {
                duration: 1e3
            },
            enableMouseTracking: !0,
            events: {},
            marker: {
                enabledThreshold: 2,
                lineColor: "var(--highcharts-background-color)",
                lineWidth: 0,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "var(--highcharts-neutral-color-20)",
                        lineColor: "var(--highcharts-neutral-color-100)",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                distance: 4,
                formatter: function() {
                    let { numberFormatter: t } = this.series.chart;
                    return "number" != typeof this.y ? "" : t(this.y, -1);
                },
                padding: [
                    1,
                    3
                ],
                style: {
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
            },
            cropThreshold: 300,
            opacity: 1,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 150
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {
                    animation: {
                        duration: 0
                    }
                },
                inactive: {
                    animation: {
                        duration: 150
                    },
                    opacity: .2
                }
            },
            stickyTracking: !0,
            turboThreshold: 1e3,
            findNearestPointBy: "x"
        }, iD.types = iT.seriesTypes, iD.registerType = iT.registerSeriesType, iD.keepProps = [
            "colorIndex",
            "eventOptions",
            "navigatorSeries",
            "symbolIndex",
            "baseSeries"
        ], iD.keepPropsForPoints = [
            "data",
            "isDirtyData",
            "isDirtyCanvas",
            "points",
            "condemnedPoints",
            "dataTable",
            "hasProcessedDataTable",
            "xIncrement",
            "cropped",
            "_hasPointMarkers",
            "hasDataLabels",
            "nodes",
            "layout",
            "level",
            "mapMap",
            "mapData",
            "minY",
            "maxY",
            "minX",
            "maxX",
            "transformGroups"
        ], S(iD.prototype, {
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            coll: "series",
            colorCounter: 0,
            directTouch: !1,
            invertible: !0,
            isCartesian: !0,
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            parallelArrays: [
                "x",
                "y"
            ],
            pointClass: e_,
            requireSorting: !0,
            sorted: !0
        }), iT.series = iD;
        let iB = iD, { registerEventOptions: iz } = eb, { composed: iR, marginNames: iN } = n, { distribute: iW } = tY, { format: iH } = tF;
        class iG {
            constructor(t, e){
                this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = t, this.setOptions(e), e.enabled && (this.render(), iz(this, e), c(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                })), c(this.chart, "render", ()=>{
                    this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
                });
            }
            setOptions(t) {
                let e = t.padding ?? 8;
                this.options = t, this.chart.styledMode || (this.itemStyle = t.itemStyle, this.itemHiddenStyle = F(this.itemStyle, t.itemHiddenStyle)), this.itemMarginTop = t.itemMarginTop, this.itemMarginBottom = t.itemMarginBottom, this.padding = e, this.initialItemY = e - 5, this.symbolWidth = t.symbolWidth ?? 16, this.pages = [], this.proximate = "proximate" === t.layout && !this.chart.inverted, this.baseline = void 0;
            }
            update(t, e) {
                let i = this.chart;
                this.setOptions(F(!0, this.options, t)), "events" in this.options && iz(this, this.options), this.destroy(), i.isDirtyLegend = i.isDirtyBox = !0, (e ?? !0) && i.redraw(), P(this, "afterUpdate", {
                    redraw: e
                });
            }
            colorizeItem(t, e) {
                let i = t.color, { area: s, group: o, label: r, line: a, symbol: n } = t.legendItem || {};
                if ((t instanceof iB || t instanceof e_) && (t.color = t.options?.legendSymbolColor || i), o?.[e ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                    let { itemHiddenStyle: i = {} } = this, o = i.color, { fillColor: h, lineColor: l } = t.options, d = (t)=>(!e && (t.fill && (t.fill = o), t.stroke && (t.stroke = o)), t);
                    r?.css(F(e ? this.itemStyle : i)), a?.attr(d({
                        stroke: l || t.color
                    })), n?.attr(d(t.series ? t.series.pointAttribs?.(t) : t.pointAttribs?.() || {
                        fill: t.color
                    })), s?.attr(d({
                        fill: h || t.color,
                        "fill-opacity": h ? 1 : t.options.fillOpacity ?? .75
                    }));
                }
                t.color = i, P(this, "afterColorizeItem", {
                    item: t,
                    visible: e
                });
            }
            positionItems() {
                this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
            }
            positionItem(t) {
                let { group: e, x: i = 0, y: s = 0 } = t.legendItem || {}, o = this.options, r = o.symbolPadding, a = !o.rtl, n = t.checkbox;
                if (e?.element) {
                    let o = {
                        translateX: a ? i : this.legendWidth - i - 2 * r - 4,
                        translateY: s
                    }, n = ()=>{
                        P(this, "afterPositionItem", {
                            item: t
                        });
                    };
                    e[v(e.translateY) ? "animate" : "attr"](o, void 0, n);
                }
                n && (n.x = i, n.y = s);
            }
            destroyItem(t) {
                let e = t.legendItem || {};
                for (let t of [
                    "group",
                    "label",
                    "line",
                    "symbol"
                ])e[t] && (e[t] = e[t].destroy());
                t.checkbox = w(t.checkbox), t.legendItem = void 0;
            }
            destroy() {
                for (let t of this.getAllItems())this.destroyItem(t);
                for (let t of [
                    "clipRect",
                    "up",
                    "down",
                    "pager",
                    "nav",
                    "box",
                    "title",
                    "group"
                ])this[t] && (this[t] = this[t].destroy());
                this.display = null;
            }
            positionCheckboxes() {
                let t, e = this.group?.alignAttr, i = this.clipHeight || this.legendHeight, s = this.titleHeight;
                e && (t = e.translateY, this.allItems.forEach(function(o) {
                    let r, a = o.checkbox;
                    a && (r = t + s + a.y + (this.scrollOffset || 0) + 3, b(a, {
                        left: e.translateX + o.checkboxOffset + a.x - 20 + "px",
                        top: r + "px",
                        display: this.proximate || r > t - 6 && r < t + i - 6 ? "" : "none"
                    }));
                }, this));
            }
            renderTitle() {
                let t = this.options, e = this.padding, i = t.title, s, o = 0;
                i.text && (this.title || (this.title = this.chart.renderer.label(i.text, e - 3, e - 4, void 0, void 0, void 0, t.useHTML, void 0, "legend-title").attr({
                    zIndex: 1
                }), this.chart.styledMode || this.title.css(i.style), this.title.add(this.group)), i.width || this.title.css({
                    width: this.maxLegendWidth + "px"
                }), o = (s = this.title.getBBox()).height, this.offsetWidth = s.width, this.contentGroup.attr({
                    translateY: o
                })), this.titleHeight = o;
            }
            setText(t) {
                let e = this.options;
                t.legendItem.label.attr({
                    text: e.labelFormat ? iH(e.labelFormat, t, this.chart) : e.labelFormatter.call(t, t)
                });
            }
            renderItem(t) {
                let e = t.legendItem = t.legendItem || {}, i = this.chart, s = i.renderer, o = this.options, r = "horizontal" === o.layout, a = this.symbolWidth, n = o.symbolPadding || 0, h = this.itemStyle, l = this.itemHiddenStyle, d = r ? o.itemDistance ?? 20 : 0, c = !o.rtl, p = !t.series, g = !p && t.series.drawLegendSymbol ? t.series : t, u = g.options, f = !!this.createCheckboxForItem && u && u.showCheckbox, m = o.useHTML, x = t.options.className, y = e.label, b = a + n + d + 20 * !!f;
                !y && (e.group = s.g("legend-item").addClass("highcharts-" + g.type + "-series highcharts-color-" + t.colorIndex + (x ? " " + x : "") + (p ? " highcharts-series-" + t.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), e.label = y = s.text("", c ? a + n : -n, this.baseline || 0, m), i.styledMode || y.css(F(t.visible ? h : l)), y.attr({
                    align: c ? "left" : "right",
                    zIndex: 2
                }).add(e.group), !this.baseline && (this.fontMetrics = s.fontMetrics(y), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, y.attr("y", this.baseline), this.symbolHeight = o.symbolHeight ?? this.fontMetrics.f, o.squareSymbol && (this.symbolWidth = o.symbolWidth ?? Math.max(this.symbolHeight, 16), b = this.symbolWidth + n + d + 20 * !!f, c && y.attr("x", this.symbolWidth + n))), g.drawLegendSymbol(this, t), this.setItemEvents && this.setItemEvents(t, y, m)), f && !t.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(t), this.colorizeItem(t, t.visible), (i.styledMode || !h.width) && y.css({
                    width: Math.min(o.itemWidth || this.widthOption || i.spacingBox.width, o.maxWidth ? Z(o.maxWidth, i.chartWidth) : 1 / 0) - b + "px"
                }), this.setText(t);
                let v = y.getBBox(), k = this.fontMetrics?.h || 0;
                t.itemWidth = t.checkboxOffset = o.itemWidth || e.labelWidth || v.width + b, this.maxItemWidth = Math.max(this.maxItemWidth, t.itemWidth), this.totalItemWidth += t.itemWidth, this.itemHeight = t.itemHeight = Math.round(e.labelHeight || (v.height > 1.5 * k ? v.height : k));
            }
            layoutItem(t) {
                let e = this.options, i = this.padding, s = "horizontal" === e.layout, o = t.itemHeight, r = this.itemMarginBottom, a = this.itemMarginTop, n = s ? e.itemDistance ?? 20 : 0, h = this.maxLegendWidth, l = e.alignColumns && this.totalItemWidth > h ? this.maxItemWidth : t.itemWidth, d = t.legendItem || {};
                s && this.itemX - i + l > h && (this.itemX = i, this.lastLineHeight && (this.itemY += a + this.lastLineHeight + r), this.lastLineHeight = 0), this.lastItemY = a + this.itemY + r, this.lastLineHeight = Math.max(o, this.lastLineHeight), d.x = this.itemX, d.y = this.itemY, s ? this.itemX += l : (this.itemY += a + o + r, this.lastLineHeight = o), this.offsetWidth = this.widthOption || Math.max((s ? this.itemX - i - (t.checkbox ? 0 : n) : l) + i, this.offsetWidth);
            }
            getAllItems() {
                let t = [];
                return this.chart.series.forEach(function(e) {
                    let i = e?.options;
                    e && (i.showInLegend ?? !v(i.linkedTo)) && (t = t.concat(e.legendItem?.labels || ("point" === i.legendType ? e.data : e)));
                }), P(this, "afterGetAllItems", {
                    allItems: t
                }), t;
            }
            getAlignment() {
                let t = this.options;
                return this.proximate ? t.align.charAt(0) + "tv" : t.floating ? "" : t.align.charAt(0) + t.verticalAlign.charAt(0) + t.layout.charAt(0);
            }
            adjustMargins(t, e) {
                let i = this.chart, s = this.options, o = this.getAlignment();
                o && [
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ].forEach((r, a)=>{
                    r.test(o) && !v(t[a]) && (i[iN[a]] = Math.max(i[iN[a]], i.legend[(a + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][a] * s[a % 2 ? "x" : "y"] + (s.margin ?? 12) + e[a] + (i.titleOffset[a] || 0)));
                });
            }
            proximatePositions() {
                let t, e = this.chart, i = [], s = "left" === this.options.align;
                for (let o of (this.allItems.forEach(function(t) {
                    let o, r, a = s, n, h;
                    t.yAxis && (t.xAxis.options.reversed && (a = !a), t.points && (o = D(a ? t.points : t.points.slice(0).reverse(), function(t) {
                        return N(t.plotY);
                    })), r = this.itemMarginTop + t.legendItem.label.getBBox().height + this.itemMarginBottom, h = t.yAxis.top - e.plotTop, n = t.visible ? (o ? o.plotY : t.yAxis.height) + (h - .3 * r) : h + t.yAxis.height, i.push({
                        target: n,
                        size: r,
                        item: t
                    }));
                }, this), iW(i, e.plotHeight)))t = o.item.legendItem || {}, N(o.pos) && (t.y = e.plotTop - e.spacing[0] + o.pos);
            }
            render() {
                let t = this.chart, e = t.spacingBox.width, i = t.renderer, s = this.options, o = this.padding, r = this.getAllItems(), a, n, h, l = this.group, d, c = this.box;
                this.itemX = o, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = Z(s.width, e - o), d = e - 2 * o - s.x, [
                    "rm",
                    "lm"
                ].indexOf(this.getAlignment().substring(0, 2)) > -1 && (d /= 2), this.maxLegendWidth = this.widthOption || d, l || (this.group = l = i.g("legend").addClass(s.className || "").attr({
                    zIndex: 7
                }).add(), this.contentGroup = i.g().attr({
                    zIndex: 1
                }).add(l), this.scrollGroup = i.g().add(this.contentGroup)), this.renderTitle(), Q(r, (t, e)=>(t.options?.legendIndex || 0) - (e.options?.legendIndex || 0)), s.reversed && r.reverse(), this.allItems = r, this.display = a = !!r.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, r.forEach(this.renderItem, this), r.forEach(this.layoutItem, this), n = (s.maxWidth ? Math.min(this.widthOption || this.offsetWidth, d, Z(s.maxWidth, t.chartWidth) || 1 / 0) : this.widthOption || this.offsetWidth) + o, h = this.lastItemY + this.lastLineHeight + this.titleHeight, h = this.handleOverflow(h) + o, c || (this.box = c = i.rect().addClass("highcharts-legend-box").attr({
                    r: s.borderRadius
                }).add(l)), t.styledMode || c.attr({
                    stroke: s.borderColor,
                    "stroke-width": s.borderWidth || 0,
                    fill: s.backgroundColor || "none"
                }).shadow(s.shadow), n > 0 && h > 0 && c[c.placed ? "animate" : "attr"](c.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: n,
                    height: h
                }, c.strokeWidth())), l[a ? "show" : "hide"](), t.styledMode && "none" === l.getStyle("display") && (n = h = 0), this.legendWidth = n, this.legendHeight = h, a && this.align(), this.proximate || this.positionItems(), P(this, "afterRender");
            }
            align(t = this.chart.spacingBox) {
                let e = this.chart, i = this.options, s = t.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && e.titleOffset[0] > 0 ? s += e.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && e.titleOffset[2] > 0 && (s -= e.titleOffset[2]), s !== t.y && (t = F(t, {
                    y: s
                })), e.hasRendered || (this.group.placed = !1), this.group.align(F(i, {
                    width: this.legendWidth,
                    height: this.legendHeight,
                    verticalAlign: this.proximate ? "top" : i.verticalAlign
                }), !0, t);
            }
            handleOverflow(t) {
                let e = this, i = this.chart, s = i.renderer, o = this.options, r = o.y, a = "top" === o.verticalAlign, n = this.padding, h = o.maxHeight, l = o.navigation, d = l.animation ?? !0, c = l.arrowSize || 12, p = this.pages, g = this.allItems, u = function(t) {
                    "number" == typeof t ? w.attr({
                        height: t
                    }) : w && (e.clipRect = w.destroy(), e.contentGroup.clip()), e.contentGroup.div && (e.contentGroup.div.style.clip = t ? "rect(" + n + "px,9999px," + (n + t) + "px,0)" : "auto");
                }, f = function(t) {
                    return e[t] = s.circle(0, 0, 1.3 * c).translate(c / 2, c / 2).add(k), i.styledMode || e[t].attr("fill", "rgba(0,0,0,0.0001)"), e[t];
                }, m, x, y, b, v = i.spacingBox.height + (a ? -r : r) - n, k = this.nav, w = this.clipRect;
                return "horizontal" !== o.layout || "middle" === o.verticalAlign || o.floating || (v /= 2), h && (v = Math.min(v, h)), p.length = 0, t && v > 0 && t > v && !1 !== l.enabled ? (this.clipHeight = m = Math.max(v - 20 - this.titleHeight - n, 0), this.currentPage = this.currentPage ?? 1, this.fullHeight = t, g.forEach((t, e)=>{
                    let i = (y = t.legendItem || {}).y || 0, s = Math.round(y.label.getBBox().height), o = p.length;
                    (!o || i - p[o - 1] > m && (x || i) !== p[o - 1]) && (p.push(x || i), o++), y.pageIx = o - 1, x && b && (b.pageIx = o - 1), e === g.length - 1 && i + s - p[o - 1] > m && i > p[o - 1] && (p.push(i), y.pageIx = o), i !== x && (x = i), b = y;
                }), w || (w = e.clipRect = s.clipRect(0, n - 2, 9999, 0), e.contentGroup.clip(w)), u(m), k || (this.nav = k = s.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = s.symbol("triangle", 0, 0, c, c).add(k), f("upTracker").on("click", function() {
                    e.scroll(-1, d);
                }), this.pager = s.text("", 15, 10).addClass("highcharts-legend-navigation"), !i.styledMode && l.style && this.pager.css(l.style), this.pager.add(k), this.down = s.symbol("triangle-down", 0, 0, c, c).add(k), f("downTracker").on("click", function() {
                    e.scroll(1, d);
                })), e.scroll(0), t = v) : k && (u(), this.nav = k.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0), t;
            }
            scroll(t, e) {
                let i = this.chart, s = this.pages, o = s.length, r = this.clipHeight, a = this.options.navigation, n = this.pager, h = this.padding, l = this.currentPage + t;
                l > o && (l = o), l > 0 && (void 0 !== e && tC(e, i), this.nav.attr({
                    translateX: h,
                    translateY: r + this.padding + 7 + this.titleHeight,
                    visibility: "inherit"
                }), [
                    this.up,
                    this.upTracker
                ].forEach(function(t) {
                    t.attr({
                        class: 1 === l ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }), n.attr({
                    text: l + "/" + o
                }), [
                    this.down,
                    this.downTracker
                ].forEach(function(t) {
                    t.attr({
                        x: 18 + this.pager.getBBox().width,
                        class: l === o ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                    });
                }, this), i.styledMode || (this.up.attr({
                    fill: 1 === l ? a.inactiveColor : a.activeColor
                }), this.upTracker.css({
                    cursor: 1 === l ? "default" : "pointer"
                }), this.down.attr({
                    fill: l === o ? a.inactiveColor : a.activeColor
                }), this.downTracker.css({
                    cursor: l === o ? "default" : "pointer"
                })), this.scrollOffset = -s[l - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = l, this.positionCheckboxes(), tt(()=>{
                    P(this, "afterScroll", {
                        currentPage: l
                    });
                }, tS(e ?? i.renderer.globalAnimation ?? !0).duration));
            }
            setItemEvents(t, e, i) {
                let s = this, o = t.legendItem || {}, r = s.chart.renderer.boxWrapper, a = t instanceof e_, n = t instanceof iB, h = "highcharts-legend-" + (a ? "point" : "series") + "-active", l = s.chart.styledMode, d = i ? [
                    e,
                    o.symbol
                ] : [
                    o.group
                ], c = (e)=>{
                    s.allItems.forEach((i)=>{
                        t !== i && [
                            i
                        ].concat(i.linkedSeries || []).forEach((t)=>{
                            t.setState(e, !a);
                        });
                    });
                };
                for (let i of d)i && i.on("mouseover", function() {
                    t.visible && c("inactive"), t.setState("hover"), t.visible && r.addClass(h), l || e.css(s.options.itemHoverStyle);
                }).on("mouseout", function() {
                    s.chart.styledMode || e.css(F(t.visible ? s.itemStyle : s.itemHiddenStyle)), c(""), r.removeClass(h), t.setState();
                }).on("click", function(e) {
                    let i = function() {
                        t.setVisible && t.setVisible(), c(t.visible ? "inactive" : "");
                    };
                    r.removeClass(h), P(s, "itemClick", {
                        browserEvent: e,
                        legendItem: t,
                        context: s
                    }, i), a ? t.firePointEvent("legendItemClick", {
                        browserEvent: e
                    }) : n && P(t, "legendItemClick", {
                        browserEvent: e
                    });
                });
            }
            createCheckboxForItem(t) {
                t.checkbox = x("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: t.selected,
                    defaultChecked: t.selected
                }, this.options.itemCheckboxStyle, this.chart.container), c(t.checkbox, "click", function(e) {
                    let i = e.target;
                    P(t.series || t, "checkboxClick", {
                        checked: i.checked,
                        item: t
                    }, function() {
                        t.select();
                    });
                });
            }
        }
        (im = iG || (iG = {})).compose = function(t) {
            _(iR, "Core.Legend") && c(t, "beforeMargins", function() {
                this.legend = new im(this, this.options.legend);
            });
        };
        let iX = iG, { defaultOptions: iF } = tm, { numberFormat: iY } = tF, { registerEventOptions: ij } = eb, { charts: i$, doc: iV, marginNames: iU, win: i_ } = n, { seriesTypes: iZ } = iT;
        class iK {
            static chart(t, e, i) {
                let s = new iK(t, e, i);
                return s.promise ?? s;
            }
            constructor(t, e, i){
                if (this.sharedClips = {}, !iV) return void to(36, !1, this);
                let s = [
                    ...arguments
                ];
                (W(t) || t.nodeName) && (this.renderTo = s.shift()), this.init(s[0], s[1]);
            }
            setZoomOptions() {
                let t = this.options.chart, e = t.zooming;
                this.zooming = {
                    ...e,
                    type: t.zoomType ?? e.type,
                    key: t.zoomKey ?? e.key,
                    pinchType: t.pinchType ?? e.pinchType,
                    singleTouch: t.zoomBySingleTouch ?? e.singleTouch ?? !1,
                    resetButton: F(e.resetButton, t.resetZoomButton)
                };
            }
            init(t, e) {
                P(this, "init", {
                    args: arguments
                }, function() {
                    let i = F(iF, t), s = i.chart, o = this.renderTo || s.renderTo;
                    this.userOptions = S({}, t), (this.renderTo = W(o) ? iV.getElementById(o) : o) || to(13, !0, this), this.margin = [], this.spacing = [], this.labelCollectors = [], !0 === e ? this.promise = new Promise((t)=>{
                        this.callback = t;
                    }) : this.callback = e, this.isResizing = 0, this.options = i, this.axes = [], this.series = [], this.locale = i.lang.locale ?? this.renderTo.closest("[lang]")?.lang, this.time = new tp(S(i.time || {}, {
                        locale: this.locale
                    }), i.lang), i.time = this.time.options, this.numberFormatter = (s.numberFormatter || iY).bind(this), this.styledMode = s.styledMode, this.hasCartesianSeries = s.showAxes, this.index = i$.length, this.dataTable = this.getDataTable(i), i$.push(this), n.chartCount++, ij(this, s), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), P(this, "afterInit"), this.firstRender();
                });
            }
            getDataTable(t) {
                return (t.dataTable ? J(t.dataTable) : []).map((t)=>t.isDataTable ? t : new e5(t));
            }
            initSeries(t) {
                let e = this.options.chart, i = t.type || e.type, s = iZ[i];
                s || to(17, !0, this, {
                    missingModuleFor: i
                });
                let o = new s;
                return "function" == typeof o.init && o.init(this, t), o;
            }
            orderItems(t, e = 0) {
                let i = this[t], s = this.options[t] = J(this.options[t]).slice(), o = this.userOptions[t] = this.userOptions[t] ? J(this.userOptions[t]).slice() : [];
                if (this.hasRendered && (s.splice(e), o.splice(e)), i) for(let t = e, r = i.length; t < r; ++t){
                    let e = i[t];
                    e && (e.index = t, e instanceof iB && (e.name = e.getName()), e.options.isInternal || (s[t] = e.options, o[t] = e.userOptions));
                }
            }
            getClipBox(t, e) {
                let i = this.inverted, { xAxis: s, yAxis: o } = t || {}, { x: r, y: a, width: n, height: h } = F(this.clipBox);
                return t && (s && s.len !== this.plotSizeX && !s.isRadial && (n = s.len), o && o.len !== this.plotSizeY && !o.isRadial && (h = o.len), i && !t.invertible && ([n, h] = [
                    h,
                    n
                ])), e && (r += (i ? o : s)?.pos ?? this.plotLeft, a += (i ? s : o)?.pos ?? this.plotTop), {
                    x: r,
                    y: a,
                    width: n,
                    height: h
                };
            }
            isInsidePlot(t, e, i = {}) {
                let { inverted: s, plotBox: o, plotLeft: r, plotTop: a, scrollablePlotBox: n } = this, { scrollLeft: h = 0, scrollTop: l = 0 } = i.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, d = i.series, c = i.visiblePlotOnly && n || o, p = i.inverted ? e : t, g = i.inverted ? t : e, u = {
                    x: p,
                    y: g,
                    isInsidePlot: !0,
                    options: i
                };
                if (!i.ignoreX) {
                    let t = d && (s && !this.polar ? d.yAxis : d.xAxis) || {
                        pos: r,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + p : r + p;
                    e >= Math.max(h + r, t.pos) && e <= Math.min(h + r + c.width, t.pos + t.len) || (u.isInsidePlot = !1);
                }
                if (!i.ignoreY && u.isInsidePlot) {
                    let t = !s && i.axis && !i.axis.isXAxis && i.axis || d && (s ? d.xAxis : d.yAxis) || {
                        pos: a,
                        len: 1 / 0
                    }, e = i.paneCoordinates ? t.pos + g : a + g;
                    e >= Math.max(l + a, t.pos) && e <= Math.min(l + a + c.height, t.pos + t.len) || (u.isInsidePlot = !1);
                }
                return P(this, "afterIsInsidePlot", u), u.isInsidePlot;
            }
            redraw(t) {
                P(this, "beforeRedraw");
                let e = this.hasCartesianSeries ? this.axes : this.colorAxis || [], i = this.series, s = this.pointer, o = this.legend, r = this.userOptions.legend, a = this.renderer, n = a.isHidden(), h = [], l, d, c, p = this.isDirtyLegend, g;
                for(a.rootFontSize = a.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), tC(!!this.hasRendered && t, this), n && this.temporaryDisplay(), this.layOutTitles(!1), c = i.length; c--;)if (((g = i[c]).options.stacking || g.options.centerInCategory) && (d = !0, g.isDirty)) {
                    l = !0;
                    break;
                }
                if (l) for(c = i.length; c--;)(g = i[c]).options.stacking && (g.isDirty = !0);
                i.forEach(function(t) {
                    t.isDirty && ("point" === t.options.legendType ? ("function" == typeof t.updateTotals && t.updateTotals(), p = !0) : r && (r.labelFormatter || r.labelFormat) && (p = !0)), t.isDirtyData && P(t, "updatedData");
                }), p && o && o.options.enabled && (o.render(), this.isDirtyLegend = !1), d && this.getStacks(), e.forEach(function(t) {
                    t.updateNames(), t.setScale();
                }), this.getMargins();
                let u = this.isDirtyBox;
                e.forEach(function(t) {
                    t.isDirty && (u = !0);
                }), e.forEach(function(t) {
                    let e = t.min + "," + t.max;
                    t.extKey !== e && (t.extKey = e, h.push(function() {
                        P(t, "afterSetExtremes", S(t.eventArgs, t.getExtremes())), delete t.eventArgs;
                    })), (u || d) && t.redraw();
                }), u && this.drawChartBox(), P(this, "predraw"), i.forEach(function(t) {
                    (u || t.isDirty) && t.visible && t.redraw(), t.isDirtyData = !1;
                }), s && s.reset(!0), a.draw(), e.forEach((t)=>{
                    t.saveOld();
                }), P(this, "redraw"), P(this, "render"), n && this.temporaryDisplay(!0), h.forEach(function(t) {
                    t.call();
                });
            }
            get(t) {
                let e = this.series;
                function i(e) {
                    return e.id === t || e.options && e.options.id === t;
                }
                let s = D(this.axes, i) || D(this.series, i);
                for(let t = 0; !s && t < e.length; t++)s = D(e[t].points || [], i);
                return s;
            }
            createAxes() {
                let t = this.userOptions;
                for (let e of (P(this, "createAxes"), [
                    "xAxis",
                    "yAxis"
                ]))for (let i of t[e] = J(t[e] || {}))new eL(this, i, e);
                P(this, "afterCreateAxes");
            }
            getSelectedPoints() {
                return this.series.reduce((t, e)=>(e.getPointsCollection().forEach((e)=>{
                        (e.selectedStaging ?? e.selected) && t.push(e);
                    }), t), []);
            }
            getSelectedSeries() {
                return this.series.filter((t)=>t.selected);
            }
            setTitle(t, e, i) {
                this.applyDescription("title", t), this.applyDescription("subtitle", e), this.applyDescription("caption", void 0), this.layOutTitles(i);
            }
            applyDescription(t, e) {
                let i = this, s = this.options[t] = F(this.options[t], e), o = this[t];
                o && e && (this[t] = o = o.destroy()), s && !o && ((o = this.renderer.text(s.text, 0, 0, s.useHTML).attr({
                    align: s.align,
                    class: [
                        s.className,
                        "highcharts-" + t
                    ].filter(W).join(" "),
                    zIndex: s.zIndex || 4
                }).css({
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }).add()).update = function(e, s) {
                    i.applyDescription(t, e), i.layOutTitles(s);
                }, this.styledMode || o.css(S("title" === t ? {
                    fontSize: this.options.isStock ? "1em" : "1.2em"
                } : {}, s.style)), o.textPxLength = o.getBBox().width, o.css({
                    whiteSpace: s.style?.whiteSpace
                }), this[t] = o);
            }
            layOutTitles(t = !0) {
                let e = [
                    0,
                    0,
                    0
                ], { options: i, renderer: s, spacingBox: o } = this;
                [
                    "title",
                    "subtitle",
                    "caption"
                ].forEach((t)=>{
                    let i = this[t], r = this.options[t], a = F(o), n = i?.textPxLength || 0;
                    if (i && r) {
                        P(this, "layOutTitle", {
                            alignTo: a,
                            key: t,
                            textPxLength: n
                        });
                        let o = s.fontMetrics(i), h = o.b, l = o.h, d = r.verticalAlign || "top", c = "top" === d, p = c && r.minScale || 1, g = "title" === t ? c ? -3 : 0 : c ? e[0] + 2 : 0, u = Math.min(a.width / n, 1), f = Math.max(p, u), m = F({
                            y: "bottom" === d ? h : g + h
                        }, r), x = (r.width || (u > p ? this.chartWidth : a.width) / f) + "px";
                        m.align ?? (m.align = "title" === t ? u < p ? "left" : "center" : this.title?.alignValue), i.alignValue !== m.align && (i.placed = !1);
                        let y = Math.round(i.css({
                            width: x
                        }).getBBox(r.useHTML).height);
                        if (m.height = y, i.align(m, !1, a).attr({
                            align: m.align,
                            scaleX: f,
                            scaleY: f,
                            "transform-origin": `${a.x + n * f * A(m.align)} ${l}`
                        }), !r.floating) {
                            let t = y * (y < 1.2 * l ? 1 : f);
                            "top" === d ? e[0] = Math.ceil(e[0] + t) : "bottom" === d && (e[2] = Math.ceil(e[2] + t));
                        }
                    }
                }, this), e[0] && "top" === (i.title?.verticalAlign || "top") && (e[0] += i.title?.margin || 0), e[2] && i.caption?.verticalAlign === "bottom" && (e[2] += i.caption?.margin || 0);
                let r = !this.titleOffset || this.titleOffset.join(",") !== e.join(",");
                this.titleOffset = e, P(this, "afterLayOutTitles"), !this.isDirtyBox && r && (this.isDirtyBox = this.isDirtyLegend = r, this.hasRendered && t && this.isDirtyBox && this.redraw());
            }
            getContainerBox() {
                let t = [].map.call(this.renderTo.children, (t)=>{
                    if (t !== this.container) {
                        let e = t.style.display;
                        return t.style.display = "none", [
                            t,
                            e
                        ];
                    }
                }), e = {
                    width: I(this.renderTo, "width", !0) || 0,
                    height: I(this.renderTo, "height", !0) || 0
                };
                return t.filter(Boolean).forEach(([t, e])=>{
                    t.style.display = e;
                }), e;
            }
            getChartSize() {
                let t = this.options.chart, e = t.width, i = t.height, s = this.getContainerBox(), o = s.height <= 1 || !this.renderTo.parentElement?.style.height && "100%" === this.renderTo.style.height;
                this.chartWidth = Math.max(0, e || s.width || 600), this.chartHeight = Math.max(0, Z(i, this.chartWidth) || (o ? 400 : s.height)), this.containerBox = s;
            }
            temporaryDisplay(t) {
                let e = this.renderTo, i;
                if (t) for(; e?.style;)e.hcOrigStyle && (b(e, e.hcOrigStyle), delete e.hcOrigStyle), e.hcOrigDetached && (iV.body.removeChild(e), e.hcOrigDetached = !1), e = e.parentNode;
                else for(; e?.style && (iV.body.contains(e) || e.parentNode || (e.hcOrigDetached = !0, iV.body.appendChild(e)), ("none" === I(e, "display", !1) || e.hcOrigDetached) && (e.hcOrigStyle = {
                    display: e.style.display,
                    height: e.style.height,
                    overflow: e.style.overflow
                }, i = {
                    display: "block",
                    overflow: "hidden"
                }, e !== this.renderTo && (i.height = 0), b(e, i), e.offsetWidth || e.style.setProperty("display", "block", "important")), (e = e.parentNode) !== iV.body););
            }
            setClassName(t) {
                this.container.className = "highcharts-container " + (t || "");
            }
            getContainer() {
                let t, e = this.options, i = e.chart, s = "data-highcharts-chart", o = tn(), r = this.renderTo, a = U(u(r, s));
                N(a) && i$[a] && i$[a].hasRendered && i$[a].destroy(), u(r, s, this.index), r.innerHTML = tB.emptyHTML, i.skipClone || r.offsetWidth || this.temporaryDisplay(), this.getChartSize();
                let n = this.chartHeight, h = this.chartWidth;
                b(r, {
                    overflow: "hidden"
                }), this.styledMode || (t = S({
                    position: "relative",
                    overflow: "hidden",
                    width: h + "px",
                    height: n + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                    userSelect: "none",
                    "touch-action": "manipulation",
                    outline: "none",
                    padding: "0px"
                }, i.style || {}));
                let l = x("div", {
                    id: o
                }, t, r);
                if (this.container = l, this.getChartSize(), h !== this.chartWidth && (h = this.chartWidth, this.styledMode || b(l, {
                    width: i.style?.width ?? h + "px"
                })), this._cursor = l.style.cursor, this.renderer = new eg(l, h, n, void 0, i.forExport, e.exporting?.allowHTML, this.styledMode, e.palette, this.index), this.containerBox = this.getContainerBox(), tC(void 0, this), this.setClassName(i.className), this.styledMode) for(let t in e.defs)this.renderer.definition(e.defs[t]);
                else this.renderer.setStyle(i.style), this.palette = this.renderer.palette;
                P(this, "afterGetContainer");
            }
            getMargins(t) {
                let { spacing: e, margin: i, titleOffset: s } = this;
                this.resetMargins(), s[0] && !v(i[0]) && (this.plotTop = Math.max(this.plotTop, s[0] + e[0])), s[2] && !v(i[2]) && (this.marginBottom = Math.max(this.marginBottom, s[2] + e[2])), this.legend?.display && this.legend.adjustMargins(i, e), P(this, "getMargins"), t || this.getAxisMargins();
            }
            getAxisMargins() {
                let t = this, e = t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], i = t.colorAxis, s = t.margin, o = (t)=>{
                    t.forEach((t)=>{
                        t.visible && t.getOffset();
                    });
                };
                t.hasCartesianSeries ? o(t.axes) : i?.length && o(i), iU.forEach((i, o)=>{
                    v(s[o]) || (t[i] += e[o]);
                }), t.setChartSize();
            }
            getOptions() {
                return M(this.userOptions, iF);
            }
            reflow(t) {
                let e = this, i = e.containerBox, s = e.getContainerBox();
                delete e.pointer?.chartPosition, !e.exporting?.isPrinting && !e.isResizing && i && s.width && ((s.width !== i.width || s.height !== i.height) && (B(e.reflowTimeout), e.reflowTimeout = tt(function() {
                    if (e.container) {
                        e.setSize(void 0, void 0, !1);
                        let t = e.containerBox;
                        t && (t.height = e.chartHeight);
                    }
                }, 100 * !!t)), e.containerBox = s);
            }
            setReflow() {
                let t = this, e = (e)=>{
                    t.options?.chart.reflow && t.hasLoaded && t.reflow(e);
                };
                if ("function" == typeof ResizeObserver) new ResizeObserver(e).observe(t.renderTo);
                else {
                    let t = c(i_, "resize", e);
                    c(this, "destroy", t);
                }
            }
            setSize(t, e, i) {
                let s = this, o = s.renderer;
                s.isResizing += 1, tC(i, s);
                let r = o.globalAnimation;
                s.oldChartHeight = s.chartHeight, s.oldChartWidth = s.chartWidth, void 0 !== t && (s.options.chart.width = t), void 0 !== e && (s.options.chart.height = e), s.getChartSize();
                let { chartWidth: a, chartHeight: n, scrollablePixelsX: h = 0, scrollablePixelsY: l = 0 } = s;
                (s.isDirtyBox || a !== s.oldChartWidth || n !== s.oldChartHeight) && (s.styledMode || (r ? tP : b)(s.container, {
                    width: `${a + h}px`,
                    height: `${n + l}px`
                }, r), s.setChartSize(!0), o.setSize(a, n, r), s.axes.forEach(function(t) {
                    t.isDirty = !0, t.setScale();
                }), s.isDirtyLegend = !0, s.isDirtyBox = !0, s.layOutTitles(), s.getMargins(), s.redraw(r), s.oldChartHeight = void 0, P(s, "resize"), setTimeout(()=>{
                    s && P(s, "endResize");
                }, tS(r).duration)), s.isResizing -= 1;
            }
            setChartSize(t) {
                let e, i, s, o, { chartHeight: r, chartWidth: a, clipOffset: n, inverted: h, spacing: l, renderer: d } = this, c = Math[h ? "floor" : "round"];
                if (this.plotLeft = e = Math.round(this.plotLeft), this.plotTop = i = Math.round(this.plotTop), this.plotWidth = s = Math.max(0, Math.round(a - e - (this.marginRight ?? 0))), this.plotHeight = o = Math.max(0, Math.round(r - i - (this.marginBottom ?? 0))), this.plotSizeX = h ? o : s, this.plotSizeY = h ? s : o, this.spacingBox = d.spacingBox = {
                    x: l[3],
                    y: l[0],
                    width: a - l[3] - l[1],
                    height: r - l[0] - l[2]
                }, this.plotBox = d.plotBox = {
                    x: e,
                    y: i,
                    width: s,
                    height: o
                }, n && (this.clipBox = {
                    x: c(n[h ? 2 : 3]),
                    y: c(n[+!!h]),
                    width: c(this.plotSizeX - n[+!h] - n[h ? 2 : 3]),
                    height: c(this.plotSizeY - n[+!!h] - n[h ? 3 : 2])
                }), !t) {
                    for (let t of this.axes)t.setAxisSize(), t.setAxisTranslation();
                    d.alignElements();
                }
                P(this, "afterSetChartSize", {
                    skipAxes: t
                });
            }
            resetMargins() {
                P(this, "resetMargins");
                let t = this, e = t.options.chart, i = e.plotBorderWidth || 0, s = Math.round(i) / 2;
                [
                    "margin",
                    "spacing"
                ].forEach((i)=>{
                    let s = e[i], o = X(s) ? s : [
                        s,
                        s,
                        s,
                        s
                    ];
                    [
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ].forEach((s, r)=>{
                        t[i][r] = e[`${i}${s}`] ?? o[r];
                    });
                }), iU.forEach((e, i)=>{
                    t[e] = t.margin[i] ?? t.spacing[i];
                }), t.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], t.clipOffset = [
                    s,
                    s,
                    s,
                    s
                ], t.plotBorderWidth = i;
            }
            drawChartBox() {
                let t = this, e = t.options.chart, { backgroundColor: i, plotBackgroundColor: s, plotBackgroundImage: o, plotBorderRadius: r = 0, shadow: a } = e, { chartWidth: n, chartHeight: h, clipBox: l, clipOffset: d, clipRect: c, plotBGImage: p, plotBox: g, plotLeft: u, plotTop: f, plotWidth: m, plotHeight: x, renderer: y, styledMode: b } = t, v = t.chartBackground, k = t.plotBackground, w = t.plotBorder, M, C, S, T = "animate";
                v || (t.chartBackground = v = y.rect().addClass("highcharts-background").add(), T = "attr"), b ? M = C = v.strokeWidth() : (C = (M = e.borderWidth || 0) + 8 * !!a, S = {
                    fill: i || "none"
                }, (M || v["stroke-width"]) && (S.stroke = e.borderColor, S["stroke-width"] = M), v.attr(S).shadow(a)), v[T]({
                    x: C / 2,
                    y: C / 2,
                    width: n - C - M % 2,
                    height: h - C - M % 2,
                    r: e.borderRadius
                }), T = "animate", k || (T = "attr", t.plotBackground = k = y.rect().addClass("highcharts-plot-background").add()), k[T]({
                    ...g,
                    r: r
                }), !b && (k.attr({
                    fill: s || "none"
                }).shadow(e.plotShadow), o && (p ? (o !== p.attr("href") && p.attr("href", o), p.animate(g)) : t.plotBGImage = y.image(o, u, f, m, x).add())), c ? c.animate({
                    width: l.width,
                    height: l.height
                }) : t.clipRect = y.clipRect(l), T = "animate", w || (T = "attr", t.plotBorder = w = y.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1.5
                }).add()), w.attr(b ? void 0 : {
                    stroke: e.plotBorderColor,
                    "stroke-width": e.plotBorderWidth || 0,
                    fill: "none"
                })[T]({
                    r: r
                });
                let A = w.strokeWidth(), L = F(w.crisp(g, -A));
                if (d && !b) {
                    let t = d[0] - A / 2, e = d[3] - A / 2;
                    L.x -= e, L.y -= t, L.width += e + d[1] - A / 2, L.height += t + d[2] - A / 2;
                }
                w[T](L), [
                    "plotClipOuter",
                    "plotClipInner"
                ].forEach((e, i)=>{
                    let s = t[e], o = i ? -A : A;
                    s?.[r ? T : "attr"]({
                        x: L.x - o / 2,
                        y: L.y - o / 2,
                        width: L.width + o,
                        height: L.height + o,
                        r: r ? r + o / 2 : 0
                    }), s?.parentGroup?.attr({
                        display: r ? "" : "none"
                    });
                }), t.isDirtyBox = !1, P(this, "afterDrawChartBox");
            }
            propFromSeries() {
                let t, e, i, s = this, o = s.options.chart, r = s.options.series;
                [
                    "inverted",
                    "angular",
                    "polar"
                ].forEach(function(a) {
                    for(e = iZ[o.type], i = o[a] || e && e.prototype[a], t = r?.length; !i && t--;)(e = iZ[r[t].type]) && e.prototype[a] && (i = !0);
                    s[a] = i;
                });
            }
            linkSeries(t) {
                let e = this, i = e.series;
                i.forEach(function(t) {
                    t.linkedSeries.length = 0;
                }), i.forEach(function(t) {
                    let { linkedTo: s } = t.options, o = W(s) && (":previous" === s ? i[t.index - 1] : e.get(s));
                    o && o.linkedParent !== t && (o.linkedSeries.push(t), t.linkedParent = o, t.visible = t.options.visible ?? o.options.visible ?? t.visible);
                }), P(this, "afterLinkSeries", {
                    isUpdating: t
                });
            }
            renderSeries() {
                this.series.forEach(function(t) {
                    t.translate(), t.render();
                });
            }
            render() {
                let t = this.axes, e = this.colorAxis, i = this.renderer, { axisLayoutRuns: s = 2, plotBorderRadius: o } = this.options.chart, r = (t)=>{
                    t.forEach((t)=>{
                        t.visible && t.render();
                    });
                }, a = 0, n = !0, h, l = 0;
                for (let e of (o && (this.plotClipOuter || (this.plotClipOuter = i.clipRect()), this.plotClipInner || (this.plotClipInner = i.clipRect())), this.setTitle(), P(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), t)){
                    let { options: t } = e, { labels: i, offset: s } = t;
                    if (this.hasCartesianSeries && e.horiz && e.visible && i.enabled && e.series.length && "colorAxis" !== e.coll && !e.isRadial) {
                        a = t.tickLength, e.createGroups();
                        let o = new ek(e, 0, "", !0), r = o.createLabel("x", i);
                        if (o.destroy(), r && (i.reserveSpace ?? !N(t.crossing)) && (a = r.getBBox().height + (i.distance ?? 15) + Math.max(N(s) ? s : 0, 0)), a) {
                            r?.destroy();
                            break;
                        }
                    }
                }
                for(this.plotHeight = Math.max(this.plotHeight - a, 0); (n || h || s > 1) && l < s;){
                    let e = this.plotWidth, i = this.plotHeight, s = [
                        1.05,
                        1.1
                    ];
                    for (let e of t){
                        let t = +(e.horiz || 0);
                        if (0 === l) {
                            e.setScale();
                            let i = e.tickPositions?.info?.match;
                            i && (s[t] = Math.min(i, s[t]));
                        } else (t && n || !t && h) && e.setTickInterval(!0);
                    }
                    0 === l ? this.getAxisMargins() : this.getMargins(), n = e / this.plotWidth > (l ? 1 : s[1]), h = i / this.plotHeight > (l ? 1 : s[0]), l++;
                }
                this.drawChartBox(), this.hasCartesianSeries ? r(t) : e?.length && r(e), this.seriesGroup || (this.seriesGroup = i.g("series-group").attr({
                    zIndex: 3
                }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
            }
            addCredits(t) {
                let e = this, i = F(!0, this.options.credits, t);
                if (i.enabled && !this.credits) {
                    let t = i.href ? tB.filterUserAttributes({
                        href: i.href
                    }).href : void 0;
                    this.credits = this.renderer.text(i.text + (this.mapCredits || ""), 0, 0, i.useHTML).addClass("highcharts-credits").on("click", function(i) {
                        P(e, "creditsClick", i, ()=>{
                            t && (i_.location.href = t);
                        });
                    }).attr({
                        align: i.position.align,
                        zIndex: 8
                    }), i.events?.click && c(e, "creditsClick", i.events.click), e.styledMode || this.credits.css(i.style), this.credits.add().align(i.position), this.credits.update = function(t) {
                        e.credits = e.credits.destroy(), e.addCredits(t);
                    };
                }
            }
            destroy() {
                let t, e = this, i = e.axes, s = e.series, o = e.container, r = o?.parentNode;
                for(P(e, "destroy"), e.renderer.forExport ? C(i$, e) : i$[e.index] = void 0, n.chartCount--, e.renderTo.removeAttribute("data-highcharts-chart"), q(e), t = i.length; t--;)i[t] = i[t].destroy();
                for(this.scroller?.destroy?.(), t = s.length; t--;)s[t] = s[t].destroy();
                [
                    "title",
                    "subtitle",
                    "chartBackground",
                    "plotBackground",
                    "plotBGImage",
                    "plotBorder",
                    "seriesGroup",
                    "clipRect",
                    "credits",
                    "pointer",
                    "rangeSelector",
                    "legend",
                    "resetZoomButton",
                    "tooltip",
                    "renderer"
                ].forEach((t)=>{
                    e[t] = e[t]?.destroy?.();
                }), o && (o.innerHTML = tB.emptyHTML, q(o), r && w(o)), j(e, function(t, i) {
                    delete e[i];
                });
            }
            firstRender() {
                let t = this, e = t.options;
                t.getContainer(), t.resetMargins(), t.setChartSize(), t.propFromSeries(), t.createAxes();
                let i = H(e.series) ? e.series : [];
                e.series = [], i.forEach(function(e) {
                    t.initSeries(e);
                }), t.linkSeries(), P(t, "beforeRender"), t.render(), t.pointer?.getChartPosition(), t.renderer.asyncCounter || t.hasLoaded || t.onload(), t.temporaryDisplay(!0);
            }
            onload() {
                this.callbacks.concat([
                    this.callback
                ]).forEach(function(t) {
                    t && void 0 !== this.index && t.apply(this, [
                        this
                    ]);
                }, this), P(this, "load"), P(this, "render"), v(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.warnIfCSSNotLoaded(), this.hasLoaded = !0;
            }
            warnIfA11yModuleNotLoaded() {
                let { options: t, title: e } = this;
                t && !this.accessibility && (this.renderer.boxWrapper.attr({
                    role: "img",
                    "aria-label": (e?.element.textContent || "").replace(/</g, "&lt;")
                }), t.accessibility && !1 === t.accessibility.enabled || to('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
            }
            warnIfCSSNotLoaded() {
                this.styledMode && "0" !== i_.getComputedStyle(this.container).zIndex && to(35, !1, this);
            }
            addSeries(t, e, i) {
                let s, o = this;
                return t && (e = e ?? !0, P(o, "addSeries", {
                    options: t
                }, function() {
                    s = o.initSeries(t), o.isDirtyLegend = !0, o.linkSeries(), P(o, "afterAddSeries", {
                        series: s
                    }), e && o.redraw(i);
                })), s;
            }
            addAxis(t, e, i, s) {
                return this.createAxis(e ? "xAxis" : "yAxis", {
                    axis: t,
                    redraw: i,
                    animation: s
                });
            }
            addColorAxis(t, e, i) {
                return this.createAxis("colorAxis", {
                    axis: t,
                    redraw: e,
                    animation: i
                });
            }
            createAxis(t, e) {
                let i = new eL(this, e.axis, t);
                return (e.redraw ?? !0) && this.redraw(e.animation), i;
            }
            showLoading(t) {
                let e = this, i = e.options, s = i.loading, o = s?.style ?? {}, r = function() {
                    a && b(a, {
                        left: o.left ?? e.plotLeft + "px",
                        top: o.top ?? e.plotTop + "px",
                        width: o.width ?? e.plotWidth + "px",
                        height: o.height ?? e.plotHeight + "px"
                    });
                }, a = e.loadingDiv, n = e.loadingSpan;
                a || (e.loadingDiv = a = x("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, e.container)), n || (e.loadingSpan = n = x("span", {
                    className: "highcharts-loading-inner"
                }, null, a), c(e, "redraw", r)), a.className = "highcharts-loading", tB.setElementHTML(n, t ?? i.lang.loading ?? ""), !e.styledMode && (b(a, S(o, {
                    zIndex: 10
                })), b(n, s?.labelStyle ?? {}), e.loadingShown || (b(a, {
                    opacity: 0,
                    display: ""
                }), tP(a, {
                    opacity: o.opacity ?? .5
                }, {
                    duration: s?.showDuration ?? 0
                }))), e.loadingShown = !0, r();
            }
            hideLoading() {
                let t = this.options, e = this.loadingDiv;
                e && (e.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || tP(e, {
                    opacity: 0
                }, {
                    duration: t.loading?.hideDuration ?? 100,
                    complete: function() {
                        b(e, {
                            display: "none"
                        });
                    }
                })), this.loadingShown = !1;
            }
            update(t, e, i, s) {
                let o, r, a, n = this, h = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                }, l = t.isResponsiveOptions, d = [], c = {
                    options: t = M(t, n.options),
                    hasChanged: !!Object.keys(t).length
                };
                if (P(n, "update", c), !c.hasChanged) return;
                l || n.setResponsive(!1, !0), n.userOptions = F(n.userOptions, t);
                let p = t.chart;
                p && (F(!0, n.options.chart, p), this.setZoomOptions(), "className" in p && n.setClassName(p.className), ("inverted" in p || "polar" in p || "type" in p) && (n.propFromSeries(), o = !0), "alignTicks" in p && (o = !0), "events" in p && ij(this, p), j(p, function(t, e) {
                    -1 !== n.propsRequireUpdateSeries.indexOf("chart." + e) && (r = !0), -1 !== n.propsRequireDirtyBox.indexOf(e) && (n.isDirtyBox = !0), -1 !== n.propsRequireReflow.indexOf(e) && (n.isDirtyBox = !0, l || (a = !0));
                }), !n.styledMode && p.style && n.renderer.setStyle(n.options.chart.style || {})), !n.styledMode && t.colors && (this.options.colors = t.colors), j(t, function(e, i) {
                    n[i] && "function" == typeof n[i].update ? n[i].update(e, !1) : "function" == typeof n[h[i]] ? n[h[i]](e) : "colors" !== i && -1 === n.collectionsWithUpdate.indexOf(i) && F(!0, n.options[i], t[i]), "chart" !== i && -1 !== n.propsRequireUpdateSeries.indexOf(i) && (r = !0);
                }), this.collectionsWithUpdate.forEach((e)=>{
                    t[e] && (J(t[e]).forEach((t, s)=>{
                        let o;
                        if (!t) return;
                        let r = v(t.id);
                        r && (o = n.get(t.id)), !o && n[e] && (o = n[e][t.index ?? s]) && (r && v(o.options.id) || o.options.isInternal) && (o = void 0), o && o.coll === e && (o.update(t, !1), i && (o.touched = !0)), !o && i && n.collectionsWithInit[e] && (n.collectionsWithInit[e][0].apply(n, [
                            t
                        ].concat(n.collectionsWithInit[e][1] || []).concat([
                            !1
                        ])).touched = !0);
                    }), i && n[e].forEach((t)=>{
                        t.touched || t.options.isInternal ? delete t.touched : d.push(t);
                    }));
                }), d.forEach((t)=>{
                    t.chart && t.remove && t.remove(!1);
                }), o && n.axes.forEach(function(t) {
                    t.update({}, !1);
                }), r && n.series.forEach((t)=>{
                    t.chart && t.update({}, !1);
                });
                let g = p?.width, u = p && (W(p.height) ? Z(p.height, g || n.chartWidth) : p.height);
                a || N(g) && g !== n.chartWidth || N(u) && u !== n.chartHeight ? n.setSize(g, u, s) : (e ?? !0) && n.redraw(s), P(n, "afterUpdate", {
                    options: t,
                    redraw: e,
                    animation: s
                });
            }
            setSubtitle(t, e) {
                this.applyDescription("subtitle", t), this.layOutTitles(e);
            }
            setCaption(t, e) {
                this.applyDescription("caption", t), this.layOutTitles(e);
            }
            showResetZoom() {
                let t = this, e = t.options.lang, i = t.zooming.resetButton, s = i.theme, o = "chart" === i.relativeTo || "spacingBox" === i.relativeTo ? void 0 : "plotBox";
                P(this, "beforeShowResetZoom", void 0, ()=>{
                    t.resetZoomButton = t.renderer.button(e.resetZoom, 0, 0, ()=>t.zoomOut(), s).attr({
                        align: i.position.align,
                        title: e.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(i.position, !1, o);
                }), P(this, "afterShowResetZoom");
            }
            zoomOut() {
                P(this, "selection", {
                    resetSelection: !0
                }, ()=>this.transform({
                        reset: !0,
                        trigger: "zoom"
                    }));
            }
            pan(t, e) {
                let i = this, s = "object" == typeof e ? e : {
                    enabled: e,
                    type: "x"
                }, o = s.type, r = o && i[({
                    x: "xAxis",
                    xy: "axes",
                    y: "yAxis"
                })[o]].filter((t)=>t.options.panningEnabled && !t.options.isInternal), a = i.options.chart;
                a?.panning && (a.panning = s), P(this, "pan", {
                    originalEvent: t
                }, ()=>{
                    i.transform({
                        axes: r,
                        event: t,
                        to: {
                            x: t.chartX - (i.mouseDownX || 0),
                            y: t.chartY - (i.mouseDownY || 0)
                        },
                        trigger: "pan"
                    }), b(i.container, {
                        cursor: "move"
                    });
                });
            }
            transform(t) {
                let { axes: e = this.axes, event: i, from: s = {}, reset: o, selection: r, to: a = {}, trigger: n, allowResetButton: h = !0 } = t, { time: l } = this;
                this.hoverPoints?.forEach((t)=>t.setState()), P(this, "transform", t);
                let d = t.hasZoomed || !1, c, p;
                for (let t of e){
                    let { horiz: e, len: g, minPointOffset: u = 0, options: f, reversed: m } = t, x = e ? "width" : "height", y = e ? "x" : "y", b = a[x] ?? t.len, k = s[x] ?? t.len, w = 10 > Math.abs(b) ? 1 : b / k, M = (s[y] || 0) + k / 2 - t.pos, C = M - ((a[y] ?? t.pos) + b / 2 - t.pos) / w, T = e && !m || !e && m ? 1 : -1;
                    if (!o && (M < 0 || M > t.len)) continue;
                    let P = r || t.chart.polar || t.isOrdinal && w <= 1 ? 0 : u * T || 0, A = t.toValue(C, !0), L = t.toValue(C + g / w, !0), O = A + P, E = L - P, I = t.allExtremes;
                    if (O > E && ([O, E] = [
                        E,
                        O
                    ]), 1 === w && !o && "yAxis" === t.coll && !I) {
                        for (let e of t.series){
                            let t = e.getExtremes(e.getProcessedData(!0).modified.getColumn(e.pointValKey || "y") || [], !0);
                            I ?? (I = {
                                dataMin: Number.MAX_VALUE,
                                dataMax: -Number.MAX_VALUE
                            }), N(t.dataMin) && N(t.dataMax) && (I.dataMin = Math.min(t.dataMin, I.dataMin), I.dataMax = Math.max(t.dataMax, I.dataMax));
                        }
                        t.allExtremes = I;
                    }
                    let { dataMin: D, dataMax: B, min: z, max: R } = S(t.getExtremes(), I || {}), W = l.parse(f.min), H = l.parse(f.max), G = D ?? W, X = B ?? H, F = E - O, Y = t.categories ? 0 : Math.min(F, X - G), j = G - Y * (v(W) ? 0 : f.minPadding), $ = X + Y * (v(H) ? 0 : f.maxPadding), V = t.allowZoomOutside || 1 === w || "zoom" !== n && w > 1, U = Math.min(W ?? j, j, V ? z : j), _ = Math.max(H ?? $, $, V ? R : $);
                    (!t.isOrdinal || 1 !== w || o) && (O < U && (O = U, w >= 1 && (E = O + F)), E > _ && (E = _, w >= 1 && (O = E - F)), (o || t.series.length && (r || (O !== z || E !== R) && O >= U && E <= _)) && (r ? r[t.coll].push({
                        axis: t,
                        min: Math.min(A, L),
                        max: Math.max(A, L)
                    }) : (t.isPanning = "zoom" !== n && "drop" !== n, t.isPanning && "mousewheel" !== n && (p = !0), "drop" !== n && t.setExtremes(o ? void 0 : O, o ? void 0 : E, !1, !1, {
                        move: C,
                        trigger: n,
                        scale: w
                    }), !o && (O > U || E < _) && (c = h)), d = !0), this.hasCartesianSeries || o || (c = h), i && (this[e ? "mouseDownX" : "mouseDownY"] = i[e ? "chartX" : "chartY"]));
                }
                return d && (r ? P(this, "selection", r, ()=>{
                    delete t.selection, t.trigger = "zoom", this.transform(t);
                }) : (!c || p || this.resetZoomButton ? !c && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw("zoom" === n && (this.options.chart.animation ?? this.pointCount < 100)))), d;
            }
        }
        S(iK.prototype, {
            callbacks: [],
            collectionsWithInit: {
                xAxis: [
                    iK.prototype.addAxis,
                    [
                        !0
                    ]
                ],
                yAxis: [
                    iK.prototype.addAxis,
                    [
                        !1
                    ]
                ],
                series: [
                    iK.prototype.addSeries
                ]
            },
            collectionsWithUpdate: [
                "xAxis",
                "yAxis",
                "series"
            ],
            propsRequireDirtyBox: [
                "backgroundColor",
                "borderColor",
                "borderWidth",
                "borderRadius",
                "plotBackgroundColor",
                "plotBackgroundImage",
                "plotBorderColor",
                "plotBorderRadius",
                "plotBorderWidth",
                "plotShadow",
                "shadow"
            ],
            propsRequireReflow: [
                "margin",
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
                "spacing",
                "spacingTop",
                "spacingRight",
                "spacingBottom",
                "spacingLeft"
            ],
            propsRequireUpdateSeries: [
                "chart.inverted",
                "chart.polar",
                "chart.ignoreHiddenSeries",
                "chart.type",
                "colors",
                "plotOptions",
                "time",
                "tooltip"
            ]
        });
        let { composed: iq } = n;
        function iJ() {
            (this.scrollablePixelsX || this.scrollablePixelsY) && !this.scrollablePlotArea && (this.scrollablePlotArea = new i0(this)), this.scrollablePlotArea?.applyFixed();
        }
        function iQ() {
            this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
        }
        class i0 {
            static compose(t, e, i) {
                _(iq, "ScrollablePlotArea") && (c(t, "afterInit", iQ), c(e, "afterSetChartSize", (t)=>this.afterSetSize(t.target, t)), c(e, "render", iJ), c(i, "show", iQ));
            }
            static afterSetSize(t, e) {
                let i, s, o, { minWidth: r, minHeight: a } = t.options.chart.scrollablePlotArea || {}, { clipBox: n, plotBox: h, inverted: l, renderer: d } = t;
                if (!d.forExport) {
                    if (r ? (t.scrollablePixelsX = i = Math.max(0, r - t.chartWidth), i && (t.scrollablePlotBox = F(t.plotBox), h.width = t.plotWidth += i, n[l ? "height" : "width"] += i, o = !0)) : a && (t.scrollablePixelsY = s = Math.max(0, a - t.chartHeight), v(s) && (t.scrollablePlotBox = F(t.plotBox), h.height = t.plotHeight += s, n[l ? "width" : "height"] += s, o = !1)), v(o)) {
                        if (!e.skipAxes) for (let e of t.axes)(e.horiz === o || t.hasParallelCoordinates && "yAxis" === e.coll) && (e.setAxisSize(), e.setAxisTranslation());
                    } else delete t.scrollablePlotBox;
                }
            }
            constructor(t){
                let e, i = t.options.chart, s = i.scrollablePlotArea || {}, o = this.moveFixedElements.bind(this), r = {
                    WebkitOverflowScrolling: "touch",
                    overflowX: "hidden",
                    overflowY: "hidden"
                };
                t.scrollablePixelsX && (r.overflowX = "auto"), t.scrollablePixelsY && (r.overflowY = "auto"), this.chart = t;
                let a = this.parentDiv = x("div", {
                    className: "highcharts-scrolling-parent"
                }, {
                    position: "relative"
                }, t.renderTo), n = this.scrollingContainer = x("div", {
                    className: "highcharts-scrolling"
                }, r, a), h = this.innerContainer = x("div", {
                    className: "highcharts-inner-container"
                }, void 0, n), l = this.fixedDiv = x("div", {
                    className: "highcharts-fixed"
                }, {
                    position: "absolute",
                    overflow: "hidden",
                    pointerEvents: "none",
                    zIndex: (i.style?.zIndex || 0) + 2,
                    top: 0
                }, void 0, !0), d = this.fixedRenderer = new eg(l, t.chartWidth, t.chartHeight, i.style);
                this.mask = d.path().attr({
                    fill: i.backgroundColor || "#fff",
                    "fill-opacity": s.opacity ?? .85,
                    zIndex: -1
                }).addClass("highcharts-scrollable-mask").add(), n.parentNode.insertBefore(l, n), b(t.renderTo, {
                    overflow: "visible"
                }), c(t, "afterShowResetZoom", o), c(t, "afterApplyDrilldown", o), c(t, "afterLayOutTitles", o), c(n, "scroll", ()=>{
                    let { pointer: i, hoverPoint: s } = t;
                    i && (delete i.chartPosition, s && (e = s), i.runPointActions(void 0, e, !0));
                }), h.appendChild(t.container);
            }
            applyFixed() {
                let { chart: t, fixedRenderer: e, isDirty: i, scrollingContainer: s } = this, { axisOffset: o, chartWidth: r, chartHeight: a, container: n, plotHeight: h, plotLeft: l, plotTop: d, plotWidth: c, scrollablePixelsX: p = 0, scrollablePixelsY: g = 0 } = t, { scrollPositionX: u = 0, scrollPositionY: f = 0 } = t.options.chart.scrollablePlotArea || {}, m = r + p, x = a + g;
                e.setSize(r, a), (i ?? !0) && (this.isDirty = !1, this.moveFixedElements()), tA(t.container), b(n, {
                    width: `${m}px`,
                    height: `${x}px`
                }), t.renderer.boxWrapper.attr({
                    width: m,
                    height: x,
                    viewBox: [
                        "0 0",
                        m,
                        x
                    ].join(" ")
                }), t.chartBackground?.attr({
                    width: m,
                    height: x
                }), b(s, {
                    width: `${r}px`,
                    height: `${a}px`
                }), v(i) || (s.scrollLeft = p * u, s.scrollTop = g * f);
                let y = d - o[0] - 1, k = l - o[3] - 1, w = d + h + o[2] + 1, M = l + c + o[1] + 1, C = l + c - p, S = d + h - g, T = [
                    [
                        "M",
                        0,
                        0
                    ]
                ];
                p ? T = [
                    [
                        "M",
                        0,
                        y
                    ],
                    [
                        "L",
                        l - 1,
                        y
                    ],
                    [
                        "L",
                        l - 1,
                        w
                    ],
                    [
                        "L",
                        0,
                        w
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        C,
                        y
                    ],
                    [
                        "L",
                        r,
                        y
                    ],
                    [
                        "L",
                        r,
                        w
                    ],
                    [
                        "L",
                        C,
                        w
                    ],
                    [
                        "Z"
                    ]
                ] : g && (T = [
                    [
                        "M",
                        k,
                        0
                    ],
                    [
                        "L",
                        k,
                        d - 1
                    ],
                    [
                        "L",
                        M,
                        d - 1
                    ],
                    [
                        "L",
                        M,
                        0
                    ],
                    [
                        "Z"
                    ],
                    [
                        "M",
                        k,
                        S
                    ],
                    [
                        "L",
                        k,
                        a
                    ],
                    [
                        "L",
                        M,
                        a
                    ],
                    [
                        "L",
                        M,
                        S
                    ],
                    [
                        "Z"
                    ]
                ]), "adjustHeight" !== t.redrawTrigger && this.mask.attr({
                    d: T
                });
            }
            moveFixedElements() {
                let t, { container: e, inverted: i, scrollablePixelsX: s, scrollablePixelsY: o } = this.chart, r = this.fixedRenderer, a = i0.fixedSelectors.slice();
                if (s && !i ? t = ".highcharts-yaxis" : s && i || o && !i ? t = ".highcharts-xaxis" : o && i && (t = ".highcharts-yaxis"), t && !(this.chart.hasParallelCoordinates && ".highcharts-yaxis" === t)) for (let e of [
                    `${t}:not(.highcharts-radial-axis)`,
                    `${t}-labels:not(.highcharts-radial-axis-labels)`
                ])_(a, e);
                else for (let t of [
                    ".highcharts-xaxis",
                    ".highcharts-yaxis"
                ])for (let e of [
                    `${t}:not(.highcharts-radial-axis)`,
                    `${t}-labels:not(.highcharts-radial-axis-labels)`
                ])C(a, e);
                for (let t of a)[].forEach.call(e.querySelectorAll(t), (t)=>{
                    (t.namespaceURI === r.SVG_NS ? r.box : r.box.parentNode).appendChild(t), t.style.pointerEvents = "auto";
                });
            }
        }
        i0.fixedSelectors = [
            ".highcharts-breadcrumbs-group",
            ".highcharts-contextbutton",
            ".highcharts-caption",
            ".highcharts-credits",
            ".highcharts-drillup-button",
            ".highcharts-legend",
            ".highcharts-legend-checkbox",
            ".highcharts-navigator-series",
            ".highcharts-navigator-xaxis",
            ".highcharts-navigator-yaxis",
            ".highcharts-navigator",
            ".highcharts-range-selector-group",
            ".highcharts-reset-zoom",
            ".highcharts-scrollbar",
            ".highcharts-subtitle",
            ".highcharts-title"
        ];
        let { format: i1 } = tF, { series: i2 } = iT, i5 = class {
            constructor(t, e, i, s){
                this.axis = t, this.negativeValue = e, this.x = i, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = s, this.leftCliff = 0, this.rightCliff = 0;
            }
            destroy() {
                k(this, this.axis);
            }
            render(t) {
                let e = this.axis, i = e.chart, s = e.options.stackLabels || {}, o = s.format, r = (o ? i1(o, this, i) : s.formatter?.call(this, this)) || "", a = this.label ? "animate" : "attr";
                this.label || (this.label = i.renderer.label(r, 0, void 0, s.shape, void 0, void 0, s.useHTML, !1, "stack-labels"));
                let n = this.label, h = {
                    r: s.borderRadius || 0,
                    padding: s.padding ?? 5
                };
                i.styledMode || (h.fill = s.backgroundColor, h.stroke = s.borderColor, h["stroke-width"] = s.borderWidth, n.css(s.style || {})), n.attr({
                    text: r,
                    visibility: "hidden"
                })[a](h), n.added || n.add(t), n.labelrank = i.plotSizeY, P(this, "afterRender");
            }
            setOffset(t, e, i, s, o, r) {
                let { axis: a, label: n } = this, h = a.chart, l = a.options.stackLabels || {}, d = h.inverted, c = !!a.reversed !== this.negativeValue, p = this.getStackBox({
                    boxBottom: i,
                    boxTop: s,
                    defaultX: o,
                    isNegative: c,
                    width: e,
                    xAxis: r,
                    xOffset: t
                }), { align: g = d ? c ? "left" : "right" : "center", verticalAlign: u = d ? "middle" : c ? "bottom" : "top", textAlign: f = d ? !c ? "left" : "right" : "center", x: m = 0, y: x = 0 } = l, y = {
                    align: g,
                    verticalAlign: u,
                    x: m,
                    y: x
                };
                if (n && p) {
                    let t = n.getBBox(void 0, 0), e = n.padding, i = (l.overflow ?? "justify") === "justify", s, { x: o, y: r } = this.adjustStackPosition({
                        labelBox: t,
                        verticalAlign: u,
                        textAlign: f
                    });
                    p.x -= o, p.y -= r, n.align(y, !1, p), (s = h.isInsidePlot(n.alignAttr.x + m + o, n.alignAttr.y + x + r)) || (i = !1), i && i2.prototype.justifyDataLabel.call(a, n, y, n.alignAttr, t, p), n.attr({
                        rotation: l.rotation,
                        rotationOriginX: t.width * A(l.textAlign || "center"),
                        rotationOriginY: t.height / 2
                    }), ((!i && l.crop) ?? !0) && (s = N(n.x) && N(n.y) && h.isInsidePlot(n.x - e + (n.width || 0), n.y) && h.isInsidePlot(n.x + e, n.y)), n[s ? "show" : "hide"]();
                }
                P(this, "afterSetOffset", {
                    xOffset: t,
                    width: e
                });
            }
            adjustStackPosition({ labelBox: t, verticalAlign: e, textAlign: i }) {
                return {
                    x: t.width / 2 + t.width / 2 * (2 * A(i) - 1),
                    y: t.height / 2 * 2 * (1 - A(e))
                };
            }
            getStackBox(t) {
                let e = this.axis, i = e.chart, { boxBottom: s, boxTop: o, defaultX: r, isNegative: a, width: n, xOffset: h } = t, l = e.stacking.usePercentage ? 100 : o ?? this.total ?? 0, d = e.toPixels(l), c = t.xAxis || i.xAxis[0], p = (r ?? c.translate(this.x)) + h, g = Math.abs(d - e.toPixels(s || N(e.min) && e.logarithmic && e.logarithmic.lin2log(e.min) || 0));
                return i.inverted ? {
                    x: (a ? d : d - g) - i.plotLeft,
                    y: c.height - p - n + c.top - i.plotTop,
                    width: g,
                    height: n
                } : {
                    x: p + c.transB - i.plotLeft,
                    y: (a ? d - g : d) - i.plotTop,
                    width: n,
                    height: g
                };
            }
        }, { series: { prototype: i3 } } = iT;
        function i9() {
            let t = this.inverted;
            this.axes.forEach((t)=>{
                t.stacking?.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
            }), this.series.forEach((e)=>{
                let i = e.xAxis?.options || {};
                e.options.stacking && e.reserveSpace() && (e.stackKey = [
                    e.type,
                    e.options.stack ?? "",
                    t ? i.top : i.left,
                    t ? i.height : i.width
                ].join(","));
            });
        }
        function i6() {
            let t = this.stacking;
            if (t) {
                let e = t.stacks;
                j(e, (t, i)=>{
                    k(t), delete e[i];
                }), t.stackTotalGroup?.destroy();
            }
        }
        function i4() {
            this.stacking || (this.stacking = new ss(this));
        }
        function i8(t, e, i, s) {
            return !v(t) || t.x !== e || s && t.stackKey !== s ? t = {
                x: e,
                index: 0,
                key: s,
                stackKey: s
            } : t.index++, t.key = [
                i,
                e,
                t.index
            ].join(","), t;
        }
        function i7() {
            let t, e = this, i = e.yAxis, s = e.stackKey || "", o = i.stacking.stacks, r = e.getColumn("x", !0), a = e.options.stacking, n = e[a + "Stacker"];
            n && [
                s,
                "-" + s
            ].forEach((i)=>{
                let s = r.length, a, h, l;
                for(; s--;)a = r[s], t = e.getStackIndicator(t, a, e.index, i), h = o[i]?.[a], (l = h?.points[t.key || ""]) && n.call(e, l, h, s);
            });
        }
        function st(t, e, i) {
            let s = e.total ? 100 / e.total : 0;
            t[0] = m(t[0] * s), t[1] = m(t[1] * s), this.stackedYData[i] = t[1];
        }
        function se(t) {
            (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && this.chart.series.length > 1 ? i3.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
        }
        function si(t, e) {
            let i, s, o, r, a, n, h, l = e || this.options.stacking;
            if (!l || !this.reserveSpace() || (({
                group: "xAxis"
            })[l] || "yAxis") !== t.coll) return;
            let d = this.getColumn("x", !0), c = this.getColumn(this.pointValKey || "y", !0), p = [], g = c.length, u = this.options, f = u.threshold || 0, x = u.startFromThreshold ? f : 0, y = u.stack, b = e ? `${this.type},${l}` : this.stackKey || "", k = "-" + b, w = this.negStacks, M = t.stacking, C = M.stacks, S = M.oldStacks;
            for(M.stacksTouched += 1, h = 0; h < g; h++){
                let e = d[h] || 0, g = c[h], u = N(g) && g || 0;
                n = (i = this.getStackIndicator(i, e, this.index)).key || "", C[a = (s = w && u < (x ? 0 : f)) ? k : b] || (C[a] = {}), C[a][e] || (S[a]?.[e] ? (C[a][e] = S[a][e], C[a][e].total = null) : C[a][e] = new i5(t, !!s, e, y)), o = C[a][e], null !== g ? (o.points[n] = o.points[this.index] = [
                    o.cumulative ?? x
                ], v(o.cumulative) || (o.base = n), o.touched = M.stacksTouched, i.index > 0 && !1 === this.singleStacks && (o.points[n][0] = o.points[this.index + "," + e + ",0"][0])) : (delete o.points[n], delete o.points[this.index]);
                let T = o.total || 0;
                "percent" === l ? (r = s ? b : k, T = w && C[r]?.[e] ? (r = C[r][e]).total = Math.max(r.total || 0, T) + Math.abs(u) : m(T + Math.abs(u))) : "group" === l ? N(g) && T++ : T = m(T + u), "group" === l ? o.cumulative = (T || 1) - 1 : o.cumulative = m((o.cumulative ?? x) + u), o.total = T, null !== g && (o.points[n].push(o.cumulative), p[h] = o.cumulative, o.hasValidPoints = !0);
            }
            "percent" === l && (M.usePercentage = !0), "group" !== l && (this.stackedYData = p), M.oldStacks = {};
        }
        class ss {
            constructor(t){
                this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
            }
            buildStacks() {
                let t, e, i = this.axis, s = i.series, o = "xAxis" === i.coll, r = i.options.reversedStacks, a = s.length;
                for(this.resetStacks(), this.usePercentage = !1, e = a; e--;)t = s[r ? e : a - e - 1], o && t.setGroupedPoints(i), t.setStackedPoints(i);
                if (!o) for(e = 0; e < a; e++)s[e].modifyStacks();
                P(i, "afterBuildStacks");
            }
            cleanStacks() {
                this.oldStacks && (this.stacks = this.oldStacks, j(this.stacks, (t)=>{
                    j(t, (t)=>{
                        t.cumulative = t.total;
                    });
                }));
            }
            resetStacks() {
                j(this.stacks, (t)=>{
                    j(t, (e, i)=>{
                        N(e.touched) && e.touched < this.stacksTouched ? (e.destroy(), delete t[i]) : (e.total = null, e.cumulative = null);
                    });
                });
            }
            renderStackTotals() {
                let t = this.axis, e = t.chart, i = e.renderer, s = this.stacks, { animation: o, enabled: r } = t.options.stackLabels || {}, a = tT(e, o || !1), n = this.stackTotalGroup = this.stackTotalGroup || (r ? i.g("stack-labels").attr({
                    zIndex: 6,
                    opacity: 0
                }).add() : void 0);
                n && (n.translate(e.plotLeft, e.plotTop), j(s, (t)=>{
                    j(t, (t)=>{
                        r ? t.render(n) : t.label = t.label?.destroy();
                    });
                }), n.animate({
                    opacity: 1
                }, a));
            }
        }
        (is || (is = {})).compose = function(t, e, i) {
            let s = e.prototype, o = i.prototype;
            s.getStacks || (c(t, "init", i4), c(t, "destroy", i6), s.getStacks = i9, o.getStackIndicator = i8, o.modifyStacks = i7, o.percentStacker = st, o.setGroupedPoints = se, o.setStackedPoints = si);
        };
        let so = is;
        class sr extends iB {
            drawGraph() {
                let t = this.options, e = (this.gappedPath || this.getGraphPath).call(this), i = this.chart.styledMode;
                [
                    this,
                    ...this.zones
                ].forEach((s, o)=>{
                    let r, a = s.graph, n = a ? "animate" : "attr", h = s.dashStyle || t.dashStyle;
                    if (a ? (a.endX = this.preventGraphAnimation ? null : e.xMap, a.animate({
                        d: e
                    })) : e.length && (s.graph = a = this.chart.renderer.path(e).addClass("highcharts-graph" + (o ? ` highcharts-zone-graph-${o - 1} ` : " ") + (o && s.className || "")).attr({
                        zIndex: 1
                    }).add(this.group)), a && !i && (r = {
                        stroke: !o && t.lineColor || s.color || this.color || "var(--highcharts-neutral-color-20)",
                        "stroke-width": t.lineWidth || 0,
                        fill: this.fillGraph && this.color || "none"
                    }, h ? r.dashstyle = h : "square" !== t.linecap && (r["stroke-linecap"] = r["stroke-linejoin"] = "round"), a[n](r), t.shadow)) {
                        let e = this.chart.inverted, i = {
                            filterUnits: "userSpaceOnUse"
                        }, s = X(t.shadow) ? F(e ? {} : i, t.shadow) : !!e || i;
                        a.shadow(s);
                    }
                    a && (a.startX = e.xMap, a.isArea = e.isArea);
                });
            }
            getGraphPath(t, e, i) {
                let s = this, o = s.options, r = [], a = [], n, h = o.step, l = (t = t || s.points).reversed;
                return l && t.reverse(), (h = ({
                    right: 1,
                    center: 2
                })[h] || h && 3) && l && (h = 4 - h), (t = this.getValidPoints(t, !1, o.nullInteraction || !(o.connectNulls && !e && !i))).forEach(function(l, d) {
                    let c, p = l.plotX, g = l.plotY, u = t[d - 1], f = l.isNull || "number" != typeof g;
                    (l.leftCliff || u?.rightCliff) && !i && (n = !0), f && !v(e) && d > 0 ? n = !o.connectNulls : f && !e ? n = !0 : (0 === d || n ? c = [
                        [
                            "M",
                            l.plotX,
                            l.plotY
                        ]
                    ] : s.getPointSpline ? c = [
                        s.getPointSpline(t, l, d)
                    ] : h ? (c = 1 === h ? [
                        [
                            "L",
                            u.plotX,
                            g
                        ]
                    ] : 2 === h ? [
                        [
                            "L",
                            (u.plotX + p) / 2,
                            u.plotY
                        ],
                        [
                            "L",
                            (u.plotX + p) / 2,
                            g
                        ]
                    ] : [
                        [
                            "L",
                            p,
                            u.plotY
                        ]
                    ]).push([
                        "L",
                        p,
                        g
                    ]) : c = [
                        [
                            "L",
                            p,
                            g
                        ]
                    ], a.push(l.x), h && (a.push(l.x), 2 === h && a.push(l.x)), r.push.apply(r, c), n = !1);
                }), r.xMap = a, s.graphPath = r, r;
            }
        }
        sr.defaultOptions = F(iB.defaultOptions, {
            legendSymbol: "lineMarker"
        }), iT.registerSeriesType("line", sr);
        let { seriesTypes: { line: sa } } = iT;
        class sn extends sa {
            drawGraph() {
                this.areaPath = [], super.drawGraph.apply(this);
                let { areaPath: t, options: e } = this;
                [
                    this,
                    ...this.zones
                ].forEach((i, s)=>{
                    let o = {}, r = i.fillColor || e.fillColor, a = i.area, n = a ? "animate" : "attr";
                    a ? (a.endX = this.preventGraphAnimation ? null : t.xMap, a.animate({
                        d: t
                    })) : (o.zIndex = 0, (a = i.area = this.chart.renderer.path(t).addClass("highcharts-area" + (s ? ` highcharts-zone-area-${s - 1} ` : " ") + (s && i.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (o.fill = r || i.color || this.color, o["fill-opacity"] = r ? 1 : e.fillOpacity ?? .75, a.css({
                        pointerEvents: this.stickyTracking ? "none" : "auto"
                    })), a[n](o), a.startX = t.xMap, a.shiftUnit = e.step ? 2 : 1;
                });
            }
            getGraphPath(t) {
                let e, i, s, o = sa.prototype.getGraphPath, r = this.options, a = r.stacking, n = this.yAxis, h = [], l = [], d = this.index, c = n.stacking.stacks[this.stackKey], p = r.threshold, g = Math.round(n.getThreshold(r.threshold)), u = r.connectNulls ?? "percent" === a, f = function(i, s, o) {
                    let r = t[i], u = t[s], f = a && c[r.x].points[d], m = r[o + "Null"] || 0, x = r[o + "Cliff"] || 0, y, b, k = !0;
                    f && (x || m) ? (y = (m ? f[0] : f[1]) + x, b = f[0] + x, k = !!m) : !a && u && (u.isNull || !v(u.plotY)) && (y = b = p), void 0 !== y && (l.push({
                        plotX: e,
                        plotY: null === y ? g : n.getThreshold(y),
                        isNull: k,
                        isCliff: !0
                    }), h.push({
                        plotX: e,
                        plotY: null === b ? g : n.getThreshold(b),
                        doCurve: !1
                    }));
                };
                t = t || this.points, a && (t = this.getStackPoints(t));
                for(let o = 0, r = t.length; o < r; ++o)a || (t[o].leftCliff = t[o].rightCliff = t[o].leftNull = t[o].rightNull = void 0), i = t[o].isNull || !v(t[o].plotY), e = t[o].rectPlotX ?? t[o].plotX, s = a ? t[o].yBottom ?? g : g, (!i || u) && (u || f(o, o - 1, "left"), i && !a && u || (l.push(t[o]), h.push({
                    x: o,
                    plotX: e,
                    plotY: s
                })), u || f(o, o + 1, "right"));
                let m = o.call(this, l, !0, !0);
                h.reversed = !0;
                let x = o.call(this, h, !0, !0), y = x[0];
                y && "M" === y[0] && (x[0] = [
                    "L",
                    y[1],
                    y[2]
                ]);
                let b = m.concat(x);
                b.length && b.push([
                    "Z"
                ]);
                let k = o.call(this, l, !1, u);
                return this.chart.series.length > 1 && a && l.some((t)=>t.isCliff) && (b.hasStackedCliffs = k.hasStackedCliffs = !0), b.xMap = m.xMap, this.areaPath = b, k;
            }
            getStackPoints(t) {
                let e = this, i = [], s = [], o = this.xAxis, r = this.yAxis, a = r.stacking.stacks[this.stackKey], n = {}, h = r.series, l = h.length, d = r.options.reversedStacks ? 1 : -1, c = h.indexOf(e), p = r.getThreshold(e.options.threshold || 0);
                if (t = t || this.points, this.options.stacking) {
                    for(let e = 0; e < t.length; e++)t[e].leftNull = t[e].rightNull = void 0, n[t[e].x] = t[e];
                    j(a, function(t, e) {
                        null !== t.total && s.push(e);
                    }), s.sort(function(t, e) {
                        return t - e;
                    });
                    let g = h.map((t)=>t.visible);
                    s.forEach(function(t, u) {
                        let f = 0, m, x;
                        if (n[t] && !n[t].isNull) i.push(n[t]), [
                            -1,
                            1
                        ].forEach(function(i) {
                            let o = 1 === i ? "rightNull" : "leftNull", r = a[s[u + i]], p = 0;
                            if (r) {
                                let i = c;
                                for(; i >= 0 && i < l;){
                                    let s = h[i].index;
                                    !(m = r.points[s]) && (s === e.index ? n[t][o] = !0 : g[i] && (x = a[t].points[s]) && (p -= x[1] - x[0])), i += d;
                                }
                            }
                            n[t][1 === i ? "rightCliff" : "leftCliff"] = p;
                        });
                        else {
                            let e = c;
                            for(; e >= 0 && e < l;){
                                let i = h[e].index;
                                if (m = a[t].points[i]) {
                                    f = m[1];
                                    break;
                                }
                                e += d;
                            }
                            f || (f = 0);
                            let s = r.positiveValuesOnly && f <= 0 ? p : r.translate(f, !1, !0, !1, !0);
                            i.push({
                                isNull: !0,
                                plotX: o.translate(t, !1, !1, !1, !0),
                                x: t,
                                plotY: s,
                                yBottom: s
                            });
                        }
                    });
                }
                return i;
            }
        }
        sn.defaultOptions = F(sa.defaultOptions, {
            threshold: 0,
            legendSymbol: "areaMarker"
        }), S(sn.prototype, {
            singleStacks: !1
        }), iT.registerSeriesType("area", sn);
        let { line: sh } = iT.seriesTypes;
        class sl extends sh {
            getPointSpline(t, e, i) {
                let s, o, r, a, n = e.plotX || 0, h = e.plotY || 0, l = t[i - 1], d = t[i + 1];
                function c(t) {
                    return t && !t.isNull && !1 !== t.doCurve && !e.isCliff;
                }
                if (c(l) && c(d)) {
                    let t = l.plotX || 0, i = l.plotY || 0, c = d.plotX || 0, p = d.plotY || 0, g = 0;
                    s = (1.5 * n + t) / 2.5, o = (1.5 * h + i) / 2.5, r = (1.5 * n + c) / 2.5, a = (1.5 * h + p) / 2.5, r !== s && (g = (a - o) * (r - n) / (r - s) + h - a), o += g, a += g, o > i && o > h ? (o = Math.max(i, h), a = 2 * h - o) : o < i && o < h && (o = Math.min(i, h), a = 2 * h - o), a > p && a > h ? (a = Math.max(p, h), o = 2 * h - a) : a < p && a < h && (a = Math.min(p, h), o = 2 * h - a), e.rightContX = r, e.rightContY = a, e.controlPoints = {
                        low: [
                            s,
                            o
                        ],
                        high: [
                            r,
                            a
                        ]
                    };
                }
                let p = [
                    "C",
                    l.rightContX ?? l.plotX ?? 0,
                    l.rightContY ?? l.plotY ?? 0,
                    s ?? n ?? 0,
                    o ?? h ?? 0,
                    n,
                    h
                ];
                return l.rightContX = l.rightContY = void 0, p;
            }
        }
        sl.defaultOptions = F(sh.defaultOptions), iT.registerSeriesType("spline", sl);
        let sd = sl, { area: sc, area: { prototype: sp } } = iT.seriesTypes;
        class sg extends sd {
        }
        sg.defaultOptions = F(sd.defaultOptions, sc.defaultOptions), S(sg.prototype, {
            getGraphPath: sp.getGraphPath,
            getStackPoints: sp.getStackPoints,
            drawGraph: sp.drawGraph
        }), iT.registerSeriesType("areaspline", sg);
        let { parse: su } = tv, { noop: sf } = n;
        class sm extends iB {
            animate(t) {
                let e, i, s = this, o = this.yAxis, r = o.pos, a = o.reversed, n = s.options, { clipOffset: h, inverted: l } = this.chart, d = {}, c = l ? "translateX" : "translateY";
                t && h ? (d.scaleY = .001, i = f(o.toPixels(n.threshold || 0), r, r + o.len), l ? d.translateX = (i += a ? -Math.floor(h[+!!l]) : Math.ceil(h[l ? 3 : 2])) - o.len : d.translateY = i += a ? Math.ceil(h[+!!l]) : -Math.floor(h[l ? 3 : 2]), s.clipBox && s.setClip(), s.group.attr(d)) : (e = Number(s.group.attr(c)), s.group.animate({
                    scaleY: 1
                }, S(tS(s.options.animation), {
                    step: function(t, i) {
                        s.group && (d[c] = e + i.pos * (r - e), s.group.attr(d));
                    }
                })));
            }
            init(t, e) {
                super.init.apply(this, arguments);
                let i = this;
                (t = i.chart).hasRendered && t.series.forEach(function(t) {
                    t.type === i.type && (t.isDirty = !0);
                });
            }
            getColumnMetrics() {
                let t = this, e = t.options, i = t.xAxis, s = t.yAxis, o = i.options.reversedStacks, r = i.reversed && !o || !i.reversed && o, a = {}, n, h = 0;
                !1 === e.grouping ? h = 1 : t.chart.series.forEach(function(e) {
                    let i, o = e.yAxis, r = e.options;
                    e.type === t.type && e.reserveSpace() && s.len === o.len && s.pos === o.pos && (r.stacking && "group" !== r.stacking ? (void 0 === a[n = e.stackKey] && (a[n] = h++), i = a[n]) : !1 !== r.grouping && (i = h++), e.columnIndex = i);
                });
                let l = Math.min(Math.abs(i.transA) * (!i.brokenAxis?.hasBreaks && i.ordinal?.slope || e.pointRange || i.closestPointRange || i.tickInterval || 1), i.len), d = l * e.groupPadding, c = (l - 2 * d) / (h || 1), p = Math.min(e.maxPointWidth || i.len, e.pointWidth ?? c * (1 - 2 * e.pointPadding)), g = (t.columnIndex || 0) + +!!r;
                return t.columnMetrics = {
                    width: p,
                    offset: (c - p) / 2 + (d + g * c - l / 2) * (r ? -1 : 1),
                    paddedWidth: c,
                    columnCount: h
                }, t.columnMetrics;
            }
            crispCol(t, e, i, s) {
                let o = this.borderWidth, r = this.chart.inverted;
                return s = y(e + s, o, r) - (e = y(e, o, r)), this.options.crisp && (i = y(t + i, o) - (t = y(t, o))), {
                    x: t,
                    y: e,
                    width: i,
                    height: s
                };
            }
            adjustForMissingColumns(t, e, i, s) {
                if (!i.isNull && s.columnCount > 1) {
                    let o = this.xAxis.series.filter((t)=>t.visible).map((t)=>t.index), r = 0, a = 0;
                    j(this.xAxis.stacking?.stacks, (t)=>{
                        let e = "number" == typeof i.x ? t[i.x.toString()]?.points : void 0, s = e?.[this.index], n = {};
                        if (e && H(s)) {
                            let t = this.index, i = Object.keys(e).filter((t)=>!t.match(",") && e[t] && e[t].length > 1).map(parseFloat).filter((t)=>-1 !== o.indexOf(t)).filter((e)=>{
                                let i = this.chart.series[e].options, s = i.stacking && i.stack;
                                if (v(s)) {
                                    if (N(n[s])) return t === e && (t = n[s]), !1;
                                    n[s] = e;
                                }
                                return !0;
                            }).sort((t, e)=>e - t);
                            r = i.indexOf(t), a = i.length;
                        }
                    }), r = this.xAxis.reversed ? a - 1 - r : r;
                    let n = (a - 1) * s.paddedWidth + e;
                    t = (i.plotX || 0) + n / 2 - e - r * s.paddedWidth;
                }
                return t;
            }
            translate() {
                let t = this, e = t.chart, i = t.options, s = t.dense = t.closestPointRange * t.xAxis.transA < 2, o = t.borderWidth = i.borderWidth ?? +!s, r = t.xAxis, a = t.yAxis, n = i.threshold, h = i.minPointLength ?? 5, l = t.getColumnMetrics(), d = l.width, c = t.pointXOffset = l.offset, p = t.dataMin, g = t.dataMax, u = t.translatedThreshold = a.getThreshold(n), m = t.barW = Math.max(d, 1 + 2 * o);
                i.pointPadding && i.crisp && (m = Math.ceil(m)), iB.prototype.translate.apply(t), t.points.concat(t.condemnedPoints).forEach(function(s) {
                    let o = s.yBottom ?? u, x = 999 + Math.abs(o), y = s.plotX || 0, b = f(s.plotY, -x, a.len + x), k, w = Math.min(b, o), M = Math.max(b, o) - w, C = d, S = y + c, T = m;
                    h && Math.abs(M) < h && (M = h, k = !a.reversed && !s.negative || a.reversed && s.negative, N(n) && N(g) && s.y === n && g <= n && (a.min || 0) < n && (p !== g || (a.max || 0) <= n) && (k = !k, s.negative = !s.negative), w = Math.abs(w - u) > h ? o - (k ? h : 0) : u - (k ? h : 0)), v(s.options.pointWidth) && (S -= Math.round(((C = T = Math.ceil(s.options.pointWidth)) - d) / 2)), i.centerInCategory && (S = t.adjustForMissingColumns(S, C, s, l)), s.barX = S, s.pointWidth = C, s.tooltipPos = e.inverted ? [
                        f(a.len + a.pos - e.plotLeft - b, a.pos - e.plotLeft, a.len + a.pos - e.plotLeft),
                        r.len + r.pos - e.plotTop - S - T / 2,
                        M
                    ] : [
                        r.left - e.plotLeft + S + T / 2,
                        f(b + a.pos - e.plotTop, a.pos - e.plotTop, a.len + a.pos - e.plotTop),
                        M
                    ], s.shapeType = t.pointClass.prototype.shapeType || "roundedRect", s.shapeArgs = t.crispCol(S, w, T, s.isNull ? 0 : M);
                }), P(this, "afterColumnTranslate");
            }
            drawGraph() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            }
            pointAttribs(t, e) {
                let i = this.options, s = this.pointAttrToOptions || {}, o = s.stroke || "borderColor", r = s["stroke-width"] || "borderWidth", a, n, h, l = t?.color || this.color, d = t?.[o] || i[o] || l, c = t?.options.dashStyle || i.dashStyle, p = t?.[r] ?? i[r] ?? this[r] ?? 1, g = t?.isNull && i.nullInteraction ? 0 : t?.opacity ?? i.opacity ?? 1;
                t && this.zones.length && (n = t.getZone(), l = t.options.color || n && (n.color || t.nonZonedColor) || this.color, n && (d = n.borderColor || d, c = n.dashStyle || c, p = n.borderWidth || p)), e && t && (h = (a = F(i.states?.[e], t.options.states?.[e] || {})).brightness, l = a.color || void 0 !== h && su(l).brighten(a.brightness).get() || l, d = a[o] || d, p = a[r] || p, c = a.dashStyle || c, g = a.opacity ?? g);
                let u = {
                    fill: l,
                    stroke: d,
                    "stroke-width": p,
                    opacity: t?.condemned ? 0 : g
                };
                return c && (u.dashstyle = c), u;
            }
            drawPoints(t) {
                let e;
                t || (t = this.points.concat(this.condemnedPoints));
                let i = this, s = this.chart, o = i.options, r = o.nullInteraction, { styledMode: a, renderer: n } = s, h = o.animationLimit || 250;
                t.forEach(function(t) {
                    let l = t.plotY, d = t.graphic, c = !!d, p = d && s.pointCount < h ? "animate" : "attr";
                    if (N(l) && (null !== t.y || r)) {
                        if (e = t.shapeArgs, d && t.hasNewShapeType() && (d = d.destroy()), !d) {
                            let o = e;
                            t.origin && s.pointCount < h && (o = F(e, t.getOrigin(t.origin, e)), a || (o.opacity = 0, o["stroke-width"] = 0), c = !0, p = "animate"), t.graphic = d = n[t.shapeType](o).add(t.group || i.group);
                        }
                        c && d[p](F(e)), a || d[p](i.pointAttribs(t, t.selected ? "select" : "")).shadow(!1 !== t.allowShadow && o.shadow), d.addClass(t.getClassName(), !0).attr({
                            visibility: t.visible ? "inherit" : "hidden"
                        });
                    } else d && (t.graphic = d.destroy());
                });
            }
            drawTracker(t = this.points) {
                let e, i = this, s = i.chart, o = s.pointer, r = function(t) {
                    o?.normalize(t);
                    let e = o?.getPointFromEvent(t);
                    o && e && i.options.enableMouseTracking && (s.isInsidePlot(t.chartX - s.plotLeft, t.chartY - s.plotTop, {
                        visiblePlotOnly: !0
                    }) || i.allowOutsidePlotInteraction && o?.inClass(t.target, "highcharts-point") || o?.inClass(t.target, "highcharts-data-label")) && (o.isDirectTouch = !0, e.onMouseOver(t));
                };
                t.forEach(function(t) {
                    e = H(t.dataLabels) ? t.dataLabels : t.dataLabel ? [
                        t.dataLabel
                    ] : [], t.graphic && (t.graphic.element.point = t), e.forEach(function(e) {
                        (e.div || e.element).point = t;
                    });
                }), i._hasTracking || (i.trackerGroups?.reduce((t, e)=>("dataLabelsGroup" === e ? t.push(...i.dataLabelsGroups || []) : t.push(i[e]), t), []).forEach((t)=>{
                    t && (t.addClass("highcharts-tracker").on("mouseover", r).on("mouseout", function(t) {
                        o?.onTrackerMouseOut(t);
                    }).on("touchstart", r), !s.styledMode && i.options.cursor && t.css({
                        cursor: i.options.cursor
                    }));
                }), i._hasTracking = !0), P(this, "afterDrawTracker");
            }
            remove() {
                let t = this, e = t.chart;
                e.hasRendered && e.series.forEach(function(e) {
                    e.type === t.type && (e.isDirty = !0);
                }), iB.prototype.remove.apply(t, arguments);
            }
        }
        sm.defaultOptions = F(iB.defaultOptions, {
            borderRadius: 3,
            centerInCategory: !1,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .2
                },
                select: {
                    color: "var(--highcharts-neutral-color-20)",
                    borderColor: "var(--highcharts-neutral-color-100)"
                }
            },
            dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
            },
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "var(--highcharts-background-color)"
        }), S(sm.prototype, {
            directTouch: !0,
            getSymbol: sf,
            negStacks: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), iT.registerSeriesType("column", sm);
        let sx = sm, { format: sy } = tF;
        !function(t) {
            function e() {
                return h(this).some((t)=>t?.enabled);
            }
            function i(t, e, i, s, o) {
                let { chart: r } = this, a = this.isCartesian && r.inverted, { condemned: n, origin: h, plotX: l, plotY: d } = t, { crop: c = !0, distance: p, overflow: g = "justify", rotation: u = 0 } = i, f = A(i.align), m = A(i.verticalAlign), x = t.pos(), y = v(l) && v(d) && r.isInsidePlot(l, Math.round(d), {
                    inverted: a,
                    paneCoordinates: !0,
                    series: this
                }), b = this.visible && t.visible && v(l) && (this.forceDL || n || y || (i.inside ?? !!this.options.stacking) && s && r.isInsidePlot(l, a ? s.x + 1 : s.y + s.height - 1, {
                    inverted: a,
                    paneCoordinates: !0,
                    series: this
                }));
                if (x) {
                    let l = e.getBBox(), d = e.getBBox(void 0, 0);
                    s = S({
                        x: x[0],
                        y: Math.round(x[1]),
                        width: 0,
                        height: 0
                    }, s || {}), "plotEdges" === i.alignTo && this.isCartesian && (s[a ? "x" : "y"] = 0, s[a ? "width" : "height"] = this.yAxis?.len || 0), S(i, {
                        width: l.width,
                        height: l.height
                    });
                    let y = 0, v = 0;
                    N(p) && !i.inside && (y = p * (1 - 2 * f), v = p * (1 - 2 * m)), e.align(F(i, {
                        x: (i.x || 0) + y,
                        y: (i.y || 0) + v,
                        width: d.width,
                        height: d.height
                    }), !1, s, !1), e.distX = y, e.distY = v, e.alignAttr.x += f * (d.width - l.width), e.alignAttr.y += m * (d.height - l.height);
                    let k = e.alignAttr.x + (l.width - d.width) / 2, w = e.alignAttr.y + (l.height - d.height) / 2;
                    if (h) {
                        let i = t.pos(!1, h.x, h.y);
                        if (i) {
                            let s = [
                                i[0] - x[0],
                                i[1] - x[1]
                            ];
                            (this.is("column") || t.plotHigh) && (s[+!a] = 0), e.attr({
                                x: k + s[0],
                                y: w + s[1],
                                opacity: .01
                            }), e.placed = !0, o = !1;
                        }
                    }
                    let M = {
                        "text-align": e.alignAttr["text-align"] || "center",
                        x: k,
                        y: w,
                        rotationOriginX: (e.width || 0) / 2,
                        rotationOriginY: (e.height || 0) / 2
                    };
                    if ((n || !b) && (M.opacity = 0), e[e.placed ? "animate" : "attr"](M), 0 === u && !n && "justify" === g && b && s.height >= 0) this.justifyDataLabel(e, i, e.alignAttr, l, s, o);
                    else if (c && !n) {
                        let { x: t, y: i } = e.alignAttr;
                        b = r.isInsidePlot(t, i, {
                            paneCoordinates: !0,
                            series: this
                        }) && r.isInsidePlot(t + l.width - 1, i + l.height - 1, {
                            paneCoordinates: !0,
                            series: this
                        });
                    }
                    i.shape && !u && e[o ? "attr" : "animate"]({
                        anchorX: x[0],
                        anchorY: x[1]
                    });
                }
                e[o ? "attr" : "animate"]({
                    visibility: b ? "inherit" : "hidden"
                }), e.placed = b;
            }
            function s(t, e) {
                P(this, "initDataLabelsGroup", {
                    index: t,
                    zIndex: e?.zIndex
                }), this.dataLabelsGroup = this.dataLabelsGroups?.[t];
                let i = this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", e?.zIndex ?? 6, this.dataLabelsParentGroups?.[t]);
                return this.dataLabelsGroups || (this.dataLabelsGroups = []), this.dataLabelsGroups[t] = i, this.dataLabelsGroup = this.dataLabelsGroups[0], i;
            }
            function o(t, e, i) {
                let s = !!this.hasRendered, o = this.initDataLabelsGroup(t, i).attr({
                    opacity: +s
                });
                return !s && o && (this.visible && o.show(), this.options.animation ? o.animate({
                    opacity: 1
                }, e) : o.attr({
                    opacity: 1
                })), o;
            }
            function r(t) {
                t = t || this.points;
                let e = this, i = e.chart, s = e.options, o = i.renderer, { backgroundColor: r, plotBackgroundColor: a } = i.options.chart, l = o.getContrast(W(a) && a || W(r) && r || "var(--highcharts-background-color)"), d = [], c = h(e), { animation: p, defer: g } = c[0], u = g ? tT(i, p, e) : {
                    defer: 0,
                    duration: 0
                };
                P(this, "drawDataLabels"), e.hasDataLabels?.() && t.concat(e.condemnedPoints).forEach((t)=>{
                    let r = t.dataLabels || [], a = t.color || e.color;
                    J(n(c, t.dlOptions || t.options?.dataLabels)).forEach((n, h)=>{
                        let c = n.enabled && (t.visible || t.dataLabelOnHidden) && (!t.isNull || t.dataLabelOnNull) && function(t, e) {
                            let i = e.filter;
                            if (i) {
                                let e = i.operator, s = t[i.property], o = i.value;
                                return ">" === e && s > o || "<" === e && s < o || ">=" === e && s >= o || "<=" === e && s <= o || "==" === e && s == o || "===" === e && s === o || "!=" === e && s != o || "!==" === e && s !== o || !1;
                            }
                            return !0;
                        }(t, n), { backgroundColor: p, borderColor: g, distance: f, style: m = {} } = n, x = J(n.padding || 0), y, b, k, w = {}, M = r[h], C = !M, S;
                        if (c && (b = v(y = n[t.formatPrefix + "Format"] ?? n.format) ? sy(y, t, i) : (n[t.formatPrefix + "Formatter"] || n.formatter).call(t, n, t), k = n.rotation, !i.styledMode && (m.color = (W(n.color) ? n.color : void 0) ?? m.color ?? (W(e.color) ? e.color : void 0) ?? "var(--highcharts-neutral-color-100)", "contrast" === m.color ? ("none" !== p && (S = p), t.contrastColor = o.getContrast("auto" !== S && "contrast" !== S && W(S) && S || (W(a) ? a : "")), m.color = S && "contrast" !== S || n.inside || 0 > U(f || 0) || s.stacking ? t.contrastColor : l) : delete t.contrastColor, s.cursor && (m.cursor = s.cursor)), w = {
                            r: n.borderRadius ?? 3,
                            rotation: k,
                            padding: x[0],
                            paddingLeft: x[3 % x.length],
                            paddingRight: x[1 % x.length],
                            zIndex: 1
                        }, i.styledMode || (w.fill = "auto" === p ? t.color : p, w.stroke = "auto" === g ? t.color : g, w["stroke-width"] = n.borderWidth), j(w, (t, e)=>{
                            void 0 === t && delete w[e];
                        })), !M || c && v(b) && !!(M.div || M.text?.foreignObject) == !!n.useHTML && (M.rotation && n.rotation || M.rotation === n.rotation) || (M = void 0, C = !0), c && v(b) && "" !== b && (M ? w.text = b : (M = o.label(b, 0, 0, n.shape, void 0, void 0, n.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + t.colorIndex + " " + (n.className || "") + (n.useHTML ? " highcharts-tracker" : "")), M)) {
                            M.options = n, M.attr(w), i.styledMode ? m.width && M.css({
                                width: m.width,
                                textOverflow: m.textOverflow,
                                whiteSpace: m.whiteSpace
                            }) : M.css(m).shadow(n.shadow), P(M, "beforeAddingDataLabel", {
                                labelOptions: n,
                                point: t
                            });
                            let s = d[h] = d[h] || this.initDataLabels(h, u, n);
                            M.added || M.add(s), e.alignDataLabel(t, M, n, void 0, C), M.isActive = !0, r[h] && r[h] !== M && r[h].destroy(), r[h] = M;
                        }
                    });
                    let h = r.length;
                    for(; h--;)r[h]?.isActive ? r[h].isActive = !1 : (r[h]?.destroy(), r.splice(h, 1));
                    t.dataLabel = r[0], t.dataLabels = r;
                }), P(this, "afterDrawDataLabels");
            }
            function a(t, e, i, s, o, r) {
                let a = this.chart, { align: n, verticalAlign: h } = e, { distX: l = 0, distY: d = 0 } = t, c = t.box ? 0 : t.padding || 0, p = a.inverted ? this.yAxis : this.xAxis, g = p ? p.left - a.plotLeft : 0, u = a.inverted ? this.xAxis : this.yAxis, f = u ? u.top - a.plotTop : 0, { x: m = 0, y: x = 0 } = e, y, b, v;
                return (y = (i.x || 0) - l + c + g) < 0 && ("right" === n && m >= 0 ? (e.align = "left", e.inside = !0, m -= l) : m -= y, b = !0), (y = (i.x || 0) + s.width - l - c + g) > a.plotWidth && ("left" === n && m <= 0 ? (e.align = "right", e.inside = !0, m -= l) : m += a.plotWidth - y, b = !0), (y = (i.y || 0) - d + c + f) < 0 && ("bottom" === h && x >= 0 ? (e.verticalAlign = "top", e.inside = !0, x -= d) : x -= y, v = !0), (y = (i.y || 0) + s.height - d - c + f) > a.plotHeight && ("top" === h && x <= 0 ? (e.verticalAlign = "bottom", e.inside = !0, x -= d) : x += a.plotHeight - y, v = !0), (b || v) && (e.x = b ? m : m + l, e.y = v ? x : x + d, t.placed = !r, t.align(e, void 0, o)), b || v;
            }
            function n(t, e) {
                let i = [], s;
                if (H(t) && !H(e)) i = t.map(function(t) {
                    return F(t, e);
                });
                else if (H(e) && !H(t)) i = e.map(function(e) {
                    return F(t, e);
                });
                else if (H(t) || H(e)) {
                    if (H(t) && H(e)) for(s = Math.max(t.length, e.length); s--;)i[s] = F(t[s], e[s]);
                } else i = F(t, e);
                return i;
            }
            function h(t) {
                let e = t.chart.options.plotOptions;
                return J(n(n(e?.series?.dataLabels, e?.[t.type]?.dataLabels), t.options.dataLabels));
            }
            t.compose = function(t) {
                let h = t.prototype;
                h.initDataLabels || (h.initDataLabels = o, h.initDataLabelsGroup = s, h.alignDataLabel = i, h.drawDataLabels = r, h.justifyDataLabel = a, h.mergeArrays = n, h.hasDataLabels = e);
            };
        }(io || (io = {}));
        let sb = io, { composed: sv } = n, { series: sk } = iT;
        function sw(t, e, i, s, o) {
            let { chart: r, options: a } = this, n = r.inverted, h = this.xAxis?.len || r.plotSizeX || 0, l = this.yAxis?.len || r.plotSizeY || 0, d = t.dlBox || t.shapeArgs, c = t.below ?? (t.plotY || 0) > (this.translatedThreshold ?? l), p = i.inside ?? !!a.stacking;
            if (d) {
                if (s = F(d), "allow" !== i.overflow || !1 !== i.crop || !1 !== a.clip) {
                    s.y < 0 && (s.height += s.y, s.y = 0);
                    let t = s.y + s.height - l;
                    t > 0 && t < s.height - 1 && (s.height -= t);
                }
                n && (s = {
                    x: l - s.y - s.height,
                    y: h - s.x - s.width,
                    width: s.height,
                    height: s.width
                }), p || (n ? (s.x += c ? 0 : s.width, s.width = 0) : (s.y += c ? s.height : 0, s.height = 0));
            }
            i.align ?? (i.align = !n || p ? "center" : c ? "right" : "left"), i.verticalAlign ?? (i.verticalAlign = n || p ? "middle" : c ? "top" : "bottom"), sk.prototype.alignDataLabel.call(this, t, e, i, s, o), i.inside && t.contrastColor && e.css({
                color: t.contrastColor
            });
        }
        (ir || (ir = {})).compose = function(t) {
            sb.compose(sk), _(sv, "ColumnDataLabel") && (t.prototype.alignDataLabel = sw);
        };
        let sM = ir;
        class sC extends sx {
        }
        sC.defaultOptions = F(sx.defaultOptions, {}), S(sC.prototype, {
            inverted: !0
        }), iT.registerSeriesType("bar", sC);
        let { column: sS, line: sT } = iT.seriesTypes;
        class sP extends sT {
            applyJitter() {
                let t = this, e = this.options.jitter, i = this.points.length;
                e && this.points.forEach((s, o)=>{
                    [
                        "x",
                        "y"
                    ].forEach((r, a)=>{
                        if (e[r] && !s.isNull) {
                            let n = `plot${r.toUpperCase()}`, h = t[`${r}Axis`];
                            if (h && !h.logarithmic) {
                                let t, l = e[r] * h.transA * (h.reversed ? -1 : 1), d = (s[n] || 0) - l, c = (s[n] || 0) + l;
                                s[n] = d + (c - d) * ((t = 1e4 * Math.sin(o + a * i)) - Math.floor(t)), "x" === r && (s.clientX = s.plotX);
                            }
                        }
                    });
                });
            }
            drawGraph() {
                this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
            }
        }
        sP.defaultOptions = F(sT.defaultOptions, {
            lineWidth: 0,
            findNearestPointBy: "xy",
            jitter: {
                x: 0,
                y: 0
            },
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
            }
        }), S(sP.prototype, {
            allowOutsidePlotInteraction: !0,
            drawTracker: sS.prototype.drawTracker,
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ]
        }), c(sP, "afterTranslate", function() {
            this.applyJitter();
        }), iT.registerSeriesType("scatter", sP);
        let { deg2rad: sA } = n;
        (ix = ia || (ia = {})).getCenter = function() {
            let t = this.options, e = this.chart, i = 2 * (t.slicedOffset || 0), s = e.plotWidth - 2 * i, o = e.plotHeight - 2 * i, r = t.center, a = Math.min(s, o), n = t.thickness, h, l = t.size, d = t.innerSize || 0, c, p;
            "string" == typeof l && (l = parseFloat(l)), "string" == typeof d && (d = parseFloat(d));
            let g = [
                r?.[0] ?? "50%",
                r?.[1] ?? "50%",
                (l && l < 0 ? void 0 : t.size) ?? "100%",
                (d && d < 0 ? void 0 : t.innerSize || 0) ?? "0%"
            ];
            for(c = 0; c < 4; ++c)p = g[c], h = c < 2 || 2 === c && /%$/.test(p), g[c] = Z(p, [
                s,
                o,
                a,
                g[2]
            ][c]) + (h ? i : 0);
            return g[3] > g[2] && (g[3] = g[2]), N(n) && 2 * n < g[2] && n > 0 && (g[3] = g[2] - 2 * n), P(this, "afterGetCenter", {
                positions: g
            }), g;
        }, ix.getStartAndEndRadians = function(t, e) {
            let i = N(t) ? t : 0, s = N(e) && e > i && e - i < 360 ? e : i + 360;
            return {
                start: sA * (i + -90),
                end: sA * (s + -90)
            };
        };
        let sL = ia;
        class sO extends e_ {
            getConnectorPath(t) {
                let e = t.dataLabelPosition, i = t.options || {}, s = i.connectorShape, o = this.connectorShapes[s] || s;
                return e && o.call(this, {
                    ...e.computed,
                    alignment: e.alignment
                }, e.connectorPosition, i) || [];
            }
            getTranslate() {
                return this.sliced && this.slicedTranslation || {
                    translateX: 0,
                    translateY: 0
                };
            }
            haloPath(t) {
                let e = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + t, e.r + t, {
                    innerR: e.r - 1,
                    start: e.start,
                    end: e.end,
                    borderRadius: e.borderRadius
                });
            }
            constructor(t, e, i){
                super(t, e, i), this.half = 0, this.name ?? (this.name = t.chart.options.lang.pieSliceName);
                let s = (t)=>{
                    this.slice("select" === t.type);
                };
                c(this, "select", s), c(this, "unselect", s);
            }
            isValid() {
                return N(this.y) && this.y >= 0;
            }
            setVisible(t, e = !0) {
                t !== this.visible && this.update({
                    visible: t ?? !this.visible
                }, e, void 0, !1);
            }
            slice(t, e, i) {
                let s = this.series;
                tC(i, s.chart), e = e ?? !0, this.sliced = this.options.sliced = t ?? !this.sliced, s.options.data && (s.options.data[s.data.indexOf(this)] = this.options), this.graphic?.animate(this.getTranslate());
            }
        }
        S(sO.prototype, {
            connectorShapes: {
                fixedOffset: function(t, e, i) {
                    let s = e.breakAt, o = e.touchingSliceAt, r = i.softConnector ? [
                        "C",
                        t.x + ("left" === t.alignment ? -5 : 5),
                        t.y,
                        2 * s.x - o.x,
                        2 * s.y - o.y,
                        s.x,
                        s.y
                    ] : [
                        "L",
                        s.x,
                        s.y
                    ];
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        r,
                        [
                            "L",
                            o.x,
                            o.y
                        ]
                    ];
                },
                straight: function(t, e) {
                    let i = e.touchingSliceAt;
                    return [
                        [
                            "M",
                            t.x,
                            t.y
                        ],
                        [
                            "L",
                            i.x,
                            i.y
                        ]
                    ];
                },
                crookedLine: function(t, e, i) {
                    let { angle: s = this.angle || 0, breakAt: o, touchingSliceAt: r } = e, { series: a } = this, [n, h, l] = a.center, d = l / 2, { plotLeft: c, plotWidth: p } = a.chart, g = "left" === t.alignment, { x: u, y: f } = t, m = o.x;
                    if (i.crookDistance) {
                        let t = Z(i.crookDistance, 1);
                        m = g ? n + d + (p + c - n - d) * (1 - t) : c + (n - d) * t;
                    } else m = n + (h - f) * Math.tan(s - Math.PI / 2);
                    let x = [
                        [
                            "M",
                            u,
                            f
                        ]
                    ];
                    return (g ? m <= u && m >= o.x : m >= u && m <= o.x) && x.push([
                        "L",
                        m,
                        f
                    ]), x.push([
                        "L",
                        o.x,
                        o.y
                    ], [
                        "L",
                        r.x,
                        r.y
                    ]), x;
                }
            }
        });
        let { getStartAndEndRadians: sE } = sL, { noop: sI } = n;
        class sD extends iB {
            animate(t) {
                let e = this, i = e.points, s = e.startAngleRad;
                t || i.forEach(function(t) {
                    let i = t.graphic, o = t.shapeArgs;
                    i && o && (i.attr({
                        r: t.startR ?? (e.center && e.center[3] / 2),
                        start: s,
                        end: s
                    }), i.animate({
                        r: o.r,
                        start: o.start,
                        end: o.end
                    }, e.options.animation));
                });
            }
            drawEmpty() {
                let t, e, i = this.startAngleRad, s = this.endAngleRad, o = this.options;
                0 === this.total && this.center ? (t = this.center[0], e = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(t, e, this.center[1] / 2, 0, i, s).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: t6.arc(t, e, this.center[2] / 2, 0, {
                        start: i,
                        end: s,
                        innerR: this.center[3] / 2
                    })
                }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": o.borderWidth,
                    fill: o.fillColor || "none",
                    stroke: o.color || "var(--highcharts-neutral-color-20)"
                })) : this.graph && (this.graph = this.graph.destroy());
            }
            drawPoints() {
                let t = this.chart.renderer;
                this.points.forEach(function(e) {
                    e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy()), e.graphic || (e.graphic = t[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
            }
            generatePoints() {
                super.generatePoints(), this.updateTotals();
            }
            getXPos(t, e, i, s) {
                let o = this.center, r = this.radii ? this.radii[i.index] || 0 : o[2] / 2, a = s.dataLabelPosition, n = a?.distance || 0, h = Math.asin(f((t - o[1]) / (r + n), -1, 1));
                return o[0] + Math.cos(h) * (r + n) * (e ? -1 : 1) + (n > 0 ? e ? -5 : 5 : 0);
            }
            hasData() {
                return this.points.some((t)=>t.visible);
            }
            redrawPoints() {
                let t, e, i, s, o = this, r = o.chart;
                this.drawEmpty(), o.group && !r.styledMode && o.group.shadow(o.options.shadow), o.points.forEach(function(a) {
                    let n = {};
                    e = a.graphic, !a.isNull && e ? (s = a.shapeArgs, t = a.getTranslate(), r.styledMode || (i = o.pointAttribs(a, a.selected && "select")), a.delayedRendering ? (e.setRadialReference(o.center).attr(s).attr(t), r.styledMode || e.attr(i).attr({
                        "stroke-linejoin": "round"
                    }), a.delayedRendering = !1) : (e.setRadialReference(o.center), r.styledMode || F(!0, n, i), F(!0, n, s, t), e.animate(n)), e.attr({
                        visibility: a.visible ? "inherit" : "hidden"
                    }), e.addClass(a.getClassName(), !0)) : e && (a.graphic = e.destroy());
                });
            }
            sortByAngle(t, e) {
                t.sort(function(t, i) {
                    return void 0 !== t.angle && (i.angle - t.angle) * e;
                });
            }
            translate(t) {
                P(this, "translate"), this.generatePoints();
                let e = this.options, i = e.slicedOffset, s = sE(e.startAngle, e.endAngle), o = this.startAngleRad = s.start, r = (this.endAngleRad = s.end) - o, a = this.points, n = e.ignoreHiddenPoint, h = a.length, l, d, c, p, g, u, f, m = 0;
                for(t || (this.center = t = this.getCenter()), u = 0; u < h; u++){
                    f = a[u], l = o + m * r, f.isValid() && (!n || f.visible) && (m += f.percentage / 100), d = o + m * r;
                    let e = {
                        x: t[0],
                        y: t[1],
                        r: t[2] / 2,
                        innerR: t[3] / 2,
                        start: l,
                        end: d
                    };
                    f.shapeType = "arc", f.shapeArgs = e, (c = (d + l) / 2) > 1.5 * Math.PI ? c -= 2 * Math.PI : c < -Math.PI / 2 && (c += 2 * Math.PI), f.slicedTranslation = {
                        translateX: Math.round(Math.cos(c) * i),
                        translateY: Math.round(Math.sin(c) * i)
                    }, p = Math.cos(c) * t[2] / 2, g = Math.sin(c) * t[2] / 2, f.tooltipPos = [
                        t[0] + .7 * p,
                        t[1] + .7 * g
                    ], f.half = +(c < -Math.PI / 2 || c > Math.PI / 2), f.angle = c;
                }
                P(this, "afterTranslate");
            }
            updateTotals() {
                let t = this.points, e = t.length, i = this.options.ignoreHiddenPoint, s, o, r = 0;
                for(s = 0; s < e; s++)(o = t[s]).isValid() && (!i || o.visible) && (r += o.y);
                for(this.total = r, s = 0; s < e; s++)(o = t[s]).percentage = r > 0 && (o.visible || !i) ? o.y / r * 100 : 0, o.total = r;
            }
        }
        sD.defaultOptions = F(iB.defaultOptions, {
            borderRadius: 3,
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                connectorPadding: 5,
                connectorShape: "crookedLine",
                crookDistance: void 0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.isNull ? void 0 : this.name;
                },
                softConnector: !0,
                x: 0
            },
            fillColor: void 0,
            ignoreHiddenPoint: !0,
            inactiveOtherPoints: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "var(--highcharts-background-color)",
            borderWidth: 1,
            lineWidth: void 0,
            states: {
                hover: {
                    brightness: .1
                }
            }
        }), S(sD.prototype, {
            axisTypes: [],
            directTouch: !0,
            drawGraph: void 0,
            drawTracker: sx.prototype.drawTracker,
            getCenter: sL.getCenter,
            getSymbol: sI,
            invertible: !1,
            isCartesian: !1,
            noSharedTooltip: !0,
            pointAttribs: sx.prototype.pointAttribs,
            pointClass: sO,
            requireSorting: !1,
            searchPoint: sI,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ]
        }), iT.registerSeriesType("pie", sD);
        let { composed: sB, noop: sz } = n, { distribute: sR } = tY, { series: sN } = iT;
        !function(t) {
            let e = {
                radialDistributionY: function(t, e) {
                    return (e.dataLabelPosition?.top || 0) + t.distributeBox.pos;
                },
                radialDistributionX: function(t, e, i, s, o) {
                    let r = o.dataLabelPosition;
                    return t.getXPos(i < (r?.top || 0) + 2 || i > (r?.bottom || 0) - 2 ? s : i, e.half, e, o);
                },
                justify: function(t, e, i, s) {
                    return s[0] + (t.half ? -1 : 1) * (i + (e.dataLabelPosition?.distance || 0));
                },
                alignToPlotEdges: function(t, e, i, s) {
                    let o = t.getBBox().width;
                    return e ? o + s : i - o - s;
                },
                alignToConnectors: function(t, e, i, s) {
                    let o = 0, r;
                    return t.forEach(function(t) {
                        (r = t.dataLabel.getBBox().width) > o && (o = r);
                    }), e ? o + s : i - o - s;
                }
            };
            function i(t, e) {
                let i = Math.PI / 2, { start: s = 0, end: o = 0 } = t.shapeArgs || {}, r = t.angle || 0;
                e > 0 && s < i && o > i && r > i / 2 && r < 1.5 * i && (r = r <= i ? Math.max(i / 2, (s + i) / 2) : Math.min(1.5 * i, (i + o) / 2));
                let { center: a, options: n } = this, h = a[2] / 2, l = Math.cos(r), d = Math.sin(r), c = a[0] + l * h, p = a[1] + d * h, g = Math.min((n.slicedOffset || 0) + (n.borderWidth || 0), e / 5);
                return {
                    natural: {
                        x: c + l * e,
                        y: p + d * e
                    },
                    computed: {},
                    alignment: e < 0 ? "center" : t.half ? "right" : "left",
                    connectorPosition: {
                        angle: r,
                        breakAt: {
                            x: c + l * g,
                            y: p + d * g
                        },
                        touchingSliceAt: {
                            x: c,
                            y: p
                        }
                    },
                    distance: e
                };
            }
            function s() {
                let t = this, e = t.points, i = t.chart, s = i.plotWidth, o = i.plotHeight, r = i.plotLeft, a = Math.round(i.chartWidth / 3), n = t.center, h = n[2] / 2, l = n[1], d = [
                    [],
                    []
                ], c = [
                    0,
                    0,
                    0,
                    0
                ], p = t.dataLabelPositioners, u, f, m, x = 0;
                t.visible && t.hasDataLabels?.() && (e.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        t.shortened && (t.attr({
                            width: "auto"
                        }).css({
                            width: "auto",
                            textOverflow: "clip"
                        }), t.shortened = !1);
                    });
                }), sN.prototype.drawDataLabels.apply(t), e.forEach((t)=>{
                    (t.dataLabels || []).forEach((e, i)=>{
                        let s = n[2] / 2, o = e.options, r = Z(o?.distance || 0, s);
                        0 === i && d[t.half].push(t), !v(o?.style?.width) && e.getBBox().width > a && (e.css({
                            width: Math.round(.7 * a) + "px"
                        }), e.shortened = !0), e.dataLabelPosition = this.getDataLabelPosition(t, r), x = Math.max(x, r);
                    });
                }), d.forEach((e, a)=>{
                    let d = e.length, g = [], u, y, b = 0, k;
                    d && (t.sortByAngle(e, a - .5), x > 0 && (u = Math.max(0, l - h - x), y = Math.min(l + h + x, i.plotHeight), e.forEach((t)=>{
                        (t.dataLabels || []).forEach((e)=>{
                            let s = e.dataLabelPosition;
                            s && s.distance > 0 && (s.top = Math.max(0, l - h - s.distance), s.bottom = Math.min(l + h + s.distance, i.plotHeight), b = e.getBBox().height || 21, e.lineHeight = i.renderer.fontMetrics(e.text || e).h + 2 * e.padding, t.distributeBox = {
                                target: (e.dataLabelPosition?.natural.y || 0) - s.top + e.lineHeight / 2,
                                size: b,
                                rank: t.y
                            }, g.push(t.distributeBox));
                        });
                    }), sR(g, k = y + b - u, k / 5)), e.forEach((i)=>{
                        (i.dataLabels || []).forEach((l)=>{
                            let d = l.options || {}, u = i.distributeBox, x = l.dataLabelPosition, y = x?.natural.y || 0, b = d.connectorPadding || 0, k = l.lineHeight || 21, w = (k - l.getBBox().height) / 2, M = 0, C = y, S = "inherit";
                            if (x) {
                                if (g && v(u) && x.distance > 0 && (void 0 === u.pos ? S = "hidden" : (m = u.size, C = p.radialDistributionY(i, l))), d.justify) M = p.justify(i, l, h, n);
                                else switch(d.alignTo){
                                    case "connectors":
                                        M = p.alignToConnectors(e, a, s, r);
                                        break;
                                    case "plotEdges":
                                        M = p.alignToPlotEdges(l, a, s, r);
                                        break;
                                    default:
                                        M = p.radialDistributionX(t, i, C - w, y, l);
                                }
                                if (x.attribs = {
                                    visibility: S,
                                    align: x.alignment
                                }, x.posAttribs = {
                                    x: M + (d.x || 0) + (({
                                        left: b,
                                        right: -b
                                    })[x.alignment] || 0),
                                    y: C + (d.y || 0) - k / 2
                                }, x.computed.x = M, x.computed.y = C - w, d.crop ?? !0) {
                                    let t;
                                    M - (f = l.getBBox().width) < b && 1 === a ? (t = Math.round(f - M + b), c[3] = Math.max(t, c[3])) : M + f > s - b && 0 === a && (t = Math.round(M + f - s + b), c[1] = Math.max(t, c[1])), C - m / 2 < 0 ? c[0] = Math.max(Math.round(-C + m / 2), c[0]) : C + m / 2 > o && (c[2] = Math.max(Math.round(C + m / 2 - o), c[2])), x.sideOverflow = t;
                                }
                            }
                        });
                    }));
                }), (0 === g(c) || this.verifyDataLabelOverflow(c)) && (this.placeDataLabels(), this.points.forEach((e)=>{
                    e.dataLabels?.forEach((s, o)=>{
                        let { connectorColor: r, connectorWidth: a = 1 } = s.options || {}, n = s.dataLabelPosition;
                        if (N(a)) {
                            let h;
                            u = s.connector, n && n.distance > 0 ? (h = !u, u || (s.connector = u = i.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + e.colorIndex + (e.className ? " " + e.className : "")).add(t.dataLabelsGroups?.[o])), i.styledMode || u.attr({
                                "stroke-width": a,
                                stroke: r || e.color || "var(--highcharts-neutral-color-60)"
                            }), u[h ? "attr" : "animate"]({
                                d: e.getConnectorPath(s)
                            }), u.attr({
                                visibility: n.attribs?.visibility
                            })) : u && (s.connector = u.destroy());
                        }
                    });
                })));
            }
            function o() {
                this.points.forEach((t)=>{
                    (t.dataLabels || []).forEach((t)=>{
                        let e = t.dataLabelPosition;
                        e ? (e.sideOverflow && (t.css({
                            width: Math.max(t.getBBox().width - e.sideOverflow, 0) + "px",
                            textOverflow: t.options?.style?.textOverflow || "ellipsis"
                        }), t.shortened = !0), t.attr(e.attribs), t[t.moved ? "animate" : "attr"](e.posAttribs), t.moved = !0) : t && t.attr({
                            y: -9999
                        });
                    }), delete t.distributeBox;
                }, this);
            }
            function r(t) {
                let e = this.center, i = this.options, s = i.center, o = i.minSize || 80, r = o, a = null !== i.size;
                return !a && (null !== s[0] ? r = Math.max(e[2] - Math.max(t[1], t[3]), o) : (r = Math.max(e[2] - t[1] - t[3], o), e[0] += (t[3] - t[1]) / 2), null !== s[1] ? r = f(r, o, e[2] - Math.max(t[0], t[2])) : (r = f(r, o, e[2] - t[0] - t[2]), e[1] += (t[0] - t[2]) / 2), r < e[2] ? (e[2] = r, e[3] = Math.min(i.thickness ? Math.max(0, r - 2 * i.thickness) : Math.max(0, Z(i.innerSize || 0, r)), r), this.translate(e), this.drawDataLabels && this.drawDataLabels()) : a = !0), a;
            }
            t.compose = function(t) {
                if (sb.compose(sN), _(sB, "PieDataLabel")) {
                    let a = t.prototype;
                    a.dataLabelPositioners = e, a.alignDataLabel = sz, a.drawDataLabels = s, a.getDataLabelPosition = i, a.placeDataLabels = o, a.verifyDataLabelOverflow = r;
                }
            };
        }(ih || (ih = {}));
        let sW = ih;
        (iy = il || (il = {})).getCenterOfPoints = function(t) {
            let e = t.reduce((t, e)=>(t.x += e.x, t.y += e.y, t), {
                x: 0,
                y: 0
            });
            return {
                x: e.x / t.length,
                y: e.y / t.length
            };
        }, iy.getDistanceBetweenPoints = function(t, e) {
            return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
        }, iy.getAngleBetweenPoints = function(t, e) {
            return Math.atan2(e.x - t.x, e.y - t.y);
        }, iy.pointInPolygon = function({ x: t, y: e }, i) {
            let s = i.length, o, r, a = !1;
            for(o = 0, r = s - 1; o < s; r = o++){
                let [s, n] = i[o], [h, l] = i[r];
                n > e != l > e && t < (h - s) * (e - n) / (l - n) + s && (a = !a);
            }
            return a;
        };
        let { pointInPolygon: sH } = il;
        function sG(t, e) {
            let i = !1;
            if (t) {
                let s = t.newOpacity, o = t.hasClass("highcharts-data-label");
                o || tA(t, "opacity"), t.oldOpacity !== s && (o ? (t[s ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), i = !0, t[t.isOld || t.placed ? "animate" : "attr"]({
                    opacity: s
                }, void 0, ()=>{
                    e.styledMode || t.css({
                        pointerEvents: s ? "auto" : "none"
                    });
                }), P(e, "afterHideOverlappingLabel")) : t[t.placed ? "animate" : "attr"]({
                    opacity: s
                })), t.isOld = !0;
            }
            return i;
        }
        let { defaultOptions: sX } = tm, { noop: sF } = n, sY = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, sj = sF, s$ = sF;
        function sV(t, e, i, s, o = {}) {
            let r = sj(t, e, i, s, o), { brStart: a = !0, brEnd: n = !0, innerR: h = 0, r: l = i, start: d = 0, end: c = 0 } = o;
            if (o.open || !o.borderRadius) return r;
            let p = c - d, g = Math.sin(p / 2), u = Math.max(Math.min(Z(s_(o.borderRadius).radius, l - h), (l - h) / 2, l * g / (1 + g)), 0), f = Math.min(u, p / Math.PI * 2 * h), m = r.length - 1;
            for(; m--;)(a || 0 !== m && 3 !== m) && (n || 1 !== m && 2 !== m) && !function(t, e, i) {
                let s, o, r, a = t[e], n = t[e + 1];
                if ("Z" === n[0] && (n = t[0]), ("M" === a[0] || "L" === a[0]) && "A" === n[0] ? (s = a, o = n, r = !0) : "A" === a[0] && ("M" === n[0] || "L" === n[0]) && (s = n, o = a), s && o && o.params) {
                    let a = o[1], n = o[5], h = o.params, { start: l, end: d, cx: c, cy: p } = h, g = n ? a - i : a + i, u = g ? Math.asin(i / g) : 0, f = n ? u : -u, m = Math.cos(u) * g;
                    r ? (h.start = l + f, s[1] = c + m * Math.cos(l), s[2] = p + m * Math.sin(l), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + a * Math.cos(h.start),
                        p + a * Math.sin(h.start)
                    ])) : (h.end = d - f, o[6] = c + a * Math.cos(h.end), o[7] = p + a * Math.sin(h.end), t.splice(e + 1, 0, [
                        "A",
                        i,
                        i,
                        0,
                        0,
                        1,
                        c + m * Math.cos(d),
                        p + m * Math.sin(d)
                    ])), o[4] = Math.abs(h.end - h.start) < Math.PI ? 0 : 1;
                }
            }(r, m, m > 1 ? f : u);
            return r;
        }
        function sU() {
            if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
                let { options: t, yAxis: e } = this, i = "percent" === t.stacking, s = sX.plotOptions?.[this.type]?.borderRadius, o = s_(t.borderRadius, X(s) ? s : {}), r = e.options.reversed;
                for (let s of this.points){
                    let { shapeArgs: a } = s;
                    if ("roundedRect" === s.shapeType && a) {
                        let { width: n = 0, height: h = 0, y: l = 0 } = a, d = l, c = h;
                        if ("stack" === o.scope && s.stackTotal) {
                            let o = e.translate(i ? 100 : s.stackTotal, !1, !0, !1, !0), r = e.translate(t.threshold || 0, !1, !0, !1, !0), a = this.crispCol(0, Math.min(o, r), 0, Math.abs(o - r));
                            d = a.y, c = a.height;
                        }
                        let p = (s.negative ? -1 : 1) * (r ? -1 : 1) == -1, g = o.where;
                        !g && this.is("waterfall") && Math.abs((s.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (g = "all"), g || (g = "end");
                        let u = Math.min(Z(o.radius, n), n / 2, "all" === g ? c / 2 : 1 / 0) || 0;
                        "end" === g && (p && (d -= u), c += u), S(a, {
                            brBoxHeight: c,
                            brBoxY: d,
                            r: u
                        });
                    }
                }
            }
        }
        function s_(t, e) {
            return X(t) || (t = {
                radius: t || 0
            }), F(sY, e, t);
        }
        function sZ() {
            let t = s_(this.options.borderRadius);
            for (let e of this.points){
                let i = e.shapeArgs;
                i && (i.borderRadius = Z(t.radius, (i.r || 0) - (i.innerR || 0)));
            }
        }
        function sK(t, e, i, s, o = {}) {
            let r = s$(t, e, i, s, o), { r: a = 0, brBoxHeight: n = s, brBoxY: h = e } = o, l = e - h, d = h + n - (e + s), c = l - a > -0.1 ? 0 : a, p = d - a > -0.1 ? 0 : a, g = Math.max(c && l, 0), u = Math.max(p && d, 0), f = [
                t + c,
                e
            ], m = [
                t + i - c,
                e
            ], x = [
                t + i,
                e + c
            ], y = [
                t + i,
                e + s - p
            ], b = [
                t + i - p,
                e + s
            ], v = [
                t + p,
                e + s
            ], k = [
                t,
                e + s - p
            ], w = [
                t,
                e + c
            ], M = (t, e)=>Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
            if (g) {
                let t = M(c, c - g);
                f[0] -= t, m[0] += t, x[1] = w[1] = e + c - g;
            }
            if (s < c - g) {
                let o = M(c, c - g - s);
                x[0] = y[0] = t + i - c + o, b[0] = Math.min(x[0], b[0]), v[0] = Math.max(y[0], v[0]), k[0] = w[0] = t + c - o, x[1] = w[1] = e + s;
            }
            if (u) {
                let t = M(p, p - u);
                b[0] += t, v[0] -= t, y[1] = k[1] = e + s - p + u;
            }
            if (s < p - u) {
                let o = M(p, p - u - s);
                x[0] = y[0] = t + i - p + o, m[0] = Math.min(x[0], m[0]), f[0] = Math.max(y[0], f[0]), k[0] = w[0] = t + p - o, y[1] = k[1] = e;
            }
            return r.length = 0, r.push([
                "M",
                ...f
            ], [
                "L",
                ...m
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...x
            ], [
                "L",
                ...y
            ], [
                "A",
                p,
                p,
                0,
                0,
                1,
                ...b
            ], [
                "L",
                ...v
            ], [
                "A",
                p,
                p,
                0,
                0,
                1,
                ...k
            ], [
                "L",
                ...w
            ], [
                "A",
                c,
                c,
                0,
                0,
                1,
                ...f
            ], [
                "Z"
            ]), r;
        }
        function sq(t, e) {
            let i = t.condition;
            (i.callback || function() {
                return this.chartWidth <= (i.maxWidth ?? Number.MAX_VALUE) && this.chartHeight <= (i.maxHeight ?? Number.MAX_VALUE) && this.chartWidth >= (i.minWidth ?? 0) && this.chartHeight >= (i.minHeight ?? 0);
            }).call(this, this) && e.push(t._id);
        }
        function sJ(t, e) {
            let i = this.options.responsive, s = this.currentResponsive, o = [], r;
            !e && i && i.rules && i.rules.forEach((t)=>{
                void 0 === t._id && (t._id = tn()), this.matchResponsiveRule(t, o);
            }, this);
            let a = F(...o.map((t)=>D(i?.rules || [], (e)=>e._id === t)).map((t)=>t?.chartOptions));
            a.isResponsiveOptions = !0, o = o.toString() || void 0;
            let n = s?.ruleIds;
            o !== n && (s && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(s.undoOptions, t, !0), this.updatingResponsive = !1), o ? ((r = M(a, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = {
                ruleIds: o,
                mergedOptions: a,
                undoOptions: r
            }, this.updatingResponsive || this.update(a, t, !0)) : this.currentResponsive = void 0);
        }
        (id || (id = {})).compose = function(t) {
            let e = t.prototype;
            return e.matchResponsiveRule || S(e, {
                matchResponsiveRule: sq,
                setResponsive: sJ
            }), t;
        };
        let sQ = id;
        n.AST = tB, n.Axis = eL, n.Chart = iK, n.Color = tv, n.DataLabel = sb, n.DataTable = e5, n.DataTableCore = e5, n.Fx = tM, n.HTMLElement = em, n.Legend = iX, n.LegendSymbol = iw, n.PlotLineOrBand = ez, n.Point = e_, n.Pointer = e0, n.Series = iB, n.SeriesRegistry = iT, n.StackItem = i5, n.SVGElement = tq, n.SVGRenderer = eg, n.Templating = tF, n.Tick = ek, n.Time = class extends tp {
            constructor(t, e){
                let i = tm.getOptions();
                super(t ?? i.time, e ?? i.lang);
            }
        }, n.Tooltip = ej, n.addEvent = c, n.animObject = tS, n.animate = tP, n.arrayMax = g, n.arrayMin = p, n.attr = u, n.chart = iK.chart, n.clamp = f, n.color = tv.parse, n.correctFloat = m, n.createElement = x, n.css = b, n.crisp = y, n.dateFormat = tF.dateFormat, n.defaultOptions = tm.defaultOptions, n.defined = v, n.destroyObjectProperties = k, n.diffObjects = M, n.discardElement = w, n.distribute = tY.distribute, n.erase = C, n.error = to, n.extend = S, n.extendClass = T, n.find = D, n.fireEvent = P, n.format = tF.format, n.getAlignFactor = A, n.getClosestDistance = L, n.getDeferredAnimation = tT, n.getMagnitude = O, n.getNestedProperty = E, n.getOptions = tm.getOptions, n.getStyle = I, n.insertItem = tr, n.isArray = H, n.isClass = R, n.isDOMElement = z, n.isFunction = G, n.isNumber = N, n.isObject = X, n.isString = W, n.internalClearTimeout = B, n.merge = F, n.normalizeTickInterval = Y, n.numberFormat = tF.numberFormat, n.objectEach = j, n.offset = $, n.pad = V, n.pick = function(...t) {
            let e = t.length;
            for(let i = 0; i < e; i++){
                let e = t[i];
                if (null != e) return e;
            }
        }, n.pushUnique = _, n.pInt = U, n.relativeLength = Z, n.removeEvent = q, n.replaceNested = K, n.seriesType = iT.seriesType, n.setAnimation = tC, n.setOptions = tm.setOptions, n.splat = J, n.stableSort = Q, n.stop = tA, n.syncTimeout = tt, n.time = tm.defaultTime, n.ucfirst = te, n.timers = tM.timers, n.timeUnits = ta, n.uniqueKey = tn, n.useSerialIds = function(e) {
            return t = e ?? t;
        }, n.wrap = function(t, e, i) {
            let s = t[e];
            t[e] = function() {
                let t = arguments, e = this;
                return i.apply(this, [
                    function() {
                        return s.apply(e, arguments.length ? arguments : t);
                    }
                ].concat([].slice.call(arguments)));
            };
        }, function(t, e, i) {
            let s = t.types.pie;
            if (!e.symbolCustomAttribs.includes("borderRadius")) {
                let o = i.prototype.symbols;
                c(t, "afterColumnTranslate", sU, {
                    order: 9
                }), c(s, "afterTranslate", sZ), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY", "brEnd", "brStart"), sj = o.arc, s$ = o.roundedRect, o.arc = sV, o.roundedRect = sK;
            }
        }(n.Series, n.SVGElement, n.SVGRenderer), sM.compose(n.Series.types.column), sb.compose(n.Series), eE.compose(n.Axis), em.compose(n.SVGRenderer), iX.compose(n.Chart), eD.compose(n.Axis), (o = (ib = n.Chart).prototype).hideOverlappingLabels || (o.hideOverlappingLabels = function(t) {
            let e = t.length, i = (t, e)=>!(e.x >= t.x + t.width || e.x + e.width <= t.x || e.y >= t.y + t.height || e.y + e.height <= t.y), s = (t, e)=>{
                for (let i of t)if (sH({
                    x: i[0],
                    y: i[1]
                }, e)) return !0;
                return !1;
            }, o, r, a, n, h, l = !1;
            for(let i = 0; i < e; i++)(o = t[i]) && (o.oldOpacity = o.opacity, o.newOpacity = 1, o.absoluteBox = function(t) {
                if (t && (!t.alignAttr || t.placed)) {
                    let e = t.box ? 0 : t.padding || 0, i = t.dataLabelPosition?.posAttribs || t.alignAttr || {
                        x: t.attr("x"),
                        y: t.attr("y")
                    }, { height: s, polygon: o, width: r } = t.getBBox(), a = A(t.alignValue) * r;
                    return t.width = r, t.height = s, {
                        x: i.x + (t.parentGroup?.translateX || 0) + e - a,
                        y: i.y + (t.parentGroup?.translateY || 0) + e,
                        width: r - 2 * e,
                        height: s - 2 * e,
                        polygon: o
                    };
                }
            }(o));
            t.sort((t, e)=>(e?.labelrank || 0) - (t?.labelrank || 0));
            for(let o = 0; o < e; ++o){
                n = (r = t[o]) && r.absoluteBox;
                let l = n?.polygon;
                for(let d = o + 1; d < e; ++d){
                    h = (a = t[d]) && a.absoluteBox;
                    let e = !1;
                    if (n && h && r !== a && r?.newOpacity !== 0 && a?.newOpacity !== 0 && r?.visibility !== "hidden" && a?.visibility !== "hidden") {
                        let t = h.polygon;
                        if (l && t && l !== t ? s(l, t) && (e = !0) : i(n, h) && (e = !0), e) {
                            let t = r?.labelrank < a?.labelrank ? r : a, e = t?.text;
                            t && (t.newOpacity = 0), e?.element.querySelector("textPath") && e.hide();
                        }
                    }
                }
            }
            for (let e of t)e && sG(e, this) && (l = !0);
            l && P(this, "afterHideAllOverlappingLabels");
        }, c(ib, "render", function() {
            let t = this, e = (e, s)=>{
                s ? (e.oldOpacity = e.opacity, e.newOpacity = 1, sG(e, t)) : i.push(e);
            }, i = [];
            for (let e of t.labelCollectors || [])i = i.concat(e());
            for (let { options: i, stacking: s } of t.yAxis || [])j(s?.stacks, (t)=>{
                j(t, ({ label: t })=>{
                    t && e(t, i.stackLabels?.allowOverlap);
                });
            });
            for (let i of t.series || [])if (i.visible && i.hasDataLabels?.()) {
                let t = (t)=>{
                    for (let s of t)s.visible && (s.dataLabels || []).forEach((t)=>{
                        let o = t.options || {};
                        t.labelrank = o.labelrank ?? s.labelrank ?? s.shapeArgs?.height, e(t, o.allowOverlap ?? (i.is("pie") && Number(o.distance) > 0));
                    });
                };
                t(i.nodes || []), t(i.points);
            }
            this.hideOverlappingLabels(i);
        })), sW.compose(n.Series.types.pie), ez.compose(n.Chart, n.Axis), e0.compose(n.Chart), sQ.compose(n.Chart), i0.compose(n.Axis, n.Chart, n.Series), so.compose(n.Axis, n.Chart, n.Series), ej.compose(n.Pointer);
        let s0 = n;
        return a.default;
    })());


var $f9b502eb601f738a$exports = {};
!/**
 * Highcharts JS v13.1.1 (2026-09-20)
 * @module highcharts/modules/accessibility
 * @requires highcharts
 *
 * Accessibility module
 *
 * (c) 2010-2026 Highsoft AS
 * Author: Øystein Moseng
 *
 * A commercial license may be required depending on use,
 * see www.highcharts.com/license
 */ function(e, t) {
    $f9b502eb601f738a$exports = t(e._Highcharts.AST, e._Highcharts.Axis, e._Highcharts.Legend, e._Highcharts.Point, e._Highcharts.SVGRenderer, e._Highcharts.Series, e._Highcharts.SeriesRegistry, e._Highcharts.Templating, e._Highcharts);
}("u" < typeof window ? $f9b502eb601f738a$exports : window, (e, t, i, r, s, n, o, a, l)=>(()=>{
        "use strict";
        let h;
        var d, c, u, p, g = {
            660 (t) {
                t.exports = e;
            },
            532 (e) {
                e.exports = t;
            },
            632 (e) {
                e.exports = i;
            },
            260 (e) {
                e.exports = r;
            },
            540 (e) {
                e.exports = s;
            },
            820 (e) {
                e.exports = n;
            },
            512 (e) {
                e.exports = o;
            },
            984 (e) {
                e.exports = a;
            },
            944 (e) {
                e.exports = l;
            }
        };
        let m = {};
        function b(e) {
            let t = m[e];
            if (void 0 !== t) return t.exports;
            let i = m[e] = {
                exports: {}
            };
            return g[e](i, i.exports, b), i.exports;
        }
        b.n = (e)=>{
            let t = e && e.__esModule ? ()=>e.default : ()=>e;
            return b.d(t, {
                a: t
            }), t;
        }, b.d = (e, t)=>{
            for(var i in t)b.o(t, i) && !b.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: t[i]
            });
        }, b.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t);
        let f = {};
        b.d(f, {
            default: ()=>i9
        });
        var x = b(944), y = b.n(x);
        let { doc: v, win: E } = y(), w = E.EventTarget && new E.EventTarget || "none";
        function A(e) {
            if ("function" == typeof E.MouseEvent) return new E.MouseEvent(e.type, e);
            if (v?.createEvent) {
                let t = v.createEvent("MouseEvent");
                if (t.initMouseEvent) return t.initMouseEvent(e.type, e.bubbles, e.cancelable, e.view || E, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget), t;
            }
            return M(e.type);
        }
        function T(e) {
            let t = e?.getRootNode();
            return t?.host ? t : void 0;
        }
        function M(e, t, i) {
            let r = t || {
                x: 0,
                y: 0
            };
            if ("function" == typeof E.MouseEvent) return new E.MouseEvent(e, {
                bubbles: !0,
                cancelable: !0,
                composed: !0,
                button: 0,
                buttons: 1,
                relatedTarget: i || w,
                view: E,
                detail: +("click" === e),
                screenX: r.x,
                screenY: r.y,
                clientX: r.x,
                clientY: r.y
            });
            if (v?.createEvent) {
                let t = v.createEvent("MouseEvent");
                if (t.initMouseEvent) return t.initMouseEvent(e, !0, !0, E, +("click" === e), r.x, r.y, r.x, r.y, !1, !1, !1, !1, 0, null), t;
            }
            return {
                type: e
            };
        }
        let C = {
            addClass: function(e, t) {
                e.classList ? e.classList.add(t) : 0 > e.className.indexOf(t) && (e.className += " " + t);
            },
            cloneMouseEvent: A,
            cloneTouchEvent: function(e) {
                let t = (e)=>{
                    let t = [];
                    for(let i = 0; i < e.length; ++i){
                        let r = e.item(i);
                        r && t.push(r);
                    }
                    return t;
                };
                if ("function" == typeof E.TouchEvent) {
                    let i = new E.TouchEvent(e.type, {
                        touches: t(e.touches),
                        targetTouches: t(e.targetTouches),
                        changedTouches: t(e.changedTouches),
                        ctrlKey: e.ctrlKey,
                        shiftKey: e.shiftKey,
                        altKey: e.altKey,
                        metaKey: e.metaKey,
                        bubbles: e.bubbles,
                        cancelable: e.cancelable,
                        composed: e.composed,
                        detail: e.detail,
                        view: e.view
                    });
                    return e.defaultPrevented && i.preventDefault(), i;
                }
                let i = A(e);
                return i.touches = e.touches, i.changedTouches = e.changedTouches, i.targetTouches = e.targetTouches, i;
            },
            escapeStringForHTML: function(e) {
                return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
            },
            getElement: function(e, t) {
                return (T(t) || v).getElementById(e);
            },
            getFakeMouseEvent: M,
            getHeadingTagNameForElement: function(e) {
                let t = (e)=>"h" + Math.min(6, parseInt(e.slice(1), 10) + 1), i = (e)=>/^H[1-6]$/i.test(e), r = (e)=>{
                    let s = ((e)=>{
                        let t = e;
                        for(; t = t.previousSibling;){
                            let e = t.tagName || "";
                            if (i(e)) return e;
                        }
                        return "";
                    })(e);
                    if (s) return t(s);
                    let n = e.parentElement;
                    if (!n) return "h6";
                    let o = n.tagName;
                    return i(o) ? t(o) : r(n);
                };
                return r(e);
            },
            getShadowRoot: T,
            removeChildNodes: function(e) {
                for(; e.lastChild;)e.removeChild(e.lastChild);
            },
            removeClass: function(e, t) {
                e.classList ? e.classList.remove(t) : e.className = e.className.replace(RegExp(t, "g"), "");
            },
            removeElement: function(e) {
                e && e.parentNode && e.parentNode.removeChild(e);
            },
            reverseChildNodes: function(e) {
                let t = e.childNodes.length;
                for(; t--;)e.appendChild(e.childNodes[t]);
            },
            simulatedEventTarget: w,
            stripHTMLTagsFromString: function(e, t = !1) {
                return "string" == typeof e ? t ? e.replace(/<\/?[^>]+(>|$)/g, "") : e.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : e;
            },
            visuallyHideElement: function(e) {
                (0, x.css)(e, {
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    clip: "rect(1px, 1px, 1px, 1px)",
                    marginTop: "-3px",
                    "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)",
                    filter: "alpha(opacity=1)",
                    opacity: .01
                });
            }
        };
        var S = b(984), k = b.n(S);
        let { format: P } = k();
        var D = d || (d = {});
        function N(e, t, i) {
            let r = (e, t)=>{
                let i = e.slice(t || 0), r = i.indexOf("{"), s = i.indexOf("}");
                if (r > -1 && s > r) return {
                    statement: i.substring(r + 1, s),
                    begin: t + r + 1,
                    end: t + s
                };
            }, s = [], n, o, a = 0;
            do n = r(e, a), (o = e.substring(a, n && n.begin - 1)).length && s.push({
                value: o,
                type: "constant"
            }), n && s.push({
                value: n.statement,
                type: "statement"
            }), a = n ? n.end + 1 : a + 1;
            while (n);
            return s.forEach((e)=>{
                "statement" === e.type && (e.value = function(e, t) {
                    let i, r, s = e.indexOf("#each("), n = e.indexOf("#plural("), o = e.indexOf("["), a = e.indexOf("]");
                    if (s > -1) {
                        let n = e.slice(s).indexOf(")") + s, o = e.substring(0, s), a = e.substring(n + 1), l = e.substring(s + 6, n).split(","), h = Number(l[1]), d;
                        if (r = "", i = (0, x.getNestedProperty)(l[0], t)) {
                            d = (h = isNaN(h) ? i.length : h) < 0 ? i.length + h : Math.min(h, i.length);
                            for(let e = 0; e < d; ++e)r += o + i[e] + a;
                        }
                        return r.length ? r : "";
                    }
                    if (n > -1) {
                        var l;
                        let i = e.slice(n).indexOf(")") + n, s = e.substring(n + 8, i).split(",");
                        switch(Number((0, x.getNestedProperty)(s[0], t))){
                            case 0:
                                r = s[4] ?? s[1];
                                break;
                            case 1:
                                r = s[2] ?? s[1];
                                break;
                            case 2:
                                r = s[3] ?? s[1];
                                break;
                            default:
                                r = s[1];
                        }
                        return r ? (l = r).trim && l.trim() || l.replace(/^\s+|\s+$/g, "") : "";
                    }
                    if (o > -1) {
                        let r, s = e.substring(0, o), n = Number(e.substring(o + 1, a));
                        return i = (0, x.getNestedProperty)(s, t), !isNaN(n) && i && (n < 0 ? void 0 === (r = i[i.length + n]) && (r = i[0]) : void 0 === (r = i[n]) && (r = i[i.length - 1])), void 0 !== r ? r : "";
                    }
                    return "{" + e + "}";
                }(e.value, t));
            }), P(s.reduce((e, t)=>e + t.value, ""), t, i);
        }
        function B(e, t) {
            let i = e.split("."), r = this.options.lang, s = 0;
            for(; s < i.length; ++s)r = r && r[i[s]];
            return "string" == typeof r ? N(r, t, this) : "";
        }
        D.compose = function(e) {
            let t = e.prototype;
            t.langFormat || (t.langFormat = B);
        }, D.i18nFormat = N;
        let I = d, { doc: F } = y(), { stripHTMLTagsFromString: O } = C;
        function R(e) {
            if (e.points && e.points.length) {
                let t = (0, x.find)(e.points, (e)=>!!e.graphic);
                return t && t.graphic && t.graphic.element;
            }
        }
        function L(e) {
            let t = R(e);
            return t && t.parentNode || e.graph && e.graph.element || e.group && e.group.element;
        }
        let H = {
            fireEventOnWrappedOrUnwrappedElement: function e(t, i) {
                let r = i.type, s = t.hcEvents;
                F?.createEvent && (t.dispatchEvent || t.fireEvent) ? t.dispatchEvent ? t.dispatchEvent(i) : t.fireEvent(r, i) : s && s[r] ? (0, x.fireEvent)(t, r, i) : t.element && e(t.element, i);
            },
            getChartTitle: function(e) {
                return O(e.options.title.text || e.langFormat("accessibility.defaultChartTitle", {
                    chart: e
                }), e.renderer.forExport);
            },
            getAxisDescription: function(e) {
                return e && (e.options.accessibility?.description || e.axisTitle?.textStr || e.options.id || e.categories && e.chart.langFormat("accessibility.axis.defaultAxisNames.categories", {}) || e.dateTime && e.chart.langFormat("accessibility.axis.defaultAxisNames.time", {}) || e.chart.langFormat("accessibility.axis.defaultAxisNames.values", {}));
            },
            getAxisRangeDescription: function(e) {
                var t, i, r;
                let s, n, o, a, l, h, d, c, u, p, g, m, b = e.options || {};
                return b.accessibility && void 0 !== b.accessibility.rangeDescription ? b.accessibility.rangeDescription : e.categories ? (s = (t = e).chart, t.dataMax && t.dataMin ? s.langFormat("accessibility.axis.rangeCategories", {
                    chart: s,
                    axis: t,
                    numCategories: t.dataMax - t.dataMin + 1
                }) : "") : e.dateTime && (0 === e.min || 0 === e.dataMin) ? (n = (i = e).chart, o = {}, a = i.dataMin || i.min || 0, l = i.dataMax || i.max || 0, h = "Seconds", o.Seconds = (l - a) / 1e3, o.Minutes = o.Seconds / 60, o.Hours = o.Minutes / 60, o.Days = o.Hours / 24, [
                    "Minutes",
                    "Hours",
                    "Days"
                ].forEach(function(e) {
                    o[e] > 2 && (h = e);
                }), d = o[h].toFixed(+("Seconds" !== h && "Minutes" !== h)), n.langFormat("accessibility.axis.timeRange" + h, {
                    chart: n,
                    axis: i,
                    range: d.replace(".0", "")
                })) : (p = (u = (c = (r = e).chart).options) && u.accessibility && u.accessibility.screenReaderSection.axisRangeDateFormat || "", g = {
                    min: r.dataMin || r.min || 0,
                    max: r.dataMax || r.max || 0
                }, m = function(e) {
                    return r.dateTime ? c.time.dateFormat(p, g[e]) : g[e].toString();
                }, c.langFormat("accessibility.axis.rangeFromTo", {
                    chart: c,
                    axis: r,
                    rangeFrom: m("min"),
                    rangeTo: m("max")
                }));
            },
            getPointFromXY: function(e, t, i) {
                let r = e.length, s;
                for(; r--;)if (s = (0, x.find)(e[r].points || [], function(e) {
                    return e.x === t && e.y === i;
                })) return s;
            },
            getSeriesFirstPointElement: R,
            getSeriesFromName: function(e, t) {
                return t ? (e.series || []).filter(function(e) {
                    return e.name === t;
                }) : e.series;
            },
            getSeriesA11yElement: L,
            unhideChartElementFromAT: function e(t, i) {
                i.setAttribute("aria-hidden", !1), i !== t.renderTo && i.parentNode && i.parentNode !== F.body && (Array.prototype.forEach.call(i.parentNode.childNodes, function(e) {
                    e.hasAttribute("aria-hidden") || e.setAttribute("aria-hidden", !0);
                }), e(t, i.parentNode));
            },
            hideSeriesFromAT: function(e) {
                let t = L(e);
                t && t.setAttribute("aria-hidden", !0);
            },
            scrollAxisToPoint: function(e) {
                let t = e.series.xAxis, i = e.series.yAxis, r = t && t.scrollbar ? t : i, s = r && r.scrollbar;
                if (s && (0, x.defined)(s.to) && (0, x.defined)(s.from)) {
                    let t = s.to - s.from, i = function(e, t) {
                        if (!(0, x.defined)(e.dataMin) || !(0, x.defined)(e.dataMax)) return 0;
                        let i = e.toPixels(e.dataMin), r = e.toPixels(e.dataMax), s = "xAxis" === e.coll ? "x" : "y";
                        return (e.toPixels(t[s] || 0) - i) / (r - i);
                    }(r, e);
                    s.updatePosition(i - t / 2, i + t / 2), (0, x.fireEvent)(s, "changed", {
                        from: s.from,
                        to: s.to,
                        trigger: "scrollbar",
                        DOMEvent: null
                    });
                }
            }
        }, { doc: z } = y(), { removeElement: q } = C, U = class {
            constructor(){
                this.elements = [];
            }
            createElement() {
                let e = z.createElement.apply(z, arguments);
                return this.elements.push(e), e;
            }
            removeElement(e) {
                q(e), this.elements.splice(this.elements.indexOf(e), 1);
            }
            destroyCreatedElements() {
                this.elements.forEach(function(e) {
                    q(e);
                }), this.elements = [];
            }
        }, G = class {
            constructor(){
                this.eventRemovers = [];
            }
            addEvent() {
                let e = x.addEvent.apply(y(), arguments);
                return this.eventRemovers.push({
                    element: arguments[0],
                    remover: e
                }), e;
            }
            removeEvent(e) {
                let t = this.eventRemovers.map((e)=>e.remover).indexOf(e);
                this.eventRemovers[t].remover(), this.eventRemovers.splice(t, 1);
            }
            removeAddedEvents() {
                this.eventRemovers.map((e)=>e.remover).forEach((e)=>e()), this.eventRemovers = [];
            }
        }, { fireEventOnWrappedOrUnwrappedElement: K } = H, { getFakeMouseEvent: V } = C, W = class {
            destroy() {}
            getKeyboardNavigation() {
                return [];
            }
            init() {}
            onChartRender() {}
            onChartUpdate() {}
            initBase(e, t) {
                this.chart = e, this.eventProvider = new G, this.domElementProvider = new U, this.proxyProvider = t, this.keyCodes = {
                    left: 37,
                    right: 39,
                    up: 38,
                    down: 40,
                    enter: 13,
                    space: 32,
                    esc: 27,
                    tab: 9,
                    pageUp: 33,
                    pageDown: 34,
                    end: 35,
                    home: 36
                };
            }
            addEvent(e, t, i, r) {
                return this.eventProvider.addEvent(e, t, i, r);
            }
            createElement(e, t) {
                return this.domElementProvider.createElement(e, t);
            }
            fakeClickEvent(e) {
                K(e, V("click"));
            }
            destroyBase() {
                this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
            }
        }, X = class {
            constructor(e, t){
                this.chart = e, this.keyCodeMap = t.keyCodeMap || [], this.validate = t.validate, this.init = t.init, this.terminate = t.terminate, this.response = {
                    success: 1,
                    prev: 2,
                    next: 3,
                    noHandler: 4,
                    fail: 5
                };
            }
            run(e) {
                let t = e.which || e.keyCode, i = this.response.noHandler, r = (0, x.find)(this.keyCodeMap, function(e) {
                    return e[0].indexOf(t) > -1;
                });
                return r ? i = r[1].call(this, t, e) : 9 === t && (i = this.response[e.shiftKey ? "prev" : "next"]), i;
            }
        }, { unhideChartElementFromAT: Y, getChartTitle: j } = H, { doc: Z } = y(), { stripHTMLTagsFromString: _ } = C, $ = class extends W {
            onChartUpdate() {
                this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
            }
            handleSVGTitleElement() {
                let e = this.chart, t = "highcharts-title-" + e.index, i = _(e.langFormat("accessibility.svgContainerTitle", {
                    chartTitle: j(e)
                }));
                if (i.length) {
                    let r = this.svgTitleElement = this.svgTitleElement || Z.createElementNS("http://www.w3.org/2000/svg", "title");
                    r.textContent = i, r.id = t, e.renderTo.insertBefore(r, e.renderTo.firstChild);
                }
            }
            setSVGContainerLabel() {
                let e = this.chart, t = e.langFormat("accessibility.svgContainerLabel", {
                    chartTitle: j(e)
                });
                e.renderer.box && t.length && e.renderer.box.setAttribute("aria-label", t);
            }
            setGraphicContainerAttrs() {
                let e = this.chart, t = e.langFormat("accessibility.graphicContainerLabel", {
                    chartTitle: j(e)
                });
                t.length && e.container.setAttribute("aria-label", t);
            }
            setRenderToAttrs() {
                let e = this.chart, t = "disabled" !== e.options.accessibility.landmarkVerbosity, i = e.langFormat("accessibility.chartContainerLabel", {
                    title: j(e),
                    chart: e
                });
                i && (e.renderTo.setAttribute("role", t ? "region" : "group"), e.renderTo.setAttribute("aria-label", i));
            }
            makeCreditsAccessible() {
                let e = this.chart, t = e.credits;
                t && (t.textStr && t.element.setAttribute("aria-label", e.langFormat("accessibility.credits", {
                    creditsStr: _(t.textStr, e.renderer.forExport)
                })), Y(e, t.element));
            }
            getKeyboardNavigation() {
                let e = this.chart;
                return new X(e, {
                    keyCodeMap: [],
                    validate: function() {
                        return !0;
                    },
                    init: function() {
                        let t = e.accessibility;
                        t && t.keyboardNavigation.tabindexContainer.focus();
                    }
                });
            }
            destroy() {
                this.chart.renderTo.setAttribute("aria-hidden", !0);
            }
        };
        !function(e) {
            let t = [
                "x",
                "y",
                "transform",
                "width",
                "height",
                "r",
                "d",
                "stroke-width"
            ];
            function i() {
                let e = this.focusElement, t = this.options.accessibility.keyboardNavigation.focusBorder;
                e && (e.removeFocusBorder(), t.enabled && e.addFocusBorder(t.margin, {
                    stroke: t.style.color,
                    strokeWidth: t.style.lineWidth,
                    r: t.style.borderRadius
                }));
            }
            function r(e, t) {
                let i = this.options.accessibility.keyboardNavigation.focusBorder, r = t || e.element;
                r && r.focus && (r.hcEvents && r.hcEvents.focusin || (0, x.addEvent)(r, "focusin", function() {}), r.focus(), i.hideBrowserFocusOutline && (r.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = e, (0, x.addEvent)(this, "endResize", function() {
                    this.renderFocusBorder();
                }), this.renderFocusBorder();
            }
            function s(e, i) {
                this.focusBorder && this.removeFocusBorder();
                let r = this.getBBox(), s = e ?? 3, n = this.parentGroup, o = this.scaleX || n && n.scaleX, a = this.scaleY || n && n.scaleY, l = (o ? !a : a) ? Math.abs(o || a || 1) : (Math.abs(o || 1) + Math.abs(a || 1)) / 2, h = this.renderer.fontMetrics(this).h;
                r.x += this.translateX ? this.translateX : 0, r.y += this.translateY ? this.translateY : 0;
                let d = r.x - s, c = r.y - s, u = r.width + 2 * s, p = r.height + 2 * s, g = !!this.text;
                if ("text" === this.element.nodeName || g) {
                    let e, t, i = !!this.rotation, n = g ? {
                        x: +!!i,
                        y: 0
                    } : (e = 0, t = 0, "middle" === this.attr("text-anchor") ? e = t = .5 : this.rotation ? e = .25 : t = .75, {
                        x: e,
                        y: t
                    }), o = +this.attr("x"), a = +this.attr("y");
                    if (isNaN(o) || (d = o - r.width * n.x - s), isNaN(a) || (c = a - ("start" === this.attr("text-anchor") ? h : r.height) * n.y - s), g && i) {
                        let e = u;
                        u = p, p = e, isNaN(o) || (d = o - r.height * n.x - s), isNaN(a) || (c = a - r.width * n.y - s);
                    }
                }
                this.focusBorder = this.renderer.rect(d, c, u, p, parseInt((i && i.r || 0).toString(), 10) / l).addClass("highcharts-focus-border").attr({
                    zIndex: 99
                }).add(n), this.renderer.styledMode || this.focusBorder.attr({
                    stroke: i && i.stroke,
                    "stroke-width": (i && i.strokeWidth || 0) / l
                }), function(e, ...i) {
                    e.focusBorderUpdateHooks || (e.focusBorderUpdateHooks = {}, t.forEach((t)=>{
                        let r = t + "Setter", s = e[r] || e._defaultSetter;
                        e.focusBorderUpdateHooks[r] = s, e[r] = function() {
                            let t = s.apply(e, arguments);
                            return e.addFocusBorder.apply(e, i), t;
                        };
                    }));
                }(this, e, i), function(e) {
                    if (e.focusBorderDestroyHook) return;
                    let t = e.destroy;
                    e.destroy = function() {
                        return e.focusBorder && e.focusBorder.destroy && e.focusBorder.destroy(), t.apply(e, arguments);
                    }, e.focusBorderDestroyHook = t;
                }(this);
            }
            function n() {
                var e;
                e = this, e.focusBorderUpdateHooks && (Object.keys(e.focusBorderUpdateHooks).forEach((t)=>{
                    let i = e.focusBorderUpdateHooks[t];
                    i === e._defaultSetter ? delete e[t] : e[t] = i;
                }), delete e.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
            }
            e.compose = function(e, t) {
                let o = e.prototype, a = t.prototype;
                o.renderFocusBorder || (o.renderFocusBorder = i, o.setFocusToElement = r), a.addFocusBorder || (a.addFocusBorder = s, a.removeFocusBorder = n);
            };
        }(c || (c = {}));
        let Q = c;
        var J = b(660), ee = b.n(J);
        let { doc: et } = y(), { addClass: ei, visuallyHideElement: er } = C, es = class {
            constructor(e, t){
                this.chart = e, this.domElementProvider = new U, this.announceRegion = this.addAnnounceRegion(t);
            }
            destroy() {
                this.domElementProvider.destroyCreatedElements();
            }
            announce(e) {
                ee().setElementHTML(this.announceRegion, e), this.clearAnnouncementRegionTimer && (0, x.internalClearTimeout)(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(()=>{
                    this.announceRegion.innerHTML = ee().emptyHTML, delete this.clearAnnouncementRegionTimer;
                }, 3e3);
            }
            addAnnounceRegion(e) {
                let t = this.chart.announcerContainer || this.createAnnouncerContainer(), i = this.domElementProvider.createElement("div");
                return (0, x.attr)(i, {
                    "aria-hidden": !1,
                    "aria-live": e,
                    "aria-atomic": !0
                }), er(i), this.chart.styledMode && ei(i, "highcharts-visually-hidden"), t.appendChild(i), i;
            }
            createAnnouncerContainer() {
                let e = this.chart, t = et.createElement("div");
                return (0, x.attr)(t, {
                    "aria-hidden": !1,
                    class: "highcharts-announcer-container"
                }), er(t), e.renderTo.insertBefore(t, e.renderTo.firstChild), e.announcerContainer = t, t;
            }
        }, { escapeStringForHTML: en, stripHTMLTagsFromString: eo } = C;
        function ea(e) {
            return (e.annotations || []).reduce((e, t)=>(t.options && !1 !== t.options.visible && (e = e.concat(t.labels)), e), []);
        }
        function el(e) {
            return e.options && e.options.accessibility && e.options.accessibility.description || e.graphic && e.graphic.text && e.graphic.text.textStr || "";
        }
        function eh(e) {
            let t = e.options && e.options.accessibility && e.options.accessibility.description;
            if (t) return t;
            let i = e.chart, r = el(e), s = e.points.filter((e)=>!!e.graphic).map((e)=>{
                let t = e.accessibility && e.accessibility.valueDescription || e.graphic && e.graphic.element && e.graphic.element.getAttribute("aria-label") || "", i = e && e.series.name || "";
                return (i ? i + ", " : "") + "data point " + t;
            }).filter((e)=>!!e), n = s.length, o = n > 1 ? "MultiplePoints" : n ? "SinglePoint" : "NoPoints", a = {
                annotationText: r,
                annotation: e,
                numPoints: n,
                annotationPoint: s[0],
                additionalAnnotationPoints: s.slice(1)
            };
            return i.langFormat("accessibility.screenReaderSection.annotations.description" + o, a);
        }
        function ed(e) {
            return ea(e).map((t)=>{
                let i = en(eo(eh(t), e.renderer.forExport));
                return i ? `<li>${i}</li>` : "";
            });
        }
        let ec = {
            getAnnotationsInfoHTML: function(e) {
                let t = e.annotations;
                if (!(t && t.length)) return "";
                let i = ed(e);
                return `<ul style="list-style-type: none">${i.join(" ")}</ul>`;
            },
            getAnnotationLabelDescription: eh,
            getAnnotationListItems: ed,
            getPointAnnotationTexts: function(e) {
                let t = ea(e.series.chart).filter((t)=>t.points.indexOf(e) > -1);
                return t.length ? t.map((e)=>`${el(e)}`) : [];
            }
        }, { getAnnotationsInfoHTML: eu } = ec, { getAxisDescription: ep, getAxisRangeDescription: eg, getChartTitle: em, unhideChartElementFromAT: eb } = H, { format: ef } = k(), { doc: ex } = y(), { addClass: ey, getElement: ev, getHeadingTagNameForElement: eE, getShadowRoot: ew, stripHTMLTagsFromString: eA, visuallyHideElement: eT } = C;
        function eM(e) {
            return (0, x.replaceNested)(e, [
                /<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g,
                ""
            ]);
        }
        let eC = class extends W {
            constructor(){
                super(...arguments), this.screenReaderSections = {};
            }
            init() {
                let e = this.chart, t = this;
                this.initRegionsDefinitions(), this.addEvent(e, "afterGetTableAST", function(e) {
                    t.onDataTableCreated(e);
                }), this.addEvent(e, "afterViewData", function(e) {
                    e.wasHidden && (t.dataTableDiv = e.element, setTimeout(function() {
                        t.focusDataTable();
                    }, 300));
                }), this.addEvent(e, "afterHideData", function() {
                    t.viewDataTableButton && t.viewDataTableButton.setAttribute("aria-expanded", "false");
                }), e.exporting && this.addEvent(e, "afterPrint", function() {
                    t.updateAllScreenReaderSections();
                }), this.announcer = new es(e, "assertive");
            }
            initRegionsDefinitions() {
                let e = this, t = this.chart.options.accessibility;
                this.screenReaderSections = {
                    before: {
                        element: null,
                        buildContent: function(i) {
                            let r = t.screenReaderSection.beforeChartFormatter;
                            return r ? r(i, e) : e.defaultBeforeChartFormatter();
                        },
                        insertIntoDOM: function(e, t) {
                            t.renderTo.insertBefore(e, t.renderTo.firstChild);
                        },
                        afterInserted: function() {
                            void 0 !== e.sonifyButtonId && e.initSonifyButton(e.sonifyButtonId), void 0 !== e.dataTableButtonId && e.initDataTableButton(e.dataTableButtonId);
                        }
                    },
                    after: {
                        element: null,
                        buildContent: function(i) {
                            let r = t.screenReaderSection.afterChartFormatter;
                            return r ? r(i, e) : e.defaultAfterChartFormatter();
                        },
                        insertIntoDOM: function(e, t) {
                            t.renderTo.insertBefore(e, t.container.nextSibling);
                        },
                        afterInserted: function() {
                            e.chart.accessibility && t.keyboardNavigation.enabled && e.chart.accessibility.keyboardNavigation.updateExitAnchor();
                        }
                    }
                };
            }
            onChartRender() {
                this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
            }
            updateAllScreenReaderSections() {
                let e = this;
                Object.keys(this.screenReaderSections).forEach(function(t) {
                    e.updateScreenReaderSection(t);
                });
            }
            getLinkedDescriptionElement() {
                let e = this.chart.options.accessibility.linkedDescription;
                if (!e) return;
                if ("string" != typeof e) return e;
                let t = ef(e, this.chart), i = ew(this.chart.renderTo), r = i?.querySelectorAll(t), s = r?.length ? r : ex.querySelectorAll(t);
                if (1 === s.length) return s[0];
            }
            setLinkedDescriptionAttrs() {
                let e = this.linkedDescriptionElement;
                e && (e.setAttribute("aria-hidden", "true"), ey(e, "highcharts-linked-description"));
            }
            updateScreenReaderSection(e) {
                let t = this.chart, i = this.screenReaderSections[e], r = i.buildContent(t), s = i.element = i.element || this.createElement("div"), n = s.firstChild || this.createElement("div");
                r ? (this.setScreenReaderSectionAttribs(s, e), ee().setElementHTML(n, r), s.appendChild(n), i.insertIntoDOM(s, t), eT(n), t.styledMode && ey(n, "highcharts-visually-hidden"), eb(t, n), i.afterInserted && i.afterInserted()) : (s.parentNode && s.parentNode.removeChild(s), i.element = null);
            }
            setScreenReaderSectionAttribs(e, t) {
                let i = this.chart, r = i.langFormat("accessibility.screenReaderSection." + t + "RegionLabel", {
                    chart: i,
                    chartTitle: em(i)
                }), s = `highcharts-screen-reader-region-${t}-${i.index}`;
                (0, x.attr)(e, {
                    id: s,
                    "aria-label": r || void 0
                }), e.style.position = "relative", r && e.setAttribute("role", "all" === i.options.accessibility.landmarkVerbosity ? "region" : "group");
            }
            defaultBeforeChartFormatter() {
                let e = this.chart, t = e.options.accessibility.screenReaderSection.beforeChartFormat;
                if (!t) return "";
                let i = this.getAxesDescription(), r = e.sonify && e.options.sonification && e.options.sonification.enabled, s = "highcharts-a11y-sonify-data-btn-" + e.index, n = "hc-linkto-highcharts-data-table-" + e.index, o = eu(e), a = e.langFormat("accessibility.screenReaderSection.annotations.heading", {
                    chart: e
                }), l = {
                    headingTagName: eE(e.renderTo),
                    chartTitle: em(e),
                    typeDescription: this.getTypeDescriptionText(),
                    chartSubtitle: this.getSubtitleText(),
                    chartLongdesc: this.getLongdescText(),
                    xAxisDescription: i.xAxis,
                    yAxisDescription: i.yAxis,
                    playAsSoundButton: r ? this.getSonifyButtonText(s) : "",
                    viewTableButton: e.exporting?.getCSV ? this.getDataTableButtonText(n) : "",
                    annotationsTitle: o ? a : "",
                    annotationsList: o
                }, h = I.i18nFormat(t, l, e);
                return this.dataTableButtonId = n, this.sonifyButtonId = s, eM(h);
            }
            defaultAfterChartFormatter() {
                let e = this.chart, t = e.options.accessibility.screenReaderSection.afterChartFormat;
                if (!t) return "";
                let i = {
                    endOfChartMarker: this.getEndOfChartMarkerText()
                };
                return eM(I.i18nFormat(t, i, e));
            }
            getLinkedDescription() {
                let e = this.linkedDescriptionElement;
                return eA(e && e.innerHTML || "", this.chart.renderer.forExport);
            }
            getLongdescText() {
                let e = this.chart.options, t = e.caption, i = t && t.text, r = this.getLinkedDescription();
                return e.accessibility.description || r || i || "";
            }
            getTypeDescriptionText() {
                let e = this.chart;
                return e.types ? e.options.accessibility.typeDescription || function(e, t) {
                    let i, r, s, n = t[0], o = e.series && e.series[0] || {}, a = e.mapView && e.mapView.geoMap && e.mapView.geoMap.title, l = {
                        numSeries: e.series.length,
                        numPoints: o.points && o.points.length,
                        chart: e,
                        mapTitle: a
                    };
                    return n ? "map" === n || "tiledwebmap" === n ? l.mapTitle ? e.langFormat("accessibility.chartTypes.mapTypeDescription", l) : e.langFormat("accessibility.chartTypes.unknownMap", l) : e.types.length > 1 ? e.langFormat("accessibility.chartTypes.combinationChart", l) : (i = t[0], r = e.langFormat("accessibility.seriesTypeDescriptions." + i, l), s = e.series && e.series.length < 2 ? "Single" : "Multiple", (e.langFormat("accessibility.chartTypes." + i + s, l) || e.langFormat("accessibility.chartTypes.default" + s, l)) + (r ? " " + r : "")) : e.langFormat("accessibility.chartTypes.emptyChart", l);
                }(e, e.types) : "";
            }
            getDataTableButtonText(e) {
                let t = this.chart;
                return '<button id="' + e + '">' + t.langFormat("accessibility.table.viewAsDataTableButtonText", {
                    chart: t,
                    chartTitle: em(t)
                }) + "</button>";
            }
            getSonifyButtonText(e) {
                let t = this.chart;
                return t.options.sonification && !1 === t.options.sonification.enabled ? "" : '<button id="' + e + '">' + t.langFormat("accessibility.sonification.playAsSoundButtonText", {
                    chart: t,
                    chartTitle: em(t)
                }) + "</button>";
            }
            getSubtitleText() {
                let e = this.chart.options.subtitle;
                return eA(e && e.text || "", this.chart.renderer.forExport);
            }
            getEndOfChartMarkerText() {
                let e = ev(`highcharts-end-of-chart-marker-${this.chart.index}`, this.chart.renderTo);
                if (e) return e.outerHTML;
                let t = this.chart, i = t.langFormat("accessibility.screenReaderSection.endOfChartMarker", {
                    chart: t
                });
                return '<div id="highcharts-end-of-chart-marker-' + t.index + '">' + i + "</div>";
            }
            onDataTableCreated(e) {
                let t = this.chart;
                if (t.options.accessibility.enabled) {
                    this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
                    let i = e.tree.attributes || {};
                    i.tabindex = -1, i.summary = t.langFormat("accessibility.table.tableSummary", {
                        chart: t
                    }), e.tree.attributes = i;
                }
            }
            focusDataTable() {
                let e = this.dataTableDiv, t = e && e.getElementsByTagName("table")[0];
                t && t.focus && t.focus();
            }
            initSonifyButton(e) {
                let t = this.chart, i = this.sonifyButton = ev(e, t.renderTo), r = (e)=>{
                    i && (i.setAttribute("aria-hidden", "true"), i.setAttribute("aria-label", "")), e.preventDefault(), e.stopPropagation();
                    let r = t.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", {
                        chart: t
                    });
                    this.announcer.announce(r), setTimeout(()=>{
                        i && (i.removeAttribute("aria-hidden"), i.removeAttribute("aria-label")), t.sonify && t.sonify();
                    }, 1e3);
                };
                i && t && (i.setAttribute("tabindex", -1), i.onclick = function(e) {
                    (t.options.accessibility && t.options.accessibility.screenReaderSection.onPlayAsSoundClick || r).call(this, e, t, this);
                });
            }
            initDataTableButton(e) {
                let t = this.chart, i = this.viewDataTableButton = ev(e, t.renderTo), r = e.replace("hc-linkto-", "");
                i && ((0, x.attr)(i, {
                    tabindex: -1,
                    "aria-expanded": !!ev(r, t.renderTo)
                }), i.onclick = t.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
                    t.exporting?.viewData();
                });
            }
            getAxesDescription() {
                let e = this.chart, t = function(t, i) {
                    let r = e[t], s = r[0] ? r[0].options.accessibility && r[0].options.accessibility.enabled : void 0;
                    return r.length > 1 || (s ?? i);
                }, i = !!e.types && 0 > e.types.indexOf("map") && 0 > e.types.indexOf("treemap") && 0 > e.types.indexOf("tilemap"), r = !!e.hasCartesianSeries, s = t("xAxis", !e.angular && r && i), n = t("yAxis", r && i), o = {};
                return s && (o.xAxis = this.getAxisDescriptionText("xAxis")), n && (o.yAxis = this.getAxisDescriptionText("yAxis")), o;
            }
            getAxisDescriptionText(e) {
                let t = this.chart, i = t[e];
                return t.langFormat("accessibility.axis." + e + "Description" + (i.length > 1 ? "Plural" : "Singular"), {
                    chart: t,
                    names: i.map(function(e) {
                        return ep(e);
                    }),
                    ranges: i.map(function(e) {
                        return eg(e);
                    }),
                    numAxes: i.length
                });
            }
            destroy() {
                this.announcer && this.announcer.destroy();
            }
        }, { getChartTitle: eS, unhideChartElementFromAT: ek } = H, { getFakeMouseEvent: eP } = C;
        function eD(e) {
            return e.exporting?.svgElements?.[0];
        }
        class eN extends W {
            init() {
                let e = this.chart, t = this;
                this.addEvent(e, "exportMenuShown", function() {
                    t.onMenuShown();
                }), this.addEvent(e, "exportMenuHidden", function() {
                    t.onMenuHidden();
                }), this.createProxyGroup();
            }
            onMenuHidden() {
                let e = this.chart.exporting?.contextMenuEl;
                e && e.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
            }
            onMenuShown() {
                let e = this.chart, t = e.exporting?.contextMenuEl;
                t && (this.addAccessibleContextMenuAttribs(), ek(e, t)), this.setExportButtonExpandedState("true");
            }
            setExportButtonExpandedState(e) {
                this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", e);
            }
            onChartRender() {
                let e = this.chart, t = e.focusElement, i = e.accessibility;
                this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && t && t === e.exporting?.group && (t.focusBorder ? e.setFocusToElement(t, this.exportButtonProxy.innerElement) : i && i.keyboardNavigation.tabindexContainer.focus());
            }
            proxyMenuButton() {
                let e, t, i = this.chart, r = this.proxyProvider, s = eD(i);
                e = i.options.exporting, t = eD(i), e && !1 !== e.enabled && e.accessibility && e.accessibility.enabled && t && t.element && s && (this.exportButtonProxy = r.addProxyElement("chartMenu", {
                    click: s
                }, "button", {
                    "aria-label": i.langFormat("accessibility.exporting.menuButtonLabel", {
                        chart: i,
                        chartTitle: eS(i)
                    }),
                    "aria-expanded": !1,
                    title: i.options.lang.contextButtonTitle || null
                }));
            }
            createProxyGroup() {
                this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
            }
            addAccessibleContextMenuAttribs() {
                let e = this.chart, t = e.exporting?.divElements;
                if (t && t.length) {
                    t.forEach((e)=>{
                        e && ("LI" !== e.tagName || e.children && e.children.length ? e.setAttribute("aria-hidden", "true") : e.setAttribute("tabindex", -1));
                    });
                    let i = t[0] && t[0].parentNode;
                    i && (0, x.attr)(i, {
                        "aria-hidden": void 0,
                        "aria-label": e.langFormat("accessibility.exporting.chartMenuLabel", {
                            chart: e
                        }),
                        role: "list"
                    });
                }
            }
            getKeyboardNavigation() {
                let e = this.keyCodes, t = this.chart, i = this;
                return new X(t, {
                    keyCodeMap: [
                        [
                            [
                                e.left,
                                e.up
                            ],
                            function() {
                                return i.onKbdPrevious(this);
                            }
                        ],
                        [
                            [
                                e.right,
                                e.down
                            ],
                            function() {
                                return i.onKbdNext(this);
                            }
                        ],
                        [
                            [
                                e.enter,
                                e.space
                            ],
                            function() {
                                return i.onKbdClick(this);
                            }
                        ]
                    ],
                    validate: function() {
                        return !!t.exporting && t.options.exporting?.buttons?.contextButton.enabled !== !1 && !1 !== t.options.exporting.enabled && !1 !== (t.options.exporting.accessibility?.enabled || !1);
                    },
                    init: function() {
                        let e = i.exportButtonProxy, r = i.chart.exporting?.group;
                        e && r && t.setFocusToElement(r, e.innerElement);
                    },
                    terminate: function() {
                        t.hideExportMenu();
                    }
                });
            }
            onKbdPrevious(e) {
                let t = this.chart, i = t.options.accessibility, r = e.response, s = t.highlightedExportItemIx || 0;
                for(; s--;)if (t.highlightExportItem(s)) return r.success;
                return i.keyboardNavigation.wrapAround ? (t.highlightLastExportItem(), r.success) : r.prev;
            }
            onKbdNext(e) {
                let t = this.chart, i = t.options.accessibility, r = e.response;
                for(let e = (t.highlightedExportItemIx || 0) + 1; e < (t.exporting?.divElements?.length || 0); ++e)if (t.highlightExportItem(e)) return r.success;
                return i.keyboardNavigation.wrapAround ? (t.highlightExportItem(0), r.success) : r.next;
            }
            onKbdClick(e) {
                let t = this.chart, i = void 0 !== t.highlightedExportItemIx && t.exporting?.divElements?.[t.highlightedExportItemIx], r = eD(t)?.element;
                return t.exporting?.openMenu ? i && this.fakeClickEvent(i) : (r && this.fakeClickEvent(r), t.highlightExportItem(0)), e.response.success;
            }
        }
        !function(e) {
            function t() {
                let e = eD(this);
                if (e) {
                    let t = e.element;
                    t.onclick && (t.onclick = function() {
                        eP("click");
                    });
                }
            }
            function i() {
                let e = this.exporting?.divElements;
                e && this.exporting?.contextMenuEl && this.exporting?.openMenu && (e.forEach((e)=>{
                    e && "highcharts-menu-item" === e.className && e.onmouseout && e.onmouseout(eP("mouseout"));
                }), this.highlightedExportItemIx = 0, this.exporting.contextMenuEl.hideMenu(), this.container.focus());
            }
            function r(e) {
                let t = this.exporting?.divElements?.[e], i = void 0 !== this.highlightedExportItemIx && this.exporting?.divElements?.[this.highlightedExportItemIx];
                if (t && "LI" === t.tagName && !(t.children && t.children.length)) {
                    let r = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
                    return t.focus && r && t.focus(), i && i.onmouseout && i.onmouseout(eP("mouseout")), t.onmouseover && t.onmouseover(eP("mouseover")), this.highlightedExportItemIx = e, !0;
                }
                return !1;
            }
            function s() {
                if (this.exporting?.divElements) {
                    let e = this.exporting?.divElements.length;
                    for(; e--;)if (this.highlightExportItem(e)) return !0;
                }
                return !1;
            }
            e.compose = function(e) {
                let n = e.prototype;
                n.hideExportMenu || (n.hideExportMenu = i, n.highlightExportItem = r, n.highlightLastExportItem = s, n.showExportMenu = t);
            };
        }(eN || (eN = {}));
        let eB = eN, { doc: eI, win: eF } = y(), { getElement: eO, simulatedEventTarget: eR } = C;
        class eL {
            constructor(e, t){
                this.currentModuleIx = 0 / 0, this.modules = [], this.init(e, t);
            }
            init(e, t) {
                let i = this.eventProvider = new G;
                this.chart = e, this.components = t, this.modules = [], this.currentModuleIx = 0, this.update(), i.addEvent(this.tabindexContainer, "keydown", (e)=>this.onKeydown(e)), i.addEvent(this.tabindexContainer, "focus", (e)=>this.onFocus(e)), [
                    "mouseup",
                    "touchend"
                ].forEach((e)=>i.addEvent(eI, e, (e)=>this.onMouseUp(e))), [
                    "mousedown",
                    "touchstart"
                ].forEach((t)=>i.addEvent(e.renderTo, t, ()=>{
                        this.isClickingChart = !0;
                    }));
            }
            update(e) {
                let t = this.chart.options.accessibility, i = t && t.keyboardNavigation, r = this.components;
                this.updateContainerTabindex(), i && i.enabled && e && e.length ? (this.modules = e.reduce(function(e, t) {
                    let i = r[t].getKeyboardNavigation();
                    return e.concat(i);
                }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
            }
            updateExitAnchor() {
                let e = eO(`highcharts-end-of-chart-marker-${this.chart.index}`, this.chart.renderTo);
                this.removeExitAnchor(), e ? (this.makeElementAnExitAnchor(e), this.exitAnchor = e) : this.createExitAnchor();
            }
            move(e) {
                let t = this.modules && this.modules[this.currentModuleIx];
                t && t.terminate && t.terminate(e), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += e;
                let i = this.modules && this.modules[this.currentModuleIx];
                if (i) {
                    if (i.validate && !i.validate()) return this.move(e);
                    if (i.init) return i.init(e), !0;
                }
                return this.currentModuleIx = 0, this.exiting = !0, e > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
            }
            onFocus(e) {
                let t = this.chart, i = e.relatedTarget && t.container.contains(e.relatedTarget), r = t.options.accessibility, s = r && r.keyboardNavigation;
                if (s && s.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !i) {
                    let e = this.getFirstValidModuleIx();
                    null !== e && (this.currentModuleIx = e, this.modules[e].init(1));
                }
                this.keyboardReset = !1, this.exiting = !1;
            }
            onMouseUp(e) {
                if (delete this.isClickingChart, !this.keyboardReset && e.relatedTarget !== eR) {
                    let t = this.chart;
                    if (!e.target || !t.container.contains(e.target)) {
                        let e = this.modules && this.modules[this.currentModuleIx || 0];
                        e && e.terminate && e.terminate(), this.currentModuleIx = 0;
                    }
                    t.focusElement && (t.focusElement.removeFocusBorder(), delete t.focusElement), this.keyboardReset = !0;
                }
            }
            onKeydown(e) {
                let t, i = e || eF.event, r = this.modules && this.modules.length && this.modules[this.currentModuleIx], s = i.target;
                if ((!s || "INPUT" !== s.nodeName || s.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, r)) {
                    let e = r.run(i);
                    e === r.response.success ? t = !0 : e === r.response.prev ? t = this.move(-1) : e === r.response.next && (t = this.move(1)), t && (i.preventDefault(), i.stopPropagation());
                }
            }
            updateContainerTabindex() {
                let e, t = this.chart.options.accessibility, i = t && t.keyboardNavigation, r = !(i && !1 === i.enabled), s = this.chart, n = s.container;
                s.renderTo.hasAttribute("tabindex") ? (n.removeAttribute("tabindex"), e = s.renderTo) : e = n, this.tabindexContainer = e;
                let o = e.getAttribute("tabindex");
                r && !o ? e.setAttribute("tabindex", "0") : r || s.container.removeAttribute("tabindex");
            }
            createExitAnchor() {
                let e = this.chart, t = this.exitAnchor = eI.createElement("div");
                e.renderTo.appendChild(t), this.makeElementAnExitAnchor(t);
            }
            makeElementAnExitAnchor(e) {
                let t = this.tabindexContainer.getAttribute("tabindex") || 0;
                e.setAttribute("class", "highcharts-exit-anchor"), e.setAttribute("tabindex", t), e.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(e);
            }
            removeExitAnchor() {
                if (this.exitAnchor) {
                    let e = this.eventProvider.eventRemovers.find((e)=>e.element === this.exitAnchor);
                    e && (0, x.defined)(e.remover) && this.eventProvider.removeEvent(e.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
                }
            }
            addExitAnchorEventsToEl(e) {
                let t = this.chart, i = this;
                this.eventProvider.addEvent(e, "focus", function(e) {
                    let r = e || eF.event, s = !(r.relatedTarget && t.container.contains(r.relatedTarget) || i.exiting);
                    if (t.focusElement && delete t.focusElement, s) {
                        if (i.tabbingInBackwards = !0, i.tabindexContainer.focus(), delete i.tabbingInBackwards, r.preventDefault(), i.modules && i.modules.length) {
                            i.currentModuleIx = i.modules.length - 1;
                            let e = i.modules[i.currentModuleIx];
                            e && e.validate && !e.validate() ? i.move(-1) : e && e.init(-1);
                        }
                    } else i.exiting = !1;
                });
            }
            getFirstValidModuleIx() {
                let e = this.modules.length;
                for(let t = 0; t < e; ++t){
                    let e = this.modules[t];
                    if (!e.validate || e.validate()) return t;
                }
                return null;
            }
            destroy() {
                this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
            }
        }
        function eH() {
            let e = this;
            (0, x.fireEvent)(this, "dismissPopupContent", {}, function() {
                e.tooltip && e.tooltip.hide(0), e.hideExportMenu();
            });
        }
        function ez(e) {
            27 === (e.which || e.keyCode) && y().charts && y().charts.forEach((e)=>{
                e && e.dismissPopupContent && e.dismissPopupContent();
            });
        }
        (eL || (eL = {})).compose = function(e) {
            eB.compose(e);
            let t = e.prototype;
            return !t.dismissPopupContent && (t.dismissPopupContent = eH, eI && (0, x.addEvent)(eI, "keydown", ez)), e;
        };
        let eq = eL;
        var eU = b(632), eG = b.n(eU);
        let { doc: eK } = y(), { getChartTitle: eV } = H, { stripHTMLTagsFromString: eW, addClass: eX, removeClass: eY } = C;
        function ej(e) {
            let t = e.legend && e.legend.allItems, i = e.options.legend.accessibility || {}, r = e.colorAxis && e.colorAxis.some((e)=>!e.dataClasses || !e.dataClasses.length);
            return !!(t && t.length && !r && !1 !== i.enabled);
        }
        function eZ(e, t) {
            let i = t.legendItem || {};
            for (let r of (t.setState(e ? "hover" : "", !0), [
                "group",
                "label",
                "symbol"
            ])){
                let t = i[r], s = t && t.element || t;
                s && (0, x.fireEvent)(s, e ? "mouseover" : "mouseout");
            }
        }
        class e_ extends W {
            constructor(){
                super(...arguments), this.highlightedLegendItemIx = 0 / 0, this.proxyGroup = null;
            }
            init() {
                let e = this;
                this.recreateProxies(), this.addEvent(eG(), "afterScroll", function() {
                    this.chart === e.chart && (e.proxyProvider.updateGroupProxyElementPositions("legend"), e.updateLegendItemProxyVisibility(), e.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(e.highlightedLegendItemIx));
                }), this.addEvent(eG(), "afterPositionItem", function(t) {
                    this.chart === e.chart && this.chart.renderer && e.updateProxyPositionForItem(t.item);
                }), this.addEvent(eG(), "afterRender", function() {
                    this.chart === e.chart && this.chart.renderer && e.recreateProxies() && (0, x.syncTimeout)(()=>e.proxyProvider.updateGroupProxyElementPositions("legend"), (0, x.animObject)(this.chart.renderer.globalAnimation ?? !0).duration);
                });
            }
            updateLegendItemProxyVisibility() {
                let e, t = this.chart, i = t.legend, r = i.allItems || [], s = i.currentPage || 1, n = i.clipHeight || 0;
                r.forEach((r)=>{
                    if (r.a11yProxyElement) {
                        let o = i.pages && i.pages.length, a = r.a11yProxyElement.element, l = !1;
                        if (e = r.legendItem || {}, o) {
                            let t = e.pageIx || 0;
                            l = (e.y || 0) + (e.label ? Math.round(e.label.getBBox().height) : 0) - i.pages[t] > n || t !== s - 1;
                        }
                        l ? t.styledMode ? eX(a, "highcharts-a11y-invisible") : a.style.visibility = "hidden" : (eY(a, "highcharts-a11y-invisible"), a.style.visibility = "");
                    }
                });
            }
            onChartRender() {
                ej(this.chart) || this.removeProxies();
            }
            highlightAdjacentLegendPage(e) {
                let t = this.chart, i = t.legend, r = (i.currentPage || 1) + e, s = i.pages || [];
                if (r > 0 && r <= s.length) {
                    let e = 0;
                    for (let s of i.allItems)((s.legendItem || {}).pageIx || 0) + 1 === r && t.highlightLegendItem(e) && (this.highlightedLegendItemIx = e), ++e;
                }
            }
            updateProxyPositionForItem(e) {
                e.a11yProxyElement && e.a11yProxyElement.refreshPosition();
            }
            recreateProxies() {
                let e = eK.activeElement, t = this.proxyGroup, i = e && t && t.contains(e);
                return this.removeProxies(), !!ej(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), i && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
            }
            removeProxies() {
                this.proxyProvider.removeGroup("legend");
            }
            updateLegendTitle() {
                let e = this.chart, t = eW((e.legend && e.legend.options.title && e.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), e.renderer.forExport), i = e.langFormat("accessibility.legend.legendLabel" + (t ? "" : "NoTitle"), {
                    chart: e,
                    legendTitle: t,
                    chartTitle: eV(e)
                });
                this.proxyProvider.updateGroupAttrs("legend", {
                    "aria-label": i
                });
            }
            addLegendProxyGroup() {
                let e = "all" === this.chart.options.accessibility.landmarkVerbosity ? "region" : null;
                this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", {
                    "aria-label": "_placeholder_",
                    role: e
                });
            }
            proxyLegendItems() {
                let e, t = this;
                ((this.chart.legend || {}).allItems || []).forEach((i)=>{
                    (e = i.legendItem || {}).label && e.label.element && t.proxyLegendItem(i);
                });
            }
            proxyLegendItem(e) {
                let t = e.legendItem || {}, i = e.legendItem?.label, r = i?.element, s = t.label?.styles?.textOverflow === "ellipsis";
                if (!t.label || !t.group) return;
                let n = this.chart.langFormat("accessibility.legend.legendItem", {
                    chart: this.chart,
                    itemName: eW(e.name, this.chart.renderer.forExport),
                    item: e
                }), o = {
                    tabindex: -1,
                    "aria-pressed": e.visible,
                    "aria-label": n,
                    title: ""
                };
                s && -1 !== (r.textContent || "").indexOf("\u2026") && (o.title = i?.textStr);
                let a = t.group.div ? t.label : t.group;
                e.a11yProxyElement = this.proxyProvider.addProxyElement("legend", {
                    click: t.label,
                    visual: a.element
                }, "button", o);
            }
            getKeyboardNavigation() {
                let e = this.keyCodes, t = this, i = this.chart;
                return new X(i, {
                    keyCodeMap: [
                        [
                            [
                                e.left,
                                e.right,
                                e.up,
                                e.down
                            ],
                            function(e) {
                                return t.onKbdArrowKey(this, e);
                            }
                        ],
                        [
                            [
                                e.enter,
                                e.space
                            ],
                            function() {
                                return t.onKbdClick(this);
                            }
                        ],
                        [
                            [
                                e.pageDown,
                                e.pageUp
                            ],
                            function(i) {
                                let r = i === e.pageDown ? 1 : -1;
                                return t.highlightAdjacentLegendPage(r), this.response.success;
                            }
                        ]
                    ],
                    validate: function() {
                        return t.shouldHaveLegendNavigation();
                    },
                    init: function() {
                        i.highlightLegendItem(0), t.highlightedLegendItemIx = 0;
                    },
                    terminate: function() {
                        t.highlightedLegendItemIx = -1, i.legend.allItems.forEach((e)=>eZ(!1, e));
                    }
                });
            }
            onKbdArrowKey(e, t) {
                let { keyCodes: { left: i, up: r }, highlightedLegendItemIx: s, chart: n } = this, o = n.legend.allItems.length, a = n.options.accessibility.keyboardNavigation.wrapAround, l = t === i || t === r ? -1 : 1;
                return n.highlightLegendItem(s + l) ? this.highlightedLegendItemIx += l : a && o > 1 && (this.highlightedLegendItemIx = l > 0 ? 0 : o - 1, n.highlightLegendItem(this.highlightedLegendItemIx)), e.response.success;
            }
            onKbdClick(e) {
                let t = this.chart.legend.allItems[this.highlightedLegendItemIx];
                return t && t.a11yProxyElement && t.a11yProxyElement.click(), e.response.success;
            }
            shouldHaveLegendNavigation() {
                if (!ej(this.chart)) return !1;
                let e = this.chart, t = (e.options.legend || {}).accessibility || {};
                return !!(e.legend.display && t.keyboardNavigation && t.keyboardNavigation.enabled);
            }
            destroy() {
                this.removeProxies();
            }
        }
        function e$(e) {
            let t = this.legend.allItems, i = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, r = t[e], s = r?.legendItem || {};
            if (r) {
                var n;
                let o, a;
                (0, x.isNumber)(i) && t[i] && eZ(!1, t[i]), n = this.legend, o = (n.allItems[e].legendItem || {}).pageIx, a = n.currentPage, void 0 !== o && o + 1 !== a && n.scroll(1 + o - a);
                let l = s.label, h = r.a11yProxyElement && r.a11yProxyElement.innerElement;
                return l && l.element && h && this.setFocusToElement(l, h), eZ(!0, r), !0;
            }
            return !1;
        }
        function eQ(e) {
            let t = this.chart.options.accessibility, i = e.item;
            t.enabled && i && i.a11yProxyElement && i.a11yProxyElement.innerElement.setAttribute("aria-pressed", e.visible ? "true" : "false");
        }
        (e_ || (e_ = {})).compose = function(e, t) {
            let i = e.prototype;
            i.highlightLegendItem || (i.highlightLegendItem = e$, (0, x.addEvent)(t, "afterColorizeItem", eQ));
        };
        let eJ = e_;
        var e0 = b(532), e1 = b.n(e0);
        let { isTouchDevice: e2 } = y(), e3 = [];
        function e5() {
            this.navigator && this.navigator.setBaseSeries(void 0, !1);
        }
        function e4() {
            let e, t, i, r = this.legend, s = this.navigator;
            if (s) {
                e = r && r.options, t = s.xAxis, i = s.yAxis;
                let { scrollbarHeight: n, scrollButtonSize: o } = s;
                this.inverted ? (s.left = s.opposite ? this.chartWidth - n - s.height : this.spacing[3] + n, s.top = this.plotTop + o) : (s.left = t.left ?? this.plotLeft + o, s.top = s.navigatorOptions.top || this.chartHeight - s.height - n - (this.scrollbar?.options.margin || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (e && "bottom" === e.verticalAlign && "proximate" !== e.layout && e.enabled && !e.floating ? r.legendHeight + (e.margin ?? 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), t && i && (this.inverted ? t.options.left = i.options.left = s.left : t.options.top = i.options.top = s.top, t.setAxisSize(), i.setAxisSize());
            }
        }
        function e6(e) {
            !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new h(this), (e.redraw ?? !0) && this.redraw(e.animation));
        }
        function e8() {
            let e = this.options;
            (e.navigator.enabled || e.scrollbar.enabled) && (this.scroller = this.navigator = new h(this));
        }
        function e9() {
            let e = this.options, t = e.navigator, i = e.rangeSelector;
            if ((t && t.enabled || i && i.enabled) && (!e2 && "x" === this.zooming.type || e2 && "x" === this.zooming.pinchType)) return !1;
        }
        function e7(e) {
            let t = e.navigator;
            if (t && e.xAxis[0]) {
                let i = e.xAxis[0].getExtremes();
                t.render(i.min, i.max);
            }
        }
        function te(e) {
            let t = e.options.navigator || {}, i = e.options.scrollbar || {};
            !this.navigator && !this.scroller && (t.enabled || i.enabled) && ((0, x.merge)(!0, this.options.navigator, t), (0, x.merge)(!0, this.options.scrollbar, i), delete e.options.navigator, delete e.options.scrollbar);
        }
        let tt = function(e, t) {
            if ((0, x.pushUnique)(e3, e)) {
                let i = e.prototype;
                h = t, i.callbacks.push(e7), (0, x.addEvent)(e, "afterAddSeries", e5), (0, x.addEvent)(e, "afterDrillUp", e5), (0, x.addEvent)(e, "afterSetChartSize", e4), (0, x.addEvent)(e, "afterUpdate", e6), (0, x.addEvent)(e, "beforeRender", e8), (0, x.addEvent)(e, "beforeShowResetZoom", e9), (0, x.addEvent)(e, "update", te);
            }
        }, { composed: ti, isTouchDevice: tr } = y();
        function ts() {
            this.navigatorAxis || (this.navigatorAxis = new to(this));
        }
        function tn(e) {
            let t, i = this.chart, r = i.options, s = r.navigator, n = this.navigatorAxis, o = i.zooming.pinchType, a = r.rangeSelector, l = i.zooming.type;
            if (this.isXAxis && (s?.enabled || a?.enabled)) {
                if ("y" === l && "zoom" === e.trigger) t = !1;
                else if (("zoom" === e.trigger && "xy" === l || tr && "xy" === o) && this.options.range) {
                    let t = n.previousZoom;
                    (0, x.defined)(e.min) ? n.previousZoom = [
                        this.min,
                        this.max
                    ] : t && (e.min = t[0], e.max = t[1], n.previousZoom = void 0);
                }
            }
            void 0 !== t && e.preventDefault();
        }
        class to {
            static compose(e) {
                (0, x.pushUnique)(ti, "Axis.Navigator") && ((0, x.addEvent)(e, "init", ts), (0, x.addEvent)(e, "setExtremes", tn));
            }
            constructor(e){
                this.axis = e;
            }
            destroy() {
                this.axis = void 0;
            }
            toFixedRange(e, t, i, r) {
                let s = this.axis, n = (s.pointRange || 0) / 2, o = i ?? s.translate(e, !0, !s.horiz), a = r ?? s.translate(t, !0, !s.horiz);
                return (0, x.defined)(i) || (o = (0, x.correctFloat)(o + n)), (0, x.defined)(r) || (a = (0, x.correctFloat)(a - n)), (0, x.isNumber)(o) && (0, x.isNumber)(a) || (o = a = void 0), {
                    min: o,
                    max: a
                };
            }
        }
        var ta = b(512), tl = b.n(ta);
        let { seriesTypes: th } = tl(), td = {
            height: 40,
            margin: 22,
            maskInside: !0,
            handles: {
                width: 7,
                borderRadius: 0,
                height: 15,
                symbols: [
                    "navigator-handle",
                    "navigator-handle"
                ],
                enabled: !0,
                lineWidth: 1,
                backgroundColor: "var(--highcharts-neutral-color-5)",
                borderColor: "var(--highcharts-neutral-color-40)"
            },
            maskFill: "color-mix(in srgb, var(--highcharts-highlight-color-60) 30%, transparent)",
            outlineColor: "var(--highcharts-neutral-color-40)",
            outlineWidth: 1,
            series: {
                type: void 0 === th.areaspline ? "line" : "areaspline",
                fillOpacity: .05,
                lineWidth: 1,
                compare: null,
                sonification: {
                    enabled: !1
                },
                dataGrouping: {
                    approximation: "average",
                    enabled: !0,
                    groupPixelWidth: 2,
                    firstAnchor: "firstPoint",
                    anchor: "middle",
                    lastAnchor: "lastPoint",
                    units: [
                        [
                            "millisecond",
                            [
                                1,
                                2,
                                5,
                                10,
                                20,
                                25,
                                50,
                                100,
                                200,
                                500
                            ]
                        ],
                        [
                            "second",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "minute",
                            [
                                1,
                                2,
                                5,
                                10,
                                15,
                                30
                            ]
                        ],
                        [
                            "hour",
                            [
                                1,
                                2,
                                3,
                                4,
                                6,
                                8,
                                12
                            ]
                        ],
                        [
                            "day",
                            [
                                1,
                                2,
                                3,
                                4
                            ]
                        ],
                        [
                            "week",
                            [
                                1,
                                2,
                                3
                            ]
                        ],
                        [
                            "month",
                            [
                                1,
                                3,
                                6
                            ]
                        ],
                        [
                            "year",
                            null
                        ]
                    ]
                },
                dataLabels: {
                    enabled: !1,
                    zIndex: 2
                },
                id: "highcharts-navigator-series",
                className: "highcharts-navigator-series",
                lineColor: null,
                marker: {
                    enabled: !1
                },
                threshold: null
            },
            xAxis: {
                className: "highcharts-navigator-xaxis",
                tickLength: 0,
                lineWidth: 0,
                gridLineColor: "var(--highcharts-neutral-color-10)",
                id: "navigator-x-axis",
                gridLineWidth: 1,
                tickPixelInterval: 200,
                labels: {
                    align: "left",
                    style: {
                        color: "var(--highcharts-neutral-color-100)",
                        fontSize: "0.7em",
                        opacity: .6,
                        textOutline: "2px contrast"
                    },
                    x: 3,
                    y: -4
                },
                crosshair: !1
            },
            yAxis: {
                className: "highcharts-navigator-yaxis",
                gridLineWidth: 0,
                startOnTick: !1,
                endOnTick: !1,
                minPadding: .1,
                id: "navigator-y-axis",
                maxPadding: .1,
                labels: {
                    enabled: !1
                },
                crosshair: !1,
                title: {
                    text: void 0
                },
                tickLength: 0,
                tickWidth: 0
            }
        }, { defaultOptions: tc } = y(), { noop: tu } = y(), tp = {
            radius: 0,
            scope: "stack",
            where: void 0
        }, tg = {
            "navigator-handle": function(e, t, i, r, s = {}) {
                var n, o, a, l, h;
                let d = s.width ? s.width / 2 : i, c = (0, x.relativeLength)((n = s.borderRadius, !(0, x.isObject)(n) && (n = {
                    radius: n || 0
                }), (0, x.merge)(tp, void 0, n)).radius, Math.min(2 * d, r));
                return [
                    [
                        "M",
                        -1.5,
                        (r = s.height || r) / 2 - 3.5
                    ],
                    [
                        "L",
                        -1.5,
                        r / 2 + 4.5
                    ],
                    [
                        "M",
                        .5,
                        r / 2 - 3.5
                    ],
                    [
                        "L",
                        .5,
                        r / 2 + 4.5
                    ],
                    ...(o = -d - 1, a = 2 * d + 1, l = r, h = {
                        r: c
                    }, h?.r ? function(e, t, i, r, s) {
                        let n = s?.r || 0;
                        return [
                            [
                                "M",
                                e + n,
                                t
                            ],
                            [
                                "L",
                                e + i - n,
                                t
                            ],
                            [
                                "A",
                                n,
                                n,
                                0,
                                0,
                                1,
                                e + i,
                                t + n
                            ],
                            [
                                "L",
                                e + i,
                                t + r - n
                            ],
                            [
                                "A",
                                n,
                                n,
                                0,
                                0,
                                1,
                                e + i - n,
                                t + r
                            ],
                            [
                                "L",
                                e + n,
                                t + r
                            ],
                            [
                                "A",
                                n,
                                n,
                                0,
                                0,
                                1,
                                e,
                                t + r - n
                            ],
                            [
                                "L",
                                e,
                                t + n
                            ],
                            [
                                "A",
                                n,
                                n,
                                0,
                                0,
                                1,
                                e + n,
                                t
                            ],
                            [
                                "Z"
                            ]
                        ];
                    }(o, .5, a, l, h) : [
                        [
                            "M",
                            o,
                            .5
                        ],
                        [
                            "L",
                            o + a,
                            .5
                        ],
                        [
                            "L",
                            o + a,
                            .5 + l
                        ],
                        [
                            "L",
                            o,
                            .5 + l
                        ],
                        [
                            "Z"
                        ]
                    ])
                ];
            }
        };
        var tm = b(540), tb = b.n(tm);
        let { defaultOptions: tf } = y(), { composed: tx } = y(), { setFixedRange: ty } = {
            setFixedRange: function(e) {
                let t = this.xAxis[0];
                (0, x.defined)(t.dataMax) && (0, x.defined)(t.dataMin) && e ? this.fixedRange = Math.min(e, t.dataMax - t.dataMin) : this.fixedRange = e;
            }
        };
        function tv() {
            this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
        }
        let tE = function(e, t, i) {
            to.compose(t), (0, x.pushUnique)(tx, "Navigator") && (e.prototype.setFixedRange = ty, (0, x.extend)(tb().prototype.symbols, tg), (0, x.extend)(tf, {
                navigator: td
            }), (0, x.addEvent)(i, "afterUpdate", tv));
        }, { composed: tw } = y();
        !function(e) {
            let t;
            function i(e) {
                let t = e.options?.min ?? e.min, i = e.options?.max ?? e.max;
                return {
                    axisMin: t,
                    axisMax: i,
                    scrollMin: (0, x.defined)(e.dataMin) ? Math.min(t, e.min ?? 1 / 0, e.dataMin, e.threshold ?? 1 / 0) : t,
                    scrollMax: e.treeGrid?.adjustedMax ?? ((0, x.defined)(e.dataMax) ? Math.max(i, e.max ?? -1 / 0, e.dataMax, e.threshold ?? -1 / 0) : i)
                };
            }
            function r() {
                let e = this.scrollbar, t = e && !e.options.opposite, i = this.horiz ? 2 : t ? 3 : 1;
                e && (this.chart.scrollbarsOffsets = [
                    0,
                    0
                ], this.chart.axisOffset[i] += e.size + (e.options.margin || 0));
            }
            function s() {
                let e = this;
                e.options?.scrollbar?.enabled ? (e.options.scrollbar.vertical = !e.horiz, e.options.startOnTick = e.options.endOnTick = !1, e.scrollbar = new t(e.chart.renderer, e.options.scrollbar, e.chart), (0, x.addEvent)(e.scrollbar, "changed", function(t) {
                    let r, s, { axisMin: n, axisMax: o, scrollMin: a, scrollMax: l } = i(e), h = e.toPixels(a), d = e.toPixels(l) - h;
                    if ((0, x.defined)(n) && (0, x.defined)(o)) {
                        if (e.horiz && !e.reversed || !e.horiz && e.reversed ? (r = Math.min(l, e.toValue(h + d * this.to)), s = Math.max(a, e.toValue(h + d * this.from))) : (r = Math.min(l, e.toValue(h + d * (1 - this.from))), s = Math.max(a, e.toValue(h + d * (1 - this.to)))), this.shouldUpdateExtremes(t.DOMType)) {
                            let i = "mousemove" !== t.DOMType && "touchmove" !== t.DOMType && void 0;
                            e.setExtremes((0, x.correctFloat)(s), (0, x.correctFloat)(r), !0, i, t);
                        } else this.setRange(this.from, this.to);
                    }
                })) : e.scrollbar && (e.scrollbar = e.scrollbar.destroy());
            }
            function n() {
                let e, t, r, { scrollMin: s, scrollMax: n } = i(this), o = this.scrollbar, a = (this.axisTitleMargin || 0) + (this.titleOffset || 0), l = this.chart.scrollbarsOffsets, h = this.options.margin || 0;
                if (o && l) {
                    if (this.horiz) this.opposite || (l[1] += a), o.position(this.left, this.top + this.height + 2 + l[1] - (this.opposite ? h : 0), this.width, this.height), this.opposite || (l[1] += h), e = 1;
                    else {
                        let t;
                        this.opposite && (l[0] += a), t = o.options.opposite ? this.left + this.width + 2 + l[0] - (this.opposite ? 0 : h) : this.opposite ? 0 : h, o.position(t, this.top, this.width, this.height), this.opposite && (l[0] += h), e = 0;
                    }
                    if (l[e] += o.size + (o.options.margin || 0), isNaN(s) || isNaN(n) || !(0, x.defined)(this.min) || !(0, x.defined)(this.max) || (0, x.defined)(this.dataMin) && this.dataMin === this.dataMax) o.setRange(0, 1);
                    else if (this.min === this.max) {
                        let e = this.pointRange / (this.dataMax + 1);
                        t = e * this.min, r = e * (this.max + 1), o.setRange(t, r);
                    } else t = (this.toPixels(this.min) - this.toPixels(s)) / (this.toPixels(n) - this.toPixels(s)), r = (this.toPixels(this.max) - this.toPixels(s)) / (this.toPixels(n) - this.toPixels(s)), this.horiz && !this.reversed || !this.horiz && this.reversed ? o.setRange(t, r) : o.setRange(1 - r, 1 - t);
                }
            }
            e.compose = function(e, i) {
                (0, x.pushUnique)(tw, "Axis.Scrollbar") && (t = i, (0, x.addEvent)(e, "afterGetOffset", r), (0, x.addEvent)(e, "afterInit", s), (0, x.addEvent)(e, "afterRender", n));
            };
        }(u || (u = {}));
        let tA = u, tT = {
            height: 10,
            barBorderRadius: 5,
            buttonBorderRadius: 0,
            buttonsEnabled: !1,
            liveRedraw: void 0,
            margin: void 0,
            minWidth: 6,
            opposite: !0,
            step: .2,
            zIndex: 3,
            barBackgroundColor: "var(--highcharts-neutral-color-20)",
            barBorderWidth: 0,
            barBorderColor: "var(--highcharts-neutral-color-20)",
            buttonArrowColor: "var(--highcharts-neutral-color-80)",
            buttonBackgroundColor: "var(--highcharts-neutral-color-10)",
            buttonBorderColor: "var(--highcharts-neutral-color-20)",
            buttonBorderWidth: 1,
            rifleColor: "none",
            trackBackgroundColor: "rgba(255, 255, 255, 0.001)",
            trackBorderColor: "var(--highcharts-neutral-color-20)",
            trackBorderRadius: 5,
            trackBorderWidth: 1
        }, { defaultOptions: tM } = y(), { composed: tC } = y();
        class tS {
            static compose(e) {
                tA.compose(e, tS), (0, x.pushUnique)(tC, "Scrollbar") && (0, x.extend)(tM, {
                    scrollbar: tT
                });
            }
            static swapXY(e, t) {
                return t && e.forEach((e)=>{
                    let t, i = e.length;
                    for(let r = 0; r < i; r += 2)"number" == typeof (t = e[r + 1]) && (e[r + 1] = e[r + 2], e[r + 2] = t);
                }), e;
            }
            constructor(e, t, i){
                this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(e, t, i);
            }
            addEvents() {
                let e = this.options.inverted ? [
                    1,
                    0
                ] : [
                    0,
                    1
                ], t = this.scrollbarButtons, i = this.scrollbarGroup.element, r = this.track.element, s = this.mouseDownHandler.bind(this), n = this.mouseMoveHandler.bind(this), o = this.mouseUpHandler.bind(this), a = [
                    [
                        t[e[0]].element,
                        "click",
                        this.buttonToMinClick.bind(this)
                    ],
                    [
                        t[e[1]].element,
                        "click",
                        this.buttonToMaxClick.bind(this)
                    ],
                    [
                        r,
                        "click",
                        this.trackClick.bind(this)
                    ],
                    [
                        i,
                        "mousedown",
                        s
                    ],
                    [
                        i.ownerDocument,
                        "mousemove",
                        n
                    ],
                    [
                        i.ownerDocument,
                        "mouseup",
                        o
                    ],
                    [
                        i,
                        "touchstart",
                        s
                    ],
                    [
                        i.ownerDocument,
                        "touchmove",
                        n
                    ],
                    [
                        i.ownerDocument,
                        "touchend",
                        o
                    ]
                ];
                a.forEach(function(e) {
                    x.addEvent.apply(null, e);
                }), this._events = a;
            }
            buttonToMaxClick(e) {
                let t = (this.to - this.from) * (this.options.step ?? .2);
                this.updatePosition(this.from + t, this.to + t), (0, x.fireEvent)(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: e
                });
            }
            buttonToMinClick(e) {
                let t = (0, x.correctFloat)(this.to - this.from) * (this.options.step ?? .2);
                this.updatePosition((0, x.correctFloat)(this.from - t), (0, x.correctFloat)(this.to - t)), (0, x.fireEvent)(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: e
                });
            }
            cursorToScrollbarPosition(e) {
                let t = this.options, i = t.minWidth > this.calculatedWidth ? t.minWidth : 0;
                return {
                    chartX: (e.chartX - this.x - this.xOffset) / (this.barWidth - i),
                    chartY: (e.chartY - this.y - this.yOffset) / (this.barWidth - i)
                };
            }
            destroy() {
                let e = this, t = e.chart.scroller;
                e.removeEvents(), [
                    "track",
                    "scrollbarRifles",
                    "scrollbar",
                    "scrollbarGroup",
                    "group"
                ].forEach(function(t) {
                    e[t] && e[t].destroy && (e[t] = e[t].destroy());
                }), t && e === t.scrollbar && (t.scrollbar = null, (0, x.destroyObjectProperties)(t.scrollbarButtons));
            }
            drawScrollbarButton(e) {
                let t = this.renderer, i = this.scrollbarButtons, r = this.options, s = this.size, n = t.g().add(this.group);
                if (i.push(n), r.buttonsEnabled) {
                    let o = t.rect().addClass("highcharts-scrollbar-button").add(n);
                    this.chart.styledMode || o.attr({
                        stroke: r.buttonBorderColor,
                        "stroke-width": r.buttonBorderWidth,
                        fill: r.buttonBackgroundColor
                    }), o.attr(o.crisp({
                        x: -0.5,
                        y: -0.5,
                        width: s,
                        height: s,
                        r: r.buttonBorderRadius
                    }, o.strokeWidth()));
                    let a = t.path(tS.swapXY([
                        [
                            "M",
                            s / 2 + (e ? -1 : 1),
                            s / 2 - 3
                        ],
                        [
                            "L",
                            s / 2 + (e ? -1 : 1),
                            s / 2 + 3
                        ],
                        [
                            "L",
                            s / 2 + (e ? 2 : -2),
                            s / 2
                        ]
                    ], r.vertical)).addClass("highcharts-scrollbar-arrow").add(i[e]);
                    this.chart.styledMode || a.attr({
                        fill: r.buttonArrowColor
                    });
                }
            }
            init(e, t, i) {
                this.scrollbarButtons = [], this.renderer = e, this.userOptions = t, this.options = (0, x.merge)(tT, tM.scrollbar, t), this.options.margin = this.options.margin ?? 10, this.chart = i, this.size = this.options.size ?? this.options.height, t.enabled && (this.render(), this.addEvents());
            }
            mouseDownHandler(e) {
                let t = this.chart.pointer?.normalize(e) || e, i = this.cursorToScrollbarPosition(t);
                this.chartX = i.chartX, this.chartY = i.chartY, this.initPositions = [
                    this.from,
                    this.to
                ], this.grabbedCenter = !0;
            }
            mouseMoveHandler(e) {
                let t, i = this.chart.pointer?.normalize(e) || e, r = this.options.vertical ? "chartY" : "chartX", s = this.initPositions || [];
                this.grabbedCenter && (!e.touches || 0 !== e.touches[0][r]) && (t = this.cursorToScrollbarPosition(i)[r] - this[r], this.hasDragged = !0, this.updatePosition(s[0] + t, s[1] + t), this.hasDragged && (0, x.fireEvent)(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMType: e.type,
                    DOMEvent: e
                }));
            }
            mouseUpHandler(e) {
                this.hasDragged && (0, x.fireEvent)(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMType: e.type,
                    DOMEvent: e
                }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
            }
            position(e, t, i, r) {
                let { buttonsEnabled: s, margin: n = 0, vertical: o } = this.options, a = this.rendered ? "animate" : "attr", l = r, h = 0;
                this.group.show(), this.x = e, this.y = t + this.trackBorderWidth, this.width = i, this.height = r, this.xOffset = l, this.yOffset = h, o ? (this.width = this.yOffset = i = h = this.size, this.xOffset = l = 0, this.yOffset = h = s ? this.size : 0, this.barWidth = r - (s ? 2 * i : 0), this.x = e += n) : (this.height = r = this.size, this.xOffset = l = s ? this.size : 0, this.barWidth = i - (s ? 2 * r : 0), this.y = this.y + n), this.group[a]({
                    translateX: e,
                    translateY: this.y
                }), this.track[a]({
                    width: i,
                    height: r
                }), this.scrollbarButtons[1][a]({
                    translateX: o ? 0 : i - l,
                    translateY: o ? r - h : 0
                });
            }
            removeEvents() {
                this._events.forEach(function(e) {
                    x.removeEvent.apply(null, e);
                }), this._events.length = 0;
            }
            render() {
                let e = this.renderer, t = this.options, i = this.size, r = this.chart.styledMode, s = e.g("scrollbar").attr({
                    zIndex: t.zIndex
                }).hide().add();
                this.group = s, this.track = e.rect().addClass("highcharts-scrollbar-track").attr({
                    r: t.trackBorderRadius || 0,
                    height: i,
                    width: i
                }).add(s), r || this.track.attr({
                    fill: t.trackBackgroundColor,
                    stroke: t.trackBorderColor,
                    "stroke-width": t.trackBorderWidth
                });
                let n = this.trackBorderWidth = this.track.strokeWidth();
                this.track.attr({
                    x: -(0, x.crisp)(0, n),
                    y: -(0, x.crisp)(0, n)
                }), this.scrollbarGroup = e.g().add(s), this.scrollbar = e.rect().addClass("highcharts-scrollbar-thumb").attr({
                    height: i - n,
                    width: i - n,
                    r: t.barBorderRadius || 0
                }).add(this.scrollbarGroup), this.scrollbarRifles = e.path(tS.swapXY([
                    [
                        "M",
                        -3,
                        i / 4
                    ],
                    [
                        "L",
                        -3,
                        2 * i / 3
                    ],
                    [
                        "M",
                        0,
                        i / 4
                    ],
                    [
                        "L",
                        0,
                        2 * i / 3
                    ],
                    [
                        "M",
                        3,
                        i / 4
                    ],
                    [
                        "L",
                        3,
                        2 * i / 3
                    ]
                ], t.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), r || (this.scrollbar.attr({
                    fill: t.barBackgroundColor,
                    stroke: t.barBorderColor,
                    "stroke-width": t.barBorderWidth
                }), this.scrollbarRifles.attr({
                    stroke: t.rifleColor,
                    "stroke-width": 1
                })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-(0, x.crisp)(0, this.scrollbarStrokeWidth), -(0, x.crisp)(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
            }
            setRange(e, t) {
                let i, r, s = this.options, n = s.vertical, o = s.minWidth, a = this.barWidth, l = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
                if (!(0, x.defined)(a)) return;
                let h = a * Math.min(t, 1);
                i = Math.ceil(a * (e = Math.max(e, 0))), this.calculatedWidth = r = (0, x.correctFloat)(h - i), r < o && (i = (a - o + r) * e, r = o);
                let d = Math.floor(i + this.xOffset + this.yOffset), c = r / 2 - .5;
                this.from = e, this.to = t, n ? (this.scrollbarGroup[l]({
                    translateY: d
                }), this.scrollbar[l]({
                    height: r
                }), this.scrollbarRifles[l]({
                    translateY: c
                }), this.scrollbarTop = d, this.scrollbarLeft = 0) : (this.scrollbarGroup[l]({
                    translateX: d
                }), this.scrollbar[l]({
                    width: r
                }), this.scrollbarRifles[l]({
                    translateX: c
                }), this.scrollbarLeft = d, this.scrollbarTop = 0), r <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), !1 === s.showFull && (e <= 0 && t >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
            }
            shouldUpdateExtremes(e) {
                return (this.options.liveRedraw ?? (y().svg && !y().isTouchDevice && !this.chart.boosted)) || "mouseup" === e || "touchend" === e || !(0, x.defined)(e);
            }
            trackClick(e) {
                let t = this.chart.pointer?.normalize(e) || e, i = this.to - this.from, r = this.y + this.scrollbarTop, s = this.x + this.scrollbarLeft;
                this.options.vertical && t.chartY > r || !this.options.vertical && t.chartX > s ? this.updatePosition(this.from + i, this.to + i) : this.updatePosition(this.from - i, this.to - i), (0, x.fireEvent)(this, "changed", {
                    from: this.from,
                    to: this.to,
                    trigger: "scrollbar",
                    DOMEvent: e
                });
            }
            update(e) {
                this.destroy(), this.init(this.chart.renderer, (0, x.merge)(!0, this.options, e), this.chart);
            }
            updatePosition(e, t) {
                t > 1 && (e = (0, x.correctFloat)(1 - (0, x.correctFloat)(t - e)), t = 1), e < 0 && (t = (0, x.correctFloat)(t - e), e = 0), this.from = e, this.to = t;
            }
        }
        tS.defaultOptions = tT;
        let { defaultOptions: tk } = y(), { isTouchDevice: tP } = y();
        function tD(e, ...t) {
            let i = [].filter.call(t, x.isNumber);
            if (i.length) return Math[e].apply(0, i);
        }
        let tN = class e {
            static compose(t, i, r) {
                tt(t, e), tE(t, i, r);
            }
            constructor(e){
                this.isDirty = !1, this.scrollbarHeight = 0, this.init(e);
            }
            drawHandle(e, t, i, r) {
                let s = this.navigatorOptions.handles.height;
                this.handles[t][r](i ? {
                    translateX: Math.round(this.left + this.height / 2),
                    translateY: Math.round(this.top + parseInt(e, 10) + .5 - s)
                } : {
                    translateX: Math.round(this.left + parseInt(e, 10)),
                    translateY: Math.round(this.top + this.height / 2 - s / 2 - 1)
                });
            }
            drawOutline(e, t, i, r) {
                let s = this.navigatorOptions.maskInside, n = this.outline.strokeWidth(), o = n / 2, a = n % 2 / 2, l = this.scrollButtonSize, h = this.size, d = this.top, c = this.height, u = d - o, p = d + c, g = this.left, m, b;
                i ? (m = d + t + a, t = d + e + a, b = [
                    [
                        "M",
                        g + c,
                        d - l - a
                    ],
                    [
                        "L",
                        g + c,
                        m
                    ],
                    [
                        "L",
                        g,
                        m
                    ],
                    [
                        "M",
                        g,
                        t
                    ],
                    [
                        "L",
                        g + c,
                        t
                    ],
                    [
                        "L",
                        g + c,
                        d + h + l
                    ]
                ], s && b.push([
                    "M",
                    g + c,
                    m - o
                ], [
                    "L",
                    g + c,
                    t + o
                ])) : (g -= l, e += g + l - a, t += g + l - a, b = [
                    [
                        "M",
                        g,
                        u
                    ],
                    [
                        "L",
                        e,
                        u
                    ],
                    [
                        "L",
                        e,
                        p
                    ],
                    [
                        "M",
                        t,
                        p
                    ],
                    [
                        "L",
                        t,
                        u
                    ],
                    [
                        "L",
                        g + h + 2 * l,
                        u
                    ]
                ], s && b.push([
                    "M",
                    e - o,
                    u
                ], [
                    "L",
                    t + o,
                    u
                ])), this.outline[r]({
                    d: b
                });
            }
            drawMasks(e, t, i, r) {
                let s, n, o, a, l = this.left, h = this.top, d = this.height;
                i ? (o = [
                    l,
                    l,
                    l
                ], a = [
                    h,
                    h + e,
                    h + t
                ], n = [
                    d,
                    d,
                    d
                ], s = [
                    e,
                    t - e,
                    this.size - t
                ]) : (o = [
                    l,
                    l + e,
                    l + t
                ], a = [
                    h,
                    h,
                    h
                ], n = [
                    e,
                    t - e,
                    this.size - t
                ], s = [
                    d,
                    d,
                    d
                ]), this.shades.forEach((e, t)=>{
                    e[r]({
                        x: o[t],
                        y: a[t],
                        width: n[t],
                        height: s[t]
                    });
                });
            }
            renderElements() {
                let e = this, t = e.navigatorOptions, i = t.maskInside, r = e.chart, s = r.inverted, n = r.renderer, o = {
                    cursor: s ? "ns-resize" : "ew-resize"
                }, a = e.navigatorGroup ?? (e.navigatorGroup = n.g("navigator").attr({
                    zIndex: 8,
                    visibility: "hidden"
                }).add());
                if ([
                    !i,
                    i,
                    !i
                ].forEach((i, s)=>{
                    let l = e.shades[s] ?? (e.shades[s] = n.rect().addClass("highcharts-navigator-mask" + (1 === s ? "-inside" : "-outside")).add(a));
                    r.styledMode || (l.attr({
                        fill: i ? t.maskFill : "rgba(0,0,0,0)"
                    }), 1 === s && l.css(o));
                }), e.outline || (e.outline = n.path().addClass("highcharts-navigator-outline").add(a)), r.styledMode || e.outline.attr({
                    "stroke-width": t.outlineWidth,
                    stroke: t.outlineColor
                }), t.handles?.enabled) {
                    let i = !1, s = t.handles, { height: l, width: h } = s;
                    [
                        0,
                        1
                    ].forEach((t)=>{
                        let d = s.symbols[t];
                        (i = i || e.handles[t]?.symbolName !== d) && (e.handles[t]?.destroy(), e.handles[t] = n.symbol(d, -h / 2 - 1, 0, h, l, s), e.handles[t].attr({
                            zIndex: 7 - t
                        }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + [
                            "left",
                            "right"
                        ][t]).add(a)), r.inverted && e.handles[t].attr({
                            rotation: 90,
                            rotationOriginX: Math.floor(-h / 2),
                            rotationOriginY: (l + h) / 2
                        }), r.styledMode || e.handles[t].attr({
                            fill: s.backgroundColor,
                            stroke: s.borderColor,
                            "stroke-width": s.lineWidth,
                            width: s.width,
                            height: s.height,
                            x: -h / 2 - 1,
                            y: 0
                        }).css(o);
                    }), i && (e.partsEventsToUnbind?.forEach((e)=>{
                        e();
                    }), e.partsEventsToUnbind = [
                        ...e.getPartsEvents("mousedown"),
                        ...e.getPartsEvents("touchstart")
                    ]);
                }
            }
            update(e, t = !1) {
                let i = this.chart, r = i.options.chart.inverted !== i.scrollbar?.options.vertical;
                if ((0, x.merge)(!0, i.options.navigator, e), this.navigatorOptions = i.options.navigator || {}, this.setOpposite(), (0, x.defined)(e.enabled) || r) return this.destroy(), this.navigatorEnabled = e.enabled || this.navigatorEnabled, this.init(i);
                if (this.navigatorEnabled && (this.isDirty = !0, !1 === e.adaptToUpdatedData && this.baseSeries.forEach((e)=>{
                    (0, x.removeEvent)(e, "updatedData", this.updatedDataHandler);
                }, this), e.adaptToUpdatedData && this.baseSeries.forEach((e)=>{
                    e.eventsToUnbind.push((0, x.addEvent)(e, "updatedData", this.updatedDataHandler));
                }, this), (e.series || e.baseSeries) && this.setBaseSeries(void 0, !1), e.height || e.xAxis || e.yAxis)) {
                    this.height = e.height ?? this.height;
                    let t = this.getXAxisOffsets();
                    this.xAxis.update({
                        ...e.xAxis,
                        offsets: t,
                        [i.inverted ? "width" : "height"]: this.height,
                        [i.inverted ? "height" : "width"]: void 0
                    }, !1), this.yAxis.update({
                        ...e.yAxis,
                        [i.inverted ? "width" : "height"]: this.height
                    }, !1);
                }
                t && i.redraw();
            }
            render(e, t, i, r) {
                let s = this.chart, n = this.xAxis, o = n.pointRange || 0, a = n.navigatorAxis.fake ? s.xAxis[0] : n, l = this.navigatorEnabled, h = this.rendered, d = s.inverted, c = s.xAxis[0].minRange, u = s.xAxis[0].options.maxRange, p = this.scrollButtonSize, g, m, b, f = this.scrollbarHeight, y, v;
                if (this.hasDragged && !(0, x.defined)(i)) return;
                if (this.isDirty && this.renderElements(), e = (0, x.correctFloat)(e - o / 2), t = (0, x.correctFloat)(t + o / 2), !(0, x.isNumber)(e) || !(0, x.isNumber)(t)) {
                    if (!h) return;
                    else i = 0, r = n.width ?? a.width;
                }
                this.left = n.left ?? s.plotLeft + p + (d ? s.plotWidth : 0);
                let E = this.size = y = n.len ?? (d ? s.plotHeight : s.plotWidth) - 2 * p;
                g = d ? f : y + 2 * p, i = i ?? n.toPixels(e, !0), r = r ?? n.toPixels(t, !0), (0, x.isNumber)(i) && 1 / 0 !== Math.abs(i) || (i = 0, r = g);
                let w = n.toValue(i, !0), A = n.toValue(r, !0), T = Math.abs((0, x.correctFloat)(A - w));
                (0, x.defined)(c) && T < c ? this.grabbedLeft ? i = n.toPixels(A - c - o, !0) : this.grabbedRight && (r = n.toPixels(w + c + o, !0)) : (0, x.defined)(u) && (0, x.correctFloat)(T - o) > u && (this.grabbedLeft ? i = n.toPixels(A - u - o, !0) : this.grabbedRight && (r = n.toPixels(w + u + o, !0))), this.zoomedMax = (0, x.clamp)(Math.max(i, r), 0, E), this.zoomedMin = (0, x.clamp)(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(i, r), 0, E), this.range = this.zoomedMax - this.zoomedMin, E = Math.round(this.zoomedMax);
                let M = Math.round(this.zoomedMin);
                l && (this.navigatorGroup.attr({
                    visibility: "inherit"
                }), v = h && !this.hasDragged ? "animate" : "attr", this.drawMasks(M, E, d, v), this.drawOutline(M, E, d, v), this.navigatorOptions.handles?.enabled && (this.drawHandle(M, 0, d, v), this.drawHandle(E, 1, d, v))), this.scrollbar && (d ? (b = this.top - p, m = this.left - f + (l || !a.opposite ? 0 : (a.titleOffset || 0) + a.axisTitleMargin), f = y + 2 * p) : (b = this.top + (l ? this.height : -f), m = this.left - p), this.scrollbar.position(m, b, g, f), this.scrollbar.setRange(this.zoomedMin / (y || 1), this.zoomedMax / (y || 1))), this.rendered = !0, this.isDirty = !1, (0, x.fireEvent)(this, "afterRender");
            }
            addMouseEvents() {
                let e, t, i = this, r = i.chart, s = r.container, n = [];
                i.mouseMoveHandler = e = function(e) {
                    i.onMouseMove(e);
                }, i.mouseUpHandler = t = function(e) {
                    i.onMouseUp(e);
                }, n.push((0, x.addEvent)(r.renderTo, "mousemove", e), (0, x.addEvent)(s.ownerDocument, "mouseup", t), (0, x.addEvent)(r.renderTo, "touchmove", e), (0, x.addEvent)(s.ownerDocument, "touchend", t)), i.eventsToUnbind = n, i.series && i.series[0] && n.push((0, x.addEvent)(i.series[0].xAxis, "foundExtremes", function() {
                    r.navigator?.modifyNavigatorAxisExtremes();
                }));
            }
            getPartsEvents(e) {
                let t = this, i = [];
                return [
                    "shades",
                    "handles"
                ].forEach((r)=>{
                    t[r].forEach(function(s, n) {
                        i.push((0, x.addEvent)(s.element, e, function(e) {
                            t[`${r}Mousedown`](e, n);
                        }));
                    });
                }), i;
            }
            shadesMousedown(e, t) {
                e = this.chart.pointer?.normalize(e) || e;
                let i = this.chart, r = this.xAxis, s = this.zoomedMin, n = this.size, o = this.range, a = this.left, l = e.chartX, h, d, c, u;
                i.inverted && (l = e.chartY, a = this.top), 1 === t ? (this.grabbedCenter = l, this.fixedWidth = o, this.dragOffset = l - s) : (u = l - a - o / 2, 0 === t ? u = Math.max(0, u) : 2 === t && u + o >= n && (u = n - o, this.reversedExtremes ? (u -= o, d = this.getUnionExtremes()?.dataMin) : h = this.getUnionExtremes()?.dataMax), u !== s && (this.fixedWidth = o, c = r.navigatorAxis.toFixedRange(u, u + o, d, h), (0, x.defined)(c.min) && (0, x.fireEvent)(this, "setRange", {
                    min: Math.min(c.min, c.max),
                    max: Math.max(c.min, c.max),
                    redraw: !0,
                    eventArguments: {
                        trigger: "navigator"
                    }
                })));
            }
            handlesMousedown(e, t) {
                e = this.chart.pointer?.normalize(e) || e;
                let i = this.chart, r = i.xAxis[0], s = this.reversedExtremes;
                0 === t ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = s ? r.min : r.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = s ? r.max : r.min), i.setFixedRange(void 0);
            }
            onMouseMove(e) {
                let t = this, i = t.chart, r = t.navigatorSize, s = t.range, n = t.dragOffset, o = i.inverted, a = t.left, l;
                (!e.touches || 0 !== e.touches[0].pageX) && (l = (e = i.pointer?.normalize(e) || e).chartX, o && (a = t.top, l = e.chartY), t.grabbedLeft ? (t.hasDragged = !0, t.render(0, 0, l - a, t.otherHandlePos)) : t.grabbedRight ? (t.hasDragged = !0, t.render(0, 0, t.otherHandlePos, l - a)) : t.grabbedCenter && n && (t.hasDragged = !0, l < n ? l = n : l > r + n - s && (l = r + n - s), t.render(0, 0, l - n, l - n + s)), t.hasDragged && (t.scrollbarOptions?.liveRedraw ?? (!tP && !this.chart.boosted)) && (e.DOMType = e.type, setTimeout(function() {
                    t.onMouseUp(e);
                }, 0)));
            }
            onMouseUp(e) {
                let t, i, r, s, n, o, a = this.chart, l = this.xAxis, h = this.scrollbar, d = e.DOMEvent || e, c = a.inverted, u = this.rendered && !this.hasDragged ? "animate" : "attr";
                (this.hasDragged && (!h || !h.hasDragged) || "scrollbar" === e.trigger) && (r = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? s = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (n = this.fixedExtreme), this.zoomedMax === this.size && (n = this.reversedExtremes ? r.dataMin : r.dataMax), 0 === this.zoomedMin && (s = this.reversedExtremes ? r.dataMax : r.dataMin), o = l.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, s, n), (0, x.defined)(o.min) && (0, x.fireEvent)(this, "setRange", {
                    min: Math.min(o.min, o.max),
                    max: Math.max(o.min, o.max),
                    redraw: !0,
                    animation: !this.hasDragged && null,
                    eventArguments: {
                        trigger: "navigator",
                        triggerOp: "navigator-drag",
                        DOMEvent: d
                    }
                })), "mousemove" !== e.DOMType && "touchmove" !== e.DOMType && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && (0, x.isNumber)(this.zoomedMin) && (0, x.isNumber)(this.zoomedMax) && (i = Math.round(this.zoomedMin), t = Math.round(this.zoomedMax), this.shades && this.drawMasks(i, t, c, u), this.outline && this.drawOutline(i, t, c, u), this.navigatorOptions.handles?.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(i, 0, c, u), this.drawHandle(t, 1, c, u)));
            }
            removeEvents() {
                this.eventsToUnbind?.forEach((e)=>{
                    e();
                }), this.eventsToUnbind = void 0, this.removeBaseSeriesEvents();
            }
            removeBaseSeriesEvents() {
                let e = this.baseSeries || [];
                this.navigatorEnabled && e[0] && (!1 !== this.navigatorOptions.adaptToUpdatedData && e.forEach(function(e) {
                    (0, x.removeEvent)(e, "updatedData", this.updatedDataHandler);
                }, this), e[0].xAxis && (0, x.removeEvent)(e[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
            }
            getXAxisOffsets() {
                return this.chart.inverted ? [
                    this.scrollButtonSize,
                    0,
                    -this.scrollButtonSize,
                    0
                ] : [
                    0,
                    -this.scrollButtonSize,
                    0,
                    this.scrollButtonSize
                ];
            }
            init(e) {
                let t = e.options, i = t.navigator || {}, r = i.enabled, s = t.scrollbar || {}, n = s.enabled, o = r && i.height || 0, a = n && s.height || 0, l = s.buttonsEnabled && a || 0;
                this.handles = [], this.shades = [], this.chart = e, this.setBaseSeries(), this.height = o, this.scrollbarHeight = a, this.scrollButtonSize = l, this.scrollbarEnabled = n, this.navigatorEnabled = !!r, this.navigatorOptions = i, this.scrollbarOptions = s, this.setOpposite();
                let h = this, d = h.baseSeries, c = e.xAxis.length, u = e.yAxis.length, p = d && d[0] && d[0].xAxis || e.xAxis[0] || {
                    options: {}
                };
                if (e.isDirtyBox = !0, h.navigatorEnabled) {
                    let t = this.getXAxisOffsets();
                    h.xAxis = new (e1())(e, (0, x.merge)({
                        breaks: p.options.breaks,
                        ordinal: p.options.ordinal,
                        overscroll: p.options.overscroll
                    }, i.xAxis, {
                        type: "datetime",
                        yAxis: i.yAxis?.id,
                        index: c,
                        isInternal: !0,
                        offset: 0,
                        keepOrdinalPadding: !0,
                        startOnTick: !1,
                        endOnTick: !1,
                        minPadding: p.options.ordinal ? 0 : p.options.minPadding,
                        maxPadding: p.options.ordinal ? 0 : p.options.maxPadding,
                        zoomEnabled: !1
                    }, e.inverted ? {
                        offsets: t,
                        width: o
                    } : {
                        offsets: t,
                        height: o
                    }), "xAxis"), h.yAxis = new (e1())(e, (0, x.merge)(i.yAxis, {
                        alignTicks: !1,
                        offset: 0,
                        index: u,
                        isInternal: !0,
                        reversed: (i.yAxis && i.yAxis.reversed) ?? (e.yAxis[0] && e.yAxis[0].reversed) ?? !1,
                        zoomEnabled: !1
                    }, e.inverted ? {
                        width: o
                    } : {
                        height: o
                    }), "yAxis"), h.xAxis.clippable = !1, h.yAxis.clippable = !1, d || i.series?.data || i.series?.dataTable ? h.updateNavigatorSeries(!1) : 0 === e.series.length && (h.unbindRedraw = (0, x.addEvent)(e, "beforeRedraw", function() {
                        e.series.length > 0 && !h.series && (h.setBaseSeries(), h.unbindRedraw?.());
                    })), h.reversedExtremes = e.inverted && !h.xAxis.reversed || !e.inverted && h.xAxis.reversed, h.renderElements(), h.addMouseEvents();
                } else h.xAxis = {
                    chart: e,
                    navigatorAxis: {
                        fake: !0
                    },
                    translate: function(t, i) {
                        let r = e.xAxis[0], s = r.getExtremes(), n = r.len - 2 * l, o = tD("min", r.options.min, s.dataMin), a = tD("max", r.options.max, s.dataMax) - o;
                        return i ? t * a / n + o : n * (t - o) / a;
                    },
                    toPixels: function(e) {
                        return this.translate(e);
                    },
                    toValue: function(e) {
                        return this.translate(e, !0);
                    }
                }, h.xAxis.navigatorAxis.axis = h.xAxis, h.xAxis.navigatorAxis.toFixedRange = to.prototype.toFixedRange.bind(h.xAxis.navigatorAxis);
                if (e.options.scrollbar?.enabled) {
                    let t = (0, x.merge)(e.options.scrollbar, {
                        vertical: e.inverted
                    });
                    (0, x.isNumber)(t.margin) || (t.margin = e.inverted ? -3 : 3), e.scrollbar = h.scrollbar = new tS(e.renderer, t, e), (0, x.addEvent)(h.scrollbar, "changed", function(e) {
                        let t = h.size, i = t * this.to, r = t * this.from;
                        h.hasDragged = h.scrollbar?.hasDragged, h.render(0, 0, r, i), this.shouldUpdateExtremes(e.DOMType) && setTimeout(function() {
                            h.onMouseUp(e);
                        });
                    });
                }
                h.addBaseSeriesEvents(), h.addChartEvents();
            }
            setOpposite() {
                let e = this.navigatorOptions, t = this.navigatorEnabled, i = this.chart;
                this.opposite = e.opposite ?? !!(!t && i.inverted);
            }
            getUnionExtremes(e) {
                let t, i = this.chart.xAxis[0], r = this.chart.time, s = this.xAxis, n = s.options, o = i.options;
                return e && null === i.dataMin || (t = {
                    dataMin: r.parse(n?.min) ?? tD("min", r.parse(o.min), i.dataMin, s.dataMin, s.min),
                    dataMax: r.parse(n?.max) ?? tD("max", r.parse(o.max), i.dataMax, s.dataMax, s.max)
                }), t;
            }
            setBaseSeries(e, t) {
                let i = this.chart, r = this.baseSeries = [];
                e = e || i.options.navigator?.baseSeries || (i.series.length ? (0, x.find)(i.series, (e)=>!e.options.isInternal).index : 0), (i.series || []).forEach((t, i)=>{
                    !t.options.isInternal && (t.options.showInNavigator || (i === e || t.options.id === e) && !1 !== t.options.showInNavigator) && r.push(t);
                }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, t);
            }
            updateNavigatorSeries(e, t) {
                let i = this, r = i.chart, s = i.baseSeries, n = {
                    enableMouseTracking: !1,
                    index: null,
                    linkedTo: null,
                    group: "nav",
                    padXAxis: !1,
                    xAxis: this.navigatorOptions.xAxis?.id,
                    yAxis: this.navigatorOptions.yAxis?.id,
                    showInLegend: !1,
                    stacking: void 0,
                    isInternal: !0,
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    }
                }, o = i.series = (i.series || []).filter((e)=>{
                    let t = e.baseSeries;
                    return !(t && 0 > s.indexOf(t)) || (t && ((0, x.removeEvent)(t, "updatedData", i.updatedDataHandler), delete t.navigatorSeries), e.chart && e.destroy(), !1);
                }), a, l, h = i.navigatorOptions.series, d;
                if (s && s.length && s.forEach((e)=>{
                    let c = e.navigatorSeries, u = (0, x.extend)({
                        color: e.color,
                        visible: e.visible
                    }, (0, x.isArray)(h) ? tk.navigator.series : h);
                    if (c && !1 === i.navigatorOptions.adaptToUpdatedData) return;
                    n.name = "Navigator " + s.length, d = (a = e.options || {}).navigatorOptions || {}, u.dataLabels = (0, x.splat)(u.dataLabels), (l = (0, x.merge)(a, n, u, d)).pointRange = u.pointRange ?? d.pointRange ?? tk.plotOptions[l.type || "line"]?.pointRange;
                    let p = d.data || u.data, g = d.dataTable || u.dataTable;
                    i.hasNavigatorData = i.hasNavigatorData || !!p || !!g, l.data = p || a.data?.slice(0), l.dataTable = g || a.dataTable, c && c.options ? c.update(l, t) : (e.navigatorSeries = r.initSeries(l), (0, x.fireEvent)(e.navigatorSeries, "afterUpdate"), e.navigatorSeries.baseSeries = e, o.push(e.navigatorSeries));
                }), (h?.data || h?.dataTable) && !(s && s.length) || (0, x.isArray)(h)) {
                    let e = r.options.colors || [];
                    i.hasNavigatorData = !1, (h = (0, x.splat)(h)).forEach((t, s)=>{
                        n.name = "Navigator " + (o.length + 1), (l = (0, x.merge)(tk.navigator?.series, {
                            color: r.series[s] && !r.series[s].options.isInternal && r.series[s].color || e[s] || e[0]
                        }, n, t)).data = t.data, l.dataTable = t.dataTable, (l.data || l.dataTable) && (i.hasNavigatorData = !0, o.push(r.initSeries(l)));
                    });
                }
                e && this.addBaseSeriesEvents();
            }
            addBaseSeriesEvents() {
                let e = this, t = e.baseSeries || [];
                t[0] && t[0].xAxis && t[0].eventsToUnbind.push((0, x.addEvent)(t[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), t.forEach((i)=>{
                    i.eventsToUnbind.push((0, x.addEvent)(i, "show", function() {
                        this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
                    })), i.eventsToUnbind.push((0, x.addEvent)(i, "hide", function() {
                        this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
                    })), !1 !== this.navigatorOptions.adaptToUpdatedData && i.xAxis && i.eventsToUnbind.push((0, x.addEvent)(i, "updatedData", this.updatedDataHandler)), i.eventsToUnbind.push((0, x.addEvent)(i, "remove", function() {
                        t && (0, x.erase)(t, i), this.navigatorSeries && e.series && ((0, x.erase)(e.series, this.navigatorSeries), (0, x.defined)(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
                    }));
                });
            }
            getBaseSeriesMin(e) {
                return this.baseSeries.reduce(function(e, t) {
                    return Math.min(e, t.getColumn("x")[0] ?? e);
                }, e);
            }
            modifyNavigatorAxisExtremes() {
                let e = this.xAxis;
                if (void 0 !== e.getExtremes) {
                    let t = this.getUnionExtremes(!0);
                    t && (t.dataMin !== e.min || t.dataMax !== e.max) && (e.min = t.dataMin, e.max = t.dataMax);
                }
            }
            modifyBaseAxisExtremes() {
                let e, t, i = this.chart.navigator, r = this.getExtremes(), s = r.min, n = r.max, o = r.dataMin, a = r.dataMax, l = n - s, h = i?.stickToMin, d = i?.stickToMax, c = this.ordinal?.convertOverscroll(this.options.overscroll) ?? 0, u = i.series && i.series[0], p = !!this.setExtremes;
                !(this.eventArgs && "rangeSelectorButton" === this.eventArgs.trigger) && (h && (e = (t = o) + l), d && (e = a + c, h || (t = Math.max(o, e - l, i.getBaseSeriesMin(u && u.xData ? u.xData[0] : -Number.MAX_VALUE)))), p && (h || d) && (0, x.isNumber)(t) && (this.min = this.userMin = t, this.max = this.userMax = e)), i.stickToMin = i.stickToMax = null;
            }
            updatedDataHandler() {
                let e = this.chart.navigator, t = this.navigatorSeries, i = e.reversedExtremes ? 0 === Math.round(e.zoomedMin) : Math.round(e.zoomedMax) >= Math.round(e.size);
                e.stickToMax = (this.chart.options.navigator && this.chart.options.navigator.stickToMax) ?? i, e.stickToMin = e.shouldStickToMin(this, e), t && !e.hasNavigatorData && (t.options.pointStart = this.getColumn("x")[0], t.setData(this.options.data || this.options.dataTable, !1, void 0, !1));
            }
            shouldStickToMin(e, t) {
                let i = t.getBaseSeriesMin(e.getColumn("x")[0]), r = e.xAxis, s = r.max, n = r.min, o = r.options.range;
                return !!((0, x.isNumber)(s) && (0, x.isNumber)(n)) && (o && s - i > 0 ? s - i < o : n <= i);
            }
            addChartEvents() {
                this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push((0, x.addEvent)(this.chart, "redraw", function() {
                    let e = this.navigator, t = e && (e.baseSeries && e.baseSeries[0] && e.baseSeries[0].xAxis || this.xAxis[0]);
                    t && e.render(t.min, t.max);
                }), (0, x.addEvent)(this.chart, "getMargins", function() {
                    let e = this.navigator, t = e.opposite ? "plotTop" : "marginBottom";
                    this.inverted && (t = e.opposite ? "marginRight" : "plotLeft"), this[t] = (this[t] || 0) + (e.navigatorEnabled || !this.inverted ? e.height + (this.scrollbar?.options.margin || 0) + e.scrollbarHeight : 0) + (e.navigatorOptions.margin || 0);
                }), (0, x.addEvent)(this, "setRange", function(e) {
                    this.chart.xAxis[0].setExtremes(e.min, e.max, e.redraw, e.animation, e.eventArguments);
                }));
            }
            destroy() {
                this.removeEvents(), this.xAxis && ((0, x.erase)(this.chart.xAxis, this.xAxis), (0, x.erase)(this.chart.axes, this.xAxis)), this.yAxis && ((0, x.erase)(this.chart.yAxis, this.yAxis), (0, x.erase)(this.chart.axes, this.yAxis)), (0, x.destroyObjectProperties)(this.series || []), [
                    "series",
                    "xAxis",
                    "yAxis",
                    "shades",
                    "outline",
                    "scrollbarTrack",
                    "scrollbarRifles",
                    "scrollbarGroup",
                    "scrollbar",
                    "navigatorGroup",
                    "rendered"
                ].forEach((e)=>{
                    this[e] && this[e].destroy && this[e].destroy(), this[e] = null;
                }), [
                    this.handles
                ].forEach((e)=>{
                    (0, x.destroyObjectProperties)(e);
                }), this.baseSeries.forEach((e)=>{
                    e.navigatorSeries = void 0;
                }), this.navigatorEnabled = !1;
            }
        }, { format: tB } = k(), { getFakeMouseEvent: tI } = C, { getAxisRangeDescription: tF, fireEventOnWrappedOrUnwrappedElement: tO } = H, tR = class extends W {
            init() {
                let e = this.chart, t = this;
                this.announcer = new es(e, "polite"), this.addEvent(tN, "afterRender", function() {
                    this.chart === t.chart && this.chart.renderer && (0, x.syncTimeout)(()=>{
                        t.proxyProvider.updateGroupProxyElementPositions("navigator"), t.updateHandleValues();
                    }, (0, x.animObject)(this.chart.renderer.globalAnimation ?? !0).duration);
                });
            }
            onChartUpdate() {
                let e = this.chart, t = e.options, i = t.navigator;
                if (i.enabled && i.accessibility?.enabled) {
                    let i = t.accessibility.landmarkVerbosity, r = t.lang.accessibility?.navigator.groupLabel;
                    this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", {
                        role: "all" === i ? "region" : "group",
                        "aria-label": tB(r, {
                            chart: e
                        }, e)
                    });
                    let s = t.lang.accessibility?.navigator.handleLabel;
                    [
                        0,
                        1
                    ].forEach((t)=>{
                        let i = this.getHandleByIx(t);
                        if (i) {
                            let r = this.proxyProvider.addProxyElement("navigator", {
                                click: i
                            }, "input", {
                                type: "range",
                                "aria-label": tB(s, {
                                    handleIx: t,
                                    chart: e
                                }, e)
                            });
                            this[t ? "maxHandleProxy" : "minHandleProxy"] = r.innerElement, r.innerElement.style.pointerEvents = "none", r.innerElement.oninput = ()=>this.updateNavigator();
                        }
                    }), this.updateHandleValues();
                } else this.proxyProvider.removeGroup("navigator");
            }
            getNavigatorHandleNavigation(e) {
                let t = this, i = this.chart, r = e ? this.maxHandleProxy : this.minHandleProxy, s = this.keyCodes;
                return new X(i, {
                    keyCodeMap: [
                        [
                            [
                                s.left,
                                s.right,
                                s.up,
                                s.down
                            ],
                            function(n) {
                                if (r) {
                                    let o = n === s.left || n === s.up ? -1 : 1;
                                    r.value = "" + (0, x.clamp)(parseFloat(r.value) + o, 0, 100), t.updateNavigator(()=>{
                                        let s = t.getHandleByIx(e);
                                        s && i.setFocusToElement(s, r);
                                    });
                                }
                                return this.response.success;
                            }
                        ]
                    ],
                    init: ()=>{
                        i.setFocusToElement(this.getHandleByIx(e), r);
                    },
                    validate: ()=>!!(this.getHandleByIx(e) && r && i.options.navigator.accessibility?.enabled)
                });
            }
            getKeyboardNavigation() {
                return [
                    this.getNavigatorHandleNavigation(0),
                    this.getNavigatorHandleNavigation(1)
                ];
            }
            destroy() {
                this.updateNavigatorThrottleTimer && (0, x.internalClearTimeout)(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
            }
            updateHandleValues() {
                let e = this.chart.navigator;
                if (e && this.minHandleProxy && this.maxHandleProxy) {
                    let t = e.size;
                    this.minHandleProxy.value = "" + Math.round(e.zoomedMin / t * 100), this.maxHandleProxy.value = "" + Math.round(e.zoomedMax / t * 100);
                }
            }
            getHandleByIx(e) {
                let t = this.chart.navigator;
                return t && t.handles && t.handles[e];
            }
            updateNavigator(e) {
                let t = (e)=>{
                    let t = this.chart, { navigator: i, pointer: r } = t, s = this.chart.accessibility?.keyboardNavigation;
                    if (i && r && this.minHandleProxy && this.maxHandleProxy) {
                        let n = r.getChartPosition(), o = parseFloat(this.minHandleProxy.value) / 100 * i.size, a = parseFloat(this.maxHandleProxy.value) / 100 * i.size;
                        [
                            [
                                0,
                                "mousedown",
                                i.zoomedMin
                            ],
                            [
                                0,
                                "mousemove",
                                o
                            ],
                            [
                                0,
                                "mouseup",
                                o
                            ],
                            [
                                1,
                                "mousedown",
                                i.zoomedMax
                            ],
                            [
                                1,
                                "mousemove",
                                a
                            ],
                            [
                                1,
                                "mouseup",
                                a
                            ]
                        ].forEach(([e, t, r])=>{
                            let s = this.getHandleByIx(e)?.element;
                            s && tO(s, tI(t, {
                                x: n.left + i.left + r,
                                y: n.top + i.top
                            }, s));
                        }), s && (s.keyboardReset = !1), e && e();
                        let l = t.options.lang.accessibility?.navigator.changeAnnouncement, h = tF(t.xAxis[0]);
                        this.announcer.announce(tB(l, {
                            axisRangeDescription: h,
                            chart: t
                        }, t));
                    }
                };
                this.updateNavigatorThrottleTimer && (0, x.internalClearTimeout)(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(t.bind(this, e), 20);
            }
        }, { getPointAnnotationTexts: tL } = ec, { getAxisDescription: tH, getSeriesFirstPointElement: tz, getSeriesA11yElement: tq, unhideChartElementFromAT: tU } = H, { format: tG, numberFormat: tK } = k(), { composed: tV } = y(), { reverseChildNodes: tW, stripHTMLTagsFromString: tX } = C;
        function tY(e, ...t) {
            let i = e.apply(this, t);
            return i.hasMockGraphic && !i.isNull && (i.graphic = i.graphic?.destroy(), delete i.hasMockGraphic), i;
        }
        function tj(e) {
            let t = e.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
            return !!(!1 !== t && e.points && e.points.length >= +t);
        }
        function tZ(e, t) {
            let i = e.series, r = i.chart, s = r.options.accessibility.point || {}, n = i.options.accessibility && i.options.accessibility.point || {}, o = i.tooltipOptions || {}, a = r.options.lang;
            return (0, x.isNumber)(t) ? tK(t, n.valueDecimals || s.valueDecimals || o.valueDecimals || -1, a.decimalPoint, a.accessibility.thousandsSep || a.thousandsSep) : t;
        }
        function t_(e, t) {
            let i = e[t];
            return e.chart.langFormat("accessibility.series." + t + "Description", {
                name: tH(i),
                series: e
            });
        }
        function t$(e) {
            let t, i, r, s, n, o, a, l, h, d, c, u, p = e.series, g = p.chart.series.length > 1 || p.options.name, m = (o = (n = e.series).chart, l = (a = n.options.accessibility) && a.point && a.point.valueDescriptionFormat || o.options.accessibility.point.valueDescriptionFormat, d = (h = (n.xAxis && n.xAxis.options.accessibility && n.xAxis.options.accessibility.enabled) ?? (!o.angular && "flowmap" !== n.type)) ? (t = function(e) {
                let t = e.series, i = t.chart, r = t.options.accessibility && t.options.accessibility.point || {}, s = i.options.accessibility.point || {}, n = t.xAxis && t.xAxis.dateTime;
                if (n) {
                    let t = n.getXDateFormat(e.x || 0, i.options.tooltip.dateTimeLabelFormats), o = r.dateFormatter && r.dateFormatter(e) || s.dateFormatter?.(e) || r.dateFormat || s.dateFormat || t;
                    return i.time.dateFormat(o, e.x || 0, void 0);
                }
            }(e), i = (e.series.xAxis || {}).categories && (0, x.defined)(e.category) && ("" + e.category).replace("<br/>", " "), r = (0, x.defined)(e.id) && 0 > ("" + e.id).indexOf("highcharts-"), s = "x, " + e.x, e.name || t || i || (r ? e.id : s)) : "", tG(l, {
                point: e,
                index: (0, x.defined)(e.index) ? e.index + 1 : "",
                xDescription: d,
                value: function(e) {
                    let t = e.series, i = t.chart.options.accessibility.point || {}, r = t.chart.options.accessibility && t.chart.options.accessibility.point || {}, s = t.tooltipOptions || {}, n = r.valuePrefix || i.valuePrefix || s.valuePrefix || "", o = r.valueSuffix || i.valueSuffix || s.valueSuffix || "", a = void 0 !== e.value ? "value" : "y", l = tZ(e, e[a]);
                    if (e.isNull) return t.chart.langFormat("accessibility.series.nullPointValue", {
                        point: e
                    });
                    if (t.pointArrayMap) {
                        let t, i, r;
                        return t = n || "", i = o || "", r = function(r) {
                            let s = tZ(e, e[r] ?? e.options[r]);
                            return void 0 !== s ? r + ": " + t + s + i : s;
                        }, e.series.pointArrayMap.reduce(function(e, t) {
                            let i = r(t);
                            return i ? e + (e.length ? ", " : "") + i : e;
                        }, "");
                    }
                    return n + l + o;
                }(e),
                separator: h ? ", " : ""
            }, o)), b = e.options && e.options.accessibility && e.options.accessibility.description, f = g ? " " + p.name + "." : "", y = (c = e.series.chart, (u = tL(e)).length ? c.langFormat("accessibility.series.pointAnnotationsDescription", {
                point: e,
                annotations: u
            }) : "");
            return e.accessibility = e.accessibility || {}, e.accessibility.valueDescription = m, m + (b ? " " + b : "") + f + (y ? " " + y : "");
        }
        function tQ(e) {
            let t, i = e.chart, r = i.types || [], s = (t = (e.options.accessibility || {}).description) && e.chart.langFormat("accessibility.series.description", {
                description: t,
                series: e
            }) || "", n = function(t) {
                return i[t] && i[t].length > 1 && e[t];
            }, o = e.index + 1, a = t_(e, "xAxis"), l = t_(e, "yAxis"), h = {
                seriesNumber: o,
                series: e,
                chart: i
            }, d = r.length > 1 ? "Combination" : "", c = i.langFormat("accessibility.series.summary." + e.type + d, h) || i.langFormat("accessibility.series.summary.default" + d, h), u = (n("yAxis") ? " " + l + "." : "") + (n("xAxis") ? " " + a + "." : "");
            return tG((e.options.accessibility && e.options.accessibility.descriptionFormat) ?? i.options.accessibility.series.descriptionFormat ?? "", {
                seriesDescription: c,
                authorDescription: s ? " " + s : "",
                axisDescription: u,
                series: e,
                chart: i,
                seriesNumber: o
            }, void 0);
        }
        let tJ = {
            compose: function(e) {
                (0, x.pushUnique)(tV, "A11y.SD") && (0, x.wrap)(e.prototype, "applyOptions", tY);
            },
            defaultPointDescriptionFormatter: t$,
            defaultSeriesDescriptionFormatter: tQ,
            describeSeries: function(e) {
                let t = e.chart, i = tz(e), r = tq(e), s = t.is3d && t.is3d();
                if (r) {
                    let n, o, a, l, h, d, c, u, p, g, m;
                    if (r.lastChild !== i || s || tW(r), n = e.options.accessibility || {}, a = !tj(e) && !n.exposeAsGroupOnly, o = e.chart.options.accessibility.keyboardNavigation.seriesNavigation, l = !!(e.points && (e.points.length < +o.pointNavigationEnabledThreshold || !1 === o.pointNavigationEnabledThreshold)), h = e.chart.options.accessibility.point.describeNull, (a || l) && e.points.forEach((t)=>{
                        let i, r, s, n, o, l = t.graphic && t.graphic.element || (r = (i = t.series) && i.chart, s = i && i.is("sunburst"), n = t.isNull, o = r && r.options.accessibility.point.describeNull, n && !s && o && function(e) {
                            let t, i = e.series, r = function(e) {
                                let t = e.index;
                                if (!e.series || !e.series.data || !(0, x.defined)(t)) return null;
                                let i = e.series.options?.nullInteraction;
                                return (0, x.find)(e.series.data, function(e) {
                                    return !!(e && void 0 !== e.index && (i || e.index > t) && e.graphic && e.graphic.element);
                                }) || null;
                            }(e), s = r && r.graphic, n = s ? s.parentGroup : i.graph || i.group, o = r ? {
                                x: e.plotX ?? r.plotX ?? 0,
                                y: e.plotY ?? r.plotY ?? 0
                            } : {
                                x: e.plotX ?? 0,
                                y: e.plotY ?? 0
                            }, a = ((t = e.series.chart.renderer.rect(o.x, o.y, 1, 1)).attr({
                                class: "highcharts-a11y-mock-point",
                                fill: "none",
                                opacity: 0,
                                "fill-opacity": 0,
                                "stroke-opacity": 0
                            }), t);
                            if (n && n.element) return e.graphic = a, e.hasMockGraphic = !0, a.add(n), n.element.insertBefore(a.element, s ? s.element : null), a.element;
                        }(t)), d = t.options && t.options.accessibility && !1 === t.options.accessibility.enabled;
                        if (l) {
                            if (t.isNull && !h) return void l.setAttribute("aria-hidden", !0);
                            if (l.setAttribute("tabindex", "-1"), e.chart.styledMode || (l.style.outline = "none"), a && !d) {
                                let e, i, r, s;
                                e = t.series, i = e.options.accessibility?.point || {}, r = e.chart.options.accessibility.point || {}, s = tX((0, x.isString)(i.descriptionFormat) && tG(i.descriptionFormat, t, e.chart) || i.descriptionFormatter?.(t) || (0, x.isString)(r.descriptionFormat) && tG(r.descriptionFormat, t, e.chart) || r.descriptionFormatter?.(t) || t$(t), e.chart.renderer.forExport), l.setAttribute("role", "img"), l.setAttribute("aria-label", s);
                            } else l.setAttribute("aria-hidden", !0);
                        }
                    }), tU(t, r), u = (c = (d = e.chart).options.chart).options3d && c.options3d.enabled, p = d.series.length > 1, g = d.options.accessibility.series.describeSingleSeries, m = (e.options.accessibility || {}).exposeAsGroupOnly, !(u && p) && (p || g || m || tj(e))) {
                        let t, i, s;
                        t = e.options.accessibility || {}, s = (i = e.chart.options.accessibility).landmarkVerbosity, t.exposeAsGroupOnly ? r.setAttribute("role", "img") : "all" === s ? r.setAttribute("role", "region") : r.setAttribute("role", "group"), r.setAttribute("tabindex", "-1"), e.chart.styledMode || (r.style.outline = "none"), r.setAttribute("aria-label", tX(i.series.descriptionFormatter && i.series.descriptionFormatter(e) || tQ(e), e.chart.renderer.forExport));
                    } else r.removeAttribute("aria-label");
                }
            }
        }, { composed: t0 } = y(), { getChartTitle: t1 } = H, { defaultPointDescriptionFormatter: t2, defaultSeriesDescriptionFormatter: t3 } = tJ;
        function t5(e) {
            return !!e.options.accessibility.announceNewData.enabled;
        }
        class t4 {
            constructor(e){
                this.dirty = {
                    allSeries: {}
                }, this.lastAnnouncementTime = 0, this.chart = e;
            }
            init() {
                let e = this.chart, t = e.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
                this.lastAnnouncementTime = 0, this.dirty = {
                    allSeries: {}
                }, this.eventProvider = new G, this.announcer = new es(e, t), this.addEventListeners();
            }
            destroy() {
                this.eventProvider.removeAddedEvents(), this.announcer.destroy();
            }
            addEventListeners() {
                let e = this, t = this.chart, i = this.eventProvider;
                i.addEvent(t, "afterApplyDrilldown", function() {
                    e.lastAnnouncementTime = 0;
                }), i.addEvent(t, "afterAddSeries", function(t) {
                    e.onSeriesAdded(t.series);
                }), i.addEvent(t, "redraw", function() {
                    e.announceDirtyData();
                });
            }
            onSeriesAdded(e) {
                t5(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[e.name + e.index] = e, this.dirty.newSeries = (0, x.defined)(this.dirty.newSeries) ? void 0 : e);
            }
            announceDirtyData() {
                let e = this.chart, t = this;
                if (e.options.accessibility.announceNewData && this.dirty.hasDirty) {
                    var i;
                    let e, r = this.dirty.newPoint;
                    r && (r = 1 === (e = (i = r).series.data.filter((e)=>i.x === e.x && i.y === e.y)).length ? e[0] : i), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((e)=>t.dirty.allSeries[e]), this.dirty.newSeries, r), this.dirty = {
                        allSeries: {}
                    };
                }
            }
            queueAnnouncement(e, t, i) {
                let r = this.chart.options.accessibility.announceNewData;
                if (r.enabled) {
                    var s;
                    let n, o = +new Date, a = o - this.lastAnnouncementTime, l = Math.max(0, r.minAnnounceInterval - a), h = (s = this.queuedAnnouncement && this.queuedAnnouncement.series, Object.keys(n = (s || []).concat(e || []).reduce((e, t)=>(e[t.name + t.index] = t, e), {})).map((e)=>n[e])), d = this.buildAnnouncementMessage(h, t, i);
                    d && (this.queuedAnnouncement && (0, x.internalClearTimeout)(this.queuedAnnouncementTimer), this.queuedAnnouncement = {
                        time: o,
                        message: d,
                        series: h
                    }, this.queuedAnnouncementTimer = setTimeout(()=>{
                        this && this.announcer && (this.lastAnnouncementTime = +new Date, this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
                    }, l));
                }
            }
            buildAnnouncementMessage(e, t, i) {
                let r = this.chart, s = r.options.accessibility.announceNewData;
                if (s.announcementFormatter) {
                    let r = s.announcementFormatter(e, t, i, this);
                    if (!1 !== r) return r.length ? r : null;
                }
                let n = y().charts && y().charts.length > 1 ? "Multiple" : "Single", o = t ? "newSeriesAnnounce" + n : i ? "newPointAnnounce" + n : "newDataAnnounce", a = t1(r);
                return r.langFormat("accessibility.announceNewData." + o, {
                    chartTitle: a,
                    seriesDesc: t ? t3(t) : null,
                    pointDesc: i ? t2(i) : null,
                    point: i,
                    series: t
                });
            }
        }
        function t6(e) {
            let t = this.chart, i = t.accessibility?.components.series.newDataAnnouncer;
            i && i.chart === t && t5(t) && (i.dirty.newPoint = (0, x.defined)(i.dirty.newPoint) ? void 0 : e.point);
        }
        function t8() {
            let e = this.chart, t = e.accessibility?.components.series.newDataAnnouncer;
            t && t.chart === e && t5(e) && (t.dirty.hasDirty = !0, t.dirty.allSeries[this.name + this.index] = this);
        }
        (t4 || (t4 = {})).compose = function(e) {
            (0, x.pushUnique)(t0, "A11y.NDA") && ((0, x.addEvent)(e, "addPoint", t6), (0, x.addEvent)(e, "updatedData", t8));
        };
        let t9 = t4, { doc: t7, win: ie } = y(), { fireEventOnWrappedOrUnwrappedElement: it } = H, { cloneMouseEvent: ii, cloneTouchEvent: ir, getFakeMouseEvent: is, removeElement: io } = C, ia = class {
            constructor(e, t, i = "button", r, s){
                this.chart = e, this.target = t, this.eventProvider = new G;
                let n = this.innerElement = t7.createElement(i), o = this.element = r ? t7.createElement(r) : n;
                e.styledMode || this.hideElementVisually(n), r && ("li" !== r || e.styledMode || (o.style.listStyle = "none"), o.appendChild(n), this.element = o), this.updateTarget(t, s);
            }
            click() {
                let e = this.getTargetPosition();
                e.x += e.width / 2, e.y += e.height / 2;
                let t = is("click", e);
                it(this.target.click, t);
            }
            updateTarget(e, t) {
                this.target = e, this.updateCSSClassName();
                let i = t || {};
                Object.keys(i).forEach((e)=>{
                    null === i[e] && delete i[e];
                });
                let r = this.getTargetAttr(e.click, "aria-label");
                (0, x.attr)(this.innerElement, (0, x.merge)(r ? {
                    "aria-label": r
                } : {}, i)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, e.click), this.refreshPosition();
            }
            refreshPosition() {
                let e = this.getTargetPosition();
                (0, x.css)(this.innerElement, {
                    width: (e.width || 1) + "px",
                    height: (e.height || 1) + "px",
                    left: (Math.round(e.x) || 0) + "px",
                    top: (Math.round(e.y) || 0) + "px"
                });
            }
            remove() {
                this.eventProvider.removeAddedEvents(), io(this.element);
            }
            updateCSSClassName() {
                let e = (e)=>e.indexOf("highcharts-no-tooltip") > -1, t = e(this.chart.legend?.group?.div?.className || ""), i = e(this.getTargetAttr(this.target.click, "class") || "");
                this.innerElement.className = t || i ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
            }
            addProxyEventsToElement(e, t) {
                [
                    "click",
                    "touchstart",
                    "touchend",
                    "touchcancel",
                    "touchmove",
                    "mouseover",
                    "mouseenter",
                    "mouseleave",
                    "mouseout"
                ].forEach((i)=>{
                    let r = 0 === i.indexOf("touch");
                    this.eventProvider.addEvent(e, i, (e)=>{
                        let i = r ? ir(e) : ii(e);
                        t && it(t, i), e.stopPropagation(), r || e.preventDefault();
                    }, {
                        passive: !1
                    });
                });
            }
            hideElementVisually(e) {
                (0, x.css)(e, {
                    borderWidth: 0,
                    backgroundColor: "transparent",
                    cursor: "pointer",
                    outline: "none",
                    opacity: .001,
                    filter: "alpha(opacity=1)",
                    zIndex: 999,
                    overflow: "hidden",
                    padding: 0,
                    margin: 0,
                    display: "block",
                    position: "absolute",
                    "pointer-events": "none",
                    "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)"
                });
            }
            getTargetPosition() {
                let e = this.target.click, t = e.element ? e.element : e, i = this.target.visual || t, r = this.chart.renderTo, s = this.chart.pointer;
                if (r && i?.getBoundingClientRect && s) {
                    let e = ie.scrollY || t7.documentElement.scrollTop, t = i.getBoundingClientRect(), r = s.getChartPosition();
                    return {
                        x: (t.left - r.left) / r.scaleX,
                        y: (t.top + e - r.top) / r.scaleY,
                        width: t.right / r.scaleX - t.left / r.scaleX,
                        height: t.bottom / r.scaleY - t.top / r.scaleY
                    };
                }
                return {
                    x: 0,
                    y: 0,
                    width: 1,
                    height: 1
                };
            }
            getTargetAttr(e, t) {
                return e.element ? e.element.getAttribute(t) : e.getAttribute(t);
            }
        }, { doc: il } = y(), { unhideChartElementFromAT: ih } = H, { removeChildNodes: id } = C, ic = class {
            constructor(e){
                this.chart = e, this.domElementProvider = new U, this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
            }
            addProxyElement(e, t, i = "button", r) {
                let s = this.groups[e];
                if (!s) throw Error("ProxyProvider.addProxyElement: Invalid group key " + e);
                let n = "ul" === s.type || "ol" === s.type ? "li" : void 0, o = new ia(this.chart, t, i, n, r);
                return s.proxyContainerElement.appendChild(o.element), s.proxyElements.push(o), o;
            }
            addGroup(e, t = "div", i) {
                let r, s = this.groups[e];
                if (s) return s.groupElement;
                let n = this.domElementProvider.createElement(t);
                return i && i.role && "div" !== t ? (r = this.domElementProvider.createElement("div")).appendChild(n) : r = n, r.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + e.replace(/\W/g, "-"), this.groups[e] = {
                    proxyContainerElement: n,
                    groupElement: r,
                    type: t,
                    proxyElements: []
                }, (0, x.attr)(r, i || {}), "ul" === t && n.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(r), this.updateGroupOrder(this.groupOrder), r;
            }
            updateGroupAttrs(e, t) {
                let i = this.groups[e];
                if (!i) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + e);
                (0, x.attr)(i.groupElement, t);
            }
            updateGroupOrder(e) {
                if (this.groupOrder = e.slice(), this.isDOMOrderGroupOrder()) return;
                let t = e.indexOf("series"), i = t > -1 ? e.slice(0, t) : e, r = t > -1 ? e.slice(t + 1) : [], s = il.activeElement;
                [
                    "before",
                    "after"
                ].forEach((e)=>{
                    let t = this["before" === e ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
                    id(t), ("before" === e ? i : r).forEach((e)=>{
                        let i = this.groups[e];
                        i && t.appendChild(i.groupElement);
                    });
                }), (this.beforeChartProxyPosContainer.contains(s) || this.afterChartProxyPosContainer.contains(s)) && s && s.focus && s.focus();
            }
            clearGroup(e) {
                let t = this.groups[e];
                if (!t) throw Error("ProxyProvider.clearGroup: Invalid group key " + e);
                id(t.proxyContainerElement);
            }
            removeGroup(e) {
                let t = this.groups[e];
                t && (this.domElementProvider.removeElement(t.groupElement), t.groupElement !== t.proxyContainerElement && this.domElementProvider.removeElement(t.proxyContainerElement), delete this.groups[e]);
            }
            update() {
                this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
            }
            updateProxyElementPositions() {
                Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
            }
            updateGroupProxyElementPositions(e) {
                let t = this.groups[e];
                t && t.proxyElements.forEach((e)=>e.refreshPosition());
            }
            destroy() {
                this.domElementProvider.destroyCreatedElements();
            }
            createProxyPosContainer(e) {
                let t = this.domElementProvider.createElement("div");
                return t.setAttribute("aria-hidden", "false"), t.className = "highcharts-a11y-proxy-container" + (e ? "-" + e : ""), (0, x.css)(t, {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    whiteSpace: "nowrap"
                }), t;
            }
            getCurrentGroupOrderInDOM() {
                let e = (e)=>{
                    let t = Object.keys(this.groups), i = t.length;
                    for(; i--;){
                        let r = t[i], s = this.groups[r];
                        if (s && e === s.groupElement) return r;
                    }
                }, t = (t)=>{
                    let i = [], r = t.children;
                    for(let t = 0; t < r.length; ++t){
                        let s = e(r[t]);
                        s && i.push(s);
                    }
                    return i;
                }, i = t(this.beforeChartProxyPosContainer), r = t(this.afterChartProxyPosContainer);
                return i.push("series"), i.concat(r);
            }
            isDOMOrderGroupOrder() {
                let e = this.getCurrentGroupOrderInDOM(), t = this.groupOrder.filter((e)=>"series" === e || !!this.groups[e]), i = e.length;
                if (i !== t.length) return !1;
                for(; i--;)if (e[i] !== t[i]) return !1;
                return !0;
            }
            updatePosContainerPositions() {
                let e = this.chart;
                if (e.renderer.forExport) return;
                let t = e.renderer.box;
                e.container.insertBefore(this.afterChartProxyPosContainer, t.nextSibling), e.container.insertBefore(this.beforeChartProxyPosContainer, t), ih(this.chart, this.afterChartProxyPosContainer), ih(this.chart, this.beforeChartProxyPosContainer);
            }
        }, { unhideChartElementFromAT: iu, getAxisRangeDescription: ip } = H;
        class ig extends W {
            init() {
                let e = this.chart;
                this.announcer = new es(e, "polite");
            }
            onChartUpdate() {
                let e = this.chart, t = this, i = e.rangeSelector;
                i && (this.updateSelectorVisibility(), this.setDropdownAttrs(), i.buttons && i.buttons.length && i.buttons.forEach((e)=>{
                    t.setRangeButtonAttrs(e);
                }), i.maxInput && i.minInput && [
                    "minInput",
                    "maxInput"
                ].forEach(function(r, s) {
                    let n = i[r];
                    n && (iu(e, n), t.setRangeInputAttrs(n, "accessibility.rangeSelector." + (s ? "max" : "min") + "InputLabel"));
                }));
            }
            updateSelectorVisibility() {
                let e = this.chart, t = e.rangeSelector, i = t && t.dropdown, r = t && t.buttons || [];
                t && t.hasVisibleDropdown && i ? (iu(e, i), r.forEach((e)=>e.element.setAttribute("aria-hidden", !0))) : (i && i.setAttribute("aria-hidden", !0), r.forEach((t)=>iu(e, t.element)));
            }
            setDropdownAttrs() {
                let e = this.chart, t = e.rangeSelector && e.rangeSelector.dropdown;
                if (t) {
                    let i = e.langFormat("accessibility.rangeSelector.dropdownLabel", {
                        rangeTitle: e.options.lang.rangeSelectorZoom
                    });
                    t.setAttribute("aria-label", i), t.setAttribute("tabindex", -1);
                }
            }
            setRangeButtonAttrs(e) {
                (0, x.attr)(e.element, {
                    tabindex: -1,
                    role: "button"
                });
            }
            setRangeInputAttrs(e, t) {
                let i = this.chart;
                (0, x.attr)(e, {
                    tabindex: -1,
                    "aria-label": i.langFormat(t, {
                        chart: i
                    })
                });
            }
            onButtonNavKbdArrowKey(e, t) {
                let i = e.response, r = this.keyCodes, s = this.chart, n = s.options.accessibility.keyboardNavigation.wrapAround, o = t === r.left || t === r.up ? -1 : 1;
                return s.highlightRangeSelectorButton(s.highlightedRangeSelectorItemIx + o) ? i.success : n ? (e.init(o), i.success) : i[o > 0 ? "next" : "prev"];
            }
            onButtonNavKbdClick(e) {
                let t = e.response, i = this.chart;
                return 3 !== i.oldRangeSelectorItemState && this.fakeClickEvent(i.rangeSelector.buttons[i.highlightedRangeSelectorItemIx].element), t.success;
            }
            onAfterBtnClick() {
                let e = this.chart, t = ip(e.xAxis[0]), i = e.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", {
                    chart: e,
                    axisRangeDescription: t
                });
                i && this.announcer.announce(i);
            }
            onInputKbdMove(e) {
                let t = this.chart, i = t.rangeSelector, r = t.highlightedInputRangeIx = (t.highlightedInputRangeIx || 0) + e;
                if (r > 1 || r < 0) {
                    if (t.accessibility) return t.accessibility.keyboardNavigation.exiting = !0, t.accessibility.keyboardNavigation.tabindexContainer.focus(), t.accessibility.keyboardNavigation.move(e);
                } else if (i) {
                    let e = i[r ? "maxDateBox" : "minDateBox"], s = i[r ? "maxInput" : "minInput"];
                    e && s && t.setFocusToElement(e, s);
                }
                return !0;
            }
            onInputNavInit(e) {
                let t = this, i = this.chart, r = e > 0 ? 0 : 1, s = i.rangeSelector, n = s && s[r ? "maxDateBox" : "minDateBox"], o = s && s.minInput, a = s && s.maxInput;
                if (i.highlightedInputRangeIx = r, n && o && a) {
                    i.setFocusToElement(n, r ? a : o), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
                    let e = (e)=>{
                        (e.which || e.keyCode) === this.keyCodes.tab && t.onInputKbdMove(e.shiftKey ? -1 : 1) && (e.preventDefault(), e.stopPropagation());
                    }, s = (0, x.addEvent)(o, "keydown", e), l = (0, x.addEvent)(a, "keydown", e);
                    this.removeInputKeydownHandler = ()=>{
                        s(), l();
                    };
                }
            }
            onInputNavTerminate() {
                let e = this.chart.rangeSelector || {};
                e.maxInput && e.hideInput("max"), e.minInput && e.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
            }
            initDropdownNav() {
                let e = this.chart, t = e.rangeSelector, i = t && t.dropdown;
                t && i && (e.setFocusToElement(t.buttonGroup, i), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = (0, x.addEvent)(i, "keydown", (t)=>{
                    let i = (t.which || t.keyCode) === this.keyCodes.tab, r = e.accessibility;
                    i && (t.preventDefault(), t.stopPropagation(), r && r.keyboardNavigation.move(t.shiftKey ? -1 : 1));
                }));
            }
            getRangeSelectorButtonNavigation() {
                let e = this.chart, t = this.keyCodes, i = this;
                return new X(e, {
                    keyCodeMap: [
                        [
                            [
                                t.left,
                                t.right,
                                t.up,
                                t.down
                            ],
                            function(e) {
                                return i.onButtonNavKbdArrowKey(this, e);
                            }
                        ],
                        [
                            [
                                t.enter,
                                t.space
                            ],
                            function() {
                                return i.onButtonNavKbdClick(this);
                            }
                        ]
                    ],
                    validate: function() {
                        return !!(e.rangeSelector && e.rangeSelector.buttons && e.rangeSelector.buttons.length);
                    },
                    init: function(t) {
                        let r = e.rangeSelector;
                        if (r && r.hasVisibleDropdown) i.initDropdownNav();
                        else if (r) {
                            let i = r.buttons.length - 1;
                            e.highlightRangeSelectorButton(t > 0 ? 0 : i);
                        }
                    },
                    terminate: function() {
                        i.removeDropdownKeydownHandler && (i.removeDropdownKeydownHandler(), delete i.removeDropdownKeydownHandler);
                    }
                });
            }
            getRangeSelectorInputNavigation() {
                let e = this.chart, t = this;
                return new X(e, {
                    keyCodeMap: [],
                    validate: function() {
                        return !!(e.rangeSelector && e.rangeSelector.inputGroup && "hidden" !== e.rangeSelector.inputGroup.element.style.visibility && !1 !== e.options.rangeSelector.inputEnabled && e.rangeSelector.minInput && e.rangeSelector.maxInput);
                    },
                    init: function(e) {
                        t.onInputNavInit(e);
                    },
                    terminate: function() {
                        t.onInputNavTerminate();
                    }
                });
            }
            getKeyboardNavigation() {
                return [
                    this.getRangeSelectorButtonNavigation(),
                    this.getRangeSelectorInputNavigation()
                ];
            }
            destroy() {
                this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
            }
        }
        function im(e) {
            let t = this.rangeSelector && this.rangeSelector.buttons || [], i = this.highlightedRangeSelectorItemIx, r = this.rangeSelector && this.rangeSelector.selected;
            return void 0 !== i && t[i] && i !== r && t[i].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = e, !!t[e] && (this.setFocusToElement(t[e].box, t[e].element), e !== r && (this.oldRangeSelectorItemState = t[e].state, t[e].setState(1)), !0);
        }
        function ib() {
            let e = this.chart.accessibility;
            if (e && e.components.rangeSelector) return e.components.rangeSelector.onAfterBtnClick();
        }
        (ig || (ig = {})).compose = function(e, t) {
            let i = e.prototype;
            i.highlightRangeSelectorButton || (i.highlightRangeSelectorButton = im, (0, x.addEvent)(t, "afterBtnClick", ib));
        };
        let ix = ig, { composed: iy } = y();
        !function(e) {
            function t(e) {
                (0, x.merge)(!0, e, {
                    marker: {
                        enabled: !0,
                        states: {
                            normal: {
                                opacity: 0
                            }
                        }
                    }
                });
            }
            function i(e) {
                return e.marker.states && e.marker.states.normal && e.marker.states.normal.opacity;
            }
            function r(e) {
                return !!(e._hasPointMarkers && e.points && e.points.length);
            }
            function s() {
                this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), r(this) && this.points.forEach((e)=>{
                    e.graphic && (e.graphic[e.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), e.graphic[!1 === e.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
                }));
            }
            function n(e) {
                this.resetA11yMarkerOptions = (0, x.merge)(e.options.marker || {}, this.userOptions.marker || {});
            }
            function o() {
                let e = this.options;
                !function(e) {
                    let t, i = e.chart.options.accessibility.enabled, r = !1 !== (e.options.accessibility && e.options.accessibility.enabled);
                    return i && r && (t = e.chart.options.accessibility, e.points.length < t.series.pointDescriptionEnabledThreshold || !1 === t.series.pointDescriptionEnabledThreshold);
                }(this) ? this.a11yMarkersForced ? (delete this.a11yMarkersForced, this.isDirty = !0, function(e) {
                    let t = e.resetA11yMarkerOptions;
                    if (t) {
                        let i = t.states && t.states.normal && t.states.normal.opacity;
                        e.chart.styledMode && !1 === t.enabled && a(e), e.userOptions && e.userOptions.marker && (e.userOptions.marker.enabled = !0), e.update({
                            marker: {
                                enabled: t.enabled,
                                states: {
                                    normal: {
                                        opacity: i
                                    }
                                }
                            }
                        });
                    }
                }(this), e.marker?.enabled === !1 && delete this.resetA11yMarkerOptions) : this.chart.styledMode && e.marker?.enabled === !1 && !r(this) && a(this) : (e.marker?.enabled === !1 && (this.a11yMarkersForced = !0, t(this.options)), r(this) && function(e) {
                    let r = e.points.length;
                    for(; r--;){
                        let n = e.points[r], o = n.options, a = n.hasForcedA11yMarker;
                        if (delete n.hasForcedA11yMarker, o.marker) {
                            var s;
                            let e = a && 0 === i(o);
                            o.marker.enabled && !e ? (s = o, (0, x.merge)(!0, s.marker, {
                                states: {
                                    normal: {
                                        opacity: i(s) || 1
                                    }
                                }
                            }), n.hasForcedA11yMarker = !1) : !1 === o.marker.enabled && (t(o), n.hasForcedA11yMarker = !0);
                        }
                    }
                }(this));
            }
            function a(e) {
                e.points?.forEach((e)=>{
                    e.graphic && (e.graphic = e.graphic.destroy());
                });
            }
            function l() {
                this.boosted && this.a11yMarkersForced && ((0, x.merge)(!0, this.options, {
                    marker: {
                        enabled: !1
                    }
                }), delete this.a11yMarkersForced);
            }
            e.compose = function(e) {
                (0, x.pushUnique)(iy, "A11y.FM") && ((0, x.addEvent)(e, "afterSetOptions", n), (0, x.addEvent)(e, "render", o), (0, x.addEvent)(e, "afterRender", s), (0, x.addEvent)(e, "renderCanvas", l));
            };
        }(p || (p = {}));
        let iv = p;
        var iE = b(260), iw = b.n(iE), iA = b(820), iT = b.n(iA);
        let { seriesTypes: iM } = tl(), { doc: iC } = y(), { getPointFromXY: iS, getSeriesFromName: ik, scrollAxisToPoint: iP } = H;
        function iD(e) {
            let t = e.index, i = e.series.points, r = i.length;
            if (i[t] === e) return t;
            for(; r--;)if (i[r] === e) return r;
        }
        function iN(e) {
            let t = e.chart.options.accessibility.keyboardNavigation.seriesNavigation, i = e.options.accessibility || {}, r = i.keyboardNavigation;
            return r && !1 === r.enabled || !1 === i.enabled || !1 === e.options.enableMouseTracking || !e.visible || t.pointNavigationEnabledThreshold && +t.pointNavigationEnabledThreshold <= e.points.length;
        }
        function iB(e) {
            let t = e.series, i = t.options.nullInteraction, r = e.options.accessibility, s = t.chart.options.accessibility, n = r?.enabled === !1, o = s.keyboardNavigation.seriesNavigation.skipNullPoints ?? !i;
            return e.isNull && o || !1 === e.visible || !1 === e.isInside || n || iN(t);
        }
        function iI(e) {
            let t = e.series || [], i = t.length;
            for(let e = 0; e < i; ++e)if (!iN(t[e])) {
                let i = function(e) {
                    let t = e.points || [], i = t.length;
                    for(let e = 0; e < i; ++e)if (!iB(t[e])) return t[e];
                    return null;
                }(t[e]);
                if (i) return i;
            }
            return null;
        }
        function iF(e) {
            let t = e.series.length, i = !1;
            for(; t-- && (e.highlightedPoint = e.series[t].points[e.series[t].points.length - 1], !(i = e.series[t].highlightNextValidPoint())););
            return i;
        }
        function iO(e) {
            delete e.highlightedPoint;
            let t = iI(e);
            return !!t && t.highlight();
        }
        class iR {
            constructor(e, t){
                this.keyCodes = t, this.chart = e;
            }
            init() {
                let e = this, t = this.chart, i = this.eventProvider = new G;
                i.addEvent(iT(), "destroy", function() {
                    return e.onSeriesDestroy(this);
                }), i.addEvent(t, "afterApplyDrilldown", function() {
                    let e;
                    (e = iI(this)) && e.highlight(!1);
                }), i.addEvent(t, "drilldown", function(t) {
                    let i = t.point, r = i.series;
                    e.lastDrilledDownPoint = {
                        x: i.x,
                        y: i.y,
                        seriesName: r ? r.name : ""
                    };
                }), i.addEvent(t, "drillupall", function() {
                    setTimeout(function() {
                        e.onDrillupAll();
                    }, 10);
                }), i.addEvent(iw(), "afterSetState", function() {
                    let e = this.graphic && this.graphic.element, i = iC.activeElement, r = i && i.getAttribute("class"), s = r && r.indexOf("highcharts-a11y-proxy-element") > -1;
                    t.highlightedPoint === this && i !== e && !s && e && e.focus && e.focus();
                });
            }
            onDrillupAll() {
                let e, t = this.lastDrilledDownPoint, i = this.chart, r = t && ik(i, t.seriesName);
                t && r && (0, x.defined)(t.x) && (0, x.defined)(t.y) && (e = iS(r, t.x, t.y)), e = e || iI(i), i.container && i.container.focus(), e && e.highlight && e.highlight(!1);
            }
            getKeyboardNavigationHandler() {
                let e = this, t = this.keyCodes, i = this.chart, r = i.inverted;
                return new X(i, {
                    keyCodeMap: [
                        [
                            r ? [
                                t.up,
                                t.down
                            ] : [
                                t.left,
                                t.right
                            ],
                            function(t) {
                                return e.onKbdSideways(this, t);
                            }
                        ],
                        [
                            r ? [
                                t.left,
                                t.right
                            ] : [
                                t.up,
                                t.down
                            ],
                            function(t) {
                                return e.onKbdVertical(this, t);
                            }
                        ],
                        [
                            [
                                t.enter,
                                t.space
                            ],
                            function(e, t) {
                                let r = i.highlightedPoint;
                                if (r) {
                                    let { plotLeft: e, plotTop: i } = this.chart, { plotX: s = 0, plotY: n = 0 } = r;
                                    t = {
                                        ...t,
                                        chartX: e + s,
                                        chartY: i + n,
                                        point: r,
                                        target: r.graphic?.element || t.target
                                    }, (0, x.fireEvent)(r.series, "click", t), r.firePointEvent("click", t);
                                }
                                return this.response.success;
                            }
                        ],
                        [
                            [
                                t.home
                            ],
                            function() {
                                return iO(i), this.response.success;
                            }
                        ],
                        [
                            [
                                t.end
                            ],
                            function() {
                                return iF(i), this.response.success;
                            }
                        ],
                        [
                            [
                                t.pageDown,
                                t.pageUp
                            ],
                            function(e) {
                                return i.highlightAdjacentSeries(e === t.pageDown), this.response.success;
                            }
                        ]
                    ],
                    init: function() {
                        return e.onHandlerInit(this);
                    },
                    validate: function() {
                        return !!iI(i);
                    },
                    terminate: function() {
                        return e.onHandlerTerminate();
                    }
                });
            }
            onKbdSideways(e, t) {
                let i = this.keyCodes, r = t === i.right || t === i.down;
                return this.attemptHighlightAdjacentPoint(e, r);
            }
            onHandlerInit(e) {
                let t = this.chart;
                return t.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && t.highlightedPoint ? t.highlightedPoint.highlight() : iO(t), e.response.success;
            }
            onKbdVertical(e, t) {
                let i = this.chart, r = this.keyCodes, s = t === r.down || t === r.right, n = i.options.accessibility.keyboardNavigation.seriesNavigation;
                if (n.mode && "serialize" === n.mode) return this.attemptHighlightAdjacentPoint(e, s);
                let o = i.highlightedPoint && i.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
                return i[o](s), e.response.success;
            }
            onHandlerTerminate() {
                let e = this.chart, t = e.options.accessibility.keyboardNavigation;
                e.tooltip && e.tooltip.hide(0);
                let i = e.highlightedPoint && e.highlightedPoint.series;
                i && i.onMouseOut && i.onMouseOut(), e.highlightedPoint && e.highlightedPoint.onMouseOut && e.highlightedPoint.onMouseOut(), t.seriesNavigation.rememberPointFocus || delete e.highlightedPoint;
            }
            attemptHighlightAdjacentPoint(e, t) {
                let i = this.chart, r = i.options.accessibility.keyboardNavigation.wrapAround;
                return i.highlightAdjacentPoint(t) ? e.response.success : r && (t ? iO(i) : iF(i)) ? e.response.success : e.response[t ? "next" : "prev"];
            }
            onSeriesDestroy(e) {
                let t = this.chart;
                t.highlightedPoint && t.highlightedPoint.series === e && (delete t.highlightedPoint, t.focusElement && t.focusElement.removeFocusBorder());
            }
            destroy() {
                this.eventProvider.removeAddedEvents();
            }
        }
        !function(e) {
            function t(e) {
                let t, i, r = this.series, s = this.highlightedPoint, n = s && iD(s) || 0, o = s && s.series.points || [], a = this.series && this.series[this.series.length - 1], l = a && a.points && a.points[a.points.length - 1];
                if (!r[0] || !r[0].points) return !1;
                if (s) {
                    if (t = r[s.series.index + (e ? 1 : -1)], (i = o[n + (e ? 1 : -1)]) || !t || (i = t.points[e ? 0 : t.points.length - 1]), !i) return !1;
                } else i = e ? r[0].points[0] : l;
                return iB(i) ? (iN(t = i.series) ? this.highlightedPoint = e ? t.points[t.points.length - 1] : t.points[0] : this.highlightedPoint = i, this.highlightAdjacentPoint(e)) : i.highlight();
            }
            function i(e) {
                let t = this.highlightedPoint, i = 1 / 0, r;
                return !!(0, x.defined)(t.plotX) && !!(0, x.defined)(t.plotY) && (this.series.forEach((s)=>{
                    iN(s) || s.points.forEach((n)=>{
                        if (!(0, x.defined)(n.plotY) || !(0, x.defined)(n.plotX) || n === t) return;
                        let o = n.plotY - t.plotY, a = Math.abs(n.plotX - t.plotX), l = Math.abs(o) * Math.abs(o) + a * a * 4;
                        s.yAxis && s.yAxis.reversed && (o *= -1), !(o <= 0 && e || o >= 0 && !e || l < 5 || iB(n)) && l < i && (i = l, r = n);
                    });
                }), !!r && r.highlight());
            }
            function r(e) {
                let t, i, r, s = this.highlightedPoint, n = this.series && this.series[this.series.length - 1], o = n && n.points && n.points[n.points.length - 1];
                return this.highlightedPoint ? !!(t = this.series[s.series.index + (e ? -1 : 1)]) && !!(i = function(e, t) {
                    let i = 1 / 0, r, s, n, o = t.points.length, a = (e)=>!((0, x.defined)(e.plotX) && (0, x.defined)(e.plotY));
                    if (!a(e)) {
                        for(; o--;)!a(r = t.points[o]) && (n = (e.plotX - r.plotX) * (e.plotX - r.plotX) * 4 + (e.plotY - r.plotY) * (e.plotY - r.plotY) * 1) < i && (i = n, s = o);
                        return (0, x.defined)(s) ? t.points[s] : void 0;
                    }
                }(s, t)) && (iN(t) ? (i.highlight(), r = this.highlightAdjacentSeries(e)) ? r : (s.highlight(), !1) : (i.highlight(), i.series.highlightNextValidPoint())) : (t = e ? this.series && this.series[0] : n, !!(i = e ? t && t.points && t.points[0] : o) && i.highlight());
            }
            function s(e = !0) {
                let t = this.series.chart, i = t.tooltip?.label?.element;
                (!this.isNull || this.series.options?.nullInteraction) && e ? this.onMouseOver() : t.tooltip && t.tooltip.hide(0), iP(this), this.graphic && (t.setFocusToElement(this.graphic), !e && t.focusElement && t.focusElement.removeFocusBorder()), t.highlightedPoint = this;
                let r = i?.getBoundingClientRect().top;
                if (i && r && r < 0) {
                    let e = window.scrollY;
                    window.scrollTo({
                        behavior: "smooth",
                        top: e + r
                    });
                }
                return this;
            }
            function n() {
                let e = this.chart.highlightedPoint, t = (e && e.series) === this ? iD(e) : 0, i = this.points, r = i.length;
                if (i && r) {
                    for(let e = t; e < r; ++e)if (!iB(i[e])) return i[e].highlight();
                    for(let e = t; e >= 0; --e)if (!iB(i[e])) return i[e].highlight();
                }
                return !1;
            }
            e.compose = function(e, o, a) {
                let l = e.prototype, h = o.prototype, d = a.prototype;
                l.highlightAdjacentPoint || (l.highlightAdjacentPoint = t, l.highlightAdjacentPointVertical = i, l.highlightAdjacentSeries = r, h.highlight = s, d.keyboardMoveVertical = !0, [
                    "column",
                    "gantt",
                    "pie"
                ].forEach((e)=>{
                    iM[e] && (iM[e].prototype.keyboardMoveVertical = !1);
                }), d.highlightNextValidPoint = n);
            };
        }(iR || (iR = {}));
        let iL = iR, { hideSeriesFromAT: iH } = H, { compose: iz, describeSeries: iq } = tJ, iU = class extends W {
            static compose(e, t, i) {
                t9.compose(i), iv.compose(i), iz(t), iL.compose(e, t, i);
            }
            init() {
                this.newDataAnnouncer = new t9(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new iL(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
            }
            hideTooltipFromATWhenShown() {
                let e = this;
                this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
                    this.chart === e.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
                });
            }
            hideSeriesLabelsFromATWhenShown() {
                this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
                    this.series.forEach(function(e) {
                        e.labelBySeries && e.labelBySeries.attr("aria-hidden", !0);
                    });
                });
            }
            onChartRender() {
                this.chart.series.forEach(function(e) {
                    !1 !== (e.options.accessibility && e.options.accessibility.enabled) && e.visible && 0 !== e.getPointsCollection().length ? iq(e) : iH(e);
                });
            }
            getKeyboardNavigation() {
                return this.keyboardNavigation.getKeyboardNavigationHandler();
            }
            destroy() {
                this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
            }
        }, { unhideChartElementFromAT: iG } = H, { getFakeMouseEvent: iK } = C, iV = class extends W {
            constructor(){
                super(...arguments), this.focusedMapNavButtonIx = -1;
            }
            init() {
                let e = this, t = this.chart;
                this.proxyProvider.addGroup("zoom", "div"), [
                    "afterShowResetZoom",
                    "afterApplyDrilldown",
                    "drillupall"
                ].forEach((i)=>{
                    e.addEvent(t, i, function() {
                        e.updateProxyOverlays();
                    });
                });
            }
            onChartUpdate() {
                let e = this.chart, t = this;
                e.mapNavigation && e.mapNavigation.navButtons.forEach((i, r)=>{
                    iG(e, i.element), t.setMapNavButtonAttrs(i.element, "accessibility.zoom.mapZoom" + (r ? "Out" : "In"));
                });
            }
            setMapNavButtonAttrs(e, t) {
                let i = this.chart, r = i.langFormat(t, {
                    chart: i
                });
                (0, x.attr)(e, {
                    tabindex: -1,
                    role: "button",
                    "aria-label": r
                });
            }
            onChartRender() {
                this.updateProxyOverlays();
            }
            updateProxyOverlays() {
                let e = this.chart;
                if (this.proxyProvider.clearGroup("zoom"), e.resetZoomButton && this.createZoomProxyButton(e.resetZoomButton, "resetZoomProxyButton", e.langFormat("accessibility.zoom.resetZoomButton", {
                    chart: e
                })), e.drillUpButton && e.breadcrumbs && e.breadcrumbs.list) {
                    let t = e.breadcrumbs.list[e.breadcrumbs.list.length - 1];
                    this.createZoomProxyButton(e.drillUpButton, "drillUpProxyButton", e.langFormat("accessibility.drillUpButton", {
                        chart: e,
                        buttonText: e.breadcrumbs.getButtonText(t)
                    }));
                }
            }
            createZoomProxyButton(e, t, i) {
                this[t] = this.proxyProvider.addProxyElement("zoom", {
                    click: e
                }, "button", {
                    "aria-label": i,
                    tabindex: -1
                });
            }
            getMapZoomNavigation() {
                let e = this.keyCodes, t = this.chart, i = this;
                return new X(t, {
                    keyCodeMap: [
                        [
                            [
                                e.up,
                                e.down,
                                e.left,
                                e.right
                            ],
                            function(e) {
                                return i.onMapKbdArrow(this, e);
                            }
                        ],
                        [
                            [
                                e.tab
                            ],
                            function(e, t) {
                                return i.onMapKbdTab(this, t);
                            }
                        ],
                        [
                            [
                                e.space,
                                e.enter
                            ],
                            function() {
                                return i.onMapKbdClick(this);
                            }
                        ]
                    ],
                    validate: function() {
                        return !!(t.mapView && t.mapNavigation && t.mapNavigation.navButtons.length);
                    },
                    init: function(e) {
                        return i.onMapNavInit(e);
                    }
                });
            }
            onMapKbdArrow(e, t) {
                let i = this.chart, r = this.keyCodes, s = i.container, n = t === r.up || t === r.down, o = t === r.left || t === r.up ? 1 : -1, a = (n ? i.plotHeight : i.plotWidth) / 10 * o, l = 10 * Math.random(), h = {
                    x: s.offsetLeft + i.plotLeft + i.plotWidth / 2 + l,
                    y: s.offsetTop + i.plotTop + i.plotHeight / 2 + l
                }, d = n ? {
                    x: h.x,
                    y: h.y + a
                } : {
                    x: h.x + a,
                    y: h.y
                };
                return [
                    iK("mousedown", h),
                    iK("mousemove", d),
                    iK("mouseup", d)
                ].forEach((e)=>s.dispatchEvent(e)), e.response.success;
            }
            onMapKbdTab(e, t) {
                let i = this.chart, r = e.response, s = t.shiftKey, n = s && !this.focusedMapNavButtonIx || !s && this.focusedMapNavButtonIx;
                if (i.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), n) return i.mapView && i.mapView.zoomBy(), r[s ? "prev" : "next"];
                this.focusedMapNavButtonIx += s ? -1 : 1;
                let o = i.mapNavigation.navButtons[this.focusedMapNavButtonIx];
                return i.setFocusToElement(o.box, o.element), o.setState(2), r.success;
            }
            onMapKbdClick(e) {
                let t = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
                return this.fakeClickEvent(t), e.response.success;
            }
            onMapNavInit(e) {
                let t = this.chart, i = t.mapNavigation.navButtons[0], r = t.mapNavigation.navButtons[1], s = e > 0 ? i : r;
                t.setFocusToElement(s.box, s.element), s.setState(2), this.focusedMapNavButtonIx = e > 0 ? 0 : 1;
            }
            simpleButtonNavigation(e, t, i) {
                let r = this.keyCodes, s = this, n = this.chart;
                return new X(n, {
                    keyCodeMap: [
                        [
                            [
                                r.tab,
                                r.up,
                                r.down,
                                r.left,
                                r.right
                            ],
                            function(e, t) {
                                let i = e === r.tab && t.shiftKey || e === r.left || e === r.up;
                                return this.response[i ? "prev" : "next"];
                            }
                        ],
                        [
                            [
                                r.space,
                                r.enter
                            ],
                            function() {
                                return i(this, n) ?? this.response.success;
                            }
                        ]
                    ],
                    validate: function() {
                        return n[e] && n[e].box && s[t].innerElement;
                    },
                    init: function() {
                        n.setFocusToElement(n[e].box, s[t].innerElement);
                    }
                });
            }
            getKeyboardNavigation() {
                return [
                    this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(e, t) {
                        t.zoomOut();
                    }),
                    this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(e, t) {
                        return t.drillUp(), e.response.prev;
                    }),
                    this.getMapZoomNavigation()
                ];
            }
        }, { doc: iW, isMS: iX, win: iY } = y(), ij = function() {
            if (iX && iY.getComputedStyle) {
                let e = iW.createElement("div");
                e.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", iW.body.appendChild(e);
                let t = (e.currentStyle || iY.getComputedStyle(e)).backgroundImage;
                return iW.body.removeChild(e), "none" === t;
            }
            return iY.matchMedia && iY.matchMedia("(forced-colors: active)").matches;
        }, iZ = function(e) {
            let t = e.highContrastState || (e.highContrastState = {});
            t.active = !0, t.applying = !0;
            try {
                let t = e.options.accessibility.highContrastTheme;
                e.update(t, !1);
                let i = t.colors?.length > 1;
                e.series.forEach(function(e) {
                    let r = t.plotOptions[e.type] || {}, s = i && void 0 !== e.colorIndex ? t.colors[e.colorIndex] : r.color || "window", n = {
                        color: r.color || "windowText",
                        colors: i ? t.colors : [
                            r.color || "windowText"
                        ],
                        borderColor: r.borderColor || "window",
                        fillColor: s
                    };
                    e.update(n, !1), e.points && e.points.forEach(function(e) {
                        e.options && e.options.color && e.update({
                            color: r.color || "windowText",
                            borderColor: r.borderColor || "window"
                        }, !1);
                    });
                }), e.redraw();
            } finally{
                delete t.applying;
            }
        }, i_ = {
            chart: {
                backgroundColor: "window"
            },
            title: {
                style: {
                    color: "windowText"
                }
            },
            subtitle: {
                style: {
                    color: "windowText"
                }
            },
            colorAxis: {
                minColor: "windowText",
                maxColor: "windowText",
                stops: [],
                dataClasses: []
            },
            colors: [
                "windowText"
            ],
            xAxis: {
                gridLineColor: "windowText",
                labels: {
                    style: {
                        color: "windowText"
                    }
                },
                lineColor: "windowText",
                minorGridLineColor: "windowText",
                tickColor: "windowText",
                title: {
                    style: {
                        color: "windowText"
                    }
                }
            },
            yAxis: {
                gridLineColor: "windowText",
                labels: {
                    style: {
                        color: "windowText"
                    }
                },
                lineColor: "windowText",
                minorGridLineColor: "windowText",
                tickColor: "windowText",
                title: {
                    style: {
                        color: "windowText"
                    }
                }
            },
            tooltip: {
                backgroundColor: "window",
                borderColor: "windowText",
                style: {
                    color: "windowText"
                }
            },
            plotOptions: {
                series: {
                    lineColor: "windowText",
                    fillColor: "window",
                    borderColor: "windowText",
                    edgeColor: "windowText",
                    borderWidth: 1,
                    dataLabels: {
                        connectorColor: "windowText",
                        color: "windowText",
                        style: {
                            color: "windowText",
                            textOutline: "none"
                        }
                    },
                    marker: {
                        lineColor: "windowText",
                        fillColor: "windowText"
                    }
                },
                pie: {
                    color: "window",
                    colors: [
                        "window"
                    ],
                    borderColor: "windowText",
                    borderWidth: 1
                },
                boxplot: {
                    fillColor: "window"
                },
                candlestick: {
                    lineColor: "windowText",
                    fillColor: "window"
                },
                errorbar: {
                    fillColor: "window"
                }
            },
            legend: {
                backgroundColor: "window",
                itemStyle: {
                    color: "windowText"
                },
                itemHoverStyle: {
                    color: "windowText"
                },
                itemHiddenStyle: {
                    color: "#555"
                },
                title: {
                    style: {
                        color: "windowText"
                    }
                }
            },
            credits: {
                style: {
                    color: "windowText"
                }
            },
            drilldown: {
                activeAxisLabelStyle: {
                    color: "windowText"
                },
                activeDataLabelStyle: {
                    color: "windowText"
                }
            },
            navigation: {
                buttonOptions: {
                    symbolStroke: "windowText",
                    theme: {
                        fill: "window"
                    }
                }
            },
            rangeSelector: {
                buttonTheme: {
                    fill: "window",
                    stroke: "windowText",
                    style: {
                        color: "windowText"
                    },
                    states: {
                        hover: {
                            fill: "window",
                            stroke: "windowText",
                            style: {
                                color: "windowText"
                            }
                        },
                        select: {
                            fill: "#444",
                            stroke: "windowText",
                            style: {
                                color: "windowText"
                            }
                        }
                    }
                },
                inputBoxBorderColor: "windowText",
                inputStyle: {
                    backgroundColor: "window",
                    color: "windowText"
                },
                labelStyle: {
                    color: "windowText"
                }
            },
            navigator: {
                handles: {
                    backgroundColor: "window",
                    borderColor: "windowText"
                },
                outlineColor: "windowText",
                maskFill: "transparent",
                series: {
                    color: "windowText",
                    lineColor: "windowText"
                },
                xAxis: {
                    gridLineColor: "windowText"
                }
            },
            scrollbar: {
                barBackgroundColor: "#444",
                barBorderColor: "windowText",
                buttonArrowColor: "windowText",
                buttonBackgroundColor: "window",
                buttonBorderColor: "windowText",
                rifleColor: "windowText",
                trackBackgroundColor: "window",
                trackBorderColor: "windowText"
            }
        };
        function i$(e, t, i) {
            let r = e, s, n = 0;
            for(; n < t.length - 1; ++n)r = r[s = t[n]] = r[s] ?? {};
            r[t[t.length - 1]] = i;
        }
        function iQ(e, t, i, r) {
            function s(e, t) {
                return t.reduce(function(e, t) {
                    return e[t];
                }, e);
            }
            let n = s(e.options, t), o = s(e.options, i);
            Object.keys(r).forEach(function(s) {
                let a = n[s];
                void 0 !== a && (i$(o, r[s], a), (0, x.error)(32, !1, e, {
                    [t.join(".") + "." + s]: i.join(".") + "." + r[s].join(".")
                }));
            });
        }
        let iJ = function(e) {
            let t, i, r;
            t = e.options.chart, i = e.options.accessibility || {}, [
                "description",
                "typeDescription"
            ].forEach(function(r) {
                t[r] && (i[r] = t[r], (0, x.error)(32, !1, e, {
                    [`chart.${r}`]: `use accessibility.${r}`
                }));
            }), e.axes.forEach(function(t) {
                let i = t.options;
                i && i.description && (i.accessibility = i.accessibility || {}, i.accessibility.description = i.description, (0, x.error)(32, !1, e, {
                    "axis.description": "use axis.accessibility.description"
                }));
            }), e.series && (r = {
                description: [
                    "accessibility",
                    "description"
                ],
                exposeElementToA11y: [
                    "accessibility",
                    "exposeAsGroupOnly"
                ],
                pointDescriptionFormat: [
                    "accessibility",
                    "point",
                    "descriptionFormat"
                ],
                pointDescriptionFormatter: [
                    "accessibility",
                    "point",
                    "descriptionFormatter"
                ],
                skipKeyboardNavigation: [
                    "accessibility",
                    "keyboardNavigation",
                    "enabled"
                ],
                "accessibility.pointDescriptionFormatter": [
                    "accessibility",
                    "point",
                    "descriptionFormatter"
                ]
            }, e.series.forEach(function(t) {
                Object.keys(r).forEach(function(i) {
                    let s = t.options[i];
                    "accessibility.pointDescriptionFormatter" === i && (s = t.options.accessibility && t.options.accessibility.pointDescriptionFormatter), void 0 !== s && (i$(t.options, r[i], "skipKeyboardNavigation" === i ? !s : s), (0, x.error)(32, !1, e, {
                        [`series.${i}`]: "series." + r[i].join(".")
                    }));
                });
            })), iQ(e, [
                "accessibility"
            ], [
                "accessibility"
            ], {
                pointDateFormat: [
                    "point",
                    "dateFormat"
                ],
                pointDateFormatter: [
                    "point",
                    "dateFormatter"
                ],
                pointDescriptionFormatter: [
                    "point",
                    "descriptionFormatter"
                ],
                pointDescriptionThreshold: [
                    "series",
                    "pointDescriptionEnabledThreshold"
                ],
                pointNavigationThreshold: [
                    "keyboardNavigation",
                    "seriesNavigation",
                    "pointNavigationEnabledThreshold"
                ],
                pointValueDecimals: [
                    "point",
                    "valueDecimals"
                ],
                pointValuePrefix: [
                    "point",
                    "valuePrefix"
                ],
                pointValueSuffix: [
                    "point",
                    "valueSuffix"
                ],
                screenReaderSectionFormatter: [
                    "screenReaderSection",
                    "beforeChartFormatter"
                ],
                describeSingleSeries: [
                    "series",
                    "describeSingleSeries"
                ],
                seriesDescriptionFormatter: [
                    "series",
                    "descriptionFormatter"
                ],
                onTableAnchorClick: [
                    "screenReaderSection",
                    "onViewDataTableClick"
                ],
                axisRangeDateFormat: [
                    "screenReaderSection",
                    "axisRangeDateFormat"
                ]
            }), iQ(e, [
                "accessibility",
                "keyboardNavigation"
            ], [
                "accessibility",
                "keyboardNavigation",
                "seriesNavigation"
            ], {
                skipNullPoints: [
                    "skipNullPoints"
                ],
                mode: [
                    "mode"
                ]
            }), iQ(e, [
                "lang",
                "accessibility"
            ], [
                "lang",
                "accessibility"
            ], {
                legendItem: [
                    "legend",
                    "legendItem"
                ],
                legendLabel: [
                    "legend",
                    "legendLabel"
                ],
                mapZoomIn: [
                    "zoom",
                    "mapZoomIn"
                ],
                mapZoomOut: [
                    "zoom",
                    "mapZoomOut"
                ],
                resetZoomButton: [
                    "zoom",
                    "resetZoomButton"
                ],
                screenReaderRegionLabel: [
                    "screenReaderSection",
                    "beforeRegionLabel"
                ],
                rangeSelectorButton: [
                    "rangeSelector",
                    "buttonText"
                ],
                rangeSelectorMaxInput: [
                    "rangeSelector",
                    "maxInputLabel"
                ],
                rangeSelectorMinInput: [
                    "rangeSelector",
                    "minInputLabel"
                ],
                svgContainerEnd: [
                    "screenReaderSection",
                    "endOfChartMarker"
                ],
                viewAsDataTable: [
                    "table",
                    "viewAsDataTableButtonText"
                ],
                tableSummary: [
                    "table",
                    "tableSummary"
                ]
            });
        }, { defaultOptions: i0 } = y(), { doc: i1 } = y(), { escapeStringForHTML: i2, removeElement: i3, stripHTMLTagsFromString: i5 } = C;
        class i4 {
            constructor(e){
                this.init(e);
            }
            init(e) {
                if (this.chart = e, !i1?.addEventListener) {
                    this.zombie = !0, this.components = {}, e.renderTo.setAttribute("aria-hidden", !0);
                    return;
                }
                iJ(e), this.proxyProvider = new ic(this.chart), this.initComponents(), this.keyboardNavigation = new eq(e, this.components);
            }
            initComponents() {
                let e = this.chart, t = this.proxyProvider, i = e.options.accessibility;
                this.components = {
                    container: new $,
                    infoRegions: new eC,
                    legend: new eJ,
                    chartMenu: new eB,
                    rangeSelector: new ix,
                    series: new iU,
                    zoom: new iV,
                    navigator: new tR
                }, i.customComponents && (0, x.extend)(this.components, i.customComponents);
                let r = this.components;
                this.getComponentOrder().forEach(function(i) {
                    r[i].initBase(e, t), r[i].init();
                });
            }
            getComponentOrder() {
                return this.components ? this.components.series ? [
                    "series"
                ].concat(Object.keys(this.components).filter((e)=>"series" !== e)) : Object.keys(this.components) : [];
            }
            update() {
                let e = this.components, t = this.chart, i = t.options.accessibility;
                (0, x.fireEvent)(t, "beforeA11yUpdate"), t.types = this.getChartTypes();
                let r = i.keyboardNavigation.order;
                this.proxyProvider.updateGroupOrder(r), this.getComponentOrder().forEach(function(i) {
                    e[i].onChartUpdate(), (0, x.fireEvent)(t, "afterA11yComponentUpdate", {
                        name: i,
                        component: e[i]
                    });
                }), this.keyboardNavigation.update(r), !t.highContrastState?.applying && !1 !== i.highContrastMode && (t.highContrastState?.active || ij() || !0 === i.highContrastMode) && iZ(t), (0, x.fireEvent)(t, "afterA11yUpdate", {
                    accessibility: this
                });
            }
            destroy() {
                let e = this.chart || {}, t = this.components;
                Object.keys(t).forEach(function(e) {
                    t[e].destroy(), t[e].destroyBase();
                }), this.proxyProvider && this.proxyProvider.destroy(), e.announcerContainer && i3(e.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), e.renderTo && e.renderTo.setAttribute("aria-hidden", !0), e.focusElement && e.focusElement.removeFocusBorder();
            }
            getChartTypes() {
                let e = {};
                return this.chart.series.forEach(function(t) {
                    e[t.type] = 1;
                }), Object.keys(e);
            }
        }
        !function(e) {
            function t() {
                this.accessibility && this.accessibility.destroy();
            }
            function i() {
                this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
                let e = this.accessibility;
                e && !e.zombie && (e.proxyProvider.updateProxyElementPositions(), e.getComponentOrder().forEach(function(t) {
                    e.components[t].onChartRender();
                }));
            }
            function r(e) {
                let t = this.accessibility;
                if (!t || t.zombie) return;
                let i = t.components.infoRegions, r = i && (i.getLongdescText() || i.getTypeDescriptionText());
                if (!r) return;
                let s = i2(i5(r, !0));
                if (!s.trim()) return;
                let n = e.chartCopy.renderer.box;
                n.querySelector(":scope > metadata")?.remove(), n.insertAdjacentHTML("afterbegin", '<metadata><rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"><rdf:Description><dc:description>' + s + "</dc:description></rdf:Description></rdf:RDF></metadata>");
            }
            function s(e) {
                let t = e.options.accessibility;
                t && (t.customComponents && (this.options.accessibility.customComponents = t.customComponents, delete t.customComponents), (0, x.merge)(!0, this.options.accessibility, t), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
            }
            function n() {
                let t = this.accessibility, i = this.options.accessibility, r = this.renderer.boxWrapper.element, s = this.title;
                if (i && i.enabled) t && !t.zombie ? t.update() : (this.accessibility = t = new e(this), t && !t.zombie && t.update(), "img" === r.getAttribute("role") && r.removeAttribute("role"));
                else if (t) t.destroy && t.destroy(), delete this.accessibility;
                else {
                    this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (s && s.element.textContent || "").replace(/</g, "&lt;")), r.setAttribute("aria-hidden", !0);
                    let e = document.getElementsByClassName("highcharts-description")[0];
                    e && (e.setAttribute("aria-hidden", !1), e.classList.remove("highcharts-linked-description"));
                }
            }
            function o() {
                this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
            }
            e.i18nFormat = I.i18nFormat, e.compose = function(e, a, l, h, d, c) {
                eq.compose(e), t9.compose(h), eJ.compose(e, a), eB.compose(e), iU.compose(e, l, h), I.compose(e), Q.compose(e, d), c && ix.compose(e, c);
                let u = e.prototype;
                u.updateA11yEnabled || (u.updateA11yEnabled = n, (0, x.addEvent)(e, "destroy", t), (0, x.addEvent)(e, "render", i), (0, x.addEvent)(e, "update", s), (0, x.addEvent)(e, "getSVG", r), [
                    "addSeries",
                    "init"
                ].forEach((t)=>{
                    (0, x.addEvent)(e, t, function() {
                        this.a11yDirty = !0;
                    });
                }), [
                    "afterApplyDrilldown",
                    "drillupall"
                ].forEach((t)=>{
                    (0, x.addEvent)(e, t, function() {
                        let e = this.accessibility;
                        e && !e.zombie && e.update();
                    });
                }), (0, x.addEvent)(l, "update", o), [
                    "update",
                    "updatedData",
                    "remove"
                ].forEach((e)=>{
                    (0, x.addEvent)(h, e, function() {
                        this.chart.accessibility && (this.chart.a11yDirty = !0);
                    });
                }));
            };
        }(i4 || (i4 = {})), (0, x.merge)(!0, i0, {
            accessibility: {
                enabled: !0,
                screenReaderSection: {
                    beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>",
                    afterChartFormat: "{endOfChartMarker}",
                    axisRangeDateFormat: "%Y-%m-%d %H:%M:%S"
                },
                series: {
                    descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}",
                    describeSingleSeries: !1,
                    pointDescriptionEnabledThreshold: 200
                },
                point: {
                    valueDescriptionFormat: "{xDescription}{separator}{value}.",
                    describeNull: !0
                },
                landmarkVerbosity: "all",
                linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description',
                highContrastMode: "auto",
                keyboardNavigation: {
                    enabled: !0,
                    focusBorder: {
                        enabled: !0,
                        hideBrowserFocusOutline: !0,
                        style: {
                            color: "var(--highcharts-highlight-color-80)",
                            lineWidth: 2,
                            borderRadius: 3
                        },
                        margin: 2
                    },
                    order: [
                        "series",
                        "zoom",
                        "rangeSelector",
                        "navigator",
                        "legend",
                        "chartMenu"
                    ],
                    wrapAround: !0,
                    seriesNavigation: {
                        skipNullPoints: void 0,
                        pointNavigationEnabledThreshold: !1,
                        rememberPointFocus: !1
                    }
                },
                announceNewData: {
                    enabled: !1,
                    minAnnounceInterval: 5e3,
                    interruptUser: !1
                }
            },
            legend: {
                accessibility: {
                    enabled: !0,
                    keyboardNavigation: {
                        enabled: !0
                    }
                }
            },
            exporting: {
                accessibility: {
                    enabled: !0
                }
            },
            navigator: {
                accessibility: {
                    enabled: !0
                }
            }
        }, {
            accessibility: {
                highContrastTheme: i_
            },
            lang: {
                accessibility: {
                    defaultChartTitle: "Chart",
                    chartContainerLabel: "{title}. Highcharts interactive chart.",
                    svgContainerLabel: "Interactive chart",
                    drillUpButton: "{buttonText}",
                    credits: "Chart credits: {creditsStr}",
                    thousandsSep: ",",
                    svgContainerTitle: "",
                    graphicContainerLabel: "",
                    screenReaderSection: {
                        beforeRegionLabel: "",
                        afterRegionLabel: "",
                        annotations: {
                            heading: "Chart annotations summary",
                            descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}",
                            descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}",
                            descriptionNoPoints: "{annotationText}"
                        },
                        endOfChartMarker: "End of interactive chart."
                    },
                    sonification: {
                        playAsSoundButtonText: "Play as sound, {chartTitle}",
                        playAsSoundClickAnnouncement: "Play"
                    },
                    legend: {
                        legendLabelNoTitle: "Toggle series visibility, {chartTitle}",
                        legendLabel: "Chart legend: {legendTitle}",
                        legendItem: "Show {itemName}"
                    },
                    zoom: {
                        mapZoomIn: "Zoom chart",
                        mapZoomOut: "Zoom out chart",
                        resetZoomButton: "Reset zoom"
                    },
                    rangeSelector: {
                        dropdownLabel: "{rangeTitle}",
                        minInputLabel: "Select start date.",
                        maxInputLabel: "Select end date.",
                        clickButtonAnnouncement: "Viewing {axisRangeDescription}"
                    },
                    navigator: {
                        handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}",
                        groupLabel: "Axis zoom",
                        changeAnnouncement: "{axisRangeDescription}"
                    },
                    stockTools: {
                        groupLabel: "Stock chart tools",
                        arrowLabel: "Toggle submenu"
                    },
                    table: {
                        viewAsDataTableButtonText: "View as data table, {chartTitle}",
                        tableSummary: "Table representation of chart."
                    },
                    announceNewData: {
                        newDataAnnounce: "Updated data for chart {chartTitle}",
                        newSeriesAnnounceSingle: "New data series: {seriesDesc}",
                        newPointAnnounceSingle: "New data point: {pointDesc}",
                        newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}",
                        newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}"
                    },
                    seriesTypeDescriptions: {
                        boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.",
                        arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.",
                        areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.",
                        bubble: "Bubble charts are scatter charts where each data point also has a size value.",
                        columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.",
                        errorbar: "Errorbar series are used to display the variability of the data.",
                        funnel: "Funnel charts are used to display reduction of data in stages.",
                        pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.",
                        waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value."
                    },
                    chartTypes: {
                        emptyChart: "Empty chart",
                        mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.",
                        unknownMap: "Map of unspecified region with {numSeries} data series.",
                        combinationChart: "Combination chart with {numSeries} data series.",
                        defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                        defaultMultiple: "Chart with {numSeries} data series.",
                        splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                        splineMultiple: "Line chart with {numSeries} lines.",
                        lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                        lineMultiple: "Line chart with {numSeries} lines.",
                        columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",
                        columnMultiple: "Bar chart with {numSeries} data series.",
                        barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",
                        barMultiple: "Bar chart with {numSeries} data series.",
                        pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.",
                        pieMultiple: "Pie chart with {numSeries} pies.",
                        scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.",
                        scatterMultiple: "Scatter chart with {numSeries} data series.",
                        boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.",
                        boxplotMultiple: "Boxplot with {numSeries} data series.",
                        bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.",
                        bubbleMultiple: "Bubble chart with {numSeries} data series."
                    },
                    axis: {
                        xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}",
                        xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",
                        yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}",
                        yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",
                        timeRangeDays: "Data range: {range} days.",
                        timeRangeHours: "Data range: {range} hours.",
                        timeRangeMinutes: "Data range: {range} minutes.",
                        timeRangeSeconds: "Data range: {range} seconds.",
                        rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.",
                        rangeCategories: "Data range: {numCategories} categories.",
                        defaultAxisNames: {
                            categories: "categories",
                            time: "Time",
                            values: "values"
                        }
                    },
                    exporting: {
                        chartMenuLabel: "Chart menu",
                        menuButtonLabel: "View chart context menu, {chartTitle}"
                    },
                    series: {
                        summary: {
                            default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",
                            pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",
                            scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",
                            scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",
                            boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",
                            boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",
                            bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                            bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                            map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",
                            mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",
                            mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                            mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}."
                        },
                        description: "{description}",
                        xAxisDescription: "X axis, {name}",
                        yAxisDescription: "Y axis, {name}",
                        nullPointValue: "No value",
                        pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}"
                    }
                }
            }
        });
        let i6 = i4, i8 = y();
        i8.i18nFormat = i6.i18nFormat, i8.A11yChartUtilities = H, i8.A11yHTMLUtilities = C, i8.AccessibilityComponent = W, i8.KeyboardNavigationHandler = X, i8.SeriesAccessibilityDescriber = tJ, i6.compose(i8.Chart, i8.Legend, i8.Point, i8.Series, i8.SVGElement, i8.RangeSelector);
        let i9 = y();
        return f.default;
    })());



var $d43e2ba1a704bc32$exports = {};
!/**
 * Highcharts JS v13.1.1 (2026-09-20)
 * @module highcharts/modules/exporting
 * @requires highcharts
 *
 * Exporting module
 *
 * (c) 2010-2026 Highsoft AS
 * Author: Torstein Hønsi
 *
 * A commercial license may be required depending on use,
 * see www.highcharts.com/license
 */ function(e, t) {
    $d43e2ba1a704bc32$exports = t(e._Highcharts.AST, e._Highcharts.Chart, e._Highcharts);
}("u" < typeof window ? $d43e2ba1a704bc32$exports : window, (e, t, n)=>(()=>{
        "use strict";
        var i, r, o = {
            660 (t) {
                t.exports = e;
            },
            960 (e) {
                e.exports = t;
            },
            944 (e) {
                e.exports = n;
            }
        };
        let a = {};
        function s(e) {
            let t = a[e];
            if (void 0 !== t) return t.exports;
            let n = a[e] = {
                exports: {}
            };
            return o[e](n, n.exports, s), n.exports;
        }
        s.n = (e)=>{
            let t = e && e.__esModule ? ()=>e.default : ()=>e;
            return s.d(t, {
                a: t
            }), t;
        }, s.d = (e, t)=>{
            for(var n in t)s.o(t, n) && !s.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, s.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t);
        let l = {};
        s.d(l, {
            default: ()=>$
        });
        var c = s(944), h = s.n(c), d = s(660), p = s.n(d), u = s(960), g = s.n(u), f = i || (i = {});
        f.compose = function(e) {
            return e.navigation || (e.navigation = new m(e)), e;
        };
        class m {
            constructor(e){
                this.updates = [], this.chart = e;
            }
            addUpdate(e) {
                this.chart.navigation.updates.push(e);
            }
            update(e, t) {
                this.updates.forEach((n)=>{
                    n.call(this.chart, e, t);
                });
            }
        }
        f.Additions = m;
        let y = i, { isSafari: x, win: v, win: { document: w } } = h(), b = v.URL || v.webkitURL || v;
        function S(e, t) {
            let n = v.navigator, i = w.createElement("a");
            if ("string" != typeof e && !(e instanceof String) && n.msSaveOrOpenBlob) return void n.msSaveOrOpenBlob(e, t);
            if (e = "" + e, n.userAgent.length > 1e3) throw Error("Input too long");
            let r = /Edge\/\d+/.test(n.userAgent);
            if ((x && "string" == typeof e && 0 === e.indexOf("data:application/pdf") || r || e.length > 2e6) && !(e = function(e) {
                let t = e.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
                if (t && t.length > 3 && v.atob && v.ArrayBuffer && v.Uint8Array && v.Blob && b.createObjectURL) {
                    let e = v.atob(t[3]), n = new v.ArrayBuffer(e.length), i = new v.Uint8Array(n);
                    for(let t = 0; t < i.length; ++t)i[t] = e.charCodeAt(t);
                    return b.createObjectURL(new v.Blob([
                        i
                    ], {
                        type: t[1]
                    }));
                }
            }(e) || "")) throw Error("Failed to convert to blob");
            if (void 0 !== i.download) i.href = e, i.download = t, w.body.appendChild(i), i.click(), w.body.removeChild(i);
            else try {
                if (!v.open(e, "chart")) throw Error("Failed to open window");
            } catch  {
                v.location.href = e;
            }
        }
        let { isTouchDevice: E } = h(), C = {
            exporting: {
                allowHTML: !0,
                allowTableSorting: !0,
                local: !0,
                type: "image/png",
                url: `https://export-svg.highcharts.com?v=${h().version}`,
                pdfFont: {
                    normal: void 0,
                    bold: void 0,
                    bolditalic: void 0,
                    italic: void 0
                },
                printMaxWidth: 780,
                scale: 2,
                buttons: {
                    contextButton: {
                        className: "highcharts-contextbutton",
                        menuClassName: "highcharts-contextmenu",
                        symbol: "menu",
                        titleKey: "contextButtonTitle",
                        menuItems: [
                            "viewFullscreen",
                            "printChart",
                            "separator",
                            "downloadPNG",
                            "downloadJPEG",
                            "downloadSVG"
                        ]
                    }
                },
                menuItemDefinitions: {
                    viewFullscreen: {
                        textKey: "viewFullscreen",
                        onclick: function() {
                            this.fullscreen?.toggle();
                        }
                    },
                    printChart: {
                        textKey: "printChart",
                        onclick: function() {
                            this.exporting?.print();
                        }
                    },
                    separator: {
                        separator: !0
                    },
                    downloadPNG: {
                        textKey: "downloadPNG",
                        onclick: async function() {
                            await this.exporting?.exportChart();
                        }
                    },
                    downloadJPEG: {
                        textKey: "downloadJPEG",
                        onclick: async function() {
                            await this.exporting?.exportChart({
                                type: "image/jpeg"
                            });
                        }
                    },
                    downloadPDF: {
                        textKey: "downloadPDF",
                        onclick: async function() {
                            await this.exporting?.exportChart({
                                type: "application/pdf"
                            });
                        }
                    },
                    downloadSVG: {
                        textKey: "downloadSVG",
                        onclick: async function() {
                            await this.exporting?.exportChart({
                                type: "image/svg+xml"
                            });
                        }
                    }
                }
            },
            lang: {
                viewFullscreen: "View in full screen",
                exitFullscreen: "Exit from full screen",
                printChart: "Print chart",
                downloadPNG: "Download PNG image",
                downloadJPEG: "Download JPEG image",
                downloadPDF: "Download PDF document",
                downloadSVG: "Download SVG vector image",
                contextButtonTitle: "Chart context menu"
            },
            navigation: {
                buttonOptions: {
                    symbolSize: 14,
                    symbolX: 14.5,
                    symbolY: 13.5,
                    align: "right",
                    buttonSpacing: 5,
                    height: 28,
                    y: -5,
                    verticalAlign: "top",
                    width: 28,
                    symbolFill: "var(--highcharts-neutral-color-60)",
                    symbolStroke: "var(--highcharts-neutral-color-60)",
                    symbolStrokeWidth: 3,
                    theme: {
                        fill: "var(--highcharts-background-color)",
                        padding: 5,
                        stroke: "none",
                        "stroke-linecap": "round"
                    }
                },
                menuStyle: {
                    border: "none",
                    borderRadius: "3px",
                    background: "var(--highcharts-background-color)",
                    padding: "0.5em"
                },
                menuItemStyle: {
                    background: "none",
                    borderRadius: "3px",
                    color: "var(--highcharts-neutral-color-80)",
                    padding: "0.5em",
                    fontSize: E ? "0.9em" : "0.8em",
                    transition: "background 250ms, color 250ms"
                },
                menuItemHoverStyle: {
                    background: "var(--highcharts-neutral-color-5)"
                }
            }
        };
        !function(e) {
            let t = [];
            function n(e, t, n, i) {
                return [
                    [
                        "M",
                        e,
                        t + 2.5
                    ],
                    [
                        "L",
                        e + n,
                        t + 2.5
                    ],
                    [
                        "M",
                        e,
                        t + i / 2 + .5
                    ],
                    [
                        "L",
                        e + n,
                        t + i / 2 + .5
                    ],
                    [
                        "M",
                        e,
                        t + i - 1.5
                    ],
                    [
                        "L",
                        e + n,
                        t + i - 1.5
                    ]
                ];
            }
            function i(e, t, n, i) {
                let r = i / 3 - 2, o = [];
                return o.concat(this.circle(n - r, t, r, r), this.circle(n - r, t + r + 4, r, r), this.circle(n - r, t + 2 * (r + 4), r, r));
            }
            e.compose = function(e) {
                if (-1 === t.indexOf(e)) {
                    t.push(e);
                    let r = e.prototype.symbols;
                    r.menu = n, r.menuball = i.bind(r);
                }
            };
        }(r || (r = {}));
        let O = r, { composed: T } = h();
        function F() {
            this.fullscreen = new k(this);
        }
        class k {
            static compose(e) {
                (0, c.pushUnique)(T, "Fullscreen") && (0, c.addEvent)(e, "beforeRender", F);
            }
            constructor(e){
                this.chart = e, this.isOpen = !1;
                let t = e.renderTo;
                !this.browserProps && ("function" == typeof t.requestFullscreen ? this.browserProps = {
                    fullscreenChange: "fullscreenchange",
                    requestFullscreen: "requestFullscreen",
                    exitFullscreen: "exitFullscreen"
                } : t.mozRequestFullScreen ? this.browserProps = {
                    fullscreenChange: "mozfullscreenchange",
                    requestFullscreen: "mozRequestFullScreen",
                    exitFullscreen: "mozCancelFullScreen"
                } : t.webkitRequestFullScreen ? this.browserProps = {
                    fullscreenChange: "webkitfullscreenchange",
                    requestFullscreen: "webkitRequestFullScreen",
                    exitFullscreen: "webkitExitFullscreen"
                } : t.msRequestFullscreen && (this.browserProps = {
                    fullscreenChange: "MSFullscreenChange",
                    requestFullscreen: "msRequestFullscreen",
                    exitFullscreen: "msExitFullscreen"
                }));
            }
            close() {
                let e = this, t = e.chart, n = t.options.chart;
                (0, c.fireEvent)(t, "fullscreenClose", void 0, function() {
                    e.isOpen && e.browserProps && t.container.ownerDocument instanceof Document && t.container.ownerDocument[e.browserProps.exitFullscreen](), e.unbindFullscreenEvent && (e.unbindFullscreenEvent = e.unbindFullscreenEvent()), t.setSize(e.origWidth, e.origHeight, !1), e.origWidth = void 0, e.origHeight = void 0, n.width = e.origWidthOption, n.height = e.origHeightOption, e.origWidthOption = void 0, e.origHeightOption = void 0, e.isOpen = !1, e.setButtonText();
                });
            }
            open() {
                let e = this, t = e.chart, n = t.options.chart;
                (0, c.fireEvent)(t, "fullscreenOpen", void 0, function() {
                    if (n && (e.origWidthOption = n.width, e.origHeightOption = n.height), e.origWidth = t.chartWidth, e.origHeight = t.chartHeight, e.browserProps) {
                        let n = (0, c.addEvent)(t.container.ownerDocument, e.browserProps.fullscreenChange, function() {
                            e.isOpen ? (e.isOpen = !1, e.close()) : (t.setSize(null, null, !1), e.isOpen = !0, e.setButtonText());
                        }), i = (0, c.addEvent)(t, "destroy", n);
                        e.unbindFullscreenEvent = ()=>{
                            n(), i();
                        };
                        let r = t.renderTo[e.browserProps.requestFullscreen]();
                        r && r.catch(function() {
                            alert("Full screen is not supported inside a frame.");
                        });
                    }
                });
            }
            setButtonText() {
                let e = this.chart, t = e.exporting?.divElements, n = e.options.exporting, i = n && n.buttons && n.buttons.contextButton.menuItems, r = e.options.lang;
                if (n?.menuItemDefinitions && r?.exitFullscreen && r.viewFullscreen && i && t) {
                    let e = t[i.indexOf("viewFullscreen")];
                    e && p().setElementHTML(e, this.isOpen ? r.exitFullscreen : n.menuItemDefinitions.viewFullscreen?.text || r.viewFullscreen);
                }
            }
            toggle() {
                this.isOpen ? this.close() : this.open();
            }
        }
        let { win: R } = h(), N = {
            ajax: function(e) {
                let t = {
                    json: "application/json",
                    xml: "application/xml",
                    text: "text/plain",
                    octet: "application/octet-stream"
                }, n = new XMLHttpRequest;
                function i(t, n) {
                    e.error && e.error(t, n);
                }
                if (!e.url) return !1;
                n.open((e.type || "get").toUpperCase(), e.url, !0), e.headers?.["Content-Type"] || n.setRequestHeader("Content-Type", t[e.dataType || "json"] || t.text), (0, c.objectEach)(e.headers, function(e, t) {
                    n.setRequestHeader(t, e);
                }), e.responseType && (n.responseType = e.responseType), n.onreadystatechange = function() {
                    let t;
                    if (4 === n.readyState) {
                        if (200 === n.status) {
                            if ("blob" !== e.responseType && (t = n.responseText, "json" === e.dataType)) try {
                                t = JSON.parse(t);
                            } catch (e) {
                                if (e instanceof Error) return i(n, e);
                            }
                            return e.success?.(t, n);
                        }
                        i(n, n.responseText);
                    }
                }, e.data && "string" != typeof e.data && (e.data = JSON.stringify(e.data)), n.send(e.data);
            },
            getJSON: function(e, t) {
                N.ajax({
                    url: e,
                    success: t,
                    dataType: "json",
                    headers: {
                        "Content-Type": "text/plain"
                    }
                });
            }
        };
        N.post = async function(e, t, n) {
            let i = new R.FormData;
            (0, c.objectEach)(t, function(e, t) {
                i.append(t, e);
            }), i.append("b64", "true");
            let r = await R.fetch(e, {
                method: "POST",
                body: i,
                ...n
            });
            if (r.ok) {
                let e = await r.text(), n = document.createElement("a");
                n.href = `data:${t.type};base64,${e}`, n.download = t.filename, n.click(), (0, c.discardElement)(n);
            }
        };
        let { defaultOptions: A, setOptions: M } = h(), { composed: P, doc: D, isFirefox: H, isMS: L, isSafari: I, SVG_NS: U, win: G } = h();
        p().allowedAttributes.push("data-z-index", "fill-opacity", "filter", "preserveAspectRatio", "rx", "ry", "stroke-dasharray", "stroke-linejoin", "stroke-opacity", "text-anchor", "transform", "transform-origin", "version", "viewBox", "visibility", "xmlns", "xmlns:xlink"), p().allowedTags.push("desc", "clippath", "fedropshadow", "femorphology", "g", "image");
        let j = G.URL || G.webkitURL || G;
        class B {
            constructor(e, t){
                this.options = {}, this.chart = e, this.options = t, this.btnCount = 0, this.buttonOffset = 0, this.divElements = [], this.svgElements = [];
            }
            static hyphenate(e) {
                return e.replace(/[A-Z]/g, function(e) {
                    return "-" + e.toLowerCase();
                });
            }
            static async imageToDataURL(e, t, n) {
                let i = await B.loadImage(e), r = D.createElement("canvas"), o = r?.getContext("2d");
                if (o) return r.height = i.height * t, r.width = i.width * t, o.drawImage(i, 0, 0, r.width, r.height), r.toDataURL(n);
                throw Error("No canvas found!");
            }
            static async fetchCSS(e) {
                try {
                    let t = await fetch(e), n = await t.text(), i = new CSSStyleSheet;
                    return i.replaceSync(n), i;
                } catch  {
                    (0, c.error)(`Warning: Failed to fetch CSS from ${e}`, !1);
                }
            }
            static extractFontFamilies(e) {
                return e ? e.split(",").map((e)=>e.trim().replace(/^['"]|['"]$/g, "")).filter(Boolean) : [];
            }
            static selectorAffectsSVG(e, t) {
                try {
                    if (t.matches(e)) return !0;
                    return !!t.querySelector(e);
                } catch  {
                    return !1;
                }
            }
            static collectSVGInlineFonts(e, t) {
                for (let n of [
                    e,
                    ...Array.from(e.querySelectorAll("text, tspan"))
                ]){
                    let e = n.getAttribute("style") || "", i = n.getAttribute("font-family") || "";
                    if (e.indexOf("font-family") > -1) {
                        let n = e.match(/font-family\s*:\s*([^;]+)/i);
                        for (let e of B.extractFontFamilies(n?.[1]))t.add(e);
                    }
                    for (let e of B.extractFontFamilies(i))t.add(e);
                }
            }
            static async handleStyleSheet(e, t, n, i, r = new Set) {
                let o = e.href;
                if (o) {
                    if (r.has(o)) return;
                    r.add(o);
                }
                try {
                    for (let a of Array.from(e.cssRules)){
                        if (a instanceof CSSImportRule) try {
                            let e = await B.fetchCSS(a.href);
                            e && await B.handleStyleSheet(e, t, n, i, r);
                        } catch  {}
                        if (a instanceof CSSStyleRule && B.selectorAffectsSVG(a.selectorText, i)) for (let e of B.extractFontFamilies(a.style.fontFamily))n.add(e);
                        if (a instanceof CSSFontFaceRule) {
                            let e = a.cssText;
                            if (o) {
                                let t = /url\(\s*(['"]?)(?![a-z]+:|\/\/)([^'")]+?)\1\s*\)/gi;
                                e = e.replace(t, (e, t, n)=>{
                                    let i = new URL(n, o).href;
                                    return `url(${t}${i}${t})`;
                                });
                            }
                            t.push(e);
                        }
                    }
                } catch (e) {
                    if ("SecurityError" === e.name && o) try {
                        let e = await B.fetchCSS(o);
                        e && await B.handleStyleSheet(e, t, n, i, r);
                    } catch  {}
                }
            }
            static async fetchStyleSheets(e) {
                let t = [], n = new Set;
                for (let i of (B.collectSVGInlineFonts(e, n), Array.from(D.styleSheets)))await B.handleStyleSheet(i, t, n, e);
                return n.size ? t.filter((e)=>{
                    let t = e.match(/font-family\s*:\s*([^;]+);?/i);
                    return B.extractFontFamilies(t?.[1]).some((e)=>n.has(e));
                }) : t;
            }
            static async inlineFonts(e) {
                let t = await B.fetchStyleSheets(e), n = /url\(([^)]+)\)/g, i = [], r = t.join("\n"), o;
                for(; o = n.exec(r);){
                    let e = o[1].replace(/['"]/g, "");
                    i.includes(e) || i.push(e);
                }
                let a = (e)=>{
                    let t = "", n = new Uint8Array(e);
                    for(let e = 0; e < n.byteLength; e++)t += String.fromCharCode(n[e]);
                    return btoa(t);
                }, s = {};
                for (let e of i)try {
                    let t = await fetch(e), n = t.headers.get("Content-Type") || "", i = a(await t.arrayBuffer());
                    s[e] = `data:${n};base64,${i}`;
                } catch  {}
                r = r.replace(n, (e, t)=>{
                    let n = t.replace(/['"]/g, "");
                    return `url(${s[n] || n})`;
                });
                let l = document.createElementNS("http://www.w3.org/2000/svg", "style");
                return l.textContent = r, e.append(l), e;
            }
            static loadImage(e) {
                return new Promise((t, n)=>{
                    let i = new G.Image;
                    i.crossOrigin = "Anonymous", i.onload = ()=>{
                        setTimeout(()=>{
                            t(i);
                        }, B.loadEventDeferDelay);
                    }, i.onerror = (e)=>{
                        n(e);
                    }, i.src = e;
                });
            }
            static prepareImageOptions(e) {
                let t = e?.type || "image/png", n = e?.libURL || A.exporting?.libURL;
                return {
                    type: t,
                    filename: (e?.filename || "chart") + "." + ("image/svg+xml" === t ? "svg" : t.split("/")[1]),
                    scale: e?.scale || 1,
                    libURL: n?.slice(-1) !== "/" ? n + "/" : n
                };
            }
            static sanitizeDOM(e) {
                e.querySelectorAll("foreignObject").forEach((e)=>{
                    [
                        "width",
                        "height"
                    ].forEach((t)=>{
                        let n = e.getAttribute(t);
                        n && e.setAttribute(t, Math.ceil(1.15 * parseInt(n, 10)));
                    });
                });
            }
            static sanitizeSVG(e, t) {
                let n = e.lastIndexOf("</svg>");
                return n > -1 && (e = e.substr(0, n + 6)), e = e.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />").replace(/(<svg(?![^>]*xmlns=)[^>]*)>/g, '$1 xmlns="http://www.w3.org/2000/svg">').replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/(<image[^>]*) xlink:href=/g, "$1 href=").replace(/\n+/g, " ").replace(/&nbsp;/g, "\xa0").replace(/&shy;/g, "\xad");
            }
            static svgToDataURL(e) {
                let t = G.navigator.userAgent, n = t.indexOf("WebKit") > -1 && 0 > t.indexOf("Chrome");
                try {
                    if (!n && -1 === e.indexOf("<foreignObject")) return j.createObjectURL(new G.Blob([
                        e
                    ], {
                        type: "image/svg+xml;charset-utf-16"
                    }));
                } catch  {}
                return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(e);
            }
            addButton(e) {
                let t, n = this, i = n.chart, r = i.renderer, o = (0, c.merge)(i.options.navigation?.buttonOptions, e), a = o.onclick, s = o.menuItems, l = o.symbolSize || 12;
                if (!1 === o.enabled || !o.theme) return;
                let h = i.styledMode ? {} : o.theme, d = ()=>{};
                a ? d = function(e) {
                    e && e.stopPropagation(), a.call(i, e, i);
                } : s && (d = function(e) {
                    e && e.stopPropagation(), n.contextMenu(p.menuClassName, s, p.translateX || 0, p.translateY || 0, p.width || 0, p.height || 0, p), p.setState(2);
                }), o.text && o.symbol ? h.paddingLeft = h.paddingLeft ?? 30 : o.text || (0, c.extend)(h, {
                    width: o.width,
                    height: o.height,
                    padding: 0
                });
                let p = r.button(o.text || "", 0, 0, d, h, void 0, void 0, void 0, void 0, o.useHTML).addClass(e.className || "").attr({
                    title: i.options.lang[o._titleKey || o.titleKey] ?? ""
                });
                p.menuClassName = e.menuClassName || "highcharts-menu-" + n.btnCount++, o.symbol && (t = r.symbol(o.symbol, Math.round((o.symbolX || 0) - l / 2), Math.round((o.symbolY || 0) - l / 2), l, l, {
                    width: l,
                    height: l
                }).addClass("highcharts-button-symbol").attr({
                    zIndex: 1
                }).add(p), i.styledMode || t.attr({
                    stroke: o.symbolStroke,
                    fill: o.symbolFill,
                    "stroke-width": o.symbolStrokeWidth || 1
                })), p.add(n.group).align((0, c.extend)(o, {
                    width: p.width,
                    x: o.x ?? n.buttonOffset
                }), !0, "spacingBox"), n.buttonOffset += ((p.width || 0) + (o.buttonSpacing || 0)) * ("right" === o.align ? -1 : 1), n.svgElements.push(p, t);
            }
            afterPrint() {
                let e = this.chart;
                if (!this.printReverseInfo) return;
                let { childNodes: t, origDisplay: n, resetParams: i } = this.printReverseInfo;
                this.moveContainers(e.renderTo), [].forEach.call(t, function(e, t) {
                    1 === e.nodeType && (e.style.display = n[t] || "");
                }), this.isPrinting = !1, i && e.setSize.apply(e, i), delete this.printReverseInfo, B.printingChart = void 0, (0, c.fireEvent)(e, "afterPrint");
            }
            beforePrint() {
                let e = this.chart, t = D.body, n = this.options.printMaxWidth, i = {
                    childNodes: t.childNodes,
                    origDisplay: [],
                    resetParams: void 0
                };
                this.isPrinting = !0, e.pointer?.reset(void 0, 0), (0, c.fireEvent)(e, "beforePrint"), n && e.chartWidth > n && (i.resetParams = [
                    e.options.chart.width,
                    void 0,
                    !1
                ], e.setSize(n, void 0, !1)), [].forEach.call(i.childNodes, function(e, t) {
                    1 === e.nodeType && (i.origDisplay[t] = e.style.display, e.style.display = "none");
                }), this.moveContainers(t), this.printReverseInfo = i;
            }
            contextMenu(e, t, n, i, r, o, a) {
                let s = this, l = s.chart, h = l.options.navigation, { chartWidth: d, chartHeight: u } = l, g = "cache-" + e, f = Math.max(r, o), m, y = l[g];
                y || (s.contextMenuEl = l[g] = y = (0, c.createElement)("div", {
                    className: e
                }, {
                    position: "absolute",
                    zIndex: 1e3,
                    padding: f + "px",
                    pointerEvents: "auto",
                    ...l.renderer.style
                }, l.scrollablePlotArea?.fixedDiv || l.container), m = (0, c.createElement)("ul", {
                    className: "highcharts-menu"
                }, l.styledMode ? {} : {
                    listStyle: "none",
                    margin: 0,
                    padding: 0
                }, y), l.styledMode || (0, c.css)(m, (0, c.extend)({
                    MozBoxShadow: "3px 3px 10px #0008",
                    WebkitBoxShadow: "3px 3px 10px #0008",
                    boxShadow: "3px 3px 10px #0008"
                }, h?.menuStyle || {})), y.hideMenu = function() {
                    (0, c.css)(y, {
                        display: "none"
                    }), a && a.setState(0), l.exporting && (l.exporting.openMenu = !1), (0, c.css)(l.renderTo, {
                        overflow: "hidden"
                    }), (0, c.css)(l.container, {
                        overflow: "hidden"
                    }), (0, c.internalClearTimeout)(y.hideTimer), (0, c.fireEvent)(l, "exportMenuHidden");
                }, s.events?.push((0, c.addEvent)(y, "mouseleave", function() {
                    y.hideTimer = G.setTimeout(y.hideMenu, 500);
                }), (0, c.addEvent)(y, "mouseenter", function() {
                    (0, c.internalClearTimeout)(y.hideTimer);
                }), (0, c.addEvent)(D, "mouseup", function(t) {
                    l.pointer?.inClass(t.target, e) || y.hideMenu();
                }), (0, c.addEvent)(y, "click", function() {
                    l.exporting?.openMenu && y.hideMenu();
                })), t.forEach(function(e) {
                    if ("string" == typeof e && s.options.menuItemDefinitions?.[e] && (e = s.options.menuItemDefinitions[e]), (0, c.isObject)(e, !0)) {
                        let t;
                        e.separator ? (t = (0, c.createElement)("li", {
                            className: "highcharts-menu-item highcharts-separator",
                            role: "separator"
                        }, void 0, m), l.styledMode || (0, c.css)(t, {
                            border: "none",
                            backgroundColor: "var(--highcharts-neutral-color-40)",
                            height: "0.5px",
                            margin: "10px 0",
                            padding: 0,
                            listStyle: "none",
                            "pointer-events": "none"
                        })) : ("viewData" === e.textKey && s.isDataTableVisible && (e.textKey = "hideData"), t = (0, c.createElement)("li", {
                            className: "highcharts-menu-item",
                            onclick: function(t) {
                                t && t.stopPropagation(), y.hideMenu(), "string" != typeof e && e.onclick && e.onclick.apply(l, arguments);
                            }
                        }, void 0, m), p().setElementHTML(t, e.text || l.options.lang[e.textKey]), l.styledMode || (t.onmouseover = function() {
                            (0, c.css)(this, h?.menuItemHoverStyle || {});
                        }, t.onmouseout = function() {
                            (0, c.css)(this, h?.menuItemStyle || {});
                        }, (0, c.css)(t, (0, c.extend)({
                            cursor: "pointer"
                        }, h?.menuItemStyle || {})))), s.divElements.push(t);
                    }
                }), s.divElements.push(m, y), s.menuHeight = y.offsetHeight, s.menuWidth = y.offsetWidth);
                let x = {
                    display: "block"
                };
                n + (s.menuWidth || 0) > d ? x.right = d - n - r - f + "px" : x.left = n - f + "px", i + o + (s.menuHeight || 0) > u && a.alignOptions?.verticalAlign !== "top" ? x.bottom = u - i - f + "px" : x.top = i + o - f + "px", (0, c.css)(y, x), (0, c.css)(l.renderTo, {
                    overflow: ""
                }), (0, c.css)(l.container, {
                    overflow: ""
                }), l.exporting && (l.exporting.openMenu = !0), (0, c.fireEvent)(l, "exportMenuShown");
            }
            destroy(e) {
                let t, n = e ? e.target : this.chart, { divElements: i, events: r, svgElements: o } = this;
                o.forEach((e, i)=>{
                    e && (e.onclick = e.ontouchstart = null, n[t = "cache-" + e.menuClassName] && delete n[t], o[i] = e.destroy());
                }), o.length = 0, this.group && (this.group.destroy(), delete this.group), i.forEach(function(e, t) {
                    e && ((0, c.internalClearTimeout)(e.hideTimer), (0, c.removeEvent)(e, "mouseleave"), i[t] = e.onmouseout = e.onmouseover = e.ontouchstart = e.onclick = null, (0, c.discardElement)(e));
                }), i.length = 0, r && (r.forEach(function(e) {
                    e();
                }), r.length = 0);
            }
            async downloadSVG(e, t) {
                let n, i = {
                    svg: e,
                    exportingOptions: t,
                    exporting: this
                };
                if ((0, c.fireEvent)(B.prototype, "downloadSVG", i), i.defaultPrevented) return;
                let { type: r, filename: o, scale: a, libURL: s } = B.prepareImageOptions(t);
                if ("application/pdf" === r) throw Error("Offline exporting logic for PDF type is not found.");
                if ("image/svg+xml" === r) {
                    if (void 0 !== G.MSBlobBuilder) {
                        let t = new G.MSBlobBuilder;
                        t.append(e), n = t.getBlob("image/svg+xml");
                    } else n = B.svgToDataURL(e);
                    S(n, o);
                } else {
                    n = B.svgToDataURL(e);
                    try {
                        B.objectURLRevoke = !0;
                        let e = await B.imageToDataURL(n, a, r);
                        S(e, o);
                    } catch (d) {
                        if ("No canvas found!" === d.message) throw d;
                        if (e.length > 1e8) throw Error("Input too long");
                        let t = D.createElement("canvas"), n = t.getContext("2d"), i = e.match(/^<svg[^>]*\s{,1000}width\s{,1000}=\s{,1000}\"?(\d+)\"?[^>]*>/), h = e.match(/^<svg[^>]*\s{0,1000}height\s{,1000}=\s{,1000}\"?(\d+)\"?[^>]*>/);
                        if (n && i && h) {
                            let d = i[1] * a, p = h[1] * a;
                            if (t.width = d, t.height = p, !G.canvg) {
                                var l;
                                if (!s) throw Error("Image export requires canvg. Set exporting.libURL or preload canvg.");
                                B.objectURLRevoke = !0, await (l = s + "canvg.js", new Promise((e, t)=>{
                                    let n = w.getElementsByTagName("head")[0], i = w.createElement("script");
                                    i.type = "text/javascript", i.src = l, i.onload = ()=>{
                                        e();
                                    }, i.onerror = ()=>{
                                        let e = `Error loading script ${l}`;
                                        (0, c.error)(e), t(Error(e));
                                    }, n.appendChild(i);
                                }));
                            }
                            G.canvg.Canvg.fromString(n, e).start(), S(G.navigator.msSaveOrOpenBlob ? t.msToBlob() : t.toDataURL(r), o);
                        }
                    } finally{
                        if (B.objectURLRevoke) try {
                            j.revokeObjectURL(n);
                        } catch  {}
                    }
                }
            }
            async exportChart(e, t) {
                if ((e = (0, c.merge)(this.options, e)).local) await this.localExport(e, t || {});
                else {
                    let n = await this.getSVGForExport(e, t);
                    e.url && await N.post(e.url, {
                        filename: e.filename ? e.filename.replace(/\//g, "-") : this.getFilename(),
                        type: e.type,
                        width: e.width,
                        scale: e.scale,
                        svg: n
                    }, e.fetchOptions);
                }
            }
            async fallbackToServer(e, t) {
                !1 === e.fallbackToExportServer ? e.error ? e.error(e, t) : (0, c.error)(t?.message || 28, !0, this.chart) : "application/pdf" === e.type ? (e.local = !1, await this.exportChart(e)) : (0, c.error)(t.message, !1);
            }
            getChartHTML(e) {
                let t = this.chart;
                return e && this.inlineStyles(), this.resolveCSSVariables(), B.sanitizeDOM(t.renderer.box), t.container.querySelectorAll("canvas").forEach(function(e) {
                    let n = e.toDataURL("image/png"), i = e.parentNode, r = t.renderer.image(n, 0, 0, e.width, e.height);
                    (0, c.css)(r.element, {
                        width: e.style.width,
                        height: e.style.height
                    }), i.parentNode.insertBefore(r.element, i), i.remove();
                }), t.container.innerHTML;
            }
            getFilename() {
                let e = this.chart.userOptions.title?.text, t = this.options.filename;
                return t ? t.replace(/\//g, "-") : ("string" == typeof e && (t = e.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!t || t.length < 5) && (t = "chart"), t);
            }
            getSVG(e, t) {
                let n = this.chart, i, r, o = (0, c.merge)(n.options, e);
                o.plotOptions = (0, c.merge)(n.userOptions.plotOptions, e?.plotOptions), o.time = (0, c.merge)(n.userOptions.time, e?.time);
                let a = (0, c.createElement)("div", void 0, {
                    position: "absolute",
                    top: "-9999em",
                    width: n.chartWidth + "px",
                    height: n.chartHeight + "px"
                }, D.body), s = n.renderTo.style.width, l = n.renderTo.style.height, h = o.exporting?.sourceWidth || o.chart.width || /px$/.test(s) && parseInt(s, 10) || (o.isGantt ? 800 : 600), d = o.exporting?.sourceHeight || o.chart.height || /px$/.test(l) && parseInt(l, 10) || 400;
                (0, c.extend)(o.chart, {
                    animation: !1,
                    renderTo: a,
                    forExport: !0,
                    renderer: "SVGRenderer",
                    width: h,
                    height: d
                }), o.exporting && (o.exporting.enabled = !1), delete o.data, o.series = [], n.series.forEach(function(e) {
                    (r = (0, c.merge)(e.userOptions, {
                        animation: !1,
                        enableMouseTracking: !1,
                        showCheckbox: !1,
                        visible: e.visible
                    })).isInternal || o?.series?.push(r);
                });
                let p = {};
                n.axes.forEach(function(e) {
                    e.userOptions.internalKey || (e.userOptions.internalKey = (0, c.uniqueKey)()), o && !e.options.isInternal && (p[e.coll] || (p[e.coll] = !0, o[e.coll] = []), o[e.coll].push((0, c.merge)(e.userOptions, {
                        visible: e.visible,
                        type: e.type,
                        uniqueNames: e.uniqueNames
                    })));
                }), o.colorAxis = n.userOptions.colorAxis;
                let u = (t)=>{
                    e && [
                        "xAxis",
                        "yAxis",
                        "series"
                    ].forEach(function(n) {
                        e[n] && t.update({
                            [n]: e[n]
                        });
                    }), n.axes.forEach(function(n) {
                        let i = (0, c.find)(t.axes, (e)=>e.options.internalKey === n.userOptions.internalKey);
                        if (i) {
                            let t = n.getExtremes(), r = (0, c.splat)(e?.[n.coll] || {})[0], o = "min" in r ? r.min : t.userMin, a = "max" in r ? r.max : t.userMax;
                            (void 0 !== o && o !== i.min || void 0 !== a && a !== i.max) && i.setExtremes(o ?? void 0, a ?? void 0, !0, !1);
                        }
                    });
                    let r = t.exporting;
                    return r?.options.applyStyleSheets && this.applyShadowDOMStyles(t), (0, c.fireEvent)(n, "getSVG", {
                        chartCopy: t
                    }), i = r?.getChartHTML(n.styledMode || o?.exporting?.applyStyleSheets) || "", i = B.sanitizeSVG(i, o), (0, c.fireEvent)(n, "afterGetSVG", {
                        chartCopy: t,
                        svg: i
                    }), o = void 0, t.destroy(), (0, c.discardElement)(a), i;
                };
                return t ? new Promise((e)=>new n.constructor(o || {}, function(t) {
                        n.callback?.call(this, t);
                        let i = (0, c.addEvent)(this, "render", function() {
                            i(), e(u(this));
                        });
                    })) : u(new n.constructor(o, n.callback));
            }
            applyShadowDOMStyles(e) {
                let t = this.chart, n = [], i = t.container, r;
                for(; i && (!(r = i.getRootNode()) || "object" != typeof r.host);)i = i.parentNode, r = null;
                r?.querySelectorAll("style").forEach((t)=>{
                    let i = t.cloneNode(!0);
                    e.renderer.defs.element.appendChild(i), n.push(i);
                }), (0, c.addEvent)(t, "afterGetSVG", ()=>{
                    n.forEach((e)=>{
                        e.remove();
                    });
                });
            }
            async getSVGForExport(e, t) {
                let n = this.options;
                return await this.getSVG((0, c.merge)({
                    chart: {
                        borderRadius: 0
                    }
                }, n.chartOptions, t, {
                    exporting: {
                        sourceWidth: e?.sourceWidth || n.sourceWidth,
                        sourceHeight: e?.sourceHeight || n.sourceHeight
                    }
                }), !0);
            }
            inlineStyles() {
                let e, t = B.inlineDenylist, n = B.inlineAllowlist, i = {}, r = (0, c.createElement)("iframe", void 0, {
                    width: "1px",
                    height: "1px",
                    visibility: "hidden"
                }, D.body), o = r.contentWindow?.document;
                o && o.body.appendChild(o.createElementNS(U, "svg")), !function r(a) {
                    let s, l, h, d, p, u, g = {};
                    if (o && 1 === a.nodeType && -1 === B.unstyledElements.indexOf(a.nodeName)) {
                        if (s = G.getComputedStyle(a, null), l = "svg" === a.nodeName ? {} : G.getComputedStyle(a.parentNode, null), !i[a.nodeName]) {
                            e = o.getElementsByTagName("svg")[0], h = o.createElementNS(a.namespaceURI, a.nodeName), e.appendChild(h);
                            let t = G.getComputedStyle(h, null), n = {};
                            for(let e in t)e.length < 1e3 && "string" == typeof t[e] && !/^\d+$/.test(e) && (n[e] = t[e]);
                            i[a.nodeName] = n, "text" === a.nodeName && delete i.text.fill, e.removeChild(h);
                        }
                        for(let e in s)(H || L || I || Object.hasOwnProperty.call(s, e)) && function(e, r) {
                            if (d = p = !1, n.length) {
                                for(u = n.length; u-- && !p;)p = n[u].test(r);
                                d = !p;
                            }
                            for("transform" === r && "none" === e && (d = !0), u = t.length; u-- && !d;){
                                if (r.length > 1e3) throw Error("Input too long");
                                d = t[u].test(r) || "function" == typeof e;
                            }
                            !d && (l[r] !== e || "svg" === a.nodeName) && i[a.nodeName][r] !== e && (B.inlineToAttributes && -1 === B.inlineToAttributes.indexOf(r) ? g[r] = e : e && a.setAttribute(B.hyphenate(r), e));
                        }(s[e], e);
                        if ((0, c.css)(a, g), "svg" === a.nodeName && a.setAttribute("stroke-width", "1px"), "text" === a.nodeName) return;
                        [].forEach.call(a.children || a.childNodes, r);
                    }
                }(this.chart.container.querySelector("svg")), e.parentNode.removeChild(e), r.parentNode.removeChild(r);
            }
            async localExport(e, t) {
                let n = this.chart, i, r, o = null, a;
                if (L && n.styledMode && !B.inlineAllowlist.length && B.inlineAllowlist.push(/^blockSize/, /^border/, /^caretColor/, /^color/, /^columnRule/, /^columnRuleColor/, /^cssFloat/, /^cursor/, /^fill$/, /^fillOpacity/, /^font/, /^inlineSize/, /^length/, /^lineHeight/, /^opacity/, /^outline/, /^parentRule/, /^rx$/, /^ry$/, /^stroke/, /^textAlign/, /^textAnchor/, /^textDecoration/, /^transform/, /^vectorEffect/, /^visibility/, /^x$/, /^y$/), L && ("application/pdf" === e.type || n.container.getElementsByTagName("image").length && "image/svg+xml" !== e.type) || "application/pdf" === e.type && [].some.call(n.container.getElementsByTagName("image"), function(e) {
                    let t = e.getAttribute("href");
                    return "" !== t && "string" == typeof t && 0 !== t.indexOf("data:");
                })) return void await this.fallbackToServer(e, Error("Image type not supported for this chart/browser."));
                let s = (0, c.addEvent)(n, "afterGetSVG", (e)=>{
                    r = e.chartCopy.options, a = (i = e.chartCopy.container.cloneNode(!0)) && i.getElementsByTagName("image") || [];
                });
                try {
                    let n;
                    for (let n of (await this.getSVGForExport(e, t), a ? Array.from(a) : []))if (o = n.getAttributeNS("http://www.w3.org/1999/xlink", "href")) {
                        B.objectURLRevoke = !1;
                        let t = await B.imageToDataURL(o, e?.scale || 1, e?.type || "image/png");
                        n.setAttributeNS("http://www.w3.org/1999/xlink", "href", t);
                    } else n.parentNode.removeChild(n);
                    let s = i?.querySelector("svg");
                    s && !e.chartOptions?.chart?.style?.fontFamily && await B.inlineFonts(s);
                    let l = (n = i?.innerHTML, B.sanitizeSVG(n || "", r));
                    if (l.indexOf("<foreignObject") > -1 && "image/svg+xml" !== e.type && (L || "application/pdf" === e.type)) throw Error("Image type not supported for charts with embedded HTML");
                    return await this.downloadSVG(l, (0, c.extend)({
                        filename: this.getFilename()
                    }, e)), l;
                } catch (t) {
                    await this.fallbackToServer(e, t);
                } finally{
                    s();
                }
            }
            moveContainers(e) {
                let t = this.chart, { scrollablePlotArea: n } = t;
                (n ? [
                    n.fixedDiv,
                    n.scrollingContainer
                ] : [
                    t.container
                ]).forEach(function(t) {
                    e.appendChild(t);
                });
            }
            print() {
                let e = this.chart;
                this.isPrinting || (B.printingChart = e, I || this.beforePrint(), setTimeout(()=>{
                    G.focus(), G.print(), I || setTimeout(()=>{
                        e.exporting?.afterPrint();
                    }, 1e3);
                }, 1));
            }
            render() {
                let e = this, { chart: t, options: n } = e, i = e?.isDirty || !e?.svgElements.length;
                e.buttonOffset = 0, e.isDirty && e.destroy(), i && !1 !== n.enabled && (e.events = [], e.group || (e.group = t.renderer.g("exporting-group").attr({
                    zIndex: 3
                }).add()), (0, c.objectEach)(n?.buttons, function(t) {
                    e.addButton(t);
                }), e.isDirty = !1);
            }
            resolveCSSVariables() {
                Array.from(this.chart.container.querySelectorAll("*")).forEach((e)=>{
                    [
                        "color",
                        "fill",
                        "stop-color",
                        "stroke"
                    ].forEach((t)=>{
                        let n = e.getAttribute(t);
                        n?.includes("var(") && e.setAttribute(t, getComputedStyle(e).getPropertyValue(t));
                        let i = e.style?.[t];
                        i?.includes("var(") && (e.style[t] = getComputedStyle(e).getPropertyValue(t));
                    });
                });
            }
            update(e, t) {
                this.isDirty = !0, (0, c.merge)(!0, this.options, e), (t ?? !0) && this.chart.redraw();
            }
        }
        B.inlineAllowlist = [], B.inlineDenylist = [
            /-/,
            /^(clipPath|cssText|d|height|width)$/,
            /^font$/,
            /[lL]ogical(Width|Height)$/,
            /^parentRule$/,
            /^(cssRules|ownerRules)$/,
            /perspective/,
            /TapHighlightColor/,
            /^transition/,
            /^length$/,
            /^\d+$/
        ], B.inlineToAttributes = [
            "fill",
            "stroke",
            "strokeLinecap",
            "strokeLinejoin",
            "strokeWidth",
            "textAnchor",
            "x",
            "y"
        ], B.loadEventDeferDelay = 150 * !!L, B.unstyledElements = [
            "clipPath",
            "defs",
            "desc"
        ], function(e) {
            function t(e) {
                let t = e.exporting;
                t && (t.render(), (0, c.addEvent)(e, "redraw", function() {
                    this.exporting?.render();
                }), (0, c.addEvent)(e, "destroy", function() {
                    this.exporting?.destroy();
                }));
            }
            function n() {
                let t = this;
                t.options.exporting && (t.exporting = new e(t, t.options.exporting), y.compose(t).navigation.addUpdate((e, n)=>{
                    t.exporting && (t.exporting.isDirty = !0, (0, c.merge)(!0, t.options.navigation, e), (n ?? !0) && t.redraw());
                }));
            }
            function i({ alignTo: e, key: t, textPxLength: n }) {
                let r = this.options.exporting, { align: o, buttonSpacing: a = 0, verticalAlign: s, width: l = 0 } = (0, c.merge)(this.options.navigation?.buttonOptions, r?.buttons?.contextButton), h = e.width - n, d = l + a;
                (r?.enabled ?? !0) && "title" === t && "right" === o && "top" === s && h < 2 * d && (h < d ? e.width -= d : this.title?.alignValue !== "left" && (e.x -= d - h / 2));
            }
            e.compose = function(r, o) {
                O.compose(o), k.compose(r), (0, c.pushUnique)(P, "Exporting") && ((0, c.extend)(g().prototype, {
                    exportChart: async function(e, t) {
                        await this.exporting?.exportChart(e, t);
                    },
                    getChartHTML: function(e) {
                        return this.exporting?.getChartHTML(e);
                    },
                    getFilename: function() {
                        return this.exporting?.getFilename();
                    },
                    getSVG: function(e) {
                        return this.exporting?.getSVG(e, !1);
                    },
                    print: function() {
                        return this.exporting?.print();
                    }
                }), r.prototype.callbacks.push(t), (0, c.addEvent)(r, "afterInit", n), (0, c.addEvent)(r, "layOutTitle", i), I && G.matchMedia("print").addListener(function(t) {
                    e.printingChart && (t.matches ? e.printingChart.exporting?.beforePrint() : e.printingChart.exporting?.afterPrint());
                }), M(C));
            };
        }(B || (B = {}));
        let V = h();
        V.Exporting = B, V.HttpUtilities = V.HttpUtilities || N, V.ajax = V.HttpUtilities.ajax, V.getJSON = V.HttpUtilities.getJSON, V.post = V.HttpUtilities.post, B.compose(V.Chart, V.Renderer);
        let $ = h();
        return l.default;
    })());


var $5276e27209a1e47a$exports = {};
!/**
 * Highcharts JS v13.1.1 (2026-09-20)
 * @module highcharts/modules/export-data
 * @requires highcharts
 * @requires highcharts/modules/exporting
 *
 * Export data module
 *
 * (c) 2010-2026 Highsoft AS
 * Author: Torstein Hønsi
 *
 * A commercial license may be required depending on use,
 * see www.highcharts.com/license
 */ function(t, e) {
    $5276e27209a1e47a$exports = e(t._Highcharts.AST, t._Highcharts.Chart, t._Highcharts);
}("u" < typeof window ? $5276e27209a1e47a$exports : window, (t, e, a)=>(()=>{
        "use strict";
        var o, n = {
            660 (e) {
                e.exports = t;
            },
            960 (t) {
                t.exports = e;
            },
            944 (t) {
                t.exports = a;
            }
        };
        let i = {};
        function r(t) {
            let e = i[t];
            if (void 0 !== e) return e.exports;
            let a = i[t] = {
                exports: {}
            };
            return n[t](a, a.exports, r), a.exports;
        }
        r.n = (t)=>{
            let e = t && t.__esModule ? ()=>t.default : ()=>t;
            return r.d(e, {
                a: e
            }), e;
        }, r.d = (t, e)=>{
            for(var a in e)r.o(e, a) && !r.o(t, a) && Object.defineProperty(t, a, {
                enumerable: !0,
                get: e[a]
            });
        }, r.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        let l = {};
        r.d(l, {
            default: ()=>H
        });
        var s = r(944), h = r.n(s);
        let { isSafari: d, win: c, win: { document: p } } = h(), u = c.URL || c.webkitURL || c;
        function g(t) {
            let e = t.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
            if (e && e.length > 3 && c.atob && c.ArrayBuffer && c.Uint8Array && c.Blob && u.createObjectURL) {
                let t = c.atob(e[3]), a = new c.ArrayBuffer(t.length), o = new c.Uint8Array(a);
                for(let e = 0; e < o.length; ++e)o[e] = t.charCodeAt(e);
                return u.createObjectURL(new c.Blob([
                    o
                ], {
                    type: e[1]
                }));
            }
        }
        function f(t, e) {
            let a = c.navigator, o = p.createElement("a");
            if ("string" != typeof t && !(t instanceof String) && a.msSaveOrOpenBlob) return void a.msSaveOrOpenBlob(t, e);
            if (t = "" + t, a.userAgent.length > 1e3) throw Error("Input too long");
            let n = /Edge\/\d+/.test(a.userAgent);
            if ((d && "string" == typeof t && 0 === t.indexOf("data:application/pdf") || n || t.length > 2e6) && !(t = g(t) || "")) throw Error("Failed to convert to blob");
            if (void 0 !== o.download) o.href = t, o.download = e, p.body.appendChild(o), o.click(), p.body.removeChild(o);
            else try {
                if (!c.open(t, "chart")) throw Error("Failed to open window");
            } catch  {
                c.location.href = t;
            }
        }
        function m(t, e) {
            let a = c.navigator, o = c.URL || c.webkitURL || c;
            try {
                if (a.msSaveOrOpenBlob && c.MSBlobBuilder) {
                    let e = new c.MSBlobBuilder;
                    return e.append(t), e.getBlob("image/svg+xml");
                }
                return o.createObjectURL(new c.Blob([
                    "\uFEFF" + t
                ], {
                    type: e
                }));
            } catch (t) {}
        }
        var x = r(660), b = r.n(x), y = r(960), w = r.n(y);
        let T = {
            exporting: {
                csv: {
                    annotations: {
                        itemDelimiter: "; ",
                        join: !1
                    },
                    columnHeaderFormatter: null,
                    dateFormat: "%Y-%m-%d %H:%M:%S",
                    decimalPoint: null,
                    itemDelimiter: null,
                    lineDelimiter: "\n"
                },
                menuItemDefinitions: {
                    downloadCSV: {
                        textKey: "downloadCSV",
                        onclick: function() {
                            this.exporting?.downloadCSV();
                        }
                    },
                    downloadXLS: {
                        textKey: "downloadXLS",
                        onclick: function() {
                            this.exporting?.downloadXLS();
                        }
                    },
                    viewData: {
                        textKey: "viewData",
                        onclick: function() {
                            this.exporting?.wrapLoading(this.exporting.toggleDataTable);
                        }
                    }
                },
                showExportInProgress: !0,
                showTable: !1,
                useMultiLevelHeaders: !0,
                useRowspanHeaders: !0
            },
            lang: {
                downloadCSV: "Download CSV",
                downloadXLS: "Download XLS",
                exportData: {
                    annotationHeader: "Annotations",
                    categoryHeader: "Category",
                    categoryDatetimeHeader: "DateTime"
                },
                viewData: "View data table",
                hideData: "Hide data table",
                exportInProgress: "Exporting..."
            }
        }, { getOptions: v, setOptions: D } = h(), { composed: S, doc: E, win: C } = h();
        !function(t) {
            function e() {
                this.chart.series.some(h) ? this.wrapLoading(()=>{
                    let t = this.getCSV(!0);
                    f(m(t, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(t), this.getFilename() + ".csv");
                }) : (0, s.error)("Warning: No data to export", !1, this.chart);
            }
            function a() {
                this.chart.series.some(h) ? this.wrapLoading(()=>{
                    let t = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head>\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
                    f(m(t, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + C.btoa(unescape(encodeURIComponent(t))), this.getFilename() + ".xls");
                }) : (0, s.error)("Warning: No data to export", !1, this.chart);
            }
            function o(t) {
                let e = "", a = this.getDataRows(), o = this.options?.csv, n = o?.decimalPoint ?? (o?.itemDelimiter !== "," && t ? 1.1.toLocaleString()[1] : "."), i = o?.itemDelimiter ?? ("," === n ? ";" : ","), r = o?.lineDelimiter;
                return a.forEach((t, o)=>{
                    let l = "", s = t.length;
                    for(; s--;)"string" == typeof (l = t[s]) && (l = `"${l}"`), "number" == typeof l && "." !== n && (l = l.toString().replace(".", n)), t[s] = l;
                    t.length = a.length ? a[0].length : 0, e += t.join(i), o < a.length - 1 && (e += r);
                }), e;
            }
            function n(t) {
                let e, a, o = this.chart, n = o.hasParallelCoordinates, i = o.time, r = this.options?.csv || {}, l = o.xAxis, d = {}, c = [], p = [], u = [], g = o.options.lang.exportData, f = g?.categoryHeader, m = g?.categoryDatetimeHeader, x = function(e, a, o) {
                    if (r.columnHeaderFormatter) {
                        let t = r.columnHeaderFormatter(e, a, o);
                        if (!1 !== t) return t;
                    }
                    return !e && f ? f : !e.bindAxes && m && f ? e.options.title && e.options.title.text || (e.dateTime ? m : f) : t ? {
                        columnTitle: ((o || 0) > 1 ? a : e.name) || "",
                        topLevelColumnTitle: e.name
                    } : e.name + ((o || 0) > 1 ? " (" + a + ")" : "");
                }, b = function(t, e, a) {
                    let o = {}, n = {};
                    return e.forEach(function(e) {
                        let i = (t.keyToAxis && t.keyToAxis[e] || e) + "Axis", r = (0, s.isNumber)(a) ? t.chart[i][a] : t[i];
                        o[e] = r && r.categories || [], n[e] = r && r.dateTime;
                    }), {
                        categoryMap: o,
                        dateTimeValueAxisMap: n
                    };
                }, y = function(t, e) {
                    let a = t.pointArrayMap || [
                        "y"
                    ];
                    return t.data.some((t)=>void 0 !== t.y && t.name) && e && !e.categories && "name" !== t.exportKey ? [
                        "x",
                        ...a
                    ] : a;
                }, w = [], T, v, D, S = 0, E, C;
                for(E in o.series.forEach(function(e) {
                    let a = e.options.keys, o = e.xAxis, c = a || y(e, o), g = c.length, f = !e.requireSorting && {}, m = l.indexOf(o), T = b(e, c), v, E;
                    if (h(e)) {
                        for((0, s.find)(w, function(t) {
                            return t[0] === m;
                        }) || w.push([
                            m,
                            S
                        ]), E = 0; E < g;)D = x(e, c[E], c.length), u.push(D.columnTitle || D), t && p.push(D.topLevelColumnTitle || D), E++;
                        v = {
                            chart: e.chart,
                            autoIncrement: e.autoIncrement,
                            options: e.options,
                            pointArrayMap: e.pointArrayMap,
                            index: e.index,
                            xAxis: e.xAxis
                        };
                        let a = Array(e.dataTable.rowCount).fill(void 0).map((t, a)=>e.dataTable.getRowObject(a)), l = e.getColumn("x");
                        (a || []).forEach(function(t, a) {
                            let s, h, p, u = {
                                series: v
                            };
                            n && (T = b(e, c, a)), e.pointClass.prototype.applyOptions.call(u, t, l[a]);
                            let x = e.data[a] && e.data[a].name;
                            if (s = (u.x ?? "") + "," + x, E = 0, (!o || "name" === e.exportKey || !n && o && o.hasNames && x) && (s = x), f && (f[s] && (s += "|" + a), f[s] = !0), d[s]) {
                                let t = `${s},${d[s].pointers[e.index]}`, a = s;
                                d[s].pointers[e.index] && (d[t] || (d[t] = [], d[t].xValues = [], d[t].pointers = []), s = t), d[a].pointers[e.index] += 1;
                            } else {
                                d[s] = [], d[s].xValues = [];
                                let t = [];
                                for(let a = 0; a < e.chart.series.length; a++)t[a] = 0;
                                d[s].pointers = t, d[s].pointers[e.index] = 1;
                            }
                            for(d[s].x = u.x, d[s].name = x, d[s].xValues[m] = u.x; E < g;)h = c[E], p = e.pointClass.prototype.getNestedProperty.apply(u, [
                                h
                            ]), d[s][S + E] = T.categoryMap[h][p] ?? (T.dateTimeValueAxisMap[h] ? i.dateFormat(r.dateFormat, p) : null) ?? p, E++;
                        }), S += E;
                    }
                }), d)Object.hasOwnProperty.call(d, E) && c.push(d[E]);
                for(v = t ? [
                    p,
                    u
                ] : [
                    u
                ], S = w.length; S--;)e = w[S][0], a = w[S][1], T = l[e], c.sort(function(t, a) {
                    return t.xValues[e] - a.xValues[e];
                }), C = x(T), v[0].splice(a, 0, C), t && v[1] && v[1].splice(a, 0, C), c.forEach(function(t) {
                    let e = t.name;
                    T && !(0, s.defined)(e) && (T.dateTime ? (t.x instanceof Date && (t.x = t.x.getTime()), e = i.dateFormat(r.dateFormat, t.x)) : e = T.categories ? T.names[t.x] ?? T.categories[t.x] ?? t.x : t.x), t.splice(a, 0, e);
                });
                return v = v.concat(c), (0, s.fireEvent)(o, "exportData", {
                    dataRows: v
                }), v;
            }
            function i(t) {
                let e = (t)=>{
                    if (!t.tagName || "#text" === t.tagName) return t.textContent || "";
                    let a = t.attributes, o = `<${t.tagName}`;
                    return a && Object.keys(a).forEach((t)=>{
                        let e = a[t];
                        o += ` ${t}="${e}"`;
                    }), o += ">", o += t.textContent || "", (t.children || []).forEach((t)=>{
                        o += e(t);
                    }), o += `</${t.tagName}>`;
                };
                return e(this.getTableAST(t));
            }
            function r(t) {
                let e = 0, a = [], o = this, n = o.chart, i = n.options, r = t ? 1.1.toLocaleString()[1] : void 0, l = o.options.useMultiLevelHeaders ?? !0, h = o.getDataRows(l), d = l ? h.shift() : null, c = h.shift(), p = function(t, e) {
                    let a = t.length;
                    if (e.length !== a) return !1;
                    for(; a--;)if (t[a] !== e[a]) return !1;
                    return !0;
                }, u = function(t, e, a, o) {
                    let i = [], l = o ?? "", h = "highcharts-text" + (e ? " " + e : "");
                    "number" == typeof l ? (l = n.numberFormatter(l, -1, r, "th" === t ? "" : void 0), h = "highcharts-number") : o || (h = "highcharts-empty"), "th" === t && "col" === a.scope && i.push({
                        tagName: "button",
                        textContent: l,
                        style: {
                            color: "inherit",
                            borderWidth: 0,
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            padding: 0,
                            fontSize: "inherit",
                            fontWeight: "inherit"
                        }
                    });
                    let d = {
                        tagName: t,
                        attributes: a = (0, s.extend)({
                            class: h
                        }, a)
                    };
                    return i.length > 0 ? d.children = i : d.textContent = l, d;
                }, { tableCaption: g } = o.options || {};
                !1 !== g && a.push({
                    tagName: "caption",
                    attributes: {
                        class: "highcharts-table-caption"
                    },
                    textContent: "string" == typeof g ? g : i.title?.text || i.lang.chartTitle
                });
                for(let t = 0, a = h.length; t < a; ++t)h[t].length > e && (e = h[t].length);
                a.push(function(t, e, a) {
                    let n = [], i = 0, r = a || e && e.length, s, h = 0, d;
                    if (l && t && e && !p(t, e)) {
                        let a = [];
                        for(; i < r; ++i)if ((s = t[i]) === t[i + 1]) ++h;
                        else if (h) a.push(u("th", "highcharts-table-topheading", {
                            scope: "col",
                            colspan: h + 1
                        }, s)), h = 0;
                        else {
                            s === e[i] ? o.options.useRowspanHeaders ? (d = 2, delete e[i]) : (d = 1, e[i] = "") : d = 1;
                            let t = u("th", "highcharts-table-topheading", {
                                scope: "col"
                            }, s);
                            d > 1 && t.attributes && (t.attributes.valign = "top", t.attributes.rowspan = d), a.push(t);
                        }
                        n.push({
                            tagName: "tr",
                            children: a
                        });
                    }
                    if (e) {
                        let t = [];
                        for(i = 0, r = e.length; i < r; ++i)void 0 !== e[i] && t.push(u("th", null, {
                            scope: "col"
                        }, e[i]));
                        n.push({
                            tagName: "tr",
                            children: t
                        });
                    }
                    return {
                        tagName: "thead",
                        children: n
                    };
                }(d, c || [], Math.max(e, c?.length || 0)));
                let f = [];
                h.forEach(function(t) {
                    let a = [];
                    for(let o = 0; o < e; o++)a.push(u(o ? "td" : "th", null, o ? {} : {
                        scope: "row"
                    }, t[o]));
                    f.push({
                        tagName: "tr",
                        children: a
                    });
                }), a.push({
                    tagName: "tbody",
                    children: f
                });
                let m = {
                    tree: {
                        tagName: "table",
                        id: `highcharts-data-table-${n.index}`,
                        children: a
                    }
                };
                return (0, s.fireEvent)(n, "afterGetTableAST", m), m.tree;
            }
            function l() {
                this.toggleDataTable(!1);
            }
            function h(t) {
                return !1 !== t.options.includeInDataExport && !t.options.isInternal && !1 !== t.visible;
            }
            function d(t) {
                let e = this.chart, a = (t = t ?? !this.isDataTableVisible) && !this.dataTableDiv;
                if (a && (this.dataTableDiv = E.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", e.renderTo.parentNode.insertBefore(this.dataTableDiv, e.renderTo.nextSibling)), this.dataTableDiv) {
                    let o = this.dataTableDiv.style, n = o.display;
                    o.display = t ? "block" : "none", t ? (this.dataTableDiv.innerHTML = b().emptyHTML, new (b())([
                        this.getTableAST()
                    ]).addToDOM(this.dataTableDiv), (0, s.fireEvent)(e, "afterViewData", {
                        element: this.dataTableDiv,
                        wasHidden: a || n !== o.display
                    })) : (0, s.fireEvent)(e, "afterHideData");
                }
                this.isDataTableVisible = t;
                let o = this.divElements, n = this.options, i = n.buttons?.contextButton.menuItems, r = e.options.lang;
                if (n && n.menuItemDefinitions && r && r.viewData && r.hideData && i && o) {
                    let t = o[i.indexOf("viewData")];
                    t && b().setElementHTML(t, this.isDataTableVisible ? r.hideData : r.viewData);
                }
            }
            function c() {
                this.toggleDataTable(!0);
            }
            function p(t) {
                let e = this.chart, a = !!this.options.showExportInProgress, o = C.requestAnimationFrame || setTimeout;
                o(()=>{
                    a && e.showLoading(e.options.lang.exportInProgress), o(()=>{
                        try {
                            t.call(this);
                        } finally{
                            a && e.hideLoading();
                        }
                    });
                });
            }
            function u() {
                let t = this.exporting, e = t?.dataTableDiv, a = this.options.lang, o = a?.decimalPoint || ".", n = a?.thousandsSep || ",", i = (t, e)=>t.children[e].textContent || "", r = (t)=>{
                    if (!t) return null;
                    let e = t;
                    n && (e = e.split(n).join(""));
                    let a = Number(e = e.replace(o, "."));
                    return (0, s.isNumber)(a) ? a : null;
                };
                if (e && t.options.allowTableSorting) {
                    let a = e.querySelector("thead tr");
                    a && a.childNodes.forEach((a)=>{
                        let o = e.querySelector("tbody");
                        a.addEventListener("click", function() {
                            let n = [
                                ...e.querySelectorAll("tr:not(thead tr)")
                            ], l = [
                                ...a.parentNode.children
                            ];
                            if (t) {
                                let e, s;
                                n.sort((e = l.indexOf(a), s = t.ascendingOrderInTable = !t.ascendingOrderInTable, (t, a)=>{
                                    let o = i(s ? t : a, e), n = i(s ? a : t, e), l = r(o), h = r(n);
                                    return null !== l && null !== h ? l - h : o.localeCompare(n);
                                })).forEach((t)=>{
                                    o?.appendChild(t);
                                }), l.forEach((t)=>{
                                    [
                                        "highcharts-sort-ascending",
                                        "highcharts-sort-descending"
                                    ].forEach((e)=>{
                                        t.classList.contains(e) && t.classList.remove(e);
                                    }), t !== a && t.removeAttribute("aria-sort");
                                }), a.classList.add(t.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending"), a.setAttribute("aria-sort", t.ascendingOrderInTable ? "ascending" : "descending");
                            }
                        });
                    });
                }
            }
            function g() {
                this.options?.exporting?.showTable && !this.options.chart.forExport && this.exporting?.viewData();
            }
            function x() {
                this.exporting?.dataTableDiv?.remove();
            }
            t.compose = function(t, h, f) {
                if (!(0, s.pushUnique)(S, "ExportData")) return;
                (0, s.extend)(w().prototype, {
                    downloadCSV: function() {
                        return this.exporting?.downloadCSV();
                    },
                    downloadXLS: function() {
                        return this.exporting?.downloadXLS();
                    },
                    getCSV: function(t) {
                        return this.exporting?.getCSV(t);
                    },
                    getDataRows: function(t) {
                        return this.exporting?.getDataRows(t);
                    },
                    getTable: function(t) {
                        return this.exporting?.getTable(t);
                    },
                    getTableAST: function(t) {
                        return this.exporting?.getTableAST(t);
                    },
                    hideData: function() {
                        return this.exporting?.hideData();
                    },
                    toggleDataTable: function(t) {
                        return this.exporting?.toggleDataTable(t);
                    },
                    viewData: function() {
                        return this.exporting?.viewData();
                    }
                });
                let m = h.prototype;
                if (!m.downloadCSV) {
                    (0, s.addEvent)(t, "afterViewData", u), (0, s.addEvent)(t, "render", g), (0, s.addEvent)(t, "destroy", x), m.downloadCSV = e, m.downloadXLS = a, m.getCSV = o, m.getDataRows = n, m.getTable = i, m.getTableAST = r, m.hideData = l, m.toggleDataTable = d, m.wrapLoading = p, m.viewData = c, D(T);
                    let h = v().exporting?.buttons?.contextButton?.menuItems;
                    h && h.push("separator", "downloadCSV", "downloadXLS", "viewData");
                    let { arearange: b, gantt: y, map: w, mapbubble: S, treemap: E, xrange: C } = f.types;
                    b && (b.prototype.keyToAxis = {
                        low: "y",
                        high: "y"
                    }), y && (y.prototype.exportKey = "name", y.prototype.keyToAxis = {
                        start: "x",
                        end: "x"
                    }), w && (w.prototype.exportKey = "name"), S && (S.prototype.exportKey = "name"), E && (E.prototype.exportKey = "name"), C && (C.prototype.keyToAxis = {
                        x2: "x"
                    });
                }
            };
        }(o || (o = {}));
        let A = o, L = h();
        L.dataURLtoBlob = L.dataURLtoBlob || g, L.downloadURL = L.downloadURL || f, A.compose(L.Chart, L.Exporting, L.Series);
        let H = h();
        return l.default;
    })());


var $560fbd26ffd480e0$exports = {};
!/**
 * Highcharts JS v13.1.1 (2026-09-20)
 * @module highcharts/modules/offline-exporting
 * @requires highcharts
 * @requires highcharts/modules/exporting
 *
 * Client side exporting module
 *
 * (c) 2015-2026 Highsoft AS
 * Author: Torstein Hønsi / Øystein Moseng
 *
 * A commercial license may be required depending on use,
 * see www.highcharts.com/license
 */ function(t, e) {
    $560fbd26ffd480e0$exports = e(t._Highcharts.AST, t._Highcharts.Chart, t._Highcharts);
}("u" < typeof window ? $560fbd26ffd480e0$exports : window, (t, e, r)=>(()=>{
        "use strict";
        var o, n = {
            660 (e) {
                e.exports = t;
            },
            960 (t) {
                t.exports = e;
            },
            944 (t) {
                t.exports = r;
            }
        };
        let a = {};
        function i(t) {
            let e = a[t];
            if (void 0 !== e) return e.exports;
            let r = a[t] = {
                exports: {}
            };
            return n[t](r, r.exports, i), r.exports;
        }
        i.n = (t)=>{
            let e = t && t.__esModule ? ()=>t.default : ()=>t;
            return i.d(e, {
                a: e
            }), e;
        }, i.d = (t, e)=>{
            for(var r in e)i.o(e, r) && !i.o(t, r) && Object.defineProperty(t, r, {
                enumerable: !0,
                get: e[r]
            });
        }, i.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        let l = {};
        i.d(l, {
            default: ()=>R
        });
        var s = i(944), c = i.n(s);
        let { isSafari: d, win: f, win: { document: h } } = c(), p = f.URL || f.webkitURL || f;
        function u(t) {
            let e = t.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
            if (e && e.length > 3 && f.atob && f.ArrayBuffer && f.Uint8Array && f.Blob && p.createObjectURL) {
                let t = f.atob(e[3]), r = new f.ArrayBuffer(t.length), o = new f.Uint8Array(r);
                for(let e = 0; e < o.length; ++e)o[e] = t.charCodeAt(e);
                return p.createObjectURL(new f.Blob([
                    o
                ], {
                    type: e[1]
                }));
            }
        }
        function g(t, e) {
            let r = f.navigator, o = h.createElement("a");
            if ("string" != typeof t && !(t instanceof String) && r.msSaveOrOpenBlob) return void r.msSaveOrOpenBlob(t, e);
            if (t = "" + t, r.userAgent.length > 1e3) throw Error("Input too long");
            let n = /Edge\/\d+/.test(r.userAgent);
            if ((d && "string" == typeof t && 0 === t.indexOf("data:application/pdf") || n || t.length > 2e6) && !(t = u(t) || "")) throw Error("Failed to convert to blob");
            if (void 0 !== o.download) o.href = t, o.download = e, h.body.appendChild(o), o.click(), h.body.removeChild(o);
            else try {
                if (!f.open(t, "chart")) throw Error("Failed to open window");
            } catch  {
                f.location.href = t;
            }
        }
        function y(t) {
            return new Promise((e, r)=>{
                let o = h.getElementsByTagName("head")[0], n = h.createElement("script");
                n.type = "text/javascript", n.src = t, n.onload = ()=>{
                    e();
                }, n.onerror = ()=>{
                    let e = `Error loading script ${t}`;
                    (0, s.error)(e), r(Error(e));
                }, o.appendChild(n);
            });
        }
        var m = i(660), b = i.n(m), w = i(960), x = i.n(w);
        let v = {
            exporting: {}
        }, { getOptions: E, setOptions: F } = c(), { composed: A, doc: L, win: S } = c();
        !function(t) {
            let e = "Invalid exporting.libURL:";
            function r() {
                return !!(S && S.jspdf?.jsPDF && S.svg2pdf);
            }
            async function o(t, e, r, o) {
                var i, l;
                let s, c, d, f, h, p, u, y = (i = t, l = o, d = L.createElement("div"), b().setElementHTML(d, i), f = d.getElementsByTagName("text"), h = function(t, e) {
                    let r = t;
                    for(; r && r !== d;){
                        if (r.style[e]) {
                            let o = r.style[e];
                            "fontSize" === e && /em$/.test(o) && (o = Math.round(16 * parseFloat(o)) + "px"), t.style[e] = o;
                            break;
                        }
                        r = r.parentNode;
                    }
                }, [].forEach.call(f, function(t) {
                    for([
                        "fontFamily",
                        "fontSize"
                    ].forEach((e)=>{
                        h(t, e);
                    }), t.style.fontFamily = l?.normal ? "HighchartsFont" : String(t.style.fontFamily && t.style.fontFamily.split(" ").splice(-1)), s = t.getElementsByTagName("title"), [].forEach.call(s, function(t) {
                        t.remove();
                    }), c = t.getElementsByClassName("highcharts-text-outline"); c.length > 0;)c[0].remove();
                }), p = /color\(\s*srgb\s+([\d.]+)[, ]+([\d.]+)[, ]+([\d.]+)(?:\s*\/\s*([\d.]+))?\s*\)/, u = (t)=>{
                    if (t?.startsWith("color(srgb")) {
                        let e = t.match(p);
                        if (e) {
                            let t = (t)=>Math.round(255 * Math.max(0, Math.min(1, parseFloat(t)))), r = t(e[1]), o = t(e[2]), n = t(e[3]), a = e[4];
                            return void 0 !== a ? `rgba(${r}, ${o}, ${n}, ${Math.max(0, Math.min(1, parseFloat(a)))})` : `rgb(${r}, ${o}, ${n})`;
                        }
                    }
                }, Array.from(d.querySelectorAll("*")).forEach((t)=>{
                    [
                        "color",
                        "fill",
                        "stop-color",
                        "stroke"
                    ].forEach((e)=>{
                        let r = u(t.getAttribute(e));
                        r && t.setAttribute(e, r);
                        let o = u(t.style?.[e]);
                        o && (t.style[e] = o);
                    });
                }), d.querySelector("svg"));
                y && (await n(y, o), g(await a(y, 0, e), r));
            }
            async function n(t, e) {
                let r, o, n = (t, e)=>{
                    S.jspdf.jsPDF.API.events.push([
                        "initialized",
                        function() {
                            this.addFileToVFS(t, e), this.addFont(t, "HighchartsFont", t), this.getFontList()?.HighchartsFont || this.setFont("HighchartsFont");
                        }
                    ]);
                };
                for (let a of (e && (o = t.textContent || "", !/[^\u0000-\u007F\u200B]+/.test(o)) && (e = void 0), [
                    "normal",
                    "italic",
                    "bold",
                    "bolditalic"
                ])){
                    let t = e?.[a];
                    if (t) try {
                        let e = await S.fetch(t);
                        if (!e.ok) throw Error(`Failed to fetch font: ${t}`);
                        let o = await e.blob(), i = new FileReader, l = await new Promise((t, e)=>{
                            i.onloadend = ()=>{
                                "string" == typeof i.result ? t(i.result.split(",")[1]) : e(Error("Failed to read font as base64"));
                            }, i.onerror = e, i.readAsDataURL(o);
                        });
                        n(a, l), "normal" === a && (r = l);
                    } catch  {}
                    else r && n(a, r);
                }
            }
            async function a(t, e, r) {
                let o = (Number(t.getAttribute("width")) + 2 * e) * r, n = (Number(t.getAttribute("height")) + 2 * e) * r, a = new S.jspdf.jsPDF(n > o ? "p" : "l", "pt", [
                    o,
                    n
                ]);
                [].forEach.call(t.querySelectorAll('*[visibility="hidden"]'), function(t) {
                    t.parentNode.removeChild(t);
                });
                let i = t.querySelectorAll("linearGradient");
                for(let t = 0; t < i.length; t++){
                    let e = i[t].querySelectorAll("stop"), r = 0;
                    for(; r < e.length && "0" === e[r].getAttribute("offset") && "0" === e[r + 1].getAttribute("offset");)e[r].remove(), r++;
                }
                return [].forEach.call(t.querySelectorAll("tspan"), (t)=>{
                    "\u200B" === t.textContent && (t.textContent = " ", t.setAttribute("dx", -5));
                }), await a.svg(t, {
                    x: 0,
                    y: 0,
                    width: o,
                    height: n,
                    removeInvalid: !0
                }), a.output("datauristring");
            }
            t.compose = function(t) {
                if ((0, s.addEvent)(t, "downloadSVG", async function(t) {
                    let { svg: n, exportingOptions: a, exporting: i, preventDefault: l } = t, d = i?.chart;
                    if (a?.type === "application/pdf") {
                        l?.();
                        try {
                            let { type: t, filename: i, scale: l } = c().Exporting.prepareImageOptions(a), s = a.libURL || d?.options.exporting?.libURL, f = function(t) {
                                let r;
                                if (!t) return;
                                let o = "/" !== t.slice(-1) ? t + "/" : t;
                                if (S.URL?.canParse) r = S.URL.canParse(o, L.baseURI);
                                else try {
                                    r = !!new S.URL(o, L.baseURI).href;
                                } catch  {
                                    r = !1;
                                }
                                if (!r) throw Error(`${e} "${t}". Provide a valid URL or path to the jsPDF and svg2pdf scripts.`);
                                return o;
                            }(s);
                            if ("application/pdf" === t) {
                                if (!r()) {
                                    if (!f) throw Error("PDF export requires jsPDF and svg2pdf.");
                                    S.jspdf?.jsPDF || await y(`${f}jspdf.js`), S.svg2pdf || await y(`${f}svg2pdf.js`);
                                }
                                await o(n, l, i, a?.pdfFont);
                            }
                        } catch (t) {
                            a?.fallbackToExportServer !== !1 && 0 === t.message.indexOf(e) && (0, s.error)(`${t.message} Falling back to export server.`, !1, d), await i?.fallbackToServer(a, t);
                        }
                    }
                }), !(0, s.pushUnique)(A, "OfflineExporting")) return;
                (0, s.addEvent)(x(), "load", function() {
                    !(this.renderer.forExport || r()) && (this.options.exporting?.libURL || (0, s.error)("Warning: exporting.libURL not defined, PDF client side export will not work", !1, this));
                }), (0, s.extend)(x().prototype, {
                    exportChartLocal: async function(t, e) {
                        await this.exporting?.exportChart(t, e);
                    }
                }), F(v);
                let n = E().exporting?.buttons?.contextButton?.menuItems;
                n?.push("downloadPDF");
            }, t.downloadSVGLocal = async function(t, e) {
                await c().Exporting.prototype.downloadSVG.call(void 0, t, e);
            };
        }(o || (o = {}));
        let U = o, j = c();
        j.dataURLtoBlob = j.dataURLtoBlob || u, j.downloadSVGLocal = U.downloadSVGLocal, j.downloadURL = j.downloadURL || g, U.compose(j.Exporting);
        let R = c();
        return l.default;
    })());


class $ad783b3f6c4e63c7$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
    }
    static get observedAttributes() {
        throw new Error("Must be implemented");
    }
    get config() {
        throw new Error("Must be implemented");
    }
    attributeChanged(name, oldValue, newValue) {
        throw new Error("Must be implemented");
    }
    get container() {
        return this.querySelector(".chart-container");
    }
    attributeChangedCallback(name, oldValue, newValue) {
        requestAnimationFrame(()=>{
            this.attributeChanged(name, oldValue, newValue);
        });
    }
    connectedCallback() {
        this.appendChild(document.createRange().createContextualFragment(`
        <div class="chart-container"></div>
      `));
        this.chart = (0, (/*@__PURE__*/$parcel$interopDefault($f633eb68188f0218$exports))).chart(this.container, this.config);
        // Force reflow
        requestAnimationFrame(()=>{
            this.chart.reflow();
        });
    }
    disconnectedCallback() {
        if (this.chart) {
            this.removeChild(this.container);
            this.chart.destroy();
        }
    }
}


class $a310e1ac4d68fb5f$export$2e2bcd8739ae039 extends (0, $ad783b3f6c4e63c7$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    static get observedAttributes() {
        return [
            "data"
        ];
    }
    get config() {
        return {
            chart: {
                type: "bar",
                height: "70%",
                animation: false
            },
            title: false,
            xAxis: {
                categories: [],
                tickPosition: "inside",
                labels: {
                    allowOverlap: false,
                    style: {
                        fontSize: "13px",
                        color: "#333"
                    }
                }
            },
            yAxis: {
                title: {
                    text: "Pts d\u2019impact"
                }
            },
            legend: {
                reversed: true,
                layout: "vertical",
                align: "right",
                verticalAlign: "middle",
                width: 220
            },
            plotOptions: {
                animation: false,
                series: {
                    animation: false,
                    stacking: "normal"
                }
            },
            tooltip: {
                valueDecimals: 2,
                valueSuffix: "\xa0Pts d\u2019impact"
            },
            series: [],
            exporting: {
                fallbackToExportServer: false,
                chartOptions: {
                    title: false
                },
                filename: "ecobalyse",
                buttons: {
                    deselectAllButton: {
                        text: "Tout d\xe9s\xe9lectionner",
                        onclick: function() {
                            this.series.forEach((s)=>s.hide());
                        }
                    },
                    selectAllButton: {
                        text: "Tout s\xe9lectionner",
                        onclick: function() {
                            this.series.forEach((s)=>s.show());
                        }
                    }
                }
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 768
                        },
                        chartOptions: {
                            // Note: the height ensures exported images contain the full legend
                            chart: {
                                height: 1000,
                                marginTop: 20
                            },
                            legend: {
                                layout: "horizontal",
                                align: "center",
                                verticalAlign: "bottom",
                                width: undefined
                            },
                            exporting: {
                                buttons: {
                                    contextButton: {
                                        y: -15
                                    },
                                    deselectAllButton: {
                                        y: -15
                                    },
                                    selectAllButton: {
                                        y: -15
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        };
    }
    attributeChanged(name, oldValue, newValue) {
        if (name === "data") {
            const rawData = JSON.parse(newValue);
            // Code below will map the JSON data received from Elm to data structures
            // expected by Highcharts.
            const series = rawData[0].data.map(({ name: name, color: color }, idx)=>{
                return {
                    name: name,
                    color: color,
                    data: rawData.map(({ data: data })=>data[idx].y)
                };
            });
            this.chart.update({
                xAxis: {
                    categories: rawData.map(({ label: label })=>label)
                }
            });
            // Remove all existing series...
            while(this.chart.series.length)this.chart.series[0].remove();
            // ... and replace them with fresh ones
            for (const serie of series)this.chart.addSeries(serie);
        }
    }
}



function $9b4e21cb56e4503d$var$ucfirst(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
class $9b4e21cb56e4503d$export$2e2bcd8739ae039 extends (0, $ad783b3f6c4e63c7$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    static get observedAttributes() {
        return [
            "data",
            "heading",
            "height",
            "unit"
        ];
    }
    get config() {
        return {
            chart: {
                type: "spline"
            },
            accessibility: {
                description: `\xc9volution de la fr\xe9quentation`
            },
            subtitle: {
                text: "30 derniers jours"
            },
            xAxis: {
                type: "datetime"
            },
            series: [
                {
                    lineWidth: 4
                }
            ]
        };
    }
    attributeChanged(name, oldValue, newValue) {
        if (name === "data") {
            const data = JSON.parse(newValue);
            this.chart.series[0].setData(data);
        } else if (name === "heading") this.chart.setTitle({
            text: newValue
        });
        else if (name === "height") this.chart.setSize(null, parseInt(newValue, 10));
        else if (name === "unit") {
            const unitTitle = $9b4e21cb56e4503d$var$ucfirst(newValue + "s");
            this.chart.yAxis[0].setTitle({
                text: unitTitle
            });
            this.chart.series[0].setName(unitTitle);
        }
    }
}


(0, (/*@__PURE__*/$parcel$interopDefault($f633eb68188f0218$exports))).setOptions({
    lang: {
        loading: "Chargement\u2026",
        months: [
            "janvier",
            "f\xe9vrier",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "ao\xfbt",
            "septembre",
            "octobre",
            "novembre",
            "d\xe9cembre"
        ],
        weekdays: [
            "dimanche",
            "lundi",
            "mardi",
            "mercredi",
            "jeudi",
            "vendredi",
            "samedi"
        ],
        shortMonths: [
            "jan",
            "f\xe9v",
            "mar",
            "avr",
            "mai",
            "juin",
            "juil",
            "ao\xfb",
            "sep",
            "oct",
            "nov",
            "d\xe9c"
        ],
        exportButtonTitle: "Exporter",
        printButtonTitle: "Imprimer",
        rangeSelectorFrom: "Du",
        rangeSelectorTo: "au",
        rangeSelectorZoom: "P\xe9riode",
        downloadPNG: "T\xe9l\xe9charger en PNG",
        downloadJPEG: "T\xe9l\xe9charger en JPEG",
        downloadPDF: "T\xe9l\xe9charger en PDF",
        downloadSVG: "T\xe9l\xe9charger en SVG",
        resetZoom: "R\xe9initialiser le zoom",
        resetZoomTitle: "R\xe9initialiser le zoom",
        thousandsSep: " ",
        decimalPoint: ","
    }
});
var $0f0a11d8c20f9e9e$export$2e2bcd8739ae039 = {
    registerElements: function() {
        customElements.define("chart-stats", (0, $9b4e21cb56e4503d$export$2e2bcd8739ae039));
        customElements.define("chart-food-comparator", (0, $a310e1ac4d68fb5f$export$2e2bcd8739ae039));
    }
};


var $2302afd5d7244c4e$exports = {};
// To ease having both ongoing and stable version stores leveraged on a same domain,
// we use two distinct localStorage keys
const $2302afd5d7244c4e$var$stableVersionKey = "store";
const $2302afd5d7244c4e$var$ongoingVersionKey = "ecobalyse";
function $2302afd5d7244c4e$var$initializeStoreKey(localStorage = window.localStorage) {
    if (localStorage[$2302afd5d7244c4e$var$stableVersionKey] && !localStorage[$2302afd5d7244c4e$var$ongoingVersionKey]) // Ongoing version store has never been initialized, while the stable version one has already
    // => Initialize current storage with stable version session data
    // Note: the ongoing version can always handle and parse old bookmark formats
    localStorage[$2302afd5d7244c4e$var$ongoingVersionKey] = localStorage[$2302afd5d7244c4e$var$stableVersionKey];
    else if (!localStorage[$2302afd5d7244c4e$var$stableVersionKey] && localStorage[$2302afd5d7244c4e$var$ongoingVersionKey]) // Stable version store has never been initialized, while the ongoing version one has already
    // => Backport only auth data, as other stuff is highly unlikely to be compatible
    try {
        const { auth2: auth2 } = JSON.parse(localStorage[$2302afd5d7244c4e$var$ongoingVersionKey]);
        localStorage[$2302afd5d7244c4e$var$stableVersionKey] = JSON.stringify({
            auth2: auth2
        });
    } catch (e) {
        console.error("Unable to retrieve previous valid legacy session data", e);
    }
    return $2302afd5d7244c4e$var$ongoingVersionKey;
}
function $2302afd5d7244c4e$var$exportBookmarks(localStorage = window.localStorage) {
    try {
        const jsonExport = JSON.stringify({
            [$2302afd5d7244c4e$var$ongoingVersionKey]: JSON.parse(localStorage[$2302afd5d7244c4e$var$ongoingVersionKey] || "{}")?.bookmarks || [],
            [$2302afd5d7244c4e$var$stableVersionKey]: JSON.parse(localStorage[$2302afd5d7244c4e$var$stableVersionKey] || "{}")?.bookmarks || []
        });
        let a = document.createElement("a");
        a.href = `data:application/json;base64,${$2302afd5d7244c4e$var$toBase64(jsonExport)}`;
        a.download = $2302afd5d7244c4e$var$createFilename();
        a.click();
    } catch (e) {
        console.error("Unable to export bookmarks", e);
        alert("Erreur durant l'export des signets");
    }
}
function $2302afd5d7244c4e$var$importBookmarks(localStorage = window.localStorage) {
    let field = document.createElement("input");
    field.type = "file";
    field.accept = "application/json,.json";
    field.click();
    field.addEventListener("change", ({ target: target })=>{
        const file = target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.addEventListener("load", ()=>{
                try {
                    const results = JSON.parse(reader.result);
                    $2302afd5d7244c4e$var$importVersionBookmarks(results, $2302afd5d7244c4e$var$stableVersionKey, localStorage);
                    $2302afd5d7244c4e$var$importVersionBookmarks(results, $2302afd5d7244c4e$var$ongoingVersionKey, localStorage);
                    document.location.reload();
                    alert("Les signets ont \xe9t\xe9 import\xe9s");
                } catch (e) {
                    console.error("Error while importing bookmarks", e);
                    alert("Erreur lors de l\u2019import des signets");
                }
            });
            reader.readAsText(file);
        }
    });
}
function $2302afd5d7244c4e$var$importVersionBookmarks(results, key, localStorage = window.localStorage) {
    if (results && key in results) {
        const bookmarks = results[key];
        if (Array.isArray(bookmarks) && bookmarks.length > 0) {
            $2302afd5d7244c4e$var$initializeStoreKey(localStorage);
            const previousStore = JSON.parse(localStorage[key] || "{}");
            const updatedStore = JSON.stringify({
                ...previousStore,
                bookmarks: bookmarks
            });
            localStorage[key] = updatedStore;
        }
    }
}
function $2302afd5d7244c4e$var$createFilename(date = new Date()) {
    const datePart = date.toISOString().replaceAll("-", "").replace("T", "-").replaceAll(":", "").slice(0, 15);
    return `ecobalyse-bookmarks-${datePart}.json`;
}
function $2302afd5d7244c4e$var$toBase64(str) {
    const uint8Array = new TextEncoder().encode(str);
    return btoa(String.fromCharCode(...uint8Array));
}
$2302afd5d7244c4e$exports = {
    exportBookmarks: $2302afd5d7244c4e$var$exportBookmarks,
    importBookmarks: $2302afd5d7244c4e$var$importBookmarks,
    initializeStoreKey: $2302afd5d7244c4e$var$initializeStoreKey
};


// The localStorage key to use to store serialized session data
const $41569a38fd64ffcf$var$storeKey = (0, (/*@__PURE__*/$parcel$interopDefault($2302afd5d7244c4e$exports))).initializeStoreKey();
// Remove trailing slash from root because it's used by the Elm API to resolve backend api urls
const $41569a38fd64ffcf$var$clientUrl = (location.origin + location.pathname).replace(/\/+$/g, "");
// using a `let` statement to avoid this error:
// @parcel/optimizer-swc: 'const' declarations must be initialized
let $41569a38fd64ffcf$var$FORCE_PLAUSIBLE, $41569a38fd64ffcf$var$NODE_ENV = "production", $41569a38fd64ffcf$var$PLAUSIBLE_HOST = "plausible.io", $41569a38fd64ffcf$var$PLAUSIBLE_SCRIPT = "/js/pa-huAqhj4W3hNhYko-4NfoD.js", $41569a38fd64ffcf$var$SENTRY_DSN = "https://5a91b30f00bb4942ad953b90903ad146@sentry.incubateur.net/10";
const $41569a38fd64ffcf$var$plausibleEnabled = $41569a38fd64ffcf$var$PLAUSIBLE_HOST && $41569a38fd64ffcf$var$PLAUSIBLE_SCRIPT && ($41569a38fd64ffcf$var$NODE_ENV === "production" || $41569a38fd64ffcf$var$FORCE_PLAUSIBLE);
// Sentry
if ($41569a38fd64ffcf$var$NODE_ENV === "production" && $41569a38fd64ffcf$var$SENTRY_DSN) {
    $620d70b04505c050$export$2cd8252107eb640b({
        dsn: $41569a38fd64ffcf$var$SENTRY_DSN,
        integrations: [
            $86439d66f81a91b2$export$b4109253475213e9()
        ],
        tracesSampleRate: 0,
        allowUrls: [
            /^https:\/\/ecobalyse\.beta\.gouv\.fr/,
            /^https:\/\/staging-ecobalyse\.incubateur\.net/,
            // Review apps
            /^https:\/\/ecobalyse-staging-pr.*\.osc-fr1\.scalingo\.io/
        ],
        ignoreErrors: [
            // Most often due to DOM-aggressive browser extensions
            /_VirtualDom_applyPatch/
        ],
        // IS_REVIEW_APP is set by `scalingo.json` only on review apps
        // See: https://developers.scalingo.com/scalingo-json-schema/
        environment: $41569a38fd64ffcf$var$NODE_ENV || "development"
    });
    $873eefa173eeba59$exports.setTag("subsystem", "front-end");
}
function $41569a38fd64ffcf$var$loadScript(scriptUrl, attributes = {}) {
    var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = scriptUrl;
    for (const [key, value] of Object.entries(attributes))g.setAttribute(key, value);
    s.parentNode.insertBefore(g, s);
}
const $41569a38fd64ffcf$var$app = (0, $be7ebd92b118fa32$exports.Elm).Main.init({
    flags: {
        clientUrl: $41569a38fd64ffcf$var$clientUrl,
        enabledSections: {
            food: true,
            food2: true,
            objects: true,
            textile: true,
            veli: false
        },
        rawStore: localStorage[$41569a38fd64ffcf$var$storeKey] || "null",
        matomo: {
            host: "stats.beta.gouv.fr",
            siteId: "57"
        },
        plausible: {
            // note: used to render the public stats page, not enable tracking
            host: "plausible.io"
        },
        scalingoAppName: "ecobalyse",
        versionPollSeconds: parseInt(undefined) || 300
    }
});
$41569a38fd64ffcf$var$app.ports.copyToClipboard.subscribe((text)=>{
    navigator.clipboard.writeText(text).then(function() {}, function() {
        alert(`Votre navigateur ne supporte pas la copie automatique; vous pouvez copier l'adresse manuellement`);
    });
});
$41569a38fd64ffcf$var$app.ports.appStarted.subscribe(()=>{
    // Matomo
    var _paq = window._paq = window._paq || [];
    _paq.push([
        "trackPageView"
    ]);
    _paq.push([
        "enableLinkTracking"
    ]);
    var u = `https://${"stats.beta.gouv.fr"}/`;
    _paq.push([
        "setTrackerUrl",
        u + "matomo.php"
    ]);
    _paq.push([
        "disableCookies"
    ]);
    _paq.push([
        "setSiteId",
        "57"
    ]);
    $41569a38fd64ffcf$var$loadScript(u + "matomo.js");
    // Plausible
    if ($41569a38fd64ffcf$var$plausibleEnabled) {
        $41569a38fd64ffcf$var$loadScript(`https://${$41569a38fd64ffcf$var$PLAUSIBLE_HOST}${$41569a38fd64ffcf$var$PLAUSIBLE_SCRIPT}`);
        window.plausible = window.plausible || function() {
            (plausible.q = plausible.q || []).push(arguments);
        }, plausible.init = plausible.init || function(i) {
            plausible.o = i || {};
        };
        plausible.init();
    }
});

$41569a38fd64ffcf$var$app.ports.loadRapidoc.subscribe(()=>{
    // load the rapi-doc script if the component hasn't be registered yet
    if (!customElements.get("rapi-doc")) (parcelRequire("hJFhm"));
});
$41569a38fd64ffcf$var$app.ports.loadJeDonneMonAvis.subscribe(()=>{
    $41569a38fd64ffcf$var$loadScript("https://jedonnemonavis.numerique.gouv.fr/static/jdma-modal-widget.js", {
        "data-jdma-form-url": "https://jedonnemonavis.numerique.gouv.fr/Demarches/avis/2361?button=4816",
        "data-jdma-button-image": "https://jedonnemonavis.numerique.gouv.fr/static/buttons/button-remark-solid-light.svg",
        "data-jdma-button-label": "Une remarque ?",
        "data-jdma-position": "bottom-right",
        defer: "defer"
    });
});
$41569a38fd64ffcf$var$app.ports.saveStore.subscribe((rawStore)=>{
    localStorage[$41569a38fd64ffcf$var$storeKey] = rawStore;
});
$41569a38fd64ffcf$var$app.ports.addBodyClass.subscribe((cls)=>{
    document.body.classList.add(cls);
});
$41569a38fd64ffcf$var$app.ports.exportBookmarks.subscribe(()=>{
    const msg = "Cet export contient l\u2019int\xe9gralit\xe9 de vos signets, tous secteurs et versions confondus";
    if (confirm(msg)) (0, (/*@__PURE__*/$parcel$interopDefault($2302afd5d7244c4e$exports))).exportBookmarks();
});
$41569a38fd64ffcf$var$app.ports.importBookmarks.subscribe(()=>{
    const msg = "Attention, l\u2019import des signets \xe9crasera ceux existant sur ce navigateur pour tous les secteurs (textile, alimentaire, etc). Voulez-vous vraiment continuer\xa0?";
    if (confirm(msg)) (0, (/*@__PURE__*/$parcel$interopDefault($2302afd5d7244c4e$exports))).importBookmarks();
});
$41569a38fd64ffcf$var$app.ports.removeBodyClass.subscribe((cls)=>{
    document.body.classList.remove(cls);
});
$41569a38fd64ffcf$var$app.ports.sendPlausibleEvent.subscribe(({ name: name, properties: properties })=>{
    if (!$41569a38fd64ffcf$var$plausibleEnabled) return;
    try {
        const props = Object.fromEntries(properties);
        const event = name === "pageview" ? {
            u: props.url.replace("/#/", "/"),
            props: props
        } : {
            props: props
        };
        window.plausible(name, event);
        if ($41569a38fd64ffcf$var$NODE_ENV === "development") console.debug("plausible event", name, JSON.stringify(event, null, 2));
    } catch (e) {
        console.error("plausible error", e);
    }
});
$41569a38fd64ffcf$var$app.ports.scrollTo.subscribe((pos)=>{
    window.scrollTo(pos.x, pos.y);
});
$41569a38fd64ffcf$var$app.ports.scrollIntoView.subscribe((selector)=>{
    let node = document.querySelector(selector);
    node?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
});
// Ensure session is refreshed when it changes in another tab/window
window.addEventListener("storage", (event)=>{
    if (event.storageArea === localStorage && event.key === $41569a38fd64ffcf$var$storeKey) $41569a38fd64ffcf$var$app.ports.storeChanged.send(event.newValue);
}, false);
// Register custom chart elements
(0, $0f0a11d8c20f9e9e$export$2e2bcd8739ae039).registerElements();


//# sourceMappingURL=67553852-1829-4146-8e1a-8bb272324069.23ddee79.js.map
